(function () {

    'use strict';

    angular
        .module('app.product', [])
        .config(config);


    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/product/');

        $stateProvider
            .state('app.product', {
                url: '/product',
                abstract: true
            })
            .state('app.product.account', {
                url: '/product-account',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/account-list/product-account-list.html',
                        controller: 'ProductAccountListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.features', {
                url: '/feature-list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/feature/feature-list/feature-list.html',
                        controller: 'FeatureListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.categoryfeature', {
                url: '/category-feature',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/category-feature/category-feature.html',
                        controller: 'ProductCategoryFeatureController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.preNegotiatedPrice', {
                url: '/pre-negociated-prices',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/pre-negotiated-price/pre-negotiated-prices.html',
                        controller: 'PreNegociatedPricesController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.parameters', {
                url: '/parameters',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/parameters/parameters.html',
                        controller: 'ParametersController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.ProductList', {
                url: '/my-products',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/product-list/product-list.html',
                        controller: 'ProductListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.consultProducts', {
                url: '/productsList',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/consultProducts/consultProducts.html',
                        controller: 'ConsultProductsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.tags', {
                url: '/tags',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/tags/tags.html',
                        controller: 'TagsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.productType', {
                url: '/productType',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/productType/productType.html',
                        controller: 'ProductTypeController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.product.productGroup', {
                url: '/productGroup',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/product/product-group/product-group-list.html',
                        controller: 'ProductGroupListController',
                        controllerAs: 'vm'
                    }
                }
            });
    }


})();

(function () {
  'use strict';
  angular
    .module('app.product')
    .controller('ProductListEstablishmentBatchDialogController', ProductListEstablishmentBatchDialogController);

  /** @ngInject */
  function ProductListEstablishmentBatchDialogController($mdDialog, $log, $rootScope, $filter, api, products, addons, establishmentId, updateMaxMin) {
    var vm = this;
    vm.productos = products;
    vm.loading = true;
    vm.productsOnSave = [];

    // Methods
    vm.closeDialog = closeDialog;

    splitProductsByGroup();

    //////////

    function closeDialog() {
      if (!vm.loading) {
        $mdDialog.hide();
      }
    }

    function saveAllProduct(pos, max) {
      if (pos > max) {
        validateAllFinished();
        return;
      }
      var product = vm.productos.content[pos];
      product.loading = true;
      getAddonByProduct(product, pos, max);
    }

    function splitProductsByGroup() {
      vm.productos.content.forEach(function(element){
        element.pending = true;
      });
      var lengthTotal = vm.productos.content.length;
      var lengthSubList = Math.ceil(lengthTotal / 5);

      for (var i = 0; i < lengthTotal; i += lengthSubList) {
        var identificador = {
          min: i,
          max: Math.min(i + lengthSubList - 1, lengthTotal - 1)
        };
        saveAllProduct(identificador.min, identificador.max);
      }
    }

    function getAddonByProduct(product, i, max) {
      api.GeneralWS.ProductCompanyEstablishmentAddons.getByProductAndCompany.get({
        'idCircle': $rootScope.bsCircle.id, 'productId': product.id, 'establishmentId': establishmentId
      }).$promise.then(function (response) {
        const addons = response;
        saveProduct(product, addons, i, max);
      }, function (response) {
        const addons = {};
        saveProduct(product, addons, i, max);
        $log.error(response);
      });
    }

    function saveProduct(product, pAddon, i, max) {
      pAddon = updateAddon(pAddon);
      var promise;
      if (pAddon.id) {
        promise = api.GeneralWS.ProductCompanyEstablishmentAddons.me.update({
          'id': pAddon.id, 'idCircle': $rootScope.bsCircle.id, 'establishmentId': establishmentId, 'updateMaxMin': updateMaxMin
        }, pAddon).$promise;
      } else {
        pAddon.active = true;
        pAddon.product = { id: product.id };
        promise = api.GeneralWS.ProductCompanyEstablishmentAddons.me.create({
          'idCircle': $rootScope.bsCircle.id, 'productId': product.id, 'establishmentId': establishmentId
        }, pAddon).$promise;
      }

      promise.then(function (response) {
        product.loading = false;
        product.pending = false;
        product.isError = false;
        saveAllProduct(i + 1, max);
      }, function (response) {
        product.loading = false;
        product.pending = false;
        product.isError = true;
        $log.error(response);
        saveAllProduct(i + 1, max);
      });
    }

    function validateAllFinished() {
      var saving = $filter('filter')(vm.productos.content, { loading: true });
      var pendings = $filter('filter')(vm.productos.content, { pending: true });
      vm.loading = pendings.length > 0 || saving.length > 0;
    }

    function updateAddon(pAddon) {
      var id = pAddon.id;
      pAddon = angular.copy(addons);
      pAddon.id = id;
      return pAddon;
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.company', [
            'flow',
            'wipImageZoom'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('app.company', {
                url: '/company',
                abstract: true
            })
            .state('app.company.mycompany', {
                url: '/my-company?tipoError',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company.html',
                        controller: 'CompanyController as vm'
                    }
                },
                resolve: {
                    Company: function () {
                        return null;
                    },
                    PreviousState: function () {
                        return null;
                    }
                },
                params: {
                    tipoError: null,
                    isMyCompany: true,
                    readonly: false
                }
            })
            .state('app.company.mycompany.documents', {
                url: '/documents?tipoError',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/documents/documents.html',
                        controller: 'DocumentController as vm'
                    }
                },
                resolve: {
                    Company: function () {
                        return null;
                    }
                },
                params: {
                    tipoError: null,
                    listOfDocumentTypes: null
                }
            })
            .state('app.company.mycompany.invoiceSerie', {
                url: '/invoiceSerie',
                resolve: {
                    Company: function () {
                        return null;
                    }
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/tabs/invoiceSerie/invoiceSerie.html',
                        controller: 'InvoiceSerieController as vm'
                    }
                }
            })
            .state('app.company.parameters', {
                url: '/parameters',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-parameters/parameters.html',
                        controller: 'CompanyParametersController as vm'
                    }
                }
            })
            .state('app.company.application', {
                url: '/applications',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-application/applications.html',
                        controller: 'CompanyApplicationController as vm'
                    }
                }
            })
            .state('app.company.blockedSeries', {
                url: '/blockedSeries',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/blockedSeries/blockedSeries.html',
                        controller: 'BlockedSeriesController as vm'
                    }
                }
            })

            .state('app.company.exchangeRate', {
                url: '/exchangeRate',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-exchangeRate/ExchangeRate/exchangeRate.html',
                        controller: 'ExchangeRateController as vm'
                    }
                }
            })

            .state('app.company.establishment', {
                url: '/establishments',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-establishments/establishment-list/establishment-list.html',
                        controller: 'CompanyEstablishmentListController as vm'
                    }
                }
            })
            .state('app.company.establishment.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-establishments/establishment/establishment.html',
                        controller: 'CompanyEstablishmentController as vm'
                    }
                }
            })
            .state('app.company.establishment.paymentTypes', {
                url: '/:id/paymentTypes',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-establishments/paymentTypes/paymentTypes.html',
                        controller: 'PaymentTypesController2',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }

            })
            .state('app.company.warehouse', {
                url: '/warehouses',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-warehouses/warehouse-list/warehouse-list.html',
                        controller: 'CompanyWarehouseListController as vm'
                    }
                }
            })
            .state('app.company.fiscalPeriod', {
                url: '/fiscalPeriod',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-fiscalPeriods/fiscalPeriod-list/fiscalPeriod-list.html',
                        controller: 'CompanyFiscalPeriodListController as vm'
                    }
                }
            })
            .state('app.company.establishment.configureDiscounts', {
                url: '/:id/discounts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/discountsConfigureDetail.html',
                        controller: 'DiscountsConfigureController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }

            })
            .state('app.company.establishment.codeBagCollectionQueue', {
                url: '/:id/codeBag',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-establishments/establishment-list/codeBagCollectionQueue/codeBagCollectionQueue.html',
                        controller: 'codeBagCollectionQueueController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                params: {
                    establishment: null
                }
            })
            .state('app.company.establishment.parameterProduct', {
                url: '/:id/parameters',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company-establishments/establishment-list/parameters/parameters.html',
                        controller: 'ParametersProductController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                params: {
                    establishment: null
                }
            })
          .state('app.company.adminSeries', {
            url: '/adminSeries',
            views: {
              'content@app': {
                templateUrl: 'app/main/apps/company/admin-series/establishment-cashier-list/establishment-cashier-list.html',
                controller: 'EstablishmentCashierListController as vm'
              }
            }
          });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/company');

    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('dialogGenerateCodeBagController', dialogGenerateCodeBagController);

    /** @ngInject */
    function dialogGenerateCodeBagController(api, $mdDialog, establishmentId, $log, $filter) {
        var vm = this;
        vm.establishmentId = establishmentId;

        vm.paginationBank = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        vm.saveBag = function () {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('company_establishment.newCode'))
                .textContent($filter('translate')('company_establishment.confirm_newCode'))
                .multiple(true)
                .ok($filter('translate')('BLOCKEDSERIES.SI'))
                .cancel($filter('translate')('BLOCKEDSERIES.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.PosAdminWS.Bag.Bag.create({ 'quantity': vm.quantity, 'establishmentId': vm.establishmentId }, function (response) {
                    if (response) {
                        vm.isShowProgressLinear = false;
                        $mdDialog.hide();
                    }
                }, function (errNewCode) {
                    vm.isShowProgressLinear = false;
                    $log.debug(errNewCode);
                });
            }, function (errNewcode) {
                $log.debug(errNewcode);
            });
        };


        vm.cancel = function () {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('dialogDetailCodeBagController', dialogDetailCodeBagController);

    /** @ngInject */
    function dialogDetailCodeBagController(api, $mdDialog, bag, $log) {
        var vm = this;
        vm.bag = bag;

        vm.paginationBank = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        vm.saveBag = function () {
            api.PosAdminWS.Bag.Bag.update({
                'establishmentId': vm.bag.companyEstablishment.id
            },
                vm.bag, function (response) {
                    $mdDialog.hide();
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
        };


        vm.cancel = function () {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.profile', {
            url: '/profile',
            views: {
                'content@app': {
                    templateUrl: 'app/main/general/profile/profile.html',
                    controller: 'ProfileController as vm'
                }
            },
            bodyClass: 'profile'
        });

        $stateProvider.state('app.profile.edit', {
            url: '/edit',
            views: {
                'content@app': {
                    templateUrl: 'app/main/general/profile/profileEditor/profileEditor.html',
                    controller: 'ProfileEditController as vm'
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/profile');

    }
})();

(function () {
  'use strict';
  angular
    .module('app.profile')
    .controller('NewGroupController', NewGroupController);

  /** @ngInject */
  function NewGroupController($mdDialog, api, $rootScope, $log, data, $scope) {

    var vm = this;

    var isNew = data === null ? true : false;
    vm.changeDefault = false;

    if (!isNew) {
      vm.group = data;
    } else {
      vm.group = {
        user: {
          account: $rootScope.account.preferredUsername.userName
        }
      }
    }

    // Methods
    vm.closeDialog = closeDialog;
    vm.saveGroup = saveGroup;
    vm.onChangeDefault = onChangeDefault;


    getGroupDefault();

    function getGroupDefault() {
      api.GeneralWS.UserEstablishmentGroup.getDefault.getGroup({
        'userAccount': $rootScope.account.preferredUsername.userName
      }).$promise.then(function (response) {
        vm.searchDefault = response;
      }, function (error) {
        $log.error(error);
      })
    }

    function onChangeDefault() {
      $scope.$watch("vm.group.searchDefault", function (newVal, oldVal) {
        if (newVal && vm.searchDefault) {
          if (vm.group.id == null || (vm.group.id != vm.searchDefault.id)) {
            vm.changeDefault = true;
          } else {
            vm.changeDefault = false;
          }
        }
      });
    }

    function saveGroup() {
      if (isNew) {
        api.GeneralWS.UserEstablishmentGroup.createGroup.save({
          'changeDefault': vm.changeDefault
        }, vm.group).$promise.then(function (response) {
          $mdDialog.hide(data);
        }, function (error) {
          $log.error(error);
        })
      } else {
        api.GeneralWS.UserEstablishmentGroup.updateGroup.update({
          'id': vm.group.id,
          'changeDefault': vm.changeDefault
        }, vm.group).$promise.then(function (response) {
          $mdDialog.hide(data);
        }, function (error) {
          $log.error(error);
        })
      }
    }

    function closeDialog() {
      $mdDialog.cancel();
    }


  }
})();

(function () {

  'use strict';

  angular
    .module('app.profile')
    .controller('MembersUserEstablishmentGroupController', MembersUserEstablishmentGroupController);

  /**@ngInject**/
  function MembersUserEstablishmentGroupController($rootScope, $log, $timeout, $filter, $mdDialog, api, MessageService, id) {

    var vm = this;

    vm.loadNoMembersGroup = loadNoMembersGroup;
    vm.loadMembersGroup = loadMembersGroup;
    vm.cancel = cancel;
    vm.searchNoMember = searchNoMember;
    vm.searchMember = searchMember;
    vm.isSelected = isSelected;
    vm.isSelectedAssociated = isSelectedAssociated;
    vm.validateSelectedAllNoMembers = validateSelectedAllNoMembers;
    vm.selectAllNoMembers = selectAllNoMembers;
    vm.validateSelectedAllMembers = validateSelectedAllMembers;
    vm.selectAllMembers = selectAllMembers;
    vm.toggle = toggle;
    vm.toggleAssociated = toggleAssociated;
    vm.associateEstablishment = associateEstablishment;
    vm.disassociateEstablishment = disassociateEstablishment;

    vm.selectedArray = [];
    vm.selectedAssociatedArray = [];
    vm.countNoMembersSelected = 0;
    vm.countMembersSelected = 0;
    vm.widget = 0;

    vm.paginationNotMembers = {
      pageNumber: 0,
      pageSize: 20,
      totalElements: 0,
      totalPages: 0,
      nextPage: function () {
        this.pageNumber++;
      },
      beforePage: function () {
        this.pageNumber--;
      },
      firstPage: function () {
        this.pageNumber = 0;
      },
      lastPage: function () {
        this.pageNumber = this.totalPages;
      },
      getPage: function (pageNumber) {
        this.pageNumber = pageNumber;
        loadNoMembersGroup();
      }
    };

    vm.paginationMembers = {
      pageNumber: 0,
      pageSize: 20,
      totalElements: 0,
      totalPages: 0,
      nextPage: function () {
        this.pageNumber++;
      },
      beforePage: function () {
        this.pageNumber--;
      },
      firstPage: function () {
        this.pageNumber = 0;
      },
      lastPage: function () {
        this.pageNumber = this.totalPages;
      },
      getPage: function (pageNumber) {
        this.pageNumber = pageNumber;
        loadMembersGroup();
      }
    };

    function loadNoMembersGroup() {
      vm.isShowProgressLinear = true;
      vm.loading = true;
      $rootScope.loadingProgress = true;
      api.GeneralWS.UserEstablishmentGroupDetail.establishmentNotMembersGroup.getAll({
        'userEstablishmentGroupId': vm.groupId,
        'pageNumber': vm.paginationNotMembers.pageNumber,
        'pageSize': vm.paginationNotMembers.pageSize,
        'search': vm.inputSearchEstablishment
      }).$promise.then(function (response) {
        vm.isShowProgressLinear = false;
        vm.loading = false;
        $rootScope.loadingProgress = false;
        vm.paginationNotMembers.totalElements = response.totalElements;
        vm.paginationNotMembers.totalPages = response.totalPages;
        vm.paginationNotMembers.pageNumber = response.number + 1;
        vm.noMembersArray = response.content;
        vm.isCheckAllNoMembers = false;
        vm.countNoMembersSelected = 0;
      }, function (error) {
        $log.error(error);
        vm.isShowProgressLinear = false;
        vm.loading = false;
        $rootScope.loadingProgress = false;
      })
    }

    function loadMembersGroup() {
      vm.isShowProgressLinear = true;
      vm.loading = true;
      $rootScope.loadingProgress = true;
      api.GeneralWS.UserEstablishmentGroupDetail.establishmentMembersGroup.getAll({
        'userEstablishmentGroupId': vm.groupId,
        'pageNumber': vm.paginationMembers.pageNumber,
        'pageSize': vm.paginationMembers.pageSize,
        'search': vm.inputSearchMember
      }).$promise.then(function (response) {
        vm.isShowProgressLinear = false;
        vm.loading = false;
        $rootScope.loadingProgress = false;
        vm.paginationMembers.totalElements = response.totalElements;
        vm.paginationMembers.totalPages = response.totalPages;
        vm.paginationMembers.pageNumber = response.number + 1;
        vm.membersArray = response.content;
        vm.isCheckAllMembers = false;
        vm.countMembersSelected = 0;
      }, function (error) {
        vm.isShowProgressLinear = false;
        vm.loading = false;
        $rootScope.loadingProgress = false;
        $log.error(error);
      });
    }

    $timeout(function () {

      vm.groupId = id;
      loadNoMembersGroup();
      loadMembersGroup();

      var mdDialog = $(".department-product");
      var windowHeight = parseInt(mdDialog.innerHeight());

      windowHeight -= 155;

      vm.dinamicHeight = {
        "height": windowHeight + "px"
      };

    }, 1000);

    function searchNoMember() {
      vm.paginationNotMembers.pageNumber = 1;
      vm.selectedArray = [];
      vm.selectedAssociatedArray = [];
      loadNoMembersGroup();
    }

    function searchMember() {
      vm.paginationMembers.pageNumber = 1;
      vm.selectedArray = [];
      vm.selectedAssociatedArray = [];
      loadMembersGroup();
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function toggle(data, event) {
      if (event) {
        event.stopPropagation();
      }
      if (vm.selectedArray.indexOf(data) > -1) {
        vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
      } else {
        vm.selectedArray.push(data);
      }
    }

    function toggleAssociated(data, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedAssociatedArray.indexOf(data) > -1) {
        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
      } else {
        vm.selectedAssociatedArray.push(data);
      }
    }

    function isSelected(data) {
      return vm.selectedArray.indexOf(data) > -1;
    }

    function isSelectedAssociated(data) {
      return vm.selectedAssociatedArray.indexOf(data) > -1;
    }

    function validateSelectedAllNoMembers() {
      vm.countNoMembersSelected = 0;
      var isSelectAll = true;
      vm.noMembersArray.forEach(function (row) {
        if (!row.isCheck) {
          isSelectAll = false;
        } else {
          vm.countNoMembersSelected++;
        }
      });
      if (isSelectAll) {
        vm.isCheckAllNoMembers = true;
      } else {
        vm.isCheckAllNoMembers = false;
      }
    }

    function selectAllNoMembers() {
      vm.selectedArray = [];
      if (vm.isCheckAllNoMembers) {
        vm.noMembersArray.forEach(function (row) {
          row.isCheck = true;
          if (!vm.selectedArray.indexOf(row) > -1) {
            vm.selectedArray.push(row);
          }
        });
        vm.countNoMembersSelected = vm.noMembersArray.length;
      } else {
        vm.noMembersArray.forEach(function (row) {
          row.isCheck = false;
          if (vm.selectedArray.indexOf(row) > -1) {
            vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
          }
        });
        vm.countNoMembersSelected = 0;
      }
    }

    function validateSelectedAllMembers() {
      vm.countMembersSelected = 0;
      var isSelectAll = true;
      vm.membersArray.forEach(function (row) {
        if (!row.isCheck) {
          isSelectAll = false;
        } else {
          vm.countMembersSelected++;
        }
      });
      if (isSelectAll) {
        vm.isCheckAllMembers = true;
      } else {
        vm.isCheckAllMembers = false;
      }
    }

    function selectAllMembers() {
      vm.selectedAssociatedArray = [];
      if (vm.isCheckAllMembers) {
        vm.membersArray.forEach(function (row) {
          row.isCheck = true;
          if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
            vm.selectedAssociatedArray.push(row);
          }
        });
        vm.countMembersSelected = vm.membersArray.length;
      } else {
        vm.membersArray.forEach(function (row) {
          row.isCheck = false;
          if (vm.selectedAssociatedArray.indexOf(row) > -1) {
            vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
          }
        });
        vm.countMembersSelected = 0;
      }
    }

    function associateEstablishment() {
      var ids = vm.isCheckAllNoMembers ? [] : vm.selectedArray.map(function (a) {
        return a.id;
      });

      if (ids.length === 0 && !vm.isCheckAllNoMembers) {
        return;
      }
      vm.isShowProgressLinear = true;
      api.GeneralWS.UserEstablishmentGroupDetail.addMembers.create({
        'userEstablishmentGroupId': vm.groupId,
        'associateAll': vm.isCheckAllNoMembers,
        'ids': ids
      }).$promise.then(function (response) {
        if (vm.paginationMembers.totalPages === 0) {
          vm.paginationMembers.pageNumber = 1;
        } else {
          vm.paginationMembers.pageNumber = vm.paginationMembers.totalPages;
        }
        vm.inputSearchMember = "";
        vm.isCheckAllNoMembers = false;
        loadMembersGroup();

        vm.paginationNotMembers.pageNumber = 1;
        vm.isCheckAllNoMembers = false;
        vm.inputSearchEstablishment = "";
        vm.selectedArray = [];
        loadNoMembersGroup();
      }, function (error) {
        MessageService.showErrorMessage($filter('translate')('general.error'));
        vm.isShowProgressLinear = false;
        $log.error(error);

      })
    }

    function disassociateEstablishment() {
      var ids = vm.isCheckAllMembers ? [] : vm.selectedAssociatedArray.map(function (a) {
        return a.id;
      });

      if (ids.length === 0 && !vm.isCheckAllMembers) {
        return;
      }

      vm.isShowProgressLinear = true;


      api.GeneralWS.UserEstablishmentGroupDetail.removeMembers.delete({
        'userEstablishmentGroupId': vm.groupId,
        'deleteAll': vm.isCheckAllMembers,
        'ids': ids
      }).$promise.then(function (response) {
        vm.isShowProgressLinear = false;
        vm.paginationNotMembers.pageNumber = 1;
        vm.isCheckAllNoMembers = false;
        vm.inputSearchEstablishment = "";
        loadNoMembersGroup();

        vm.inputSearchMember = "";
        vm.isCheckAllNoMembers = false;
        vm.selectedAssociatedArray = [];
        loadMembersGroup();
      }, function (error) {
        vm.isShowProgressLinear = false;
        $log.error(error);
      });
    }


  }

})();

(function () {

  'use strict';

  angular
    .module('app.product')
    .controller('CreateProductController', CreateProductController);

  /**@ngInject**/
  function CreateProductController(api, $mdDialog, product, $log, $filter, $timeout, $rootScope, MessageService, brands, measures, envService) {

    var vm = this;
    vm.product = product;
    vm.photoProduct = [];

    vm.closeDialog = closeDialog;
    vm.save = save;
    vm.clearSearchBrand = clearSearchBrand;
    vm.clearSearchMeasure = clearSearchMeasure;
    vm.changeBrand = changeBrand;
    vm.fileRemove = fileRemove;
    vm.viewImage = viewImage;
    vm.baseUrlSharedFiles = envService.read('baseUrlSharedFiles');

    function closeDialog() {
      $mdDialog.cancel();
    }

    function clearSearchBrand() {
      vm.searchBrand = "";
    }

    function clearSearchMeasure() {
      vm.searchMeasures = "";
    }

    function init() {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchMeasuresesInput = document.querySelector("#searchMeasureses");
      var searchBrandInput = document.querySelector("#searchBrand");

      if (searchMeasuresesInput) {
        searchMeasuresesInput.addEventListener("keydown", keyEvent);
      }

      if (searchBrandInput) {
        searchBrandInput.addEventListener("keydown", keyEvent);
      }

      vm.brands = brands;
      vm.measures = measures;

      if (vm.product.id && vm.product.expirationDate) {
        if (typeof (vm.product.expirationDate) === "number") {
          vm.product.expirationDate = new Date(vm.product.expirationDate);
        } else if (vm.product.expirationDate.length === 10) {
          const ff = vm.product.expirationDate.split("-");
          vm.product.expirationDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
        }
      }

      api.GeneralWS.FileStorage.productPhoto.get({
        productIds: vm.product.id,
      }).$promise
        .then(function (productPhoto) {

          productPhoto.forEach(function (i) {
            vm.product.productPhotos.push({
              id: i.productPhotoId,
              active: i.active,
              productId: i.productId,
              photo: {
                id: i.id,
                active: i.active,
                serverPath: i.pathServer,
                basePath: i.pathBase,
                parentPath: i.pathParent,
                name: i.fileName,
                extension: i.fileExtension,
                fileSize: i.fileSize,
                originalName: i.fileOriginalName,
                fullUrl: i.fileFullUrl,
                isPrivate: i.fileIsPrivate,
                productPhotoId: i.productPhotoId,
                productId: i.productId,
              },
            });
          });

        });
    }

    function changeBrand() {
      vm.noExistBrand = !vm.noExistBrand;
    }

    function save() {
      vm.isShowProgressLinear = true;
      vm.loading = true;

      var promise;
      var isEdit = false;

      if (vm.product.id === null) {
        promise = api.GeneralWS.Product.create({idCircle: $rootScope.bsCircle.id}, vm.product).$promise;
      } else {
        isEdit = true;
        promise = api.GeneralWS.Product.update({idCircle: $rootScope.bsCircle.id}, vm.product).$promise;
      }

      promise.then(function (response) {
        vm.isShowProgressLinear = false;
        switch (response.$status) {
          case 200:
            if (isEdit) {
              MessageService.show("CREATE.PRODUCT_UPDATED");
            } else {
              MessageService.show('CREATE.PRODUCT_CREATED');
            }
            savePhotos(response);
            break;
          case 202:
            if (response.$data === "exist_in_other_company") {
              MessageService.show("CREATE.PRODUCT_IN_OTHER_COMPANY");
            } else {
              MessageService.show("CREATE.PRODUCT_ASSOCIATED_PROVIDER");
            }
            vm.loading = false;
            break;
          default:
            break;
        }

      }, function (erro) {
        vm.isShowProgressLinear = false;
        vm.loading = false;

        if (erro.data && erro.data.mensaje) {
          MessageService.showErrorMessage(erro.data.mensaje);
        } else {
          MessageService.showErrorMessage('general.general_error');
        }
      });
    }

    function savePhotos(response) {
      if (vm.product.productPhotos != null) {
        response.productPhotos = vm.product.productPhotos;
      } else {
        response.productPhotos = null;
      }
      const files = [];
      vm.filesToUpload.forEach(function (r) {
        files.push(r.file.file);
      });

      if (vm.filesToUpload.length > 0) {
        vm.isShowProgressLinear = true;

        api.GeneralWS.ProductPhotos.addPhotos({id: response.id}, files).then(function (photos) {
          if (vm.product.id > 0 && response.productPhotos != null) {
            vm.product.productPhotos.push(photos.data);
            response.productPhotos = vm.product.productPhotos;
          } else {
            response.productPhotos = photos.data;
          }
          vm.isShowProgressLinear = false;
          vm.loading = false;
          $mdDialog.hide(response);
        }, function (errResponse) {
          vm.isShowProgressLinear = false;
          $log.error(errResponse);
          vm.loading = false;
          MessageService.showErrorMessage($filter('translate')('general.general_error'));
        });
      } else {
        vm.loading = false;
        $mdDialog.hide(response);
      }
    }

    function fileRemove(file) {
      vm.loading = true;
      vm.isShowProgressLinear = true;
      api.GeneralWS.ProductPhotos.deletePhoto.delete({id: file.id}).$promise.then(function () {
        vm.loading = false;
        vm.isShowProgressLinear = false;
        const index = vm.product.productPhotos.indexOf(file);
        vm.product.productPhotos.splice(index, 1);
        MessageService.show("CREATE.PRODUCT_PHOTO_DELETED");
      }, function (errResponse) {
        $log.error(errResponse);
        vm.isShowProgressLinear = false;
        vm.loading = false;
        MessageService.showErrorMessage($filter('translate')('CREATE.PRODUCT_PHOTO_DELETED_ERROR'));
      });

    }

    function viewImage(file) {
      const url = ''.concat(vm.baseUrlSharedFiles, file.photo.parentPath, file.photo.name, 'l',file.photo.extension );
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
    }


    $timeout(init, 1000);

  }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('DialogProductTypeController', DialogProductTypeController);

    /**@ngInject**/
    function DialogProductTypeController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog, company) {
        var vm = this;
        vm.cancel = cancel;
        vm.selectProductType = selectProductType;
        vm.productsToFilter = [];
        vm.description = '';

        $rootScope.categorySelected = null;
        vm.categorySelected = {
            description: strAllCategory,
            nameInner: 'AllCategory',
            id: 0
        };
        vm.filterProduct = '';
        var strAllCategory = $filter('translate')('PRODUCT.ALL_CATEGORY');

        vm.obSearch = {
            page: 0,
            size: 20,
            typeSearch: 'product'
        };
        vm.productTypeSelected = {};

        $timeout(init, 200);

        function init() {
            vm.loading = true;
            $timeout(createCategoryTree(vm.categorySelected.id), 1500);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        vm.changeFilter = function () {
            $("#tree").jstree("search", vm.filterProduct);
        }

        function createCategoryTree(categoryParentId) {

            vm.group = [];

            api.GeneralWS.ProductType.categoryParent.get(
                {
                    'company': $rootScope.bsCircle.company.id, 'idCircle': $rootScope.bsCircle.id, 'categoryId': categoryParentId
                }
            ).$promise.then(function (response) {
                vm.group = new jinqJs()
                    .from(response)
                    .groupBy('productTypeParent')
                    .select(function (r) {
                        r.text = r.productTypeCode + "-" + r.description;
                        r.parent = r.productTypeParent ? r.productTypeParent.id : '#';
                        return r;
                    });

            }, function (response) {
                $log.error(response);
            });

            $timeout(function () {
                $.jstree.destroy();
                $('#tree')
                    .bind('changed.jstree', function (e, data) {
                        if (data.action === 'select_node') {
                            data.selected.forEach(function (r) {
                                vm.productsToFilter.push(r);
                            });
                            if (data.node.text) {
                                vm.description = vm.description + data.node.text + ', ';
                            }
                        } else {
                            vm.productsToFilter = [];
                            data.selected.forEach(function (r) {
                                vm.productsToFilter.push(r);
                            });
                            vm.description = vm.description.replace(data.node.text + ', ', '');

                        }
                        style();
                    })
                    .on('hover_node.jstree', function (e, data) {
                        $("#" + data.node.id).prop('title', data.node.text);
                        style();
                    })
                    .jstree({
                        'core': {
                            'data': vm.group,
                            "themes": {
                                "icons": false
                            }
                        },
                        'search': {
                            "show_only_matches": true
                        },
                        'plugins': ["search", "crrm", "types", "wholerow", "checkbox"]
                    });
                vm.loading = false;
                style();
            }, 5000);

        }

        function style() {
            $timeout(function () {
                document.querySelectorAll('.jstree-anchor').forEach(function (inf) {
                    inf.setAttribute("style", 'font-size:18px');
                });
            }, 300);
        }

        function selectProductType() {
            var obj = {
                description: vm.description.substring(0, vm.description.length - 2),
                ids: vm.productsToFilter
            };
            $mdDialog.hide(obj);

        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('RepositionDaysDialogController', RepositionDaysDialogController);

    /**@ngInject**/
    function RepositionDaysDialogController(api, $mdDialog, $log, $filter, $timeout, $rootScope, MessageService, productId) {
        var vm = this;
        vm.loading = false;

        vm.arrayDaysOfWeek = [
            {id: 0, value: 'daysOfWeek.Monday'},
            {id: 1, value: 'daysOfWeek.Tuesday'},
            {id: 2, value: 'daysOfWeek.Wednesday'},
            {id: 3, value: 'daysOfWeek.Thursday'},
            {id: 4, value: 'daysOfWeek.Friday'},
            {id: 5, value: 'daysOfWeek.Saturday'},
            {id: 6, value: 'daysOfWeek.Sunday'}
        ];

        vm.copyArrayDaysOfWeek = angular.copy(vm.arrayDaysOfWeek);
        vm.arrayRepositionDays = [];
        vm.salePurchaseRepositionDays = {
            companyId: $rootScope.bsCircle.company.id,
            productId: productId,
            dayOfWeek: null
        };
        vm.closeDialog = closeDialog;
        vm.save = save;

        vm.masterColumnDefs = [
            {
                headerName: '#',
                width: 50,
                filter: 'number',
                cellStyle: {'text-align': 'center'},
                pinned: 'left',
                cellRenderer: function (data) {
                    return data.rowIndex + 1;
                }
            },
            {
                headerName: 'product_parameters.daysOfWeek',
                field: "dayOfWeek",
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.data) {
                        return $filter("translate")("product_parameters." + vm.arrayDaysOfWeek[params.data.dayOfWeek].value);
                    } else {
                        return ""
                    }
                },
                width: 250,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'product_parameters.actions',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: renderer,
                cellStyle: {'padding': '0px'},
                pinned: 'right'
            }
        ];
        vm.gridOptions = {
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            pagination: false,
            columnDefs: vm.masterColumnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getRowNodeId: function (data) {
                return data.id;
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            }
        };

        function renderer(params) {
            var toRet = '<div style="width: 100%;">';
            toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.deleteData(' + params.rowIndex + ', data.id)" aria-label="Order details"'
                + '                         translate translate-attr-aria-label="general.delete">'
                + '                <md-tooltip md-direction="bottom">'
                + '                    {{"general.delete"| translate}}'
                + '                </md-tooltip>'
                + '                <md-icon md-font-icon="icon-trash" class="s16 md-warn"></md-icon> '
                + '            </md-button>';
            return toRet + '</div>';
        }

        function loadData() {
            vm.isShowProgressLinear = true;
            var dataSource = {
                getRows: function (params) {
                    api.InterfazWS.SalePurchaseRepositionDays.byCompanyAndProduct.query({
                        'companyId': $rootScope.bsCircle.company.id,
                        'productId': productId
                    }).$promise.then(function (response) {
                        vm.isShowProgressLinear = false;
                        vm.loading = false;
                        vm.arrayRepositionDays = response;
                        params.successCallback(response, response.length);
                        getDaysToConfig();
                        vm.showGrid = true;
                    }, function (response) {
                        $log.error(response);
                        vm.isShowProgressLinear = false;
                    });
                }
            };
            vm.gridOptions.api.setEnterpriseDatasource(dataSource);
        }

        init();

        function init() {
            $timeout(function () {
                loadData();
            }, 200);
        }

        function closeDialog() {
            $mdDialog.hide(vm.arrayRepositionDays);
        }

        vm.deleteData = function (index, id) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('product_parameters.MSG.deleteRepositionDays'))
                .textContent($filter('translate')('product_parameters.MSG.confirmationDeleteDays') + "?")
                .ok($filter('translate')('product_parameters.MSG.SI'))
                .multiple(true)
                .cancel($filter('translate')('product_parameters.MSG.NO'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                vm.loading = true;
                api.InterfazWS.SalePurchaseRepositionDays.me.delete({
                    'id': id
                }).$promise.then(function () {
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                    MessageService.show($filter('translate')('product_parameters.MSG.successfullyDeleteConfig'));
                    loadData();
                }, function (err) {
                    $rootScope.loadingProgress = false;
                    vm.loading = false;
                    console.error(err);
                });
            }, function (error) {
                console.error(error);
            });
        };

        function getDaysToConfig() {
            var days = vm.arrayRepositionDays.map(function (value) {
                return value.dayOfWeek
            });
            vm.copyArrayDaysOfWeek = vm.arrayDaysOfWeek.filter(function (value) {
                return !days.includes(value.id)
            });
        }

        function save() {
            $rootScope.loadingProgress = true;
            vm.loading = true;
            api.InterfazWS.SalePurchaseRepositionDays.me.create({}, vm.salePurchaseRepositionDays)
                .$promise.then(function () {
                vm.salePurchaseRepositionDays.dayOfWeek = null;
                MessageService.show('product_parameters.MSG.successfullyAddedConfig');
                loadData();
                $rootScope.loadingProgress = false;
                vm.loading = false;
            }, function (errResponse) {
                MessageService.showErrorMessage('product_parameters.MSG.errorAddingConfig');
                $rootScope.loadingProgress = false;
                vm.loading = false;
            });
        }

    }
})();

(function () {
  'use strict';
  angular
    .module('app.product')
    .controller('ProductListBatchDialogController', ProductListBatchDialogController);

  /** @ngInject */
  function ProductListBatchDialogController($mdDialog, $log, $rootScope, $filter, api, products, addons) {
    var vm = this;
    vm.productos = products;
    vm.loading = true;

    // Methods
    vm.closeDialog = closeDialog;

    saveAllProduct();

    //////////

    function closeDialog() {
      if (!vm.loading) {
        $mdDialog.hide();
      }
    }

    function saveAllProduct() {
      vm.productos.content.forEach(function (product) {
        product.loading = true;
        getAddonByProduct(product);
      });
    }

    function getAddonByProduct(product) {
      api.GeneralWS.ProductCompanyAddons.me.get({
        'id': 'getByProductAndCompany', 'idCircle': $rootScope.bsCircle.id, 'productId': product.id
      }).$promise.then(function (response) {
        const addons = response;
        addons.providerCanInvoiceBeforeReceive = response.providerCanInvoiceBeforeReceive ? response.providerCanInvoiceBeforeReceive : false;
        addons.isConsignment = response.isConsignment ? response.isConsignment : false;
        saveProduct(product, addons);
      }, function (response) {
        const addons = { canReQuote: true };
        saveProduct(product, addons);
        $log.error(response);
      });
    }

    function saveProduct(product, pAddon) {
      pAddon = updateAddon(pAddon);
      var promise;
      if (pAddon.id) {
        promise = api.GeneralWS.ProductCompanyAddons.me.update({
          "id": pAddon.id, 'idCircle': $rootScope.bsCircle.id, 'byMassiveUpdate': true
        }, pAddon).$promise;
      } else {
        pAddon.product = product;
        promise = api.GeneralWS.ProductCompanyAddons.me.create({
          'idCircle': $rootScope.bsCircle.id, 'productId': product.id, 'byMassiveUpdate': true
        }, pAddon).$promise;
      }

      promise.then(function (response) {
        product.loading = false;
        product.isError = false;
        validateAllFinished();
      }, function (response) {
        product.loading = false;
        product.isError = true;
        validateAllFinished();
        $log.error(response);
      });
    }

    function validateAllFinished() {
      var pendings = $filter('filter')(vm.productos.content, { loading: true });
      vm.loading = pendings.length > 0;
    }

    function updateAddon(pAddon) {
      var id = pAddon.id;
      pAddon = angular.copy(addons);
      pAddon.id = id;
      return pAddon;
    }
  }

})();

(function () {
    'use strict';
    angular
        .module('app.product')
        .controller('ProductListDialogController', ProductListDialogController);

    /** @ngInject */
    function ProductListDialogController($mdDialog, api, $timeout, $rootScope, $scope, productId) {
        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;

        var isNew = productId !== 0 ? false : true;
        vm.product = { id: productId };
        vm.loading = true;
        vm.canSave = false;
        vm.productos = [];

        // Methods
        vm.closeDialog = closeDialog;
        vm.selectProduct = selectProduct;
        vm.sendDetail = sendDetail;
        vm.getProducts = getProducts;
        vm.changeFilter = changeFilter;
        vm.activeSearch = activeSearch;

        getProducts(vm.page);

        //////////

        function closeDialog() {
            $mdDialog.cancel();
        }

        $scope.$watch('vm.filterProduct', function (newVal) {
            if (newVal && newVal.length > -1) {
                getProducts(1);
            }
        });

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function activeSearch() {
            vm.searchMode = true;
            $timeout(function () {
                $('#searchField').focus();
            });
        }

        function selectProduct(product) {
            vm.searchMode = false;
            var change = isNew ? isNew : vm.product.id !== product.id;
            vm.product = product;

            if (isNew || change) {
                $timeout(function () {
                    vm.canSave = true;
                });
            }
        }

        function getProducts(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.ProductAll.get({ circle: $rootScope.bsCircle.id, page: page - 1, size: vm.pageSize, filter: vm.filterProduct },
                function (data) {
                    vm.productos = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function sendDetail() {
            if (vm.canSave && vm.product.id !== 0) {
                $mdDialog.hide(vm.product);
            }

        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.interfaz', [])
        .config(config);

    function config($stateProvider, $translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/apps/interfaz');

        $stateProvider
            .state('app.interfaz', {
                url: '/interfaz',
                abstract: true
            })
            .state('app.interfaz.report', {
                url: '/report',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/interfaz/report/report.html',
                        controller: 'InterfazReportController',
                        controllerAs: 'vm'
                    }
                }
            });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.interfaz')
        .controller('InterfazReportDetailController', InterfazReportDetailController);

    function InterfazReportDetailController($mdDialog, api, $filter, $timeout, $log, $rootScope, detailArray) {

        var vm = this;
        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            fullWidthCellRenderer: true,
            rowData: detailArray,
            pinnedBottomRowData: [],
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            columnDefs: [
                {
                    headerName: "REPORT.date",
                    field: "createdAt",
                    headerCellRenderer: getHeader,
                    valueFormatter: function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
                        }
                    },
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    suppressMenu: true,
                    suppressSorting: false,
                    headerName: "REPORT.message",
                    headerCellRenderer: getHeader,
                    field: "messageDetail",
                    width: 500,
                    enableRowGroup: false,
                    enablePivot: false
                }
            ]
        };

        //methods
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {
            var element = $("#transactionDetailMasterGridOptions");

            if (element) {
                var dialogHeight = element[0].parentElement.offsetHeight;
                dialogHeight -= 40;

                element.css('height', dialogHeight + 'px');
            }
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration', [])
        .config(config);

    function config($stateProvider, $translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/apps/generalConfiguration');

        $stateProvider
            .state('app.generalConfiguration', {
                url: '/generalConfig',
                abstract: true
            })
            .state('app.generalConfiguration.additionalFields', {
                url: '/configuration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalConfiguration/additionalFields/additionalFields.html',
                        controller: 'AdditionalFieldsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.generalConfiguration.discounts', {
                url: '/discounts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalConfiguration/discounts/discounts.html',
                        controller: 'DiscountsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }
            })
            .state('app.generalConfiguration.gFace', {
                url: '/gFace',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalConfiguration/gFace/gFace.html',
                        controller: 'gFaceController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.generalConfiguration.paymentCondition', {
                url: '/paymentCondition',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/generalConfiguration/payment-condition/payment-list/payment-list.html',
                        controller: 'PaymentConditionListController',
                        controllerAs: 'vm'
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('DiscountEstablishmentProductTypeController', DiscountEstablishmentProductTypeController);

    function DiscountEstablishmentProductTypeController($scope, $rootScope, $stateParams, DiscountCondition, $timeout, api, $log, $mdDialog, $filter, MessageService) {
        //Discount producttype controller alias
        var dptCtrl = this;
        var vm = $scope.$parent.vm;

        dptCtrl.page = 1;
        dptCtrl.pageSize = 20;
        dptCtrl.getProductstypes = getProductstypes;
        dptCtrl.selectProductType = selectProductType;
        dptCtrl.onChangeDiscount = onChangeDiscount;
        dptCtrl.producttypes = [];
        dptCtrl.loadingPt = true;

        $timeout(init, 500);

        /**
         * Initialize
         */
        function init() {
            var contentHeight = 800 /**$("#prenegociatedPriceProductList").innerHeight()*/;
            contentHeight -= 112;
            dptCtrl.dinamicHeight = { "height": contentHeight + "px" };

            getProductstypes();
            getDiscounts();
        }

        function getProductstypes() {
            dptCtrl.selectedProducttype = null;
            dptCtrl.searchText = null;
            dptCtrl.producttypes = [];

            api.GeneralWS.ProductType.allN1.get(
                {
                    'company': $rootScope.bsCircle.company.id, 'idCircle': $rootScope.bsCircle.id
                }
            ).$promise.then(function (response) {
                dptCtrl.producttypes = response;
                dptCtrl.loadingPt = false;
            }, function (response) {
                $log.error(response);
                dptCtrl.loadingPt = false;
            });
        }

        function getDiscounts() {
            dptCtrl.selectedProducttype = null;
            dptCtrl.searchText = null;
            dptCtrl.alldiscounts = [];

            api.GeneralWS.DiscountCompanyEstablishment.byEstablishment.get(
                {
                    'establishmentId': $stateParams.id, 'idCircle': $rootScope.bsCircle.id
                }
            ).$promise.then(function (response) {
                dptCtrl.alldiscounts = response;
            }, function (response) {
                $log.error(response);
            });
        }

        function selectProductType(producttype) {
            if (dptCtrl.selectedProducttype && producttype.id === dptCtrl.selectedProducttype.id) {
                return null;
            }

            dptCtrl.selectedProducttype = producttype;
            dptCtrl.searchText = null;
            dptCtrl.messageOnLoadDiscounts = $filter('translate')('DISCOUNTS.loading');
            dptCtrl.loadingDiscounts = true;

            api.GeneralWS.DiscountCompanyEstablishmentProductType.byProductType.get(
                {
                    'establishmentId': $stateParams.id, 'productTypeId': producttype.id
                }
            ).$promise.then(function (response) {
                dptCtrl.establishmentDiscounts = new jinqJs()
                        .from(dptCtrl.alldiscounts)
                        .leftJoin(response)
                        .on(function(d1, d2){
                            return d1.id === d2.discountCompanyEstablishment.id;
                        })
                        .select(function(dd1, dd2){
                            if(dd1.productType && dd1.productType.id) {
                                dd1.selected = true;
                            } else {
                                dd1.selected = false;
                            }
                            return dd1;
                        });
                dptCtrl.loadingDiscounts = false;
            }, function (response) {
                $log.error(response);
                dptCtrl.loadingDiscounts = false;
            });
            
        }

        function onChangeDiscount(discountCompanyEstablishment) {
            discountCompanyEstablishment.loading = true;
            api.GeneralWS.DiscountCompanyEstablishmentProductType.byProductType.modify(
                {
                    'establishmentId': $stateParams.id, 
                    'productTypeId': dptCtrl.selectedProducttype.id,
                    'id': discountCompanyEstablishment.id,
                    'selected': discountCompanyEstablishment.selected
                },{}
            ).$promise.then(function (response) {
                discountCompanyEstablishment.loading = false;
            }, function (response) {
                $log.error(response);
                discountCompanyEstablishment.loading = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('DiscountDatesMessageDialogController', DiscountDatesMessageDialogController);

    function DiscountDatesMessageDialogController($log, api, $mdDialog, $timeout, $filter, DiscountTypes, $rootScope, discountDate, MessageService) {
        var vm = this;
        vm.discountDate = discountDate;
        vm.closeDialog = $mdDialog.cancel;
        vm.save = save;

        function save() {
            vm.showLoadingProgress = true;
            api.GeneralWS.DiscountDates.message.update({
                'id': discountDate.id,
                'message': discountDate.message
            }, {}).$promise.then(function () {
                vm.showLoadingProgress = false;
                $mdDialog.hide(discountDate.message);
                MessageService.show('general.register_updated_successfully');
            }, function (response) {
                $log.error(response);
                MessageService.showErrorMessage('general.general_error');
                vm.showLoadingProgress = false;
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('DiscountDateFiltersListController', DiscountDateFiltersListController);

    function DiscountDateFiltersListController($scope, $rootScope, $timeout, api, $log, $filter, $mdDialog, MessageService) {
        var ddflCtrl = this;
        var vm = $scope.$parent.vm;

        ddflCtrl.deleteRow = deleteRow;
        ddflCtrl.editRow = editRow;

        var columnDefs = [
            {
                field: "discountField.discountFieldDescription",
                headerName: 'DISCOUNTS.DISCOUNT_FIELD',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "discountCondition",
                headerName: 'DISCOUNTS.DISCOUNT_CONDITION',
                headerCellRenderer: getHeader,
                width: 180,
                cellRenderer: function () {
                    return '<span>{{"DISCOUNTS.CONDITION."+data.discountCondition | translate}}</span>'
                },
                cellStyle: { 'align': 'center' }
            },
            {
                field: "hasListValue",
                headerName: 'DISCOUNTS.HAS_LIST_VALUE',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    return "<div layout='row' layout-align='center center'><md-icon ng-if='data.hasListValue' class='md-primary' " +
                        "md-font-icon='icon-check'></md-icon><md-icon ng-if='!data.hasListValue' class='md-warn' " +
                        "md-font-icon='icon-close'></md-icon></div>";
                },
                width: 150,
                cellStyle: { 'align': 'center' }
            },
            {
                field: "filterValue",
                headerName: 'DISCOUNTS.FILTER_VALUE',
                headerCellRenderer: getHeader,
                width: 120,
                cellStyle: { 'align': 'center' }
            },
            {
                headerName: 'DISCOUNTS.ACTIONS',
                headerCellRenderer: getHeader,
                width: 110,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='ddflCtrl.editRow(data)'> " +
                        "<md-icon md-font-icon='icon-pencil'></md-icon> <md-tooltip md-direction='left'>{{'general.edit' | translate}}" +
                        "</md-tooltip> </md-button> <md-button class='md-icon-button' ng-click='ddflCtrl.deleteRow(data)'> " +
                        "<md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> <md-tooltip md-direction='left'>{{'general.delete' | translate}}" +
                        "</md-tooltip> </md-button>" +
                        " </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        ddflCtrl.pagination = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        ddflCtrl.discountDatesFilterGrid = {
            paginationPageSize: ddflCtrl.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            cacheBlockSize: ddflCtrl.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function getDiscountDatesFilter() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.DiscountDatesFilter.byDiscountDates.get({
                "discountDatesId": vm.currentDiscountDates.id, "page": ddflCtrl.pagination.pageNumber, "pageSize": ddflCtrl.pagination.pageSize
            }).$promise.then(function (response) {
                ddflCtrl.discountDatesFilterGrid.api.setRowData(response.content);
                ddflCtrl.discountDatesFilterGrid.api.setColumnDefs(columnDefs);
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $log.debug(errResponse);
                $rootScope.loadingProgress = false;
            });

        }

        function editRow(data) {
            vm.currentDiscountDatesFilter = data;
            vm.previousViewIndex = vm.viewIndex;
            vm.viewIndex = 4;
            vm.tabIndex = 2;
        }

        function deleteRow(data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('DISCOUNTS.DELETE'))
                .textContent($filter('translate')('DISCOUNTS.CONFIRMATION_DELETE'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.DiscountDatesFilter.DiscountDatesFilter.del({ 'id': data.id }).$promise.then(function (response) {
                    getDiscountDatesFilter();
                    $rootScope.loadingProgress = false;
                    MessageService.show($filter('translate')('DISCOUNTS.DELETED_SUCCESSFULLY'));
                }, function (errResponse) {
                    $log.debug(errResponse);
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage("Ha ocurrido un error");
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        $scope.$watch(function () {
            return vm.viewIndex;
        }, function (current, old) {
            if (current === 5) {
                $timeout(getDiscountDatesFilter, 500);
            } else {
                $timeout(function () {
                    ddflCtrl.discountDatesFilterGrid.api.setRowData([]);
                }, 500);
            }
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('DiscountDateFiltersController', DiscountDateFiltersController);

    function DiscountDateFiltersController($scope, $rootScope, EntitiesToApplyDiscounts, DiscountCondition, $timeout, api, $log, $mdDialog, $filter, MessageService) {
        //Discount date filter controller alias
        var ddfCtrl = this;
        var vm = $scope.$parent.vm;

        //variables filtros de descuentos
        ddfCtrl.entitiesToApplyDiscounts = [];
        ddfCtrl.tmpDiscountFields = [];
        ddfCtrl.entitiesToApplyDiscounts = EntitiesToApplyDiscounts;
        ddfCtrl.discountConditions = DiscountCondition;
        ddfCtrl.discountDateFilterValues = [];
        ddfCtrl.discountDateFilterValuesDeleted = [];
        ddfCtrl.clearValues = clearValues;

        //metodos filtros de descuento
        ddfCtrl.filterDiscountFieldByEntityName = filterDiscountFieldByEntityName;
        ddfCtrl.addValue = addValue;
        ddfCtrl.save = save;
        ddfCtrl.cancel = cancel;
        ddfCtrl.removeFilterValue = removeFilterValue;
        ddfCtrl.close = close;

        function getDiscountFields() {
            api.GeneralWS.DiscountField.DiscountField.get().$promise.then(function (data) {
                ddfCtrl.tmpDiscountFields = data;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        function filterDiscountFieldByEntityName() {
            ddfCtrl.discountFields = [];

            for (var i = 0; i < ddfCtrl.tmpDiscountFields.length; i++) {
                if (ddfCtrl.tmpDiscountFields[i].discountFieldEntityName === ddfCtrl.discountEntity) {
                    ddfCtrl.discountFields.push(ddfCtrl.tmpDiscountFields[i]);
                }
            }
        }

        function addValue() {
            var discountField = null;
            var type = null;

            for (var i = 0; i < ddfCtrl.tmpDiscountFields.length; i++) {
                if (ddfCtrl.tmpDiscountFields[i].id === parseInt(ddfCtrl.discountDatesFilter.discountField.id)) {
                    discountField = ddfCtrl.tmpDiscountFields[i];
                    break;
                }
            }

            if (discountField !== null && discountField !== undefined) {
                if (discountField.discountFieldCode === "001") {
                    type = "PRODUCT"
                } else if (discountField.discountFieldCode === "002") {
                    type = "PAYMENT_TYPE"
                } else if (discountField.discountFieldCode === "003") {
                    type = "PRODUCT_TYPE"
                }
            }

            $mdDialog.show({
                controller: 'dialogReferenceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/dialogReference/dialogReference.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'establishment': vm.establishment,
                    'type': type,
                    'hasList': ddfCtrl.discountDatesFilter.hasListValue
                },
                clickOutsideToClose: false
            }).then(function (response) {
                if (ddfCtrl.discountDatesFilter.hasListValue) {
                    response.forEach(function(item) {
                        for (var i = 0; i < ddfCtrl.discountDateFilterValues.length; i++) {
                            if (item.id === ddfCtrl.discountDateFilterValues[i].filterIdValue) {
                                return;
                            }
                        }

                        var objDeleted = null;

                        for (var i = 0; i < ddfCtrl.discountDateFilterValuesDeleted.length; i++) {
                            if (ddfCtrl.discountDateFilterValuesDeleted[i].filterIdValue === item.id) {
                                objDeleted = angular.copy(ddfCtrl.discountDateFilterValuesDeleted[i]);
                                objDeleted.active = true;
                                ddfCtrl.discountDateFilterValues.push(objDeleted);
                                ddfCtrl.discountDateFilterValuesDeleted.splice(i, 1);
                                return;
                            }
                        }

                        ddfCtrl.discountDateFilterValues.push({
                            id: null,
                            filterIdValue: item.id,
                            active: true
                        });
                    });
                } else {
                    ddfCtrl.discountDatesFilter.filterValue = response[0].id;
                }
            }, function () { });
        }

        function save() {
            $rootScope.loadingProgress = true;
            ddfCtrl.discountDatesFilter.discountDates = vm.currentDiscountDates;
            var requestBody = {
                discountDatesFilter: ddfCtrl.discountDatesFilter,
                filterValues: angular.copy(ddfCtrl.discountDateFilterValues)
            };

            ddfCtrl.discountDateFilterValuesDeleted.forEach(function (item) {
                requestBody.filterValues.push(item);
            });

            api.GeneralWS.DiscountDatesFilter.DiscountDatesFilter.create({}, requestBody).$promise.then(function (response) {
                $rootScope.loadingProgress = false;
                clearAll();

                MessageService.show($filter('translate')('DISCOUNTS.ADDED_SUCCESSFULLY'));
                close();
            }, function (errResponse) {
                $log.debug(errResponse);
                $rootScope.loadingProgress = false;
                MessageService.showErrorMessage("Ha ocurrido un error");
            });
        }

        function getDiscountDateFilterList() {
            api.GeneralWS.DiscountDatesFilterList
                .byDiscountDatesFilter
                .get({ 'discountDatesFilterId': ddfCtrl.discountDatesFilter.id, 'page': 0, 'pageSize': 500 })
                .$promise.then(function (response) {
                    response.forEach(function (item) {
                        ddfCtrl.discountDateFilterValues.push({
                            id: item.id,
                            filterIdValue: item.filterIdValue,
                            active: item.active
                        });
                    });
                }, function (err) {
                    $log.err(err);
                });
        }

        function removeFilterValue($chip) {
            if ($chip.id !== null && $chip.id !== undefined) {
                var obj = angular.copy($chip);
                delete obj.$$hashKey;
                obj.active = false;
                ddfCtrl.discountDateFilterValuesDeleted.push(obj);
            }
        }

        function clearValues() {
            ddfCtrl.discountDatesFilter.filterValue = "";
            ddfCtrl.discountDateFilterValues = [];
        }

        function clearAll() {
            ddfCtrl.discountDateFilterValuesDeleted = [];
            ddfCtrl.discountDateFilterValues = [];
            vm.currentDiscountDatesFilter = null;
            ddfCtrl.discountEntity = null;
            ddfCtrl.discountDatesFilter = {
                filterValue: "",
                hasListValue: false
            };
        }

        function init() {
            getDiscountFields();
        }

        function cancel() {
            clearAll();
            close();
        }

        function close() {
            vm.viewIndex = vm.previousViewIndex;
            vm.tabIndex = 2;
        }

        $timeout(init, 1000);

        $scope.$watch(function () {
            return vm.viewIndex;
        }, function (current, old) {
            if (current === 4) {
                if (vm.currentDiscountDatesFilter !== null && vm.currentDiscountDatesFilter !== undefined) {
                    ddfCtrl.discountDatesFilter = angular.copy(vm.currentDiscountDatesFilter);
                    ddfCtrl.discountEntity = ddfCtrl.discountDatesFilter.discountField.discountFieldEntityName;
                    filterDiscountFieldByEntityName();
                    getDiscountDateFilterList();
                }
            } else {
                $timeout(clearAll, 500);
            }
        });


    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('dialogReferenceController', dialogReferenceController);

    function dialogReferenceController($log, api, $rootScope, establishment, type, $mdDialog, hasList) {
        var vm = this;
        vm.establishment = establishment;
        vm.type = type;
        vm.objectArray = [];
        vm.getAll = getAll;
        vm.objectsSelected = [];

        vm.pagination = {
            pageNumber: 1,
            pageSize: 8,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getAll();
            }
        };

        getAll();

        function getAll() {

            var parameters = {
                company: $rootScope.bsCircle.company.id,
                circle: $rootScope.bsCircle.id,
                idCircle: $rootScope.bsCircle.id,
                page: vm.pagination.pageNumber - 1,
                pageSize: vm.pagination.pageSize,
                size: vm.pagination.pageSize,
                establishmentId: vm.establishment.id,
                companyEstablishmentId: vm.establishment.id,
                search: vm.searchInput,
                filter: vm.searchInput
            };

            vm.isShowLoader = true;
            var promise = null;
            if (vm.type === 'INVENTORY') {
                promise = api.InventarioWS.Inventory.Inventory.page(parameters).$promise;
            } else if (vm.type === 'PRODUCT') {
                promise = api.GeneralWS.ProductAll.get(parameters).$promise;
            } else if (vm.type === 'PRODUCT_TYPE') {
                promise = api.GeneralWS.ProductType.allByCompany.get(parameters).$promise;
            } else if (vm.type === 'PRODUCT_TYPE_ADD_FIELD') {
                promise = api.GeneralWS.CompanyAdditionalFields.getByCompany.get(parameters).$promise;
            } else if (vm.type === 'PAYMENT_TYPE') {
                promise = api.GeneralWS.CompanyEstablishmentPaymentType.allByCompanyEstablishment.get(parameters).$promise;
            }

            promise.then(function (response) {
                vm.isShowLoader = false;
                vm.objectArray = response.content ? response.content : response;
                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.pagination.numberOfElements = response.numberOfElements;
            }, function (response) {
                vm.isShowLoader = false;
                $log.error(response);
            });
        }

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.save = function () {
            $rootScope.loadingProgress = true;
            if (vm.objectsSelected.length > 0) {
                $rootScope.loadingProgress = false;
                $mdDialog.hide(vm.objectsSelected);
            }
        };

        vm.selectdObject = function (obj) {
            obj.selected = !obj.selected;

            if (hasList) {
                if (obj.selected) {
                    vm.objectsSelected.push(obj);
                } else {
                    vm.objectsSelected.forEach(function (data, i) {
                        if (data.id === obj.id) {
                            vm.objectsSelected.splice(i, 1);
                        }
                    });
                }
            } else {
                vm.objectsSelected[0] = obj;
            }
        }

        vm.existSelectedObject = function(id) {
            var response = false;
            vm.objectsSelected.forEach(function (item)
            {
                if (item.id === id) {
                    response = true;
                };
            });
            return response;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('dialogMoreFiltersController', dialogMoreFiltersController);

    function dialogMoreFiltersController($log, api, $rootScope, $filter, establishment, data, $mdDialog,
        DiscountCondition, $timeout, MessageService, EntitiesToApplyDiscounts) {

        var vm = this;
        vm.entitiesToApplyDiscounts = EntitiesToApplyDiscounts;
        vm.establishment = establishment;
        vm.data = data;
        vm.discountConditions = DiscountCondition;
        vm.tabCurrent = false;
        vm.fieldValueList = [];
        vm.discountDatesFilterSaved = {};

        vm.flipping = flipping;

        vm.newContact = true;
        vm.flip;

        vm.tmpDiscountFields = [];
        vm.discountFields = [];

        //methodos
        vm.filterByEntityName = filterByEntityName

        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }

        $timeout(function () { init() }, 200);

        vm.pagination = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "discountField.discountFieldDescription",
                headerName: 'DISCOUNTS.DISCOUNT_FIELD',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "discountCondition",
                headerName: 'DISCOUNTS.DISCOUNT_CONDITION',
                headerCellRenderer: getHeader,
                width: 180,
                cellRenderer: function () {
                    return '<span>{{"DISCOUNTS.CONDITION."+data.discountCondition | translate}}</span>'
                },
                cellStyle: { 'align': 'center' }
            },
            {
                field: "hasListValue",
                headerName: 'DISCOUNTS.HAS_LIST_VALUE',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    return "<div layout='row' layout-align='center center'><md-icon ng-if='data.hasListValue' class='md-primary' " +
                        "md-font-icon='icon-check'></md-icon><md-icon ng-if='!data.hasListValue' class='md-warn' " +
                        "md-font-icon='icon-close'></md-icon></div>";
                },
                width: 150,
                cellStyle: { 'align': 'center' }
            },
            {
                field: "filterValue",
                headerName: 'DISCOUNTS.FILTER_VALUE',
                headerCellRenderer: getHeader,
                width: 120,
                cellStyle: { 'align': 'center' }
            },
            {
                headerName: 'DISCOUNTS.ACTIONS',
                headerCellRenderer: getHeader,
                width: 90,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.editRow(data)'> " +
                        "<md-icon md-font-icon='icon-pencil'></md-icon> <md-tooltip md-direction='left'>{{'general.edit' | translate}}" +
                        "</md-tooltip> </md-button> <md-button class='md-icon-button' ng-click='vm.deleteRow(data)'> " +
                        "<md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> <md-tooltip md-direction='left'>{{'general.delete' | translate}}" +
                        "</md-tooltip> </md-button>" +
                        " </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.discountDatesFilterGrid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        var columnDefsField = [
            {
                field: "filterIdValue",
                headerName: 'DISCOUNTS.value',
                headerCellRenderer: getHeader,
                width: 200,
                cellStyle: { 'align': 'center' }
            },
            {
                headerName: 'DISCOUNTS.ACTIONS',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.deleteValueField(data," + params.rowIndex + ")'> " +
                        "<md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> " +
                        "<md-tooltip md-direction='left'>{{'general.delete' | translate}}</md-tooltip> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.discountFieldValueGrid = {
            rowSelection: 'multiple',
            rowDeselection: true,
            columnDefs: columnDefsField,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.save = function () {
            if (vm.tabCurrent) {
                vm.flip();
                vm.tabCurrent = !vm.tabCurrent;
                vm.discountDatesFilter = {};
                updateGridDiscuntDatesFilter();
            } else {
                $mdDialog.hide();
            }
        };

        function init() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.DiscountField.DiscountField.get().$promise.then(function (data) {
                vm.tmpDiscountFields = data;
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $log.debug(errResponse);
                $rootScope.loadingProgress = false;
            });
            updateGridDiscuntDatesFilter();
        }

        vm.createList = function (tabCurrent) {
            vm.tabCurrent = tabCurrent;
            if (tabCurrent) {
                vm.flip();
                verifyIfExist();
            } else {
                vm.fieldValueList = [];
            }
        }

        vm.addFieldValue = function () {
            $rootScope.loadingProgress = true;
            vm.discountDatesFilter.discountDates = vm.data;
            api.GeneralWS.DiscountDatesFilter.DiscountDatesFilter.create({}, vm.discountDatesFilter).$promise.then(function (response) {
                vm.discountDatesFilterSaved = response;
                var obj = {
                    "discountDatesFilter": response,
                    "filterIdValue": vm.discountDatesFilterValue
                }
                api.GeneralWS.DiscountDatesFilterList.DiscountDatesFilterList.create({}, obj).$promise.then(function (response) {
                    updateGridValueField();
                    $rootScope.loadingProgress = false;
                    vm.discountDatesFilterValue = '';
                    MessageService.show($filter('translate')('DISCOUNTS.ADDED_SUCCESSFULLY'));
                }, function (errResponse) {
                    $log.debug(errResponse);
                    $rootScope.loadingProgress = false;
                });

            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        function updateGridValueField() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.DiscountDatesFilterList.byDiscountDatesFilter.get({
                "discountDatesFilterId": vm.discountDatesFilterSaved.id, "page": vm.pagination.pageNumber, "pageSize": vm.pagination.pageSize
            }).$promise.then(function (response) {
                vm.discountFieldValueGrid.api.setRowData(response);
                vm.discountFieldValueGrid.api.setColumnDefs(columnDefsField);
                vm.fieldValueList = response;
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.deleteValueField = function (data, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('DISCOUNTS.DELETE'))
                .textContent($filter('translate')('DISCOUNTS.CONFIRMATION_DELETE'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                if (data.id) {
                    $rootScope.loadingProgress = true;
                    api.GeneralWS.DiscountDatesFilterList.DiscountDatesFilterList.del({ 'id': data.id }).$promise.then(function (response) {
                        updateGridValueField();
                        $rootScope.loadingProgress = false;
                        MessageService.show($filter('translate')('DISCOUNTS.DELETED_SUCCESSFULLY'));
                    }, function (errResponse) {
                        $log.debug(errResponse);
                        $rootScope.loadingProgress = false;
                    });
                } else {
                    vm.fieldValueList.splice(index, 1);
                    updateGridValueField();
                }
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.saveFilter = function () {
            $rootScope.loadingProgress = true;
            vm.discountDatesFilter.discountDates = vm.data;
            api.GeneralWS.DiscountDatesFilter.DiscountDatesFilter.create({}, vm.discountDatesFilter).$promise.then(function (response) {
                updateGridDiscuntDatesFilter();
                vm.discountDatesFilterSaved = response;
                $rootScope.loadingProgress = false;
                vm.discountDatesFilter = {};
                MessageService.show($filter('translate')('DISCOUNTS.ADDED_SUCCESSFULLY'));
            }, function (errResponse) {
                $log.debug(errResponse);
                $rootScope.loadingProgress = false;
            });
        }

        function updateGridDiscuntDatesFilter() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.DiscountDatesFilter.byDiscountDates.get({
                "discountDatesId": vm.data.id, "page": vm.pagination.pageNumber, "pageSize": vm.pagination.pageSize
            }).$promise.then(function (response) {
                vm.discountDatesFilterGrid.api.setRowData(response.content);
                vm.discountDatesFilterGrid.api.setColumnDefs(columnDefs);
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $log.debug(errResponse);
                $rootScope.loadingProgress = false;
            });
        }

        function verifyIfExist() {
            $rootScope.loadingProgress = true;
            vm.discountDatesFilter.discountDates = vm.data;
            api.GeneralWS.DiscountDatesFilter.byVerifyIfExist.verify({}, vm.discountDatesFilter).$promise.then(function (response) {
                if (response.id) {
                    vm.discountDatesFilterSaved = response;
                    updateGridValueField();
                }
                vm.discountDatesFilterSaved = response;
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $log.debug(errResponse);
                $rootScope.loadingProgress = false;
            });
        }

        vm.deleteRow = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('DISCOUNTS.DELETE'))
                .textContent($filter('translate')('DISCOUNTS.CONFIRMATION_DELETE'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.DiscountDatesFilter.DiscountDatesFilter.del({ 'id': data.id }).$promise.then(function (response) {
                    updateGridDiscuntDatesFilter();
                    $rootScope.loadingProgress = false;
                    MessageService.show($filter('translate')('DISCOUNTS.DELETED_SUCCESSFULLY'));
                }, function (errResponse) {
                    $log.debug(errResponse);
                    $rootScope.loadingProgress = false;
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        };

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        vm.editRow = function (data) {
            vm.discountDatesFilter = data;
            if (data.hasListValue) {
                vm.createList(!vm.tabCurrent);
            }
        };


        function filterByEntityName() {
            vm.discountFields = [];

            for (var i = 0; i < vm.tmpDiscountFields.length; i++) {
                if (vm.tmpDiscountFields[i].discountFieldEntityName === vm.discountEntity) {
                    vm.discountFields.push(vm.tmpDiscountFields[i]);
                }
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('AddDiscountPriorityController', AddDiscountPriorityController);

    function AddDiscountPriorityController($log, api, $mdDialog, $timeout, $filter, DiscountTypes, $rootScope, establishmentId, MessageService) {
        var vm = this;
        vm.discountEstablishmentPriority = {};

        vm.discountTypes = DiscountTypes;
        vm.closeDialog = $mdDialog.cancel;
        vm.save = save;

        vm.discountTypes.forEach(function (element) {
            element.value = $filter("translate")("DISCOUNTS.types." + element.keyDiscountType);
        });

        function save() {
            vm.showLoadingProgress = true;

            vm.discountEstablishmentPriority.companyEstablishment = {
                id: establishmentId
            };

            api.GeneralWS.DiscountCompanyEstablishmentPriority.DiscountCompanyEstablishmentPriority.create({
                'establishmentId': establishmentId
            }, vm.discountEstablishmentPriority).$promise.then(function (response) {
                vm.discountEstablishmentPriority = {};
                vm.showLoadingProgress = false;
                $mdDialog.hide(true);
            }, function (response) {
                $log.error(response);
                MessageService.showErrorMessage('general.general_error');
                vm.showLoadingProgress = false;
            });
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('AdditionalFieldValuesDialogController', AdditionalFieldValuesDialogController);


    function AdditionalFieldValuesDialogController($log, api, $mdDialog, companyAdditionalFieldId, dialogTitle, $timeout) {
        var vm = this;
        vm.showLoadingProgress = false;
        vm.additionalFieldValueList = [];
        vm.dialogTitle = dialogTitle

        //metodos
        vm.showAdditionalFieldValues = showAdditionalFieldValues;
        vm.closeDialog = $mdDialog.cancel;
        vm.selectValue = selectValue

        function selectValue(valueObject) {
            $mdDialog.hide(valueObject);
        }

        function showAdditionalFieldValues() {
            vm.showLoadingProgress = true;
            api
                .GeneralWS
                .CompanyAdditionalFieldsValueResource.byAdditionalFieldId
                .get({ 'companyAdditionalFieldId': companyAdditionalFieldId })
                .$promise
                .then(function (response) {
                    vm.showLoadingProgress = false;
                    vm.additionalFieldValueList = response;
                }, function (err) {
                    vm.showLoadingProgress = false;
                    $log.error(err);
                });
        }

        function init() {
            showAdditionalFieldValues();
        }

        $timeout(init, 300);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.CompanyProvider', [])
        .config(config);

    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/company-providers/');

        $stateProvider
            .state('app.CompanyProvider', {
                url: '/company-providers',
                abstract: true
            })
            .state('app.CompanyProvider.private', {
                url: '/private/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/company.html',
                        controller: 'CompanyController as vm'
                    },
                    'users@app.CompanyProvider.private': {
                        templateUrl: 'app/main/apps/usr/user/user-list/user-list.html',
                        controller: 'UserListController',
                        controllerAs: 'ul'
                    }
                },
                resolve: {
                    Company: function (apiResolver, $stateParams) {
                        if (!$stateParams.id) {
                            return null;
                        }
                        return apiResolver.resolve('GeneralWS.Company@get', { id: $stateParams.id });
                    },
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                },
                params: {
                    tipoError: null,
                    privated: true,
                    readonly: false
                }
            })
            .state('app.CompanyProvider.private.documents', {
                url: '/documents',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/documents/documents.html',
                        controller: 'DocumentController as vm'
                    }
                },
                resolve: {
                    Company: function (apiResolver, $stateParams) {
                        if (!$stateParams.id) {
                            return null;
                        }
                        return apiResolver.resolve('GeneralWS.Company@get', { id: $stateParams.id });
                    }
                },
                params: {
                    tipoError: null,
                    listOfDocumentTypes: null,
                    privated: true,
                    isProvider: false,
                    providerId: null
                }
            })
            .state('app.CompanyProvider.private.invoiceSerie', {
                url: '/invoiceSerie',
                resolve: {
                    Company: function (apiResolver, $stateParams) {
                        if (!$stateParams.id) {
                            return null;
                        }
                        return apiResolver.resolve('GeneralWS.Company@get', { id: $stateParams.id });
                    }
                },
                params: {
                    privated: true
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company/tabs/invoiceSerie/invoiceSerie.html',
                        controller: 'InvoiceSerieController as vm'
                    }
                }
            })
            .state('app.CompanyProvider.ValidateProvider', {
                url: '/validate-provider',
                params: {
                    viewName: "validateProvider"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/validate-provider.html',
                        controller: 'ValidateProviderController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.CompanyProvider.ValidateProvider.ProviderInformation', {
                url: '/{companyId:int}',
                params: {
                    provider: null,
                    viewParentName: "validateProvider"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/provider-information/provider-information.html',
                        controller: 'ProviderInformationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }
            })
            .state('app.CompanyProvider.MyProviders', {
                url: '/my-providers',
                params: {
                    viewName: "myProviders"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/validate-provider.html',
                        controller: 'ValidateProviderController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.CompanyProvider.MyProviders.ProviderInformation', {
                url: '/{companyId:int}',
                params: {
                    provider: null,
                    viewParentName: "myProviders"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/provider-information/provider-information.html',
                        controller: 'ProviderInformationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }
            })
            .state('app.CompanyProvider.InternalProviders', {
                url: '/internal-provider',
                params: {
                    viewName: "internalProviders"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/validate-provider.html',
                        controller: 'ValidateProviderController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.CompanyProvider.InternalProviders.ProviderInformation', {
                url: '/{companyId:int}',
                params: {
                    provider: null,
                    viewParentName: "internalProviders"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/provider-information/provider-information.html',
                        controller: 'ProviderInformationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }
            })
            .state('app.CompanyProvider.QueryProviders', {
                url: '/query-provider',
                params: {
                    viewName: "queryProviders"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/validate-provider.html',
                        controller: 'ValidateProviderController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.CompanyProvider.QueryProviders.ProviderInformation', {
                url: '/{companyId:int}',
                params: {
                    provider: null,
                    viewParentName: "queryProviders"
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/validate-provider/provider-information/provider-information.html',
                        controller: 'ProviderInformationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    PreviousState: function ($state) {
                        return angular.copy($state.current);
                    }
                }
            })
            .state('app.CompanyProvider.providerGroups', {
                url: '/providerGroups',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/company-providers/provider-group/provider-group-list/provider-group-list.html',
                        controller: 'CompanyProviderGroupListController',
                        controllerAs: 'vm'
                    }
                }
            });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.CompanyProvider')
        .controller('ValidateDialogController', ValidateDialogController);

    /**@ngInject**/
    function ValidateDialogController($mdDialog, api, $log, MessageService, $filter, $timeout, $rootScope, params) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;
        vm.validateProvider = false;
        vm.title = 'validate_provider.validateProvider';
        if(params.isEdit) {
            vm.title = 'validate_provider.editProvider';
            vm.account = params.account;
            vm.paymentCondition = params.paymentCondition;
            vm.providerGroup = params.providerGroup;
        }

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;
        vm.onEdit = onEdit;
        vm.getAccounts = getAccounts;
        vm.selectProduct = selectProduct;
        vm.flipping = flipping;
        vm.changeFilter = changeFilter;
        vm.provider = params.provider;

        vm.newContact = true;
        vm.flip;

        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }

        function getAccounts(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.Account.AccountingCatalog.ByDescription.get({
                'company': $rootScope.bsCircle.company.id, page: page - 1, size: vm.pageSize, filter: vm.filterAccount
            },
                function (data) {
                    vm.accounts = data;
                    vm.loading = false;
                },
                function () {
                    vm.loading = false;
                }
            );
        }

        function getPaymentConditions() {
            api.PagosWS.PaymentCondition.byCompany.get({
                'companyId': $rootScope.bsCircle.company.id,
            })
                .$promise.then(function (response) {
                    vm.paymentConditions = response;
                    vm.isShowProgressLineargridPayment = false;
                }, function (response) {
                    vm.isShowProgressLineargridPayment = false;
                    $log.error(response);
                });
        }

        function getProviderGroups() {
            api.GeneralWS.CompanyProviderGroup.byCompany.get({
                'companyId': $rootScope.bsCircle.company.id,
            })
                .$promise.then(function (response) {
                    vm.providerGroups = response;
                    vm.isShowProgressLinearGrid = false;
                }, function (response) {
                    vm.isShowProgressLinearGrid = false;
                    $log.error(response);
                });
        }

        function changeFilter() {
            getAccounts(1);
        }

        function onEdit() {
            vm.flip();
            changeFilter();
            $timeout(function () {
                document.getElementById("searchAccount").focus();
            }, 600);
        }

        function selectProduct(account) {
            vm.account = account;
            vm.searchMode = false;
            vm.flip();
        }

        function save() {
            
            if (vm.account === undefined || vm.account === null) {
                MessageService.showErrorMessage($filter('translate')('validate_provider.selectAccount'));
                return;
            }

            const data = {
                account: vm.account,
                paymentCondition: vm.paymentCondition,
                providerGroup: vm.providerGroup
            }
            $mdDialog.hide(data);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function init() {
            getAccounts(1);
            getPaymentConditions();
            getProviderGroups();
        }

        init();
    }

})();

(function () {

    'use strict';

    angular
        .module('app.CompanyProvider')
        .controller('NoValidateProviderController', NoValidateProviderController);

    function NoValidateProviderController($rootScope, $mdDialog, $timeout, $filter, $log, api, MessageService, provider) {

        var vm = this;

        vm.numberOfCharactersAllowed = 750;
        vm.countCharacters = 0;
        vm.noValidateProvider = {
            'provider': provider
        };

        //metodos
        vm.trixInitialize = trixInitialize;
        vm.focusEditor = focusEditor;
        vm.trixChange = trixChange;
        vm.closeDialog = closeDialog;
        vm.send = send;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function init() {

            var element = $("trix-toolbar");

            if (element) {

                var buttons = element.find("button");

                for (var i = 0; i < buttons.length; i++) {
                    buttons[i].innerText = "";
                }
            }

        }

        function trixInitialize(e, editor) {
            editor.getDocument();

            var element = document.getElementById("responseEditor");

            if (element) {
                element.onkeydown = function (e) {
                    var evtobj = window.event ? event : e;

                    if (evtobj.keyCode === 13 && evtobj.ctrlKey) {
                        if (vm.countCharacters > 1) {
                            send();
                        } else {
                            MessageService.show($filter('translate')('validate_provider.write_your_observations'));
                        }
                    }
                };
            }
        }

        function focusEditor() {
            if (vm.ticketDetail.ticket.department) {
                $timeout(function () {
                    document.getElementById("responseEditor").focus();
                }, 500);
            }
        }

        function trixChange(e, editor) {

            vm.countCharacters = editor.getDocument().toString().length;

            if (vm.countCharacters >= (vm.numberOfCharactersAllowed - 1)) {
                editor.setSelectedRange([(vm.numberOfCharactersAllowed - 1), vm.countCharacters]);
                editor.deleteInDirection("forward");
            }

        }

        function send() {

            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyProvider.noValidate.create({ 'companyId': $rootScope.bsCircle.company.id }, vm.noValidateProvider).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                $mdDialog.hide(true);

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });

        }

        $timeout(init, 100);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('WarehouseProviderController', WarehouseProviderController);

    /**@ngInject**/
    function WarehouseProviderController($mdDialog, api, warehouse, $log, MessageService, $filter, $rootScope, $timeout) {

        var vm = this;

        vm.warehouse = warehouse;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (vm.warehouse.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }
            var promise;
            vm.warehouse.company = (vm.warehouse.companyEstablishment && vm.warehouse.companyEstablishment.company) ? vm.warehouse.companyEstablishment.company : $rootScope.bsCircle.company;
            if (vm.warehouse.id) {
                promise = api.GeneralWS.CompanyWarehouse.me.update({ idCircle: $rootScope.bsCircle.id, id: vm.warehouse.id }, vm.warehouse).$promise;
            } else {
                promise = api.GeneralWS.CompanyWarehouse.me.create({}, vm.warehouse).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(vm.warehouse);
                        break;
                    case 201:
                        $mdDialog.hide(vm.warehouse);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 409) {
                    MessageService.showErrorMessage(($filter('translate')('company_warehouse.conflict_with_code')) + response.data);
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

        vm.clearSearchEstablishment = function () {
            vm.searchEstablishment = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchEstablishmentInput = document.querySelector("#searchEstablishment");

            if (searchEstablishmentInput) {
                searchEstablishmentInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('CompanyContactController', CompanyContactController);

    /**@ngInject**/
    function CompanyContactController($mdDialog, api, contact, $log, MessageService, $filter) {

        const vm = this;
        const NOT_ACCEPTABLE_NUMBER = 406;

        vm.contact = contact;

        vm.save = save;
        vm.cancel = cancel;

        function save() {
            vm.isShowProgressLinear = true;
            let promise;
            if (vm.contact) {
                let address = vm.contact.address;
                if (vm.contact.address === undefined) {
                    address = null;
                }
                let phone2 = vm.contact.phone2;
                if (vm.contact.phone2 === undefined) {
                    phone2 = null;
                }
                let phoneMobile = vm.contact.phoneMobile;
                if (vm.contact.phoneMobile === undefined) {
                    phoneMobile = null;
                }
                let email = vm.contact.email;
                if (vm.contact.email === undefined) {
                    email= null;
                }

                const currectContact = {
                    id: 0,
                    active: true,
                    companyId: vm.contact.companyId,
                    name: vm.contact.name,
                    phone: vm.contact.phone,
                    address: address,
                    phone2: phone2,
                    phoneMobile: phoneMobile,
                    email: email
                };

                if (vm.contact.id) {
                    currectContact.id = vm.contact.id;
                    currectContact.active = vm.contact.active;
                    promise = api.GeneralWS.CompanyContact.byCompanyActive.update({
                        'id': vm.contact.id,
                    }, currectContact).$promise;
                } else {
                    promise = api.GeneralWS.CompanyContact.byCompanyActive.create({
                        'id': undefined,
                    }, currectContact).$promise;
                }

                promise.then(function (response) {
                    currectContact.id = response.id;
                    vm.isShowProgressLinear = false;
                    $mdDialog.hide(currectContact);
                }, function (exception) {
                    if (exception.status === NOT_ACCEPTABLE_NUMBER) {
                        MessageService.showErrorMessage($filter('translate')('CONTACTS.REQUIRED_COMPANY_CONTACT'));
                    } else {
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    }
                    vm.isShowProgressLinear = false;
                    $log.error(exception);
                });
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('InvoiceSerieDialogController', InvoiceSerieDialogController);

    /** @ngInject */
    function InvoiceSerieDialogController($mdDialog, api, $rootScope, $log, MessageService, invoiceSerie, establishment, $filter, Company, Privated, invoiceSerieType, INVOICE_SERIE_DOCUMENT_TYPES) {
        var vm = this;
        var originalInv = angular.copy(invoiceSerie);
        vm.baseUrlFiles = api.baseUrlFiles;
        var companyRoot = Privated ? Company : $rootScope.bsCircle.company;
        vm.company = angular.copy(companyRoot);
        vm.establishment = establishment;
        vm.invoiceSerieTypes = invoiceSerieType;

        vm.invoiceSerie = invoiceSerie ? invoiceSerie : {};
        vm.gFaces = [];
        vm.invoiceSerieDocumentTypesCancel = [
          'CREDIT_NOTE',
          'GLOBAL_CREDITNOTE',
          'CREDIT_NOTE_TICKET',
          'CREDIT_NOTE_CREDIT_FISCAL',
          'ANNULMENT',
      ];
        verifySeries();

        function verifySeries() {

          vm.printDocumentInvoice = vm.invoiceSerie.printDocument;
          vm.amountBaseCustomerIdentifer = vm.invoiceSerie.amountBaseToRequestCustomerIdentifier;
          vm.daysCancel = vm.invoiceSerie.daysToCancel;
          vm.partitialCreditNote = vm.invoiceSerie.creditNotePartial;
          vm.invoiceType = vm.invoiceSerie.invoiceSerieType;

          if (vm.invoiceSerie.printDocument != null) {
            vm.invoiceSerie.printDocument = vm.printDocumentInvoice;
          }  else {
            if (vm.printDocument === false) {
              vm.invoiceSerie.printDocument = false;
            } else {
              vm.invoiceSerie.printDocument = true;
            }
          }

          if (vm.invoiceSerie.amountBaseToRequestCustomerIdentifier != null) {
            vm.invoiceSerie.amountBaseToRequestCustomerIdentifier = vm.amountBaseCustomerIdentifer;
          } else {
            vm.invoiceSerie.amountBaseToRequestCustomerIdentifier = 0;
          }


          if (vm.invoiceSerie.daysToCancel == null) {
            vm.invoiceSerie.daysToCancel = 0;
          } else {
            vm.invoiceSerie.daysToCancel = vm.daysCancel;
          }

          if (vm.invoiceSerie.quantityCorrelativeDigits == null) {
            vm.invoiceSerie.quantityCorrelativeDigits = 0;
          }


          if (vm.invoiceSerie.creditNotePartial == null) {
            vm.invoiceSerie.creditNotePartial = true;
          } else {
            vm.invoiceSerie.creditNotePartial = vm.partitialCreditNote;
          }
            if (vm.invoiceType) {
                for (var i = 0; i < vm.invoiceSerieTypes.length; i++) {
                    if (vm.invoiceSerieTypes[i].id === vm.invoiceSerie.invoiceSerieType.id) {
                        vm.invoiceSerie.invoiceSerieType = vm.invoiceSerieTypes[i];
                        if (vm.invoiceSerie.invoiceSerieType.isElectronic) {
                            getGfaces();
                        }
                    }
                }
            }
            if (!vm.invoiceSerie.id && vm.invoiceSerieTypes.length === 1) {
                vm.invoiceSerie.invoiceSerieType = vm.invoiceSerieTypes[0];
                if (vm.invoiceSerie.invoiceSerieType.isElectronic) {
                    getGfaces();
                }
            }
        }
        
        vm.invoiceSerieDocumentTypes = [];
        getInvoiceSeriesDocumentCountryList();

        function getInvoiceSeriesDocumentCountryList() {
            api.GeneralWS.InvoiceSeriesDocumentCountry.getList.getByCountry({ countryId: vm.company.country.id }).$promise.then(function (data) {
                vm.invoiceSerieDocumentTypes = data;
                if (!vm.invoiceSerie.id && data.length === 1) {
                    vm.invoiceSerie.invoiceSerieDocumentType = vm.invoiceSerieDocumentTypes[0].invoiceSeriesDocumentTypeId;
                }
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }
        
        vm.setFile = invoiceSerie.fileStorage ? false : true;
        if (invoiceSerie.fileStorage && (invoiceSerie.fileStorage.extension === '.jpg' || invoiceSerie.fileStorage.extension === '.png' || invoiceSerie.fileStorage.extension === '.JPG' || invoiceSerie.fileStorage.extension === '.PNG')) {
            var ft = {
                url: getPhoto(null, invoiceSerie.fileStorage),
                type: 'image',
                original: invoiceSerie.fileStorage,
                extension: invoiceSerie.fileStorage.extension
            };
            vm.image = ft;
            updateImageZoomOptions(vm.image);
        }

        vm.minDate = new Date();

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        vm.updateImageZoomOptions = updateImageZoomOptions;
        vm.validateCorrelativeRange = validateCorrelativeRange;
        vm.getGfaces = getGfaces;

        function getFormData(file) {
            var fd = new FormData();
            fd.append('files', file);
            return fd;
        }

        function save() {

            if (vm.theForm.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }

            if (!vm.invoiceSerie.fileStorage) {
                if (vm.filesToUpload.length <= 0) {
                    MessageService.showErrorMessage($filter('translate')('COMPANY.NO_FILES'));
                    return false;
                }
            }
            vm.isShowProgressLinear = true;
            var newInvoiceSerie = {
                id: vm.invoiceSerie.id ? vm.invoiceSerie.id : 0,
                authorizationDate: vm.invoiceSerie.authorizationDate.getTime(),
                company: null,
                companyEstablishment: null,
                serie: vm.invoiceSerie.serie,
                initialNumber: vm.invoiceSerie.initialNumber,
                lastNumber: vm.invoiceSerie.lastNumber,
                resolution: vm.invoiceSerie.resolution,
                electronicInvoice: vm.invoiceSerie.invoiceSerieType.isElectronic,
                dueDate: vm.invoiceSerie.invoiceSerieType.isElectronic && !vm.invoiceSerie.invoiceSerieType.endDateByInvoiceElectronic ?
                    new Date('12/31/2099').getTime() : vm.invoiceSerie.dueDate.getTime(),
                active: vm.invoiceSerie.id ? vm.invoiceSerie.active : true,
                invoiceSerieType: vm.invoiceSerie.invoiceSerieType,
                invoiceSerieDocumentType: vm.invoiceSerie.invoiceSerieDocumentType,
                gFace: vm.invoiceSerie.gFace,
                printDocument: vm.invoiceSerie.printDocument,
                printFormatDocument:  vm.invoiceSerie.printFormatDocument,
               onlyCancelInMonth: vm.invoiceSerie.onlyCancelInMonth,
               creditNotePartial: vm.invoiceSerie.creditNotePartial,
               daysToCancel: vm.invoiceSerie.daysToCancel,
               amountBaseToRequestCustomerIdentifier: vm.invoiceSerie.amountBaseToRequestCustomerIdentifier,
               invoiceSerieDocumentTypeCancel: vm.invoiceSerie.invoiceSerieDocumentTypeCancel,
               prefixCorrelative: vm.invoiceSerie.prefixCorrelative,
               quantityCorrelativeDigits: vm.invoiceSerie.quantityCorrelativeDigits,
            };

            !vm.establishment ? newInvoiceSerie.company = { id: vm.company.id } : newInvoiceSerie.companyEstablishment = { id: vm.establishment.id };

            if (vm.filesToUpload && vm.filesToUpload.length > 0) {
                var typeFile = vm.filesToUpload[0].file.file.type.split('/');
                if (!typeFile || typeFile.length === 0) {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    return null;
                }
                var params = { id: 'CompanySerieAndCorrelative', invoiceSerieId: vm.invoiceSerie.id, companyId: null, establishmentId: null, serie: vm.invoiceSerie.serie, initialNumber: vm.invoiceSerie.initialNumber, lastNumber: vm.invoiceSerie.lastNumber };
                !vm.establishment ? params.companyId = vm.company.id : params.establishmentId = vm.establishment.id;
                api.GeneralWS.InvoiceSerie.getByCompanySerieAndCorrelative(params).$promise.then(function (data) {
                    var fd = getFormData(vm.filesToUpload[0].file.file);
                    var fileNameString = "invoiceSerie-" + vm.invoiceSerie.serie + "-" + vm.company.id;
                    var isImage = (typeFile[1] === 'jpg' || typeFile[1] === 'JPG' || typeFile[1] === 'png' || typeFile[1] === 'PNG' || typeFile[1] === 'jpeg' || typeFile[1] === 'JPEG') ? true : false;
                    api.GeneralWS.FileStorage.me.save({ id: 'uploadFileOrImage', fileName: fileNameString, isImage: isImage }, fd).$promise.then(function (response) {
                        newInvoiceSerie.fileStorage = { id: response[0].id };
                        saveInvoiceSerie(newInvoiceSerie);
                    }, function (errResponse) {
                        vm.isShowProgressLinear = false;
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    });
                }, function (errResponse) {
                    vm.isShowProgressLinear = false;
                    MessageService.showErrorMessage(errResponse.data.mensaje);
                });
            } else {
                newInvoiceSerie.fileStorage = { id: vm.invoiceSerie.fileStorage.id };
                saveInvoiceSerie(newInvoiceSerie);
            }
            return true;
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function saveInvoiceSerie(newInvoiceSerie) {
            var promise;
            if (!vm.invoiceSerie.id) {
                promise = api.GeneralWS.InvoiceSerie.save({}, newInvoiceSerie).$promise;
            } else {
                promise = api.GeneralWS.InvoiceSerie.update({ id: vm.invoiceSerie.id }, newInvoiceSerie).$promise;
            }
            promise.then(
                function (invoiceSerie) {
                    invoiceSerie.authorizationDate = $filter('date')(invoiceSerie.authorizationDate, 'yyyy-MM-dd');
                    invoiceSerie.dueDate = $filter('date')(invoiceSerie.dueDate, 'yyyy-MM-dd');
                    var response = invoiceSerie;
                    if (!vm.establishment) {
                        if (vm.invoiceSerie.id) {
                            var i = vm.company.invoiceSeries.indexOf(originalInv);
                            vm.company.invoiceSeries[i] = response;
                        } else {
                            vm.company.invoiceSeries = [];
                            vm.company.invoiceSeries.push(response);
                        }
                        if (!Privated) {
                            $rootScope.bsCircle.company.invoiceSeries = vm.company.invoiceSeries;
                        }
                    }
                    vm.filesToUpload = null;
                    vm.isShowProgressLinear = false;

                    MessageService.show($filter('translate')(!vm.invoiceSerie.id ? 'COMPANY.SERIE_CREATED' : 'COMPANY.SERIE_UPDATED'));
                    vm.invoiceSerie = {};
                    response.invoiceSerieDocumentTypeName = vm.invoiceSerieDocumentTypes.find(function (documentType) {
                        return documentType.invoiceSeriesDocumentTypeId === response.invoiceSerieDocumentType;
                    }).invoiceSeriesDocumentTypeDescription;
                    $mdDialog.hide(response);
                },
                function (errResponse) {
                    vm.isShowProgressLinear = false;
                    MessageService.showErrorMessage(errResponse.data.mensaje);
                }
            );
        }

        function getPhoto(url, ph) {
            if (ph) {
                url = ph.parentPath + ph.name;
            }
            if (url) {
                return vm.baseUrlFiles + url;
            }
            return 'assets/images/etc/thumbPhoto';
        }

        /**
         * Update image zoom options
         *
         * @param img
         */
        function updateImageZoomOptions(img) {
            var url = img.url;
            var extension = img.extension;
            vm.imageZoomOptions = {
                images: [
                    {
                        thumb: url + 's' + extension,
                        medium: url + 'm' + extension,
                        large: url + 'l' + extension
                    }
                ]
            };
        }

        function validateCorrelativeRange(isInitialNumber) {
            if (isInitialNumber === true && vm.invoiceSerie.lastNumber && vm.invoiceSerie.initialNumber) {
                vm.invoiceSerie.lastNumber = vm.invoiceSerie.lastNumber > vm.invoiceSerie.initialNumber ? vm.invoiceSerie.lastNumber : null;
            } else if (isInitialNumber === false && vm.invoiceSerie.lastNumber && vm.invoiceSerie.initialNumber) {
                vm.invoiceSerie.initialNumber = vm.invoiceSerie.initialNumber < vm.invoiceSerie.lastNumber ? vm.invoiceSerie.initialNumber : null;
            }
        }

        function getGfaces() {
            api.GeneralWS.GFace.GFace.getAll({ 'companyId': $rootScope.bsCircle.company.id }, function (response) {
                vm.gFaces = response;
                if (vm.invoiceSerie.gFace) {
                    vm.gFaces.forEach(function (data) {
                        if (vm.invoiceSerie.gFace.id === data.id) {
                            vm.invoiceSerie.gFace = data;
                        }
                    })
                }
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

    }
})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('BankController', BankController);

    /**@ngInject**/
    function BankController($mdDialog, api, firstAccount, bankAccount, company, $log, MessageService, $filter, $rootScope, $timeout) {

        const vm = this;
        const TIMEOUT_THREE_HUNDRED = 300;
        const NOT_ACCEPTABLE_NUMBER = 406;
        const CONFLICT_NUMBER = 409;

        vm.bankAccount = bankAccount;
        vm.firstBankAccount = firstAccount;

        vm.onChangeActive = onChangeActive;
        vm.save = save;
        vm.cancel = cancel;

        init();

        function init() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Bank.byCountry.get({ 'country': company.country.id },
                function (response) {
                    vm.banks = response;
                }, function (errResponse) {
                    vm.isShowProgressLinear = false;
                    $log.error(errResponse);
                });

            api.GeneralWS.BankAccountType.BankAccountType.get({ 'idCircle': $rootScope.bsCircle.id }, function (response) {
                vm.bankAccountTypes = response;
                vm.isShowProgressLinear = false;
            }, function (errResponse) {
                vm.isShowProgressLinear = false;
                $log.error(errResponse);
            });

            if (vm.firstBankAccount === true) {
                vm.bankAccount.isDefault = true;
            }

            vm.isShowProgressLinear = false;

            vm.clearSearchBank = function () {
                vm.searchBank = '';
            };
            vm.clearSearchBankAccountType = function () {
                vm.searchBankAccountType = '';
            };

            $timeout(function () {

                const keyEvent = function (event) {
                    event.stopPropagation();
                };

                const searchBankInput = document.querySelector('#searchBank');
                const searchBankAccountTypeInput = document.querySelector('#searchBankAccountType');

                if (searchBankInput) {
                    searchBankInput.addEventListener('keydown', keyEvent);
                }
                if (searchBankAccountTypeInput) {
                    searchBankAccountTypeInput.addEventListener('keydown', keyEvent);
                }
            }, TIMEOUT_THREE_HUNDRED);
        }

        function onChangeActive() {
            if (vm.bankAccount.active === false) {
                vm.bankAccount.isDefault = false;
            }
        }

        function save() {
            vm.isShowProgressLinear = true;
            let promise;
            if (vm.bankAccount) {
                if (vm.bankAccount.id) {
                    promise = api.GeneralWS.BankAccount.BankAccount.update({
                        'company': company.id,
                        'idCircle': $rootScope.bsCircle.id
                    }, vm.bankAccount).$promise;

                } else {
                    vm.bankAccount.currency = { id: company.currency.id };
                    vm.bankAccount.isForCompany = true;
                    promise = api.GeneralWS.BankAccount.BankAccount.create({
                        'company': company.id,
                        'idCircle': $rootScope.bsCircle.id
                    }, vm.bankAccount).$promise;
                }

                promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    $mdDialog.hide(response);
                }, function (exception) {
                    if (exception.status === NOT_ACCEPTABLE_NUMBER) {
                        MessageService.showErrorMessage($filter('translate')('BANKACCOUNT.REQUIRED_BANK_ACCOUNT'));
                    } else if (exception.status === CONFLICT_NUMBER) {
                        MessageService.showErrorMessage($filter('translate')('BANKACCOUNT.dataExist'));
                    } else {
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    }
                    vm.isShowProgressLinear = false;
                    $log.error(exception);
                });
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('CompanyDocumentController', CompanyDocumentController);

    /** @ngInject */
    function CompanyDocumentController($mdDialog, api, $rootScope, $log,
        MessageService, companyDocument, documentTypes, $filter, localStorageService,
        Company, Privated, providerId) {
        var vm = this;

        vm.maxPermitedFiles = 1;
        var companyRoot = Privated ? Company : $rootScope.bsCircle.company;
        vm.company = angular.copy(companyRoot);
        vm.document = companyDocument;
        vm.documentTypes = documentTypes;
        vm.minDate = new Date();
        vm.providerId = providerId;

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        vm.selectDocumentType = selectDocumentType;

        function selectDocumentType(data) {
            vm.document.document.documentType = data;
        }

        function getFormData(file) {
            var fd = new FormData();
            fd.append('files', file);
            return fd;
        }

        function saveDocument(company, document) {
            vm.isShowProgressLinear = true;

            var promise;

            vm.isNew = false;
            if (vm.document.id) {
                promise = api.GeneralWS.CompanyDocument.update({
                    company: company.id,
                    id: document.id,
                    'providerId': vm.providerId,
                },
                    document.document).$promise;
            } else {
                vm.isNew = true;
                if (document.document.dateOfIssue === undefined) {
                    document.document.dateOfIssue === '';
                    document.document.dueDate === '';
                }

                promise = api.GeneralWS.CompanyDocument.addDocument({ company: company.id }, document.document).$promise;
            }

            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (vm.isNew) {
                    vm.company.documents.push(angular.copy(response.$data));
                } else {
                    for (var i = 0; i < vm.company.documents.length; i++) {
                        if (vm.company.documents[i].document.id === vm.document.document.id) {
                            vm.company.documents[i] = vm.document;
                            vm.company.documents[i].document.dateOfIssue = $filter('date')(vm.company.documents[i].document.dateOfIssue, 'yyyy-MM-dd');
                            vm.company.documents[i].document.dueDate = $filter('date')(vm.company.documents[i].document.dueDate, 'yyyy-MM-dd');
                        }
                    }
                }

                for (var i = 0; i < vm.company.documents.length; i++) {
                    vm.company.documents[i].document.dateOfIssue = $filter('date')(vm.company.documents[i].document.dateOfIssue, 'yyyy-MM-dd');
                    vm.company.documents[i].document.dueDate = $filter('date')(vm.company.documents[i].document.dueDate, 'yyyy-MM-dd');
                }

                companyRoot.documents = [];
                companyRoot.documents = angular.copy(vm.company.documents);
                if (!Privated) {
                    $rootScope.bsCircle.company = companyRoot;
                    localStorageService.set('accountc', $rootScope.bsCircle);
                }

                vm.isShowProgressLinear = false;
                $mdDialog.hide(companyRoot.documents);

            }, function (response) {

                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response && response.status === 302) {
                    MessageService.showErrorMessage($filter('translate')('company_document.exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function save() {

            if (vm.theForm.$invalid) {
                MessageService.show($filter('translate')('general.completeInfo'));
                return false;
            }

            if (vm.document.document.documentType.requiredFile) {
                if (vm.filesToUpload.length <= 0) {
                    MessageService.show($filter('translate')('COMPANY.NO_FILES'));
                    return false;
                }
            }

            vm.isShowProgressLinear = true;

            var files = [];
            vm.filesToUpload.forEach(function (r) {
                files.push(r.file.file);
            });

            if (vm.filesToUpload.length > 0) {
                var typeFile = vm.filesToUpload[0].file.file.type.split('/');
                if (!typeFile || typeFile.length === 0) {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    return null;
                }

                var fd = getFormData(vm.filesToUpload[0].file.file);
                var fileNameString = "document-" + vm.document.document.documentType.name + "-" + companyRoot.id;
                var isImage = (typeFile[1] === 'jpg' || typeFile[1] === 'JPG' || typeFile[1] === 'png' || typeFile[1] === 'PNG' || typeFile[1] === 'jpeg' || typeFile[1] === 'JPEG') ? true : false;

                api.GeneralWS.FileStorage.me.save({ id: 'uploadFileOrImage', fileName: fileNameString, isImage: isImage }, fd).$promise.then(function (response) {
                    vm.document.document.files = response;
                    saveDocument(companyRoot, vm.document);
                }, function (errResponse) {
                    vm.isShowProgressLinear = false;
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
            } else { //si no hay archivos, sólo graba el documento
                saveDocument(companyRoot, vm.document);
            }
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

    }
})();


(function () {

  'use strict';

  angular
    .module('app.company')
    .controller('dialogPaymentTypesController', dialogPaymentTypesController);

  function dialogPaymentTypesController($log, api, $rootScope, $mdDialog, paymentType, establishmentId, $filter, $timeout) {
    var vm = this;
    vm.page = 1;
    vm.pageSize = 20;

    vm.flip;
    vm.flipping = flipping;
    vm.newAccount = true;

    vm.selectAccount = selectAccount;
    vm.getAccounts = getAccounts;
    vm.onAccountingCatalog = onAccountingCatalog;
    vm.changeFilter = changeFilter;
    vm.typeCatalog = 1;

    vm.paymentIntegrated = [
      {id: 'NA', name: $filter('translate')('PAYMENT_TYPE.providerIntegration.NA')},
      {id: 'BAC_PINPAD', name: $filter('translate')('PAYMENT_TYPE.providerIntegration.BAC_PINPAD')},
      {id: 'VISA_PINPAD', name: $filter('translate')('PAYMENT_TYPE.providerIntegration.VISA_PINPAD')},
      {id: 'EVO_MULTIPAY', name: $filter('translate')('PAYMENT_TYPE.providerIntegration.EVO_MULTIPAY')},
      {id: 'VISA_LINK', name: $filter('translate')('PAYMENT_TYPE.providerIntegration.VISA_LINK')},
      {id: 'OMC', name: $filter('translate')('PAYMENT_TYPE.providerIntegration.OMC')},
    ];

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.save = function () {
      $mdDialog.hide(vm.obj);
    };

    vm.obj = {
      authorizedAmount: 0.0,
      commissionPercentage: 0.0,
      usePosIntegrated: false,
      requestAuthorization: false,
      typeProviderIntegration: 'NA',
      accountingCatalog: null,
      amountForSignature: 0.0,
      canInvoiceStayPending: false,
      canEnterCustomerEmailOnInvoice: false,
      requireCustomerEmailOnInvoice: false,
      paymentTypeAutomaticInvoice: 12,
      invoiceAutomaticCustomerAddress: 'CIUDAD',
      maxAmount: 0.0,
      generateAutomaticInvoice: false,
      percentageInvoice: 0.0,
      extractPercentageFromTotal: false,
    };

    if (paymentType) {
      api.GeneralWS.CompanyEstablishmentPaymentType.CompanyEstablishmentPaymentType.getId({
        'idCircle': $rootScope.bsCircle.id,
        'companyEstablishmentId': establishmentId,
        'id': paymentType.id,
      }).$promise.then(function (response) {
        if (response) {
          vm.obj = response;
        }
        vm.obj.companyEstablishment = {id: establishmentId};
        vm.isShowProgressLinear = false;
      }, function (response) {
        vm.isShowProgressLinear = false;
        $log.error(response);
      });
    }

    function getAccounts(page) {
      vm.page = page;
      api.GeneralWS.Account.AccountingCatalog.ByDescription.get({
        'company': $rootScope.bsCircle.company.id, page: page - 1, size: vm.pageSize, filter: vm.filterAccount
      }, function (data) {
        vm.accounts = data;
        vm.loading = false;
      }, function (data) {
        vm.loading = false;
      });
    }

    function flipping(funct) {
      vm.flip = funct;
      if (vm.newAccount) {
        funct();
      }
    }

    function onAccountingCatalog(typeCatalog) {
      vm.typeCatalog = typeCatalog;
      vm.flip();
      changeFilter();
      $timeout(function () {
        document.getElementById("searchAccount").focus();
      }, 600);
    }

    function changeFilter() {
      if (!vm.filterProduct || vm.filterProduct === '') {
        getAccounts(1);
      }
    }

    function selectAccount(account) {
      if (vm.typeCatalog === 1) {
        vm.selectedAccount = account;
        vm.obj.accountingCatalog = account;
      } else {
        vm.accountForCreditDocument = account;
        vm.obj.accountForCreditDocument = account;
      }
      vm.flip();
    }

  }
})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ParametersProductController', ParametersProductController);

    /**@ngInject**/
    function ParametersProductController(api, $rootScope, $timeout, $log, $mdDialog, $filter, MessageService, $state) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 50;
        vm.onlyNotValidated = false;
        vm.messageOnLoadParameter = '';
        vm.backTo = backTo;
        vm.establishment = $state.params.establishment;
        vm.salesTaxArray = [];
        vm.batchUpdate = false;
        vm.saveInBatch = false;
        vm.textSearch = 'general.search';
        vm.textButtonSearch = 'general.search';

        vm.getProducts = getProducts;
        vm.changeBatch = changeBatch;
        vm.clearTextSearch = clearTextSearch;
        vm.selectProduct = selectProduct;
        vm.changeFilter = changeFilter;
        vm.save = save;
        vm.disableButtonSave = true;
        vm.updateMaxMin = true;

        $timeout(init, 1200);

        function init() {

            setDinamicHeight();

            var contentHeight2 = $('#parametersProductList').innerHeight();
            contentHeight2 -= 60;
            vm.dinamicMinHeight = { 'min-height': contentHeight2 + 'px' };

            getProducts(vm.page);

          // obtiene la lista de impuestos
            getSalesTax();
        }

        function setDinamicHeight() {
          var contentHeight = $('#parametersProductList').innerHeight();
          const switchHeight = 40;
          contentHeight -= switchHeight;
          if (!vm.batchUpdate) {
            const pagingSize = 77;
            contentHeight -= pagingSize;
          }
          vm.dinamicHeight = { 'height': contentHeight + 'px' };
        }

        function getSalesTax() {
          vm.salesTaxArray = [];

          api.GeneralWS.Common.CountryTax.self
            .query({'country': $rootScope.bsCircle.company.country.id})
            .$promise
            .then(function(response){
              response.forEach(function(row){
                if(row.isSalesTax) {
                  vm.salesTaxArray.push(row);
                }
              });
            }, function(err){
              $log.error(err);
            });
        }

        function clearTextSearch() {
            vm.selectedProduct = null;
            vm.productCompanyAddons = null;
            vm.filterProduct = '';
            vm.textButtonSearch = 'general.search';
            vm.productos = {
              content: []
            };
        }

        function changeBatch() {
          setDinamicHeight();
          if (vm.batchUpdate) {
            vm.textSearch = 'product_parameters.searchProductCode';
            clearTextSearch();
          } else {
            vm.textSearch = 'general.search';
            clearTextSearch();
            getProducts(1);
          }
        }

        function getProducts(page) {
            vm.selectedProduct = null;
            vm.productCompanyAddons = null;
            vm.textSearch = 'general.search';
            var filterText = angular.copy(vm.filterProduct);
            vm.productos = [];
            if (vm.batchUpdate) {
              const arrayFilters = vm.filterProduct.toString().split(',');
              if (arrayFilters.length > 50) {
                MessageService.showErrorMessage($filter('translate')('product_parameters.max_50_product_codes'));
                return;
              }
              vm.saveInBatch = false;
              vm.textSearch = 'product_parameters.searchProductCode';
              if(!vm.filterProduct) {
                clearTextSearch();
                MessageService.showErrorMessage($filter('translate')('product_parameters.must_entered_product_code'));
                return;
              }
              filterText = filterText.toLowerCase();
              if (vm.textButtonSearch === 'general.search') {
                vm.textButtonSearch = 'product_parameters.clear';
              }
            }

            vm.loading = true;
            api.GeneralWS.ProductValidated.getValidated({
                'pageNumber': page, 'pageSize': vm.pageSize, 'search': filterText,
                'establishmentId': $state.params.id, 'batchUpdate': vm.batchUpdate
            },
                function (data) {
                    processProductData(data);
                    vm.productos = data;
                    vm.page = page;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function processProductData(products) {
          if (!vm.batchUpdate || products.content.length === 0) {
            return;
          }
          const repetedCodes = {};
          products
          .content
          .forEach(function (product) {
            if (repetedCodes[product.productCode]) {
              repetedCodes[product.productCode]++;

            } else {
              repetedCodes[product.productCode] = 1;
            }
          });

          products
          .content
          .forEach(function (product) {
            product.repeated = repetedCodes[product.productCode] > 1;
          });
        }

        function selectProduct(product) {
            if (vm.selectedProduct && product.id === vm.selectedProduct.id) {
                return null;
            }

            vm.selectedProduct = product;
            vm.productCompanyAddons = {};
            vm.messageOnLoadParameter = $filter('translate')('product_parameters.charging_parameters');
            vm.loadingParameters = true;
            api.GeneralWS.ProductCompanyEstablishmentAddons.getByProductAndCompany.get({
                'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id, 'establishmentId': $state.params.id
            }).$promise.then(function (response) {
                $timeout(function () {
                    vm.loadingParameters = false;
                }, 1000);
                    vm.productCompanyAddons = response;
                    setLastSaleDate(response.lastSaleDate);
            }, function (response) {
                vm.loadingParameters = false;
                $log.error(response);
            });

            return true;
        }

        function changeFilter(event) {
            if ((!vm.filterProduct || vm.filterProduct === '') && !vm.batchUpdate) {
              getProducts(1);
            }
        }

        function save() {

            vm.messageOnLoadParameter = $filter('translate')('product_parameters.updating_parameters');
            vm.loadingParameters = true;

            var promise;
            if (vm.productCompanyAddons.salePrice === null || vm.productCompanyAddons.salePrice === undefined) {
                vm.productCompanyAddons.salePrice = 0;
            }

            vm.productCompanyAddons.inventoryBalancedEnabled = vm.productCompanyAddons.inventoryBalancedEnabled ? vm.productCompanyAddons.inventoryBalancedEnabled : false;

            if (vm.batchUpdate && vm.saveInBatch) {
              saveProductBatch();
              return;
            }

            if (vm.productCompanyAddons.id) {
                promise = api.GeneralWS.ProductCompanyEstablishmentAddons.me.update({
                    'id': vm.productCompanyAddons.id, 'idCircle': $rootScope.bsCircle.id, 'establishmentId': $state.params.id, 'updateMaxMin': vm.updateMaxMin
                }, vm.productCompanyAddons).$promise;
            } else {
                vm.productCompanyAddons.active = true;
                vm.productCompanyAddons.product = { id: vm.selectedProduct.id };
                promise = api.GeneralWS.ProductCompanyEstablishmentAddons.me.create({
                    'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id, 'establishmentId': $state.params.id
                }, vm.productCompanyAddons).$promise;
            }

            promise.then(function (response) {
                vm.loadingParameters = false;
                vm.productCompanyAddons = response;
                setLastSaleDate(response.lastSaleDate);
                MessageService.show($filter('translate')('product_parameters.updated'));

            }, function (response) {
                vm.loadingParameters = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
                selectProduct(vm.selectedProduct);
                $log.error(response);
            });
        }

        function saveProductBatch() {
          $mdDialog.show({
            controller: 'ProductListEstablishmentBatchDialogController',
            controllerAs: 'vm',
            locals: {
              products: vm.productos,
              addons: vm.productCompanyAddons,
              establishmentId: $state.params.id,
              updateMaxMin: vm.updateMaxMin
            },
            templateUrl: 'app/main/apps/company/company-establishments/establishment-list/parameters/dialog/product-list-batch-dialog/product-list-batch-dialog.html',
            parent: angular.element('#main'),
            clickOutsideToClose: false
          })
            .then(function (answer) {
              MessageService.show($filter('translate')('product_parameters.updated'));
              vm.loadingParameters = false;
            });
        }

        function backTo() {
            $state.go('app.company.establishment');
        }

        function setLastSaleDate(date) {
            vm.lastSaleDate = null;

            if (!date) {
                return;
            }
            const parts = date.split('-');
            if (parts[0].length !== 4) {
                vm.lastSaleDate = date;
            } else {
                vm.lastSaleDate = parts[2] + '-' + parts[1] + '-' + parts[0];
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogRoleSpecialActionController', DialogRoleSpecialActionController);

    /** @ngInject */
    function DialogRoleSpecialActionController(api, $log, $rootScope, $mdDialog, establishment) {
        var vm = this;
        vm.establishment = establishment;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];


        vm.cancel = function () {
            $mdDialog.cancel();
        }

        init();

        function init() {
            getApps();
        }

        function getApps() {
            api.GeneralWS.CompanyApplication.me.query({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.applications = response;
            }, function (d) {
            });
        }

        vm.getInfoByApp = function (app) {
            api.GeneralWS.RoleApplication.byLevel.page({ 'level': 0, 'applicationId': vm.appId, 'pageSize': 100, 'pageNumber': 1 }, function (response) {
                vm.roleApplications = response.content;
            }, function (d) {

            });
        };


        vm.getInfoByApp2 = function (app) {
            vm.load = true;
            api.GeneralWS.RoleCompanySpecialAction.notAssociated.get(
                {
                    idCircle: $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id, 'roleApplicationId': vm.roleApplicationId
                }, function (response) {
                    vm.roleArray = response;
                    vm.load = false;
                }, function (d) {
                    vm.load = false;
                });
            getAssignedSpecialAction();
        };

        vm.toggle = function (data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        };

        vm.toggleAssociated = function (data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        };

        vm.isSelected = function (data) {
            return vm.selectedArray.indexOf(data) > -1;
        };

        vm.isSelectedAssociated = function (data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        };



        vm.selectAll = function () {
            if (vm.isCheckAll) {
                vm.roleArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countRoleSelected = vm.roleArray.length;

            } else {
                vm.roleArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countRoleSelected = 0;
            }
        }


        vm.selectAllUsers = function () {
            if (vm.isCheckAllUser) {
                vm.userArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }
                });

                vm.countUserSelected = vm.userArray.length;

            } else {
                vm.userArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserSelected = 0;
            }
        }

        vm.associate = function () {

            var roleIdArray = [];

            if (!vm.isCheckAll) {
                vm.selectedArray.forEach(function (row) {
                    roleIdArray.push(row.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAll) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.RoleCompanySpecialAction.RoleCompanySpecialAction.create(
                {
                    'associateAll': vm.isCheckAll, 'establishmentId': vm.establishment.id, 'idCircle': $rootScope.bsCircle.id, 'roleApplicationId': vm.roleApplicationId
                }, roleIdArray).$promise.then(function (response) {

                    vm.isShowProgressLinear = false;

                    getAssignedSpecialAction();

                    vm.selectedArray = [];
                    vm.getInfoByApp2(null);

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
            return true;
        }

        vm.disassociate = function () {

            var roleIdArray = [];

            if (!vm.isCheckAllUser) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    roleIdArray.push(row.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAllUser) {
                return null;
            }


            vm.isShowProgressLinear = true;
            api.GeneralWS.RoleCompanySpecialAction.RoleCompanySpecialAction.update(
                {
                    'deleteAll': vm.isCheckAllUser, 'establishmentId': vm.establishment.id, 'idCircle': $rootScope.bsCircle.id, 'roleApplicationId': vm.roleApplicationId
                }, roleIdArray).$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    getAssignedSpecialAction();

                    vm.selectedAssociatedArray = [];

                    vm.getInfoByApp2(null);

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
            return true;
        }

        function getAssignedSpecialAction() {
            vm.loadAssociated = true;
            api.GeneralWS.RoleCompanySpecialAction.associated.get(
                {
                    'idCircle': $rootScope.bsCircle.id, 'roleApplicationId': vm.roleApplicationId, 'establishmentId': vm.establishment.id
                }, function (response) {
                    vm.userArray = response;
                    vm.loadAssociated = false;
                }, function (d) {
                    vm.loadAssociated = false;
                });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogDiscountsController', DialogDiscountsController);

    /** @ngInject */
    function DialogDiscountsController(api, $log, $rootScope, $filter, $mdDialog, MessageService, $timeout, establishment) {
        var vm = this;
        vm.establishment = establishment;

        vm.pagination = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        init();

        function init() {
            $timeout(function () {
                loadDiscount();
                vm.clearSearchDiscount = function () {
                    vm.searchDiscount = "";
                };

                $timeout(function () {

                    var keyEvent = function (event) {
                        event.stopPropagation();
                    };

                    var searchDiscountInput = document.querySelector("#searchDiscount");


                    if (searchDiscountInput) {
                        searchDiscountInput.addEventListener("keydown", keyEvent);
                    }
                }, 500);
            }, 500);
        }

        function loadDiscount() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.DiscountCompany.DiscountCompany.get({ "idCircle": $rootScope.bsCircle.id }, function (response) {
                vm.discounts = response;
                vm.isShowProgressLinear = false;
                loadDiscountEstablishment();
            }, function (errResponse) {

            });
        }

        vm.save = function () {
            vm.discountEstablishment.companyEstablishment = {
                id: vm.establishment.id
            };
            vm.isShowProgressLinear = true;
            api.GeneralWS.DiscountCompanyEstablishment.DiscountCompanyEstablishment.create({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id
            }, vm.discountEstablishment, function (response) {
                vm.isShowProgressLinear = false;
                MessageService.show($filter('translate')('DISCOUNTS.ADDED_SUCCESSFULLY'));
                vm.discountEstablishment = {};
                init();
            }, function (errResponse) {
                MessageService.showErrorMessage($filter('translate')('DISCOUNTS.' + errResponse.data.mensaje));
            });
        };

        var columnDefs = [
            {
                field: "discountCompany.discountName",
                headerName: 'DISCOUNTS.name',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: 'discountCompany.discountMethod',
                headerName: 'DISCOUNTS.applicationMethod',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.data) {
                        return $filter("translate")("DISCOUNTS.discountMethods." + params.data.discountCompany.discountMethod);
                    }
                },
                width: 200
            },
            {
                headerName: 'BANK.ACTIONS',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.delete(data)'> " +
                        "<md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> " +
                        " <md-tooltip md-direction='left'>{{'general.delete' | translate}}</md-tooltip> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function loadDiscountEstablishment() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.DiscountCompanyEstablishment.byEstablishment.get({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id
            }, function (response) {
                vm.companyEstablishmentDiscounts = response;
                vm.discountGrid.api.setRowData(vm.companyEstablishmentDiscounts);
                vm.discountGrid.api.setColumnDefs(columnDefs);
                vm.isShowProgressLinear = false;
                vm.companyEstablishmentDiscounts.forEach(function (element) {
                    vm.discounts.forEach(function (data, i) {
                        if (data.id === element.discountCompany.id) {
                            vm.discounts.splice(i, 1);
                        }
                    })
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.discountGrid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.delete = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('DISCOUNTS.DELETE'))
                .textContent($filter('translate')('DISCOUNTS.CONFIRMATION_DELETE'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.DiscountCompanyEstablishment.DiscountCompanyEstablishment.del({
                    "idCircle": $rootScope.bsCircle.id, 'id': data.id
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('DISCOUNTS.DELETED_SUCCESSFULLY'));
                    init();
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogCompanyWarehouseController', DialogCompanyWarehouseController);

    /** @ngInject */
    function DialogCompanyWarehouseController(api, $log, $rootScope, $mdDialog, $timeout, $filter, MessageService, establishment) {
        var vm = this;
        vm.establishment = establishment;
        vm.load = false;

        vm.companyWarehouseArray = [];
        vm.establishmentCompanyWarehouseArray = [];
        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.countCompanyWarehouseSelected = 0;
        vm.countEstablishmentCompanyWarehouseSelected = 0;
        vm.inputSearchCompanyWarehouse = "";
        vm.inputSearchEstablishmentCompanyWarehouse = "";

        vm.cancel = cancel;
        vm.selectAllCompanyWarehouse = selectAllCompanyWarehouse;
        vm.selectAllEstablishmentCompanyWarehouse = selectAllEstablishmentCompanyWarehouse;
        vm.validateSelectAllCompanyWarehouse = validateSelectAllCompanyWarehouse;
        vm.validateSelectAllEstablishmentCompanyWarehouse = validateSelectAllEstablishmentCompanyWarehouse;
        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;
        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.searchCompanyWarehouse = searchCompanyWarehouse;
        vm.searchEstablishmentCompanyWarehouse = searchEstablishmentCompanyWarehouse;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.paginationCompanyWarehouse = {
            pageNumber: 1,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getCompanyWarehouse();
            }
        };

        vm.paginationEstablishmentCompanyWarehouse = {
            pageNumber: 1,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getEstablishmentCompanyWarehouse();
            }
        };

        function getCompanyWarehouse() {
            vm.load = true;
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyWarehouse.notAssociatedToEstablishment.page({
                'establishmentId': vm.establishment.id,
                'pageNumber': vm.paginationCompanyWarehouse.pageNumber,
                'pageSize': vm.paginationCompanyWarehouse.pageSize,
                'search': vm.inputSearchCompanyWarehouse
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.load = false;

                vm.paginationCompanyWarehouse.totalElements = response.totalElements;
                vm.paginationCompanyWarehouse.totalPages = response.totalPages;
                vm.companyWarehouseArray = response.content;

                vm.isCheckAllCompanyWarehouse = false;
                vm.countCompanyWarehouseSelected = 0;
            }, function (response) {
                $log.error(response);
            });
        }

        function getEstablishmentCompanyWarehouse() {
            vm.loadAssociatedProducts = true;
            vm.isShowProgressLinear = true;

            api.GeneralWS.CompanyWarehouse.associatedToEstablishment.page({
                'establishmentId': vm.establishment.id,
                'pageNumber': vm.paginationEstablishmentCompanyWarehouse.pageNumber,
                'pageSize': vm.paginationEstablishmentCompanyWarehouse.pageSize,
                'search': vm.inputSearchEstablishmentCompanyWarehouse
            }).$promise.then(function (response) {
                vm.loadAssociatedProducts = false;
                vm.isShowProgressLinear = false;

                vm.paginationEstablishmentCompanyWarehouse.totalElements = response.totalElements;
                vm.paginationEstablishmentCompanyWarehouse.totalPages = response.totalPages;
                vm.establishmentCompanyWarehouseArray = response.content;

                vm.isCheckAllEstablishmentCompanyWarehouse = false;
                vm.countEstablishmentCompanyWarehouseSelected = 0;

            }, function (response) {
                $log.error(response);
            });
        }

        function searchCompanyWarehouse() {
            if (vm.inputSearchCompanyWarehouse === undefined || vm.inputSearchCompanyWarehouse === null) {
                return null;
            }

            vm.paginationCompanyWarehouse.pageNumber = 1;
            getCompanyWarehouse();
        }

        function searchEstablishmentCompanyWarehouse() {
            if (vm.inputSearchEstablishmentCompanyWarehouse === undefined || vm.inputSearchEstablishmentCompanyWarehouse === null) {
                return null;
            }

            vm.paginationEstablishmentCompanyWarehouse.pageNumber = 1;
            getEstablishmentCompanyWarehouse();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAllCompanyWarehouse() {
            vm.countCompanyWarehouseSelected = 0;
            var isSelectAll = true;

            vm.companyWarehouseArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countCompanyWarehouseSelected++;
                }
            });

            vm.isCheckAllCompanyWarehouse = isSelectAll;
        }

        function selectAllCompanyWarehouse() {
            if (vm.isCheckAllCompanyWarehouse) {
                vm.companyWarehouseArray.forEach(function (row) {
                    row.isCheck = true;
                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countCompanyWarehouseSelected = vm.companyWarehouseArray.length;
            } else {
                vm.companyWarehouseArray.forEach(function (row) {
                    row.isCheck = false;
                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countCompanyWarehouseSelected = 0;
            }
        }

        function validateSelectAllEstablishmentCompanyWarehouse() {
            vm.countEstablishmentCompanyWarehouseSelected = 0;
            var isSelectAll = true;

            vm.establishmentCompanyWarehouseArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countEstablishmentCompanyWarehouseSelected++;
                }
            });

            vm.isCheckAllEstablishmentCompanyWarehouse = isSelectAll;
        }

        function selectAllEstablishmentCompanyWarehouse() {
            if (vm.isCheckAllEstablishmentCompanyWarehouse) {
                vm.establishmentCompanyWarehouseArray.forEach(function (row) {
                    row.isCheck = true;
                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }
                });
                vm.countEstablishmentCompanyWarehouseSelected = vm.establishmentCompanyWarehouseArray.length;
            } else {
                vm.establishmentCompanyWarehouseArray.forEach(function (row) {
                    row.isCheck = false;
                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });
                vm.countEstablishmentCompanyWarehouseSelected = 0;
            }
        }

        function associate() {
            var companyWarehouseIdArray = [];
            if (!vm.isCheckAllCompanyWarehouse) {
                vm.selectedArray.forEach(function (row) {
                    companyWarehouseIdArray.push(row.id);
                });
            }

            if (companyWarehouseIdArray.length === 0 && !vm.isCheckAllCompanyWarehouse) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyEstablishmentCompanyWarehouse.me.create({
                    'establishmentId': vm.establishment.id,
                    'associateAll': vm.isCheckAllCompanyWarehouse,
                    'search': vm.inputSearchCompanyWarehouse
                },
                companyWarehouseIdArray
            ).$promise.then(function () {
                vm.isShowProgressLinear = false;

                if (vm.paginationEstablishmentCompanyWarehouse.totalPages === 0) {
                    vm.paginationEstablishmentCompanyWarehouse.pageNumber = 1;
                } else {
                    vm.paginationEstablishmentCompanyWarehouse.pageNumber = vm.paginationEstablishmentCompanyWarehouse.totalPages;
                }
                vm.inputSearchEstablishmentCompanyWarehouse = "";
                getEstablishmentCompanyWarehouse();

                vm.paginationCompanyWarehouse.pageNumber = 1;
                vm.inputSearchCompanyWarehouse = "";
                vm.selectedArray = [];
                getCompanyWarehouse();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function disassociate() {
            var companyWarehouseIdArray = [];
            if (!vm.isCheckAllEstablishmentCompanyWarehouse) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    companyWarehouseIdArray.push(row.id);
                });
            }

            if (companyWarehouseIdArray.length === 0 && !vm.isCheckAllEstablishmentCompanyWarehouse) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyEstablishmentCompanyWarehouse.me.update({
                    'establishmentId': vm.establishment.id,
                    'deleteAll': vm.isCheckAllEstablishmentCompanyWarehouse,
                    'search': vm.inputSearchEstablishmentCompanyWarehouse
                },
                companyWarehouseIdArray
            ).$promise.then(function () {
                vm.isShowProgressLinear = false;

                vm.paginationCompanyWarehouse.pageNumber = 1;
                getCompanyWarehouse();

                vm.paginationEstablishmentCompanyWarehouse.pageNumber = 1;
                vm.selectedAssociatedArray = [];

                getEstablishmentCompanyWarehouse();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        $timeout(function () {
            getCompanyWarehouse();
            getEstablishmentCompanyWarehouse();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());
            windowHeight -= 155;
            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
        }, 1000);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogCoinController', DialogCoinController);

    /** @ngInject */
    function DialogCoinController(api, $log, $rootScope, $filter, $mdDialog, MessageService, $timeout, establishment) {
        var vm = this;
        vm.establishment = establishment;

        vm.paginationCoin = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        init();

        function init() {
            $timeout(function () {
                loadCoin();
                vm.clearSearchCurrency = function () {
                    vm.searchCurrency = "";
                };

                $timeout(function () {

                    var keyEvent = function (event) {
                        event.stopPropagation();
                    };

                    var searchCoinInput = document.querySelector("#searchCurrency");


                    if (searchCoinInput) {
                        searchCoinInput.addEventListener("keydown", keyEvent);
                    }
                }, 500);
            }, 500);
        }

        function loadCoin() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Currency.get({ "country": $rootScope.bsCircle.company.country.id }, function (response) {
                vm.currencies = response;
                vm.isShowProgressLinear = false;
                loadCompanyEstablishmentCoin();
            }, function (errResponse) {

            });
        }

        vm.saveCurrency = function () {
            vm.currencyAccount.companyEstablishment = {
                id: vm.establishment.id
            };
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyEstablishmentCurrency.CompanyEstablishmentCurrency.create({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id
            }, vm.currencyAccount, function (response) {
                vm.isShowProgressLinear = false;
                vm.currencyAccount = {};
                MessageService.show($filter('translate')('company_establishment.added_successfully'));
                init();
            }, function (errResponse) {
                MessageService.showErrorMessage('general.' + errResponse.data);
            });
        };

        var columnDefsCoin = [
            {
                field: "currency.description",
                headerName: 'CURRENCY.CURRENCY',
                headerCellRenderer: getHeader,
                width: 180
            },
            {
                field: "baseAmount",
                headerName: 'CURRENCY.BASE_AMOUNT',
                headerCellRenderer: getHeader,
                valueFormatter: function (param) {
                    return $filter("number")(param.value, 2)
                },
                cellStyle: { 'textAlign': 'right' },
                width: 140
            },
            {
                field: "cashDepositAmount",
                headerName: 'CURRENCY.CASH_DEPOSIT_AMOUNT',
                headerCellRenderer: getHeader,
                valueFormatter: function (param) {
                    return $filter("number")(param.value, 2)
                },
                width: 160,
                cellStyle: { 'textAlign': 'right' }
            },
            {
                field: "isDefaultCurrency",
                headerName: 'CURRENCY.ISDEFAULT',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    return "<div layout='row' layout-align='center center'> " +
                        " <md-icon ng-if='data.isDefaultCurrency' class='md-primary' md-font-icon='icon-check'></md-icon> " +
                        " <md-icon ng-if='!data.isDefaultCurrency' class='md-warn' md-font-icon='icon-close'></md-icon></div>";
                },
                width: 200,
                cellStyle: { 'align': 'center' }
            },
            {
                headerName: 'BANK.ACTIONS',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.deleteCurrency(data)'> " +
                        "<md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> " +
                        " <md-tooltip md-direction='left'>{{'general.delete' | translate}}</md-tooltip> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function loadCompanyEstablishmentCoin() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyEstablishmentCurrency.CompanyEstablishmentCurrency.get({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id
            }, function (response) {
                vm.companyEstablishmentCoins = response;
                vm.gridCoin.api.setRowData(vm.companyEstablishmentCoins);
                vm.gridCoin.api.setColumnDefs(columnDefsCoin);
                vm.isShowProgressLinear = false;
                vm.companyEstablishmentCoins.forEach(function (element) {
                    vm.currencies.forEach(function (data, i) {
                        if (data.id === element.currency.id) {
                            vm.currencies.splice(i, 1);
                        }
                    })
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.gridCoin = {
            paginationPageSize: vm.paginationCoin.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            cacheBlockSize: vm.paginationCoin.pageSize,
            pagination: true,
            columnDefs: columnDefsCoin,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.deleteCurrency = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('CURRENCY.DELETE_CURRENCY'))
                .textContent($filter('translate')('CURRENCY.CONFIRMACION_DELETE_CURRENCY'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.CompanyEstablishmentCurrency.CompanyEstablishmentCurrency.del({
                    "idCircle": $rootScope.bsCircle.id, 'id': data.id
                }, vm.currencyAccount, function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('company_establishment.deleted_successfully'));
                    init();
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogClassificationsController', DialogClassificationsController);

    /** @ngInject */
    function DialogClassificationsController(api, $log, $rootScope, $filter, $mdDialog, MessageService, $timeout, establishment) {
        var vm = this;
        vm.establishment = establishment;
        vm.establishmentClassType = {};

        init();

        function init() {
            $timeout(function () {
                loadClassTypes();
                vm.clearSearchType = function () {
                    vm.searchType = "";
                };
                vm.clearSearchValue = function () {
                    vm.searchValue = "";
                };

                $timeout(function () {
                    var keyEvent = function (event) {
                        event.stopPropagation();
                    };
                    var searchTypeInput = document.querySelector("#searchType");
                    var searchValueInput = document.querySelector("#searchValue");
                    if (searchTypeInput) {
                        searchTypeInput.addEventListener("keydown", keyEvent);
                    }
                    if (searchValueInput) {
                        searchValueInput.addEventListener("keydown", keyEvent);
                    }
                }, 500);
            }, 500);
        }

        function loadClassTypes() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CorporateClassificationType.me.list({ 'companyId': $rootScope.bsCircle.company.id }, function (response) {
                vm.classTypes = response;
                vm.isShowProgressLinear = false;
                vm.classTypeValues = [];
                vm.classificationTypeId = null;
                loadEstablishmentClassTypes();
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.getClassficationValues = function (selectedValue) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CorporateClassificationTypeValues.me.list({ 'classificationTypeId': vm.classificationTypeId }, function (response) {
                vm.classTypeValues = response.filter(function(item){return item.active === true});
                vm.isShowProgressLinear = false;
                if (selectedValue) {
                    vm.establishmentClassType.corporateClassificationTypeValues.id = selectedValue;
                    return;
                }
                if (!vm.establishmentClassType.id) {
                    vm.establishmentClassType.corporateClassificationTypeValues = {};
                }
                if (response.length === 1) {
                    vm.establishmentClassType.corporateClassificationTypeValues.id = response[0].id.toString();
                } else {
                    vm.establishmentClassType.corporateClassificationTypeValues.id = null;
                }
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.save = function () {
            vm.establishmentClassType.companyEstablishment = {
                id: vm.establishment.id
            };
            var promise;
            if (vm.establishmentClassType.id) {
                promise = api.GeneralWS.CompanyEstablishmentClassType.me.update({ id: vm.establishmentClassType.id }, vm.establishmentClassType).$promise;
            } else {
                promise = api.GeneralWS.CompanyEstablishmentClassType.me.create({}, vm.establishmentClassType).$promise;
            }
            vm.isShowProgressLinear = true;
            promise.then(function () {
                vm.isShowProgressLinear = false;
                if (vm.establishmentClassType.id) {
                    MessageService.show($filter('translate')('company_establishment.classification.updated'));
                } else {
                    MessageService.show($filter('translate')('company_establishment.classification.added'));
                }
                vm.establishmentClassType = {};
                vm.classificationTypeId = null;
                init();
            }, function (errResponse) {
                vm.isShowProgressLinear = false;
                $log.debug(errResponse);
                MessageService.showErrorMessage($filter('translate')('general.error'));
            });
        };

        var columnDefs = [
            {
                field: "corporateClassificationTypeValues.corporateClassificationType.classTypeName",
                headerName: 'company_establishment.classification.type',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "corporateClassificationTypeValues.typeValue",
                headerName: 'company_establishment.classification.value',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                headerName: '',
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: function (params) {
                    return '<center> ' +
                        '<md-button class="md-icon-button" ng-click="vm.edit(data)">' +
                        ' <md-icon md-font-icon="icon-border-color"></md-icon> ' +
                        ' <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip>' +
                        '</md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.delete(data)"> ' +
                        ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> ' +
                        ' <md-tooltip md-direction="left">{{"general.delete" | translate}}</md-tooltip> ' +
                        '</md-button> ' +
                        '</center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function loadEstablishmentClassTypes() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyEstablishmentClassType.me.list({
                'establishmentId': vm.establishment.id
            }, function (response) {
                vm.establishmentClassTypes = response;
                vm.classTypesGrid.api.setRowData(vm.establishmentClassTypes);
                vm.classTypesGrid.api.setColumnDefs(columnDefs);
                vm.isShowProgressLinear = false;
                vm.establishmentClassTypes.forEach(function (element) {
                    vm.classTypes.forEach(function (data, i) {
                        if (data.id === element.corporateClassificationTypeValues.corporateClassificationType.id) {
                            vm.classTypes.splice(i, 1);
                        }
                    });
                });
                if (vm.classTypes.length === 1) {
                    vm.classificationTypeId = vm.classTypes[0].id.toString();
                    vm.getClassficationValues();
                }
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.classTypesGrid = {
            rowSelection: 'multiple',
            rowDeselection: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.edit = function (data) {
            vm.cancelEdit();
            vm.establishmentClassType = angular.copy(data);
            vm.classTypes.push(vm.establishmentClassType.corporateClassificationTypeValues.corporateClassificationType);
            vm.classificationTypeId = data.corporateClassificationTypeValues.corporateClassificationType.id.toString();
            vm.getClassficationValues(vm.establishmentClassType.corporateClassificationTypeValues.id.toString());
        }

        vm.cancelEdit = function () {
            if (!vm.establishmentClassType.id) {
                return;
            }
            vm.classTypes.forEach(function (data, i) {
                if (data.id === vm.establishmentClassType.corporateClassificationTypeValues.corporateClassificationType.id) {
                    vm.classTypes.splice(i, 1);
                }
            });
            vm.classTypeValues = [];
            vm.establishmentClassType = {};
            vm.classificationTypeId = null;
        }

        vm.delete = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('company_establishment.classification.sure_delete'))
                .multiple(true)
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));
            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.CompanyEstablishmentClassType.me.delete({
                    'id': data.id
                }, function () {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('company_establishment.classification.deleted'));
                    init();
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogBankController', DialogBankController);

    /** @ngInject */
    function DialogBankController(api, $log, $rootScope, $filter, $mdDialog, MessageService, $timeout, establishment) {
        var vm = this;
        vm.establishment = establishment;

        vm.paginationBank = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        init();

        function init() {
            $timeout(function () {
                loadBank();
                vm.clearSearchBank = function () {
                    vm.searchBank = "";
                };

                $timeout(function () {

                    var keyEvent = function (event) {
                        event.stopPropagation();
                    };

                    var searchBankInput = document.querySelector("#searchBank");


                    if (searchBankInput) {
                        searchBankInput.addEventListener("keydown", keyEvent);
                    }
                }, 500);
            }, 500);
        }

        function loadBank() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Bank.byCountry.get({ "country": $rootScope.bsCircle.company.country.id }, function (response) {
                vm.banks = response;
                vm.isShowProgressLinear = false;
                loadCompanyEstablishmentBank();
            }, function (errResponse) {

            });
        }

        vm.saveBank = function () {
            vm.bankAccount.companyEstablishment = {
                id: vm.establishment.id
            };
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyEstablishmentBank.CompanyEstablishmentBank.create({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id
            },
                vm.bankAccount, function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('BANK.ADDED_SUCCESSFULLY'));
                    vm.bankAccount = {};
                    init();
                }, function (errResponse) {

                });
        };

        var columnDefsBank = [
            {
                field: "bank.name",
                headerName: 'BANK.BANK',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "isDefaultBank",
                headerName: 'BANK.ISDEFAULT',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    return "<div layout='row' layout-align='center center'> " +
                        " <md-icon ng-if='data.isDefaultBank' class='md-primary' md-font-icon='icon-check'></md-icon> " +
                        " <md-icon ng-if='!data.isDefaultBank' class='md-warn' md-font-icon='icon-close'></md-icon></div>";
                },
                width: 200,
                cellStyle: { 'align': 'center' }
            },
            {
                headerName: 'BANK.ACTIONS',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.deleteBank(data)'> " +
                        "<md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> " +
                        " <md-tooltip md-direction='left'>{{'general.delete' | translate}}</md-tooltip> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function loadCompanyEstablishmentBank() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyEstablishmentBank.CompanyEstablishmentBank.get({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id
            }, function (response) {
                vm.companyEstablishmentBanks = response;
                vm.gridBank.api.setRowData(vm.companyEstablishmentBanks);
                vm.gridBank.api.setColumnDefs(columnDefsBank);
                vm.isShowProgressLinear = false;
                vm.companyEstablishmentBanks.forEach(function (element) {
                    vm.banks.forEach(function (data, i) {
                        if (data.id === element.bank.id) {
                            vm.banks.splice(i, 1);
                        }
                    })
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.gridBank = {
            paginationPageSize: vm.paginationBank.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            cacheBlockSize: vm.paginationBank.pageSize,
            pagination: true,
            columnDefs: columnDefsBank,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.deleteBank = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('BANK.DELETE_BANK'))
                .textContent($filter('translate')('BANK.CONFIRMACION_DELETE_BANK'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.CompanyEstablishmentBank.CompanyEstablishmentBank.del({
                    "idCircle": $rootScope.bsCircle.id, 'id': data.id
                }, vm.bankAccount, function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('BANK.DELETED_SUCCESSFULLY'));
                    init();
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('dialogAccountingAccountController', dialogAccountingAccountController);

    /** @ngInject */
    function dialogAccountingAccountController(api, $log, $rootScope, $filter, $mdDialog, MessageService, $timeout, establishment) {
        var vm = this;
        vm.establishment = establishment;
        vm.establishmentAccountingAccounts = {};
        vm.companyAccount = {};
        vm.save = save;
        vm.delete = deleteAccountingAccount;
        vm.edit = edit;
        vm.cancelEdit = cancelEdit;
        vm.onOpenSelect = onOpenSelect;
        vm.cancel = cancel;
        vm.timeToTimeOut500 = 500;
        vm.conflictStatusResponse = 409;

        vm.accountingAccountColumnDefs = [
            {
                field: 'accountTypeCode',
                headerName: 'company_establishment.accountingAccount.accountTypeCode',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'accountTypeDescription',
                headerName: 'company_establishment.accountingAccount.accountTypeDescription',
                headerCellRenderer: getHeader,
                width: 250,
            },
            {
                field: 'accountingCatalogCode',
                headerName: 'company_establishment.accountingAccount.catalogCode',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'accountingCatalogDescription',
                headerName: 'company_establishment.accountingAccount.catalogDescription',
                headerCellRenderer: getHeader,
                width: 250,
            },
            {
                headerName: '',
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: optionsColumnCellRenderer,
                cellStyle: { 'padding': '2px' },
                pinned: 'right',
            },
        ];

        function optionsColumnCellRenderer() {
            return '<center> ' +
                '<md-button ng-disabled="vm.isShowProgressLinear" class="md-icon-button" ng-click="vm.edit(data)">' +
                ' <md-icon md-font-icon="icon-border-color"></md-icon> ' +
                ' <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip>' +
                '</md-button>' +
                '<md-button ng-disabled="vm.isShowProgressLinear" class="md-icon-button" ng-click="vm.delete(data)"> ' +
                ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> ' +
                ' <md-tooltip md-direction="left">{{"general.delete" | translate}}</md-tooltip> ' +
                '</md-button> ' +
                '</center>';
        }

        vm.accountingAccountGrid = {
            rowSelection: 'multiple',
            rowDeselection: true,
            columnDefs: vm.accountingAccountColumnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: getMainMenuItemsGrid,
            localeTextFunc: localeTextFuncGrid,
        };

        function getMainMenuItemsGrid(params) {
            return getHeaderMenu(params, $filter);
        }

        function localeTextFuncGrid(key, defaultValue) {
            return translateGrid(key, defaultValue, $filter);
        }


        init();

        function init() {
            $timeout(function () {
                loadAccountTypes();
                loadAccountingCatalogs();
                loadEstablishmentAccountingAccounts();
                vm.clearSearchAccountType = function () {
                    vm.searchAccountType = '';
                };
                vm.clearSearchAccountingCatalog = function () {
                    vm.searchAccountingCatalog = '';
                };
                $timeout(searchInpuntKeyEvent, vm.timeToTimeOut500);
            }, vm.timeToTimeOut500);
        }

        function searchInpuntKeyEvent() {
            let searchInput = document.querySelector('#searchAccountType');
            if (searchInput) {
                searchInput.addEventListener('keydown', stopPropagationKeyEvent);
            }
            searchInput = document.querySelector('#searchAccountingCatalog');
            if (searchInput) {
                searchInput.addEventListener('keydown', stopPropagationKeyEvent);
            }
        }

        function stopPropagationKeyEvent(event) {
            event.stopPropagation();
        }

        function loadAccountTypes() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Account.AccountType.me.list({ 'company': $rootScope.bsCircle.company.id }, function (response) {
                vm.accountTypes = response;
                vm.isShowProgressLinear = false;
            }, function () {
                vm.isShowProgressLinear = false;
            });
        }

        function loadAccountingCatalogs() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Account.AccountingCatalog.me.get({ 'company': $rootScope.bsCircle.company.id }, function (response) {
                vm.accountingCatalogs = response;
                vm.isShowProgressLinear = false;
            }, function () {
                vm.isShowProgressLinear = false;
            });
        }

        function loadEstablishmentAccountingAccounts() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Account.CompanyAccount.byEstablishment.get({ 'establishmentId': vm.establishment.id }, function (response) {
                vm.establishmentAccountingAccounts = response;
                vm.accountingAccountGrid.api.setRowData(vm.establishmentAccountingAccounts);
                vm.accountingAccountGrid.api.setColumnDefs(vm.accountingAccountColumnDefs);
                vm.isShowProgressLinear = false;
            }, function () {
                vm.isShowProgressLinear = false;
            });
        }

        function save() {
            let promise;
            if (vm.companyAccount.id) {
                promise = api.GeneralWS.Account.CompanyAccount.me.update({ id: vm.companyAccount.id }, vm.companyAccount).$promise;
            } else {
                vm.companyAccount.companyEstablishmentId = vm.establishment.id;
                vm.companyAccount.companyId = $rootScope.bsCircle.company.id;
                promise = api.GeneralWS.Account.CompanyAccount.me.create({}, vm.companyAccount).$promise;
            }
            vm.isShowProgressLinear = true;
            promise.then(function () {
                vm.isShowProgressLinear = false;
                let message = 'company_establishment.accountingAccount.added';
                if (vm.companyAccount.id) {
                    message = 'company_establishment.accountingAccount.updated';
                }
                MessageService.show($filter('translate')(message));
                vm.companyAccount = {};
                loadEstablishmentAccountingAccounts();
            }, function (response) {
                vm.isShowProgressLinear = false;
                let message = 'general.error';
                if (response.status === vm.conflictStatusResponse) {
                    message = 'company_establishment.accountingAccount.alreadyExist';
                }
                MessageService.showErrorMessage($filter('translate')(message));
            });
        }

        function deleteAccountingAccount(data) {
            $mdDialog.show(
                $mdDialog.confirm()
                    .title($filter('translate')('general.delete'))
                    .textContent($filter('translate')('company_establishment.accountingAccount.sure_delete'))
                    .multiple(true)
                    .ok($filter('translate')('general.si'))
                    .cancel($filter('translate')('general.no'))
            ).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.Account.CompanyAccount.me.delete({ 'id': data.id }, function () {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('company_establishment.accountingAccount.deleted'));
                    loadEstablishmentAccountingAccounts();
                }, function () {
                    vm.isShowProgressLinear = false;
                });
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        function edit(data) {
            vm.cancelEdit();
            vm.companyAccount = angular.copy(data);
        }


        function cancelEdit() {
            vm.companyAccount = {};
        }

        function onOpenSelect(id) {
            $timeout(function () {
                document.querySelector(id).focus();
            }, vm.timeToTimeOut500);
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.company')
    .controller('DialogChangeCodeEmployee', DialogChangeCodeEmployee);

  /** @ngInject */
  function DialogChangeCodeEmployee(api, $log, $rootScope, $mdDialog, $timeout, establishment, selectedUser, MessageService) {
    var vm = this;
    vm.cancel=cancel;
    vm.selectedUser = selectedUser ? selectedUser : {};
    vm.disableAssociateButton = false;
    vm.employeeArray = [];
    vm.getAllEmployeeByCompanyCode = getAllEmployeeByCompanyCode;
    vm.associateEmployeeToUser = associateEmployeeToUser;

    function getAllEmployeeByCompanyCode() {
      api.RecursosHumanosWS.Employee.byEmployeeCompanyCode.getList({
          'companyId': $rootScope.bsCircle.company.id, 'employeeCompanyCode': vm.inputSearchEmployeeCode
        },
        function (response) {
          vm.employeeArray = response;
          if (response.length === 1) {
            MessageService.show('company_establishment.employee_found');
          } else if (response.length > 1) {
            MessageService.showErrorMessage('company_establishment.error_exist_more_employee');
          } else {
            MessageService.showErrorMessage('company_establishment.error_not_exist_employee');
          }
        }, function (errResponse) {
          $log.error(errResponse);
        });
    }

    function associateEmployeeToUser() {
      vm.isShowProgressLinear = true;
      $timeout(function () {
        vm.disableAssociateButton = true;
        api.RecursosHumanosWS.Employee.doUpdateUserEmployee.doSetUser({
          'companyId': $rootScope.bsCircle.company.id,
          'employeeId': vm.employeeArray[0].employeeId,
          'userId': vm.selectedUser.userId
        }, function (responseEmployee) {
          if (responseEmployee.employeeId === vm.employeeArray[0].employeeId) {
            vm.selectedEmployee = vm.employeeArray[0];
          }
          MessageService.show('company_establishment.user_associated_to_employee_successfully');
          $mdDialog.hide(vm.changed);
          vm.isShowProgressLinear = false;
        }, function (errResponseEmployee) {
          if (errResponseEmployee && errResponseEmployee.data) {
            MessageService.showErrorMessage('company_establishment.' + errResponseEmployee.data.mensaje);
          }
          $log.error(errResponseEmployee);
          vm.disableAssociateButton = false;
          vm.isShowProgressLinear = false;
        });
      }, 100);
    }

    function cancel() {
      $mdDialog.hide(vm.changed);
    }


  }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogAddUserController', DialogAddUserController);

    /** @ngInject */
    function DialogAddUserController(api, $log, $rootScope, $mdDialog, $timeout, establishment, selectedUser, MessageService) {
        var vm = this;

        vm.establishment = establishment;
        vm.userArray = {};
        vm.selectUser = selectUser;
        vm.getAllUser = getAllUser;
        vm.currentTab = 1;
        vm.cancel = cancel;
        vm.getInfoByApp = getInfoByApp;
        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;
        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];
        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;
        vm.associate = associate;
        vm.disassociate = disassociate;
        vm.selectAllRoles = selectAllRoles;
        vm.selectAllUserRoles = selectAllUserRoles;
        vm.validateSelectAllRoles = validateSelectAllRoles;
        vm.validateSelectAllUserRoles = validateSelectAllUserRoles;
        vm.selectedUser = selectedUser ? selectedUser : {};
        vm.changed = false;
        vm.hideButton = false;
        vm.selectedEmployee = null;
        vm.inputSearchEmployeeCode = '';
        vm.employeeArray = [];
        vm.getAllEmployeeByCompanyCode = getAllEmployeeByCompanyCode;
        vm.associateEmployeeToUser = associateEmployeeToUser;
        vm.disableAssociateButton = false;
        vm.canAssociateWithoutEmployeeCode = false;
        vm.withoutEmployeeCode = false;

        if (selectedUser) {
            selectUser(selectedUser);
            vm.hideButton = true;
        }

        vm.pagination = {
            pageNumber: 1,
            pageSize: 15,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getAllUser();
            }
        };

        vm.paginationRole = {
            pageNumber: 0,
            pageSize: 15,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 0;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getRole();
            }
        };

        init();

        function init() {
            var contentHeight = $("#parametersProductList").innerHeight();
            contentHeight -= 212;
            vm.dinamicHeight = { "height": contentHeight + "px" };

            api.GeneralWS.CompanyApplication.me.query({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.applications = response;
            }, function (d) {
            });

            if (vm.selectedUser && vm.selectedUser.employeeCompanyCode) {
              vm.inputSearchEmployeeCode = vm.selectedUser.employeeCompanyCode;
              vm.selectedEmployee = {
                employeeId: vm.selectedUser.employeeId,
                fullName: vm.selectedUser.userName,
                userId: vm.selectedUser.userId
              };
              getAllEmployeeByCompanyCode();
            }

          verifyUserRoleCanAssociateWithoutEmployee();
        }

        function getAllUser() {
            api.GeneralWS.Usr.User.Company.me.page({
                'company': $rootScope.bsCircle.company.id, 'pageNumber': (vm.pagination.pageNumber), 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
            },
                function (response) {
                    vm.pagination.totalElements = response.totalElements;
                    vm.pagination.totalPages = response.totalPages;

                    vm.userArray = response;
                }, function (errResponse) {
                $log.error(errResponse);
                });
        }

        function getAllEmployeeByCompanyCode() {
            api.RecursosHumanosWS.Employee.byEmployeeCompanyCode.getList({
                'companyId': $rootScope.bsCircle.company.id, 'employeeCompanyCode': vm.inputSearchEmployeeCode
            },
              function (response) {
                vm.employeeArray = response;
                if (response.length === 1) {
                  MessageService.show('company_establishment.employee_found');
                } else if (response.length > 1) {
                  MessageService.showErrorMessage('company_establishment.error_exist_more_employee');
                } else {
                  MessageService.showErrorMessage('company_establishment.error_not_exist_employee');
                }
              }, function (errResponse) {
                $log.error(errResponse);
              });
        }

        function selectUser(usr) {
            vm.selectedUser = usr;
            if (vm.selectedUser.id) {
              vm.selectedUser.userId = usr.id;
            }
            vm.currentTab = 2;
            vm.appId = 0;
        }

        function cancel() {
            $mdDialog.hide(vm.changed);
        }

        function getInfoByApp() {

            vm.paginationUserRole.pageNumber = 0;
            vm.pagination.pageNumber = 1;

            vm.roleArray = [];
            vm.userRoleArray = [];

            getRole();
            getUserRole();
        }

        function getRole() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.notAssociatedToUser.page({
                'establishmentId': vm.establishment.id, 'idCircle': $rootScope.bsCircle.id,
                'appId': vm.appId, 'userId': vm.selectedUser.userId, 'pageNumber': (vm.pagination.pageNumber), 'pageSize': vm.pagination.pageSize
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.totalElements = response.totalElements;
                    vm.pagination.totalPages = response.totalPages;
                    vm.pagination.pageNumber = response.number + 1;
                    vm.roleArray = new jinqJs()
                        .from(response.content)
                        .where(function (r) {
                            return r.roleLevel >= $rootScope.bsCircle.role.roleLevel;
                        })
                        .select();

                    vm.isCheckAllRole = false;
                    vm.countRoleSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function getUserRole() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.associatedToUser.page({
                'establishmentId': vm.establishment.id, 'idCircle': $rootScope.bsCircle.id,
                'appId': vm.appId, 'userId': vm.selectedUser.userId, 'pageNumber': (vm.pagination.pageNumber), 'pageSize': vm.pagination.pageSize
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.paginationUserRole.totalElements = response.totalElements;
                    vm.paginationUserRole.totalPages = response.totalPages;
                    vm.paginationUserRole.pageNumber = response.number + 1;
                    vm.userRoleArray = new jinqJs()
                        .from(response.content)
                        .where(function (r) {
                            return r;
                        })
                        .select();

                    vm.isCheckAllUserRole = false;
                    vm.countUserRoleSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function associate() {

            var roleIdArray = [];

            if (!vm.isCheckAllRole) {
                vm.selectedArray.forEach(function (row) {
                    roleIdArray.push(row.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAllRole) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.byUser.create({
                'establishmentId': vm.establishment.id, 'associateAll': vm.isCheckAllRole, 'userId': vm.selectedUser.userId,
                'idCircle': $rootScope.bsCircle.id, 'appId': vm.appId, 'level': $rootScope.bsCircle.role.roleLevel
            }, roleIdArray)
                .$promise.then(function (response) {

                    vm.isShowProgressLinear = false;

                    vm.paginationUserRole.pageNumber = 0;
                    vm.changed = true;

                    vm.pagination.pageNumber = 0;
                    vm.selectedArray = [];
                    getInfoByApp();
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
            return true;
        }

        function disassociate() {

            var roleIdArray = [];

            if (!vm.isCheckAllUserRole) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    roleIdArray.push(row.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAllUserRole) {
                return null;
            }


            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.byUser.update({
                'companyId': $rootScope.bsCircle.company.id, 'deleteAll': vm.isCheckAllUserRole, 'userId': vm.selectedUser.userId,
                'establishmentId': vm.establishment.id, 'idCircle': $rootScope.bsCircle.id, 'appId': vm.appId, 'level': $rootScope.bsCircle.role.roleLevel
            }, roleIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.pageNumber = 0;

                    vm.paginationUserRole.pageNumber = 0;
                    vm.selectedAssociatedArray = [];
                    vm.changed = true;

                    getInfoByApp();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
            return true;
        }

        function selectAllRoles() {
            if (vm.isCheckAllRole) {
                vm.roleArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countRoleSelected = vm.roleArray.length;

            } else {
                vm.roleArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countRoleSelected = 0;
            }
        }

        function validateSelectAllUserRoles() {

            vm.countUserRoleSelected = 0;

            var isSelectAll = true;

            vm.userRoleArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserRoleSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserRole = true;
            } else {
                vm.isCheckAllUserRole = false;
            }

        }

        function selectAllUserRoles() {
            if (vm.isCheckAllUserRole) {
                vm.userRoleArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }
                });

                vm.countUserRoleSelected = vm.userRoleArray.length;

            } else {
                vm.userRoleArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserRoleSelected = 0;
            }
        }

        function validateSelectAllRoles() {

            vm.countRoleSelected = 0;

            var isSelectAll = true;

            vm.roleArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countRoleSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllRole = true;
            } else {
                vm.isCheckAllRole = false;
            }

        }

      function associateEmployeeToUser() {
        vm.isShowProgressLinear = true;
        $timeout(function () {
          vm.disableAssociateButton = true;
          api.RecursosHumanosWS.Employee.doUpdateUserEmployee.doSetUser({
            'companyId': $rootScope.bsCircle.company.id,
            'employeeId': vm.employeeArray[0].employeeId,
            'userId': vm.selectedUser.userId
          }, function (responseEmployee) {
            if (responseEmployee.employeeId === vm.employeeArray[0].employeeId) {
              vm.selectedEmployee = vm.employeeArray[0];
            }
            MessageService.show('company_establishment.user_associated_to_employee_successfully');
            vm.isShowProgressLinear = false;
          }, function (errResponseEmployee) {
            if (errResponseEmployee && errResponseEmployee.data) {
              MessageService.showErrorMessage('company_establishment.' + errResponseEmployee.data.mensaje);
            }
            $log.error(errResponseEmployee);
            vm.disableAssociateButton = false;
            vm.isShowProgressLinear = false;
          });
        }, 100);
      }

        $timeout(function () {

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 300;

            getAllUser();
            verifyExistEmployeeByUser();

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };

        }, 1000);

      function verifyExistEmployeeByUser() {
        api.RecursosHumanosWS.Employee.byUserId.getList({'companyId': 0, 'userId': vm.selectedUser.userId}, function (response) {
            if (response && response.userId) {
                vm.selectedEmployee = response;
            }
        }, function (err) {
          $log.error(err);
        });
      }

      function verifyUserRoleCanAssociateWithoutEmployee() {
        var exist = $rootScope.getEspecialActionByName('Asociar Usuario Sin Codigo de Empleado');
        if (exist) {
          vm.canAssociateWithoutEmployeeCode = true;
        }
      }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('AddressController', AddressController);

    /** @ngInject */
    function AddressController(api, $mdToast, $scope, $log, $rootScope, $filter, $state, $document, $mdDialog, envService, MessageService, address, $timeout) {
        var vm = this;

        //Data
        vm.establishment = {};
        vm.address = address ? address : {};

        // Methods
        vm.closeDialog = closeDialog;
        vm.loadCities = loadCities;
        vm.sendAddress = sendAddress;


        ////////

        init();
        /**
         * Initialize
         */
        function init() {
            loadStates();
        }

        function loadStates() {

            vm.loadingStates = true;
            var params = { 'id': 'byCountry', 'countryId': $rootScope.bsCircle.company.country.id };
            api.GeneralWS.State.me.query(params, function (data) {
                if (data.length === 1 && !address) {
                    vm.state = {
                        id: data[0].id.toString()
                    };
                }
                vm.states = data;
                loadCities();
                vm.loadingStates = false;
            });
        }
        function loadCities() {
            if (vm.state || address) {
                if (address && address.city && address.city.state) {
                    vm.state = { id: address.city.state.id.toString() };
                    vm.address.city = { id: address.city.id.toString() };
                } else {
                    vm.address.city = null;
                }
                vm.loadingCities = true;
                var params = { 'id': 'byState', 'stateId': vm.state.id };
                api.GeneralWS.City.me.query(params, function (data) {
                    if (data.length === 1 && !address) {
                        vm.address.city = {
                            id: data[0].id.toString()
                        };
                    }
                    vm.cities = data;
                    vm.loadingCities = false;
                });
            } else {
                vm.address.city = null;
            }
        }

        vm.clearSearchStates = function () {
            vm.searchState = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchStateInput = document.querySelector("#searchState");

            if (searchStateInput) {
                searchStateInput.addEventListener("keydown", keyEvent);
            }

        }, 500);


        ////To Address

        function closeDialog() {
            $mdDialog.cancel();
        }

        function sendAddress() {
            var city = _.find(vm.cities, function (city) {
                return city.id.toString() === vm.address.city.id.toString();
            });
            vm.address.city = city;
            $mdDialog.hide(vm.address);
        }

    }
})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('codeBagCollectionQueueController', codeBagCollectionQueueController);

    /**@ngInject**/
    function codeBagCollectionQueueController(api, $timeout, $log, $mdDialog, $filter, $state) {

        var vm = this;
        vm.search = search;
        vm.backTo = backTo;
        vm.name = $state.params.establishment ? $state.params.establishment.establishmentName : '';

        vm.bag = {
            companyEstablishment: {
                id: $state.params.id
            }
        }

        vm.pagination = {
            page: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "code",
                headerName: 'company_establishment.code',
                headerCellRenderer: getHeader,
                width: 550
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 190,
                cellRenderer: function (params) {
                    return '<center> ' +
                        '<md-button class="md-icon-button" ng-click="vm.delete(data)">' +
                        ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> ' +
                        '<md-tooltip md-direction="left">{{"company_establishment.delete"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        ' </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {
            vm.isShowProgressLinear = true;

            vm.grid.api.setColumnDefs(columnDefs);

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.PosAdminWS.Bag.Bag.page({
                        'establishmentId': $state.params.id, 'pageNumber': vm.pagination.page, 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;

                            vm.content = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select();

                            params.successCallback(vm.content, response.totalElements);
                            vm.showGrid = true;
                            vm.isShowProgressLinear = false;

                        }, function (responseErr) {
                            $log.error(responseErr);
                            vm.isShowProgressLinear = false
                        });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);
        }

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        function init() {
            createNewDatasource();
        }

        $timeout(function () {
            init();
        }, 1000);

        vm.addNewCode = function () {
            $mdDialog.show({
                controller: 'dialogGenerateCodeBagController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/codeBagCollectionQueue/dialogGenerate/dialogGenerateCodeBag.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'establishmentId': $state.params.id
                },
                multiple: true
            }).then(function (code) {
                init();
            }, function (errcode) {
                $log.debug(errcode);
            });
        }

        vm.delete = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('company_establishment.delete'))
                .textContent($filter('translate')('company_establishment.confirm_delete'))
                .ok($filter('translate')('BLOCKEDSERIES.SI'))
                .cancel($filter('translate')('BLOCKEDSERIES.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                api.PosAdminWS.Bag.Bag.delete({ 'id': data.id, 'establishmentId': $state.params.id }, function (response) {
                    init();
                }, function (errDelete) {
                    $log.debug(errDelete);
                })
            }, function (errDialog) {
                $log.debug(errDialog);
            });
        }

        vm.exportXLS = function () {
            const params = {
                skipHeader: false,
                skipFooters: false,
                skipGroups: false,
                allColumns: true,
                onlySelected: false,
                onlySelectedAllPages: false,
                fileName: 'CodeBag' + new Date().getTime() + '.xls',
                columnSeparator: ',',
                sheetName: 'data'
            };
            params.processHeaderCallback = function (paramsData) {
                return $filter('translate')(paramsData.column.getColDef().headerName);
            };

            vm.grid.api.exportDataAsExcel(params);
        };

        function backTo() {
            $state.go('app.company.establishment');
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('InvoiceSerieAdminDialogController', InvoiceSerieDialogController);

    /** @ngInject */
    function InvoiceSerieDialogController($mdDialog, api, $rootScope, $log, MessageService, $filter, data, $timeout) {
        var vm = this;
        vm.baseUrlFiles = api.baseUrlFiles;
        var companyRoot = $rootScope.bsCircle.company;
        vm.company = angular.copy(companyRoot);
        vm.establishment = data ? data.establishmentCashier.companyEstablishment : {};
        vm.establishmentCashier = data ? data.establishmentCashier: {};
        vm.cashierInvoiceSerie = data ? data : {};
        vm.searchEstablishment = '';

        vm.invoiceSerie = data ? data.invoiceSerie : {};
        vm.gFaces = [];
        vm.loadEstablishmentCashiers = loadEstablishmentCashiersClick;

        function verifySeries() {
            if (vm.invoiceSerie.invoiceSerieType) {
                for (var i = 0; i < vm.invoiceSerieTypes.length; i++) {
                    if (vm.invoiceSerieTypes[i].id === vm.invoiceSerie.invoiceSerieType.id) {
                        vm.invoiceSerie.invoiceSerieType = vm.invoiceSerieTypes[i];
                        if (vm.invoiceSerie.invoiceSerieType.isElectronic) {
                            getGfaces();
                        }
                    }
                }
            }
            if (!vm.invoiceSerie.id && vm.invoiceSerieTypes.length === 1) {
              vm.invoiceSerie.invoiceSerieType = vm.invoiceSerieTypes[0];
              if (vm.invoiceSerie.invoiceSerieType.isElectronic) {
                getGfaces();
              }
            }
        }

        vm.invoiceSerieDocumentTypes = [];
        getInvoiceSeriesDocumentCountryList();

        function getInvoiceSeriesDocumentCountryList() {
            api.GeneralWS.InvoiceSeriesDocumentCountry.getList.getByCountry({ countryId: vm.company.country.id }).$promise.then(function (response) {
                vm.invoiceSerieDocumentTypes = response;
                if (!vm.invoiceSerie.id && response.length === 1) {
                    vm.invoiceSerie.invoiceSerieDocumentType = vm.invoiceSerieDocumentTypes[0].invoiceSeriesDocumentTypeId;
                }
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

      vm.invoiceSerieDocumentTypesCancel = [
        'CREDIT_NOTE',
        'GLOBAL_CREDITNOTE',
        'CREDIT_NOTE_TICKET',
        'CREDIT_NOTE_CREDIT_FISCAL',
        'ANNULMENT',
      ];
        vm.setFile = data && data.invoiceSerie.fileStorage ? false : true;
        if (data && (data.invoiceSerie.fileStorage && (data.invoiceSerie.fileStorage.extension === '.jpg' || data.invoiceSerie.fileStorage.extension === '.png' || data.invoiceSerie.fileStorage.extension === '.JPG' || data.invoiceSerie.fileStorage.extension === '.PNG'))) {
            var ft = {
                url: getPhoto(null, data.invoiceSerie.fileStorage),
                type: 'image',
                original: data.invoiceSerie.fileStorage,
                extension: data.invoiceSerie.fileStorage.extension
            };
            vm.image = ft;
            updateImageZoomOptions(vm.image);
        }

        vm.minDate = new Date();

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        vm.updateImageZoomOptions = updateImageZoomOptions;
        vm.validateCorrelativeRange = validateCorrelativeRange;
        vm.getGfaces = getGfaces;

        function getFormData(file) {
            var fd = new FormData();
            fd.append('files', file);
            return fd;
        }

        function save() {

            if (vm.theForm.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }

            if (!vm.invoiceSerie.fileStorage) {
                if (vm.filesToUpload.length <= 0) {
                    MessageService.showErrorMessage($filter('translate')('COMPANY.NO_FILES'));
                    return false;
                }
            }
            vm.isShowProgressLinear = true;
            var newInvoiceSerie = {
                id: vm.invoiceSerie.id ? vm.invoiceSerie.id : 0,
                authorizationDate: vm.invoiceSerie.id ? vm.invoiceSerie.authorizationDate : vm.invoiceSerie.authorizationDate.getTime(),
                company: null,
                companyEstablishment: null,
                serie: vm.invoiceSerie.serie,
                initialNumber: vm.invoiceSerie.initialNumber,
                lastNumber: vm.invoiceSerie.lastNumber,
                resolution: vm.invoiceSerie.resolution,
                electronicInvoice: vm.invoiceSerie.invoiceSerieType.isElectronic,
                dueDate: vm.invoiceSerie.invoiceSerieType.isElectronic && !vm.invoiceSerie.invoiceSerieType.endDateByInvoiceElectronic ?
                  new Date('12/31/2099').getTime() : (vm.invoiceSerie.id ? vm.invoiceSerie.dueDate : vm.invoiceSerie.dueDate.getTime()),
                active: vm.invoiceSerie.id ? vm.invoiceSerie.active : true,
                invoiceSerieType: vm.invoiceSerie.invoiceSerieType,
                invoiceSerieDocumentType: vm.invoiceSerie.invoiceSerieDocumentType,
                gFace: vm.invoiceSerie.gFace,
                printDocument: vm.invoiceSerie.printDocument,
                printFormatDocument:  vm.invoiceSerie.printFormatDocument,
                onlyCancelInMonth: vm.invoiceSerie.onlyCancelInMonth,
                creditNotePartial: vm.invoiceSerie.creditNotePartial,
                daysToCancel: vm.invoiceSerie.daysToCancel,
                amountBaseToRequestCustomerIdentifier: vm.invoiceSerie.amountBaseToRequestCustomerIdentifier,
                invoiceSerieDocumentTypeCancel: vm.invoiceSerie.invoiceSerieDocumentTypeCancel,
            };

            !vm.establishment ? newInvoiceSerie.company = { id: vm.company.id } : newInvoiceSerie.companyEstablishment = { id: vm.establishment.id };

            if (vm.filesToUpload && vm.filesToUpload.length > 0) {
                var typeFile = vm.filesToUpload[0].file.file.type.split('/');
                if (!typeFile || typeFile.length === 0) {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    return null;
                }
                var params = { id: 'CompanySerieAndCorrelative', invoiceSerieId: vm.invoiceSerie.id, companyId: null, establishmentId: null, serie: vm.invoiceSerie.serie, initialNumber: vm.invoiceSerie.initialNumber, lastNumber: vm.invoiceSerie.lastNumber };
                !vm.establishment ? params.companyId = vm.company.id : params.establishmentId = vm.establishment.id;
                api.GeneralWS.InvoiceSerie.getByCompanySerieAndCorrelative(params).$promise.then(function (data) {
                    var fd = getFormData(vm.filesToUpload[0].file.file);
                    var fileNameString = "invoiceSerie-" + vm.invoiceSerie.serie + "-" + vm.company.id;
                    var isImage = (typeFile[1] === 'jpg' || typeFile[1] === 'JPG' || typeFile[1] === 'png' || typeFile[1] === 'PNG' || typeFile[1] === 'jpeg' || typeFile[1] === 'JPEG') ? true : false;
                    api.GeneralWS.FileStorage.me.save({ id: 'uploadFileOrImage', fileName: fileNameString, isImage: isImage }, fd).$promise.then(function (response) {
                        newInvoiceSerie.fileStorage = { id: response[0].id };

                      $timeout(function () {
                        saveInvoiceSerie(newInvoiceSerie);
                      }, 800);

                    }, function (errResponse) {
                        vm.isShowProgressLinear = false;
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    });
                }, function (errResponse) {
                    vm.isShowProgressLinear = false;
                    MessageService.showErrorMessage(errResponse.data.mensaje);
                });
            } else {
                newInvoiceSerie.fileStorage = { id: vm.invoiceSerie.fileStorage.id };
              $timeout(function () {
                saveInvoiceSerie(newInvoiceSerie);
              }, 800);
            }
            return true;
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function saveInvoiceSerie(newInvoiceSerie) {
            var promise;
          var cashierInvoiceSerieSave = {
            id: vm.cashierInvoiceSerie && vm.cashierInvoiceSerie.id ? vm.cashierInvoiceSerie.id : null,
            active: vm.cashierInvoiceSerie.id ? vm.cashierInvoiceSerie.active : true,
            invoiceSerie: newInvoiceSerie,
            establishmentCashier: {
              id: vm.establishmentCashier.id,
              companyEstablishment: {
                id: vm.establishment.id
              }
            }
          };
            if (!vm.cashierInvoiceSerie.id) {
              promise = api.PosAdminWS.CashierInvoiceSerie.saveAndAssociated.save({'idC': $rootScope.bsCircle.id}, cashierInvoiceSerieSave).$promise;
            } else {

              promise = api.PosAdminWS.CashierInvoiceSerie.updateAndAssociated.upd({
                'id': vm.cashierInvoiceSerie.id,
                'idC': $rootScope.bsCircle.id
              }, cashierInvoiceSerieSave).$promise;
            }
            promise.then(
                function (invoiceSerie) {

                    MessageService.show($filter('translate')(!vm.invoiceSerie.id ? 'COMPANY.SERIE_CREATED' : 'COMPANY.SERIE_UPDATED'));
                    vm.invoiceSerie = {};
                    $mdDialog.hide(invoiceSerie);
                },
                function (errResponse) {
                  if(errResponse.data && errResponse.data.mensaje){
                    MessageService.showErrorMessage(errResponse.data.mensaje);
                  } else {
                    MessageService.showErrorMessage('SERIES.' + errResponse.data);
                  }
                  vm.isShowProgressLinear = false;
                }
            );
        }

        function getPhoto(url, ph) {
            if (ph) {
                url = ph.parentPath + ph.name;
            }
            if (url) {
                return vm.baseUrlFiles + url;
            }
            return 'assets/images/etc/thumbPhoto';
        }

        /**
         * Update image zoom options
         *
         * @param img
         */
        function updateImageZoomOptions(img) {
            var url = img.url;
            var extension = img.extension;
            vm.imageZoomOptions = {
                images: [
                    {
                        thumb: url + 's' + extension,
                        medium: url + 'm' + extension,
                        large: url + 'l' + extension
                    }
                ]
            };
        }

        function validateCorrelativeRange(isInitialNumber) {
            if (isInitialNumber === true && vm.invoiceSerie.lastNumber && vm.invoiceSerie.initialNumber) {
                vm.invoiceSerie.lastNumber = vm.invoiceSerie.lastNumber > vm.invoiceSerie.initialNumber ? vm.invoiceSerie.lastNumber : null;
            } else if (isInitialNumber === false && vm.invoiceSerie.lastNumber && vm.invoiceSerie.initialNumber) {
                vm.invoiceSerie.initialNumber = vm.invoiceSerie.initialNumber < vm.invoiceSerie.lastNumber ? vm.invoiceSerie.initialNumber : null;
            }
        }

        function getGfaces() {
            api.GeneralWS.GFace.GFace.getAll({ 'companyId': $rootScope.bsCircle.company.id }, function (response) {
                vm.gFaces = response;
                if (vm.invoiceSerie.gFace) {
                    vm.gFaces.forEach(function (data) {
                        if (vm.invoiceSerie.gFace.id === data.id) {
                            vm.invoiceSerie.gFace = data;
                        }
                    });
                }
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        function  getInvoiceSeriesType() {
          api.GeneralWS.InvoiceSerieType.active.get({ country: $rootScope.bsCircle.company.country.id }).$promise.then(function (response) {
            vm.invoiceSerieTypes = response;
            verifySeries();
          }, function (errResponse) {
            $log.debug(errResponse);
          });
        }

      function getCompanyEstablishments() {
        api.GeneralWS.CompanyEstablishment.findAllByCompany.query({'idCircle': $rootScope.bsCircle.id}, function (response) {
          vm.establishmentList = response.sort(function (a, b) {
            if (a.establishmentName > b.establishmentName) {
              return 1;
            }
            if (b.establishmentName > a.establishmentName) {
              return -1;
            }
            return 0;
          });
        }, function () {
        });
       vm.printDocument = vm.invoiceSerie.printDocument;
        if (vm.invoiceSerie.printDocument == null) {
          vm.invoiceSerie.printDocument = true;
        } else {
          if (vm.printDocument === false) {
            vm.invoiceSerie.printDocument = false;
          } else {
            vm.invoiceSerie.printDocument = true;
          }

        }

        vm.partitialCreditNote = vm.invoiceSerie.creditNotePartial;
        if (vm.invoiceSerie.creditNotePartial == null) {
          vm.invoiceSerie.creditNotePartial = true;
        } else {
          vm.invoiceSerie.creditNotePartial = vm.partitialCreditNote;
        }

        vm.amountBaseCustomerIdentifer = vm.invoiceSerie.amountBaseToRequestCustomerIdentifier;
        if (vm.invoiceSerie.amountBaseToRequestCustomerIdentifier == null) {
          vm.invoiceSerie.amountBaseToRequestCustomerIdentifier = 0;
        } else {
          vm.invoiceSerie.amountBaseToRequestCustomerIdentifier = vm.amountBaseCustomerIdentifer;
        }
        vm.daysCancel = vm.invoiceSerie.daysToCancel;
        if (vm.invoiceSerie.daysToCancel == null) {
          vm.invoiceSerie.daysToCancel = 0;
        } else {
          vm.invoiceSerie.daysToCancel = vm.daysCancel;
        }

      }

      function loadEstablishmentCashiers() {
        api.PosAdminWS.EstablishmentCashier.byEstablishment.query({'establishmentId': vm.establishment.id}, function (response) {
          vm.establishmentCashierList = [];
          response.forEach(function (dataCashier) {
            if (dataCashier.isServer === false) {
              vm.establishmentCashierList.push(dataCashier);
            }
        });
        }, function (err) {
        });
      }

      function loadEstablishmentCashiersClick(){
        vm.establishmentCashier = {};
        loadEstablishmentCashiers();
      }

      $timeout(function () {
        if (vm.establishment.id) {
          loadEstablishmentCashiers();
        }
        getInvoiceSeriesType();

        getCompanyEstablishments();
      }, 200);

    }
})();

(function () {

    'use strict';

    angular
        .module('app.account', [])
        .config(config);


    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/account/');

        $stateProvider
            .state('app.account', {
                url: '/account',
                abstract: true
            })
            .state('app.account.costcenter', {
                url: '/cost-center',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/cost-center/cost-center-list/cost-center-list.html',
                        controller: 'CostCenterListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.department', {
                url: '/department',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/department/department-list/department-list.html',
                        controller: 'DepartmentListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.expensetype', {
                url: '/expense-type',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/expense-type/expense-type-list/expense-type-list.html',
                        controller: 'ExpenseTypeListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.accountingcatalog', {
                url: '/accounting-catalog',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/accounting-catalog/accounting-catalog-list/accounting-catalog-list.html',
                        controller: 'AccountingCatalogListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.projects', {
                url: '/projects',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/projects/projects-list/projects-list.html',
                        controller: 'ProjectsListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.accounttype', {
                url: '/account-type',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/account-type/account-type-list/account-type-list.html',
                        controller: 'AccountTypeListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.accountingEntryConfig', {
                url: '/AccountingEntryConfig',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/accounting-entry/accounting-entry-config-list/accounting-entry-config-list.html',
                        controller: 'AccountingEntryConfigListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.accountingEntryConfig.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/accounting-entry/accounting-entry-config-detail/accounting-entry-config-detail.html',
                        controller: 'AccountingEntryConfigDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    backTo: null
                }
            })
            .state('app.account.department.departmentTicketsGroupAssignConfig', {
                url: '/ConfigAssign/:departmentGroupId/:departmentId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/department/department-tickets-group/department-ticket-group-assign-config/department-ticket-group-assign-config.html',
                        controller: 'TicketsDepartmentGroupgAssignConfigController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    backTo: null
                }
            })
            .state('app.account.department.departmentTicketsGroupAssignConfig.detail', {
                url: '/userAssign/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/department/department-tickets-group/department-ticket-group-assign-config/group-assign-detail/group-assign-detail.html',
                        controller: 'GroupgAssignConfigDetailController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    backTo: null
                }
            })
            .state('app.account.accountingItemsReport', {
                url: '/accounting-itemsReport',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/accounting-item-report/accounting-item-report-list/accounting-itemReport-list.html',
                        controller: 'AccountingItemReportController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.dimensions', {
                url: '/dimensions',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/dimensions/dimensions-company-list/dimensions-company-list.html',
                        controller: 'DimensionsCompanyListController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.account.dimensions.detail', {
                url: '/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/dimensions/dimension-company-detail-list/dimension-company-detail-list.html',
                        controller: 'DimensionCompanyDetailListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    dimensionName: null
                }
            })
            .state('app.account.postingPeriod', {
                url: 'postingPeriod',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/posting-period/posting-period-list/posting-period-list.html',
                        controller: 'PostingPeriodListController',
                        controllerAs: 'vm',
                    },
                },
            })
            .state('app.account.rolDimensionDefault', {
                url: 'rolDimensionDefault',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/account/rol-dimension-default/dimension-default/dimension-default.html',
                        controller: 'RolDimensionDefaultController',
                        controllerAs: 'vm',
                    },
                }
            });
    }


})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('DimensionCompanyDetailEditController', DimensionCompanyDetailEditController);

    /**@ngInject**/
    function DimensionCompanyDetailEditController(api, MessageService, $log, dimensionCompanyId, $filter, $mdDialog, $rootScope, dimensionDetail) {

        var vm = this;

        vm.dimensionCompanyId = dimensionCompanyId;
        vm.accountingEntryTypes = [];
        vm.dimensionDetail = dimensionDetail ? dimensionDetail : { 'dimensionCompanyId': vm.dimensionCompanyId };

        vm.dinamicStyle = {
            'width': '350px',
            'height': '350px'
        };

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (vm.dimensionDetailForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.dimensionDetail.id) {
                promise = api.GeneralWS.Account.DimensionCompanyDetail.me.update(
                    { 'id': vm.dimensionDetail.id }
                    , vm.dimensionDetail).$promise;
            } else {
                promise = api.GeneralWS.Account.DimensionCompanyDetail.me.create(
                    { }
                    , vm.dimensionDetail).$promise;
            }
            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                $mdDialog.hide(response);
            }, function (response) {
                vm.isShowProgressLinear = false;

                if (response.status === 409) {
                    MessageService.showErrorMessage($filter('translate')('dimensions.codeAlreadyExist'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('DialogDepartmentRelatedController', DialogDepartmentRelatedController);

    function DialogDepartmentRelatedController($log, $mdDialog, api, MessageService, $filter, data, $rootScope, $timeout) {
        var vm = this;
        vm.isShowProgressLinear = true;
        vm.oneSelectedDay = false;
        vm.indexView = 0;
        vm.showGrid = false;
        vm.pageSize = 50;
        vm.pageNumber = 1;
        vm.dinamicHeightDialog = { 'height': '70%' };
        vm.inputSearchDepartment = "";
        vm.inputSearchRelatedDepartment = "";
        vm.pagination = {
            pageNumber: 1,
            pageSize: 20,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getDepartmentsByCompany();
            }
        };
        vm.paginationRelatedDepartment = {
            pageNumber: 1,
            pageSize: 20,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getDepartmentsRelated();
            }
        };
        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];
        vm.countDepartmentSelected = 0;
        vm.countRelatedDepartmentSelected = 0;

        vm.cancel = cancel;
        vm.getDepartmentsByCompany = getDepartmentsByCompany;
        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;
        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;
        vm.associate = associate;
        vm.disassociate = disassociate;
        vm.validateSelectAllDepartments = validateSelectAllDepartments;
        vm.validateSelectAllRelatedDepartments = validateSelectAllRelatedDepartments;
        vm.selectAllDepartments = selectAllDepartments;
        vm.selectAllRelatedDepartments = selectAllRelatedDepartments;
        vm.searchRelatedDepartment = searchRelatedDepartment;
        vm.searchDepartment = searchDepartment;

        init();

        function init() {
            vm.isShowProgressLinear = false;
            vm.totalS = $(window).innerHeight();
            vm.dinamicHeightDialog = { 'height': '85%', 'min-height': '85%', 'max-width': '75%', 'width': '75%' };
            if (vm.totalS < 700) {
                vm.dinamicHeightDialog = { 'max-height': '98%', 'height': '98%', 'max-width': '75%', 'width': '75%' };
            } else if (vm.totalS > 800) {
                vm.dinamicHeightDialog = { 'max-height': '75%', 'height': '75%', 'width': '70%', 'min-width': '70%' };
            }

            $timeout(function () {
                var mdDialog = $("#department-related");
                var windowHeight = parseInt(mdDialog.innerHeight());

                windowHeight -= 325;

                vm.dinamicHeight = {
                    "height": windowHeight + "px"
                };
            }, 400);

            getCompaniesByCorporate();
        }

        function cancel() {
            if (vm.indexView === 1) {
                vm.indexView = 0;
            } else {
                $mdDialog.cancel();
            }
        }

        function getCompaniesByCorporate() {
            api.GeneralWS.CorporateMembers.byCompanyMember.get(
                { 'idCompany': $rootScope.bsCircle.company.id }
            ).$promise.then(function (response) {
                vm.companyArray = new jinqJs()
                    .from(response)
                    .select(function (r) {
                        return r.company;
                    });
                if (vm.companyArray.length === 0) {
                    vm.companyArray = [];
                    vm.companyArray.push($rootScope.bsCircle.company);
                }
            }, function (err) {
                $log.debug(err)
            });
        }

        function getDepartmentsRelated() {
            vm.loadAssociated = true;
            api.GeneralWS.DepartmentRelated.byDepartment.get({
                'companyId': vm.companySelected.id,
                'departmentId': data.id, 'page': vm.paginationRelatedDepartment.pageNumber,
                'pageSize': vm.paginationRelatedDepartment.pageSize, 'search': vm.inputSearchRelatedDepartment.toString().toLowerCase()
            }).$promise.then(function (response) {
                vm.departmentsRelatedArray = new jinqJs()
                    .from(response.content)
                    .select(function (r) {
                        return r.relatedDepartment;
                    });
                vm.loadAssociated = false;
                vm.paginationRelatedDepartment.totalElements = response.totalElements;
                vm.paginationRelatedDepartment.totalPages = response.totalPages;
                vm.countRelatedDepartmentSelected = 0;
            }, function (err) {
                $log.debug(err);
                vm.loadAssociated = false;
            });
        }

        function getDepartmentsByCompany() {
            vm.load = true;
            api.GeneralWS.DepartmentRelated.byNotDepartment.page({
                'companyId': vm.companySelected.id, 'departmentId': data.id,
                'page': vm.pagination.pageNumber,
                'pageSize': vm.pagination.pageSize, 'search': vm.inputSearchDepartment.toString().toLowerCase()
            }).$promise.then(function (response) {
                vm.departmentArray = new jinqJs()
                    .from(response.content)
                    .where(function (row) {
                        return data.id !== row.id;
                    })
                    .select(function (r) {
                        return r;
                    });
                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.load = false;
                getDepartmentsRelated();
            }, function (err) {
                $log.debug(err);
                vm.load = false;
            })
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function associate() {

            var departmentIdArray = [];

            if (!vm.isCheckAllDepartment) {
                vm.selectedArray.forEach(function (row) {
                    departmentIdArray.push(row.id);
                });
            }

            if (departmentIdArray.length === 0 && !vm.isCheckAllDepartment) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.DepartmentRelated.DepartmentRelated.create({
                'associateAll': vm.isCheckAllDepartments, 'departmentId': data.id,
                'companyId': vm.companySelected.id,
                'search': vm.inputSearchDepartment
            }, departmentIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    getDepartmentsRelated();
                    vm.countRelatedDepartmentSelected = 0;

                    if (vm.paginationRelatedDepartment.totalPages === 0) {
                        vm.paginationRelatedDepartment.pageNumber = 1;
                    } else {
                        vm.paginationRelatedDepartment.pageNumber = vm.paginationRelatedDepartment.totalPages;
                    }
                    vm.inputSearchRelatedDepartment = "";
                    vm.isCheckAllRelatedDepartment = false;
                    vm.selectedAssociatedArray = [];


                    vm.pagination.pageNumber = 1;
                    vm.isCheckAllDepartments = false;
                    vm.inputSearchDepartment = "";
                    vm.selectedArray = [];
                    getDepartmentsByCompany();
                    MessageService.show($filter('translate')('department.associated_successfully'));

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });

        }

        function disassociate() {

            var departmentIdArray = [];

            if (!vm.isCheckAllRelatedDepartment) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    departmentIdArray.push(row.id);
                });
            }

            if (departmentIdArray.length === 0 && !vm.isCheckAllRelatedDepartment) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.DepartmentRelated.DepartmentRelated.update({
                'associateAll': vm.isCheckAllRelatedDepartment, 'departmentId': data.id,
                'companyId': vm.companySelected.id,
                'search': vm.inputSearchRelatedDepartment
            }, departmentIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.pageNumber = 1;
                    vm.inputSearchDepartment = "";
                    vm.isCheckAllDepartment = false;
                    getDepartmentsByCompany();

                    vm.paginationRelatedDepartment.pageNumber = 1;
                    vm.inputSearchRelatedDepartment = "";
                    vm.isCheckAllRelatedDepartment = false;
                    vm.selectedAssociatedArray = [];

                    getDepartmentsRelated();
                    MessageService.show($filter('translate')('department.disassociated_successfully'));

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });

        }

        function selectAllRelatedDepartments() {
            if (vm.isCheckAllRelatedDepartment) {
                vm.departmentsRelatedArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }

                });

                vm.countRelatedDepartmentSelected = vm.departmentsRelatedArray.length;

            } else {
                vm.departmentsRelatedArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countRelatedDepartmentSelected = 0;
            }
        }

        function validateSelectAllRelatedDepartments() {

            vm.countRelatedDepartmentSelected = 0;

            var isSelectAll = true;

            vm.departmentsRelatedArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countRelatedDepartmentSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllRelatedDepartment = true;
            } else {
                vm.isCheckAllRelatedDepartment = false;
            }

        }

        function selectAllDepartments() {
            if (vm.isCheckAllDepartments) {
                vm.departmentArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countDepartmentSelected = vm.departmentArray.length;

            } else {
                vm.departmentArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countDepartmentSelected = 0;
            }
        }

        function validateSelectAllDepartments() {

            vm.countDepartmentSelected = 0;

            var isSelectAll = true;

            vm.departmentArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countDepartmentSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllDepartments = true;
            } else {
                vm.isCheckAllDepartments = false;
            }

        }

        function searchDepartment() {
            vm.pagination.pageNumber = 1;
            getDepartmentsByCompany();
        }

        function searchRelatedDepartment() {
            vm.paginationRelatedDepartment.pageNumber = 1;
            getDepartmentsRelated()
        }

    }
})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('DepartmentProductController', DepartmentController);

    function DepartmentController($rootScope, $timeout, api, $log, $mdDialog, department) {
        var vm = this;
        vm.department = department;
        vm.productPagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getNotAssociatedProductToDepartment();
            }
        };

        vm.productTypes = [
            { value: false, description: 'Para Compra No Urgente' },
            { value: true, description: 'Para Compra Urgente' }
        ];

        vm.productType = { value: false };

        vm.associatedProductPagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getAssociatedProductToDepartment();
            }
        };

        vm.productSelectedArray = [];
        vm.productAssociatedSelectedArray = [];

        vm.closeDialog = closeDialog;
        vm.searchProduct = searchProduct;
        vm.toggleProduct = toggleProduct;
        vm.isSelectedProduct = isSelectedProduct;
        vm.associate = associate;
        vm.searchAssociatedProduct = searchAssociatedProduct;
        vm.toggleAssociatedProduct = toggleAssociatedProduct;
        vm.isSelectedAssociatedProduct = isSelectedAssociatedProduct;
        vm.disassociate = disassociate;
        vm.getAssociatedProductToDepartment = getAssociatedProductToDepartment;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function searchProduct() {
            if (vm.searchProductInput === undefined || vm.searchProductInput === null) {
                return null;
            }

            vm.productPagination.pageNumber = 1;
            getNotAssociatedProductToDepartment();
        }

        function searchAssociatedProduct() {
            if (vm.searchAssociatedProductInput === undefined || vm.searchAssociatedProductInput === null) {
                return null;
            }

            vm.associatedProductPagination.pageNumber = 1;
            getAssociatedProductToDepartment();
        }

        function getNotAssociatedProductToDepartment() {
            vm.loadProducts = true;
            api.GeneralWS.ProductAccount.notAssociatedToDepartment.page({
                'companyId': $rootScope.bsCircle.company.id, 'departmentId': department.id,
                'pageNumber': vm.productPagination.pageNumber, 'pageSize': vm.productPagination.pageSize, 'search': vm.searchProductInput
            })
                .$promise.then(function (response) {
                    vm.loadProducts = false;
                    vm.productArray = response.content;
                    vm.productPagination.totalElements = response.totalElements;
                    vm.productPagination.totalPages = response.totalPages;
                    vm.productPagination.numberOfElements = response.numberOfElements;
                }, function (response) {
                    vm.loadProducts = false;
                    $log.error(response);
                });
        }

        function toggleAssociatedProduct(departmentProduct, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.productAssociatedSelectedArray.indexOf(departmentProduct) > -1) {
                vm.productAssociatedSelectedArray.splice(vm.productAssociatedSelectedArray.indexOf(departmentProduct), 1);
            } else {
                vm.productAssociatedSelectedArray.push(departmentProduct);
            }
        }

        function toggleProduct(product, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.productSelectedArray.indexOf(product) > -1) {
                vm.productSelectedArray.splice(vm.productSelectedArray.indexOf(product), 1);
            } else {
                vm.productSelectedArray.push(product);
            }
        }

        function isSelectedProduct(product) {
            return vm.productSelectedArray.indexOf(product) > -1;
        }

        function isSelectedAssociatedProduct(departmentProduct) {
            return vm.productAssociatedSelectedArray.indexOf(departmentProduct) > -1;
        }

        function getAssociatedProductToDepartment() {
            vm.loadAssociatedProducts = true;
            api.GeneralWS.Account.DepartmentProduct.me.page({
                'circleId': $rootScope.bsCircle.id, 'departmentId': department.id, 'pageNumber': vm.associatedProductPagination.pageNumber,
                'pageSize': vm.associatedProductPagination.pageSize, 'search': vm.searchAssociatedProductInput, 'productType': vm.productType.value
            })
                .$promise.then(function (response) {
                    vm.loadAssociatedProducts = false;
                    vm.associatedProductArray = response.content;
                    vm.associatedProductPagination.totalElements = response.totalElements;
                    vm.associatedProductPagination.totalPages = response.totalPages;
                    vm.associatedProductPagination.numberOfElements = response.numberOfElements;
                }, function (response) {
                    vm.loadAssociatedProducts = false;
                });
        }

        function associate() {
            vm.isShowProgressLinear = true;

            var _departmentProductArray = [];

            vm.productSelectedArray.forEach(function (row) {
                _departmentProductArray.push({
                    'product': row,
                    'department': department,
                    'urgentPurchase': vm.productType.value
                });
            });

            api.GeneralWS.Account.DepartmentProduct.me.add({ 'circleId': $rootScope.bsCircle.id, 'departmentId': department.id }, _departmentProductArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.productSelectedArray = [];

                    getAssociatedProductToDepartment();
                    getNotAssociatedProductToDepartment();
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

        function disassociate() {
            vm.isShowProgressLinear = true;

            var _associatedProductIdArray = [];

            vm.productAssociatedSelectedArray.forEach(function (row) {
                _associatedProductIdArray.push(row.id);
            });

            api.GeneralWS.Account.DepartmentProduct.me.remove({ 'circleId': $rootScope.bsCircle.id, 'departmentId': department.id }, _associatedProductIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.productAssociatedSelectedArray = [];

                    getAssociatedProductToDepartment();
                    getNotAssociatedProductToDepartment();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

        function init() {
            getNotAssociatedProductToDepartment();
            getAssociatedProductToDepartment();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 155;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };

        }

        $timeout(init, 1000);
    }

})();


(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('DepartmentSettingsController', DepartmentSettingsController);

    function DepartmentSettingsController(api, $log, $mdDialog, department, $rootScope) {
        var vm = this;

        if (department.settings === null || department.settings === undefined) {
            department.settings = {};
        }

        vm.department = department;

        //methods
        vm.closeDialog = closeDialog;
        vm.save = save;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function save() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Account.Department.Settings.update({ 'idc': $rootScope.bsCircle.company.id, 'departmentId': vm.department.id }, vm.department.settings)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    $mdDialog.hide(response);
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }
    }

})();


(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountEntryDetailEditController', AccountEntryDetailEditController);

    /**@ngInject**/
    function AccountEntryDetailEditController(api, MessageService, $log, accountingEntryConfig, $filter, $mdDialog, $rootScope, accountingEntryConfigDetail, accountTypeIds) {

        var vm = this;

        vm.accountingEntryConfig = accountingEntryConfig;
        vm.accountingEntryTypes = [];
        vm.accountingEntryConfigDetail = accountingEntryConfigDetail ? accountingEntryConfigDetail : { 'accountingEntryConfig': vm.accountingEntryConfig };
        vm.pageNumber = 1;
        vm.pageSize = 100;
        vm.validateTemplateIds = validateTemplateIds;
        vm.dinamicStyle = {
            'width': '30%',
            'height': '45%'
        };

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;
        init();

        function init() {
            vm.verifyIds = new jinqJs()
                .from(accountTypeIds)
                .distinct('accountType')
                .where(function (row) {
                    return row.accountType > 0 && row.remove;
                })
                .select(function (row) {
                    return row.accountType;
                });
            getAccountingEntryTypeTemplate();
            vm.loadingTypes = true;
            api.GeneralWS.Account.AccountType.me.list({ 'company': $rootScope.bsCircle.company.id, 'pageNumber': vm.pageNumber, 'pageSize': vm.pageSize }).$promise.then(function (response) {
                vm.accountTypes = new jinqJs()
                    .from(response)
                    .where(function (r) {
                        var templatesDetail = new jinqJs()
                            .from(vm.accountingEntryTypeTemplatesAll)
                            .where(function (row) {
                                return verifiExistTemplateByAccountType(r, row.id);
                            })
                            .select();
                        return templatesDetail.length > 0;
                    })
                    .select();
                if (vm.accountingEntryConfigDetail && vm.accountingEntryConfigDetail.accountType) {
                    vm.accountTypes.push(vm.accountingEntryConfigDetail.accountType);
                    validateTemplateIds();
                }
                vm.loadingTypes = false;
            }, function (err) {
                vm.loadingTypes = false;
                $log.debug(err);
            });

            var windowHeight = parseInt(window.innerHeight);

            if (windowHeight < 700) {
                vm.dinamicStyle.height = '70%';
            } else if (windowHeight < 800) {
                vm.dinamicStyle.height = '45%';
            }
        }

        function save() {

            if (vm.accountEntryForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.accountingEntryConfigDetail.id) {
                promise = api.GeneralWS.AccountingEntryConfigDetail.update(
                    { 'id': vm.accountingEntryConfigDetail.id }
                    , vm.accountingEntryConfigDetail).$promise;
            } else {
                promise = api.GeneralWS.AccountingEntryConfigDetail.save(
                    { 'id': undefined }
                    , vm.accountingEntryConfigDetail).$promise;
            }
            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                $mdDialog.hide(response);
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                if (response.data.mensaje === 'ERROR_EXIST_DETAIL_WITH_TYPE') {
                    MessageService.showErrorMessage($filter('translate')('accountingEntry.ERROR_EXIST_DETAIL_WITH_TYPE'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function validateTemplateIds() {
            vm.accountingEntryTypeTemplates = new jinqJs()
                .from(vm.accountingEntryTypeTemplatesAll)
                .where(function (row) {
                    return verifiExistTemplateByAccountType(vm.accountingEntryConfigDetail.accountType, row.id);
                })
                .select();
        }

        function verifiExistTemplateByAccountType(accountType, id) {
            var exist = false;
            for (var i = 0; i < accountTypeIds.length; i++) {
                if (accountTypeIds[i].accountType === accountType.id && (!vm.accountingEntryConfigDetail.id || vm.accountingEntryConfigDetail.accountingEntryTypeTemplate.id != accountTypeIds[i].accountingEntryTypeTemplates)) {
                    if (accountTypeIds[i].accountingEntryTypeTemplates === id) {
                        exist = true;
                        break;
                    }
                }
            }
            return !exist;
        }

        function getAccountingEntryTypeTemplate() {
            vm.accountingEntryTypeTemplatesAll = [];
            api.GeneralWS.AccountingEntryTypeTemplate.getAll({ 'accountingEntryTypeId': vm.accountingEntryConfig.accountingEntryType.id }).$promise.then(function (response) {
                vm.accountingEntryTypeTemplatesAll = new jinqJs()
                    .from(response)
                    .select();
                vm.loadingTypes = false;
            }, function (err) {
                vm.loadingTypes = false;
                $log.debug(err);
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

  'use strict';

  angular
    .module('app.profile')
    .controller('UserGroupEstablishmentController', UserGroupEstablishmentController);

  /**@ngInject**/
  function UserGroupEstablishmentController($timeout, api, $log, $rootScope, $filter, $mdDialog, MessageService) {

    var vm = this;

    vm.addNewGroup = addNewGroup;
    vm.editGroup = editGroup;
    vm.deleteGroup = deleteGroup;
    vm.addMemberGroup = addMemberGroup;

    vm.pagination = {
      page: 0,
      pageSize: 50,
      totalElements: 0,
      totalPages: 0
    };

    vm.masterColumnDefs = [{
        headerName: '#',
        field: "id",
        width: 50,
        pinned: 'left',
        cellStyle: {
          'text-align': 'center'
        }
      },
      {
        headerName: 'GROUP.NAME',
        field: "groupName",
        headerCellRenderer: getHeader,
        width: 250
      },
      {
        headerName: 'GROUP.DESCRIPTION',
        field: "groupDescription",
        headerCellRenderer: getHeader,
        width: 350
      },
      {
        headerName: 'GROUP.SEARCH_DEFAULT',
        field: "searchDefault",
        headerCellRenderer: getHeader,
        width: 150,
        cellRenderer: function (params) {
          if (params.value) {
            return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
          } else {
            return "";
          }
        },
        cellStyle: {
          'padding': '5px'
        }
      },
      {
        headerName: 'GROUP.ACTIONS',
        name: "actions",
        headerCellRenderer: getHeader,
        width: 250,
        pinned: 'right',
        cellRenderer: renderer,
        cellStyle: {
          'padding': '0px'
        }
      }
    ];

    vm.masterGridOptions = {
      paginationPageSize: vm.pagination.pageSize,
      rowSelection: 'multiple',
      rowDeselection: true,
      rowModelType: "enterprise",
      cacheBlockSize: vm.pagination.pageSize,
      pagination: true,
      columnDefs: vm.masterColumnDefs,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowHeight: 40,
      enableColResize: true,
      rowData: [],
      getMainMenuItems: function (params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function (key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      }
    };

    $timeout(function () {
      createNewDatasource();
    }, 1000);


    function createNewDatasource() {

      vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);

      var dataSource = {
        paginationPageSize: vm.pagination.pageSize,
        getRows: function (params) {

          vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

          vm.isShowProgressLinear = true;
          api.GeneralWS.UserEstablishmentGroup.getGroups.getAll({
              'userAccount': $rootScope.account.preferredUsername.userName,
              'page': vm.page,
              'pageSize': vm.pagination.pageSize
            })
            .$promise.then(function (response) {
              vm.isShowProgressLinear = false;

              vm.pagination.totalElements = response.totalElements;
              vm.pagination.totalPages = response.totalPages;

              params.successCallback(response.content, response.totalElements);

            }, function (error) {
              $log.error(error);
            });

        }
      };

      vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);

    }

    function renderer(params) {
      var toRet = '<div style="width: 100%;">';
      toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.editGroup($event, data,' + params.rowIndex + ')" aria-label="Edit" ' +
        '                                    translate translate-attr-aria-label="PROFILE.EDIT.TITLE"> ' +
        '                        <md-tooltip md-direction="bottom">' +
        '                            {{"PROFILE.EDIT.TITLE"| translate}} ' +
        '                        </md-tooltip> ' +
        '                        <md-icon md-font-icon="icon-pencil" class="s16"></md-icon> ' +
        '                    </md-button> ' +
        '            <md-button class="edit-button md-icon-button" ng-click="vm.deleteGroup($event, data.id,' + params.rowIndex + ')" aria-label="Delete" ' +
        '                               translate translate-attr-aria-label="GROUP.DELETE"> ' +
        '                        <md-tooltip md-direction="bottom">' +
        '                            {{"GROUP.DELETE"| translate}}' +
        '                      </md-tooltip>' +
        '                     <md-icon md-font-icon="icon-minus-circle" class="s16 md-warn"></md-icon> ' +
        '                 </md-button>' +
        '         <md-button class="edit-button md-icon-button" ng-click="vm.addMemberGroup($event, data.id,' + params.rowIndex + ')" aria-label="Members"' +
        '                            translate translate-attr-aria-label="GROUP.ADD_MEMBERS">' +
        '                     <md-tooltip md-direction="bottom">' +
        '                         {{"GROUP.ADD_MEMBERS"| translate}}' +
        '                     </md-tooltip>' +
        '                     <md-icon md-font-icon="icon-account-multiple" class="s16"></md-icon> ' +
        '                 </md-button>'
      return toRet + '</div>';
    }

    function addNewGroup(ev) {
      $mdDialog.show({
        controller: 'NewGroupController',
        controllerAs: 'vm',
        templateUrl: 'app/main/general/profile/tabs/userGroups/newGroup/newGroup.html',
        parent: angular.element("#main"),
        targetEvent: ev,
        data: null,
        clickOutsideToClose: false
      }).then(function (answer) {
        createNewDatasource();
        MessageService.show('GROUP.MSG.ADDED_SUCCESSFULLY')
      });
    }

    function editGroup(ev, data, index) {
      $mdDialog.show({
        controller: 'NewGroupController',
        controllerAs: 'vm',
        templateUrl: 'app/main/general/profile/tabs/userGroups/newGroup/newGroup.html',
        parent: angular.element("#main"),
        targetEvent: ev,
        data: data,
        clickOutsideToClose: false
      }).then(function (answer) {
        createNewDatasource();
        MessageService.show('GROUP.MSG.EDITED_SUCCESSFULLY')
      });
    };

    function deleteGroup(ev, id, index) {

      var confirm = $mdDialog.confirm()
        .title($filter('translate')('GROUP.DELETE'))
        .textContent($filter('translate')('GROUP.MSG.CONFIRMACION_DELETE'))
        .ok($filter('translate')('GROUP.MSG.YES'))
        .cancel($filter('translate')('GROUP.MSG.NO'));

      $mdDialog.show(confirm).then(function () {
        vm.loading = true;
        $rootScope.loadingProgress = true;
        api.GeneralWS.UserEstablishmentGroup.deleteGroup.delete({
          id: id
        }).$promise.then(function (response) {
          vm.loading = false;
          $rootScope.loadingProgress = false;
          createNewDatasource();
        }, function (error) {
          $log.error(data);
        })
      }, function (err) {

      });

    };

    function addMemberGroup(ev, id) {
      $mdDialog.show({
        controller: 'MembersUserEstablishmentGroupController',
        controllerAs: 'vm',
        templateUrl: 'app/main/general/profile/tabs/userGroups/members/members.html',
        parent: angular.element("#main"),
        clickOutsideToClose: false,
        locals: {
          'id': id
        }
      }).then(function (answer) {}, function () {});
    }

  }

})();

(function () {

    'use strict';

    angular
        .module('app.notifications', [])
        .config(config);

    function config($stateProvider) {

        $stateProvider
            .state('app.notifications', {
                url: '/notifications',
                abstract: true
            })
            .state('app.notifications.MyNotifications', {
                url: '/my-notifications',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/general/notifications/my-notifications/my-notifications.html',
                        controller: 'MyNotifications as vm'
                    }
                }
            })
            .state('app.notifications.Configuration', {
                url: '/configuration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/general/notifications/configuration/configuration.html',
                        controller: 'NotificationConfigurationController as vm'
                    }
                }
            });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.notifications')
        .controller('MyNotificationsFilterController', MyNotificationsFilterController);

    function MyNotificationsFilterController(api, $scope, $filter, $timeout, $log) {

        var vm = $scope.vm;
        var filterCtrl = this;

        filterCtrl.search = search;
        filterCtrl.changeStartDate = changeStartDate;
        filterCtrl.clearSearchCompany = clearSearchCompany;
        filterCtrl.clearSearchApplication = clearSearchApplication;
        filterCtrl.clearFilters = clearFilters;


        function clearFilters() {
            vm.filter = {
                filterByDates: false,
                startDate: new Date(),
                endDate: new Date(),
                applications: [],
                companies: []
            };

            search();
        }

        function changeStartDate(isStart) {
            if (isStart) {
                if (vm.filter.startDate > vm.filter.endDate) {
                    vm.filter.endDate = vm.filter.startDate;
                }
            }
            vm.filter.startDate = setDateType(vm.filter.startDate, false);
            vm.filter.endDate = setDateType(vm.filter.endDate, true);
        }

        function setDateType(date, end) {
            if (end) {
                date.setHours(23);
                date.setMinutes(59);
                date.setSeconds(59);
            } else {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
            }
            return date;
        }

        function getCompanies() {
            api.GeneralWS.CompanyUser.query({}).$promise.then(function (response) {
                filterCtrl.companyArray = response;
            }, function (response) {
                $log.error(response);
            });
        }

        function search(event) {
            vm.showAdvancedFilter = false;
            vm.getMyNotifications();
        }

        function clearSearchCompany() {
            filterCtrl.searchCompany = "";
        }

        function clearSearchApplication() {
            filterCtrl.searchApplication = "";
        }

        function init() {

            getCompanies();

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchCompanyInput = document.querySelector("#searchCompanyInput");
            var searchApplicationInput = document.querySelector("#searchApplicationInput");

            if (searchCompanyInput) {
                searchCompanyInput.addEventListener("keydown", keyEvent);
            }

            if (searchApplicationInput) {
                searchApplicationInput.addEventListener("keydown", keyEvent);
            }

        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';

    angular.module('app.auth.strengthPassword', [])
        .directive('myPasswordStrength', ['passwordStrengthService',
            function (service) {

                function updateValues(password, scope) {
                    password = password || '';
                    scope.lengthLevel = service.getLengthLevel(password);
                    scope.strengthLevel = service.getStrengthLevel(password);
                    scope.strengthLabel = service.getLabel(scope.strengthLevel);
                }

                function link(scope) {
                    scope.$watch('password', function (password) {
                        updateValues(password, scope);
                    });
                }

                return {
                    restrict: 'EA',
                    replace: true,
                    scope: { password: '=' },
                    templateUrl: 'app/main/general/auth/directives/strengthPassword/strengthPassword.tpl.html',
                    link: link
                };
            }])

        .factory('passwordStrengthService', ['passwordStrengthConstants',
            function (constant) {
                var _matchPatterns = constant.patterns;
                var _maxLengthLevel = constant.maxLengthLevel;

                function _getStrengthLevel(password) {
                    for (var level in _matchPatterns) {
                        if (_matchPatterns[level].test(password)) {
                            return level;
                        }
                    }
                }

                function _getLengthLevel(password) {
                    var level = password.length / _maxLengthLevel * 100;
                    return level < 100 ? level : 100;
                }

                function _getLabel(level) {
                    return constant.labels[level];
                }

                return {
                    getStrengthLevel: _getStrengthLevel,
                    getLengthLevel: _getLengthLevel,
                    getLabel: _getLabel
                };
            }])

        .constant('passwordStrengthConstants', {
            patterns: {
                empty: /^$/i, // not looping if empty
                strong: /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).*$/, // 8+ sym, small+capital, digits, alpha
                medium: /^.*(?=.{6,})(?=.*[a-z])(?=.*[\d\W]).*$/i, // 6+ sym letters, digits
                weak: /^.*(?=.{6,})(?=.*[a-z\d]).*$/i, // 6+ letters or digits
                useless: /^.*$/i                                                  // anything other
            },
            labels: {
                empty: 'pwdCheck.pwdIsRequired',
                strong: 'pwdCheck.strong',
                medium: 'pwdCheck.medium',
                weak: 'pwdCheck.weak',
                useless: 'pwdCheck.useless'
            },
            maxLengthLevel: 20
        });



})();

(function () {
    'use strict';

    angular.module('app.auth.checkPassword', [])
        .directive('pwCheck', [function () {
            return {
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    var firstPassword = '#' + attrs.pwCheck;
                    elem.add(firstPassword).on('keyup', function () {
                        scope.$apply(function () {
                            var v = elem.val() === $(firstPassword).val();
                            ctrl.$setValidity('pwmatch', v);
                        });
                    });
                }
            };
        }]);
})();

(function () {

    angular
        .module('app.usr', [])
        .config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/usr/');

        $stateProvider
            .state('app.usr', {
                abstract: true,
                url: '/usr'
            })
            .state('app.usr.user', {
                url: '/user',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/usr/user/user-list/user-list.html',
                        controller: 'UserListController',
                        controllerAs: 'ul'
                    }
                },
                resolve: {
                    Company: function (apiResolver, $rootScope) {
                        return $rootScope.bsCircle.company;
                    }
                }
            })
            .state('app.usr.guest', {
                url: '/user-guest',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/usr/user-guest/user-guest.html',
                        controller: 'UserGuestController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.usr.reports', {
                abstract: true,
                url: '/reports'
            })
            .state('app.usr.reports.usersRoles', {
                url: '/roles',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/usr/user-roles/user-roles.html',
                        controller: 'UsersRolesController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.usr.reports.reportUsersCostCenter', {
                url: '/users-costcenter',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/general/general-template-report.html',
                        controller: 'ReportUsersCostCenterController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.usr.reports.reportUsersDepartment', {
                url: '/users-department',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/general/general-template-report.html',
                        controller: 'ReportUsersDeparmentController',
                        controllerAs: 'vm'
                    }
                }
            })
          .state('app.usr.reports.reportDimensionByUser', {
                url: '/users-dimension',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/general/general-template-report.html',
                        controller: 'ReportUsersDimensionController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.usr.reports.reportAppsByUser', {
                url: '/apps-user',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/usr/apps-user/reportAppsByUser.html',
                        controller: 'ReportApplicationByUserController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.usr.associateEquivalenceRole', {
                url: '/apps-associate-equivalence-role',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/usr/associate-equivalence-role/associate-equivalence-role-list/associate-equivalence-role-list.html',
                        controller: 'AssociateEquivalenceRoleListController',
                        controllerAs: 'vm'
                    }
                }
            })
          .state('app.usr.associateRoleJobHR',{
          url: '/apps-associate-rol-jobhr',
          views:{
            'content@app':{
              templateUrl: 'app/main/apps/usr/associate-role-jobhr/associateRolJobHr.html',
              controller: 'AssociateRolJobHrController',
              controllerAs: 'vm'
            }
          }
        });
    }
})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('UserListController', userListController);

    /**@ngInject**/
    function userListController($rootScope, $log, $timeout, $filter, api, MessageService, $mdDialog, Company, $scope, $stateParams) {

        var ul = this;

        //methods
        ul.roles = roles;
        ul.departments = departments;
        ul.costCenter = costCenter;
        ul.deactive = deactive;
        ul.resetPassword = resetPassword;
        ul.ticketsGroup = ticketsGroup;
        ul.associateEstablishment = associateEstablishment;
        ul.search = search;
        ul.companyEstablishment = companyEstablishment;
        ul.country = country;
        ul.dialogUserNotification = dialogUserNotification;
        ul.parameter = parameter;
        ul.dimensionCompany = dimensionCompany;
        ul.operations = operations;
        ul.adminWarehouses = adminWarehouses;
        ul.readonly = ($stateParams && $stateParams.readonly);
        ul.canConfigureUser = $rootScope.getEspecialActionByName('Puede Configurar Usuario');

        ul.pagination = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "name",
                headerName: 'user.name',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "account",
                headerName: 'user.account',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "roles",
                headerName: 'user.roles',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button ng-disabled='ul.readonly' class='md-icon-button' ng-click='ul.roles(data)'> "
                        + " <md-icon md-font-icon='icon-account-network'></md-icon> "
                        + " <md-tooltip md-direction='left'>{{'user.roles' | translate}}</md-tooltip> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                field: "restartPassword",
                headerName: 'user.resetPassword',
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button ng-disabled='ul.readonly' class='md-icon-button' ng-click='ul.resetPassword(data)'> "
                        + " <md-icon md-font-icon='icon-account-key'></md-icon> <md-tooltip md-direction='left'>{{'user.resetPassword' | translate}}</md-tooltip> "
                        + " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                field: "deactiveUser",
                headerName: 'user.deactivate',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button ng-disabled='ul.readonly' class='md-icon-button' ng-click='ul.deactive(data)'> "
                        + " <md-icon md-font-icon='icon-account-remove' class='md-warn'></md-icon> "
                        + " <md-tooltip md-direction='left'>{{'user.deactivate' | translate}}</md-tooltip> "
                        + " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }

        ];

        if (!$scope.vm.isPrivated && !ul.readonly && ul.canConfigureUser) {
            columnDefs.splice(2, 0, {
                field: "costCenter",
                headerName: 'user.cost_center',
                headerCellRenderer: getHeader,
                width: 135,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button class='md-icon-button' ng-click='ul.costCenter(data)'> "
                        + " <md-icon md-font-icon='icon-indent'></md-icon> <md-tooltip md-direction='left'>{{'user.cost_center' | translate}}</md-tooltip> "
                        + " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            });
            columnDefs.splice(3, 0, {
                field: "department",
                headerName: 'user.departments',
                headerCellRenderer: getHeader,
                width: 135,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button class='md-icon-button' ng-click='ul.departments(data)'> "
                        + "  <md-icon md-font-icon='icon-view-module'></md-icon> <md-tooltip md-direction='left'>{{'user.departments' | translate}}</md-tooltip> "
                        + " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            });
          api.GeneralWS.DimensionCompany.byCompany.getList(
            {
              'company': $rootScope.bsCircle.company.id
            }
          ).$promise.then(function (response) {

            if (response.length > 0) {
              columnDefs.splice(4, 0, {
                field: "dimension",
                headerName: 'user.dimensionCompany',
                headerCellRenderer: getHeader,
                width: 135,
                cellRenderer: function (params) {
                  return "<center> "
                    + " <md-button class='md-icon-button' ng-click='ul.dimensionCompany(data)'> "
                    + "  <md-icon md-font-icon='icon-view-module'></md-icon> <md-tooltip md-direction='left'>{{'user.dimensionCompany' | translate}}</md-tooltip> "
                    + " </md-button> </center>";
                },
                cellStyle: {'padding': '2px'}
              });
            }
          });

            columnDefs.splice(5, 0, {
                field: "companyEstablishment",
                headerName: 'user.companyEstablishment',
                headerCellRenderer: getHeader,
                width: 125,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button class='md-icon-button' ng-click='ul.companyEstablishment(data)'> "
                        + "  <md-icon md-font-icon='icon-image-filter-none'></md-icon> <md-tooltip md-direction='left'>{{'user.companyEstablishment' | translate}}</md-tooltip> "
                        + " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            });
            columnDefs.splice(6, 0, {
                field: "country",
                headerName: 'user.countries',
                headerCellRenderer: getHeader,
                width: 90,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button class='md-icon-button' ng-click='ul.country(data)'> "
                        + "  <md-icon md-font-icon='icon-earth'></md-icon> <md-tooltip md-direction='left'>{{'user.countries' | translate}}</md-tooltip> "
                        + " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            });
          columnDefs.splice(7, 0, {
            field: "userNotification",
            headerName: 'user.notifications',
            headerCellRenderer: getHeader,
            width: 135,
            cellRenderer: function (params) {
              return "<center> "
                  + " <md-button class='md-icon-button' ng-click='ul.dialogUserNotification(data)'> "
                  + " <md-icon md-font-icon='icon-indent'></md-icon> <md-tooltip md-direction='left'>{{'user.notifications' | translate}}</md-tooltip> "
                  + " </md-button> </center>";
            },
            cellStyle: { 'padding': '2px' }
          });
            columnDefs.splice(8, 0, {
                field: "parameter",
                headerName: 'user.parameters',
                headerCellRenderer: getHeader,
                width: 90,
                cellRenderer: function (params) {
                    return "<center> "
                        + " <md-button class='md-icon-button' ng-click='ul.parameter(data)'> "
                        + "  <md-icon md-font-icon='icon-cog'></md-icon> <md-tooltip md-direction='left'>{{'user.parameters' | translate}}</md-tooltip> "
                        + " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            });
        }

        ul.grid = {
            paginationPageSize: ul.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: ul.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function search() {
            ul.showSearch = true;
            createNewDatasource();
        }

        function createNewDatasource() {
            if (ul.application === null && ul.application === undefined) {
                return null;
            }
            var dataSource = {
                paginationPageSize: ul.pagination.pageSize,
                getRows: function (params) {
                    ul.isShowProgressLinear = true;
                    ul.pagination.pageNumber = params.request.endRow / ul.pagination.pageSize;

                    api.GeneralWS.Usr.User.Company.me.page({
                        'company': Company.id, 'pageNumber': (ul.pagination.pageNumber), 'pageSize': ul.pagination.pageSize, 'search': ul.inputSearch
                    })
                        .$promise.then(function (response) {
                            ul.isShowProgressLinear = false;
                            ul.pagination.totalElements = response.totalElements;
                            ul.pagination.totalPages = response.totalPages;

                            params.successCallback(response.content, response.totalElements);
                            ul.showGrid = true;
                        }, function (response) {
                            $log.error(response);
                        });
                }
            };
            ul.grid.api.setEnterpriseDatasource(dataSource);
        }

        function roles(user) {
            $mdDialog.show({
                controller: 'UserRoleController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/roles/roles.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user,
                    'Company': Company,
                    'Private': $scope.vm.isPrivated
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function departments(user) {
            $mdDialog.show({
                controller: 'UserDepartmentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/department/department.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function costCenter(user) {
            $mdDialog.show({
                controller: 'UserCostCenterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/cost-center/cost-center.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function adminWarehouses(user) {
            $mdDialog.show({
                controller: 'UserOperacionesWarehousesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/operaciones-warehouses/operaciones-warehouses.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user,
                    'application': ul.OP2Application,
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function companyEstablishment(user) {
            $mdDialog.show({
                controller: 'UserCompanyEstablishmentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/company-establishment/company-establishment.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function dimensionCompany(user) {
            $mdDialog.show({
                controller: 'UserDimensionCompanyController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/dimension-company/dimension-company.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function country(user) {
            $mdDialog.show({
                controller: 'UserCountryController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/country/country.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user
                }
            }).then(function (answer) {
            }, function () {
            });
        }

      function dialogUserNotification(user) {
        $mdDialog.show({
          controller: 'DialogUserNotificationController',
          controllerAs: 'vm',
          templateUrl: 'app/main/apps/usr/user/dialog-user-notification/dialog-user-notification.html',
          parent: angular.element("#main"),
          clickOutsideToClose: false,
          locals: {
            'user': user
          }
        }).then(function (answer) {
        }, function () {
        });
      }

        function parameter(user) {
            $mdDialog.show({
                controller: 'UserParameterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/parameter/parameter.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function deactive(user) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('user.deactivate'))
                .textContent($filter('translate')('user.confirm_deactivate_user') + user.account + '?')
                .ariaLabel($filter('translate')('user.deactivate'))
                .ok('Si')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {

                ul.isShowProgressLinear = true;
                api.GeneralWS.BusinessCircleMembers.company.user.me.delete({
                    'user': user.id, 'company': Company.id, 'app': 0, 'circleId': $rootScope.bsCircle.id
                })
                    .$promise.then(function (response) {
                        ul.isShowProgressLinear = false;

                        ul.pagination.pageNumber--;
                        createNewDatasource();

                    }, function (response) {
                        ul.isShowProgressLinear = false;
                    });

            }, function () {

            });
        }

        function resetPassword(user) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('user.resetPassword'))
                .textContent($filter('translate')('user.resetPasswordConfirm'))
                .ariaLabel($filter('translate')('user.resetPassword'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {

                ul.isShowProgressLinear = true;

                api.UsuarioWS.forgotPassword.update({ 'username': user.account }).$promise.then(function (response) {
                    ul.isShowProgressLinear = false;

                    MessageService.show($filter('translate')('user.resetPasswordSucess'));

                }, function (response) {
                    ul.isShowProgressLinear = false;

                    $log.error(response);
                    var message = (response.status === 404 || response.status === 401) ? ' FORGOTPASSWORD.ERRORS.' + response.status + '' : response.statusText;
                    MessageService.show($filter('translate')(message));

                });

            }, function () {

            });

        }

        function ticketsGroup(user) {
            $mdDialog.show({
                controller: 'UserTicketsGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/tickets-group/tickets-group.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function associateEstablishment(user) {
            $mdDialog.show({
                controller: 'EstablishmentRoleUserController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/usr/user/dialog-establishment-role-user/dialog-establishment-role-user.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'user': user,
                    'company': Company,
                    'POSApplication': ul.POSApplication
                }
            }).then(function (answer) {
            }, function () {
            });
        }

      function operations(userData) {
        $mdDialog.show({
          controller: 'ProductTypeUserController',
          controllerAs: 'vm',
          templateUrl: 'app/main/apps/usr/user/dialog-product-type-user/dialog-product-type-user.html',
          parent: angular.element('#main'),
          clickOutsideToClose: false,
          locals: {
            'user': userData,
          },
        });
      }

        $timeout(function () {
            getCompanyApplication();
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': Company.id, 'app': 'Tickets' }).$promise.then(function (responseParameter) {
                if (responseParameter.$status === 200) {
                    ul.appTicketsActive = responseParameter.$data !== "";
                    if (ul.appTicketsActive && ul.canConfigureUser) {
                        columnDefs.push({
                            name: "edit",
                            headerName: 'department.ticketsGroup',
                            headerCellRenderer: getHeader,
                            width: 150,
                            cellRenderer: function (params) {
                                return '<center> '
                                    + ' <md-button class="md-icon-button" ng-click="ul.ticketsGroup(data)"> '
                                    + ' <md-icon md-font-icon="icon-view-list"></md-icon> '
                                    + ' <md-tooltip md-direction="left">{{"department.ticketsGroup"| translate}}</md-tooltip> '
                                    + ' </md-button> </center>';
                            },
                            cellStyle: { 'padding': '2px' }
                        });
                    }

                    ul.grid.api.setColumnDefs(columnDefs);
                }
                loadAssociateEstablismentColumn();
                loadOperationsColumn();
            }, function (response) {
                $log.error(response);
            });

        }, 1000);

        function getCompanyApplication() {
                api.GeneralWS.CompanyApplication.byAppName.get({ 'company': Company.id, 'app': 'Operaciones2' }).$promise.then(function (responseApp) {
                    if (responseApp.$status === 200) {
                        if (responseApp.$data && responseApp.$data !== '' && ul.canConfigureUser) {
                            ul.OP2Application = responseApp.$data.application;
                            columnDefs.push({
                                name: "edit",
                                headerName: 'user.wareHousesByUser',
                                headerCellRenderer: getHeader,
                                width: 200,
                                cellRenderer: function (params) {
                                        return "<center> "
                                        + " <md-button class='md-icon-button' ng-click='ul.adminWarehouses(data)'> "
                                        + " <md-icon md-font-icon='icon-factory'></md-icon> "
                                        + " <md-tooltip md-direction='left'>{{'user.wareHousesByUser' | translate}}</md-tooltip> "
                                        + " </md-button> </center>";
                                },
                                cellStyle: { 'padding': '2px' }
                            });
                        }
                        ul.grid.api.setColumnDefs(columnDefs);
                    }
                    createNewDatasource();
                }, function (response) {
                    $log.error(response);
                });
        }

        function loadAssociateEstablismentColumn() {
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': Company.id, 'app': 'POS' }).$promise.then(function (responseApp) {
                if (responseApp.$status === 200) {
                    if (responseApp.$data && responseApp.$data !== '' && ul.canConfigureUser) {
                        ul.POSApplication = responseApp.$data.application;
                        columnDefs.push({
                            name: "edit",
                            headerName: 'user.POSCompanyEstablishments',
                            headerCellRenderer: getHeader,
                            width: 200,
                            cellRenderer: function (params) {
                                return '<center> '
                                    + ' <md-button class="md-icon-button" ng-click="ul.associateEstablishment(data)"> '
                                    + ' <md-icon md-font-icon="icon-image-filter-none"></md-icon> '
                                    + ' <md-tooltip md-direction="left">{{"user.POSCompanyEstablishments"| translate}}</md-tooltip> '
                                    + ' </md-button> </center>';
                            },
                            cellStyle: { 'padding': '2px' }
                        });
                    }
                    ul.grid.api.setColumnDefs(columnDefs);
                }
                createNewDatasource();
            }, function (response) {
                $log.error(response);
            });
        }

        function loadOperationsColumn() {
          const statusCode = 200;
          api.GeneralWS.CompanyApplication.byAppName.get({ 'company': Company.id, 'app': 'Operaciones2' }).$promise
            .then(function (responseApp) {
            if (responseApp.$status === statusCode) {
              ul.appOperations = responseApp.$data !== '';
              if (ul.appOperations && ul.canConfigureUser) {
                ul.POSApplication = responseApp.$data.application;
                columnDefs.push({
                  name: 'edit',
                  headerName: 'user.productType',
                  headerCellRenderer: getHeader,
                  width: 200,
                  cellRenderer: function () {
                    return '<center> '
                      + ' <md-button class=\'md-icon-button\' ng-click=\'ul.operations(data)\'> '
                      + ' <md-icon md-font-icon=\'icon-library-books\'></md-icon> '
                      + ' <md-tooltip md-direction=\'left\'>{{\'user.productType\'| translate}}</md-tooltip> '
                      + ' </md-button> </center>';
                  },
                  cellStyle: { 'padding': '2px' },
                });
              }
              ul.grid.api.setColumnDefs(columnDefs);
            }
          }, function (response) {
            $log.error(response);
          });
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('UserTicketsGroupController', UserTicketsGroupController);

    /**@ngInject**/
    function UserTicketsGroupController($rootScope, $log, $timeout, $mdDialog, api, user) {

        var vm = this;

        vm.groupArray = [];
        vm.userGroupArray = [];
        vm.cancel = cancel;
        vm.selectAll = selectAll;
        vm.selectAllUserGroups = selectAllUserGroups;

        vm.validateSelectAll = validateSelectAll;
        vm.validateSelectAllUserGroups = validateSelectAllUserGroups;

        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.countGroupSelected = 0;
        vm.countUserTicketGroupSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.getInfoByDepartment = getInfoByDepartment;

        vm.pagination = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 0;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getGroups();
            }
        };

        vm.paginationUserGroup = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 0;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getUserGroups();
            }
        };

        function getInfoByDepartment() {

            vm.paginationUserGroup.pageNumber = 0;
            vm.pagination.pageNumber = 0;

            vm.groupArray = [];
            vm.userGroupArray = [];

            getGroups();
            getUserGroups();
        }

        function getGroups() {
            vm.isShowProgressLinear = true;
            api.TicketsWS.UserDepartmentGroup.notAssociatedToUser.page({
                'company': $rootScope.bsCircle.company.id, 'department': vm.departmentId, 'groupId': 0,
                'userId': user.id, 'pageNumber': (vm.pagination.pageNumber + 1), 'pageSize': vm.pagination.pageSize
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.totalElements = response.totalElements;
                    vm.pagination.totalPages = response.totalPages;
                    vm.pagination.pageNumber = response.number + 1;
                    vm.groupArray = response.content;

                    vm.isCheckAll = false;
                    vm.countGroupSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function getUserGroups() {
            vm.isShowProgressLinear = true;
            api.TicketsWS.UserDepartmentGroup.me.query({
                'userId': user.id,
                'company': $rootScope.bsCircle.company.id, 'department': vm.departmentId, 'groupId': 0,
                'pageNumber': (vm.paginationUserGroup.pageNumber + 1), 'pageSize': vm.paginationUserGroup.pageSize
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.paginationUserGroup.totalElements = response.length;
                    vm.paginationUserGroup.totalPages = 1;
                    vm.paginationUserGroup.pageNumber = 1;
                    vm.userGroupArray = response;

                    vm.isCheckAllUserGroup = false;
                    vm.countUserTicketGroupSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAll() {

            vm.countGroupSelected = 0;

            var isSelectAll = true;

            vm.groupArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countGroupSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAll = true;
            } else {
                vm.isCheckAll = false;
            }

        }

        function selectAll() {
            if (vm.isCheckAll) {
                vm.groupArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countGroupSelected = vm.groupArray.length;

            } else {
                vm.groupArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countGroupSelected = 0;
            }
        }

        function validateSelectAllUserGroups() {

            vm.countUserTicketGroupSelected = 0;

            var isSelectAll = true;

            vm.userGroupArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserTicketGroupSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserGroup = true;
            } else {
                vm.isCheckAllUserGroup = false;
            }

        }

        function selectAllUserGroups() {
            if (vm.isCheckAllUserGroup) {
                vm.userGroupArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }
                });

                vm.countUserTicketGroupSelected = vm.userGroupArray.length;

            } else {
                vm.userGroupArray.forEach(function (row) {
                    row.isCheck = false;


                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserTicketGroupSelected = 0;
            }
        }

        function associate() {

            var roleIdArray = [];

            if (!vm.isCheckAll) {
                vm.selectedArray.forEach(function (row) {
                    roleIdArray.push(row.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAll) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.TicketsWS.UserDepartmentGroup.me.create({
                'associateAll': vm.isCheckAll, 'userId': user.id, 'company': $rootScope.bsCircle.company.id,
                'department': vm.departmentId, 'groupId': 0
            }, roleIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.paginationUserGroup.pageNumber = 0;
                    getUserGroups();

                    vm.pagination.pageNumber = 0;
                    vm.selectedArray = [];

                    getGroups();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });

        }

        function disassociate() {

            var roleIdArray = [];

            if (!vm.isCheckAllUserGroup) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    roleIdArray.push(row.ticketDepartmentGroup.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAllUserGroup) {
                return null;
            }


            vm.isShowProgressLinear = true;
            api.TicketsWS.UserDepartmentGroup.me.update({
                'deleteAll': vm.isCheckAllUserGroup, 'userId': user.id, 'company': $rootScope.bsCircle.company.id,
                'department': vm.departmentId, 'groupId': 0
            }, roleIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.pageNumber = 0;
                    getGroups();

                    vm.paginationUserGroup.pageNumber = 0;
                    vm.selectedAssociatedArray = [];

                    getUserGroups();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });

        }

        $timeout(function () {

            api.GeneralWS.Account.Department.departmentTicket.query({ idc: $rootScope.bsCircle.company.id }, function (response) {
                vm.deparments = response;
            }, function (d) {
            });

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 300;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };

        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('UserRoleController', userRoleController);

    /**@ngInject**/
    function userRoleController($rootScope, $log, $timeout, $mdDialog, api, user, Private, Company) {

        var vm = this;

        const NUMBER_THREE_HUNDRED = 300;
        const NUMBER_TWO = 2;
        const NUMBER_THREE = 3;
        const NUMBER_FOUR = 4;
        const NUMBER_FIVE = 5;

        vm.roleArray = [];
        vm.userRoleArray = [];
        vm.cancel = cancel;
        vm.selectAllRoles = selectAllRoles;
        vm.selectAllUserRoles = selectAllUserRoles;

        vm.validateSelectAllRoles = validateSelectAllRoles;
        vm.validateSelectAllUserRoles = validateSelectAllUserRoles;

        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.countRoleSelected = 0;
        vm.countUserRoleSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.getInfoByApp = getInfoByApp;

        vm.pagination = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 0;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getRole();
            }
        };

        vm.paginationUserRole = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 0;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getUserRole();
            }
        };

        function getInfoByApp() {

            vm.paginationUserRole.pageNumber = 0;
            vm.pagination.pageNumber = 0;

            vm.roleArray = [];
            vm.userRoleArray = [];

            getRole();
            getUserRole();
        }

        function getRole() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.BusinessCircle.notAssociatedToUser.page({
                'companyId': Company.id, 'app': vm.appId, 'userId': user.id, 'pageNumber': (vm.pagination.pageNumber + 1), 'pageSize': vm.pagination.pageSize
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.totalElements = response.totalElements;
                    vm.pagination.totalPages = response.totalPages;
                    vm.pagination.pageNumber = response.number + 1;
                    vm.roleArray = new jinqJs()
                        .from(response.content)
                        .where(function (r) {
                            if (Private) {
                                r.businessCircle.role.name = 'ROLE_PROVEEDOR';
                            }
                            return r.roleLevel >= $rootScope.bsCircle.role.roleLevel;
                        })
                        .select();

                    vm.isCheckAllRole = false;
                    vm.countRoleSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function getUserRole() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.BusinessCircleMembers.company.user.me.page({
                'user': user.id, 'company': Company.id, 'app': vm.appId, 'pageNumber': (vm.paginationUserRole.pageNumber + 1),
                'pageSize': vm.paginationUserRole.pageSize
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.paginationUserRole.totalElements = response.totalElements;
                vm.paginationUserRole.totalPages = response.totalPages;
                vm.paginationUserRole.pageNumber = response.number + 1;
                vm.userRoleArray = new jinqJs()
                    .from(response.content)
                    .where(function (r) {
                        return r.businessCircle.role.roleLevel >= $rootScope.bsCircle.role.roleLevel;
                    })
                    .select();

                vm.isCheckAllUserRole = false;
                vm.countUserRoleSelected = 0;

            }, function (response) {
                $log.error(response);
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAllRoles() {

            vm.countRoleSelected = 0;

            var isSelectAll = true;

            vm.roleArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countRoleSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllRole = true;
            } else {
                vm.isCheckAllRole = false;
            }

        }

        function selectAllRoles() {
            if (vm.isCheckAllRole) {
                vm.roleArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countRoleSelected = vm.roleArray.length;

            } else {
                vm.roleArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countRoleSelected = 0;
            }
        }

        function validateSelectAllUserRoles() {

            vm.countUserRoleSelected = 0;

            var isSelectAll = true;

            vm.userRoleArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserRoleSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserRole = true;
            } else {
                vm.isCheckAllUserRole = false;
            }

        }

        function selectAllUserRoles() {
            if (vm.isCheckAllUserRole) {
                vm.userRoleArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }
                });

                vm.countUserRoleSelected = vm.userRoleArray.length;

            } else {
                vm.userRoleArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserRoleSelected = 0;
            }
        }

        function associate() {

            var roleIdArray = [];

            if (!vm.isCheckAllRole) {
                vm.selectedArray.forEach(function (row) {
                    roleIdArray.push(row.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAllRole) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.BusinessCircleMembers.me.create({
                'associateAll': vm.isCheckAllRole, 'userId': user.id, 'companyId': Company.id, 'app': vm.appId,
                'level': $rootScope.bsCircle.role.roleLevel
            }, roleIdArray).$promise.then(function (response) {
                roleIdArray.forEach(function (id) {
                    validateDimensionDefaults(id);
                });

                setTimeout(function () {
                    vm.paginationUserRole.pageNumber = 0;
                    getUserRole();

                    vm.pagination.pageNumber = 0;
                    vm.selectedArray = [];
                    getRole();
                }, NUMBER_THREE_HUNDRED);

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });

        }

        function validateDimensionDefaults(roleId) {
            api.baseUrlAccountCatalogWS.CompanyRolDimensionDefault.getList.query({
                'companyId': Company.id,
                'roleApplicationId': roleId
            })
                .$promise.then(function (defaults) {
                    const data = defaults.reduce(function (obj, item) {
                        obj[item.dimensionNumber - 1] = obj[item.dimensionNumber - 1] || { dimensionNumber: item.dimensionNumber, values: [] };
                        obj[item.dimensionNumber - 1].values.push(item.dimensionValueId);
                        return obj;
                    }, []);

                    data.forEach(function (dt) {
                        switch (dt.dimensionNumber) {
                            case NUMBER_TWO:
                                associateDepartments(dt.values);
                                break;
                            case NUMBER_THREE:
                            case NUMBER_FOUR:
                            case NUMBER_FIVE:
                                associateDimensionDetails(dt.values);
                                break;
                            default:
                                associateCostCenters(dt.values);
                                break;
                        }
                    });

                }, function (err) {
                    $log.error(err);
                });
        }

        function associateCostCenters(costCenterIds) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserCostCenter.me.create({
                'associateAll': false, 'search': '',
                'idUsuario': user.id, 'company': Company.id
            }, costCenterIds).$promise.then(function () {
                vm.isShowProgressLinear = false;
            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
            })
        }

        function associateDepartments(departmentIdArray) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserDepartment.me.create({
                'associateAll': false, 'idUsuario': user.id,
                'company': Company.id, 'search': ''
            }, departmentIdArray)
                .$promise.then(function () {
                    vm.isShowProgressLinear = false;
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

        function associateDimensionDetails(detailIds) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Account.DimensionCompanyDetail.byIds.getDetails({ 'idList': detailIds })
                .$promise.then(function (details) {

                    const dimensionDetails = [];

                    details.forEach(function (row) {
                        const userDimension = {
                            userId: user.id,
                            dimensionCompanyId: row.dimensionCompanyId,
                            dimensionCompanyDetailId: row.id
                        }
                        dimensionDetails.push(userDimension);
                    });

                    api.UserWS.UserDimension.UserDimension.create({
                        'idUsuario': user.id,
                        'company': $rootScope.bsCircle.company.id
                    }, dimensionDetails)
                        .$promise.then(function () {
                            vm.isShowProgressLinear = false;
                        }, function (response) {
                            vm.isShowProgressLinear = false;
                            $log.error(response);
                        });
                });
        }

        function disassociate() {

            var roleIdArray = [];

            if (!vm.isCheckAllUserRole) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    roleIdArray.push(row.businessCircle.id);
                });
            }

            if (roleIdArray.length === 0 && !vm.isCheckAllUserRole) {
                return null;
            }


            vm.isShowProgressLinear = true;
            api.GeneralWS.BusinessCircleMembers.me.update({
                'deleteAll': vm.isCheckAllUserRole, 'userId': user.id, 'companyId': Company.id, 'app': vm.appId,
                'level': $rootScope.bsCircle.role.roleLevel
            }, roleIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.pagination.pageNumber = 0;
                getRole();

                vm.paginationUserRole.pageNumber = 0;
                vm.selectedAssociatedArray = [];

                getUserRole();

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });

        }

        $timeout(function () {

            //apps
            api.GeneralWS.CompanyApplication.me.query({ company: Company.id }, function (response) {
                vm.applications = response;
            }, function (d) {
            });


            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 300;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };

        }, 1000);

    }

})();


(function () {
    'use strict';

    angular
        .module('app.usr')
        .controller('UserParameterController', userParameterController);

    /** @ngInject */
    function userParameterController(api, $log, $rootScope, $filter, $mdDialog, MessageService, $timeout, user) {
        var vm = this;
        vm.updateParameterValue = updateParameterValue;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        init();

        function init() {
            $timeout(function () {
                loadParameters();
            }, 500);
        }

        function loadParameters() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.ParameterCompanyCanUpdate.page({
                "idUsuario": user.id,
                "pageNumber": vm.pagination.pageNumber,
                "pageSize": vm.pagination.pageSize
            }, function (response) {
                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.pagination.pageNumber = response.number + 1;
                vm.content = new jinqJs()
                    .from(response.content)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        if (r.applicationParameter.dataType === 'BOOLEAN') {
                            r.parameterValue = (r.parameterValue === 'true');
                        }
                      if (r.applicationParameter.dataType === 'DECIMAL') {
                        r.parameterValue = parseFloat(r.parameterValue);
                      }
                        return r;
                    });

                vm.isShowProgressLinear = false;
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        vm.dtOptionsParameters = {
            columnDefs: [
                {
                    // Target the id column
                    targets: 0,
                    responsivePriority: 1
                },
                {
                    // Target the actions column
                    targets: 1,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                },
                {
                    // Target the actions column
                    targets: 2,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ],
            order: [[0, "asc"]],
            paging: false,
            responsive: true,
            info: false,
            searching: false
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        }

        function updateParameterValue(data) {
            if (data.userJsonParameterValue === null || data.userJsonParameterValue === undefined) {
                data.userJsonParameterValue = "[]";
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserParameter.update({
                'userParameterId': data.id,
            }, data).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                MessageService.show($filter('translate')('company_parameters.parameter_updated_successfully'));

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

    }
})();

(function () {

    angular
        .module('app.usr')
        .controller('UserOperacionesWarehousesController', UserOperacionesWarehousesController);

    /**@ngInject**/
    function UserOperacionesWarehousesController($rootScope, $log, $timeout, $filter, $mdDialog, api, MessageService, user, application) {

        var vm = this;
        vm.warehousesArray = [];
        vm.userWarehousesArray = [];
        vm.allWarehousesArray = [];
        vm.cancel = cancel;
        vm.selectAllWarehouses = selectAllWarehouses;
        vm.selectAllUserWarehouses = selectAllUserWarehouses;

        vm.validateSelectAllWarehouses = validateSelectAllWarehouses;
        vm.validateSelectAllUserWarehouses = validateSelectAllUserWarehouses;
        vm.updateRole = updateRole;

        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.selectedDataArray = [];
        vm.selectedAssociatedDataArray = [];

        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.countWarehousesSelected = 0;
        vm.countUserWarehousesSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.searchWarehouses = searchWarehouses;
        vm.inputSearchWarehouses = '';

        vm.searchUserWarehouses = searchUserWarehouses;
        vm.inputSearchUserWarehouses = '';

        vm.load = false;

        function getWarehouses() {
            vm.isShowProgressLinear = true;
            vm.load = true;
            api.Operaciones2ConfigWS.getListAllWarehouse.get({}).$promise.then(function (response) {
                response.forEach(function (element) {
                    element.description = (element.code + ' ' + element.name).toLowerCase();
                });
                vm.isShowProgressLinear = false;
                vm.load = false;

                vm.allWarehousesArray = response;

                vm.isCheckAllWarehouses = false;
                vm.countWarehousesSelected = 0;

            }, function (response) {
                $log.error(response);
            });
        }

        function getUserWarehouses() {
            vm.isShowProgressLinear = true;
            vm.loadAssociatedProducts = true;

            api.Operaciones2ConfigWS.getListWarehouseByUser.get({
                'userId': user.id,
            }).$promise.then(function (response) {
                    response.forEach(function (element) {
                        element.description = (element.code + ' ' +  element.name).toLowerCase();
                    });
                    vm.isShowProgressLinear = false;
                    vm.loadAssociatedProducts = false;

                    updateListOfWarehousesByUser(response);

                    vm.isCheckAllWarehouses = false;
                    vm.isCheckAllUserWarehouses = false;
                    vm.countUserWarehousesSelected = 0;
                    vm.countWarehousesSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function getRoleApplications() {
          vm.isShowProgressLinear = true;
          vm.load = true;
          api.GeneralWS.RoleApplication.me.get({
            'applicationId': application.id,
          }).$promise.then(function (response) {
              vm.roleApplications = response;
              vm.isShowProgressLinear = false;
          }, function (response) {
              vm.isShowProgressLinear;
              $log.error(response);
          });
      }

      function updateRole(data) {
        const userWarehouse = {
          warehouseId: data.id,
          userId: data.userId,
          roleApplicationId: data.roleApplicationId,
        };

        vm.updatingUserWarehouse = true;
        api.Operaciones2ConfigWS.UserWarehouse.me.update({
          'userId': data.userId, 'id': data.userWarehouseId,
        }, userWarehouse).$promise.then(function () {
          vm.updatingUserWarehouse = false;
          MessageService.show($filter('translate')('user.message.rolUpdated'));
        }, function (response) {
          $log.error(response);
          vm.updatingUserWarehouse = false;
          MessageService.showErrorMessage($filter('translate')('user.message.updateRolError'));
        });
      }


        function updateListOfWarehousesByUser(userWarehouses) {
            vm.warehousesArray = [];
            vm.userWarehousesArray = [];
            $timeout(function () {
                if (userWarehouses.length !== 0) {
                    vm.allWarehousesArray.forEach(function (element) {
                        const associated = userWarehouses.find(function (fl) {
                            return fl.warehouseId === element.id;
                        });
                        if (associated) {
                          element.userWarehouseId = associated.id;
                          element.userId = associated.userId;
                          element.warehouseId = associated.warehouseId;
                          element.roleApplicationId = associated.roleApplicationId;
                          vm.userWarehousesArray.push(element);
                        } else {
                          vm.warehousesArray.push(element);
                        }
                    });

                } else {
                    vm.warehousesArray = vm.allWarehousesArray;
                }
                vm.warehouseOriginalArray = angular.copy(vm.warehousesArray);
                vm.userWarehouseOriginalArray = angular.copy(vm.userWarehousesArray);

            }, 1000);
        }

        function searchWarehouses() {

            var warehousesList = vm.warehouseOriginalArray;

            if (vm.inputSearchWarehouses === undefined || vm.inputSearchWarehouses === null) {
                return null;
            }

           vm.warehousesArray = warehousesList.filter(function (r) {
                return r.description.includes(vm.inputSearchWarehouses.toLowerCase());

            });

        }

        function searchUserWarehouses() {
            var userWarehousesList = vm.userWarehouseOriginalArray;

            if (vm.inputSearchUserWarehouses === undefined || vm.inputSearchUserWarehouses === null) {
                return null;
            }
            vm.userWarehousesArray = userWarehousesList.filter(function (r) {
                return r.description.includes(vm.inputSearchUserWarehouses.toLowerCase());
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedDataArray.indexOf(data) > -1) {
                vm.selectedDataArray.splice(vm.selectedDataArray.indexOf(data), 1);
            } else {
                vm.selectedDataArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedDataArray.indexOf(data) > -1) {
                vm.selectedAssociatedDataArray.splice(vm.selectedAssociatedDataArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedDataArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedDataArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedDataArray.indexOf(data) > -1;
        }

        function validateSelectAllWarehouses() {

            vm.countWarehousesSelected = 0;

            var isSelectAll = true;

            vm.warehousesArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countWarehousesSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllWarehouses = true;
            } else {
                vm.isCheckAllWarehouses = false;
            }

        }

        function selectAllWarehouses() {
            if (vm.isCheckAllWarehouses) {
                vm.warehousesArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedDataArray.indexOf(row) > -1) {
                        vm.selectedDataArray.push(row);
                    }

                });

                vm.countWarehousesSelected = vm.warehousesArray.length;

            } else {
                vm.warehousesArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedDataArray.indexOf(row) > -1) {
                        vm.selectedDataArray.splice(vm.selectedDataArray.indexOf(row), 1);
                    }

                });

                vm.countWarehousesSelected = 0;
            }
        }

        function validateSelectAllUserWarehouses() {

            vm.countUserWarehousesSelected = 0;

            var isSelectAll = true;

            vm.userWarehousesArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserWarehousesSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserWarehouses = true;
            } else {
                vm.isCheckAllUserWarehouses = false;
            }

        }

        function selectAllUserWarehouses() {
            if (vm.isCheckAllUserWarehouses) {
                vm.userWarehousesArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedDataArray.indexOf(row) > -1) {
                        vm.selectedAssociatedDataArray.push(row);
                    }

                });

                vm.countUserWarehousesSelected = vm.userWarehousesArray.length;

            } else {
                vm.userWarehousesArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedDataArray.indexOf(row) > -1) {
                        vm.selectedAssociatedDataArray.splice(vm.selectedAssociatedDataArray.indexOf(row), 1);
                    }
                });

                vm.countUserWarehousesSelected = 0;
            }
        }

        function associate() {

            var warehousesIdArray = [];

            vm.selectedDataArray.forEach(function (row) {
                warehousesIdArray.push(row.id);
            });

            if (warehousesIdArray.length === 0 && !vm.isCheckAllWarehouses) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.Operaciones2ConfigWS.WarehouseByUser.create({
                'userId': user.id,
            }, warehousesIdArray).$promise.then(function () {
                vm.isShowProgressLinear = false;

                vm.inputSearchUserWarehouses = '';
                getUserWarehouses();

                vm.inputSearchWarehouses = '';
                vm.selectedDataArray = [];

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function disassociate() {

            var warehousesIdArray = [];

            vm.selectedAssociatedDataArray.forEach(function (row) {
                warehousesIdArray.push(row.userWarehouseId);
            });

            if (warehousesIdArray.length === 0 && !vm.isCheckAllUserWarehouses) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.Operaciones2ConfigWS.WarehouseByUser.delete({
                'userId': user.id, 'ids': warehousesIdArray,
            }).$promise.then(function () {
                vm.isShowProgressLinear = false;
                getUserWarehouses();
                vm.selectedAssociatedDataArray = [];

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        $timeout(function () {
            getWarehouses();
            getUserWarehouses();
            getRoleApplications();

            var mdDialog = $('.department-product');
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 155;

            vm.dinamicHeight = {
                'height': windowHeight + 'px',
            };
        }, 1000);

    }

})();

(function () {

    angular
        .module('app.usr')
        .controller('UserDimensionCompanyController', userDimensionCompanyController);

    /**@ngInject**/
    function userDimensionCompanyController($rootScope, $log, $timeout, $filter, $mdDialog, api, MessageService, user) {

      var vm = this;

      vm.arrayListDimensions = [];
      vm.dimensionCompanyArray = [];
      vm.dimensionCompanyList = [];
      vm.userDimensionCompanyArray = [];
      vm.eight_hundred = 800;
      vm.three_hundred = 300;
      vm.two_hundred = 200;
      vm.two_hundred_thirty_five = 235;
      vm.dimensionCompanyId = 0;
      vm.getDimensionCompany = getDimensionCompany;
      vm.cancel = cancel;
      vm.selectAllDimensionCompany = selectAllDimensionCompany;
      vm.selectAllUserDimensionCompany = selectAllUserDimensionCompany;

      vm.validateSelectAllDimensionCompany = validateSelectAllDimensionCompany;
      vm.validateSelectAllUserDimensionCompany = validateSelectAllUserDimensionCompany;

      vm.isSelected = isSelected;
      vm.isSelectedAssociated = isSelectedAssociated;

      vm.selectedArray = [];
      vm.selectedAssociatedArray = [];

      vm.toggle = toggle;
      vm.toggleAssociated = toggleAssociated;

      vm.countDimensionCompanySelected = 0;
      vm.countUserDimensionCompanySelected = 0;

      vm.associate = associate;
      vm.disassociate = disassociate;
      vm.loadAssociated = false;
      vm.load = false;

      vm.searchDimensionCompany = searchDimensionCompany;
      vm.searchUserDimensionCompany = searchUserDimensionCompany;

      vm.pagination = {
        pageNumber: 1,
        pageSize: 50,
        totalElements: 0,
        totalPages: 0,
        nextPage: function () {
          this.pageNumber++;
        },
        beforePage: function () {
          this.pageNumber--;
        },
        firstPage: function () {
          this.pageNumber = 1;
        },
        lastPage: function () {
          this.pageNumber = this.totalPages;
        },
        getPage: function (pageNumber) {
          this.pageNumber = pageNumber;
          getDimensionCompany();
        }
      };

      vm.paginationUserDimensionCompany = {
        pageNumber: 1,
        pageSize: 50,
        totalElements: 0,
        totalPages: 0,
        nextPage: function () {
          this.pageNumber++;
        },
        beforePage: function () {
          this.pageNumber--;
        },
        firstPage: function () {
          this.pageNumber = 1;
        },
        lastPage: function () {
          this.pageNumber = this.totalPages;
        },
        getPage: function (pageNumber) {
          this.pageNumber = pageNumber;
          getUserDimensionCompany();
        }
      };

      function searchDimensionCompany() {
        vm.load = true;
        vm.pagination.pageNumber = 1;
        if (!vm.inputSearchDimensionCompany || vm.inputSearchDimensionCompany.length === 0) {
          getDimensionCompany();
        }
        const arr = vm.dimensionCompanyArray.filter(function (r) {
          return r.dimensionName.toLowerCase().includes(vm.inputSearchDimensionCompany.toLowerCase());
        });
        $timeout(function () {
          vm.dimensionCompanyArray = arr;
          vm.load = false;
        }, vm.eight_hundred);
      }

      function searchUserDimensionCompany() {
        vm.loadAssociated = true;
        vm.paginationUserDimensionCompany.pageNumber = 1;
        if (!vm.inputSearchUserDimensionCompany || vm.inputSearchUserDimensionCompany.length === 0) {
          getDimensionCompany();
        } else {
          const arr = vm.userDimensionCompanyArray.filter(function (r) {
            return r.dimensionName.toLowerCase().includes(vm.inputSearchUserDimensionCompany.toLowerCase());
          });
          $timeout(function () {
            vm.userDimensionCompanyArray = arr;
            vm.loadAssociated = false;
          }, vm.eight_hundred);
        }
      }

      function getDimensionCompany() {
        vm.isShowProgressLinear = true;
        vm.load = true;
        api.GeneralWS.Account.DimensionCompanyDetail.allByDimensionCompany.get(
          {'dimensionCompanyId': vm.dimensionCompanyId}
        ).$promise.then(function (responseDimension) {
          vm.pagination.totalElements = responseDimension.length;
          vm.pagination.totalPages = 1;
          vm.dimensionCompanyArray = responseDimension;
          vm.arrayListDimensions = responseDimension;

          vm.isCheckAllDimensionCompany = false;
          vm.countDimensionCompanySelected = 0;
          $timeout(function () {
            getUserDimensionCompany();
          }, vm.three_hundred);
        }, function () {
          vm.loadingdimensionCompanyDetail3List = false;
          vm.loadingdimensionCompanyDetail4List = false;
          vm.loadingdimensionCompanyDetail5List = false;
          vm.load = false;
        });
      }

      function getUserDimensionCompany() {
        vm.isShowProgressLinear = true;
        vm.loadAssociated = true;
        api.UserWS.UserDimension.byUser.getUser({
          'userId': user.id, 'search': vm.inputSearchUserDimensionCompany
        })
          .$promise.then(function (response) {
          vm.paginationUserDimensionCompany.totalElements = response.length;
          vm.paginationUserDimensionCompany.totalPages = 1;
          const arrUser = [];
          for (let i = 0; i < vm.arrayListDimensions.length; i++) {
            for (let j = 0; j < response.length; j++) {
              if (vm.arrayListDimensions[i] && response[j].dimensionCompanyDetailId === vm.arrayListDimensions[i].id) {
                const userAssignedDimension = vm.arrayListDimensions[i];
                userAssignedDimension.idId = response[j].id;
                arrUser.push(userAssignedDimension);
              }
            }
          }
          $timeout(function () {
            for (let k = 0; k < arrUser.length; k++) {
              for (let l = 0; l < vm.arrayListDimensions.length; l++) {
                if (arrUser[k].id === vm.arrayListDimensions[l].id) {
                  vm.arrayListDimensions.splice(l, 1);
                }
              }
            }
            $timeout(function(){
              vm.userDimensionCompanyArray = arrUser;
              vm.dimensionCompanyArray = vm.arrayListDimensions;
              vm.load = false;
              vm.loadAssociated = false;
            }, vm.two_hundred);

          }, vm.two_hundred);

          vm.isShowProgressLinear = false;
          vm.isCheckAllUserDimensionCompany = false;
          vm.countUserDimensionCompanySelected = 0;

        }, function (response) {
          $log.error(response);
          vm.load = false;
          vm.loadAssociated = false;
          vm.isShowProgressLinear = false;
          MessageService.showErrorMessage($filter('translate')('dimensions.error_load_dimension_user'));
        });
      }

      function cancel() {
        $mdDialog.cancel();
      }

      function toggle(data, event) {
        if (event) {
          event.stopPropagation();
        }
        if (vm.selectedArray.indexOf(data) > -1) {
          vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
        } else {
          vm.selectedArray.push(data);
        }
      }

      function toggleAssociated(data, event) {
        if (event) {
          event.stopPropagation();
        }

        if (vm.selectedAssociatedArray.indexOf(data) > -1) {
          vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
        } else {
          vm.selectedAssociatedArray.push(data);
        }
      }

      function isSelected(data) {
        return vm.selectedArray.indexOf(data) > -1;
      }

      function isSelectedAssociated(data) {
        return vm.selectedAssociatedArray.indexOf(data) > -1;
      }

      function validateSelectAllDimensionCompany() {

        vm.countDimensionCompanySelected = 0;

        var isSelectAll = true;

        vm.dimensionCompanyArray.forEach(function (row) {
          if (!row.isCheck) {
            isSelectAll = false;
          } else {
            vm.countDimensionCompanySelected++;
          }
        });

        if (isSelectAll) {
          vm.isCheckAllDimensionCompany = true;
        } else {
          vm.isCheckAllDimensionCompany = false;
        }

      }

      function selectAllDimensionCompany() {
        if (vm.isCheckAllDimensionCompany) {
          vm.dimensionCompanyArray.forEach(function (row) {
            row.isCheck = true;

            if (!vm.selectedArray.indexOf(row) > -1) {
              vm.selectedArray.push(row);
            }
          });

          vm.countDimensionCompanySelected = vm.dimensionCompanyArray.length;

        } else {
          vm.dimensionCompanyArray.forEach(function (row) {
            row.isCheck = false;

            if (vm.selectedArray.indexOf(row) > -1) {
              vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
            }
          });

          vm.countDimensionCompanySelected = 0;
        }
      }

      function validateSelectAllUserDimensionCompany() {

        vm.countUserDimensionCompanySelected = 0;

        var isSelectAll = true;

        vm.userDimensionCompanyArray.forEach(function (row) {
          if (!row.isCheck) {
            isSelectAll = false;
          } else {
            vm.countUserDimensionCompanySelected++;
          }
        });

        if (isSelectAll) {
          vm.isCheckAllUserDimensionCompany = true;
        } else {
          vm.isCheckAllUserDimensionCompany = false;
        }

      }

      function selectAllUserDimensionCompany() {
        if (vm.isCheckAllUserDimensionCompany) {
          vm.userDimensionCompanyArray.forEach(function (row) {
            row.isCheck = true;

            if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
              vm.selectedAssociatedArray.push(row);
            }

          });

          vm.countUserDimensionCompanySelected = vm.userDimensionCompanyArray.length;

        } else {
          vm.userDimensionCompanyArray.forEach(function (row) {
            row.isCheck = false;

            if (vm.selectedAssociatedArray.indexOf(row) > -1) {
              vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
            }
          });

          vm.countUserDimensionCompanySelected = 0;
        }
      }

      function associate() {

        var dimensionCompanyIdArray = [];

        vm.selectedArray.forEach(function (row) {
          const userDimension = {
            userId: user.id,
            dimensionCompanyId: row.dimensionCompanyId,
            dimensionCompanyDetailId: row.id
          };
          dimensionCompanyIdArray.push(userDimension);
        });

        if (dimensionCompanyIdArray.length === 0 && !vm.isCheckAllDimensionCompany) {
          return null;
        }

        vm.isShowProgressLinear = true;
        api.UserWS.UserDimension.UserDimension.create({
          'idUsuario': user.id,
          'company': $rootScope.bsCircle.company.id
        }, dimensionCompanyIdArray)
          .$promise.then(function (response) {
          vm.isShowProgressLinear = false;

          if (vm.paginationUserDimensionCompany.totalPages === 0) {
            vm.paginationUserDimensionCompany.pageNumber = 1;
          } else {
            vm.paginationUserDimensionCompany.pageNumber = vm.paginationUserDimensionCompany.totalPages;
          }
          vm.inputSearchUserDimensionCompany = "";
          vm.isCheckAllUserDimensionCompany = false;
          vm.pagination.pageNumber = 1;
          vm.isCheckAllDimensionCompany = false;
          vm.inputSearchDimensionCompany = "";
          vm.selectedArray = [];
          getDimensionCompany();

        }, function (response) {
          vm.isShowProgressLinear = false;
          $log.error(response);
          MessageService.showErrorMessage($filter('translate')('dimensions.error_to_assigning_dimension_user'));
        });

      }

      function disassociate() {

        var dimensionCompanyIdArray = [];

        vm.selectedAssociatedArray.forEach(function (row) {
          dimensionCompanyIdArray.push(row.idId);
        });

        if (dimensionCompanyIdArray.length === 0 && !vm.isCheckAllUserDimensionCompany) {
          return null;
        }

        vm.isShowProgressLinear = true;
        api.UserWS.UserDimension.UserDimension.delete({
          'ids': dimensionCompanyIdArray,
          'company': $rootScope.bsCircle.company.id
        })
          .$promise.then(function () {
          vm.isShowProgressLinear = false;

          vm.pagination.pageNumber = 1;
          vm.inputSearchDimensionCompany = "";
          vm.isCheckAllDimensionCompany = false;
          getDimensionCompany();

          vm.paginationUserDimensionCompany.pageNumber = 1;
          vm.inputSearchUserDimensionCompany = "";
          vm.isCheckAllUserDimensionCompany = false;
          vm.selectedAssociatedArray = [];


        }, function (response) {
          vm.isShowProgressLinear = false;
          $log.error(response);
          MessageService.showErrorMessage($filter('translate')('dimensions.error_to_disassociate_dimension_user'));
        });

      }

      function getDimensionCompanyList() {
        api.GeneralWS.DimensionCompany.byCompanyActive.getList(
          {
            'company': $rootScope.bsCircle.company.id
          }
        ).$promise.then(function (response) {
          vm.dimensionCompanyList = response.sort(function (a, b) {
            if (a.id < b.id) {
              return -1;
            }
            if (a.id > b.id) {
              return 1;
            }
            return 0;
          });

          if (vm.dimensionCompanyList.length === 1) {
            vm.dimensionCompanyId = response[0].id;
            getDimensionCompany();
          }
        });
      }

      $timeout(function () {
        getDimensionCompanyList();

        var mdDialog = $(".department-product");
        var windowHeight = parseInt(mdDialog.innerHeight());

        windowHeight -= vm.two_hundred_thirty_five;

        vm.dinamicHeight = {
          "height": windowHeight + "px"
        };

      }, 1000);

    }

})();

(function () {

    angular
        .module('app.usr')
        .controller('DialogUserNotificationController', dialogUserNotificationController);

    /**@ngInject**/
    function dialogUserNotificationController($rootScope, $log, $timeout, $filter, $mdDialog, api, MessageService, user) {
        var vm = this;

        vm.notAssociatedUserNotificationArray = [];
        vm.associatedUserNotificationArray = [];
        vm.selectedNotAssociatedArray = [];
        vm.selectedAssociatedArray = [];
        vm.inputSearchNotAssociated = "";
        vm.inputSearchAssociated = "";

        vm.cancel = cancel;
        vm.selectAllNotAssociated = selectAllNotAssociated;
        vm.selectAllAssociated = selectAllAssociated;
        vm.validateSelectAllNotAssociated = validateSelectAllNotAssociated;
        vm.validateSelectAllAssociated = validateSelectAllAssociated;
        vm.toggleNotAssociated = toggleNotAssociated;
        vm.toggleAssociated = toggleAssociated;
        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;
        vm.associate = associate;
        vm.disassociate = disassociate;
        vm.searchNotAssociated = searchNotAssociated;
        vm.searchAssociated = searchAssociated;

        vm.load = false;

        vm.paginationNotAssociated = {
            pageNumber: 1,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getNotAssociatedUserNotification();
            }
        };

        vm.paginationAssociated = {
            pageNumber: 1,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getAssociatedUserNotification();
            }
        };

        function getNotAssociatedUserNotification() {
            vm.load = true;
            vm.isShowProgressLinear = true;

            api.NotificacionesWS.NotificationType.notAssociatedToUser.page({
                'userId': user.id,
                'companyId': $rootScope.bsCircle.company.id,
                'pageNumber': vm.paginationNotAssociated.pageNumber,
                'pageSize': vm.paginationNotAssociated.pageSize,
                'search': vm.inputSearchNotAssociated
            }).$promise.then(function (data) {
                vm.paginationNotAssociated.totalElements = data.totalElements;
                vm.paginationNotAssociated.totalPages = data.totalPages;
                vm.notAssociatedUserNotificationArray = data.content;

                vm.isShowProgressLinear = false;
                vm.load = false;
                vm.isCheckAllNotAssociated = false;
            }, function (response) {
                $log.error(response);
            });
        }

        function getAssociatedUserNotification() {
            vm.isShowProgressLinear = true;
            vm.loadAssociated = true;

            api.NotificacionesWS.UserNotificationConfig.byUser.page({
                'userId': user.id,
                'companyId': $rootScope.bsCircle.company.id,
                'pageNumber': vm.paginationAssociated.pageNumber,
                'pageSize': vm.paginationAssociated.pageSize,
                'search': vm.inputSearchAssociated
            }).$promise.then(function (data) {
                vm.paginationAssociated.totalElements = data.totalElements;
                vm.paginationAssociated.totalPages = data.totalPages;
                vm.associatedUserNotificationArray = data.content;

                vm.isShowProgressLinear = false;
                vm.loadAssociated = false;
                vm.isCheckAllAssociated = false;
            }, function (response) {
                $log.error(response);
            });
        }

        function searchNotAssociated() {
            if (vm.inputSearchNotAssociated === undefined || vm.inputSearchNotAssociated === null) {
                return null;
            }

            vm.paginationNotAssociated.pageNumber = 1;
            getNotAssociatedUserNotification();
        }

        function searchAssociated() {
            if (vm.inputSearchAssociated === undefined || vm.inputSearchAssociated === null) {
                return null;
            }

            vm.paginationAssociated.pageNumber = 1;
            getAssociatedUserNotification();
        }

        function toggleNotAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedNotAssociatedArray.indexOf(data) > -1) {
                vm.selectedNotAssociatedArray.splice(vm.selectedNotAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedNotAssociatedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedNotAssociatedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAllNotAssociated() {
            var isSelectAll = true;

            vm.notAssociatedUserNotificationArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                }
            });

            vm.isCheckAllNotAssociated = isSelectAll;
        }

        function selectAllNotAssociated() {
            if (vm.isCheckAllNotAssociated) {
                vm.notAssociatedUserNotificationArray.forEach(function (row) {
                    row.isCheck = true;
                    if (!vm.selectedNotAssociatedArray.indexOf(row) > -1) {
                        vm.selectedNotAssociatedArray.push(row);
                    }
                });
            } else {
                vm.notAssociatedUserNotificationArray.forEach(function (row) {
                    row.isCheck = false;
                    if (vm.selectedNotAssociatedArray.indexOf(row) > -1) {
                        vm.selectedNotAssociatedArray.splice(vm.selectedNotAssociatedArray.indexOf(row), 1);
                    }
                });
            }
        }

        function validateSelectAllAssociated() {
            var isSelectAll = true;

            vm.associatedUserNotificationArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                }
            });

            vm.isCheckAllAssociated = isSelectAll;
        }

        function selectAllAssociated() {
            if (!vm.isCheckAllAssociated) {
                vm.associatedUserNotificationArray.forEach(function (row) {
                    row.isCheck = false;
                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });
            } else {
                vm.associatedUserNotificationArray.forEach(function (row) {
                    row.isCheck = true;
                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }
                });
            }
        }

        function associate() {
            var associatedIdArray = [];

            if (!vm.isCheckAllNotAssociated) {
                vm.selectedNotAssociatedArray.forEach(function (row) {
                    associatedIdArray.push(row.id);
                });
            }

            if (associatedIdArray.length === 0 && !vm.isCheckAllNotAssociated) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.NotificacionesWS.UserNotificationConfig.byUser.create({
                'userId': user.id,
                'companyId': $rootScope.bsCircle.company.id,
                'associateAll': vm.isCheckAllNotAssociated,
                'search': vm.inputSearchNotAssociated
            }, associatedIdArray).$promise.then(function () {
                vm.isShowProgressLinear = false;

                if (vm.paginationAssociated.totalPages === 0) {
                    vm.paginationAssociated.pageNumber = 1;
                } else {
                    vm.paginationAssociated.pageNumber = vm.paginationAssociated.totalPages;
                }
                vm.inputSearchAssociated = "";
                getAssociatedUserNotification();

                vm.paginationNotAssociated.pageNumber = 1;
                vm.inputSearchNotAssociated = "";
                vm.selectedNotAssociatedArray = [];
                getNotAssociatedUserNotification();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function disassociate() {
            var disassociatedIdArray = [];

            if (!vm.isCheckAllAssociated) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    disassociatedIdArray.push(row.id);
                });
            }

            if (disassociatedIdArray.length === 0 && !vm.isCheckAllAssociated) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.NotificacionesWS.UserNotificationConfig.byUser.update({
                'userId': user.id,
                'companyId': $rootScope.bsCircle.company.id,
                'deleteAll': vm.isCheckAllAssociated,
                'search': vm.inputSearchAssociated
            }, disassociatedIdArray).$promise.then(function () {
                vm.isShowProgressLinear = false;
                vm.paginationNotAssociated.pageNumber = 1;
                vm.inputSearchNotAssociated = "";
                getNotAssociatedUserNotification();

                vm.paginationAssociated.pageNumber = 1;
                vm.selectedAssociatedArray = [];
                vm.inputSearchAssociated = "";
                getAssociatedUserNotification();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        $timeout(function () {
            getNotAssociatedUserNotification();
            getAssociatedUserNotification();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 155;
            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
        }, 1000);

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

  angular
    .module('app.usr')
    .controller('ProductTypeUserController', productTypeUserController);

  /**@ngInject**/
  function productTypeUserController($rootScope, $log, $timeout, $filter, $mdDialog, api,
                                 MessageService, arrayUtils, user) {

    const vm = this;
    vm.productTypeArray = [];
    vm.productTypeArrayAuxToDisassociate = [];
    vm.userProductTypeArray = [];
    vm.inputSearchUserProductType = '';
    vm.inputSearchProductType = '';
    vm.load = false;
    vm.selectedArray = [];
    vm.selectedAssociatedArray = [];
    vm.countProductTypeSelected = 0;
    vm.countUserProductTypeSelected = 0;
    vm.timeOut100 = 1000;
    vm.cancel = cancel;
    vm.selectAllProductType = selectAllProductType;
    vm.selectAllUserProductType = selectAllUserProductType;
    vm.isSelected = isSelected;
    vm.isSelectedAssociated = isSelectedAssociated;
    vm.toggle = toggle;
    vm.toggleAssociated = toggleAssociated;
    vm.associate = associate;
    vm.disassociate = disassociate;

    function getProductType() {
      vm.selectedProducttype = null;
      vm.searchText = null;
      api.GeneralWS.ProductType.allN1.get(
        {
          'company': $rootScope.bsCircle.company.id, 'idCircle': $rootScope.bsCircle.id,
        }).$promise.then(function (response) {
        vm.productTypeArray = response;
        vm.productTypeArrayAuxToDisassociate = response;
        vm.isCheckAllProductType = false;
        vm.countProductTypeSelected = 0;

      }, function (response) {
        $log.error(response);
        vm.load = false;
      });
    }

    function getUserProductType() {
      vm.isShowProgressLinear = true;
      api.Operaciones2ConfigWS.getProductTypeByUser.get(
        {'userId': user.id}).$promise.then(function (response) {
        vm.isShowProgressLinear = false;
        vm.userProductTypeArray = response;
        vm.isCheckAllUserProductType = false;
        vm.countUserProductTypeSelected = 0;
      }, function (response) {
        $log.error(response);
      });
    }

    function isSelectedAssociated(data) {
      return vm.selectedAssociatedArray.indexOf(data) > -1;
    }

    function isSelected(data) {
      return vm.selectedArray.indexOf(data) > -1;
    }

    function toggle(data, event) {
      if (event) {
        event.stopPropagation();
      }
      if (vm.selectedArray.indexOf(data) > -1) {
        vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
      } else {
        vm.selectedArray.push(data);
      }
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function toggleAssociated(data, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedAssociatedArray.indexOf(data) > -1) {
        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
      } else {
        vm.selectedAssociatedArray.push(data);
      }
    }

    function selectAllProductType() {
      if (vm.isCheckAllProductType) {
        vm.productTypeArray.forEach(function (row) {
          row.isCheck = true;
          vm.selectedArray.push(row);
        });
        vm.countProductTypeSelected = vm.productTypeArray.length;
      } else {
        vm.productTypeArray.forEach(function (row) {
          row.isCheck = false;

          if (vm.selectedArray.indexOf(row) > -1) {
            vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
          }
        });
        vm.countProductTypeSelected = 0;
      }
    }

    function selectAllUserProductType() {
      if (vm.isCheckAllUserProductType) {
        vm.userProductTypeArray.forEach(function (row) {
          row.isCheck = true;
          vm.selectedAssociatedArray.push(row);
        });
        vm.countUserProductTypeSelected = vm.userProductTypeArray.length;
      } else {
        vm.userProductTypeArray.forEach(function (row) {
          row.isCheck = false;

          if (vm.selectedAssociatedArray.indexOf(row) > -1) {
            vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
          }
        });
        vm.countUserProductTypeSelected = 0;
      }
    }

    function associate() {
      const productTypeIdArray = [];
      vm.loadAssociated = true;
      vm.selectedArray.forEach(function (row) {
        productTypeIdArray.push(row.id);
      });

      if (productTypeIdArray.length !== 0) {
        vm.isShowProgressLinear = true;
        api.Operaciones2ConfigWS.createProductType.create({
          'userId': user.id,
        }, productTypeIdArray).$promise.then(function () {
          getUserProductType();
          vm.selectedArray = [];
          setTimeout(function () {
            vm.productTypeArray = arrayUtils.filterArray(vm.productTypeArray, 'id',
              vm.userProductTypeArray, 'productTypeId');
            vm.userProductTypeArray = arrayUtils.mergeArray(vm.userProductTypeArray, 'productTypeId',
              vm.productTypeArrayAuxToDisassociate, 'id', 'productType'
            );
            vm.loadAssociated = false;
            $rootScope.$digest();
          }, vm.timeOut100);
          vm.isCheckAllProductType = false;

        }, function (response) {
          vm.isShowProgressLinear = false;
          $log.error(response);
          MessageService.showErrorMessage($filter('translate')('general.general_error'));
        });
      }
    }

    function disassociate() {
      const productTypeIdArray = [];
      vm.loadAssociated = true;
      vm.selectedAssociatedArray.forEach(function (row) {
        productTypeIdArray.push(row.id);
      });

      if (productTypeIdArray.length !== 0) {
        vm.isShowProgressLinear = true;
        api.Operaciones2ConfigWS.deleteProductType.delete({
          'userId': user.id, 'ids': productTypeIdArray,
        }).$promise.then(function () {
          vm.selectedAssociatedArray = [];
          vm.isCheckAllProductType = false;
          getUserProductType();
          setTimeout(function () {
            vm.productTypeArray = arrayUtils.filterArray(vm.productTypeArrayAuxToDisassociate, 'id',
              vm.userProductTypeArray, 'productTypeId');
            vm.userProductTypeArray = arrayUtils.mergeArray(vm.userProductTypeArray, 'productTypeId',
              vm.productTypeArrayAuxToDisassociate, 'id', 'productType'
            );
            vm.loadAssociated = false;
            $rootScope.$digest();
          }, vm.timeOut100);

        }, function (response) {
          MessageService.showErrorMessage($filter('translate')('general.general_error'));
          $log.error(response);
          vm.isShowProgressLinear = false;
        });
      }
    }

    const timeOut = 1800;
    $timeout(function () {
      const timeOutArrays = 1600;
      const windowHeightNumber = 155;
      getProductType();
      getUserProductType();
      vm.load = true;
      vm.loadAssociated = true;
      setTimeout(function () {
        vm.productTypeArray = arrayUtils.filterArray(vm.productTypeArray, 'id',
          vm.userProductTypeArray, 'productTypeId');
        vm.userProductTypeArray = arrayUtils.mergeArray(vm.userProductTypeArray, 'productTypeId',
          vm.productTypeArrayAuxToDisassociate, 'id', 'productType'
        );
        vm.load = false;
        vm.loadAssociated = false;
        $rootScope.$digest();
      }, timeOutArrays);

      const mdDialog = $('.department-product');
      let windowHeight = parseInt(mdDialog.innerHeight(), 10);
      windowHeight -= windowHeightNumber;
      vm.dinamicHeight = {
        'height': windowHeight + 'px',
      };
    }, timeOut);
  }

})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('EstablishmentRoleUserController', establishmentRoleUserController);

    /**@ngInject**/
    function establishmentRoleUserController($rootScope, $log, $timeout, $mdDialog, api, user, company, POSApplication, MessageService) {

        var vm = this;

        vm.roles = [];
        vm.establishmentArray = [];
        vm.establishmentRoleUserArray = [];
        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.cancel = cancel;
        vm.loadEstablishmentRoleUser = loadEstablishmentRoleUser;

        vm.isSelected = isSelected;
        vm.validateSelectAllEstablishment = validateSelectAllEstablishment;
        vm.selectAllEstablishment = selectAllEstablishment;

        vm.selectAllEstablishmentRoleUser = selectAllEstablishmentRoleUser;
        vm.isSelectedAssociated = isSelectedAssociated;
        vm.validateSelectAllEstablishmentRoleUser = validateSelectAllEstablishmentRoleUser;

        vm.associate = associate;
        vm.disassociate = disassociate;
        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.getEstablishment = getEstablishment;
        vm.getEstablishmentRoleUser = getEstablishmentRoleUser;
        vm.employee = null;
        vm.inputSearchEmployeeCode = '';
        vm.getAllEmployeeByCompanyCode=getAllEmployeeByCompanyCode;
        vm.employeeArray = [];
        vm.associateEmployeeToUser=associateEmployeeToUser;
        vm.disableAssociateButton = false;
        vm.withoutEmployeeCode = false;
        vm.canAssociateWithoutEmployeeCode = false;

        vm.paginationEstablishment = {
            pageNumber: 1,
            pageSize: 10,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getEstablishment();
            }
        };

        vm.paginationEstablishmentRoleUser = {
            pageNumber: 1,
            pageSize: 10,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getEstablishmentRoleUser();
            }
        };

        function loadEstablishmentRoleUser() {
            vm.paginationEstablishmentRoleUser.pageNumber = 1;
            vm.paginationEstablishment.pageNumber = 1;

            vm.establishmentArray = [];
            vm.establishmentRoleUserArray = [];

            getEstablishment();
            getEstablishmentRoleUser();
        }

        function getEstablishment() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.establishmentNotAssociatedToUser.page({
                'roleApplicationId': vm.roleApplicationId,
                'userId': user.id,
                'companyId': company.id,
                'pageNumber': (vm.paginationEstablishment.pageNumber),
                'pageSize': vm.paginationEstablishment.pageSize,
                'search': vm.inputSearchCompanyEstablishment
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.paginationEstablishment.totalElements = response.totalElements;
                vm.paginationEstablishment.totalPages = response.totalPages;
                vm.establishmentArray = response.content;

                vm.isCheckAllEstablishment = false;
                vm.selectedArray = [];
            }, function (response) {
                $log.error(response);
            });
        }

        function getEstablishmentRoleUser() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.establishmentAssociatedToUser.page({
                'roleApplicationId': vm.roleApplicationId,
                'userId': user.id,
                'companyId': company.id,
                'pageNumber': (vm.paginationEstablishmentRoleUser.pageNumber),
                'pageSize': vm.paginationEstablishmentRoleUser.pageSize,
                'search': vm.inputSearchCompanyEstablishmentRoleUser
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.paginationEstablishmentRoleUser.totalElements = response.totalElements;
                vm.paginationEstablishmentRoleUser.totalPages = response.totalPages;
                vm.establishmentRoleUserArray = response.content;

                vm.isCheckAllEstablishmentRoleUser = false;
                vm.selectedAssociatedArray = [];
            }, function (response) {
                $log.error(response);
            });
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function validateSelectAllEstablishment() {
            var isSelectAll = true;

            vm.establishmentArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllEstablishment = true;
            } else {
                vm.isCheckAllEstablishment = false;
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function selectAllEstablishment() {
            if (vm.isCheckAllEstablishment) {
                vm.establishmentArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });
            } else {
                vm.establishmentArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });
            }
        }

        function validateSelectAllEstablishmentRoleUser() {
            var isSelectAll = true;

            vm.establishmentRoleUserArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllEstablishmentRoleUser = true;
            } else {
                vm.isCheckAllEstablishmentRoleUser = false;
            }
        }

        function selectAllEstablishmentRoleUser() {
            if (vm.isCheckAllEstablishmentRoleUser) {
                vm.establishmentRoleUserArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }
                });
            } else {
                vm.establishmentRoleUserArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });
            }
        }

        function associate() {
            var establishmentIdArray = [];

            if (!vm.isCheckAllEstablishment) {
                establishmentIdArray = vm.selectedArray.map(function (row) {
                    return row.id;
                });
            }

            if (establishmentIdArray.length === 0 && !vm.isCheckAllEstablishment) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.byRoleApplication.create({
                'roleApplicationId': vm.roleApplicationId,
                'associateAll': vm.isCheckAllEstablishment,
                'userId': user.id,
                'companyId': company.id,
                'search': vm.inputSearchCompanyEstablishment
            }, establishmentIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.paginationEstablishmentRoleUser.pageNumber = 1;
                getEstablishmentRoleUser();

                vm.paginationEstablishment.pageNumber = 1;
                vm.selectedArray = [];
                vm.inputSearchCompanyEstablishment = "";
                getEstablishment();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function disassociate() {
            var establishmentIdArray = [];

            if (!vm.isCheckAllEstablishmentRoleUser) {
                establishmentIdArray = vm.selectedAssociatedArray.map(function (row) {
                    return row.id;
                });
            }

            if (establishmentIdArray.length === 0 && !vm.isCheckAllEstablishmentRoleUser) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablismentRoleUser.byRoleApplication.update({
                'roleApplicationId': vm.roleApplicationId,
                'deleteAll': vm.isCheckAllEstablishmentRoleUser,
                'userId': user.id,
                'companyId': company.id,
                'search': vm.inputSearchCompanyEstablishmentRoleUser
            }, establishmentIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.paginationEstablishment.pageNumber = 1;
                getEstablishment();

                vm.paginationEstablishmentRoleUser.pageNumber = 1;
                vm.selectedAssociatedArray = [];
                vm.inputSearchCompanyEstablishmentRoleUser = "";
                getEstablishmentRoleUser();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function getRoleApplication() {
            vm.isShowProgressLinearRoles = true;
            api.GeneralWS.RoleApplication.me.get({
                'applicationId': POSApplication.id
            }).$promise.then(function (response) {
                vm.roles = response;
                vm.isShowProgressLinearRoles = false;
            }, function (d) {
                vm.isShowProgressLinearRoles = false;
            });
        }

        $timeout(function () {
            getRoleApplication();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());
            windowHeight -= 300;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
            verifyExistEmployeeByUser();
            verifyUserRoleCanAssociateWithoutEmployee();

        }, 1000);

        function cancel() {
            $mdDialog.cancel();
        }

      function verifyExistEmployeeByUser() {
        api.RecursosHumanosWS.Employee.byUserId.getList({'companyId': 0, 'userId': user.id}, function (response) {
            if (response && response.userId) {
                vm.employee = response;
            }
        }, function (err) {
          $log.error(err);
          console.log(err);
        });
      }

      function getAllEmployeeByCompanyCode() {
        api.RecursosHumanosWS.Employee.byEmployeeCompanyCode.getList({
            'companyId': $rootScope.bsCircle.company.id, 'employeeCompanyCode': vm.inputSearchEmployeeCode
          },
          function (response) {
            vm.employeeArray = response;
            if (response.length === 1) {
              MessageService.show('company_establishment.employee_found');
            } else if (response.length > 1) {
              MessageService.showErrorMessage('company_establishment.error_exist_more_employee');
            } else {
              MessageService.showErrorMessage('company_establishment.error_not_exist_employee');
            }
          }, function (errResponse) {
            $log.error(errResponse);
          });
      }

      function associateEmployeeToUser() {
        vm.isShowProgressLinear = true;
        $timeout(function () {
          vm.disableAssociateButton = true;
          api.RecursosHumanosWS.Employee.doUpdateUserEmployee.doSetUser({
            'companyId': $rootScope.bsCircle.company.id,
            'employeeId': vm.employeeArray[0].employeeId,
            'userId': user.id
          }, function (responseEmployee) {
            if (responseEmployee.employeeId === vm.employeeArray[0].employeeId) {
              vm.employee = vm.employeeArray[0];
            }
            MessageService.show('company_establishment.user_associated_to_employee_successfully');
            vm.isShowProgressLinear = false;
          }, function (errResponseEmployee) {
            if (errResponseEmployee && errResponseEmployee.data) {
              MessageService.showErrorMessage('company_establishment.' + errResponseEmployee.data.mensaje);
            }
            $log.error(errResponseEmployee);
            vm.disableAssociateButton = false;
            vm.isShowProgressLinear = false;
          });
        }, 100);
      }

      function verifyUserRoleCanAssociateWithoutEmployee() {
        var exist = $rootScope.getEspecialActionByName('Asociar Usuario Sin Codigo de Empleado');
        if (exist) {
          vm.canAssociateWithoutEmployeeCode = true;
        }
      }

    }
})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('UserDepartmentController', userDepartmentController);

    /**@ngInject**/
    function userDepartmentController($rootScope, $log, $timeout, $mdDialog, api, user) {

        var vm = this;

        vm.departmentArray = [];
        vm.userDepartmentArray = [];
        vm.cancel = cancel;
        vm.selectAllDepartments = selectAllDepartments;
        vm.selectAllUserDepartments = selectAllUserDepartments;

        vm.validateSelectAllDepartments = validateSelectAllDepartments;
        vm.validateSelectAllUserDepartments = validateSelectAllUserDepartments;

        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.countDepartmentSelected = 0;
        vm.countUserDepartmentSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.searchDepartment = searchDepartment;
        vm.searchUserDepartment = searchUserDepartment;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getDepartment();
            }
        };

        vm.paginationUserDepartment = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getUserDepartment();
            }
        };

        function searchDepartment() {
            vm.pagination.pageNumber = 1;
            getDepartment();
        }

        function searchUserDepartment() {
            vm.paginationUserDepartment.pageNumber = 1;
            getUserDepartment();
        }

        function getDepartment() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Account.Department.notAssociatedToUser.page({
                'idc': $rootScope.bsCircle.company.id, 'userId': user.id, 'pageNumber': vm.pagination.pageNumber,
                'pageSize': vm.pagination.pageSize, 'search': vm.inputSearchDepartment
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.departmentArray = response.content;

                vm.isCheckAllDepartments = false;
                vm.countDepartmentSelected = 0;

            }, function (response) {
                $log.error(response);
            });
        }

        function getUserDepartment() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserDepartment.me.page({
                'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id,
                'pageNumber': vm.paginationUserDepartment.pageNumber, 'pageSize': vm.paginationUserDepartment.pageSize, 'search': vm.inputSearchUserDepartment
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.paginationUserDepartment.totalElements = response.totalElements;
                    vm.paginationUserDepartment.totalPages = response.totalPages;
                    vm.userDepartmentArray = response.content;

                    vm.isCheckAllUserDepartment = false;
                    vm.countUserDepartmentSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAllDepartments() {

            vm.countDepartmentSelected = 0;

            var isSelectAll = true;

            vm.departmentArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countDepartmentSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllDepartments = true;
            } else {
                vm.isCheckAllDepartments = false;
            }

        }

        function selectAllDepartments() {
            if (vm.isCheckAllDepartments) {
                vm.departmentArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countDepartmentSelected = vm.departmentArray.length;

            } else {
                vm.departmentArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countDepartmentSelected = 0;
            }
        }

        function validateSelectAllUserDepartments() {

            vm.countUserDepartmentSelected = 0;

            var isSelectAll = true;

            vm.userDepartmentArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserDepartmentSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserDepartment = true;
            } else {
                vm.isCheckAllUserDepartment = false;
            }

        }

        function selectAllUserDepartments() {
            if (vm.isCheckAllUserDepartment) {
                vm.userDepartmentArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }

                });

                vm.countUserDepartmentSelected = vm.userDepartmentArray.length;

            } else {
                vm.userDepartmentArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserDepartmentSelected = 0;
            }
        }

        function associate() {

            var departmentIdArray = [];

            if (!vm.isCheckAllDepartment) {
                vm.selectedArray.forEach(function (row) {
                    departmentIdArray.push(row.id);
                });
            }

            if (departmentIdArray.length === 0 && !vm.isCheckAllDepartment) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserDepartment.me.create({
                'associateAll': vm.isCheckAllDepartments, 'idUsuario': user.id,
                'company': $rootScope.bsCircle.company.id, 'search': vm.inputSearchDepartment
            }, departmentIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    if (vm.paginationUserDepartment.totalPages === 0) {
                        vm.paginationUserDepartment.pageNumber = 1;
                    } else {
                        vm.paginationUserDepartment.pageNumber = vm.paginationUserDepartment.totalPages;
                    }
                    vm.inputSearchUserDepartment = "";
                    vm.isCheckAllUserDepartment = false;
                    getUserDepartment();

                    vm.pagination.pageNumber = 1;
                    vm.isCheckAllDepartments = false;
                    vm.inputSearchDepartment = "";
                    vm.selectedArray = [];
                    getDepartment();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });

        }

        function disassociate() {

            var departmentIdArray = [];

            if (!vm.isCheckAllUserDepartment) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    departmentIdArray.push(row.department.id);
                });
            }

            if (departmentIdArray.length === 0 && !vm.isCheckAllUserDepartment) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserDepartment.me.update({
                'deleteAll': vm.isCheckAllUserDepartment, 'idUsuario': user.id,
                'company': $rootScope.bsCircle.company.id, 'search': vm.inputSearchUserDepartment
            }, departmentIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.pageNumber = 1;
                    vm.inputSearchDepartment = "";
                    vm.isCheckAllDepartment = false;
                    getDepartment();

                    vm.paginationUserDepartment.pageNumber = 1;
                    vm.inputSearchUserDepartment = "";
                    vm.isCheckAllUserDepartment = false;
                    vm.selectedAssociatedArray = [];

                    getUserDepartment();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });

        }

        $timeout(function () {
            getDepartment();
            getUserDepartment();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 155;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };

        }, 1000);

    }

})();

(function () {

    angular
        .module('app.usr')
        .controller('UserCountryController', userCountryController);

    /**@ngInject**/
    function userCountryController($rootScope, $log, $timeout, $filter, $mdDialog, api, MessageService, user) {

        var vm = this;
        vm.countryArray = [];
        vm.userCountryArray = [];
        vm.cancel = cancel;
        vm.selectAllCountry = selectAllCountry;
        vm.selectAllUserCountry = selectAllUserCountry;

        vm.validateSelectAllCountry = validateSelectAllCountry;
        vm.validateSelectAllUserCountry = validateSelectAllUserCountry;

        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.countCountrySelected = 0;
        vm.countUserCountrySelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.searchCountry = searchCountry;
        vm.inputSearchCountry = "";

        vm.searchUserCountry = searchUserCountry;
        vm.inputSearchUserCountry = "";

        vm.load = false;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getCountry();
            }
        };

        vm.paginationUserCountry = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getUserCountry();
            }
        };

        function getCountry() {
            vm.isShowProgressLinear = true;
            vm.load = true;
            api.GeneralWS.Country.notAssociatedToUser.page({
                'userId': user.id,
                'pageNumber': vm.pagination.pageNumber,
                'pageSize': vm.pagination.pageSize,
                'search': vm.inputSearchCountry
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.load = false;

                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.countryArray = response.content;

                vm.isCheckAllCountry = false;
                vm.countCountrySelected = 0;

            }, function (response) {
                $log.error(response);
            });
        }

        function getUserCountry() {
            vm.isShowProgressLinear = true;
            vm.loadAssociatedProducts = true;

            api.GeneralWS.Usr.UserCountry.AssociatedToUser.page({
                'idUsuario': user.id,
                'pageNumber': vm.paginationUserCountry.pageNumber, 
                'pageSize': vm.paginationUserCountry.pageSize, 
                'search': vm.inputSearchUserCountry
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    vm.loadAssociatedProducts = false;

                    vm.paginationUserCountry.totalElements = response.totalElements;
                    vm.paginationUserCountry.totalPages = response.totalPages;
                    vm.userCountryArray = response.content;

                    vm.isCheckAllUserCountry = false;
                    vm.countUserCountrySelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function searchCountry() {

            if (vm.inputSearchCountry === undefined || vm.inputSearchCountry === null) {
                return null;
            }

            vm.pagination.pageNumber = 1;
            getCountry();
        }

        function searchUserCountry() {
            if (vm.inputSearchUserCountry === undefined || vm.inputSearchUserCountry === null) {
                return null;
            }

            vm.paginationUserCountry.pageNumber = 1;
            getUserCountry();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAllCountry() {

            vm.countCountrySelected = 0;

            var isSelectAll = true;

            vm.countryArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countCountrySelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllCountry = true;
            } else {
                vm.isCheckAllCountry = false;
            }

        }

        function selectAllCountry() {
            if (vm.isCheckAllCountry) {
                vm.countryArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }

                });

                vm.countCountrySelected = vm.countryArray.length;

            } else {
                vm.countryArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }

                });

                vm.countCountrySelected = 0;
            }
        }

        function validateSelectAllUserCountry() {

            vm.countUserCountrySelected = 0;

            var isSelectAll = true;

            vm.userCountryArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserCountrySelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserCountry = true;
            } else {
                vm.isCheckAllUserCountry = false;
            }

        }

        function selectAllUserCountry() {
            if (vm.isCheckAllUserCountry) {
                vm.userCountryArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }

                });

                vm.countUserCountrySelected = vm.userCountryArray.length;

            } else {
                vm.userCountryArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserCountrySelected = 0;
            }
        }

        function associate() {

            var countryIdArray = [];

            if (!vm.isCheckAllCountry) {
                vm.selectedArray.forEach(function (row) {
                    countryIdArray.push(row.id);
                });
            }

            if (countryIdArray.length === 0 && !vm.isCheckAllCountry) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserCountry.me.create({
                'associateAll': vm.isCheckAllCountry, 'search': vm.inputSearchCountry,
                'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id
            }, countryIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (vm.paginationUserCountry.totalPages === 0) {
                    vm.paginationUserCountry.pageNumber = 1;
                } else {
                    vm.paginationUserCountry.pageNumber = vm.paginationUserCountry.totalPages;
                }
                vm.inputSearchUserCountry = "";
                getUserCountry();

                vm.pagination.pageNumber = 1;
                vm.inputSearchCountry = "";
                vm.selectedArray = [];
                getCountry();

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function disassociate() {

            var countryIdArray = [];
            if (!vm.isCheckAllUserCountry) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    countryIdArray.push(row.id);
                });
            }

            if (countryIdArray.length === 0 && !vm.isCheckAllUserCountry) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserCountry.me.update({
                'deleteAll': vm.isCheckAllUserCountry, 'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id
            }, countryIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.pageNumber = 1;
                    getCountry();

                    vm.paginationUserCountry.pageNumber = 1;
                    vm.selectedAssociatedArray = [];

                    getUserCountry();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });

        }

        $timeout(function () {
            getCountry();
            getUserCountry();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 155;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
        }, 1000);

    }

})();

(function () {

    angular
        .module('app.usr')
        .controller('UserCostCenterController', userCostCenterController);

    /**@ngInject**/
    function userCostCenterController($rootScope, $log, $timeout, $filter, $mdDialog, api, MessageService, user) {

        var vm = this;
        vm.costCenterArray = [];
        vm.userCostCenterArray = [];
        vm.cancel = cancel;
        vm.selectAllCostCenter = selectAllCostCenter;
        vm.selectAllUserCostCenter = selectAllUserCostCenter;

        vm.validateSelectAllCostCenter = validateSelectAllCostCenter;
        vm.validateSelectAllUserCostCenter = validateSelectAllUserCostCenter;

        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.countCostCenterSelected = 0;
        vm.countUserCostCenterSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.searchCostCenter = searchCostCenter;
        vm.inputSearchCostCenter = "";

        vm.searchUserCostCenter = searchUserCostCenter;
        vm.inputSearchUserCostCenter = "";

        vm.load = false;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getCostCenter();
            }
        };

        vm.paginationUserCostCenter = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getUserCostCenter();
            }
        };

        function getCostCenter() {
            vm.isShowProgressLinear = true;
            vm.load = true;
            api.GeneralWS.Account.CostCenter.notAssociatedToUser.page({
                'idc': $rootScope.bsCircle.company.id, 'userId': user.id, 'pageNumber': vm.pagination.pageNumber,
                'pageSize': vm.pagination.pageSize, 'search': '%'+vm.inputSearchCostCenter+'%'
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.load = false;

                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.costCenterArray = response.content;

                vm.isCheckAllCostCenter = false;
                vm.countCostCenterSelected = 0;

            }, function (response) {
                $log.error(response);
            });
        }

        function getUserCostCenter() {
            vm.isShowProgressLinear = true;
            vm.loadAssociatedProducts = true;

            api.GeneralWS.Usr.UserCostCenter.me.page({
                'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id,
                'pageNumber': vm.paginationUserCostCenter.pageNumber, 'pageSize': vm.paginationUserCostCenter.pageSize, 'search': '%'+vm.inputSearchUserCostCenter+'%'
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    vm.loadAssociatedProducts = false;

                    vm.paginationUserCostCenter.totalElements = response.totalElements;
                    vm.paginationUserCostCenter.totalPages = response.totalPages;
                    vm.userCostCenterArray = response.content;

                    vm.isCheckAllUserCostCenter = false;
                    vm.countUserCostCenterSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function searchCostCenter() {

            if (vm.inputSearchCostCenter === undefined || vm.inputSearchCostCenter === null) {
                return null;
            }

            vm.pagination.pageNumber = 1;
            getCostCenter();
        }

        function searchUserCostCenter() {
            if (vm.inputSearchUserCostCenter === undefined || vm.inputSearchUserCostCenter === null) {
                return null;
            }

            vm.paginationUserCostCenter.pageNumber = 1;
            getUserCostCenter();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAllCostCenter() {

            vm.countCostCenterSelected = 0;

            var isSelectAll = true;

            vm.costCenterArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countCostCenterSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllCostCenter = true;
            } else {
                vm.isCheckAllCostCenter = false;
            }

        }

        function selectAllCostCenter() {
            if (vm.isCheckAllCostCenter) {
                vm.costCenterArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }

                });

                vm.countCostCenterSelected = vm.costCenterArray.length;

            } else {
                vm.costCenterArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }

                });

                vm.countCostCenterSelected = 0;
            }
        }

        function validateSelectAllUserCostCenter() {

            vm.countUserCostCenterSelected = 0;

            var isSelectAll = true;

            vm.userCostCenterArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserCostCenterSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserCostCenter = true;
            } else {
                vm.isCheckAllUserCostCenter = false;
            }

        }

        function selectAllUserCostCenter() {
            if (vm.isCheckAllUserCostCenter) {
                vm.userCostCenterArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }

                });

                vm.countUserCostCenterSelected = vm.userCostCenterArray.length;

            } else {
                vm.userCostCenterArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserCostCenterSelected = 0;
            }
        }

        function associate() {

            var costCenterIdArray = [];

            if (!vm.isCheckAllCostCenter) {
                vm.selectedArray.forEach(function (row) {
                    costCenterIdArray.push(row.id);
                });
            }

            if (costCenterIdArray.length === 0 && !vm.isCheckAllCostCenter) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserCostCenter.me.create({
                'associateAll': vm.isCheckAllCostCenter, 'search': vm.inputSearchCostCenter,
                'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id
            }, costCenterIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (vm.paginationUserCostCenter.totalPages === 0) {
                    vm.paginationUserCostCenter.pageNumber = 1;
                } else {
                    vm.paginationUserCostCenter.pageNumber = vm.paginationUserCostCenter.totalPages;
                }
                vm.inputSearchUserCostCenter = "";
                getUserCostCenter();

                vm.pagination.pageNumber = 1;
                vm.inputSearchCostCenter = "";
                vm.selectedArray = [];
                getCostCenter();

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function disassociate() {

            var costCenterIdArray = [];

            if (!vm.isCheckAllUserCostCenter) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    costCenterIdArray.push(row.costCenter.id);
                });
            }

            if (costCenterIdArray.length === 0 && !vm.isCheckAllUserCostCenter) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.Usr.UserCostCenter.me.update({
                'deleteAll': vm.isCheckAllUserCostCenter, 'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id
            }, costCenterIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.pageNumber = 1;
                    getCostCenter();

                    vm.paginationUserCostCenter.pageNumber = 1;
                    vm.selectedAssociatedArray = [];

                    getUserCostCenter();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });

        }

        $timeout(function () {
            getCostCenter();
            getUserCostCenter();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 155;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
        }, 1000);

    }

})();

(function () {

    angular
        .module('app.usr')
        .controller('UserCompanyEstablishmentController', userCompanyEstablishmentController);

    /**@ngInject**/
    function userCompanyEstablishmentController($rootScope, $log, $timeout, $filter, $mdDialog, api, MessageService, user) {

        var vm = this;
        vm.companyEstablishmentArray = [];
        vm.userCompanyEstablishmentArray = [];
        vm.cancel = cancel;
        vm.selectAllCompanyEstablishment = selectAllCompanyEstablishment;
        vm.selectAllUserCompanyEstablishment = selectAllUserCompanyEstablishment;

        vm.validateSelectAllCompanyEstablishment = validateSelectAllCompanyEstablishment;
        vm.validateSelectAllUserCompanyEstablishment = validateSelectAllUserCompanyEstablishment;

        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];

        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;

        vm.countCompanyEstablishmentSelected = 0;
        vm.countUserCompanyEstablishmentSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.searchCompanyEstablishment = searchCompanyEstablishment;
        vm.inputSearchCompanyEstablishment = "";

        vm.searchUserCompanyEstablishment = searchUserCompanyEstablishment;
        vm.inputSearchUserCompanyEstablishment = "";

        vm.load = false;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getCompanyEstablishment();
            }
        };

        vm.paginationUserCompanyEstablishment = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getUserCompanyEstablishment();
            }
        };

        function getCompanyEstablishment() {
            vm.isShowProgressLinear = true;
            vm.load = true;
            api.GeneralWS.CompanyEstablishment.notAssociatedToUser.page({
                'idc': $rootScope.bsCircle.company.id,
                'userId': user.id,
                'pageNumber': vm.pagination.pageNumber,
                'pageSize': vm.pagination.pageSize,
                'search': vm.inputSearchCompanyEstablishment
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.load = false;

                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.companyEstablishmentArray = response.content;

                vm.isCheckAllCompanyEstablishment = false;
                vm.countCompanyEstablishmentSelected = 0;

            }, function (response) {
                $log.error(response);
            });
        }

        function getUserCompanyEstablishment() {
            vm.isShowProgressLinear = true;
            vm.loadAssociatedProducts = true;

            api.GeneralWS.UserCompanyEstablishment.AssociatedToUser.page({
                'idUsuario': user.id,
                'pageNumber': vm.paginationUserCompanyEstablishment.pageNumber, 
                'pageSize': vm.paginationUserCompanyEstablishment.pageSize, 
                'search': vm.inputSearchUserCompanyEstablishment
            })
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    vm.loadAssociatedProducts = false;

                    vm.paginationUserCompanyEstablishment.totalElements = response.totalElements;
                    vm.paginationUserCompanyEstablishment.totalPages = response.totalPages;
                    vm.userCompanyEstablishmentArray = response.content;

                    vm.isCheckAllUserCompanyEstablishment = false;
                    vm.countUserCompanyEstablishmentSelected = 0;

                }, function (response) {
                    $log.error(response);
                });
        }

        function searchCompanyEstablishment() {

            if (vm.inputSearchCompanyEstablishment === undefined || vm.inputSearchCompanyEstablishment === null) {
                return null;
            }

            vm.pagination.pageNumber = 1;
            getCompanyEstablishment();
        }

        function searchUserCompanyEstablishment() {
            if (vm.inputSearchUserCompanyEstablishment === undefined || vm.inputSearchUserCompanyEstablishment === null) {
                return null;
            }

            vm.paginationUserCompanyEstablishment.pageNumber = 1;
            getUserCompanyEstablishment();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        function validateSelectAllCompanyEstablishment() {

            vm.countCompanyEstablishmentSelected = 0;

            var isSelectAll = true;

            vm.companyEstablishmentArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countCompanyEstablishmentSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllCompanyEstablishment = true;
            } else {
                vm.isCheckAllCompanyEstablishment = false;
            }

        }

        function selectAllCompanyEstablishment() {
            if (vm.isCheckAllCompanyEstablishment) {
                vm.companyEstablishmentArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }

                });

                vm.countCompanyEstablishmentSelected = vm.companyEstablishmentArray.length;

            } else {
                vm.companyEstablishmentArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }

                });

                vm.countCompanyEstablishmentSelected = 0;
            }
        }

        function validateSelectAllUserCompanyEstablishment() {

            vm.countUserCompanyEstablishmentSelected = 0;

            var isSelectAll = true;

            vm.userCompanyEstablishmentArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countUserCompanyEstablishmentSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllUserCompanyEstablishment = true;
            } else {
                vm.isCheckAllUserCompanyEstablishment = false;
            }

        }

        function selectAllUserCompanyEstablishment() {
            if (vm.isCheckAllUserCompanyEstablishment) {
                vm.userCompanyEstablishmentArray.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }

                });

                vm.countUserCompanyEstablishmentSelected = vm.userCompanyEstablishmentArray.length;

            } else {
                vm.userCompanyEstablishmentArray.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countUserCompanyEstablishmentSelected = 0;
            }
        }

        function associate() {

            var companyEstablishmentIdArray = [];

            if (!vm.isCheckAllCompanyEstablishment) {
                vm.selectedArray.forEach(function (row) {
                    companyEstablishmentIdArray.push(row.id);
                });
            }

            if (companyEstablishmentIdArray.length === 0 && !vm.isCheckAllCompanyEstablishment) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.UserCompanyEstablishment.me.create({
                'associateAll': vm.isCheckAllCompanyEstablishment, 'search': vm.inputSearchCompanyEstablishment,
                'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id
            }, companyEstablishmentIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (vm.paginationUserCompanyEstablishment.totalPages === 0) {
                    vm.paginationUserCompanyEstablishment.pageNumber = 1;
                } else {
                    vm.paginationUserCompanyEstablishment.pageNumber = vm.paginationUserCompanyEstablishment.totalPages;
                }
                vm.inputSearchUserCompanyEstablishment = "";
                getUserCompanyEstablishment();

                vm.pagination.pageNumber = 1;
                vm.inputSearchCompanyEstablishment = "";
                vm.selectedArray = [];
                getCompanyEstablishment();

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function disassociate() {

            var companyEstablishmentIdArray = [];
            if (!vm.isCheckAllUserCompanyEstablishment) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    companyEstablishmentIdArray.push(row.id);
                });
            }

            if (companyEstablishmentIdArray.length === 0 && !vm.isCheckAllUserCompanyEstablishment) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.UserCompanyEstablishment.me.update({
                'deleteAll': vm.isCheckAllUserCompanyEstablishment, 'idUsuario': user.id, 'company': $rootScope.bsCircle.company.id
            }, companyEstablishmentIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.pagination.pageNumber = 1;
                    getCompanyEstablishment();

                    vm.paginationUserCompanyEstablishment.pageNumber = 1;
                    vm.selectedAssociatedArray = [];

                    getUserCompanyEstablishment();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });

        }

        $timeout(function () {
            getCompanyEstablishment();
            getUserCompanyEstablishment();

            var mdDialog = $(".department-product");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 155;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
        }, 1000);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.usr')
        .controller('ReportUsersDimensionController', reportUsersDimensionController);

    /** @ngInject */
    function reportUsersDimensionController(api, $rootScope, $filter, $timeout) {

        var vm = this;

        vm.title = 'dimensions.dimensionsCompany';
        vm.isShowFilter = true;
        vm.filterDimension = true;
        vm.masterColumnDefs = [];
        vm.dimensionCompanyList = [];
        vm.one_thousand = 1000;

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: false,
            fullWidthCellRenderer: true,
            rowHeight: 40,
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: 1,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        //metodos
        vm.search = search;

        function addColumnsToGrid() {
            vm.masterColumnDefs = [
                {
                    headerName: $filter('translate')('dimensions.dimensionsCompany'),
                    field: 'dimensionCompanyDetailName',
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true,
                    rowGroup: true,
                    hide: true,
                    rowGroupIndex: 0
                },
                {
                    headerName: $filter('translate')('reporUsersRoles.usuario'),
                    field: 'user.name',
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: $filter('translate')('reportsUsers.email'),
                    field: 'user.account',
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true
                }
            ];

            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }


        function search() {
            addColumnsToGrid();
            vm.masterGridOptions.api.setRowData([]);

            vm.isShowProgressLinear = true;
            vm.hasData = false;
            api.UserWS.UserDimension.byDimensionCompanyId.getList({ }, [Number(vm.dimensionCompanySelected)], function (response) {
                vm.showGrid = true;
                vm.isShowProgressLinear = false;
                vm.data = response;
              vm.distinctUsers = response.map(function (r) {
                return r.userId;
              }).filter(function (x, i, arr) {
                return arr.indexOf(x) === i;
              });
              vm.distinctDimensionCompanyDetails = response.map(function (r) {
                return r.dimensionCompanyDetailId;
              }).filter(function (x, i, arr) {
                return arr.indexOf(x) === i;
              });
              api.GeneralWS.Usr.User.getFilterByIds.getList({}, vm.distinctUsers, function (respUsers) {
                vm.usersList = respUsers;
                vm.data.map(function (r) {
                  r.user = vm.usersList.filter(function (row) {
                    return row.id === r.userId;
                  })[0];
                });
              });

              api.GeneralWS.Account.DimensionCompanyDetail.byIds.getDetails({'idList': vm.distinctDimensionCompanyDetails}, function (respDimensions) {
                vm.dimensionCompanyDetailList = respDimensions;
                vm.data.map(function (r) {
                  r.dimensionCompanyDetail = vm.dimensionCompanyDetailList.filter(function (row) {
                    return row.id === r.dimensionCompanyDetailId;
                  })[0];
                  r.dimensionCompanyDetailName = r.dimensionCompanyDetail.code + ' - ' + r.dimensionCompanyDetail.name;
                });
              });
              $timeout(function () {
                transformData();
              }, vm.one_thousand);

                vm.hasData = response.length > 0;
            }, function (d) {
            });

            vm.isShowFilter = false;
        }

        function init() {

          getDimensionCompanyList();

            vm.onExportXLS = function () {
                var params = {
                    skipHeader: false,
                    skipFooters: false,
                    skipGroups: false,
                    allColumns: true,
                    onlySelected: false,
                    fileName: 'Report' + new Date().getTime() + '.xls',
                    columnSeparator: ',',
                    sheetName: 'data'
                };

                params.processCellCallback = function (params) {
                    return agGridFormatToExport(params);
                };

                vm.masterGridOptions.api.exportDataAsExcel(params);
            };

        }

      function getDimensionCompanyList() {
        api.GeneralWS.DimensionCompany.byCompanyActive.getList(
          {
            'company': $rootScope.bsCircle.company.id
          }
        ).$promise.then(function (response) {
          vm.dimensionCompanyList = response.sort(function (a, b) {
            if (a.id < b.id) {
              return -1;
            }
            if (a.id > b.id) {
              return 1;
            }
            return 0;
          });
          if (vm.dimensionCompanyList.length === 1) {
            vm.dimensionCompanySelected = vm.dimensionCompanyList[0].id;
            search();
          }

        });
      }

      function transformData(){
        vm.masterGridOptions.api.setRowData(
          vm.data
        );
      }

        init();

    }
})();

(function () {
    'use strict';

    angular
        .module('app.usr')
        .controller('ReportUsersDeparmentController', ReportUsersDeparmentController);

    /** @ngInject */
    function ReportUsersDeparmentController(api, $rootScope, $filter, $timeout) {

        var vm = this;

        vm.title = 'menu.reportUsersDepartment';
        vm.isShowFilter = true;
        vm.masterColumnDefs = [];

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: false,
            fullWidthCellRenderer: true,
            rowHeight: 40,
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: 1,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        //metodos
        vm.search = search;

        function addColumnsToGrid() {
            vm.masterColumnDefs = [
                {
                    headerName: $filter('translate')('reportsUsers.department'),
                    field: "department",
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true,
                    rowGroupIndex: 0
                },
                {
                    headerName: $filter('translate')('reporUsersRoles.usuario'),
                    field: "userName",
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: $filter('translate')('reportsUsers.email'),
                    field: "userAccount",
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true
                }
            ];

            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }


        function search() {
            addColumnsToGrid();
            vm.masterGridOptions.api.setRowData([]);

            vm.isShowProgressLinear = true;
            vm.hasData = false;
            api.GeneralWS.Departments.allUserInfo.get({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.showGrid = true;
                vm.isShowProgressLinear = false;

                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(response)
                    .select(function (r) {
                        var d = r;
                        d.usuario = d.userName + '(' + d.userAccount + ')';
                        d.department = d.roleName + ' - ' + d.roleDescription;
                        return d;
                    })
                );

                vm.hasData = response.length > 0;
            }, function (d) {
            });

            vm.isShowFilter = false;
        }

        function init() {

            vm.onExportXLS = function () {
                var params = {
                    skipHeader: false,
                    skipFooters: false,
                    skipGroups: false,
                    allColumns: true,
                    onlySelected: false,
                    fileName: 'Report' + new Date().getTime() + '.xls',
                    columnSeparator: ',',
                    sheetName: 'data'
                };

                params.processCellCallback = function (params) {
                    return agGridFormatToExport(params);
                };

                vm.masterGridOptions.api.exportDataAsExcel(params);
            };

            $timeout(function () {
                search();
            }, 1000);

        }

        init();

    }
})();

(function () {
    'use strict';

    angular
        .module('app.usr')
        .controller('ReportUsersCostCenterController', ReportUsersCostCenterController);

    /** @ngInject */
    function ReportUsersCostCenterController(api, $rootScope, $filter, $timeout) {

        var vm = this;

        vm.title = 'menu.reportUsersCostCenter';
        vm.isShowFilter = true;
        vm.masterColumnDefs = [];

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: false,
            fullWidthCellRenderer: true,
            rowHeight: 40,
            rowGroupPanelShow: 'always',
            groupDefaultExpanded: 1,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        //metodos
        vm.search = search;

        function addColumnsToGrid() {
            vm.masterColumnDefs = [
                {
                    headerName: $filter('translate')('reportsUsers.costCenter'),
                    field: "costCenter",
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true,
                    rowGroupIndex: 0
                },
                {
                    headerName: $filter('translate')('reporUsersRoles.usuario'),
                    field: "userName",
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: $filter('translate')('reportsUsers.email'),
                    field: "userAccount",
                    width: 400,
                    suppressFilter: false,
                    enableRowGroup: true,
                    enablePivot: true
                }
            ];

            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }


        function search() {
            addColumnsToGrid();
            vm.masterGridOptions.api.setRowData([]);

            vm.isShowProgressLinear = true;
            vm.hasData = false;
            api.GeneralWS.CostCenters.allUserInfo.get({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.showGrid = true;
                vm.isShowProgressLinear = false;

                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(response)
                    .select(function (r) {
                        var d = r;
                        d.usuario = d.userName + '(' + d.userAccount + ')';
                        d.costCenter = d.roleName + ' - ' + d.roleDescription;
                        return d;
                    })
                );

                vm.hasData = response.length > 0;
            }, function (d) {
            });

            vm.isShowFilter = false;
        }

        function init() {

            vm.onExportXLS = function () {
                var params = {
                    skipHeader: false,
                    skipFooters: false,
                    skipGroups: false,
                    allColumns: true,
                    onlySelected: false,
                    fileName: 'Report' + new Date().getTime() + '.xls',
                    columnSeparator: ',',
                    sheetName: 'data'
                };

                params.processCellCallback = function (params) {
                    return agGridFormatToExport(params);
                };

                vm.masterGridOptions.api.exportDataAsExcel(params);
            };

            $timeout(function () {
                search();
            }, 1000);

        }

        init();

    }
})();

(function () {
  'use strict';

  angular
    .module('app.account')
    .controller('AssociateRolJobDialogController', associateRolJobDialogController);


  /**@ngInject**/
  function associateRolJobDialogController(
    $mdDialog,
    $rootScope,
    api,
    $timeout,
    $log,
    $scope,
    MessageService,
    companyRolJobData
  ){
    var vm = this;


    vm.saveRolJob = saveRolJob;
    vm.cancel = cancel;
    vm.getApplication = getApplication;
    vm.getRol = getRol;
    vm.builRoleJobData = builRoleJobData;
    vm.createRoleJob = createRoleJob;
    vm.updateRoleJob = updateRoleJob;
    vm.getRolDialog = getRolDialog;

    vm.companyRoleJobNewData = companyRolJobData;

    vm.dinamicStyle = {
      'width': '50%',
      'height': '65%'
    };

    function cancel() {
      $mdDialog.cancel();
    }

    function saveRolJob() {
      if (vm.companyRoleJobNewData.id != null) {
        vm.updateRoleJob();
      } else {

        vm.createRoleJob();
      }
    }
    function builRoleJobData() {
      var newData = {
        companyId: $rootScope.bsCircle.company.id,
        rolApplicationId: vm.companyRoleJobNewData.rolApplicationId,
        jobHrId: vm.companyRoleJobNewData.jobHrId
      };
      return newData;
    }

      function createRoleJob() {
        vm.isShowProgressLinear = true;
        if (vm.companyRoleJobNewData.jobHrId > 0 && vm.companyRoleJobNewData.applicationId != null &&
          vm.companyRoleJobNewData.rolApplicationId != null) {
          api.UserWS.CompanyRolJob.meCreate.create(
            {},
            vm.builRoleJobData()).$promise.then(
            function () {
              vm.isShowProgressLinear = false;
              vm.companyRoleJobNewData.roles.forEach(function (item){
                if (vm.companyRoleJobNewData.rolApplicationId === item.id) {
                  vm.companyRoleJobNewData.name = item.name;
                  vm.companyRoleJobNewData.description = item.description;
                  vm.companyRoleJobNewData.active = true;
                }
              });
              MessageService.show('associateRoleJobHR.associateCreatedSuccessfully');
              $mdDialog.hide(vm.companyRoleJobNewData);
            }, function (error) {

              MessageService.showErrorMessage('associateRoleJobHR.error_created');
              $log.error(error);
              vm.isShowProgressLinear = false;
            });
        } else {
          MessageService.showErrorMessage('associateRoleJobHR.error_jobCode_not_be_null');
          vm.isShowProgressLinear = false;
        }
      }

    function updateRoleJob() {
      vm.isShowProgressLinear = true;
      if (vm.companyRoleJobNewData.jobHrId > 0 && vm.companyRoleJobNewData.applicationId != null &&
        vm.companyRoleJobNewData.rolApplicationId != null) {
        api.UserWS.CompanyRolJob.meUpdate.update({'id': vm.companyRoleJobNewData.id},
          vm.companyRoleJobNewData).$promise.then(function () {
          $rootScope.isShowProgressLinear = false;
          MessageService.show('associateRoleJobHR.associateUpdatedSuccessfully');
          $mdDialog.hide(vm.companyRoleJobNewData);

        }, function (error) {
          $rootScope.isShowProgressLinear = false;
          MessageService.showErrorMessage('associateRoleJobHR.error_updated');
          $log.error(error);
        });
      } else{
        MessageService.showErrorMessage('associateRoleJobHR.error_jobCode_not_be_null');
        vm.isShowProgressLinear = false;
      }
    }


    function getApplication() {

      vm.loadingRoleApplication = true;
      api.GeneralWS.CompanyApplication.appsByCompany.query({
        'company': vm.companyRoleJobNewData.companyId,
      }).$promise.then(function (resp) {
        vm.roleApplications = resp;
        vm.loading = false;
        vm.loadingRoleApplication = false;
      }, function (err) {
        vm.loadingRoleApplication = false;
        vm.loading = false;
        $log.error(err);
      });
    }

    function getRol(appId){
      var id = appId;
      vm.loadingRoleApplication = true;
      $timeout(function () {
        api.GeneralWS.RoleApplication.me.get({
          'applicationId': id,
        }).$promise.then(function (resp) {
          vm.companyRoleJobNewData.roles = resp;
          vm.loading = false;
          vm.loadingRoleApplication = false;
        }, function (err) {
          vm.loading = false;
          vm.loadingRoleApplication = false;
          $log.error(err);
        });
      }, 800);
    }

    function getRolDialog(){
      vm.loadingRoleApplication = true;
      api.GeneralWS.RoleApplication.me.get({
        'applicationId': vm.companyRoleJobNewData.applicationId,
      }).$promise.then(function (resp) {
        vm.role = resp;
        vm.loading = false;
        vm.loadingRoleApplication = false;
      }, function (err) {
        vm.loadingRoleApplication = false;
        vm.loading = false;
        $log.error(err);
      });
    }






    function init() {
      if (vm.companyRoleJobNewData.applicationData === null || vm.companyRoleJobNewData.applicationData === undefined) {
        vm.getApplication();
      }
      if (vm.companyRoleJobNewData.roles === null || vm.companyRoleJobNewData.roles === undefined) {
        vm.getRol(vm.companyRoleJobNewData.applicationId);
        vm.companyRoleJobNewData.roles = vm.role;
      }
      var contentHeightShow = $('#department').innerHeight();
      contentHeightShow -= 112;
      vm.dinamicHeight = { 'height': contentHeightShow + 'px' };
      var height;
      height = window.innerHeight;

      var windowHeightShow = parseInt(height);

      if (windowHeightShow < 700) {
        vm.dinamicStyle.height = '100%';
      } else if (windowHeightShow < 800) {
        vm.dinamicStyle.height = '80%';
      }
    }
    $timeout(function () {

    }, 500);
    init();
  }
})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('AssociateEquivalenceRoleListController', AssociateEquivalenceRoleListController);

    /**@ngInject**/
    function AssociateEquivalenceRoleListController($rootScope, $log, api, MessageService, $filter, $timeout) {

        var vm = this;
        vm.getEquivalencesByApplication = getEquivalencesByApplication;
        vm.updateEquivalenceValue = updateEquivalenceValue;

        var columnDefs = [
            {
                field: "roleApplication.description",
                headerName: 'associateEquivalenceRole.role',
                headerCellRenderer: getHeader,
                width: 500
            }
            , {
                field: "jobCode",
                headerName: 'associateEquivalenceRole.value',
                headerCellRenderer: getHeader,
                width: 200,
                cellRenderer: function (params) {
                    return '<center><input id="documentNumber" autocomplete="off" ng-model="data.jobCode" ng-enter="vm.updateEquivalenceValue(data)" style="text-align: right"/></center>';
                }
            }
            , {
                field: "save",
                headerName: 'associateEquivalenceRole.save',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.updateEquivalenceValue(data)'> <md-icon md-font-icon='icon-content-save'></md-icon> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowSelection: 'multiple',
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getNodeChildDetails: function (file) {
                if (file.folder && file.children.length > 0) {
                    return {
                        group: true,
                        children: file.children,
                        expanded: file.open
                    };
                } else {
                    return null;
                }
            }
        };

        function getEquivalencesByApplication(application) {
            if (vm.application) {
                if (vm.application.id === application.id) {
                    return null;
                }
            }
            vm.application = application;

            if (vm.application === null && vm.application === undefined) {
                return null;
            }
            getEquivalences();
        }

        function getEquivalences() {
            vm.showGrid = false;
            vm.isShowProgressLinearGrid = true;
            api.GeneralWS.Usr.AssociateEquivalenceRole.allWithRoleNotPresentByCompanyAndApplication
                .get({ 'companyId': $rootScope.bsCircle.company.id, 'applicationId': vm.application.id }).$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    response.sort(function (a, b) {
                        if (a.roleApplication.description < b.roleApplication.description) { return -1; }
                        if (a.roleApplication.description > b.roleApplication.description) { return 1; }
                        return 0;
                    });
                    vm.grid.api.setRowData(response);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                }, function (response) {
                    vm.grid.api.setRowData([]);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                    $log.error(response);
                });
        }

        function updateEquivalenceValue(equivalence) {
            vm.isShowProgressLinear = true;

            if (equivalence.id) {
                api.GeneralWS.Usr.AssociateEquivalenceRole.me.update({ 'id': equivalence.id }, equivalence).$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('associateEquivalenceRole.equivalenceUpdatedSuccessfully'));
                    getEquivalences();
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
                return;
            }

            equivalence.company = { id: $rootScope.bsCircle.company.id }
            api.GeneralWS.Usr.AssociateEquivalenceRole.me.create({}, equivalence).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                MessageService.show($filter('translate')('associateEquivalenceRole.equivalenceCreatedSuccessfully'));
                getEquivalences();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function init() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyApplication.me.query({ 'company': $rootScope.bsCircle.company.id, 'includeServices': true }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                vm.applicationArray = new jinqJs()
                    .from(response)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('PrenegotiatedPriceController', PrenegotiatedPriceController);

    /**@ngInject**/
    function PrenegotiatedPriceController($mdDialog, api, productCompanyBuy, currencies, $log, MessageService, $filter, $timeout, $rootScope) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;
        vm.productCompanyBuy = productCompanyBuy;
        vm.productCompanyBuy.taxesIncluded = !vm.productCompanyBuy.taxesIncluded ? false : vm.productCompanyBuy.taxesIncluded;
        vm.visibleCompanies = true;
        vm.addProductSale = false;
        vm.minDate = new Date();
        vm.currencies = currencies;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;
        vm.onEdit = onEdit;
        vm.getAllCompanies = getAllCompanies;
        vm.getProductSales = getProductSales;
        vm.changeFilter = changeFilter;
        vm.selectItem = selectItem;
        vm.flipping = flipping;
        vm.selectProviderToAdd = selectProviderToAdd;

        vm.newContact = true;
        vm.flip;

        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }

        function getProductSales(page) {
            vm.loading = true;
            api.GeneralWS.getAllCompaniesProviders.page(
                {
                    'pageNumber': page - 1, 'pageSize': vm.pageSize, 'search': vm.filterProvider, 'companyId': $rootScope.bsCircle.company.id, 'includeMe': false
                },
                function (data) {
                    vm.productSales = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function getAllCompanies(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.Company.page(
                {
                    'id': 'isActive', pageNumber: page - 1, pageSize: vm.pageSize, search: vm.filterProvider, includeMe: false, companyId: $rootScope.bsCircle.company.id
                },
                function (data) {
                    vm.companies = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function changeFilter() {
            if (vm.addProductSale === false) {
                getProductSales(1);
            } else {
                getAllCompanies(1);
            }
        }

        function selectItem(item) {
            if (vm.addProductSale === true) {
                vm.selectedCompany = item;
                vm.selectedProductSale = { company: item };
                vm.productCompanyBuy.productSale = { product: vm.productCompanyBuy.productSale.product, company: item };
                vm.productCompanyBuy.currency = { id: $rootScope.bsCircle.company.currency.id };
                vm.flip();
            } else {
                vm.selectedCompany = item;
                vm.selectedProductSale = item;
                vm.productCompanyBuy.productSale.company = item;
                vm.productCompanyBuy.price = null;
                vm.productCompanyBuy.taxesIncluded = null;
                vm.productCompanyBuy.currency = null;
                vm.productCompanyBuy.price = item.salePrice > 0 ? item.salePrice : null;
                vm.productCompanyBuy.taxesIncluded = item.isPriceIncludeTaxes === true ? true : false;
                vm.productCompanyBuy.currency = item.currencySale ? { id: item.currencySale.id } : { id: $rootScope.bsCircle.company.currency.id };
                vm.flip();
            }
        }

        function save() {

            if (vm.productBuyForm.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }

            if (!vm.productCompanyBuy.productSale || !vm.productCompanyBuy.productSale.company) {
                MessageService.showErrorMessage($filter('translate')('pre-negotiated_price.select_provider'));
                return false;
            }

            var promise;
            if (vm.productCompanyBuy.id) {
                promise = api.GeneralWS.ProductCompanyBuy.me.update({ 'id': vm.productCompanyBuy.id, 'idCircle': $rootScope.bsCircle.id }, vm.productCompanyBuy).$promise;
            } else {
                promise = api.GeneralWS.ProductCompanyBuy.me.create({ 'idCircle': $rootScope.bsCircle.id }, vm.productCompanyBuy).$promise;
            }
            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                if (response.status === 409) {
                    MessageService.showErrorMessage($filter('translate')('pre-negotiated_price.dates_conflict'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

        function onEdit() {
            vm.flip();
            changeFilter();
            $timeout(function () {
                document.getElementById("searchFilter").focus();
            }, 600);
        }
        function selectProviderToAdd(addProductSale) {
            if (addProductSale === true) {
                vm.addProductSale = true;
                changeFilter();
                $timeout(function () {
                    document.getElementById("searchFilter").focus();
                }, 500);
            } else {
                vm.addProductSale = false;
                changeFilter();
                $timeout(function () {
                    document.getElementById("searchFilter").focus();
                }, 500);
            }
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ProductTypeDialogController', ProductTypeDialogController);

    /**@ngInject**/
    function ProductTypeDialogController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog, productType, ProductSaleValidationType) {
        var vm = this;
        vm.cancel = cancel;
        vm.productType = productType ? productType : { active: true, canOrder: false };
        vm.addChildren = addChildren;
        vm.viewButtons = true;
        vm.getApplications = getApplications;
        vm.getParametersByApplication = getParametersByApplication;
        vm.updateParameterValue = updateParameterValue;
        vm.updateAdditionalField = updateAdditionalField;
        vm.productSaleValidationType = ProductSaleValidationType;
        vm.loadingProductCondition = false;
        vm.productConditionArray = [];
        vm.productGenders = [];
        vm.changeGrouporCreate = changeGrouporCreate;
        vm.active = true;
        vm.updateChildProduct = false;
        vm.onDelete = onDelete;

        vm.pagination = {
            page: 0,
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        vm.dtOptionsParameters = {
            columnDefs: [
                {
                    // Target the id column
                    targets: 0,
                    responsivePriority: 1
                },
                {
                    // Target the actions column
                    targets: 1,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                },
                {
                    // Target the actions column
                    targets: 2,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ],
            order: [[0, "asc"]],
            paging: false,
            responsive: true,
            info: false,
            searching: false
        };

        vm.dtOptionsParameters2 = {
            columnDefs: [
                {
                    targets: 0,
                    responsivePriority: 1
                }
            ],
            order: [[0, "asc"]],
            paging: false,
            responsive: true,
            info: false,
            searching: false
        };

        $timeout(init, 500);

        vm.saveProductType = function (ev) {
            var promise;
            if (vm.productType.id) {
                promise = api.GeneralWS.ProductType.byCompany.update({
                    'company': $rootScope.bsCircle.company.id,
                    'id': vm.productType.id,
                    'idCircle': $rootScope.bsCircle.id,
                    'updateChildProduct': vm.updateChildProduct},
                    vm.productType
                    ).$promise;
            } else {
                promise = api.GeneralWS.ProductType.byCompany.create({
                    'company': $rootScope.bsCircle.company.id,
                    'idCircle': $rootScope.bsCircle.id }, vm.productType
                    ).$promise;
            }

            promise.then(function (response) {
                $mdDialog.hide(response);
            }, function (errResponse) {
                $log.error(errResponse);
                if(errResponse.data.mensaje) {
                    MessageService.showErrorMessage($filter('translate')('productType.msg.' + errResponse.data.mensaje));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });
        };

        function init() {
            api.GeneralWS.CompanyEstablishment.me.page({
                'id': 'byCompany',
                'idCircle': $rootScope.bsCircle.id,
                'page': 1, 'pageSize': 100, 'active': vm.active
            }).$promise.then(function (response) {
                vm.companyestablishments = response.content;
                getProductCondition();
                getProductGender();
            }, function (response) {
                $log.error(response);
            });
        }

        function getProductCondition() {
            vm.loadingProductCondition = true;
            api.GeneralWS.ProductCondition.allActive.query({ }, function (response) {
                vm.productConditionArray = response;
                vm.loadingProductCondition = false;
            }, function (errResponse) {
                $log.error(errResponse);
                vm.loadingProductCondition = false;
            });
        }

        function getProductGender() {
            vm.loadingProductGender = true;
            api.GeneralWS.ProductGender.allActive.query({ }, function (response) {
                vm.productGenders = response;
                vm.loadingProductGender = false;
            }, function (errResponse) {
                $log.error(errResponse);
                vm.loadingProductGender = false;
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function addChildren() {
            vm.productType = {
                active : true,
                canOrder: false,
                productTypeParent: productType
            };
        }

        function getApplications() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyApplication.me.query({ 'company': $rootScope.bsCircle.company.id, 'includeServices': true }).$promise.then(function (response) {

                vm.isShowProgressLinear = false;

                vm.applicationArray = response;

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function getParametersByApplication(application) {
            vm.application = application;

            vm.pagination.pageNumber = 0;
            vm.content = [];
            vm.padditionals = [];
            vm.groups = [];
            if (vm.application === null && vm.application === undefined) {
                return;
            }
            createSourcesGroups();
            createNewDatasource();
            createAdditionalsFields();
        }

        function createSourcesGroups() {
            api.GeneralWS.ProductCompanyAdditionalFields.query(
                {
                    'app': vm.application, 'productType': vm.productType.id,
                    'establishmentId': vm.companyEstablishment.id, 'id': 'groups'
                }
            ).$promise.then(function (response) {
                $log.debug(response);
                vm.groups = response;
            }, function (response) {
                $log.error(response);
            });
            return true;
        }

        function changeGrouporCreate(additional) {
            additional.newGroup = additional.newGroup ? '' : additional.productAddonFieldGroup.name;
            additional.productAddonFieldGroup.name = !additional.newGroup ? additional.newGroup : '';
        }

        function createNewDatasource() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductTypeParameter.byCompany.get(
                {
                    'app': vm.application, 'productTypeId': vm.productType.id,
                    'establishmentId': vm.companyEstablishment.id, 'idCircle': $rootScope.bsCircle.id,
                    'pageNumber': (vm.pagination.pageNumber + 1), 'pageSize': vm.pagination.pageSize
                }
            ).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                $log.debug(response);
                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.pagination.pageNumber = response.number + 1;
                vm.content = new jinqJs()
                    .from(response.content)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                        if (r.applicationParameter.dataType === 'BOOLEAN') {
                            r.parameterValue = (r.parameterValue === 'true');
                        }
                      if (r.applicationParameter.dataType === 'DECIMAL') {
                        r.parameterValue = parseFloat(r.parameterValue);
                      }
                        return r;
                    });
                vm.showGrid = true;
            }, function (response) {
                $log.error(response);
            });
            return true;
        }

        function createAdditionalsFields() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductCompanyAdditionalFields.query(
                {
                    'app': vm.application, 'productType': vm.productType.id,
                    'establishmentId': vm.companyEstablishment.id
                }
            ).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                $log.debug(response);
                vm.padditionals = response;
                vm.showGridAdd = true;
            }, function (response) {
                $log.error(response);
            });
            return true;
        }

        function updateAdditionalField(additionalField) {
            var ob = angular.copy(additionalField);
            delete ob.newGroup;
            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductCompanyAdditionalFields.create({
                'app': vm.application, 'productType': vm.productType.id,
                'establishmentId': vm.companyEstablishment.id, 'id': additionalField.id ? additionalField.id : 0
            }, ob).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                additionalField = response;
                MessageService.show($filter('translate')('company_parameters.parameter_updated_successfully'));

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function onDelete() {
            if (vm.productType.id && !vm.productType.active) {
                var confirm = $mdDialog.confirm()
                .multiple(true)
                .title($filter('translate')('productType.disableProductType'))
                .textContent($filter('translate')('productType.confirmaDesactivar1') + $filter('translate')('productType.confirmaDesactivar2'))
                .ariaLabel($filter('translate')('productType.desactivarCuenta'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

                $mdDialog.show(confirm).then(function () {
                    var promise;
                    promise = api.GeneralWS.ProductType.byCompany.del({
                        'company': $rootScope.bsCircle.company.id,
                        'id': vm.productType.id,
                        'idCircle': $rootScope.bsCircle.id}
                        ).$promise;

                    vm.isShowProgressLinear = true;
                    promise.then(function (response) {
                        vm.isShowProgressLinear = false;
                        MessageService.show($filter('translate')('productType.msg.updated'));
                        $mdDialog.hide(response);

                    }, function (response) {
                        vm.isShowProgressLinear = false;
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    });
                }, function () {
                    vm.productType.active = true;
                });
            }
        }

        function updateParameterValue(productTypeParameter) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductTypeParameter.byCompany.update({
                'idCircle': $rootScope.bsCircle.id, 'productTypeId': vm.productType.id, 'establishmentId': vm.companyEstablishment.id,
                'updateChildProduct': vm.updateChildProduct
            }, productTypeParameter).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                MessageService.show($filter('translate')('company_parameters.parameter_updated_successfully'));

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        vm.clearSearchApplication = function () {
            vm.searchApplication = "";
        };

        vm.clearSearchCompanyEstablishment = function () {
            vm.searchCompanyEstablishment = "";
        };

        vm.clearSearchProductCondition = function () {
            vm.searchProductCondition = "";
        };

        vm.clearSearchProductGender = function () {
            vm.searchProductGender = "";
        };

        vm.clearSearchProductSaleValidationType = function () {
            vm.searchProductSaleValidationType = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchApplicationInput = document.querySelector("#searchApplication");

            if (searchApplicationInput) {
                searchApplicationInput.addEventListener("keydown", keyEvent);
            }

        }, 500);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ProductGroupAccountingCatalogController', productGroupAccountingCatalogController);

    /**@ngInject**/
    function productGroupAccountingCatalogController($log, $filter, $mdDialog, $timeout, productCompanyGroup, api, $rootScope, MessageService) {

        var vm = this;
        vm.productCompanyGroup = productCompanyGroup;

        vm.cancel = cancel;
        vm.onAdd = onAdd;
        vm.onSave = onSave;
        vm.onEdit = onEdit;
        vm.onDelete = onDelete;

        vm.indexView = 0;

        vm.page = 1;
        vm.pageSize = 20;

        vm.flip;
        vm.flipping = flipping;
        vm.newAccount = true;
        vm.selectAccount = selectAccount;
        vm.getAccounts = getAccounts;
        vm.onAccountingCatalog = onAccountingCatalog;
        vm.changeFilter = changeFilter;

        /**
         * methods
         */
        var columnDefs = [
            {
                field: "accountingCatalog.code",
                headerName: 'productGroup.groupCode',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "accountingCatalog.description",
                headerName: 'productAccount.description',
                headerCellRenderer: getHeader,
                width: 250
            },
            {
                field: "accountType.acTypeDescription",
                headerName: 'productAccount.accountType',
                headerCellRenderer: getHeader,
                width: 250
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                        return '<center> '
                            + ' <md-button class="md-icon-button" ng-click="vm.onEdit(data)"> '
                            + ' <md-icon md-font-icon="icon-border-color"></md-icon> '
                            + ' <md-tooltip md-direction="left" >{{"general.edit"| translate}}</md-tooltip> '
                            + ' </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            columnDefs: columnDefs,
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            enableFilter: true,
            rowHeight: 40,
            angularCompileRows: true,
            angularCompileHeaders: true,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        }

        function onAdd() {
            vm.indexView = 1;

            vm.productGroupAccountingCatalog = {
                id: null,
                productCompanyGroup: vm.productCompanyGroup,
                accountingCatalog: null,
                accountType: null,
                active: true
            };
        }

        function getAccounts(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.Account.AccountingCatalog.ByDescription.get({ 'company': vm.productCompanyGroup.company.id, page: page - 1, size: vm.pageSize, filter: vm.filterAccount },
                function (data) {
                    vm.accounts = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function flipping(funct) {
            vm.flip = funct;
            if (vm.newAccount) {
                funct();
            }
        }

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getAccounts(1);
            }
        }

        function selectAccount(account) {
            vm.selectedAccount = account;
            vm.productGroupAccountingCatalog.accountingCatalog = account;
            vm.flip();
        }

        function onAccountingCatalog() {
            vm.flip();
            changeFilter();
            $timeout(function () {
                document.getElementById("searchAccount").focus();
            }, 600);
        }

        function cancel() {
            if (vm.indexView === 1) {
                vm.indexView = 0;
            } else {
                $mdDialog.cancel();
            }
        }

        function onSave() {
            vm.isShowProgressLinear = true;
            var promise;

            if (vm.productGroupAccountingCatalog.id) {
                promise = api.GeneralWS.ProductCompanyGroupAccountingCatalog.me.update({'id': vm.productGroupAccountingCatalog.id, 'idCircle': $rootScope.bsCircle.id }, vm.productGroupAccountingCatalog).$promise;
            } else {
                promise = api.GeneralWS.ProductCompanyGroupAccountingCatalog.me.create({'id': undefined, 'idCircle': $rootScope.bsCircle.id }, vm.productGroupAccountingCatalog).$promise;
            }
            promise.then(function (response) {
                switch (response.$status) {
                    case 200:
                        MessageService.show($filter('translate')('productGroup.MSG.updated'));
                        break;
                    case 201:
                        MessageService.show($filter('translate')('productGroup.MSG.added'));
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

                onGetAccountingCatalog();

                vm.isShowProgressLinear = false;
                vm.indexView = 0;

            }, function (errResponse) {
                if (errResponse.data != null) {
                    MessageService.showErrorMessage($filter('translate')('productGroup.MSG.' + errResponse.data));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general.error'));
                }

                vm.isShowProgressLinear = false;
            });
        }

        function onEdit(data) {
            vm.indexView = 1;

            vm.productGroupAccountingCatalog = angular.copy(data);
        }

        function onDelete(data) {
            vm.productGroupAccountingCatalog = angular.copy(data);
            vm.productGroupAccountingCatalog.active = false;

            onSave();
        }
        
        function init() {
            vm.grid.api.setRowData([]);

            vm.isShowProgressLinear = true;
            vm.showGrid = true;
            
            api.GeneralWS.Account.AccountType.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.accountType = response;
            }, function (response) {
                $log.error(response);
            });

            onGetAccountingCatalog();
        }

        function onGetAccountingCatalog() {
            api.GeneralWS.ProductCompanyGroupAccountingCatalog.byProductCompanyGroup.get({ 'productCompanyGroupId': vm.productCompanyGroup.id })
            .$promise.then(function (response) {
                response = $filter('orderBy')(response, 'id');
                vm.grid.api.setRowData(response)

                vm.isShowProgressLinear = false;
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function changeSearch() {
            vm.clearSearchAccountType = function () {
                vm.searchAccountType = "";
            };

            $timeout(function () {
                var keyEvent = function (event) {
                    event.stopPropagation();
                };

                var searchAccountTypeInput = document.querySelector("#searchAccountType");

                if (searchAccountTypeInput) {
                    searchAccountTypeInput.addEventListener("keydown", keyEvent);
                }
            }, 300);
        }

        function dinamicHeight() {
            var contentHeight = $("#dialogGroup").innerHeight();
            contentHeight -= 155;
            vm.dinamicHeight = { "height": contentHeight + "px" };
        }

        $timeout(function () {
            init();
            changeSearch();
            dinamicHeight();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
            .module('app.product')
            .controller('ProductGroupController', productGroupController);

    /**@ngInject**/
    function productGroupController(api, MessageService, $log, $filter, $mdDialog, productCompanyGroup) {

        var vm = this;

        vm.productCompanyGroup = productCompanyGroup;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (vm.productCompanyGroupForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.productCompanyGroup.id) {
                promise = api.GeneralWS.ProductCompanyGroup.me.update({ 
                    'company': vm.productCompanyGroup.company.id, 
                    'id': vm.productCompanyGroup.id}, vm.productCompanyGroup).$promise;
            } else {
                promise = api.GeneralWS.ProductCompanyGroup.me.create({ 
                    'company': vm.productCompanyGroup.company.id, 
                    'id': undefined}, vm.productCompanyGroup).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('productGroup.productgroup_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('UpdatePriceController', UpdatePriceController);

    /**@ngInject**/
    function UpdatePriceController($filter, $mdDialog, type) {

        const vm = this;
        vm.cancel = cancel;
        vm.save = save;

        vm.response = { allCompanies: false, newPrice: null };
        vm.allCompanies = false;
        vm.newPrice;

        if (type === 1) {
            vm.title = 'pre-negotiated_price.updateQuotations';
        } else {
            vm.title = 'pre-negotiated_price.updatePurchaseOrders';
        }

        vm.loading = false;

        function cancel() {
            $mdDialog.cancel();
        }

        function save() {
            $mdDialog.hide(vm.response);
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('MassiveUpdateController', MassiveUpdateController);

    /**@ngInject**/
    function MassiveUpdateController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog, filter, products) {
        var vm = this;
        vm.cancel = cancel;
        vm.save = save;
        vm.filter = filter
        vm.productsId = [];
        vm.loadingSave = false;

        var today = setDateType(new Date(), false);
        vm.productCompanyBuy = {
            startDate: today,
            endDate: today,
            daysForDelivery: 1
        };

        $timeout(init, 200);

        function init() {
            vm.loading = true;
            vm.productsId = new jinqJs()
                .from(products)
                .select(function (row) {
                    return row.id;
                })
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function setDateType(date, end) {
            if (end) {
                date.setHours(23);
                date.setMinutes(59);
                date.setSeconds(59);
            } else {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
            }
            return date;
        }

        function save() {
            $rootScope.loadingProgress = true;
            vm.loadingSave = true;
            var dateFilter = vm.filter.endDateNegotiation.getFullYear() + '-' + (vm.filter.endDateNegotiation.getMonth() + 1) + '-' + vm.filter.endDateNegotiation.getDate();
            api.GeneralWS.ProductCompanyBuy.me.updateList(
                {
                    'id': 'updateList', 'idCircle': $rootScope.bsCircle.id, 'ids': vm.productsId, 'providersId': vm.filter.providersId,
                    'productTypesId': vm.filter.productTypesId, 'endDate': dateFilter, 'productFilter': vm.filter.productFilter
                }, vm.productCompanyBuy
            ).$promise.then(function (response) {
                MessageService.show($filter('translate')('pre-negotiated_price.updated_successfully'));
                vm.loadingSave = false;
                $rootScope.loadingProgress = false;
                $mdDialog.hide();
            }, function (response) {
                vm.loadingSave = false;
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('PreNegociatedPriceFilterController', PreNegociatedPriceFilterController);

    function PreNegociatedPriceFilterController(api, $scope, $rootScope, $timeout, $log, $mdDialog) {

        var vm = $scope.vm;
        var filterCtrl = this;

        filterCtrl.search = search;
        filterCtrl.changeStartDate = changeStartDate;
        filterCtrl.clearFilters = clearFilters;
        filterCtrl.selectProductType = selectProductType;
        vm.today = setDateType(new Date(), false);

        function clearFilters() {
            vm.productType = { id: 0, description: '' };
            vm.filter = {
                filterByDates: false,
                productWithPrice: false
            };

            search();
        }

        function changeStartDate(isStart) {
            if (isStart) {
                if (vm.filter.startDate > vm.filter.endDate) {
                    vm.filter.endDate = vm.filter.startDate;
                }
            }
            vm.filter.startDate = setDateType(vm.filter.startDate, false);
            vm.filter.endDate = setDateType(vm.filter.endDate, true);
        }

        function setDateType(date, end) {
            if (end) {
                date.setHours(23);
                date.setMinutes(59);
                date.setSeconds(59);
            } else {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
            }
            return date;
        }



        function selectProductType() {
            $mdDialog.show({
                controller: 'DialogProductTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/filter/dialogProductType/dialogProductType.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'company': $rootScope.bsCircle.company
                }
            }).then(function (answer) {
                vm.productType = { id: 0, description: '' };
                vm.filter.productTypesId = [];
                if (answer) {
                    vm.productType.description = answer.description;
                    vm.filter.productTypesId = new jinqJs()
                        .from(answer.ids)
                        .select(function (row) {
                            return parseInt(row);
                        });
                }
            }, function () {

            });
        }

        function search(event) {
            vm.showAdvancedFilter = false;
            if (vm.filter.providersId && vm.filter.providersId.length > 0) {
                vm.filter.productWithPrice = true;
            }
            if (vm.filter.filterByDates) {
                vm.filter.productWithPrice = true;
                if (!vm.filter.endDateNegotiation) {
                    vm.filter.filterByDates = true;
                    vm.filter.endDateNegotiation = setDateType(vm.today, false);
                } else {
                    vm.filter.endDateNegotiation = setDateType(vm.filter.endDateNegotiation, false);
                }
            } else {
                delete vm.filter.endDateNegotiation;
            }

            vm.getProducts(1);
        }

        function init() {

        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('PrenegotiatedPriceController', PrenegotiatedPriceController);

    /**@ngInject**/
    function PrenegotiatedPriceController($mdDialog, api, productCompanyBuy, currencies, $log, MessageService, $filter, $timeout, $rootScope) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;
        vm.productCompanyBuy = productCompanyBuy;
        vm.productCompanyBuy.taxesIncluded = !vm.productCompanyBuy.taxesIncluded ? false : vm.productCompanyBuy.taxesIncluded;
        vm.visibleCompanies = true;
        vm.addProductSale = false;
        vm.minDate = new Date();
        vm.currencies = currencies;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;
        vm.onEdit = onEdit;
        vm.getAllCompanies = getAllCompanies;
        vm.getProductSales = getProductSales;
        vm.changeFilter = changeFilter;
        vm.selectItem = selectItem;
        vm.flipping = flipping;
        vm.selectProviderToAdd = selectProviderToAdd;

        vm.newContact = true;
        vm.flip;

        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }

        function getProductSales(page) {
            vm.loading = true;
            api.GeneralWS.getAllCompaniesProviders.page(
                {
                    'pageNumber': page, 'pageSize': vm.pageSize, 'search': vm.filterProvider, 'companyId': $rootScope.bsCircle.company.id, 'includeMe': false
                },
                function (data) {
                    vm.productSales = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function getAllCompanies(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.Company.page(
                {
                    'id': 'isActive', pageNumber: page - 1, pageSize: vm.pageSize, search: vm.filterProvider, includeMe: false, companyId: $rootScope.bsCircle.company.id
                },
                function (data) {
                    vm.companies = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function changeFilter() {
            if (vm.addProductSale === false) {
                getProductSales(1);
            } else {
                getAllCompanies(1);
            }
        }

        function selectItem(item) {
            if (vm.addProductSale === true) {
                vm.selectedCompany = item;
                vm.selectedProductSale = { company: item };
                vm.productCompanyBuy.productSale = { product: vm.productCompanyBuy.productSale.product, company: item };
                vm.productCompanyBuy.currency = { id: $rootScope.bsCircle.company.currency.id };
                vm.flip();
            } else {
                vm.selectedCompany = item;
                vm.selectedProductSale = item;
                vm.productCompanyBuy.productSale.company = item;
                vm.productCompanyBuy.price = null;
                vm.productCompanyBuy.taxesIncluded = null;
                vm.productCompanyBuy.currency = null;
                vm.productCompanyBuy.price = item.salePrice > 0 ? item.salePrice : null;
                vm.productCompanyBuy.taxesIncluded = item.isPriceIncludeTaxes === true ? true : false;
                item.currencySale ? vm.productCompanyBuy.currency = { id: item.currencySale.id } : null;
                vm.productCompanyBuy.currency = { id: $rootScope.bsCircle.company.currency.id };
                vm.flip();
            }
        }

        function save() {

            if (vm.productBuyForm.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }

            if (!vm.productCompanyBuy.productSale || !vm.productCompanyBuy.productSale.company) {
                MessageService.showErrorMessage($filter('translate')('pre-negotiated_price.select_provider'));
                return false;
            }

            var promise;
            if (vm.productCompanyBuy.id) {
                promise = api.GeneralWS.ProductCompanyBuy.me.update(
                    {
                        'id': vm.productCompanyBuy.id, 'idCircle': $rootScope.bsCircle.id
                    }, vm.productCompanyBuy).$promise;
            } else {
                promise = api.GeneralWS.ProductCompanyBuy.me.create({ 'idCircle': $rootScope.bsCircle.id }, vm.productCompanyBuy).$promise;
            }
            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                const dt = response.$data;
                dt.productSale = vm.productCompanyBuy.productSale;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(dt);
                        break;
                    case 201:
                        $mdDialog.hide(dt);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                if (response.status === 409) {
                    MessageService.showErrorMessage($filter('translate')('pre-negotiated_price.dates_conflict'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });
            return true;
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function onEdit() {
            vm.flip();
            changeFilter();
            $timeout(function () {
                document.getElementById("searchFilter").focus();
            }, 600);
        }
        function selectProviderToAdd(addProductSale) {
            if (addProductSale === true) {
                vm.addProductSale = true;
                changeFilter();
                $timeout(function () {
                    document.getElementById("searchFilter").focus();
                }, 500);
            } else {
                vm.addProductSale = false;
                changeFilter();
                $timeout(function () {
                    document.getElementById("searchFilter").focus();
                }, 500);
            }
        }

    }

})();

(function () {
  'use strict';

  angular
    .module('app.product')
    .controller('DefaultCostCenterController', DefaultCostCenterController);

  /**@ngInject**/
  function DefaultCostCenterController(
    $mdDialog,
    api,
    productCompanyBuys,
    $log,
    MessageService,
    $timeout,
    $rootScope
  ) {
    var vm = this;

    vm.isShowProgressLinear = false;

    vm.loadProductBuysCC = loadProductBuysCC;

    vm.cancel = cancel;
    vm.changeDefault = changeDefault;

    vm.productCompanyBuys = productCompanyBuys;
    vm.productCompanyBuysCC = [];

    function init() {
      vm.isShowProgressLinear = true;
      var idsBuys = vm.productCompanyBuys.map(function (a) {
        return a.id;
      });
      var proms = api.GeneralWS.ProductCompanyBuyCostCenter.CostCenters.query({
        productCompanyBuyIds: idsBuys,
      }).$promise;

      proms.then(
        function (rsp) {
          var promsCostCenter = api.GeneralWS.CostCenter.filter({
            idPath: 'getByIdIn',
            idc: -1
          }, rsp).$promise;
          promsCostCenter.then(
            function (ccs) {
              vm.costCenters = ccs;
              vm.isShowProgressLinear = false;
            },
            function (err) {
              vm.isShowProgressLinear = false;
            }
          );
        },
        function () {
          vm.isShowProgressLinear = false;
        }
      );
    }

    function loadProductBuysCC(costCenterId) {
      vm.loadingCostCenter = true;
      vm.productCompanyBuysCC = [];
      var prome = api.GeneralWS.ProductCompanyBuyCostCenter.CostCenter.get({
        costCenterId: costCenterId,
      }).$promise;

      prome.then(
        function (rsp) {
          var values = {};
          rsp.forEach(function (dt) {
            values[dt.productCompanyBuyId] = dt;
          });

          vm.productCompanyBuys.forEach(function (buy) {
            var dt = values[buy.id];
            if (dt) {
              var by = angular.copy(buy);
              by.isDefaultCC = dt.default;
              by.idCC = dt.id;
              vm.productCompanyBuysCC.push(by);
            }
            vm.loadingCostCenter = false;
          });
        },
        function () {
          vm.loadingCostCenter = false;
        }
      );
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function changeDefault(by) {
      vm.loadingCostCenter = false;
      var actualBuys = vm.productCompanyBuys.map(function (buy) {
        return buy.id;
      });
      var proms = api.GeneralWS.ProductCompanyBuyCostCenter.ChangeDefault.update(
        {
          id: by.idCC,
        },
        actualBuys
      ).$promise;

      proms.then(
        function (rsp) {
          var i = vm.productCompanyBuysCC.indexOf(by);
          vm.productCompanyBuysCC.forEach(function (df) {
            df.isDefaultCC = false;
          });
          vm.productCompanyBuysCC[i].isDefaultCC = true;
          vm.loadingCostCenter = false;
        },
        function () {
          vm.loadingCostCenter = false;
        }
      );
    }

    init();

    $timeout(function () {
      var mdDialog = $('.default-costcenter');
      var windowHeight = parseInt(mdDialog.innerHeight());

      windowHeight -= 305;

      vm.dinamicHeight = {
        height: windowHeight + 'px',
      };
    }, 1000);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.product')
    .controller('ByCostCenterController', ByCostCenterController);

  /**@ngInject**/
  function ByCostCenterController(
    $mdDialog,
    api,
    productCompanyBuy,
    $timeout,
    $rootScope
  ) {
    var vm = this;

    vm.isShowProgressLinear = false;

    vm.cancel = cancel;
    vm.save = save;
    vm.clearSearchEntity = clearSearchEntity;
    vm.loadCostCenter = loadCostCenter;
    vm.selectAllCostCenter = selectAllCostCenter;

    vm.toggle = toggle;
    vm.isSelected = isSelected;

    vm.selectedArray = [];
    vm.productCompanyBuy = productCompanyBuy;

    function init() {
      initEvents();
      vm.isShowProgressLinear = true;
      var proms = api.GeneralWS.CompaniesVerifieds.getAll({
        role: $rootScope.bsCircle.role.name,
        businessCircleId: $rootScope.bsCircle.id,
        validateCountry: true
      }).$promise;

      proms.then(
        function (rsp) {
          vm.companies = rsp;
          vm.isShowProgressLinear = false;
        },
        function () {
          vm.isShowProgressLinear = false;
        }
      );
    }

    function isSelected(data) {
      return vm.selectedArray.indexOf(data) > -1;
    }

    function loadCostCenter(companyId) {
      vm.loadingCostCenter = true;
      var prome = api.GeneralWS.CostCenter.query({
        idc: companyId,
        idPath: 'Company',
        onlyActive: true
      }).$promise;

      var promsSelected = api.GeneralWS.ProductCompanyBuyCostCenter.CompanyBuy
        .get({productCompanyBuyId: vm.productCompanyBuy.id})
        .$promise;

      prome.then(
        function (rsp) {
          vm.costCenters = rsp;
          promsSelected.then(
            function(ccs) {
              var result = ccs.map(function(a) {
                return a.costCenterId;
              });

              vm.costCenters.forEach(function (row) {
  
                if (result.indexOf(row.id) > -1) {
                    row.isCheck = true;
                    vm.selectedArray.push(row);
                }
  
              });
  
              vm.countCostCenterSelected = result.length;
              vm.loadingCostCenter = false;
            },
            function() {
              vm.loadingCostCenter = false;
            }
          );
        },
        function () {
          vm.loadingCostCenter = false;
        }
      );
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function save() {
      var listSave = [];

      vm.selectedArray.forEach(function(prop){
        listSave.push({
          costCenterId: prop.id,
          productCompanyBuyId: vm.productCompanyBuy.id
        });
      });

      var proms = api.GeneralWS.ProductCompanyBuyCostCenter.CompanyBuy.create(
        {
          productCompanyBuyId: vm.productCompanyBuy.id
        }, listSave
      ).$promise;

      proms.then(
        function (rsp) {
          $mdDialog.hide(rsp);
          vm.loadingCostCenter = false;
        },
        function () {
          vm.loadingCostCenter = false;
        }
      );
    }

    function clearSearchEntity() {
      vm.searchEntity = "";
    }

    function initEvents() {
      var keyEvent = function (event) {
          event.stopPropagation();
      };

      var searchEntityInput = document.querySelector("#searchEntityInput");

      if (searchEntityInput) {
          searchEntityInput.addEventListener("keydown", keyEvent);
      }

    }

    function toggle(data, event) {
      if (event) {
          event.stopPropagation();
      }
      if (vm.selectedArray.indexOf(data) > -1) {
          vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
      } else {
          vm.selectedArray.push(data);
      }
    }

    function selectAllCostCenter() {
      if (vm.isCheckAllCostCenter) {
          vm.selectedArray = [];
          vm.costCenters.forEach(function (row) {
              row.isCheck = true;

              if (!vm.selectedArray.indexOf(row) > -1) {
                  vm.selectedArray.push(row);
              }

          });

          vm.countCostCenterSelected = vm.costCenters.length;

      } else {
          vm.costCenters.forEach(function (row) {
              row.isCheck = false;

              if (vm.selectedArray.indexOf(row) > -1) {
                  vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
              }

          });

          vm.countCostCenterSelected = 0;
      }
  }

    init();

    $timeout(function () {
      var mdDialog = $(".by-costcenter");
      var windowHeight = parseInt(mdDialog.innerHeight());

      windowHeight -= 305;

      vm.dinamicHeight = {
          "height": windowHeight + "px"
      };
    }, 1000);
  }
})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('FeatureValuesController', featureValuesController);

    function featureValuesController($log, $mdDialog, api, MessageService, $timeout, feature, $filter) {

        var vm = this;
        vm.cancel = cancel;
        vm.add = add;
        vm.save = save;
        vm.update = update;
        vm.changeActive = changeActive;
        vm.edit = edit;
        vm.indexView = 0;

        vm.featureValue = null;

        vm.feature = feature;

        function cancel() {
            if (vm.indexView === 1) {
                vm.indexView = 0;
            } else {
                $mdDialog.cancel();
            }
        }

        function edit(featureValue) {

            vm.indexView = 1;

            vm.featureValue = featureValue;
        }

        function add() {

            vm.indexView = 1;

            vm.featureValue = {
                active: true
            };

        }

        function save() {

            var promise;

            vm.isShowProgressLinear = true;

            if (vm.featureValue.id) {
                promise = api.GeneralWS.FeatureValue.me.update({ 'featureId': vm.feature.id }, vm.featureValue).$promise;
            } else {
                promise = api.GeneralWS.FeatureValue.me.create({ 'featureId': vm.feature.id }, vm.featureValue).$promise;
            }

            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (response.$status === 201) {
                    MessageService.show($filter('translate')('feature.feature_value_added_successfully'));
                    vm.featureValuesArray.push(response);
                    vm.indexView = 0;

                } else if (response.$status === 200) {
                    MessageService.show($filter('translate')('feature.feature_value_updated_successfully'));

                    vm.indexView = 0;

                } else {
                    $log.error(response);
                }

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
                if (response.status === 302) {
                    MessageService.show($filter('translate')('feature.feature_value_already_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function update(featureValue) {

            vm.isShowProgressLinear = true;
            api.GeneralWS.FeatureValue.me.create({ 'featureId': vm.feature.id }, featureValue).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (response.$status === 200) {
                    MessageService.show($filter('translate')('feature.feature_value_updated_successfully'));
                } else {
                    $log.error(response);
                }

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function changeActive(featureValue) {

            vm.isShowProgressLinear = true;
            api.GeneralWS.FeatureValue.me.update({ 'featureId': vm.feature.id }, featureValue).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (response.$status === 200) {
                    if (featureValue.active) {
                        MessageService.show($filter('translate')('general.value_activated_successfully'));
                    } else {
                        MessageService.show($filter('translate')('general.value_deactivated_successfully'));
                    }
                } else {
                    $log.error(response);
                }

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
                MessageService.show("Ocurrio un error");
            });

        }

        function init() {

            api.GeneralWS.FeatureValue.me.query({ 'featureId': vm.feature.id }).$promise.then(function (response) {

                vm.featureValuesArray = response;

            }, function (response) {
                $log.error(response);
            });

        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    angular
        .module('app.product')
        .controller('FeatureMeasurementUnitController', featureMeasurementUnitController);

    /**@ngInject**/
    function featureMeasurementUnitController($log, api, MessageService, $timeout, $mdDialog, feature, $filter) {

        var vm = this;
        vm.feature = feature;

        vm.cancel = cancel;
        vm.measurementUnitArray = [];
        vm.featureMeasurementUnitArray = [];

        vm.selectAllMeasurementUnit = selectAllMeasurementUnit;
        vm.selectAllFeatureMeasurementUnit = selectAllFeatureMeasurementUnit;

        vm.validateSelectAllMeasurementUnit = validateSelectAllMeasurementUnit;
        vm.validateSelectAllFeatureMeasurementUnit = validateSelectAllFeatureMeasurementUnit;

        vm.countMeasurementUnitSelected = 0;
        vm.countFeatureMeasurementUnitSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
                getMeasurementUnit();
            },
            beforePage: function () {
                this.pageNumber--;
                getMeasurementUnit();
            },
            firstPage: function () {
                this.pageNumber = 0;
                getMeasurementUnit();
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
                getMeasurementUnit();
            }
        };

        vm.paginationFeatureMeasurementUnit = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                this.pageNumber++;
                getFeatureMeasurementUnit();
            },
            beforePage: function () {
                this.pageNumber--;
                getFeatureMeasurementUnit();
            },
            firstPage: function () {
                this.pageNumber = 0;
                getFeatureMeasurementUnit();
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
                getFeatureMeasurementUnit();
            }
        };

        function cancel() {
            $mdDialog.cancel();
        }

        function getFeatureMeasurementUnit() {

            vm.isShowProgressLinear = true;
            api.GeneralWS.FeatureMeasurementUnit.me.page({ 'featureId': feature.id, 'pageNumber': vm.paginationFeatureMeasurementUnit.pageNumber, 'pageSize': vm.paginationFeatureMeasurementUnit.pageSize }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.featureMeasurementUnitArray = response.content;
                vm.paginationFeatureMeasurementUnit.totalElements = response.totalElements;
                vm.paginationFeatureMeasurementUnit.totalPages = response.totalPages;

                //verifica la unidad de medida predeterminada
                vm.featureMeasurementUnitArray.forEach(function (row) {
                    if (row.measurementUnit.id === feature.measurementUnit.id) {
                        row.isPredeterminated = true;
                    }
                });

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });

        }

        function getMeasurementUnit() {

            vm.isShowProgressLinear = true;
            api.GeneralWS.Common.MeasurementUnit.notAssociatedToFeature.page({ 'pageNumber': vm.pagination.pageNumber, 'pageSize': vm.pagination.pageSize, 'featureId': feature.id }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.measurementUnitArray = response.content;
                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
            });

        }

        function validateSelectAllMeasurementUnit() {

            vm.countMeasurementUnitSelected = 0;

            var isSelectAll = true;

            vm.measurementUnitArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countMeasurementUnitSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllMeasurementUnit = true;
            } else {
                vm.isCheckAllMeasurementUnit = false;
            }

        }

        function selectAllMeasurementUnit() {
            if (vm.isCheckAllMeasurementUnit) {
                vm.measurementUnitArray.forEach(function (row) {
                    row.isCheck = true;
                });

                vm.countMeasurementUnitSelected = vm.measurementUnitArray.length;

            } else {
                vm.measurementUnitArray.forEach(function (row) {
                    row.isCheck = false;
                });

                vm.countMeasurementUnitSelected = 0;
            }
        }

        function validateSelectAllFeatureMeasurementUnit() {

            vm.countFeatureMeasurementUnitSelected = 0;

            var isSelectAll = true;

            vm.featureMeasurementUnitArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countFeatureMeasurementUnitSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllFeatureMeasurementUnit = true;
            } else {
                vm.isCheckAllFeatureMeasurementUnit = false;
            }

        }

        function selectAllFeatureMeasurementUnit() {
            if (vm.isCheckAllFeatureMeasurementUnit) {
                vm.featureMeasurementUnitArray.forEach(function (row) {
                    if (!row.isPredeterminated) {
                        row.isCheck = true;
                    }
                });

                vm.countFeatureMeasurementUnitSelected = vm.featureMeasurementUnitArray.length;

            } else {
                vm.featureMeasurementUnitArray.forEach(function (row) {
                    row.isCheck = false;
                });

                vm.countFeatureMeasurementUnitSelected = 0;
            }
        }

        function associate() {

            var measurementUnitIdArray = [];

            if (!vm.isCheckAllMeasurementUnit) {
                vm.measurementUnitArray.forEach(function (row) {
                    if (row.isCheck) {
                        measurementUnitIdArray.push(row.id);
                    }
                });
            }

            if (measurementUnitIdArray.length === 0 && !vm.isCheckAllMeasurementUnit) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.FeatureMeasurementUnit.associate.create({ 'featureId': feature.id, 'associateAll': vm.isCheckAllMeasurementUnit }, measurementUnitIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (vm.paginationFeatureMeasurementUnit.totalPages > 0) {
                    vm.paginationFeatureMeasurementUnit.pageNumber = vm.paginationFeatureMeasurementUnit.totalPages;
                } else {
                    vm.paginationFeatureMeasurementUnit.pageNumber = 1;
                }

                getFeatureMeasurementUnit();

                vm.pagination.pageNumber = vm.pagination.totalPages;
                getMeasurementUnit();

                vm.isCheckAllMeasurementUnit = false;
                vm.countMeasurementUnitSelected = 0;

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
            });

        }

        function disassociate() {

            if (vm.featureMeasurementUnitArray.length === 1) {
                if (vm.featureMeasurementUnitArray[0].isPredeterminated) {
                    MessageService.show($filter('translate')('feature.not_deactive_default_measurement_unit'));
                    return null;
                }
            }

            var measurementUnitIdArray = [];

            if (!vm.isCheckAllFeatureMeasurementUnit) {
                vm.featureMeasurementUnitArray.forEach(function (row) {
                    if (row.isCheck) {
                        measurementUnitIdArray.push(row.id);
                    }
                });
            }

            if (measurementUnitIdArray.length === 0 && !vm.isCheckAllFeatureMeasurementUnit) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.FeatureMeasurementUnit.deactive.create({ 'featureId': feature.id, 'deactiveAll': vm.isCheckAllFeatureMeasurementUnit }, measurementUnitIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.paginationFeatureMeasurementUnit.pageNumber = vm.paginationFeatureMeasurementUnit.totalPages;
                getFeatureMeasurementUnit();

                vm.pagination.pageNumber = vm.pagination.totalPages;
                getMeasurementUnit();

                vm.isCheckAllFeatureMeasurementUnit = false;
                vm.countFeatureMeasurementUnitSelected = 0;

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
            });

        }

        $timeout(function () {

            var windowHeight = $(window).innerHeight();

            if (windowHeight <= 653) {
                windowHeight -= 400;
            } else {
                windowHeight -= 460;
            }

            var divMeasurementUnitList = $("#listMeasurementUnitContainer");
            var divFeatureMeasurementUnitList = $("#listFeatureMeasurementUnitContainer");

            divMeasurementUnitList.css({ 'height': windowHeight + "px", "overflow-y": "auto" });
            divFeatureMeasurementUnitList.css({ 'height': windowHeight + "px", "overflow-y": "auto" });

            getMeasurementUnit();
            getFeatureMeasurementUnit();

        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('FeatureListController', featureListController);

    /**@ngInject**/
    function featureListController($log, MessageService, $filter, api, $timeout, $mdDialog, GeneralService) {

        var vm = this;

        vm.add = add;
        vm.edit = edit;
        vm.onDeactivate = onDeactivate;
        vm.showValues = showValues;
        vm.showMeasurementUnit = showMeasurementUnit;

        vm.pagination = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "name",
                headerName: 'feature.name',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "dataType",
                headerName: 'feature.value_data_type',
                headerCellRenderer: getHeader,
                width: 200,
                cellRenderer: function (params) {

                    var translate = GeneralService.getTranslateDataTypeEnumByName(params.value);

                    return "{{'" + translate + "' | translate}}";
                }
            },
            {
                field: "valueLength",
                headerName: 'feature.value_length',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "canAddValues",
                headerName: 'feature.can_add_values',
                headerCellRenderer: getHeader,
                width: 170,
                cellRenderer: function (params) {
                    if (params.value) {
                        return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                field: "required",
                headerName: 'feature.required',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function (params) {
                    if (params.value) {
                        return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDeactivate(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    return '<center> <md-button class="md-icon-button" ng-click="vm.edit(data)"> <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                name: "edit",
                headerName: 'feature.values',
                headerCellRenderer: getHeader,
                width: 90,
                cellRenderer: function (params) {
                    return '<center> <md-button class="md-icon-button" ng-click="vm.showValues(data)"> <md-icon md-font-icon="icon-view-list"></md-icon> <md-tooltip md-direction="left" >Valores</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                name: "measurementUnits",
                headerName: 'feature.measurement_units',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function (params) {
                    return '<center> <md-button class="md-icon-button" ng-click="vm.showMeasurementUnit(data)"> <md-icon md-font-icon="icon-sort-variant"></md-icon> <md-tooltip md-direction="left" >Unidades de medida</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowModelType: 'pagination',
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 45,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.Feature.me.page({ 'pageNumber': (vm.pagination.pageNumber + 1), 'pageSize': vm.pagination.pageSize }).$promise.then(function (response) {
                        vm.isShowProgressLinear = false;

                        vm.pagination.totalElements = response.totalElements;
                        vm.pagination.totalPages = response.totalPages;
                        vm.pagination.pageNumber = response.number + 1;

                        params.successCallback(response.content, response.totalElements);
                        vm.showGrid = true;

                    }, function (response) {
                        $log.error(response);
                        vm.isShowProgressLinear = false;
                    });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);

        }

        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'FeatureController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/feature/feature/feature.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'feature': {
                        'name': '',
                        'active': true
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.pageNumber = vm.pagination.totalPages - 1;
                    createNewDatasource();
                    MessageService.show($filter('translate')('feature.feature_add_successfully'));
                }
            }, function () {

            });
        }

        function edit(feature) {
            $mdDialog.show({
                controller: 'FeatureController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/feature/feature/feature.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'feature': angular.copy(feature)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });

                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('feature.feature_updated_successfully'));
                }
            }, function () {

            });
        }

        function showMeasurementUnit(feature) {
            $mdDialog.show({
                controller: 'FeatureMeasurementUnitController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/feature/feature-measurement-unit/feature-measurement-unit.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'feature': angular.copy(feature)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });

                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('feature.feature_updated_successfully'));
                }
            }, function () {

            });
        }

        function showValues(feature) {
            $mdDialog.show({
                controller: 'FeatureValuesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/feature/feature-values/feature-values.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'feature': angular.copy(feature)
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        function onDeactivate(data) {

            data.active = false;
            api.GeneralWS.Feature.me.update({}, data).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                MessageService.show($filter('translate')('measurement_unit.measurement_unit_deactivate'));

                vm.grid.api.forEachNode(function (row) {
                    if (row.data.id === data.id) {
                        row.data = data;
                    }
                });

                vm.grid.api.refreshView();

            }, function (response) {
                $log.error(response);
                vm.isShowProgressLinear = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        $timeout(function () {
            init();
        }, 1000);

    }


})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('FeatureController', featureController);

    /**@ngInject**/
    function featureController($log, $mdDialog, api, MessageService, feature, $filter, $timeout, GeneralService) {

        var vm = this;

        vm.dataTypeArray = GeneralService.getDataTypeEnumArray();

        vm.feature = feature;

        vm.measurementUnitArray = [];

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (vm.featureForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.feature.id) {
                promise = api.GeneralWS.Feature.me.update({}, vm.feature).$promise;
            } else {
                promise = api.GeneralWS.Feature.me.create({}, vm.feature).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                if (response.status === 302) {
                    MessageService.show($filter('translate')('feature.feature_already_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function getMeasurementUnit() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.Common.MeasurementUnit.me.query({}).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.measurementUnitArray = response;

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        $timeout(function () {

            getMeasurementUnit();

        }, 1000);

    }

})();


(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('AssociateCategoryFeatureController', associateCategoryFeatureController);


    function associateCategoryFeatureController(api, MessageService, $mdDialog, $log, $filter, $timeout, productCategoryId) {

        var vm = this;

        vm.featureArray = [];
        vm.categoryFeatureArray = [];
        vm.cancel = cancel;

        vm.selectAllFeature = selectAllFeature;
        vm.selectAllCategoryFeature = selectAllCategoryFeature;

        vm.validateSelectAllFeature = validateSelectAllFeature;
        vm.validateSelectAllCategoryFeature = validateSelectAllCategoryFeature;

        vm.countFeatureSelected = 0;
        vm.countCategoryFeatureSelected = 0;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                getRole();
            },
            beforePage: function () {
                this.pageNumber--;
                getRole();
            },
            firstPage: function () {
                this.pageNumber = 0;
                getRole();
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
                getRole();
            }
        };

        vm.paginationCategoryFeature = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0,
            nextPage: function () {
                getUserRole();
            },
            beforePage: function () {
                this.pageNumber--;
                getUserRole();
            },
            firstPage: function () {
                this.pageNumber = 0;
                getUserRole();
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
                getUserRole();
            }
        };

        function cancel() {
            $mdDialog.cancel();
        }

        function validateSelectAllFeature() {

            vm.countFeatureSelected = 0;

            var isSelectAll = true;

            vm.featureArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countFeatureSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllFeature = true;
            } else {
                vm.isCheckAllFeature = false;
            }

        }

        function selectAllFeature() {
            if (vm.isCheckAllFeature) {
                vm.featureArray.forEach(function (row) {
                    row.isCheck = true;
                });

                vm.countFeatureSelected = vm.featureArray.length;

            } else {
                vm.featureArray.forEach(function (row) {
                    row.isCheck = false;
                });

                vm.countFeatureSelected = 0;
            }
        }

        function validateSelectAllCategoryFeature() {

            vm.countCategoryFeatureSelected = 0;

            var isSelectAll = true;

            vm.categoryFeatureArray.forEach(function (row) {
                if (!row.isCheck) {
                    isSelectAll = false;
                } else {
                    vm.countCategoryFeatureSelected++;
                }
            });

            if (isSelectAll) {
                vm.isCheckAllCategoryFeature = true;
            } else {
                vm.isCheckAllCategoryFeature = false;
            }

        }

        function selectAllCategoryFeature() {
            if (vm.isCheckAllCategoryFeature) {
                vm.categoryFeatureArray.forEach(function (row) {
                    row.isCheck = true;
                });

                vm.countCategoryFeatureSelected = vm.categoryFeatureArray.length;

            } else {
                vm.categoryFeatureArray.forEach(function (row) {
                    row.isCheck = false;
                });

                vm.countCategoryFeatureSelected = 0;
            }
        }

        function getFeature() {

            vm.isShowProgressLinear = true;
            api.GeneralWS.Feature.notAssociatedToCategory.page({ 'categoryId': productCategoryId, 'pageNumber': vm.pagination.pageNumber, 'pageSize': vm.pagination.pageSize }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.pagination.pageNumber = response.number + 1;
                vm.featureArray = response.content;

                vm.isCheckAllFeature = false;
                vm.countFeatureSelected = 0;

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });

        }

        function getCategoryFeature() {

            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductCategoryFeature.me.page({ 'productCategoryId': productCategoryId, 'pageNumber': vm.paginationCategoryFeature.pageNumber, 'pageSize': vm.paginationCategoryFeature.pageSize }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.paginationCategoryFeature.totalElements = response.totalElements;
                vm.paginationCategoryFeature.totalPages = response.totalPages;
                vm.paginationCategoryFeature.pageNumber = response.number + 1;
                vm.categoryFeatureArray = response.content;

                vm.isCheckAllCategoryFeature = false;
                vm.countCategoryFeatureSelected = 0;

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });

        }

        function associate() {

            var featureIdArray = [];

            if (!vm.isCheckAllFeature) {

                vm.featureArray.forEach(function (row) {
                    if (row.isCheck) {
                        featureIdArray.push(row.id);
                    }
                });

            }

            if (featureIdArray.length === 0 && !vm.isCheckAllFeature) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductCategoryFeature.me.create({ 'productCategoryId': productCategoryId, 'associateAll': vm.isCheckAllFeature }, featureIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (vm.paginationCategoryFeature.totalPages > 0) {
                    vm.paginationCategoryFeature.pageNumber = vm.paginationCategoryFeature.totalPages;
                } else {
                    vm.paginationCategoryFeature.pageNumber = 1;
                }

                getCategoryFeature();

                vm.pagination.pageNumber = vm.pagination.totalPages;
                getFeature();

                vm.isCheckAllFeature = false;
                vm.countFeatureSelected = 0;

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        function disassociate() {

            var featureIdArray = [];

            if (!vm.isCheckAllCategoryFeature) {
                vm.categoryFeatureArray.forEach(function (row) {
                    if (row.isCheck) {
                        featureIdArray.push(row.id);
                    }
                });
            }

            if (featureIdArray.length === 0 && !vm.isCheckAllCategoryFeature) {
                return null;
            }

            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductCategoryFeature.me.update({ 'productCategoryId': productCategoryId, 'deleteAll': vm.isCheckAllCategoryFeature }, featureIdArray).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.pagination.pageNumber = 0;
                getFeature();

                vm.paginationCategoryFeature.pageNumber = 0;
                getCategoryFeature();

            }, function (response) {
                vm.isShowProgressLinear = true;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });

        }

        $timeout(function () {

            getFeature();
            getCategoryFeature();

            var windowHeight = $(window).innerHeight();

            if (windowHeight <= 653) {
                windowHeight -= 340;
            } else {
                windowHeight -= 420;
            }

            var divFeatureList = $("#listFeatureContainer");
            var divCategoryFeatureList = $("#listCategoryFeatureContainer");

            divFeatureList.css({ 'height': windowHeight + "px", "overflow-y": "auto" });
            divCategoryFeatureList.css({ 'height': windowHeight + "px", "overflow-y": "auto" });

        }, 1000);

    }

})();

(function () {

    angular
        .module('app.notification', [])
        .config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/notification/');

        $stateProvider
            .state('app.notification', {
                abstract: true,
                url: '/notification'
            })
            .state('app.notification.notificationTypeSchedule', {
                url: '/configuration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/notification/notification-type-schedule-list/notification-type-schedule-list.html',
                        controller: 'NotificationTypeScheduleListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    Company: function (apiResolver, $rootScope) {
                        return $rootScope.bsCircle.company;
                    }
                }
            })
            .state('app.notification.publishNotifications', {
                url: '/publishNotifications',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/notification/publishNotifications/publishNotifications.html',
                        controller: 'publishNotificationsController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.notification.notificationReport', {
                url: '/Consult',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/notification/notificationReport/notificationReport.html',
                        controller: 'notificationReportController',
                        controllerAs: 'vm'
                    }
                }
            })
    }

})();

(function () {
    'use strict';

    angular
        .module('app.notification')
        .controller('dialogScheduleParameterController', dialogScheduleParameterController);

    /** @ngInject**/
    function dialogScheduleParameterController(api, MessageService, $log, $mdDialog, $timeout, $filter, notificationTypeSchedule) {
        var vm = this;
        vm.notificationTypeSchedule = notificationTypeSchedule;

        /**Metodos**/
        vm.save = save;
        vm.closeDialog = closeDialog;
        vm.getAllNotificationTypeParameter = getAllNotificationTypeParameter;
        vm.clearSearchNotificationTypeScheduleParameter = clearSearchNotificationTypeScheduleParameter;

        vm.arrayValuesAdditionalField = [];

        var columnDefs = [{
                headerName: "notificationTypeSchedule.parameters.parameterName",
                field: "notificationTypeParameter.parameterName",
                headerCellRenderer: getHeader,
                width: 150,
                cellStyle: {
                    "text-align": "center"
                }
            },
            {
                headerName: "notificationTypeSchedule.parameters.parameterValue",
                field: "parameterValue",
                headerCellRenderer: getHeader,
                width: 150,
                cellStyle: {
                    "text-align": "center"
                },
            },
            {
                headerName: "notificationTypeSchedule.actions",
                width: 150,
                headerCellRenderer: getHeader,
                cellStyle: {
                    "text-align": "center"
                },
                cellRenderer: function () {
                    return '<div>' +
                        '<md-button class="edit-button md-icon-button" ng-click="vm.deleteRow(data)">' +
                        '<md-icon md-font-icon="icon-trash" class="s16 md-warn">' +
                        '<md-tooltip md-direction="bottom">' +
                        '{{"notificationTypeSchedule.delete"| translate}}' +
                        '</md-tooltip>' +
                        '</md-icon>' +
                        '</md-button>' +
                        '</div>'
                }
            }
        ];

        vm.gridAdditionalFields = {
            enableSorting: true,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            toolPanelSuppressGroups: true,
            fullWidthCellRenderer: true,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        $timeout(function () {
            initSearchParameterField();
            init();
        }, 500);

        function getAllNotificationTypeParameter() {
            vm.loadingAdditionalFields = true;
            api.NotificacionesWS.NotificationTypeParameter.byNotificationType.get({
                    'notificationTypeId': vm.notificationTypeSchedule.notificationType.id,
                    'notificationTypeScheduleId': vm.notificationTypeSchedule.id
                })
                .$promise.then(function (response) {
                    vm.loadingAdditionalFields = false;
                    vm.notificationTypeParameters = response;
                }, function (response) {
                    vm.loadingAdditionalFields = false;
                    $log.error(response);
                });
        }

        function init() {
            vm.notificationTypeScheduleParameter = {};
            getAllNotificationTypeParameter();
            createNewDatasource();
        }

        function save() {
            $mdDialog.hide(vm.arrayValuesAdditionalField);
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        vm.addNotificationTypeParameter = function () {
            if (vm.notificationTypeScheduleParameter.notificationTypeParameter === undefined ||
                vm.notificationTypeScheduleParameter.notificationTypeParameter === null) {
                return;
            }

            if (vm.notificationTypeScheduleParameter.parameterValue === '') return;

            api.NotificacionesWS.NotificationTypeScheduleParameter.me.create({
                    'notificationTypeScheduleId': vm.notificationTypeSchedule.id
                }, vm.notificationTypeScheduleParameter)
                .$promise.then(function () {
                    vm.loadingAdditionalFields = false;
                    MessageService.show($filter('translate')('notificationTypeSchedule.MSG.added_successfully'));
                    init();
                }, function (response) {
                    vm.loadingAdditionalFields = false;
                    $log.error(response);
                });
        }

        vm.deleteRow = function (data) {
            api.NotificacionesWS.NotificationTypeScheduleParameter.me.delete({
                    'notificationTypeScheduleId': vm.notificationTypeSchedule.id,
                    'id': data.id
                })
                .$promise.then(function () {
                    vm.loadingAdditionalFields = false;
                    MessageService.show($filter('translate')('notificationTypeSchedule.MSG.deleted_successfully'));
                    init();
                }, function (response) {
                    vm.loadingAdditionalFields = false;
                    $log.error(response);
                });
        };

        function createNewDatasource() {
            vm.loadingAdditionalFields = true;
            vm.gridAdditionalFields.api.setColumnDefs(columnDefs);
            vm.gridAdditionalFields.api.setRowData([]);

            api.NotificacionesWS.NotificationTypeScheduleParameter.byNotificationTypeSchedule.get({
                'notificationTypeScheduleId': vm.notificationTypeSchedule.id
            }, function (response) {
                vm.loadingAdditionalFields = false;
                vm.gridAdditionalFields.api.setRowData(response);
            }, function (response) {
                $log.error(response);
            });
            vm.loadingAdditionalFields = false;
        }

        function initSearchParameterField() {
            $timeout(function () {
                var keyEvent = function (event) {
                    event.stopPropagation();
                };

                var searchParameterInput = document.querySelector("#searchParameter");

                if (searchParameterInput) {
                    searchParameterInput.addEventListener("keydown", keyEvent);
                }
            }, 300);
        }

        function clearSearchNotificationTypeScheduleParameter() {
            vm.searchParameter = "";
        }
    }
})();

(function () {

    'use strict';

    angular
        .module('app.notification')
        .controller('dialogNotificationTypeScheduleController', dialogNotificationTypeScheduleController);

    /**@ngInject**/
    function dialogNotificationTypeScheduleController($mdDialog, api, notificationTypeSchedule, $log, MessageService, $filter, $rootScope) {
        var vm = this;

        //Data
        vm.notificationTypeSchedule = notificationTypeSchedule;
        vm.showSpecificDate = notificationTypeSchedule.startDate != null;
        vm.removeDayOfWeek = notificationTypeSchedule.dayOfWeek === null;
        vm.currentDate = new Date();

        //Methods
        vm.save = save;
        vm.cancel = cancel;
        vm.changeDayOfWeek = changeDayOfWeek;
        vm.changeSpecificDate = changeSpecificDate;

        if (notificationTypeSchedule.startDate != undefined || notificationTypeSchedule.startDate != null) {
            vm.notificationTypeSchedule.startDate = new Date(notificationTypeSchedule.startDate.replace(/-/g, '\/'));
        }

        if (notificationTypeSchedule.endDate != undefined || notificationTypeSchedule.endDate != null) {
            vm.notificationTypeSchedule.endDate = new Date(notificationTypeSchedule.endDate.replace(/-/g, '\/'));
        }

        function save() {
            if (vm.notificationTypeScheduleForm.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return;
            }
            var promise;
            vm.notificationTypeSchedule.company = $rootScope.bsCircle.company;

            if (vm.notificationTypeSchedule.id) {
                promise = api.NotificacionesWS.NotificationTypeSchedule.me.update({
                    'idCircle': $rootScope.bsCircle.id,
                    'id': vm.notificationTypeSchedule.id
                }, vm.notificationTypeSchedule).$promise;
            } else {
                promise = api.NotificacionesWS.NotificationTypeSchedule.me.create({ 
                    'idCircle': $rootScope.bsCircle.id 
                }, vm.notificationTypeSchedule).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 409) {
                    MessageService.showErrorMessage($filter('translate')('notificationTypeSchedule.already_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

        function changeSpecificDate() {
            if (vm.showSpecificDate) {
                vm.removeDayOfWeek = false;
                if (vm.notificationTypeSchedule.startDate === null) {
                    vm.notificationTypeSchedule.startDate = new Date();
                } 
            } else {
                vm.removeDayOfWeek = false;
                vm.notificationTypeSchedule.startDate = null;
                vm.notificationTypeSchedule.endDate = null;
            }
        }

        function changeDayOfWeek() {
            vm.notificationTypeSchedule.dayOfWeek = null;
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('PaymentConditionListController', PaymentConditionListController);

    /**@ngInject**/
    function PaymentConditionListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log, $scope) {
        const vm = this;
        const TIMEOUT_EONE_THOUSAND = 1000;

        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.paymentConditions = [];

        const colDefs = [
            {
                field: 'name',
                headerName: 'paymentCondition.name',
                headerCellRenderer: getHeader,
                width: 250,
            },
            {
                field: 'erpCode',
                headerName: 'paymentCondition.code',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'active',
                headerCellRenderer: getHeader,
                headerName: 'general.active',
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' },
                width: 70,
            },
            {
                name: 'edit',
                headerName: 'paymentCondition.options',
                headerCellRenderer: getHeader,
                width: 100,
                cellStyle: { 'padding': '2px' },
                pinned: 'right',
                cellRenderer: function () {
                    return '<div layout="row" layout-align="space-between"> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onDelete(data)" ng-if="data.active"> '
                        + ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + '</div>';
                },
            },
        ];

        vm.gridPayment = {
            columnDefs: colDefs,
            rowSelection: 'multiple',
            enableColResize: true,
            enableSorting: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            animateRows: true,
            rowHeight: 45,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function () {
                return true;
            },
            doesExternalFilterPass: doesExternalFilterPassFunc,
            isExternalFilterPresent: isExternalFilterPresentFunc,
        };

        const filter = 'everyone';
        function isExternalFilterPresentFunc() {
            return filter !== '';
        }

        function doesExternalFilterPassFunc(node) {
            if (filter && filter !== 'everyone') {
                const arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }
        function getPaymentConditions() {
            vm.showGrid = false;
            vm.isShowProgressLineargridPayment = true;
            api.PagosWS.PaymentCondition.byCompany.get({
                'companyId': $rootScope.bsCircle.company.id,
            })
                .$promise.then(function (response) {
                    const newData = new jinqJs()
                        .from(response)
                        .orderBy('id')
                        .select(function (d) {
                            d.filter = (d.id + ',' + d.name + ',' + d.erpCode).toLowerCase();
                            return d;
                        });

                    vm.gridPayment.api.setRowData(newData);
                    vm.paymentConditions = newData;
                    vm.showGrid = true;
                    vm.isShowProgressLineargridPayment = false;
                }, function (response) {
                    vm.gridPayment.api.setRowData([]);
                    vm.showGrid = true;
                    vm.isShowProgressLineargridPayment = false;
                    $log.error(response);
                });
        }

        function init() {
            getPaymentConditions();
        }

        function edit(data) {
            let isNew = false;
            if (data) {
                data.companyId = $rootScope.bsCircle.company.id;
            } else {
                isNew = true;
                data = {
                    companyId: $rootScope.bsCircle.company.id
                };
            }

            $mdDialog.show({
                controller: 'PaymentConditionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/payment-condition/payment/payment.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'paymentCondition': angular.copy(data),
                },
            }).then(function (answer) {
                if (isNew) {
                    vm.paymentConditions.push(answer);
                    MessageService.show($filter('translate')('paymentCondition.added'));
                } else {
                    const i = vm.paymentConditions.indexOf(data);
                    vm.paymentConditions[i] = answer;
                    MessageService.show($filter('translate')('paymentCondition.updated'));
                }
                vm.gridPayment.api.setRowData(vm.paymentConditions);
                vm.gridPayment.api.redrawRows();
            }, function () {
                // Empty
            });
        }

        function onDelete(data) {
            const confirm = $mdDialog.confirm()
            .ariaLabel($filter('translate')('paymentCondition.deactivatePaymentCondition'))
                .title($filter('translate')('paymentCondition.deactivatePaymentCondition'))
                .textContent($filter('translate')('paymentCondition.deactivateConfirm'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.PagosWS.PaymentCondition.byCompany.delete({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': data.id,
                }).$promise.then(function () {
                    const i = vm.paymentConditions.indexOf(data);
                    data.active = false;
                    vm.paymentConditions[i] = data;
                    vm.isShowProgressLinear = false;
                    vm.gridPayment.api.setRowData(vm.paymentConditions);
                    vm.gridPayment.api.redrawRows();
                    MessageService.show($filter('translate')('paymentCondition.deleted'));
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    $log.error(response);
                });
            }, function () {
                // Empty
            });
        }

        $timeout(function () {
            init();
        }, TIMEOUT_EONE_THOUSAND);

        $scope.$watch('vm.inputSearch', function () {
            if (vm.gridPayment.api) {
                vm.gridPayment.api.setRowData($filter('filter')(vm.paymentConditions, vm.inputSearch));
            }
        });

    }
})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('PaymentConditionController', PaymentConditionController);

    /**@ngInject**/
    function PaymentConditionController($mdDialog, api, paymentCondition, $log, MessageService, $filter, $rootScope) {

        const vm = this;
        const EXCEPTION_STATUS_ALREADY_EXISTS = 409;

        vm.paymentCondition = paymentCondition;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        if (vm.paymentCondition.id) {
            vm.paymentCondition.company = $rootScope.bsCircle.company.id;
        }

        function save() {
            vm.isShowProgressLinear = true;
            let promise;
            if (vm.paymentCondition) {
                vm.paymentCondition.companyId = $rootScope.bsCircle.company.id;
            }

            let activeP = angular.copy(vm.paymentCondition.active);
            if (vm.paymentCondition.active === undefined) {
                activeP = true;
            }

            const currentPaymentCondition= {
                companyId: vm.paymentCondition.company,
                name: vm.paymentCondition.name,
                erpCode: vm.paymentCondition.erpCode,
                active: activeP
            };

            if (vm.paymentCondition.id) {
                promise = api.PagosWS.PaymentCondition.byCompany.update({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': vm.paymentCondition.id,
                }, vm.paymentCondition).$promise;
            } else {
                promise = api.PagosWS.PaymentCondition.byCompany.create({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': undefined,
                }, vm.paymentCondition).$promise;
            }
            promise.then(function (response) {
                currentPaymentCondition.id = response.$data;
                const filter = (currentPaymentCondition.id + ',' + currentPaymentCondition.name + ',' + currentPaymentCondition.erpCode).toLowerCase();
                currentPaymentCondition.filter = filter;
                vm.isShowProgressLinear = false;
                $mdDialog.hide(currentPaymentCondition);
            }, function (exception) {
                if (exception && exception.status === EXCEPTION_STATUS_ALREADY_EXISTS) {
                    MessageService.showErrorMessage($filter('translate')('paymentCondition.alreadyExists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.error'));
                }
                vm.isShowProgressLinear = false;
                $log.error(exception);
            });
            return true;
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('dialogAdditionalFieldAppEditController', dialogAdditionalFieldAppEditController);

    function dialogAdditionalFieldAppEditController(api, MessageService, $filter, $rootScope, data, $mdDialog) {
        var vm = this;
        vm.currentTab = 1;
        vm.data = data;
        vm.active = true;

        vm.selectedCompanyApplicationAdditionalField = {
            additionalField: { id: vm.data.id },
            required: false,
            id: 0
        };

        vm.masterColumnDefs = [
            {
                headerName: "ADDITIONAL_FIELDS.appName",
                headerCellRenderer: getHeader,
                field: "application.name",
                width: 250,
                cellRenderer: "group"
            },
            {
                headerName: "ADDITIONAL_FIELDS.establishmentName",
                headerCellRenderer: getHeader,
                field: "companyEstablishment.establishmentName",
                width: 250,
                cellRenderer: "group"
            },
            {
                headerName: "ADDITIONAL_FIELDS.orders",
                headerCellRenderer: getHeader,
                field: "orders",
                width: 90,
                cellRenderer: "group",
                cellStyle: { 'text-align': 'center' },
            },
            {
                headerName: "ADDITIONAL_FIELDS.fieldDetailOrder",
                headerCellRenderer: getHeader,
                field: "fieldDetailOrder",
                width: 120,
                cellRenderer: "group",
                cellStyle: { 'text-align': 'center' },
            },
            {
                headerName: "ADDITIONAL_FIELDS.required",
                headerCellRenderer: getHeader,
                field: "required",
                cellStyle: { 'text-align': 'center' },
                width: 120,
                cellRenderer: function (param) {
                    return '<md-icon ng-if="data.required" md-font-icon=\'icon-check\'></md-icon><md-icon ng-if="!data.required" md-font-icon=\'icon-close\'></md-icon>';
                }
            },
            {
                headerName: "ADDITIONAL_FIELDS.visibleReport",
                headerCellRenderer: getHeader,
                field: "visibleReport",
                cellStyle: { 'text-align': 'center' },
                width: 120,
                cellRenderer: function (param) {
                    return '<md-icon ng-if="data.visibleReport" md-font-icon=\'icon-check\'></md-icon><md-icon ng-if="!data.visibleReport" md-font-icon=\'icon-close\'></md-icon>';
                }
            },
            {
                suppressMenu: true,
                suppressSorting: true,
                headerName: "ADDITIONAL_FIELDS.options",
                headerCellRenderer: getHeader,
                name: "edit",
                width: 250,
                cellRenderer: function (params) {
                    if (params.data && params.data.id) {
                        return '<md-button class="md-icon-button" ng-click="vm.editCompanyApplicationAdditionalFields(data, $event)">'
                            + ' <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip>'
                            + ' </md-tooltip> </md-button> '
                            + ' <md-button class="md-icon-button" ng-click="vm.deleteCompanyApplicationAdditionalFields(data, $event)"> '
                            + ' <md-icon md-font-icon="icon-trash" class="s16 md-warn"></md-icon> '
                            + ' <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip></md-tooltip> </md-button>';
                    }
                    return '';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.gridFields = {
            enableSorting: true,
            debug: false,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            rowGroupPanelShow: "none",
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            rowSelection: 'multiple',
            rowDeselection: true,
            pagination: true,
            fullWidthCellRenderer: true,
            rowData: null,
            pinnedBottomRowData: [],
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.closeDialog = function () {

            if (vm.currentTab === 1) {
                $mdDialog.cancel();
            } else {
                vm.currentTab = 1;
            }
        };

        init();

        function init() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.CompanyApplicationAdditionalFields.CompanyApplicationAdditionalFields.get({
                'additionalField': vm.data.id, 'idCircle': $rootScope.bsCircle.id
            }, function (response) {
                vm.gridFields.api.setColumnDefs(vm.masterColumnDefs);
                vm.gridFields.api.setRowData(response);
                vm.appExist = [];
                response.forEach(function (appField) {
                    vm.appExist.push(appField.application);
                });
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                $rootScope.loadingProgress = false;
            });
            api.GeneralWS.CompanyEstablishment.me.page({ 
                'id': 'byCompany',
                'idCircle': $rootScope.bsCircle.id, 
                'page': 1, 'pageSize': 100, 'active': vm.active 
            }).$promise.then(function (response) {
                vm.companyestablishments = response.content;

            }, function (response) {
                $log.error(response);
            });
        }

        vm.saveCompanyApplicationAdditionalField = function () {
            $rootScope.loadingProgress = true;
            api.GeneralWS.CompanyApplicationAdditionalFields.CompanyApplicationAdditionalFields.save({
                'idCircle': $rootScope.bsCircle.id
            }, vm.selectedCompanyApplicationAdditionalField, function (response) {
                $mdDialog.hide(response);
                MessageService.show($filter('translate')('ADDITIONAL_FIELDS.MSG.ADDEDD_SUCCESSFULLY'));
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                MessageService.showErrorMessage($filter('translate')('ADDITIONAL_FIELDS.MSG.' + errResponse.data));
                $rootScope.loadingProgress = false;
            });
        };

        vm.editCompanyApplicationAdditionalFields = function (data, index) {
            vm.selectedCompanyApplicationAdditionalField = angular.copy(data);
            api.GeneralWS.CompanyApplication.me.query({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.applications = response;
                vm.appExist.forEach(function (inf) {
                    vm.applications.forEach(function (app, index) {
                        if (inf.id === app.application.id
                            && (vm.selectedCompanyApplicationAdditionalField.id > 0
                                && vm.selectedCompanyApplicationAdditionalField.application.id !== app.application.id)) {
                            vm.applications.splice(index, 1);
                        }
                    });
                });
            }, function (d) {
            });
            vm.currentTab = 2;
        };

        vm.deleteCompanyApplicationAdditionalFields = function (data, index) {
            vm.selectedCompanyApplicationAdditionalField = data;
            var dl = $mdDialog.confirm()
                .title($filter('translate')('ADDITIONAL_FIELDS.MSG.DELETE'))
                .textContent($filter('translate')('ADDITIONAL_FIELDS.MSG.DELETE_CONFIRM'))
                .ariaLabel('none')
                .clickOutsideToClose(true)
                .multiple(true)
                .ok($filter('translate')('ADDITIONAL_FIELDS.MSG.SI'))
                .cancel($filter('translate')('ADDITIONAL_FIELDS.MSG.NO'));
            $mdDialog.show(dl).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.CompanyApplicationAdditionalFields.CompanyApplicationAdditionalFields.update({
                    'idCircle': $rootScope.bsCircle.id
                }, vm.selectedCompanyApplicationAdditionalField, function (response) {
                    init();
                    vm.currentTab = 1;
                    MessageService.show($filter('translate')('ADDITIONAL_FIELDS.MSG.ADDEDD_SUCCESSFULLY'));
                    $rootScope.loadingProgress = false;
                }, function (errResponse) {
                    MessageService.showErrorMessage($filter('translate')('ADDITIONAL_FIELDS.MSG.' + errResponse.data));
                    $rootScope.loadingProgress = false;
                });
            });
        };

        vm.newCompanyApplicationAdditionalFields = function () {
            vm.selectedCompanyApplicationAdditionalField = {
                additionalField: { id: vm.data.id },
                required: false,
                id: 0
            };
            api.GeneralWS.CompanyApplication.me.query({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.applications = response;
            }, function (d) {
            });
            vm.currentTab = 2;
        };


    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('AdditionalFieldsEditController', additionalFieldsEditController);

    function additionalFieldsEditController($log, api, MessageService, $timeout, $rootScope, additionalField, $mdDialog) {

        var vm = this;
        vm.additionalField = additionalField;
        vm.dataTypes = [
            { value: 'TEXT', text: 'Texto' },
            { value: 'NUMBER', text: 'Número' },
            { value: 'DECIMAL', text: 'Número Decimal' },
            { value: 'BOOLEAN', text: 'Lógico' },
            { value: 'LIST', text: 'Lista' }
        ];

        vm.colorPickerOptions = {
            hasBackdrop: false,
            clickOutsideToClose: true,
            random: true,
            skipHide: true,
            openOnInput: true,
            parent: angular.element("#main"),

            alphaChannel: false,
            history: false,
            default: "#f00",
            defaultTab: 1
        };

        vm.width = '60%';
        vm.height = '60%';

        //methods
        vm.clearDataType = clearDataType;
        vm.closeDialog = closeDialog;
        vm.save = save;
        vm.verifyListValue = verifyListValue;
        vm.arrValueList = [];
        vm.valueNewList = {};
        vm.indexView = 0;
        vm.companyAdditionalFieldsValue = {
            companyAdditionalFields: additionalField
        };

        if (vm.additionalField && vm.additionalField.dataType === 'LIST') {
            api.GeneralWS.CompanyAdditionalFieldsValue.get(
                {
                    company: $rootScope.bsCircle.company.id, 'companyAdditionalFieldsId': vm.additionalField.id
                }
            ).$promise.then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    response[i].style = getStyleRow(response[i]);
                }
                vm.arrValueList = response;
            }, function (err) { });
        }

        function clearDataType() {
            vm.searchDataType = "";
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function getStyleRow(valueAdd) {
            var obStyle = {};
            if (valueAdd.fieldColor) {
                obStyle["background-color"] = valueAdd.fieldColor;
            }
            if (valueAdd.fieldColorFont) {
                obStyle["color"] = valueAdd.fieldColorFont;
            }
            return obStyle;
        }

        function save() {
            vm.isShowProgressLinear = true;

            var promise;
            var isEdit = false;

            vm.additionalField.company = {
                id: $rootScope.bsCircle.company.id
            };

            if (!vm.additionalField.id) {
                promise = api.GeneralWS.CompanyAdditionalFields.getByCompany.create({ company: $rootScope.bsCircle.company.id }, vm.additionalField).$promise;
            } else if (vm.additionalField.id) {
                isEdit = true;
                promise = api.GeneralWS.CompanyAdditionalFields.getByCompany.update({ company: $rootScope.bsCircle.company.id }, vm.additionalField).$promise;
            }
            vm.additionalField.useInOpeningCycle = vm.additionalField.useInOpeningCycle ? vm.additionalField.useInOpeningCycle : false;

            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                if (isEdit) {
                    MessageService.show("ADDITIONAL_FIELDS.FIELD_UPDATED");
                } else {
                    MessageService.show('ADDITIONAL_FIELDS.FIELD_CREATED');
                }
                $mdDialog.hide(response);


            }, function (erro) {
                vm.isShowProgressLinear = false;
                MessageService.show('general.general_error');
                if (erro.status === 409) {
                    MessageService.show('El nombre del campo ya está asociado a la empresa');
                }

            });
        }

        function init() {
            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchDataTypeInput = document.querySelector("#searchDataType");

            if (searchDataTypeInput) {
                searchDataTypeInput.addEventListener("keydown", keyEvent);
            }
        }

        function verifyListValue() {
            if (vm.additionalField && vm.additionalField.dataType === 'LIST') {
                vm.viewDetailList = true;
                vm.height = '80%';
            } else {
                vm.height = '60%';
            }
        }

        vm.addValueList = function (data) {
            if (!data.fieldValue || data.fieldValue === '' || !data.fieldCode || data.fieldCode === '') {
                MessageService.showErrorMessage("ADDITIONAL_FIELDS.valuesrequired");
                return;
            }
            var exist = false;
            vm.arrValueList.forEach(function (info) {
                if (data === info.fieldValue) {
                    exist = true;
                }
            });

            if (!exist) {
                var CompanyAdditionalFieldsValue = {
                    fieldValue: data.fieldValue,
                    fieldCode: data.fieldCode,
                    fieldColor: data.fieldColor,
                    fieldColorFont: data.fieldColorFont,
                    fieldOrder: data.fieldOrder,
                    companyAdditionalFields: vm.additionalField
                };
                if (vm.companyAdditionalFieldsValue && vm.companyAdditionalFieldsValue.id) {
                    CompanyAdditionalFieldsValue = vm.companyAdditionalFieldsValue;
                    CompanyAdditionalFieldsValue.fieldValue = data.fieldValue;
                    CompanyAdditionalFieldsValue.fieldCode = data.fieldCode;
                    CompanyAdditionalFieldsValue.fieldColor = data.fieldColor; 
                    CompanyAdditionalFieldsValue.fieldOrder = data.fieldOrder;
                    CompanyAdditionalFieldsValue.fieldColorFont = data.fieldColorFont;
                }
                api.GeneralWS.CompanyAdditionalFieldsValue.create({ company: $rootScope.bsCircle.company.id }, CompanyAdditionalFieldsValue).$promise.then(
                    function (response) {
                        response.style = getStyleRow(response);
                        vm.arrValueList.push(response);
                        vm.valueNewList = {};
                        vm.indexView = 0;
                        vm.companyAdditionalFieldsValue = {
                            companyAdditionalFields: vm.additionnalField
                        };
                    }, function (err) {
                        if (err.data === 'EXISTS' || err.data.mensaje === 'EXISTS') {
                            MessageService.showErrorMessage("ADDITIONAL_FIELDS.detailExist");
                        }
                    }
                );


            } else {
                MessageService.showErrorMessage("ADDITIONAL_FIELDS.detailExist");
            }
        };

        vm.removeValueList = function (ev, data, index) {
            api.GeneralWS.CompanyAdditionalFieldsValue.dele({ company: $rootScope.bsCircle.company.id, 'id': data.id }).$promise.then(function (response) {
                MessageService.show('ADDITIONAL_FIELDS.deleted');
                vm.arrValueList.splice(index, 1);
            }, function (err) { });

        };

        vm.editValueList = function (ev, data, index) {
            vm.companyAdditionalFieldsValue = data;
            vm.indexView = 1;
            vm.valueNewList = data;
            vm.arrValueList.splice(index, 1);
        };

        vm.add = function () {
            vm.companyAdditionalFieldsValue = {
                companyAdditionalFields: vm.additionalField
            };
            vm.indexView = 1;
        };

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('DiscountsConfigureController', DiscountsConfigureController);

    function DiscountsConfigureController($scope, $log, api, MessageService, $filter, $timeout, $rootScope, $stateParams, DiscountTypes, $mdDialog,
        PreviousState, $state) {

        var vm = this;
        vm.viewIndex = 0;
        vm.tabIndex = 0;
        vm.pagination = {
            pageNumber: 0,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        vm.discountDate = {
            discountStartDate: new Date(),
            discountEndDate: new Date()
        }
        vm.discountTypes = DiscountTypes;
        vm.currentDiscountDates = {};
        vm.currentDiscountDatesFilter = {};

        vm.discountTypes.forEach(function (element) {
            element.value = $filter("translate")("DISCOUNTS.types." + element.keyDiscountType);
        });
        vm.allDiscountCompanyPriority = [];
        vm.finalPriceDiscountTypes = [
          'PRODUCT',
          'PRODUCT_TYPE_ADD_FIELD',
          'PRODUCT_TYPE'
        ];

        //methods
        vm.addAdditionalField = addAdditionalField;
        vm.addDiscountPriority = addDiscountPriority;
        vm.getEstablishment = getEstablishment;
        vm.goToDiscountDateSpecialFilters = goToDiscountDateSpecialFilters;
        vm.goToDiscountDateSpecialFiltersList = goToDiscountDateSpecialFiltersList;
        vm.editDiscountDatesMessage = editDiscountDatesMessage;
        vm.filterDisocuntPriorityByDiscountMethod = filterDisocuntPriorityByDiscountMethod;

        var columnDefs = [
            {
                field: "discountType",
                headerName: 'DISCOUNTS.DISCOUNT_TYPE',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.data) {
                        return $filter("translate")("DISCOUNTS.types." + params.data.discountType);
                    }
                },
                width: 250
            },
            {
                field: "priorityOrder",
                headerName: 'DISCOUNTS.PRIORITY_ORDER',
                headerCellRenderer: getHeader,
                width: 200,
                cellStyle: { 'text-align': 'center' },
                sort: 'asc'
            },
            {
                field: "secondDiscountType",
                headerName: 'DISCOUNTS.SECOND_DISCOUNT_TYPE',
                headerCellRenderer: getHeader,
                width: 200,
                cellRenderer: function (params) {
                    if (params.data && params.data.secondDiscountType) {
                        return $filter("translate")("DISCOUNTS.types." + params.data.secondDiscountType);
                    }
                }
            },
            {
                headerName: 'DISCOUNTS.DELETE',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.delete(data)'> " +
                        "<md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> <md-tooltip md-direction='left'>" +
                        "{{'general.delete' | translate}}</md-tooltip> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        var columnDefsDD = [
            {
                field: "discountType",
                headerName: 'DISCOUNTS.DISCOUNT_TYPE',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.data) {
                        return $filter("translate")("DISCOUNTS.types." + params.data.discountType);
                    }
                },
                width: 250
            },
            {
                field: "discountCompanyEstablishment.discountCompany.discountName",
                headerName: 'DISCOUNTS.discountCompanyEstablishment',
                headerCellRenderer: getHeader,
                width: 130,
                cellStyle: { 'text-align': 'center' }
            },
            {
                field: "discountStartDate",
                headerName: 'DISCOUNTS.discountStartDate',
                headerCellRenderer: getHeader,
                width: 140,
                cellRenderer: function (params) {
                    return "{{data.discountStartDate+'T00:00:00.000' | date: 'dd-MM-yyyy'}}";
                }
            },
            {
                field: "discountEndDate",
                headerName: 'DISCOUNTS.discountEndDate',
                headerCellRenderer: getHeader,
                width: 140,
                cellRenderer: function (params) {
                    return "{{data.discountEndDate+'T00:00:00.000' | date: 'dd-MM-yyyy'}}";
                }
            },
            {
                field: "referenceId",
                headerName: 'DISCOUNTS.referenceId',
                headerCellRenderer: getHeader,
                width: 150,
                cellStyle: { 'text-align': 'center' }
            },
            {
                field: "additionalFieldValue",
                headerName: 'DISCOUNTS.additionalFieldValue',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "applyAll",
                headerName: 'DISCOUNTS.APPLY_ALL',
                headerCellRenderer: getHeader,
                width: 120,
                cellRenderer: function (params) {
                    if (params.data.applyAll) {
                        return '<center><md-icon md-font-icon="icon-check"></md-icon></center>'
                    } else {
                        return '<center><md-icon md-font-icon="icon-close"></md-icon></center>'
                    }
                }
            },
            {
                field: "applyToAllInvoices",
                headerName: 'DISCOUNTS.APPLY_TO_ALL_INVOICES',
                headerCellRenderer: getHeader,
                width: 120,
                cellRenderer: function (params) {
                    if (params.data.applyToAllInvoices) {
                        return '<center><md-icon md-font-icon="icon-check"></md-icon></center>'
                    } else {
                        return '<center><md-icon md-font-icon="icon-close"></md-icon></center>'
                    }
                }
            },
            {
                headerName: 'DISCOUNTS.message',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function () {
                    return "<center> " +
                        " <md-button class='md-icon-button' ng-click='vm.editDiscountDatesMessage(data)' " +
                        "           title=\"{{'general.edit' | translate}} {{'DISCOUNTS.message' | translate}}\" >" +
                        "  <md-icon md-font-icon='icon-comment-text'></md-icon> " +
                        " </md-button>" +
                        " </center>";
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                headerName: 'DISCOUNTS.SPECIAL_FILTERS',
                headerCellRenderer: getHeader,
                width: 130,
                cellRenderer: function (params) {
                    return "<center> " +
                        " <md-button title=\"{{'DISCOUNTS.addFilters' | translate}}\" ng-if='!data.applyAll' class='md-icon-button' ng-click='vm.goToDiscountDateSpecialFilters(data);'> " +
                        " <md-icon md-font-icon='icon-plus'> " +
                        " </md-button> " +
                        " <md-button title='Ver lista de filtros' ng-if='!data.applyAll' class='md-icon-button' ng-click='vm.goToDiscountDateSpecialFiltersList(data);'> " +
                        " <md-icon md-font-icon='icon-eye'></md-icon> " +
                        " </md-button> " +
                        " </center>";
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                headerName: 'DISCOUNTS.DELETE',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> " +
                        " <md-button class='md-icon-button' ng-click='vm.deleteDiscounDates(data)'> " +
                        "  <md-icon class='md-warn' md-font-icon='icon-trash'></md-icon> <md-tooltip md-direction='left'>" +
                        "{{'general.delete' | translate}}</md-tooltip> " +
                        " </md-button>" +
                        " </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.discountGrid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            enableSorting: true,
            sortingOrder: ['asc', 'asc'],
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };


        vm.discountDatesGrid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefsDD,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            enableSorting: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function init() {
            getDiscountCompanyEstablishments();
            getDiscountDatesEstablishment();
            getEstablishment();
        }

        function goToDiscountDateSpecialFilters(discountDates) {
            vm.currentDiscountDates = discountDates;
            vm.previousViewIndex = vm.viewIndex;
            vm.viewIndex = 4;
        }

        function goToDiscountDateSpecialFiltersList(discountDates) {
            vm.currentDiscountDates = discountDates;
            vm.viewIndex = 5;
        }

        function editDiscountDatesMessage(discountDate) {
            $mdDialog.show({
                    controller: 'DiscountDatesMessageDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/discountDatesMessageDialog/discountDatesMessageDialog.html',
                    parent: angular.element("#main"),
                    targetEvent: event,
                    locals: {
                        'discountDate': angular.copy(discountDate)
                    },
                    clickOutsideToClose: false
                }).then(function (response) {
                    discountDate.message = response;
                }, function () { });
        }

        function getEstablishment() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.CompanyEstablishment.me.get({ 'id': $stateParams.id }).$promise.then(function (response) {
                var startDate = new Date(response.startDate);
                response.startDate = startDate;
                var endDate = new Date(response.endDate);
                response.endDate = endDate;
                vm.establishment = response;
                $rootScope.loadingProgress = false;
                getDiscountCompanyEstablishmentPriority();
            }, function (response) {
                $log.error(response);
                MessageService.showErrorMessage('general.general_error');
                $rootScope.loadingProgress = false;
            });
        }

        function getDiscountCompanyEstablishmentPriority() {
            $rootScope.loadingProgress = true;
            api.GeneralWS.DiscountCompanyEstablishmentPriority.byEstablishment.get({
                'establishmentId': $stateParams.id
            }).$promise.then(function (response) {
                vm.discountGrid.api.setRowData(response);
                vm.discountCompanyPriority = response;
                vm.discountCompanyPriority.forEach(function (element) {
                    element.value = $filter("translate")("DISCOUNTS.types." + element.discountType);
                });
                vm.allDiscountCompanyPriority = angular.copy(vm.discountCompanyPriority);
                vm.discountGrid.api.setColumnDefs(columnDefs);
                $rootScope.loadingProgress = false;
            }, function (response) {
                $log.error(response);
                MessageService.showErrorMessage('general.general_error');
                $rootScope.loadingProgress = false;
            });
        }

        vm.delete = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('DISCOUNTS.DELETE'))
                .textContent($filter('translate')('DISCOUNTS.CONFIRMATION_DELETE'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.DiscountCompanyEstablishmentPriority.DiscountCompanyEstablishmentPriority.del({
                    "idCircle": $rootScope.bsCircle.id, 'id': data.id
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('DISCOUNTS.DELETED_SUCCESSFULLY'));
                    init();
                }, function (errResponse) {
                    $log.error(errResponse);
                });
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function getDiscountCompanyEstablishments() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.DiscountCompanyEstablishment.byEstablishment.get({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': $stateParams.id, 'pageSize': vm.pagination.pageSize,
                'page': vm.pagination.pageNumber
            }, function (response) {
                vm.companyEstablishmentDiscounts = response;
                vm.isShowProgressLinear = false;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        function getDiscountDatesEstablishment() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.DiscountDates.byEstablishment.get({
                "idCircle": $rootScope.bsCircle.id, 'establishmentId': $stateParams.id, 'pageSize': vm.pagination.pageSize,
                'page': vm.pagination.pageNumber
            }, function (response) {
                vm.discountDatesGrid.api.setRowData(response);
                vm.discountDatesGrid.api.setColumnDefs(columnDefsDD);
                vm.isShowProgressLinear = false;
            }, function (errResponse) {
                vm.isShowProgressLinear = false;
                $log.debug(errResponse);
            });
        }

        vm.saveDiscountDates = function () {
            $rootScope.loadingProgress = true;
            api.GeneralWS.DiscountDates.DiscountDates.create({ "idCircle": $rootScope.bsCircle.id }, vm.discountDate, function (response) {
                vm.discountDate = {
                    discountStartDate: new Date(),
                    discountEndDate: new Date()
                };
                MessageService.show($filter('translate')('DISCOUNTS.ADDED_SUCCESSFULLY'));
                getDiscountDatesEstablishment();
                $rootScope.loadingProgress = false;
                vm.tabIndex = 2;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        };

        vm.deleteDiscounDates = function (data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('DISCOUNTS.DELETE'))
                .textContent($filter('translate')('DISCOUNTS.CONFIRMATION_DELETE'))
                .multiple(true)
                .ok($filter('translate')('BANK.SI'))
                .cancel($filter('translate')('BANK.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                $rootScope.loadingProgress = true;
                api.GeneralWS.DiscountDates.DiscountDates.del({ "id": data.id }, function (response) {
                    MessageService.show($filter('translate')('DISCOUNTS.DELETED_SUCCESSFULLY'));
                    getDiscountDatesEstablishment();
                    $rootScope.loadingProgress = false;
                }, function (errResponse) {
                    $log.debug(errResponse);
                });

            }, function (errResponse) {
                $log.debug(errResponse);
            });
        };

        vm.addReference = function () {
            if (vm.discountDate.discountType) {
                var discountType0 = angular.copy(vm.discountDate.discountType);

                if (discountType0 === 'PRODUCT_TYPE_ADD_FIELD') {
                    discountType0 = 'PRODUCT_TYPE';
                }

                $mdDialog.show({
                    controller: 'dialogReferenceController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/dialogReference/dialogReference.html',
                    parent: angular.element("#main"),
                    targetEvent: event,
                    locals: {
                        'establishment': vm.establishment,
                        'type': discountType0,
                        'hasList': false
                    },
                    clickOutsideToClose: false
                }).then(function (response) {
                    vm.discountDate.referenceId = response[0].id;
                }, function () { });
            }
        }

        vm.back = function () {
            if (PreviousState.name) {
                $state.go(PreviousState.name);
            } else {
                $state.go('app.dashboards_project');
            }
        };

        vm.addFilters = function (data) {
            $mdDialog.show({
                controller: 'dialogMoreFiltersController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/dialogMoreFilters/dialogMoreFilters.html',
                parent: angular.element("#main"),
                targetEvent: event,
                multiple: true,
                locals: {
                    'establishment': vm.establishment,
                    'data': data
                },
                clickOutsideToClose: false
            }).then(function (response) {
                vm.discountDate.referenceId = response.id;
            }, function () { });
        }

        function addAdditionalField($event) {
            if (vm.discountDate.discountType) {
                $mdDialog.show({
                    controller: 'dialogReferenceController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/dialogReference/dialogReference.html',
                    parent: angular.element("#main"),
                    targetEvent: event,
                    locals: {
                        'establishment': vm.establishment,
                        'type': vm.discountDate.discountType,
                        'hasList': false
                    },
                    clickOutsideToClose: false
                }).then(function (response) {
                    showAdditionalFieldValues(response[0].id, response[0].additionalFieldName);
                }, function () { });
            }
        }

        function showAdditionalFieldValues(companyAdditionalFieldId, dialogTitle) {
            $mdDialog.show({
                controller: 'AdditionalFieldValuesDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/AdditionalFieldValuesDialog/AdditionalFieldValuesDialog.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'companyAdditionalFieldId': companyAdditionalFieldId,
                    'dialogTitle': dialogTitle
                },
                clickOutsideToClose: false
            }).then(function (response) {
                vm.discountDate.additionalFieldValue = response.fieldValue;
            }, function () { });
        }

        function addDiscountPriority() {
            $mdDialog.show({
                controller: 'AddDiscountPriorityController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/discounts/discountsConfigure/addDiscountPriorityDialog/AddDiscountPriorityDialog.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'establishmentId': $stateParams.id
                },
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                    MessageService.show($filter('translate')('DISCOUNTS.ADDED_SUCCESSFULLY'));
                    init()
                }
            }, function () { });
        }

        function filterDisocuntPriorityByDiscountMethod() {
          if (!vm.discountDate.discountCompanyEstablishment.id) {
            return;
          }
          const discountEstablishment = vm.companyEstablishmentDiscounts.find(function (item) {
            return item.id.toString() === vm.discountDate.discountCompanyEstablishment.id.toString();
          });

          if (discountEstablishment && discountEstablishment.discountCompany.discountMethod === 'FINAL_PRICE') {
            vm.discountCompanyPriority = vm.allDiscountCompanyPriority.filter(function (item) {
              return vm.finalPriceDiscountTypes.includes(item.discountType);
            });
            vm.discountDate.discountType = null;
          } else {
            vm.discountCompanyPriority = angular.copy(vm.allDiscountCompanyPriority);
          }
        }

        init();

        $scope.$watch(function () {
            return vm.viewIndex;
        }, function (current, old) {
            if (current === 3) {
                vm.currentDiscountDates = {}
            }
            if (current === 3) {
                $timeout(function () {
                    vm.discountDate = {
                        discountStartDate: new Date(),
                        discountEndDate: new Date()
                    };
                }, 500);
            }
        });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('gFaceEditController', gFaceEditController);

    function gFaceEditController(api, MessageService, $filter, $timeout, $rootScope, data, $mdDialog) {
        const vm = this;
        vm.companyGface = data;
        vm.searchGetCompanyGface = searchGetCompanyGface;
        vm.gFaceDisabled = false;
        vm.closeDialog = closeDialog;
        init();
        if (vm.companyGface) {
            vm.gFaceDisabled = true;
            processDate();
        }
        function init() {
            api.GeneralWS.GFace.GFace.getAll({ 'companyId': $rootScope.bsCircle.company.id }, function (response) {
                vm.gFaces = response;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }
         function closeDialog() {
            $mdDialog.cancel();
        }
        vm.saveGfaceByCompany = function () {
            $rootScope.loadingProgress = true;
            api.GeneralWS.CompanyGface.companyGface.save({ 'companyId': $rootScope.bsCircle.company.id, 'gFaceId': vm.companyGface.gface.id },
                vm.companyGface, function (response) {
                    $mdDialog.hide(response);
                    MessageService.show($filter('translate')('GFACE.ADDEDD_SUCCESSFULLY'));
                    $rootScope.loadingProgress = false;
                }, function (errResponse) {
                    MessageService.showErrorMessage($filter('translate')('GFACE.ERRORWHENSAVINGTHEDATA' + errResponse.data));
                    $rootScope.loadingProgress = false;
                });
        };

        function searchGetCompanyGface(dataId) {
            api.GeneralWS.CompanyGface.companyGface.get({ 'companyId': $rootScope.bsCircle.company.id, 'gFaceId': dataId }, function (response) {
                if (response.id !== undefined) {
                    vm.companyGface = response;
                    processDate();
                }
                else {
                    vm.companyGface = {
                        gface: vm.companyGface.gface,
                        orderPriority: "",
                        userToSignDocuments: "",
                        keyToSignDocuments: "",
                        aliasPfx: "",
                        keyPfx: '',
                        expirationDate: null,
                    };
                }
            }, function (errResponse) {
                MessageService.showErrorMessage($filter('translate')('GFACE.ERROR.' + errResponse.data));
            });
        }

        function processDate() {
            if (vm.companyGface.expirationDate) {
                vm.companyGface.expirationDate = moment(vm.companyGface.expirationDate).toDate();
            }
        }

        function changeSearch() {
            vm.clearSearchCompanyGface = function () {
                vm.searchCompanyGface = "";
            };
            $timeout(function () {

                const keyEvent = function (event) {
                    event.stopPropagation();
                };
                const searchCompanyGfaceInput = document.querySelector("#searchCompanyGface");
                if (searchCompanyGfaceInput) {
                    searchCompanyGfaceInput.addEventListener("keydown", keyEvent);
                }
            }, 300);
        }
        changeSearch();
        $timeout(init, 500);
    }
})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('dialogDiscountsController', dialogDiscountsController);

    function dialogDiscountsController(api, MessageService, $filter, $rootScope, data, $mdDialog, DiscountMethods, $timeout) {
        var vm = this;
        vm.discount = data;

        vm.discountMethodFinalPriceCode = 'FINAL_PRICE';
        vm.discountMethods = DiscountMethods;
        vm.discountMethods.forEach(function (element) {
            element.value = $filter("translate")("DISCOUNTS.discountMethods." + element.key);
        });

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        if (!vm.discount) {
            vm.discount = {
                id: 0
            };
        }

        vm.saveCompanyApplicationAdditionalField = function () {
            $rootScope.loadingProgress = true;
            api.GeneralWS.DiscountCompany.DiscountCompany.create({ 'idCircle': $rootScope.bsCircle.id }, vm.discount, function (response) {
                $mdDialog.hide(response);
                MessageService.show($filter('translate')('ADDITIONAL_FIELDS.MSG.ADDEDD_SUCCESSFULLY'));
                $rootScope.loadingProgress = false;
            }, function (errResponse) {
                MessageService.showErrorMessage($filter('translate')('ADDITIONAL_FIELDS.MSG.' + errResponse.data));
                $rootScope.loadingProgress = false;
            });
        };

        init();

        function init() {
          $timeout(function () {

              var keyEvent = function (event) {
                  event.stopPropagation();
              };

              var searchDiscountMethodInput = document.querySelector("#searchDiscountMethod");


              if (searchDiscountMethodInput) {
                  searchDiscountMethodInput.addEventListener("keydown", keyEvent);
              }
          }, 500);
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.CompanyProvider')
        .controller('ProviderInformationController', CompanyInformationController);

    function CompanyInformationController(
        envService, $rootScope, $timeout, $state,
        $stateParams, $log, api, MessageService, $mdDialog, $filter, PreviousState
    ) {

        var vm = this;
        vm.baseUrlFiles = api.baseUrlFiles;
        const NOT_FOUND_NUMBER = 302;
        const TIMEOUT_FIVE_HUMDRED = 500;

        vm.provider = $stateParams.provider;
        vm.documentArray = [];
        vm.regimeArray = [];
        vm.serieArray = [];
        vm.ngFlowOptions = {
            target: '/Megasistemas'
        };
        vm.updateImageZoomOptions = updateImageZoomOptions;
        vm.baseUrlSharedFiles = envService.read('baseUrlSharedFiles');
        vm.viewParentName = $stateParams.viewParentName;
        vm.saveButton = true;
        vm.showAccountingCatalog = false;
        vm.canEditProvider = false;
        vm.editBusinessName = false;
        vm.loading = false;

        //metodos
        vm.back = back;
        vm.validate = validate;
        vm.noValidate = noValidate;
        vm.removeProvider = removeProvider;
        vm.sendForm = sendForm;
        vm.haveCredit = false;
        vm.getProductsListAssociate = getProductsListAssociate;
        vm.companyProvider = null;
        vm.companyProviderFiles = [];
        vm.myProviders = false;
        vm.productSelectedArray = [];
        vm.productAssociatedSelectedArray = [];
        vm.toggleAssociatedProduct = toggleAssociatedProduct;
        vm.toggleProduct = toggleProduct;
        vm.isSelectedProduct = isSelectedProduct;
        vm.isSelectedAssociatedProduct = isSelectedAssociatedProduct;
        vm.associate = associate;
        vm.disassociate = disassociate;
        vm.getCompanyProviderProducts = getCompanyProviderProducts;
        vm.getNotAssociatedProductToProvider = getNotAssociatedProductToProvider;
        vm.disableEditButton = false;
        vm.updateFieldsConfiguration = updateFieldsConfiguration;
        vm.saveBusinessName = saveBusinessName;
        vm.cancelEditBusinessName = cancelEditBusinessName;
        vm.editBusinessNameF = editBusinessNameF;
        vm.saveCompanyCategory = saveCompanyCategory;
        vm.cancelEditCompanyCategory = cancelEditCompanyCategory;
        vm.editCompanyCategoryF = editCompanyCategoryF;
        vm.goDocuments = goDocuments;
        vm.showValidateDialog = showValidateDialog;
        vm.formConfiguration = {
          purchaseIgnoreLimitDate: false,
          purchaseIgnoreLimitDateProvision: false
        };
        vm.disableSaveConfigButton = true;

        vm.productPagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getNotAssociatedProductToProvider();
            }
        };

      vm.dtOptionsFiles = {
        columnDefs: [
          {
            // Target the id column
            targets: 1,
            responsivePriority: 1
          },
          {
            // Target the actions column
            targets: 1,
            responsivePriority: 1
          }
        ],
        paging: false,
        responsive: true,
        info: false,
        searching: false
      };
      vm.dtOptionsConfiguration = {
        columnDefs: [
          {
            // Target the id column
            targets: 0,
            responsivePriority: 1
          },
          {
            // Target the actions column
            targets: 1,
            responsivePriority: 1,
            filterable: false,
            sortable: false
          },
          {
            // Target the actions column
            targets: 2,
            responsivePriority: 1,
            filterable: false,
            sortable: false
          }
        ],
        paging: false,
        responsive: true,
        info: false,
        searching: false
      };
      vm.valueConfiguration = [
        {
          name: 'purchaseIgnoreLimitDate',
          description: $filter('translate')('validate_provider.purchaseIgnoreLimitDate'),
          dataType: 'BOOLEAN',
          value: false
        },
        {
          name: 'purchaseIgnoreLimitDateProvision',
          description: $filter('translate')('validate_provider.purchaseIgnoreLimitDateProvision'),
          dataType: 'BOOLEAN',
          value: false
        }
      ];

        vm.associatedProductPagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getCompanyProviderProducts();
            }
        };

        function toggleAssociatedProduct(companyProviderProduct, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.productAssociatedSelectedArray.indexOf(companyProviderProduct) > -1) {
                vm.productAssociatedSelectedArray.splice(vm.productAssociatedSelectedArray.indexOf(companyProviderProduct), 1);
            } else {
                vm.productAssociatedSelectedArray.push(companyProviderProduct);
            }
        }

        function toggleProduct(product, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.productSelectedArray.indexOf(product) > -1) {
                vm.productSelectedArray.splice(vm.productSelectedArray.indexOf(product), 1);
            } else {
                vm.productSelectedArray.push(product);
            }
        }

        function isSelectedProduct(product) {
            return vm.productSelectedArray.indexOf(product) > -1;
        }

        function isSelectedAssociatedProduct(companyProviderProduct) {
            return vm.productAssociatedSelectedArray.indexOf(companyProviderProduct) > -1;
        }

        if ($stateParams.viewParentName === 'myProviders' || $stateParams.viewParentName === 'queryProviders') {
            vm.showAccountingCatalog = true;
        }
        if ($stateParams.viewParentName !== 'internalProviders' && $stateParams.viewParentName !== 'myProviders') {
            vm.editMode = true;
            vm.saveButton = false;
        }
        if ($stateParams.viewParentName === 'myProviders') {
            vm.disableEditButton = true;
            vm.canEditProvider = true;
        }

        function init() {
            if ($stateParams.provider === null || $stateParams.provider === undefined) {
                if ($stateParams.viewParentName === 'validateProvider') {
                    $state.go('app.CompanyProvider.ValidateProvider');
                } else if ($stateParams.viewParentName === 'internalProviders') {
                    $state.go('app.CompanyProvider.InternalProviders');
                } else {
                    $state.go('app.CompanyProvider.MyProviders');
                }
                return null;
            }

            api.GeneralWS.CompanyProvider.me.query({ 'companyId': $rootScope.bsCircle.company.id, 'providerId': vm.provider.id }).$promise.then(function (data) {
              vm.haveCredit = data.haveCredit ? data.haveCredit : false;
                vm.daysCredit = data.daysCredit;
                vm.accountingCatalog = data.accountingCatalog ? data.accountingCatalog : { code: null };
                vm.companyProviderCode = data.companyProviderCode;
                vm.companyProviderTag = { companyProvider: data, companyTags: {} };
                vm.companyProvider = data;
                verifyValuesConfiguration();
                getCompanyProviderFiles();
                getPaymentCondition();
                getProviderGroup();
                vm.myProviders = ($stateParams.viewParentName !== 'validateProvider') ? true : false;
            }, function (err) {
                $log.error(err);
            });

            getDocuments();
            getRegime();
            getSeries();
            getWitholdings(vm.provider.id);
            getCompanyContacts();
            getBankAccounts();
            getCompanyCategoryList();
            getCompanyTypeList();
        }

        function back() {
            if ($stateParams.viewParentName === 'validateProvider') {
                $state.go('app.CompanyProvider.ValidateProvider');
            } else if (PreviousState && PreviousState.name) {
                $state.go(PreviousState.name);
            }else{
                $state.go('app.CompanyProvider.MyProviders');
            }
        }

        function getDocuments() {
            api.GeneralWS.CompanyDocument.query({ 'company': vm.provider.id }).$promise.then(function (response) {
                vm.documentArray = response;
            }, function (response) {
                $log.error(response);
            });

        }

        function getRegime() {

            api.GeneralWS.AllRegimeByCompany.query({ 'idCompany': vm.provider.id }).$promise.then(function (response) {
                vm.regimeArray = response;
            }, function (response) {
                $log.error(response);
            });

        }

        function getSeries() {

            api.GeneralWS.InvoiceSerieByCompany.query({ 'companyId': vm.provider.id }).$promise.then(function (response) {
                vm.serieArray = response;
            }, function (response) {
                $log.error(response);
            });

        }

        function getWitholdings(companyId) {
            api.GeneralWS.CompanyWithholding.me.query({ company: companyId }).$promise.then(function (data) {

                vm.withholdings = data;
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        /**
         * Update image zoom options
         *
         * @param img
         */
        function updateImageZoomOptions(img) {
            var url = img.url;
            var extension = img.extension;
            vm.imageZoomOptions = {
                images: [
                    {
                        thumb: url + 's' + extension,
                        medium: url + 'm' + extension,
                        large: url + 'l' + extension
                    }
                ]
            };
        }

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0
                },
                {
                    // Target the actions column
                    targets: 4,
                    responsivePriority: 1,
                    filterable: true,
                    sortable: false
                }
            ],
            order: [[0, "desc"]],
            pagingType: 'simple',
            paging: false,
            responsive: true
        };

        vm.dtOptionsInvoice = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0
                },
                {
                    // Target the status column
                    targets: 7,
                    filterable: false,
                    render: function (data, type) {
                        if (type === 'display') {
                            if (data === 'true') {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }

                            return '<i class="icon-cancel red-500-fg"></i>';
                        }

                        if (type === 'filter') {
                            if (data) {
                                return '1';
                            }

                            return '0';
                        }

                        return data;
                    }
                }
            ],
            order: [[0, "desc"]],
            pagingType: 'simple',
            paging: false,
            responsive: true
        };

        function validate(event) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('menu.validate_provider'))
                .textContent($filter('translate')('validate_provider.confirm_that_you_want_to_add_the_company_to_your_list_of_provider') + ' ' + vm.provider.name)
                .ariaLabel('Validate provider')
                .targetEvent(event)
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                showValidateDialog(event,false);
            }, function () {
                // Empty
            });
        }

        function showValidateDialog(event, editProvider) {
            const paramsConst = {
                provider: vm.provider,
                isEdit: false,
            };
            if (editProvider) {
                paramsConst.account = vm.accountingCatalog;
                paramsConst.paymentCondition = vm.paymentCondition;
                paramsConst.providerGroup = vm.providerGroup;
                paramsConst.isEdit = true;
            }
            $mdDialog.show({
                controller: 'ValidateDialogController',
                controllerAs: 'vm',
                locals: {
                    'params': paramsConst,
                },
                templateUrl: 'app/main/apps/company-providers/validate-provider/provider-information/validate-dialog/validate-dialog.html',
                parent: angular.element("#main"),
                targetEvent: event,
                clickOutsideToClose: false,
            }).then(function (response) {
                if (response) {
                    sendForm(response, paramsConst.isEdit);
                }
            }, function () {
                // Emtpy
            });
        }

        function noValidate(event) {

            $mdDialog.show({
                controller: 'NoValidateProviderController',
                controllerAs: 'vm',
                locals: {
                    'provider': vm.provider
                },
                templateUrl: 'app/main/apps/company-providers/validate-provider/provider-information/no-validate-dialog/no-validate-provider.html',
                parent: angular.element("#main"),
                targetEvent: event,
                clickOutsideToClose: false
            }).then(function (response) {
                if (response) {
                    MessageService.show($filter('translate')('validate_provider.notification_has_been_sent_to_provider'));
                }
            }, function () {
            });

        }

        function removeProvider(event) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('menu.my_providers'))
                .textContent($filter('translate')('validate_provider.onfirm_that_you_want_to_remove_from_your_provider_list') + ' ' + vm.provider.name)
                .ariaLabel('Remove provider')
                .targetEvent(event)
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.CompanyProvider.me.update({ 'companyId': $rootScope.bsCircle.company.id, 'providerId': vm.provider.id }).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;

                    MessageService.show("Proveedor eliminado correctamente" + "!");

                    if ($stateParams.viewParentName === 'validateProvider') {
                        $state.go('app.CompanyProvider.ValidateProvider');
                    } else {
                        $state.go('app.CompanyProvider.MyProviders');
                    }

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });
            }, function () {
            });

        }

        $timeout(init, 500);

        function sendForm(dataAccount, isEdit) {
            $rootScope.loadingProgress = true;
            vm.daysCredit = vm.haveCredit ? vm.daysCredit : 0;
            const companyProviderModel = {
                haveCredit: vm.haveCredit,
                daysCredit: vm.daysCredit,
                paymentConditionId: dataAccount.paymentCondition.id,
                companyProviderGroupId: dataAccount.providerGroup.id,
                providerId: vm.provider.id,
                accountingCode: dataAccount.account.code
            }

            if (vm.companyProviderCode !== null) {
                companyProviderModel.companyProviderCode = vm.companyProviderCode;
            }

            if (isEdit) {
                api.GeneralWS.CompanyProvider.updateAccountingInf.update({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': vm.companyProvider.id,
                }, companyProviderModel).$promise.then(function(prov) {
                    MessageService.show($filter('translate')('validate_provider.accountingInformationUpdatedSuccessfully'));
                    vm.companyProvider.paymentConditionId = prov.paymentConditionId;
                    vm.companyProvider.companyProviderGroupId = prov.companyProviderGroupId;
                    vm.accountingCatalog = prov.accountingCatalog;
                    getPaymentCondition();
                    getProviderGroup();
                    $rootScope.loadingProgress = false;
                }, function (error) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')('validate_provider.errorOnUpdateAccountingInfo'));
                        $log.error(error);
                });

            } else {
                api.GeneralWS.CompanyProvider.me.create({
                    'companyId': $rootScope.bsCircle.company.id,
                    'providerId': undefined
                }, companyProviderModel).$promise.then(function () {
                        MessageService.show($filter('translate')('validate_provider.provider_validated_correctly') + "!");
                        if ($stateParams.viewParentName === 'validateProvider') {
                            $state.go('app.CompanyProvider.ValidateProvider');
                        } else {
                            $state.go('app.CompanyProvider.MyProviders');
                        }
                        $rootScope.loadingProgress = false;
                    }, function (err) {
                        $rootScope.loadingProgress = false;
                        $log.error(err);
                        if (err.status === NOT_FOUND_NUMBER) {
                            MessageService.show($filter('translate')('validate_provider.the_provider_has_already_been_validated'));
                        }
                    });
            }
        }

        vm.clearSearchAccountingCatalog = function () {
            vm.searchAccountingCatalog = "";
        };

        vm.saveTag = function () {
            if (vm.companyProviderTag.companyTags.companyTagValue === '' || !vm.companyProviderTag.companyTags.companyTagValue) {
                return false;
            }
            vm.loadingTags = true;
            api.GeneralWS.CompanyProviderTags.me.create({ 'idCircle': $rootScope.bsCircle.id }, vm.companyProviderTag, function (response) {
                vm.companyProviderTag.companyTags.companyTagValue = '';
                init();
                MessageService.show($filter('translate')('TAGS.MSG.ADDED_TAG'));
                vm.loadingTags = false;
            }, function (errResponse) {
                MessageService.showErrorMessage($filter('translate')('TAGS.MSG.' + errResponse.data));
            });
            return true;
        };

        vm.deleteTag = function (row) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('TAGS.MSG.CONFIRM_DELETE'))
                .ok($filter('translate')('general.accept'))
                .cancel($filter('translate')('general.cancel'));
            $mdDialog.show(confirm).then(function () {
                vm.loadingTags = true;
                api.GeneralWS.CompanyProviderTags.me.del({
                    'idCircle': $rootScope.bsCircle.id, 'id': row.id, 'companyProviderId': vm.companyProviderTag.companyProvider.id
                }, {}, function (response) {
                    vm.companyProviderTag.companyTags.companyTagValue = '';
                    init();
                    MessageService.show($filter('translate')('TAGS.MSG.DELETED_TAG'));
                    vm.loadingTags = false;
                }, function (errResponse) {

                });
            }, function () {
            });
        };

        vm.focusTag = function () {
            var companyTagValue = document.querySelector("#companyTagValue");
            $timeout(function () {
                if (companyTagValue) {
                    companyTagValue.focus();
                }
            }, TIMEOUT_FIVE_HUMDRED);
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchAccountingCatalog = document.querySelector("#searchAccountingCatalog");
            const searchCompanyCategoryInput = document.querySelector('#searchCompanyCategory');

            if (searchAccountingCatalog) {
                searchAccountingCatalog.addEventListener("keydown", keyEvent);
            }
            if (searchCompanyCategoryInput) {
                searchCompanyCategoryInput.addEventListener('keydown', keyEvent);
            }
        }, 500);

        vm.viewIMG = function (file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.baseUrlFiles + file.parentPath + file.name + file.extension,
                fullUrl: file.fullUrl,
                clickOutsideToClose: false
            }).then(function () {
                //go to Quotations
            });

        }

        function getCompanyProviderProducts() {
            vm.loadAssociatedProducts = true;
            api.GeneralWS.CompanyProviderProduct.byProvider.get({
                'companyId': $rootScope.bsCircle.company.id, 'providerId': vm.companyProvider.provider.id,
                'pageNumber': vm.associatedProductPagination.pageNumber,
                'pageSize': vm.associatedProductPagination.pageSize, 'search': vm.searchAssociatedProductInput
            })
                .$promise.then(function (response) {
                    vm.loadAssociatedProducts = false;
                    vm.associatedProductArray = response.content;
                    vm.associatedProductPagination.totalElements = response.totalElements;
                    vm.associatedProductPagination.totalPages = response.totalPages;
                    vm.associatedProductPagination.numberOfElements = response.numberOfElements;
                }, function (response) {
                    vm.loadAssociatedProducts = false;
                    $log.debug(response);
                });
        }

        function getCompanyProviderFiles() {
            vm.loadCompanyProviderFiles = true;
            api.GeneralWS.CompanyProviderFiles.getAllFiles.query({
                'companyId': $rootScope.bsCircle.company.id, 'providerId': vm.companyProvider.provider.id
            })
                .$promise.then(function (responsePhotos) {
                  responsePhotos.forEach(function (r) {
                    r.fileStorage.fileUrl = vm.baseUrlFiles + r.fileStorage.parentPath + r.fileStorage.name + r.fileStorage.extension;
                  });
                    vm.loadCompanyProviderFiles = false;
                    vm.companyProviderFiles = responsePhotos;
                }, function (errResponse) {
                    vm.loadCompanyProviderFiles = false;
                    $log.debug(errResponse);
                });
        }

        function getNotAssociatedProductToProvider() {
            vm.loadProducts = true;
            api.GeneralWS.CompanyProviderProduct.byNotProvider.get({
                'idCircle': $rootScope.bsCircle.id, companyProviderId: vm.companyProvider.id,
                'pageNumber': vm.productPagination.pageNumber, 'pageSize': vm.productPagination.pageSize, 'search': vm.searchProductInput
            }, function (response) {
                vm.loadProducts = false;
                vm.productArray = response.content;
                vm.productPagination.totalElements = response.totalElements;
                vm.productPagination.totalPages = response.totalPages;
                vm.productPagination.numberOfElements = response.numberOfElements;
            }, function (err) {
                $log.debug(err);
                vm.loadProducts = false;
            });

        }

        function getProductsListAssociate() {
            var windowHeight = parseInt(window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth);

            windowHeight -= windowHeight > 1400 ? 1300 : 1010;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
            if (!vm.associatedProductArray) {
                getNotAssociatedProductToProvider();
                getCompanyProviderProducts();
            }
        }

        function associate() {
            vm.isShowProgressLinear = true;

            var _companyProviderProductArray = [];

            vm.productSelectedArray.forEach(function (row) {
                _companyProviderProductArray.push({
                    'product': row,
                    'companyProvider': vm.companyProvider
                });
            });

            api.GeneralWS.CompanyProviderProduct.CompanyProviderProduct.create(
                {
                    'idCircle': $rootScope.bsCircle.id
                }, _companyProviderProductArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.productSelectedArray = [];

                    if (response) {
                        MessageService.show($filter('translate')('validate_provider.product_added_successfully'));
                    }

                    getCompanyProviderProducts();
                    getNotAssociatedProductToProvider();
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

        function disassociate() {
            vm.isShowProgressLinear = true;

            var _associatedProductIdArray = [];

            vm.productAssociatedSelectedArray.forEach(function (row) {
                _associatedProductIdArray.push(row.id);
            });

            api.GeneralWS.CompanyProviderProduct.CompanyProviderProduct.update(
                {
                    'idCircle': $rootScope.bsCircle.id
                }, _associatedProductIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.productAssociatedSelectedArray = [];

                    if (response) {
                        MessageService.show($filter('translate')('validate_provider.product_removed_successfully'));
                    }

                    getCompanyProviderProducts();
                    getNotAssociatedProductToProvider();
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

      function updateFieldsConfiguration() {
        vm.disableSaveConfigButton = true;
        vm.valueConfiguration.forEach(function (r) {
          if (r.name === 'purchaseIgnoreLimitDate') {
            vm.companyProvider.purchaseIgnoreLimitDate = r.value;
          }
          if (r.name === 'purchaseIgnoreLimitDateProvision') {
            vm.companyProvider.purchaseIgnoreLimitDateProvision = r.value;
          }
        });
        api.GeneralWS.CompanyProvider.updateFieldsConfiguration.doUpdateFields({
          companyId: 0,
          id: vm.companyProvider.id
        }, vm.companyProvider, function (resp) {
          vm.companyProvider = resp;
          verifyValuesConfiguration();
          MessageService.show($filter('translate')('validate_provider.configurationAddedSuccessfully'));
        }, function (err) {
          $log.debug(err);
          vm.disableSaveConfigButton = false;
        });
      }

      function verifyValuesConfiguration(){
        vm.valueConfiguration.forEach(function (r) {
          if (r.name === 'purchaseIgnoreLimitDate') {
            r.value = vm.companyProvider.purchaseIgnoreLimitDate;
          }
          if (r.name === 'purchaseIgnoreLimitDateProvision') {
            r.value = vm.companyProvider.purchaseIgnoreLimitDateProvision;
          }
        });
      }

        // Personas de contacto
        function getCompanyContacts() {
            api.GeneralWS.CompanyContact.byCompany.getList({ 'companyId': vm.provider.id })
                .$promise.then(function (companyContacts) {
                    if (companyContacts.length > 0) {
                        vm.companyContact = companyContacts[0];
                    }
                }, function (errCompanyContacts) {
                    $log.error(errCompanyContacts);
                })
        }

        // Cuentas bancarias
        function getBankAccounts() {
            api.GeneralWS.BankAccount.BankAccount.get({
                'company': vm.provider.id, 'search': ''
            }).$promise.then(function (bankAccounts) {
                if (bankAccounts.length > 0) {
                    vm.bankAccount = _.find(bankAccounts, function (bank) {
                        return bank.isDefault === true;
                    });
                }
            }, function (response) {
                $log.error(response);
            });
        }

        // Condiciones de pago
        function getPaymentCondition() {
            if (vm.companyProvider.paymentConditionId !== null) {
                api.PagosWS.PaymentCondition.byCompany.getId({
                    'companyId': $rootScope.bsCircle.company.id, 'id': vm.companyProvider.paymentConditionId
                }).$promise.then(function (paymentCondition) {
                    vm.paymentCondition = paymentCondition;
                });
            }

        }

        // Grupo de proveedor
        function getProviderGroup() {
            if (vm.companyProvider.companyProviderGroupId !== null) {
                api.GeneralWS.CompanyProviderGroup.byCompany.getId({
                    'companyId': $rootScope.bsCircle.company.id, 'id': vm.companyProvider.companyProviderGroupId
                }).$promise.then(function (providerGroup) {
                    vm.providerGroup = providerGroup;//JR
                });
            }
        }

        function editBusinessNameF() {
            vm.editBusinessName = true;
            vm.currentBusinessName = vm.provider.businessName;
        }

        function saveBusinessName() {
            vm.loading = true;
            api.GeneralWS.CompanyProvider.updateBusinessName.update({
                'companyId': $rootScope.bsCircle.company.id, 'id': vm.companyProvider.id,
                'businessName': vm.provider.businessName,
            }).$promise.then(function() {
                vm.editBusinessName = false;
                MessageService.show($filter('translate')('validate_provider.businessNameUpdated'));
                vm.loading = false;
            });
        }

        function cancelEditBusinessName() {
            vm.provider.businessName = vm.currentBusinessName;
            vm.editBusinessName = false;
        }

        function getCompanyCategoryList() {
            api.GeneralWS.CompanyCategory.getList.getByCountry({ countryId: vm.provider.country.id }).$promise.then(function (data) {
                vm.companyCategoryList = data;
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function getCompanyTypeList() {
          api.GeneralWS.CompanyType.getList.getByCountry({ countryId: vm.provider.country.id }).$promise.then(function (data) {
            vm.companyTypeList = data;
          }, function (errResponse) {
            $log.error(errResponse);
          });
        }

        function editCompanyCategoryF() {
            vm.editCompanyCategory = true;
            vm.currentCompanyCategoryId = vm.provider.companyCategoryId;
        }

        function saveCompanyCategory() {
            vm.loading = true;
            api.GeneralWS.CompanyProvider.updateCompanyCategory.update({
                'companyId': $rootScope.bsCircle.company.id, 'id': vm.provider.id,
                'companyCategoryId': vm.provider.companyCategoryId,
            }).$promise.then(function() {
                vm.editCompanyCategory = false;
                MessageService.show($filter('translate')('validate_provider.companyCategoryUpdated'));
                vm.loading = false;
            });
        }

        function cancelEditCompanyCategory() {
            vm.provider.companyCategoryId = vm.currentCompanyCategoryId;
            vm.editCompanyCategory = false;
        }

        function goDocuments() {
            const stateGo = 'app.CompanyProvider.private.documents';
            const params = {
                id: vm.provider.id,
                isProvider: true,
                providerId: vm.companyProvider.id,
            };
            $state.go(stateGo, params);
        }

    }

})();



(function () {

    'use strict';

    angular
        .module('app.CompanyProvider')
        .controller('CompanyProviderGroupController', CompanyProviderGroupController);

    /**@ngInject**/
    function CompanyProviderGroupController($mdDialog, api, providerGroup, $log, MessageService, $filter, $rootScope) {

        const vm = this;
        const EXCEPTION_STATUS_ALREADY_EXISTS = 409;

        vm.providerGroup = providerGroup;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        if (vm.providerGroup.id) {
            vm.providerGroup.company = $rootScope.bsCircle.company.id;
        }

        function save() {
            vm.isShowProgressLinear = true;
            let promise;
            if (vm.providerGroup) {
                vm.providerGroup.companyId = $rootScope.bsCircle.company.id;
            }

            let activeP = angular.copy(vm.providerGroup.active);
            if (vm.providerGroup.active === undefined) {
                activeP = true;
            }

            const currentProviderGroup = {
                companyId: vm.providerGroup.company,
                groupCode: vm.providerGroup.groupCode,
                groupName: vm.providerGroup.groupName,
                erpCode: vm.providerGroup.erpCode,
                active: activeP
            };

            if (vm.providerGroup.id) {
                promise = api.GeneralWS.CompanyProviderGroup.byCompany.update({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': vm.providerGroup.id,
                }, vm.providerGroup).$promise;
            } else {
                promise = api.GeneralWS.CompanyProviderGroup.byCompany.create({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': undefined,
                }, vm.providerGroup).$promise;
            }
            promise.then(function (response) {
                currentProviderGroup.id = response.$data;
                const filter = (currentProviderGroup.id + ',' + currentProviderGroup.groupCode + 
                ',' + currentProviderGroup.groupName + ',' + currentProviderGroup.erpCode).toLowerCase();
                currentProviderGroup.filter = filter;
                vm.isShowProgressLinear = false;
                $mdDialog.hide(currentProviderGroup);
            }, function (exception) {
                if (exception && exception.status === EXCEPTION_STATUS_ALREADY_EXISTS) {
                    MessageService.showErrorMessage($filter('translate')('providerGroup.alreadyExists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.error'));
                }
                vm.isShowProgressLinear = false;
                $log.error(exception);
            });
            return true;
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.CompanyProvider')
        .controller('CompanyProviderGroupListController', CompanyProviderGroupListController);

    /**@ngInject**/
    function CompanyProviderGroupListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log, $scope) {
        const vm = this;
        const TIMEOUT_EONE_THOUSAND = 1000;

        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.providerGroups = [];

        const colDefs = [
            {
                field: 'groupCode',
                headerName: 'providerGroup.groupCode',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'groupName',
                headerCellRenderer: getHeader,
                headerName: 'providerGroup.groupName',
                width: 250,
            },
            {
                field: 'erpCode',
                width: 200,
                headerName: 'providerGroup.code',
                headerCellRenderer: getHeader,
            },
            {
                field: 'active',
                headerCellRenderer: getHeader,
                headerName: 'general.active',
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' },
            },
            {
                name: 'edit',
                headerName: 'providerGroup.options',
                pinned: 'right',
                headerCellRenderer: getHeader,
                width: 100,
                cellStyle: { 'padding': '2px' },
                cellRenderer: function () {
                    return '<div layout="row" layout-align="space-between"> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onDelete(data)" ng-if="data.active"> '
                        + ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + '</div>';
                },
            },
        ];

        vm.gridProviderGroups = {
            columnDefs: colDefs,
            rowHeight: 45,
            rowSelection: 'multiple',
            animateRows: true,
            enableColResize: true,
            enableSorting: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function () {
                return true;
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesExternalFilterPass: doesExternalFilterPassFunc,
            isExternalFilterPresent: isExternalFilterPresentFunc,
        };

        const filter = 'everyone';
        function isExternalFilterPresentFunc() {
            return filter !== '';
        }

        function doesExternalFilterPassFunc(node) {
            if (filter && filter !== 'everyone') {
                const arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function getProviderGroups() {
            vm.showGrid = false;
            vm.isShowProgressLinearGrid = true;
            api.GeneralWS.CompanyProviderGroup.byCompany.get({
                'companyId': $rootScope.bsCircle.company.id,
            })
                .$promise.then(function (response) {
                    const newData = new jinqJs()
                        .from(response)
                        .orderBy('id')
                        .select(function (d) {
                            d.filter = (d.id + ',' + d.name + ',' + d.erpCode).toLowerCase();
                            return d;
                        });

                    vm.gridProviderGroups.api.setRowData(newData);
                    vm.providerGroups = newData;
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                }, function (response) {
                    vm.gridProviderGroups.api.setRowData([]);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                    $log.error(response);
                });
        }

        function init() {
            getProviderGroups();
        }

        function edit(model) {
            let isNew = false;
            if (model) {
                model.companyId = $rootScope.bsCircle.company.id;
            } else {
                isNew = true;
                model = {
                    companyId: $rootScope.bsCircle.company.id,
                };
            }

            $mdDialog.show({
                controller: 'CompanyProviderGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company-providers/provider-group/provider-group/provider-group.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'providerGroup': angular.copy(model),
                },
            }).then(function (answer) {
                if (isNew) {
                    vm.providerGroups.push(answer);
                    MessageService.show($filter('translate')('providerGroup.added'));
                } else {
                    const i = vm.providerGroups.indexOf(model);
                    vm.providerGroups[i] = answer;
                    MessageService.show($filter('translate')('providerGroup.updated'));
                }
                vm.gridProviderGroups.api.setRowData(vm.providerGroups);
                vm.gridProviderGroups.api.redrawRows();
            }, function () {
                // Empty
            });
        }

        function onDelete(model) {
            const confirm = $mdDialog.confirm()
            .ariaLabel($filter('translate')('providerGroup.deactivateCompanyProviderGroup'))
                .title($filter('translate')('providerGroup.deactivateCompanyProviderGroup'))
                .textContent($filter('translate')('providerGroup.deactivateConfirm'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.CompanyProviderGroup.byCompany.delete({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': model.id,
                }).$promise.then(function () {
                    const i = vm.providerGroups.indexOf(model);
                    model.active = false;
                    vm.providerGroups[i] = model;
                    vm.isShowProgressLinear = false;
                    vm.gridProviderGroups.api.setRowData(vm.providerGroups);
                    vm.gridProviderGroups.api.redrawRows();
                    MessageService.show($filter('translate')('providerGroup.deleted'));
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    $log.error(response);
                });
            }, function () {
                // Empty
            });
        }

        $timeout(function () {
            init();
        }, TIMEOUT_EONE_THOUSAND);

        $scope.$watch('vm.inputSearch', function () {
            if (vm.gridProviderGroups.api) {
                vm.gridProviderGroups.api.setRowData($filter('filter')(vm.providerGroups, vm.inputSearch));
            }
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('DialogWithholdingFileController', DialogWithholdingFileController);

    /** @ngInject */
    function DialogWithholdingFileController(api, $log, $rootScope, $filter, $mdDialog, MessageService, $timeout, companyWithholding) {
        var vm = this;
        vm.companyWithholding = companyWithholding;
        vm.file = vm.companyWithholding.withholdingFile;
        vm.baseUrlFiles = api.baseUrlFiles;
        vm.filesToUpload = [];


        vm.cancel = function () {
            $mdDialog.cancel();
        };

        vm.save = function () {
            if (vm.filesToUpload.length > 0) {
                var files = [];

                vm.filesToUpload.forEach(function (r) {
                    files.push(r.file.file);
                });

                $rootScope.loadingProgress = true;
                api.GeneralWS.Commons.FileStorage.filesUpload.add({ 'companyId': $rootScope.bsCircle.company.id }, files).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.withholdingStorage = response.data[0];
                    $mdDialog.hide(vm.withholdingStorage);
                }, function (errResponse) {
                    $log.error(errResponse);
                    $rootScope.loadingProgress = false;
                });

            } else {
                MessageService.showErrorMessage($filter("translate")("COMPANY.FILE_ERROR_UPLOAD"));
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('app.company')
        .controller('InvoiceSerieController', InvoiceSerieController);
    /** @ngInject */
    function InvoiceSerieController(api, $scope, MessageService, $rootScope, $filter, $state, envService, $mdDialog, $log, Company, $stateParams) {

        var vm = this;
        $rootScope.loadingProgress = true;
        vm.isPrivated = $stateParams.privated;
        var stateReturn = vm.isPrivated ? 'app.CompanyProvider.private' : 'app.company.mycompany';

        $scope.originForm;

        if (vm.isPrivated) {
            if (!Company || !Company.privated) {
                $state.go('app.CompanyProvider.MyProviders');
            } else {
                vm.company = Company;
            }
        } else {
            vm.company = $rootScope.bsCircle.company;
        }

        vm.closeThread = closeThread;

        api.GeneralWS.InvoiceSerieType.active.get({ country: vm.company.country.id }).$promise.then(function (response) {
            vm.invoiceSerieTypes = new jinqJs()
                .from(response)
                .orderBy([{ field: 'id', sort: 'asc' }])
                .select();
        }, function (errResponse) {
            $log.debug(errResponse);
        });


        vm.minDate = new Date();
        vm.minDateWithFormat = $filter('date')(vm.minDate, 'yyyy-MM-dd');
        vm.baseUrlSharedFiles = envService.read('baseUrlSharedFiles');

        vm.validateCorrelativeRange = validateCorrelativeRange;
        vm.filterInvoiceSerie = filterInvoiceSerie;
        vm.addInvoiceSerieDialog = addInvoiceSerieDialog;
        vm.editInvoiceSerie = editInvoiceSerie;
        vm.deleteInvoiceSerie = deleteInvoiceSerie;
        vm.invoiceSeries = [];
        vm.invoiceSerieDocumentTypes = {};
        getInvoiceSeriesDocumentCountryList();
        function getInvoiceSeriesDocumentCountryList() {
            api.GeneralWS.InvoiceSeriesDocumentCountry.getList.getByCountry({ countryId: vm.company.country.id }).$promise.then(function (data) {
                vm.invoiceSerieDocumentTypes = {};
                data.forEach(function(documentType) {
                    vm.invoiceSerieDocumentTypes[documentType.invoiceSeriesDocumentTypeId] = documentType.invoiceSeriesDocumentTypeDescription;
                });
                getInvoiceSeriesByCompany();
            }, function (errResponse) {
                $log.error(errResponse);
                getInvoiceSeriesByCompany();
            });
        }

        function getInvoiceSeriesByCompany() {
            api.GeneralWS.InvoiceSerie.getByCompany({ id: 'getCompanyId', idCompany: vm.company.id }).$promise.then(function (response) {
                vm.invoiceSeries = new jinqJs()
                    .from(response)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select();
                    vm.invoiceSeries.forEach(function(serie) {
                        serie.invoiceSerieDocumentTypeName = vm.invoiceSerieDocumentTypes[serie.invoiceSerieDocumentType];
                    });
                    vm.company.invoiceSeries=vm.invoiceSeries;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.dtOptionsInvoiceSerie = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0,
                    responsivePriority: 2
                },
                {
                    // Target the actions column
                    targets: 11,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ],
            order: [[0, "asc"]],
            pagingType: 'simple',
            paging: false,
            responsive: true
        };


        function validateCorrelativeRange(isInitialNumber) {
            if (isInitialNumber === true && vm.invoiceSerie.lastNumber && vm.invoiceSerie.initialNumber) {
                vm.invoiceSerie.lastNumber = vm.invoiceSerie.lastNumber > vm.invoiceSerie.initialNumber ? vm.invoiceSerie.lastNumber : null;
            } else if (isInitialNumber === false && vm.invoiceSerie.lastNumber && vm.invoiceSerie.initialNumber) {
                vm.invoiceSerie.initialNumber = vm.invoiceSerie.initialNumber < vm.invoiceSerie.lastNumber ? vm.invoiceSerie.initialNumber : null;
            }
        }

        function filterInvoiceSerie() {
            return function (item) {
                return item.dueDate >= vm.minDateWithFormat && item.active === true;
            };
        }

        $scope.set_color = function (requireRevision) {
            if (requireRevision !== false) {
                return { background: "#BBDEFB" };
            }
        };

        function closeThread() {
            if (vm.isPrivated) {
                $state.go(stateReturn, { id: $stateParams.id }, { reload: true });
            } else {
                $state.go(stateReturn);
            }
        }

        function addInvoiceSerieDialog() {
            vm.invoiceSerie = {};
            $mdDialog.show({
                controller: 'InvoiceSerieDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/invoiceSerie/dialog/invoiceSerieDialog.html',
                parent: angular.element("#main"),
                locals: {
                    Company: vm.company,
                    Privated: vm.isPrivated,
                    'invoiceSerie': vm.invoiceSerie,
                    'establishment': null,
                    invoiceSerieType: vm.invoiceSerieTypes
                },
                clickOutsideToClose: false
            }).then(function (answer) {
                if (answer) {
                    vm.invoiceSeries.push(answer);
                }
            }, function () {

            });
        }

        function editInvoiceSerie(data, index) {
            var newInvoiceSerie = angular.copy(data);

            newInvoiceSerie.authorizationDate = (newInvoiceSerie.authorizationDate ? new Date(newInvoiceSerie.authorizationDate + " 00:00:00") : new Date());
            newInvoiceSerie.dueDate = (newInvoiceSerie.dueDate ? new Date(newInvoiceSerie.dueDate + " 00:00:00") : new Date());

            $mdDialog.show({
                controller: 'InvoiceSerieDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/invoiceSerie/dialog/invoiceSerieDialog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    Company: vm.company,
                    Privated: vm.isPrivated,
                    'invoiceSerie': newInvoiceSerie,
                    'establishment': null,
                    invoiceSerieType: vm.invoiceSerieTypes
                }
            }).then(function (answer) {
                vm.invoiceSeries[index] = answer;
            }, function () {

            });
        }

        function deleteInvoiceSerie(data, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.deactive'))
                .content($filter('translate')('COMPANY.DEACTIVATE_SERIE'))
                .ariaLabel('Deactive Serie')
                .ok($filter('translate')('general.deactive'))
                .cancel($filter('translate')('general.cancel'));

            $mdDialog.show(confirm).then(function () {
                if (data.id) {
                    vm.invoiceSeries.splice(index, 1);
                    api.GeneralWS.InvoiceSerie.delete({ id: data.id }).$promise.then(function (response) {
                        response.fileStorage = data.fileStorage;
                        vm.invoiceSeries.push(response);
                        MessageService.show($filter('translate')('COMPANY.SERIE_DEACTIVATED'));
                    }, function (errResponse) {
                        MessageService.showErrorMessage('general.general_error');
                        vm.invoiceSeries.push(data);
                        $log.debug(errResponse);
                    });
                }
            }, function () {
            });

        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('FilesController', FilesController);

    function FilesController(api, MessageService, $scope) {

        var fl = this;
        var vm = $scope.vm;

        vm.filesToUpload = [];
        fl.ngFlowOptions = {
            target: '/Megasistemas'
        };
        fl.ngFlow = {
            flow: {}
        };
        fl.dropping = false;
        fl.imageZoomOptions = {};
        //Methods

        fl.fileAdded = fileAdded;
        fl.fileRemove = fileRemove;
        fl.upload = upload;
        fl.uploadFiles = uploadFiles;
        fl.fileSuccess = fileSuccess;
        fl.updateZoomOptions = updateZoomOptions;


        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            if (vm.filesToUpload.length > 0) {
                fl.updateZoomOptions(vm.filesToUpload[0].url);
            }
        }


        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            // Prepare the temp file data for media list
            var uploadingFile = {
                id: file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            if (!file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
                uploadingFile.image = getImageFile(file.name);
            }

            if (vm.maxPermitedFiles) {
                if (vm.filesToUpload.length === vm.maxPermitedFiles) {
                    return false;
                }
            }

            // Append it to the media list
            if (file.size <= 5000000) {//309983   7561216
                vm.filesToUpload.push(uploadingFile);
            } else {
                MessageService.showErrorMessage(file.name + $filter('translate')('PRODUCT.TEXT.PHOTOS.IS_MAJOR_SIZE'));
            }
        }

        function fileRemove(file) {
            fl.ngFlow.flow.files.splice(fl.ngFlow.flow.files.indexOf(file.file), 1);
            vm.filesToUpload.splice(vm.filesToUpload.indexOf(file), 1);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload() {
            // Set headers
            fl.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest'
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            fl.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.filesToUpload, function (media, index) {
                if (media.id === file.uniqueIdentifier) {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event) {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }

        function updateZoomOptions(url) {
            fl.imageZoomOptions = {
                images: [
                    {
                        thumb: url,
                        medium: url,
                        large: url
                    }
                ]
            };
        }

        function uploadFiles() {
            fl.loadingFiles = true;
            var files = [];
            vm.filesToUpload.forEach(function (r) {
                files.push(r.file.file);
            });
            var message = 'PRODUCT.MSG.SAVEIMAGE';
            MessageService.show(message);
            vm.uploadFiles(files);
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('CompanyWarehouseListController', CompanyWarehouseListController);

    /**@ngInject**/
    function CompanyWarehouseListController(api, $timeout, $log, $rootScope, $mdDialog, $filter, MessageService) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.onUpdate = onUpdate;
        vm.search = search;

        vm.pagination = {
            page: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "whsCode",
                headerName: 'company_warehouse.code',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "whsName",
                headerName: 'company_warehouse.name',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "companyEstablishment.establishmentName",
                headerName: 'company_warehouse.establishment',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "companyWarehouseType",
                headerName: 'company_warehouse.companyWarehouseType',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    switch (params.value) {
                        case 'STORE':
                            return 'Bodega de Tienda';
                        case 'SALE':
                            return 'Bodega de Venta';
                        case 'PRODUCT':
                            return 'Bodega de Producto';
                      case 'CENTRAL':
                        return 'Bodega Central';
                      case 'POUND':
                        return 'Bodega de Libras';
                        default:
                            return '';
                    }
                },
                width: 400
            },
            {
                field: "default",
                headerName: 'general.default',
                headerCellRenderer: getHeader,
                width: 120,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.default" ng-change="vm.onUpdate(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
              field: 'useInTms',
              headerName: 'general.useInTms',
              headerCellRenderer: getHeader,
              width: 120,
              cellRenderer: function (params) {
                 if (params.value) {
                   return '<center><md-checkbox ng-model="data.useInTms" ng-change="vm.onUpdate(data)" aria-label="chk"></md-checkbox></center>';
                 } else {
                   return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                 }
              },
              cellStyle: {'padding': '5px'}
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    return '<center> <md-button class="md-icon-button" ng-click="vm.edit(data)"> <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            vm.grid.api.setColumnDefs(columnDefs);

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    var parameters = { 'id': 'byCompanyAndEstablishmentsOrCompanyOrEstablishment', 'idCircle': $rootScope.bsCircle.id, 'page': vm.pagination.page, 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch };
                    api.GeneralWS.CompanyWarehouse.me.page(parameters).$promise.then(function (response) {
                        vm.isShowProgressLinear = false;

                        vm.pagination.totalElements = response.totalElements;
                        vm.pagination.totalPages = response.totalPages;

                        params.successCallback(response.content, response.totalElements);
                        vm.showGrid = true;

                    }, function (response) {
                        $log.error(response);
                    });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);

        }

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'WarehouseController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-warehouses/warehouse/warehouse.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'warehouse': {
                        'whsCode': '',
                        'whsName': '',
                        'active': true,
                        'company': null,
                        'companyEstablishment': null,
                        'useInTms': null
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                    MessageService.show($filter('translate')('company_warehouse.aggregate'));
                }
            }, function () {

            });
        }

        function edit(warehouse) {
            $mdDialog.show({
                controller: 'WarehouseController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-warehouses/warehouse/warehouse.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'warehouse': angular.copy(warehouse)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });
                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('company_warehouse.updated'));
                }
            }, function () {
            });
        }

        function onDelete(warehouse) {

            var promise;
            promise = api.GeneralWS.CompanyWarehouse.me.delete({ idCircle: $rootScope.bsCircle.id, id: warehouse.id }).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.grid.api.refreshView();
                        MessageService.show($filter('translate')('company_warehouse.deactivated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function onUpdate(warehouse) {
            vm.isShowProgressLinear = true;
            warehouse.isDefault = false;
            warehouse.company = (warehouse.companyEstablishment) ? null : $rootScope.bsCircle.company;

            api.GeneralWS.CompanyWarehouse.me.update({
                idCircle: $rootScope.bsCircle.id,
                id: warehouse.id
            }, warehouse).$promise.then(function (data) {
                vm.isShowProgressLinear = false;
                switch (data.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === warehouse.id) {
                                row.data = warehouse;
                                MessageService.show($filter('translate')('company_warehouse.updated'));
                            }
                        });
                        break;
                    default:
                        $log.error(data);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }
                vm.grid.api.refreshView();
            }, function (err) {
                vm.isShowProgressLinear = false;
                $log.error(err);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('WarehouseController', WarehouseController);

    /**@ngInject**/
    function WarehouseController($mdDialog, api, warehouse, $log, MessageService, $filter, $rootScope, $timeout) {

        var vm = this;

        vm.warehouse = warehouse;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        init();
        /**
         * Initialize
         */
        function init() {
            loadCatalogs();
        }

        function loadCatalogs() {
            vm.loadingEstablishments = true;
            var params = { 'id': 'byCompany', 'idCircle': $rootScope.bsCircle.id, 'active': true };
            api.GeneralWS.CompanyEstablishment.me.getByCompany(params).$promise.then(function (data) {
                vm.establishments = data;
                vm.loadingEstablishments = false;
                if (vm.warehouse.companyEstablishment) {
                    vm.warehouse.companyEstablishment.id = vm.warehouse.companyEstablishment.id.toString();
                }
            }, function (response) {
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }


        function save() {

            if (vm.warehouse.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }
            var promise;
            vm.warehouse.company = (vm.warehouse.companyEstablishment) ? null : $rootScope.bsCircle.company;
            if (vm.warehouse.id) {
                promise = api.GeneralWS.CompanyWarehouse.me.update({ idCircle: $rootScope.bsCircle.id, id: vm.warehouse.id }, vm.warehouse).$promise;
            } else {
              if ( vm.warehouse.useInTms === null) {
                vm.warehouse.useInTms = false;
              }


                promise = api.GeneralWS.CompanyWarehouse.me.create({}, vm.warehouse).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(vm.warehouse);
                        break;
                    case 201:
                        $mdDialog.hide(vm.warehouse);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                switch (response.status) {
                    case 409:
                        MessageService.showErrorMessage(($filter('translate')('company_warehouse.conflict_with_code')) + response.data);
                        break;
                    case 302:
                        MessageService.showErrorMessage(response.data + ($filter('translate')('company_warehouse.default_already_exist')));
                        break;
                    case  303:
                        MessageService.showErrorMessage(response.data + ($filter('translate')('company_warehouse.useInTms_already_exist')));
                        break;
                    default:
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

        vm.clearSearchEstablishment = function () {
            vm.searchEstablishment = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchEstablishmentInput = document.querySelector("#searchEstablishment");

            if (searchEstablishmentInput) {
                searchEstablishmentInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('CompanyFiscalPeriodListController', CompanyFiscalPeriodListController);

    /**@ngInject**/
    function CompanyFiscalPeriodListController(api, $timeout, $log, $rootScope, $mdDialog, $filter, MessageService) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;

        vm.pagination = {
            page: 0,
            pageSize: 20,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "id",
                headerName: 'company_fiscal_period.fiscal_period',
                headerCellRenderer: getHeader,
                width: 120
            },
            {
                field: "startDate",
                headerName: 'company_fiscal_period.start_date',
                headerCellRenderer: getHeader,
                width: 200,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                }
            },
            {
                field: "finalDate",
                headerName: 'company_fiscal_period.final_date',
                headerCellRenderer: getHeader,
                width: 200,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                }
            },
            {
                field: "extendedDate",
                headerName: 'company_fiscal_period.extended_date',
                headerCellRenderer: getHeader,
                width: 200,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    return '<center> <md-button class="md-icon-button" ng-click="vm.edit(data)"> <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            vm.grid.api.setColumnDefs(columnDefs);

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    var parameters = { 'id': 'byCompany', 'idCircle': $rootScope.bsCircle.id, 'page': vm.pagination.page, 'pageSize': vm.pagination.pageSize };
                    api.GeneralWS.CompanyFiscalPeriods.me.page(parameters).$promise.then(function (response) {
                        vm.isShowProgressLinear = false;

                        vm.pagination.totalElements = response.totalElements;
                        vm.pagination.totalPages = response.totalPages;

                        params.successCallback(response.content, response.totalElements);
                        vm.showGrid = true;

                    }, function (response) {
                        $log.error(response);
                    });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);

        }

        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'FiscalPeriodController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-fiscalPeriods/fiscalPeriod/fiscalPeriod.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'fiscalPeriod': {
                        'id': '',
                        'startDate': '',
                        'finalDate': '',
                        'extendedDate': null,
                        'company': null
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                    MessageService.show($filter('translate')('company_fiscal_period.created'));
                }
            }, function () {

            });
        }

        function edit(fiscalPeriod) {
            $mdDialog.show({
                controller: 'FiscalPeriodController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-fiscalPeriods/fiscalPeriod/fiscalPeriod.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'fiscalPeriod': angular.copy(fiscalPeriod)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });
                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('company_fiscal_period.updated'));
                }
            }, function () {
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('FiscalPeriodController', FiscalPeriodController);

    /**@ngInject**/
    function FiscalPeriodController($mdDialog, api, fiscalPeriod, $log, MessageService, $filter, $rootScope, $timeout) {

        var vm = this;

        //Data
        vm.fiscalPeriod = fiscalPeriod;

        //Methods
        vm.changeFinalDate = changeFinalDate;
        vm.save = save;
        vm.cancel = cancel;
        vm.autoResizeDialog = autoResizeDialog;


        ////////
        function addDay(date, day) {
            date.setDate(date.getDate() + day);
            return date;
        }

        if (fiscalPeriod.id) {
            changeFinalDate(vm.fiscalPeriod.finalDate);
            vm.fiscalPeriod.startDate = addDay((new Date(vm.fiscalPeriod.startDate)), 1);
            vm.fiscalPeriod.finalDate = addDay((new Date(vm.fiscalPeriod.finalDate)), 1);
            vm.fiscalPeriod.extendedDate = addDay((new Date(vm.fiscalPeriod.extendedDate)), 1);
        }

        function changeFinalDate(date) {
            vm.minDate = addDay((new Date(date)), 2);
        }

        function save() {

            if (vm.fiscalPeriodForm.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }
            var promise;
            vm.fiscalPeriod.company = $rootScope.bsCircle.company;
            if (vm.fiscalPeriod.id) {
                promise = api.GeneralWS.CompanyFiscalPeriods.me.update({ idCircle: $rootScope.bsCircle.id, id: vm.fiscalPeriod.id }, vm.fiscalPeriod).$promise;
            } else {
                promise = api.GeneralWS.CompanyFiscalPeriods.me.create({ idCircle: $rootScope.bsCircle.id }, vm.fiscalPeriod).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 409) {
                    MessageService.showErrorMessage(($filter('translate')('company_fiscal_period.already_exists')) + response.data);
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function autoResizeDialog() {
            var windowHeight = parseInt(window.innerHeight);
            windowHeight -= 160;

            vm.dinamicHeight = {
                "width": "20%",
                "min-width": "350px",
                "height": windowHeight + "px",
                "min-height": "490px",
                "max-height": "515px"
            };

            return vm.dinamicHeight;
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('EstablishmentExchangeRateController', EstablishmentExchangeRateController);

    /**@ngInject**/
    function EstablishmentExchangeRateController(api, $log, $rootScope, $mdDialog, $filter, $scope, $mdToast, MessageService, $timeout) {
        var secondCtrl = this;
        var vm = $scope.$parent.vm;

        secondCtrl.onChangeEstablishment = onChangeEstablishment;
        secondCtrl.saveModel = saveModel;
        secondCtrl.deleteExchangeRate = deleteExchangeRate;
        secondCtrl.updateExchangeRate = updateExchangeRate;
        secondCtrl.changeFinalDate = changeFinalDate;

        secondCtrl.exchangeRates = [];
        secondCtrl.model = {};
        secondCtrl.establishments = [];

        secondCtrl.gridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            getRowHeight: function (params) {
                return 45;
            },
            getRowNodeId: function (data) {
                return data.id;
            },
            pagination: false,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        }

        secondCtrl.masterColumnDefs = [
            {
                headerName: 'Fecha de inicio',
                field: "startDate",
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: function renderer(params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy HH:mm:ss')
                }
            },
            {
                headerName: 'Fecha de vencimiento',
                field: "dueDate",
                headerCellRenderer: getHeader,
                width: 155,
                cellRenderer: function renderer(params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy HH:mm:ss')
                }
            },
            {
                headerName: 'EXCHANGERATE.SOURCECURRENCY',
                field: "sourceCurrency.code",
                headerCellRenderer: getHeader,
                width: 120
            },
            {
                headerName: 'EXCHANGERATE.TARGETCURRENCY',
                field: "targetCurrency.code",
                headerCellRenderer: getHeader,
                width: 120
            },
            {
                headerName: 'EXCHANGERATE.RATE',
                field: "exchangeRate",
                headerCellRenderer: getHeader,
                width: 130
            },
            {
                headerName: 'EXCHANGERATE.OPTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 100,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;"> '
                        + '<md-button class="edit-button md-icon-button" ng-click="secondCtrl.deleteExchangeRate($event, data.id, data, $index)" translate-attr-aria-label="EXCHANGERATE.DELETE">'
                        + '  <md-tooltip md-direction="bottom">'
                        + ' {{"EXCHANGERATE.DELETE"| translate}}'
                        + ' </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-delete" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-click="secondCtrl.updateExchangeRate(data)" aria-label="updateExchangeRate"'
                        + ' translate translate-attr-aria-label="EXCHANGERATE.EDIT">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXCHANGERATE.EDIT"| translate}}'
                        + ' </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-pencil" class="s16"></md-icon>'
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function init() {
            // Obtiene la lista de sucursales
            getEstablishments();
            clearModel();
        }

        function onChangeEstablishment() {
            clearModel();
            secondCtrl.model.establishment.id = secondCtrl.establishment.id;
            loadExchangeRatesByEstablishment();
        }

        function getEstablishments() {
            api.GeneralWS.CompanyEstablishment
                .findAllByCompany
                .query({ 'idCircle': $rootScope.bsCircle.id })
                .$promise
                .then(function (response) {
                    secondCtrl.establishments = response;
                }, function (err) {
                    $log.error(err);
                })
        }

        function saveModel() {
            if (secondCtrl.model.sourceCurrency.id == secondCtrl.model.targetCurrency.id) {
                MessageService.showErrorMessage('La moneda destino no puede ser igual a la moneda origen');
                return;
            }

            for (var i = 0; i < secondCtrl.exchangeRates.length; i++) {
                if (!secondCtrl.model
                    && secondCtrl.model.sourceCurrency.id == secondCtrl.exchangeRates[i].sourceCurrency.id
                    && secondCtrl.model.targetCurrency.id == secondCtrl.exchangeRates[i].targetCurrency.id
                    && secondCtrl.startDatePicker.getTime() >= new Date(secondCtrl.exchangeRates[i].startDate).getTime()
                    && secondCtrl.startDatePicker.getTime() <= new Date(secondCtrl.exchangeRates[i].dueDate).getTime()) {
                    MessageService.showErrorMessage('Ya existe una tasa de cambio vigente para las monedas seleccionadas');
                    return;
                }
            }

            secondCtrl.model.startDate = $filter('date')(secondCtrl.startDatePicker, 'yyyy-MM-dd') + 'T00:00:00.000Z';
            secondCtrl.model.dueDate = $filter('date')(secondCtrl.dueDatePicker, 'yyyy-MM-dd') + 'T23:59:59.000Z';

            $rootScope.loadingProgress = true;
            if (secondCtrl.model.id) {
                api.GeneralWS.EstablishmentCurrencyExchangeRate
                    .doUpdate
                    .update({ 'id': secondCtrl.model.id, 'idCircle': $rootScope.bsCircle.id }, secondCtrl.model)
                    .$promise
                    .then(function (response) {
                        $rootScope.loadingProgress = false;
                        MessageService.show('Tasa de cambio actualizada exitosamente');
                        onChangeEstablishment();
                    }, function (err) {
                        $rootScope.loadingProgress = false;
                        $log.error(err);
                        MessageService.showErrorMessage('Error al guardar la tasa de cambio');
                    });
            } else {
                api.GeneralWS.EstablishmentCurrencyExchangeRate
                    .self
                    .save({ 'idCircle': $rootScope.bsCircle.id }, secondCtrl.model)
                    .$promise
                    .then(function (response) {
                        $rootScope.loadingProgress = false;
                        MessageService.show('Tasa de cambio guardada exitosamente');
                        onChangeEstablishment();
                    }, function (err) {
                        $rootScope.loadingProgress = false;
                        $log.error(err);
                        if (err.status === 409) {
                            MessageService.showErrorMessage($filter('translate')('EXCHANGERATE.DATE_CONFLICT'));
                        } else {
                            MessageService.showErrorMessage('Error al guardar la tasa de cambio');
                        }
                    });
            }
        }

        function loadExchangeRatesByEstablishment() {
            secondCtrl.exchangeRates = [];
            api.GeneralWS.EstablishmentCurrencyExchangeRate
                .self
                .query({ 'idCircle': $rootScope.bsCircle.id, 'establishmentId': secondCtrl.establishment.id })
                .$promise
                .then(function (response) {
                    $rootScope.loadingProgress = false;
                    secondCtrl.exchangeRates = response;
                    secondCtrl.gridOptions.api.setColumnDefs(secondCtrl.masterColumnDefs);
                    secondCtrl.gridOptions.api.setRowData(response);
                }, function (err) {
                    $rootScope.loadingProgress = false;
                    $log.error(err);
                    MessageService.showErrorMessage('Error al guardar la tasa de cambio');
                });
        }

        function clearModel() {
            secondCtrl.startDatePicker = new Date();
            secondCtrl.dueDatePicker = new Date();

            secondCtrl.model = {
                exchangeRate: null,
                establishment: {},
                sourceCurrency: {},
                targetCurrency: {},
                id: null
            };
        }

        function deleteExchangeRate(event, id, data, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('menu.exchangeRate'))
                .textContent($filter('translate')('EXCHANGERATE.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('EXCHANGERATE.OK'))
                .cancel($filter('translate')('EXCHANGERATE.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                api.GeneralWS.EstablishmentCurrencyExchangeRate
                    .doDelete
                    .update({ 'id': id, 'idCircle': $rootScope.bsCircle.id })
                    .$promise
                    .then(function (response) {
                        $rootScope.loadingProgress = false;
                        MessageService.show('Tasa de cambio eliminada exitosamente');
                        clearModel();
                        loadExchangeRatesByEstablishment();
                    }, function (err) {
                        $rootScope.loadingProgress = false;
                        $log.error(err);
                        MessageService.showErrorMessage('Error al guardar la tasa de cambio');
                    });
            }, function () {
            });
        }

        function updateExchangeRate(data) {
            secondCtrl.model = data;
            secondCtrl.startDatePicker = new Date(data.startDate);
            setTimeout(function () {
                secondCtrl.dueDatePicker = new Date(data.dueDate);
            }, 200);
        }

        function changeFinalDate() {
            if (secondCtrl.startDatePicker.getTime() > secondCtrl.dueDatePicker.getTime()) {
                secondCtrl.dueDatePicker = new Date(secondCtrl.startDatePicker.getTime());
            }
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('ExchangeRateController', ExchangeRateController);

    /**@ngInject**/
    function ExchangeRateController(api, $log, $rootScope, $mdDialog, $filter, $scope, $mdToast, MessageService) {

        var vm = this;

        var pageSize = 20;
        vm.pageNumber = 0;

        vm.allExchangeRate = allExchangeRate;
        vm.exchangeRate = {};
        vm.exchangeRate.rateStartDate = new Date();
        vm.exchangeRate.rateDueDate = new Date();
        vm.saveModel = saveModel;
        vm.deleteExchangeRate = deleteExchangeRate;
        vm.updateExchangeRate = updateExchangeRate;
        vm.onChangeSwitch = onChangeSwitch;
        vm.allExchangeRates = [];
        vm.isByEstablishment = false;
        vm.contentTemplates = [
            'app/main/apps/company/company-exchangeRate/by-company/by-company.html',
            'app/main/apps/company/company-exchangeRate/by-establishment/by-establishment.html'
        ];
        vm.currentContentTemplateUrl = vm.contentTemplates[0];

        init();

        $scope.$watch('vm.exchangeRate.rateStartDate', function (date) {
            vm.rateStartDate = date;

        });

        $scope.$watch('vm.exchangeRate.rateDueDate', function (date) {
            vm.rateDueDate = date;

        });

        $rootScope.rateStartDate = vm.exchangeRate.rateStartDate;
        $rootScope.rateDueDate = vm.exchangeRate.rateDueDate;

        function init() {
            api.GeneralWS.Currency.query({},
                function (data) {
                    vm.sourcecurrencies = angular.copy(data);
                    vm.targetCurrencies = angular.copy(data);
                    if (data.length === 1) {
                        vm.exchangeRate.sourcecurrency = vm.sourcecurrencies[0];
                        vm.exchangeRate.targetcurrency = vm.targetCurrencies[0];
                    }
                }

            );
        }

        function onChangeSwitch() {
            if (vm.isByEstablishment) {
                vm.currentContentTemplateUrl = vm.contentTemplates[1];
            } else {
                vm.currentContentTemplateUrl = vm.contentTemplates[0];
            }
        }

        function allExchangeRate() {
            if (vm.rateStartDate === undefined && vm.rateDueDate === undefined) {
                vm.exchangeRate.rateStartDate = $rootScope.rateStartDate;
                vm.exchangeRate.rateDueDate = $rootScope.rateDueDate;

            } else {
                vm.exchangeRate.rateStartDate = vm.rateStartDate;
                vm.exchangeRate.rateDueDate = vm.rateDueDate;

            }
            var rateStartDate = new Date(vm.exchangeRate.rateStartDate);
            rateStartDate = rateStartDate.getFullYear() + '-' + (rateStartDate.getMonth() + 1) + '-' + rateStartDate.getDate();
            var rateDueDate = new Date(vm.exchangeRate.rateDueDate);
            rateDueDate = rateDueDate.getFullYear() + '-' + (rateDueDate.getMonth() + 1) + '-' + rateDueDate.getDate();

            var exchange = {
                paginationPageSize: pageSize,
                getRows: function (params) {
                    var parameters = {
                        idCircle: $rootScope.bsCircle.id,
                        rateStartDate: rateStartDate,
                        rateDueDate: rateDueDate,
                        page: vm.pageNumber,
                        size: pageSize
                    };

                    api.GeneralWS.getAllExchangeRate.get(parameters, function (data) {
                        params.successCallback(data.content, data.totalElements);
                        vm.pageNumber = data.number;
                        vm.showGrid = true;

                        vm.allowRoleAccess = true;
                        vm.allExchangeRates = data.content;

                    }, function (response) {
                        vm.loading = false;

                        vm.allowRoleAccess = false;
                        $log.error(response);

                    });
                }
            };
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            vm.masterGridOptions.api.setEnterpriseDatasource(exchange);
        }

        vm.masterColumnDefs = [
            {
                headerName: 'EXCHANGERATE.RATEDATE',
                field: "rateDate",
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                headerName: 'EXCHANGERATE.SOURCECURRENCY',
                field: "sourceCurrency.code",
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                headerName: 'EXCHANGERATE.TARGETCURRENCY',
                field: "targetCurrency.code",
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                headerName: 'EXCHANGERATE.RATE',
                field: "rate",
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                headerName: 'EXCHANGERATE.OPTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 100,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;"> '
                        + '<md-button class="edit-button md-icon-button" ng-click="vm.deleteExchangeRate($event, data.id, data, $index)" translate-attr-aria-label="EXCHANGERATE.DELETE">'
                        + '  <md-tooltip md-direction="bottom">'
                        + ' {{"EXCHANGERATE.DELETE"| translate}}'
                        + ' </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-delete" class="s16"></md-icon> '
                        + ' </md-button>'
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.updateExchangeRate(data)" aria-label="updateExchangeRate"'
                        + ' translate translate-attr-aria-label="EXCHANGERATE.EDIT">'
                        + ' <md-tooltip md-direction="bottom">'
                        + ' {{"EXCHANGERATE.EDIT"| translate}}'
                        + ' </md-tooltip>'
                        + ' <md-icon md-font-icon="icon-pencil" class="s16"></md-icon>'
                        + ' </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 50,
            getRowHeight: function (params) {
                return 45;
            },
            getRowNodeId: function (data) {
                return data.id;
            },
            rowModelType: "enterprise",
            paginationPageSize: pageSize,
            cacheBlockSize: pageSize,
            pagination: true,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }


        function saveModel() {
            var promise;
            if (!vm.exchangeRate.id) {
                var rateStartDate = new Date(vm.exchangeRate.rateStartDate);
                rateStartDate = rateStartDate.getFullYear() + '-' + (rateStartDate.getMonth() + 1) + '-' + rateStartDate.getDate();
                var rateDueDate = new Date(vm.exchangeRate.rateDueDate);
                rateDueDate = rateDueDate.getFullYear() + '-' + (rateDueDate.getMonth() + 1) + '-' + rateDueDate.getDate();
                promise = api.GeneralWS.allExchangeRate.create({
                    id: null, idCircle: $rootScope.bsCircle.id, rateStartDate: rateStartDate, rateDueDate: rateDueDate
                }, vm.exchangeRate)
                    .$promise;
            } else {
                promise = api.GeneralWS.allExchangeRate.update({ idCircle: $rootScope.bsCircle.id, id: vm.exchangeRate.id }, vm.exchangeRate).$promise;
            }
            promise.then(function (data) {
                if (data.length === 0) {
                    MessageService.showErrorMessage($filter('translate')('EXCHANGERATE.NO_CREATED'));
                    return;
                }

                vm.exchangeRate = {};
                allExchangeRate();

                showMessage($filter('translate')('EXCHANGERATE.SAVE_UPDATE'));
            }, function (err) {
                $log.error(err);

            });
        }

        function deleteExchangeRate(e, id, data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('menu.exchangeRate'))
                .textContent($filter('translate')('EXCHANGERATE.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('EXCHANGERATE.OK'))
                .cancel($filter('translate')('EXCHANGERATE.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                api.GeneralWS.allExchangeRate.delete({ idCircle: $rootScope.bsCircle.id, id: id }, function (data) {
                    vm.exchangeRate = {};
                    vm.masterGridOptions.api.forEachNode(function (row, index) {
                        if (row.data.id === id) {
                            vm.allExchangeRate();
                        }

                    });
                    vm.masterGridOptions.api.redrawRows();
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start">'
                            + ' <div class="md-toast-content" translate="EXCHANGERATE.DELETE_EXCHANGERATE"></div></md-toast>',
                        hideDelay: 3000,
                        position: 'top right'
                    });

                }, function (response) {// Error
                    $log.debug(response);
                    if (response.data === "ExchangeRate can not deleted") {
                        showErrorMessage($filter('translate')('EXCHANGERATE.ERROR_DELETE_EXCHANGERATE'));
                    }
                });

            }, function () {
                $log.debug(data);

            });

        }

        function updateExchangeRate(data) {
            $rootScope.rateStartDate = vm.exchangeRate.rateStartDate;
            $rootScope.rateDueDate = vm.exchangeRate.rateDueDate;

            vm.exchangeRate = data;
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }


    }

})();

(function () {

  'use strict';

  angular
    .module('app.company')
    .controller('PaymentTypesController2', PaymentTypesController2);

  function PaymentTypesController2($log, api, MessageService, $filter, $timeout, $rootScope, $mdDialog, $stateParams, PreviousState, $state) {

    var vm = this;

    vm.toggle = toggle;
    vm.toggleAssociated = toggleAssociated;
    vm.selectedArray = [];
    vm.selectedAssociatedArray = [];
    vm.isSelected = isSelected;
    vm.isSelectedAssociated = isSelectedAssociated;
    vm.associate = associate;
    vm.disassociate = disassociate;
    vm.gotoBack = gotoBack;

    vm.paymentTypesCompany = [];
    vm.paymentTypesNotCompany = [];

    function init() {
      vm.load = true;
      vm.loadAssociated = true;
      api.GeneralWS.CompanyEstablishment.me.get({'id': $stateParams.id}).$promise.then(function (response) {
        vm.companyEstablishment = response;
      }, function (err) {
        $log.debug(err);
      });
      vm.selectedArray = [];
      vm.selectedAssociatedArray = [];
      api.GeneralWS.CompanyEstablishmentPaymentType.byCompanyEstablishment.get({'companyEstablishmentId': $stateParams.id}, function (response) {
        vm.paymentTypesCompany = response;
        vm.load = false;
      }, function (errResponse) {
      });
      api.GeneralWS.CompanyEstablishmentPaymentType.byNotCompanyEstablishment.get({'companyEstablishmentId': $stateParams.id}, function (response) {
        vm.paymentTypesNotCompany = response;
        vm.loadAssociated = false;
      }, function (errResponse) {
        $log.debug(errResponse);
      });
    }

    $timeout(function () {
      init();
    }, 300);

    function toggle(data, event) {
      if (event) {
        event.stopPropagation();
      }
      if (vm.selectedArray.indexOf(data) > -1) {
        vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
      } else {
        vm.selectedArray.push(data);
      }
    }

    function toggleAssociated(data, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedAssociatedArray.indexOf(data) > -1) {
        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
      } else {
        vm.selectedAssociatedArray.push(data);
      }
    }

    function isSelected(data) {
      return vm.selectedArray.indexOf(data) > -1;
    }

    function isSelectedAssociated(data) {
      return vm.selectedAssociatedArray.indexOf(data) > -1;
    }

    function associate(paymentType) {
      $mdDialog.show({
        controller: 'dialogPaymentTypesController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/company/company-establishments/paymentTypes/dialogPaymentTypes/dialogPaymentTypes.html',
        parent: angular.element("#main"),
        clickOutsideToClose: false,
        locals: {
          'paymentType': paymentType,
          'establishmentId': $stateParams.id
        }
      }).then(function (answer) {
        if (answer) {
          var paymentTypeArray = [];
          if (!vm.isCheckAllRole) {

            answer.usePosIntegrated = answer.usePosIntegrated ? answer.usePosIntegrated : false;
            answer.requestAuthorization = answer.requestAuthorization ? answer.requestAuthorization : false;
            answer.canInvoiceStayPending = answer.canInvoiceStayPending ? answer.canInvoiceStayPending : false;
            answer.canEnterCustomerEmailOnInvoice = answer.canEnterCustomerEmailOnInvoice ? answer.canEnterCustomerEmailOnInvoice: false;
            answer.requireCustomerEmailOnInvoice = answer.requireCustomerEmailOnInvoice ? answer.requireCustomerEmailOnInvoice: false;
            answer.generateAutomaticInvoice = answer.generateAutomaticInvoice ? answer.generateAutomaticInvoice : false;
            answer.extractPercentageFromTotal = answer.extractPercentageFromTotal ? answer.extractPercentageFromTotal : false;

            vm.selectedArray.forEach(function (row) {
              var obj = {
                companyEstablishment: {id: $stateParams.id},
                paymentType: {id: row.id},
                authorizedAmount: answer.authorizedAmount,
                commissionPercentage: answer.commissionPercentage,
                usePosIntegrated: answer.usePosIntegrated,
                requestAuthorization: answer.requestAuthorization,
                typeProviderIntegration: answer.typeProviderIntegration,
                accountingCatalog: answer.accountingCatalog,
                canInvoiceStayPending: answer.canInvoiceStayPending,
                canEnterCustomerEmailOnInvoice: answer.canEnterCustomerEmailOnInvoice,
                requireCustomerEmailOnInvoice: answer.requireCustomerEmailOnInvoice,
                paymentTypeAutomaticInvoice: answer.paymentTypeAutomaticInvoice,
                invoiceAutomaticCustomerAddress: answer.invoiceAutomaticCustomerAddress,
                maxAmount: answer.maxAmount,
                generateAutomaticInvoice: answer.generateAutomaticInvoice,
                percentageInvoice: answer.percentageInvoice,
                extractPercentageFromTotal: answer.extractPercentageFromTotal,
                invoiceAutomaticCustomerName: answer.invoiceAutomaticCustomerName,
                invoiceAutomaticCustomerTax: answer.invoiceAutomaticCustomerTax,
                invoiceAutomaticProductCode: answer.invoiceAutomaticProductCode,
              };
              paymentTypeArray.push(obj);
            });

            if (vm.selectedArray.length === 0) {
              paymentTypeArray.push(answer);
            }
          }

          if (paymentTypeArray.length === 0 && !vm.isCheckAllRole) {
            return null;
          }

          vm.isShowProgressLinear = true;
          api.GeneralWS.CompanyEstablishmentPaymentType.CompanyEstablishmentPaymentType.create(
            {'idCircle': $rootScope.bsCircle.id}, paymentTypeArray).$promise.then(function () {

            vm.isShowProgressLinear = false;
            MessageService.show($filter('translate')('PAYMENT_TYPE.MSG.ADDEDD_SUCCESSFULLY'));

            init();

          }, function (response) {
            vm.isShowProgressLinear = false;
            $log.error(response);
          });
        }
        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];
        return true;
      }, function () {

      });


    }

    function disassociate() {

      var paymentTypeArray = [];

      if (!vm.isCheckAllUserRole) {
        vm.selectedAssociatedArray.forEach(function (row) {
          var obj = {
            companyEstablishment: {id: $stateParams.id},
            paymentType: {id: row.id}
          };
          paymentTypeArray.push(obj);
        });
      }

      if (paymentTypeArray.length === 0 && !vm.isCheckAllUserRole) {
        return null;
      }


      vm.isShowProgressLinear = true;
      api.GeneralWS.CompanyEstablishmentPaymentType.CompanyEstablishmentPaymentType.update(
        {'idCircle': $rootScope.bsCircle.id}, paymentTypeArray).$promise.then(function () {

        vm.isShowProgressLinear = false;

        MessageService.show($filter('translate')('PAYMENT_TYPE.MSG.DELETED_SUCCESSFULLY'));

        init();

      }, function (response) {
        vm.isShowProgressLinear = false;
        $log.error(response);
      });
      return true;

    }

    $timeout(function () {

      var mdDialog = $("#productParamenters");
      var windowHeight = parseInt(mdDialog.innerHeight());

      windowHeight -= 300;

      vm.dinamicHeight = {
        "height": windowHeight + "px"
      };

    }, 1000);

    function gotoBack() {
      if (PreviousState && PreviousState.name) {
        $state.go(PreviousState.name);
      } else {
        $state.go('app.dashboards_project', {}, {reload: true});
      }
    }


  }

})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('CompanyEstablishmentListController', CompanyEstablishmentListController);

    /**@ngInject**/
    function CompanyEstablishmentListController(api, $timeout, $log, $rootScope, $filter, MessageService, $state, $mdDialog) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;
        vm.paymentTypes = paymentTypes;
        vm.isCorporateMember = false;

        vm.pagination = {
            page: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "internalCode",
                headerName: 'company_establishment.internal_code',
                headerCellRenderer: getHeader,
                width: 110
            },
            {
                field: "establishmentName",
                headerName: 'company_establishment.name',
                headerCellRenderer: getHeader,
                width: 330
            },
            {
                field: "department.description",
                headerName: 'company_establishment.department',
                headerCellRenderer: getHeader,
                width: 330
            },
            {
                field: "costCenter.description",
                headerName: 'company_establishment.cost_center',
                headerCellRenderer: getHeader,
                width: 280
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 60,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                field: "template",
                headerName: 'company_establishment.template',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
                    } else {
                        return "";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
          {
                field: "enabledJournal",
                headerName: 'company_establishment.enabledJournal',
                headerCellRenderer: getHeader,
                width: 130,
                cellRenderer: function (params) {
                    if (params.value) {
                        return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
                    } else {
                        return "";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 625,
                cellRenderer: function (params) {
                    return '<center> ' +
                        '<md-button class="md-icon-button" ng-click="vm.edit(data)">' +
                        ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.companyEstablishmentBank(data)">' +
                        ' <md-icon md-font-icon="icon-bank"></md-icon> <md-tooltip md-direction="left">{{"BANK.BANK"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.companyEstablishmentCurrency(data)">' +
                        ' <md-icon md-font-icon="icon-coin"></md-icon> <md-tooltip md-direction="left">{{"company_establishment.coin"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.companyEstablishmentRoleSpecialAction(data)">' +
                        ' <md-icon md-font-icon="icon-account-network"></md-icon> ' +
                        ' <md-tooltip md-direction="left">{{"company_establishment.role_special_action"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.paymentTypes(data)">' +
                        ' <md-icon md-font-icon="icon-credit-card-multiple"></md-icon> <md-tooltip md-direction="left">{{"PAYMENT_TYPE.PAYMENT_TYPE"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.discounts(data)">' +
                        ' <md-icon md-font-icon="icon-percent"></md-icon> <md-tooltip md-direction="left">{{"DISCOUNTS.DISCOUNTS"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.configureDiscounts(data)">' +
                        ' <md-icon md-font-icon="icon-margin"></md-icon> <md-tooltip md-direction="left">{{"DISCOUNTS.DISCOUNTS_CONFIGURE"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.codeCollectionQueue(data)">' +
                        ' <md-icon md-font-icon="icon-qrcode"></md-icon> <md-tooltip md-direction="left">{{"company_establishment.CODE_CHARGE_QUEUE"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.productAdministration(data)">' +
                        ' <md-icon md-font-icon="icon-checkbox-multiple-marked-outline"></md-icon> ' +
                        '<md-tooltip md-direction="left">{{"menu.parameters_product"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.companyWarehouse(data)">' +
                        ' <md-icon md-font-icon="icon-home"></md-icon> ' +
                        '<md-tooltip md-direction="left">{{"menu.warehouses"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.classifications(data)" ng-if="vm.isCorporateMember">' +
                        ' <md-icon md-font-icon="icon-sitemap"></md-icon> ' +
                        '<md-tooltip md-direction="left">{{"company_establishment.classification.classifications"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.accountingAccounts(data)">' +
                        ' <md-icon md-font-icon="icon-archive"></md-icon> ' +
                        '<md-tooltip md-direction="left">{{"company_establishment.accountingAccount.accountingAccount"| translate}}</md-tooltip>' +
                        ' </md-button>' +
                        ' </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            vm.grid.api.setColumnDefs(columnDefs);

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.CompanyEstablishment.me.page({
                        'id': 'byCompany', 'idCircle': $rootScope.bsCircle.id, 'page': vm.pagination.page, 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;

                            params.successCallback(response.content, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);

        }

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        function init() {
            validateCorporate();
            createNewDatasource();
        }

        function add() {
            $state.go('app.company.establishment.detail');
        }

        function edit(data) {
            $state.go('app.company.establishment.detail', { id: data.id });
        }

        function paymentTypes(data) {
            $state.go('app.company.establishment.paymentTypes', { id: data.id });
        }

        function onDelete(establishment) {

            var promise;
            promise = api.GeneralWS.CompanyEstablishment.me.delete({ idCircle: $rootScope.bsCircle.id, id: establishment.id }).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.grid.api.refreshView();
                        MessageService.show($filter('translate')('company_establishment.deactivated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        $timeout(function () {
            init();
        }, 1000);

        vm.companyEstablishmentBank = function (data) {
            $mdDialog.show({
                controller: 'DialogBankController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/dialogBank/dialog-Bank.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'establishment': data
                },
                multiple: true
            }).then(function (answer) {

            }, function () {

            });
        };

        vm.companyEstablishmentCurrency = function (data) {
            $mdDialog.show({
                controller: 'DialogCoinController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/dialogCoin/dialog-Coin.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'establishment': data
                },
                multiple: true
            }).then(function (answer) {

            }, function () {

            });
        };

        vm.companyEstablishmentRoleSpecialAction = function (data) {
            $mdDialog.show({
                controller: 'DialogRoleSpecialActionController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/dialogRoleSpecialAction/dialog-RoleSpecialAction.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'establishment': data
                },
                multiple: true
            }).then(function (answer) {

            }, function () {

            });
        };

        vm.discounts = function (data) {
            $mdDialog.show({
                controller: 'DialogDiscountsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/dialogDiscounts/dialog-Discounts.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'establishment': data
                },
                multiple: true
            }).then(function (answer) {

            }, function () {

            });
        }

        vm.configureDiscounts = function (data) {
            $state.go('app.company.establishment.configureDiscounts', { id: data.id });
        }

        vm.codeCollectionQueue = function (inf) {
            $state.go('app.company.establishment.codeBagCollectionQueue', { 'id': inf.id, 'establishment': inf });
        }

        vm.productAdministration = function (inf) {
            $state.go('app.company.establishment.parameterProduct', { 'id': inf.id, 'establishment': inf });
        }

        vm.companyWarehouse = function (data) {
            $mdDialog.show({
                controller: 'DialogCompanyWarehouseController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/dialogCompanyWarehouse/dialog-CompanyWarehouse.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'establishment': data
                },
                multiple: true
            }).then(function (answer) {

            }, function () {

            });
        }

        vm.classifications = function (data) {
            $mdDialog.show({
                controller: 'DialogClassificationsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/dialogClassifications/dialog-classifications.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'establishment': data
                },
                multiple: true
            });
        }

        vm.accountingAccounts = function (data) {
            $mdDialog.show({
                controller: 'dialogAccountingAccountController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment-list/dialogAccountingAccount/dialog-accounting-account.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'establishment': data,
                },
                multiple: true,
            });
        }

        function validateCorporate() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CorporateMembers.isCorporateMember.get({
                "companyId": $rootScope.bsCircle.company.id
            }, function (response) {
                vm.isCorporateMember = response;
            }, function (errResponse) {
                vm.isCorporateMember = false;
                $log.debug(errResponse);
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('CompanyEstablishmentController', CompanyEstablishmentController);

    /** @ngInject */
    function CompanyEstablishmentController(api, $log, $rootScope, $filter, $state, $mdDialog, MessageService, $stateParams, $timeout) {
        var vm = this;

        //Data
        var isNew = $stateParams.id ? false : true;
        const NUMBER_FIVE_HUNDRED = 500;
        vm.establishment = {};

        vm.baseUrlFiles = api.baseUrlFiles;

        // Methods
        vm.goToEstablishments = goToEstablishments;
        vm.save = save;
        vm.addAddress = addAddress;
        vm.addInvoiceSerieDialog = addInvoiceSerieDialog;
        vm.editInvoiceSerie = editInvoiceSerie;
        vm.deleteInvoiceSerie = deleteInvoiceSerie;
        vm.invoiceSeries = [];
        vm.updateParameterValue = updateParameterValue;
        vm.getParametersByApplication = getParametersByApplication;
        vm.addNewUser = addNewUser;
        vm.parameterColor = "#aed581";
        vm.content = [];
        vm.changeEmployeeCompanyCode = changeEmployeeCompanyCode;
        vm.searchDimensionCompanyDetail3 = '';
        vm.searchDimensionCompanyDetail4 = '';
        vm.searchDimensionCompanyDetail5 = '';
        vm.dimensionCompanyDetail3List = [];
        vm.dimensionCompanyDetail4List = [];
        vm.dimensionCompanyDetail5List = [];
        vm.dimensionCompanyDetail3 = '';
        vm.dimensionCompanyDetail4 = '';
        vm.dimensionCompanyDetail5 = '';
        vm.invoiceSerieDocumentTypes = {};
        vm.appOperaciones2Active = false;

        ////////

        init();
        /**
         * Initialize
         */
        function init() {
            if (isNew === false) {
                $rootScope.loadingProgress = true;
                var establishmentId = vm.establishment.id ? vm.establishment.id : $stateParams.id;
                api.GeneralWS.CompanyEstablishment.me.get({ 'id': establishmentId }).$promise.then(function (response) {
                  if (response.dimensionCompanyDetail3) {
                    response.dimensionCompanyDetail3.id = response.dimensionCompanyDetail3.id.toString();
                  }
                  if (response.dimensionCompanyDetail4) {
                    response.dimensionCompanyDetail4.id = response.dimensionCompanyDetail4.id.toString();
                  }
                  if (response.dimensionCompanyDetail5) {
                    response.dimensionCompanyDetail5.id = response.dimensionCompanyDetail5.id.toString();
                  }
                    var startDate = new Date(response.startDate);
                    response.startDate = startDate;
                    var endDate = new Date(response.endDate);
                    response.endDate = endDate;
                    vm.establishment = response;
                    vm.establishment.department = { id: response.department.id.toString() };
                    vm.establishment.costCenter = { id: response.costCenter.id.toString() };
                    vm.establishment.currency = { id: response.currency.id.toString() };
                    $rootScope.loadingProgress = false;
                    getInvoiceSeriesDocumentCountryList();
                    getApplications();
                }, function (response) {
                    $log.error(response);
                    MessageService.showErrorMessage('general.general_error');
                    $rootScope.loadingProgress = false;
                });
            } else {
                vm.minDate = new Date();
                getCompanyApplicationOp2();
            }
            loadCatalogs();
            getDimensionCompany();
        }

        function getInvoiceSeriesDocumentCountryList() {
            api.GeneralWS.InvoiceSeriesDocumentCountry.getList.getByCountry({ countryId: $rootScope.bsCircle.company.country.id }).$promise.then(function (data) {
                vm.invoiceSerieDocumentTypes = {};
                data.forEach(function(documentType) {
                    vm.invoiceSerieDocumentTypes[documentType.invoiceSeriesDocumentTypeId] = documentType.invoiceSeriesDocumentTypeDescription;
                });
                getInvoiceSeries();
            }, function (errResponse) {
                $log.error(errResponse);
                getInvoiceSeries();
            });
        }

        function loadCatalogs() {
            vm.loadingDepartments = true;
            var params = { idc: $rootScope.bsCircle.company.id };
            api.GeneralWS.Department.query(params, function (data) {
                if (data.length === 1) {
                    vm.establishment.department = {
                        id: data[0].id.toString()
                    };
                }
                vm.departments = data;
                vm.loadingDepartments = false;
            });

            vm.loadingCostCenter = true;
            api.GeneralWS.CostCenter.query(params, function (data) {
                if (data.length === 1) {
                    vm.establishment.costCenter = {
                        id: data[0].id.toString()
                    };
                }
                vm.costCenters = data;
                vm.loadingCostCenter = false;
            });

            vm.loadingCurrencies = true;
            api.GeneralWS.Currency.get({},
                function (data) {
                    if (data.length === 1) {
                        vm.establishment.currency = {
                            id: data[0].id.toString()
                        };
                    }
                    vm.currencies = data;
                    vm.loadingCurrencies = false;
                },
                function (data) {
                    vm.loadingCurrencies = false;
                }
            );

            api.GeneralWS.InvoiceSerieType.active.get({ country: $rootScope.bsCircle.company.country.id }).$promise.then(function (response) {
              vm.invoiceSerieTypes = response;
            }, function (errResponse) {
                $log.debug(errResponse);
            });

            api.GeneralWS.CompanyEstablishmentTemplate.getAll.get({ idCircle: $rootScope.bsCircle.id }).$promise.then(function (response) {
                vm.templateReferences = response;
            }, function (errResponse) {
                $log.debug(errResponse);
            });
        }

        vm.paginationSeries = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefsSeries = [
            {
                field: "serie",
                headerName: 'COMPANY.INVOICE_SERIE.SERIE',
                headerCellRenderer: getHeader,
                width: 100
            },
            {
                field: "initialNumber",
                headerName: 'COMPANY.INVOICE_SERIE.INITIAL_NUMBER',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "lastNumber",
                headerName: 'COMPANY.INVOICE_SERIE.LAST_NUMBER',
                headerCellRenderer: getHeader,
                width: 100
            },
            {
                field: "resolution",
                headerName: 'COMPANY.INVOICE_SERIE.RESOLUTION',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: 'invoiceSerieDocumentTypeName',
                headerName: 'COMPANY.INVOICE_SERIE.DOCUMENT_TYPE',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: "invoiceSerieType.invoiceSerieTypeName",
                headerName: 'COMPANY.INVOICE_SERIE.INVOICE_TYPE',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "authorizationDate",
                headerName: 'COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE',
                headerCellRenderer: getHeader,
                width: 200,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
            },
            {
                field: "dueDate",
                headerName: 'COMPANY.INVOICE_SERIE.DUE_DATE',
                headerCellRenderer: getHeader,
                width: 200,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
            },
            {
                field: "dueDate",
                headerName: 'COMPANY.INVOICE_SERIE.VALIDATED',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params) {
                        return '<md-icon ng-if="data.validated" md-font-icon="icon-check" ></md-icon>' +
                            '<md-icon ng-if="!data.validated" md-font-icon="icon-close" ></md-icon>'
                    }
                    return "";
                },
                cellStyle: { 'text-align': 'center' }
            },
            {
                field: "dueDate",
                headerName: 'COMPANY.FILE',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params) {
                        return '<div layout="row" layout-align="center center"><a ng-href="{{vm.baseUrlFiles}}{{data.fileStorage.parentPath}}' +
                            '{{data.fileStorage.name}}{{\'l\'}}{{data.fileStorage.extension}}"' +
                            'title="{{data.fileStorage.originalName + data.fileStorage.extension}}"' +
                            'data-gallery target="_blank" ng-if="data.fileStorage.extension === \'.jpg\' || ' +
                            'data.fileStorage.extension === \'.png\' || data.fileStorage.extension === \'.JPG\' || ' +
                            'data.fileStorage.extension === \'.PNG\' || data.fileStorage.extension === \'.jpeg\' || ' +
                            'data.fileStorage.extension === \'.JPEG\'">' +
                            '<img style="height:30px !important" ng-src="{{vm.baseUrlFiles}}{{data.fileStorage.parentPath}}{{data.fileStorage.name}}{{\'i\'}}' +
                            '{{data.fileStorage.extension}}"' +
                            ' class="img-rounded border12" alt="photo" height="15" onerror="this.src=\'assets/images/logos/angular.png\'"' +
                            '/>' +
                            '</a>' +
                            '<a ng-href="{{vm.baseUrlFiles + data.fileStorage.parentPath + data.fileStorage.name + data.fileStorage.extension}}"' +
                            'title="{{data.fileStorage.originalName + data.fileStorage.extension}}"' +
                            'data-gallery target="_blank" ng-if="data.fileStorage.extension !== \'.jpg\' && data.fileStorage.extension !== \'.png\' &&' +
                            ' data.fileStorage.extension !== \'.JPG\' && data.fileStorage.extension !== \'.PNG\' && ' +
                            'data.fileStorage.extension !== \'.jpeg\' && data.fileStorage.extension !== \'.JPEG\'">' +
                            '<md-icon md-font-icon="icon-file-document"></md-icon>' +
                            '</a></div>';
                    }
                    return "";
                },
                cellStyle: { 'text-align': 'center' }
            },
            {
                field: "dueDate",
                headerName: 'COMPANY.INVOICE_SERIE.ACTIVE',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params) {
                        return '<md-icon ng-if="data.active" md-font-icon="icon-check" ></md-icon>' +
                            '<md-icon ng-if="!data.active" md-font-icon="icon-close" ></md-icon>'
                    }
                    return "";
                },
                cellStyle: { 'text-align': 'center' }
            },
          {
            field: 'printDocument',
            headerName: 'COMPANY.INVOICE_SERIE.PRINT_DOCUMENT',
            headerCellRenderer: getHeader,
            width: 200,
            cellRenderer: function (params) {
              if (params) {
                return '<md-icon ng-if="data.printDocument" md-font-icon="icon-check" ></md-icon>' +
                  '<md-icon ng-if="!data.printDocument" md-font-icon="icon-close" ></md-icon>';
              }
              return '';
            },
            cellStyle: { 'text-align': 'center' },
          },
          {
            field: 'printFormatDocument',
            headerName: 'COMPANY.INVOICE_SERIE.PRINT_FORMAT_DOCUMENT',
            headerCellRenderer: getHeader,
            width:220,
          },
            {
                field: "id",
                headerName: 'COMPANY.OPTIONS',
                headerCellRenderer: getHeader,
                width: 120,
                cellRenderer: function (params) {
                    return '<md-button class="edit-button md-icon-button" ng-click="vm.editInvoiceSerie(data, $index)" aria-label="Product details"' +
                        'translate translate-attr-aria-label="COMPANY.EDIT">' +
                        '<md-icon md-font-icon="icon-pencil" class="s16"></md-icon>' +
                        '<md-tooltip md-direction="bottom">{{"general.edit"| translate}}</md-tooltip>' +
                        '</md-button>' +
                        '<md-button class="md-icon-button" ng-click="vm.deleteInvoiceSerie(data, $index)" ng-if="data.active" aria-label="Delete"' +
                        'translate translate-attr-aria-label="COMPANY.DELETE">' +
                        '<md-icon md-font-icon="icon-delete" class="s16 md-warn"></md-icon>' +
                        '<md-tooltip md-direction="bottom">{{"general.deactive"| translate}}</md-tooltip>' +
                        '</md-button>';
                },
                cellStyle: { 'padding': '2px' },
                pinned: 'right'
            }
        ];

        vm.gridSeries = {
            paginationPageSize: vm.paginationSeries.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "inMemory",
            cacheBlockSize: vm.paginationSeries.pageSize,
            pagination: true,
            columnDefs: columnDefsSeries,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.dtOptionsParameters = {
            columnDefs: [
                {
                    // Target the id column
                    targets: 0,
                    responsivePriority: 1
                },
                {
                    // Target the actions column
                    targets: 1,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                },
                {
                    // Target the actions column
                    targets: 2,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ],
            order: [[0, "asc"]],
            paging: false,
            responsive: true,
            info: false,
            searching: false
        };

        function save() {
            if (vm.establishmentForm.$invalid) {
                MessageService.showErrorMessage($filter('translate')('general.completeInfo'));
                return false;
            }

            if (!vm.establishment.address) {
                MessageService.showErrorMessage($filter('translate')('company_establishment.address_required'));
                return false;
            }
            $rootScope.loadingProgress = true;
            var promise;
            if (isNew === true) {
                vm.establishment.company = { id: $rootScope.bsCircle.company.id };
                promise = api.GeneralWS.CompanyEstablishment.me.create({}, vm.establishment).$promise;
            } else {
                promise = api.GeneralWS.CompanyEstablishment.me.update({
                    idCircle: $rootScope.bsCircle.id, id: vm.establishment.id
                }, vm.establishment).$promise;
            }
            promise.then(
                function (data) {
                    vm.currentTab = isNew === true ? 1 : 0;
                    MessageService.show(isNew === true ? 'general.register_created_successfully' : 'general.register_updated_successfully');
                    createOperaciones2WarehouseEstablishment([data.id]);
                    isNew = false;
                    vm.establishment.id = data.id;
                    $timeout(function () {
                        init();
                    }, 3000)
                    $rootScope.loadingProgress = false;
                },
                function (errResponse) {
                    if (errResponse.status === NUMBER_FIVE_HUNDRED) {
                      const msgErr = errResponse.data.message.split(':');
                      const errorMessage = msgErr[1].split(';');
                        var message = ($filter('translate')(errorMessage[0] === 'number' ?
                            'company_establishment.conflict_with_number' :
                            'company_establishment.conflict_with_internal_code'));
                        MessageService.showErrorMessage(message + errorMessage[1]);
                    } else {
                        MessageService.showErrorMessage('general.general_error');
                    }
                    $rootScope.loadingProgress = false;
                }
            );
        }

        function addAddress() {
            $mdDialog.show({
                controller: 'AddressController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment/dialogs/address.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'address': angular.copy(vm.establishment.address)
                }
            }).then(function (answer) {
                vm.establishment.address = answer;
            }, function () {

            });
        }

        function goToEstablishments() {
            $state.go('app.company.establishment');
        }
        vm.clearSearchDepartment = function () {
            vm.searchDepartment = "";
        };

        vm.clearSearchCostCenter = function () {
            vm.searchCostCenter = "";
        };

        vm.clearSearchCurrencies = function () {
            vm.searchCurrency = "";
        };

        vm.clearSearchApplication = function () {
            vm.searchApplication = "";
        };

        $timeout(function () {

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchDepartmentInput = document.querySelector("#searchDepartment");
            var searchCostCenterInput = document.querySelector("#searchCostCenter");
            var searchCurrencyInput = document.querySelector("#searchCurrency");
            var searchApplicationInput = document.querySelector("#searchApplication");

            if (searchDepartmentInput) {
                searchDepartmentInput.addEventListener("keydown", keyEvent);
            }

            if (searchCostCenterInput) {
                searchCostCenterInput.addEventListener("keydown", keyEvent);
            }

            if (searchCurrencyInput) {
                searchCurrencyInput.addEventListener("keydown", keyEvent);
            }
            if (searchApplicationInput) {
                searchApplicationInput.addEventListener("keydown", keyEvent);
            }
        }, NUMBER_FIVE_HUNDRED);

        function getInvoiceSeries() {
            vm.showGridSeries = false;
            $rootScope.loadingProgress = true;
            vm.isShowProgressLinear = true;
            api.GeneralWS.InvoiceSerie.getByCompany({
                id: 'byCompanyEstablishment', idCircle: $rootScope.bsCircle.id, establishmentId: vm.establishment.id
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                response.forEach(function(serie) {
                    serie.invoiceSerieDocumentTypeName = vm.invoiceSerieDocumentTypes[serie.invoiceSerieDocumentType];
                });
                vm.gridSeries.api.setRowData(response);
                vm.showGridSeries = true;
            }, function (response) {
                $log.error(response);
            });
            $rootScope.loadingProgress = false;
        }

        function addInvoiceSerieDialog() {
            vm.invoiceSerie = {};
            $mdDialog.show({
                controller: 'InvoiceSerieDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/invoiceSerie/dialog/invoiceSerieDialog.html',
                parent: angular.element("#main"),
                locals: {
                    Company: $rootScope.bsCircle.company,
                    Privated: false,
                    'invoiceSerie': vm.invoiceSerie,
                    'establishment': vm.establishment,
                    invoiceSerieType: vm.invoiceSerieTypes
                },
                clickOutsideToClose: false
            }).then(function (answer) {
                getInvoiceSeries();
            }, function () {

            });
        }

        function editInvoiceSerie(data, index) {
            var newInvoiceSerie = angular.copy(data);

            newInvoiceSerie.authorizationDate = (newInvoiceSerie.authorizationDate ?
                new Date(newInvoiceSerie.authorizationDate + " 00:00:00") :
                new Date());
            newInvoiceSerie.dueDate = (newInvoiceSerie.dueDate ? new Date(newInvoiceSerie.dueDate + " 00:00:00") : new Date());

            $mdDialog.show({
                controller: 'InvoiceSerieDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/invoiceSerie/dialog/invoiceSerieDialog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    Company: $rootScope.bsCircle.company,
                    Privated: false,
                    'invoiceSerie': newInvoiceSerie,
                    'establishment': vm.establishment,
                    invoiceSerieType: vm.invoiceSerieTypes
                }
            }).then(function (answer) {
                getInvoiceSeries();
            }, function () {

            });
        }
        function deleteInvoiceSerie(data, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.deactive'))
                .content($filter('translate')('COMPANY.DEACTIVATE_SERIE'))
                .ariaLabel('Deactive Serie')
                .ok($filter('translate')('general.deactive'))
                .cancel($filter('translate')('general.cancel'));

            $mdDialog.show(confirm).then(function () {
                if (data.id) {
                    vm.invoiceSeries.splice(index, 1);
                    api.GeneralWS.InvoiceSerie.delete({ id: data.id }).$promise.then(function (response) {
                        response.fileStorage = data.fileStorage;
                        getInvoiceSeries()
                        MessageService.show($filter('translate')('COMPANY.SERIE_DEACTIVATED'));
                    }, function (errResponse) {
                        MessageService.showErrorMessage('general.general_error');
                        vm.invoiceSeries.push(data);
                        $log.debug(errResponse);
                    });
                }
            }, function () {
            });

        }


        function createNewDatasource() {
            if (vm.application === null && vm.application === undefined) {
                return null;
            }
            api.GeneralWS.EstablishmentParameter.byCompany.get({
                'app': vm.application.id, 'establishmentId': vm.establishment.id, 'idCircle': $rootScope.bsCircle.id,
                'pageNumber': (vm.pagination.pageNumber + 1), 'pageSize': vm.pagination.pageSize
            }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                $log.debug(response);
                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.pagination.pageNumber = response.number + 1;
                vm.content = new jinqJs()
                    .from(response.content)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select(function (r) {
                      if (r.applicationParameter.dataType === 'BOOLEAN') {
                        r.parameterValue = (r.parameterValue === 'true');
                      }
                      if (r.applicationParameter.dataType === 'DECIMAL') {
                        r.parameterValue = parseFloat(r.parameterValue);
                      }
                        return r;
                    });
                vm.showGrid = true;
            }, function (response) {
                $log.error(response);
            });
        }

        vm.pagination = {
            pageNumber: 0,
            pageSize: 1000,
            totalElements: 0,
            totalPages: 0
        };

        function updateParameterValue(establishmentParameter) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.EstablishmentParameter.byCompany.update({
                'idCircle': $rootScope.bsCircle.id, 'establishmentId': vm.establishment.id
            }, establishmentParameter).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                MessageService.show($filter('translate')('company_parameters.parameter_updated_successfully'));

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function getApplications() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyApplication.me.query({
                'company': $rootScope.bsCircle.company.id, 'includeServices': true
            }).$promise.then(function (response) {

                vm.isShowProgressLinear = false;

                vm.applicationArray = new jinqJs()
                    .from(response)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select();

                if (vm.applicationArray.length > 0) {
                    getParametersByApplication(vm.applicationArray[0].application);
                }
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function getParametersByApplication(application) {

            if (application) {
                vm.application = application;
            }

            vm.pagination.pageNumber = 0;
            createNewDatasource();
            createNewDatasourceUser();
        }

        function addNewUser(selectedUser) {
            $mdDialog.show({
                controller: 'DialogAddUserController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/company-establishments/establishment/dialogs/dialog-addUser.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    Company: $rootScope.bsCircle.company,
                    'establishment': vm.establishment,
                    'selectedUser': selectedUser
                }
            }).then(function () {
              createNewDatasourceUser();
            }, function () {

            });
        }

        function changeEmployeeCompanyCode(selectedUser){
          $mdDialog.show({
            controller: 'DialogChangeCodeEmployee',
            controllerAs: 'vm',
            templateUrl: 'app/main/apps/company/company-establishments/establishment/dialogs/dialog-change-code-employee.html',
            parent: angular.element("#main"),
            clickOutsideToClose: false,
            locals: {
              Company: $rootScope.bsCircle.company,
              'establishment': vm.establishment,
              'selectedUser': selectedUser
            }
          }).then(function () {
              createNewDatasourceUser();
          }, function () {

          });
        }



        /////USUARIO

        vm.paginationUser = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefsUser = [
            {
                field: "employeeCompanyCode",
                headerName: 'company_establishment.employeeCompanyCode',
                headerCellRenderer: getHeader,
                width: 150
            },
          {
                field: "employeeName",
                headerName: 'company_establishment.employeeName',
                headerCellRenderer: getHeader,
                width: 200
            },
          {
                field: "userName",
                headerName: 'company_establishment.userName',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "account",
                headerName: 'user.account',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "roles",
                headerName: 'user.roles',
                headerCellRenderer: getHeader,
                width: 80,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.addNewUser(data)'> " +
                        "<md-icon md-font-icon='icon-account-network'></md-icon> <md-tooltip md-direction='left'>{{'user.roles' | translate}}</md-tooltip>" +
                        " </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            },
          {
            field: "changeEmployeeCompanyCode",
            headerName: 'company_establishment.change_employee_company_code',
            headerCellRenderer: getHeader,
            width: 220,
            cellRenderer: function (params) {
              return "<center> <md-button class='md-icon-button' ng-if='data.employeeCompanyCode' ng-click='vm.changeEmployeeCompanyCode(data)'> " +
                "<md-icon md-font-icon='icon-barcode'></md-icon> <md-tooltip md-direction='left'>{{'company_establishment.change_employee_company_code' | translate}}</md-tooltip>" +
                " </md-button> </center>";
            },
            cellStyle: { 'padding': '2px' }
          }
        ];

        vm.gridUser = {
            paginationPageSize: vm.paginationUser.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.paginationUser.pageSize,
            pagination: true,
            columnDefs: columnDefsUser,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasourceUser() {
            var dataSource = {
                paginationPageSize: vm.paginationUser.pageSize,
                getRows: function (params) {
                    vm.isShowProgressLinear = true;
                    vm.paginationUser.pageNumber = params.request.endRow / vm.paginationUser.pageSize;

                  api.RecursosHumanosWS.Employee.byEstablishment.page({
                    'companyId': $rootScope.bsCircle.company.id,
                    'idCircle': $rootScope.bsCircle.id,
                    'establishmentId': vm.establishment.id,
                    'pageNumber': (vm.paginationUser.pageNumber),
                    'pageSize': vm.paginationUser.pageSize,
                    'search': ''
                  }).$promise.then(function (response) {
                        vm.isShowProgressLinear = false;
                        vm.paginationUser.totalElements = response.totalElements;
                        vm.paginationUser.totalPages = response.totalPages;

                        params.successCallback(response.content, response.totalElements);
                        vm.showGrid = true;
                    }, function (response) {
                        $log.error(response);
                    });
                }
            };
            vm.gridUser.api.setEnterpriseDatasource(dataSource);
        }

        function getDimensionCompany() {
            vm.loadingdimensionCompanyDetail3List = true;
            vm.loadingdimensionCompanyDetail4List = true;
            vm.loadingdimensionCompanyDetail5List = true;
            const NUMBER_DIMENSION_THREE = 3;
            const NUMBER_DIMENSION_FOUR = 4;
            const NUMBER_DIMENSION_FIVE = 5;
            api.GeneralWS.DimensionCompany.byCompanyActive.getList(
                { 'company': $rootScope.bsCircle.company.id }
            ).$promise.then(function (responseDimension) {
                for (let i = 0; i < responseDimension.length; i++) {
                    if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_THREE) {
                        vm.dimensionCompanyDetail3 = responseDimension[i];
                        getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FOUR) {
                        vm.dimensionCompanyDetail4 = responseDimension[i];
                        getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                    } else if (responseDimension[i].dimensionNumber === NUMBER_DIMENSION_FIVE) {
                        vm.dimensionCompanyDetail5 = responseDimension[i];
                        getDimensionCompanyDetail(responseDimension[i].id, responseDimension[i].dimensionNumber);
                    } else {
                        vm.dimensionCompanyDetail1 = responseDimension[i];
                    }
                }
            }, function (err) {
                if (err) {
                    vm.loadingdimensionCompanyDetail3List = false;
                    vm.loadingdimensionCompanyDetail4List = false;
                    vm.loadingdimensionCompanyDetail5List = false;
                }
            });
        }

        function getDimensionCompanyDetail(id, number) {
            const NUMBER_THREE = 3;
            const NUMBER_FOUR = 4;
            const NUMBER_FIVE = 5;
            api.GeneralWS.DimensionCompanyDetail.byDimensionCompany.getList(
                { 'dimensionCompanyId': id }
            ).$promise.then(function (responseDimension) {
                if (number === NUMBER_THREE) {
                    vm.dimensionCompanyDetail3List = responseDimension;
                    vm.loadingdimensionCompanyDetail3List = false;
                } else if (number === NUMBER_FOUR) {
                    vm.dimensionCompanyDetail4List = responseDimension;
                    vm.loadingdimensionCompanyDetail4List = false;
                } else if (number === NUMBER_FIVE) {
                    vm.dimensionCompanyDetail5List = responseDimension;
                    vm.loadingdimensionCompanyDetail5List = false;
                } else {
                    vm.loadingdimensionCompanyDetail1List = false;
                }
            }, function () {
                vm.loadingdimensionCompanyDetail3List = false;
                vm.loadingdimensionCompanyDetail4List = false;
                vm.loadingdimensionCompanyDetail5List = false;
            });
        }

        function getCompanyApplicationOp2() {
          api.GeneralWS.CompanyApplication.byAppName.get({ 'company': $rootScope.bsCircle.company.id, 'app': 'Operaciones2' })
          .$promise.then(function (responseApp) {
            const statusNumberOk = 200;
            if (responseApp.$status === statusNumberOk && responseApp.$data && responseApp.$data !== '') {
              vm.appOperaciones2Active = true;
            }
          }, function (response) {
              $log.error(response);
            });
        }

        function createOperaciones2WarehouseEstablishment(establishments) {
          if (!isNew || !vm.appOperaciones2Active) {
            return;
          }

          const warehouseOperacionesId = $rootScope.bsCircle.company.warehouseOperacionesId;
          if (!warehouseOperacionesId || warehouseOperacionesId === null) {
            return;
          }

          api.Operaciones2ConfigWS.WarehouseEstablishment.me
          .create({ 'warehouseId': $rootScope.bsCircle.company.warehouseOperacionesId }, establishments)
          .$promise.then(function () {
            vm.loading = false;
          }, function () {
            vm.loading = false;
            MessageService.showErrorMessage($filter('translate')
            ('OPERACIONES2.WAREHOUSE.MESSAGE.CREATE_WAREHOUSE_ESTABLISHMENTS_ERROR'));
          });
        }

    }
})();

(function () {
  'use strict';

  angular
    .module('app.company')
    .controller('EstablishmentCashierListController', EstablishmentCashierListController);

  /** @ngInject */
  function EstablishmentCashierListController(api, $timeout, $log, $rootScope, $filter, MessageService, $state, $mdDialog) {
    var vm = this;

    vm.search = search;
    vm.addInvoiceSerieDialog = addInvoiceSerieDialog;
    vm.onDelete = onDelete;
    vm.onDeactive = onDeactive;
    vm.serieDesactivate = serieDesactivate;
    vm.validateSwitch = false;
    vm.invoiceSerieDocumentTypes = {};

    vm.pagination = {
      page: 0,
      pageSize: 50,
      totalElements: 0,
      totalPages: 0
    };

    var columnDefs = [
      {
        field: "id",
        headerName: 'SERIES.NO',
        headerCellRenderer: getHeader,
        width: 100
      },
      {
        field: "establishmentCashier.companyEstablishment.establishmentName",
        headerName: 'SERIES.ESTABLISHMENT',
        headerCellRenderer: getHeader,
        width: 300
      },
      {
        field: "establishmentCashier.nameComputer",
        headerName: 'SERIES.NAME_COMPUTER',
        headerCellRenderer: getHeader,
        width: 200
      },
      {
        field: 'invoiceSerie.invoiceSerieDocumentTypeName',
        headerName: 'COMPANY.INVOICE_SERIE.DOCUMENT_TYPE',
        headerCellRenderer: getHeader,
        width: 200,
      },
      {
        field: "establishmentCashier.number",
        headerName: 'SERIES.NUMBER',
        headerCellRenderer: getHeader,
        width: 150
      },
      {
        field: "invoiceSerie.serie",
        headerName: 'SERIES.SERIE',
        headerCellRenderer: getHeader,
        width: 180
      },
      {
        field: "invoiceSerie.resolution",
        headerName: 'SERIES.RESOLUTION',
        headerCellRenderer: getHeader,
        width: 280
      },
      {
        field: "invoiceSerie.authorizationDate",
        headerName: 'SERIES.AUTHORIZATION_DATE',
        headerCellRenderer: getHeader,
        width: 180,
        cellStyle: { 'text-align': 'right' },
        cellRenderer: function (params) {
          return $filter('date')(params.value, 'dd/MM/yyyy');
        }
      },
      {
        field: "invoiceSerie.dueDate",
        headerName: 'SERIES.DUE_DATE',
        headerCellRenderer: getHeader,
        width: 180,
        cellStyle: { 'text-align': 'right' },
        cellRenderer: function (params) {
          return $filter('date')(params.value, 'dd/MM/yyyy');
        }
      },
      {
        field: "invoiceSerie.invoiceSerieType.invoiceSerieTypeName",
        headerName: 'SERIES.INVOICE_SERIE_TYPE',
        headerCellRenderer: getHeader,
        width: 180
      },
      {
        field: "invoiceSerie.initialNumber",
        headerName: 'SERIES.INITIAL_NUMBER',
        headerCellRenderer: getHeader,
        width: 180,
        cellStyle: { 'text-align': 'right' }
      },
      {
        field: "invoiceSerie.lastNumber",
        headerName: 'SERIES.LAST_NUMBER',
        headerCellRenderer: getHeader,
        width: 180,
        cellStyle: { 'text-align': 'right' }
      },
      {
        field: "active",
        headerName: 'general.active',
        headerCellRenderer: getHeader,
        width: 60,
        pinned: 'right',
        cellRenderer: function (params) {
          if (params.value) {
            return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
          } else {
            return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
          }
        },
        cellStyle: { 'padding': '5px' }
      },
      {
        field: 'invoiceSerie.printDocument',
        headerName: 'COMPANY.INVOICE_SERIE.PRINT_DOCUMENT',
        headerCellRenderer: getHeader,
        width: 150,
        cellRenderer: function (params) {
          if (params.value) {
            return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
          } else {
            return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
          }
        },
        cellStyle: { 'padding': '6px' },
      },
      {
        field: 'invoiceSerie.printFormatDocument',
        headerName: 'COMPANY.INVOICE_SERIE.PRINT_FORMAT_DOCUMENT',
        headerCellRenderer: getHeader,
        width: 240,
      },

    ];

    vm.grid = {
      paginationPageSize: vm.pagination.pageSize,
      rowSelection: 'multiple',
      rowDeselection: true,
      rowModelType: "enterprise",
      cacheBlockSize: vm.pagination.pageSize,
      pagination: true,
      columnDefs: columnDefs,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowHeight: 40,
      enableColResize: true,
      rowData: [],
      getMainMenuItems: function (params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function (key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      }
    };

    function createNewDatasource() {


      var dataSource = {
        paginationPageSize: vm.pagination.pageSize,
        getRows: function (params) {

          vm.pagination.page = params.request.endRow / vm.pagination.pageSize;
          vm.isShowProgressLinear = true;
          var promise;
          if (vm.validateSwitch === true) {
            promise = api.PosAdminWS.CashierInvoiceSerie.byCompanyInactive.page({
              'companyId': $rootScope.bsCircle.company.id, 'pageNumber': vm.pagination.page, 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
            }).$promise;
          } else {
            promise = api.PosAdminWS.CashierInvoiceSerie.byCompany.page({
              'companyId': $rootScope.bsCircle.company.id, 'pageNumber': vm.pagination.page, 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
            }).$promise;
          }
          promise.then(function (response) {
            vm.isShowProgressLinear = false;
            vm.pagination.totalElements = response.totalElements;
            vm.pagination.totalPages = response.totalPages;
            vm.data = response.content;

            response.content.forEach(function(row) {
              row.invoiceSerie.invoiceSerieDocumentTypeName = vm.invoiceSerieDocumentTypes[row.invoiceSerie.invoiceSerieDocumentType];
            });

            params.successCallback(response.content, response.totalElements);
            vm.showGrid = true;
          }, function (response) {
            $log.error(response);
          });
        }
      };
      vm.grid.api.setEnterpriseDatasource(dataSource);
      vm.showDataSource = dataSource;
      validateColumnEdit();

    }

    function validateColumnEdit() {
      if (vm.validateSwitch) {
        vm.grid.api.setColumnDefs(columnDefs);
        return;
      }
      const columnDefsWithEdit = angular.copy(columnDefs);

      columnDefsWithEdit.push({
        name: "edit",
        headerName: 'general.edit',
        headerCellRenderer: getHeader,
        width: 175,
        pinned: 'right',
        hide: vm.validateSwitch,
        cellRenderer: function () {
          if (vm.validateSwitch === false) {
            return '<center> ' +
              '<div layout="row" flex><div flex><md-button class="md-icon-button" ng-click="vm.addInvoiceSerieDialog(data)">' +
              ' <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip>' +
              ' </md-button></div>' +
              '<div flex><md-button class="md-icon-button" ng-click="vm.onDelete(data)" ng-if="data.active">' +
              ' <md-icon md-font-icon="icon-trash" class="s16 md-warn"></md-icon> <md-tooltip md-direction="left">{{"general.deactive"| translate}}</md-tooltip>' +
              ' </md-button></div>' +
              ' </div></center>';
          }
        },
        cellStyle: { 'padding': '2px' }
      });
      vm.grid.api.setColumnDefs(columnDefsWithEdit);
    }

    function search() {
      vm.showSearch = true;
      createNewDatasource();
    }

    function init() {
      getInvoiceSeriesDocumentCountryList();
    }

    function getInvoiceSeriesDocumentCountryList() {
      api.GeneralWS.InvoiceSeriesDocumentCountry.getList.getByCountry({ countryId: $rootScope.bsCircle.company.country.id }).$promise.then(function (data) {
          vm.invoiceSerieDocumentTypes = {};
          data.forEach(function(documentType) {
              vm.invoiceSerieDocumentTypes[documentType.invoiceSeriesDocumentTypeId] = documentType.invoiceSeriesDocumentTypeDescription;
          });
          createNewDatasource();
      }, function (errResponse) {
          $log.error(errResponse);
          createNewDatasource();
      });
    }

    function serieDesactivate() {
      vm.inputSearch = '';
      createNewDatasource();
    }

    function addInvoiceSerieDialog(data) {
      vm.invoiceSerie = {};
      $mdDialog.show({
        controller: 'InvoiceSerieAdminDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/apps/company/admin-series/establishment-cashier-list/dialogSeries/invoiceSerieDialog.html',
        parent: angular.element("#main"),
        locals: {
          data: angular.copy(data)
        },
        clickOutsideToClose: false
      }).then(function (answer) {

        $timeout(function () {
          createNewDatasource();
        }, 1000);
      }, function () {

      });
    }

    function onDeactive(data) {
      var confirm = $mdDialog.confirm()
        .title($filter('translate')('general.deactive'))
        .content($filter('translate')('COMPANY.DEACTIVATE_SERIE'))
        .ariaLabel('Deactive Serie')
        .ok($filter('translate')('general.deactive'))
        .cancel($filter('translate')('general.cancel'));

      $mdDialog.show(confirm).then(function () {
        api.PosAdminWS.CashierInvoiceSerie.doDeactiveSerie.put({ 'id': data.id }, null, function () {
          MessageService.show($filter('translate')('COMPANY.SERIE_DEACTIVATED'));
          createNewDatasource();
        });
      }, function (err) {
        data.active = true;
      });
    }

    function onDelete(data) {
      var confirm = $mdDialog.confirm()
        .title($filter('translate')('general.deactive'))
        .content($filter('translate')('COMPANY.DEACTIVATE_SERIE'))
        .ariaLabel('deactive Serie')
        .ok($filter('translate')('general.deactive'))
        .cancel($filter('translate')('general.cancel'));

      $mdDialog.show(confirm).then(function () {
        api.PosAdminWS.CashierInvoiceSerie.doDeleteSerie.put({ 'id': data.id }, null, function () {
          MessageService.show($filter('translate')('COMPANY.SERIE_DEACTIVATED'));
          createNewDatasource();
        });
      }, function (err) {
        data.active = true;
      });
    }

    $timeout(function () {
      init();
    }, 1000);

  }
})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('RolDimensionDefaultController', RolDimensionDefaultController);

    /**@ngInject**/
    function RolDimensionDefaultController(api, $log, $filter, $rootScope, $timeout) {

        const vm = this;

        const NUMBER_ONE_HUNDRED = 100;
        const NUMBER_THREE_HUNDRED = 300;

        vm.loading = false;
        vm.loadingRoleApplication = false;
        vm.loadingDimensions = false;
        vm.load = false;
        vm.loadAssociated = false;

        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];
        vm.countSelected = 0;
        vm.countAssociatedSelected = 0;

        vm.dimensionsDefault = [];
        vm.noDimensionsDefault = [];
        vm.roleApplications = [];
        vm.dimensions = [
            {
                id: 1,
                name: 'COST_CENTER',
                value: 'Centro de Costo'
            },
            {
                id: 2,
                name: 'DEPARTMENT',
                value: 'Departamento'
            },
        ];

        vm.getDimensionsDefault = getDimensionsDefault;
        vm.selectAllNoDimensions = selectAllNoDimensions;
        vm.toggle = toggle;
        vm.selectAllDimensionsDefault = selectAllDimensionsDefault;
        vm.toggleDefaults = toggleDefaults;
        vm.isSelected = isSelected;
        vm.isSelectedAssociated = isSelectedAssociated;

        vm.associate = associate;
        vm.disassociate = disassociate;

        vm.searchDimensions = searchDimensions;
        vm.searchDefaults = searchDefaults;

        vm.pagination = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            getPage: function (pageNumber) {
                getPage(pageNumber);
            }
        };

        vm.paginationDefaults = {
            pageNumber: 1,
            pageSize: 50,
            totalElements: 0,
            getPage: function (pageNumber) {
                getPageDefault(pageNumber);
            }
        }

        init();
        function init() {
            $timeout(function () {
                let contentHeight = $("#e-commerce-order").innerHeight();
                contentHeight -= NUMBER_THREE_HUNDRED;
                vm.dinamicHeight = { "height": contentHeight + "px" };
            }, NUMBER_ONE_HUNDRED);

            getDimensions();
            getRoleApplications();
        }

        function getDimensions() {
            vm.loading = true;
            vm.loadingDimensions = true;
            api.GeneralWS.DimensionCompany.byCompanyActive.query({
                'company': $rootScope.bsCircle.company.id,
            }).$promise.then(function (resp) {
                resp.forEach(function (row) {
                    const dimension = {
                        id: row.dimensionNumber,
                        name: 'DIMENSION_' + row.dimensionNumber,
                        value: 'Dimension' + row.dimensionNumber
                    }
                    vm.dimensions.push(dimension);
                });
                vm.dimensions = $filter('orderBy')(vm.dimensions, 'id');
                vm.loadingDimensions = false;
            }, function (err) {
                vm.loading = false;
                vm.loadingDimensions = false;
                $log.error(err);
            });
        }

        function getRoleApplications() {
            vm.loadingRoleApplication = true;
            api.GeneralWS.CompanyApplication.companyRoleApplication.query({
                'companyId': $rootScope.bsCircle.company.id,
            }).$promise.then(function (resp) {
                vm.roleApplications = resp;
                vm.loading = false;
                vm.loadingRoleApplication = false;
            }, function (err) {
                vm.loadingRoleApplication = false;
                vm.loading = false;
                $log.error(err);
            });
        }

        function getDimensionsDefault() {
            if (vm.default.roleApplicationId != null && vm.default.dimensionNumber != null) {
                vm.selectedArray = [];
                vm.selectedAssociatedArray = [];
                vm.countSelected = 0;
                vm.countAssociatedSelected = 0;
                vm.partialArray = [];
                vm.partialDefaultArray = [];
                vm.dimensionsDefault = [];
                vm.noDimensionsDefault = [];
                vm.pagination.totalElements = 0;
                vm.paginationDefaults.totalElements = 0;
                vm.loadAssociated = true;
                vm.loading = true;
                getDimensionData();
            }
        }

        function getDimensionData() {
            vm.noDimensionsDefault = [];
            vm.dimensionsDefault = [];
            switch (vm.default.dimensionNumber.name) {
                case 'DEPARTMENT':
                    getDepartments();
                    break;
                case 'DIMENSION_3':
                case 'DIMENSION_4':
                case 'DIMENSION_5':
                    getDimensionDetails(vm.default.dimensionNumber.id);
                    break;
                default:
                    getCostCenters();
                    break;
            }
        }

        function getDepartments() {
            vm.load = true;
            api.GeneralWS.departments.getByCompany({ 'companyId': $rootScope.bsCircle.company.id })
                .$promise.then(function (departments) {
                    vm.noDimensionsDefault = departments;
                    getPagesByGeneralData();
                    getDefaults();
                }, function (err) {
                    $log.error(err);
                    vm.load = false;
                });
        }

        function getCostCenters() {
            vm.load = true;
            api.GeneralWS.costCenters.getByCompany({ 'companyId': $rootScope.bsCircle.company.id })
                .$promise.then(function (costCenters) {
                    vm.noDimensionsDefault = costCenters;
                    getPagesByGeneralData();
                    getDefaults();
                }, function (err) {
                    $log.error(err);
                    vm.load = false;
                });

        }

        function getDimensionDetails(number) {
            vm.load = true;
            vm.noDimensionsDefault = [];
            api.GeneralWS.dimensionDetails.getByCompany({ 'companyId': $rootScope.bsCircle.company.id, 'number': number })
                .$promise.then(function (details) {
                    vm.noDimensionsDefault = details;
                    getPagesByGeneralData();
                    getDefaults();
                }, function (err) {
                    $log.error(err);
                    vm.load = false;
                });
        }

        function getPagesByGeneralData() {
            vm.pagedDatas = [];
            let i = 0;
            vm.pagination.totalElements = vm.noDimensionsDefault.length;
            while (i < vm.pagination.totalElements) {
                vm.pagedDatas.push(vm.noDimensionsDefault.slice(i, i += vm.pagination.pageSize));
            }
            getPage(1);
        }

        function getPage(page) {
            vm.partialArray = vm.pagedDatas[page - 1];
        }

        function searchDimensions() {
            if (vm.searchDimension === '') {
                getPage(vm.pagination.pageNumber);
            } else {
                vm.partialArray = vm.noDimensionsDefault.filter(function (o) {
                    o.filter = o.code + ' ' + (o.description && o.description !== null ? o.description : o.name);
                    return o.filter.toLowerCase().includes(vm.searchDimension.toLowerCase());
                });
            }
        }

        function getDefaults() {
            vm.dimensionsDefault = [];
            api.baseUrlAccountCatalogWS.CompanyRolDimensionDefault.getList.query({
                'companyId': $rootScope.bsCircle.company.id,
                'roleApplicationId': vm.default.roleApplicationId,
                'dimensionNumber': vm.default.dimensionNumber.name
            })
                .$promise.then(function (response) {
                    vm.noDimensionsDefault.forEach(function (data) {
                        const exist = _.find(response, function (res) {
                            return data.id === res.dimensionValueId;
                        });
                        if (exist) {
                            data.associated = true;
                            const dimensionDefault = {
                                id: exist.id,
                                companyId: exist.companyId,
                                roleApplicationId: exist.roleApplicationId,
                                dimensionValueId: exist.dimensionValueId,
                                dimensionNumber: exist.dimensionNumber,
                                code: data.code,
                                description: data.description ? data.description : data.name
                            };

                            vm.dimensionsDefault.push(dimensionDefault);
                        } else {
                            data.associated = false;
                        }

                        getPagesByGeneralDefaults();
                    });
                    vm.loadAssociated = false;
                    vm.load = false;
                    vm.loading = false;
                }, function (err) {
                    vm.loadAssociated = false;
                    vm.loading = false;
                    vm.load = false;
                    $log.error(err);
                });
        }

        function getPagesByGeneralDefaults() {
            vm.pagedDefaults = [];
            let i = 0;
            vm.paginationDefaults.totalElements = vm.dimensionsDefault.length;
            while (i < vm.paginationDefaults.totalElements) {
                vm.pagedDefaults.push(vm.dimensionsDefault.slice(i, i += vm.paginationDefaults.pageSize));
            }
            getPageDefault(1);
        }

        function getPageDefault(page) {
            vm.partialDefaultArray = vm.pagedDefaults[page - 1];
        }

        function searchDefaults() {
            if (vm.searchDefault === '') {
                getPageDefault(vm.paginationDefaults.pageNumber);
            } else {
                vm.partialDefaultArray = vm.dimensionsDefault.filter(function (o) {
                    o.filter = o.code + ' ' + (o.description && o.description !== null ? o.description : o.name);
                    return o.filter.toLowerCase().includes(vm.searchDefault.toLowerCase());
                });
            }
        }

        function selectAllNoDimensions() {
            if (vm.allNoDimensions) {
                vm.noDimensionsDefault.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.push(row);
                    }
                });

                vm.countSelected = vm.noDimensionsDefault.length;

            } else {
                vm.noDimensionsDefault.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedArray.indexOf(row) > -1) {
                        vm.selectedArray.splice(vm.selectedArray.indexOf(row), 1);
                    }
                });

                vm.countSelected = 0;

            }
        }

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }

            if (vm.selectedArray.length === vm.noDimensionsDefault.length) {
                vm.allNoDimensions = true;
            } else {
                vm.allNoDimensions = false;
            }

        }

        function selectAllDimensionsDefault() {
            if (vm.allDimensions) {
                vm.dimensionsDefault.forEach(function (row) {
                    row.isCheck = true;

                    if (!vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.push(row);
                    }

                    vm.countAssociatedSelected = vm.dimensionsDefault.length;
                });
            } else {
                vm.dimensionsDefault.forEach(function (row) {
                    row.isCheck = false;

                    if (vm.selectedAssociatedArray.indexOf(row) > -1) {
                        vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(row), 1);
                    }
                });

                vm.countAssociatedSelected = 0;
            }

        }

        function toggleDefaults(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }

            if (vm.selectedAssociatedArray.length === vm.dimensionsDefault.length) {
                vm.allDimensions = true;
            } else {
                vm.allDimensions = false;
            }

        }

        function associate() {
            vm.loading = true;
            const dimensions = [];

            vm.selectedArray.forEach(function (row) {
                const dimension = {
                    companyId: $rootScope.bsCircle.company.id,
                    roleApplicationId: vm.default.roleApplicationId,
                    dimensionValueId: row.id,
                    dimensionNumber: vm.default.dimensionNumber.id
                }
                dimensions.push(dimension);
            });
            api.baseUrlAccountCatalogWS.CompanyRolDimensionDefault.fromList.create({}, dimensions)
                .$promise.then(function () {
                    vm.selectedArray.forEach(function (row) {
                        const dimension = _.find(vm.noDimensionsDefault, function (res) {
                            return row.id === res.id;
                        });
                        dimension.associated = true;
                    });

                    getDefaults();

                    vm.selectedArray = [];
                    vm.allNoDimensions = false;
                    vm.countSelected = 0;
                    vm.loading = false;
                }, function (exception) {
                    vm.loading = false;
                    $log.error(exception);
                });
        }

        function disassociate() {
            vm.loading = true;
            const dimensionIds = [];

            vm.selectedAssociatedArray.forEach(function (row) {
                dimensionIds.push(row.id);
            });
            api.baseUrlAccountCatalogWS.CompanyRolDimensionDefault.fromList.delete({}, dimensionIds)
                .$promise.then(function () {
                    vm.selectedAssociatedArray.forEach(function (row) {
                        const dimension = _.find(vm.noDimensionsDefault, function (res) {
                            return row.dimensionValueId === res.id;
                        });
                        dimension.associated = false;

                        vm.dimensionsDefault.splice(vm.dimensionsDefault.indexOf(row), 1);
                    })
                    vm.loading = false;

                    getPagesByGeneralDefaults();

                    vm.selectedAssociatedArray = [];
                    vm.countAssociatedSelected = 0;
                    vm.allDimensions = false;
                }, function (exception) {
                    vm.loading = false;
                    $log.error(exception);
                });
        }

        function isSelected(data) {
            return vm.selectedArray.indexOf(data) > -1;
        }

        function isSelectedAssociated(data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        }

        vm.clearSearchRoleInput = function () {
            vm.searchRoleInput = '';
        }

        vm.clearSearchDimensionInput = function () {
            vm.searchDimensionInput = '';
        }

        $timeout(function () {
            const keyEvent = function (event) {
                event.stopPropagation();
            };

            const searchRoleInput = document.querySelector("#searchRoleInput");
            const searchDimensionInput = document.querySelector("#searchDimensionInput");

            if (searchRoleInput) {
                searchRoleInput.addEventListener("keydown", keyEvent);
            }

            if (searchDimensionInput) {
                searchDimensionInput.addEventListener("keydown", keyEvent);
            }


        }, NUMBER_ONE_HUNDRED);
    }
})();
(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('PostingPeriodListController', PostingPeriodListController);

    /**@ngInject**/
    function PostingPeriodListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log, $scope) {
        const vm = this;
        const TIMEOUT_EONE_THOUSAND = 1000;

        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.postingPeriods = [];

        const colDefs = [
            {
                field: 'periodCode',
                headerName: 'postingPeriod.code',
                headerCellRenderer: getHeader,
                width: 150,
            },
            {
                field: 'periodName',
                headerName: 'postingPeriod.name',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'periodStartDate',
                headerName: 'postingPeriod.startDate',
                headerCellRenderer: getHeader,
                width: 125,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
            },
            {
                field: 'periodEndDate',
                headerName: 'postingPeriod.endDate',
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                width: 125,
            },
            {
                field: 'locked',
                headerName: 'postingPeriod.locked',
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon></center>';
                    } else {
                        return '<center><md-icon md-font-icon="icon-cancel red-500-fg"></md-icon></center>';
                    }
                },
                cellStyle: { 'padding': '5px' },
                headerCellRenderer: getHeader,
                width: 125,
            },
            {
                field: 'active',
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                width: 70,
                cellStyle: { 'padding': '5px' },
            },
            {
                name: 'edit',
                headerName: 'postingPeriod.options',
                cellStyle: { 'padding': '2px' },
                pinned: 'right',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function () {
                    return '<div layout="row" layout-align="space-between"> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onDelete(data)" ng-if="data.active"> '
                        + ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + '</div>';
                },
            },
        ];

        vm.grid = {
            columnDefs: colDefs,
            rowSelection: 'multiple',
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            doesDataFlower: function () {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresentFunc,
            doesExternalFilterPass: doesExternalFilterPassFunc,
        };

        const filter = 'everyone';
        function isExternalFilterPresentFunc() {
            return filter !== '';
        }

        function doesExternalFilterPassFunc(node) {
            if (filter && filter !== 'everyone') {
                const arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function getPostingPeriods() {
            vm.showGrid = false;
            vm.isShowProgressLinearGrid = true;
            api.baseUrlAccountCatalogWS.PostingPeriod.byCompany.get({
                'companyId': $rootScope.bsCircle.company.id,
            })
                .$promise.then(function (response) {
                    const newData = new jinqJs()
                        .from(response)
                        .orderBy('id')
                        .select(function (d) {
                            d.filter = (d.id + ',' + d.periodCode + ',' + d.periodName + ','
                                + d.periodStartDate + ',' + d.periodEndDate).toLowerCase();
                            return d;
                        });

                    vm.grid.api.setRowData(newData);
                    vm.postingPeriods = newData;
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                }, function (response) {
                    vm.grid.api.setRowData([]);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                    $log.error(response);
                });
        }

        function init() {
            getPostingPeriods();
        }

        function edit(data) {
            let isNew = false;
            if (data) {
                data.companyId = { id: $rootScope.bsCircle.company.id };
            } else {
                isNew = true;
                data = {
                    companyId: {
                        id: $rootScope.bsCircle.company.id,
                    },
                };
            }

            $mdDialog.show({
                controller: 'PostingPeriodController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/posting-period/posting-period/posting-period.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'postingPeriod': angular.copy(data),
                },
            }).then(function (answer) {
                if (isNew) {
                    vm.postingPeriods.push(answer);
                    MessageService.show($filter('translate')('postingPeriod.added'));
                } else {
                    const i = vm.postingPeriods.indexOf(data);
                    vm.postingPeriods[i] = answer;
                    MessageService.show($filter('translate')('postingPeriod.updated'));
                }
                vm.grid.api.setRowData(vm.postingPeriods);
                vm.grid.api.redrawRows();
            }, function () {
                // Empty
            });
        }

        function onDelete(data) {
            const confirm = $mdDialog.confirm()
                .title($filter('translate')('postingPeriod.deactivatePostingPeriod'))
                .textContent($filter('translate')('postingPeriod.deactivateConfirm'))
                .ariaLabel($filter('translate')('postingPeriod.deactivatePostingPeriod'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.baseUrlAccountCatalogWS.PostingPeriod.byCompany.delete({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': data.id,
                }).$promise.then(function () {
                    const i = vm.postingPeriods.indexOf(data);
                    data.active = false;
                    vm.postingPeriods[i] = data;
                    vm.isShowProgressLinear = false;
                    vm.grid.api.setRowData(vm.postingPeriods);
                    vm.grid.api.redrawRows();
                    MessageService.show($filter('translate')('postingPeriod.deleted'));
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
            }, function () {
                // Empty
            });
        }

        $timeout(function () {
            init();
        }, TIMEOUT_EONE_THOUSAND);

        $scope.$watch('vm.inputSearch', function () {
            if (vm.grid.api) {
                vm.grid.api.setRowData($filter('filter')(vm.postingPeriods, vm.inputSearch));
            }
        });

    }
})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('PostingPeriodController', PostingPeriodController);

    /**@ngInject**/
    function PostingPeriodController($mdDialog, api, postingPeriod, $log, MessageService, $filter, $rootScope) {

        const vm = this;
        const EXCEPTION_STATUS_ALREADY_EXISTS = 409;
        const TIME_SIXTY = 60;
        const TIME_ONE_THOUSAND = 1000;

        vm.postingPeriod = postingPeriod;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        if (vm.postingPeriod.id) {
            const startDate = new Date(vm.postingPeriod.periodStartDate);
            const endDate = new Date(vm.postingPeriod.periodEndDate);
            vm.postingPeriod.periodStartDate = new Date(startDate.setTime(startDate.getTime() + startDate.getTimezoneOffset() * TIME_SIXTY * TIME_ONE_THOUSAND));
            vm.postingPeriod.periodEndDate = new Date(endDate.setTime(endDate.getTime() + endDate.getTimezoneOffset() * TIME_SIXTY * TIME_ONE_THOUSAND));
            vm.postingPeriod.companyId = $rootScope.bsCircle.company.id;
        }

        function save() {
            vm.isShowProgressLinear = true;
            let promise;
            if (vm.postingPeriod) {
                vm.postingPeriod.companyId = $rootScope.bsCircle.company.id;
            }

            let activeP = angular.copy(vm.postingPeriod.active);
            let lockedP = angular.copy(vm.postingPeriod.locked);
            if (vm.postingPeriod.active === undefined) {
                activeP = true;
            }
            if (vm.postingPeriod.locked === undefined) {
                lockedP = false;
            }

            const currentPostingPeriod = {
                companyId: vm.postingPeriod.companyId,
                periodCode: vm.postingPeriod.periodCode,
                periodName: vm.postingPeriod.periodName,
                periodStartDate: vm.postingPeriod.periodStartDate,
                periodEndDate: vm.postingPeriod.periodEndDate,
                locked: lockedP,
                active: activeP,
            };

            if (vm.postingPeriod.id) {
                promise = api.baseUrlAccountCatalogWS.PostingPeriod.byCompany.update({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': vm.postingPeriod.id,
                }, vm.postingPeriod).$promise;
            } else {
                promise = api.baseUrlAccountCatalogWS.PostingPeriod.byCompany.create({
                    'companyId': $rootScope.bsCircle.company.id,
                    'id': undefined,
                }, vm.postingPeriod).$promise;
            }
            promise.then(function (response) {
                currentPostingPeriod.id = response.$data;
                const filter = (currentPostingPeriod.id + ',' + currentPostingPeriod.periodCode + ',' + currentPostingPeriod.periodName + ','
                    + currentPostingPeriod.periodStartDate + ',' + currentPostingPeriod.periodEndDate).toLowerCase();
                currentPostingPeriod.filter = filter;
                vm.isShowProgressLinear = false;
                $mdDialog.hide(currentPostingPeriod);
            }, function (exception) {
                if (exception && exception.status === EXCEPTION_STATUS_ALREADY_EXISTS) {
                    MessageService.showErrorMessage($filter('translate')('postingPeriod.alreadyExists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('postingPeriod.error'));
                }
                vm.isShowProgressLinear = false;
                $log.error(exception);
            });
            return true;
        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('ProjectController', ProjectController);

    /**@ngInject**/
    function ProjectController($mdDialog, api, project, $log, MessageService, $filter, $rootScope) {

        var vm = this;

        vm.project = project;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        if (vm.project) {
            if (vm.project.startDate) {
                vm.project.startDate = new Date(vm.project.startDate);
            }
            if (vm.project.endDate) {
                vm.project.endDate = new Date(vm.project.endDate);
            }

            vm.project.companyId = $rootScope.bsCircle.company.id;

        }


        function save() {

            if (vm.projectForm.$invalid) {
                return false;
            }

            var promise;
            var isNew = false;

            if (vm.project) {
                if (vm.project.startDate) {
                    vm.project.startDate = new Date(vm.project.startDate).toISOString().slice(0, 10);
                }
                if (vm.project.endDate) {
                    vm.project.endDate = new Date(vm.project.endDate).toISOString().slice(0, 10);
                }

                vm.project.companyId = $rootScope.bsCircle.company.id;

            }

            if (vm.project.id) {
                promise = api.ProyectosWS.Proyectos.byCompany.update({ 'companyId': $rootScope.bsCircle.company.id, 'id': vm.project.id }, vm.project).$promise;
            } else {
                isNew = true;
                promise = api.ProyectosWS.Proyectos.byCompany.create({ 'companyId': vm.project.companyId, 'id': undefined }, vm.project).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                if (isNew) {
                    MessageService.show($filter('translate')('projects.updated_successfully'));
                } else {
                    MessageService.show($filter('translate')('projects.created_successfully'));
                }

                $mdDialog.hide(response);

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.show($filter('translate')('projects.error'));


            });
            return true;
        }

        function cancel() {
            $mdDialog.cancel();
        }



    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('ProjectsListController', ProjectsListController);

    /**@ngInject**/
    function ProjectsListController(api, $timeout, $log, $rootScope, $mdDialog, $filter, MessageService, $scope) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.totalRow = 0;

        vm.pagination = {
            page: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "code",
                headerName: 'projects.prjCode',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "name",
                headerName: 'projects.prjName',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "startDate",
                headerName: 'company_establishment.start_date',
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                width: 150
            },
            {
                field: "endDate",
                headerName: 'company_establishment.end_date',
                headerCellRenderer: getHeader,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                },
                width: 150
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: function (params) {
                    return '<div style="width: 100%;"><md-button class="md-icon-button" ng-click="vm.edit(data)"> ' +
                        '<md-icon md-font-icon="icon-border-color" class="s18"></md-icon> <md-tooltip md-direction="left">' +
                        '{{"general.edit"| translate}}</md-tooltip> </md-button><md-button class="md-icon-button" ng-click="vm.onDelete(data)">' +
                        ' <md-icon class="s18 md-warn" md-font-icon="icon-trash"></md-icon> ' +
                        '<md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip> </md-button></div>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            columnDefs: columnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 54,
            rowHeight: 44,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';
        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        function createNewDatasource() {
            vm.isShowProgressLinear = true;
            api.ProyectosWS.Proyectos.byCompany.get({ 'companyId': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                vm.gridData = response;

                vm.grid.api.setColumnDefs(columnDefs);
                vm.grid.api.setRowData(new jinqJs()
                    .from(response)
                    .orderBy('id')
                    .select(function (d) {
                        d.filter = (d.id + "," + d.code + "," + d.name + "," + d.startDate + "," + d.endDate).toLowerCase();
                        return d;
                    }));
                vm.totalRow = response.length;
                vm.showGrid = true;

            }, function (response) {
                $log.error(response);
            });
        }


        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'ProjectController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/projects/projects/projects.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'project': {
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                }
            }, function () {

            });
        }

        function edit(project) {
            $mdDialog.show({
                controller: 'ProjectController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/projects/projects/projects.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'project': angular.copy(project)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });
                    createNewDatasource();
                }
            }, function () {
            });
        }

        function onDelete(project) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('projects.delete_project') + '?')
                .ariaLabel($filter('translate')('projects.deleted_project'))
                .ok('Si')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.ProyectosWS.Proyectos.byCompany.delete({ 'companyId': $rootScope.bsCircle.company.id, 'id': project.id }).$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    MessageService.show($filter('translate')('projects.deleted_successfully'));

                    createNewDatasource();

                }, function (response) {
                    vm.isShowProgressLinear = false;
                });
            }, function () {

            });
        }

        $timeout(function () {
            init();
        }, 1000);

        $scope.$watch('vm.search', function (newValue) {
            if (vm.grid.api) {
                vm.grid.api.setRowData($filter('filter')(vm.gridData, vm.search));
            }
        });

    }

})();

(function () {

    'use strict';

    angular
            .module('app.account')
            .controller('ExpenseTypeController', expenseTypeController);

    /**@ngInject**/
    function expenseTypeController(api, MessageService, $log, expensetype, $filter, $mdDialog) {

        var vm = this;

        vm.expensetype = expensetype;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (vm.expensetypeForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.expensetype.id) {
                promise = api.GeneralWS.Account.ExpenseType.me.update({'company': vm.expensetype.company.id, 'id': vm.expensetype.id}, vm.expensetype).$promise;
            } else {
                promise = api.GeneralWS.Account.ExpenseType.me.create({'company': vm.expensetype.company.id, 'id': undefined}, vm.expensetype).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('expensetype.expensetype_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountingCatalogController', AccountingCatalogController);

    /**@ngInject**/
    function AccountingCatalogController($mdDialog, api, account, $log, MessageService, $filter, expenseType) {

        var vm = this;

        vm.expenseType = expenseType;
        vm.account = account;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (!vm.confirmDeactivate && vm.accountForm.$invalid) {
                MessageService.show($filter('translate')('general.completeInfo'));
                return false;
            }

            if (!vm.account.active && !vm.confirmDeactivate) {
                vm.confirmDeactivate = true;
            } else {
                updateData();
            }

        }

        function cancel() {
            $mdDialog.cancel();
        }

        function updateData() {
            var promise;

            if (vm.account.id) {
                promise = api.GeneralWS.Account.AccountingCatalog.me.update({ 'company': vm.account.company.id, 'id': vm.account.id }, vm.account).$promise;
            } else {
                promise = api.GeneralWS.Account.AccountingCatalog.me.create({ 'company': vm.account.company.id, 'id': undefined }, vm.account).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('accountingCatalog.exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('ExpenseTypeListController', expenseTypeListController);

    /**@ngInject**/
    function expenseTypeListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;

        vm.pagination = {
            page: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "description",
                headerName: 'costcenter.description',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        function createNewDatasource() {

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.Account.ExpenseType.me.page({
                        'company': $rootScope.bsCircle.company.id, 'page': (vm.pagination.page), 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;

                            params.successCallback(response.content, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);

        }

        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'ExpenseTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/expense-type/expense-type/expense-type.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'expensetype': {
                        'description': '',
                        'active': true,
                        'company': $rootScope.bsCircle.company
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                    MessageService.show($filter('translate')('expensetype.expensetype_added'));
                }
            }, function () {

            });
        }

        function edit(expensetype) {
            $mdDialog.show({
                controller: 'ExpenseTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/expense-type/expense-type/expense-type.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'expensetype': angular.copy(expensetype)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });

                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('expensetype.expensetype_updated'));
                }
            }, function () {

            });
        }

        function onDelete(expensetype) {
            expensetype.active = false;

            var promise;
            promise = api.GeneralWS.Account.ExpenseType.me.update({ 'company': expensetype.company.id, 'id': expensetype.id }, expensetype).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.grid.api.refreshView();
                        MessageService.show($filter('translate')('expensetype.expensetype_updated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('DimensionsCompanyListController', DimensionsCompanyListController);

    /**@ngInject**/
    function DimensionsCompanyListController($rootScope, $log, api, MessageService, $filter, $timeout, $state) {

        var vm = this;
        vm.getDimensionCompanies = getDimensionCompanies;
        vm.updateDimensionCompany = updateDimensionCompany;
        vm.viewDetail = viewDetail;

        var columnDefs = [
            {
                field: "dimensionCode",
                headerName: 'dimensions.code',
                headerCellRenderer: getHeader,
                width: 100
            },
            {
                field: "dimensionName",
                headerName: 'dimensions.name',
                headerCellRenderer: getHeader,
                width: 300
            },
            {
                field: "active",
                headerName: 'dimensions.enabled',
                headerCellRenderer: getHeader,
                width: 90,
                cellRenderer: function (params) {
                    return '<center><md-checkbox ng-model="data.active" ng-change="vm.updateDimensionCompany(data)" aria-label="chk"></md-checkbox></center>';
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                field: "required",
                headerName: 'dimensions.required',
                headerCellRenderer: getHeader,
                width: 90,
                cellRenderer: function () {
                    return '<center><md-checkbox ng-model="data.required" ng-change="vm.updateDimensionCompany(data)" aria-label="chk" ng-if="data.active"></md-checkbox></center>';
                },
                cellStyle: { 'padding': '5px' }
            },
          {
            field: 'enterInDetailInBudget',
            headerName: 'dimensions.enterInDetailInBudget',
            headerCellRenderer: getHeader,
            width: 270,
            cellRenderer: function () {
              return '<center><md-checkbox ng-model="data.enterInDetailInBudget" ' +
                'ng-change="vm.updateDimensionCompany(data)" aria-label="chk" ng-if="data.active"></md-checkbox></center>';
            },
            cellStyle: { 'padding': '5px' },
          },

            {
                field: "description",
                headerName: 'dimensions.description',
                headerCellRenderer: getHeader,
                width: 300,
                cellRenderer: function () {
                    return '<center><input id="dimensionDescription" autocomplete="off" ng-model="data.description" ng-enter="vm.updateDimensionCompany(data)" style="text-align: left" ng-if="data.active"/></center>';
                }
            },
            {
                field: "save",
                headerName: 'dimensions.save',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function () {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.updateDimensionCompany(data)' ng-if='data.active'> <md-icon md-font-icon='icon-content-save'></md-icon> <md-tooltip md-direction='left'>{{'dimensions.save'| translate}}</md-tooltip> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                field: "detail",
                headerName: 'dimensions.showDetail',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function () {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.viewDetail(data)" ng-if="data.active"> '
                        + ' <md-icon md-font-icon="icon-eye"></md-icon> <md-tooltip md-direction="left">{{"dimensions.showDetail"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowSelection: 'multiple',
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getNodeChildDetails: function (file) {
                if (file.folder && file.children.length > 0) {
                    return {
                        group: true,
                        children: file.children,
                        expanded: file.open
                    };
                } else {
                    return null;
                }
            }
        };

        function getDimensionCompanies() {
            vm.showGrid = false;
            vm.isShowProgressLinearGrid = true;
            api.GeneralWS.Account.DimensionCompany.allWithDimensionNotPresent
                .get({ 'companyId': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    response.sort(function (a, b) {
                        if (a.dimensionName < b.dimensionName) { return -1; }
                        if (a.dimensionName > b.dimensionName) { return 1; }
                        return 0;
                    });
                    vm.dimensionCompanies = angular.copy(response);
                    vm.grid.api.setRowData(response);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                }, function (response) {
                    vm.grid.api.setRowData([]);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                    $log.error(response);
                });
        }

        function updateDimensionCompany(data) {
            vm.isShowProgressLinear = true;

            if (data.id) {
                api.GeneralWS.Account.DimensionCompany.me.update({ 'id': data.id }, data).$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('dimensions.dimensionUpdatedSuccessfully'));
                    data.active = response.active;
                    data.required = response.required;
                    data.description = response.description;
                    var index = vm.dimensionCompanies.findIndex(function (row) {return row.id === data.id});
                    vm.dimensionCompanies[index] = response;
                }, function (response) {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    var dimensionCompany = vm.dimensionCompanies.find(function (row) { return row.id === data.id});
                    data.active = dimensionCompany.active;
                    data.required = dimensionCompany.required;
                    data.description = dimensionCompany.description;
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
                return;
            }

            data.companyId = $rootScope.bsCircle.company.id;
            api.GeneralWS.Account.DimensionCompany.me.create({}, data).$promise.then(function (response) {
                vm.isShowProgressLinear = false;
                MessageService.show($filter('translate')('dimensions.dimensionCreatedSuccessfully'));
                data.id = response.id;
                data.active = response.active;
                var index = vm.dimensionCompanies.findIndex(function (row) {
                    return row.dimensionBaseId === data.dimensionBaseId
                });
                vm.dimensionCompanies[index] = response;
            }, function (response) {
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
                data.active = false;
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function viewDetail(data) {
            $state.go('app.account.dimensions.detail', { id: data.id, dimensionName: data.dimensionName });
        }

        function init() {
            getDimensionCompanies();
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('CostCenterController', costCenterController);

    /**@ngInject**/
    function costCenterController($mdDialog, api, costcenter, $log, MessageService, $filter) {

        var vm = this;

        vm.costcenter = costcenter;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (vm.costcenterForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.costcenter.id) {
                promise = api.GeneralWS.CostCenter.update({ 'idc': vm.costcenter.company.id, 'idPath': vm.costcenter.id }, vm.costcenter).$promise;
            } else {
                promise = api.GeneralWS.CostCenter.create({ 'idc': vm.costcenter.company.id, 'idPath': undefined }, vm.costcenter).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('costcenter.costcenter_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.usr')
        .controller('DimensionCompanyDetailListController', DimensionCompanyDetailListController);

    /**@ngInject**/
    function DimensionCompanyDetailListController($rootScope, $log, api, MessageService, $filter, $timeout, $stateParams, $state, $mdDialog) {

        var vm = this;
        vm.getDimensionCompanyDetail = getDimensionCompanyDetail;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.back = back;
        vm.dimensionName = $stateParams.dimensionName;

        var columnDefs = [
            {
                field: "code",
                headerName: 'dimensions.code',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "name",
                headerName: 'dimensions.name',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function () {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <center>';
                },
                cellStyle: { 'padding': '2px' },
                pinned: 'right'
            },
            {
                name: "delete",
                headerName: 'general.delete',
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onDelete(data)"> '
                        + ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + '</center>';
                },
                cellStyle: { 'padding': '2px' },
                pinned: 'right'
            }
        ];

        vm.grid = {
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowSelection: 'multiple',
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getNodeChildDetails: function (file) {
                if (file.folder && file.children.length > 0) {
                    return {
                        group: true,
                        children: file.children,
                        expanded: file.open
                    };
                } else {
                    return null;
                }
            }
        };

        function getDimensionCompanyDetail() {
            vm.showGrid = false;
            vm.isShowProgressLinearGrid = true;
            api.GeneralWS.Account.DimensionCompanyDetail.allByDimensionCompany
                .get({ 'dimensionCompanyId': $stateParams.id }).$promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    vm.grid.api.setRowData(response);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                }, function (response) {
                    vm.grid.api.setRowData([]);
                    vm.showGrid = true;
                    vm.isShowProgressLinearGrid = false;
                    $log.error(response);
                });
        }

        function edit(data) {

            $mdDialog.show({
                controller: 'DimensionCompanyDetailEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/dimensions/dimension-company-detail-list/dialog-detail/dialog-detail.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'dimensionCompanyId': angular.copy($stateParams.id),
                    'dimensionDetail': angular.copy(data)
                }
            }).then(function (answer) {
                if(!answer) {
                    return;
                }
                if (data && data.id) {
                    MessageService.show($filter('translate')('dimensions.detailUpdated'));
                } else {
                    MessageService.show($filter('translate')('dimensions.detailAdded'));
                }
                getDimensionCompanyDetail();
            }, function () {

            });
        }

        function onDelete(data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('dimensions.deleteDimensionCompanyDetail') + '?')
                .ariaLabel($filter('translate')('dimensions.detail'))
                .ok('Si')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                var promise;
                promise = api.GeneralWS.Account.DimensionCompanyDetail.me.delete({ 'id': data.id }, {}).$promise;

                vm.isShowProgressLinear = true;
                promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    getDimensionCompanyDetail();
                    MessageService.show($filter('translate')('dimensions.detailDeleted'));
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
            });
        }


        function back() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo);
            } else {
                $state.go('app.account.dimensions');
            }
        }

        function init() {
            getDimensionCompanyDetail();
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('DepartmentListController', departmentListController);

    /**@ngInject**/
    function departmentListController($rootScope, $timeout, api, MessageService, $filter, $log, $mdDialog) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;
        vm.onUpdateCanReceiveTickets = onUpdateCanReceiveTickets;
        vm.onUpdateCloseTicketOnReceivePurchase = onUpdateCloseTicketOnReceivePurchase;
        vm.showSettings = showSettings;
        vm.showProductsAllowed = showProductsAllowed;
        vm.addRelatedDepartment = addRelatedDepartment;

        vm.pagination = {
            page: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "code",
                headerName: 'costcenter.code',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "description",
                headerName: 'costcenter.description',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "departmentParent.description",
                headerName: 'department.padre',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.Department.page({
                        'idc': $rootScope.bsCircle.company.id, 'page': (vm.pagination.page), 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;

                            params.successCallback(response.content, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);

        }

        function init() {

            vm.appTicketsActive = false;
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': $rootScope.bsCircle.company.id, 'app': 'Tickets' }).$promise.then(function (responseParameter) {
                if (responseParameter.$status === 200) {

                    if (responseParameter.$data && responseParameter.$data !== "") {
                        vm.appTicketsActive = responseParameter.$data.active;
                    }

                    columnDefs.push({
                        field: "canReceiveTickets",
                        headerName: 'department.canReceiveTickets',
                        headerCellRenderer: getHeader,
                        width: 125,
                        cellRenderer: function (params) {
                            if (params.value) {
                                return '<center> '
                                    + ' <md-checkbox ng-model="data.canReceiveTickets" ng-change="vm.onUpdateCanReceiveTickets(data)" aria-label="chk"></md-checkbox> '
                                    + ' </center>';
                            } else {
                                return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                            }
                        },
                        cellStyle: { 'padding': '5px' }
                    });
                    if (vm.appTicketsActive) {
                        columnDefs.push({
                            field: 'closeTicketOnReceivePurchase',
                            headerName: 'department.closeTicketOnReceivePurchase',
                            headerCellRenderer: getHeader,
                            width: 125,
                            cellRenderer: function (params) {
                                if (params.data.canReceiveTickets) {
                                    return '<center> '
                                        + ' <md-checkbox ng-model="data.closeTicketOnReceivePurchase" '
                                        + ' ng-change="vm.onUpdateCloseTicketOnReceivePurchase(data)" aria-label="chk"></md-checkbox> '
                                        + ' </center>';
                                } else {
                                    return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                                }
                            },
                            cellStyle: { 'padding': '5px' },
                        });
                        columnDefs.push({
                            name: "relatedDepartment",
                            headerName: 'department.add_department_related',
                            headerCellRenderer: getHeader,
                            width: 190,
                            cellRenderer: function (params) {
                                if (params.data && params.data.canReceiveTickets) {
                                    return '<center> '
                                        + ' <md-button class="md-icon-button" ng-click="vm.addRelatedDepartment(data)"> '
                                        + ' <md-icon md-font-icon="icon-view-list"></md-icon> <md-tooltip md-direction="left">{{"department.add_department_related"| translate}}</md-tooltip> '
                                        + ' </md-button> </center>';
                                } else {
                                    return '';
                                }
                            },
                            cellStyle: { 'padding': '2px' }
                        });

                        columnDefs.push({
                            name: "settings",
                            headerName: 'department.settings',
                            headerCellRenderer: getHeader,
                            width: 130,
                            cellRenderer: function (params) {
                                if (params.data && params.data.canReceiveTickets) {
                                    return '<center> '
                                        + ' <md-button class="md-icon-button" ng-click="vm.showSettings(data)"> '
                                        + ' <md-icon md-font-icon="icon-cog"></md-icon> <md-tooltip md-direction="left">{{"department.settings"| translate}}</md-tooltip> '
                                        + ' </md-button> </center>';
                                } else {
                                    return '';
                                }
                            },
                            cellStyle: { 'padding': '2px' }
                        });

                    }

                    columnDefs.push({
                        name: "showProductsAllowed",
                        headerName: 'department.products_allowed',
                        headerCellRenderer: getHeader,
                        width: 170,
                        cellRenderer: function (params) {
                            return '<center> '
                                + '  <md-button class="md-icon-button" ng-click="vm.showProductsAllowed(data)"> '
                                + ' <md-icon md-font-icon="icon-document"></md-icon> <md-tooltip md-direction="left">{{"department.products_allowed"| translate}}</md-tooltip> '
                                + ' </md-button> </center>';
                        },
                        cellStyle: { 'padding': '2px' }
                    });

                    columnDefs.push({
                        name: "edit",
                        headerName: 'general.edit',
                        headerCellRenderer: getHeader,
                        width: 70,
                        cellRenderer: function (params) {
                            return '<center> '
                                + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                                + ' <md-icon md-font-icon="icon-border-color"></md-icon> '
                                + ' <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                                + ' </md-button> </center>';
                        },
                        cellStyle: { 'padding': '2px' }
                    });

                    vm.grid.api.setColumnDefs(columnDefs);
                }

                createNewDatasource();

            }, function (response) {
                $log.error(response);
            });
        }

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'DepartmentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/department/department/department.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'department': {
                        'code': '',
                        'description': '',
                        'active': true,
                        'company': $rootScope.bsCircle.company
                    },
                    'appTicketsActive': vm.appTicketsActive
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                    MessageService.show($filter('translate')('department.department_added'));
                }
            }, function () {

            });
        }

        function edit(department) {
            $mdDialog.show({
                controller: 'DepartmentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/department/department/department.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'department': angular.copy(department),
                    'appTicketsActive': vm.appTicketsActive
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });

                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('department.department_updated'));
                }
            }, function () {

            });
        }

        function onDelete(department) {
            department.active = false;

            var promise;
            promise = api.GeneralWS.Department.update({ 'idc': department.company.id, 'idPath': department.id }, department).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.grid.api.refreshView();
                        MessageService.show($filter('translate')('department.department_updated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function onUpdateCloseTicketOnReceivePurchase(department) {
            onUpdateDepartment(department);
        }


        function onUpdateCanReceiveTickets(department) {
            department.canReceiveTickets = false;
            department.closeTicketOnReceivePurchase = false;
            onUpdateDepartment(department);
        }

        function onUpdateDepartment(department) {
            var promise;
            promise = api.GeneralWS.Department.update({ 'idc': department.company.id, 'idPath': department.id }, department).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.grid.api.refreshView();
                        MessageService.show($filter('translate')('department.department_updated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function showSettings(department) {
            $mdDialog.show({
                controller: 'DepartmentSettingsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/department/department/settings/settings.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'department': angular.copy(department)
                }
            }).then(function (response) {
                if (response) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === response.id) {
                            row.data.settings = response;
                        }
                    });
                    vm.grid.api.refreshView();
                    MessageService.show("general.register_updated_successfully");
                }
            }, function () {

            });
        }

        function showProductsAllowed(department) {
            $mdDialog.show({
                controller: 'DepartmentProductController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/department/department/products/department-product.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'department': angular.copy(department)
                }
            }).then(function (response) {
                if (response) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === response.id) {
                            row.data.settings = response;
                        }
                    });
                    vm.grid.api.refreshView();
                    MessageService.show("general.register_updated_successfully");
                }
            }, function () {

            });
        }

        function addRelatedDepartment(data) {
            $mdDialog.show({
                controller: 'DialogDepartmentRelatedController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/department/department-list/department-related/department-related.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'data': angular.copy(data)
                }
            }).then(function () {

            }, function () {

            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('DepartmentController', departmentController);

    /**@ngInject**/
    function departmentController($mdDialog, api, department, $log, MessageService, $filter, appTicketsActive, $timeout, $scope) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;

        vm.department = department;
        vm.appTicketsActive = appTicketsActive;

        vm.selectedFather = vm.department.departmentParent;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        vm.flipping = flipping;
        vm.newContact = true;
        vm.flip;
        vm.onEdit = onEdit;
        vm.selectFather = selectFather;
        vm.dinamicStyle = {
            'width': '50%',
            'height': '65%'
        };

        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }

        function onEdit() {
            vm.flip();

            changeFilter();

            $timeout(function () {
                document.getElementById("searchFather").focus();
            }, 600);
        }

        function getDepartments(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.Department.page({ 'idc': vm.department.company.id, idPath: 'isActive', page: page, pageSize: vm.pageSize, search: vm.filter },
                function (data) {
                    vm.departments = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function changeFilter() {
            getDepartments(1);
        }

        function selectFather(depto) {
            vm.searchMode = false;
            vm.selectedFather = depto;
            vm.department.departmentParent = depto;
            vm.flip();
        }


        function save() {

            if (vm.departmentForm.$invalid) {
                return false;
            }
            if(vm.department.canReceiveTickets === false){
                vm.department.closeTicketOnReceivePurchase = false;
            }

            var promise;

            if (vm.department.id) {
                promise = api.GeneralWS.Department.update({ 'idc': vm.department.company.id, 'idPath': vm.department.id }, vm.department).$promise;
            } else {
                promise = api.GeneralWS.Department.create({ 'idc': vm.department.company.id, 'idPath': undefined }, vm.department).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('department.department_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

        $scope.$watch('vm.filter', function (newVal) {
            changeFilter();
        });

        function init() {
            var contentHeight = $("#department").innerHeight();
            contentHeight -= 112;
            vm.dinamicHeight = { "height": contentHeight + "px" };

            var windowHeight = parseInt(window.innerHeight);

            if (windowHeight < 700) {
                vm.dinamicStyle.height = '100%';
            } else if (windowHeight < 800) {
                vm.dinamicStyle.height = '80%';
            }
        }

        init();

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('CostCenterListController', costCenterListController);

    /**@ngInject**/
    function costCenterListController(api, $timeout, $log, $rootScope, $mdDialog, $filter, MessageService) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;

        vm.pagination = {
            page: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "code",
                headerName: 'costcenter.code',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "description",
                headerName: 'costcenter.description',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> '
                        + ' <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            vm.grid.api.setColumnDefs(columnDefs);

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.CostCenter.page({
                        'idc': $rootScope.bsCircle.company.id,
                        'page': vm.pagination.page, 'pageSize': vm.pagination.pageSize,
                        'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;

                            params.successCallback(response.content, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });

                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);

        }

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'CostCenterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/cost-center/cost-center/cost-center.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'costcenter': {
                        'code': '',
                        'description': '',
                        'active': true,
                        'company': $rootScope.bsCircle.company
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                    MessageService.show($filter('translate')('costcenter.costcenter_added'));
                }
            }, function () {

            });
        }

        function edit(costcenter) {
            $mdDialog.show({
                controller: 'CostCenterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/cost-center/cost-center/cost-center.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'costcenter': angular.copy(costcenter)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });
                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('costcenter.costcenter_updated'));
                }
            }, function () {
            });
        }

        function onDelete(costcenter) {
            costcenter.active = false;

            var promise;
            promise = api.GeneralWS.CostCenter.update({ 'idc': costcenter.company.id, 'idPath': costcenter.id }, costcenter).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.grid.api.refreshView();
                        MessageService.show($filter('translate')('costcenter.costcenter_updated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('dialogDetailAccountingItemController', dialogDetailAccountingItemController);

    function dialogDetailAccountingItemController(api, $timeout, $filter, data, $mdDialog) {
        var vm = this;
        vm.data = data;
        vm.active = true;
        vm.accountingItemDetail = [];
        vm.getDetail = getDetail;

        vm.pagination = {
            pageSize: 100,
            pageNumber: 0,
            totalPages: 0,
            totalElements: 0
        };

        vm.masterColumnDefs = [
            {
                headerName: "accountingItemReport.code",
                headerCellRenderer: getHeader,
                field: "code",
                width: 180,
            },
            {
                headerName: "accountingItemReport.description",
                headerCellRenderer: getHeader,
                field: "description",
                width: 350,
            },
            {
                headerName: "accountingItemReport.debit",
                headerCellRenderer: getHeader,
                field: "debit",
                width: 250,
                valueFormatter: function (param) {
                    return $filter("number")(param.value, 2)
                },
                cellStyle: { 'textAlign': 'right' },
            },
            {
                headerName: "accountingItemReport.credit",
                headerCellRenderer: getHeader,
                field: "credit",
                width: 250,
                valueFormatter: function (param) {
                    return $filter("number")(param.value, 2)
                },
                cellStyle: { 'textAlign': 'right' },
            }
        ];

        vm.gridFields = {
            enableSorting: true,
            debug: false,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            rowGroupPanelShow: "none",
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            fullWidthCellRenderer: true,
            rowData: null,
            pinnedBottomRowData: [],
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.closeDialog = function () {
            $mdDialog.cancel();
        };

        function init() {
            vm.gridFields.api.setColumnDefs(vm.masterColumnDefs);
            getDetail();;
        }

        function getDetail() {
            const dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {
                    vm.pagination.pageNumber = params.request.endRow / vm.pagination.pageSize;
                    api.GeneralWS.JournalEntry.Detail.page({
                        'id': data.id,
                        'pageNumber': vm.pagination.pageNumber,
                        'pageSize': vm.pagination.pageSize
                    }).$promise.then(function (response) {
                        vm.accountingItemDetail = response.content;
                        vm.pagination.totalElements = response.totalElements;
                        vm.pagination.totalPages = response.totalPages;
                        vm.showGrid = true;
                        params.successCallback(response.content, response.totalElements);
                    }, function (response) {
                    });
                }
            };
            vm.gridFields.api.setEnterpriseDatasource(dataSource);
        }

        $timeout(function () {
            init();
        }, 10);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountingItemReportController', AccountingItemReportController);

    /**@ngInject**/
    function AccountingItemReportController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log) {

        var vm = this;
        vm.isShowFilter = true;
        vm.establishmentByUser = establishmentByUser;
        vm.companyList = [];
        vm.establishmentList = [];
        vm.query = query;
        vm.estabishmentListByCompany = estabishmentListByCompany;
        vm.showGrid = false;

        vm.filterDTO = {
            startDate: new Date(),
            endDate: new Date(),
            company: null,
            establishment: null,
            journalEntryType: null,
            erpreference: null,
            journalEntryTypeDescription: null
        };

        vm.pagination = {
            pageSize: 100,
            pageNumber: 0,
            totalPages: 0,
            totalElements: 0
        };

        vm.journalEntryTypeList = [
            { value: 0, description: 'INVOICE', name: 'Factura', translate: 'accountingItemReport.invoice' },
            { value: 1, description: 'CREDIT_NOTE', name: 'Nota de crédito', translate: 'accountingItemReport.creditNote' },
            { value: 2, description: 'PAYMENT', name: 'Pago', translate: 'accountingItemReport.payment' },
            { value: 3, description: 'PURCHASE', name: 'Compra', translate: 'accountingItemReport.purchase' },
            { value: 4, description: 'INVENTORY', name: 'Inventario', translate: 'accountingItemReport.inventory' },
            { value: 5, description: 'CASH_DEPOSIT', name: 'Depósito en efectivo', translate: 'accountingItemReport.cashDeposit' },
            { value: 6, description: 'COSTING', name: 'Costo', translate: 'accountingItemReport.costing' },
            { value: 7, description: 'INVENTORY_INVOICE', name: 'Factura de inventario', translate: 'accountingItemReport.inventoryInvoice' },
            { value: 8, description: 'INVENTORY_TRANSFER', name: 'Transferencia de inventario', translate: 'accountingItemReport.inventoryTransfer' },
            { value: 9, description: 'INVENTORY_PACKAGE', name: 'Paquete de inventario', translate: 'accountingItemReport.inventoryPackage' },
            { value: 10, description: 'INVENTORY_RETURN', name: 'Devolución de inventario', translate: 'accountingItemReport.inventoryReturn' },
            { value: 11, description: 'INVENTORY_TRANSFER_CANCEL', name: 'Cancelación de transferencia de inventario', translate: 'accountingItemReport.inventoryTransferCancel' },
            { value: 12, description: 'COST_INVOICE', name: 'Costo de factura', translate: 'accountingItemReport.costInvoice' },
            { value: 13, description: 'COST_CREDITNOTE', name: 'Costo de nota de crédito', translate: 'accountingItemReport.costCreditNote' }
        ];

        function init() {
            changeSearch();
            establishmentByUser();
        }

        function establishmentByUser() {
            api.GeneralWS.Usr.User.Company.CompanyRolUser.query({ 'idCircle': $rootScope.bsCircle.id },
                function (response) {
                    vm.companyList = response;
                    vm.loadingsucursal = false;
                }, function (err) {
                    $log.debug(err);
                });
        }

        function estabishmentListByCompany(company) {
            api.GeneralWS.CompanyEstablishment.corporateGroupMembers.get({ 'idCircle': $rootScope.bsCircle.id, 'companyId': company }, function (response) {
                vm.establishmentList = response;
                vm.loadingEstablishments = false;
                vm.isShowFilter = true;
            }, function (err) {
                $log.debug(err);
                vm.loadingEstablishments = false;
            });
        }

        function query() {
            const dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {
                    if (vm.filterDTO.erpReference === "") {
                        vm.filterDTO.erpReference = null;
                    }
                    vm.filterDTO.startDate.setHours(0);
                    vm.filterDTO.startDate.setMinutes(0);
                    vm.filterDTO.startDate.setSeconds(0);

                    vm.filterDTO.endDate.setHours(23);
                    vm.filterDTO.endDate.setMinutes(59);
                    vm.filterDTO.endDate.setSeconds(59);
                    vm.pagination.pageNumber = params.request.endRow / vm.pagination.pageSize;
                    vm.isShowFilter = false;
                    vm.showFilterTab = true;
                    vm.isShowProgressLinear = true;
                    api.GeneralWS.JournalEntry.AccountingItem.page({
                        'pageNumber': vm.pagination.pageNumber,
                        'pageSize': vm.pagination.pageSize
                    }, vm.filterDTO).$promise.then(function (response) {
                        vm.listAccountingItem = response.content;
                        vm.isShowProgressLinear = false;
                        vm.pagination.totalElements = response.totalElements;
                        vm.pagination.totalPages = response.totalPages;
                        vm.showGrid = true;
                        params.successCallback(response.content, response.totalElements);
                        vm.showGrid = true;
                    }, function (response) {
                        vm.loading = false;
                        $log.error(response);
                    });
                }
            };
            vm.gridOptions.api.setEnterpriseDatasource(dataSource);
        }

        const columnsDef = [
            {
                field: "id",
                headerName: '#',
                headerCellRenderer: getHeader,
                width: 150,
                enableRowGroup: true,
                enablePivot: true,
                hide: true
            },
            {
                field: "name",
                headerName: 'accountingItemReport.company',
                headerCellRenderer: getHeader,
                width: 250,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                field: "sucursal",
                headerName: 'accountingItemReport.establishment',
                headerCellRenderer: getHeader,
                width: 300,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                field: "refDate",
                headerName: 'accountingItemReport.refDate',
                headerCellRenderer: getHeader,
                width: 150,
                valueFormatter: function (params) {
                    return $filter('date')(params.value, 'dd/MM/yyyy');
                }
            },
            {
                field: "memo",
                headerName: 'accountingItemReport.memo',
                headerCellRenderer: getHeader,
                width: 350,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                field: "erpReference",
                headerName: 'accountingItemReport.erpReference',
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                field: "reference1",
                headerName: 'accountingItemReport.reference1',
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                field: "reference2",
                headerName: 'accountingItemReport.reference2',
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                field: "reference3",
                headerName: 'accountingItemReport.reference3',
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                field: "journalType",
                headerName: 'accountingItemReport.journalEntryType',
                headerCellRenderer: getHeader,
                width: 200,
                cellRenderer: function (params) {
                    for (var i = 0; i < vm.journalEntryTypeList.length; i++) {
                        if (vm.journalEntryTypeList[i].description === params.data.journalEntryType) {
                            return vm.journalEntryTypeList[i].name;
                        }
                    }
                }
            },
            {
                headerName: 'accountingItemReport.options',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 200,
                cellRenderer: function renderer() {
                    return '<div style="width: 100%;"> '
                        + ' <md-button class="md-icon-button" ng-click="vm.getAllDetail(data, $index)"> '
                        + ' <md-icon md-font-icon="icon-document" class="s16"></md-icon> '
                        + ' <md-tooltip md-direction="left">{{"accountingItemReport.detail"| translate}}</md-tooltip></md-tooltip> </md-button>'
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        vm.gridOptions = {
            columnDefs: columnsDef,
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        vm.getAllDetail = function (data) {
            $mdDialog.show({
                controller: 'dialogDetailAccountingItemController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/accounting-item-report/dialogDetailAccountingItem/dialogDetailAccountingItem.html',
                parent: angular.element("#main"),
                targetEvent: window.event,
                locals: {
                    'data': data
                },
                clickOutsideToClose: false
            }).then(function () {
                init();
            });
        };



        function changeSearch() {
            vm.clearSearchCompany = function () {
                vm.searchCompany = "";
            };
            vm.clearSearchEstablishment = function () {
                vm.searchEstablishment = "";
            };
            vm.clearSearcJournalEntryType = function () {
                vm.searchJournalEntryType = "";
            };

            $timeout(function () {

                const keyEvent = function (event) {
                    event.stopPropagation();
                };
                const searchCompanyInput = document.querySelector("#clearSearchCompany");
                if (searchCompanyInput) {
                    searchCompanyInput.addEventListener("keydown", keyEvent);
                }
                const searchEstablishmentInput = document.querySelector("#searchEstablishment");
                if (searchEstablishmentInput) {
                    searchEstablishmentInput.addEventListener("keydown", keyEvent);
                }
                const searchsearchJournalEntryTypetInput = document.querySelector("#searchJournalEntryType");
                if (searchsearchJournalEntryTypetInput) {
                    searchsearchJournalEntryTypetInput.addEventListener("keydown", keyEvent);
                }
            }, 300);
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountingCatalogListController', AccountingCatalogListController);

    /**@ngInject**/
    function AccountingCatalogListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.addChildren = addChildren;
        vm.getAccountByLevel = getAccountByLevel;
        vm.onDelete = onDelete;

        var columnDefs = [
            {
                field: "code",
                headerName: 'accountingCatalog.code',
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: 'group',
                cellRendererParams: {
                    innerRenderer: function (params) {
                        return params.data.code;
                    }
                }
            },
            {
                field: "description",
                headerName: 'accountingCatalog.description',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "expenseType.description",
                headerName: 'accountingCatalog.expenseType',
                headerCellRenderer: getHeader,
                width: 100
            },
            {
                field: "levels",
                headerName: 'accountingCatalog.level',
                headerCellRenderer: getHeader,
                width: 100,
                cellStyle: { 'text-align': 'center' }
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.data.parentActive) {
                        return '<center> '
                            + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                            + ' <md-icon md-font-icon="icon-border-color"></md-icon> '
                            + ' <md-tooltip md-direction="left" >{{"general.edit"| translate}}</md-tooltip> '
                            + ' </md-button> </center>';
                    }
                    return '';
                },
                cellStyle: { 'padding': '2px' }
            },
            {
                name: "add",
                headerName: 'general.add',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.data.active && params.data.levels < vm.companyParameterAccountLevel) {
                        return '<center> '
                            + ' <md-button class="md-icon-button" ng-click="vm.addChildren(data)"> '
                            + ' <md-icon md-font-icon="icon-plus"></md-icon> '
                            + ' <md-tooltip md-direction="left" >{{"accountingCatalog.agregarCuentaHija"| translate}}</md-tooltip> '
                            + ' </md-button> </center>';
                    } else {
                        return '';
                    }
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowSelection: 'multiple',
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            getNodeChildDetails: function (file) {
                if (file.folder && file.children.length > 0) {
                    return {
                        group: true,
                        children: file.children,
                        expanded: file.open
                    };
                } else {
                    return null;
                }
            }
        };

        function getAccountByLevel(account) {
            vm.account = account;

            vm.grid.api.setRowData([]);

            vm.isShowProgressLinear = true;
            vm.showGrid = true;

            api.GeneralWS.Account.AccountingCatalog.ByParentLevel1.query({ 'company': $rootScope.bsCircle.company.id, 'level': account.id })
                .$promise.then(function (response) {

                    var rowData = [];
                    var level0 = new jinqJs()
                        .from(response)
                        .orderBy('code')
                        .where('accountFather = ' + account.id)
                        .select();

                    for (var i = 0; i < level0.length; i++) {
                        rowData.push({
                            folder: true,
                            open: true,
                            id: level0[i].id,
                            code: level0[i].code,
                            description: level0[i].description,
                            levels: level0[i].levels,
                            active: level0[i].active,
                            expenseType: level0[i].expenseType,
                            accountFather: level0[i].accountFather,
                            accountParentLevel1: level0[i].accountParentLevel1,
                            children: getChildByParent(response, level0[i]),
                            parentActive: account.active
                        });
                    }

                    vm.grid.api.setRowData(rowData);

                    vm.isShowProgressLinear = false;
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

        function getChildByParent(data, parent) {
            return new jinqJs()
                .from(data)
                .orderBy('code')
                .where('accountFather = ' + parent.id)
                .select(
                    function (r) {
                        return {
                            folder: true,
                            id: r.id,
                            code: r.code,
                            description: r.description,
                            levels: r.levels,
                            active: r.active,
                            expenseType: r.expenseType,
                            accountFather: r.accountFather,
                            accountParentLevel1: r.accountParentLevel1,
                            children: getChildByParent(data, r),
                            parentActive: parent.active
                        };
                    }
                );
        }

        function init() {

            vm.isShowProgressLinear = true;

            api.GeneralWS.CompanyParameter.byName.get({ 'company': $rootScope.bsCircle.company.id, 'parameterName': 'ACCOUNTING_CATALOG_LEVELS' })
                .$promise.then(function (responseParameter) {

                    vm.companyParameterAccountLevel = 0;
                    if (responseParameter.parameterValue) {
                        vm.companyParameterAccountLevel = responseParameter.parameterValue;
                    }

                    api.GeneralWS.Account.AccountingCatalog.ByLevel.query({ 'company': $rootScope.bsCircle.company.id, 'level': 1 })
                        .$promise.then(function (response) {
                            response = $filter('orderBy')(response, 'code');
                            vm.accountLevel1 = response;

                            vm.isShowProgressLinear = false;
                        }, function (response) {
                            vm.isShowProgressLinear = false;
                            $log.error(response);
                        });

                }, function (response) {
                    $log.error(response);
                });

            api.GeneralWS.Account.ExpenseType.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.expenseType = response;
            }, function (response) {
                $log.error(response);
            });
        }

        function add() {
            $mdDialog.show({
                controller: 'AccountingCatalogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/accounting-catalog/accounting-catalog/accounting-catalog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': {
                        'code': '',
                        'description': '',
                        'active': true,
                        'company': $rootScope.bsCircle.company,
                        'accountFather': 0,
                        'levels': 1,
                        'expenseType': { id: 0 },
                        'accountParentLevel1': 0
                    },
                    'expenseType': vm.expenseType
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('accountingCatalog.added'));

                    init();
                }
            }, function () {

            });
        }

        function edit(account) {
            account.company = $rootScope.bsCircle.company;
            $mdDialog.show({
                controller: 'AccountingCatalogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/accounting-catalog/accounting-catalog/accounting-catalog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': angular.copy(account),
                    'expenseType': vm.expenseType
                }
            }).then(function (answer) {
                if (answer) {
                    if (answer.accountFather === 0) {
                        for (var i = 0; i < vm.accountLevel1.length; i++) {
                            if (vm.accountLevel1[i].id === answer.id) {
                                vm.accountLevel1[i] = answer;
                            }
                        }

                        vm.getAccountByLevel(answer);

                    } else {
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === answer.id) {
                                answer.parentActive = row.data.parentActive;
                                row.data = answer;
                            }

                            if (row.data.accountFather === answer.id) {
                                row.data.parentActive = answer.active;
                            }
                        });

                        vm.grid.api.refreshView();
                    }

                    MessageService.show($filter('translate')('accountingCatalog.updated'));
                }
            }, function () {

            });
        }

        function onDelete(account) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('accountingCatalog.desactivarCuenta'))
                .textContent($filter('translate')('accountingCatalog.confirmaDesactivar1') + $filter('translate')('accountingCatalog.confirmaDesactivar2'))
                .ariaLabel($filter('translate')('accountingCatalog.desactivarCuenta'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                account.company = $rootScope.bsCircle.company;
                account.active = false;

                var promise;
                promise = api.GeneralWS.Account.AccountingCatalog.me.update({ 'company': account.company.id, 'id': account.id }, account).$promise;

                vm.isShowProgressLinear = true;
                promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    switch (response.$status) {
                        case 200:
                        case 201:
                            vm.grid.api.forEachNode(function (row, index) {
                                if (row.data.id === response.id) {
                                    row.data = response;
                                }
                            });
                            vm.grid.api.refreshView();
                            MessageService.show($filter('translate')('accountingCatalog.updated'));
                            break;

                        default:
                            $log.error(response);
                            MessageService.showErrorMessage($filter('translate')('general.general_error'));
                            break;
                    }

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
            }, function () {
                account.active = true;
            });
        }

        function addChildren(account, isChildLevel2) {

            if (isChildLevel2) {
                if (account.accountParentLevel1 === 0) {
                    account.accountParentLevel1 = account.id;
                }
            }

            $mdDialog.show({
                controller: 'AccountingCatalogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/accounting-catalog/accounting-catalog/accounting-catalog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': {
                        'code': '',
                        'description': '',
                        'active': true,
                        'company': $rootScope.bsCircle.company,
                        'accountFather': account.id,
                        'levels': (account.levels + 1),
                        'expenseType': { id: 0 },
                        'accountParentLevel1': account.accountParentLevel1
                    },
                    'expenseType': vm.expenseType
                }
            }).then(function (answer) {
                if (answer) {
                    getAccountByLevel(vm.account);
                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('accountingCatalog.updated'));
                }
            }, function () {

            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountingEntryConfigListController', AccountingEntryConfigListController);

    /**@ngInject**/
    function AccountingEntryConfigListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log, $state) {

        var vm = this;

        /**
         * methods
         */
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;
        vm.viewDetail = viewDetail

        vm.pagination = {
            page: 0,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "seriesNameErp",
                headerName: 'accounttype.acTypeDescription',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "accountingEntryType.accEntryTypeName",
                headerName: 'accountingEntry.accountingEntryType',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'accountingEntry.options',
                headerCellRenderer: getHeader,
                width: 200,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.viewDetail(data)"> '
                        + ' <md-icon md-font-icon="icon-eye"></md-icon> <md-tooltip md-direction="left">{{"accountingEntry.view_detail"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onDelete(data)"> '
                        + ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + '</center>';
                },
                cellStyle: { 'padding': '2px' },
                pinned: 'right'
            }
        ];

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.AccountingEntryConfig.getAll({
                        'companyId': $rootScope.bsCircle.company.id, 'pageNumber': (vm.pagination.page), 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;
                            vm.list = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select();
                            vm.idsTypes = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (row) { return row.accountingEntryType.id });

                            params.successCallback(vm.list, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });
                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);
        }

        function init() {
            createNewDatasource();
        }



        function edit(data) {
            var isNew = false;
            if (data) {
                data.company = { id: $rootScope.bsCircle.company.id };
            } else {
                isNew = true;
                data = {
                    company: {
                        id: $rootScope.bsCircle.company.id
                    }
                }
            }

            $mdDialog.show({
                controller: 'AccountEntryEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/accounting-entry/account-entry-edit/account-entry-edit.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'accountEntry': angular.copy(data),
                    'idsTypes': vm.idsTypes
                }
            }).then(function (answer) {
                if (isNew) {
                    MessageService.show($filter('translate')('accountingEntry.added'));
                } else {
                    MessageService.show($filter('translate')('accountingEntry.updated'));
                }
                createNewDatasource();
            }, function () {

            });
        }

        function onDelete(accounttype) {
            accounttype.active = false;

            var promise;
            promise = api.GeneralWS.AccountingEntryConfig.del({ 'company': accounttype.company.id, 'id': accounttype.id }).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                createNewDatasource();
                MessageService.show($filter('translate')('accountingEntry.updated'));

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function viewDetail(data) {
            $state.go('app.account.accountingEntryConfig.detail', { id: data.id, backTo: $state.current.name });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountEntryEditController', AccountEntryEditController);

    /**@ngInject**/
    function AccountEntryEditController(api, MessageService, $log, accountEntry, $filter, $mdDialog, idsTypes) {

        var vm = this;

        vm.accountEntry = accountEntry;
        vm.accountingEntryTypes = [];
        vm.dinamicStyle = {
            'width': '30%',
            'height': '50%'
        };

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;
        init();

        function init() {
            vm.loadingTypes = true;
            api.GeneralWS.AccountingEntryType.getAll({}).$promise.then(function (response) {
                vm.accountingEntryTypes = new jinqJs()
                    .from(response)
                    .where(function (row) {
                        return idsTypes.indexOf(row.id) < 0;
                    })
                    .select();
                if (accountEntry && accountEntry.accountingEntryType) {
                    vm.accountingEntryTypes.push(accountEntry.accountingEntryType);
                }
                vm.loadingTypes = false;
            }, function (err) {
                vm.loadingTypes = false;
                $log.debug(err);
            });

            var windowHeight = parseInt(window.innerHeight);

            if (windowHeight < 700) {
                vm.dinamicStyle.height = '75%';
            } else if (windowHeight < 800) {
                vm.dinamicStyle.height = '55%';
            }
        }

        function save() {

            if (vm.accountEntryForm.$invalid) {
                return false;
            }

            var promise;

            if (!vm.accountEntry.seriesNameErp) {
                vm.accountEntry.seriesNameErp = '';
            }

            if (vm.accountEntry.id) {
                promise = api.GeneralWS.AccountingEntryConfig.update(
                    { 'companyId': vm.accountEntry.company.id, 'id': vm.accountEntry.id }
                    , vm.accountEntry).$promise;
            } else {
                promise = api.GeneralWS.AccountingEntryConfig.save(
                    { 'companyId': vm.accountEntry.company.id, 'id': undefined }
                    , vm.accountEntry).$promise;
            }
            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                $mdDialog.hide(response);
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                if (response.data.mensaje === 'ERROR_EXIST_ACCOUNTING_TYPE') {
                    MessageService.showErrorMessage($filter('translate')('accountingEntry.ERROR_EXIST_ACCOUNTING_TYPE'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountingEntryConfigDetailController', AccountingEntryConfigDetailController);

    /**@ngInject**/
    function AccountingEntryConfigDetailController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log, $stateParams, $state) {

        var vm = this;

        /**
         * methods
         */
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;
        vm.back = back;

        vm.pagination = {
            page: 0,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "accountingEntryTypeTemplate.actTemplateName",
                headerName: 'accountingEntry.accountingEntryTypeTemplate',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "accountType.acTypeDescription",
                headerName: 'accountingEntry.accountType',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                headerName: 'accountingEntry.isCredit',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function (params) {
                    if (params.data && params.data.accountingEntryTypeTemplate.isCredit) {
                        return ' <md-icon md-font-icon="icon-close"></md-icon>';
                    }
                    return '';
                }
            },
            {
                headerName: 'accountingEntry.isDebit',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function (params) {
                    if (params.data && !params.data.accountingEntryTypeTemplate.isCredit) {
                        return ' <md-icon md-font-icon="icon-close"></md-icon>';
                    }
                    return '';
                }
            },
            {
                name: "edit",
                headerName: 'accountingEntry.options',
                headerCellRenderer: getHeader,
                width: 150,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onDelete(data)"> '
                        + ' <md-icon class="md-warn" md-font-icon="icon-trash"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip> '
                        + ' </md-button> '
                        + '</center>';
                },
                cellStyle: { 'padding': '2px' },
                pinned: 'right'
            }
        ];

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.AccountingEntryConfigDetail.getAll({
                        'accountingEntryConfigId': $stateParams.id,
                        'companyId': $rootScope.bsCircle.company.id, 'pageNumber': (vm.pagination.page), 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;
                            vm.list = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select();
                            vm.accountTypeIds = new jinqJs()
                                .from(response.content)
                                .orderBy([{ field: 'id', sort: 'asc' }])
                                .select(function (row) {
                                    var resp = { accountType: row.accountType.id, accountingEntryTypeTemplates: row.accountingEntryTypeTemplate.id };
                                    return resp;
                                });
                            params.successCallback(vm.list, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });
                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);
        }

        function init() {
            api.GeneralWS.AccountingEntryConfig.getId({ 'id': $stateParams.id }).$promise.then(function (response) {
                vm.accountingEntryConfig = response;
                vm.loadingTypes = true;
                api.GeneralWS.AccountingEntryTypeTemplate.getAll({ 'accountingEntryTypeId': vm.accountingEntryConfig.accountingEntryType.id }).$promise.then(function (response) {
                    vm.accountingEntryTypeTemplates = response;
                    vm.loadingTypes = false;
                }, function (err) {
                    vm.loadingTypes = false;
                    $log.debug(err);
                });
                createNewDatasource();
            }, function (error) {
                $log.debug(error);
            });
        }



        function edit(data) {
            var isNew = false;
            if (data) {
                data.accountingEntryConfig = { id: vm.accountingEntryConfig.id };
            } else {
                isNew = true;
                data = {
                    accountingEntryConfig: {
                        id: vm.accountingEntryConfig.id
                    }
                }
            }
            $mdDialog.show({
                controller: 'AccountEntryDetailEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/accounting-entry/accounting-entry-config-detail/dialog-detail/dialog-detail.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'accountingEntryConfig': angular.copy(vm.accountingEntryConfig),
                    'accountingEntryConfigDetail': angular.copy(data),
                    'accountTypeIds': vm.accountTypeIds
                }
            }).then(function (answer) {
                if (isNew) {
                    MessageService.show($filter('translate')('accountingEntry.added'));
                } else {
                    MessageService.show($filter('translate')('accountingEntry.updated'));
                }
                createNewDatasource();
            }, function () {

            });
        }

        function onDelete(accounttype) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('accountingEntry.delete_accountingEntry') + '?')
                .ariaLabel($filter('translate')('accountingEntry.accountingEntry'))
                .ok('Si')
                .cancel('No');

            $mdDialog.show(confirm).then(function () {
                accounttype.active = false;

                var promise;
                promise = api.GeneralWS.AccountingEntryConfigDetail.update({ 'id': accounttype.id }, accounttype).$promise;

                vm.isShowProgressLinear = true;
                promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    createNewDatasource();
                    MessageService.show($filter('translate')('accountingEntry.deleted'));

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
            });
        }

        function back() {
            if ($stateParams.backTo) {
                $state.go($stateParams.backTo);
            } else {
                $state.go('app.account.accountingEntryConfig');
            }
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.account')
        .controller('AccountTypeListController', accountTypeListController);

    /**@ngInject**/
    function accountTypeListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;

        vm.pagination = {
            page: 0,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "acTypeCode",
                headerName: 'accounttype.acTypeCode',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "acTypeDescription",
                headerName: 'accounttype.acTypeDescription',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {

            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.Account.AccountType.me.page({
                        'company': $rootScope.bsCircle.company.id, 'page': (vm.pagination.page), 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;

                            params.successCallback(response.content, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });
                }
            };

            vm.grid.api.setEnterpriseDatasource(dataSource);
        }

        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'AccountTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/account-type/account-type/account-type.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'accounttype': {
                        'acTypeCode': '',
                        'acTypeDescription': '',
                        'active': true,
                        'company': $rootScope.bsCircle.company
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                    MessageService.show($filter('translate')('accounttype.accounttype_added'));
                }
            }, function () {

            });
        }

        function edit(accounttype) {
            $mdDialog.show({
                controller: 'AccountTypeController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/account/account-type/account-type/account-type.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'accounttype': angular.copy(accounttype)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });

                    vm.grid.api.refreshView();
                    MessageService.show($filter('translate')('accounttype.accounttype_updated'));
                }
            }, function () {

            });
        }

        function onDelete(accounttype) {
            accounttype.active = false;

            var promise;
            promise = api.GeneralWS.Account.AccountType.me.update({ 'company': accounttype.company.id, 'id': accounttype.id }, accounttype).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.grid.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.grid.api.refreshView();
                        MessageService.show($filter('translate')('accounttype.accounttype_updated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
            .module('app.account')
            .controller('AccountTypeController', accountTypeController);

    /**@ngInject**/
    function accountTypeController(api, MessageService, $log, accounttype, $filter, $mdDialog) {

        var vm = this;

        vm.accounttype = accounttype;

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function save() {

            if (vm.accounttypeForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.accounttype.id) {
                promise = api.GeneralWS.Account.AccountType.me.update({'company': vm.accounttype.company.id, 'id': vm.accounttype.id}, vm.accounttype).$promise;
            } else {
                promise = api.GeneralWS.Account.AccountType.me.create({'company': vm.accounttype.company.id, 'id': undefined}, vm.accounttype).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('accounttype.accounttype_exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider) {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
    }
})();

(function () {

    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ViewNotificationController', ViewNotificationController);

    function ViewNotificationController($mdDialog, api, notification, notificationIndex, $rootScope, $log, $timeout) {

        var vm = this;
        vm.notification = notification;

        //metodos
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.cancel();
        }

        function markAsRead() {

            var _notificationIdArray = [notification.id];

            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.markAsRead.update({ 'circleId': $rootScope.bsCircle.id }, _notificationIdArray).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                $rootScope.msNotificationArray.splice(notificationIndex, 1);
                $rootScope.totalNumberOfNotifications -= 1;

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });

        }

        function init() {
            if (notification.isUserNotification) {
                markAsRead();
            }
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.notifications')
        .controller('NotificationConfigurationController', NotificationConfigurationController);

    function NotificationConfigurationController($filter, APPNAME, $timeout, $scope, api, $rootScope, $log, $compile, $interpolate) {

        var vm = this;
        vm.userNotificationConfigArray = [];
        vm.isActiveAll = true;
        vm.isReceiveEmailAll = true;
        vm.isReceiveSmsAll = true;
        vm.isReceiveWebNotificationAll = true;
        vm.applicationsArray = [];

        //configuracion de grid
        vm.gridOptions = {
            columnDefs: [
                {
                    headerName: $filter('translate')('notifications.group'),
                    field: "groupName",
                    width: 175,
                    cellRenderer: 'group'
                },
                {
                    headerName: $filter('translate')('notifications.notification_name'),
                    field: "notificationType.notificationTypeDescription",
                    width: 400
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')('general.active'),
                    //headerCellRenderer: getHeader,
                    field: "active",
                    width: 150,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;
                        return getMdChip("active", "!data.notificationType.userCanDisable && data.id !== -1 && !node.group", "vm.changeActive(data, node)", "data.active");
                    }
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')("notifications.can_send_email"),
                    //headerCellRenderer: getHeader,
                    field: "receiveEmail",
                    width: 175,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;

                        if (params.data.id === -1 || params.node.group) {
                            return getMdChip("Email notifications", "!data.hasActive && (data.id === -1 || node.group)", "vm.changeReceiveEmail(data, node)", "data.receiveEmail");
                        } else if (params.data.notificationType && params.data.notificationType.canSendEmail) {
                            return getMdChip("Email notifications", "(!data.notificationType.userCanDisable || !data.active) && data.id !== -1 && !node.group", "vm.changeReceiveEmail(data, node)", "data.receiveEmail");
                        } else {
                            return '';
                        }

                    }
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')("notifications.can_send_sms"),
                    //headerCellRenderer: getHeader,
                    field: "receiveSms",
                    width: 175,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;

                        if (params.data.id === -1 || params.node.group) {
                            return getMdChip("SMS notifications", "!data.hasActive && (data.id === -1 || node.group)", "vm.changeReceiveSms(data, node)", "data.receiveSms");
                        } else if (params.data.notificationType && params.data.notificationType.canSendSms) {
                            return getMdChip("SMS notifications", "(!data.notificationType.userCanDisable || !data.active) && data.id !== -1 && !node.group", "vm.changeReceiveSms(data, node)", "data.receiveSms");
                        } else {
                            return '';
                        }
                    }
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')("notifications.can_send_web_notification"),
                    //headerCellRenderer: getHeader,
                    field: "receiveWebNotification",
                    width: 175,
                    cellRenderer: function (params) {
                        params.$scope.node = params.node;

                        if (params.data.id === -1 || params.node.group) {
                            return getMdChip("Web notifications", "!data.hasActive && (data.id === -1 || node.group)", "vm.changeReceiveWebNotification(data, node)", "data.receiveWebNotification");
                        } else if (params.data.notificationType && params.data.notificationType.canSendWebNotification) {
                            return getMdChip("Web notifications", "(!data.notificationType.userCanDisable || !data.active) && data.id !== -1 && !node.group", "vm.changeReceiveWebNotification(data, node)", "data.receiveWebNotification");
                        } else {
                            return '';
                        }
                    }
                }
            ],
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            rowData: [],
            rowHeight: 45,
            getNodeChildDetails: getNodeChildDetails
        };

        //metodos
        vm.updateConfiguration = updateConfiguration;
        vm.changeActive = changeActive;
        vm.changeReceiveEmail = changeReceiveEmail;
        vm.changeReceiveSms = changeReceiveSms;
        vm.changeReceiveWebNotification = changeReceiveWebNotification;
        vm.filterConfigByAppName = filterConfigByAppName;

        function getMdChip(ariaLabel, ngDisabled, ngChange, ngModel) {

            var mdChip = "<div layout='row' layout-align='center center'> <md-switch aria-label='[ARIA-LABEL]' ng-disabled='[NG-DISABLED]' ng-change='[NG-CHANGE]' ng-model='[NG-MODEL]'></md-switch> </div>";

            return mdChip
                .replace("[ARIA-LABEL]", ariaLabel)
                .replace("[NG-DISABLED]", ngDisabled)
                .replace("[NG-CHANGE]", ngChange)
                .replace("[NG-MODEL]", ngModel);

        }

        function getNodeChildDetails(rowItem) {
            if (rowItem.notifications) {
                return {
                    group: true,
                    expanded: true,
                    children: rowItem.notifications,
                    key: rowItem.notifications
                };
            } else {
                return null;
            }
        }

        function changeActive(data, node) {

            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (row.data.notificationType && row.data.notificationType.userCanDisable) {
                        row.data.active = data.active;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (row.data.notificationType && row.data.notificationType.userCanDisable) {
                        row.data.active = data.active;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }
        }

        function changeReceiveEmail(data, node) {

            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendEmail) {
                        row.data.receiveEmail = data.receiveEmail;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendEmail) {
                        row.data.receiveEmail = data.receiveEmail;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }

        }

        function changeReceiveSms(data, node) {
            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (!row.group && row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendSms) {
                        row.data.receiveSms = data.receiveSms;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (!row.group && row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendSms) {
                        row.data.receiveSms = data.receiveSms;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }
        }

        function changeReceiveWebNotification(data, node) {

            var userNotificationConfigArray = [];

            if (data.id === -1) {

                vm.gridOptions.api.forEachNode(function (row, index) {
                    if (!row.group && row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendWebNotification) {
                        row.data.receiveWebNotification = data.receiveWebNotification;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else if (node.group) {

                node.allLeafChildren.forEach(function (row) {
                    if (!row.group && row.data.active && row.data.notificationType && row.data.notificationType.userCanDisable && row.data.notificationType.canSendWebNotification) {
                        row.data.receiveWebNotification = data.receiveWebNotification;
                        userNotificationConfigArray.push(row.data);
                    }
                });

            } else {
                userNotificationConfigArray.push(data);
            }

            if (userNotificationConfigArray.length > 0) {
                updateConfiguration(userNotificationConfigArray);
            }

        }

        function getApplications(userNotificationConfigArray) {

            var _applicationsArray = [];

            userNotificationConfigArray.forEach(function (row) {
                _applicationsArray.push({
                    id: row.notificationType.notificationGroup.application.id,
                    name: row.notificationType.notificationGroup.application.name
                });
            });

            vm.applicationsArray = new jinqJs()
                .from(_applicationsArray)
                .distinct('id', 'name')
                .select();

            //verifica la aplicacion actual
            for (var i = 0; i < vm.applicationsArray.length; i++) {
                if (vm.applicationsArray[i].name === APPNAME) {
                    vm.applicationsSelected = vm.applicationsArray[i].id;
                    break;
                }
            }

            filterConfigByAppName();

        }

        function getNotificationsByGroup(notificationGroupId) {
            var result = [];

            vm.notificationsByAppArray.forEach(function (row) {

                if (row.notificationType.notificationGroup.id === notificationGroupId) {
                    result.push(row);
                }

            });

            return result;
        }

        function filterConfigByAppName() {
            vm.gridOptions.api.setPinnedTopRowData([]);

            vm.notificationsByAppArray = new jinqJs()
                .from(vm.userNotificationConfigArray)
                .where(function (r, i) {

                    if (r.notificationType.notificationGroup.application.id === vm.applicationsSelected) {
                        return true;
                    }

                    return false;
                })
                .select();

            vm.notificationGroupsArray = [];

            vm.notificationsByAppArray.forEach(function (row) {

                if (!existsNotificationGroupInGroupArray(row.notificationType.notificationGroup.id)) {
                    vm.notificationGroupsArray.push({
                        id: row.notificationType.notificationGroup.id,
                        groupName: row.notificationType.notificationGroup.groupName
                    });
                }

            });


            var gridRowData = [];

            for (var i = 0; i < vm.notificationGroupsArray.length; i++) {

                gridRowData.push({
                    id: vm.notificationGroupsArray[i].id,
                    groupName: vm.notificationGroupsArray[i].groupName,
                    notifications: getNotificationsByGroup(vm.notificationGroupsArray[i].id)
                });

            }

            vm.gridOptions.api.setRowData(gridRowData);


            if (gridRowData.length > 0) {
                vm.gridOptions.api.setPinnedTopRowData([{
                    groupName: "Todo (" + vm.notificationsByAppArray.length + ")",
                    id: -1,
                    active: false,
                    receiveEmail: false,
                    receiveSms: false,
                    receiveWebNotification: false
                }]);

                validateActiveAllNotifications();
            }
        }

        function existsNotificationGroupInGroupArray(notificationGroupId) {
            if (vm.notificationGroupsArray === null || vm.notificationGroupsArray === undefined) {
                return false;
            }

            if (vm.notificationGroupsArray.length === 0) {
                return false;
            }

            for (var i = 0; i < vm.notificationGroupsArray.length; i++) {
                if (vm.notificationGroupsArray[i].id === notificationGroupId) {
                    return true;
                }
            }
            return false;
        }

        function getMyNotifications() {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotificationConfig.me.query({ 'companyId': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                vm.userNotificationConfigArray = response;

                //obtiene las aplicaciones
                getApplications(response);

                vm.showGrid = true;

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function updateConfiguration(userNotificationConfigArray, event) {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotificationConfig.me.update({}, userNotificationConfigArray).$promise.then(function (response) {
                $rootScope.loadingProgress = false;
                validateActiveAllNotifications();
            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function validateActiveAllNotifications() {

            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.hasActive = false;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.active = true;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveEmail = true;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveSms = true;
            vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveWebNotification = true;

            vm.gridOptions.api.forEachNode(function (node) {

                if (node.group) {

                    node.data.hasActive = false;
                    node.data.active = true;
                    node.data.receiveEmail = true;
                    node.data.receiveSms = true;
                    node.data.receiveWebNotification = true;

                    node.allLeafChildren.forEach(function (child) {

                        if (child.data.notificationType.userCanDisable) {

                            if (child.data.active) {
                                node.data.hasActive = true;
                            }

                            if (!child.data.active) {
                                node.data.active = false;
                            }

                            if (!child.data.receiveEmail) {
                                node.data.receiveEmail = false;
                            }

                            if (!child.data.receiveSms) {
                                node.data.receiveSms = false;
                            }

                            if (!child.data.receiveWebNotification) {
                                node.data.receiveWebNotification = false;
                            }
                        }

                    });

                }

            });


            vm.gridOptions.api.forEachNode(function (node) {
                if (node.group) {
                    if (node.data.hasActive) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.hasActive = true;
                    }

                    if (!node.data.active) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.active = false;
                    }

                    if (!node.data.receiveEmail) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveEmail = false;
                    }

                    if (!node.data.receiveSms) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveSms = false;
                    }

                    if (!node.data.receiveWebNotification) {
                        vm.gridOptions.api.pinnedRowModel.pinnedTopRows[0].data.receiveWebNotification = false;
                    }
                }
            });
        }

        function init() {
            getMyNotifications();
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.notifications')
        .controller('MyNotifications', MyNotifications);

    function MyNotifications($scope, api, $log, $timeout, $filter, $state, $stateParams, $rootScope, MessageService) {

        var vm = this;

        vm.filter = {
            filterByDates: false,
            startDate: new Date(),
            endDate: new Date(),
            applications: [],
            companies: []
        };

        vm.showAdvancedFilter = false;
        vm.myNotificationsArray = [];
        vm.selectedNotifications = [];
        vm.pagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
                getMyNotifications();
            },
            beforePage: function () {
                this.pageNumber--;
                getMyNotifications();
            },
            firstPage: function () {
                this.pageNumber = 1;
                getMyNotifications();
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
                getMyNotifications();
            }
        };

        //metodos
        vm.toggleSelectNotifications = toggleSelectNotifications;
        vm.isSelectedNotification = isSelectedNotification;
        vm.toggleSelectNotification = toggleSelectNotification;
        vm.showNotification = showNotification;
        vm.markAsRead = markAsRead;
        vm.markAllAsRead = markAllAsRead;
        vm.getMyNotifications = getMyNotifications;

        function showNotification(event, notification) {

            event.stopPropagation();

            if (vm.currentNotification !== null && vm.currentNotification !== undefined && vm.currentNotification.id === notification.id) {
                vm.currentNotification = null;
            } else {
                vm.currentNotification = notification;
                if (!notification.markedAsRead) {
                    var _notificationsArray = [];
                    _notificationsArray.push(notification);
                    markAsRead(_notificationsArray);
                }
            }

        }

        function markAllAsRead() {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.markAllAsRead.update({ 'circleId': $rootScope.bsCircle.id }).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                for (var i = 0; i < vm.myNotificationsArray.length; i++) {
                    vm.myNotificationsArray[i].markedAsRead = true;
                }

                $rootScope.msNotificationArray = [];
                $rootScope.totalNumberOfNotifications = 0;

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function markAsRead(notificationsArray) {

            var _notificationIdArray = [];

            notificationsArray.forEach(function (row) {
                if (!row.markedAsRead) {
                    _notificationIdArray.push(row.id);
                }
            });

            if (_notificationIdArray.length > 0) {

                $rootScope.loadingProgress = true;
                api.NotificacionesWS.UserNotification.markAsRead.update({ 'circleId': $rootScope.bsCircle.id }, _notificationIdArray).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;

                    for (var i = 0; i < notificationsArray.length; i++) {
                        notificationsArray[i].markedAsRead = true;
                        removeFromUnreadNotificationList(notificationsArray[i]);
                    }

                    if (vm.selectedNotifications.length > 0) {
                        deselectNotifications();
                    }

                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                });

            }

        }

        function removeFromUnreadNotificationList(notification) {
            for (var i = 0; i < $rootScope.msNotificationArray.length; i++) {
                if (notification.id === $rootScope.msNotificationArray[i].id && $rootScope.msNotificationArray[i].isUserNotification) {
                    $rootScope.msNotificationArray.splice(i, 1);
                    break;
                }
            }
        }

        function toggleSelectNotification(notification, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedNotifications.indexOf(notification) > -1) {
                vm.selectedNotifications.splice(vm.selectedNotifications.indexOf(notification), 1);
            } else {
                vm.selectedNotifications.push(notification);
            }
        }

        function isSelectedNotification(notification) {
            return vm.selectedNotifications.indexOf(notification) > -1;
        }

        function selectNotifications(key, value) {

            vm.selectedNotifications = [];

            for (var i = 0; i < vm.myNotificationsArray.length; i++) {

                if (angular.isUndefined(key) && angular.isUndefined(value)) {
                    vm.selectedNotifications.push(vm.myNotificationsArray[i]);
                    continue;
                }

                if (angular.isDefined(key) && angular.isDefined(value) && vm.myNotificationsArray[i][key] === value) {
                    vm.selectedNotifications.push(vm.myNotificationsArray[i]);
                }

            }

        }

        function deselectNotifications() {
            vm.selectedNotifications = [];
        }

        function toggleSelectNotifications() {
            if (vm.selectedNotifications.length > 0) {
                deselectNotifications();
            } else {
                selectNotifications();
            }
        }

        function getMyNotifications() {
            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.myNotifications.page({ 'circleId': $rootScope.bsCircle.id, 'pageSize': vm.pagination.pageSize, 'pageNumber': vm.pagination.pageNumber }, vm.filter).$promise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.myNotificationsArray = response.content;
                vm.pagination.totalElements = response.totalElements;
                vm.pagination.totalPages = response.totalPages;
                vm.pagination.numberOfElements = response.numberOfElements;
            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });
        }

        function init() {
            getMyNotifications();
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular.module('app.errors', []).config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/general/errors/');

        $stateProvider.state('app.errors', {
            url: '/errors',
            abstract: true
        });

        $stateProvider
            .state('app.errors.unauthorized', {
                url: '/unauthorized',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.errors.unauthorized': {
                        templateUrl: 'app/main/general/errors/unauthorized/unauthorized.html',
                        controller: 'UnauthorizedController as vm'
                    }
                }
            })
            .state('app.errors.notFound', {
                url: '/not-found',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.errors.notFound': {
                        templateUrl: 'app/main/general/errors/notFound/error-404.html',
                        controller: 'NotFoundController as vm'
                    }
                }
            })
            .state('app.pages_errors_error-404', {
                url: '/error',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.pages_errors_error-404': {
                        templateUrl: 'app/main/general/errors/404/error-404.html',
                        controller: 'Error404Controller as vm'
                    }
                },
                bodyClass: 'error-404'
            });
    }

})();

(function () {

    'use strict';

    angular.module('app.errors').controller('UnauthorizedController', UnauthorizedController);

    /**@ngInject**/
    function UnauthorizedController(envService, ICON_APP_NAME) {

        var vm = this;
        var urlMsBase = envService.read('msConfigUrl');
        vm.iconApp = envService.read('imagesApps') + ICON_APP_NAME;

        vm.goToConfigureCompany = function () {
            window.location.href = urlMsBase + "company/my-company";
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.errors')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller(envService, ICON_APP_NAME) {
        var vm = this;
        vm.iconApp = envService.read('imagesApps') + ICON_APP_NAME;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.reset-password', [])
        .directive('pwValidate', passwordValidate)
        .directive('pwCheck', passwordConfirm)
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('auth.reset-password', {
            url: '/auth/reset-password',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'AuthMainController as vm'
                },
                'content@auth.reset-password': {
                    templateUrl: 'app/main/common/auth/reset-password/reset-password.html',
                    controller: 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/common/auth/reset-password');
    }


    function passwordValidate() {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                scope.$watch(attrs.ngModel, function (newVal) {
                    if (newVal) {
                        scope.pwd1Rq = newVal && newVal !== '' ? newVal !== '' : false;
                        ctrl.$setValidity('pwlen', newVal.length >= 8);
                        ctrl.$setValidity('pwletter', newVal.match(/[A-z]/) ? newVal !== '' : false);
                        ctrl.$setValidity('pwcapital', newVal.match(/[A-Z]/) ? newVal !== '' : false);
                        ctrl.$setValidity('pwnum', newVal.match(/\d/) ? newVal !== '' : false);
                    } else if (newVal === '') {
                        ctrl.$setValidity('pwlen', true);
                        ctrl.$setValidity('pwletter', true);
                        ctrl.$setValidity('pwcapital', true);
                        ctrl.$setValidity('pwnum', true);
                    }
                });
            }
        };
    }

    function passwordConfirm() {
        return {
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                var firstPassword = '#' + attrs.pwCheck;
                elem.add(firstPassword).on('keyup', function () {
                    scope.$apply(function () {
                        var v = elem.val() === $(firstPassword).val();
                        ctrl.$setValidity('pwmatch', v);
                    });
                });
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(api, $state, $cookies, $rootScope, $scope, $log, $mdToast) {

        var vm = this;
        vm.form = {
            password: ''
        };

        vm.changePwd = changePwd;
        var sesion;

        api.UsuarioWS.Me.get({}, function (data) {
            sesion = angular.copy($rootScope.tk);
            sesion.usuario = angular.copy(data);
            if (data.snCambioPwd && data.snCambioPwd2) {
                $state.go('app.dashboards_project');
            }
            delCookies($cookies, $rootScope);
            vm.user = data;
        }, function (data) {
            delCookies($cookies, $rootScope);
            $state.go('auth.login');
        });

        function changePwd() {
            var user = angular.copy(vm.user);
            if (!user.snCambioPwd) {
                user.txtPwd = vm.form.password;
            }
            if (!user.snCambioPwd2) {
                user.txtPwd2 = vm.form.password2;
            }

            var sLocal = angular.copy(sesion);
            setCookies(sLocal, $cookies, $rootScope);
            api.UsuarioWS.User.Password.update({}, user, function (data) {
                vm.user = data;
                sesion.usuario = data;
                setCookies(sesion, $cookies, $rootScope);
                $state.go('app.dashboards_project');
            }, function (data) {
                delCookies($cookies, $rootScope);
                var message = (data.status === 400) ? ' translate="' + data.data + '"' : data.statusText;

                $log.debug(message);

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content"' + message + '></div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('auth.login', {
                url: '/auth/login',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/general/auth/login/login.html',
                        controller: 'AuthController as vm'
                    }
                },
                bodyClass: 'login'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/auth/login');


    }

})();


(function () {
    'use strict';

    angular
        .module('app.auth.login')
        .controller('AuthController', AuthController);

    /** @ngInject */
    function AuthController($rootScope, $auth, $state, MessageService, $mdToast, api, localStorageService, APPNAME, APPINITIALS, ICON_APP_NAME, $log, envService, $filter, $window) {
        var vm = this;
        var urlMsBase = envService.read('msConfigUrl');
        vm.urlIcons = envService.read('imagesApps') + ICON_APP_NAME;

        vm.forgetPassword = forgetPassword;
        vm.register = register;

        vm.app = {
            initials: APPINITIALS,
            name: APPNAME
        };

        vm.authenticate = function (provider) {
            document.title = APPNAME;

            localStorageService.remove('account');
            localStorageService.remove('accountc');
            $window.localStorage.removeItem('APP001_C_C');
            localStorageService.remove('circles');
            localStorageService.remove('userParameters');

            delete $rootScope.bsCircle;
            delete $rootScope.circles;
            delete $rootScope.userParameters;

            $auth.authenticate(provider)
                .then(function () {
                    getProfile(provider);
                })
                .catch(function (error) {
                    if (error.error) {
                        // Popup error - invalid redirect_uri, pressed cancel button, etc.
                        $log.debug(error.error);
                    } else if (error.data) {
                        // HTTP response error from server
                        $log.debug(error.data.message, error.status);
                    } else {
                        $log.debug(error);
                    }

                    if (error.status === 401) {
                        MessageService.showErrorMessage($filter('translate')('general.error'));
                    }

                });
        };

        function register() {
            window.location.href = urlMsBase + "public/auth/register";
        }

        function forgetPassword() {
            window.location.href = urlMsBase + "public/auth/forgot-password";
        }

        function getProfile(provider) {
            api.UsuarioWS.Yo.get({},
                function (response) {
                    var message = $filter('translate')('LOGIN_V2.SESSION_CORRECT') + provider + '!';
                    MessageService.show(message);

                    $log.debug(response);
                    $rootScope.account = response;
                    localStorageService.set('account', $rootScope.account);
                    api.GeneralWS.MyCircles.query({}, function (response) {// Success
                        $log.debug(response);
                        if (response.length <= 0) {
                            $state.go('app.errors.unauthorized');
                        } else {
                            $rootScope.bsCircle = response[0];
                            localStorageService.set('accountc', $rootScope.bsCircle);
                            if ($rootScope.bsCircle) {
                                $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
                            }
                            $rootScope.circles = response;
                            localStorageService.set('circles', $rootScope.circles);

                            $state.go('app.dashboards_project');
                        }
                    }, function (response) {// Error
                        $state.go('app.errors.unauthorized');
                    });
                },
                function (response) {
                    logoutFinish($auth, $state, 'auth.login');
                }
            );
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        // State
        $stateProvider
            .state('auth.register', {
                url: '/auth/register?companyid&email',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/general/auth/register/register.html',
                        controller: 'RegisterV2Controller as vm'
                    }
                },
                bodyClass: 'register',
                params: {
                    companyid: null,
                    email: null
                }
            });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/general/auth/register');


    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth.register')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller(api, $mdToast, $state, $mdDialog, $log) {
        var vm = this;
        // Data

        vm.UserInfo = {
            preferredUsername: {
                userName: $state.params.email !== null ? $state.params.email : null,
                password: null,
                enabled: false
            },
            name: null,
            givenName: null,
            familyName: null,
            middleName: null,
            nickname: null,
            profile: null,
            picture: null,
            website: null,
            email: null,
            emailVerified: null,
            gender: null,
            zoneinfo: null,
            locale: null,
            phoneNumber: null,
            phoneNumberVerified: null,
            birthdate: null,
            updatedTime: null
        };

        vm.passwordConfirm = null;
        vm.User = {
            account: null,
            sub: null,
            name: null
        };

        // Methods
        vm.add = add;
        vm.reboot = rebootModels;

        function add() {
            vm.UserInfo.email = vm.UserInfo.preferredUsername.userName;
            $log.debug(vm.UserInfo);
            api.UsuarioWS.UserInfo.save({ 'companyid': $state.params.companyid !== null ? $state.params.companyid : 0 }, vm.UserInfo).$promise.then(function (UserInfo) {
                $log.debug(UserInfo);

                vm.User = {
                    account: UserInfo.preferredUsername.userName,
                    sub: UserInfo.sub,
                    name: UserInfo.name
                };

                $log.debug(vm.User);
                api.GeneralWS.User.save({ 'companyid': $state.params.companyid !== null ? $state.params.companyid : 0 }, vm.User).$promise.then(function (User) {
                    $log.debug(User);
                    showMessage('Usuario creado satisfactoriamente');
                    $state.go('auth.login');
                }, function (errResponse) {
                    $log.debug(errResponse);
                    if (errResponse.status === 409) {
                        showMessage("Correo Eléctronico ya fue utilizado.");
                    }
                    rebootModels();
                });

            }, function (errResponse) {
                $log.debug(errResponse);
                if (errResponse.status === 409) {
                    showMessage("Correo Eléctronico ya fue utilizado.");
                }
                rebootModels();
            });
        }

        function rebootModels() {
            vm.UserInfo = {
                preferredUsername: { userName: '', password: null, enabled: false },
                name: null, givenName: null, familyName: null, middleName: null, nickname: null, profile: null, picture: null, website: null, email: null, emailVerified: null, gender: null, zoneinfo: null, locale: null, phoneNumber: null, phoneNumberVerified: null, birthdate: null, updatedTime: null
            };
            vm.passwordConfirm = null;
        }

        function showMessage(message) {
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top right'
            });

        }


        /**
         * Show Terms and conditions
         */

        vm.accepTermsAndConditions = function () {

            $mdDialog.show({
                controller: "AcceptTermsAndConditionController as vm",
                templateUrl: 'app/main/general/auth/register/readAccept.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false
            }).then(function (answer) {
                vm.isAcceptTermsAndConditions = answer;
            }, function () {
                vm.isAcceptTermsAndConditions = false;
            });

        };

    }


    angular
        .module('app.auth.register')
        .controller('AcceptTermsAndConditionController', AcceptTermsAndConditionController);

    /**@ngInject**/
    function AcceptTermsAndConditionController($mdDialog) {

        var vm = this;

        vm.close = function () {
            $mdDialog.cancel();
        };

        vm.accept = function () {
            $mdDialog.hide(true);
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('auth.forgot-password', {
                url: '/auth/forgot-password',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'AuthMainController as vm'
                    },
                    'content@auth.forgot-password': {
                        templateUrl: 'app/main/general/auth/forgot-password/forgot-password.html',
                        controller: 'ForgotPasswordController as vm'
                    }
                },
                bodyClass: 'forgot-password'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/auth/forgot-password');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(api, $state, $log, $mdToast, $translate) {
        // Data
        var vm = this;

        // Methods
        vm.send = send;
        //////////

        function send() {

            api.UsuarioWS.forgotPassword.update({ 'username': vm.form.email }).$promise.then(function (response) {

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content" translate="FORGOTPASSWORD.ERRORS.RESETPASS">Operacion Exitosa</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                $state.go('auth.login');

            }, function (response) {

                $log.error(response);

                var message = (response.status === 404 || response.status === 401) ? ' translate="FORGOTPASSWORD.ERRORS.' + response.status + '"' : response.statusText;

                $log.debug(message);

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content"' + message + '></div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

            });

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider
            .state('auth.lock', {
                url: '/auth/lock',
                views: {
                    'content@auth': {
                        templateUrl: 'app/main/general/auth/lock/lock.html',
                        controller: 'LockController as vm'
                    }
                },
                bodyClass: 'lock'
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/auth/lock');

    }

})();



(function () {
    'use strict';
    angular
        .module('app.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController($filter, $rootScope, api, $auth, $state, $mdToast, localStorageService, $log, APPINITIALS, APPNAME, MessageService, $window) {
        var vm = this;
        $rootScope.account = localStorageService.get('account');
        vm.userInfo = "";
        vm.isAuthenticated = false;
        vm.token = null;
        vm.credenciales = { username: $rootScope.account.userName, password: '' };

        vm.authenticate = function (provider) {
            document.title = APPNAME;

            $auth.authenticate(provider)
                .then(function () {
                    MessageService.show($filter('translate')('LOGIN_V2.SESSION_CORRECT') + provider + '!');
                    getProfile();

                })
                .catch(function (error) {
                    if (error.error) {
                        // Popup error - invalid redirect_uri, pressed cancel button, etc.
                        $log.debug(error.error);
                    } else if (error.data) {
                        // HTTP response error from server
                        $log.debug(error.data.message, error.status);
                    } else {
                        $log.debug(error);
                    }
                });
        };

        function getProfile() {
            api.UsuarioWS.Yo.get({},
                // Success
                function (response) {
                    $log.debug(response);
                    if ($rootScope.account.id !== response.id) {
                        localStorageService.remove('accountc');
                        $window.localStorage.removeItem('APP001_C_C');
                        localStorageService.remove('circles');
                        localStorageService.remove('userParameters');
                        delete $rootScope.bsCircle;
                        delete $rootScope.circles;
                        delete $rootScope.userParameters;
                    }
                    $rootScope.account = response;
                    localStorageService.set('account', $rootScope.account);
                    $state.go('app.dashboards_project');
                },
                // Error
                function (response) {
                    console.error(response);
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.directives', [])
        .config(config);

    /** @ngInject */
    function config() {

    }
})();

(function () {

    'use strict';

    angular
        .module('app.public', [])
        .config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/public/');

        $stateProvider
            .state('public', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'PublicController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content', {
                url: '/public',
                views: {
                    'content@public': {
                        templateUrl: 'app/main/public/start-page/start-page.html',
                        controller: 'StartPageController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.index', {
                url: '/index',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/apps-list/apps-list.html',
                        controller: 'AppsListController',
                        controllerAs: 'appsListCtrl'
                    }
                }
            })
            .state('public.content.licitador', {
                url: '/licitador',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/licitador.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.compras', {
                url: '/compras',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/compras.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.presupuestos', {
                url: '/presupuestos',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/presupuestos.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.productos', {
                url: '/productos',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/productos.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.tickets', {
                url: '/tickets',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/tickets.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.activosfijos', {
                url: '/ActivosFijos',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/activosFijos.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.clientes', {
                url: '/Clientes',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/clientes.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.corporativo', {
                url: '/Corporativo',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/corporativo.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.oms', {
                url: '/Oms',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/oms.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.pos', {
                url: '/pos',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/pos.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.inventario', {
                url: '/Inventario',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/inventario.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.tarjetaderegalo', {
                url: '/TarjetaRegalo',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/tarjetaderegalo.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.fms', {
                url: '/FMS',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/fms.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.wms', {
                url: '/WMS',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/info-apps/wms.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    }
                }
            })
            .state('public.content.auth', {
                url: '/auth',
                abstract: true
            })
            .state('public.content.auth.register', {
                url: '/register?companyid&email',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/auth/register/register.html',
                        controller: 'AuthRegisterController',
                        controllerAs: 'registerCtrl'
                    }
                },
                params: {
                    companyid: null,
                    email: null
                }
            })
            .state('public.content.auth.forgot-password', {
                url: '/forgot-password',
                views: {
                    'startPageContentView@public.content': {
                        templateUrl: 'app/main/public/auth/forgot-password/forgot-password.html',
                        controller: 'AuthForgotPasswordController',
                        controllerAs: 'forgotPasswordCtrl'
                    }
                }
            });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.public')
        .controller('AuthRegisterController', authRegisterController);

    /**@ngInject**/
    function authRegisterController($scope, api, $mdToast, $state, $mdDialog, $log, MessageService) {

        var registerCtrl = this;

        // Methods
        registerCtrl.add = add;
        registerCtrl.reboot = rebootModels;
        registerCtrl.login = login;
        registerCtrl.accepTermsAndConditions = accepTermsAndConditions;

        function createUserInfoObject() {

            registerCtrl.UserInfo = {
                preferredUsername: {
                    userName: $state.params.email !== null ? $state.params.email : null,
                    password: null,
                    enabled: false
                },
                name: null,
                givenName: null,
                familyName: null,
                middleName: null,
                nickname: null,
                profile: null,
                picture: null,
                website: null,
                email: null,
                emailVerified: null,
                gender: null,
                zoneinfo: null,
                locale: null,
                phoneNumber: null,
                phoneNumberVerified: null,
                birthdate: null,
                updatedTime: null
            };

            registerCtrl.passwordConfirm = null;
            registerCtrl.User = { account: null, sub: null };

        }

        function add() {

            $scope.$parent.vm.isShowProgressLinear = true;

            registerCtrl.UserInfo.email = registerCtrl.UserInfo.preferredUsername.userName;

            $log.debug(registerCtrl.UserInfo);

            api.UsuarioWS.UserInfo.save({ 'companyid': $state.params.companyid !== null ? $state.params.companyid : 0 }, registerCtrl.UserInfo).$promise.then(function (UserInfo) {

                $log.debug(UserInfo);

                registerCtrl.User = {
                    account: UserInfo.preferredUsername.userName,
                    sub: UserInfo.sub,
                    name: UserInfo.name,
                    password: registerCtrl.UserInfo.preferredUsername.password
                };

                $log.debug(registerCtrl.User);

                api.GeneralWS.User.save({ 'companyid': $state.params.companyid !== null ? $state.params.companyid : 0 }, registerCtrl.User).$promise.then(function (User) {
                    $log.debug(User);

                    MessageService.show('Usuario creado satisfactoriamente, revise su correo electronico para confirmar usuario');

                    $scope.$parent.vm.isShowProgressLinear = false;

                    $state.go('public.content.index');

                }, function (errResponse) {

                    $scope.$parent.vm.isShowProgressLinear = false;

                    $log.debug(errResponse);
                    if (errResponse.status === 409) {
                        MessageService.show("Correo Eléctronico ya fue utilizado.");
                    }

                    createUserInfoObject();

                });

            }, function (errResponse) {
                $log.debug(errResponse);
                if (errResponse.status === 409) {
                    MessageService.show("Correo Eléctronico ya fue utilizado.");
                }
                createUserInfoObject();
            });
        }

        function rebootModels() {
            registerCtrl.UserInfo = {
                preferredUsername: { userName: '', password: null, enabled: false },
                name: null, givenName: null, familyName: null, middleName: null, nickname: null, profile: null, picture: null, website: null, email: null, emailVerified: null, gender: null, zoneinfo: null, locale: null, phoneNumber: null, phoneNumberVerified: null, birthdate: null, updatedTime: null
            };
            registerCtrl.passwordConfirm = null;
        }

        function login() {

            $scope.$parent.vm.authenticate('OIDC');

        }


        /**
         * Show Terms and conditions
         */

        function accepTermsAndConditions() {

            $mdDialog.show({
                controller: function ($mdDialog) {

                    var termsCtrl = this;

                    termsCtrl.close = function () {
                        $mdDialog.cancel();
                    };

                    termsCtrl.accept = function () {
                        $mdDialog.hide(true);
                    };

                },
                controllerAs: 'termsCtrl',
                templateUrl: 'app/main/public/auth/register/readAccept.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                escapeToClose: false
            }).then(function (answer) {
                registerCtrl.isAcceptTermsAndConditions = answer;
            }, function () {
                registerCtrl.isAcceptTermsAndConditions = false;
            });
        }

        createUserInfoObject();

    }

})();


(function () {

    'use strict';

    angular
        .module('app.public')
        .controller('AuthForgotPasswordController', authForgotPasswordController);

    /**@ngInject**/
    function authForgotPasswordController(api, $state, $log, $mdToast, $translate, MessageService, $filter) {

        // Data
        var forgotPasswordCtrl = this;

        // Methods
        forgotPasswordCtrl.send = send;
        //////////

        function send() {

            api.UsuarioWS.forgotPassword.update({ 'username': forgotPasswordCtrl.form.email }).$promise.then(function (response) {

                MessageService.show($filter('translate')('FORGOTPASSWORD.ERRORS.RESETPASS'));

                $state.go('public.content.index');

            }, function (response) {

                $log.error(response);

                var message = (response.status === 404 || response.status === 401) ? ' FORGOTPASSWORD.ERRORS.' + response.status + '' : response.statusText;

                $log.debug(message);

                MessageService.show($filter('translate')(message));

            });

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.usr')
        .controller('UsersRolesController', UsersRolesController);

    /** @ngInject */
    function UsersRolesController(api, $rootScope, $filter) {

        var vm = this;

        vm.isShowFilter = true;
        vm.masterColumnDefs = [];

        vm.masterGridOptions = {
            pivotMode: true,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            fullWidthCellRenderer: true,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        //metodos
        vm.search = search;
        vm.clearSearchGroup = clearSearchGroup;

        function addColumnsToGrid() {
            vm.masterColumnDefs = [
                {
                    headerName: $filter('translate')('reporUsersRoles.usuario'),
                    field: "usuario",
                    width: 400,
                    enableRowGroup: true,
                    hide: false,
                    enablePivot: true,
                    rowGroup: true,
                    rowGroupIndex: 1,
                    suppressFilter: false
                },
                {
                    headerName: 'Role',
                    field: "roleDescription",
                    width: 300,
                    enableRowGroup: true,
                    enablePivot: true,
                    pivot: true,
                    pivotIndex: 0
                },
                {
                    headerName: '',
                    field: "cantidad",
                    width: 150,
                    enableRowGroup: true,
                    enablePivot: true,
                    aggFunc: 'sum',
                    cellRenderer: function (params) {
                        if (params.value === 1) {
                            return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
                        } else {
                            return "";
                        }
                    }
                }
            ];

            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }


        function search() {
            addColumnsToGrid();
            vm.masterGridOptions.api.setRowData([]);

            vm.isShowProgressLinear = true;
            api.GeneralWS.BusinessCircleMembers.allMembers.query({ company: $rootScope.bsCircle.company.id, app: vm.appId }, function (response) {
                vm.showGrid = true;
                vm.isShowProgressLinear = false;

                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(response)
                    .select(function (r) {
                        var d = r;
                        d.usuario = d.userName + '(' + d.userAccount + ')';
                        d.cantidad = 1;
                        return d;
                    })
                );
            }, function (d) {
            });

            vm.isShowFilter = false;
        }

        function init() {

            //apps
            api.GeneralWS.CompanyApplication.me.query({ company: $rootScope.bsCircle.company.id }, function (response) {
                vm.applications = response;
            }, function (d) {
            });

            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchGroupInput = document.querySelector("#searchGroupInput");

            if (searchGroupInput) {
                searchGroupInput.addEventListener("keydown", keyEvent);
            }

            vm.onExportXLS = function () {
                var params = {
                    skipHeader: false,
                    skipFooters: false,
                    skipGroups: false,
                    allColumns: true,
                    onlySelected: false,
                    fileName: 'ReporteUsuariosRoles' + new Date().getTime() + '.xls',
                    columnSeparator: ',',
                    sheetName: 'data'
                };

                params.processCellCallback = function (params) {
                    return agGridFormatToExport(params);
                };

                vm.masterGridOptions.api.exportDataAsExcel(params);
            };

        }

        function clearSearchGroup() {
            vm.searchGroupInput = "";
        }

        init();

    }
})();

(function () {
  'use strict';

  angular
    .module('app.usr')
    .controller('UserGuestController', UserGuestController);

  /** @ngInject */
  function UserGuestController(api, $mdToast, $scope, $log, $rootScope, $filter, $mdConstant, MessageService, $timeout) {

    var vm = this;

    vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    vm.loading = true;
    vm.invitationContacts = [];
    vm.company = $rootScope.bsCircle.company;
    vm.pageSize = 50;
    vm.pageNumber = 1;

    vm.getData = getData;
    vm.getRoles = getRoles;
    vm.getGuest = getGuest;


    vm.columnDefs = [
      {
        field: 'email',
        headerName: 'guest.email',
        headerCellRenderer: getHeader,
        width: 200
      },
      {
        field: 'rolDescription',
        headerName: 'guest.role',
        headerCellRenderer: getHeader,
        width: 200
      },
      {
        field: 'active',
        headerName: 'guest.registrado',
        headerCellRenderer: getHeader,
        width: 125,
        cellRenderer: function (params) {
          if (params.value) {
            return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
          } else {
            return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
          }
        },
        cellStyle: { 'padding': '5px' }
      },
      {
        name: 'send',
        headerName: 'guest.reenviarInvitacion',
        headerCellRenderer: getHeader,
        width: 200,
        cellRenderer: function (params) {
          return '<center> <md-button class="md-icon-button" ng-click="vm.sendInvitation(data)"> <md-icon md-font-icon="icon-send"></md-icon> <md-tooltip md-direction="left">{{"guest.SEND_INVITATION"| translate}}</md-tooltip> </md-button> </center>';
        },
        cellStyle: { 'padding': '2px' }
      }
    ];

    vm.pagination = {
      pageNumber: 0,
      pageSize: 50,
      totalElements: 0,
      totalPages: 0,
    };

    vm.masterGridOptions = {
      paginationPageSize: vm.pagination.pageSize,
      rowSelection: 'multiple',
      rowDeselection: true,
      rowModelType: 'enterprise',
      cacheBlockSize: vm.pagination.pageSize,
      pagination: true,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowHeight: 40,
      enableColResize: true,
      rowData: [],
      getMainMenuItems: function (params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function (key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      }
    };


    function init() {
      getData();
    }

    //apps
    function getData() {
      api.GeneralWS.CompanyApplication.me.query({ company: $rootScope.bsCircle.company.id }, function (response) {
        vm.applications = response;
      }, function (d) {
      });
      vm.masterGridOptions.api.setColumnDefs(vm.columnDefs);
      getGuest();
    }
    function getGuest() {
      var dataSource = {
        paginationPageSize: vm.pagination.pageSize,
        getRows: function (params) {
          vm.isShowProgressLinear = true;
          vm.pagination.pageNumber = params.request.endRow / vm.pagination.pageSize;
          api.GeneralWS.UserGuest.byCompany.page({
            'company': $rootScope.bsCircle.company.id,
            'pageNumber': (vm.pagination.pageNumber),
            'pageSize': vm.pagination.pageSize,
          }).$promise.then(function (response) {
            vm.pagination.totalElements = response.totalElements;
            vm.pagination.totalPages = response.totalPages;
            vm.pagination.pageSize = response.size;
            $rootScope.loadingProgress = false;
            vm.isShowProgressLinear = false;
            params.successCallback(response.content, response.totalElements);
            vm.showGrid = true;

          }, function (response) {
            $rootScope.loadingProgress = false;
            $log.error(response);
          });
        }
      };
      vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);

    }

    function getRoles() {
      vm.isShowProgressLinearRoles = true;
      vm.roles = [];
      api.GeneralWS.RoleApplication.byLevel.query({ applicationId: vm.appId, level: $rootScope.bsCircle.role.roleLevel }, function (response) {
        vm.roles = response;
        vm.isShowProgressLinearRoles = false;
      }, function (d) {
        vm.isShowProgressLinearRoles = false;
      });
    }

    // Methods
    $scope.originform = angular.copy($scope.company);

    //////////

    vm.sendInvitation = function (reSend) {

      if (reSend) {
        vm.invitationContacts.push(reSend.email);
        vm.rolId = reSend.idRoleApplication;
      }

      if (vm.invitationContacts.length === 0) {
        $log.debug("No contacts");
        return false;
      }

      if (!vm.rolId) {
        $log.debug("No rolid");
        MessageService.show($filter('translate')('guest.selectRole'));
        return false;
      }

      if (vm.rolId <= 0) {
        $log.debug("No rolid <= 0");
        MessageService.show($filter('translate')('guest.selectRole'));
        return false;
      }

      vm.loading = true;
      api.GeneralWS.UserInvitation.sendInvitation({ 'companyid': vm.company.id, 'rol': vm.rolId }, vm.invitationContacts, function (response) {
        vm.loading = false;

        vm.invitationContacts = [];
        getGuest();

        MessageService.show($filter('translate')('guest.INVITATION_SEND_SUCCESSFULLY'));

      }, function (response) {
        vm.loading = false;
        MessageService.showErrorMessage($filter('translate')('guest.errorONSend'));
      });

    };

    vm.validateEmailChip = function ($chip) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test($chip)) {
        return $chip;
      } else {
        return null;
      }
    };

    $timeout(init, 1000);
  }
})();




(function () {

  'use strict';

  angular
    .module('app.usr')
    .controller('AssociateRolJobHrController', associateRolJobHr);

  /**@ngInject**/
  function associateRolJobHr($rootScope, $log, api, MessageService, $filter, $timeout, $mdDialog) {

    var vm = this;
    vm.add = add;
    vm.onDelete = onDelete;
    vm.cancel = cancel;
    vm.getApplication = getApplication;
    vm.getRol = getRol;
    vm.getCompanyRolJobByRolApp = getCompanyRolJobByRolApp;
    vm.getCompanyRolJob = getCompanyRolJob;
    vm.buildDataRoleJob = buildDataRoleJob;
    vm.buildDataRoleJobByJobHrId = buildDataRoleJobByJobHrId;
    vm.getRoleApplication = getRoleApplication;
    vm.getAllAssociateRoleApp = getAllAssociateRoleApp;
    vm.getCompanyRolJobByJobHrIdList = getCompanyRolJobByJobHrIdList;
    vm.getAllRoleApplication = getAllRoleApplication;
    vm.findByApplication = findByApplication;
    vm.findByAllFilters = findByAllFilters;
    vm.findByJobHrId = findByJobHrId;
    vm.initEvents = initEvents;
    vm.initEventRol = initEventRol;
    vm.initEventJob = initEventJob;
    vm.clearSearchApplicationInput = clearSearchApplicationInput;
    vm.clearSearchRolInput = clearSearchRolInput;
    vm.clearSearchJobInput = clearSearchJobInput;
    vm.search = search;
    vm.edit = edit;
    vm.appId = 0;
    vm.roleId = 0;
    vm.jobHrId = '';
    vm.companyRolJob = [];
    vm.dataGrid = [];


    vm.showButton = false;

    vm.dinamicStyle = {
      'width': '30%',
      'height': '70%'
    };
    vm.loadingRoleApplication = false;
    var columnDefs = [
      {
        field: 'nameRol',
        headerName: 'associateRoleJobHR.name',
        headerCellRenderer: getHeader,
        width: 500
      },
      {
        field: 'descripcionRol',
        headerName: 'associateRoleJobHR.description',
        headerCellRenderer: getHeader,
        width: 200,
      },
      {
        field: 'codigoPuesto',
        headerName: 'associateRoleJobHR.jobCode',
        headerCellRenderer: getHeader,
        width: 200,
      },
      {
        field: 'active',
        headerName: 'associateRoleJobHR.active',
        headerCellRenderer: getHeader,
        width: 70,
        cellRenderer: function (params) {
          if (params.value) {
            return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" ' +
              'aria-label="chk"></md-checkbox></center>';
          } else {
            return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
          }
        },
        cellStyle: {'padding': '5px'}
      },
      {
        name: "edit",
        headerName: 'associateRoleJobHR.edit',
        headerCellRenderer: getHeader,
        width: 70,
        cellRenderer: function () {
          return '<center> '
            + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
            + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">' +
            '{{"general.edit"| translate}}</md-tooltip> '
            + ' </md-button> </center>';
        },
        cellStyle: {'padding': '2px'}
      }
    ];

    vm.roleJobGrid = {
      columnDefs: columnDefs,
      angularCompileRows: true,
      angularCompileHeaders: true,
      rowSelection: 'multiple',
      rowModelType: '',
      enableColResize: true,
      enableSorting: true,
      animateRows: true,
      rowHeight: 45,
      rowData: [],
      getMainMenuItems: function (params) {
        return getHeaderMenu(params, $filter);
      },
      localeTextFunc: function (key, defaultValue) {
        return translateGrid(key, defaultValue, $filter);
      }
    };

    function getApplication() {
      vm.loadingRoleApplication = true;
      api.GeneralWS.CompanyApplication.appsByCompany.query({
        'company': $rootScope.bsCircle.company.id,
      }).$promise.then(function (resp) {
        vm.roleApplications = resp;
        vm.loading = false;
        vm.loadingRoleApplication = false;
      }, function (err) {
        vm.loadingRoleApplication = false;
        vm.loading = false;
        $log.error(err);
      });
    }

    function getRol(appId) {
      vm.loadingRoleApplication = true;
      api.GeneralWS.RoleApplication.me.get({
        'applicationId': appId,
      }).$promise.then(function (resp) {
        vm.role = resp;
        vm.loading = false;
        vm.loadingRoleApplication = false;
      }, function (err) {
        vm.loadingRoleApplication = false;
        vm.loading = false;
        $log.error(err);
      });
    }

    function clearSearchApplicationInput() {
      vm.searchApplicationInput = "";
    }

    function clearSearchRolInput() {
      vm.clearSearchRolInput = "";
    }

    function clearSearchJobInput() {
      vm.searchJobInput = "";
    }

    function initEventJob() {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchJobInput = document.querySelector("#searchJobInput");

      if (searchJobInput) {
        searchJobInput.addEventListener("keydown", keyEvent);
      }
    }

    function initEventRol() {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var clearSearchRolInput = document.querySelector("#clearSearchRolInput");

      if (clearSearchRolInput) {
        clearSearchRolInput.addEventListener("keydown", keyEvent);
      }
    }

    function initEvents() {
      var keyEvent = function (event) {
        event.stopPropagation();
      };

      var searchApplicationInput = document.querySelector("#searchApplicationInput");

      if (searchApplicationInput) {
        searchApplicationInput.addEventListener("keydown", keyEvent);
      }
    }

    function search() {
      vm.dataGrid = [];
      if (vm.jobHrId === null || vm.jobHrId === '' && vm.appId && vm.roleId.id) {
        vm.getCompanyRolJobByRolApp(vm.roleId.id);

      } else {
        vm.findByAllFilters();
      }
    }

      function findByApplication(){
      if (vm.roleId.id === null || vm.roleId.id === '' || vm.jobHrId == null || vm.jobHrId === '' && vm.appId) {
        vm.getRoleApplication();
      }
        }

      function findByAllFilters() {
        if (vm.jobHrId && vm.roleId.id && vm.appId) {
          vm.getCompanyRolJob(vm.roleId.id, vm.jobHrId);
        } else if (vm.appId === null || vm.appId === '' && vm.roleId.id === '' || vm.roleId.id == null && vm.jobHrId) {
          vm.getCompanyRolJobByJobHrIdList(vm.jobHrId);
        } else {
          vm.findByApplication();
        }
      }

      function findByJobHrId() {
        if (vm.appId === null || vm.appId === '' && vm.roleId.id === '' || vm.roleId.id == null && vm.jobHrId) {
          vm.getCompanyRolJobByJobHrIdList(vm.jobHrId);
        }
      }

      function getCompanyRolJobByJobHrIdList(id) {
        vm.isShowProgressLinear = true;
        api.UserWS.getListCompanyByJobAndRolApp.byJobHr
          .get({'id': id}).$promise.then(function (resp) {
          vm.companyRolJobByJobHr = resp;
          vm.loading = false;
          vm.loadingRoleApplication = false;
          vm.isShowProgressLinear = false;
          vm.buildDataRoleJobByJobHrId();
        }, function (err) {
          vm.loadingRoleApplication = false;
          vm.loading = false;
          $log.error(err);
        });
      }

      function getCompanyRolJob() {
        vm.isShowProgressLinear = true;
        api.UserWS.getCompanyByJobAndRolApp.byJobAndRolApp
          .get({ 'jobId': vm.jobHrId ,
            'rolApp': vm.roleId.id}).$promise.then(function (resp) {
          vm.companyRolJobByJobHr = resp;
          vm.isShowProgressLinear = false;
          vm.loading = false;
          vm.loadingRoleApplication = false;
          vm.buildDataRoleJobByJobHrId();
        }, function (err) {
          vm.loadingRoleApplication = false;
          vm.loading = false;
          $log.error(err);
        });
      }

      function getCompanyRolJobByRolApp(){
        vm.isShowProgressLinear = true;
        api.UserWS.getListCompanyByRolApp.byRolApp.get({
          'id': vm.roleId.id
        }).$promise.then(function (resp) {
          vm.companyRolJobByJobHr = resp;
          vm.loading = false;
          vm.isShowProgressLinear = false;
          vm.loadingRoleApplication = false;
          vm.buildDataRoleJobByJobHrId();
        }, function (err) {
          vm.loadingRoleApplication = false;
          vm.loading = false;
          $log.error(err);
        });
      }

      function getRoleApplication(){
        vm.isShowProgressLinear = true;
        api.GeneralWS.RoleApplication.me.get({
          'applicationId': vm.appId
          }).$promise.then(function (resp) {
          vm.rolApplicationbyAppId = resp;
          vm.loading = false;
          vm.isShowProgressLinear = false;
          vm.loadingRoleApplication = false;
          vm.buildDataRoleJob();
        }, function (err) {
          vm.loadingRoleApplication = false;
          vm.loading = false;
          $log.error(err);
        });
      }



      function getAllAssociateRoleApp(){
        api.UserWS.getListAllCompanyRolApp.allRolApp.query({}).$promise.then(function (resp){
          vm.associateRoleApp = resp;
          vm.loading = false;
          vm.loadingRoleApplication = false;
        }, function (err) {
          vm.loadingRoleApplication = false;
          vm.loading = false;
          $log.error(err);
        });

      }

      function getAllRoleApplication(){
        api.GeneralWS.CompanyApplication.companyRoleApplication.query({
          'companyId': $rootScope.bsCircle.company.id }).$promise.then(function (resp) {
          vm.allRoleApplication = resp;
          vm.loading = false;
          vm.loadingRoleApplication = false;
        }, function (err) {
          vm.loadingRoleApplication = false;
          vm.loading = false;
          $log.error(err);
        });
      }

      function buildDataRoleJobByJobHrId(){
        vm.isShowProgressLinear = true;

        for(var i=0;i<vm.companyRolJobByJobHr.length;i++) {
          const value = vm.companyRolJobByJobHr[i];
          for(var j=0;j<vm.allRoleApplication.length;j++) {
            const val = vm.allRoleApplication[j];
            if (value.rolApplicationId === val.roleApplicationId && value.rolApplicationId != null &&
              val.roleApplicationId !=null) {


              vm.dataGrid.push({
                id: value.id,
                nameRol: val.roleName,
                codigoPuesto: value.jobHrId,
                descripcionRol: val.roleDescription,
                rolId: val.roleApplicationId,
                active: value.active,
                appName: val.applicationId
              });

            }
          }
        }

        vm.roleJobGrid.api.setRowData(vm.dataGrid);
        vm.isShowProgressLinear = false;
        vm.showGrid = true;
        vm.isShowFilter = false;
      }

      function buildDataRoleJob() {
        vm.isShowProgressLinear = true;
        vm.dataGrid = [];
        vm.associateRoleApp.forEach(function (value) {
          var arrFiltered = buildData(value);
          Array.prototype.push.apply(vm.dataGrid, arrFiltered);
        });

        vm.roleJobGrid.api.setRowData(vm.dataGrid);
        vm.isShowProgressLinear = false;
        vm.showGrid = true;
        vm.isShowFilter = false;

      }

      function buildData(value) {
      if (value.rolApplicationId > 0) {
        return vm.rolApplicationbyAppId
          .filter(function (vl) {
            return value.rolApplicationId === vl.id && value.rolApplicationId != null && vl.id != null;
          })
          .map(function (mpVal) {
            return {
              id: value.id,
              nameRol: mpVal.name,
              codigoPuesto: value.jobHrId,
              descripcionRol: mpVal.description,
              rolId: mpVal.id,
              active: value.active,
              appName: mpVal.aplication.id
            };
          });
      } else {
        return {
          id: value.id,
          nameRol: value.roleName,
          codigoPuesto: value.jobHrId,
          descripcionRol: value.roleDescription,
          rolId: value.roleApplicationId,
          active: value.active,
          appName: value.applicationId
        };
      }
      }

      function add() {

        $mdDialog.show({
          controller: 'AssociateRolJobDialogController',
          controllerAs: 'vm',
          width: 800,
          height: 500,
          templateUrl: 'app/main/apps/usr/associate-role-jobhr/associate-role-jobhr-dialog/associateRolJobHrDialog.html',
          parent: angular.element('#main'),
          clickOutsideToClose: false,
          locals: {
            'companyRolJobData':  {
              'applicationData': vm.roleApplications,
              'roles': vm.role,
              'applicationId': vm.appId,
              'disabledData': true,
              'rolApplicationId': vm.roleId.id,
              'name': '',
              'description': '',
              'active': false
            }
          }
        }).then(function (response) {
          if(response) {
            vm.dataGrid.forEach(function (item) {
              var id = item.id;
              var name = response.name;
              if (response.id === id) {
                id = response.id;
                item.nameRol = name;
                item.codigoPuesto = response.jobHrId;
                item.descripcionRol = response.description;
                item.rolId = response.roleApplicationId;
                item.active = response.active;
                item.appName = response.applicationId;
              }
            });
            vm.dataGrid.push({
              id: response.id,
              nameRol: response.name,
              codigoPuesto: response.jobHrId,
              descripcionRol: response.description,
              rolId: response.rolApplicationId,
              active: response.active,
              appName: response.applicationId,
            });
            vm.roleJobGrid.api.setRowData(vm.dataGrid);
            vm.roleJobGrid.api.refreshView();
          }
        });
      }

      function cancel() {
        $mdDialog.cancel();
      }


      function edit(companyRolJobByJobHr) {
        $mdDialog.show({
          controller: 'AssociateRolJobDialogController',
          controllerAs: 'vm',
          width: 800,
          height: 500,
          templateUrl: 'app/main/apps/usr/associate-role-jobhr/associate-role-jobhr-dialog/associateRolJobHrDialog.html',
          parent: angular.element('#main'),
          clickOutsideToClose: false,
          locals: {
            'companyRolJobData': {
              'id': companyRolJobByJobHr.id,
             'active': companyRolJobByJobHr.active,
              'companyId': $rootScope.bsCircle.company.id,
              'applicationId': companyRolJobByJobHr.appName,
             'rolApplicationId': companyRolJobByJobHr.rolId,
              'jobHrId': companyRolJobByJobHr.codigoPuesto,
              'applicationData': vm.roleApplications,
              'roles': vm.role,
              'description': companyRolJobByJobHr.descripcionRol,
              'name': companyRolJobByJobHr.nameRol,
              'disabledData': false
            }
          }
        }).then(function (response) {
          if(response && vm.rolApplicationbyAppId > 0) {
            var respBuilder = buildData(response);
            respBuilder.forEach(function (r) {
              vm.dataGrid.forEach(function (rl) {
                if (r.id === rl.id) {
                  rl.active = r.active;
                  rl.appName = r.appName;
                  rl.codigoPuesto = r.codigoPuesto;
                  rl.descripcionRol = r.descripcionRol;
                  rl.id = r.id;
                  rl.nameRol = r.nameRol;
                  rl.rolId = r.rolId;
                }
              });
            });
          } else {
              vm.dataGrid.forEach(function (item) {
                if (response.id === item.id) {
                  item.id = response.id;
                  item.nameRol = response.name;
                  item.codigoPuesto = response.jobHrId;
                  item.descripcionRol = response.description;
                  item.rolId = response.rolApplicationId;
                  item.active = response.active;
                  item.appName = response.applicationId;
                }
              });
          }
          vm.roleJobGrid.api.setRowData(vm.dataGrid);
          vm.roleJobGrid.api.refreshView();
          });
      }

      function onDelete(companyRolJob) {
        companyRolJob.active = false;

        var promise;
        promise = api.UserWS.CompanyRolJob.meUpdate.deleteJob({ 'id': companyRolJob.id}, companyRolJob).$promise;

        promise.then(function (response) {
          vm.isShowProgressLinear = true;
          vm.isShowProgressLinear = false;
          vm.roleJobGrid.api.forEachNode(function (row, index) {
              if (row.data.id === response.id) {
                row.data = response;
              }
            });
          vm.roleJobGrid.api.refreshView();
            MessageService.show($filter('translate')('associateRoleJobHR.associateDeletedSuccessfully'));

        }, function (response) {
          vm.isShowProgressLinear = false;
          $log.error(response);
          MessageService.showErrorMessage($filter('translate')('general.general_error'));
        });
      }

      function init() {
        if (vm.appId === null){

        }
        vm.isShowFilter = true;
        vm.isShowProgressLinear = true;
        vm.getApplication();
        vm.getAllRoleApplication();
        vm.getAllAssociateRoleApp();
        vm.initEvents();
        vm.initEventRol();
        vm.initEventJob();
          vm.isShowProgressLinear = false;
      }

      $timeout(function () {
        init();
      }, 1000);

      vm.dtOptions = {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        columnDefs: [
          {
            // Target the id column
            targets: 0
          },
          {
            // Target the actions column
            targets: 4,
            responsivePriority: 1,
            filterable: true,
            sortable: false
          }
        ],
        order: [[0, 'desc']],
        pagingType: 'simple',
        paging: false,
        responsive: true
      };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.usr')
        .controller('ReportApplicationByUserController', ReportApplicationByUserController);

    /** @ngInject */
    function ReportApplicationByUserController(api, $rootScope, $filter, $timeout) {

        const vm = this;

        vm.isShowFilter = true;
        vm.masterColumnAppByUserDefs = [];

        vm.masterGridOptionsAppByUser = {
            pivotMode: true,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            toolPanelSuppressGroups: true,
            fullWidthCellRenderer: true,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            autoGroupColumnDef: {
                headerName: $filter('translate')('reporUsersRoles.usuario'), width: 400,
                valueFormatter: 'usuario'
            },
        };

        //metodos
        vm.search = search;

        function addColumnsToGrid() {
            vm.masterColumnAppByUserDefs = [
                {
                    headerName: $filter('translate')('reporUsersRoles.usuario'),
                    field: "usuario",
                    width: 100,
                    rowGroupIndex: 1,
                    suppressFilter: false,
                    enableRowGroup: true,
                    hide: false,
                    enablePivot: true,
                    rowGroup: true
                },
                {
                    headerName: '',
                    field: "appName",
                    pivotIndex: 0,
                    enableRowGroup: true,
                    enablePivot: true,
                    pivot: true
                },
                {
                    headerName: '',
                    field: "number",
                    width: 150,
                    aggFunc: 'sum',
                    enableRowGroup: true,
                    enablePivot: true,
                    cellRenderer: function (params) {
                        if (params.value === 1) {
                            return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
                        } else {
                            return "";
                        }
                    }
                }
            ];
            vm.masterGridOptionsAppByUser.api.setColumnDefs(vm.masterColumnAppByUserDefs);
        }

        function search() {
            addColumnsToGrid();
            vm.masterGridOptionsAppByUser.api.setRowData([]);

            vm.isShowProgressLinear = true;
            api.GeneralWS.allApplicationsByUser.get({ companyId: $rootScope.bsCircle.company.id }, function (response) {
                vm.showGrid = true;
                vm.masterGridOptionsAppByUser.api.setRowData(new jinqJs()
                    .from(response)
                    .select(function (r) {
                        r.usuario = r.userName;
                        return r;
                    })
                );
                vm.isShowProgressLinear = false;
            });

            vm.isShowFilter = false;
        }

        function init() {

            vm.exportXLS = function () {
                const params = {
                    skipHeader: false,
                    skipFooters: false,
                    skipGroups: false,
                    allColumns: true,
                    onlySelected: false,
                    fileName: 'ReporteAppsByUser' + new Date().getTime() + '.xls',
                    columnSeparator: ',',
                    sheetName: 'data'
                };
                params.processCellCallback = function (paramsData) {
                    return agGridFormatToExport(paramsData);
                };

                vm.masterGridOptionsAppByUser.api.exportDataAsExcel(params);
            };


            $timeout(function () {
                search();
            }, 1000);

        }

        init();

    }
})();

(function () {
    'use strict';

    angular
        .module('app.groupFavorite', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

        $stateProvider
            .state('app.groupFavorite', {
                url: '/apps/GroupFavorite',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/providers/providers.html',
                        controller: 'GroupFavoriteController as vm'
                    }
                }
            })
            .state('app.groupFavorite.providers', {
                url: '/provider/:favoriteGroupId',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/providers/detail/detail.html',
                        controller: 'GroupEditorController as vm'
                    }
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/apps/providers');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.groupFavorite')
        .controller('GroupEditorController', GroupEditorController);

    /** @ngInject */
    function GroupEditorController(api, envService, $log, $state, $rootScope, $mdDialog, $timeout, $document, $mdToast, $filter, $stateParams, $scope) {

        var vm = this;
        vm.arrMembersToDelete = [];
        vm.page = 1;
        vm.pageM = 1;
        vm.pageSize = 50;
        vm.pageSizeM = 50;
        vm.selectedTab = 0;
        vm.ModifyNameGroup = true;
        $rootScope.snThread = true;
        var company = $rootScope.bsCircle.company;
        vm.favoriteProvider = {
            name: ''
        };
        vm.baseUrlSharedFiles = envService.read('baseUrlSharedFiles');

        //Methods
        vm.saveHeader = saveHeader;
        vm.addMembers = addMembers;
        vm.addMember = addMember;
        vm.deleteMember = deleteMember;
        vm.loadCompaniesAvailable = loadCompaniesAvailable;
        vm.activeSearchMem = activeSearchMem;
        vm.activeSearchAll = activeSearchAll;
        vm.loadMembersList = loadMembersList;
        vm.selectedArray = [];
        vm.selectedAssociatedArray = [];
        vm.toggle = toggle;
        vm.toggleAssociated = toggleAssociated;


        init();

        //////////

        function init() {
            if ($stateParams.favoriteGroupId) {
                api.GeneralWS.AllFavoriteGroup.get({ id: $stateParams.favoriteGroupId, idCircle: $rootScope.bsCircle.id }, function (data) {
                    vm.group = data;
                    vm.ModifyNameGroup = false;
                    loadCompanies();
                });
            } else {
                vm.allGroupType = [];
                api.GeneralWS.AllFavoriteGroupType.query({}, function (response) {
                    vm.allGroupType = response;
                }, function (responseErr) {
                    $log.error(responseErr);
                });
            }
        }
        function activeSearchAll() {
            vm.searchModeAll = true;
            $timeout(function () {
                $('#searchFieldAll').focus();
            });
        }
        activeSearchAll();
        function activeSearchMem() {
            vm.searchModeMem = true;
            $timeout(function () {
                $('#searchFieldMem').focus();
            });
        }
        activeSearchMem();

        function loadCompanies() {
            if (vm.group && vm.group.id) {
                loadCompaniesAvailable(1);
                loadMembersList(1);
            }
        }
        /// companys
        function loadCompaniesAvailable(page, filter) {
            page--;
            api.GeneralWS.CompaniesGroup.get({ group: vm.group.id, listAll: true, page: page, size: 50, filter: filter, idCircle: $rootScope.bsCircle.id },
                function (data) {
                    vm.allCompany = data;
                },
                function (error) {

                }
            );
        }
        //members
        function loadMembersList(page, filter) {
            page--;
            api.GeneralWS.CompaniesGroup.get({ group: vm.group.id, page: page, size: 50, filter: filter, idCircle: $rootScope.bsCircle.id },
                function (data) {
                    vm.membersList = data;
                },
                function (error) {

                }
            );
        }


        function saveHeader() {
            var isNew = vm.group.id;
            if (!isNew) {
                var groupType = 0;
                if ($rootScope.valorNuevo) {
                    groupType = $rootScope.valorNuevo;
                } else {
                    groupType = vm.stateId;
                }
                api.GeneralWS.AllFavoriteGroup.save({ idCircle: $rootScope.bsCircle.id, groupTypeId: groupType }, vm.group,
                    function (data) {
                        vm.group = data;
                        loadCompanies();
                    },
                    function (error) {
                        $log.debug(error);
                    });
            } else {
                api.GeneralWS.AllFavoriteGroup.update({ id: vm.group.id, idCircle: $rootScope.bsCircle.id }, vm.group, function (data) {
                    vm.group = data;
                });
            }

        }

        function addMembers() {
        }

        function addMember(item) {
            api.GeneralWS.FavoriteGroupMembers.add({ group: vm.group.id, companyId: item.id, idCircle: $rootScope.bsCircle.id }, {},
                function (data) {
                    showMessage($filter('translate')('PROVIDER.TXTSAVE'));
                    var i = vm.allCompany.content.indexOf(item);
                    if (!vm.membersList.content) {
                        vm.membersList.content = [];
                        vm.membersList.page = 1;
                        vm.membersList.pageSize = 50;
                    }
                    vm.membersList.content.push(item);
                    vm.membersList.totalElements++;
                    vm.allCompany.content.splice(i, 1);
                    vm.allCompany.totalElements--;
                },
                function (error) {
                }
            );
        }

        function deleteMember(item) {
            api.GeneralWS.FavoriteGroupMembers.remove({ group: vm.group.id, companyId: item.id, idCircle: $rootScope.bsCircle.id }, {},
                function (data) {
                    showMessage($filter('translate')('PROVIDER.TXTDELETE'));
                    var i = vm.membersList.content.indexOf(item);
                    if (!vm.allCompany.content) {
                        vm.allCompany.content = [];
                        vm.allCompany.page = 1;
                        vm.allCompany.pageSize = 50;
                    }
                    item.deleteMem = true;
                    vm.allCompany.content.push(item);
                    vm.allCompany.totalElements++;
                    vm.membersList.content.splice(i, 1);
                    vm.membersList.totalElements--;
                },
                function (error) {
                }
            );
        }

        function showMessage(message) {

            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 7000,
                position: 'top right'
            });

        }

        vm.backTo = function () {
            $state.go("app.groupFavorite");
        };

        vm.isSelected = function (data) {
            return vm.selectedArray.indexOf(data) > -1;
        };

        function toggle(data, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedArray.indexOf(data) > -1) {
                vm.selectedArray.splice(vm.selectedArray.indexOf(data), 1);
            } else {
                vm.selectedArray.push(data);
            }
        }

        function toggleAssociated(data, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedAssociatedArray.indexOf(data) > -1) {
                vm.selectedAssociatedArray.splice(vm.selectedAssociatedArray.indexOf(data), 1);
            } else {
                vm.selectedAssociatedArray.push(data);
            }
        }

        vm.isSelectedAssociated = function (data) {
            return vm.selectedAssociatedArray.indexOf(data) > -1;
        };

        vm.associate = function () {

            var itemIdArray = [];

            if (!vm.isCheckAllItem) {
                vm.selectedArray.forEach(function (row) {
                    itemIdArray.push(row.id);
                });
            }

            if (itemIdArray.length === 0 && !vm.isCheckAllItem) {
                return null;
            }

            api.GeneralWS.FavoriteGroupMembers.add({ group: vm.group.id, companyId: company.id, idCircle: $rootScope.bsCircle.id }, itemIdArray,
                function (data) {
                    showMessage($filter('translate')('PROVIDER.TXTSAVE'));
                    vm.isShowProgressLinear = false;
                    $stateParams.favoriteGroupId = vm.group.id;
                    init();
                    vm.selectedArray = [];

                },
                function (errorAdd) {
                    log.debug(errorAdd);
                }
            );
            return true;
        };

        vm.disassociate = function () {

            var itemIdArray = [];

            if (!vm.isCheckAllUserItem) {
                vm.selectedAssociatedArray.forEach(function (row) {
                    itemIdArray.push(row.id);
                });
            }

            if (itemIdArray.length === 0 && !vm.isCheckAllUserItem) {
                return null;
            }

            api.GeneralWS.FavoriteGroupMembers.remove({ group: vm.group.id, companyId: company.id, idCircle: $rootScope.bsCircle.id }, itemIdArray,
                function (data) {
                    $stateParams.favoriteGroupId = vm.group.id;
                    showMessage($filter('translate')('PROVIDER.TXTDELETED'));
                    init();
                },
                function (errorFavoriteGroupMembers) {
                    $log.debug(errorFavoriteGroupMembers);
                }
            );
            return true;
        };

        $timeout(function () {

            var mdDialog = $("#providers");
            var windowHeight = parseInt(mdDialog.innerHeight());

            windowHeight -= 270;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };

        }, 1000);
    }
})();


(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('TagsController', TagsController);

    /**@ngInject**/
    function TagsController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;
        vm.onlyNotValidated = false;
        vm.messageOnLoadTags = "";

        // Methods
        vm.add = add;
        vm.edit = edit;
        vm.getProducts = getProducts;
        vm.selectProduct = selectProduct;
        vm.changeFilter = changeFilter;
        vm.onDelete = onDelete
        vm.saveTag = saveTag;
        vm.deleteTag = deleteTag;
        //////////

        $timeout(init, 500);

        /**
         * Initialize
         */
        function init() {
            var contentHeight = $("#prenegociatedPriceProductList").innerHeight();
            contentHeight -= 112;
            vm.dinamicHeight = { "height": contentHeight + "px" };

            getCurrency();
            getProducts(vm.page);

        }

        function getProducts(page) {
            vm.selectedProduct = null;
            vm.searchText = null;
            vm.productos = [];

            vm.loading = true;
            api.GeneralWS.Product.get(
                {
                    'page': page - 1, 'size': vm.pageSize, 'filter': vm.filterProduct, 'onlyNotValidated': vm.onlyNotValidated, 'companyId': $rootScope.bsCircle.company.id
                },
                function (data) {
                    vm.productos = data;
                    vm.loading = false;
                    vm.page = page;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function getCurrency() {
            api.GeneralWS.Currency.get({},
                function (data) {
                    vm.currencies = data;
                },
                function (data) {
                }
            );
        }

        function selectProduct(product, added) {
            if (vm.selectedProduct && product.id === vm.selectedProduct.id && !added) {
                return null;
            }

            vm.selectedProduct = product;
            vm.searchText = null;
            vm.messageOnLoadTags = $filter('translate')('TAGS.LOADING');
            vm.loadingTags = true;

            vm.canAdd = true;
            vm.productCompanyAddonsTags = [];

            api.GeneralWS.ProductCompanyAddonsTags.ProductCompanyAddonsTags.getByProduct(
                {
                    'idCircle': $rootScope.bsCircle.id, 'idProduct': vm.selectedProduct.id
                }
            ).$promise.then(function (response) {
                vm.productCompanyAddonsTags = response.sort(function (a, b) {
                    return a.id - b.id;
                });
                vm.showGrid = true;
                $timeout(function () {
                    vm.loadingTags = false;
                }, 500);

            }, function (response) {
                vm.loadingTags = false;
                $log.error(response);
            });
        }

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function add() {
            var productCompanyBuy = { productSale: { product: vm.selectedProduct } };
            $mdDialog.show({
                controller: 'PrenegotiatedPriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/editor/pre-negotiated-price.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyBuy': productCompanyBuy,
                    'currencies': vm.currencies
                }
            }).then(function (answer) {
                if (answer) {
                    if (typeof (answer.startDate) === "number") {
                        answer.startDate = new Date(answer.startDate);
                        answer.endDate = new Date(answer.endDate);
                    } else {
                        var ff = answer.startDate.split("-");
                        var startDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.startDate = startDate;
                        ff = answer.endDate.split("-");
                        var endDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.endDate = endDate;
                    }
                    vm.productCompanyBuys.push(answer);
                    vm.productCompanyBuys = vm.productCompanyBuys.sort(function (a, b) {
                        return a.startDate - b.startDate;
                    });
                    MessageService.show($filter('translate')('pre-negotiated_price.added'));
                }
            }, function () {

            });
        }

        function edit(productCompanyBuy, index) {
            productCompanyBuy.productSale.product = vm.selectedProduct;
            $mdDialog.show({
                controller: 'PrenegotiatedPriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/editor/pre-negotiated-price.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyBuy': angular.copy(productCompanyBuy),
                    'currencies': vm.currencies
                }
            }).then(function (answer) {
                if (answer) {
                    if (typeof (answer.startDate) === "number") {
                        answer.startDate = new Date(answer.startDate);
                        answer.endDate = new Date(answer.endDate);
                    } else {
                        var ff = answer.startDate.split("-");
                        var startDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.startDate = startDate;
                        ff = answer.endDate.split("-");
                        var endDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.endDate = endDate;
                    }

                    vm.productCompanyBuys[index] = answer;
                    vm.productCompanyBuys = vm.productCompanyBuys.sort(function (a, b) {
                        return a.startDate - b.startDate;
                    });
                    MessageService.show($filter('translate')('pre-negotiated_price.updated'));
                }
            }, function () {

            });
        }

        function onDelete(productCompanyBuy, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('pre-negotiated_price.confirm_delete'))
                .ok($filter('translate')('general.accept'))
                .cancel($filter('translate')('general.cancel'));
            $mdDialog.show(confirm).then(function () {
                api.GeneralWS.ProductCompanyBuy.me.delete({ 'id': productCompanyBuy.id, 'idCircle': $rootScope.bsCircle.id }).$promise.then(function (response) {
                    vm.productCompanyBuys.splice(index, 1);
                    vm.productCompanyBuys = vm.productCompanyBuys.sort(function (a, b) {
                        return a.startDate - b.startDate;
                    });
                    MessageService.show($filter('translate')('pre-negotiated_price.deleted'));
                }, function (response) {
                    $log.error(response);
                });
            }, function () {
            });
        }

        function saveTag() {
            vm.loadingTags = true;
            api.GeneralWS.ProductCompanyAddonsTags.SaveProductCompanyAddonsTags.save(
                {
                    'idCircle': $rootScope.bsCircle.id, 'idProduct': vm.selectedProduct.id, 'tag': vm.newTag
                }, {}, function (response) {
                    vm.newTag = '';
                    selectProduct(vm.selectedProduct, true);
                    MessageService.show($filter('translate')('TAGS.MSG.ADDED_TAG'));
                    vm.loadingTags = false;
                }, function (errResponse) {

                });
        }

        function deleteTag(row) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('TAGS.MSG.CONFIRM_DELETE'))
                .ok($filter('translate')('general.accept'))
                .cancel($filter('translate')('general.cancel'));
            $mdDialog.show(confirm).then(function () {
                vm.loadingTags = true;
                api.GeneralWS.ProductCompanyAddonsTags.SaveProductCompanyAddonsTags.del({ 'idCircle': $rootScope.bsCircle.id, 'id': row.id }, {}, function (response) {
                    vm.newTag = '';
                    selectProduct(vm.selectedProduct, true);
                    MessageService.show($filter('translate')('TAGS.MSG.DELETED_TAG'));
                    vm.loadingTags = false;
                }, function (errResponse) {

                });
            }, function () {
            });
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ProductListController', ProductListController);

    function ProductListController($rootScope, api, $log, $timeout, $filter, $mdDialog, MessageService) {

        var vm = this;

        vm.pagination = {
            page: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                headerName: 'ID',
                headerCellRenderer: getHeader,
                field: 'id',
                width: 75,
            },
            {
                headerName: 'CREATE.NAME',
                headerCellRenderer: getHeader,
                field: 'name',
                width: 400,
                cellRenderer: 'group',
            },
            {
                headerName: 'CREATE.BRAND',
                headerCellRenderer: getHeader,
                field: 'brand.name',
                width: 200,
            },
            {
                headerName: 'CREATE.MEASURE',
                headerCellRenderer: getHeader,
                field: 'measurementUnit.name',
                width: 200,
            },
            {
                headerName: 'CREATE.TYPE',
                headerCellRenderer: getHeader,
                field: 'type',
                width: 250,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<span>{{"CREATE.TYPES." + data.type| translate}}</span>';
                    }
                    return '';
                },
            },
            {
                headerName: 'CREATE.DATE',
                headerCellRenderer: getHeader,
                field: 'createdAt',
                valueFormatter: getCellFormater('localDateTime'),
                width: 150,
            },
            {
                headerName: 'CREATE.MX_PRODUCT_CODE',
                headerCellRenderer: getHeader,
                field: 'mxProductCode',
                width: 200,
            },
          {
            headerName: 'CREATE.PROVIDER_CODE',
            headerCellRenderer: getHeader,
            field: 'providerCode',
            width: 200,
          },
            {
                headerName: 'CREATE.HIGH',
                headerCellRenderer: getHeader,
                field: 'high',
                width: 100,
                cellStyle: { 'text-align': 'center' }
            },
            {
                headerName: 'CREATE.WIDTH',
                headerCellRenderer: getHeader,
                field: 'width',
                width: 100,
                cellStyle: { 'text-align': 'center' },
            },
            {
                headerName: 'CREATE.DEPTH',
                headerCellRenderer: getHeader,
                field: 'depth',
                width: 100,
                cellStyle: { 'text-align': 'center' },
            },
            {
                headerName: 'CREATE.DAYS_INVENTORY_DURATION',
                headerCellRenderer: getHeader,
                field: 'daysInventoryDuration',
                width: 150,
                cellStyle: { 'text-align': 'center' },
            },
            {
                headerName: 'CREATE.MASTER_BOX_UNITS',
                headerCellRenderer: getHeader,
                field: 'masterBoxUnits',
                width: 150,
                cellStyle: { 'text-align': 'center' },
            },
            {
                headerName: 'CREATE.MASTER_BOX_CODE',
                headerCellRenderer: getHeader,
                field: 'masterBoxCode',
                width: 150,
            },
            {
                suppressMenu: true,
                suppressSorting: true,
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                name: 'edit',
                width: 110,
                cellRenderer: function (params) {
                    if (params.data && params.data.id) {
                        return '<center> <md-button class="md-icon-button" ng-click="vm.add(data, $event)"> <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip></md-tooltip> </md-button>' +
                            '<md-button class="md-icon-button" ng-click="vm.deleteProduct(data)"> <md-icon md-font-icon="icon-trash" class="s16"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip></md-tooltip> </md-button>' +
                            ' </center>';
                    }
                    return '';
                },
                cellStyle: { 'padding': '0px' },
            }
        ];

        vm.masterGridOptions = {
            rowModelType: 'enterprise',
            pagination: true,
            paginationPageSize: vm.pagination.pageSize,
            cacheBlockSize: vm.pagination.pageSize,
            columnDefs: columnDefs,
            rowData: [],
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            enableSorting: true,
            debug: false,
            groupSuppressBlankHeader: true,
            rowGroupPanelShow: "none",
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            rowSelection: 'multiple',
            rowDeselection: true,
            fullWidthCellRenderer: true,
            pinnedBottomRowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
        };

        vm.produtIds = [];
        vm.photoProduct = [];
        vm.searchInput = '';
        vm.time = 1000;

       //methods
        vm.add = add;
        vm.search = search;
        vm.deleteProduct = deleteProduct;

        function getCellFormater(type) {
            switch (type) {
                case 'date':
                    return function (params) {
                        return $filter('date')(params.value, 'dd/MM/yyyy');
                    };
                case 'currency':
                    return function (params) {
                        return $filter('number')(params.value, '2');
                    };
                case 'localDateTime':
                    return function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
                        }
                    };
                default:
                    break;
            }
        }

       function createNewDatasource() {

         const dataSource = {
           paginationPageSize: vm.pagination.pageSize,
           getRows: function (params) {
             vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

             const parameters = {
               companyId: $rootScope.bsCircle.company.id,
               pageNumber: vm.pagination.page,
               pageSize: vm.pagination.pageSize,
               search: vm.searchInput,
             };

             api.GeneralWS.ProductAccount.myProducts.page(parameters).$promise.then(function (response) {
               const listContent = response.content;
               const newContent = [];
               response.content.forEach(function (it) {
                       listContent.forEach(function (item) {

                         if (it.id === item.id) {
                           newContent.push(
                             {
                               id: it.productId,
                               active: true,
                               createdAt: it.createdAt,
                               company: {
                                 id: it.companyId,
                                 name: it.companyName,
                               },
                               name: it.productName,
                               productCode: it.productCode,
                               isPhoneService: it.phoneService,
                               barCode: it.codeBar,
                               urlReference: it.referenceUrl,
                               upc: it.upc,
                               ean: it.ean,
                               isbn: it.isbn,
                               googleCategory: it.categoryGoogle,
                               mxProductCode: it.productCodeMx,
                               providerCode: it.codeProvider,
                               type: it.type,
                               brand: {
                                 id: it.brandId,
                                 name: it.brandName,
                               },
                               isPrivate: it.private,
                               description1: it.description1,
                               description2: it.description2,
                               expirationDate: it.dateExpiration,
                               measurementUnit: {
                                 id: it.measurementUnitId,
                                 name: it.measurementUnitName,
                               },
                               high: it.height,
                               width: it.width,
                               depth: it.depth,
                               daysInventoryDuration: it.inventoryDaysDuration,
                               masterBoxUnits: it.unitsMasterBox,
                               masterBoxCode: it.codeMasterBox,
                               productPhotos: [],
                             });
                         }

                       });
                     });
               response.content = newContent;
               vm.pagination.totalElements = response.totalElements;
               vm.pagination.totalPages = response.totalPages;
               params.successCallback(response.content, response.totalElements);
               vm.showGrid = true;
               $rootScope.loadingProgress = false;
               vm.setDataRow = true;

             }).catch(function (response) {
               $log.error(response);
               vm.showGrid = false;
               $rootScope.loadingProgress = false;
             });
           },
         };
         vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
       }

        function add(product, event) {
            var isEdit = true;
            if (product === null || product === undefined) {
                isEdit = false;
                product = {
                    id: null,
                };
            }
            $mdDialog.show({
                controller: 'CreateProductController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/product-list/dialogs/create/create-product.html',
                parent: angular.element('#main'),
                targetEvent: event,
                locals: {
                    'product': angular.copy(product),
                    'brands': vm.brands,
                    'measures': vm.measures,
                },
                clickOutsideToClose: false,
            }
            ).then(function (response) {
                if (isEdit) {
                    vm.masterGridOptions.api.forEachNode(function (row, index) {
                        if (row.data.id === response.id) {
                            row.data = response;
                        }
                    });
                    vm.masterGridOptions.api.refreshView();
                } else {
                }
            }, function (response) {

            });
        }

        function deleteProduct(product, textContent) {
            var isConfirmByConflict = false;
            var buttonOkText = $filter('translate')('general.accept');
            if (!textContent) {
                textContent = $filter('translate')('my_products.confirm_delete');
            } else {
                isConfirmByConflict = true;
                buttonOkText = $filter('translate')('my_products.confirm');
            }
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete') + " " + product.name)
                .textContent(textContent)
                .ok(buttonOkText)
                .cancel($filter('translate')('general.cancel'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                const parameters = {
                    companyId: $rootScope.bsCircle.company.id,
                    productId: product.id,
                    confirmed: isConfirmByConflict
                };
                api.GeneralWS.ProductAccount.myProducts.delete(parameters).$promise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    MessageService.show($filter('translate')('my_products.deleted'));
                    createNewDatasource();
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    $log.error(response);
                    if (response.status === 406) {
                        MessageService.showErrorMessage($filter('translate')('my_products.product_belong_other_company') + response.data.mensaje);
                        return;
                    }
                    if (response.status !== 409) {
                        MessageService.showErrorMessage($filter('translate')('general.error'));
                        return;
                    }
                    const messages = response.data.mensaje.split(",");

                    var textContent = $filter('translate')('my_products.product_conflict_message') + "\n\n";
                    messages.forEach(function (row) {
                        textContent = textContent + $filter('translate')(row) + "\n";
                    });
                    textContent = textContent + "\n" + $filter('translate')("my_products.confirm_delete_by_conflict");
                    deleteProduct(product, textContent);
                });
            }, function () {
            });
        }

        function search() {
          $rootScope.loadingProgress = true;
            if (vm.searchInput === null || vm.searchInput === undefined || vm.searchInput === '') {
                return null;
            }
            createNewDatasource();
        }

        function init() {
          $rootScope.loadingProgress = true;
            api.GeneralWS.BrandProduct.query({}).$promise.then(function (data) {
                vm.brands = data;
            }, function (err) {
            });

            api.GeneralWS.Common.MeasurementUnit.me.query({}).$promise.then(function (data) {
                vm.measures = data;
              createNewDatasource();

            }, function (err) {
            });
        }

        $timeout(init, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ProductTypeController', ProductTypeController);

    /**@ngInject**/
    function ProductTypeController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;
        vm.onlyNotValidated = false;
        vm.messageOnLoadTags = "";
        vm.filterProduct = '';
        var strAllCategory = $filter('translate')('PRODUCT.ALL_CATEGORY');

        $rootScope.categorySelected = null;
        vm.categorySelected = {
            description: strAllCategory,
            nameInner: 'AllCategory',
            id: 0
        };
        vm.obSearch = {
            page: 0,
            size: 20,
            typeSearch: 'product'
        };

        vm.changeFilter = function () {
            $("#tree").jstree("search", vm.filterProduct);
        }

        $timeout(init, 300);

        /**
         * Initialize
         */
        function init() {
            var contentHeight = $("#prenegociatedPriceProductList").innerHeight();
            contentHeight -= 112;
            vm.dinamicHeight = { "height": contentHeight + "px" };

            $timeout(createCategoryTree(vm.categorySelected.id), 500);
        }

        function createCategoryTree(categoryParentId) {
            vm.categoriesLoaded = true;

            vm.group = [];

            api.GeneralWS.ProductType.categoryParent.get(
                {
                    'company': $rootScope.bsCircle.company.id, 'idCircle': $rootScope.bsCircle.id, 'categoryId': categoryParentId
                }
            ).$promise.then(function (response) {
                vm.group = new jinqJs()
                    .from(response)
                    .groupBy('productTypeParentId')
                    .orderBy('productTypeCode')
                    .select(function (r) {
                        r.text = r.productTypeCode + "-" + r.description;
                        r.parent = r.productTypeParentId ? r.productTypeParentId : '#';
                        r.productTypeParent = {id: r.productTypeParentId, description: r.productTypeParentDescription};
                        r.productCondition = {id: r.productConditionId ? r.productConditionId.toString() : null};
                        r.productGender = {id: r.productGenderId ? r.productGenderId.toString() : null};
                        return r;
                    });

                createTreeProductType();
                style();
            }, function (response) {
                $log.error(response);
            });
        }

        function createTreeProductType() {
            $timeout(function () {
                $.jstree.destroy();
                $('#tree')
                    .bind('dblclick.jstree', function (e, data) {
                        var tree = $(this).jstree();
                        var nd = tree.get_node(e.target);
                        vm.addProductType(nd.original);
                        style();
                    })
                    .on('hover_node.jstree', function (e, data) {
                        $("#" + data.node.id).prop('title', data.node.text);
                        style();
                    })
                    .jstree({
                        'core': {
                            'data': vm.group,
                            "themes": {
                                "icons": false
                            }
                        },
                        'search': {
                            "show_only_matches": true
                        },
                        'plugins': ["search", "crrm", "types", "wholerow"]
                    });
            }, 500);
        }

        vm.addProductType = function (productType) {
            $mdDialog.show({
                controller: 'ProductTypeDialogController',
                controllerAs: 'vm',
                multiple: true,
                templateUrl: 'app/main/apps/product/productType/productType-dialog/productType-dialog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'productType': productType ? angular.copy(productType) : null
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('productType.msg.added'));
                    //productType = answer;
                    $timeout(function () {
                        createCategoryTree(vm.categorySelected.id);
                    }, 300);
                }
            }, function () {

            });
        };

        function style() {
            $timeout(function () {
                document.querySelectorAll('.jstree-anchor').forEach(function (inf) {
                    inf.setAttribute("style", 'font-size:18px');
                });
            }, 300);
        }


    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ProductGroupListController', productGroupListController);

    /**@ngInject**/
    function productGroupListController($rootScope, api, MessageService, $mdDialog, $filter, $timeout, $log, $state) {

        var vm = this;

        /**
         * methods
         */
        vm.add = add;
        vm.edit = edit;
        vm.onDelete = onDelete;
        vm.search = search;
        vm.addAccountingCatalog = addAccountingCatalog;

        vm.pagination = {
            page: 0,
            pageSize: 25,
            totalElements: 0,
            totalPages: 0
        };

        var columnDefs = [
            {
                field: "groupCode",
                headerName: 'productGroup.groupCode',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "groupName",
                headerName: 'productGroup.groupName',
                headerCellRenderer: getHeader,
                width: 300
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 110,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.edit(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button>'
                        + ' <md-button class="md-icon-button" ng-click="vm.addAccountingCatalog(data)" ng-disabled="!data.active"> '
                        + ' <md-icon md-font-icon="icon-archive"></md-icon> <md-tooltip md-direction="left">{{"productGroup.addAccountingCatalog"| translate}}</md-tooltip> '
                        + ' </md-button>'
                        + ' </center>'
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function search() {
            vm.showSearch = true;
            createNewDatasource();
        }

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {
            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {

                    vm.pagination.page = params.request.endRow / vm.pagination.pageSize;

                    vm.isShowProgressLinear = true;
                    api.GeneralWS.ProductCompanyGroup.me.page({
                        'company': $rootScope.bsCircle.company.id, 'page': (vm.pagination.page), 'pageSize': vm.pagination.pageSize, 'search': vm.inputSearch
                    })
                        .$promise.then(function (response) {
                            vm.isShowProgressLinear = false;

                            vm.pagination.totalElements = response.totalElements;
                            vm.pagination.totalPages = response.totalPages;

                            params.successCallback(response.content, response.totalElements);
                            vm.showGrid = true;

                        }, function (response) {
                            $log.error(response);
                        });
                }
            };
            vm.grid.api.setEnterpriseDatasource(dataSource);
        }

        function init() {
            createNewDatasource();
        }

        function add() {
            $mdDialog.show({
                controller: 'ProductGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/product-group/product-group/product-group.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyGroup': {
                        'groupCode': '',
                        'groupName': '',
                        'active': true,
                        'company': $rootScope.bsCircle.company
                    }
                }
            }).then(function (answer) {
                if (answer) {
                    vm.pagination.page = ((vm.pagination.totalPages > 0) ? (vm.pagination.totalPages - 1) : 0);
                    createNewDatasource();
                    MessageService.show($filter('translate')('productGroup.productgroup_added'));
                }
            }, function (){

            });
        }

        function edit(productCompanyGroup) {
            $mdDialog.show({
                controller: 'ProductGroupController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/product-group/product-group/product-group.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyGroup': angular.copy(productCompanyGroup)
                }
            }).then(function (answer) {
                if (answer) {
                    vm.grid.api.forEachNode(function (row, index) {
                        if (row.data.id === answer.id) {
                            row.data = answer;
                        }
                    });

                    vm.grid.api.redrawRows();
                    MessageService.show($filter('translate')('productGroup.productgroup_updated'));
                }
            }, function (){

            });
        }

        function onDelete(productCompanyGroup) {
            productCompanyGroup.active = false;

            var promise;
            promise = api.GeneralWS.ProductCompanyGroup.me.update({ 
                'company': productCompanyGroup.company.id,
                'id': productCompanyGroup.id
            }, productCompanyGroup).$promise;
                vm.isShowProgressLinear = true;
                promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    switch (response.$status) {
                        case 200:
                        case 201:
                            vm.grid.api.forEachNode(function (row, index) {
                                if (row.data.id === response.id) {
                                    row.data = response;
                                }
                            });
                            vm.grid.api.refreshView();
                            MessageService.show($filter('translate')('productGroup.productgroup_updated'));
                            break;

                        default:
                            $log.error(response);
                            MessageService.showErrorMessage($filter('translate')('general.general_error'));
                            break;
                    }
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
        }

        function addAccountingCatalog(data) {
            $mdDialog.show({
                controller: 'ProductGroupAccountingCatalogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/product-group/product-group-accounting-catalog/product-group-accounting-catalog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyGroup': angular.copy(data)
                }
            }).then(function (answer) {
                
            }, function (){

            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('PreNegociatedPricesController', PreNegociatedPricesController);

    /**@ngInject**/
    function PreNegociatedPricesController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;
        vm.onlyNotValidated = false;
        vm.canChangePriceOnDocuments = false;
        vm.messageOnLoadPrenegociated = '';
        vm.showEditCostCenter = false;

        // Methods
        vm.add = add;
        vm.edit = edit;
        vm.editCostCenter = editCostCenter;
        vm.changeDefaultPrice = changeDefaultPrice;
        vm.getProducts = getProducts;
        vm.selectProduct = selectProduct;
        vm.changeFilter = changeFilter;
        vm.onDelete = onDelete;
        vm.editByCostCenter = editByCostCenter;
        vm.showAdvancedFilter = false;
        vm.filter = {
            filterByDates: false,
            productWithPrice: false
        };
        vm.canUpdateAll = false;
        vm.productType = {};
        vm.massiveUpdate = massiveUpdate;
        vm.updateQuotations = updateQuotations;
        vm.updatePurchaseOrders = updatePurchaseOrders;
        //////////

        $timeout(init, 500);

        /**
         * Initialize
         */
        function init() {
            var contentHeight = $('#prenegociatedPriceProductList').innerHeight();
            contentHeight -= 112;
            vm.dinamicHeight = { 'height': contentHeight + 'px' };

            getCurrency();
            getProducts(vm.page);

            getCompanies();

            vm.canChangePriceOnDocuments = $rootScope.getEspecialActionByName('Actualizar precio en documentos');

        }

        function getProducts(page) {
            vm.selectedProduct = null;
            vm.searchText = null;
            vm.productos = [];

            vm.loading = true;
            if (vm.filter) {
                vm.filter.productFilter = vm.filterProduct;
                if (vm.filter.providersId && vm.filter.providersId.length > 0 && vm.filter.endDateNegotiation) {
                    vm.canUpdateAll = true;
                } else {
                    vm.canUpdateAll = false;
                }
            }

            api.GeneralWS.ProductPricePreNegociated.getByFilter(
                {
                    'page': page - 1, 'size': vm.pageSize, 'onlyNotValidated': vm.onlyNotValidated, 'companyId': $rootScope.bsCircle.company.id
                },
                vm.filter,
                function (data) {
                    vm.productos = data;
                    vm.loading = false;
                    vm.page = page;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function getCurrency() {
            api.GeneralWS.Currency.get({},
                function (data) {
                    vm.currencies = data;
                },
                function (data) {
                }
            );
        }

        function selectProduct(product, added) {
            if (vm.selectedProduct && product.id === vm.selectedProduct.id && !added) {
                return null;
            }

            vm.selectedProduct = product;
            vm.searchText = null;
            vm.messageOnLoadPrenegociated = $filter('translate')('pre-negotiated_price.loading');
            vm.loadingPreNegociatedPrice = true;
            vm.showEditCostCenter = false;

            vm.canAdd = true;
            if (!vm.filter.endDateNegotiation) {
                vm.filter.endDateNegotiation = new Date();
            }

            const dateFilter = vm.filter.endDateNegotiation.getFullYear() + '-' + (vm.filter.endDateNegotiation.getMonth() + 1) + '-' + vm.filter.endDateNegotiation.getDate();

            api.GeneralWS.ProductCompanyBuy.me.doGetByProductAndCompanyGreatByDate(
                {
                    'id': 'doGetByProductAndCompanyGreatByDate', 'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id, 'endDate': dateFilter
                }
            ).$promise.then(function (response) {
                response.forEach(function (data) {
                    let ff = data.startDate.split('-');
                    const startDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                    data.startDate = startDate;
                    ff = data.endDate.split('-');
                    const endDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                    data.endDate = endDate;

                    const currentDate = new Date();
                    if (currentDate >= startDate && currentDate <= endDate) {
                        data.valid = true;
                    } else {
                        data.valid = false;
                    }

                });
                vm.productCompanyBuys = response.sort(function (a, b) {
                    return a.startDate - b.startDate;
                });
                validateShowEditCostCenter();
                vm.showGrid = true;
                $timeout(function () {
                    vm.loadingPreNegociatedPrice = false;
                }, 500);

            }, function (response) {
                vm.loadingPreNegociatedPrice = false;
                $log.error(response);
            });
        }

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function add() {
            var productCompanyBuy = { productSale: { product: vm.selectedProduct } };
            $mdDialog.show({
                controller: 'PrenegotiatedPriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/editor/pre-negotiated-price.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyBuy': productCompanyBuy,
                    'currencies': vm.currencies
                }
            }).then(function (answer) {
                if (answer) {
                    if (typeof (answer.startDate) === 'string') {
                        let tmpdate = answer.startDate.split('T');
                        let ff = tmpdate[0].split('-');
                        const startDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.startDate = startDate;
                        tmpdate = answer.endDate.split('T');
                        ff = tmpdate[0].split('-');
                        const endDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.endDate = endDate;
                    } else {
                        answer.startDate = new Date(answer.startDate);
                        answer.endDate = new Date(answer.endDate);
                    }
                    vm.productCompanyBuys.push(answer);
                    vm.productCompanyBuys = vm.productCompanyBuys.sort(function (a, b) {
                        return a.startDate - b.startDate;
                    });
                    validateShowEditCostCenter();
                    MessageService.show($filter('translate')('pre-negotiated_price.added'));
                }
            }, function () {

            });
        }

        function validateShowEditCostCenter() {
            vm.showEditCostCenter = vm.productCompanyBuys
                    .filter(function(fl) {
                        return fl.isByCostCenter;
                    }).length > 0;
        }

        function editCostCenter() {
            var result = vm.productCompanyBuys
                .filter(function(val) {
                    return val.isByCostCenter;
                });
            $mdDialog.show({
                controller: 'DefaultCostCenterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/default-cost-center/default-cost-center.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyBuys': result
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('pre-negotiated_price.added'));
                }
            });
        }

        function edit(productCompanyBuy, index) {
            productCompanyBuy.productSale.product = vm.selectedProduct;
            $mdDialog.show({
                controller: 'PrenegotiatedPriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/editor/pre-negotiated-price.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyBuy': angular.copy(productCompanyBuy),
                    'currencies': vm.currencies
                }
            }).then(function (answer) {
                if (answer) {
                    if (typeof (answer.startDate) === 'string') {
                        let tmpdate = answer.startDate.split('T');
                        let ff = tmpdate[0].split('-');
                        const startDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.startDate = startDate;
                        tmpdate = answer.endDate.split('T');
                        ff = tmpdate[0].split('-');
                        const endDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.endDate = endDate;
                    } else {
                        answer.startDate = new Date(answer.startDate);
                        answer.endDate = new Date(answer.endDate);
                    }

                    vm.productCompanyBuys[index] = answer;
                    vm.productCompanyBuys = vm.productCompanyBuys.sort(function (a, b) {
                        return a.startDate - b.startDate;
                    });
                    validateShowEditCostCenter();
                    MessageService.show($filter('translate')('pre-negotiated_price.updated'));
                }
            }, function () {

            });
        }

        function editByCostCenter(productCompanyBuy, index) {
            productCompanyBuy.productSale.product = vm.selectedProduct;
            $mdDialog.show({
                controller: 'ByCostCenterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/by-cost-center/by-cost-center.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'productCompanyBuy': angular.copy(productCompanyBuy),
                    'currencies': vm.currencies
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('pre-negotiated_price.bycostcenterupdate'));
                }
            }, function () {

            });
        }

        function onDelete(productCompanyBuy, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('pre-negotiated_price.confirm_delete'))
                .ok($filter('translate')('general.accept'))
                .cancel($filter('translate')('general.cancel'));
            $mdDialog.show(confirm).then(function () {
                api.GeneralWS.ProductCompanyBuy.me.delete(
                    {
                        'id': productCompanyBuy.id, 'idCircle': $rootScope.bsCircle.id
                    }
                ).$promise.then(function (response) {
                    vm.productCompanyBuys.splice(index, 1);
                    vm.productCompanyBuys = vm.productCompanyBuys.sort(function (a, b) {
                        return a.startDate - b.startDate;
                    });
                    MessageService.show($filter('translate')('pre-negotiated_price.deleted'));
                }, function (response) {
                    $log.error(response);
                });
            }, function () {
            });
        }

        function massiveUpdate() {
            $mdDialog.show({
                controller: 'MassiveUpdateController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/massive-update-dialog/massive-update-dialog.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'filter': angular.copy(vm.filter),
                    'products': vm.productos.content,
                }
            }).then(function (answer) {
                if (answer) {
                    if (typeof (answer.startDate) === 'string') {
                        var ff = answer.startDate.split('-');
                        var startDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.startDate = startDate;
                        ff = answer.endDate.split('-');
                        var endDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                        answer.endDate = endDate;
                    } else {
                        answer.startDate = new Date(answer.startDate);
                        answer.endDate = new Date(answer.endDate);
                    }

                    vm.productCompanyBuys[index] = answer;
                    vm.productCompanyBuys = vm.productCompanyBuys.sort(function (a, b) {
                        return a.startDate - b.startDate;
                    });
                    MessageService.show($filter('translate')('pre-negotiated_price.updated'));
                }
            }, function () {

            });
        }

        function updateQuotations() {
            $mdDialog.show({
                controller: 'UpdatePriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/update-price-dialog/update-price-dialog.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'type': 1
                }
            }).then(function (resp) {
                vm.loading2 = true;
                $rootScope.loadingProgress = true;
                api.ComprasWS.quotation.updatePriceQuotations({
                    'companyId': $rootScope.bsCircle.company.id,
                    'allCompanies': resp.allCompanies,
                    'productId': vm.selectedProduct.id,
                    'newPrice': resp.newPrice
                }).$promise.then(function () {
                    $rootScope.loadingProgress = false;
                    vm.loading2 = false;
                    MessageService.show($filter('translate')('pre-negotiated_price.quotationsUpdated'));
                }, function (response) {
                    $log.error(response);
                    vm.loading2 = false;
                    $rootScope.loadingProgress = false;
                });
            }, function () {
                //Empty
            });
        }

        function updatePurchaseOrders() {
            $mdDialog.show({
                controller: 'UpdatePriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/pre-negotiated-price/update-price-dialog/update-price-dialog.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'type': 2
                }
            }).then(function (response) {
                $rootScope.loadingProgress = true;
                vm.loading2 = true;
                api.ComprasWS.purchaseOrder.updatePricePurchaseOrders({
                    'companyId': $rootScope.bsCircle.company.id,
                    'allCompanies': response.allCompanies,
                    'productId': vm.selectedProduct.id,
                    'newPrice': response.newPrice
                }).$promise.then(function () {
                    $rootScope.loadingProgress = false;
                    vm.loading2 = false;
                    MessageService.show($filter('translate')('pre-negotiated_price.purchaseOrdersUpdated'));
                }, function (err) {
                    $rootScope.loadingProgress = false;
                    $log.error(err);
                    vm.loading2 = false;
                });
            }, function () {
                //Empty
            });
        }

        function getCompanies() {
            api.GeneralWS.ProviderByProductPreNegociated.query(
                { 'companyId': $rootScope.bsCircle.company.id }
            ).$promise.then(function (response) {
                vm.companyArray = response;
            }, function (response) {
                $log.error(response);
            });
        }

        function changeDefaultPrice(by) {
            vm.loadingPreNegociatedPrice = true;
            api.GeneralWS.ProductCompanyBuy.ChangeDefault.update(
                { 'id': by.id, 'idCircle': $rootScope.bsCircle.id },{}
            ).$promise.then(function (response) {
                var i = vm.productCompanyBuys.indexOf(by);
                vm.productCompanyBuys.forEach(function (df) {
                    df.isDefault = false;
                });
                vm.productCompanyBuys[i].isDefault = true;
                vm.loadingPreNegociatedPrice = false;
            }, function (response) {
                $log.error(response);
                vm.loadingPreNegociatedPrice = false;
            });
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ParametersController', ParametersController);

    /**@ngInject**/
    function ParametersController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 50;
        vm.onlyNotValidated = false;
        vm.batchUpdate = false;
        vm.saveInBatch = false;
        vm.textSearch = 'general.search';
        vm.textButtonSearch = 'general.search';
        vm.messageOnLoadParameter = '';
        vm.filterProduct = ''

        // Methods
        vm.getProducts = getProducts;
        vm.changeBatch = changeBatch;
        vm.clearTextSearch = clearTextSearch;
        vm.selectProduct = selectProduct;
        vm.changeFilter = changeFilter;
        vm.save = save;
        vm.activateAll = activateAll;
        vm.saveFixedAsset = saveFixedAsset;
        vm.querySearch = querySearch;
        vm.addAccount = addAccount;
        vm.onEditAccount = onEditAccount;
        vm.onDeleteAccount = onDeleteAccount;
        vm.disableButtonSave = true;
        vm.saveProductType = saveProductType;
        vm.addFieldValue = addFieldValue;
        vm.onEditFieldValue = onEditFieldValue;
        vm.onDeleteFieldValue = onDeleteFieldValue;
        vm.validateChecksIsActive = validateChecksIsActive;
        vm.addRepositionDays = addRepositionDays;
        vm.selectInventoryProduct = selectInventoryProduct;
        vm.productParameterContent = '#productParamenters';

        var strAllCategory = $filter('translate')('PRODUCT.ALL_CATEGORY');

        vm.categorySelected = {
            description: strAllCategory,
            nameInner: 'AllCategory',
            id: 0
        };

        var columnDefs = [
            {
                field: "accountingCatalog.code",
                headerName: 'productAccount.code',
                headerCellRenderer: getHeader,
                width: 100
            },
            {
                field: "accountingCatalog.description",
                headerName: 'productAccount.description',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "expenseType.description",
                headerName: 'productAccount.expenseType',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "accountType.acTypeDescription",
                headerName: 'productAccount.accountType',
                headerCellRenderer: getHeader,
                width: 250
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 60,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDeleteAccount(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 60,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onEditAccount(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> '
                        + ' <md-tooltip md-direction="left" >{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function onInitGrid() {
            vm.grid = {
                columnDefs: columnDefs,
                enableColResize: true,
                enableSorting: true,
                animateRows: true,
                enableFilter: true,
                rowHeight: 40,
                angularCompileRows: true,
                angularCompileHeaders: true,
                getMainMenuItems: function (params) {
                    return getHeaderMenu(params, $filter);
                },
                localeTextFunc: function (key, defaultValue) {
                    return translateGrid(key, defaultValue, $filter);
                }
            }
        }

        var columnDefsFields = [
            {
                field: "companyAdditionalFields.additionalFieldName",
                headerName: 'additional-field-value.additional-field',
                headerCellRenderer: getHeader,
                width: 230
            },
            {
                field: "fieldValue",
                headerName: 'additional-field-value.value',
                headerCellRenderer: getHeader,
                width: 130
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 60,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDeleteFieldValue(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 60,
                cellRenderer: function (params) {
                    return '<center> '
                        + ' <md-button class="md-icon-button" ng-click="vm.onEditFieldValue(data)"> '
                        + ' <md-icon md-font-icon="icon-border-color"></md-icon> '
                        + ' <md-tooltip md-direction="left" >{{"general.edit"| translate}}</md-tooltip> '
                        + ' </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        function onInitGridFields() {
            vm.gridFields = {
                columnDefs: columnDefsFields,
                enableColResize: true,
                enableSorting: true,
                animateRows: true,
                enableFilter: true,
                rowHeight: 40,
                angularCompileRows: true,
                angularCompileHeaders: true,
                getMainMenuItems: function (params) {
                    return getHeaderMenu(params, $filter);
                },
                localeTextFunc: function (key, defaultValue) {
                    return translateGrid(key, defaultValue, $filter);
                }
            }
        }

        //////////

        $timeout(init, 1500);

        /**
         * Initialize
         */
        function init() {

            setDinamicHeight();

            const extraHeight = 172;
            const contentHeight2 = $(vm.productParameterContent).innerHeight() - extraHeight;
            vm.dinamicMinHeight = { "min-height": contentHeight2 + "px" };

            const contentHeight = $(vm.productParameterContent).innerHeight();
            var contentHeight3 = contentHeight - 115;
            vm.gridDinamicHeight = { "height": contentHeight3 + "px", "min-height": "250px" };

            onInitGrid();
            onInitGridFields();

            getProducts(vm.page);
            api.ActivosFijosWS.FixedAssetGroup.me.get({ 'companyId': $rootScope.bsCircle.company.id },
                function (data) {
                    vm.groups = data;
                },
                function (data) {
                }
            );

            vm.loadingProductGroups = true;
            api.GeneralWS.ProductGroup.active.query({ 'country': $rootScope.bsCircle.company.country.id }, function (data) {
                vm.taxesGroup = data;
                vm.loadingProductGroups = false;
            });

            api.GeneralWS.Account.ExpenseType.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.expenseType = response;
            }, function (response) {
                $log.error(response);
            });

            api.GeneralWS.Account.AccountType.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.accountType = response;
            }, function (response) {
                $log.error(response);
            });

            vm.loadingProductCompanyGroups = true;
            api.GeneralWS.ProductCompanyGroup.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.productCompanyGroup = response;
                vm.loadingProductCompanyGroups = false;
            }, function (response) {
                $log.error(response);
            });

            vm.customText = {
                productcodeerp: $filter('translate')('product_parameters.productCodeERP'),
                productcodeerp2: $filter('translate')('product_parameters.erp_code2'),
                productcodeerp3: $filter('translate')('product_parameters.erp_code3')
            };

            api.GeneralWS.CompanyCustomText.byItemName.get({
                'companyId': $rootScope.bsCircle.company.id, itemName: 'apps.product.parameters'
            }).$promise.then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    if (response[i].customText && response[i].customText !== '') {
                        vm.customText[response[i].keyName] = response[i].customText;
                    }
                }

            }, function (response) {
                $log.error(response);
            });

        }

        function setDinamicHeight() {
          var contentHeight = $(vm.productParameterContent).innerHeight();
          const swithHeight = 120;
          contentHeight -= swithHeight;
          if (!vm.batchUpdate) {
            const pagingSize = 77;
            contentHeight -= pagingSize;
          }
          vm.dinamicHeight = { "height": contentHeight + "px", "min-height": "500px" };
        }

        function clearTextSearch() {
            vm.selectedProduct = null;
            vm.activeAll = false;
            vm.productCompanyAddons = null;
            vm.dissableCheck = false;
            vm.group = null;
            vm.searchText = null;
            vm.filterProduct = '';
            vm.textButtonSearch = 'general.search';
            vm.productos = {
              content: []
            };
        }

        function changeBatch() {
          setDinamicHeight();
          if (vm.batchUpdate) {
            vm.textSearch = 'product_parameters.searchProductCode';
            clearTextSearch();
          } else {
            vm.textSearch = 'general.search';
            clearTextSearch();
            getProducts(1);
          }
        }

        function getProducts(page) {
            vm.selectedProduct = null;
            vm.activeAll = false;
            vm.productCompanyAddons = null;
            vm.dissableCheck = false;
            vm.group = null;
            vm.searchText = null;
            vm.textSearch = 'general.search';
            vm.productos = [];
            if (vm.batchUpdate) {
              const arrayFilters = vm.filterProduct.toString().split(',');
              if (arrayFilters.length > 50) {
                MessageService.showErrorMessage($filter('translate')('product_parameters.max_50_product_codes'));
                return;
              }
              vm.saveInBatch = false;
              vm.textSearch = 'product_parameters.searchProductCode';
              if(!vm.filterProduct) {
                clearTextSearch();
                MessageService.showErrorMessage($filter('translate')('product_parameters.must_entered_product_code'));
                return;
              }
              if (vm.textButtonSearch === 'general.search') {
                vm.textButtonSearch = 'product_parameters.clear';
              }
            }

            vm.loading = true;
            api.GeneralWS.Product.get({
                'page': page - 1,
                'size': vm.pageSize,
                'filter': vm.filterProduct.toLowerCase(),
                'batchUpdate': vm.batchUpdate,
                'onlyNotValidated': vm.onlyNotValidated,
                'companyId': $rootScope.bsCircle.company.id
            },
                function (data) {
                    processProductData(data);
                    vm.productos = data;
                    vm.page = page;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function processProductData(products) {
          if (!vm.batchUpdate || products.content.length === 0) {
            return;
          }

          const repetedCodes = {};
          products.content.forEach(function (product) {
            if (repetedCodes[product.productCode]) {
              repetedCodes[product.productCode]++;
            } else {
              repetedCodes[product.productCode] = 1;
            }
          });

          products.content.forEach(function (product) {
            product.repeated = repetedCodes[product.productCode] > 1;
          });
        }

        function selectProduct(product) {
            if (vm.selectedProduct && product.id === vm.selectedProduct.id) {
                return null;
            }

            vm.selectedProduct = product;
            vm.activeAll = false;
            vm.productCompanyAddons = { canReQuote: true };
            vm.dissableCheck = false;
            vm.group = null;
            vm.searchText = null;

            vm.messageOnLoadParameter = $filter('translate')('product_parameters.charging_parameters');
            vm.loadingParameters = true;
            api.GeneralWS.ProductCompanyAddons.me.get({
                'id': 'getByProductAndCompany', 'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id
            }).$promise.then(function (response) {
                $timeout(function () {
                    vm.loadingParameters = false;
                }, 1000);

                vm.productCompanyAddons = response;
                vm.productCompanyAddons.providerCanInvoiceBeforeReceive = response.providerCanInvoiceBeforeReceive ? response.providerCanInvoiceBeforeReceive : false;
                vm.productCompanyAddons.isConsignment = response.isConsignment ? response.isConsignment : false;
                vm.activeAll = (vm.productCompanyAddons.fixedAsset === true && vm.productCompanyAddons.prenegotiatedPrice === true) ? true : false;
                vm.group = !vm.productCompanyAddons.fixedAssetGroupId ? null : _.find(vm.groups, function (group) {
                    return group.id === vm.productCompanyAddons.fixedAssetGroupId;
                });

                $timeout(function () {

                    var keyEvent = function (event) {
                        event.stopPropagation();
                    };

                    var searchProductGroupInput = document.querySelector("#searchProductGroup");
                    if (searchProductGroupInput) {
                        searchProductGroupInput.addEventListener("keydown", keyEvent);
                    }

                    var searchProductCompanyGroupInput = document.querySelector("#searchProductCompanyGroup");
                    if (searchProductCompanyGroupInput) {
                        searchProductCompanyGroupInput.addEventListener("keydown", keyEvent);
                    }

                }, 1000);

            }, function (response) {
                vm.loadingParameters = false;
                $log.error(response);
            });

            vm.canAdd = false;
            $timeout(function () {
                onGetProductAccount();
                onGetFieldsValue();
            }, 3000);

            createCategoryTree(vm.categorySelected.id);

            $timeout(function () {
                getProductTypeParent(vm.productCompanyAddons.productType ? vm.productCompanyAddons.productType : null);
            }, 4000);

        }

        function saveProductBatch() {
            $mdDialog.show({
                controller: 'ProductListBatchDialogController',
                controllerAs: 'vm',
                locals: {
                  products: vm.productos,
                  addons: vm.productCompanyAddons
                },
                templateUrl: 'app/main/apps/product/parameters/dialogs/product-list-batch-dialog/product-list-batch-dialog.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false
            })
            .then(function(answer) {
              MessageService.show($filter('translate')('product_parameters.updated'));
              vm.loadingParameters = false;
            });
        }

        function changeFilter(event) {
          if ((!vm.filterProduct || vm.filterProduct === '') && !vm.batchUpdate) {
            getProducts(1);
          }
      }

        function activateAll() {

            vm.productCompanyAddons.fixedAsset = vm.activeAll;
            vm.productCompanyAddons.prenegotiatedPrice = vm.activeAll;
            vm.activeAll === true ? saveFixedAsset() : save();
        }

        function selectInventoryProduct(ev, inventoryProduct) {
            const prodId = inventoryProduct != null ? inventoryProduct.id : 0;
            $mdDialog.show({
                controller: 'ProductListDialogController',
                controllerAs: 'vm',
                locals: {
                    productId: prodId
                },
                templateUrl: 'app/main/apps/product/parameters/dialogs/product-list-dialog/product-list-dialog.html',
                parent: angular.element("#main"),
                targetEvent: ev,
                clickOutsideToClose: false
            }).then(function (answer) {
                if (answer) {
                    vm.productCompanyAddons.inventoryProduct = { id: answer.id };
                }
            });
        }

        function save() {

            if (vm.productCompanyAddons.loadInventorySingleProduct && vm.productCompanyAddons.inventoryProduct == null) {
                MessageService.showErrorMessage($filter('translate')('product_parameters.must_select_inventory_product'));
                return;
            } else if (vm.productCompanyAddons.loadInventorySingleProduct == null || !vm.productCompanyAddons.loadInventorySingleProduct) {
                vm.productCompanyAddons.inventoryProduct = null;
            }

            vm.messageOnLoadParameter = $filter('translate')('product_parameters.updating_parameters');

            if (vm.group) {
                vm.productCompanyAddons.fixedAssetGroupId = vm.group.id;
            }

            vm.loadingParameters = true;
            if (vm.batchUpdate && vm.saveInBatch) {
              saveProductBatch();
              return;
            }

            var promise;
            if (vm.productCompanyAddons.id) {
                promise = api.GeneralWS.ProductCompanyAddons.me.update({
                    "id": vm.productCompanyAddons.id, 'idCircle': $rootScope.bsCircle.id
                }, vm.productCompanyAddons).$promise;
            } else {
                vm.productCompanyAddons.product = { id: vm.selectedProduct.id };
                promise = api.GeneralWS.ProductCompanyAddons.me.create({
                    'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id
                }, vm.productCompanyAddons).$promise;
            }

            promise.then(function (response) {
                vm.loadingParameters = false;
                vm.productCompanyAddons = response;
                MessageService.show($filter('translate')('product_parameters.updated'));

                if (vm.onlyNotValidated && response.validated) {
                    vm.productos.content.splice(vm.productos.content.indexOf(vm.selectedProduct), 1);
                    vm.selectedProduct = null;
                    vm.productCompanyAddons = null;
                    return;
                }
                var product = angular.copy(vm.selectedProduct);
                vm.selectedProduct = null;

                selectProduct(product);
            }, function (response) {
                vm.loadingParameters = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
                selectProduct(vm.selectedProduct);
                $log.error(response);
            });
        }

        function saveFixedAsset() {
            if (vm.productCompanyAddons.fixedAsset === false) {
                vm.dissableCheck = false;
                save();
            } else {
                vm.dissableCheck = true;
            }
        }

        function querySearch(query) {
            return query ? vm.groups.filter(createFilterFor(query)) : vm.groups;

        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(model) {
                var lowercaseName;
                lowercaseName = angular.lowercase(model.fixedAssetGroupName);
                return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) > 0);
            };
        }


        vm.clearSearchProductGroup = function () {
            vm.searchProductGroup = "";
        };

        vm.clearSearchProductCompanyGroup = function () {
            vm.searchProductCompanyGroup = "";
        };

        function onGetProductAccount() {
            api.GeneralWS.ProductAccount.getAccount.query({
                'company': $rootScope.bsCircle.company.id, 'product': vm.selectedProduct.id
            }).$promise.then(function (response) {
                vm.grid.api.setRowData(response);

            }, function (response) {
                $log.error(response);
            });
        }

        function addAccount() {
            var account = {};
            account.company = $rootScope.bsCircle.company;
            account.product = vm.selectedProduct;
            account.active = true;

            $mdDialog.show({
                controller: 'ProductAccountController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/account/product-account.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': account,
                    'expenseType': vm.expenseType,
                    'accountType': vm.accountType
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('productAccount.added'));

                    onGetProductAccount();

                    selectProduct(vm.selectedProduct);
                }
            }, function () {

            });
        }

        function onEditAccount(account) {
            account.company = $rootScope.bsCircle.company;
            account.product = vm.selectedProduct;

            $mdDialog.show({
                controller: 'ProductAccountController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/account/product-account.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': account,
                    'expenseType': vm.expenseType,
                    'accountType': vm.accountType
                }
            }).then(function (answer) {
                if (answer) {
                    onGetProductAccount();

                    selectProduct(vm.selectedProduct);
                    MessageService.show($filter('translate')('productAccount.updated'));
                }
            }, function () {

            });
        }

        function onDeleteAccount(account) {
            account.active = false;

            var promise;
            promise = api.GeneralWS.ProductAccount.Account.update({ 'product': account.id }, account).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                if (response.$status === 200 || response.$status === 201) {
                    onGetProductAccount();
                    MessageService.show($filter('translate')('productAccount.updated'));
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                account.active = true;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function createCategoryTree(categoryParentId) {
            vm.categoriesLoaded = true;
            $timeout(function () {
                $.jstree.destroy();
                $('#tree')
                    .bind('dblclick.jstree', function (e, data) {
                        var tree = $(this).jstree();
                        var nd = tree.get_node(e.target);
                        vm.productCompanyAddons.productType = nd.original;
                        MessageService.show(nd.original.description + ' ' + $filter('translate')('productType.msg.selected'));
                        vm.disableButtonSave = false;
                        style();
                    })
                    .on('hover_node.jstree', function (e, data) {
                        $("#" + data.node.id).prop('title', data.node.text);
                        style();
                    })
                    .jstree({
                        'core': {
                            'data': function (node, callback) {
                                if (node.id !== '#') {
                                    categoryParentId = node.original.id;
                                }
                                api.GeneralWS.ProductType.categoryParent.get({
                                    'company': $rootScope.bsCircle.company.id,
                                    'idCircle': $rootScope.bsCircle.id,
                                    'categoryId': categoryParentId
                                }).$promise.then(function (response) {
                                    const data = new jinqJs()
                                        .from(response)
                                        .groupBy('productTypeParentId')
                                        .orderBy('productTypeCode')
                                        .select(function (r) {
                                            r.text = r.productTypeCode + "-" + r.description;
                                            if(r.productTypeParentId) {
                                                r.parent = r.productTypeParentId;
                                            } else {
                                                r.parent = '#';
                                            }
                                            r.productTypeParent = { id: r.productTypeParentId, description: r.productTypeParentDescription };
                                            let idN = null;
                                            if(r.productConditionId) {
                                                idN = r.productConditionId.toString();
                                            }
                                            r.productCondition = { id: idN };
                                            return r;
                                        });

                                    callback.call(this, data);
                                    if (data.length === 0) {
                                        vm.categoriesLoaded = false;
                                    }

                                }, function (response) {
                                    $log.error(response);
                                });
                                style();

                            },
                            "themes": {
                                "theme": "apple",
                                "icons": false
                            }
                        },
                        "search": {
                            "show_only_matches": false
                        },
                        'plugins': ["search", "crrm", "types", "wholerow", "themes"]
                    })
                    .bind("search.jstree", function (e, data) {
                        $("#tree").jstree("open_node", $("#" + data.res[0]));
                    });
            }, 3500);
            style();
        }

        function style() {
            $timeout(function () {
                document.querySelectorAll('.jstree-anchor').forEach(function (inf) {
                    inf.setAttribute("style", 'font-size:13px');
                });
            }, 300);
        }

        function getProductTypeParent(productType) {
            if (productType) {
                api.GeneralWS.ProductType.byCompany.getId({
                    'company': $rootScope.bsCircle.company.id, 'idCircle': $rootScope.bsCircle.id, 'id': productType.id
                }, function (response) {
                    if (response.description) {
                        $("#tree").jstree("search", response.productTypeCode + '-' + response.description);
                    }
                    if (response.productType && response.productType.id > 0) {
                        productType.productType = response.productType;
                        $("#tree").jstree("search", response.productType.productTypeCode + '-' + response.productType.description);
                        getProductTypeParent(productType.productType);
                    } else {
                        if (productType.description) {
                            $("#tree").jstree("search", productType.productTypeCode + '-' + productType.description);
                        }
                    }
                }, function () {
                });
            }
        }

        function saveProductType() {
            vm.disableButtonSave = true;

            vm.messageOnLoadParameter = $filter('translate')('product_parameters.updating_parameters');
            vm.loadingParameters = true;

            if (vm.group) {
              vm.productCompanyAddons.fixedAssetGroupId = vm.group.id;
            }

            if (vm.batchUpdate && vm.saveInBatch) {
              saveProductBatch();
              return;
            }

            var promise;
            if (vm.productCompanyAddons.id) {
                promise = api.GeneralWS.ProductCompanyAddons.me.update({
                    "id": vm.productCompanyAddons.id, 'idCircle': $rootScope.bsCircle.id
                }, vm.productCompanyAddons).$promise;
            } else {
                vm.productCompanyAddons.product = { id: vm.selectedProduct.id };
                promise = api.GeneralWS.ProductCompanyAddons.me.create({
                    'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id
                }, vm.productCompanyAddons).$promise;
            }

            promise.then(function (response) {
                vm.loadingParameters = false;
                vm.productCompanyAddons = response;
                MessageService.show($filter('translate')('product_parameters.updated'));

                if (vm.onlyNotValidated && response.validated) {
                    vm.productos.content.splice(vm.productos.content.indexOf(vm.selectedProduct), 1);
                    vm.selectedProduct = null;
                    vm.productCompanyAddons = null;
                }
                createCategoryTree(vm.categorySelected.id);
                $timeout(function () {
                    getProductTypeParent(vm.productCompanyAddons.productType ? vm.productCompanyAddons.productType : null);
                }, 3500);
            }, function (response) {
                vm.loadingParameters = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
                selectProduct(vm.selectedProduct);
                $log.error(response);
            });
        }

        function onGetFieldsValue() {
            api.GeneralWS.ProductCompanyAdditionalFieldsValue.getByProductAndCompany.query({ 'companyId': $rootScope.bsCircle.company.id, 'productId': vm.selectedProduct.id }).$promise.then(function (response) {
                vm.gridFields.api.setRowData(response);
            }, function (error) {
                $log.error(error);
            })
        }

        function addFieldValue() {
            $mdDialog.show({
                controller: 'AddonsFieldValueController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/fields-value/fields-value.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'fieldValue': {},
                    'productId': vm.selectedProduct.id
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('additional-field-value.created'));

                    onGetFieldsValue();

                    selectProduct(vm.selectedProduct);
                }
            }, function () {

            });
        }

        function onEditFieldValue(field) {
            $mdDialog.show({
                controller: 'AddonsFieldValueController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/fields-value/fields-value.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'fieldValue': field,
                    'productId': vm.selectedProduct.id
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('additional-field-value.updated'));

                    onGetFieldsValue();

                    selectProduct(vm.selectedProduct);
                }
            }, function () {

            });
        }

        function onDeleteFieldValue(field) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.ProductCompanyAdditionalFieldsValue.fieldValue.delete({ 'id': field.fieldValueId }).$promise.then(function (response) {
                MessageService.show($filter('translate')('additional-field-value.deleted'));
                onGetFieldsValue();
                vm.isShowProgressLinear = false;
            }, function (err) {
                $log.error(err);
                vm.isShowProgressLinear = false;
                field.active = true;
            });
        }

        function validateChecksIsActive(nameCheck) {
            if (vm.productCompanyAddons.isConsignment === true && vm.productCompanyAddons.providerCanInvoiceBeforeReceive === true) {
                if (nameCheck === 'isConsignment') {
                    MessageService.showErrorMessage($filter('translate')('product_parameters.canNotActivateIfCanInvoiceBefore'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('product_parameters.canNotActivateIfIsConsignment'));
                }
                vm.productCompanyAddons[nameCheck] = false;
            }
        }

        function addRepositionDays() {
            if (vm.productCompanyAddons.generateReposition) {
                $mdDialog.show({
                    controller: 'RepositionDaysDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/apps/product/parameters/dialogs/reposition-days-dialog/reposition-days-dialog.html',
                    parent: angular.element("#main"),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    locals: {
                        'productId': vm.selectedProduct.id
                    }
                }).then(function (answer) {
                    if (!answer || answer.length === 0) {
                        MessageService.showErrorMessage($filter('translate')('product_parameters.MSG.canNotActivateIfNoDataConfig'));
                        vm.productCompanyAddons.generateReposition = false;
                    }
                }, function (err) {
                });
            }
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('AddonsFieldValueController', AddonsFieldValueController);

    /**@ngInject**/
    function AddonsFieldValueController($mdDialog, api, fieldValue, productId, $log, MessageService, $filter, $rootScope, $timeout) {

        var vm = this;
        vm.company = $rootScope.bsCircle.company;

        //Methods
        vm.onOpenSelect = onOpenSelect;


        if (fieldValue.fieldValueId == null) {
            getCompanyAdditionalFields();

            vm.fieldValueModel = {
                id: 0,
                active: true,
                companyAdditionalFields: {},
                additionalFieldValue: ""
            }
        } else {
            vm.fieldValue = angular.copy(fieldValue);
            
            vm.fieldValueModel = {
                id: vm.fieldValue.fieldValueId,
                active: vm.fieldValue.active,
                companyAdditionalFields: vm.fieldValue.companyAdditionalFields,
                additionalFieldValue: vm.fieldValue.fieldValue, 

            }
        }

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;

        function getCompanyAdditionalFields() {
            vm.loadingAdditionalFields = true;
            api.GeneralWS.ProductCompanyAdditionalFieldsValue.companyAdditionalFields.getAvailables({ 'companyId': vm.company.id, 'productId': productId }).$promise.then(function (response) {
                vm.additionalFields = response;
                vm.loadingAdditionalFields = false;
            }, function (error) {
                $log.error(error);
                vm.loadingAdditionalFields = false;
            });
        }

        function save() {

            if (vm.fieldValueForm.$invalid) {
                return false;
            }

            var promise;

            if (vm.fieldValueModel.id) {
                promise = api.GeneralWS.ProductCompanyAdditionalFieldsValue.fieldValue.update({ 'id': vm.fieldValueModel.id}, vm.fieldValueModel).$promise;
            } else {
                promise = api.GeneralWS.ProductCompanyAdditionalFieldsValue.fieldValueAdd.create({'companyId': vm.company.id, 'productId': productId }, vm.fieldValueModel).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                $mdDialog.hide(response);

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('additional-field-value.field-value-exist'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function onOpenSelect(id) {
            $timeout(function () {
                $(id).focus();
            }, 500);
        }

        vm.clearSearchAdditionalField = function () {
            vm.searchAdditionalField = "";
        };

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };
            var searchAdditionalFieldInput = document.querySelector("#searchAdditionalField");

            if (searchAdditionalFieldInput) {
                searchAdditionalFieldInput.addEventListener("keydown", keyEvent);
            }
        }, 500);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ConsultProductsController', consultProductsController);

    /**@ngInject**/
    function consultProductsController(api, $rootScope, $timeout, $log, $filter, MessageService, $mdDialog) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 50;
        vm.onlyNotValidated = false;
        vm.messageOnLoadParameter = "";
        vm.generateFilter = generateFilter;
        generateFilter();
        vm.noFilter = false;

        // Methods
        vm.getProducts = getProducts;
        vm.selectProduct = selectProduct;
        vm.changeFilter = changeFilter;
        vm.save = save;
        vm.activateAll = activateAll;
        vm.saveFixedAsset = saveFixedAsset;
        vm.querySearch = querySearch;
        vm.addAccount = addAccount;
        vm.onEditAccount = onEditAccount;
        vm.onDeleteAccount = onDeleteAccount;

        vm.masterColumnDefs = [
            {
                headerName: 'company.provider',
                field: "company.name",
                headerCellRenderer: getHeader,
                width: 280

            },
            {
                headerName: 'pre-negotiated_price.currency',
                field: "currencySale.symbol",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'pre-negotiated_price.price',
                field: "salePrice",
                headerCellRenderer: getHeader,
                width: 100,
                enableRowGroup: true,
                enablePivot: true,
                valueFormatter: function (params) {
                    return $filter('number')(params.value, 2);
                },
                cellStyle: { 'text-align': 'right' }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 34,
            rowHeight: 34,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        vm.masterColumnDefsdepartments = [
            {
                headerName: 'department.departments',
                field: "department.description",
                headerCellRenderer: getHeader,
                width: 280

            },
            {
                headerName: 'product_parameters.urgentPurchase',
                name: "urgentPurchase",
                headerCellRenderer: getHeader,
                width: 180,
                cellRenderer: function (param) {
                    if (param.data.urgentPurchase) {
                        return '<div style="text-align: center;"><md-icon md-font-icon="icon-check" class="s30"></md-icon></div>';
                    } else {
                        return '<div style="text-align: center;"><md-icon md-font-icon="icon-close" class="s30"></md-icon></div>';
                    }
                }

            }
        ];

        var columnDefs = [
            {
                field: "accountingCatalog.code",
                headerName: 'productAccount.code',
                headerCellRenderer: getHeader,
                width: 100
            },
            {
                field: "accountingCatalog.description",
                headerName: 'productAccount.description',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "expenseType.description",
                headerName: 'productAccount.expenseType',
                headerCellRenderer: getHeader,
                width: 150
            },
            {
                field: "accountType.acTypeDescription",
                headerName: 'productAccount.accountType',
                headerCellRenderer: getHeader,
                width: 250
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 60,
                cellRenderer: function (params) {
                    if (params.value) {
                        return "<center><md-icon md-font-icon='icon-check'> </md-icon></center>";
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            }            
        ];

        vm.grid = {
            columnDefs: columnDefs,
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            enableFilter: true,
            rowHeight: 40,
            angularCompileRows: true,
            angularCompileHeaders: true,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        }

        vm.masterGridOptionsDepartments = {
            columnDefs: vm.masterColumnDefsdepartments,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 34,
            rowHeight: 34,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = '';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }

        //////////

        $timeout(init, 1500);

        /**
         * Initialize
         */
        function init() {

            var contentHeight = $("#consultProducts").innerHeight();
            contentHeight -= 192;
            vm.dinamicHeight = { "height": contentHeight + "px" };

            var contentHeight2 = $("#consultProducts").innerHeight();
            contentHeight2 -= 172;
            vm.dinamicMinHeight = { "min-height": contentHeight2 + "px" };

            var contentHeight3 = contentHeight - 95;
            vm.gridDinamicHeight = { "height": contentHeight3 + "px", "min-height": "250px" };

            getProducts(vm.page);
            api.ActivosFijosWS.FixedAssetGroup.me.get({ 'companyId': $rootScope.bsCircle.company.id },
                function (data) {
                    vm.groups = data;
                },
                function (data) {
                }
            );

            vm.loadingProductGroups = true;
            api.GeneralWS.ProductGroup.active.query({ 'country': $rootScope.bsCircle.company.country.id }, function (data) {
                vm.taxesGroup = data;
                vm.loadingProductGroups = false;
            });

            api.GeneralWS.Account.ExpenseType.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.expenseType = response;
            }, function (response) {
                $log.error(response);
            });

            vm.loadingProductCompanyGroups = true;
            api.GeneralWS.ProductCompanyGroup.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.productCompanyGroup = response;
                vm.loadingProductCompanyGroups = false;
            }, function (response) {
                $log.error(response);
            });

            vm.customText = {
                productcodeerp: $filter('translate')('product_parameters.productCodeERP'),
                productcodeerp2: $filter('translate')('product_parameters.erp_code2'),
                productcodeerp3: $filter('translate')('product_parameters.erp_code3')
            };

            api.GeneralWS.CompanyCustomText.byItemName.get({
                'companyId': $rootScope.bsCircle.company.id, itemName: 'apps.product.parameters'
            }).$promise.then(function (response) {
                for (var i = 0; i < response.length; i++) {
                    if (response[i].customText && response[i].customText !== '') {
                        vm.customText[response[i].keyName] = response[i].customText;
                    }
                }

            }, function (response) {
                $log.error(response);
            });

        }

        function getProducts(page) {
            vm.selectedProduct = null;
            vm.activeAll = false;
            vm.productCompanyAddons = null;
            vm.dissableCheck = false;
            vm.group = null;
            vm.searchText = null;
            vm.productos = [];
            vm.showAdvancedFilter = false;

            if (vm.filtrar && (vm.filtrar.validated !== null || vm.filtrar.prenegotiatedPrice !== null ||
                vm.filtrar.fixedAsset !== null || vm.filtrar.isConsignment !== null || vm.filtrar.isExento !== null ||
                vm.filtrar.generateReposition !== null || (vm.filtrar.productCodeERP !== null && vm.filtrar.productCodeERP !== '') ||
                (vm.filtrar.productCodeERP2 !== null && vm.filtrar.productCodeERP2 !== '') || (vm.filtrar.productCodeERP3 !== null &&
                    vm.filtrar.productCodeERP3 !== ''))) {
                vm.noFilter = true;
            } else {
                vm.noFilter = false;
            }

            vm.loading = true;
            if (!vm.noFilter) {
                api.GeneralWS.Product.get({
                    'page': page - 1, 'size': vm.pageSize, 'filter': vm.filterProduct, 'onlyNotValidated': vm.onlyNotValidated,
                    'companyId': $rootScope.bsCircle.company.id
                },
                    function (data) {
                        vm.productos = data;
                        vm.page = page;
                        vm.loading = false;
                    },
                    function (data) {
                        vm.loading = false;
                    }
                );
            } else {
                api.GeneralWS.ProductFilter.getByFilter({
                    'page': page - 1, 'size': vm.pageSize, 'filter': vm.filterProduct, 'onlyNotValidated': vm.onlyNotValidated,
                    'companyId': $rootScope.bsCircle.company.id
                }, vm.filtrar,
                    function (data) {
                        vm.productos = data;
                        vm.page = page;
                        vm.loading = false;
                    },
                    function (data) {
                        vm.loading = false;
                    }
                );
            }

        }

        function selectProduct(product) {
            if (vm.selectedProduct && product.id === vm.selectedProduct.id) {
                return null;
            }

            vm.selectedProduct = product;
            vm.activeAll = false;
            vm.productCompanyAddons = {};
            vm.dissableCheck = false;
            vm.group = null;
            vm.searchText = null;

            vm.messageOnLoadParameter = $filter('translate')('product_parameters.charging_parameters');
            vm.loadingParameters = true;
            api.GeneralWS.ProductCompanyAddons.me.get({
                'id': 'getByProductAndCompany', 'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id
            }).$promise.then(function (response) {
                $timeout(function () {
                    vm.loadingParameters = false;
                }, 1000);

                vm.productCompanyAddons = response;
                vm.activeAll = (vm.productCompanyAddons.fixedAsset === true && vm.productCompanyAddons.prenegotiatedPrice === true) ? true : false;
                vm.group = !vm.productCompanyAddons.fixedAssetGroupId ? null : _.find(vm.groups, function (group) {
                    return group.id === vm.productCompanyAddons.fixedAssetGroupId;
                });

                $timeout(function () {

                    var keyEvent = function (event) {
                        event.stopPropagation();
                    };

                    var searchProductGroupInput = document.querySelector("#searchProductGroup");
                    if (searchProductGroupInput) {
                        searchProductGroupInput.addEventListener("keydown", keyEvent);
                    }

                }, 1000);

            }, function (response) {
                vm.loadingParameters = false;
                $log.error(response);
            });

            vm.canAdd = false;
            api.GeneralWS.ProductAccount.getAccount.query({
                'company': $rootScope.bsCircle.company.id, 'product': vm.selectedProduct.id
            }).$promise.then(function (response) {
                vm.grid.api.setRowData(response);

            }, function (response) {
                $log.error(response);
            });

            vm.messageOnLoadPrenegociated = $filter('translate')('pre-negotiated_price.loading');
            vm.loadingPreNegociatedPrice = true;


            api.GeneralWS.ProductCompanyBuy.me.getByProductAndCompanyGreatCurrentDate({
                'id': 'getByProductAndCompanyGreatCurrentDate', 'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id
            }).$promise.then(function (response) {
                response.forEach(function (data) {
                    var ff = data.startDate.split("-");
                    var startDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                    data.startDate = startDate;
                    ff = data.endDate.split("-");
                    var endDate = new Date(ff[0], (parseInt(ff[1]) - 1), ff[2]);
                    data.endDate = endDate;
                });
                vm.productCompanyBuys = response.sort(function (a, b) {
                    return a.startDate - b.startDate;
                });
                vm.showGrid = true;
                $timeout(function () {
                    vm.loadingPreNegociatedPrice = false;
                }, 500);

            }, function (response) {
                vm.loadingPreNegociatedPrice = false;
                $log.error(response);
            });

            api.GeneralWS.ProductCompanySale.pageByProduct.get({
                'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id, filter: filter
            }, function (response) {
                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData(response.content);

            }, function (response) {
                vm.loadingPreNegociatedPrice = false;
                $log.error(response);
            });

            api.GeneralWS.Account.DepartmentProductByProd.me.page({
                'circleId': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id, 'departmentId': 0, 'companyId': $rootScope.bsCircle.company.id
            }, function (response) {
                vm.masterGridOptionsDepartments.api.setColumnDefs(vm.masterColumnDefsdepartments);
                vm.masterGridOptionsDepartments.api.setRowData(response);

            }, function (response) {
                vm.loadingPreNegociatedPrice = false;
                $log.error(response);
            });

            api.GeneralWS.ProductCompanyAddonsTags.ProductCompanyAddonsTags.getByProduct({
                'idCircle': $rootScope.bsCircle.id, 'idProduct': vm.selectedProduct.id
            }).$promise.then(function (response) {
                vm.productCompanyAddonsTags = response.sort(function (a, b) {
                    return a.id - b.id;
                });
                vm.showGrid = true;
                $timeout(function () {
                    vm.loadingTags = false;
                }, 500);

            }, function (response) {
                vm.loadingTags = false;
                $log.error(response);
            });

        }

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function activateAll() {

            vm.productCompanyAddons.fixedAsset = vm.activeAll;
            vm.productCompanyAddons.prenegotiatedPrice = vm.activeAll;
            vm.activeAll === true ? saveFixedAsset() : save();
        }

        function save() {

            vm.messageOnLoadParameter = $filter('translate')('product_parameters.updating_parameters');
            vm.loadingParameters = true;

            if (vm.group) {
                vm.productCompanyAddons.fixedAssetGroupId = vm.group.id;
            }

            var promise;
            if (vm.productCompanyAddons.id) {
                promise = api.GeneralWS.ProductCompanyAddons.me.update({
                    "id": vm.productCompanyAddons.id, 'idCircle': $rootScope.bsCircle.id
                }, vm.productCompanyAddons).$promise;
            } else {
                vm.productCompanyAddons.product = { id: vm.selectedProduct.id };
                promise = api.GeneralWS.ProductCompanyAddons.me.create({
                    'idCircle': $rootScope.bsCircle.id, 'productId': vm.selectedProduct.id
                }, vm.productCompanyAddons).$promise;
            }

            promise.then(function (response) {
                vm.loadingParameters = false;
                vm.productCompanyAddons = response;
                MessageService.show($filter('translate')('product_parameters.updated'));

                if (vm.onlyNotValidated && response.validated) {
                    vm.productos.content.splice(vm.productos.content.indexOf(vm.selectedProduct), 1);
                    vm.selectedProduct = null;
                    vm.productCompanyAddons = null;
                }
            }, function (response) {
                vm.loadingParameters = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
                selectProduct(vm.selectedProduct);
                $log.error(response);
            });
        }

        function saveFixedAsset() {
            if (vm.productCompanyAddons.fixedAsset === false) {
                vm.dissableCheck = false;
                save();
            } else {
                vm.dissableCheck = true;
            }
        }

        function querySearch(query) {
            return query ? vm.groups.filter(createFilterFor(query)) : vm.groups;

        }

        function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(model) {
                var lowercaseName='';
                lowercaseName = angular.lowercase(model.fixedAssetGroupName);
                return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) > 0);
            };
        }


        vm.clearSearchProductGroup = function () {
            vm.searchProductGroup = "";
        };


        function addAccount() {
            var account = {};
            account.company = $rootScope.bsCircle.company;
            account.product = vm.selectedProduct;
            account.active = true;

            $mdDialog.show({
                controller: 'ProductAccountController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/account/product-account.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': account,
                    'expenseType': vm.expenseType
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('productAccount.added'));

                    selectProduct(vm.selectedProduct);
                }
            }, function () {

            });
        }

        function onEditAccount(account) {
            account.company = $rootScope.bsCircle.company;
            account.product = vm.selectedProduct;

            $mdDialog.show({
                controller: 'ProductAccountController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/account/product-account.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': account,
                    'expenseType': vm.expenseType
                }
            }).then(function (answer) {
                if (answer) {
                    selectProduct(vm.selectedProduct);
                    MessageService.show($filter('translate')('productAccount.updated'));
                }
            }, function () {

            });
        }

        function onDeleteAccount(account) {
            account.active = false;

            var promise;
            promise = api.GeneralWS.ProductAccount.Account.update({ 'product': account.id }, account).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        MessageService.show($filter('translate')('productAccount.updated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function generateFilter() {
            vm.filtrar = {
                validated: null,
                prenegotiatedPrice: null,
                fixedAsset: null,
                isConsignment: null,
                isExento: null,
                generateReposition: null,
                productCodeERP: null,
                productCodeERP2: null,
                productCodeERP3: null
            };
            vm.noFilter = false;
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ProductCategoryFeatureController', productCategoryFeatureController);


    function productCategoryFeatureController($log, $timeout, api, MessageService, $mdDialog) {

        var vm = this;

        vm.associateFeature = associateFeature;

        function createCategoryTree() {
            $('#tree').jstree({
                'core': {
                    'data': function (node, callback) {

                        var categoryParentId = 0;

                        if (node.id !== '#') {
                            categoryParentId = node.original.categoryId;
                        }

                        api.GeneralWS.ProductCategory.TreeNodeChildren.query({ 'productCategoryId': categoryParentId }).$promise.then(function (response) {

                            callback.call(this, response);

                        }, function (response) {
                            $log.error(response);
                        });

                    },
                    "themes": {
                        "icons": false
                    }
                },
                'plugins': ["checkbox", "search", "contextmenu", "dnd", "crrm", "types"],
                "contextmenu": {
                    "items": function ($node) {

                        var menu = {};

                        if (!$node.original.hasChildren) {
                            menu.associateFeatures = {
                                "separator_before": false,
                                "separator_after": false,
                                "label": "Asociar caracteristicas",
                                "action": function (obj) {

                                    associateFeature($node.original.categoryId);

                                }
                            };
                        }

                        return menu;
                    }
                },
                "dnd": {
                    check_while_dragging: false
                }
            });
        }

        function associateFeature(productCategoryId) {

            $mdDialog.show({
                controller: 'AssociateCategoryFeatureController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/category-feature/associate-category-feature/associate-category-feature.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'productCategoryId': productCategoryId
                }
            }).then(function (answer) {
            }, function () {
            });
        }

        $timeout(function () {

            createCategoryTree();

        }, 1000);


    }

})();

(function () {
    'use strict';

    angular
        .module('app.product')
        .controller('ProductAccountListController', ProductAccountListController);

    /** @ngInject */
    function ProductAccountListController(api, $rootScope, $state, $scope, $mdToast, $timeout, $log, $filter, MessageService, $mdDialog) {
        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;

        // Methods
        vm.add = add;
        vm.edit = edit;
        vm.getProducts = getProducts;
        vm.selectProduct = selectProduct;
        vm.changeFilter = changeFilter;
        vm.onDelete = onDelete;
        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            api.GeneralWS.Account.ExpenseType.allActive.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.expenseType = response;
            }, function (response) {
                $log.error(response);
            });

            getProducts(vm.page);
        }

        function getProducts(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.Product.get({ page: page - 1, size: vm.pageSize, filter: vm.filterProduct },
                function (data) {
                    vm.productos = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function selectProduct(product) {
            vm.searchMode = false;
            vm.selectedProduct = product;
            vm.canAdd = false;

            api.GeneralWS.ProductAccount.getAccount.query({ 'company': $rootScope.bsCircle.company.id, 'product': vm.selectedProduct.id }).$promise.then(function (response) {
                vm.productAccount = response;
                vm.showGrid = true;
                vm.canAdd = !(response.length >= 2);

            }, function (response) {
                $log.error(response);
            });
        }

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getProducts(1);
            }
        }

        function add() {
            var account = {};
            account.company = $rootScope.bsCircle.company;
            account.product = vm.selectedProduct;
            account.active = true;

            $mdDialog.show({
                controller: 'ProductAccountController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/account/product-account.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': account,
                    'expenseType': vm.expenseType
                }
            }).then(function (answer) {
                if (answer) {
                    MessageService.show($filter('translate')('productAccount.added'));

                    selectProduct(vm.selectedProduct);
                }
            }, function () {

            });
        }

        function edit(account) {
            account.company = $rootScope.bsCircle.company;
            account.product = vm.selectedProduct;

            $mdDialog.show({
                controller: 'ProductAccountController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/product/account/product-account.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'account': account,
                    'expenseType': vm.expenseType
                }
            }).then(function (answer) {
                if (answer) {
                    selectProduct(vm.selectedProduct);
                    MessageService.show($filter('translate')('productAccount.updated'));
                }
            }, function () {

            });
        }

        function onDelete(account) {
            account.active = false;

            var promise;
            promise = api.GeneralWS.ProductAccount.Account.update({ 'product': account.id }, account).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        MessageService.show($filter('translate')('productAccount.updated'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.product')
        .controller('ProductAccountController', ProductAccountController);

    /**@ngInject**/
    function ProductAccountController($mdDialog, api, account, $log, MessageService, $filter, expenseType, $timeout, accountType) {

        var vm = this;

        vm.page = 1;
        vm.pageSize = 20;

        vm.expenseType = expenseType;
        vm.accountType = accountType;
        vm.account = angular.copy(account);

        /**
         * methods
         */
        vm.save = save;
        vm.cancel = cancel;
        vm.onEdit = onEdit;
        vm.getAccounts = getAccounts;
        vm.changeFilter = changeFilter;
        vm.selectProduct = selectProduct;

        vm.flipping = flipping;
        vm.newContact = true;
        vm.flip;

        $timeout(function () {
            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchAccountTypeInput = document.querySelector("#searchAccountType");
            if (searchAccountTypeInput) {
                searchAccountTypeInput.addEventListener("keydown", keyEvent);
            }
        }, 400);

        function flipping(funct) {
            vm.flip = funct;
            if (vm.newContact) {
                funct();
            }
        }

        function getAccounts(page) {
            vm.page = page;
            vm.loading = true;
            api.GeneralWS.Account.AccountingCatalog.ByDescription.get({ 'company': vm.account.company.id, page: page - 1, size: vm.pageSize, filter: vm.filterAccount },
                function (data) {
                    vm.accounts = data;
                    vm.loading = false;
                },
                function (data) {
                    vm.loading = false;
                }
            );
        }

        function changeFilter() {
            if (!vm.filterProduct || vm.filterProduct === '') {
                getAccounts(1);
            }
        }

        function selectProduct(product) {
            vm.searchMode = false;
            vm.selectedProduct = product;
            vm.account.accountingCatalog = product;
            vm.flip();
        }

        function save() {

            if (vm.accountForm.$invalid) {
                MessageService.show($filter('translate')('productAccount.completeInfo'));
                return false;
            }

            if (!vm.account) {
                $log.debug('No data');
                MessageService.show($filter('translate')('productAccount.completeInfo'));
                return false;
            }

            if (!vm.account.accountingCatalog) {
                $log.debug('No account');
                MessageService.show($filter('translate')('productAccount.completeInfo'));
                return false;
            }

            if (!vm.account.expenseType) {
                $log.debug('No expenseType');
                MessageService.show($filter('translate')('productAccount.completeInfo'));
                return false;
            }

            if (vm.account.expenseType.id <= 0) {
                $log.debug('No expenseType Id');
                MessageService.show($filter('translate')('productAccount.completeInfo'));
                return false;
            }

            if (!vm.account.accountType) {
                $log.debug('No accountType');
                MessageService.show($filter('translate')('productAccount.completeInfo'));
                return false;
            }

            if (vm.account.accountType.id <= 0) {
                $log.debug('No accountType Id');
                MessageService.show($filter('translate')('productAccount.completeInfo'));
                return false;
            }

            var promise;

            if (vm.account.id) {
                promise = api.GeneralWS.ProductAccount.Account.update({ 'product': vm.account.id }, vm.account).$promise;
            } else {
                promise = api.GeneralWS.ProductAccount.Account.create({ 'product': vm.account.product.id }, vm.account).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                        $mdDialog.hide(response);
                        break;
                    case 201:
                        $mdDialog.hide(response);
                        break;
                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);

                if (response.status === 302) {
                    MessageService.show($filter('translate')('productAccount.exists'));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
            });

        }

        function cancel() {
            $mdDialog.cancel();
        }

        function onEdit() {
            vm.flip();

            changeFilter();

            $timeout(function () {
                document.getElementById("searchAccount").focus();
            }, 600);
        }

    }

})();

(function () {

    'use strict';

    angular
        .module('app.notification')
        .controller('publishNotificationsController', publishNotificationsController);

    function publishNotificationsController(api, MessageService, $filter, $timeout, $rootScope) {
        const vm = this;
        vm.saveNotification = saveNotification;
        vm.notification = {
            startDate: new Date(),
            endDate: new Date()
        };
        vm.showButton = false;

        init();
        function init() {
            api.GeneralWS.CompanyApplication.appsByCompany.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.applications = response;
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
            changeSearch();
        }

        function saveNotification() {
            vm.showButton = true;
            vm.notification.startDate.setHours(0);
            vm.notification.startDate.setMinutes(0);
            vm.notification.startDate.setSeconds(0);

            vm.notification.endDate.setHours(23);
            vm.notification.endDate.setMinutes(59);
            vm.notification.endDate.setSeconds(59);

            vm.notification.companyId = $rootScope.bsCircle.company.id;

            api.NotificacionesWS.Notification.publishNotification.save(
                {
                    circleId: $rootScope.bsCircle.id
                },
                vm.notification,
                function () {
                    vm.notification = {
                        startDate: new Date(),
                        endDate: new Date(),
                        message: "",
                        applicationId: ""
                    };
                    vm.showButton = false;
                    MessageService.show($filter('translate')('publish.notificationSuccessFullPublished'));
                },
                function (errResponse) {
                    vm.showButton = false;
                    MessageService.showErrorMessage($filter('translate')('' + errResponse.data));
                }
            );
        }
        function changeSearch() {
            vm.clearSearchApplication = function () {
                vm.searchApplication = "";
            };
            $timeout(function () {

                const keyEvent = function (event) {
                    event.stopPropagation();
                };
                const searchAplicationInput = document.querySelector("#searchApplication");
                if (searchAplicationInput) {
                    searchAplicationInput.addEventListener("keydown", keyEvent);
                }
            }, 300);
        }

    }
})();

(function () {

    angular
        .module('app.bank', [])
        .config(config);

    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider) {

        $translatePartialLoaderProvider.addPart('app/main/apps/bank/');

        $stateProvider
            .state('app.bank', {
                abstract: true,
                url: '/bank'
            })
            .state('app.bank.bankAccount', {
                url: '/bankAccount',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/bank/bankAccount/bankAccount.html',
                        controller: 'bankAccountController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('app.bank.parameterConfiguration', {
                url: '/parameterConfiguration',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/apps/bank/parameterConfiguration/parameterConfiguration.html',
                        controller: 'bankParameterConfigurationController',
                        controllerAs: 'vm'
                    }
                }
            });

    }

})();

(function () {

    'use strict';

    angular
        .module('app.bank')
        .controller('bankAccountController', bankAccountController);

    /**@ngInject**/
    function bankAccountController() {}
})();

(function () {
    'use strict';

    angular
        .module('app.notification')
        .controller('notificationReportController', notificationReportController);

    function notificationReportController(MessageService, $rootScope, api, $filter, $timeout, $log) {
        const vm = this;
        vm.showFilterTab = false;
        vm.expandFilter = true;
        vm.showGrid = false;
        vm.applicationNotSelected = [];
        vm.isShowFilter = true;
        vm.notification = {
            startDate: new Date(),
            endDate: new Date(),
            filterEndDate:false
        };
        vm.onDesactivate = onDesactivate;

        //metodos
        vm.query = query;
        function getApplicationByCompany() {
            api.GeneralWS.CompanyApplication.appsByCompany.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                vm.applications = new jinqJs()
                    .from(response)
                    .select(
                        function (r) {
                            return r.application;
                        }
                    );
                vm.applicationByCompany = new jinqJs()
                    .from(vm.applications)
                    .orderBy([{ field: 'name', sort: 'asc' }])
                    .select();

                for (var i = 0; i < vm.applicationByCompany.length; i++) {
                    vm.applicationNotSelected.push(vm.applicationByCompany[i].id);
                }
            }, function (response) {
                $log.error(response);
            });
        }

        function query() {
            vm.isShowFilter = false;
            vm.showFilterTab = true;
            if (vm.notification.startDate === undefined) {
                vm.notification = vm.parameters;
            }
            vm.notification.startDate.setHours(0);
            vm.notification.startDate.setMinutes(0);
            vm.notification.startDate.setSeconds(0);

            vm.notification.endDate.setHours(23);
            vm.notification.endDate.setMinutes(59);
            vm.notification.endDate.setSeconds(59);

            if (vm.notification.applications === undefined || vm.notification.applications.length === 0) {
                vm.notification.applications = vm.applicationNotSelected;
            }
            vm.parameters = vm.notification;
            vm.notification.companyId = $rootScope.bsCircle.company.id;
            api.NotificacionesWS.Notification.getNotificationsByApplication.query({ circleId: $rootScope.bsCircle.id }, vm.notification).$promise.then(function (response) {
                vm.allNotification = response;
                vm.gridOptions.api.setRowData(vm.allNotification);
                vm.showGrid = true;
                vm.expandFilter = false;
                vm.loading = false;
            }, function (response) {
                vm.loading = false;
                $log.error(response);
            });
        }

        const columnsNotifications = [
            {
                suppressMenu: true,
                headerName: $filter('translate')('publish.message'),
                field: "message",
                width: 350,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'publish.desactivate',
                headerCellRenderer: getHeader,
                width: 300,
                cellRenderer: function() {
                    return '<center> <md-button class="md-warn" ng-click="vm.onDesactivate(data)"><span style="font-weight: bold;">{{"publish.desactivate"| translate}}</span></md-button></center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.gridOptions = {
            columnDefs: columnsNotifications,
            enableSorting: true,
            debug: false,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            headerHeight: 50,
            pinnedBottomRowData: [],
            rowHeight: 45
        };


        function onDesactivate(data) {
            vm.notification = {
                id: data.id,
                companyId: data.company.id,
                applicationId: data.application.id
            };

            api.NotificacionesWS.Notification.publishNotification.save(
                {
                    circleId: $rootScope.bsCircle.id
                },
                vm.notification).$promise.then(function () {
                    const i = vm.allNotification.indexOf(data);
                        vm.allNotification.splice(i, 1);
                        vm.gridOptions.api.setRowData(vm.allNotification);
                    MessageService.show($filter('translate')('company_applications.desactivadaCorrectamente'));
                    $rootScope.loadingProgress = false;

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
        }


        function changeSearch() {
            vm.clearSearchApplication = function () {
                vm.searchApplication = "";
            };
            $timeout(function () {

                const keyEvent = function (event) {
                    event.stopPropagation();
                };
                const searchAplicationInput = document.querySelector("#searchApplication");
                if (searchAplicationInput) {
                    searchAplicationInput.addEventListener("keydown", keyEvent);
                }
            }, 300);
        }

        function init() {
            getApplicationByCompany();
        }
        changeSearch();
        $timeout(init, 500);
    }
})();

(function () {

    'use strict';

    angular
        .module('app.notification')
        .controller('NotificationTypeScheduleListController', notificationTypeScheduleListController);

    /**@ngInject**/
    function notificationTypeScheduleListController($rootScope, $log, $timeout, $filter, api, MessageService, $mdDialog, Company) {

        var vm = this;

        vm.isShowFilter = true;
        vm.exchangeNotificationType = {}

        //metodos
        vm.search = search;
        vm.clearSearchNotificationType = clearSearchNotificationType;
        vm.add = add;
        vm.onDelete = onDelete;
        vm.addParams = addParams;

        var columnDefs = [{
                headerName: "notificationTypeSchedule.dayOfWeek",
                field: "dayOfWeek",
                headerCellRenderer: getHeader,
                width: 150,
                hide: false,
                cellRenderer: function (params) {
                    return dayOfWeekAsString(params.value);
                }
            },
            {
                headerName: "notificationTypeSchedule.startDate",
                field: "startDate",
                headerCellRenderer: getHeader,
                width: 150,
                hide: false
            },
            {
                headerName: "notificationTypeSchedule.endDate",
                field: "endDate",
                headerCellRenderer: getHeader,
                width: 150,
                hide: false
            },
            {
                headerName: "notificationTypeSchedule.hourOfDay",
                field: "hourOfDay",
                headerCellRenderer: getHeader,
                width: 150,
                hide: false
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: {
                    'padding': '5px'
                }
            },
            {
                field: "options",
                headerName: 'notificationTypeSchedule.actions',
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 150,
                cellRenderer: function (params) {
                    return '<center> ' +
                        '<md-button class="md-icon-button" ng-click="vm.add(data)"> ' +
                        '<md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> ' +
                        '</md-button> ' +
                        '<md-button class="md-icon-button" ng-click="vm.addParams(data)"> ' +
                        '<md-icon md-font-icon="icon-cog"></md-icon> <md-tooltip md-direction="left">{{"notificationTypeSchedule.addParams"| translate}}</md-tooltip> ' +
                        '</md-button> ' +
                        '</center> ';
                }
            }
        ];

        vm.masterGridOptions = {
            enableSorting: true,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            toolPanelSuppressGroups: true,
            fullWidthCellRenderer: true,
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function createNewDatasource() {
            vm.masterGridOptions.api.setColumnDefs(columnDefs);
            vm.masterGridOptions.api.setRowData([]);

            api.NotificacionesWS.NotificationTypeSchedule.allNotificationTypeSchedule.query({
                'notificationTypeId': vm.exchangeNotificationType.notificationType.id,
                'companyId': Company.id
            }, function (response) {
                vm.showGrid = true;
                vm.isShowProgressLinear = false;

                vm.masterGridOptions.api.setRowData(new jinqJs()
                    .from(response)
                    .orderBy([{
                        field: 'hourOfDay',
                        sort: 'asc'
                    },{
                        field: 'dayOfWeek',
                        sort: 'asc'
                    }])
                    .select()
                );
            }, function (response) {
                $log.error(response);
            });

            vm.isShowFilter = false;
        }

        function clearSearchNotificationType() {
            vm.searchNotificationType = "";
        }

        function search() {
            if (vm.exchangeNotificationType.notificationType !== undefined || vm.exchangeNotificationType.notificationType != null) {
                vm.isShowProgressLinear = true;
                createNewDatasource()
            }
        }

        function dayOfWeekAsString(data) {
            var index = data - 1;
            return ["{{'daysOfWeek.Sunday'| translate}}",
                    "{{'daysOfWeek.Monday'| translate}}",
                    "{{'daysOfWeek.Tuesday'| translate}}",
                    "{{'daysOfWeek.Wednesday'| translate}}",
                    "{{'daysOfWeek.Thursday'| translate}}",
                    "{{'daysOfWeek.Friday'| translate}}",
                    "{{'daysOfWeek.Saturday'| translate}}"
                ]
                [index];
        }

        function add(data) {
            vm.notificationTypeSchedule = {
                'active': true,
                'notificationType': vm.exchangeNotificationType.notificationType,
                'company': Company
            }

            if (data != null || data != undefined) {
                vm.notificationTypeSchedule = angular.copy(data);
            }

            $mdDialog.show({
                controller: 'dialogNotificationTypeScheduleController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/notification/dialogs/dialog-notification-type-schedule/dialog-notification-type-schedule.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'notificationTypeSchedule': vm.notificationTypeSchedule
                }
            }).then(function (answer) {
                if (answer) {
                    createNewDatasource();
                    MessageService.show($filter('translate')('notificationTypeSchedule.added'));

                }
            }, function () {});
        }

        function onDelete(data) {
            data.active = false;

            var promise;
            promise = api.NotificacionesWS.NotificationTypeSchedule.me.update({
                'idCircle': $rootScope.bsCircle.id,
                'id': data.id
            }, data).$promise;

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;

                switch (response.$status) {
                    case 200:
                    case 201:
                        vm.masterGridOptions.api.forEachNode(function (row, index) {
                            if (row.data.id === response.id) {
                                row.data = response;
                            }
                        });
                        vm.masterGridOptions.api.redrawRows();
                        MessageService.show($filter('translate')('notificationTypeSchedule.deactivated_successfully'));
                        break;

                    default:
                        $log.error(response);
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                        break;
                }

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function addParams(data) {
            $mdDialog.show({
                controller: 'dialogScheduleParameterController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/notification/dialogs/dialog-scheduleParameter/dialog-scheduleParameter.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'notificationTypeSchedule': data
                }
            }).then(function () {}, function () {});
        }

        function init() {
            initSearchNotificationTypeField();
            api.NotificacionesWS.NotificationType.allNotificationType.query({},
                function (data) {
                    vm.notificationTypes = angular.copy(data);

                    if (data.length === 1) {
                        vm.exchangeNotificationType.notificationType = vm.notificationTypes[0];
                    }

                }
            );
        }

        $timeout(function () {
            init();
        }, 1000);

        function initSearchNotificationTypeField() {
            $timeout(function () {
                var keyEvent = function (event) {
                    event.stopPropagation();
                };

                var searchParameterInput = document.querySelector("#searchNotificationType");

                if (searchParameterInput) {
                    searchParameterInput.addEventListener("keydown", keyEvent);
                }
            }, 300);
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.interfaz')
        .controller('InterfazReportController', InterfazReportController);

    function InterfazReportController(api, $log, $rootScope, $timeout, $filter, $mdDialog) {

        var vm = this;
        var pageSize = 100;

        vm.isShowFilter = true;
        vm.minDate = new Date();
        vm.filter = {
            startDate: new Date(vm.minDate.getTime()),
            endDate: new Date(vm.minDate.getTime())
        };
        vm.entityCatalogArray = [];
        vm.masterColumnDefs = [];
        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            rowGroupPanelShow: "always",
            toolPanelSuppressGroups: true,
            groupHeaders: true,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: pageSize,
            pagination: true,
            fullWidthCellRenderer: true,
            rowData: null,
            pinnedBottomRowData: [],
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        //methods
        vm.clearSearchEntity = clearSearchEntity;
        vm.changeStartDate = changeStartDate;
        vm.setDateType = setDateType;
        vm.search = search;
        vm.showDetails = showDetails;

        function addColumnsToGrid() {
            vm.masterColumnDefs = [
                {
                    headerName: $filter('translate')('REPORT.schema'),
                    field: "entityCatalog.entitySchema",
                    width: 300,
                    enableRowGroup: true,
                    enablePivot: true,
                    cellRenderer: "group"
                },
                {
                    headerName: $filter('translate')('REPORT.entity'),
                    field: "entityCatalog.entityName",
                    width: 300,
                    enableRowGroup: true,
                    enablePivot: true,
                    cellRenderer: "group"
                },
                {
                    headerName: $filter('translate')('REPORT.entity_id'),
                    field: "theID",
                    width: 150,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: $filter('translate')('REPORT.erp_reference_code'),
                    field: "erpCodeReference",
                    width: 300,
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    headerName: $filter('translate')('REPORT.sent_successfully'),
                    field: "isSucessfully",
                    width: 250,
                    enableRowGroup: true,
                    enablePivot: true,
                    cellRenderer: function (params) {
                        if (params.data && params.data.isSucessfully) {
                            return '<center> <md-icon md-font-icon="icon-check"></md-icon> </center>';
                        } else {
                            return '<center> <md-icon md-font-icon="icon-close"></md-icon> </center>';
                        }
                    }
                },
                {
                    headerName: $filter('translate')('REPORT.date_of_transaction'),
                    field: "createdAt",
                    valueFormatter: getCellFormater("localDateTime"),
                    enableRowGroup: true,
                    enablePivot: true
                },
                {
                    suppressMenu: true,
                    suppressSorting: true,
                    headerName: $filter('translate')('REPORT.show_details'),
                    name: "showDetails",
                    width: 110,
                    cellRenderer: function (params) {
                        if (params.data && params.data.id) {
                            return '<center> <md-button class="md-icon-button" ng-click="vm.showDetails(data, $event)"> <md-icon md-font-icon="icon-eye" class="s16"></md-icon> <md-tooltip md-direction="left">Ver detalles</md-tooltip> </md-button> </center>';
                        }
                        return '';
                    },
                    cellStyle: { 'padding': '0px' }
                }
            ];

            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
        }

        function getCellFormater(type) {
            switch (type) {
                case 'date':
                    return function (params) {
                        return $filter('date')(params.value, 'dd/MM/yyyy');
                    };
                case 'currency':
                    return function (params) {
                        return $filter('number')(params.value, '2');
                    };
                case 'localDateTime':
                    return function (params) {
                        if (params.value === undefined || params.value === null) {
                            return '';
                        } else {
                            return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
                        }
                    };
                default:
                    break;
            }
        }

        function getEntityCatalogArray() {
            vm.loadingEntityArray = true;
            api.InterfazWS.EntityCatalog.me.query({}).$promise.then(function (response) {
                vm.loadingEntityArray = false;
                vm.entityCatalogArray = response;
            }, function (response) {
                vm.loadingEntityArray = false;
                $log.error(response);
            });
        }

        function search() {
            vm.filter.startDate.setHours(0);
            vm.filter.startDate.setMinutes(0);
            vm.filter.startDate.setSeconds(0);

            vm.filter.endDate.setHours(23);
            vm.filter.endDate.setMinutes(59);
            vm.filter.endDate.setSeconds(59);

            vm.pageNumber = 0;
            createNewDatasource();
            vm.isShowFilter = false;
        }

        function createNewDatasource() {
            var dataSource = {
                paginationPageSize: pageSize,
                getRows: function (params) {
                    var parameters = {
                        companyId: $rootScope.bsCircle.company.id,
                        pageNumber: vm.pageNumber,
                        pageSize: pageSize
                    };

                    $rootScope.loadingProgress = true;
                    api.InterfazWS.InterfazTransaction.findByFilter.page(parameters, vm.filter).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;
                        params.successCallback(response.content, response.totalElements);
                        vm.pageNumber = response.number;
                        vm.showGrid = true;
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        function clearSearchEntity() {
            vm.searchEntity = "";
        }

        function initEvents() {
            var keyEvent = function (event) {
                event.stopPropagation();
            };

            var searchEntityInput = document.querySelector("#searchEntityInput");

            if (searchEntityInput) {
                searchEntityInput.addEventListener("keydown", keyEvent);
            }

        }

        function changeStartDate(isStart) {
            if (isStart) {
                if (vm.filter.startDate > vm.filter.endDate) {
                    vm.filter.endDate = vm.filter.startDate;
                }
            }
            vm.filter.startDate = setDateType(vm.filter.startDate, false);
            vm.filter.endDate = setDateType(vm.filter.endDate, true);
        }

        function setDateType(date, end) {
            if (end) {
                date.setHours(23);
                date.setMinutes(59);
                date.setSeconds(59);
            } else {
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
            }
            return date;
        }

        function showDetails(transaction, event) {
            $mdDialog.show({
                controller: 'InterfazReportDetailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/interfaz/report/dialogs/detail/detail.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'detailArray': transaction.details
                },
                clickOutsideToClose: false
            }).then(function (response) {
            }, function (response) {
            });
        }

        function init() {
            getEntityCatalogArray();
            initEvents();
            addColumnsToGrid();
        }

        $timeout(init, 1000);
    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('AdditionalFieldsController', additionalFieldsController);

    function additionalFieldsController($log, api, MessageService, $filter, $timeout, $rootScope, $mdDialog) {

        var vm = this;
        var pageSize = 100;

        vm.getData = getData;
        vm.createAdditionalFields = createAdditionalFields;
        vm.deleteAdditionalFields = deleteAdditionalFields;

        vm.dataTypes = [
            { value: 'TEXT', text: 'Texto' },
            { value: 'NUMBER', text: 'Número' },
            { value: 'DECIMAL', text: 'Número Decimal' },
            { value: 'BOOLEAN', text: 'Lógico' },
            { value: 'LIST', text: 'Lista' }
        ];

        vm.masterColumnDefs = [
            {
                headerName: "ADDITIONAL_FIELDS.additionalFieldName",
                headerCellRenderer: getHeader,
                field: "additionalFieldName",
                width: 400,
                cellRenderer: "group"
            },
            {
                headerName: "ADDITIONAL_FIELDS.dataType",
                headerCellRenderer: getHeader,
                name: "dataType",
                cellRenderer: function (params) {
                    for (var i = 0; i < vm.dataTypes.length; i++) {
                        if (vm.dataTypes[i].value === params.data.dataType) {
                            return vm.dataTypes[i].text;
                        }
                    }



                },
                width: 200
            },
            {
                headerName: "ADDITIONAL_FIELDS.useInOpeningCycle",
                headerCellRenderer: getHeader,
                field: "useInOpeningCycle",
                cellRenderer: function (params) {
                    if (params.data.useInOpeningCycle) {
                        return '<center><md-icon md-font-icon="icon-check"></md-icon></center>';
                    } else {
                        return '<center><md-icon md-font-icon="icon-close"></md-icon></center>';
                    }
                },
                width: 200,
                cellStyle: { 'align': 'center' }
            },
            {
                suppressMenu: true,
                suppressSorting: true,
                headerName: "ADDITIONAL_FIELDS.options",
                headerCellRenderer: getHeader,
                name: "edit",
                width: 250,
                cellRenderer: function (params) {
                    if (params.data && params.data.id) {
                        return '<md-button class="md-icon-button" ng-click="vm.createAdditionalFields(data, $event)"> '
                            + ' <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip>'
                            + ' </md-tooltip> </md-button> '
                            + ' <md-button class="md-icon-button" ng-click="vm.deleteAdditionalFields(data, $index)"> '
                            + ' <md-icon md-font-icon="icon-trash" class="md-warn s16"></md-icon> '
                            + ' <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip></md-tooltip> </md-button> '
                            + ' <md-button ng-disabled="data.dataType!==\'LIST\'" class="md-icon-button" ng-click="vm.listCompanyAdditionalFieldsValue(data, $index)"> '
                            + ' <md-icon md-font-icon="icon-menu" class="s16"></md-icon> <md-tooltip md-direction="left">{{"ADDITIONAL_FIELDS.detailList"| translate}}</md-tooltip>'
                            + ' </md-tooltip> </md-button> '
                            + ' <md-button class="md-icon-button" ng-click="vm.appCompanyAdditionalFieldsValue(data, $index)"> '
                            + ' <md-icon md-font-icon="icon-apps" class="s16"></md-icon> '
                            + ' <md-tooltip md-direction="left">{{"ADDITIONAL_FIELDS.APPS"| translate}}</md-tooltip></md-tooltip> </md-button>';
                    }
                    return '';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            rowGroupPanelShow: "none",
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: pageSize,
            pagination: true,
            fullWidthCellRenderer: true,
            rowData: null,
            pinnedBottomRowData: [],
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        //methods

        function init() {
            getData();
        }

        function getData() {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            createNewDatasource();
        }

        function createNewDatasource() {
            var dataSource = {
                paginationPageSize: pageSize,
                getRows: function (params) {
                    var parameters = {
                        company: $rootScope.bsCircle.company.id
                    };

                    $rootScope.loadingProgress = true;
                    api.GeneralWS.CompanyAdditionalFields.getByCompany.get(parameters).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;
                        params.successCallback(response, response.length);
                        vm.showGrid = true;

                        vm.pageNumber = response.number;

                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        function createAdditionalFields(detail) {
            $mdDialog.show({
                controller: 'AdditionalFieldsEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/additionalFields/additionalFieldsEdit/additionalFieldsEdit.html',
                parent: angular.element("#main"),
                multiple: true,
                targetEvent: window.event,
                locals: {
                    'additionalField': detail
                },
                clickOutsideToClose: false
            }).then(function (response) {
                init();
            }, function () { });
        }

        function deleteAdditionalFields(detail, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('ADDITIONAL_FIELDS.delete'))
                .textContent($filter('translate')('ADDITIONAL_FIELDS.deleteConfirm'))
                .ok($filter('translate')('BLOCKEDSERIES.SI'))
                .cancel($filter('translate')('BLOCKEDSERIES.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.CompanyAdditionalFields.getByCompany.delete({ id: detail.id }, function (response) {// Success
                    MessageService.show($filter('translate')('ADDITIONAL_FIELDS.deleted'));
                    createNewDatasource();
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                    if (response.data === "not update") {
                        MessageService.show($filter('translate')('BLOCKEDSERIES.ERRORUPDATE'));
                    }
                });
            }, function () {
            });
        }

        vm.listCompanyAdditionalFieldsValue = function (detail) {
            $mdDialog.show({
                controller: 'AdditionalFieldsEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/additionalFields/additionalFieldsEdit/aditionalFieldDetail.html',
                parent: angular.element("#main"),
                targetEvent: window.event,
                locals: {
                    'additionalField': detail
                },
                clickOutsideToClose: false
            }).then(function (response) {
                init();
            }, function () { });
        }

        $timeout(init, 1000);

        vm.appCompanyAdditionalFieldsValue = function (data, index) {
            $mdDialog.show({
                controller: 'dialogAdditionalFieldAppEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/additionalFields/dialogAdditionalFieldApp/dialogAdditionalFieldApp.html',
                parent: angular.element("#main"),
                targetEvent: window.event,
                locals: {
                    'data': data
                },
                clickOutsideToClose: false
            }).then(function (response) {
                init();
            }, function () { });
        };

    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('gFaceController', gFaceController);

    function gFaceController($log, api, MessageService, $filter, $timeout, $rootScope, $mdDialog) {
        const vm = this;
        vm.createGface = createGface;
        vm.deleteGface = deleteGface;
        vm.searchByCompanyGface = searchByCompanyGface;

        function searchByCompanyGface() {
            vm.showSearch = true;
            vm.masterGridCompanyGface.api.setColumnDefs(vm.masterColumnCompanyGface);
            createNewDatasource();
        }

        function createNewDatasource() {
            const dataSource = {
                getRows: function (params) {
                    api.GeneralWS.CompanyGface.byCompanyGface.query({ 'companyId': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                        vm.isShowProgressLinear = false;
                        params.successCallback(response, response.length);
                        vm.showGrid = true;
                    }, function (response) {
                        $log.error(response);
                    });
                }
            };
            vm.masterGridCompanyGface.api.setEnterpriseDatasource(dataSource);
            return true;
        }

        $timeout(function () {
            vm.masterGridCompanyGface.api.setColumnDefs(vm.masterColumnCompanyGface);
            createNewDatasource();
        }, 300);

        vm.masterColumnCompanyGface = [
            {
                headerName: 'GFACE.gFaceName',
                field: "gface.gfaceName",
                width: 200,
                headerCellRenderer: getHeader,
                enablePivot: true,
                enableRowGroup: true
            },
            {
                headerName: 'GFACE.orderPriority',
                field: "orderPriority",
                enableRowGroup: true,
                width: 200,
                enablePivot: true,
                headerCellRenderer: getHeader

            },
            {
                headerName: 'GFACE.userToSignDocuments',
                field: "userToSignDocuments",
                width: 250,
                enableRowGroup: true,
                headerCellRenderer: getHeader,
                enablePivot: true
            },
            {
                headerName: 'GFACE.keyToSignDocuments',
                field: "keyToSignDocuments",
                enableRowGroup: true,
                headerCellRenderer: getHeader,
                width: 250,
                enablePivot: true
            },
            {
                headerName: 'GFACE.aliasPfx',
                field: "aliasPfx",
                headerCellRenderer: getHeader,
                enableRowGroup: true,
                width: 200,
                enablePivot: true
            },
            {
                headerName: 'GFACE.keyPfx',
                field: "keyPfx",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'GFACE.ACTIONS',
                name: "actions",
                enableRowGroup: true,
                headerCellRenderer: getHeader,
                width: 200,
                enablePivot: true,
                cellRenderer: function renderer() {
                    return '<md-button class="md-icon-button" ng-click="vm.createGface(data, $event)"> <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
                        + ' <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip></md-tooltip> </md-button> '
                        + ' <md-button class="md-icon-button" ng-click="vm.deleteGface(data, $index)"> '
                        + ' <md-icon md-font-icon="icon-trash" class="md-warn s16"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip>'
                        + ' </md-tooltip> </md-button>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridCompanyGface = {
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            pagination: false,
            columnDefs: vm.masterColumnCompanyGface,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: []
        };
        function createGface(detail) {
            $mdDialog.show({
                controller: 'gFaceEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/gFace/gFaceEdit/gFaceEdit.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'data': detail
                },
                clickOutsideToClose: false
            }).then(function () {
                searchByCompanyGface();
            });
        }

        function deleteGface(detail) {
            const confirm = $mdDialog.confirm()
                .title($filter('translate')('GFACE.delete'))
                .textContent($filter('translate')('GFACE.deleteConfirm'))
                .ok($filter('translate')('GFACE.SI'))
                .cancel($filter('translate')('GFACE.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.CompanyGface.companyGface.del({ 'companyId': $rootScope.bsCircle.company.id, 'gFaceId': detail.gface.id }, function () {// Success
                    MessageService.show($filter('translate')('GFACE.deleted'));
                    $rootScope.loadingProgress = false;
                    searchByCompanyGface();
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                });
            });
        }
    }

})();

(function () {

    'use strict';

    angular
        .module('app.generalConfiguration')
        .controller('DiscountsController', DiscountsController);

    function DiscountsController($log, api, MessageService, $filter, $timeout, $rootScope, $mdDialog) {

        var vm = this;
        var pageSize = 100;

        vm.getData = getData;
        vm.createDiscount = createDiscount;
        vm.deleteAdditionalFields = deleteAdditionalFields;

        vm.masterColumnDefs = [
            {
                headerName: "DISCOUNTS.name",
                headerCellRenderer: getHeader,
                field: "discountName",
                width: 400,
                cellRenderer: "group"
            },
            {
                headerName: "DISCOUNTS.value",
                headerCellRenderer: getHeader,
                field: "discountValue",
                width: 200
            },
            {
                field: 'discountMethod',
                headerName: 'DISCOUNTS.applicationMethod',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    if (params.data) {
                        return $filter("translate")("DISCOUNTS.discountMethods." + params.data.discountMethod);
                    }
                },
                width: 200
            },
            {
                suppressMenu: true,
                suppressSorting: true,
                headerName: "ADDITIONAL_FIELDS.options",
                headerCellRenderer: getHeader,
                name: "edit",
                width: 250,
                cellRenderer: function (params) {
                    if (params.data && params.data.id) {
                        return '<md-button class="md-icon-button" ng-click="vm.createDiscount(data, $event)"> <md-icon md-font-icon="icon-border-color" class="s16"></md-icon> '
                            + ' <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip></md-tooltip> </md-button> '
                            + ' <md-button class="md-icon-button" ng-click="vm.deleteAdditionalFields(data, $index)"> '
                            + ' <md-icon md-font-icon="icon-trash" class="md-warn s16"></md-icon> <md-tooltip md-direction="left">{{"general.delete"| translate}}</md-tooltip>'
                            + ' </md-tooltip> </md-button>';
                    }
                    return '';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridOptions = {
            enableSorting: true,
            debug: false,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            groupSuppressBlankHeader: true,
            rowGroupPanelShow: "none",
            toolPanelSuppressGroups: true,
            groupHeaders: false,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: pageSize,
            pagination: true,
            fullWidthCellRenderer: true,
            rowData: null,
            pinnedBottomRowData: [],
            rowHeight: 40,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        //methods

        function init() {
            getData();
        }

        function getData() {
            vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
            createNewDatasource();
        }

        function createNewDatasource() {
            var dataSource = {
                paginationPageSize: pageSize,
                getRows: function (params) {
                    var parameters = {
                        idCircle: $rootScope.bsCircle.id
                    };
                    $rootScope.loadingProgress = true;
                    api.GeneralWS.DiscountCompany.DiscountCompany.get(parameters).$promise.then(function (response) {
                        $rootScope.loadingProgress = false;
                        params.successCallback(response, response.length);
                        vm.showGrid = true;
                        vm.pageNumber = response.number;
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });
                }
            };
            vm.masterGridOptions.api.setEnterpriseDatasource(dataSource);
        }

        function createDiscount(detail) {
            $mdDialog.show({
                controller: 'dialogDiscountsController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/discounts/dialogDiscounts/dialogDiscounts.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'data': detail
                },
                clickOutsideToClose: false
            }).then(function (response) {
                init();
            }, function () { });
        }

        function deleteAdditionalFields(detail, index) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('ADDITIONAL_FIELDS.delete'))
                .textContent($filter('translate')('ADDITIONAL_FIELDS.deleteConfirm'))
                .ok($filter('translate')('BLOCKEDSERIES.SI'))
                .cancel($filter('translate')('BLOCKEDSERIES.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.DiscountCompany.DiscountCompany.del({ id: detail.id }, function (response) {// Success
                    MessageService.show($filter('translate')('ADDITIONAL_FIELDS.deleted'));
                    createNewDatasource();
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                    if (response.data === "not update") {
                        MessageService.show($filter('translate')('BLOCKEDSERIES.ERRORUPDATE'));
                    }
                });
            }, function () {
            });
        }

        vm.listCompanyAdditionalFieldsValue = function (detail) {
            $mdDialog.show({
                controller: 'AdditionalFieldsEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/additionalFields/additionalFieldsEdit/aditionalFieldDetail.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'additionalField': detail
                },
                clickOutsideToClose: false
            }).then(function (response) {
                init();
            }, function () { });
        }

        $timeout(init, 1000);

        vm.appCompanyAdditionalFieldsValue = function (data, index) {
            $mdDialog.show({
                controller: 'dialogAdditionalFieldAppEditController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/generalConfiguration/additionalFields/dialogAdditionalFieldApp/dialogAdditionalFieldApp.html',
                parent: angular.element("#main"),
                targetEvent: event,
                locals: {
                    'data': data
                },
                clickOutsideToClose: false
            }).then(function (response) {
                init();
            }, function () { });
        };

    }

})();

(function () {

    'use strict';

    angular
        .module('app.files', [
          'flow',
          'wipImageZoom'
        ])
        .config(config);


    /**@ngInject**/
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

      $stateProvider
        .state('app.files', {
          url: '/files',
          abstract: true
        });
        $translatePartialLoaderProvider.addPart('app/main/apps/files');
    }

})();

(function () {

  'use strict';

  angular
    .module('app.files')
    .controller('DialogPhotoController', DialogPhotoController);

  function DialogPhotoController(name, url, fullUrl, $mdDialog, $log, $sce, $http, $timeout) {

    var vm = this;

    vm.name = name;
    vm.url = url;
    vm.isIMG = true;
    vm.fullUrl = fullUrl;

    if (url.endsWith('.pdf')) {
      vm.isIMG = false;
      vm.isPDF = true;
    }

    vm.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    };


    vm.closeDialog = function () {
      $mdDialog.cancel();
    };

    vm.printElement = function (divName) {
      $log.debug('entra imprimir');
      var printContents = document.getElementById(divName).innerHTML;
      var w = window.open();
      w.document.write(printContents);
      w.print();
      w.close();
    };

    vm.downladFile = function () {
      if (vm.fullUrl) {
        var config = {
          responseType: 'arraybuffer',
          headers: {
            'Content-type': 'image/jpeg',
          }
        };
        $http.get(vm.fullUrl, config).then(function (file) {
          $timeout(function () {
            var fileBlob = new Blob([file.data], {
              type: 'image/jpeg'
            });
            //trick to download store a file having its URL
            var fileURL = URL.createObjectURL(fileBlob);
            var a = document.createElement('a');
            a.download = name;
            a.href = fileURL;
            a.target = '_blank';
            a.click();
            a.remove();
          }, 500);
        }, function (err) {
          console.log(err);
        });
      } else {
        var a = document.createElement('a');
        a.download = name;
        a.href = vm.url;
        a.target = '_blank';
        a.click();
        a.remove();
      }
    };

  }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboards.project', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.dashboards_project', {
            url: '/dashboard-project',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller: 'DashboardProjectController as vm'
                }
            },
            bodyClass: 'dashboard-project'
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($rootScope, $scope, $interval, $mdSidenav, $state, $log, api, $timeout) {
        var vm = this;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project) {
            vm.selectedProject = project;
        }

        function init() {
            $log.debug("Circulo Seleccionado:");
            $log.debug($rootScope.bsCircle);
        }

        $timeout(function () {
            init();
        }, 1000);
    }

})();

(function () {

    'use strict';

    angular
        .module('app.CompanyProvider')
        .controller('ValidateProviderController', ValidateProviderController);

    function ValidateProviderController($mdDialog, $rootScope, $stateParams, $log, $timeout, api, MessageService, $state, $filter) {

        var vm = this;
        vm.companyArray = [];
        vm.dinamicHeight = {};
        vm.paginationCompanies = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getAllCompanies();
            }
        };
        vm.viewName = $stateParams.viewName;

        //metodos
        vm.getAllCompanies = getAllCompanies;
        vm.viewCompany = viewCompany;
        vm.removeProvider = removeProvider;

        function getAllCompanies() {

            vm.isShowLoaderCompanies = true;

            var promise;

            if ($stateParams.viewName === 'validateProvider') {
                promise = api.GeneralWS.getCompaniesNoValidatedAsProvider.page({
                    'pageNumber': vm.paginationCompanies.pageNumber, 'pageSize': vm.paginationCompanies.pageSize,
                    'search': vm.searchCompanyInput, 'companyId': $rootScope.bsCircle.company.id
                })
                    .$promise;
            } else if ($stateParams.viewName === 'internalProviders') {
              promise = api.GeneralWS.CompanyProvider.me.page({
                'pageNumber': vm.paginationCompanies.pageNumber, 'pageSize': vm.paginationCompanies.pageSize, 'search': vm.searchCompanyInput,
                'companyId': $rootScope.bsCircle.company.id, privated : true
              })
                .$promise;
            } else {
                promise = api.GeneralWS.CompanyProvider.me.page({
                    'pageNumber': vm.paginationCompanies.pageNumber, 'pageSize': vm.paginationCompanies.pageSize, 'search': vm.searchCompanyInput,
                    'companyId': $rootScope.bsCircle.company.id
                })
                    .$promise;
            }

            promise.then(function (response) {
                vm.isShowLoaderCompanies = false;

                vm.companyArray = response.content;
                vm.paginationCompanies.totalElements = response.totalElements;
                vm.paginationCompanies.totalPages = response.totalPages;
                vm.paginationCompanies.numberOfElements = response.numberOfElements;

            }, function (response) {
                vm.isShowLoaderCompanies = false;
                $log.error(response);
            });

        }

        function viewCompany(event, company) {
            if ($stateParams.viewName === 'validateProvider') {
                $state.go('app.CompanyProvider.ValidateProvider.ProviderInformation', { 'provider': company, 'companyId': company.id });
            } else if ($stateParams.viewName === 'internalProviders') {
                if (company.privated) {
                    $state.go('app.CompanyProvider.private', { id: company.id });
                } else {
                    $state.go('app.CompanyProvider.InternalProviders.ProviderInformation', { 'provider': company, 'companyId': company.id });
                }
            } else if ($stateParams.viewName === 'queryProviders') {
                if (company.privated) {
                    $state.go('app.CompanyProvider.private', { id: company.id, readonly: true });
                } else {
                    $state.go('app.CompanyProvider.QueryProviders.ProviderInformation', { 'provider': company, 'companyId': company.id });
                }
            } else {
                $state.go('app.CompanyProvider.MyProviders.ProviderInformation', { 'provider': company, 'companyId': company.id });
            }
        }

        function removeProvider(event, provider) {

            event.stopPropagation();

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('menu.my_providers'))
                .textContent($filter('translate')('validate_provider.onfirm_that_you_want_to_remove_from_your_provider_list') + ' ' + provider.name)
                .ariaLabel('Remove provider')
                .targetEvent(event)
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;
                api.GeneralWS.CompanyProvider.me.update({ 'companyId': $rootScope.bsCircle.company.id, 'providerId': provider.id })
                    .$promise.then(function (response) {
                        $rootScope.loadingProgress = false;

                        MessageService.show("Proveedor eliminado correctamente" + "!");

                        var index = vm.companyArray.indexOf(provider);
                        vm.companyArray.splice(index, 1);
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        $log.error(response);
                    });
            }, function () {
            });

        }

        function init() {
            getAllCompanies();

            var contentHeight = $("#company-list-container").innerHeight();
            contentHeight -= 112;
            vm.dinamicHeight = { "height": contentHeight + "px" };

        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';
    angular
        .module('app.company')
        .controller('DocumentController', DocumentController);
    /** @ngInject */
    function DocumentController(api, $log, $rootScope, $filter, $state,  $mdDialog, envService, MessageService, localStorageService, Company, $stateParams) {
        var vm = this;



        if ($state.params.tipoError) {
            vm.textTipoError = 'COMPANY.COMPLETE_INFO_ERR' + $state.params.tipoError;
        }
        vm.isPrivated = $stateParams.privated ? $stateParams.privated : false;
        var stateReturn = vm.isPrivated ? 'app.CompanyProvider.private' : 'app.company.mycompany';
        vm.isProvider = $stateParams.isProvider ? $stateParams.isProvider : false;
        vm.providerId = $stateParams.providerId;

        vm.baseUrlSharedFiles = envService.read('baseUrlSharedFiles');
        vm.msgRequired = '';
        vm.closeThread = closeThread;
        vm.authorizedToEdit = true;
        vm.asProvider = false;
        if ($stateParams.privated) {
            if ((!Company || !Company.privated) && !vm.isProvider) {
                $state.go('app.CompanyProvider.MyProviders');
            } else {
                vm.company = Company;
                vm.CompanyDocumentsType = $rootScope.documentTypes;

            }
        } else {
            vm.company = angular.copy($rootScope.bsCircle.company);
            vm.CompanyDocumentsType = $rootScope.documentTypes;

            api.GeneralWS.CompanyDocument.query({ 'company': vm.company.id }).$promise.then(function (response) {
              vm.company.documents = response;
            }, function (response) {
              $log.error(response);
            });

        }

        vm.edit = edit;
        vm.addDocument = addDocument;
        vm.deleteDocument = deleteDocument;
        vm.validateAsProvider = validateAsProvider;
        vm.validateCanEditWhenIsProvider = validateCanEditWhenIsProvider;

        if (vm.company.country === null) {
            vm.company.country = { id: 0 };

        }

        function closeThread() {
            if (vm.isProvider) {
                $state.go('app.CompanyProvider.MyProviders.ProviderInformation', { 'provider': vm.company, 'companyId': vm.company.id }, { reload: true });
            } else if (vm.isPrivated) {
                $state.go(stateReturn, { id: $stateParams.id }, { reload: true });
            } else {
                $state.go(stateReturn);
            }
        }

        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0
                },
                {
                    // Target the actions column
                    targets: 5,
                    responsivePriority: 1,
                    filterable: true,
                    sortable: false
                }
            ],
            order: [[0, "desc"]],
            pagingType: 'simple',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 20,
            paging: false,
            responsive: true
        };

        function onInitValidDocumentTypes() {

            vm.canAddDocuments = false;
            var listOfValidDocumentTypes = [];
            if (vm.company.documents) {

                for (var i = 0; i < vm.documentTypes.length; i++) {

                    var encontro = false;
                    for (var j = 0; j < vm.company.documents.length; j++) {
                        if (vm.company.documents[j].active && vm.company.documents[j].document.documentType.id === vm.documentTypes[i].id) {
                            encontro = true;
                            break;
                        }
                    }

                    if (!encontro) {
                        listOfValidDocumentTypes.push(vm.documentTypes[i]);
                    }
                }

            } else {
                listOfValidDocumentTypes = vm.documentTypes;
            }

            vm.listOfValidDocumentTypes = listOfValidDocumentTypes;
            if (listOfValidDocumentTypes.length > 0) {
                vm.canAddDocuments = true;
            }
            if(vm.isProvider) {
                vm.canAddDocuments = false;
             }

        }

        function onInit() {

            var company = vm.isPrivated ? Company : $rootScope.bsCircle.company;
            if (company.documents === null) {
                vm.company.documents = [];
                company.documents = [];
            } else {
                vm.company.documents = company.documents;
            }
            if(!vm.isProvider) {
                validateAsProvider();
            }
            if ($state.params.listOfDocumentTypes) {
                vm.documentTypes = $state.params.listOfDocumentTypes;
              validateCanEditWhenIsProvider();

                var requiredDocuments = "";
                for (var i = 0; i < vm.documentTypes.length; i++) {
                    if (vm.documentTypes[i].required === true) {
                        requiredDocuments = requiredDocuments ? requiredDocuments + ", " + vm.documentTypes[i].name : vm.documentTypes[i].name;
                    }
                }
                vm.msgRequired = requiredDocuments;
                onInitValidDocumentTypes();
            } else {
                api.GeneralWS.DocumentType.getAll({ id: company.country.id, 'category': 'COMPANY' }).$promise.then(function (response) {
                    vm.documentTypes = response;

                    var requiredDocuments = "";
                    for (var i = 0; i < vm.documentTypes.length; i++) {
                        if (vm.documentTypes[i].required === true) {
                            requiredDocuments = requiredDocuments ? requiredDocuments + ", " + vm.documentTypes[i].name : vm.documentTypes[i].name;
                        }
                    }
                    vm.msgRequired = requiredDocuments;
                    onInitValidDocumentTypes();
                    validateCanEditWhenIsProvider();
                }, function (errResponse) {
                    $log.error(errResponse.data);
                });
            }
        }

        onInit();
        function addDocument() {
            $mdDialog.show({
                controller: 'CompanyDocumentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/documents/dialogs/document/document.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    Company: vm.company,
                    Privated: vm.isPrivated,
                    'companyDocument': {
                        document: {
                            documentType: {},
                            number: '',
                            dateOfIssue: new Date(),
                            dueDate: new Date(),
                            files: []
                        }
                    },
                    'documentTypes': vm.listOfValidDocumentTypes,
                    'providerId': null
                }
            }).then(function (answer) {
                if (answer) {
                    if (vm.isPrivated) {
                        vm.company = Company;
                    } else {
                        vm.company = angular.copy($rootScope.bsCircle.company);
                    }
                    onInitValidDocumentTypes();
                    MessageService.show($filter('translate')('COMPANY.DOCUMENT_CREATED'));
                }
            }, function () {

            });
        }

        function edit(companyDocument) {

            var newCompanyDocument = angular.copy(companyDocument);
            newCompanyDocument.document.dateOfIssue = (newCompanyDocument.document.dateOfIssue ? new Date(newCompanyDocument.document.dateOfIssue + " 00:00:00") : new Date());
            newCompanyDocument.document.dueDate = (newCompanyDocument.document.dueDate ? new Date(newCompanyDocument.document.dueDate + " 00:00:00") : new Date());
            $mdDialog.show({
                controller: 'CompanyDocumentController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/documents/dialogs/document/document.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    Company: vm.company,
                    Privated: vm.isPrivated,
                    'companyDocument': newCompanyDocument,
                    'documentTypes': vm.documentTypes,
                    'providerId': vm.providerId
                }
            }).then(function (answer) {
                if (answer) {
                    vm.company.documents = answer;
                    MessageService.show($filter('translate')('COMPANY.DOCUMENT_UPDATED'));
                }
            }, function () {

            });
        }

        function deleteDocument(companyDocument) {
            var company = vm.isPrivated ? Company : $rootScope.bsCircle.company;
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('company_document.delete'))
                .textContent($filter('translate')('company_document.confirmDelete'))
                .ariaLabel($filter('translate')('company_document.delete'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));
            $mdDialog.show(confirm).then(function () {

                var promise;
                promise = api.GeneralWS.CompanyDocument.Delete({ company: vm.company.id, id: companyDocument.id }).$promise;
                promise.then(function (response) {
                    vm.isShowProgressLinear = false;
                    for (var i = 0; i < vm.company.documents.length; i++) {
                        if (vm.company.documents[i].document.id === companyDocument.document.id) {
                            vm.company.documents[i].active = false;
                        }
                    }

                    company.documents = [];
                    company.documents = vm.company.documents;
                    if (!vm.isPrivated) {
                        $rootScope.bsCircle.company = company;
                        localStorageService.set('accountc', $rootScope.bsCircle);
                    }
                    vm.company = angular.copy(company);
                    onInitValidDocumentTypes();
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('COMPANY.DOCUMENT_UPDATED'));
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
            }, function () {

            });
        }

        // Validar si empresa es proveedor de otra
        function validateAsProvider() {

            vm.loading = true;
            api.GeneralWS.CompanyProvider.validateAsProvider.validate({
                'companyId': 0,
                'providerId': vm.company.id,
            }).$promise.then(function (resp) {
                vm.asProvider = resp.$data;
                vm.loading = false;
            }, function (err) {
                $log.error(err);
                vm.loading = false;
            });
        }

        function validateCanEditWhenIsProvider() {
          for (let i = 0; i < vm.company.documents.length; i++) {
            vm.documentTypeCompanyId = vm.company.documents[i].document.documentType.id;

            for (let r = 0; r < vm.documentTypes.length; r++) {
              vm.newDocumentTypeId = vm.documentTypes[r].id;
              if ( vm.newDocumentTypeId === vm.documentTypeCompanyId ) {
                vm.company.documents[i].document.
                  documentType.canEditWhenIsProvider =  vm.documentTypes[r].canEditWhenIsProvider;
              }
            }
          }

        }
    }
})();

(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('CompanyParametersController', companyParameterController);

    /**@ngInject**/
    function companyParameterController($rootScope, $log, api, MessageService, $filter, $timeout) {

        var vm = this;

        vm.pagination = {
            pageNumber: 0,
            pageSize: 50,
            totalElements: 0,
            totalPages: 0
        };

        vm.getParametersByApplication = getParametersByApplication;

        var columnDefs = [
            {
                field: "applicationParameter.parameterDescription",
                headerName: 'company_parameters.description',
                headerCellRenderer: getHeader,
                width: 500
            }
            , {
                field: "parameterValue",
                headerName: 'company_parameters.value',
                headerCellRenderer: getHeader,
                width: 200,
                cellRenderer: function (params) {
                    switch (params.data && params.data.applicationParameter.dataType) {
                        case "TEXT":
                            return '<center><input id="documentNumber" autocomplete="off" ng-model="data.parameterValue" ng-enter="vm.updateParameterValue(data)" style="text-align: right"/></center>';
                            break;

                        case "NUMBER":
                            return '<center><input id="documentNumber" numbers-only="numbers-only" autocomplete="off" ng-model="data.parameterValue" ng-enter="vm.updateParameterValue(data)" style="text-align: right" /></center>';
                            break;

                        case "DECIMAL":
                            return '<center><input ng-model="data.parameterValue" type="number" name="rate" required min="0.01" max="vm.promotion.rate+1" ng-enter="vm.updateParameterValue(data)" style="text-align: right"></center>';
                            break;

                        case "BOOLEAN":
                            params.data.parameterValue=params.data.parameterValue==='true';
                            return '<center><md-checkbox ng-model="data.parameterValue" ng-change="vm.updateParameterValue(data)" aria-label="chk" ></md-checkbox></center>';
                            break;
                    }
                }
            }
            , {
                field: "save",
                headerName: 'company_parameters.save',
                headerCellRenderer: getHeader,
                width: 100,
                cellRenderer: function (params) {
                    return "<center> <md-button class='md-icon-button' ng-click='vm.updateParameterValue(data)'> <md-icon md-font-icon='icon-content-save'></md-icon> </md-button> </center>";
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.grid = {
            paginationPageSize: vm.pagination.pageSize,
            rowSelection: 'multiple',
            rowDeselection: true,
            rowModelType: "enterprise",
            cacheBlockSize: vm.pagination.pageSize,
            pagination: true,
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            onCellValueChanged: function (event) {
                if (event.oldValue !== event.newValue) {

                    var canUpdate = false;

                    switch (event.data.applicationParameter.dataType) {
                        case "TEXT":
                            canUpdate = true;
                            break;

                        case "NUMBER":
                            if (!isNaN(parseInt(event.data.parameterValue))) {
                                canUpdate = true;
                            }
                            break;

                        case "DECIMAL":
                            if (!isNaN(parseFloat(event.data.parameterValue))) {
                                canUpdate = true;
                            }
                            break;

                        case "BOOLEAN":

                            break;
                    }

                    if (canUpdate) {
                        updateParameterValue(event.data);
                    } else {
                        event.data.parameterValue = event.oldValue;
                        MessageService.show($filter('translate')('company_parameters.incorrectFormat'));
                    }

                }
            }
        };

        function createNewDatasource() {
            if (vm.application === null && vm.application === undefined) {
                return null;
            }
            var dataSource = {
                paginationPageSize: vm.pagination.pageSize,
                getRows: function (params) {
                    vm.isShowProgressLinear = true;
                    api.GeneralWS.CompanyParameter.application.page({ 'company': $rootScope.bsCircle.company.id, 'app': vm.application.id, 'pageNumber': (vm.pagination.pageNumber + 1), 'pageSize': vm.pagination.pageSize }).$promise.then(function (response) {
                        vm.isShowProgressLinear = false;
                        $log.debug(response);

                        vm.pagination.totalElements = response.totalElements;
                        vm.pagination.totalPages = response.totalPages;
                        vm.pagination.pageNumber = response.number + 1;
                        params.successCallback(response.content, response.totalElements);
                        vm.showGrid = true;
                    }, function (response) {
                        $log.error(response);
                    });
                }
            };
            vm.grid.api.setEnterpriseDatasource(dataSource);
        }

        function getParametersByApplication(application) {

            if (vm.application) {
                if (vm.application.id === application.id) {
                    return null;
                }
            }

            vm.application = application;

            vm.pagination.pageNumber = 0;
            createNewDatasource();
        }

        vm.updateParameterValue = updateParameterValue;
        function updateParameterValue(companyParameter) {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyParameter.me.update({ 'company': $rootScope.bsCircle.company.id, 'id': companyParameter.id }, companyParameter).$promise.then(function (response) {
                vm.isShowProgressLinear = false;

                MessageService.show($filter('translate')('company_parameters.parameter_updated_successfully'));

            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        function init() {
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyApplication.me.query({ 'company': $rootScope.bsCircle.company.id, 'includeServices': true }).$promise.then(function (response) {

                vm.isShowProgressLinear = false;

                vm.applicationArray = new jinqJs()
                    .from(response)
                    .orderBy([{ field: 'id', sort: 'asc' }])
                    .select();

                if (vm.applicationArray.length > 0) {
                    getParametersByApplication(vm.applicationArray[0].application);
                }
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('BlockedSeriesController', blockedSeriesController);

    /** @ngInject */
    function blockedSeriesController(api, $rootScope, $log, $mdDialog, $filter, $mdToast) {

        var vm = this;
        vm.currentThread = null;
        vm.updateBlockedSeries = updateBlockedSeries;

        init();

        function init() {

            api.GeneralWS.AllBlockedSeries.query({ companyId: $rootScope.bsCircle.company.id }, function (data) {
                vm.allowRoleAccess = true;
                vm.allBlockedSeries = data;
                $log.debug(vm.allBlockedSeries);

                vm.masterGridOptions.api.setColumnDefs(vm.masterColumnDefs);
                vm.masterGridOptions.api.setRowData(data);
                vm.loading = false;
            }, function (response) {
                vm.loading = false;

                vm.allowRoleAccess = false;
                $log.error(response);

            });
        }

        vm.masterColumnDefs = [
            {
                headerName: 'BLOCKEDSERIES.SERIEID',
                field: "id",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'BLOCKEDSERIES.SERIE',
                field: "serie",
                headerCellRenderer: getHeader,
                width: 200,
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'BLOCKEDSERIES.ACTIONS',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 200,
                cellRenderer: function renderer(params) {
                    return '<div style="width: 100%;"> '
                        + ' <md-button class="edit-button md-icon-button" ng-click="vm.updateBlockedSeries($event, data.id, data)" aria-label="blockedSeries" '
                        + '        translate translate-attr-aria-label="BLOCKEDSERIES.UPDATE"> '
                        + ' <md-tooltip md-direction="bottom"> '
                        + '     {{"BLOCKEDSERIES.UPDATE"| translate}} '
                        + ' </md-tooltip> '
                        + ' <md-icon md-font-icon="icon-delete" class="s16"></md-icon> '
                        + ' </md-button> '
                        + ' </div>';
                },
                cellStyle: { 'padding': '0px' }
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            enableSorting: true,
            debug: false,
            enableFilter: true,
            enableColResize: true,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowData: null,
            groupHeaders: true,
            headerHeight: 64,
            rowHeight: 64,
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass
        };

        var filter = 'everyone';

        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }



        function updateBlockedSeries(e, id, data) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('BLOCKEDSERIES.ACTIVE'))
                .textContent($filter('translate')('BLOCKEDSERIES.CONFIRMACION_CANCEL'))
                .ok($filter('translate')('BLOCKEDSERIES.SI'))
                .cancel($filter('translate')('BLOCKEDSERIES.CANCELAR'));
            $mdDialog.show(confirm).then(function () {
                var i = vm.allBlockedSeries.indexOf(data);
                $rootScope.loadingProgress = true;
                api.GeneralWS.AllBlockedSeries.delete({ id: id }, function (response) {// Success
                    vm.allBlockedSeries.splice(i, 1);
                    vm.masterGridOptions.api.setRowData(vm.allBlockedSeries);
                    showMessage($filter('translate')('BLOCKEDSERIES.UPDATE'));
                    $rootScope.loadingProgress = false;
                }, function (response) {// Error
                    $log.debug(response);
                    $rootScope.loadingProgress = false;
                    if (response.data === "not update") {
                        showErrorMessage($filter('translate')('BLOCKEDSERIES.ERRORUPDATE'));
                    }
                });
            }, function () {
            });
        }

        function showMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                hideDelay: 3000,
                position: 'top right'
            });
        }
        function showErrorMessage(message) {
            $rootScope.loadingProgress = false;
            $mdToast.show({
                template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">' + message + '</div></md-toast>',
                hideDelay: 5000,
                position: 'top right'
            });
        }
    }


})();


(function () {

    'use strict';

    angular
        .module('app.company')
        .controller('CompanyApplicationController', CompanyApplicationController);

    /**@ngInject**/
    function CompanyApplicationController($rootScope, $log, api, MessageService, $filter, $timeout, $mdDialog) {

        var vm = this;

        //methods
        vm.onActiveApp = onActiveApp;
        vm.onDeleteApp = onDeleteApp;

        var columnDefs = [
            {
                field: "applicationName",
                headerName: 'company_applications.applicationName',
                headerCellRenderer: getHeader,
                width: 350
            },
            {
                field: "isActive",
                headerName: 'company_applications.isActive',
                headerCellRenderer: getHeader,
                width: 300,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center> <md-button class="md-warn" ng-click="vm.onDeleteApp(data)"><span style="font-weight: bold;">{{"company_applications.desactivar"| translate}}</span></md-button></center>';
                    } else {
                        return '<center> <md-button md-no-ink class="md-primary" ng-click="vm.onActiveApp(data)"><span style="font-weight: bold;">{{"company_applications.activar"| translate}}</span></md-button></center>';
                    }
                }
            }
        ];

        vm.grid = {
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        function init() {

            vm.grid.api.setRowData([]);
            vm.isShowProgressLinear = true;
            api.GeneralWS.CompanyApplication.me.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {

                var companyAplication = [];
                for (var i = 0; i < response.length; i++) {

                    if (response[i].application.name !== "Megasistemas") {
                        companyAplication.push({
                            applicationId: response[i].application.id,
                            applicationName: response[i].application.name,
                            isActive: true
                        });
                    }
                }

                api.GeneralWS.CompanyApplication.notAssociatedToCompany.query({ 'company': $rootScope.bsCircle.company.id }).$promise.then(function (response) {
                    for (var i = 0; i < response.length; i++) {

                        if (response[i].name !== "Megasistemas") {
                            companyAplication.push({
                                applicationId: response[i].id,
                                applicationName: response[i].name,
                                isActive: false
                            });
                        }
                    }

                    vm.grid.api.setRowData(companyAplication);
                    vm.isShowProgressLinear = false;
                }, function (response) {
                    $log.error(response);
                    vm.isShowProgressLinear = false;
                });

                vm.showGrid = true;
            }, function (response) {
                $log.error(response);
            });
        }

        function onActiveApp(data) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('company_applications.confirmaDeseaActivar'))
                .content('')
                .ariaLabel('Active')
                .ok($filter('translate')('company_applications.activar'))
                .cancel($filter('translate')('COMPANY.CANCEL'));

            $mdDialog.show(confirm).then(function () {

                var promise;
                promise = api.GeneralWS.CompanyApplication.me.create({ 'company': $rootScope.bsCircle.company.id, 'app': data.applicationId }).$promise;

                vm.isShowProgressLinear = true;
                promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    switch (response.$status) {
                        case 200:
                        case 201:
                            init();
                            MessageService.show($filter('translate')('company_applications.activadaCorrectamente'));
                            break;

                        default:
                            $log.error(response);
                            MessageService.showErrorMessage($filter('translate')('general.general_error'));
                            break;
                    }

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });

            }, function () {
            });

        }

        function onDeleteApp(data) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('company_applications.confirmaDesactivar'))
                .content('')
                .ariaLabel('DeActive')
                .ok($filter('translate')('company_applications.desactivar'))
                .cancel($filter('translate')('COMPANY.CANCEL'));

            $mdDialog.show(confirm).then(function () {

                var promise;
                promise = api.GeneralWS.CompanyApplication.me.Delete({ 'company': $rootScope.bsCircle.company.id, 'app': data.applicationId }).$promise;

                vm.isShowProgressLinear = true;
                promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    switch (response.$status) {
                        case 200:
                        case 201:
                            init();
                            MessageService.show($filter('translate')('company_applications.desactivadaCorrectamente'));
                            break;

                        default:
                            $log.error(response);
                            MessageService.showErrorMessage($filter('translate')('general.general_error'));
                            break;
                    }

                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });

            }, function () {
            });
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.bank')
        .controller('bankParameterConfigurationController', bankParameterConfigurationController);

    function bankParameterConfigurationController() {
      //general-banks implemented
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'mdColorPicker'
            ]);
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('focusMe', focusMe);

    /** @ngInject */
    function focusMe($timeout, $parse)
    {
        return {
            //scope: true,   // optionally create a child scope
            link: function (scope, element, attrs) {
                var model = $parse(attrs.focusMe);
                scope.$watch(model, function (value) {
                    if (value === true) {
                        $timeout(function () {
                            element[0].focus();
                        });
                    }
                });
                // to address @blesh's comment, set attribute value to 'false'
                // on blur event:
                element.bind('blur', function () {
                    scope.$apply(model.assign(scope, false));
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout) {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response) {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact) {
            vm.chatActive = !vm.chatActive;

            if (vm.chatActive) {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply() {
            if (vm.replyMessage === '') {
                return;
            }

            if (!vm.chat.contact.dialog) {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who: 'user',
                message: vm.replyMessage,
                time: 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed) {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function () {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.general', [
            'app.auth',
            'app.profile',
            'app.role',
            'app.errors',
            'app.notifications'
        ]).config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/general/');
    }

})();


(function () {

    'use strict';

    angular
        .module('app.general')
        .service('GeneralService', generalService);

    /**@ngInject**/
    function generalService($log) {

        var service = this;

        var DataTypeEnum = {
            TEXT: { translate: "general.text" },
            NUMBER: { translate: "general.number" },
            DECIMAL: { translate: "general.decimal" },
            BOOLEAN: { translate: "general.boolean" }
        };

        service.getDataTypeEnumArray = function () {

            var enumArray = [];

            for (var propertyName in DataTypeEnum) {

                var _enum = {
                    name: propertyName,
                    translate: DataTypeEnum[propertyName].translate
                };

                enumArray.push(_enum);

            }

            return enumArray;

        };

        service.getTranslateDataTypeEnumByName = function (name) {
            return DataTypeEnum[name].translate;
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.role', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.role', {
            url: '/roles',
            views: {
                'content@app': {
                    templateUrl: 'app/main/general/role/role.html',
                    controller: 'RolesController as vm'
                }
            }
        });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/general/role');
    }

})();

(function () {
    'use strict';

    angular
        .module('app.role')
        .controller('RolesController', RolesController);

    /** @ngInject */
    function RolesController($rootScope, localStorageService, $state, $window) {

        var vm = this;
        vm.tipoFiltro = '0';
        vm.roles = [];
        vm.companies = [];

        var roleMap = {};
        var companyMap = {};
        var i = 0, j = 0;

        if ($rootScope.circles) {

            var arrayOfData = new jinqJs()
                .from($rootScope.circles)
                .orderBy([{ field: 'id', sort: 'asc' }])
                .select();

            arrayOfData.forEach(function (r) {

                var comp;
                if (companyMap[r.company.id] >= 0) {
                    comp = vm.companies[companyMap[r.company.id]];
                    comp.roles.push({ name: r.role.description, circle: r });
                } else {
                    companyMap[r.company.id] = i;
                    comp = {
                        name: r.company.name,
                        roles: [
                            { name: r.role.description, circle: r }
                        ]
                    };
                    vm.companies.splice(i, 0, comp);
                    i++;
                }

                var role;

                if (roleMap[r.role.id] >= 0) {
                    role = vm.roles[roleMap[r.role.id]];
                    role.companies.push({ name: r.company.name, circle: r });
                } else {
                    roleMap[r.role.id] = j;
                    role = {
                        name: r.role.description,
                        companies: [
                            { name: r.company.name, circle: r }
                        ]
                    };
                    vm.roles.splice(j, 0, role);
                    j++;
                }

            });
        }

        vm.changeCircle = changeCircle;

        function changeCircle(c) {
            $rootScope.bsCircle = c;

            localStorageService.set('accountc', $rootScope.bsCircle);
            if ($rootScope.bsCircle) {
                $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
            }
            $rootScope.msNotificationArray = [];

            if ($state.is('app.dashboards_project')) {
                $state.reload();
            } else {
                $state.go('app.dashboards_project', {}, { reload: true });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.profile')
        .controller('ProfileController', ProfileController)
        .controller('ProfileEditController', ProfileEditController);


    function ProfileController($rootScope, $scope, $filter, localStorageService, api, envService, $state, $log, MessageService) {

        var vm = this;
        vm.editMode = false;

        vm.cancelarEdit = cancelarEdit;
        vm.sendForm = sendForm;
        vm.sendFormChangePassword = sendFormChangePassword;

        vm.filesToUpload;
        vm.uploadFiles = uploadFiles;

        vm.userInfo = angular.copy($rootScope.account);
        vm.userInfo.birthdate = vm.userInfo.birthdate ? new Date(vm.userInfo.birthdate) : new Date('1900-01-01');
        vm.userInfo.preferredUsername = { password: "" };

        vm.genders = ['F', 'M'];
        vm.pass = { newPassword: "", validatePassword: "" };

        $scope.originForm = angular.copy(vm.userInfo);

        api.GeneralWS.Company.getByMe({ id: 'bycircles' }, function (response) {// Success
            vm.company = response;
        }, function (response) {// Error
        });

        function cancelarEdit() {
            vm.userInfo = angular.copy($scope.originForm);
            vm.editMode = false;
        }

        function sendForm() {
            if (vm.filesToUpload) {
                saveUserAndPicture();
            } else {
                saveUser();
            }
        }

        function saveUserAndPicture() {
            vm.loading = true;
            var fd = getFDt2(vm.filesToUpload);

            api.GeneralWS.LoadAvatar.save({ sub: vm.userInfo.sub }, fd).$promise.then(
                function (response) {
                    vm.loading = false;
                    $log.debug(response);
                    vm.userInfo.picture = "https://www.megapaca.com/ms/images" + response.parentPath + response.name + "m" + response.extension;
                    saveUser();
                },
                function (errResponse) {
                    vm.loading = false;
                }
            );

        }

        function saveUser() {
            vm.loading = true;
            api.UsuarioWS.UserInfo.update({ sub: vm.userInfo.sub }, vm.userInfo).$promise.then(
                function (UserInfo) {
                    vm.loading = false;

                    vm.userInfo = angular.copy(UserInfo);
                    vm.userInfo.birthdate = vm.userInfo.birthdate ? new Date(vm.userInfo.birthdate) : null;
                    var name = UserInfo.name;

                    if (UserInfo.middleName !== '') {
                        name += ' ' + UserInfo.middleName;
                    }

                    if (UserInfo.familyName !== '') {
                        name += ' ' + UserInfo.familyName;
                    }

                    var userLocal = {
                        name: name
                    };

                    api.GeneralWS.UserSub.update({ 'sub': vm.userInfo.sub }, userLocal).$promise.then(function (User) {
                        $rootScope.account = vm.userInfo;
                        localStorageService.set('account', $rootScope.account);

                        MessageService.show($filter('translate')('PROFILE.UPDATED'));
                        vm.editMode = false;
                        $state.go('app.profile');
                    }, function (errResponse) {
                        vm.loading = false;
                    });
                },
                function (errResponse) {
                    vm.loading = false;
                }
            );
        }


        function sendFormChangePassword() {
            vm.loading = true;
            vm.userInfo.preferredUsername.password = vm.pass.newPassword;
            api.UsuarioWS.UserPass.update({ sub: vm.userInfo.sub }, vm.userInfo).$promise.then(function (response) {

                api.GeneralWS.UserSub.patch({ 'sub': vm.userInfo.sub }, { 'password': vm.pass.newPassword, 'name': response.name }).$promise.then(function (User) {
                    vm.loading = false;
                    vm.pass = { newPassword: "", validatePassword: "" };
                    MessageService.show($filter('translate')('PROFILE.PWD_UPDATED'));
                    vm.editMode = false;
                    $state.go('app.profile');
                }, function (errResponse) {
                });
            }, function (errResponse) {
            });
        }

        function getFDt2(file) {
            var fd = new FormData();
            fd.append('files', file);
            return fd;
        }

        function uploadFiles() {
            $log.debug(vm.filesToUpload.length + " files selected ... Write your Upload Code");

            $log.debug("vm.filesToUpload:");
            $log.debug(vm.filesToUpload);

            var fd = getFDt2(vm.filesToUpload);

            api.GeneralWS.LoadAvatar.save({ sub: vm.userInfo.sub }, fd).$promise.then(
                function (response) {
                    $log.debug(response);
                    var baseUrlSharedFiles = envService.read('baseUrlSharedFiles');
                    vm.userInfo.picture = baseUrlSharedFiles + response.parentPath + response.name + "m" + response.extension;
                },
                function (errResponse) {
                }
            );
        }

        $scope.uploadf3 = function () {
            angular.element(document.querySelector('#fileInput')).click();
        };

    }

    function ProfileEditController($rootScope, api, localStorageService, MessageService, $state) {

        var vm = this;

        vm.userInfo = angular.copy($rootScope.account);
        vm.userInfo.birthdate = vm.userInfo.birthdate ? new Date(vm.userInfo.birthdate) : null;
        vm.userInfo.preferredUsername = null;
        vm.genders = ['F', 'M'];

        vm.sendForm = function () {

            vm.loading = true;

            api.UsuarioWS.UserInfo.update({ sub: vm.userInfo.sub }, vm.userInfo).$promise.then(function (UserInfo) {

                vm.userInfo = angular.copy(UserInfo);

                $rootScope.account = vm.userInfo;
                localStorageService.set('account', $rootScope.account);

                vm.loading = false;

                MessageService.show($filter('translate')('PROFILE.UPDATED'));

                $state.go('app.profile');
            }, function (errResponse) {
                vm.loading = false;
            });
        };

    }
})();

(function () {

    'use sctrict';

    angular.module('app.general')
        .directive('expandGrid', function () {
            var directive = {
                link: link, // The function attaching the behavior
                restrict: 'A' // Restrict directive to be used only as attribute
            };
            return directive;


            function link(scope, element, attrs) {

                var gridElement = $(element);
                var idGrid = attrs.id;
                var min = attrs.min ? parseInt(attrs.min) : 250;
                var other = attrs.other ? parseInt(attrs.other) : 0;
                resizeGridM("#" + idGrid, other, min);
                // Attach an eventHandler to the resize event of the
                // window to resize the data area of the grid accordingly
                scope.$watch(
                    function () {
                        return gridElement.parent().height();
                    },
                    function (height) {
                        resizeGridM("#" + idGrid, other, min);
                    });
            }
        });

    function resizeGridM(gridName, other, min) {
        //Define Elements Needed
        var grid = $(gridName);

        other = other ? other : 0;
        //Other variables
        var minimumAcceptableGridHeight = min ? min : 250; //This is roughly 5 rows

        //Get Window Height
        var windowHeight = $(window).innerHeight();

        //Padding you want to apply below your page
        var bottomPadding = 60;

        //Check if Calculated height is below threshold
        var calculatedHeight = windowHeight - bottomPadding - other - 150;
        var finalHeight = calculatedHeight < minimumAcceptableGridHeight ? minimumAcceptableGridHeight : calculatedHeight;

        //Apply the height for the content area
        grid.css('height', finalHeight + 'px');
    }


})();

(function () {

    'use strict';

    angular
        .module('app.public')
        .controller('StartPageController', startPageController);

    /**@ngInject**/
    function startPageController($mdSidenav, $window, $auth, $state, api, $log, $timeout, $mdMedia, localStorageService, $rootScope, MessageService, $filter, APPINITIALS, APPNAME) {

        var vm = this;

        document.title = APPNAME;

        vm.goToDashboard = goToDashboard;
        vm.forgotPassword = forgotPassword;
        vm.register = register;
        vm.openMenu = openMenu;

        vm.$mdMedia = $mdMedia;

        /**
         * Esto es para hacer login
         */

        vm.authenticate = function (provider, toggleMenu) {

            if (toggleMenu) {
                $mdSidenav("startPageMenu").toggle();
            }

            document.title = APPNAME;

            localStorageService.remove('account');
            localStorageService.remove('accountc');
            localStorageService.remove('circles');
            $window.localStorage.removeItem('APP001_C_C');
            delete $rootScope.bsCircle;
            delete $rootScope.circles;
            $auth.authenticate(provider)
                .then(function () {
                    getProfile(provider);
                })
                .catch(function (error) {
                    if (error.error) {
                        // Popup error - invalid redirect_uri, pressed cancel button, etc.
                        $log.debug(error.error);
                    } else if (error.data) {
                        // HTTP response error from server
                        $log.debug(error.data.message, error.status);
                    } else {
                        $log.debug(error);
                    }
                });
        };

        function getProfile(provider) {
            api.UsuarioWS.Yo.get({},
                function (response) {
                    MessageService.show($filter('translate')('LOGIN_V2.SESSION_CORRECT') + provider + '!');

                    $log.debug(response);
                    $rootScope.account = response;
                    localStorageService.set('account', $rootScope.account);

                    $state.go('app.dashboards_project');
                },
                function (response) {
                    logoutFinish($auth, $state, 'public.content.index');
                    console.error(response);
                }
            );
        }

        function goToDashboard(toggleMenu) {
            if (toggleMenu) {
                $mdSidenav("startPageMenu").toggle();
            }
            $state.go('app.dashboards_project');
        }

        function forgotPassword(toggleMenu) {
            if (toggleMenu) {
                $mdSidenav("startPageMenu").toggle();
            }
            $state.go('public.content.auth.forgot-password');
        }

        function register(toggleMenu) {
            if (toggleMenu) {
                $mdSidenav("startPageMenu").toggle();
            }
            $state.go('public.content.auth.register');
        }

        function openMenu() {
            $mdSidenav('startPageMenu').toggle().then(function () {
            });
        }

        $timeout(function () {
            if ($auth.isAuthenticated()) {
                vm.isAuthenticated = true;
            } else {
                vm.isAuthenticated = false;
            }

            var windowHeight = $(window).innerHeight();

            windowHeight -= 103;

            var divContainerView = $("#startPageContentView");

            divContainerView.css({ 'height': windowHeight + "px" });

        }, 500);

    }

})();

(function () {

    'use strict';

    angular
        .module('app.public')
        .controller('AppsListController', appsListController);

    /**@ngInject**/
    function appsListController($scope, $timeout, api, $log, $mdMedia, $state, $rootScope, $filter) {

        var appsListCtrl = this;
        appsListCtrl.$mdMedia = $mdMedia;

        appsListCtrl.goToReadMore = goToReadMore;
        appsListCtrl.goToApplication = goToApplication;

        appsListCtrl.applicationArray = [];

        function goToApplication(application) {
            $log.debug(application);
            if (application.url !== null && application.url) {
                window.location.href = application.url;
            }
        }

        function goToReadMore(application) {
            $state.go('public.content.' + application.name.toLowerCase(), {}, {});
        }

        function init() {
            if (!$rootScope.listOfApps) {
                $scope.$parent.vm.isShowProgressLinear = true;
                api.GeneralWS.Application.query({}).$promise.then(function (response) {
                    response = $filter('orderBy')(response, 'sortOrderApp');

                    appsListCtrl.applicationArray = [];

                    response.forEach(function (row) {
                        if (row.name !== "Megasistemas") {
                            row.nameToShow = row.name;
                            row.name = row.name.replace(/ /g, '');

                            appsListCtrl.applicationArray.push(row);
                        }
                    });

                    $rootScope.listOfApps = appsListCtrl.applicationArray;

                    $scope.$parent.vm.isShowProgressLinear = false;

                }, function (response) {
                    appsListCtrl.isShowProgressLinear = false;
                    $log.error(response);
                });
            } else {
                appsListCtrl.applicationArray = $rootScope.listOfApps;
            }
        }

        $timeout(function () {
            init();
        }, 1000);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.groupFavorite')
        .controller('GroupFavoriteController', GroupFavoriteController);

    /** @ngInject */
    function GroupFavoriteController(api, $scope, $rootScope, $log, $state, $mdDialog, $filter, $stateParams, $mdToast, MessageService) {

        var vm = this;
        vm.currentThread = null;

        vm.newGroupProvider = newGroupProvider;
        vm.deleteGroup = deleteGroup;

        vm.masterColumnDefs = [
            {
                headerName: '#',
                field: "id",
                width: 50,
                filter: 'number',
                cellStyle: { 'text-align': 'center' },
                pinned: 'left'
            },
            {
                headerName: 'PROVIDER.NAMEGROUP',
                field: "name",
                headerCellRenderer: getHeader,
                width: 300,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PROVIDER.GROUPTYPE',
                field: "favoriteGroupType.description",
                headerCellRenderer: getHeader,
                width: 300,
                filter: 'text',
                enableRowGroup: true,
                enablePivot: true
            },
            {
                headerName: 'PROVIDER.OPTION',
                name: "actions",
                headerCellRenderer: getHeader,
                suppressSorting: true,
                suppressMenu: true,
                width: 250,
                cellRenderer: renderer,
                cellStyle: { 'padding': '0px' },
                pinned: 'right'
            }
        ];

        vm.masterGridOptions = {
            columnDefs: vm.masterColumnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowHeight: 40,
            enableColResize: true,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            },
            doesDataFlower: function (dataItem) {
                dataItem.filter = (dataItem.id + ',' + dataItem.name + ',' + dataItem.favoriteGroupType.description).toLowerCase();
                return true;
            },
            isExternalFilterPresent: isExternalFilterPresent,
            doesExternalFilterPass: doesExternalFilterPass,
        };

        vm.masterColumnDefs.forEach(function (d) {
            correctFilterParams(d);
        });

        function correctFilterParams(column) {
            switch (column.filter) {
                case 'number':
                    column.filterParams = {
                        filterOptions: ['equals'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'text':
                    column.filterParams = {
                        filterOptions: ['contains'],
                        newRowsAction: 'keep'
                    };
                    break;
                case 'date':
                    column.suppressFilter = true;
                    break;
            }
        }

        var filter = 'everyone';
        function isExternalFilterPresent() {
            return filter !== '';
        }

        function doesExternalFilterPass(node) {
            if (filter && filter !== 'everyone') {
                var arrdt = node.data.filter.split(filter);
                return arrdt.length > 1;
            }
            return true;
        }


        $scope.$watch('vm.search',
            function (newValue) {
                filter = newValue ? newValue.toLowerCase() : '';
                vm.masterGridOptions.api.onFilterChanged();
            }
        );

        function renderer(params) {
            var toRet = '<div style="width: 100%;">';
            toRet = toRet + '<md-button class="edit-button md-icon-button" ng-click="vm.newGroupProvider(data.id)" translate-attr-aria-label="EC.PRODUCT_DETAILS"'
                + ' ng-disabled="false">'
                + ' <md-icon md-font-icon="icon-pencil" class="md-accent-bgn"></md-icon>'
                + ' <md-tooltip md-direction="top" >{{"general.edit"| translate}}</md-tooltip>'
                + ' </md-button>'
                + ' <md-button class="md-icon-button" ng-click="vm.deleteGroup(data.id, $index, $event)" aria-label="Delete">'
                + ' <md-icon md-font-icon="icon-delete" class="md-warn"></md-icon>'
                + ' <md-tooltip md-direction="top" >{{"general.delete"| translate}}</md-tooltip>'
                + ' </md-button>';

            return toRet + '</div>';
        }


        function newGroupProvider(id) {
            vm.currentThread = {};
            $state.go('app.groupFavorite.providers', { favoriteGroupId: id });
        }
        $scope.$watch('snThread', function (newVal) {
            vm.snThread = newVal;
        });

        $scope.$watch('vm.stateId', function (valorNuevo, valorAnterior) {
            $rootScope.valorNuevo = valorNuevo;
            allProviderTypeGroup(valorNuevo);
        });


        function allProviderTypeGroup(valorNuevo) {
            if (valorNuevo !== undefined && valorNuevo !== 0) {

                vm.allProvider = [];
                api.GeneralWS.AllFavoriteGroup.query({ idCircle: $rootScope.bsCircle.id, groupTypeId: valorNuevo }, function (response) {
                    //// Success
                    vm.allowRoleAccess = true;
                    vm.allProvider = response;
                    vm.masterGridOptions.api.setRowData(vm.allProvider);
                    $log.debug(vm.allProvider);
                    vm.loading = false;
                }, function (response) {
                    vm.loading = false;
                    // Error
                    vm.allowRoleAccess = false;
                    $log.error(response);

                });
            } else {
                vm.loading = false;
                api.GeneralWS.AllFavoriteGroup.query({ idCircle: $rootScope.bsCircle.id }, function (response) {
                    //// Success
                    vm.allowRoleAccess = true;
                    vm.allProvider = response;
                    $log.debug(vm.allProvider);
                    vm.masterGridOptions.api.setRowData(vm.allProvider);
                    vm.loading = false;
                }, function (response) {
                    vm.loading = false;
                    // Error
                    vm.allowRoleAccess = false;
                    $log.error(response);

                });
            }
        }
        vm.allGroupType = [];
        api.GeneralWS.AllFavoriteGroupType.query({}, function (response) {
            vm.allGroupType = response;
        }, function (response) {
            $log.error(response);
        });

        function deleteGroup(id, i, e) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('PROVIDER.DELETE'))
                .ariaLabel('Delete modal')
                .targetEvent(e)
                .ok($filter('translate')('PROVIDER.TXTDELETE'))
                .cancel($filter('translate')('PROVIDER.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                api.GeneralWS.AllFavoriteGroup.delete({ id: id, idCircle: $rootScope.bsCircle.id }, function (response) {
                    vm.allProvider.splice(i, 1);
                    vm.masterGridOptions.api.setRowData(vm.allProvider);
                    MessageService.show("PROVIDER.GROUP_DELETED_SUCCESSFULLY");
                }, function (response) {
                    $log.debug(response);
                });
            }, function () {
            });
        }

    }
})();

(function () {

    'use strict';

    angular
        .module('app.files')
        .controller('FilesController', FilesController);

    function FilesController(api, MessageService, $scope, $log) {

        var fl = this;
        var vm = $scope.vm;

        vm.filesToUpload = [];
        fl.ngFlowOptions = {
            target: '/Compras'
        };
        fl.ngFlow = {
            flow: {}
        };
        fl.dropping = false;
        fl.imageZoomOptions = {};
        //Methods

        fl.fileAdded = fileAdded;
        fl.fileRemove = fileRemove;
        fl.upload = upload;
        fl.uploadFiles = uploadFiles;
        fl.fileSuccess = fileSuccess;
        fl.updateZoomOptions = updateZoomOptions;


        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            if (vm.filesToUpload.length > 0) {
                fl.updateZoomOptions(vm.filesToUpload[0].url);
            }
        }


        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            // Prepare the temp file data for media list
            var uploadingFile = {
                id: file.uniqueIdentifier,
                file: file,
                type: 'uploading'
            };

            if (!file.name.match(/.(jpg|jpeg|png|gif)$/i)) {
                uploadingFile.image = getImageFile(file.name);
            }

            // Append it to the media list
            if (file.size <= 5000000) {//309983   7561216
                if (vm.isInvoice) {
                    if (file.name.match(/.(pdf|jpg|jpeg|png)$/i)) {
                        vm.filesToUpload.push(uploadingFile);
                    } else {
                        MessageService.show(file.name + " es formato inválido.");
                    }
                } else {
                    vm.filesToUpload.push(uploadingFile);
                }
            } else {
                MessageService.show(file.name + " es mayor al tamaño máximo.");
            }
        }

        function fileRemove(file) {
            fl.ngFlow.flow.files.splice(fl.ngFlow.flow.files.indexOf(file.file), 1);
            vm.filesToUpload.splice(vm.filesToUpload.indexOf(file), 1);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload() {
            // Set headers
            fl.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest'
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            fl.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.filesToUpload, function (media, index) {
                if (media.id === file.uniqueIdentifier) {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event) {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }

        /**
         * Update image zoom options
         *
         * @param url
         */
        function updateZoomOptions(url) {
            fl.imageZoomOptions = {
                images: [
                    {
                        thumb: url,
                        medium: url,
                        large: url
                    }
                ]
            };
        }

        function uploadFiles() {
            fl.loadingFiles = true;
            var files = [];
            vm.filesToUpload.forEach(function (r) {
                files.push(r.file.file);
            });
            var message = 'PRODUCT.MSG.SAVEIMAGE';
            MessageService.show(message);
            vm.uploadFiles(files);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('CompanyController', CompanyController);

    /** @ngInject */
    function CompanyController(
        api, MessageService, $scope, $log, $rootScope, $window,
        localStorageService, $filter, $state, envService,
        $mdDialog, $timeout, $stateParams, Company, PreviousState
    ) {

        var vm = this;
        const NOT_ACCEPTABLE_NUMBER = 406;
        const TIMEOUT_TWO_HUNDRED = 200;
        const CONFLICT_NUMBER = 409;
        const STRING_SIZE_100 = 100;
        const STRING_SIZE_99 = 99;
        vm.images = [];
        vm.invitationContacts = [];
        vm.setLogo = true;
        var circle;
        vm.isPrivated = $stateParams.privated ? $stateParams.privated : false;
        vm.isMyCompany = $stateParams.isMyCompany ? $stateParams.isMyCompany : false;
        vm.bankAccount = null;
        vm.asProvider = false;
        vm.baseUrlFiles = api.baseUrlFiles;
        vm.getProductsListAssociate = getProductsListAssociate;
        vm.myProviders = false;
        vm.productSelectedArray = [];
        vm.productAssociatedSelectedArray = [];
        vm.toggleAssociatedProduct = toggleAssociatedProduct;
        vm.toggleProduct = toggleProduct;
        vm.isSelectedProduct = isSelectedProduct;
        vm.isSelectedAssociatedProduct = isSelectedAssociatedProduct;
        vm.associate = associate;
        vm.disassociate = disassociate;
        vm.getCompanyProviderProducts = getCompanyProviderProducts;
        vm.getNotAssociatedProductToProvider = getNotAssociatedProductToProvider;
        vm.addWarehouse = addWarehouse;
        vm.onDelete = onDelete;
        vm.addContact = addContact;
        vm.onDeleteContact = onDeleteContact;
        vm.addBankAccount = addBankAccount;
        vm.onDeleteBankAccount = onDeleteBankAccount;
        vm.validateAsProvider = validateAsProvider;
        vm.addCompany = addCompany;
        vm.readonly = $stateParams.readonly || (PreviousState && PreviousState.name === '' && $stateParams.id);
        vm.invoiceSerieDocumentTypes = {};
        vm.appOperaciones2Active = false;
        vm.operaciones2Warehouses = [];
        vm.selectOperaciones2Warehouse = selectOperaciones2Warehouse;

        vm.productPagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getNotAssociatedProductToProvider();
            }
        };

        vm.associatedProductPagination = {
            pageNumber: 1,
            pageSize: 100,
            totalElements: 0,
            totalPages: 0,
            numberOfElements: 0,
            nextPage: function () {
                this.pageNumber++;
            },
            beforePage: function () {
                this.pageNumber--;
            },
            firstPage: function () {
                this.pageNumber = 1;
            },
            lastPage: function () {
                this.pageNumber = this.totalPages;
            },
            getPage: function (pageNumber) {
                this.pageNumber = pageNumber;
                getCompanyProviderProducts();
            }
        };

        function toggleAssociatedProduct(companyProviderProduct, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.productAssociatedSelectedArray.indexOf(companyProviderProduct) > -1) {
                vm.productAssociatedSelectedArray.splice(vm.productAssociatedSelectedArray.indexOf(companyProviderProduct), 1);
            } else {
                vm.productAssociatedSelectedArray.push(companyProviderProduct);
            }
        }

        function toggleProduct(product, event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.productSelectedArray.indexOf(product) > -1) {
                vm.productSelectedArray.splice(vm.productSelectedArray.indexOf(product), 1);
            } else {
                vm.productSelectedArray.push(product);
            }
        }

        function isSelectedProduct(product) {
            return vm.productSelectedArray.indexOf(product) > -1;
        }

        function isSelectedAssociatedProduct(companyProviderProduct) {
            return vm.productAssociatedSelectedArray.indexOf(companyProviderProduct) > -1;
        }

        var columnDefs = [
            {
                field: "whsCode",
                headerName: 'company_warehouse.code',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "whsName",
                headerName: 'company_warehouse.name',
                headerCellRenderer: getHeader,
                width: 400
            },
            {
                field: "companyEstablishment.establishmentName",
                headerName: 'company_warehouse.establishment',
                headerCellRenderer: getHeader,
                width: 200
            },
            {
                field: "companyWarehouseType",
                headerName: 'company_warehouse.companyWarehouseType',
                headerCellRenderer: getHeader,
                cellRenderer: function (params) {
                    switch (params.value) {
                        case 'STORE':
                            return 'Bodega de Tienda';
                        case 'SALE':
                            return 'Bodega de Venta';
                        case 'PRODUCT':
                            return 'Bodega de Producto';
                        case 'CENTRAL':
                            return 'Bodega Central';
                        case 'POUND':
                            return 'Bodega de Libras';
                        default:
                            return '';
                    }
                },
                width: 200
            },
            {
                field: "active",
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-disabled="vm.readonly" ng-model="data.active" ng-change="vm.onDelete(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return "<center><md-icon md-font-icon='icon-close'> </md-icon></center>";
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: "edit",
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    return '<center> <md-button ng-disabled="vm.readonly" class="md-icon-button" ng-click="vm.addWarehouse(data)"> ' +
                        '<md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">{{"general.edit"| translate}}</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.warehousesGrid = {
            columnDefs: columnDefs,
            angularCompileRows: true,
            angularCompileHeaders: true,
            rowSelection: 'multiple',
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        const columnDefsContacts = [
            {
                field: 'name',
                headerName: 'CONTACTS.NAME',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'phone',
                headerName: 'CONTACTS.PHONE',
                headerCellRenderer: getHeader,
                width: 100,
            },
            {
                field: 'phone2',
                headerName: 'CONTACTS.PHONE2',
                headerCellRenderer: getHeader,
                width: 100,
            },
            {
                field: 'phoneMobile',
                headerName: 'CONTACTS.PHONEMOBILE',
                headerCellRenderer: getHeader,
                width: 125,
            },
            {
                field: 'email',
                headerName: 'CONTACTS.EMAIL',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'address',
                headerName: 'CONTACTS.ADDRESS',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'active',
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-disabled="vm.readonly" ng-model="data.active"' +
                            'ng-change="vm.onDeleteContact(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return '<center><md-icon md-font-icon="icon-close"> </md-icon></center>';
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: 'edit',
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function () {
                    return '<center> <md-button ng-disabled="vm.readonly" class="md-icon-button" ng-click="vm.addContact(data)"> ' +
                        '<md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">' +
                        '{{"general.edit"| translate}}</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.contactsGrid = {
            columnDefs: columnDefsContacts,
            rowSelection: 'multiple',
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        const columnDefsBankAccount = [
            {
                field: 'bank.name',
                headerName: 'BANKACCOUNT.BANK',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'bankAccountType.bankAccountTypeDescription',
                headerName: 'BANKACCOUNT.ACCOUNTTYPE',
                headerCellRenderer: getHeader,
                width: 150,
            },
            {
                field: 'accountNumber',
                headerName: 'BANKACCOUNT.ACCOUNTNUMBER',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'accountName',
                headerName: 'BANKACCOUNT.NAME',
                headerCellRenderer: getHeader,
                width: 200,
            },
            {
                field: 'isDefault',
                headerName: 'BANKACCOUNT.ISDEFAULT',
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-icon md-font-icon="icon-checkbox-marked-circle green-500-fg"></md-icon></center>';
                    } else {
                        return '<center><md-icon md-font-icon="icon-cancel red-500-fg"></md-icon></center>';
                    }
                },
                cellStyle: { 'padding': '5px' },
                headerCellRenderer: getHeader,
                width: 125,
            },
            {
                field: 'active',
                headerName: 'general.active',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function (params) {
                    if (params.value) {
                        return '<center><md-checkbox ng-disabled="vm.readonly" ng-model="data.active"' +
                            'ng-change="vm.onDeleteBankAccount(data)" aria-label="chk"></md-checkbox></center>';
                    } else {
                        return '<center><md-icon md-font-icon="icon-close"> </md-icon></center>';
                    }
                },
                cellStyle: { 'padding': '5px' }
            },
            {
                name: 'edit',
                headerName: 'general.edit',
                headerCellRenderer: getHeader,
                width: 70,
                cellRenderer: function () {
                    return '<center> <md-button ng-disabled="vm.readonly" class="md-icon-button" ng-click="vm.addBankAccount(data)"> ' +
                        '<md-icon md-font-icon="icon-border-color"></md-icon> <md-tooltip md-direction="left">' +
                        '{{"general.edit"| translate}}</md-tooltip> </md-button> </center>';
                },
                cellStyle: { 'padding': '2px' }
            }
        ];

        vm.bankAccountGrid = {
            columnDefs: columnDefsBankAccount,
            rowSelection: 'multiple',
            angularCompileRows: true,
            angularCompileHeaders: true,
            enableColResize: true,
            enableSorting: true,
            animateRows: true,
            rowHeight: 45,
            rowData: [],
            getMainMenuItems: function (params) {
                return getHeaderMenu(params, $filter);
            },
            localeTextFunc: function (key, defaultValue) {
                return translateGrid(key, defaultValue, $filter);
            }
        };

        init();

        function init() {
            if (vm.isPrivated) {
                if (Company && !Company.privated) {
                    $state.go('app.CompanyProvider.MyProviders');
                }
                circle = Company ? { company: Company, role: { name: 'ADMIN' } } : null;
                if (circle) {
                    api.GeneralWS.CompanyProvider.me.query({ 'companyId': $rootScope.bsCircle.company.id, 'providerId': circle.company.id }).$promise.then(function (data) {
                        vm.haveCredit = data.haveCredit;
                        vm.daysCredit = data.daysCredit;
                        vm.accountingCatalog = data.accountingCatalog;
                        vm.companyProvider = data;
                        vm.companyProviderCode = data.companyProviderCode;
                        vm.myProviders = !vm.isMyCompany ? true : false;
                        vm.companyProviderTag = { companyProvider: data, companyTags: {} };
                    }, function (err) {
                        $log.error(err);
                    });
                }
            } else {
                circle = $rootScope.bsCircle;
            }
            getCompanyApplicationOp2();
            getOperaciones2Warehouses();
        }

        vm.isNew = circle === null || circle === undefined;
        vm.addNewCompany = false;

        if ($state.params.tipoError) {
            vm.textTipoError = 'COMPANY.COMPLETE_INFO_ERR' + $state.params.tipoError;
        }

        vm.ngFlowOptions = {
            target: '/Megasistemas'
        };

        vm.querySearch = querySearch;

        vm.sendForm = sendForm;
        vm.cancelar = cancelar;
        vm.closeThread = closeThread;

        vm.goDocuments = goDocuments;
        vm.goInvoiceSeries = goInvoiceSeries;

        vm.addRegime = addRegime;
        vm.deleteRegime = deleteRegime;
        vm.fileAdded = fileAdded;
        vm.fileRemove = fileRemove;
        vm.upload = upload;
        vm.fileSuccess = fileSuccess;
        vm.updateImageZoomOptions = updateImageZoomOptions;
        vm.uploadFiles = uploadFiles;
        vm.deleteLogo = deleteLogo;
        vm.getRoles = getRoles;
        vm.sendInvitation = sendInvitation;
        vm.validateEmailChip = validateEmailChip;
        vm.back = back;

        vm.addWithholding = addWithholding;
        vm.deleteWithholding = deleteWithholding;

        vm.onChangeCountry = onChangeCountry;

        vm.baseUrlSharedFiles = envService.read('baseUrlSharedFiles');

        vm.msgRequired = '';

        function closeThread() {
            $state.go('app.company.mycompany');
        }

        function querySearch(numberSelect, query) {
            var results;
            if (numberSelect) {
                if (numberSelect === 1) {
                    results = query ? vm.typeDocuments.filter(createFilterFor(1, query)) : vm.typeDocuments;
                } else if (numberSelect === 2) {
                    results = query ? vm.number.filter(createFilterFor(2, query)) : vm.number;
                } else if (numberSelect === 3) {
                    results = query ? vm.countries.filter(createFilterFor(1, query)) : vm.countries;
                }
                return results;
            }
        }

        function createFilterFor(fieldFilter, query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(model) {
                var lowercaseName;
                if (fieldFilter === 1) {
                    lowercaseName = angular.lowercase(model.name);
                } else if (fieldFilter === 2) {
                    lowercaseName = angular.lowercase(model.description);
                } else {
                    lowercaseName = '';
                }

                return (lowercaseName.indexOf(lowercaseQuery) === 0 || lowercaseName.indexOf(lowercaseQuery) >= 1);
            };
        }

        vm.clearSearchCurrency = function () {
            vm.searchCurrency = '';
        };

        vm.clearSearchForeignCurrency = function () {
            vm.searchCurrency = '';
        };

        vm.clearSearchCountry = function () {
            vm.searchCountry = '';
        };
        vm.clearSearchAccountingCatalog = function () {
            vm.searchAccountingCatalog = '';
        };

        vm.clearSearchBank = function () {
            vm.searchBank = '';
        };

        vm.searchBankAccountType = function () {
            vm.searchBankAccountType = '';
        }

        $timeout(function () {
            const keyEvent = function (event) {
                event.stopPropagation();
            };
            const searchCurrencyInput = document.querySelector('#currency');
            const searchForeignCurrencyInput = document.querySelector('#foreignCurrency');
            const searchCountryInput = document.querySelector('#country');
            const searchAccountingCatalog = document.querySelector('#searchAccountingCatalog');
            const searchBankInput = document.querySelector('#searchBank');
            const searchBankAccountTypeInput = document.querySelector('#searchBankAccountType');
            const searchCompanyCategoryInput = document.querySelector('#searchCompanyCategory');

            if (searchCurrencyInput) {
                searchCurrencyInput.addEventListener('keydown', keyEvent);
            }
            if (searchForeignCurrencyInput) {
                searchForeignCurrencyInput.addEventListener('keydown', keyEvent);
            }
            if (searchCountryInput) {
                searchCountryInput.addEventListener('keydown', keyEvent);
            }
            if (searchAccountingCatalog) {
                searchAccountingCatalog.addEventListener('keydown', keyEvent);
            }
            if (searchBankInput) {
                searchBankInput.addEventListener('keydown', keyEvent);
            }
            if (searchBankAccountTypeInput) {
                searchBankAccountTypeInput.addEventListener('keydown', keyEvent);
            }
            if (searchCompanyCategoryInput) {
                searchCompanyCategoryInput.addEventListener('keydown', keyEvent);
            }
        }, 500);

        function onInit() {
            //países
            vm.loading = true;
            api.GeneralWS.Country.me.query().$promise.then(function (response) {
                vm.countries = response;
                vm.loading = false;
            }, function (errResponse) {
                vm.loading = false;
                $log.error(errResponse.data);
            });

            //Monedas
            api.GeneralWS.getAllCurrency.query().$promise.then(function (response) {
                vm.currencies = response;
                vm.loading = false;
            }, function (error) {
                vm.loading = false;
                $log.error(error.data);
            });

            // Tipo de cuenta
            api.GeneralWS.BankAccountType.BankAccountType.get({ 'idCircle': 0 }, function (response) {
                vm.bankAccountTypes = response;
                vm.isShowProgressLinear = false;
            }, function (errResponse) {
                vm.isShowProgressLinear = false;
                $log.error(errResponse);
            });

            vm.editMode = vm.isNew;

            if (vm.isNew) {
                vm.company = {};
                vm.companyContact = {};
                if (vm.isPrivated) {
                    vm.company.country = { id: $rootScope.bsCircle.company.country.id };
                    onChangeCountry();
                }
                vm.authorizedToEdit = true;
            } else {
                vm.company = circle.company;

                api.GeneralWS.CompanyDocument.query({ 'company': vm.company.id }).$promise.then(function (response) {
                    vm.company.documents = response;
                }, function (response) {
                    $log.error(response);
                });

                onChangeCountry();
                getRegimen(vm.company.country.id);
                getWitholdings(vm.company.id);
                vm.authorizedToEdit = true;
                getDocumentTypes();
                if (vm.company.logo) {
                    var ft = {
                        url: getPhoto(null, vm.company.logo),
                        type: 'image',
                        original: vm.company.logo,
                        extension: vm.company.logo.extension
                    };
                    vm.logo = ft;
                    vm.updateImageZoomOptions(vm.logo);
                    vm.setLogo = false;
                }

                $timeout(function () {
                    getCompanyContacts();
                    getBankAccounts();
                    validateAsProvider();
                }, TIMEOUT_TWO_HUNDRED);
            }

            if (vm.isPrivated) {
                getInvoiceSeries();

                $timeout(function () {
                    getWarehouses();
                }, 800);

            }
        }

        function getRegimen(country) {
            api.GeneralWS.Regime.getAllByCountry.query({ id: country }).$promise.then(function (data) {

                vm.infoRegimen = data;
                loadRegimen();

            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function getCompanyTypeList(country) {
            api.GeneralWS.CompanyType.getList.getByCountry({ countryId: country }).$promise.then(function (data) {
                vm.companyTypeList = data;

                if (vm.isNew && data.length === 1) {
                    vm.company.companyTypeId = vm.companyTypeList[0].id;
                }

            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function getCompanyCategoryList(country) {
            api.GeneralWS.CompanyCategory.getList.getByCountry({ countryId: country }).$promise.then(function (data) {
                vm.companyCategoryList = data;
                if (vm.isNew && data.length === 1) {
                    vm.company.companyCategoryId = vm.companyCategoryList[0].id;
                }
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function getWitholdings(companyId) {
            var list = [];
            api.GeneralWS.CompanyWithholding.me.query({ company: companyId }).$promise.then(function (data) {

                list = data;

                api.GeneralWS.CompanyWithholding.notAssociatedToCompany.query({ company: companyId }).$promise.then(function (data1) {

                    for (var i = 0; i < data1.length; i++) {
                        list.push({
                            id: 0,
                            withholding: data1[i]
                        });
                    }

                    vm.withholdings = list;

                }, function (errResponse) {
                    $log.error(errResponse);
                });

            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function loadRegimen() {

            api.GeneralWS.AllRegimeByCompany.query({ 'idCompany': vm.company.id }).$promise.then(function (data) {

                vm.company.regimes = data;

                var infoRegimen = angular.copy(vm.infoRegimen);
                if (vm.company.regimes && vm.company.regimes.length > 0) {

                    for (var i = 0; i < vm.company.regimes.length; i++) {
                        for (var j = 0; j < infoRegimen.length; j++) {
                            if (infoRegimen[j].id === vm.company.regimes[i].id) {
                                infoRegimen[j].enabled = true;
                            }
                        }
                    }
                }

                vm.regimes = infoRegimen;

            }, function (errResponse) {
                $log.error(errResponse);
            });

        }

        //////////
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0
                },
                {
                    // Target the actions column
                    targets: 4,
                    responsivePriority: 1,
                    filterable: true,
                    sortable: false
                }
            ],
            order: [[0, 'desc']],
            pagingType: 'simple',
            paging: false,
            responsive: true
        };

        vm.dtOptionsInvoice = {
            dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: 0
                },
                {
                    // Target the status column
                    targets: 8,
                    filterable: false,
                    render: function (data, type) {
                        if (type === 'display') {
                            if (data === 'true') {
                                return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                            }

                            return '<i class="icon-cancel red-500-fg"></i>';
                        }

                        if (type === 'filter') {
                            if (data) {
                                return '1';
                            }

                            return '0';
                        }

                        return data;
                    }
                }
            ],
            order: [[0, 'desc']],
            pagingType: 'simple',
            paging: false,
            responsive: true
        };

        function addCompany() {
            vm.editMode = true;
            vm.company = null;
            vm.addNewCompany = true;
            vm.isNew = true;
            vm.companyContact = null;
            vm.bankAccount = null;
            vm.asProvider = false;
            vm.company = {};
            if (vm.companyCategoryList && vm.companyCategoryList.length === 1) {
                vm.company.companyCategoryId = vm.companyCategoryList[0].id;
            }
            if (vm.companyTypeList && vm.companyTypeList.length === 1) {
                vm.company.companyTypeId = vm.companyTypeList[0].id;
            }
        }

        function sendForm() {
            if (vm.wizardStep1.$invalid) {
                MessageService.show($filter('translate')('general.completeInfo'));
                return false;
            }

            vm.company.privated = vm.isPrivated;
            vm.loading = true;
            var params = {};
            if (vm.isPrivated) {
                params.idHostCompany = $rootScope.bsCircle.company.id;
                params.haveCredit = vm.haveCredit;
                params.daysCredit = vm.haveCredit ? vm.daysCredit : 0;
                params.companyProviderCode = vm.companyProviderCode;
            }

            doCreateOrUpdate(params);
        }

        function doCreateOrUpdate(params) {

            let address = vm.companyContact.address;
            if (vm.companyContact.address === undefined) {
                address = null;
            }
            let phone2 = vm.companyContact.phone2;
            if (vm.companyContact.phone2 === undefined) {
                phone2 = null;
            }
            let phoneMobile = vm.companyContact.phoneMobile;
            if (vm.companyContact.phoneMobile === undefined) {
                phoneMobile = null;
            }
            let email = vm.companyContact.email;
            if (vm.companyContact.email === undefined) {
                email = null;
            }

            const currectContact = {
                id: 0,
                active: true,
                company: { id: 0 },
                name: vm.companyContact.name,
                phone: vm.companyContact.phone,
                address: address,
                phone2: phone2,
                phoneMobile: phoneMobile,
                email: email
            };

            let promise;
            if (vm.isNew) {
                vm.bankAccount.currency = { id: vm.company.currency.id };
                vm.bankAccount.isForCompany = true;
                vm.bankAccount.id = 0;

                const dto = {
                    company: vm.company,
                    companyContactDTO: currectContact,
                    bankAccount: vm.bankAccount
                };
                promise = api.GeneralWS.CompanyWithDataRequired.addCompany.add(params, dto).$promise;
            } else {
                params.id = circle.company.id;
                currectContact.id = vm.companyContact.id;
                currectContact.active = vm.companyContact.active;
                currectContact.company = vm.company;
                if (vm.bankAccount.id === undefined) {
                    vm.bankAccount.id = 0;
                }
                if (vm.bankAccount.currency === undefined) {
                    vm.bankAccount.currency = { id: vm.company.currency.id };
                }
                vm.bankAccount.isForCompany = true;
                const dto = {
                    company: vm.company,
                    companyContactDTO: currectContact,
                    bankAccount: vm.bankAccount
                };
                promise = api.GeneralWS.CompanyWithDataRequired.editCompany.update(params, dto).$promise;
            }

            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                validateResponse(response);
            }, function (response) {
                if (response.status === CONFLICT_NUMBER) {
                    MessageService.showErrorMessage($filter('translate')('BANKACCOUNT.dataExist'));
                } else if (response.data.mensaje) {
                    MessageService.showErrorMessage($filter('translate')('COMPANY.MSG.' + response.data.mensaje));
                } else {
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                }
                vm.loading = false;
            });
        }

        function validateResponse(response) {
            vm.loading = false;
            vm.wizardStep1.$setPristine();
            vm.editMode = false;

            if (vm.isNew) {
                MessageService.show($filter('translate')('COMPANY.COMPANY_CREATED'));
                circle = { company: response.company, role: { name: 'ADMIN' } };
                vm.company = response.company;
                loadBussinesCircle(response.company);
            } else {
                MessageService.show($filter('translate')('COMPANY.COMPANY_UPDATED'));

                if (circle.company.documents === null) {
                    goDocuments();
                    loadBussinesCircle(response.company);
                }
            }

            if (circle.company.documents !== null) {
                getCompanyContacts();
                getBankAccounts();
            }

            vm.isShowProgressLinear = false;
        }

        function back() {
            if (PreviousState && PreviousState.name) {
                $state.go(PreviousState.name);
            } else {
                $state.go('app.CompanyProvider.MyProviders');
            }
        }

        function loadBussinesCircle(company) {
            if (!vm.isPrivated) {
                api.GeneralWS.MyCircles.query({}, function (response) {// Success
                    if (response.length > 0) {
                        $rootScope.circles = response;
                        localStorageService.set('circles', $rootScope.circles);

                        circle = $rootScope.circles[0];

                        if (vm.addNewCompany === true) {
                            circle = _.find(response, function (circle) {
                                return circle.company.id === company.id;
                            });
                        } else if (localStorageService.get('accountc')) {
                            circle = localStorageService.get('accountc');
                        }

                        circle.company = company;

                        api.GeneralWS.InvoiceSerie.getByCompany({ id: 'getCompany', idCircle: circle.id, active: true }).$promise.then(function (response) {
                            circle.company.invoiceSeries = response;
                            api.GeneralWS.InvoiceSerie.getByCompany({ id: 'getCompany', idCircle: circle.id, active: false }).$promise.then(function (response) {
                                circle.company.invoiceSeries = circle.company.invoiceSeries.concat(response);
                                getInvoiceSerieDocumentTypeName(circle.company.invoiceSeries);
                            }, function (errResponse) {
                                getInvoiceSerieDocumentTypeName(circle.company.invoiceSeries);
                                $log.debug(errResponse);
                            });
                        }, function (errResponse) {
                            $log.debug(errResponse);
                        });
                        localStorageService.set('accountc', circle);
                        $rootScope.bsCircle = circle;
                        if ($rootScope.bsCircle) {
                            $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
                        }
                        getApps();
                        $rootScope.getScreenByRole();
                    }

                    if (circle.company.documents === null) {
                        goDocuments();
                    }
                }, function (response) {// Error
                    $log.debug(response);
                });
            } else {
                if (circle.company.documents === null) {
                    goDocuments();
                }
            }
        }

        function getInvoiceSerieDocumentTypeName(invoiceSeries) {
            invoiceSeries.forEach(function(serie) {
                serie.invoiceSerieDocumentTypeName = vm.invoiceSerieDocumentTypes[serie.invoiceSerieDocumentType];
            });
        }

        function getDocumentTypes() {
            api.GeneralWS.DocumentType.getAll({ id: circle.company.country.id, 'category': 'COMPANY' }).$promise.then(function (response) {
                vm.documentTypes = response;
                var requiredDocuments = "";
                for (var i = 0; i < vm.documentTypes.length; i++) {
                    if (vm.documentTypes[i].required === true) {
                        requiredDocuments = requiredDocuments ? requiredDocuments + ", " + vm.documentTypes[i].name : vm.documentTypes[i].name;
                    }
                }
                vm.msgRequired = requiredDocuments;
            }, function (errResponse) {
                $log.error(errResponse.data);
            });
        }

        function goDocuments() {
            var stateGo = vm.isPrivated ? 'app.CompanyProvider.private.documents' : 'app.company.mycompany.documents';
            var params = { listOfDocumentTypes: vm.documentTypes };
            if (vm.isPrivated) {
                params.id = vm.company.id;
            }
            $state.go(stateGo, params);
        }

        function goInvoiceSeries() {
            var stateGo = vm.isPrivated ? 'app.CompanyProvider.private.invoiceSerie' : 'app.company.mycompany.invoiceSerie';
            var params = {};
            if (vm.isPrivated) {
                params.id = vm.company.id;
            }
            $state.go(stateGo, params);
        }

        function cancelar() {
            vm.company = angular.copy($scope.bsCircle.company);
            vm.wizardStep1.$setPristine();
            vm.editMode = false;
            vm.isNew = circle === null || circle === undefined;
            vm.addNewCompany = false;
            getCompanyContacts();
            getBankAccounts();
            validateAsProvider();
        }

        onInit();

        function addRegime(regime) {
            vm.loading = true;

            if (!vm.company.regimes) {
                vm.company.regimes = [];
            }

            vm.company.regimes.push(regime);
            api.GeneralWS.CompanyRegime.addRegime({ id: vm.company.id }, vm.company, function (data) {

                circle.company.regimes = vm.company.regimes;
                $rootScope.loadingProgress = false;
                vm.loading = false;

                loadRegimen();

                MessageService.show($filter('translate')('COMPANY.REGIME_ADDED'));
            }, function (errResponse) {
                $rootScope.loadingProgress = false;
                vm.company.regimes.splice(vm.company.regimes.length - 1);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        function deleteRegime(regime) {

            var confirm = $mdDialog.confirm()
                .title($filter('translate')('COMPANY.MSG_SURE_DELETE'))
                .content($filter('translate')('COMPANY.DELETE_DETAIL'))
                .ariaLabel('Delete Regime')
                .ok($filter('translate')('COMPANY.DELETE'))
                .cancel($filter('translate')('COMPANY.CANCEL'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.loadingProgress = true;

                var newData = [];
                for (var i = 0; i < vm.company.regimes.length; i++) {
                    if (vm.company.regimes[i].id !== regime.id) {
                        newData.push(vm.company.regimes[i]);
                    }
                }

                vm.company.regimes = newData;

                api.GeneralWS.CompanyRegime.addRegime({ id: vm.company.id }, vm.company, function (data) {

                    circle.company.regimes = newData;
                    $rootScope.loadingProgress = false;

                    loadRegimen();

                    MessageService.show($filter('translate')('COMPANY.MSG_DELETE'));

                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    vm.company.regimes.push(regime);
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });

            }, function () {
            });
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            // Prepare the temp file data for media list
            if (file.name.match(/.(jpg|jpeg)$/i)) {
                var uploadingFile = {
                    id: file.uniqueIdentifier,
                    file: file,
                    type: 'uploading'
                };

                if (file.size <= 8000000) {
                    vm.images.length > 0 ? fileRemove(vm.images[0]) : null;
                    vm.images[0] = uploadingFile;
                } else {
                    MessageService.showErrorMessage(file.name + $filter('translate')('PRODUCT.TEXT.PHOTOS.IS_MAJOR_SIZE'));
                }
            } else {
                MessageService.show($filter('translate')('COMPANY.MSG.ONLY_FORMAT'));
            }
        }

        function fileRemove(file) {
            vm.ngFlow.flow.files.splice(vm.ngFlow.flow.files.indexOf(file.file), 1);
            vm.images.splice(vm.images.indexOf(file), 1);
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function upload() {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest'
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            // Iterate through the media list, find the one we
            // are added as a temp and replace its data
            // Normally you would parse the message and extract
            // the uploaded file data from it
            angular.forEach(vm.images, function (media, index) {
                if (media.id === file.uniqueIdentifier) {
                    // Normally you would update the media item
                    // from database but we are cheating here!
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(media.file.file);
                    fileReader.onload = function (event) {
                        media.url = event.target.result;
                    };

                    // Update the image type so the overlay can go away
                    media.type = 'image';
                }
            });
        }

        /**
         * Update image zoom options
         *
         * @param img
         */
        function updateImageZoomOptions(img) {
            var url = img.url;
            var extension = img.extension;
            vm.imageZoomOptions = {
                images: [
                    {
                        thumb: url + 's' + extension,
                        medium: url + 'm' + extension,
                        large: url + 'l' + extension
                    }
                ]
            };
        }

        function uploadFiles() {
            vm.loading = true;
            var files = [vm.images[0].file.file];
            api.GeneralWS.CompanyLogo.add({ id: vm.company.id }, files).then(function (response) {
                vm.company.logo = response.data;
                vm.company.urlImage = response.parentPath + response.name + "s" + response.extension;
                localStorageService.set('accountc', circle);
                if ($rootScope.bsCircle) {
                    $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
                }
                var ft = {
                    url: getPhoto(null, vm.company.logo),
                    type: 'image',
                    original: vm.company.logo,
                    extension: vm.company.logo.extension
                };
                vm.logo = ft;
                vm.updateImageZoomOptions(vm.logo);
                vm.setLogo = false;
                vm.images = [];
                MessageService.show($filter('translate')('COMPANY.MSG.SAVE_LOGO'));
                vm.loading = false;
            }, function (errResponse) {
                $log.error(errResponse);
                vm.loading = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }
        function getPhoto(url, ph) {
            if (ph) {
                url = ph.parentPath + ph.name;
            }
            if (url) {
                return vm.baseUrlFiles + url;
            }
            return 'assets/images/etc/thumbPhoto';
        }
        function deleteLogo() {
            vm.loading = true;
            api.GeneralWS.Company.deleteLogo({ id: 'deleteLogo', companyId: vm.company.id }, function (data) {
                vm.company.logo = null;
                vm.company.urlImage = null;
                vm.imageZoomOptions = {};
                vm.setLogo = true;

                localStorageService.set('accountc', circle);
                if ($rootScope.bsCircle) {
                    $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
                }
                MessageService.show($filter('translate')('COMPANY.MSG.LOGO_DELETED'));
                vm.loading = false;
            }, function (errResponse) {
                $log.error(errResponse);
                vm.loading = false;
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        //Invitacion
        function getApps() {
            api.GeneralWS.CompanyApplication.me.query({ company: vm.company.id }, function (response) {
                vm.applications = response;
                if (vm.applications.length > 0) {
                    vm.appId = vm.applications[0].application.id;
                    getRoles();
                }
            }, function (d) {
            });
        }

        if (!vm.isNew) {
            getApps();
        }

        function getRoles() {
            vm.isShowProgressLinearRoles = true;
            vm.roles = [];
            api.GeneralWS.RoleApplication.byLevel.query({ applicationId: vm.appId, level: $rootScope.bsCircle.role.roleLevel }, function (response) {
                vm.roles = new jinqJs()
                    .from(response)
                    .where(function (r) {
                        return r.name === 'ROLE_PROVEEDOR';
                    })
                    .select();
                if (vm.roles.length > 0) {
                    vm.rolId = vm.roles[0].id;
                }
                vm.isShowProgressLinearRoles = false;
            }, function (d) {
                vm.isShowProgressLinearRoles = false;
            });
        }
        function sendInvitation(reSend) {

            if (reSend) {
                vm.invitationContacts.push(reSend.email);
                vm.rolId = reSend.roleApplication.id;
            }

            if (vm.invitationContacts.length === 0) {
                $log.debug("No contacts");
                return false;
            }

            if (!vm.rolId) {
                $log.debug("No rolid");
                MessageService.show($filter('translate')('guest.selectRole'));
                return false;
            }

            if (vm.rolId <= 0) {
                $log.debug("No rolid <= 0");
                MessageService.show($filter('translate')('guest.selectRole'));
                return false;
            }

            vm.loading = true;
            api.GeneralWS.UserInvitation.sendInvitation({ 'companyid': vm.company.id, 'rol': vm.rolId }, vm.invitationContacts, function (response) {
                vm.loading = false;

                vm.invitationContacts = [];
                MessageService.show($filter('translate')('guest.INVITATION_SEND_SUCCESSFULLY'));

            }, function (response) {
                vm.loading = false;
                MessageService.showErrorMessage($filter('translate')('guest.errorONSend'));
            });

        }

        function validateEmailChip($chip) {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test($chip)) {
                return $chip;
            } else {
                return null;
            }
        }

        function addWithholding(row) {

            $mdDialog.show({
                controller: 'DialogWithholdingFileController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/withholdingFileDialog/withholdingFile.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    companyWithholding: row
                }
            }).then(function (answer) {
                api.GeneralWS.CompanyWithholding.me.create({ company: vm.company.id, withholdingId: row.withholding.id, fileStorageId: answer.id }, function (data) {

                    $rootScope.loadingProgress = false;

                    getWitholdings(vm.company.id);

                    MessageService.show($filter('translate')('COMPANY.REGIME_ADDED'));
                }, function (errResponse) {
                    $rootScope.loadingProgress = false;
                    MessageService.showErrorMessage($filter('translate')('general.general_error'));
                });
            }, function () {

            });
        }

        function deleteWithholding(row) {
            if (row.id > 0) {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('COMPANY.MSG_SURE_DELETE'))
                    .content($filter('translate')('COMPANY.DELETE_DETAIL'))
                    .ariaLabel('Delete Regime')
                    .ok($filter('translate')('COMPANY.DELETE'))
                    .cancel($filter('translate')('COMPANY.CANCEL'));

                $mdDialog.show(confirm).then(function () {
                    $rootScope.loadingProgress = true;

                    api.GeneralWS.CompanyWithholding.me.Delete({ company: vm.company.id, id: row.id }, function (data) {

                        $rootScope.loadingProgress = false;

                        getWitholdings(vm.company.id);

                        MessageService.show($filter('translate')('COMPANY.MSG_DELETE'));

                    }, function (errResponse) {
                        $rootScope.loadingProgress = false;
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    });

                }, function () {
                });
            }
        }

        vm.saveTag = function () {
            if (vm.companyProviderTag.companyTags.companyTagValue === '') {
                return false;
            }
            vm.loadingTags = true;
            api.GeneralWS.CompanyProviderTags.me.create({ 'idCircle': $rootScope.bsCircle.id }, vm.companyProviderTag, function (response) {
                vm.companyProviderTag.companyTags.companyTagValue = '';
                init();
                MessageService.show($filter('translate')('TAGS.MSG.ADDED_TAG'));
                vm.loadingTags = false;
            }, function (errResponse) {
                MessageService.showErrorMessage($filter('translate')('TAGS.MSG.' + errResponse.data));
            });
            return true;
        };

        vm.deleteTag = function (row) {
            var confirm = $mdDialog.confirm()
                .title($filter('translate')('general.delete'))
                .textContent($filter('translate')('TAGS.MSG.CONFIRM_DELETE'))
                .ok($filter('translate')('general.accept'))
                .cancel($filter('translate')('general.cancel'));
            $mdDialog.show(confirm).then(function () {
                vm.loadingTags = true;
                api.GeneralWS.CompanyProviderTags.me.del({ 'idCircle': $rootScope.bsCircle.id, 'id': row.id, 'companyProviderId': vm.companyProvider.id }, {}, function (response) {
                    vm.companyProviderTag.companyTags.companyTagValue = '';
                    init();
                    MessageService.show($filter('translate')('TAGS.MSG.DELETED_TAG'));
                    vm.loadingTags = false;
                }, function (errResponse) {

                });
            }, function () {
            });
        };

        vm.focusTag = function () {
            var companyTagValue = document.querySelector("#companyTagValue");
            $timeout(function () {
                companyTagValue.focus();
            }, 300);
        };

        vm.viewIMG = function (file) {
            $mdDialog.show({
                controller: 'DialogPhotoController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/files/dialogPhoto/dialogPhoto.html',
                parent: angular.element("#main"),
                name: file.originalName,
                url: vm.baseUrlFiles + file.parentPath + file.name + file.extension,
                clickOutsideToClose: false
            }).then(function (answer) {
                //go to Quotations
                answer === true ? goToInvoicePurchases() : null;
            });

        }

        function getProductsListAssociate() {
            var windowHeight = parseInt(window.innerWidth
                || document.documentElement.clientWidth
                || document.body.clientWidth);

            windowHeight -= windowHeight > 1400 ? 1300 : 1010;

            vm.dinamicHeight = {
                "height": windowHeight + "px"
            };
            if (!vm.associatedProductArray) {
                getNotAssociatedProductToProvider();
                getCompanyProviderProducts();
            }
        }

        function getCompanyProviderProducts() {
            vm.loadAssociatedProducts = true;
            api.GeneralWS.CompanyProviderProduct.byProvider.get({
                'companyId': $rootScope.bsCircle.company.id, 'providerId': vm.companyProvider.provider.id,
                'pageNumber': vm.associatedProductPagination.pageNumber,
                'pageSize': vm.associatedProductPagination.pageSize, 'search': vm.searchAssociatedProductInput
            })
                .$promise.then(function (response) {
                    vm.loadAssociatedProducts = false;
                    vm.associatedProductArray = response.content;
                    vm.associatedProductPagination.totalElements = response.totalElements;
                    vm.associatedProductPagination.totalPages = response.totalPages;
                    vm.associatedProductPagination.numberOfElements = response.numberOfElements;
                }, function (response) {
                    vm.loadAssociatedProducts = false;
                    $log.debug(response);
                });
        }

        function getNotAssociatedProductToProvider() {
            vm.loadProducts = true;
            api.GeneralWS.CompanyProviderProduct.byNotProvider.get({
                'idCircle': $rootScope.bsCircle.id, companyProviderId: vm.companyProvider.id,
                'pageNumber': vm.productPagination.pageNumber, 'pageSize': vm.productPagination.pageSize, 'search': vm.searchProductInput
            }, function (response) {
                vm.loadProducts = false;
                vm.productArray = response.content;
                vm.productPagination.totalElements = response.totalElements;
                vm.productPagination.totalPages = response.totalPages;
                vm.productPagination.numberOfElements = response.numberOfElements;
            }, function (err) {
                $log.debug(err);
                vm.loadProducts = false;
            });
        }

        function associate() {
            vm.isShowProgressLinear = true;

            var _companyProviderProductArray = [];

            vm.productSelectedArray.forEach(function (row) {
                _companyProviderProductArray.push({
                    'product': row,
                    'companyProvider': vm.companyProvider
                });
            });

            api.GeneralWS.CompanyProviderProduct.CompanyProviderProduct.create(
                {
                    'idCircle': $rootScope.bsCircle.id
                }, _companyProviderProductArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.productSelectedArray = [];

                    if (response) {
                        MessageService.show($filter('translate')('validate_provider.product_added_successfully'));
                    }

                    getCompanyProviderProducts();
                    getNotAssociatedProductToProvider();
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

        function disassociate() {
            vm.isShowProgressLinear = true;

            var _associatedProductIdArray = [];

            vm.productAssociatedSelectedArray.forEach(function (row) {
                _associatedProductIdArray.push(row.id);
            });

            api.GeneralWS.CompanyProviderProduct.CompanyProviderProduct.update(
                {
                    'idCircle': $rootScope.bsCircle.id
                }, _associatedProductIdArray)
                .$promise.then(function (response) {
                    vm.isShowProgressLinear = false;

                    vm.productAssociatedSelectedArray = [];

                    if (response) {
                        MessageService.show($filter('translate')('validate_provider.product_removed_successfully'));
                    }

                    getCompanyProviderProducts();
                    getNotAssociatedProductToProvider();
                }, function (response) {
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
        }

        function getInvoiceSeriesDocumentCountryList(country) {
            api.GeneralWS.InvoiceSeriesDocumentCountry.getList.getByCountry({ countryId: country }).$promise.then(function (data) {
                vm.invoiceSerieDocumentTypes = {};
                data.forEach(function(documentType) {
                    vm.invoiceSerieDocumentTypes[documentType.invoiceSeriesDocumentTypeId] = documentType.invoiceSeriesDocumentTypeDescription;
                });
            }, function (errResponse) {
                $log.error(errResponse);
            });
        }

        function getInvoiceSeries() {
            if (vm.company && vm.company.id) {
                api.GeneralWS.InvoiceSerie.getByCompany({ id: 'getCompanyId', idCompany: vm.company.id }).$promise.then(function (response) {
                    vm.invoiceSeries = new jinqJs()
                        .from(response)
                        .orderBy([{ field: 'id', sort: 'asc' }])
                        .select();
                    vm.company.invoiceSeries = vm.invoiceSeries;
                    getInvoiceSerieDocumentTypeName(vm.company.invoiceSeries);
                }, function (errResponse) {
                    $log.debug(errResponse);
                });
            }
        }

        function getWarehouses() {
            if (vm.company && vm.company.id) {
                var parameters = { 'id': 'byCompanyAndEstablishmentsOrCompanyOrEstablishment', 'idCircle': $rootScope.bsCircle.id, 'page': 1, 'pageSize': 100, 'companyId': vm.company.id };
                api.GeneralWS.CompanyWarehouse.me.page(parameters).$promise.then(function (response) {
                    vm.warehouses = response;
                    vm.warehousesGrid.api.setColumnDefs(columnDefs);
                    vm.warehousesGrid.api.setRowData(vm.warehouses.content);
                }, function (response) {
                    $log.error(response);
                });
            }
        }

        function addWarehouse(warehouse) {
            var isNew = true;
            if (!warehouse) {
                warehouse = {
                    'whsCode': '',
                    'whsName': '',
                    'active': true,
                    'company': vm.company,
                    'companyEstablishment': { company: vm.company }
                };
            } else {
                isNew = false;
                warehouse.companyEstablishment = { company: vm.company };
            }
            $mdDialog.show({
                controller: 'WarehouseProviderController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/warehouses/warehouse/warehouse.html',
                parent: angular.element("#main"),
                clickOutsideToClose: false,
                locals: {
                    'warehouse': warehouse
                }
            }).then(function (answer) {
                if (answer) {
                    getWarehouses();
                }
                if (isNew) {
                    MessageService.show($filter('translate')('company_warehouse.aggregate'));
                } else {
                    MessageService.show($filter('translate')('company_warehouse.updated'));
                }
            }, function () {

            });
        }

        function onDelete(warehouse) {
            var promise;
            warehouse.active = false;
            promise = api.GeneralWS.CompanyWarehouse.me.update({ idCircle: $rootScope.bsCircle.id, id: warehouse.id }, warehouse).$promise;
            vm.isShowProgressLinear = true;
            promise.then(function (response) {
                vm.isShowProgressLinear = false;
                MessageService.show($filter('translate')('company_warehouse.deactivated'));
                getWarehouses();
            }, function (response) {
                vm.isShowProgressLinear = false;
                $log.error(response);
                MessageService.showErrorMessage($filter('translate')('general.general_error'));
            });
        }

        // Personas de contacto
        function getCompanyContacts() {
            vm.loading = true;
            api.GeneralWS.CompanyContact.byCompany.getList({ 'companyId': vm.company.id })
                .$promise.then(function (companyContacts) {
                    if (companyContacts.length > 0) {
                        vm.companyContact = companyContacts[0];
                    }
                    vm.companyContacts = companyContacts;
                    vm.contactsGrid.api.setRowData(companyContacts);
                    vm.loading = false;
                }, function (errCompanyContacts) {
                    $log.error(errCompanyContacts);
                    vm.loading = false;
                })
        }

        function addContact(data) {
            let isNew = false;
            if (data) {
                data.companyId = vm.company.id;
            } else {
                isNew = true;
                data = {
                    companyId: vm.company.id,
                    address: vm.company.address
                }
            }

            $mdDialog.show({
                controller: 'CompanyContactController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/company-contact/contact/contact.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'contact': angular.copy(data),
                },
            }).then(function (answer) {
                if (isNew) {
                    vm.companyContacts.push(answer);
                    MessageService.show($filter('translate')('CONTACTS.added'));
                } else {
                    const i = vm.companyContacts.indexOf(data);
                    vm.companyContacts[i] = answer;
                    MessageService.show($filter('translate')('CONTACTS.updated'));
                }
                vm.contactsGrid.api.setRowData(vm.companyContacts);
                vm.contactsGrid.api.redrawRows();
            }, function () {
                // Empty
            });
        }

        function onDeleteContact(data) {
            const confirm = $mdDialog.confirm()
                .title($filter('translate')('CONTACTS.deactivateCompanyContact'))
                .textContent($filter('translate')('CONTACTS.deactivateConfirm'))
                .ariaLabel($filter('translate')('CONTACTS.deactivateCompanyContact'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.CompanyContact.byCompanyActive.delete({
                    'id': data.id,
                }).$promise.then(function () {
                    const i = vm.companyContacts.indexOf(data);
                    data.active = false;
                    vm.companyContacts[i] = data;
                    vm.contactsGrid.api.setRowData(vm.companyContacts);
                    vm.contactsGrid.api.redrawRows();
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('CONTACTS.deleted'));
                }, function (response) {
                    const j = vm.companyContacts.indexOf(data);
                    vm.companyContacts[j].active = true;
                    vm.contactsGrid.api.setRowData(vm.companyContacts);
                    vm.contactsGrid.api.redrawRows();
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                    if (response.status === NOT_ACCEPTABLE_NUMBER) {
                        MessageService.showErrorMessage($filter('translate')('CONTACTS.REQUIRED_COMPANY_CONTACT'));
                    } else {
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    }
                });
            }, function () {
                // Empty
            });
        }

        // Cuentas bancarias
        function getBankAccounts() {
            vm.loading = true;
            api.GeneralWS.BankAccount.BankAccount.get({
                'company': vm.company.id, 'search': ''
            }).$promise.then(function (bankAccounts) {
                if (bankAccounts.length > 0) {
                    vm.bankAccount = _.find(bankAccounts, function (bank) {
                        return bank.isDefault === true;
                    });
                    if (vm.bankAccount === undefined) {
                        vm.bankAccount = null;
                    }
                }
                vm.bankAccounts = bankAccounts;
                vm.bankAccountGrid.api.setRowData(bankAccounts);
                vm.loading = false;
            }, function (response) {
                vm.loading = false;
                $log.error(response);
            });
        }

        function addBankAccount(data) {
            let isNew = false;
            if (data == null) {
                isNew = true;
                data = {
                    id: 0,
                    company: { id: vm.company.id }
                }
            }
            let firstBankAccount = true;
            if (vm.bankAccount !== null && vm.bankAccount.id !== undefined) {
                firstBankAccount = false;
            }

            $mdDialog.show({
                controller: 'BankController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/company/tabs/bank-account/bank/bank.html',
                parent: angular.element('#main'),
                clickOutsideToClose: false,
                locals: {
                    'firstAccount': firstBankAccount,
                    'bankAccount': angular.copy(data),
                    'company': vm.company
                },
            }).then(function (answer) {
                if (isNew) {
                    vm.bankAccounts.push(answer);
                    MessageService.show($filter('translate')('BANKACCOUNT.added'));
                } else {
                    const i = vm.bankAccounts.indexOf(data);
                    vm.bankAccounts[i] = answer;
                    MessageService.show($filter('translate')('BANKACCOUNT.updated'));
                }
                if (vm.bankAccount !== null && vm.bankAccount.id !== undefined) {
                    const j = vm.bankAccounts.indexOf(vm.bankAccount);
                    if (answer.id !== vm.bankAccount.id && answer.isDefault === true) {
                        vm.bankAccounts[j].isDefault = false;
                    }
                } else {
                    vm.bankAccount = answer;
                }
                vm.bankAccountGrid.api.setRowData(vm.bankAccounts);
                vm.bankAccountGrid.api.redrawRows();
            }, function () {
                // Empty
            });
        }

        function onDeleteBankAccount(data) {
            const confirm = $mdDialog.confirm()
                .title($filter('translate')('BANKACCOUNT.deactivateConfirmBankAccount'))
                .textContent($filter('translate')('BANKACCOUNT.deactivateConfirm'))
                .ariaLabel($filter('translate')('BANKACCOUNT.deactivateConfirmBankAccount'))
                .ok($filter('translate')('general.si'))
                .cancel($filter('translate')('general.no'));

            $mdDialog.show(confirm).then(function () {
                vm.isShowProgressLinear = true;
                api.GeneralWS.BankAccount.BankAccount.delete({
                    'id': data.id,
                    'company': vm.company.id,
                }).$promise.then(function () {
                    const i = vm.bankAccounts.indexOf(data);
                    data.active = false;
                    vm.bankAccounts[i] = data;
                    vm.bankAccountGrid.api.setRowData(vm.bankAccounts);
                    vm.bankAccountGrid.api.redrawRows();
                    vm.isShowProgressLinear = false;
                    MessageService.show($filter('translate')('BANKACCOUNT.deleted'));
                }, function (response) {
                    const k = vm.bankAccounts.indexOf(data);
                    vm.bankAccounts[k].active = true;
                    vm.bankAccountGrid.api.setRowData(vm.bankAccounts);
                    vm.bankAccountGrid.api.redrawRows();
                    if (response.status === NOT_ACCEPTABLE_NUMBER) {
                        MessageService.showErrorMessage($filter('translate')('BANKACCOUNT.REQUIRED_BANK_ACCOUNT'));
                    } else {
                        MessageService.showErrorMessage($filter('translate')('general.general_error'));
                    }
                    vm.isShowProgressLinear = false;
                    $log.error(response);
                });
            }, function () {
                // Empty
            });
        }

        function onChangeCountry() {
            //Bancos
            api.GeneralWS.Bank.byCountry.get({ 'country': vm.company.country.id },
                function (response) {
                    vm.banks = response;
                    vm.isShowProgressLinear = false;
                }, function (errResponse) {
                    $log.error(errResponse);
                });
            getCompanyTypeList(vm.company.country.id);
            getCompanyCategoryList(vm.company.country.id);
            getInvoiceSeriesDocumentCountryList(vm.company.country.id);
        }

        // Validar si empresa es proveedor de otra
        function validateAsProvider() {
            vm.loading = true;
            api.GeneralWS.CompanyProvider.validateAsProvider.validate({
                'companyId': 0,
                'providerId': vm.company.id,
            }).$promise.then(function (resp) {
                vm.asProvider = resp.$data;
                vm.loading = false;
            }, function (err) {
                $log.error(err);
                vm.loading = false;
            });
        }

        function getCompanyApplicationOp2() {
          if (circle && circle.company) {
            api.GeneralWS.CompanyApplication.byAppName.get({ 'company': circle.company.id, 'app': 'Operaciones2' }).$promise.then(function (responseApp) {
              const statusNumberOk = 200;
              if (responseApp.$status === statusNumberOk) {
                vm.appOperaciones2Active = responseApp.$data && responseApp.$data !== '';
              }
            }, function (response) {
                $log.error(response);
            });
          }
        }

        function getOperaciones2Warehouses() {
          api.Operaciones2ConfigWS.Warehouse.allActive.get({}).$promise.then(function (warehouses) {
              vm.operaciones2Warehouses = warehouses;
          }, function (response) {
              $log.error(response);
          });
        }

        function selectOperaciones2Warehouse(warehouseIdParam) {
          if (vm.loading || vm.company.warehouseOperacionesId === warehouseIdParam) {
            return;
          }
          vm.loading = true;
          api.GeneralWS.CompanyApi.updateWarehouseOperacoinesId.update({'id': vm.company.id, 'warehouseId': warehouseIdParam})
          .$promise.then(function () {
            vm.company.warehouseOperacionesId = warehouseIdParam;
            getCompanyEstablishmentsByCompany();
          }, function () {
            vm.loading = false;
            MessageService.showErrorMessage($filter('translate')('general.general_error'));
          });
        }

        function getCompanyEstablishmentsByCompany() {
          api.GeneralWS.CompanyEstablishment.findAllByCompanyIds.get({ 'companyIds': [vm.company.id] })
          .$promise.then(function (establishments) {
            const establishmentIds = establishments.map(function (row) {
              return row.id;
            });
            createOperaciones2WarehouseEstablishment(establishmentIds);
          }, function () {
            vm.loading = false;
            MessageService.showErrorMessage($filter('translate')
            ('OPERACIONES2.WAREHOUSE.ERROR.CREATE_WAREHOUSE_ESTABLISHMENTS'));
          });
        }

        function createOperaciones2WarehouseEstablishment(establishments) {
          api.Operaciones2ConfigWS.WarehouseEstablishment.me
          .create({ 'warehouseId': vm.company.warehouseOperacionesId }, establishments)
          .$promise.then(function () {
            vm.loading = false;
            MessageService.show($filter('translate')
            ('OPERACIONES2.WAREHOUSE.MESSAGE.WAREHOUSE_ASSOCIATED_SUCCESSFULLY'));
          }, function () {
            vm.loading = false;
            MessageService.showErrorMessage($filter('translate')
            ('OPERACIONES2.WAREHOUSE.MESSAGE.CREATE_WAREHOUSE_ESTABLISHMENTS_ERROR'));
          });
        }

        $scope.$watch('vm.company.address', function () {
            if (!vm.editMode) {
                return;
            }
            if ((vm.company != null && vm.company != undefined && vm.company.address !== null && vm.company.address != undefined)
                && (vm.companyContact == null || vm.companyContact === undefined || vm.companyContact.id === undefined)) {
                let contactAddress = vm.company.address;
                if (vm.company.address.length > STRING_SIZE_100) {
                    contactAddress = angular.copy(vm.company.address).substring(0, STRING_SIZE_99);
                }
                vm.companyContact = {
                    address: contactAddress,
                }
            }
        });
    }
})();

(function () {

    'use strict';

    angular
            .module('app.core')
            .service('MessageService', function ($mdToast) {

                var service = this;

                service.show = function (message) {

                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content">{{\'' + message + '\'| translate}}</div></md-toast>',
                        hideDelay: 7000,
                        position: 'top right'
                    });

                };

                service.showErrorMessage = function (message) {
                    $mdToast.show({
                        template: '<md-toast layout="column" layout-align="center start"><div class="md-toast-content" style="background-color: red">{{\'' + message + '\'| translate}}</div></md-toast>',
                        hideDelay: 5000,
                        position: 'top right'
                    });
                };

            });

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {

    'use strict';

    angular
            .module('app.core')
            .filter('topCharactersHtml', topCharactersHtml);

    /**@ngInject**/
    function topCharactersHtml($log) {

        return function (htmlMessage, topNumber) {
            
            var a = document.createElement('div');
            
            a.innerHTML = htmlMessage;
            
            var elements = angular.element(a);
            var plainText = "";

            for (var i = 0; i < elements.length; i++) {
                plainText += (elements[i].innerText || elements[i].textContent) + " ";

                if (plainText.length > topNumber) {
                    break;
                }
            }

            plainText = plainText.split("\n").join(" ");
            plainText = plainText.substring(0, topNumber);

            return plainText;

        };

    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .filter('sumOfValue', sumOfValue)
            .filter('totalSumPriceQty', totalSumPriceQty);

    /** @ngInject */
    function sumOfValue($filter)
    {
        return function (data, key, decimals) {
            if (angular.isUndefined(data) || angular.isUndefined(key))
                return 0;
            var sum = 0;
            var field = key.split(".");
            angular.forEach(data, function (value) {
                var val = value;
                field.forEach(function (f) {
                    if (val) {
                        val = val[f];
                    }
                });
                sum = sum + parseFloat(val ? val : 0, 10);
            });
            if (decimals) {
                return $filter('number')(sum, decimals);
            }
            return sum;
        };
    }

    /** @ngInject */
    function totalSumPriceQty()
    {
        return function (data, key1, key2) {
            if (angular.isUndefined(data) || angular.isUndefined(key1) || angular.isUndefined(key2))
                return 0;
            var sum = 0;
            angular.forEach(data, function (value) {
                sum = sum + (parseInt(value[key1], 10) * parseInt(value[key2], 10));
            });
            return sum;
        }
    }

})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .filter('flipdate', flipdate);

    /** @ngInject */
    function flipdate($filter)
    {
        return function (input, format)
        {
            if (input === null) {
                return "";
            }

            var _date = $filter('date')(new Date(input + ' 00:00:00'), format);

            return _date;
        };
    }

})();
(function () {

    'use strict';

    angular
            .module('app.core')
            .filter('apiDate', apiDate);

    /**@ngInject**/
    function apiDate($filter, $log) {

        return function (dateObject, format) {
            var date = new Date(dateObject.year, dateObject.monthValue - 1, dateObject.dayOfMonth, dateObject.hour, dateObject.minute, dateObject.second);
            var currentDate = new Date();
            
            var yesterdayDate = new Date();
            yesterdayDate.setDate(yesterdayDate.getDate() - 1);
            
            var isToday = (dateObject.year === currentDate.getFullYear() && dateObject.monthValue === (currentDate.getMonth() + 1) && dateObject.dayOfMonth === currentDate.getDate());
            var isYesterday = (dateObject.year === currentDate.getFullYear() && dateObject.monthValue === (currentDate.getMonth() + 1) && dateObject.dayOfMonth === yesterdayDate.getDate());;
            
            if (isToday) {
                return $filter('translate')('general.today') + ' ' + $filter('date')(date, 'HH:mm');
            } else if(isYesterday) {
                return $filter('translate')('general.yesterday') + ' ' + $filter('date')(date, 'HH:mm');
            } else {
                return $filter('date')(date, format);
            }

        };

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('ngFallback', ngFallback);

    /** @ngInject */
    function ngFallback()
    {
        return{
            link: function postLink(scope, element, attrs) {
                element.bind('error', function () {
                    angular.element(this).attr("src", attrs.ngFallback);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .controller('MsStepperController', MsStepperController)
            .directive('msHorizontalStepper', msHorizontalStepperDirective)
            .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
            .directive('msVerticalStepper', msVerticalStepperDirective)
            .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout, $scope)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;
        vm.stepSubmitToo;
        vm.validChange;

        // Methods
        vm.setStepSubmitToo = setStepSubmitToo;
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;
        vm.setValidChange = setValidChange;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;
        vm.isFormDirty = isFormDirty;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Set the orientation of the stepper
         *
         * @param step
         */
        function setStepSubmitToo(step)
        {
            vm.stepSubmitToo = step || null;
        }

        /**
         * Set the orientation of the stepper
         *
         * @param field
         */
        function setValidChange(field)
        {
            vm.validChange = field || null;
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element: element,
                scope: scope,
                form: form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle: scope.stepTitle
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            var isReset = true;
            if (vm.stepSubmitToo && vm.currentStepNumber === vm.stepSubmitToo) {
                isReset = false;
            }

            $timeout(function ()
            {
                // Reset all the steps
                for (var x = 0; x < vm.steps.length; x++)
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                if (isReset) {
                    gotoFirstStep();
                } else {
                    if (vm.validChange) {
                        $scope.$watch('vm.model.' + vm.validChange, function (newVal) {
                            if (newVal) {
                                gotoNextStep();
                            }
                        });
                    }
                }
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            $("#step" + stepNumber).scrollTop();
            if (!isStepNumberValid(stepNumber))
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if (vm.orientation === 'horizontal')
            {
                // Hide all steps
                for (var i = 0; i < vm.steps.length; i++)
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            } else if (vm.orientation === 'vertical')
            {
                // Hide all step content
                for (var j = 0; j < vm.steps.length; j++)
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if (isStepHidden(stepNumber))
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s >= 1; s--)
            {
                if (!isStepHidden(s))
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s <= vm.steps.length; s++)
            {
                if (!isStepHidden(s))
                {
                    stepNumber = s;
                    break;
                }
            }
            vm.setCurrentStep(stepNumber);
            $("#step" + (stepNumber - 1)).scrollTop();
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            if (vm.stepSubmitToo && vm.currentStepNumber === vm.stepSubmitToo && isFormDirty()) {
                return true;
            }
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            var disabled = false;

            for (var i = 1; i < stepNumber; i++)
            {
                if (!isStepValid(i))
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber))
            {
                return null;
            }

            // If the step is optional, always return true
            if (isStepOptional(stepNumber))
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }

        /**
         * Check if the entire form is dirty
         *
         * @returns {boolean}
         */
        function isFormDirty()
        {
            return vm.mainForm.$dirty;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict: 'A',
            scope: {
                stepSubmitToo: '=?',
                validChange: '=?'
            },
            require: ['form', 'msHorizontalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    MsStepperCtrl.nextDescriptionButton = iAttrs.nextButtonDescription ? iAttrs.nextButtonDescription : "NEXT";
                    MsStepperCtrl.backDescriptionButton = iAttrs.backButtonDescription ? iAttrs.backButtonDescription : "BACK";
                    MsStepperCtrl.submitDescriptionButton = iAttrs.submitButtonDescription ? iAttrs.submitButtonDescription : "SUBMIT";
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.setStepSubmitToo(scope.stepSubmitToo);
                    MsStepperCtrl.setValidChange(scope.validChange);
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require: ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict: 'A',
            scope: {
                stepSubmitToo: '=?',
                validChange: '=?',
                msScopeStepper: '=?'
            },
            require: ['form', 'msVerticalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.nextDescriptionButton = iAttrs.nextButtonDescription ? iAttrs.nextButtonDescription : "NEXT";
                        MsStepperCtrl.backDescriptionButton = iAttrs.backButtonDescription ? iAttrs.backButtonDescription : "BACK";
                        MsStepperCtrl.submitDescriptionButton = iAttrs.submitButtonDescription ? iAttrs.submitButtonDescription : "SUBMIT";
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setValidChange(scope.validChange);
                        MsStepperCtrl.setStepSubmitToo(scope.stepSubmitToo);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require: ['form', '^msVerticalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile: function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                            MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($log, $rootScope, api, $scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;
        
        vm.userParameterName = "USER_SHORTCUTS";

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            
            var shortcuts = angular.fromJson($rootScope.getUserParameterValueByName(vm.userParameterName, true));
            
            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) || shortcuts === null )
            {
                shortcuts = [];
                
                $rootScope.createUserParameter(vm.userParameterName, angular.toJson(shortcuts), true);
                
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            
            $rootScope.updateUserParameterValue(vm.userParameterName, angular.toJson(vm.shortcuts), true);
            
            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;
            
            delete item.createdAt;
            delete item.modifiedAt;
            delete item.application;
            
            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.validateItemShow = validateItemShow;
        vm.openIsExternal = openIsExternal;
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Open When is External
         */
        function openIsExternal(item)
        {
            window.open(item.uisref, "_blank");
        }

        function validateItemShow(item, showExternal) 
        {
            var isExternal = item.uisref.toString().startsWith('http');
            if (showExternal) {
                return isExternal;
            } else {
                return !isExternal;
            }
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
/**
 * md-color-picker - Angular-Material inspired color picker.
 * @version v0.2.6
 * @link https://github.com/brianpkelley/md-color-picker
 * @license MIT
 */
; (function (angular, window, tinycolor) {

	(function (window, angular, undefined) {
		'use strict';
		var dateClick;

		var GradientCanvas = function (type, restrictX) {

			this.type = type;
			this.restrictX = restrictX;
			this.offset = {
				x: null,
				y: null
			};
			this.height = 255;

			this.$scope = null;
			this.$element = null;

			this.get = angular.bind(this, function ($temp_scope, $temp_element, $temp_attrs) {
				////////////////////////////
				// Variables
				////////////////////////////

				this.$scope = $temp_scope;
				this.$element = $temp_element;


				this.canvas = this.$element.children()[0];
				this.marker = this.$element.children()[1];
				this.context = this.canvas.getContext('2d');
				this.currentColor = this.$scope.color.toRgb();
				this.currentHue = this.$scope.color.toHsv().h;
				////////////////////////////
				// Watchers, Observes, Events
				////////////////////////////

				//$scope.$watch( function() { return color.getRgb(); }, hslObserver, true );



				this.$element.on('mousedown', angular.bind(this, this.onMouseDown));
				this.$scope.$on('mdColorPicker:colorSet', angular.bind(this, this.onColorSet));
				if (this.extra) {
					this.extra();
				};
				////////////////////////////
				// init
				////////////////////////////

				this.draw();
			});

			//return angular.bind( this, this.get );

		};
		GradientCanvas.prototype.$window = angular.element(window);

		GradientCanvas.prototype.getColorByMouse = function (e) {
			var x = e.pageX - this.offset.x;
			var y = e.pageY - this.offset.y;

			return this.getColorByPoint(x, y);
		};

		GradientCanvas.prototype.setMarkerCenter = function (x, y) {
			var xOffset = -1 * this.marker.offsetWidth / 2;
			var yOffset = -1 * this.marker.offsetHeight / 2;
			if (y === undefined) {
				y = x + yOffset;
				y = Math.max(Math.min(this.height - 1 + yOffset, y), Math.ceil(yOffset));

				x = 0;
			} else {
				x = x + xOffset;
				y = y + yOffset;

				x = Math.max(Math.min(this.height + xOffset, x), Math.ceil(xOffset));
				y = Math.max(Math.min(this.height + yOffset, y), Math.ceil(yOffset));
			}



			angular.element(this.marker).css({ 'left': x + 'px' });
			angular.element(this.marker).css({ 'top': y + 'px' });
		};

		GradientCanvas.prototype.getMarkerCenter = function () {
			var returnObj = {
				x: this.marker.offsetLeft + (Math.floor(this.marker.offsetWidth / 2)),
				y: this.marker.offsetTop + (Math.floor(this.marker.offsetHeight / 2))
			};
			return returnObj;
		};

		GradientCanvas.prototype.getImageData = function (x, y) {
			x = Math.max(0, Math.min(x, this.canvas.width - 1));
			y = Math.max(0, Math.min(y, this.canvas.height - 1));

			var imageData = this.context.getImageData(x, y, 1, 1).data;
			return imageData;
		};

		GradientCanvas.prototype.onMouseDown = function (e) {
			// Prevent highlighting
			e.preventDefault();
			e.stopImmediatePropagation();

			this.$scope.previewUnfocus();

			this.$element.css({ 'cursor': 'none' });

			this.offset.x = this.canvas.getBoundingClientRect().left + 1;
			this.offset.y = this.canvas.getBoundingClientRect().top;

			var fn = angular.bind(this, function (e) {
				switch (this.type) {
					case 'hue':
						var hue = this.getColorByMouse(e);
						this.$scope.$broadcast('mdColorPicker:spectrumHueChange', { hue: hue });
						break;
					case 'alpha':
						var alpha = this.getColorByMouse(e);
						this.$scope.color.setAlpha(alpha);
						this.$scope.alpha = alpha;
						this.$scope.$apply();
						break;
					case 'spectrum':
						var color = this.getColorByMouse(e);
						this.setColor(color);
						break;
				}
			});

			this.$window.on('mousemove', fn);
			this.$window.one('mouseup', angular.bind(this, function (e) {
				this.$window.off('mousemove', fn);
				this.$element.css({ 'cursor': 'crosshair' });
			}));

			// Set the color
			fn(e);
		};

		GradientCanvas.prototype.setColor = function (color) {

			this.$scope.color._r = color.r;
			this.$scope.color._g = color.g;
			this.$scope.color._b = color.b;
			this.$scope.$apply();
			this.$scope.$broadcast('mdColorPicker:spectrumColorChange', { color: color });
		};

		GradientCanvas.prototype.onColorSet = function (e, args) {
			switch (this.type) {
				case 'hue':
					var hsv = this.$scope.color.toHsv();
					this.setMarkerCenter(this.canvas.height - (this.canvas.height * (hsv.h / 360)));
					break;
				case 'alpha':
					this.currentColor = args.color.toRgb();
					this.draw();

					var alpha = args.color.getAlpha();
					var pos = this.canvas.height - (this.canvas.height * alpha);

					this.setMarkerCenter(pos);
					break;
				case 'spectrum':
					var hsv = args.color.toHsv();
					this.currentHue = hsv.h;
					this.draw();

					var posX = this.canvas.width * hsv.s;
					var posY = this.canvas.height - (this.canvas.height * hsv.v);

					this.setMarkerCenter(posX, posY);
					break;
			}

		};

		var hueLinkFn = new GradientCanvas('hue', true);
		hueLinkFn.getColorByPoint = function (x, y) {
			var imageData = this.getImageData(x, y);
			this.setMarkerCenter(y);

			var hsl = new tinycolor({ r: imageData[0], g: imageData[1], b: imageData[2] });
			return hsl.toHsl().h;

		};
		hueLinkFn.draw = function () {


			this.$element.css({ 'height': this.height + 'px' });

			this.canvas.height = this.height;
			this.canvas.width = this.height;



			// Create gradient
			var hueGrd = this.context.createLinearGradient(90, 0.000, 90, this.height);

			// Add colors
			hueGrd.addColorStop(0.01, 'rgba(255, 0, 0, 1.000)');
			hueGrd.addColorStop(0.167, 'rgba(255, 0, 255, 1.000)');
			hueGrd.addColorStop(0.333, 'rgba(0, 0, 255, 1.000)');
			hueGrd.addColorStop(0.500, 'rgba(0, 255, 255, 1.000)');
			hueGrd.addColorStop(0.666, 'rgba(0, 255, 0, 1.000)');
			hueGrd.addColorStop(0.828, 'rgba(255, 255, 0, 1.000)');
			hueGrd.addColorStop(0.999, 'rgba(255, 0, 0, 1.000)');

			// Fill with gradient
			this.context.fillStyle = hueGrd;
			this.context.fillRect(0, 0, this.canvas.width, this.height);
		};


		var alphaLinkFn = new GradientCanvas('alpha', true);
		alphaLinkFn.getColorByPoint = function (x, y) {
			var imageData = this.getImageData(x, y);
			this.setMarkerCenter(y);

			return imageData[3] / 255;
		};
		alphaLinkFn.draw = function () {
			this.$element.css({ 'height': this.height + 'px' });

			this.canvas.height = this.height;
			this.canvas.width = this.height;

			// Create gradient
			var hueGrd = this.context.createLinearGradient(90, 0.000, 90, this.height);

			// Add colors
			hueGrd.addColorStop(0.01, 'rgba(' + this.currentColor.r + ',' + this.currentColor.g + ',' + this.currentColor.b + ', 1.000)');
			hueGrd.addColorStop(0.999, 'rgba(' + this.currentColor.r + ',' + this.currentColor.g + ',' + this.currentColor.b + ', 0.000)');

			// Fill with gradient
			this.context.fillStyle = hueGrd;
			this.context.fillRect(0, 0, this.canvas.width, this.height);
		};
		alphaLinkFn.extra = function () {
			this.$scope.$on('mdColorPicker:spectrumColorChange', angular.bind(this, function (e, args) {
				this.currentColor = args.color;
				this.draw();
			}));
		};


		var spectrumLinkFn = new GradientCanvas('spectrum', false);
		spectrumLinkFn.getColorByPoint = function (x, y) {
			var imageData = this.getImageData(x, y);
			this.setMarkerCenter(x, y);

			return {
				r: imageData[0],
				g: imageData[1],
				b: imageData[2]
			};
		};
		spectrumLinkFn.draw = function () {
			this.canvas.height = this.height;
			this.canvas.width = this.height;
			this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
			// White gradient

			var whiteGrd = this.context.createLinearGradient(0, 0, this.canvas.width, 0);

			whiteGrd.addColorStop(0, 'rgba(255, 255, 255, 1.000)');
			whiteGrd.addColorStop(1, 'rgba(255, 255, 255, 0.000)');

			// Black Gradient
			var blackGrd = this.context.createLinearGradient(0, 0, 0, this.canvas.height);

			blackGrd.addColorStop(0, 'rgba(0, 0, 0, 0.000)');
			blackGrd.addColorStop(1, 'rgba(0, 0, 0, 1.000)');

			// Fill with solid
			this.context.fillStyle = 'hsl( ' + this.currentHue + ', 100%, 50%)';
			this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);

			// Fill with white
			this.context.fillStyle = whiteGrd;
			this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);

			// Fill with black
			this.context.fillStyle = blackGrd;
			this.context.fillRect(0, 0, this.canvas.width, this.canvas.height);
		};
		spectrumLinkFn.extra = function () {
			this.$scope.$on('mdColorPicker:spectrumHueChange', angular.bind(this, function (e, args) {
				this.currentHue = args.hue;
				this.draw();
				var markerPos = this.getMarkerCenter();
				var color = this.getColorByPoint(markerPos.x, markerPos.y);
				this.setColor(color);

			}));
		};


		angular.module('mdColorPicker', [])
			.run(['$templateCache', function ($templateCache) {
				//icon resource should not be dependent
				//credit to materialdesignicons.com
				var shapes = {
					'clear': '<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>',
					'gradient': '<path d="M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"/>',
					'tune': '<path d="M13 21v-2h8v-2h-8v-2h-2v6h2zM3 17v2h6v-2H3z"/><path d="M21 13v-2H11v2h10zM7 9v2H3v2h4v2h2V9H7z"/><path d="M15 9h2V7h4V5h-4V3h-2v6zM3 5v2h10V5H3z"/>',
					'view_module': '<path d="M4 11h5V5H4v6z"/><path d="M4 18h5v-6H4v6z"/><path d="M10 18h5v-6h-5v6z"/><path d="M16 18h5v-6h-5v6z"/><path d="M10 11h5V5h-5v6z"/><path d="M16 5v6h5V5h-5z"/>',
					'view_headline': '<path d="M4 15h17v-2H4v2z"/><path d="M4 19h17v-2H4v2z"/><path d="M4 11h17V9H4v2z"/><path d="M4 5v2h17V5H4z"/>',
					'history': '<path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"/><path d="M12 8v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>',
					'clear_all': '<path d="M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"/>'
				};
				for (var i in shapes) {
					if (shapes.hasOwnProperty(i)) {
						$templateCache.put([i, 'svg'].join('.'),
							['<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">', shapes[i], '</svg>'].join(''));
					}
				}
			}])
			.factory('mdColorPickerHistory', ['$injector', function ($injector) {

				var history = [];
				var strHistory = [];

				var $cookies = false;
				try {
					$cookies = $injector.get('$cookies');
				} catch (e) {

				}

				if ($cookies) {
					var tmpHistory = $cookies.getObject('mdColorPickerHistory') || [];
					for (var i = 0; i < tmpHistory.length; i++) {
						history.push(tinycolor(tmpHistory[i]));
						strHistory.push(tmpHistory[i]);
					}
				}

				var length = 40;

				return {
					length: function () {
						if (arguments[0]) {
							length = arguments[0];
						} else {
							return history.length;
						}
					},
					add: function (color) {
						for (var x = 0; x < history.length; x++) {
							if (history[x].toRgbString() === color.toRgbString()) {
								history.splice(x, 1);
								strHistory.splice(x, 1);
							}
						}

						history.unshift(color);
						strHistory.unshift(color.toRgbString());

						if (history.length > length) {
							history.pop();
							strHistory.pop();
						}
						if ($cookies) {
							$cookies.putObject('mdColorPickerHistory', strHistory);
						}
					},
					get: function () {
						return history;
					},
					reset: function () {
						history = [];
						strHistory = [];
						if ($cookies) {
							$cookies.putObject('mdColorPickerHistory', strHistory);
						}
					}
				};
			}])
			.directive('mdColorPicker', ['$timeout', 'mdColorPickerHistory', function ($timeout, colorHistory) {

				return {
					templateUrl: "mdColorPicker.tpl.html",

					// Added required controller ngModel
					require: '^ngModel',
					scope: {
						options: '=mdColorPicker',

						// Input options
						type: '@',
						label: '@',
						icon: '@',
						random: '@',
						default: '@',

						// Dialog Options
						openOnInput: '@',
						hasBackdrop: '@',
						clickOutsideToClose: '@',
						skipHide: '@',
						parent: '@',
						preserveScope: '@',

						// Advanced options
						mdColorClearButton: '=?',
						mdColorPreview: '=?',

						mdColorAlphaChannel: '=?',
						mdColorSpectrum: '=?',
						mdColorSliders: '=?',
						mdColorGenericPalette: '=?',
						mdColorMaterialPalette: '=?',
						mdColorHistory: '=?',
						mdColorDefaultTab: '=?'
					},
					controller: ['$scope', '$element', '$attrs', '$mdDialog', '$mdColorPicker', function ($scope, $element, $attrs, $mdDialog, $mdColorPicker) {
						var didJustClose = false;

						// Merge Options Object with scope.  Scope will take precedence much like css vs style attribute.
						if ($scope.options !== undefined) {
							for (var opt in $scope.options) {
								if ($scope.options.hasOwnProperty(opt)) {
									var scopeVal = undefined;
									var scopeKey = undefined;
									if ($scope.hasOwnProperty(opt)) {
										scopeKey = opt;
									} else if ($scope.hasOwnProperty('mdColor' + opt.slice(0, 1).toUpperCase() + opt.slice(1))) {
										scopeKey = 'mdColor' + opt.slice(0, 1).toUpperCase() + opt.slice(1);
									}

									if (scopeKey && $scope[scopeKey] === undefined) {
										$scope[scopeKey] = $scope.options[opt];
									}
								}
							}
						}

						// Get ngModelController from the current element
						var ngModel = $element.controller('ngModel');

						// Quick function for updating the local 'value' on scope
						var updateValue = function (val) {
							$scope.value = val || ngModel.$viewValue || '';
						};

						// Defaults
						// Everything is enabled by default.
						$scope.mdColorClearButton = $scope.mdColorClearButton === undefined ? true : $scope.mdColorClearButton;
						$scope.mdColorPreview = $scope.mdColorPreview === undefined ? true : $scope.mdColorPreview;

						$scope.mdColorAlphaChannel = $scope.mdColorAlphaChannel === undefined ? true : $scope.mdColorAlphaChannel;
						$scope.mdColorSpectrum = $scope.mdColorSpectrum === undefined ? true : $scope.mdColorSpectrum;
						$scope.mdColorSliders = $scope.mdColorSliders === undefined ? true : $scope.mdColorSliders;
						$scope.mdColorGenericPalette = $scope.mdColorGenericPalette === undefined ? true : $scope.mdColorGenericPalette;
						$scope.mdColorMaterialPalette = $scope.mdColorMaterialPalette === undefined ? true : $scope.mdColorMaterialPalette;
						$scope.mdColorHistory = $scope.mdColorHistory === undefined ? true : $scope.mdColorHistory;


						// Set the starting value
						updateValue();

						// Keep an eye on changes
						$scope.$watch(function () {
							return ngModel.$modelValue;
						}, function (newVal) {
							updateValue(newVal);
						});

						// Watch for updates to value and set them on the model
						$scope.$watch('value', function (newVal, oldVal) {
							if (newVal !== '' && typeof newVal !== 'undefined' && newVal && newVal !== oldVal) {
								ngModel.$setViewValue(newVal);
							}
						});

						// The only other ngModel changes

						$scope.clearValue = function clearValue() {
							$scope.value = '';
						};
						$scope.showColorPicker = function showColorPicker($event) {
							if (didJustClose) {
								return;
							}
							//	dateClick = Date.now();
							//	console.log( "CLICK OPEN", dateClick, $scope );

							$mdColorPicker.show({
								value: $scope.value,
								defaultValue: $scope.default,
								random: $scope.random,
								clickOutsideToClose: $scope.clickOutsideToClose,
								hasBackdrop: $scope.hasBackdrop,
								multiple: $scope.skipHide,
								parent: $scope.parent,
								preserveScope: $scope.preserveScope,

								mdColorAlphaChannel: $scope.mdColorAlphaChannel,
								mdColorSpectrum: $scope.mdColorSpectrum,
								mdColorSliders: $scope.mdColorSliders,
								mdColorGenericPalette: $scope.mdColorGenericPalette,
								mdColorMaterialPalette: $scope.mdColorMaterialPalette,
								mdColorHistory: $scope.mdColorHistory,
								mdColorDefaultTab: $scope.mdColorDefaultTab,

								$event: $event,

							}).then(function (color) {
								$scope.value = color;
							});
						};
					}],
					compile: function (element, attrs) {

						//attrs.value = attrs.value || "#ff0000";
						attrs.type = attrs.type !== undefined ? attrs.type : 0;

					}
				};
			}])
			.directive('mdColorPickerContainer', ['$compile', '$timeout', '$mdColorPalette', 'mdColorPickerHistory', function ($compile, $timeout, $mdColorPalette, colorHistory) {
				return {
					templateUrl: 'mdColorPickerContainer.tpl.html',
					scope: {
						value: '=?',
						default: '@',
						random: '@',
						ok: '=?',
						mdColorAlphaChannel: '=',
						mdColorSpectrum: '=',
						mdColorSliders: '=',
						mdColorGenericPalette: '=',
						mdColorMaterialPalette: '=',
						mdColorHistory: '=',
						mdColorDefaultTab: '='
					},
					controller: ["$scope", "$element", "$attrs", function ($scope, $element, $attrs) {
						//	console.log( "mdColorPickerContainer Controller", Date.now() - dateClick, $scope );

						function getTabIndex(tab) {
							var index = 0;
							if (tab && typeof (tab) === 'string') {
								/* DOM isn't fast enough for this
								
														var tabs = $element[0].querySelector('.md-color-picker-colors').getElementsByTagName( 'md-tab' );
														console.log( tabs.length );
								*/
								var tabName = 'mdColor' + tab.slice(0, 1).toUpperCase() + tab.slice(1);
								var tabs = ['mdColorSpectrum', 'mdColorSliders', 'mdColorGenericPalette', 'mdColorMaterialPalette', 'mdColorHistory'];
								for (var x = 0; x < tabs.length; x++) {
									//console.log(  tabs[x]('ng-if') );
									//if ( tabs[x].getAttribute('ng-if') == tabName ) {
									if (tabs[x] == tabName) {
										if ($scope[tabName]) {
											index = x;
											break;
										}
									}
								}
							} else if (tab && typeof (tab) === 'number') {
								index = tab;
							}

							return index;
						}

						///////////////////////////////////
						// Variables
						///////////////////////////////////
						var container = angular.element($element[0].querySelector('.md-color-picker-container'));
						var resultSpan = angular.element(container[0].querySelector('.md-color-picker-result'));
						var previewInput = angular.element($element[0].querySelector('.md-color-picker-preview-input'));

						var outputFn = [
							'toHexString',
							'toRgbString',
							'toHslString'
						];



						$scope.default = $scope.default ? $scope.default : $scope.random ? tinycolor.random() : 'rgb(255,255,255)';
						if ($scope.value.search('#') >= 0) {
							$scope.type = 0;
						} else if ($scope.value.search('rgb') >= 0) {
							$scope.type = 1;
						} else if ($scope.value.search('hsl') >= 0) {
							$scope.type = 2;
						}
						$scope.color = new tinycolor($scope.value || $scope.default); // Set initial color
						$scope.alpha = $scope.color.getAlpha();
						$scope.history = colorHistory;
						$scope.materialFamily = [];

						$scope.whichPane = getTabIndex($scope.mdColorDefaultTab);
						$scope.inputFocus = false;

						// Colors for the palette screen
						///////////////////////////////////
						var steps = 9;
						var freq = 2 * Math.PI / steps;

						$scope.palette = [
							["rgb(255, 204, 204)", "rgb(255, 230, 204)", "rgb(255, 255, 204)", "rgb(204, 255, 204)", "rgb(204, 255, 230)", "rgb(204, 255, 255)", "rgb(204, 230, 255)", "rgb(204, 204, 255)", "rgb(230, 204, 255)", "rgb(255, 204, 255)"],
							["rgb(255, 153, 153)", "rgb(255, 204, 153)", "rgb(255, 255, 153)", "rgb(153, 255, 153)", "rgb(153, 255, 204)", "rgb(153, 255, 255)", "rgb(153, 204, 255)", "rgb(153, 153, 255)", "rgb(204, 153, 255)", "rgb(255, 153, 255)"],
							["rgb(255, 102, 102)", "rgb(255, 179, 102)", "rgb(255, 255, 102)", "rgb(102, 255, 102)", "rgb(102, 255, 179)", "rgb(102, 255, 255)", "rgb(102, 179, 255)", "rgb(102, 102, 255)", "rgb(179, 102, 255)", "rgb(255, 102, 255)"],
							["rgb(255, 51, 51)", "rgb(255, 153, 51)", "rgb(255, 255, 51)", "rgb(51, 255, 51)", "rgb(51, 255, 153)", "rgb(51, 255, 255)", "rgb(51, 153, 255)", "rgb(51, 51, 255)", "rgb(153, 51, 255)", "rgb(255, 51, 255)"],
							["rgb(255, 0, 0)", "rgb(255, 128, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)", "rgb(0, 255, 128)", "rgb(0, 255, 255)", "rgb(0, 128, 255)", "rgb(0, 0, 255)", "rgb(128, 0, 255)", "rgb(255, 0, 255)"],
							["rgb(245, 0, 0)", "rgb(245, 123, 0)", "rgb(245, 245, 0)", "rgb(0, 245, 0)", "rgb(0, 245, 123)", "rgb(0, 245, 245)", "rgb(0, 123, 245)", "rgb(0, 0, 245)", "rgb(123, 0, 245)", "rgb(245, 0, 245)"],
							["rgb(214, 0, 0)", "rgb(214, 108, 0)", "rgb(214, 214, 0)", "rgb(0, 214, 0)", "rgb(0, 214, 108)", "rgb(0, 214, 214)", "rgb(0, 108, 214)", "rgb(0, 0, 214)", "rgb(108, 0, 214)", "rgb(214, 0, 214)"],
							["rgb(163, 0, 0)", "rgb(163, 82, 0)", "rgb(163, 163, 0)", "rgb(0, 163, 0)", "rgb(0, 163, 82)", "rgb(0, 163, 163)", "rgb(0, 82, 163)", "rgb(0, 0, 163)", "rgb(82, 0, 163)", "rgb(163, 0, 163)"],
							["rgb(92, 0, 0)", "rgb(92, 46, 0)", "rgb(92, 92, 0)", "rgb(0, 92, 0)", "rgb(0, 92, 46)", "rgb(0, 92, 92)", "rgb(0, 46, 92)", "rgb(0, 0, 92)", "rgb(46, 0, 92)", "rgb(92, 0, 92)"],
							["rgb(255, 255, 255)", "rgb(205, 205, 205)", "rgb(178, 178, 178)", "rgb(153, 153, 153)", "rgb(127, 127, 127)", "rgb(102, 102, 102)", "rgb(76, 76, 76)", "rgb(51, 51, 51)", "rgb(25, 25, 25)", "rgb(0, 0, 0)"]
						];

						$scope.materialPalette = $mdColorPalette;

						///////////////////////////////////
						// Functions
						///////////////////////////////////
						$scope.isDark = function isDark(color) {
							if (angular.isArray(color)) {
								return tinycolor({ r: color[0], g: color[1], b: color[2] }).isDark();
							} else {
								return tinycolor(color).isDark();
							}

						};
						$scope.previewFocus = function () {
							$scope.inputFocus = true;
							$timeout(function () {
								previewInput[0].setSelectionRange(0, previewInput[0].value.length);
							});
						};
						$scope.previewUnfocus = function () {
							$scope.inputFocus = false;
							previewInput[0].blur();
						};
						$scope.previewBlur = function () {
							$scope.inputFocus = false;
							$scope.setValue();
						};
						$scope.previewKeyDown = function ($event) {

							if ($event.keyCode == 13) {
								$scope.ok && $scope.ok();
							}
						};
						$scope.setPaletteColor = function (event) {
							$timeout(function () {
								$scope.color = tinycolor(event.target.style.backgroundColor);
							});
						};

						$scope.setValue = function setValue() {
							// Set the value if available
							if ($scope.color && $scope.color && outputFn[$scope.type] && $scope.color.toRgbString() !== 'rgba(0, 0, 0, 0)') {
								$scope.value = $scope.color[outputFn[$scope.type]]();
							}
						};

						$scope.changeValue = function changeValue() {
							$scope.color = tinycolor($scope.value);
							$scope.$broadcast('mdColorPicker:colorSet', { color: $scope.color });
						};


						///////////////////////////////////
						// Watches and Events
						///////////////////////////////////
						$scope.$watch('color._a', function (newValue) {
							$scope.color.setAlpha(newValue);
						}, true);

						$scope.$watch('whichPane', function (newValue) {
							// 0 - spectrum selector
							// 1 - sliders
							// 2 - palette
							$scope.$broadcast('mdColorPicker:colorSet', { color: $scope.color });

						});

						$scope.$watch('type', function () {
							previewInput.removeClass('switch');
							$timeout(function () {
								previewInput.addClass('switch');
							});
						});

						$scope.$watchGroup(['color.toRgbString()', 'type'], function (newValue) {
							if (!$scope.inputFocus) {
								$scope.setValue();
							}
						});


						///////////////////////////////////
						// INIT
						// Let all the other directives initialize
						///////////////////////////////////
						//	console.log( "mdColorPickerContainer Controller PRE Timeout", Date.now() - dateClick );
						$timeout(function () {
							//		console.log( "mdColorPickerContainer Controller Timeout", Date.now() - dateClick );
							$scope.$broadcast('mdColorPicker:colorSet', { color: $scope.color });
							previewInput.focus();
							$scope.previewFocus();
						});
					}],
					link: function (scope, element, attrs) {

						var tabs = element[0].getElementsByTagName('md-tab');
						/*
						Replicating these structure without ng-repeats
		
						<div ng-repeat="row in palette track by $index" flex="15"  layout-align="space-between" layout="row"  layout-fill>
							<div ng-repeat="col in row track by $index" flex="10" style="height: 25.5px;" ng-style="{'background': col};" ng-click="setPaletteColor($event)"></div>
						</div>
		
						<div ng-repeat="(key, value) in materialColors">
							<div ng-style="{'background': 'rgb('+value['500'].value[0]+','+value['500'].value[1]+','+value['500'].value[2]+')', height: '75px'}" class="md-color-picker-material-title" ng-class="{'dark': isDark( value['500'].value )}" ng-click="setPaletteColor($event)">
								<span>{{key}}</span>
							</div>
							<div ng-repeat="(label, color) in value track by $index" ng-style="{'background': 'rgb('+color.value[0]+','+color.value[1]+','+color.value[2]+')', height: '33px'}" class="md-color-picker-with-label" ng-class="{'dark': isDark( color.value )}" ng-click="setPaletteColor($event)">
								<span>{{label}}</span>
							</div>
						</div>
						*/


						$timeout(function () {
							createDOM();
						});

						function createDOM() {
							var paletteContainer = angular.element(element[0].querySelector('.md-color-picker-palette'));
							var materialContainer = angular.element(element[0].querySelector('.md-color-picker-material-palette'));
							var paletteRow = angular.element('<div class="flex-15 layout-fill layout-row layout-align-space-between" layout-align="space-between" layout="row" layout-fill"></div>');
							var paletteCell = angular.element('<div class="flex-10"></div>');

							var materialTitle = angular.element('<div class="md-color-picker-material-title"></div>');
							var materialRow = angular.element('<div class="md-color-picker-with-label"></div>');



							angular.forEach(scope.palette, function (value, key) {
								var row = paletteRow.clone();
								angular.forEach(value, function (color) {
									var cell = paletteCell.clone();
									cell.css({
										height: '25.5px',
										backgroundColor: color
									});
									cell.bind('click', scope.setPaletteColor);
									row.append(cell);
								});

								paletteContainer.append(row);
							});

							angular.forEach(scope.materialPalette, function (value, key) {
								var title = materialTitle.clone();
								title.html('<span>' + key.replace('-', ' ') + '</span>');
								title.css({
									height: '75px',
									backgroundColor: 'rgb(' + value['500'].value[0] + ',' + value['500'].value[1] + ',' + value['500'].value[2] + ')'
								});
								if (scope.isDark(value['500'].value)) {
									title.addClass('dark');
								}

								materialContainer.append(title);

								angular.forEach(value, function (color, label) {

									var row = materialRow.clone();
									row.css({
										height: '33px',
										backgroundColor: 'rgb(' + color.value[0] + ',' + color.value[1] + ',' + color.value[2] + ')'
									});
									if (scope.isDark(color.value)) {
										row.addClass('dark');
									}

									row.html('<span>' + label + '</span>');
									row.bind('click', scope.setPaletteColor);
									materialContainer.append(row);
								});


							});
						}
					}
				};
			}])

			.directive('mdColorPickerHue', [function () {
				return {
					template: '<canvas width="100%" height="100%"></canvas><div class="md-color-picker-marker"></div>',
					link: hueLinkFn.get,
					controller: function () {
						//	console.log( "mdColorPickerHue Controller", Date.now() - dateClick );
					}
				};
			}])

			.directive('mdColorPickerAlpha', [function () {
				return {
					template: '<canvas width="100%" height="100%"></canvas><div class="md-color-picker-marker"></div>',
					link: alphaLinkFn.get,
					controller: function () {
						//	console.log( "mdColorPickerAlpha Controller", Date.now() - dateClick );
					}
				};
			}])

			.directive('mdColorPickerSpectrum', [function () {
				return {
					template: '<canvas width="100%" height="100%"></canvas><div class="md-color-picker-marker"></div>{{hue}}',
					link: spectrumLinkFn.get,
					controller: function () {
						//	console.log( "mdColorPickerSpectrum Controller", Date.now() - dateClick );
					}
				};
			}])

			.factory('$mdColorPicker', ['$q', '$mdDialog', 'mdColorPickerHistory', function ($q, $mdDialog, colorHistory) {
				var dialog;

				return {
					show: function (options) {
						if (options === undefined) {
							options = {};
						}
						//console.log( 'DIALOG OPTIONS', options );
						// Defaults
						// Dialog Properties
						options.hasBackdrop = options.hasBackdrop === undefined ? true : options.hasBackdrop;
						options.clickOutsideToClose = options.clickOutsideToClose === undefined ? true : options.clickOutsideToClose;
						options.defaultValue = options.defaultValue === undefined ? '#FFFFFF' : options.defaultValue;
						options.focusOnOpen = options.focusOnOpen === undefined ? false : options.focusOnOpen;
						options.preserveScope = options.preserveScope === undefined ? true : options.preserveScope;
						options.skipHide = options.skipHide === undefined ? true : options.skipHide;
						options.parent = options.parent === undefined ? angular.element(document.body) : options.parent;

						// mdColorPicker Properties
						options.mdColorAlphaChannel = options.mdColorAlphaChannel === undefined ? false : options.mdColorAlphaChannel;
						options.mdColorSpectrum = options.mdColorSpectrum === undefined ? true : options.mdColorSpectrum;
						options.mdColorSliders = options.mdColorSliders === undefined ? true : options.mdColorSliders;
						options.mdColorGenericPalette = options.mdColorGenericPalette === undefined ? true : options.mdColorGenericPalette;
						options.mdColorMaterialPalette = options.mdColorMaterialPalette === undefined ? true : options.mdColorMaterialPalette;
						options.mdColorHistory = options.mdColorHistory === undefined ? true : options.mdColorHistory;





						dialog = $mdDialog.show({
							templateUrl: 'mdColorPickerDialog.tpl.html',
							hasBackdrop: options.hasBackdrop,
							clickOutsideToClose: options.clickOutsideToClose,

							controller: ['$scope', 'options', function ($scope, options) {
								//console.log( "DIALOG CONTROLLER OPEN", Date.now() - dateClick );
								$scope.close = function close() {
									$mdDialog.cancel();
								};
								$scope.ok = function ok() {
									$mdDialog.hide($scope.value);
								};
								$scope.hide = $scope.ok;



								$scope.value = options.value;
								$scope.default = options.defaultValue;
								$scope.random = options.random;

								$scope.mdColorAlphaChannel = options.mdColorAlphaChannel;
								$scope.mdColorSpectrum = options.mdColorSpectrum;
								$scope.mdColorSliders = options.mdColorSliders;
								$scope.mdColorGenericPalette = options.mdColorGenericPalette;
								$scope.mdColorMaterialPalette = options.mdColorMaterialPalette;
								$scope.mdColorHistory = options.mdColorHistory;
								$scope.mdColorDefaultTab = options.mdColorDefaultTab;

							}],

							locals: {
								options: options,
							},
							preserveScope: options.preserveScope,
							multiple: options.skipHide,
							parent: options.parent,

							targetEvent: options.$event,
							focusOnOpen: options.focusOnOpen,
							autoWrap: false,
							onShowing: function () {
								//		console.log( "DIALOG OPEN START", Date.now() - dateClick );
							},
							onComplete: function () {
								//		console.log( "DIALOG OPEN COMPLETE", Date.now() - dateClick );
							}
						});

						dialog.then(function (value) {
							colorHistory.add(new tinycolor(value));
						}, function () { });

						return dialog;
					},
					hide: function () {
						return dialog.hide();
					},
					cancel: function () {
						return dialog.cancel();
					}
				};
			}]);
	})(window, window.angular);

	angular.module("mdColorPicker").run(["$templateCache", function ($templateCache) {
		$templateCache.put("mdColorPicker.tpl.html", "<div class=\"md-color-picker-input-container\" layout=\"row\">\n	<div class=\"md-color-picker-preview md-color-picker-checkered-bg\" ng-click=\"showColorPicker($event)\" ng-if=\"mdColorPreview\">\n		<div class=\"md-color-picker-result\" ng-style=\"{background: value}\"></div>\n	</div>\n	<md-input-container flex>\n		<label><md-icon ng-if=\"icon\">{{icon}}</md-icon>{{label}}</label>\n		<input type=\"input\" ng-model=\"value\" class=\'md-color-picker-input\'  ng-mousedown=\"(openOnInput || !mdColorPreview) && showColorPicker($event)\"/>\n	</md-input-container>\n	<md-button class=\"md-icon-button md-color-picker-clear\" ng-if=\"mdColorClearButton && value\" ng-click=\"clearValue();\" aria-label=\"Clear Color\">\n		<md-icon md-svg-icon=\"clear.svg\"></md-icon>\n	</md-button>\n</div>\n");
		$templateCache.put("mdColorPickerContainer.tpl.html", "<div class=\"md-color-picker-container in\" layout=\"column\">\n	<div class=\"md-color-picker-arrow\" ng-style=\"{\'border-bottom-color\': color.toRgbString() }\"></div>\n\n	<div class=\"md-color-picker-preview md-color-picker-checkered-bg\" ng-class=\"{\'dark\': !color.isDark() || color.getAlpha() < .45}\" flex=\"1\" layout=\"column\">\n\n		<div class=\"md-color-picker-result\" ng-style=\"{\'background\': color.toRgbString()}\" flex=\"100\" layout=\"column\" layout-fill layout-align=\"center center\" ng-click=\"focusPreviewInput( $event )\">\n			<!--<span flex  layout=\"column\" layout-align=\"center center\">{{value}}</span>-->\n			<div flex  layout=\"row\" layout-align=\"center center\">\n				<input class=\"md-color-picker-preview-input\" type=\"text\" ng-model=\"value\" ng-focus=\"previewFocus($event);\" ng-blur=\"previewBlur()\" ng-change=\"changeValue()\" ng-keypress=\"previewKeyDown($event)\" layout-fill />\n			</div>\n			<div class=\"md-color-picker-tabs\" style=\"width: 100%\">\n				<md-tabs md-selected=\"type\" md-stretch-tabs=\"always\" md-no-bar md-no-ink md-no-pagination=\"true\" >\n					<md-tab label=\"Hex\" ng-disabled=\"color.getAlpha() !== 1\" md-ink-ripple=\"#ffffff\"></md-tab>\n					<md-tab label=\"RGB\"></md-tab>\n					<md-tab label=\"HSL\"></md-tab>\n					<!--<md-tab label=\"HSV\"></md-tab>\n					<md-tab label=\"VEC\"></md-tab>-->\n				</md-tabs>\n			</div>\n		</div>\n	</div>\n\n	<div class=\"md-color-picker-tabs md-color-picker-colors\">\n		<md-tabs md-stretch-tabs=\"always\" md-align-tabs=\"bottom\"  md-selected=\"whichPane\" md-no-pagination>\n			<md-tab ng-if=\"mdColorSpectrum\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"gradient.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"row\" layout-align=\"space-between\" style=\"height: 255px\">\n						<div md-color-picker-spectrum></div>\n						<div md-color-picker-hue ng-class=\"{\'md-color-picker-wide\': !mdColorAlphaChannel}\"></div>\n						<div md-color-picker-alpha class=\"md-color-picker-checkered-bg\" ng-if=\"mdColorAlphaChannel\"></div>\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if=\"mdColorSliders\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"tune.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"column\" flex=\"100\" layout-fill layout-align=\"space-between start center\" class=\"md-color-picker-sliders\">\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill>\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">R</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"255\" ng-model=\"color._r\" aria-label=\"red\" class=\"red-slider\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\">\n								<input style=\"width: 100%;\" min=\"0\" max=\"255\" type=\"number\" ng-model=\"color._r\" aria-label=\"red\" aria-controls=\"red-slider\">\n							</div>\n						</div>\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill>\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">G</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"255\" ng-model=\"color._g\" aria-label=\"green\" class=\"green-slider\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\">\n								<input style=\"width: 100%;\" min=\"0\" max=\"255\" type=\"number\" ng-model=\"color._g\" aria-label=\"green\" aria-controls=\"green-slider\">\n							</div>\n						</div>\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill>\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">B</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"255\" ng-model=\"color._b\" aria-label=\"blue\" class=\"blue-slider\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\" >\n								<input style=\"width: 100%;\" min=\"0\" max=\"255\" type=\"number\" ng-model=\"color._b\" aria-label=\"blue\" aria-controls=\"blue-slider\">\n							</div>\n						</div>\n						<div layout=\"row\" layout-align=\"start center\" layout-wrap flex layout-fill ng-if=\"!mdColorAlphaChannel\">\n							<div flex=\"10\" layout layout-align=\"center center\">\n								<span class=\"md-body-1\">A</span>\n							</div>\n							<md-slider flex=\"65\" min=\"0\" max=\"1\" step=\".01\" ng-model=\"color._a\" aria-label=\"alpha\" class=\"md-primary\"></md-slider>\n							<span flex></span>\n							<div flex=\"20\" layout layout-align=\"center center\" >\n								<input style=\"width: 100%;\" min=\"0\" max=\"1\" step=\".01\" type=\"number\" ng-model=\"color._a\" aria-label=\"alpha\" aria-controls=\"alpha-slider\">\n							</div>\n						</div>\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if=\"mdColorGenericPalette\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"view_module.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"column\" layout-align=\"space-between start center\" flex class=\"md-color-picker-palette\">\n\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab  ng-if=\"mdColorMaterialPalette\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"view_headline.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body>\n					<div layout=\"column\" layout-fill flex class=\"md-color-picker-material-palette\">\n\n					</div>\n				</md-tab-body>\n			</md-tab>\n			<md-tab ng-if=\"mdColorHistory\">\n				<md-tab-label>\n					<md-icon md-svg-icon=\"history.svg\"></md-icon>\n				</md-tab-label>\n				<md-tab-body layout=\"row\" layout-fill>\n					<div layout=\"column\" flex layout-align=\"space-between start\" layout-wrap layout-fill class=\"md-color-picker-history\">\n						<div layout=\"row\" flex=\"80\" layout-align=\"space-between start start\" layout-wrap  layout-fill>\n							<div flex=\"10\" ng-repeat=\"historyColor in history.get() track by $index\">\n								<div  ng-style=\"{\'background\': historyColor.toRgbString()}\" ng-click=\"setPaletteColor($event)\"></div>\n							</div>\n						</div>\n\n\n						<md-button flex-end ng-click=\"history.reset()\" class=\"md-mini\" aria-label=\"Clear History\">\n							<md-icon md-svg-icon=\"clear_all.svg\"></md-icon>\n						</md-button>\n					</div>\n				</md-tab-body>\n			</md-tab>\n		</md-tabs>\n	</div>\n\n</div>\n");
		$templateCache.put("mdColorPickerDialog.tpl.html", "<md-dialog class=\"md-color-picker-dialog\">\n	<div md-color-picker-container\n		value=\"value\"\n		default=\"{{defaultValue}}\"\n		random=\"{{random}}\"\n		ok=\"ok\"\n		md-color-alpha-channel=\"mdColorAlphaChannel\"\n		md-color-spectrum=\"mdColorSpectrum\"\n		md-color-sliders=\"mdColorSliders\"\n		md-color-generic-palette=\"mdColorGenericPalette\"\n		md-color-material-palette=\"mdColorMaterialPalette\"\n		md-color-history=\"mdColorHistory\"\n		md-color-default-tab=\"mdColorDefaultTab\"\n	></div>\n	<md-actions layout=\"row\">\n		<md-button class=\"md-mini\" ng-click=\"close()\" style=\"width: 50%;\">Cancel</md-button>\n		<md-button class=\"md-mini\" ng-click=\"ok()\" style=\"width: 50%;\">Select</md-button>\n	</md-actions>\n</md-dialog>\n");
	}]);
})(angular, window, tinycolor);
(function () {

    'use strict';

    angular
            .module('app.core')
            .directive('numbersOnly', numbersOnly);

    function numbersOnly() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue === undefined)
                        return '';
                    var transformedInput = inputValue.replace(/[^0-9]/g, '');
                    if (transformedInput !== inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    }

})();
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('ngEnter', ngEnterDirective)

    /** @ngInject */
    function ngEnterDirective($parse) {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }


})();


(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('ngFileModel', ngFileModelDirective)
            .directive('fileModel', fileModel);
    /** @ngInject */
    function ngFileModelDirective($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.ngFileModel);
                var isMultiple = attrs.multiple;
                var modelSetter = model.assign;
                element.bind('change', function () {
                    var values = [];
                    angular.forEach(element[0].files, function (item) {
                        var value = {
                            // File Name 
                            name: item.name,
                            //File Size 
                            size: item.size,
                            //File URL to view 
                            url: URL.createObjectURL(item),
                            // File Input Value 
                            _file: item
                        };
                        values.push(value);
                    });
                    scope.$apply(function () {
                        if (isMultiple) {
                            modelSetter(scope, values);
                        } else {
                            modelSetter(scope, values[0]);
                        }
                    });
                });
            }
        };
    }


    function fileModel($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;
                element.bind('change', function () {
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }
})();
/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
(function ()
{
    'use strict';

    angular
            .module('app.core')
            .directive('expandGrid', expandGrid);

    /** @ngInject */
    function expandGrid($log) {
        var directive = {
            link: link, // The function attaching the behavior
            restrict: 'A' // Restrict directive to be used only as attribute
        };
        return directive;


        function link(scope, element, attrs) {
            
            var gridElement = $(element);
            var idGrid = attrs.id;
            var min = attrs.min ? parseInt(attrs.min) : 250;
            var other = attrs.other ? parseInt(attrs.other) : 0;
            resizeGridM("#" + idGrid, other, min);
            // Attach an eventHandler to the resize event of the
            // window to resize the data area of the grid accordingly
            scope.$watch(
                    function () {
                        return gridElement.parent().height();
                    },
                    function (height) {
                        resizeGridM("#" + idGrid, other, min);
                    });
        }
    }

    function resizeGridM(gridName, other, min) {
        //Define Elements Needed
        var grid = $(gridName);

        other = other ? other : 0;
        //Other variables
        var minimumAcceptableGridHeight = min ? min : 250; //This is roughly 5 rows 

        //Get Window Height 
        var windowHeight = $(window).innerHeight();

        //Padding you want to apply below your page
        var bottomPadding = 60;

        //Check if Calculated height is below threshold
        var calculatedHeight = windowHeight - bottomPadding - other - 150;
        var finalHeight = calculatedHeight < minimumAcceptableGridHeight ? minimumAcceptableGridHeight : calculatedHeight;

        //Apply the height for the content area
        grid.css('height', finalHeight + 'px');
    }


})();


(function () {

    'use strict';

    angular
            .module('app.core')
            .directive('decimalsOnly', decimalsOnly);

    function decimalsOnly() {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, modelCtrl) {
                modelCtrl.$parsers.push(function (inputValue) {
                    if (inputValue === undefined) {
                        modelCtrl.$setViewValue('0.00');
                        modelCtrl.$render();
                    }

                    if (inputValue.substring(0, 1) === ".") {
                        modelCtrl.$setViewValue('0' + inputValue);
                        modelCtrl.$render();
                    }

                    var transformedInput = inputValue.replace(/[^\.0-9]/g, '');
                    if (transformedInput !== inputValue) {
                        modelCtrl.$setViewValue(transformedInput);
                        modelCtrl.$render();
                    }

                    return transformedInput;
                });
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {

    'use strict';

    angular
        .module('app.public')
        .controller('PublicController', publicController);

    /**@ngInject**/
    function publicController($scope, $rootScope) {

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/Megasistemas/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/Megasistemas/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/Megasistemas/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/Megasistemas/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/Megasistemas/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/Megasistemas/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function () {
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider)
        .provider('filterWatcher', filterWatcher)

    /** @ngInject **/
    function msApiProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope) {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                resolve: resolve,
                request: request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters) {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response) {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response) {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error) {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response) {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if (angular.isDefined(success) && angular.isFunction(success)) {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response) {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');

                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if (angular.isDefined(error) && angular.isFunction(error)) {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }

    function filterWatcher() {

        this.$get = ['$window', '$rootScope', function ($window, $rootScope) {

            /**
             * Cache storing
             * @type {Object}
             */
            var $$cache = {};

            /**
             * Scope listeners container
             * scope.$destroy => remove all cache keys
             * bind to current scope.
             * @type {Object}
             */
            var $$listeners = {};

            /**
             * $timeout without triggering the digest cycle
             * @type {function}
             */
            var $$timeout = $window.setTimeout;

            /**
             * @description
             * get `HashKey` string based on the given arguments.
             * @param fName
             * @param args
             * @returns {string}
             */
            function getHashKey(fName, args) {
                function replacerFactory() {
                    var cache = [];
                    return function (key, val) {
                        if (isObject(val) && !isNull(val)) {
                            if (~cache.indexOf(val)) return '[Circular]';
                            cache.push(val)
                        }
                        if ($window == val) return '$WINDOW';
                        if ($window.document == val) return '$DOCUMENT';
                        if (isScope(val)) return '$SCOPE';
                        return val;
                    }
                }
                return [fName, JSON.stringify(args, replacerFactory())]
                    .join('#')
                    .replace(/"/g, '');
            }

            function isObject(value) {
                // http://jsperf.com/isobject4
                return value !== null && typeof value === 'object';
              }

              function isUndefined(value) {return typeof value === 'undefined';}

              function isNull(value) {
                return value === null;
            }

            function isScope(obj) {
                return obj && obj.$evalAsync && obj.$watch;
              }

            /**
             * @description
             * fir on $scope.$destroy,
             * remove cache based scope from `$$cache`,
             * and remove itself from `$$listeners`
             * @param event
             */
            function removeCache(event) {
                var id = event.targetScope.$id;
                forEach($$listeners[id], function (key) {
                    delete $$cache[key];
                });
                delete $$listeners[id];
            }

            /**
             * @description
             * for angular version that greater than v.1.3.0
             * it clear cache when the digest cycle is end.
             */
            function cleanStateless() {
                $$timeout(function () {
                    if (!$rootScope.$$phase)
                        $$cache = {};
                }, 2000);
            }

            /**
             * @description
             * Store hashKeys in $$listeners container
             * on scope.$destroy, remove them all(bind an event).
             * @param scope
             * @param hashKey
             * @returns {*}
             */
            function addListener(scope, hashKey) {
                var id = scope.$id;
                if (isUndefined($$listeners[id])) {
                    scope.$on('$destroy', removeCache);
                    $$listeners[id] = [];
                }
                return $$listeners[id].push(hashKey);
            }

            /**
             * @description
             * return the `cacheKey` or undefined.
             * @param filterName
             * @param args
             * @returns {*}
             */
            function $$isMemoized(filterName, args) {
                var hashKey = getHashKey(filterName, args);
                return $$cache[hashKey];
            }

            /**
             * @description
             * store `result` in `$$cache` container, based on the hashKey.
             * add $destroy listener and return result
             * @param filterName
             * @param args
             * @param scope
             * @param result
             * @returns {*}
             */
            function $$memoize(filterName, args, scope, result) {
                var hashKey = getHashKey(filterName, args);
                //store result in `$$cache` container
                $$cache[hashKey] = result;
                // for angular versions that less than 1.3
                // add to `$destroy` listener, a cleaner callback
                if (isScope(scope)) {
                    addListener(scope, hashKey);
                } else {
                    cleanStateless();
                }
                return result;
            }

            return {
                isMemoized: $$isMemoized,
                memoize: $$memoize
            }
        }];
    }
})();
(function ()
{
  'use strict';

  angular
    .module('app.core')
    .factory('arrayUtils', arrayUtils);

  /** @ngInject */
  function arrayUtils() {
    const service = {
      mergeArray   : mergeArray,
      filterArray  : filterArray,
    };

    return service;

    /**
     * Merge array
     *
     * @param principalArray Arreglo en donde se desea reemplazar una propiedad
     * @param propertyIdPrincipalArray Nombre de propiedad que identifica el objeto en el arreglo principal
     * @param secondaryArray Arreglo en el que se busca el valor (este arreglo sera insertado en el principal)
     * @param propertyIdSecondaryArray Nombre de propiedad que identifica el objeto en el arreglo secundario
     * @param newPropertyName Nombre de la propiedad donde se guardara el valor
     */
    function mergeArray(principalArray,
                        propertyIdPrincipalArray,
                        secondaryArray,
                        propertyIdSecondaryArray,
                        newPropertyName) {

      principalArray.forEach(function (principalArrayItem) {
        secondaryArray.find(function (secondaryArrayItem) {
          if (secondaryArrayItem[propertyIdSecondaryArray] === principalArrayItem[propertyIdPrincipalArray]) {
            principalArrayItem[newPropertyName] = secondaryArrayItem;
          }
        });

      });
      return principalArray;
    }

    /**
     * Filter array
     *
     * @param principalArray Arreglo que se filtrara
     * @param propertyIdPrincipalArray Nombre de propiedad que identifica el objeto en el arreglo principal
     * @param secondaryArray Arreglo en el que se busca si existe el valor
     * @param propertyIdSecondaryArray Nombre de propiedad que identifica el objeto en el arreglo secundario
     */
    function filterArray(principalArray,
                         propertyIdPrincipalArray,
                         secondaryArray,
                         propertyIdSecondaryArray) {
      return principalArray.filter(function (principalArrayItem) {
        return secondaryArray.every(function (secondaryArrayItem) {
          return secondaryArrayItem[propertyIdSecondaryArray] !== principalArrayItem[propertyIdPrincipalArray];
        });
      });
    }

  }

}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
  .filter('groupBy', [ '$parse', 'filterWatcher', function ( $parse, filterWatcher ) {
    return function (collection, property) {

      if(!isObject(collection) || isUndefined(property)) {
        return collection;
      }

      return filterWatcher.isMemoized('groupBy', arguments) ||
        filterWatcher.memoize('groupBy', arguments, this,
          _groupBy(collection, $parse(property)));

      /**
       * groupBy function
       * @param collection
       * @param getter
       * @returns {{}}
       */
      function _groupBy(collection, getter) {
        var result = {};
        var prop;

        forEach( collection, function( elm ) {
          prop = getter(elm);

          if(!result[prop]) {
            result[prop] = [];
          }
          result[prop].push(elm);
        });
        return result;
      }

      function isObject(value) {
        // http://jsperf.com/isobject4
        return value !== null && typeof value === 'object';
      }

      function isUndefined(value) {return typeof value === 'undefined';}

     

    function forEach(obj, iterator, context) {
        var key, length;
        if (obj) {
          if (isFunction(obj)) {
            for (key in obj) {
              if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else if (isArray(obj) || isArrayLike(obj)) {
            var isPrimitive = typeof obj !== 'object';
            for (key = 0, length = obj.length; key < length; key++) {
              if (isPrimitive || key in obj) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else if (obj.forEach && obj.forEach !== forEach) {
              obj.forEach(iterator, context, obj);
          } else if (isBlankObject(obj)) {
            // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
            for (key in obj) {
              iterator.call(context, obj[key], key, obj);
            }
          } else if (typeof obj.hasOwnProperty === 'function') {
            // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
            for (key in obj) {
              if (obj.hasOwnProperty(key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          } else {
            // Slow path for objects which do not have a method `hasOwnProperty`
            for (key in obj) {
              if (hasOwnProperty.call(obj, key)) {
                iterator.call(context, obj[key], key, obj);
              }
            }
          }
        }
        return obj;
      }

      function isFunction(value) {return typeof value === 'function';}

      function isArray(arr) {
        return Array.isArray(arr) || arr instanceof Array;
      }
    }
 }]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config() {

    }

})();

(function () {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($rootScope, $scope, localStorageService, APPNAME, APPINITIALS) {
        var vm = this;
        $rootScope.account = localStorageService.get('account');

        vm.app = {
            initials: APPINITIALS,
            name: APPNAME
        };

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function () {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController($q, APPNAME, api, $rootScope, $timeout, $log, $mdSidenav, $state, $mdDialog) {
        var vm = this;

        $rootScope.totalNumberOfNotifications = 0;
        vm.appNotificationArray = [];
        vm.userNotificationArray = [];

        //metodos
        vm.showAllMyNotifications = showAllMyNotifications;
        vm.showNotification = showNotification;
        vm.goToUserNotificationConfiguration = goToUserNotificationConfiguration;

        function getCurrentNotifications() {

            var defered = $q.defer();
            var promise = defered.promise;

            var numberOfRequest = 2;
            var numberOfRequestCompleted = 0;

            if ($rootScope.bsCircle) {
                api.NotificacionesWS.Notification.pageOfCurrentNotifications.page({ 'circleId': $rootScope.bsCircle.id, 'pageNumber': 1, 'pageSize': 50 }).$promise.then(function (response) {

                    vm.appNotificationArray = response.content;
                    $rootScope.totalNumberOfNotifications += response.totalElements;

                    numberOfRequestCompleted += 1;

                    if (numberOfRequest === numberOfRequestCompleted) {
                        defered.resolve(true);
                    }

                }, function (response) {
                    numberOfRequestCompleted += 1;
                    $log.error(response);

                    if (numberOfRequest === numberOfRequestCompleted) {
                        defered.resolve(true);
                    }

                });

                api.NotificacionesWS.UserNotification.pageOfUnreadNotifications.page({ 'circleId': $rootScope.bsCircle.id, 'pageNumber': 1, 'pageSize': 50 }).$promise.then(function (response) {

                    $rootScope.totalNumberOfNotifications += response.totalElements;

                    response.content.forEach(function (row) {
                        row.isUserNotification = true;

                        row.longTime = new Date(row.createdAt.year, row.createdAt.monthValue, row.createdAt.dayOfMonth, row.createdAt.hour, row.createdAt.minute, row.createdAt.second).getTime();

                        if (row.applicationName === APPNAME) {
                            row.appPriorityNumber = 1;
                        } else {
                            row.appPriorityNumber = 2;
                        }

                        switch (row.notificationPriority) {
                            case 'HIGH':
                                row.priorityNumber = 1;
                                break;
                            case 'MEDIUM':
                                row.priorityNumber = 2;
                                break;
                            case 'LOW':
                                row.priorityNumber = 3;
                                break;
                            default:
                                break;
                        }
                        vm.userNotificationArray.push(row);
                    });

                    numberOfRequestCompleted += 1;

                    if (numberOfRequest === numberOfRequestCompleted) {
                        defered.resolve(true);
                    }

                }, function (response) {
                    numberOfRequestCompleted += 1;
                    $log.error(response);

                    if (numberOfRequest === numberOfRequestCompleted) {
                        defered.resolve(true);
                    }

                });

            } else {
                defered.resolve(true);
            }

            return promise;

        }


        function processData() {

            getCurrentNotifications().then(function (response) {

                if ($rootScope.msNotificationArray === null || $rootScope.msNotificationArray === undefined) {
                    $rootScope.msNotificationArray = [];
                }

                $rootScope.msNotificationArray = $rootScope.msNotificationArray.concat(vm.appNotificationArray);

                var filterResult = new jinqJs()
                    .from(vm.userNotificationArray)
                    .orderBy([{ field: 'appPriorityNumber', sort: 'asc' }, { field: 'priorityNumber' }, { field: 'longTime' }])
                    .select();

                $rootScope.msNotificationArray = $rootScope.msNotificationArray.concat(filterResult);

            });

        }

        function goToUserNotificationConfiguration() {
            $state.go('app.notifications.Configuration');
            $mdSidenav('quick-panel').close();
        }

        function showAllMyNotifications() {
            $state.go('app.notifications.MyNotifications');
            $mdSidenav('quick-panel').close();
        }

        function markAsRead(notification, notificationIndex) {

            var _notificationIdArray = [notification.id];

            $rootScope.loadingProgress = true;
            api.NotificacionesWS.UserNotification.markAsRead.update({ 'circleId': $rootScope.bsCircle.id }, _notificationIdArray).$promise.then(function (response) {
                $rootScope.loadingProgress = false;

                $rootScope.msNotificationArray.splice(notificationIndex, 1);
                $rootScope.totalNumberOfNotifications -= 1;

            }, function (response) {
                $rootScope.loadingProgress = false;
                $log.error(response);
            });

        }

        function showNotification(event, notification, index) {

            $mdSidenav('quick-panel').close();

            if (notification.originType !== null && notification.originType !== undefined && notification.originType.queryUrl !== null && notification.originType.queryUrl !== undefined && notification.originType.queryUrl !== "") {

                markAsRead(notification, index);

                var url = notification.originType.queryUrl + notification.referenceNumber;

                window.open(url, "_blank");

                return null;

            }

            $mdDialog.show({
                controller: 'ViewNotificationController',
                controllerAs: 'vm',
                locals: {
                    'notification': notification,
                    'notificationIndex': index
                },
                templateUrl: 'app/quick-panel/tabs/my-notifications/view-notification/view-notification.html',
                parent: angular.element("#main"),
                targetEvent: event,
                clickOutsideToClose: false
            }).then(function (response) {

            }, function () {
            });

        }

        function init() {
            processData();
        }

        $timeout(init, 1000);

    }

})();

(function () {
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController( $rootScope, $q, api, $state, $timeout, $mdSidenav, $translate, msNavigationService,
        $mdMenu, $auth, localStorageService, APPNAME, APPINITIALS, envService, $filter, ICON_APP_NAME, $window) {
        var vm = this;
        vm.urlIcons = envService.read('imagesApps');
        vm.urlIconsFull = envService.read('imagesApps') + ICON_APP_NAME;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.app = {
            initials: APPINITIALS,
            name: APPNAME
        };

        $rootScope.account = localStorageService.get('account');
        vm.bodyEl = angular.element('body');

        vm.userStatusOptions = [];
        vm.languages = {
            es: {
                'title': 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code': 'es',
                'flag': 'es'
            },
            esHN: {
                'title': 'Spanish(Honduras)',
                'translation': 'TOOLBAR.SPANISH_HN',
                'code': 'es-hn',
                'flag': 'hn'
            },
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.changeApp = changeApp;
        vm.getImageApp = getImageApp;
        vm.openRoles = openRoles;
        vm.openManual = openManual;
        vm.searchResultClick = searchResultClick;
        vm.changeCircle = changeCircle;


        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.selectedLanguage = vm.languages[$translate.use()];
            $rootScope.currentTranslateLang = vm.selectedLanguage
                && vm.selectedLanguage.code ? vm.selectedLanguage.code : 'es';
            loadApps();
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        function getImageApp(name) {
            return vm.urlIcons + name.split(' ').join('');
        }

        function changeApp(app) {
            if (app.url !== null && app.url) {
                window.open(app.url);
            }

        }

        function openRoles(e) {
            $state.go('app.role');
            $mdMenu.hide();
            $mdMenu.hide();
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here..
            logoutFinish($auth, $state, 'public.content.index');
            localStorageService.remove('account');
            localStorageService.remove('accountc');
            localStorageService.remove('circles');
            localStorageService.remove('userParameters');
            $window.localStorage.removeItem('APP001_C_C');

            delete $rootScope.bsCircle;
            delete $rootScope.circles;
            delete $rootScope.userParameters;

            if ($rootScope.userListenerEvent) {
                $rootScope.userListenerEvent.close();
            }
        }

        function loadApps() {
            api.GeneralWS.ApplicationByUser.query({}).$promise.then(
                function (response) {
                    response = $filter('orderBy')(response, 'sortOrderApp');
                    vm.apps = response;
                    $rootScope.myApps = response;
                },
                function (err) {

                }
            );
        }

        function changeCircle(c) {
            $rootScope.bsCircle = c;

            localStorageService.set('accountc', $rootScope.bsCircle);
            if ($rootScope.bsCircle) {
                $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
            }
            $rootScope.msNotificationArray = [];
            $rootScope.totalNumberOfNotifications = 0;

            if ($state.is('app.dashboards_project')) {
                $state.reload();
            } else {
                $state.go('app.dashboards_project', {}, { reload: true });
            }
        }

        function openManual(link) {
            window.open(link);
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            // Change the language
            $translate.use(lang.code);
            $rootScope.currentTranslateLang = vm.selectedLanguage.code;
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }


    }

})();

(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            // Core
            'app.core',
            'app.common',
            // Navigation
            'app.navigation',
            // Toolbar
            'app.toolbar',
            // Quick panel
            'app.quick-panel',
            // Apps
            'app.dashboards',
            //Generales
            'app.general',
            'app.account',
            'app.product',
            'app.usr',
            'app.company',
            'app.public',
            'app.groupFavorite',
            'app.interfaz',
            'app.CompanyProvider',
            'app.generalConfiguration',
            'app.bank',
            'app.files',
            'app.notification'
        ]);
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $state, Idle, $auth, api, $log, localStorageService, msNavigationService, APPNAME, $window) {
        $scope.events = [];

        $rootScope.hasCircle = hasCircle;
        $rootScope.dashboardScreens = dashboardScreens;
        $rootScope.getScreenByRole = getScreenByRole;
        $rootScope.getEspecialActionByName = getEspecialActionByName;
        $rootScope.getUserParameterValueByName = getUserParameterValueByName;
        $rootScope.createUserParameter = createUserParameter;
        $rootScope.updateUserParameterValue = updateUserParameterValue;

        $scope.$on('IdleStart', function () {
            // the user appears to have gone idle
            var now = new Date();
            $log.debug("****** IdleStart ******* " + now);
        });

        $scope.$on('IdleWarn', function (e, countdown) {
            // follows after the IdleStart event, but includes a countdown until the user is considered timed out
            // the countdown arg is the number of seconds remaining until then.
            // you can change the title or display a warning dialog from here.
            // you can let them resume their session by calling Idle.watch()
            var now = new Date();
            $log.debug("****** IdleWarn ******* " + now);
        });

        $scope.$on('IdleTimeout', function () {
            // the user has timed out (meaning idleDuration + timeout has passed without any activity)
            // this is where you'd log them
            var now = new Date();
            $log.debug("****** IDLE TIMEOUT ******* " + now);
            logoutFinish($auth, $state, 'auth.lock');
        });

        $scope.$on('IdleEnd', function () {
            // the user has come back from AFK and is doing stuff. if you are warning them, you can use this to hide the dialog
            var now = new Date();
            $log.debug("****** IdleEnd ******* " + now);
        });

        $scope.$on('Keepalive', function () {
            // do something to keep the user's session alive
            var now = new Date();
            $log.debug("****** Keepalive ******* " + now);
        });

        msNavigationService.clearNavigation();

        if ($rootScope.circles && $rootScope.circles.length <= 0) {
            $rootScope.circles = [];
            localStorageService.set('circles', $rootScope.circles);

            $rootScope.bsCircle = null;
            localStorageService.set('accountc', $rootScope.bsCircle);
            if ($rootScope.bsCircle) {
                $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
            }

            dashboardScreens();

            msNavigationService.saveItem('apps.company', {
                title: 'Empresa',
                group: true,
                weight: 5
            });

            msNavigationService.saveItem('apps.company.mycompany', {
                title: 'Empresa',
                icon: 'icon-domain',
                state: 'app.company.mycompany',
                weight: 6
            });
        } else {
            hasCircle();
        }

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        Idle.watch();

        function hasCircle() {
            if ($rootScope.circles) {
                if ($rootScope.circles.length > 0) {
                    if (!$rootScope.bsCircle || $rootScope.bsCircle.role.aplication.name !== APPNAME) {
                        $rootScope.bsCircle = $rootScope.circles[0];
                        localStorageService.set('accountc', $rootScope.bsCircle);
                        if ($rootScope.bsCircle) {
                            $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
                        }
                        $state.go('app.dashboards_project');
                    }
                }

                if ($rootScope.bsCircle) {
                    getScreenByRole();
                } else {
                    dashboardScreens();
                }
            }
        }

        function dashboardScreens() {
            msNavigationService.saveItem('apps', {
                title: 'MAIN',
                group: true,
                weight: 1
            });

            msNavigationService.saveItem('apps.dashboards', {
                title: 'Dashboards',
                icon: 'icon-tile-four',
                state: 'app.dashboards_project',
                weight: 1
            });
        }

        function getScreenByRole() {

            msNavigationService.clearNavigation();
            $scope.items = [];

            api.GeneralWS.Menu.ByRole.query({ rol: $rootScope.bsCircle.role.id }).$promise.then(function (response) {
                $scope.items = response;

                msNavigationService.saveItem('apps.dashboards', {
                    title: 'Dashboards',
                    icon: 'icon-tile-four',
                    state: 'app.dashboards_project',
                    weight: 1
                });

                $rootScope.statesAutorized = [
                    'public.content.index',
                    'app.dashboards_project',
                    'app.pages_errors_error-404',
                    'app.errors.unauthorized',
                    'app.errors.notFound',
                    'auth.login',
                    'auth.lock',
                    'app.profile',
                    'app.profile.edit',
                    'app.role',
                    'app.notifications.MyNotifications',
                    'app.notifications.Configuration'
                ];

                var hasApps = false;

                $scope.items.forEach(function (item) {
                    item.menuItem.group = item.menuItem.isGroup;
                    item.menuItem.state = item.menuItem.stateName;
                    msNavigationService.saveItem(item.menuItem.itemName, item.menuItem);

                    if (item.menuItem.state !== null && item.menuItem.state !== "") {
                        $rootScope.statesAutorized.push(item.menuItem.state);
                    }

                    if (item.menuItem.states) {
                        var states = item.menuItem.states.split(",");
                        $rootScope.statesAutorized = $rootScope.statesAutorized.concat(states);
                    }

                    if (item.menuItem.itemName === 'apps' && item.menuItem.isGroup) {
                        hasApps = true;
                    }
                });

                if (!hasApps) {
                    msNavigationService.saveItem('apps', {
                        title: 'MAIN',
                        group: true,
                        weight: 1
                    });
                }

            }, function (err) {
                $log.debug(err);
            });
        }

        function getEspecialActionByName(actionName) {
            if (!$rootScope.bsCircle) {
                return false;
            }

            for (var i = 0; i < $rootScope.bsCircle.role.roleSpecialActions.length; i++) {
                if ($rootScope.bsCircle.role.roleSpecialActions[i].specialAction
                    && $rootScope.bsCircle.role.roleSpecialActions[i].specialAction.actionName === actionName
                    && $rootScope.bsCircle.role.roleSpecialActions[i].active === true) {
                    return true;
                }
            }

            return false;
        }

        function getUserParameterValueByName(name, returnJsonValue) {
            if ($rootScope.userParameters === null || $rootScope.userParameters === undefined) {
                return null;
            }
            for (var i = 0; i < $rootScope.userParameters.length; i++) {
                if ($rootScope.userParameters[i].applicationParameter.parameterName === name) {
                    if (returnJsonValue) {
                        return $rootScope.userParameters[i].userJsonParameterValue;
                    } else {
                        return $rootScope.userParameters[i].userParameterValue;
                    }
                }
            }

            return null;
        }

        function createUserParameter(parameterName, value, saveValueAsJson) {

            var parameter = {
                applicationParameter: {
                    parameterName: parameterName
                }
            };

            if (saveValueAsJson) {
                parameter.userJsonParameterValue = value;
            } else {
                parameter.userParameterValue = value;
            }

            api.GeneralWS.Usr.UserParameter.create({}, parameter).$promise.then(function (response) {
                if ($rootScope.userParameters === undefined || $rootScope.userParameters === null) {
                    $rootScope.userParameters = [];
                }

                $rootScope.userParameters.push(response);

                localStorageService.remove('userParameters');
                localStorageService.set('userParameters', $rootScope.userParameters);
            }, function (response) {
                $log.error(response);
            });

        }

        function updateUserParameterValue(parameterName, value, saveValueAsJson) {

            var parameter = null;

            for (var i = 0; i < $rootScope.userParameters.length; i++) {
                if ($rootScope.userParameters[i].applicationParameter.parameterName === parameterName) {

                    if (saveValueAsJson) {
                        $rootScope.userParameters[i].userJsonParameterValue = value;
                    } else {
                        $rootScope.userParameters[i].userParameterValue = value;
                    }

                    parameter = $rootScope.userParameters[i];
                    break;
                }
            }

            api.GeneralWS.Usr.UserParameter.update({ 'userParameterId': parameter.id }, parameter).$promise.then(function (response) {
                localStorageService.remove('userParameters');
                localStorageService.set('userParameters', $rootScope.userParameters);
            }, function (response) {
                $log.error(response);
            });

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('AuthMainController', AuthMainController);

    /** @ngInject */
    function AuthMainController($scope, $rootScope) {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(false);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
function translateGrid(key, defaultValue, $filter) {

    // to avoid key clash with external keys, we add 'grid' to the start of each key.
    var gridKey = 'GRID.' + key;

    // look the value up. here we use the AngularJS 1.x $filter service, however you can use whatever
    // service you want, AngularJS 1.x or otherwise.
    var value = $filter('translate')(gridKey);
    return value === gridKey ? defaultValue : value;
}

function getHeader(name) {
    return '{{\'' + name.value + '\'|translate}}';
}

function getHeaderMenu(a, $filter) {
    a.columnApi.getAllColumns().forEach(function (r) {
        r.colDef.hN = r.colDef.hN ? r.colDef.hN : angular.copy(r.colDef.headerName);
        r.colDef.headerName = $filter('translate')(r.colDef.hN);
    });
    return a.defaultItems;
}

function agGridFormatToExport(params, $filter) {
    if (params.column.colId.indexOf("createdAt") !== -1) {
        return $filter('apiDate')(params.value, 'dd/MM/yyyy HH:mm:ss');
    }

    if (params.column.colId.indexOf("fecha") !== -1) {
        return $filter('date')(params.value, 'dd/MM/yyyy');
    } else {
        return params.value;
    }
}

function logoutFinish($auth, $state, redirect) {
    $auth.logout('OIDC').then(function () {
    }, function (out) {
        $state.go(redirect);
    });
}

(function () {
    'use strict';

    agGrid.initialiseAgGridWithAngular1(angular);
    agGrid.LicenseManager.setLicenseKey("CompanyName=MPRH, S.A.,LicensedApplication=Multi,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-026056,ExpiryDate=7_April_2023_[v2]_MTY4MDgyMjAwMDAwMA==00d2d5b8ad66ae62b0774f46af5c430c");

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($mdIconProvider, $mdDateLocaleProvider, $httpProvider, APPNAME, IdleProvider, KeepaliveProvider,
        localStorageServiceProvider, $translateProvider, $provide, $translatePartialLoaderProvider) {
        // configure Idle settings
        IdleProvider.idle(15 * 60); // 1 minutes idle - tiempo inactividad
        IdleProvider.timeout(15); // after 30 seconds idle, time the user out - tiempo para vencer luego de inactividad aqui dispara los warning cada segundo
        KeepaliveProvider.interval(10 * 60); // 1 minute keep-alive ping - intervalo para accion para mantener vivo

        localStorageServiceProvider
            .setPrefix(APPNAME.split(' ').join(''))
            .setStorageType('sessionStorage')
            .setNotify(true, true);

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('es');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions) {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote', 'wordcount', 'charcount']
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);

        $mdDateLocaleProvider.formatDate = function (date) {
            return moment(date).format('DD-MM-YYYY');
        };

        $translatePartialLoaderProvider.addPart('app/common');

        $mdIconProvider
            .defaultIconSet('assets/angular-material-assets/img/icons/mdi.svg');

        $httpProvider.interceptors.push(function ($q, $cookies, $log, $rootScope) {
            return {
                'request': function (config) {
                    if (config.url.indexOf('http') !== -1) {
                        if (config.params) {
                            config.params.apprequest = APPNAME;
                            config.params.Apprequest = APPNAME;
                        } else {
                            config.params = { apprequest: APPNAME, Apprequest: APPNAME };
                        }
                    }
                    return config;
                },
                'response': function (response) {
                    return response;
                },
                'responseError': function (response) {
                    if (response.status === 401) {
                        $rootScope.$broadcast('IdleTimeout');
                    }
                    return $q.reject(response);
                }
            };
        });

        document.addEventListener("mousewheel", function (event) {
            if (document.activeElement.type === "number") {
                document.activeElement.blur();
            }
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            if (!$rootScope.bsCircle
                && !$state.current.abstract
                && $state.current.name.split('auth').length === 1
                && $state.current.name
                && !$state.current.name.includes('profile')
                && !$state.current.name.includes('public')) {

                $timeout(function () {
                    if (!$rootScope.circles) {
                        $state.go('app.company.mycompany');
                    } else {
                        $state.go('app.errors.unauthorized');
                    }
                });
            }
            if ($rootScope.statesAutorized && $rootScope.statesAutorized.indexOf($state.current.name) < 0) {
                $state.go('app.pages_errors_error-404');
            }

            $timeout(function () {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function () {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, APPNAME) {
        var stateProvider = $stateProvider;

        $urlRouterProvider.otherwise('/public/index');

        // Get active layout
        var layoutStyle = 'verticalNavigationFullwidthToolbar2';
        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        stateProvider
            .state('app', {
                abstract: true,
                url: '',
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller: 'QuickPanelController as vm'
                    }
                }, resolve: {
                    redirectIfNotAuthenticated: ['$q', '$state', '$auth', '$timeout', '$rootScope', 'api', 'localStorageService', '$window', redirectIfNotAuthenticated]
                }
            });

        stateProvider
            .state('auth', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'AuthMainController as vm'
                    }
                }, resolve: {
                    skipIfAuthenticated: ['$q', '$state', '$auth', '$timeout', '$rootScope', 'api', 'localStorageService', '$window', skipIfAuthenticated]
                }
            });

        function skipIfAuthenticated($q, $state, $auth, $timeout, $rootScope, api, localStorageService, $window) {
            var defer = $q.defer();
            if ($auth.isAuthenticated()) {
                var prome = api.GeneralWS.Usr.User.basicUserInformation.get({}).$promise;
                var ejecuteProme = false;
                if (!$rootScope.account) {
                    api.UsuarioWS.Yo.get({},
                        function (response) {
                            $rootScope.account = response;
                            localStorageService.set('account', $rootScope.account);
                        },
                        function (response) {
                            console.error(response);
                        }
                    );
                }
                var ret;
                if (ejecuteProme) {
                    ret = loadCirclesBasicInformation($rootScope, localStorageService, prome, $state, defer, $timeout, $auth, $window);
                } else {
                    defer.resolve();
                    ret = defer.promise;
                }
                if ($state.current.name === "") {
                    $timeout(function () {
                        $state.go('app.dashboards_project');
                    });
                    return ret;
                } else {
                    $timeout(function () {
                        $state.go('app.dashboards_project');
                    });
                    defer.reject();
                }
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        function redirectIfNotAuthenticated($q, $state, $auth, $timeout, $rootScope, api, localStorageService, $window) {

            var defer = $q.defer();

            if ($auth.isAuthenticated()) {
                var prome = api.GeneralWS.Usr.User.basicUserInformation.get({}).$promise;

                if (!$rootScope.account) {
                    api.UsuarioWS.Yo.get({},
                        function (response) {
                            $rootScope.account = response;
                            localStorageService.set('account', $rootScope.account);
                        },
                        function (response) {
                            console.error(response);
                        }
                    );
                }
                return loadCirclesBasicInformation($rootScope, localStorageService, prome, $state, defer, $timeout, $auth, $window);
            } else {
                $timeout(function () {
                    $state.go('public.content.index');
                });
                defer.reject();
            }
            return defer.promise;
        }

        function loadCirclesBasicInformation($rootScope, localStorageService, prome, $state, defer, $timeout, $auth, $window) {

            //valida los circulos y los parametros
            $rootScope.circles = localStorageService.get('circles');
            $rootScope.userParameters = localStorageService.get('userParameters');

            if (!$rootScope.circles || !$rootScope.userParameters) {
                prome.then(function (response) {

                    if (response.circles.length > 0) {
                        for (let j = 0; j < response.circles.length; j++) {
                            response.circles[j].role.roleSpecialActions = response.roleSpecialAction.filter(function (item) {
                                return item.roleAppId === response.circles[j].role.id;
                            });
                        }
                        $rootScope.bsCircle = response.circles[0];
                        localStorageService.set('accountc', $rootScope.bsCircle);
                        if ($rootScope.bsCircle) {
                            $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
                        }

                        $rootScope.circles = response.circles;
                        localStorageService.set('circles', $rootScope.circles);

                        $rootScope.userParameters = response.parameters;
                        localStorageService.set('userParameters', $rootScope.userParameters);

                        $rootScope.userId = response.userId;
                        localStorageService.set(APPNAME + '_UID', $rootScope.userId);

                        $rootScope.userCompanies = getUserCompanies(response.circles);
                    }
                }, function (response) {
                    if (response.status === 401) {
                        logoutFinish($auth, $state, 'public.content.index');
                    }
                    console.error(response);
                    $timeout(function () {
                        $state.go('app.errors.unauthorized');
                    });
                });

                return prome;
            } else {
                $rootScope.bsCircle = localStorageService.get('accountc');
                $rootScope.userId = localStorageService.get(APPNAME + '_UID');
                $rootScope.userCompanies = getUserCompanies($rootScope.circles);
                if (!$rootScope.bsCircle || $rootScope.bsCircle.role.aplication.name !== APPNAME) {
                    $rootScope.bsCircle = $rootScope.circles[0];
                    localStorageService.set('accountc', $rootScope.bsCircle);
                    if ($rootScope.bsCircle) {
                        $window.localStorage.setItem('APP001_C_C', $rootScope.bsCircle.id);
                    }
                    defer.resolve();
                } else {
                    defer.resolve();
                }
            }
            return defer.promise;
        }

        function getUserCompanies(circles) {
            var companies = [];

            for (var i = 0; i < circles.length; i++) {
                var companyId = circles[i].company.id;

                if (companies.indexOf(companyId) < 0) {
                    companies.push(companyId);
                }
            }

            return companies;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, APPNAME, APPINITIALS, api, $rootScope, $log) {
        var vm = this;

        document.title = APPNAME;

        api.GeneralWS.Application.get({ app: APPNAME }, function (d) {
            $rootScope.APPQ = d;
            $log.debug($rootScope.APPQ);

            if (d) {
                api.GeneralWS.ApplicationParameter.get({ app: d.id }, function (response) {
                    $rootScope.APPParameters = response;
                });
            }

        });

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();

(function () {
    'use strict';

    var ProductSaleValidationType = [
        { value: 'NONE' },
        { value: 'LOCAL' },
        { value: 'REMOTE' },
        { value: 'VALIDATE_INVENTORY' },
    ];

    var EntitiesToApplyDiscounts = [
        { name: 'TmpInvoiceSale', description: 'Total de la factura' },
        { name: 'TmpInvoiceSaleDetail', description: 'Detalle de factura' }
    ];

    var DiscountTypes = [
        { keyDiscountType: 'NONE' },
        { keyDiscountType: 'INVENTORY' },
        { keyDiscountType: 'PRODUCT' },
        { keyDiscountType: 'PRODUCT_TYPE' },
        { keyDiscountType: 'PRODUCT_TYPE_ADD_FIELD' },
        { keyDiscountType: 'INVOICE_SALE' },
	{ keyDiscountType: 'DEFAULT' }
    ];

    var DiscountMethods = [
        { key: 'PERCENTAGE' },
        { key: 'FIXED_VALUE' },
        { key: 'FINAL_PRICE' }
    ];

    var DiscountCondition = [
        { value: 'EQUALS', symbol: "=", translate: 'DISCOUNTS.CONDITION.EQUALS' },
        { value: 'GREATER_THAN', symbol: ">", translate: 'DISCOUNTS.CONDITION.GREATER_THAN' },
        { value: 'SMALLER_THAN', symbol: "<", translate: 'DISCOUNTS.CONDITION.SMALLER_THAN' },
        { value: 'GREATER_EQUAL_THAN', symbol: ">=", translate: 'DISCOUNTS.CONDITION.GREATER_EQUAL_THAN' },
        { value: 'SMALLER_EQUAL_THAN', symbol: "<=", translate: 'DISCOUNTS.CONDITION.SMALLER_EQUAL_THAN' },
        { value: 'IN', symbol: "IN", translate: 'DISCOUNTS.CONDITION.IN' },
        { value: 'NOT_IN', symbol: "NOT IN", translate: 'DISCOUNTS.CONDITION.NOT_IN' },
    ];

    var invoiceSerieDocumentTypes= [
      'INVOICE',
      'CREDIT_NOTE',
      'TRANSFER_NOTE',
      'DELIVERY_NOTE',
      'RETURN_NOTE',
      'GLOBAL_INVOICE',
      'GLOBAL_CREDITNOTE',
      'CASH_TRANSFER',
      'INVOICE_TICKET',
      'INVOICE_CREDIT_FISCAL',
      'CREDIT_NOTE_TICKET',
      'CREDIT_NOTE_CREDIT_FISCAL',
      'ANNULMENT',
    ];

    angular
        .module('fuse')
        .constant('APPNAME', 'Megasistemas')
        .constant('APPINITIALS', 'MS')
        .constant('ICON_APP_NAME', 'Megasistemas.png')
        .constant('ProductSaleValidationType', ProductSaleValidationType)
        .constant('DiscountTypes', DiscountTypes)
        .constant('DiscountCondition', DiscountCondition)
        .constant('EntitiesToApplyDiscounts', EntitiesToApplyDiscounts)
        .constant('INVOICE_SERIE_DOCUMENT_TYPES', invoiceSerieDocumentTypes)
        .constant('DiscountMethods', DiscountMethods)

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($authProvider, $windowProvider, envServiceProvider) {
        envServiceProvider.config({
            domains: {
                localhost: ['localhost'],
                development: ['desarrollo.megapaca'],
                test: ['pruebas.megapaca'],
                production: ['www.megapaca.com', 'www.megapaca.gt']
            },
            vars: {
                localhost: {
                    clientId: 'a355631f-de45-4fa9-9dd9-af6b90c1645f',
                    secret: 'XkbTgL894oG2zkS7nkk3-WAc1Qfq7YO5dLY22P0MwaksGHHUhPk9DiBcFLaTSURoBSQg60fdbAJ7lfBDK1JTRw',
                    hostOIC: 'https://desarrollo.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    baseUrl: 'https://desarrollo.megapaca.gt/PresupuestosWS/api/',
                    baseUrlGeneral: 'https://desarrollo.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://desarrollo.megapaca.gt/UsuarioWS/api/',
                    baseUrlTicketsWS: 'https://desarrollo.megapaca.gt/TicketsWS/api/',
                    baseUrlSharedFiles: 'http://testing.megapaca.gt/ms/images',
                    baseUrlComprasWS: 'https://desarrollo.megapaca.gt/ComprasWS/api/',
                    imagesApps: 'https://www.megapaca.com.gt/images/logosapps/v1/p/pms',
                    baseUrlActivosFijosWS: 'https://desarrollo.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlInterfazWS: 'https://desarrollo.megapaca.gt/InterfazWS/api/',
                    baseUrlNotificacionesWS: 'https://desarrollo.megapaca.gt/NotificacionesWS/api/',
                    baseUrlProyectosWS: 'https://desarrollo.megapaca.gt/ProyectosWS/api/',
                    baseUrlPosAdminWS: 'https://desarrollo.megapaca.gt/PosAdminWS/api/',
                    baseUrlInventarioWS: 'https://desarrollo.megapaca.gt/InventarioWS/api/',
                    baseUrlPagosWS: 'https://desarrollo.megapaca.gt/PagosWS/api/',
                    baseUrlRecursosHumanosWS: 'https://desarrollo.megapaca.gt/RecursosHumanosWS/api/',
                    baseUrlAccountCatalogWS: 'https://desarrollo.megapaca.gt/account-catalog-ws/api/',
                    baseUrlUserWS: 'https://desarrollo.megapaca.gt/user-ws/api/',
                    baseUrlFiles: 'http://testing.megapaca.gt/ms/images',
                    baseUrlInterfazCompanyConfigWS: 'https://desarrollo.megapaca.gt/interfaz-config-ws/api/',
                    baseUrlOperaciones2ConfigWS: 'https://desarrollo.megapaca.gt/operaciones2-config-ws/api/',
                },
                development: {
                    clientId: 'a355631f-de45-4fa9-9dd9-af6b90c1645f',
                    secret: 'XkbTgL894oG2zkS7nkk3-WAc1Qfq7YO5dLY22P0MwaksGHHUhPk9DiBcFLaTSURoBSQg60fdbAJ7lfBDK1JTRw',
                    hostOIC: 'https://desarrollo.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    baseUrl: 'https://desarrollo.megapaca.gt/PresupuestosWS/api/',
                    baseUrlGeneral: 'https://desarrollo.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://desarrollo.megapaca.gt/UsuarioWS/api/',
                    baseUrlTicketsWS: 'https://desarrollo.megapaca.gt/TicketsWS/api/',
                    baseUrlSharedFiles: 'http://testing.megapaca.gt/ms/images',
                    baseUrlComprasWS: 'https://desarrollo.megapaca.gt/ComprasWS/api/',
                    imagesApps: 'https://www.megapaca.com.gt/images/logosapps/v1/p/pms',
                    baseUrlActivosFijosWS: 'https://desarrollo.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlInterfazWS: 'https://desarrollo.megapaca.gt/InterfazWS/api/',
                    baseUrlNotificacionesWS: 'https://desarrollo.megapaca.gt/NotificacionesWS/api/',
                    baseUrlProyectosWS: 'https://desarrollo.megapaca.gt/ProyectosWS/api/',
                    baseUrlPosAdminWS: 'https://desarrollo.megapaca.gt/PosAdminWS/api/',
                    baseUrlInventarioWS: 'https://desarrollo.megapaca.gt/InventarioWS/api/',
                    baseUrlPagosWS: 'https://desarrollo.megapaca.gt/PagosWS/api/',
                    baseUrlRecursosHumanosWS: 'https://desarrollo.megapaca.gt/RecursosHumanosWS/api/',
                    baseUrlAccountCatalogWS: 'https://desarrollo.megapaca.gt/account-catalog-ws/api/',
                    baseUrlUserWS: 'https://desarrollo.megapaca.gt/user-ws/api/',
                    baseUrlFiles: 'http://testing.megapaca.gt/ms/images',
                    baseUrlInterfazCompanyConfigWS: 'https://desarrollo.megapaca.gt/interfaz-config-ws/api/',
                    baseUrlOperaciones2ConfigWS: 'https://desarrollo.megapaca.gt/operaciones2-config-ws/api/',
                },
                test: {
                    clientId: '5eb1b6a0-bd84-4be0-94f7-964616a5de2c',
                    secret: 'ANLTkyU5Ndk835M5J6t63suxINNcWDdAQsu9W_hdoPPAx1KUpG-AE14hC1Mcor5mx9NMAjIqYmCQakKOO7bRcOQ',
                    hostOIC: 'https://pruebas.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    baseUrl: 'https://pruebas.megapaca.gt/PresupuestosWS/api/',
                    baseUrlGeneral: 'https://pruebas.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://pruebas.megapaca.gt/UsuarioWS/api/',
                    baseUrlTicketsWS: 'https://pruebas.megapaca.gt/TicketsWS/api/',
                    baseUrlSharedFiles: 'http://testing.megapaca.gt/ms/images',
                    baseUrlComprasWS: 'https://pruebas.megapaca.gt/ComprasWS/api/',
                    imagesApps: 'https://www.megapaca.com.gt/images/logosapps/v1/p/pms',
                    baseUrlActivosFijosWS: 'https://pruebas.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlInterfazWS: 'https://pruebas.megapaca.gt/InterfazWS/api/',
                    baseUrlNotificacionesWS: 'https://pruebas.megapaca.gt/NotificacionesWS/api/',
                    baseUrlProyectosWS: 'https://pruebas.megapaca.gt/ProyectosWS/api/',
                    baseUrlPosAdminWS: 'https://pruebas.megapaca.gt/PosAdminWS/api/',
                    baseUrlInventarioWS: 'https://pruebas.megapaca.gt/InventarioWS/api/',
                    baseUrlPagosWS: 'https://pruebas.megapaca.gt/PagosWS/api/',
                    baseUrlRecursosHumanosWS: 'https://pruebas.megapaca.gt/RecursosHumanosWS/api/',
                    baseUrlAccountCatalogWS: 'https://pruebas.megapaca.gt/account-catalog-ws/api/',
                    baseUrlUserWS: 'https://pruebas.megapaca.gt/user-ws/api/',
                    baseUrlFiles: 'http://testing.megapaca.gt/ms/images',
                    baseUrlInterfazCompanyConfigWS: 'https://pruebas.megapaca.gt/interfaz-config-ws/api/',
                    baseUrlOperaciones2ConfigWS: 'https://pruebas.megapaca.gt/operaciones2-config-ws/api/',
                },
                production: {
                    clientId: '3b60d6f8-1be6-48e2-8849-e205716510ef',
                    secret: 'AOjnOfYL2c-blgQQkCC0-Mt4ZTOJMq-JLFbUDBzftkcc5wc8Tk8zeZwbHthchbfzoqeDSl912mv5TTeMFQpntbY',
                    hostOIC: 'https://www.megapaca.gt/',
                    appOIC: 'openid-connect-server-webapp',
                    baseUrl: 'https://www.megapaca.gt/PresupuestosWS/api/',
                    baseUrlGeneral: 'https://www.megapaca.gt/GeneralWS/api/',
                    baseUrlUsuarioWS: 'https://www.megapaca.gt/UsuarioWS/api/',
                    baseUrlTicketsWS: 'https://www.megapaca.gt/TicketsWS/api/',
                    baseUrlSharedFiles: 'https://www.megapaca.com/ms/images',
                    baseUrlComprasWS: 'https://www.megapaca.gt/ComprasWS/api/',
                    imagesApps: 'https://www.megapaca.com.gt/images/logosapps/v1/p/pms',
                    baseUrlActivosFijosWS: 'https://www.megapaca.gt/ActivosFijosWS/api/',
                    baseUrlInterfazWS: 'https://www.megapaca.gt/InterfazWS/api/',
                    baseUrlNotificacionesWS: 'https://www.megapaca.gt/NotificacionesWS/api/',
                    baseUrlProyectosWS: 'https://www.megapaca.gt/ProyectosWS/api/',
                    baseUrlPosAdminWS: 'https://www.megapaca.gt/PosAdminWS/api/',
                    baseUrlInventarioWS: 'https://www.megapaca.gt/InventarioWS/api/',
                    baseUrlPagosWS: 'https://www.megapaca.gt/PagosWS/api/',
                    baseUrlRecursosHumanosWS: 'https://www.megapaca.gt/RecursosHumanosWS/api/',
                    baseUrlAccountCatalogWS: 'https://www.megapaca.gt/account-catalog-ws/api/',
                    baseUrlUserWS: 'https://www.megapaca.gt/user-ws/api/',
                    baseUrlFiles: 'https://www.megapaca.com/ms/images',
                    baseUrlInterfazCompanyConfigWS: 'https://www.megapaca.gt/interfaz-config-ws/api/',
                    baseUrlOperaciones2ConfigWS: 'https://www.megapaca.gt/operaciones2-config-ws/api/',
                }
            }
        });
        envServiceProvider.check();

        var win = $windowProvider.$get();
        $authProvider.oauth2({
            name: 'OIDC',
            url: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/token',
            userInfo: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/userinfo',
            clientId: envServiceProvider.read('clientId'),
            secret: envServiceProvider.read('secret'),
            tokenName: 'access_token',
            redirectUri: win.location.origin || win.location.protocol + '//' + win.location.host,
            authorizationEndpoint: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/authorize',
            endSesionEndPoint: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/endsession',
            revokeEndPoint: envServiceProvider.read('hostOIC') + envServiceProvider.read('appOIC') + '/revoke',
            scope: ['address', 'phone', 'openid', 'profile', 'email'],
            scopeDelimiter: '+'
        });
    }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .factory('api', apiService);

  /** @ngInject */
  function apiService($resource, envService, $http) {

    var api = {};

    var interceptor = {
      response: function (response) {
        var result = response.resource;
        result.$status = response.status;
        result.$data = response.data;
        return result;
      }
    };

    api.baseUrl = envService.read('baseUrl');
    api.baseUrlGeneral = envService.read('baseUrlGeneral');
    api.baseUrlTicketsWS = envService.read('baseUrlTicketsWS');
    api.baseUrlLocal = 'app/data/';
    api.baseUrlUsuarioWS = envService.read('baseUrlUsuarioWS');
    api.baseUrlComprasWS = envService.read('baseUrlComprasWS');
    api.baseUrlActivosFijosWS = envService.read('baseUrlActivosFijosWS');
    api.baseUrlInterfazWS = envService.read('baseUrlInterfazWS');
    api.baseUrlNotificacionesWS = envService.read('baseUrlNotificacionesWS');
    api.baseUrlProyectosWS = envService.read('baseUrlProyectosWS');
    api.baseUrlInterfazCompanyConfigWS = envService.read('baseUrlInterfazCompanyConfigWS');
    api.baseUrlPosAdminWS = envService.read('baseUrlPosAdminWS');
    api.baseUrlInventarioWS = envService.read('baseUrlInventarioWS');
    api.baseUrlPagosWS = envService.read('baseUrlPagosWS');
    api.baseUrlRecursosHumanosWS = envService.read('baseUrlRecursosHumanosWS');
    api.baseUrlAccountCatalogWS = envService.read('baseUrlAccountCatalogWS');
    api.baseUrlUserWS = envService.read('baseUrlUserWS');
    api.baseUrlFiles = envService.read('baseUrlFiles');
    api.baseUrlOperaciones2ConfigWS = envService.read('baseUrlOperaciones2ConfigWS');

    api.UsuarioWS = {
      UserInfo: $resource(api.baseUrlUsuarioWS + 'UserInfo/:sub', {
        id: '@_sub'
      }, {
          update: {
            method: 'PUT'
          },
          patch: {
            method: 'PATCH'
          },
          save: {
            method: 'POST',
            params: {
              companyid: '@companyid'
            }
          }
        }),
      UserPass: $resource(api.baseUrlUsuarioWS + 'UserInfo/changePassword/:sub', {
        id: '@_sub'
      }, {
          update: {
            method: 'PUT'
          }
        }),
      forgotPassword: $resource(api.baseUrlUsuarioWS + 'UserInfo/forgotPassword/:username', {
        'username': '@username'
      }, {
          update: {
            method: 'PUT'
          }
        }),
      Me: $resource(envService.read('hostOIC') + envService.read('appOIC') + '/userinfo'),
      Yo: $resource(api.baseUrlUsuarioWS + 'me')
    };

    api.GeneralWS = {
      Usr: {
        User: {
          Company: {
            me: $resource(api.baseUrlGeneral + 'User/company/:company', {
              'company': '@company'
            }, {
                page: {
                  method: 'GET',
                  isArray: false
                }
              }),
              CompanyRolUser: $resource(api.baseUrlGeneral + 'Company/CompanyRolUser', {}, {
                page: {
                    method: 'GET',
                    isArray: true
                }
            })
          },
          basicUserInformation: $resource(api.baseUrlGeneral + 'User/Me/basicUserInformation', {}, {
            get: {
              method: 'GET'
            }
          }),
          getFilterByIds: $resource(api.baseUrlGeneral + 'User/getFilterByIds', {}, {
            getList: {
              method: 'POST',
              isArray: true
            }
          }),
        },
        UserCostCenter: {
          me: $resource(api.baseUrlGeneral + 'UserCostCenter/:idUsuario/:company', {
            'idUsuario': '@idUsuario',
            'company': '@company'
          }, {
              'page': {
                method: 'GET',
                params: {
                  'pageNumber': '@pageNumber',
                  'pageSize': '@pageSize',
                  'search': '@search'
                },
                isArray: false
              },
              'create': {
                method: 'POST',
                params: {
                  'associateAll': '@associateAll'
                },
                isArray: false
              },
              'update': {
                method: 'PUT',
                params: {
                  'deleteAll': '@deleteAll'
                },
                isArray: false
              }
            })
        },
        UserDepartment: {
          me: $resource(api.baseUrlGeneral + 'UserDepartment/:idUsuario/:company', {
            'idUsuario': '@idUsuario',
            '@company': '@company'
          }, {
              'page': {
                method: 'GET',
                params: {
                  'pageNumber': '@pageNumber',
                  'pageSize': '@pageSize',
                  'search': '@search'
                },
                isArray: false
              },
              'create': {
                method: 'POST',
                params: {
                  'associateAll': '@associateAll',
                  'search': '@search'
                },
                isArray: false
              },
              'update': {
                method: 'PUT',
                params: {
                  'deleteAll': '@deleteAll',
                  'search': '@search'
                },
                isArray: false
              }
            })
        },
        UserParameter: $resource(api.baseUrlGeneral + 'UserParameter/:userParameterId', {
          'userParameterId': '@userParameterId'
        }, {
            create: {
              method: 'POST'
            },
            update: {
              method: 'PUT'
            }
          }),
        ParameterCompanyCanUpdate: $resource(api.baseUrlGeneral + 'UserParameter/companyCanUpdate', { 'idUsuario': '@idUsuario' }, {
          page: {
            method: 'GET',
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            },
            isArray: false
          },
          get: {
            method: 'GET'
          }
        }),
        UserCountry: {
          me: $resource(api.baseUrlGeneral + 'UserCountry/:company/:idUsuario', { 'company': '@company', 'idUsuario': '@idUsuario' }, {
            create: {
              method: 'POST',
              params: {
                'associateAll': '@associateAll'
              },
              isArray: false
            },
            update: {
              method: 'PUT',
              params: {
                'deleteAll': '@deleteAll'
              },
              isArray: false
            }
          }),
          AssociatedToUser: $resource(api.baseUrlGeneral + 'UserCountry/byUser/:idUsuario', { 'idUsuario': '@idUsuario' }, {
            page: {
              method: 'GET',
              params: {
                'page': '@page',
                'pageSize': '@pageSize',
                'search': '@search'
              },
              isArray: false
            }
          })
        },
        AssociateEquivalenceRole: {
          me: $resource(api.baseUrlGeneral + 'CompanyRoleEquivalence/:id', {
            'id': '@id'
          }, {
              create: {
                method: 'POST',
                isArray: false
              },
              update: {
                method: 'PUT',
                isArray: false
              }
            }),
          allWithRoleNotPresentByCompanyAndApplication: $resource(api.baseUrlGeneral + 'CompanyRoleEquivalence/all/withRoleNotPresent', {}, {
            get: {
              method: 'GET',
              isArray: true
            }
          }),
          getAllRole: $resource(api.baseUrlGeneral + 'Role', {}, {
            get: {
              method: 'GET',
              isArray: true
            },
          }),
        },
      },
      UserInvitation: $resource(api.baseUrlGeneral + 'UserInvitation/inviteUser/:companyid/:rol', {
        companyid: '@companyid',
        rol: '@rol'
      }, {
          sendInvitation: {
            method: 'POST'
          }
        }),
      UserGuest: {
        byCompany: $resource(api.baseUrlGeneral + 'UserInvitation/guest/:company', {
          'company': '@company'
        }, {
          page: {
            method: 'GET',
            isArray: false
          }
        }),
      },
      Application: $resource(api.baseUrlGeneral + 'Application/:app', {
        id: '@_app'
      }, {
          page: {
            method: 'GET',
            params: {
              pageNumber: '@pageNumber',
              pageSize: '@pageSize'
            },
            isArray: false,
          },
          get: {
            method: 'GET',
            isArray: false
          }
        }),
      ApplicationParameter: $resource(api.baseUrlGeneral + 'Application/:app/Parameter', {
        id: '@_app'
      }, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
      ApplicationParameterByApplication: $resource(api.baseUrlGeneral + 'Application/:app/Parameter/byApplication', {
        id: '@_app'
      }, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
      ApplicationById: $resource(api.baseUrlGeneral + 'Application/byId/:applicationId', {
        'applicationId': '@applicationId'
      }),
      ApplicationByUser: $resource(api.baseUrlGeneral + 'Application/byUser'),
      allApplicationsByUser: $resource(api.baseUrlGeneral + 'Application/allApplicationByUser', {
        'companyId': '@companyId'
      }, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
      RoleApplication: {
        me: $resource(api.baseUrlGeneral + 'Application/:applicationId/Role/:id', {
          'applicationId': '@applicationId',
          'id': '@_id'
        }, {
            page: {
              method: 'GET',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            },
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            },
            create: {
              'method': 'POST',
              'interceptor': interceptor
            },
            get: {
              method: 'GET',
              isArray: true
            }
          }),
        byLevel: $resource(api.baseUrlGeneral + 'Application/:applicationId/Role/:id/byLevel/:level', {
          'applicationId': '@applicationId',
          'id': '@_id',
          'level': '@level'
        }, {
            page: {
              method: 'GET',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            }
          }),
      },
      RoleMenu: {
        me: $resource(api.baseUrlGeneral + 'RoleApplication/:roleApplicationId/RoleMenu/:id', {
          'id': '@id'
        }, {
            query: {
              method: 'GET',
              isArray: true
            },
            create: {
              'method': 'POST',
              'interceptor': interceptor
            },
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            }
          })
      },
      RoleSpecialAction: {
        me: $resource(api.baseUrlGeneral + 'RoleApplication/:roleApplicationId/RoleSpecialAction/:id', {
          'id': '@id'
        }, {
            query: {
              method: 'GET',
              isArray: false
            },
            create: {
              'method': 'POST',
              'interceptor': interceptor
            },
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            }
          }),
        notAssociatedToRole: $resource(api.baseUrlGeneral + 'RoleApplication/:roleApplicationId/RoleSpecialAction/notAssociatedToRole', {
          'roleApplicationId': '@roleApplicationId'
        }, {
            page: {
              method: 'GET',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize',
                'search': '@search'
              },
              isArray: false
            }
          }),
        byApplication: $resource(api.baseUrlGeneral + 'RoleApplication/:roleApplicationId/RoleSpecialAction/byApplication', {
          'roleApplicationId': '@roleApplicationId'
        }, {
            get: {
              method: 'GET',
              isArray: false
            }
          })
      },
      RoleCompanySpecialAction: {
        RoleCompanySpecialAction: $resource(api.baseUrlGeneral + 'RoleCompanySpecialAction/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: true
            },
            update: {
              method: 'PUT',
              isArray: true
            }
          }),
        notAssociated: $resource(api.baseUrlGeneral + 'RoleCompanySpecialAction/notAssociated', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        associated: $resource(api.baseUrlGeneral + 'RoleCompanySpecialAction/associated', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        })
      },
      AllFavoriteGroup: $resource(api.baseUrlGeneral + 'FavoriteGroup/:id', {
        id: '@id'
      }, {
          get: {
            method: 'GET'
          },
          update: {
            method: 'PUT'
          }
        }),
      AllFavoriteGroupType: $resource(api.baseUrlGeneral + 'FavoriteGroup/groupType', {}, {}),
      CompanyEstablishmentCompanyWarehouse: {
        me: $resource(api.baseUrlGeneral + 'CompanyEstablishment/:establishmentId/CompanyWarehouse', { 'establishmentId': '@establishmentId' }, {
          create: {
            method: 'POST',
            params: {
              'associateAll': '@associateAll'
            },
            isArray: false
          },
          update: {
            method: 'PUT',
            params: {
              'deleteAll': '@deleteAll'
            },
            isArray: false
          }
        })
      },
      EstablismentRoleUser: {
        notAssociatedToUser: $resource(api.baseUrlGeneral + 'EstablishmentRoleUser/notAssociatedToUser/', {}, {
          page: {
            method: 'GET',
            params: {
              'userId': '@userId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        associatedToUser: $resource(api.baseUrlGeneral + 'EstablishmentRoleUser/associatedToUser/', {}, {
          page: {
            method: 'GET',
            params: {
              'userId': '@userId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        byUser: $resource(api.baseUrlGeneral + 'EstablishmentRoleUser/', {}, {
          create: {
            method: 'POST',
            params: {
              'idCircle': '@idCircle',
              'userId': '@userId',
              'associateAll': '@associateAll',
              'level': '@level'
            },
            'interceptor': interceptor
          },
          update: {
            method: 'PUT',
            'interceptor': interceptor
          },
          page: {
            method: 'GET',
            isArray: false
          }
        }),
        establishmentNotAssociatedToUser: $resource(api.baseUrlGeneral + 'EstablishmentRoleUser/byRoleApplication/:roleApplicationId/notAssociatedToUser', {
          'roleApplicationId': '@roleApplicationId'
        }, {
          page: {
            method: 'GET',
            params: {
              'userId': '@userId',
              'companyId': '@companyId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        establishmentAssociatedToUser: $resource(api.baseUrlGeneral + 'EstablishmentRoleUser/byRoleApplication/:roleApplicationId/associatedToUser', {
          'roleApplicationId': '@roleApplicationId'
        }, {
          page: {
            method: 'GET',
            params: {
              'userId': '@userId',
              'companyId': '@companyId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        byRoleApplication: $resource(api.baseUrlGeneral + 'EstablishmentRoleUser/byRoleApplication/:roleApplicationId', {
          'roleApplicationId': '@roleApplicationId'
        }, {
          create: {
            method: 'POST',
            params: {
              'userId': '@userId',
              'companyId': '@companyId',
              'associateAll': '@associateAll',
              'search': '@search'
            },
            'interceptor': interceptor
          },
          update: {
            method: 'PUT',
            params: {
              'userId': '@userId',
              'companyId': '@companyId',
              'deleteAll': '@associateAll',
              'search': '@search'
            },
            'interceptor': interceptor
          }
        })
      },
      CompaniesGroup: $resource(api.baseUrlGeneral + 'FavoriteGroup/:group/companyMembers/:size/:page', {
        group: '@group',
        page: '@page',
        size: '@size'
      }),
      FavoriteGroupMembers: $resource(api.baseUrlGeneral + 'FavoriteGroup/:group/members', {
        group: '@group'
      }, {
          add: {
            method: 'POST',
            isArray: true
          },
          companyMembers: {
            method: 'GET',
            isArray: true
          },
          remove: {
            method: 'PUT',
            isArray: true
          }
        }),
      AllBlockedSeries: $resource(api.baseUrlGeneral + 'BlockedSerie/:id', {
        id: '@id'
      }, {
          get: {
            method: 'GET'
          },
          delete: {
            method: 'DELETE'
          }
        }),
      allExchangeRate: $resource(api.baseUrlGeneral + 'ExchangeRate/:id', {
        id: '@id'
      }, {
          get: {
            method: 'GET'
          },
          delete: {
            method: 'DELETE'
          },
          create: {
            method: 'POST',
            isArray: true

          },
          update: {
            method: 'PUT'
          }

        }),
      getAllExchangeRate: $resource(api.baseUrlGeneral + 'ExchangeRate/getExchangeRate/:size/:page', {
        page: '@page',
        size: '@size'
      }, {
          get: {
            method: 'GET'
          }

        }),
      UserSub: $resource(api.baseUrlGeneral + 'User/sub/:sub', {
        sub: '@_sub'
      }, {
          update: {
            method: 'PUT'
          },
          patch: {
            method: 'PATCH'
          }
        }),
      User: $resource(api.baseUrlGeneral + 'User/:id', {
        id: '@_id'
      }, {
          update: {
            method: 'PUT'
          },
          patch: {
            method: 'PATCH'
          },
          save: {
            method: 'POST',
            params: {
              companyid: '@companyid'
            }
          }
        }),
      UserDepartment: $resource(api.baseUrlGeneral + 'User/departments', {}, {
        get: {
          method: 'GET',
          isArray: true,
          params: {
            companyId: '@companyId'
          }
        }
      }),
      UserCostCenter: $resource(api.baseUrlGeneral + 'User/costcenter', {}, {
        get: {
          method: 'GET',
          isArray: true,
          params: {
            companyId: '@companyId'
          }
        }
      }),
      TransactionType: $resource(api.baseUrlGeneral + 'TransactionType/:id', {
        id: '@_id'
      }),
      DocumentType: $resource(api.baseUrlGeneral + 'DocumentType/Country/:id', {
        id: '@id'
      }, {
          getAll: {
            method: 'GET',
            isArray: true,
            params: {
              category: '@category'
            }
          }
        }),
      LoadFiles: $resource(api.baseUrlGeneral + 'FileStorage/:fileName/Files', {
        fileName: '@fileName'
      }, {
          save: {
            method: 'POST',
            isArray: true,
            transformRequest: angular.identity,
            headers: {
              'Content-Type': undefined
            }
          }
        }),
      Department: $resource(api.baseUrlGeneral + 'Company/:idc/Department/:idPath', {
        idc: '@idc',
        idPath: '@idPath'
      }, {
          page: {
            method: 'GET',
            params: {
              'page': '@page',
              'pageSize': '@pageSize',
              'search': '@search'
            },
            isArray: false
          },
          create: {
            'method': 'POST',
            'interceptor': interceptor
          },
          update: {
            'method': 'PUT',
            'interceptor': interceptor
          }
        }),
      BusinessCircle: {
        me: $resource(api.baseUrlGeneral + 'BusinessCircle/', {}, {}),
        notAssociatedToUser: $resource(api.baseUrlGeneral + 'BusinessCircle/Company/:companyId/notAssociatedToUser/app/:app', {
          'companyId': '@companyId',
          'app': '@app'
        }, {
            page: {
              method: 'GET',
              params: {
                'userId': '@userId',
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            }
          })
      },
      BusinessCircleMembers: {
        me: $resource(api.baseUrlGeneral + 'BusinessCircleMembers/', {}, {
          create: {
            method: 'POST',
            params: {
              'companyId': '@companyId',
              'userId': '@userId',
              'associateAll': '@associateAll',
              'level': '@level'
            },
            'interceptor': interceptor
          },
          update: {
            method: 'PUT',
            'interceptor': interceptor
          }
        }),
        company: {
          user: {
            me: $resource(api.baseUrlGeneral + 'BusinessCircleMembers/company/:company/user/:user/app/:app', {
              'company': '@company',
              'user': '@user',
              'app': '@app'
            }, {
                'page': {
                  method: 'GET',
                  params: {
                    'pageNumber': '@pageNumber',
                    'pageSize': '@pageSize'
                  }
                },
                'delete': {
                  method: 'DELETE',
                  params: {}
                }
              })
          }
        },
        allMembers: $resource(api.baseUrlGeneral + 'BusinessCircleMembers/allMembers/company/:company/app/:app', {
          'company': '@company',
          'app': '@app'
        }, {})
      },
      Product: $resource(api.baseUrlGeneral + 'Product/:id', {
        id: '@id'
      }, {
        create: {
          method: 'POST',
          'interceptor': interceptor
        },
        update: {
          method: 'PUT',
          'interceptor': interceptor
        }
      }),
      ProductPhotos: {
        addPhotos:  function (params, body) {
            const fd = addToFdFile(body, 'files');
            return $http.post(api.baseUrlGeneral + 'ProductPhotos/addToProduct/' + params.id, fd, {
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            });
        },
        deletePhoto: $resource(api.baseUrlGeneral + 'ProductPhotos/:id', {
          id: '@id'
      }, {
          'delete': {
          'method': 'DELETE'
          }
      })
      },
      ProductPricePreNegociated: $resource(api.baseUrlGeneral + 'Product/preNegociated', {}, {
        getByFilter: {
          method: 'POST',
          isArray: false
        }
      }),
      ProviderByProductPreNegociated: $resource(api.baseUrlGeneral + 'Product/providerByProductPreNegociated', {}, {
        getByFilter: {
          method: 'GET',
          isArray: true
        }
      }),
      ProductValidated: $resource(api.baseUrlGeneral + 'Product/productValidatedCompany', {}, {
        getValidated: {
          method: 'GET',
          'interceptor': interceptor
        }
      }),
      ProductFilter: $resource(api.baseUrlGeneral + 'ProductFilter/:id', {
        id: '@id'
      }, {
          getByFilter: {
            method: 'POST',
            'interceptor': interceptor
          },
          update: {
            method: 'PUT',
            'interceptor': interceptor
          }
        }),
      ProductAccount: {
        getAccount: $resource(api.baseUrlGeneral + 'Product/account/company/:company/product/:product', {
          company: '@company',
          product: '@product'
        }),
        Account: $resource(api.baseUrlGeneral + 'Product/account/:product', {
          product: '@product'
        }, {
            create: {
              'method': 'POST',
              'interceptor': interceptor
            },
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            }
          }),
        notAssociatedToDepartment: $resource(api.baseUrlGeneral + 'Product/:companyId/:departmentId/notAssociatedToDepartment', {
          'companyId': '@companyId',
          'departmentId': '@departmentId'
        }, {
            page: {
              method: 'GET',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize',
                'search': '@search'
              }
            }
          }),
        myProducts: $resource(api.baseUrlGeneral + 'Product/:companyId/myProducts', {
          'companyId': '@companyId'
        }, {
            page: {
              method: 'GET',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize',
                'search': '@search'
              }
            },
            delete: {
              method: 'DELETE'
            }
          })
      },
      ProductCategory: {
        me: $resource(api.baseUrlGeneral + 'ProductCategory/', {}, {}),
        Children: $resource(api.baseUrlGeneral + 'ProductCategory/:productCategoryId/Children', {
          'productCategoryId': '@productCategoryId'
        }, {
            'query': {
              'method': 'GET',
              'isArray': true,
              'params': {}
            }
          }),
        TreeNodeChildren: $resource(api.baseUrlGeneral + 'ProductCategory/TreeCategory/:productCategoryId/Children', {
          'productCategoryId': '@productCategoryId'
        }, {
            'query': {
              'method': 'GET',
              'isArray': true,
              'params': {}
            }
          })
      },
      ProductCategoryFeature: {
        me: $resource(api.baseUrlGeneral + 'ProductCategory/:productCategoryId/Feature', {
          'productCategoryId': '@productCategoryId'
        }, {
            'page': {
              'method': 'GET',
              'isArray': false,
              'params': {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            },
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            }
          })
      },
      ProductCondition: {
        allActive: $resource(api.baseUrlGeneral + 'ProductCondition/active', {}, {
            query: {
                method: 'GET',
                isArray: true
            }
        })
      },
      ProductGender: {
        allActive: $resource(api.baseUrlGeneral + 'ProductGender/all/active', {}, {
            query: {
                method: 'GET',
                isArray: true,
            }
        }),
      },
      ProductCompanyGroup: {
        me: $resource(api.baseUrlGeneral + 'ProductCompanyGroup/:company/:id', {
          'company': '@company',
          'id': '@id'
        }, {
            page: {
              'method': 'GET',
              'isArray': false,
              'params': {
                'page': '@page',
                'pageSize': '@pageSize'
              }
            },
            create: {
              'method': 'POST',
              'interceptor': interceptor
            },
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            }
          }),
        allActive: $resource(api.baseUrlGeneral + 'ProductCompanyGroup/:company/isActive', {
          'company': '@company'
        }, {})
      },
      Feature: {
        me: $resource(api.baseUrlGeneral + 'Feature', {}, {
          'query': {
            'method': 'GET',
            'isArray': true
          },
          'page': {
            'method': 'GET',
            'params': {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          },
          'create': {
            'method': 'POST',
            'interceptor': interceptor
          },
          'update': {
            'method': 'PUT',
            'interceptor': interceptor
          }
        }),
        notAssociatedToCategory: $resource(api.baseUrlGeneral + 'Feature/notAssociatedToCategory', {}, {
          'page': {
            'method': 'GET',
            'isArray': false,
            'params': {
              'categoryId': '@categoryId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        })
      },
      FeatureValue: {
        me: $resource(api.baseUrlGeneral + 'Feature/:featureId/Value/', {
          'featureId': '@featureId'
        }, {
            'query': {
              'method': 'GET',
              'isArray': true
            },
            'create': {
              'method': 'POST',
              'params': {},
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'params': {},
              'interceptor': interceptor
            }
          })
      },
      FeatureMeasurementUnit: {
        me: $resource(api.baseUrlGeneral + 'Feature/:featureId/MeasurementUnit/', {
          'featureId': '@featureId'
        }, {
            'query': {
              'method': 'GET',
              'isArray': true
            },
            'page': {
              'method': 'GET',
              'isArray': false,
              'params': {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            },
            'create': {
              'method': 'POST',
              'isArray': false,
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'isArray': false,
              'interceptor': interceptor
            }
          }),
        associate: $resource(api.baseUrlGeneral + 'Feature/:featureId/MeasurementUnit/associated/', {
          'featureId': '@featureId'
        }, {
            'create': {
              'method': 'POST',
              'isArray': true,
              'params': {
                'associateAll': '@associateAll'
              },
              'interceptor': interceptor
            }
          }),
        deactive: $resource(api.baseUrlGeneral + 'Feature/:featureId/MeasurementUnit/deactive/', {
          'featureId': '@featureId'
        }, {
            'create': {
              'method': 'PUT',
              'isArray': true,
              'params': {
                'deactiveAll': '@deactiveAll'
              },
              'interceptor': interceptor
            }
          })
      },
      Currency: $resource(api.baseUrlGeneral + 'Currency/:id', {
        id: '@id'
      }, {
          page: {
            method: 'GET',
            params: {
              'page': '@page',
              'pageSize': '@pageSize'
            }
          },
          create: {
            'method': 'POST',
            'interceptor': interceptor
          },
          update: {
            'method': 'PUT',
            'interceptor': interceptor
          },
          get: {
            'method': 'GET',
            'isArray': true,
            'interceptor': interceptor
          }
        }),
      getAllCurrency: $resource(api.baseUrlGeneral + 'Currency/isActive'),
      CostCenter: $resource(api.baseUrlGeneral + 'Company/:idc/CostCenter/:idPath', {
        idc: '@idc',
        idPath: '@idPath'
      }, {
          query: {
            method: 'GET',
            isArray: true
          },
          filter: {
            method: 'POST',
            isArray: true
          },
          page: {
            method: 'GET',
            params: {
              'page': '@page',
              'pageSize': '@pageSize',
              'search': '@search'
            },
            isArray: false
          },
          create: {
            'method': 'POST',
            'interceptor': interceptor
          },
          update: {
            'method': 'PUT',
            'interceptor': interceptor
          }
        }),
      CostCenters: {
        allUserInfo: $resource(api.baseUrlGeneral + 'Company/:company/CostCenter/allUserInfo', {
          'company': '@company'
        }, {
            get: {
              'method': 'GET',
              isArray: true
            }
          })
      },
      Departments: {
        allUserInfo: $resource(api.baseUrlGeneral + 'Company/:company/Department/allUserInfo', {
          'company': '@company'
        }, {
            get: {
              'method': 'GET',
              isArray: true
            }
          })
      },
      MyCircles: $resource(api.baseUrlGeneral + 'BusinessCircle/me'),
      Company: $resource(api.baseUrlGeneral + 'Company/:id', {
        id: '@id'
      }, {
          update: {
            method: 'PUT'
          },
          create: {
            method: 'POST'
          },
          getByMe: {
            method: 'GET',
            isArray: true
          },
          page: {
            method: 'GET',
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'search': '@search'
            }
          },
          deleteLogo: {
            method: 'DELETE'
          }
        }),
      CompaniesVerifieds: $resource(api.baseUrlGeneral + 'Company/isActiveAndVerified', {}, {
        getAll: {
          method: 'GET',
          isArray: true
        }
      }),
      CompanyApi: {
        updateWarehouseOperacoinesId: $resource(api.baseUrlGeneral + 'Company/:id/updateWarehouseOperacionesId', {
          id: '@id',
        }, {
          update: {
            method: 'PUT',
            isArray: false,
            params: {
              'warehouseId': '@warehouseId',
            },
          },
        }),
      },
      CompanyWithDataRequired: {
        addCompany: $resource(api.baseUrlGeneral + 'Company/createByCompanyDTO', {}, {
          add: {
            method: 'POST',
            isArray: false
          }
        }),
        editCompany: $resource(api.baseUrlGeneral + 'Company/:id/updateByCompanyDTO', {
          id: '@id'
        }, {
         update: {
          method: 'PUT',
          isArray: false
         }
        })
      },
      CompanyLogo: {
        add: function (params, body) {
          var fd = addToFdFile(body, 'files');
          return $http.post(api.baseUrlGeneral + 'Company/' + params.id + '/logoUpload', fd, {
            transformRequest: angular.identity,
            headers: {
              'Content-Type': undefined
            }
          });
        }
      },
      CompanyDocument: $resource(api.baseUrlGeneral + 'Company/:company/Document/:id', {
        company: '@company',
        id: '@id'
      }, {
          addDocument: {
            method: 'POST',
            interceptor: interceptor
          },
          update: {
            method: 'PUT'
          },
          Delete: {
            method: 'DELETE',
            interceptor: interceptor
          },
          active: $resource(api.baseUrlGeneral + 'Company/:company/Document/isActive', {
            company: '@company/'
          }, {})
        }),
      Document: $resource(api.baseUrlGeneral + 'Document/:id', {
        id: '@id'
      }, {
          update: {
            method: 'PUT',
            params: {
              businessCircleId: '@businessCircleId'
            }
          }
        }),
      CompanyParameter: {
        me: $resource(api.baseUrlGeneral + 'Company/:company/Parameter/:id', {
          'company': '@company',
          'id': '@id'
        }, {
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            }
          }),
        application: $resource(api.baseUrlGeneral + 'Company/:company/Parameter/app/:app', {
          'app': '@app'
        }, {
            page: {
              method: 'GET',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            }
          }),
        byName: $resource(api.baseUrlGeneral + 'Company/:company/Parameter/:parameterName', {
          'parameterName': '@parameterName'
        }, {})
      },
      CompanyApplication: {
        me: $resource(api.baseUrlGeneral + 'Company/:company/Application/:app', {
          'company': '@company',
          'app': '@app'
        }, {
            create: {
              method: 'POST',
              'interceptor': interceptor
            },
            Delete: {
              method: 'DELETE',
              'interceptor': interceptor
            }
          }),
        notAssociatedToCompany: $resource(api.baseUrlGeneral + 'Company/:company/Application/notAssociatedToCompany', {
          'company': '@company'
        }, {}),
        appsByCompany: $resource(api.baseUrlGeneral + 'Company/:company/Application/byCompany', { 'company': '@company' }),
        byAppName: $resource(api.baseUrlGeneral + 'Company/:company/Application/:app', {
          'company': '@company',
          'app': '@app'
        }, {
            get: {
              method: 'GET',
              'interceptor': interceptor
            }
          }),
        companyRoleApplication: $resource(api.baseUrlGeneral + 'CompanyApplication/summary/:companyId', {'companyId': '@companyId'}, {})
      },
      RoleByApp: $resource(api.baseUrlGeneral + 'Role/app'),
      LoadAvatar: $resource(api.baseUrlGeneral + 'User/:sub/photoUpload', {
        sub: '@_sub'
      }, {
          save: {
            method: 'POST',
            transformRequest: angular.identity,
            headers: {
              'Content-Type': undefined
            }
          }
        }),
      Menu: {
        me: $resource(api.baseUrlGeneral + 'MenuItem', {}, {}),
        ByRole: $resource(api.baseUrlGeneral + 'MenuItem/byRole/:rol', {
          rol: '@rol'
        })
      },
      MenuItem: {
        Application: $resource(api.baseUrlGeneral + 'MenuItem/Application/:applicationId', {
          'applicationId': '@applicationId'
        }, {})
      },
      SpecialAction: {
        me: $resource(api.baseUrlGeneral + 'Application/:applicationId/SpecialAction', {
          'applicationId': '@applicationId'
        }, {})
      },
      Account: {
        Department: {
          notAssociatedToUser: $resource(api.baseUrlGeneral + 'Company/:idc/Department/notAssociatedToUser', {
            'idc': '@idc'
          }, {
              page: {
                method: 'GET',
                params: {
                  'userId': '@userId',
                  'pageNumber': '@pageNumber',
                  'pageSize': '@pageSize',
                  'search': '@search'
                },
                isArray: false
              }
            }),
          departmentTicket: $resource(api.baseUrlGeneral + 'Company/:idc/Department/departmentTicket', {
            'idc': '@idc'
          }, {
              query: {
                method: 'GET',
                params: {},
                isArray: true
              }
            }),
          Settings: $resource(api.baseUrlGeneral + 'Company/:idc/Department/:departmentId/Settings', {
            'idc': '@idc',
            'departmentId': '@departmentId'
          }, {
              update: {
                method: 'PUT'
              },
            })
        },
        DepartmentProduct: {
          me: $resource(api.baseUrlGeneral + 'Circle/:circleId/Department/:departmentId/Product', {
            'circleId': '@circleId',
            'departmentId': '@departmentId'
          }, {
              page: {
                method: 'GET',
                params: {
                  'pageNumber': '@pageNumber',
                  'pageSize': '@pageSize',
                  'search': '@search'
                }
              },
              add: {
                method: 'POST',
                isArray: true
              },
              remove: {
                method: 'PUT'
              }
            })
        },
        DepartmentProductByProd: {
          me: $resource(api.baseUrlGeneral + 'Circle/:circleId/Department/:departmentId/Product/byProduct', {
            'circleId': '@circleId',
            'departmentId': '@departmentId'
          }, {
              page: {
                method: 'GET',
                params: {
                  'productId': '@productId',
                  'companyId': '@companyId'
                },
                isArray: true
              }
            })
        },
        CostCenter: {
          notAssociatedToUser: $resource(api.baseUrlGeneral + 'Company/:idc/CostCenter/notAssociatedToUser', {
            'idc': '@idc'
          }, {
              page: {
                method: 'GET',
                params: {
                  'userId': '@userId',
                  'pageNumber': '@pageNumber',
                  'pageSize': '@pageSize',
                  'search': '@search'
                },
                isArray: false
              }
            })
        },
        ExpenseType: {
          me: $resource(api.baseUrlGeneral + 'ExpenseType/:company/:id', {
            'company': '@company',
            'id': '@id'
          }, {
              page: {
                'method': 'GET',
                'isArray': false,
                'params': {
                  'page': '@page',
                  'pageSize': '@pageSize'
                }
              },
              create: {
                'method': 'POST',
                'interceptor': interceptor
              },
              update: {
                'method': 'PUT',
                'interceptor': interceptor
              }
            }),
          allActive: $resource(api.baseUrlGeneral + 'ExpenseType/:company/isActive', {
            'company': '@company'
          }, {})
        },
        AccountType: {
          me: $resource(api.baseUrlGeneral + 'AccountType/:company/:id', {
            'company': '@company',
            'id': '@id'
          }, {
              page: {
                'method': 'GET',
                'isArray': false,
                'params': {
                  'page': '@page',
                  'pageSize': '@pageSize'
                }
              },
              list: {
                'method': 'GET',
                'isArray': true,
                'params': {
                  'page': '@page',
                  'pageSize': '@pageSize'
                }
              },
              create: {
                'method': 'POST',
                'interceptor': interceptor
              },
              update: {
                'method': 'PUT',
                'interceptor': interceptor
              }
            }),
          allActive: $resource(api.baseUrlGeneral + 'AccountType/:company/isActive', {
            'company': '@company'
          }, {})
        },
        AccountingCatalog: {
          me: $resource(api.baseUrlGeneral + 'AccountingCatalog/:company/:id', {
            'company': '@company',
            'id': '@id'
          }, {
              create: {
                'method': 'POST',
                'interceptor': interceptor
              },
              update: {
                'method': 'PUT',
                'interceptor': interceptor
              },
              get: {
                'method': 'GET',
                isArray: true
              }
            }),
          ByLevel: $resource(api.baseUrlGeneral + 'AccountingCatalog/:company/byLevel/:level', {
            company: '@company',
            level: '@level'
          }),
          ByParentLevel1: $resource(api.baseUrlGeneral + 'AccountingCatalog/:company/byParentLevel1/:level', {
            company: '@company',
            level: '@level'
          }),
          ByCode: $resource(api.baseUrlGeneral + 'AccountingCatalog/:company/byCode', {
            company: '@company'
          }),
          ByDescription: $resource(api.baseUrlGeneral + 'AccountingCatalog/:company/byDescription', {
            company: '@company'
          })
        },
        DimensionCompany: {
          me: $resource(api.baseUrlGeneral + 'DimensionCompany/:id', {
            'id': '@id'
          }, {
              create: {
                method: 'POST',
                isArray: false
              },
              update: {
                method: 'PUT',
                isArray: false
              }
            }),
            allWithDimensionNotPresent: $resource(api.baseUrlGeneral + 'DimensionCompany/all/withDimensionNotPresent', {}, {
            get: {
              method: 'GET',
              isArray: true
            }
          }),
          byCompanyActive: $resource(api.baseUrlGeneral + 'DimensionCompany/byCompanyActive/:company', {'company': '@company'}, {})
        },
        DimensionCompanyDetail: {
          me: $resource(api.baseUrlGeneral + 'DimensionCompanyDetail/:id', {
            'id': '@id'
          }, {
              create: {
                method: 'POST',
                isArray: false
              },
              update: {
                method: 'PUT',
                isArray: false
              },
              delete: {
                method: 'DELETE',
                isArray: false
              }
            }),
            allByDimensionCompany: $resource(api.baseUrlGeneral + 'DimensionCompanyDetail/all/byDimensionCompany', {}, {
            get: {
              method: 'GET',
              isArray: true
            }
          }),
          byIds: $resource(api.baseUrlGeneral + 'DimensionCompanyDetail/getDimensionCompanyDetailByIdList', {}, {
            getDetails: {
              method: 'GET',
              params: {'idList': '@idList'},
              isArray: true,
            }
          }),
          byDimensionCompanyIdList: $resource(api.baseUrlGeneral + 'DimensionCompanyDetail/byDimensionCompanyIdList', {}, {
            get: {
              method: 'GET',
              params: {
                'dimensionCompanyIdList': '@dimensionCompanyIdList'
              },
              isArray: true
            }
          })
        },
        CompanyAccount: {
          me: $resource(api.baseUrlGeneral + 'CompanyAccount/:id', { 'id': '@id' },
            {
              create: {
                method: 'POST',
                isArray: false,
              },
              update: {
                method: 'PUT',
                isArray: false,
              },
              delete: {
                method: 'DELETE',
                isArray: false,
              },
            }),
          byEstablishment: $resource(api.baseUrlGeneral + 'CompanyAccount/byEstablishmentId/:establishmentId', { 'establishmentId': '@establishmentId' },
            {
              get: {
                method: 'GET',
                isArray: true,
              }
            })
        },
      },
      Country: {
        me: $resource(api.baseUrlGeneral + 'Country', {}),
        notAssociatedToUser: $resource(api.baseUrlGeneral + 'Country/notAssociatedToUser', {}, {
          page: {
            method: 'GET',
            params: {
              'userId': '@userId',
              'page': '@page',
              'pageSize': '@pageSize',
              'search': '@search'
            },
            isArray: false
          }
        })
      },
      Regime: {
        getAllByCountry: $resource(api.baseUrlGeneral + 'Regime/Country/:id', {
          id: '@id'
        }, {})
      },
      CompanyRegime: $resource(api.baseUrlGeneral + 'Company/:id/setRegime', {
        id: '@id'
      }, {
          addRegime: {
            method: 'PUT'
          }
        }),
      RegimeByCompany: $resource(api.baseUrlGeneral + 'Regime/Company/:companyId', {
        'companyId': '@companyId'
      }),
      AllRegimeByCompany: $resource(api.baseUrlGeneral + 'Regime/getAllRegimes', {
        'companyId': '@companyId'
      }),
      InvoiceSerieByCompany: $resource(api.baseUrlGeneral + 'InvoiceSerie/:companyId', {
        'companyId': '@companyId'
      }),
      InvoiceSerie: $resource(api.baseUrlGeneral + 'InvoiceSerie/:id', {
        id: '@_id'
      }, {
          update: {
            method: 'PUT'
          },
          patch: {
            method: 'PATCH'
          },
          save: {
            method: 'POST'
          },
          delete: {
            method: 'DELETE'
          },
          getByCompanySerieAndCorrelative: {
            method: 'GET',
            params: {
              invoiceSerieId: '@_invoiceSerieId',
              companyId: '@_companyId',
              serie: '@_serie',
              initialNumber: '@_intialNumber',
              lastNumber: '@_lastNumber'
            }
          },
          getByCompany: {
            method: 'GET',
            params: {
              idCircle: '@_idCircle'
            },
            isArray: true
          },
          getByEstablishment: {
            method: 'GET',
            isArray: true
          }
        }),
      InvoiceSerieType: {
        me: $resource(api.baseUrlGeneral + 'InvoiceSerieType/Country/:country', {
          'country': '@country'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          }),
        active: $resource(api.baseUrlGeneral + 'InvoiceSerieType/Country/:country/active', {
          'country': '@country'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          })
      },
      Common: {
        CountryTax: {
          self: $resource(api.baseUrlGeneral + 'CountryTax/byCountry/:country', { 'country': '@country' })
        },
        MeasurementUnit: {
          me: $resource(api.baseUrlGeneral + 'MeasurementUnit', {}, {
            'page': {
              'method': 'GET',
              'params': {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              },
              'isArray': false
            },
            'query': {
              'method': 'GET',
              'params': {},
              'isArray': true
            },
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            }
          }),
          notAssociatedToFeature: $resource(api.baseUrlGeneral + 'MeasurementUnit/notAssociatedToFeature', {}, {
            'page': {
              'method': 'GET',
              'params': {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize',
                'featureId': '@featureId'
              },
              'isArray': false
            }
          })
        }
      },
      ProductCompanyAddons: {
        me: $resource(api.baseUrlGeneral + 'ProductCompanyAddons/:id', {
          id: '@id'
        }, {
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            }
          })
      },
      ProductCompanyEstablishmentAddons: {
        me: $resource(api.baseUrlGeneral + 'ProductCompanyEstablishmentAddons/:id', {
          id: '@id'
        }, {
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            }
          }),
        getByProductAndCompany: $resource(api.baseUrlGeneral + 'ProductCompanyEstablishmentAddons/getByProductAndCompany', {}, {})
      },
      ProductCompanyAdditionalFields: $resource(api.baseUrlGeneral + 'ProductCompanyAdditionalFields/:productType/:app/:establishmentId/:id', {
        id: '@id'
      }, {
          'create': {
            'method': 'POST'
          }
        }),
        ProductCompanyAdditionalFieldsValue: {
          getByProductAndCompany: $resource(api.baseUrlGeneral + 'ProductCompanyAddonsFieldsValue/Company/:companyId/Product/:productId', {'companyId': '@companyId', 'productId': '@productId'}),
          fieldValueAdd: $resource(api.baseUrlGeneral+ 'ProductCompanyAddonsFieldsValue', {}, {
            'create': {
              'method': 'POST'
            },
          }),
          fieldValue: $resource(api.baseUrlGeneral+ 'ProductCompanyAddonsFieldsValue/:id', {id: '@id'}, {
            'get': {
              'method': 'GET'
            },
            'update': {
              'method': 'PUT'
            },
            'delete': {
            'method': 'DELETE'
            }
          }),
          companyAdditionalFields: $resource(api.baseUrlGeneral + 'ProductCompanyAddonsFieldsValue/getAdditionalFields', {}, {
            getAvailables: {
              method: 'GET',
              isArray: true,
              params: {'companyId': '@companyId', 'productId': '@productId'}
            }
          })
        },
      ProductCompanyBuy: {
        me: $resource(api.baseUrlGeneral + 'ProductCompanyBuy/:id', {
          id: '@id'
        }, {
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            },
            'delete': {
              method: 'DELETE',
              'interceptor': interceptor
            },
            'getByProductAndCompanyGreatCurrentDate': {
              method: 'GET',
              isArray: true
            },
            'doGetByProductAndCompanyGreatByDate': {
              method: 'GET',
              isArray: true,
              params: { 'id': 'doGetByProductAndCompanyGreatByDate' }
            },
            'updateList': {
              method: 'PUT',
              isArray: true,
              params: { 'id': 'updateList' }
            }
          }),
          ChangeDefault: $resource(api.baseUrlGeneral + 'ProductCompanyBuy/:id/ChangeDefault', {
            id: '@id'
          }, {
            update: {
              method: 'PUT',
              isArray: false,
              interceptor: interceptor
            }
          })
      },
      ProductCompanySale: {
        pageByProduct: $resource(api.baseUrlGeneral + 'Product/Sale/filter/productId/companyName')
      },
      BrandProduct: $resource(api.baseUrlGeneral + 'Product/brand'),
      CompanyEstablishment: {
        me: $resource(api.baseUrlGeneral + 'CompanyEstablishment/:id', {
          id: '@id'
        }, {
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            },
            'delete': {
              method: 'DELETE',
              'interceptor': interceptor
            },
            'page': {
              method: 'GET',
              params: {
                'page': '@page',
                'pageSize': '@pageSize',
                'search': '@search'
              },
              isArray: false
            },
            'get': {
              'method': 'GET'
            },
            'getByCompany': {
              'method': 'GET',
              'isArray': true
            }
          }),
        findAllByCompany: $resource(api.baseUrlGeneral + 'CompanyEstablishment/get-all-by-company', {}, {
          query: {
            method: 'GET',
            'isArray': true
          }
        }),
        findAllByCompanyIds: $resource(api.baseUrlGeneral + 'CompanyEstablishment/byCompanyIds/:companyIds', {
          companyIds: '@companyIds',
        }, {
          get: {
            method: 'GET',
            'isArray': true
          }
        }),
        corporateGroupMembers:$resource(api.baseUrlGeneral + 'CompanyEstablishment/corporateGroupMembers', {}, {
          get: {
            method: 'GET',
            isArray: true
        }
        }),

        CompanyCirclesByUser: $resource(api.baseUrlGeneral + 'Company/circlesByUser',{},{
          query:{
            method: 'GET',
            'isArray': true
          }
        }),

        notAssociatedToUser: $resource(api.baseUrlGeneral + 'CompanyEstablishment/:idc/notAssociatedToUser', { 'idc': '@idc' }, {
          page: {
            method: 'GET',
            params: {
              'page': '@page',
              'pageSize': '@pageSize',
              'search': '@search'
            },
            isArray: false
          }
        })
      },
      CompanyEstablishmentTemplate: {
        getAll: $resource(api.baseUrlGeneral + 'CompanyEstablishment/getTemplates', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        })
      },
      EstablishmentCurrencyExchangeRate: {
        self: $resource(api.baseUrlGeneral + 'EstablishmentCurrencyExchangeRate'),
        doDelete: $resource(api.baseUrlGeneral + 'EstablishmentCurrencyExchangeRate/:id/delete', {
          id: '@id'
        }, {
            'update': {
              'method': 'PUT',
              'params': {
                'idCircle': '@idCircle'
              }
            },
          }),
        doUpdate: $resource(api.baseUrlGeneral + 'EstablishmentCurrencyExchangeRate/:id/update', {
          id: '@id'
        }, {
            'update': {
              'method': 'PUT',
              'params': {
                'idCircle': '@idCircle'
              }
            },
          })
      },
      State: {
        me: $resource(api.baseUrlGeneral + 'State/:id', {
          id: '@id'
        }, {
            'getByCountry': {
              'method': 'GET',
              isArray: true
            }
          })
      },
      City: {
        me: $resource(api.baseUrlGeneral + 'City/:id', {
          id: '@id'
        }, {
            'getByState': {
              'method': 'GET',
              isArray: true
            }
          })
      },
      FileStorage: {
        me: $resource(api.baseUrlGeneral + 'FileStorage/:id', {
          id: '@id'
        }, {
            save: {
              method: 'POST',
              isArray: true,
              transformRequest: angular.identity,
              headers: {
                'Content-Type': undefined
              }
            }
          }),
        productPhoto: $resource(api.baseUrlGeneral + 'FileStorage/byProductIds', {}, {
          get: {
            method: 'GET',
            isArray: true,
            params: {
              'productIds': '@productIds'
            }
          },
        }),
      },
      CompanyWarehouse: {
        me: $resource(api.baseUrlGeneral + 'CompanyWarehouse/:id', {
          id: '@id'
        }, {
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            },
            'delete': {
              method: 'DELETE',
              'interceptor': interceptor
            },
            'page': {
              method: 'GET',
              isArray: false
            },
            'get': {
              'method': 'GET'
            }
          }),
        notAssociatedToEstablishment: $resource(api.baseUrlGeneral + 'CompanyWarehouse/notAssociatedToEstablishment', {}, {
          page: {
            method: 'GET',
            params: {
              'establishmentId': '@establishmentId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        associatedToEstablishment: $resource(api.baseUrlGeneral + 'CompanyWarehouse/associatedToEstablishment', {}, {
          page: {
            method: 'GET',
            params: {
              'establishmentId': '@establishmentId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        })
      },
      getAllCompanies: $resource(api.baseUrlGeneral + 'Company/isActive', {}, {
        page: {
          method: 'GET',
          isArray: false,
          params: {
            'pageNumber': '@pageNumber',
            'pageSize': '@pageSize',
            'search': '@search',
            'companyId': '@companyId',
            'includeMe': '@includeMe'
          }
        }
      }),
      getCompaniesNoValidatedAsProvider: $resource(api.baseUrlGeneral + 'Company/:companyId/getNoValidatedAsProvider', {
        'companyId': '@companyId'
      }, {
          page: {
            method: 'GET',
            isArray: false,
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'search': '@search'
            }
          }
        }),
      CompanyProvider: {
        me: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider/:providerId', {
          'companyId': '@companyId',
          'providerId': '@providerId'
        }, {
            create: {
              method: 'POST'
            },
            update: {
              method: 'PUT'
            },
            page: {
              method: 'GET',
              isArray: false,
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize',
                'search': '@search'
              }
            },
            query: {
              method: 'GET',
              isArray: false
            }
          }),
        noValidate: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider/noValidate', {
          'companyId': '@companyId'
        }, {
            create: {
              method: 'POST'
            }
          }),
        updateFieldsConfiguration: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider/:id/updateFieldsConfiguration', {
          'companyId': '@companyId', 'id': '@id'
        }, {
          doUpdateFields: {
            method: 'POST'
          }
        }),
        validateAsProvider: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider/:id/validateAsProvider', {
          'companyId': '@companyId', 'id': '@id'
        }, {
          validate: {
            method: 'GET',
            isArray: false,
            'interceptor': interceptor,
            params: {
              'providerId': '@providerId'
            }
          }
        }),
        updateBusinessName: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider/:id/updateProviderBusinessName', {
          'companyId': '@companyId', 'id': '@id'
        }, {
          update: {
            method: 'PUT',
            isArray: false,
            params: {
              'businessName': '@businessName'
            }
          }
        }),
        updateCompanyCategory: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider/:id/updateProviderCompanyCategory', {
          'companyId': '@companyId', 'id': '@id'
        }, {
          update: {
            method: 'PUT',
            isArray: false,
            params: {
              'companyCategoryId': '@companyCategoryId',
            },
          }
        }),
        updateAccountingInf: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider/:id/updateAccountingInformation', {
          'companyId': '@companyId', 'id': '@id',
        }, {
          update: {
            method: 'PUT',
            isArray: false
          }
        })
      },
      CompanyProviderTags: {
        me: $resource(api.baseUrlGeneral + 'CompanyProviderTags/:id', {
          'id': '@id'
        }, {
            create: {
              method: 'POST'
            },
            del: {
              method: 'DELETE'
            }
          })
      },
      UserCompanyEstablishment: {
        me: $resource(api.baseUrlGeneral + 'UserCompanyEstablishment/:company/:idUsuario', { 'company': '@company', 'idUsuario': '@idUsuario' }, {
          create: {
            method: 'POST',
            params: {
              'associateAll': '@associateAll'
            },
            isArray: false
          },
          update: {
            method: 'PUT',
            params: {
              'deleteAll': '@deleteAll'
            },
            isArray: false
          }
        }),
        AssociatedToUser: $resource(api.baseUrlGeneral + 'UserCompanyEstablishment/byUser/:idUsuario', { 'idUsuario': '@idUsuario' }, {
          page: {
            method: 'GET',
            params: {
              'page': '@page',
              'pageSize': '@pageSize',
              'search': '@search'
            },
            isArray: false
          }
        })
      },
      ProductGroup: {
        me: $resource(api.baseUrlGeneral + 'ProductGroup/Country/:country', {
          'country': '@country'
        }, {}),
        active: $resource(api.baseUrlGeneral + 'ProductGroup/Country/:country/active', {
          'country': '@country'
        }, {})
      },
      ProductCompanyGroupAccountingCatalog: {
        byProductCompanyGroup: $resource(api.baseUrlGeneral + 'ProductCompanyGroupAccountingCatalog/byProductCompanyGroup', {}, {
          get: {
            method: 'GET',
            isArray: true,
            params: {
              'productCompanyGroupId': '@productCompanyGroupId'
            }
          },
          page: {
            method: 'GET',
            isArray: false,
            params: {
              'productCompanyGroupId': '@productCompanyGroupId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        me: $resource(api.baseUrlGeneral + 'ProductCompanyGroupAccountingCatalog/:id', {
          id: '@id',
          'idCircle': '@idCircle'
        }, {
            create: {
              method: 'POST',
              'interceptor': interceptor
            },
            update: {
              method: 'PUT',
              'interceptor': interceptor
            }
          })
      },
      CompanyFiscalPeriods: {
        me: $resource(api.baseUrlGeneral + 'CompanyFiscalPeriod/:id', {
          id: '@id'
        }, {
            'create': {
              'method': 'POST',
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'interceptor': interceptor
            },
            'page': {
              method: 'GET',
              isArray: false,
              params: {
                'idCircle': '@idCircle',
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            }
          })
      },
      CompanyUser: $resource(api.baseUrlGeneral + 'Company/byUser'),
      CompanyCustomText: {
        byItemName: $resource(api.baseUrlGeneral + 'Company/:companyId/CustomText/ItemName/:itemName', {
          'companyId': '@companyId',
          'itemName': '@itemName'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          }),
        byMenuItem: $resource(api.baseUrlGeneral + 'Company/:companyId/CustomText/MenuItem/:menuId', {
          'companyId': '@companyId',
          'menuId': '@menuId'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          })
      },
      CompanyAdditionalFields: {
        getByCompany: $resource(api.baseUrlGeneral + 'CompanyAdditionalFields/:id', {
          'company': '@company',
          id: '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST'
            },
            update: {
              method: 'PUT'
            },
            delete: {
              method: 'DELETE'
            }
          })
      },
      CompanyAdditionalFieldsList: {
        byCompany: $resource(api.baseUrlGeneral + 'CompanyAdditionalFields/list', {
          'company': '@company',
          id: '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: true
            }
          })
      },
      CompanyAdditionalFieldsValue: $resource(api.baseUrlGeneral + 'CompanyAdditionalFieldsValue/:id', {
        'company': '@company',
        id: '@id'
      }, {
          dele: {
            method: 'DELETE',
            isArray: false
          },
          get: {
            method: 'GET',
            isArray: true
          },
          create: {
            method: 'POST',
            isArray: false
          }
        }),
      CompanyAdditionalFieldsValueResource: {
        byAdditionalFieldId: $resource(api.baseUrlGeneral + 'CompanyAdditionalFieldsValue/byAdditionalFieldId', {}, {
          get: {
            method: 'GET',
            isArray: true,
            params: {
              'companyAdditionalFieldsId': '@companyAdditionalFieldsId'
            }
          }
        })
      },
      getAllCompaniesProviders: $resource(api.baseUrlGeneral + 'Company/:companyId/Provider', {
        'companyId': '@companyId'
      }, {
          page: {
            method: 'GET',
            isArray: false,
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'search': '@search',
              'includeMe': '@includeMe'
            }
          }
        }),
      CompanyWithholding: {
        me: $resource(api.baseUrlGeneral + 'Company/:company/Withholding/:withholdingId/:id', {
          'company': '@company',
          'id': '@id',
          'withholdingId': '@withholdingId'
        }, {
            create: {
              method: 'POST',
              params: {
                'fileStorageId': '@fileStorageId'
              },
              'interceptor': interceptor
            },
            Delete: {
              method: 'DELETE',
              'interceptor': interceptor
            }
          }),
        notAssociatedToCompany: $resource(api.baseUrlGeneral + 'Company/:company/Withholding/notAssociatedToCompany', {
          'company': '@company'
        }, {})
      },
      ProductCompanyAddonsTags: {
        ProductCompanyAddonsTags: $resource(api.baseUrlGeneral + 'ProductCompanyAddonsTags/:idProduct', {
          'idProduct': '@idProduct'
        }, {
            getByProduct: {
              method: 'GET',
              isArray: true
            }
          }),
        SaveProductCompanyAddonsTags: $resource(api.baseUrlGeneral + 'ProductCompanyAddonsTags/:id', {
          'id': '@id'
        }, {
            save: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })

      },
      ProductType: {
        byCompany: $resource(api.baseUrlGeneral + 'ProductType/:company/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            del: {
              method: 'DELETE'
            },
            create: {
              method: 'POST'
            },
            getId: {
              method: 'GET'
            },
            update: {
              method: 'PUT'
            }
          }),
        categoryParent: $resource(api.baseUrlGeneral + 'ProductType/:company/categoryParent/:categoryId', {
          'categoryId': '@categoryId'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          }),
        allByCompany: $resource(api.baseUrlGeneral + 'ProductType/:company/all/byCompany', {}, {
          get: {
            method: 'GET',
            isArray: false
          }
        }),
        allN1: $resource(api.baseUrlGeneral + 'ProductType/:company/getN1', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        })
      },
      EstablishmentParameter: {
        byCompany: $resource(api.baseUrlGeneral + 'EstablishmentParameter/:establishmentId/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: false
            },
            del: {
              method: 'DELETE'
            },
            create: {
              method: 'POST'
            },
            getId: {
              method: 'GET'
            },
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            }
          })
      },
      ProductTypeParameter: {
        byCompany: $resource(api.baseUrlGeneral + 'ProductTypeParameter/:productTypeId/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: false
            },
            del: {
              method: 'DELETE'
            },
            create: {
              method: 'POST'
            },
            getId: {
              method: 'GET'
            },
            update: {
              'method': 'PUT',
              'interceptor': interceptor
            }
          })
      },
      CompanyEstablishmentPaymentType: {
        byCompanyEstablishment: $resource(api.baseUrlGeneral + 'CompanyEstablishmentPaymentType/byCompanyEstablishment', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        byNotCompanyEstablishment: $resource(api.baseUrlGeneral + 'CompanyEstablishmentPaymentType/byNotCompanyEstablishment', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        CompanyEstablishmentPaymentType: $resource(api.baseUrlGeneral + 'CompanyEstablishmentPaymentType/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: true
            },
            update: {
              method: 'PUT',
              isArray: false
            },
            getId: {
              method: 'GET',
              isArray: false,
              params: {
                'paymentTypeId': '@paymentTypeId'
              }
            }
          }),
        allByCompanyEstablishment: $resource(api.baseUrlGeneral + 'CompanyEstablishmentPaymentType/all/byCompanyEstablishment', {}, {
          get: {
            method: 'GET',
            isArray: false
          }
        })
      },
      BankAccount: {
        BankAccount: $resource(api.baseUrlGeneral + 'Company/:company/BankAccount/:id', {
          'id': '@id',
          'company': '@company'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: false
            },
            update: {
              method: 'PUT',
              isArray: false
            },
            delete: {
              method: 'DELETE',
            },
          })
      },
      BankAccountType: {
        BankAccountType: $resource(api.baseUrlGeneral + 'BankAccountType/:id', {
          'id': '@id',
          'company': '@company'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          })
      },
      Bank: {
        Bank: $resource(api.baseUrlGeneral + 'Bank/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          }),
        byCountry: $resource(api.baseUrlGeneral + 'Bank/Country/:country', {
          'country': '@country'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          })
      },
      CompanyApplicationAdditionalFields: {
        CompanyApplicationAdditionalFields: $resource(api.baseUrlGeneral + 'CompanyApplicationAdditionalFields/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            save: {
              method: 'POST',
              isarray: false
            },
            update: {
              method: 'PUT',
              isArray: false
            }
          })
      },
      CompanyEstablishmentBank: {
        CompanyEstablishmentBank: $resource(api.baseUrlGeneral + 'CompanyEstablishmentBank/:id', {
          'id': '@id',
          'company': '@company'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      CompanyEstablishmentCurrency: {
        CompanyEstablishmentCurrency: $resource(api.baseUrlGeneral + 'CompanyEstablishmentCurrency/:id', {
          'id': '@id',
          'company': '@company'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      Commons: {
        FileStorage: {
          filesUpload: {
            add: function (params, body) {
              var fd = addToFdFile(body, 'files');
              return $http.post(api.baseUrlGeneral + 'FileStorage/filesUpload/' + params.companyId, fd, {
                transformRequest: angular.identity,
                headers: {
                  'Content-Type': undefined
                }
              });
            }
          }
        }
      },
      DiscountCompany: {
        DiscountCompany: $resource(api.baseUrlGeneral + 'DiscountCompany/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      DiscountCompanyEstablishment: {
        byEstablishment: $resource(api.baseUrlGeneral + 'DiscountCompanyEstablishment/byEstablishment', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        DiscountCompanyEstablishment: $resource(api.baseUrlGeneral + 'DiscountCompanyEstablishment/:id', {
          'id': '@id'
        }, {
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      DiscountCompanyEstablishmentPriority: {
        byEstablishment: $resource(api.baseUrlGeneral + 'DiscountCompanyEstablishmentPriority/byEstablishment', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        DiscountCompanyEstablishmentPriority: $resource(api.baseUrlGeneral + 'DiscountCompanyEstablishmentPriority/:id', {
          'id': '@id'
        }, {
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      DiscountCompanyEstablishmentProductType: {
        byProductType: $resource(api.baseUrlGeneral + 'DiscountCompanyEstablishmentProductType/:establishmentId/byProductType/:productTypeId', {
          'establishmentId': '@establishmentId', 'productTypeId': '@productTypeId'
        }, {
          get: {
            method: 'GET',
            isArray: true
          },
          modify: {
            method: 'POST',
            isArray: false
          }
        }),
      },
      DiscountDates: {
        byEstablishment: $resource(api.baseUrlGeneral + 'DiscountDates/byEstablishment', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        DiscountDates: $resource(api.baseUrlGeneral + 'DiscountDates/:id', {
          'id': '@id'
        }, {
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          }),
        message: $resource(api.baseUrlGeneral + 'DiscountDates/:id/message', {
          'id': '@id'
        }, {
          update: {
            method: 'PUT',
            isArray: false
          }
        })
      },
      ProductAll: $resource(api.baseUrlGeneral + 'Product/all/:circle', {
        circle: '@circle'
      }),
      DiscountDatesFilter: {
        byDiscountDates: $resource(api.baseUrlGeneral + 'DiscountDatesFilter/byDiscountDates', {}, {
          get: {
            method: 'GET',
            isArray: false
          }
        }),
        byVerifyIfExist: $resource(api.baseUrlGeneral + 'DiscountDatesFilter/byVerifyIfExist', {}, {
          verify: {
            method: 'POST',
            isArray: false
          }
        }),
        DiscountDatesFilter: $resource(api.baseUrlGeneral + 'DiscountDatesFilter/:id', {
          'id': '@id'
        }, {
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      DiscountField: {
        DiscountField: $resource(api.baseUrlGeneral + 'DiscountField/:id', {
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          })
      },
      DiscountDatesFilterList: {
        byDiscountDatesFilter: $resource(api.baseUrlGeneral + 'DiscountDatesFilterList/byDiscountDatesFilter', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        DiscountDatesFilterList: $resource(api.baseUrlGeneral + 'DiscountDatesFilterList/:id', {
          'id': '@id'
        }, {
            create: {
              method: 'POST',
              isArray: false
            },
            del: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      GFace: {
        GFace: $resource(api.baseUrlGeneral + 'GFace', {}, {
          getAll: {
            method: 'GET',
            isArray: true
          }
        })
      },
      UserEstablishmentGroup: {
        getGroups: $resource(api.baseUrlGeneral + 'UserEstablishmentGroup/userEstablishmentGroup', {}, {
          getAll: {
            method: 'GET',
            isArray: false,
            params: {
              'userAccount': '@userAccount',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        getDefault: $resource(api.baseUrlGeneral + 'UserEstablishmentGroup/getSearchDefault', {}, {
          getGroup: {
            method: 'GET',
            isArray: false,
            params: {
              'userAccount': '@userAccount'
            }
          }

        }),
        createGroup: $resource(api.baseUrlGeneral + 'UserEstablishmentGroup', {}, {
          save: {
            method: 'POST',
            isArray: false,
            params: {
              'changeDefault': '@changeDefault'
            }
          }
        }),
        updateGroup: $resource(api.baseUrlGeneral + 'UserEstablishmentGroup/:id', {
          'id': '@id'
        }, {
            update: {
              method: 'PUT',
              isArray: false,
              params: {
                'changeDefault': '@changeDefault'
              }
            },
          }),
        deleteGroup: $resource(api.baseUrlGeneral + 'UserEstablishmentGroup/:id', {
          'id': '@id'
        }, {
            delete: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      UserEstablishmentGroupDetail: {
        establishmentNotMembersGroup: $resource(api.baseUrlGeneral + 'UserEstablishmentGroupDetail/notInUserEstablishmentGroup', {}, {
          getAll: {
            method: 'GET',
            isArray: false,
            params: {
              'userEstablishmentGroupId': '@userEstablishmentGroupId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'search': '@search'
            }
          }
        }),
        establishmentMembersGroup: $resource(api.baseUrlGeneral + 'UserEstablishmentGroupDetail/userEstablishmentGroup', {}, {
          getAll: {
            method: 'GET',
            isArray: false,
            params: {
              'userEstablishmentGroupId': '@userEstablishmentGroupId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'search': '@search'
            }
          }
        }),
        addMembers: $resource(api.baseUrlGeneral + 'UserEstablishmentGroupDetail/byIds', {}, {
          create: {
            method: 'POST',
            isArray: true,
            params: {
              'userEstablishmentGroupId': '@userEstablishmentGroupId',
              'associateAll': '@associateAll',
              'ids': '@ids'
            }
          },
        }),
        removeMembers: $resource(api.baseUrlGeneral + 'UserEstablishmentGroupDetail/byIds', {}, {
          delete: {
            method: 'DELETE',
            isArray: false,
            params: {
              'userEstablishmentGroupId': '@userEstablishmentGroupId',
              'deleteAll': '@deleteAll',
              'ids': '@ids'
            }
          }
        })
      },
      CompanyProviderProduct: {
        CompanyProviderProduct: $resource(api.baseUrlGeneral + 'CompanyProviderProduct/:id', { 'id': '@id' }, {
          create: {
            method: 'POST',
            isArray: true
          },
          update: {
            method: 'PUT',
            isArray: false
          }
        }),
        byProvider: $resource(api.baseUrlGeneral + 'CompanyProviderProduct/byProvider', {}, {
          get: {
            method: 'GET',
            isArray: false
          }
        }),
        byNotProvider: $resource(api.baseUrlGeneral + 'CompanyProviderProduct/byNotProvider', {}, {
          get: {
            method: 'GET',
            isArray: false
          },
        })
      },
      CompanyProviderFiles:{
        getAllFiles:$resource(api.baseUrlGeneral + 'Company/:companyId/CompanyProviderFiles', {'companyId': '@companyId'}, {
          query: {
            method: 'GET',
            isArray: true,
            params: {
              'companyId': '@companyId',
              'providerId': '@providerId'
            }
          }
        })
      },
      CompanyGface: {
        byCompanyGface: $resource(api.baseUrlGeneral + 'CompanyGface/byCompany', {}, {
          query: {
            method: 'GET',
            isArray: true,
            params: {
              'companyId': '@companyId'
            }
          }
        }),
        companyGface: $resource(api.baseUrlGeneral + 'CompanyGface/:gFaceId', { 'gFaceId': '@gFaceId' }, {
          save: {
            method: 'POST',
            isArray: false,
            params: {
              'companyId': '@companyId'
            }
          },
          del: {
            method: 'DELETE',
            isArray: false
          }
        })
      },
      AccountingEntryConfig: $resource(api.baseUrlGeneral + 'AccountingEntryConfig/:id', { 'id': '@id' }, {
        getAll: {
          method: 'GET',
          isArray: false
        },
        getId: {
          method: 'GET',
          isArray: false,
          params: {
            'id': '@id'
          }
        },
        save: {
          method: 'POST',
          isArray: false
        },
        update: {
          method: 'PUT',
          isArray: false
        },
        del: {
          method: 'DELETE',
          isArray: false
        }
      }),
      AccountingEntryConfigDetail: $resource(api.baseUrlGeneral + 'AccountingEntryConfigDetail/:id', { 'id': '@id' }, {
        getAll: {
          method: 'GET',
          isArray: false
        },
        save: {
          method: 'POST',
          isArray: false
        },
        update: {
          method: 'PUT',
          isArray: false
        }
      }),
      AccountingEntryTypeTemplate: $resource(api.baseUrlGeneral + 'AccountingEntryTypeTemplate/:id', { 'id': '@id' }, {
        getAll: {
          method: 'GET',
          isArray: true
        }
      }),
      AccountingEntryType: $resource(api.baseUrlGeneral + 'AccountingEntryType/:id', { 'id': '@id' }, {
        getAll: {
          method: 'GET',
          isArray: true
        }
      }),
      DepartmentRelated: {
        DepartmentRelated: $resource(api.baseUrlGeneral + 'DepartmentRelated/:id', { 'id': '@id' }, {
          create: {
            method: 'POST',
            isArray: false
          },
          update: {
            method: 'PUT',
            isArray: false
          },
          del: {
            method: 'DELETE',
            isArray: false
          }
        }),
        byDepartment: $resource(api.baseUrlGeneral + 'DepartmentRelated/byDepartment', {}, {
          get: {
            method: 'GET',
            isArray: false
          }
        }),
        byNotDepartment: $resource(api.baseUrlGeneral + 'DepartmentRelated/byNotDepartment', {}, {
          page: {
            method: 'GET',
            isArray: false
          }
        })
      },
      CorporateMembers: {
        byCompanyMember: $resource(api.baseUrlGeneral + 'CorporateMembers/byCompanyMember', {}, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        isCorporateMember: $resource(api.baseUrlGeneral + 'CorporateMembers/isCorporateMember', {}, {
          get: {
            method: 'GET'
          }
        })
      },
      CompanyEstablishmentClassType: {
        me: $resource(api.baseUrlGeneral + 'CompanyEstablishmentClassType/:id', { 'id': '@id' },
        {
            list: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST',
              isArray: false
            },
            update: {
              method: 'PUT',
              isArray: false
            },
            delete: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      CorporateClassificationType: {
        me: $resource(api.baseUrlGeneral + 'CorporateClassificationType/byCorporate/corporateMember', { },
        {
            list: {
              method: 'GET',
              isArray: true
            }
          })
      },
      CorporateClassificationTypeValues: {
        me: $resource(api.baseUrlGeneral + 'CorporateClassificationTypeValues/byClassificationType', { },
        {
            list: {
              method: 'GET',
              isArray: true
            }
          })
      },
      JournalEntry:{
        AccountingItem: $resource(api.baseUrlGeneral + 'JournalEntry/doGetAccountingItem', {},
        {
          page: {
            method: 'POST',
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        }),
        Detail: $resource(api.baseUrlGeneral + 'JournalEntry/Detail/accountingItemDetail', {},
        {
          page: {
            method: 'GET',
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize'
            }
          }
        })
      },
      DimensionCompany: {
        byCompany : $resource(api.baseUrlGeneral + 'DimensionCompany/byCompany/:company', {}, {
          getList:{
            method: 'GET',
            params: {
              'company': '@company'
            },
            isArray: true
          }
        }),
        byCompanyActive : $resource(api.baseUrlGeneral + 'DimensionCompany/byCompanyActive/:company', {}, {
          getList:{
            method: 'GET',
            params: {
              'company': '@company'
            },
            isArray: true
          }
        }),
      },
      DimensionCompanyDetail: {
        byDimensionCompany : $resource(api.baseUrlGeneral + 'DimensionCompanyDetail/all/byDimensionCompany', {}, {
          getList:{
            method: 'GET',
            params: {
              'dimensionCompanyId': '@dimensionCompanyId'
            },
            isArray: true
          }
        })
      },
      CompanyContact: {
        byCompany: $resource(api.baseUrlGeneral + 'CompanyContact/isActive', {}, {
          getList: {
            method: 'GET',
            params: {
              'companyId': '@companyId'
            },
            isArray: true
          }
        }),
        byCompanyActive: $resource(api.baseUrlGeneral + 'CompanyContact/:id', {
          'id': '@id',
        }, {
          create: {
            method: 'POST',
            isArray: false,
            'interceptor': interceptor,
          },
          update: {
            method: 'PUT',
            isArray: false,
            'interceptor': interceptor,
          },
          delete: {
            method: 'DELETE',
          },
        })
      },
      CompanyProviderGroup: {
        byCompany: $resource(api.baseUrlGeneral + 'Company/:companyId/CompanyProviderGroup/:id', {
          'companyId': '@companyId',
          'id': '@id',
        }, {
          getId: {
            method: 'GET',
            isArray: false,
          },
          get: {
            method: 'GET',
            isArray: true,
          },
          create: {
            method: 'POST',
            isArray: false,
            'interceptor': interceptor,
          },
          update: {
            method: 'PUT',
            isArray: false,
            'interceptor': interceptor,
          },
          delete: {
            method: 'DELETE',
          },
        }),
      },
      ProductCompanyBuyCostCenter: {
        CompanyBuy: $resource(api.baseUrlGeneral + 'ProductCompanyBuyCostCenter/ProductBuy/:productCompanyBuyId', {
          'productCompanyBuyId': '@productCompanyBuyId'
        }, {
          get: {
            method: 'GET',
            isArray: true,
          },
          create: {
            method: 'POST',
            isArray: true,
          },
        }),
        CostCenter: $resource(api.baseUrlGeneral + 'ProductCompanyBuyCostCenter/CostCenter/:costCenterId', {
          'costCenterId': '@costCenterId'
        }, {
          get: {
            method: 'GET',
            isArray: true,
          },
        }),
        ChangeDefault: $resource(api.baseUrlGeneral + 'ProductCompanyBuyCostCenter/:id/ChangeDefault', {
          'id': '@id'
        }, {
          update: {
            method: 'PUT',
            isArray: false,
          }
        }),
        CostCenters: $resource(api.baseUrlGeneral + 'ProductCompanyBuyCostCenter/ProductBuy/distinctCostCenter')
      },
      departments: $resource(api.baseUrlGeneral + 'Department/Company/:companyId', { 'companyId': '@companyId' }, {
        getByCompany: {
          'method': 'GET',
          isArray: true
        }
      }),
      costCenters: $resource(api.baseUrlGeneral + 'CostCenter/Company/:companyId', { 'companyId': '@companyId' }, {
        getByCompany: {
          'method': 'GET',
          isArray: true
        }
      }),
      dimensionDetails: $resource(api.baseUrlGeneral + 'DimensionCompanyDetail/Company/:companyId',
        { 'companyId': '@companyId', 'number': '@number' }, {
        getByCompany: {
          'method': 'GET',
          isArray: true
        }
      }),
      CompanyType:{
        getList: $resource(api.baseUrlGeneral + 'CompanyType/byCountryId',
          { 'countryId': '@countryId' }, {
            getByCountry: {
              'method': 'GET',
              isArray: true
            }
          }),
      },
      CompanyCategory:{
        getList: $resource(api.baseUrlGeneral + 'CompanyCategory/byCountryId',
          { 'countryId': '@countryId' }, {
            getByCountry: {
              'method': 'GET',
              isArray: true,
            }
          }),
      },
      InvoiceSeriesDocumentCountry: {
        getList: $resource(api.baseUrlGeneral + 'InvoiceSeriesDocumentCountry/byCountryId',
          { 'countryId': '@countryId' }, {
            getByCountry: {
              'method': 'GET',
              isArray: true,
            }
          }),
      },
    };
    api.TicketsWS = {
      DepartmentGroup: {
        me: $resource(api.baseUrlTicketsWS + 'Company/:companyId/Ticket/Department/Group/:id', {
          'companyId': '@companyId', 'id': '@id'
        }, {
            'query': {
              'method': 'GET',
              'isArray': true
            },
            'create': {
              'method': 'POST',
              'params': {},
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'params': {},
              'interceptor': interceptor
            },
            'getId': {
              method: 'GET',
              isArray: false
            }
          }),
        byDepartment: $resource(api.baseUrlTicketsWS + 'Company/:companyId/Ticket/Department/Group/:departmentId/:parent', {
          'companyId': '@companyId',
          'departmentId': '@departmentId',
          'parent': '@parent'
        }, {}),
        byDepartmentActive: $resource(api.baseUrlTicketsWS + 'Company/:companyId/Ticket/Department/Group/:departmentId/active', {
          'companyId': '@companyId',
          'departmentId': '@departmentId'
        }, {})
      },
      UserDepartmentGroup: {
        me: $resource(api.baseUrlTicketsWS + 'Company/:company/Ticket/Department/:department/Group/:groupId/User/:userId', {
          'company': '@company'
        }, {
            'query': {
              'method': 'GET',
              'isArray': true
            },
            'create': {
              'method': 'POST',
              'params': {},
              'interceptor': interceptor
            },
            'update': {
              'method': 'PUT',
              'params': {},
              'interceptor': interceptor
            }
          }),
        notAssociatedToUser: $resource(api.baseUrlTicketsWS + 'Company/:company/Ticket/Department/:department/Group/:groupId/User/notAssociatedToUser/:userId', {
          'company': '@company'
        }, {
            page: {
              method: 'GET',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize',
                'search': '@search'
              },
              isArray: false
            }
          })
      },
      TicketDepartmentGroupAssignConfig: {
        TicketDepartmentGroupAssignConfig: $resource(api.baseUrlTicketsWS + 'TicketDepartmentGroupAssignConfig/:id', { 'id': '@id' }, {
          page: {
            method: 'GET',
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'search': '@search'
            },
            isArray: false
          },
          create: {
            method: 'POST',
            isArray: false
          },
          update: {
            method: 'PUT',
            isArray: false
          },
          del: {
            method: 'DELETE',
            params: {
              'id': '@id'
            },
            isArray: false
          },
          getId: {
            method: 'GET',
            params: {
              'id': '@id'
            },
            isArray: false
          }
        }),
        TicketDepartmentGroup: $resource(api.baseUrlTicketsWS + 'TicketDepartmentGroupAssignConfig/TicketDepartmentGroup/:id', { 'id': '@id' }, {
          query: {
            method: 'GET',
            isArray: false
          }
        })
      },
      TicketDepartmentGroupAssignConfigUser: {
        TicketDepartmentGroupAssignConfigUser: $resource(api.baseUrlTicketsWS + 'TicketDepartmentGroupAssignConfigUser/:id', { 'id': '@id' }, {
          page: {
            method: 'GET',
            params: {
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'ticketDepartmentGroupAssignConfigId': '@ticketDepartmentGroupAssignConfigId'
            },
            isArray: false
          },
          create: {
            method: 'POST',
            isArray: false
          },
          update: {
            method: 'PUT',
            params: {
              'id': '@id'
            },
            isArray: false
          },
          del: {
            method: 'DELETE',
            params: {
              'id': '@id'
            },
            isArray: false
          }
        })
      }
    };

    api.ActivosFijosWS = {
      FixedAssetGroup: {
        me: $resource(api.baseUrlActivosFijosWS + 'Company/:companyId/FixedAssetGroup/active', {
          'companyId': '@companyId'
        }, {
            get: {
              method: 'GET',
              isArray: true
            }
          })
      }
    };
   // -----
    api.InterfazWS = {
      Erp: {
        me: $resource(api.baseUrlInterfazWS + 'ERP', {}, {}),
        active: $resource(api.baseUrlInterfazWS + 'ERP/active', {}, {
          query: {
            method: 'GET',
            isArray: true
          }
        })
      },
      CompanyConfig: {
        me: $resource(api.baseUrlInterfazCompanyConfigWS + 'CompanyConfig/company/:companyId', {
          'companyId': '@id'
        }, {
            get: {
              method: 'GET'
            }
          }),
        meUpdate: $resource(api.baseUrlInterfazCompanyConfigWS + 'CompanyConfig/:id' , {
          'id': '@id'
        }, {
          update: {
            method: 'PUT'
          },
        }),
        meCreate: $resource(api.baseUrlInterfazCompanyConfigWS + 'CompanyConfig/', {}, {
          create: {
            method: 'POST',
            params: {
              'id': undefined,
            },
            'interceptor': interceptor
          },
        })
      },
      EntityCatalog: {
        me: $resource(api.baseUrlInterfazWS + 'EntityCatalog', {}, {
          query: {
            method: 'GET',
            isArray: true
          }
        })
      },
      InterfazTransaction: {
        findByFilter: $resource(api.baseUrlInterfazWS + 'Transaction/:companyId', {
          'companyId': '@companyId'
        }, {
            page: {
              method: 'POST',
              params: {
                'pageNumber': '@pageNumber',
                'pageSize': '@pageSize'
              }
            }
          })
      },
        SalePurchaseRepositionDays: {
            me: $resource(api.baseUrlInterfazWS + 'SalePurchaseRepositionDays/:id', {
                'id': '@id'
            }, {
                delete: {
                    method: 'DELETE'
                },
                create: {
                    method: 'POST'
                }
            }),
            byCompanyAndProduct: $resource(api.baseUrlInterfazWS + 'SalePurchaseRepositionDays/:companyId/product', {
                'companyId': '@companyId'
            }, {
                query: {
                    method: 'GET',
                    isArray: true,
                    params: {
                        'productId': '@productId'
                    }
                }
            })
      }
    };

    //-----
    api.NotificacionesWS = {
      Notification: {
        publishNotification: $resource(api.baseUrlNotificacionesWS + ':circleId/Notification/', { 'circleId': '@circleId' }, {
          save: {
            method: 'POST',
            isArray: false
          }
        }),
        getNotificationsByApplication: $resource(api.baseUrlNotificacionesWS + ':circleId/Notification/getNotificationbyCompany',
          { 'circleId': '@circleId' }, {
            query: {
              method: 'POST',
              isArray: true
            }
          }),
        currentNotifications: $resource(api.baseUrlNotificacionesWS + ':circleId/Notification/currentNotifications', {
          'circleId': '@circleId'
        }, {
            query: {
              method: 'GET',
              isArray: true
            }
          }),
        pageOfCurrentNotifications: $resource(api.baseUrlNotificacionesWS + ':circleId/Notification/pageOfCurrentNotifications', {
          'circleId': '@circleId'
        }, {
            page: {
              method: 'GET',
              isArray: false,
              params: {
                'pageSize': '@pageSize',
                'pageNumber': '@pageNumber'
              }
            }
          })
      },
      UserNotification: {
        unreadNotifications: $resource(api.baseUrlNotificacionesWS + ':circleId/UserNotification/Me/unread', {
          'circleId': '@circleId'
        }, {
            query: {
              method: 'GET',
              isArray: true
            }
          }),
        pageOfUnreadNotifications: $resource(api.baseUrlNotificacionesWS + ':circleId/UserNotification/Me/pageOfUnreadNotifications', {
          'circleId': '@circleId'
        }, {
            page: {
              method: 'GET',
              isArray: false,
              params: {
                'pageSize': '@pageSize',
                'pageNumber': '@pageNumber'
              }
            }
          }),
        myNotifications: $resource(api.baseUrlNotificacionesWS + ':circleId/UserNotification/Me', {
          'circleId': '@circleId'
        }, {
            page: {
              method: 'POST',
              isArray: false,
              params: {
                'pageSize': '@pageSize',
                'pageNumber': '@pageNumber'
              }
            }
          }),
        markAsRead: $resource(api.baseUrlNotificacionesWS + ':circleId/UserNotification/markAsRead', {
          'circleId': '@circleId'
        }, {
            update: {
              method: 'PUT'
            }
          }),
        markAllAsRead: $resource(api.baseUrlNotificacionesWS + ':circleId/UserNotification/markAllAsRead', {
          'circleId': '@circleId'
        }, {
            update: {
              method: 'PUT'
            }
          })
      },
      UserNotificationConfig: {
        me: $resource(api.baseUrlNotificacionesWS + 'UserNotificationConfig', {}, {
          query: {
            method: 'GET',
            isArray: true,
            params: {
              'companyId': '@companyId'
            }
          },
          update: {
            method: 'PUT'
          }
        }),
        byUser: $resource(api.baseUrlNotificacionesWS + 'UserNotificationConfig/:userId/byUser/:companyId', {}, {
            page: {
                method: 'GET',
                params: {
                    'userId': '@userId',
                    'companyId': '@companyId',
                    'pageNumber': '@pageNumber',
                    'pageSize': '@pageSize',
                    'search': '@search'
                },
                isArray: false
            },
            create: {
                method: 'POST',
                params: {
                    'userId': '@userId',
                    'companyId': '@companyId',
                    'associateAll': '@associateAll',
                    'search': '@search'
                },
                isArray: false
            },
            update: {
                method: 'PUT',
                params: {
                    'userId': '@userId',
                    'companyId': '@companyId',
                    'deleteAll': '@deleteAll'
                },
                isArray: false
            }
        })
      },
      NotificationType: {
        allNotificationType: $resource(api.baseUrlNotificacionesWS + 'NotificationType/All', {}, {
          query: {
            method: 'GET',
            isArray: true
          }
        }),
        notAssociatedToUser: $resource(api.baseUrlNotificacionesWS + 'NotificationType/:userId/notAssociatedToUser/:companyId', {}, {
          page: {
            method: 'GET',
            params: {
              'userId': '@userId',
              'companyId': '@companyId',
              'pageNumber': '@pageNumber',
              'pageSize': '@pageSize',
              'search': '@search'
            }
          }
        })
      },
      NotificationTypeSchedule: {
        allNotificationTypeSchedule: $resource(api.baseUrlNotificacionesWS + 'NotificationTypeSchedule/All', {
          'notificationTypeId': '@notificationTypeId',
          '@companyId': 'CompanyId'
        }, {
            query: {
              method: 'GET',
              isArray: true
            }

          }),
        me: $resource(api.baseUrlNotificacionesWS + 'NotificationTypeSchedule/:id', {
          'idCircle': '@idCircle'
        }, {
            create: {
              method: 'POST',
              params: {
                'id': undefined,
              },
              'interceptor': interceptor

            },
            update: {
              method: 'PUT',
              params: {
                'id': '@id',
              },
              'interceptor': interceptor
            }
          })
      },
      NotificationTypeParameter: {
        byNotificationType: $resource(api.baseUrlNotificacionesWS + ':notificationTypeId/NotificationTypeParameter/byNotificationType', {
            'notificationTypeId': '@notificationTypeId'
        }, {
          get: {
            method: 'GET',
            isArray: true
          }
        })
      },
      NotificationTypeScheduleParameter: {
        byNotificationTypeSchedule: $resource(api.baseUrlNotificacionesWS + ':notificationTypeScheduleId/NotificationTypeScheduleParameter/All', {
            'notificationTypeScheduleId': '@notificationTypeScheduleId'
        }, {
          get: {
            method: 'GET',
            isArray: true
          }
        }),
        me: $resource(api.baseUrlNotificacionesWS + ':notificationTypeScheduleId/NotificationTypeScheduleParameter/:id', {
            'notificationTypeScheduleId': '@notificationTypeScheduleId'
        }, {
          create: {
            method: 'POST',
            'interceptor': interceptor
          },
          delete: {
            method: 'PUT',
            params: {
              'id': '@id'
            },
            'interceptor': interceptor
          }
        })
      }
    };

    api.ProyectosWS = {
      Proyectos: {
        byCompany: $resource(api.baseUrlProyectosWS + 'Company/:companyId/Project/:id', {
          'companyId': '@companyId',
          'id': '@id'
        }, {
            get: {
              method: 'GET',
              isArray: true
            },
            create: {
              method: 'POST'
            },
            update: {
              method: 'PUT'
            },
            delete: {
              method: 'DELETE'
            }
          })
      }
    };
    api.PagosWS = {
      Pagos: {
        parameterConfigBank: $resource(api.baseUrlPagosWS + 'Payment/Company/:companyId/Config/:bankId', { 'bankId': '@bankId', 'companyId': '@companyId' }, {
          save: {
            method: 'POST',
            isArray: false
          }
        })
      },
      PaymentCondition: {
        byCompany: $resource(api.baseUrlPagosWS + 'Company/:companyId/PaymentCondition/:id', {
          'companyId': '@companyId',
          'id': '@id',
        }, {
          getId: {
            method: 'GET',
            isArray: false
          },
          get: {
            method: 'GET',
            isArray: true,
          },
          create: {
            method: 'POST',
            isArray: false,
            'interceptor': interceptor,
          },
          update: {
            method: 'PUT',
            isArray: false,
            'interceptor': interceptor,
          },
          delete: {
            method: 'DELETE',
          },
        }),
      }
    };

    api.InventarioWS = {
      Inventory: {
        Inventory: $resource(api.baseUrlInventarioWS + 'Inventory/', {
          circle: '@circle'
        }, {
            page: {
              method: 'GET',
              isArray: false
            }
          })
      }
    };

    api.PosAdminWS = {
      Bag: {
        Bag: $resource(api.baseUrlPosAdminWS + 'Bag/:id', {
          id: '@id'
        }, {
            page: {
              method: 'GET',
              isArray: false
            },
            create: {
              method: 'POST',
              isArray: false,
              params: {
                'quantity': '@quantity',
                'establishmentId': '@establishmentId'
              },
            },
            update: {
              method: 'PUT',
              isArray: false
            },
            delete: {
              method: 'DELETE',
              isArray: false
            }
          })
      },
      CashierInvoiceSerie: {
        byCompany: $resource(api.baseUrlPosAdminWS + 'CashierInvoiceSerie/byCompany', {
          id: '@id'
        }, {
          page: {
            method: 'GET',
            isArray: false
          }
        }),
        byCompanyInactive: $resource(api.baseUrlPosAdminWS + 'CashierInvoiceSerie/byCompany/false', {
          id: '@id'
        }, {
          page: {
            method: 'GET',
            isArray: false
          }
        }),
        saveAndAssociated: $resource(api.baseUrlPosAdminWS + 'CashierInvoiceSerie/saveAndAssociatedSerie', {
          id: '@id'
        }, {
          save: {
            method: 'POST',
            isArray: false
          }
        }),
        updateAndAssociated: $resource(api.baseUrlPosAdminWS + 'CashierInvoiceSerie/updateAndAssociatedSerie', {
          id: '@id'
        }, {
          upd: {
            method: 'PUT',
            isArray: false
          }
        }),
        doDeleteSerie: $resource(api.baseUrlPosAdminWS + 'CashierInvoiceSerie/doDeleteSerie', {}, {
          put: {
            method: 'PUT',
            isArray: false
          }
        }),
        doDeactiveSerie: $resource(api.baseUrlPosAdminWS + 'CashierInvoiceSerie/doDeactiveSerie', {}, {
          put: {
            method: 'PUT',
            isArray: false
          }
        })
      },
      EstablishmentCashier: {
        byEstablishment: $resource(api.baseUrlPosAdminWS + 'EstablishmentCashier/byEstablishment', {
          id: '@id'
        }, {
          page: {
            method: 'GET',
            isArray: true
          }
        })
      }
    };

    api.RecursosHumanosWS = {
      Employee: {
        byEmployeeCompanyCode: $resource(api.baseUrlRecursosHumanosWS + 'Company/:companyId/Employee/byEmployeeCompanyCode', {
          companyId: '@companyId'
        }, {
          getList: {
            method: 'GET',
            params: {
              'employeeCompanyCode': '@employeeCompanyCode'
            },
            isArray: true
          }
        }),
        doUpdateUserEmployee: $resource(api.baseUrlRecursosHumanosWS + 'Company/:companyId/Employee/doUpdateUserEmployee', {
          companyId: '@companyId'
        }, {
          doSetUser: {
            method: 'PUT',
            params: {
              'employeeId': '@employeeId',
              'userId': '@userId'
            },
            isArray: false
          }
        }),
        byEstablishment: $resource(api.baseUrlRecursosHumanosWS + 'Company/:companyId/Employee/getByEstablishment/', {'companyId': '@companyId'}, {
          page: {
            method: 'GET',
            isArray: false
          }
        }),
        byUserId: $resource(api.baseUrlRecursosHumanosWS + 'Company/:companyId/Employee/byUserId', {
          companyId: '@companyId'
        }, {
          getList: {
            method: 'GET',
            params: {
              'userId': '@userId'
            },
            isArray: false
          }
        }),
      }
    };

    api.ComprasWS = {
      quotation: $resource(api.baseUrlComprasWS + 'Company/:companyId/Quotation/updatePriceQuotations', { companyId: '@companyId' }, {
        updatePriceQuotations: {
          method: 'PUT',
          params: {
            'allCompanies': '@allCompanies',
            'productId': '@productId',
            'newPrice': '@newPrice'
          }
        }
      }),
      purchaseOrder: $resource(api.baseUrlComprasWS + 'PurchaseOrder/updatePricePurchaseOrders', {}, {
        updatePricePurchaseOrders: {
          method: 'PUT',
          params: {
            'companyId': '@companyId',
            'allCompanies': '@allCompanies',
            'productId': '@productId',
            'newPrice': '@newPrice'
          }
        }
      })
    };

    api.baseUrlAccountCatalogWS = {
      PostingPeriod: {
        byCompany: $resource(api.baseUrlAccountCatalogWS + 'Company/:companyId/PostingPeriod/:id', {
          'companyId': '@companyId',
          'id': '@id',
        }, {
          get: {
            method: 'GET',
            isArray: true,
          },
          create: {
            method: 'POST',
            isArray: false,
            'interceptor': interceptor,
          },
          update: {
            method: 'PUT',
            isArray: false,
            'interceptor': interceptor,
          },
          delete: {
            method: 'DELETE',
          },
        }),
      },
      CompanyRolDimensionDefault: {
        byCriteria: $resource(api.baseUrlAccountCatalogWS + 'CompanyRolDimensionDefault/Criteria', {}, {
          get: {
            method: 'POST',
            isArray: false
          }
        }),
        getList: $resource(api.baseUrlAccountCatalogWS + 'CompanyRolDimensionDefault', {}, {}),
        fromList: $resource(api.baseUrlAccountCatalogWS + 'CompanyRolDimensionDefault/list', {}, {
          create: {
            method: 'POST',
          },
          delete: {
            method: 'PUT',
          }
        }),
      }
    };

    api.UserWS = {
      UserDimension: {
        byUser: $resource(api.baseUrlUserWS + 'UserDimension/ByUser/:userId', {
          'userId': '@userId',
        }, {
          getUser: {
            method: 'GET',
            isArray: true,
          },
        }),
        UserDimension: $resource(api.baseUrlUserWS + 'UserDimension/:id', {
          'id': '@id',
        }, {
          get: {
            method: 'GET',
            isArray: false,
          },
          create: {
            method: 'POST',
            isArray: true,
            'interceptor': interceptor,
          },
          update: {
            method: 'PUT',
            isArray: false,
            'interceptor': interceptor,
          },
          delete: {
            method: 'DELETE',
            isArray: true,
          },
        }),
        byDimensionCompanyId: $resource(api.baseUrlUserWS + 'UserDimension/ByDimensionCompanyIdList/', {}, {
          getList: {
            method: 'POST',
            isArray: true,
          },
        }),
      },
      getCompanyByJobAndRolApp: {
      byJobAndRolApp: $resource(api.baseUrlUserWS + 'CompanyRolJob/byJobIdAndRolApp/:jobId/:rolApp',{
        'jobId': '@jobId',
        'rolApp': '@rolApp',
      }, {
        get: {
          method: 'GET',
          isArray: true
        }
        })
  },
      getListCompanyByJobAndRolApp: {
        byJobHr: $resource(api.baseUrlUserWS + 'CompanyRolJob/jobHrId/:id', {
          'id': '@id',
        }, {
          get: {
            method: 'GET',
            isArray: true
          }
        })
      },
      getListCompanyByRolApp: {
        byRolApp: $resource(api.baseUrlUserWS + 'CompanyRolJob/role/:id', {
          'id': '@id',
        }, {
          get: {
            method: 'GET',
            isArray: true
          }
        })
      },
      getListAllCompanyRolApp:{
        allRolApp: $resource(api.baseUrlUserWS + 'CompanyRolJob/all',{})
      },
      CompanyRolJob: {
        me: $resource(api.baseUrlUserWS + 'CompanyRolJob/:id', {
          'id': '@id'
        }, {
          get: {
            method: 'GET'
          }
        }),
        meUpdate: $resource(api.baseUrlUserWS + 'CompanyRolJob/:id' , {
          'id': '@id'
        }, {
          update: {
            method: 'put'
          },
          deleteJob: {
            method: 'delete',
          }
        }),
        meCreate: $resource(api.baseUrlUserWS + 'CompanyRolJob/', {}, {
          create: {
            method: 'POST'
          },
        })
      },
    };

    api.Operaciones2ConfigWS = {
      getProductTypeByUser: $resource(api.baseUrlOperaciones2ConfigWS + 'User/:userId/ProductType/active', {}, {
        get: {
          method: 'GET',
          isArray: true,
        },
      }),

      createProductType: $resource(api.baseUrlOperaciones2ConfigWS + 'User/:userId/ProductType', {}, {
        create: {
          method: 'POST',
          isArray: true,
        },
      }),

      deleteProductType: $resource(api.baseUrlOperaciones2ConfigWS + 'User/:userId/ProductType', {}, {
        delete: {
          method: 'DELETE',
          params: {
            'ids': '@ids',
          },
          isArray: true,
        },
      }),

      getListAllWarehouse: $resource(api.baseUrlOperaciones2ConfigWS + 'Warehouse/active', {}, {
        get: {
          method: 'GET',
          isArray: true,
        },
      }),

      getListWarehouseByUser: $resource(api.baseUrlOperaciones2ConfigWS + 'User/:userId/Warehouse/active', {}, {
        get: {
          method: 'GET',
          isArray: true,
        },
      }),

      WarehouseByUser: $resource(api.baseUrlOperaciones2ConfigWS + 'User/:userId/Warehouse', {}, {
        create: {
          method: 'POST',
          isArray: true,
          'interceptor': interceptor,
        },
        delete: {
          method: 'DELETE',
          params: {
            'ids': '@ids',
          },
          isArray: true,
        },
      }),
      UserWarehouse: {
        me: $resource(api.baseUrlOperaciones2ConfigWS + 'User/:userId/Warehouse/:id', {
          'userId': '@userId',
          'id': '@id',
        }, {
          get: {
            method: 'GET',
          },
          update: {
            method: 'PUT',
          },
        }),
      },
      Warehouse: {
        allActive: $resource(api.baseUrlOperaciones2ConfigWS + 'Warehouse/active', {},
        {
          get: {
            method: 'GET',
            isArray: true,
          },
        }),
      },
      WarehouseEstablishment: {
        me: $resource(api.baseUrlOperaciones2ConfigWS + 'Warehouse/:warehouseId/Establishment/:id', {
          'warehouseId': '@warehouseId',
          'id': '@id',
        }, {
          create: {
            method: 'POST',
            isArray: true,
          },
        }),
      },
    };
    return api;
  }
})();


function prepareFieldName(name) {
    name = name.split('%').join('');
    name = name.split('+').join('');
    name = name.split(' ').join('');
    name = name.split('(').join('');
    name = name.split(')').join('');
    name = name.split('-').join('');
    name = name.split('–').join('');
    name = name.split('_').join('');
    name = name.split('/').join('');
    name = name.split('.').join('');
    name = name.split('&').join('');
    return name;
}

function getQSByM(m) {
    var arrM = [
        { q: 1, s: 1 },
        { q: 1, s: 1 },
        { q: 1, s: 1 },
        { q: 2, s: 1 },
        { q: 2, s: 1 },
        { q: 2, s: 1 },
        { q: 3, s: 2 },
        { q: 3, s: 2 },
        { q: 3, s: 2 },
        { q: 4, s: 2 },
        { q: 4, s: 2 },
        { q: 4, s: 2 }
    ];
    return arrM[m];
}


function createKeyFile(_keys_, currentKey) {
    var keys = angular.copy(_keys_);
    keys.push(currentKey);
    var formKey = keys.shift();

    if (keys.length) {
        formKey += "[" + keys.join("][") + "]";
    }
    return formKey;
}


function addToFdFile(object, keys) {
    var fd = new FormData();
    angular.forEach(object, function (value, key) {
        var formKey = keys;

        if (value instanceof File) {
            fd.append(formKey, value);
        } else if (value instanceof FileList) {
            if (value.length === 1) {
                fd.append(formKey, value[0]);
            } else {
                angular.forEach(value, function (file, index) {
                    fd.append(formKey + '[' + index + ']', file);
                });
            }
        } else if (value && (typeof value === 'object' || typeof value === 'array')) {
            var _keys = angular.copy(keys);
            _keys.push(key);
            addToFd(value, _keys);
        } else {
            fd.append(formKey, value);
        }
    });
    return fd;
}

function getImageFile(name) {
    if (name.match(/.(doc|docx|odt)$/i)) {
        return 'assets/images/logos/doc.ico';
    } else if (name.match(/.(xls|xlsx|ods)$/i)) {
        return 'assets/images/logos/xls.ico';
    } else if (name.match(/.(pdf)$/i)) {
        return 'assets/images/logos/pdf.jpg';
    }
    return 'assets/images/logos/gulp.png';
}

(function () {
    'use strict';

    angular
        .module('app.auth', ['app.auth.login', 'app.auth.lock', 'app.auth.strengthPassword', 'app.auth.checkPassword'])
        .config(config);

    /** @ngInject */
    function config() {

    }
})();


(function () {
    'use strict';

    angular
        .module('app.dashboards', [
            'app.dashboards.project'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title: 'MAIN',
            group: true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards', {
            title: 'Dashboards',
            icon: 'icon-tile-four',
            state: 'app.dashboards_project',
            weight: 1
        });
    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.common',
                    [
                        'angular-chartist',
                        'chart.js',
                        'datatables',
                        'gridshore.c3js.chart',
                        'nvd3',
                        'timer',
                        'uiGmapgoogle-maps',
                        'textAngular',
                        'ui.sortable',
                        'ngMdIcons',
                        'ng-sortable',
                        'xeditable',
                        'moment-picker',
                        // Library Optionals
                        'bw.paging',
                        'satellizer', 'LocalStorageModule', 'ngIdle', 'agGrid',
                        'environment',
                        //Querys to JSON
                        'angular-jinqjs',
                        //ng-flog attach file
                        'flow',
                        //notifications
                        'angular-web-notification',
                        'ngJsTree',
                        'mdColorPicker',
                        'angularTrix'
                    ]);
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><div class=\"my-notifications\" layout=\"column\" \nng-include=\"\'app/quick-panel/tabs/my-notifications/my-notifications.html\'\"></div></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" ms-scroll \nng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.translate ? shortcut.translate : shortcut.title| translate}}\" \nui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\">\n</md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip \nmd-direction=\"bottom\">{{shortcut.translate ? shortcut.translate : shortcut.title| translate}}</md-tooltip></md-button>\n</div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\n{{\'SHORTCUTS.CLICK_ADD_TO_REMOVE_SHORTCUT\' | translate}}</md-tooltip></md-button><md-menu-content><div \nid=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-icon\" layout=\"row\" layout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" \nplaceholder=\"{{\'SHORTCUTS.SEARCH\' | translate}}\" flex ng-model=\"MsShortcuts.query\" \nng-model-options=\"MsShortcuts.queryOptions\" ng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" \nng-if=\"MsShortcuts.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.translate ? result.translate : result.title | translate}}</div></div></div><md-icon md-font-icon=\"icon-pin\" \nclass=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content>\n</md-menu></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{vm.app.initials}}</span> <span \nclass=\"logo-text\">{{vm.app.name}}</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" \nfolded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/apps/company/company.html","<div id=\"company\" class=\"page-layout simple tabbed\"><div layout=\"row\" class=\"custom-header\" flex=\"100\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"vm.back()\" ng-if=\"vm.isPrivated\"><md-icon \nstyle=\"color: white\" class=\"s25\" md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div flex=\"70\" \nclass=\"title\" style=\"padding-left: 20px; color: white\"><h1><strong>{{vm.company.name}}</strong></h1></div><span flex>\n</span><div layout-align=\"center center\" ng-if=\"!vm.readonly\"><md-button class=\"md-raised md-warn\" \naria-label=\"Save Change\" ng-if=\"!vm.editMode && vm.tabIndex === 0 && !vm.isNew && !vm.isPrivated\" \nng-click=\"vm.addCompany()\">{{(\'COMPANY.NEW\')| translate}}<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button class=\"md-raised md-warn\" aria-label=\"Save Change\" ng-if=\"vm.authorizedToEdit && vm.tabIndex === 0\" \nng-click=\"vm.editMode ? vm.sendForm() : (vm.editMode = true)\">\n{{(vm.editMode ? \'COMPANY.SEND\' : \'COMPANY.EDIT\')| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon>\n</md-button><md-button class=\"md-raised md-warn\" aria-label=\"Cancel\" translate=\"COMPANY.CANCELED\" \nng-if=\"vm.editMode && vm.tabIndex === 0 && (!vm.isNew || vm.addNewCompany)\" ng-click=\"vm.cancelar()\"><md-icon \nmd-svg-icon=\"border-color\"></md-icon></md-button></div></div><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading\"></md-progress-linear><md-card class=\"content-card\" flex><md-tabs md-dynamic-height><md-tab \nmd-on-select=\"vm.tabIndex = 0\"><md-tab-label><span translate=\"COMPANY.ABOUT\">About</span></md-tab-label><md-tab-body>\n<md-content class=\"about-tab\" ng-include=\"\'app/main/apps/company/tabs/about/about.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.tabIndex = 1\" ng-if=\"!vm.isNew\"><md-tab-label><span translate=\"COMPANY.DOCUMENTS\">\nDocuments</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company/tabs/about/documents.html\'\"></md-content></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.tabIndex = 2\" ng-if=\"!vm.isNew\"><md-tab-label><span translate=\"COMPANY.REGIME\">Regimen</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" ng-include=\"\'app/main/apps/company/tabs/about/regime.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 3\" ng-if=\"!vm.isNew\"><md-tab-label><span \ntranslate=\"COMPANY.INVOICE_SERIE.INVOICE_SERIE\">Invoice series</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/apps/company/tabs/about/invoiceSerie.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.tabIndex = 4\" ng-if=\"!vm.isNew && !vm.isPrivated\"><md-tab-label><span \ntranslate=\"COMPANY.LOGO\">Invoice series</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company/tabs/about/logo.html\'\"></md-content></md-tab-body></md-tab><md-tab \nmd-on-select=\"vm.tabIndex = 5\" ng-if=\"!vm.isNew && vm.isPrivated\"><md-tab-label><span translate=\"user.users\">Usuarios\n</span></md-tab-label><md-tab-body><md-content class=\"users-tab\" id=\"useres\" ms-scroll expand-grid min=\"100\" \nother=\"30\" ui-view=\"users\"></md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 6\" \nng-if=\"!vm.isNew && vm.isPrivated\"><md-tab-label><span translate=\"guest.invitar\">Invite</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" ng-include=\"\'app/main/apps/company/tabs/invite/invite.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 7\" ng-if=\"!vm.isNew && vm.isPrivated\" \nng-show=\"!vm.isMyCompany\" ng-click=\"vm.focusTag()\"><md-tab-label><span \ntranslate=\"accountingCatalog.companyProviderTags\">companyProviderTags</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderTags.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 8\" \nng-if=\"!vm.isNew && vm.isPrivated && vm.myProviders\" ng-click=\"vm.getProductsListAssociate()\" \nng-show=\"!vm.isMyCompany\"><md-tab-label><span translate=\"accountingCatalog.companyProviderProduct\">\ncompanyProviderProduct</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderProduct.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 9\" ng-if=\"!vm.isNew && vm.isPrivated\">\n<md-tab-label><span translate=\"menu.warehouses\">warehouse</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/apps/company/tabs/warehouses/warehouse-list.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.tabIndex = 10\" ng-if=\"!vm.isNew\"><md-tab-label><span translate=\"menu.companyContact\">\ncompanyContact</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company/tabs/company-contact/contact-list.html\'\"></md-content></md-tab-body></md-tab><md-tab\n md-on-select=\"vm.tabIndex = 11\" ng-if=\"!vm.isNew\"><md-tab-label><span translate=\"menu.bankAccounts\">bankAccount</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company/tabs/bank-account/bank-account-list.html\'\"></md-content></md-tab-body></md-tab>\n<md-tab md-on-select=\"vm.tabIndex = 12\" ng-if=\"!vm.isNew && vm.appOperaciones2Active\"><md-tab-label><span \ntranslate=\"OPERACIONES2.WAREHOUSE.WAREHOUSE\">operaciones2Warehouse</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" ng-include=\"\'app/main/apps/company/tabs/operaciones2-warehouse/operaciones2-warehouse.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-card></div>");
$templateCache.put("app/main/apps/files/files.html","<md-content ng-controller=\"FilesController as fl\" class=\"p-16 mv-16\"><div class=\"md-background-bg md-whiteframe-1dp\">\n<div id=\"attach-uploader\" flow-init=\"fl.ngFlowOptions\" flow-name=\"fl.ngFlow.flow\" flow-files-submitted=\"fl.upload()\" \nflow-file-added=\"fl.fileAdded($file)\" flow-file-success=\"fl.fileSuccess($file, $message)\" \nflow-complete=\"fl.uploadComplete()\" flow-drop flow-drag-enter=\"fl.dropping=true\" flow-drag-leave=\"fl.dropping=false\" \nng-class=\"{\'dropping\':fl.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"files.DROP\">Drop to upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"!fl.loadingFiles\"><md-button \nng-disabled=\"vm.maxNumberFiles && vm.filesToUpload.length === vm.maxNumberFiles\" class=\"md-accent md-raised\" flow-btn \naria-label=\"upload\" id=\"btnUpload\">{{\'files.UPLOAD\'| translate}}</md-button><span class=\"secondary-text mt-8\" \ntranslate=\"files.DROP\"></span></div><div layout=\"row\" layout-align=\"center start\" layout-wrap><div \nng-repeat=\"file in vm.filesToUpload\" ng-switch=\"file.type\"><md-content><div class=\"product-image\" \nng-class=\"fl.loadingFiles ? \'uploading\' : \'\'\" ng-switch-when=\"image\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"overlay\" layout=\"column\" layout-align=\"center center\"><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear></div><div layout=\"column\"><img class=\"media\" ng-src=\"{{file.image ? file.image : file.url}}\" \nng-click=\"fl.updateZoomOptions(file.url)\" alt=\"image\"><p>{{file.file.name}}</p></div><md-button \nclass=\"md-fab-bottom-right md-fab md-mini\" ng-click=\"fl.fileRemove(file);\" ng-show=\"!fl.loadingFiles\" \naria-label=\"remove\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-content></div></div></div>\n</div></md-content>");
$templateCache.put("app/main/apps/general/general-template-report.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><div id=\"h-filter\"><md-card>\n<md-button class=\"md-primary button-filter\" target=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">\n{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nng-show=\"vm.isShowFilter\" class=\"animate-show\"><div layout=\"row\" layout-align=\"center center\"><md-input-container \nflex=\"50\" ng-if=\"vm.filterDimension\"><label translate=\"dimensions.select_dimension_company\">Application</label>\n<md-select name=\"app\" ng-model=\"vm.dimensionCompanySelected\" md-on-close=\"vm.searchDimensionInput = \'\'\">\n<md-select-header><input id=\"searchGroupInput\" ng-model=\"vm.searchDimensionInput\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-option \nng-repeat=\"row in vm.dimensionCompanyList| filter:vm.searchDimensionInput\" value=\"{{row.id}}\">{{row.description}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"row\" layout-align=\"center center\">\n<md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"vm.search()\">{{\'REPORT.SEARCH\'| translate}}</md-button></div>\n</div></md-card></div><center><h2>{{vm.title| translate}}</h2></center><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div></div>\n<md-button class=\"md-fab\" aria-label=\"Generar xls\" ng-show=\"vm.showGrid\" ng-disabled=\"!vm.hasData\" \nng-click=\"vm.onExportXLS()\" style=\"position: fixed; bottom: 10px; right: 20px\"><md-icon md-font-icon=\"icon-file-excel\">\n</md-icon><md-tooltip md-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/providers/providers.html","<div id=\"providers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span translate=\"PROVIDER.FAVORITEGOUP\">Offers</span></div><div\n class=\"product-count secondary-text\"><span translate=\"PROVIDER.TOTAL\">Total providers</span> <span>\n{{vm.allProvider.length}}</span></div></div><div layout=\"column\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"search\" ng-model=\"vm.search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"PROVIDER.SEARCH\" flex></div><div class=\"white-text\" flex><md-input-container \nclass=\"lineaBlanca md-block\" md-block><label translate=\"PROVIDER.GROUPTYPE\">Tipo de grupos</label><md-select \nng-model=\"vm.stateId\"><md-option ng-value=\"0\">{{\"PROVIDER.ALLGROUPTYPE\" | translate}}</md-option><md-option \nng-repeat=\"state in vm.allGroupType\" ng-value=\"{{state.id}}\">{{state.description}}</md-option></md-select>\n</md-input-container></div></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\">\n</md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"content\" layout=\"column\" flex><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.providers.length === 0\"><h2>\n{{\'PROVIDER.NO_PROVIDERS\'| translate}}</h2></div><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"!vm.stateId\"><h2>{{\'PROVIDER.SELECT_GROUP_TYPE\'| translate}}</h2></div><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-show=\"vm.allProvider.length > 0\">\n<div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div>\n</div></div><md-button class=\"md-fab md-warn md-fab-bottom-right\" ng-click=\"vm.newGroupProvider(null)\"><ng-md-icon \nicon=\"add\"></ng-md-icon><md-tooltip md-direction=\"top\"><span translate=\"PROVIDER.NEWGROUP\">COMPOSE</span></md-tooltip>\n</md-button></div></div></div>");
$templateCache.put("app/main/public/apps-list/apps-list.html","<div class=\"list\"><div \nng-class=\"{\'tile-xs \': appsListCtrl.$mdMedia(\'xs\'), \'tile\': (appsListCtrl.$mdMedia(\'sm\') || appsListCtrl.$mdMedia(\'md\') || appsListCtrl.$mdMedia(\'lg\') || appsListCtrl.$mdMedia(\'xl\'))}\" \nng-repeat=\"application in appsListCtrl.applicationArray\"><md-card class=\"card card-1\" \nstyle=\"width: 100%; height: 100%; background: white; box-shadow: none\"><div layout=\"column\" \nlayout-align=\"space-around center\" style=\"height: 100%\"><div><img ng-click=\"appsListCtrl.goToApplication(application)\" \nclass=\"start-page-img\" \nng-class=\"{\'start-page-img-app-xs\': appsListCtrl.$mdMedia(\'xs\'), \'start-page-img-app-lg\': (appsListCtrl.$mdMedia(\'md\') || appsListCtrl.$mdMedia(\'lg\') || appsListCtrl.$mdMedia(\'sm\')), \'start-page-img-app-xl\': appsListCtrl.$mdMedia(\'xl\')}\" \nng-src=\"https://www.megapaca.com.gt/images/logosapps/v1/p/pms{{application.name}}.png\" alt=\"image\"></div><div>\n<md-button style=\"font-weight: 500; color: rgba(0,0,0,0.54)\" ng-click=\"appsListCtrl.goToReadMore(application)\">\n{{\'app_list.read_more\'| translate}}</md-button></div></div></md-card></div></div>");
$templateCache.put("app/main/public/start-page/start-page.html","<md-progress-linear style=\"position: fixed; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-sm=\"row\" layout-xs=\"row\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-sm=\"space-between center\" layout-align-xs=\"space-between center\" class=\"start-page-header\"><div \nflex-xl=\"5\" flex-lg=\"5\" flex-md=\"5\" flex-sm=\"5\" flex-xs=\"15\"><div layout=\"column\" layout=\"center center\"><img \nng-class=\"{\'start-page-logo-app-xs\': vm.$mdMedia(\'xs\'),\n                            \'start-page-logo-app-sm\': vm.$mdMedia(\'sm\'),\n                            \'start-page-logo-app-md\': vm.$mdMedia(\'md\'), \n                            \'start-page-logo-app-lg\': vm.$mdMedia(\'lg\'), \n                            \'start-page-logo-app-xl\': vm.$mdMedia(\'xl\')}\" \nclass=\"start-page-logo\" ng-src=\"https://www.megapaca.com.gt/images/logosapps/v1/p/pmsMegasistemas.png\" alt=\"image\">\n</div></div><div flex-xl=\"70\" flex-lg=\"70\" flex-md=\"70\" flex-sm=\"70\" flex-xs=\"80\"><div layout=\"column\" \nlayout=\"center center\"><div flex><span \nng-class=\"{\n                        \'start-page-xs-title\': vm.$mdMedia(\'xs\'), \n                        \'start-page-sm-title\': vm.$mdMedia(\'sm\'),\n                        \'start-page-lg-title\': (vm.$mdMedia(\'md\') || vm.$mdMedia(\'lg\')), \n                        \'start-page-xl-title\': vm.$mdMedia(\'xl\')}\">\n{{\'start_page.welcome_to\'| translate}} <a ui-sref=\"public.content.index\">Megasistemas!</a></span></div><div flex \nng-class=\"{\'start-page-sm-subtitle\': vm.$mdMedia(\'sm\'), \'start-page-xs-subtitle\': vm.$mdMedia(\'xs\'), \'start-page-lg-subtitle\': (vm.$mdMedia(\'md\') || vm.$mdMedia(\'lg\')), \'start-page-xl-subtitle\': vm.$mdMedia(\'xl\')}\">\n<span>{{\'start_page.the_nation_of_software\'| translate}}</span></div></div></div><div flex-xs=\"20\" hide-xl hide-lg \nhide-md hide-sm><md-button class=\"md-icon-button start-page-menu\" ng-click=\"vm.openMenu()\"><md-icon \nmd-font-icon=\"icon-menu\"></md-icon></md-button></div><div flex-xl=\"25\" flex-lg=\"25\" flex-md=\"25\" flex-sm=\"25\" \nflex-xs=\"30\" hide-xs><md-list flex layout=\"row\" layout-align=\"end center\"><md-list-item ng-show=\"!vm.isAuthenticated\">\n<div><md-button class=\"md-grid-item-content\" ng-click=\"vm.authenticate(\'OIDC\')\"><md-icon md-font-icon=\"icon-login\" \nstyle=\"color: white\"></md-icon><div class=\"md-grid-text\" style=\"color: white\">{{\'start_page.sign_in\'| translate}}</div>\n</md-button></div></md-list-item><md-list-item ng-show=\"!vm.isAuthenticated\"><div><md-button \nclass=\"md-grid-item-content\" ng-click=\"vm.register()\"><md-icon md-font-icon=\"icon-account-plus\" style=\"color: white\">\n</md-icon><div class=\"md-grid-text\" style=\"color: white\">{{\'start_page.sign_up\'| translate}}</div></md-button></div>\n</md-list-item><md-list-item ng-show=\"!vm.isAuthenticated\"><div><md-button class=\"md-grid-item-content\" \nng-click=\"vm.forgotPassword()\"><md-icon md-font-icon=\"icon-account-alert\" style=\"color: white\"></md-icon><div \nclass=\"md-grid-text\" style=\"color: white\">{{\'start_page.forgot_password\'| translate}}</div></md-button></div>\n</md-list-item><md-list-item ng-show=\"vm.isAuthenticated\"><div><md-button class=\"md-grid-item-content\" \nng-click=\"vm.goToDashboard()\"><md-icon md-font-icon=\"icon-view-dashboard\" style=\"color: white\"></md-icon><div \nclass=\"md-grid-text\" style=\"color: white\">{{\'start_page.go_to_dashboard\'| translate}}</div></md-button></div>\n</md-list-item></md-list></div></div><md-sidenav class=\"md-sidenav-right\" md-component-id=\"startPageMenu\" \nmd-whiteframe=\"1\"><md-content><md-list><md-list-item ng-show=\"!vm.isAuthenticated\" \nng-click=\"vm.authenticate(\'OIDC\', true)\"><md-icon md-font-icon=\"icon-login\"></md-icon><p>\n{{\'start_page.sign_in\'| translate}}</p></md-list-item><md-list-item ng-show=\"!vm.isAuthenticated\" \nng-click=\"vm.register(true)\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon><p>{{\'start_page.sign_up\'| translate}}\n</p></md-list-item><md-list-item ng-show=\"!vm.isAuthenticated\" ng-click=\"vm.forgotPassword(true)\"><md-icon \nmd-font-icon=\"icon-account-alert\"></md-icon><p>{{\'start_page.forgot_password\'| translate}}</p></md-list-item>\n<md-list-item ng-show=\"vm.isAuthenticated\" ng-click=\"vm.goToDashboard(true)\"><md-icon \nmd-font-icon=\"icon-view-dashboard\"></md-icon><p>{{\'start_page.go_to_dashboard\'| translate}}</p></md-list-item>\n</md-list></md-content></md-sidenav><div id=\"startPageContentView\"><div style=\"height: 100%; overflow-y: auto\" \nui-view=\"startPageContentView\"></div></div>");
$templateCache.put("app/main/public/info-apps/activosFijos.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Activos Fijos</h1></div><md-content class=\"content\" flex ms-scroll><p>\nEl Sistema de Activos Fijos.</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/clientes.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Clientes</h1></div><md-content class=\"content\" flex ms-scroll><p>\nSistema para el control de clientes y programa de cliente frecuente</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/compras.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Compras</h1></div><md-content class=\"content\" flex ms-scroll><p>\nEl Sistema de Compras permite al usuario llevar control sobre los procesos de compra de productos y/o servicios de los diferentes proveedores que disponen abastecer las necesidades de los departamentos o tiendas en base a una solicitud en el sistema, logrando así el control de los recursos obtenidos y servicios prestados.\n</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/corporativo.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Corporativo</h1></div><md-content class=\"content\" flex ms-scroll><p>\nAdministre su corporación...</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/fms.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - FMS</h1></div><md-content class=\"content\" flex ms-scroll><p>El Sistema de Gestión de cargas...\n</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/inventario.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Inventario</h1></div><md-content class=\"content\" flex ms-scroll><p>\nSistema para el control de inventarios</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/licitador.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Licitador</h1></div><md-content class=\"content\" flex ms-scroll><p>\nEl sistema Licitador le permite a las personas y empresas encontrar la mejor opción para comprar un producto o contratar un servicio, promoviendo la competencia interactiva de los proveedores, utilizando una dinámica de bajasta con variantes configurables al gusto de los compradores.\n</p><p>El Licitador es un sistema que puede ser utilizado en línea o consumido por sistemas de compras de empresas.</p>\n</md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/oms.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - OMS</h1></div><md-content class=\"content\" flex ms-scroll><p>Sistema de control de pedidos</p>\n</md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/pos.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - POS</h1></div><md-content class=\"content\" flex ms-scroll><p>Punto de Venta</p></md-content>\n</div></div></div>");
$templateCache.put("app/main/public/info-apps/presupuestos.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Presupuestos</h1></div><md-content class=\"content\" flex ms-scroll><p>\nEl sistema de Presupuestos le permite a las personas individuales, grupos de personas, y/o empresas a establecer poder llevar un control de los ingresos (cantidades unicamente), proyección de gastos/inversión, y revisión de los resultados para poder realizar ajustes que permitan modificar la forma en que el dinero es utilizado en las diferentes necesidades que existen.\n</p><p>\nEl Sistema de Presupuestos puede ser utilizado en línea o alimentado y/o consumido por sistemas relacionados de empresas, dentro de ellos podemos mencionar \"Sistema de Compras\", \"Sistema Contable\", etc.\n</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/productos.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Productos</h1></div><md-content class=\"content\" flex ms-scroll><p>\nEl Sistema de productos permite consultar los productos que vende una empresa.</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/tarjetaderegalo.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Tarjeta de regalo</h1></div><md-content class=\"content\" flex ms-scroll><p>\nEl Sistema de Tarjetas de regalo</p></md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/tickets.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - Tickets</h1></div><md-content class=\"content\" flex ms-scroll><p>El Sistema de Tickets.</p>\n</md-content></div></div></div>");
$templateCache.put("app/main/public/info-apps/wms.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\" style=\"padding-top: 50px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a ui-sref=\"public.content.index\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Back\" translate translate-attr-aria-label=\"Back\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button></a><h1>MS - WMS</h1></div><md-content class=\"content\" flex ms-scroll><p>El Sistema de control de bodegas\n</p></md-content></div></div></div>");
$templateCache.put("app/main/general/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" \nng-src=\"{{vm.userInfo.picture ? vm.userInfo.picture : \'assets/images/avatars/profile.jpg\'}}\" alt=\"image\"><div \nclass=\"name\">{{vm.userInfo.name}} {{vm.userInfo.familyName}}</div></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-raised md-warn\" aria-label=\"Save Change\" \nng-if=\"data.selectedIndex === 0\" ng-click=\"vm.editMode ? vm.sendForm() : (vm.editMode = true)\">\n{{(vm.editMode ? \'PROFILE.EDIT.SAVE\' : \'PROFILE.EDITBUTTON\')| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon>\n</md-button><md-button class=\"md-raised md-warn\" aria-label=\"Save Change\" translate=\"PROFILE.EDIT.CANCEL\" \nng-if=\"vm.editMode\" ng-click=\"vm.cancelarEdit()\"><md-icon md-svg-icon=\"border-color\"></md-icon></md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div class=\"content\" flex>\n<md-tabs md-dynamic-height md-selected=\"data.selectedIndex\"><md-tab id=\"tab0\"><md-tab-label><span \ntranslate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/general/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab id=\"tab1\">\n<md-tab-label><span translate=\"PROFILE.CHANGE_PASSWORD\">Password</span></md-tab-label><md-tab-body><md-content \nclass=\"password-tab\" ng-include=\"\'app/main/general/profile/tabs/password/password.html\'\"></md-content></md-tab-body>\n</md-tab><md-tab id=\"tab2\"><md-tab-label><span translate=\"PROFILE.USER_GROUPS\">Password</span></md-tab-label>\n<md-tab-body><md-content class=\"groups-tab\" ng-controller=\"UserGroupEstablishmentController as vm\" \nng-include=\"\'app/main/general/profile/tabs/userGroups/userGroups.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/general/role/role.html","<div class=\"page-layout simple fullwidth\" id=\"rolePage\"><div class=\"header md-accent-bg\"><span class=\"h1\" \ntranslate=\"ROLE.MYROLES\">Mis Roles</span><br><div layout=\"row\" layout-align=\"end center\"><div flex=\"50\" \nclass=\"md-toolbar-tools\" style=\"padding: 0px\"><md-input-container><label translate=\"ROLE.FILTER_TYPE\">Tipo de Filtro\n</label><md-select ng-model=\"vm.tipoFiltro\"><md-option value=\"0\">{{\'ROLE.COMPANY\'|translate}}</md-option><md-option \nvalue=\"1\">{{\'ROLE.ROLE\'|translate}}</md-option></md-select></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div flex=\"50\"><div class=\"custom-crud-search\" style=\"padding: 10px\"><md-icon flex=\"5\" \nmd-font-icon=\"icon-magnify\"></md-icon><input flex=\"90\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\" \nng-model=\"vm.inputSearch\"><md-icon flex=\"5\" md-font-icon=\"icon-close\" \nng-if=\"vm.inputSearch && vm.inputSearch.length > 0\" ng-click=\"vm.inputSearch=\'\'\"></md-icon></div></div></div></div><div\n class=\"content md-background-bg\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap \nng-if=\"vm.tipoFiltro === \'0\'\"><ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-repeat=\"c in vm.companies|filter: {name: vm.inputSearch}\"><ms-widget-front class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><div class=\"h4\">{{c.name}}</div></div></md-toolbar><md-content><md-list flex><md-list-item \nng-repeat=\"r in c.roles\" ng-click=\"vm.changeCircle(r.circle);\" \nng-class=\"r.circle.id === $root.bsCircle.id ? \'selected-item\' : \'\'\"><md-list-item-text>{{r.name}}</md-list-item-text>\n<md-button class=\"md-secondary md-icon-button\" ng-if=\"r.circle.id === $root.bsCircle.id\" aria-label=\"call\"><md-icon \nmd-font-icon=\"icon-check-circle\"></md-icon></md-button></md-list-item></md-list></md-content></ms-widget-front>\n</ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap ng-if=\"vm.tipoFiltro === \'1\'\">\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nng-repeat=\"r in vm.roles|filter: {name: vm.inputSearch}\"><ms-widget-front class=\"white-bg\"><md-toolbar><div \nclass=\"md-toolbar-tools\"><div class=\"h4\">{{r.name}}</div></div></md-toolbar><md-content><md-list flex><md-list-item \nng-repeat=\"c in r.companies\" ng-click=\"vm.changeCircle(c.circle);\" \nng-class=\"c.circle.id === $root.bsCircle.id ? \'selected-item\' : \'\'\"><md-list-item-text>{{c.name}}</md-list-item-text>\n<md-button class=\"md-secondary md-icon-button\" ng-if=\"c.circle.id === $root.bsCircle.id\" aria-label=\"call\"><md-icon \nmd-font-icon=\"icon-check-circle\"></md-icon></md-button></md-list-item></md-list></md-content></ms-widget-front>\n</ms-widget></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{vm.app.initials}}</span> <span class=\"logo-text\">\n{{vm.app.name}}</span></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\">\n<md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" \nalt=\"image\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" \nalt=\"image\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div layout=\"column\" layout-align=\"space-between stretch\" class=\"h-128\"><div class=\"top-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"navigation-toggle\" \nhide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">{{vm.app.initials}}</span> <span class=\"logo-text\">\n{{vm.app.name}}</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\">\n<md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div><div class=\"bottom-row\"><div \nid=\"horizontal-navigation\" ui-view=\"navigation\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\" alt=\"image\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\">\n<md-icon md-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>Visitante</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\" style=\"cursor: pointer\" ui-sref=\"app.dashboards_project\"><span \nclass=\"logo-image\"><img ng-src=\"{{vm.urlIconsFull}}\" alt=\"image\"> </span><span class=\"logo-text\" hide-sm hide-xs>\n{{vm.app.name}}</span></div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts hide-sm hide-xs></ms-shortcuts><div class=\"toolbar-separator\"></div><div layout=\"column\" \nclass=\"bussinesCircle\" layout-align=\"center center\" hide-xs><span class=\"role\"><strong>{{bsCircle.role.description}}\n</strong> </span><span class=\"company\">{{bsCircle.company.name}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"{{account.picture ? account.picture : \'assets/images/avatars/profile.jpg\'}}\" alt=\"picture\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" aria-label=\"icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide-xs>\n{{account.name + \' \' + (account.familyName ? account.familyName : \'\')}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div><md-tooltip>{{bsCircle.role.description}}\n</md-tooltip></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-show=\"account.sub\"><md-icon \nmd-font-icon class=\"icon-account-multiple\"></md-icon><md-menu class=\"roles-bs\"><md-button \nng-click=\"vm.openRoles($event);\" translate translate-attr-aria-label=\"TOOLBAR.ROLES\"><span transalte=\"TOOLBAR.ROLES\">\nMis Roles</span></md-button><md-menu-content width=\"4\" style=\"max-height: 90vh\" ms-scroll><md-list flex><md-list-item \nclass=\"md-2-line item-menu-bs\" ng-class=\"bsCircle.id === r.id ? \'md-light-green-300-bg\' : \'\'\" ng-repeat=\"r in circles\" \nng-click=\"vm.changeCircle(r);\"><md-icon ng-if=\"r.icon\" md-font-icon=\"{{r.icon}}\" class=\"icon\"></md-icon><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{r.role.description}}</h3><h4>{{r.company.name}}</h4></div>\n</md-list-item></md-list></md-menu-content></md-menu></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"auth.register\" ng-hide=\"account.sub\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>\n<span transalte=\"TOOLBAR.NEW_ACCOUNT\">Crear Cuenta</span></md-button></md-menu-item><md-menu-item class=\"md-indent\" \nui-sref=\"app.profile\" ng-show=\"account.sub\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>\n<span translate=\"TOOLBAR.PROFILE\">Mi Perfil</span></md-button></md-menu-item><md-menu-divider ng-show=\"account.sub\">\n</md-menu-divider><md-menu-item class=\"md-indent\" ng-click=\"vm.openManual($root.APPQ.urlManual)\" \nng-show=\"$root.APPQ.urlManual\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"icon\"></md-icon><md-button><span \ntranslate=\"TOOLBAR.USER_MANUAL\">Manual de Usuario</span></md-button></md-menu-item><md-menu-divider \nng-show=\"account.sub\"></md-menu-divider><md-menu-item class=\"md-indent\" ng-show=\"account.sub\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\"><span translate=\"TOOLBAR.EXIT\">\nSalir</span></md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div>\n<ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\" hide-sm \nhide-xs></ms-search-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\" alt=\"image\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\" alt=\"image\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\" hide-sm hide-xs></div><md-menu id=\"apps-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"apps-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Apps\" \nmd-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button>\n<md-menu-content width=\"5\" id=\"apps-menu-content\" class=\"apps-menu-content\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap style=\"max-width: 400px\" ms-scroll><ms-widget layout=\"column\" flex=\"50\" flex-gt-xs=\"33\" \nflex-gt-md=\"33\" ng-repeat=\"app in vm.apps\" ng-click=\"vm.changeApp(app)\" layout-align=\"end center\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.getImageApp(app.name)}}.png\" width=\"50\" height=\"50\" alt=\"image\"> <span \nclass=\"h3\">{{app.name}}</span></div></ms-widget></div></md-menu-content></md-menu><div class=\"toolbar-separator\"></div>\n<md-button title=\"{{$root.totalNumberOfNotifications | number:0}} {{\'notifications.notifications\' | translate}}\" \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><span \nclass=\"notifications-number\" ng-if=\"$root.totalNumberOfNotifications > 0\">\n{{$root.totalNumberOfNotifications | number:0}}</span><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon>\n</md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" alt=\"image\"><div class=\"bubble\" \nflex><div class=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div>\n</md-content><form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/my-notifications/my-notifications.html","<div class=\"notifications-header\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \ntitle=\"{{\'notifications.notification_configuration\'| translate}}\" ng-click=\"vm.goToUserNotificationConfiguration()\">\n<md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><span>{{\'QUICKPANEL.NOTIFICATIONS\'| translate}}</span></div><div\n class=\"notifications-list scrollable\" ms-scroll flex><div class=\"notification\" \nng-class=\"{\'warning-type\': notification.alertType === \'WARNING\',\n        \'error-type\': notification.alertType === \'ERROR\',\n        \'success-type\': notification.alertType === \'SUCCESS\',\n        \'message-type\': notification.alertType === \'MESSAGE\'}\" \nng-repeat=\"notification in $root.msNotificationArray\" ng-click=\"vm.showNotification($event, notification)\" \nlayout=\"column\"><div layout=\"row\"><div class=\"icon-alert-type\" flex=\"30\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-pin\" class=\"s20\" ng-if=\"!notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-message-text\" class=\"s20\" \nng-if=\"notification.alertType === \'MESSAGE\' && notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-check\" class=\"s20\" ng-if=\"notification.alertType === \'SUCCESS\' && notification.isUserNotification\">\n</md-icon><md-icon md-font-icon=\"icon-alert\" class=\"s20\" \nng-if=\"notification.alertType === \'WARNING\' && notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-cancel\" class=\"s20\" ng-if=\"notification.alertType === \'ERROR\' && notification.isUserNotification\">\n</md-icon></div><div flex=\"70\" layout=\"row\" layout-align=\"end center\"><span>\n{{notification.createdAt| apiDate:\'dd-MM-yyyy HH:mm\'}}</span></div></div><div layout=\"row\"><span>\n{{notification.message| topCharactersHtml: 100}}...</span></div></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-primary\" ng-click=\"vm.showAllMyNotifications()\">\n{{\'notifications.show_all_my_notifications\'| translate}}</md-button></div>");
$templateCache.put("app/quick-panel/tabs/notifications/notifications.html","<div class=\"notification\" ng-repeat=\"notification in $root.msNotificationArray\"><span>\n{{notification.createdAt | apiDate:\'dd-MM-yyyy HH:mm\'}}</span><br><span>{{notification.message}}</span></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\" layout=\"column\" layout-align=\"start start\"><div class=\"secondary-text\">\n<div>{{vm.date | date:\'EEEE\'}}</div><div layout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> \n<span class=\"md-subhead\">th</span> <span>{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ng-click=\"vm.openIsExternal(node)\"\n           ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && vm.validateItemShow(node, true) && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n            ng-if=\"node.uisref && vm.validateItemShow(node, false) && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/bank/bankAccount/bankAccount.html","<bank-account-component translate-lang=\"{{$root.currentTranslateLang}}\"></bank-account-component>");
$templateCache.put("app/main/apps/bank/parameterConfiguration/parameterConfiguration.html","<parameter-configuration-component translate-lang=\"{{$root.currentTranslateLang}}\"></parameter-configuration-component>");
$templateCache.put("app/main/apps/company/blockedSeries/blockedSeries.html","<div id=\"providers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span translate=\"BLOCKEDSERIES.BLOCKEDSERIES\">Series Bloqueadas\n</span></div><div class=\"product-count secondary-text\"><span translate=\"BLOCKEDSERIES.TOTAL\">Total Series Bloqueadas\n</span> <span>{{vm.allBlockedSeries.length}}</span></div></div></div><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading\"></md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" \nclass=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" \nexpand-grid min=\"260\" other=\"-10\"></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><div \nclass=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"vm.allBlockedSeries.length === 0\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/apps/company/company-application/applications.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"30\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'company_applications.applications\' | translate}}</span></div></div><div layout=\"row\"><div flex=\"100\"><md-card><div \nid=\"appsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"0\" ng-show=\"vm.showGrid\"></div></md-card>\n</div></div>");
$templateCache.put("app/main/apps/company/company-parameters/parameters.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"80\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'company_parameters.parameters\' | translate}} {{vm.application.name}} ({{vm.pagination.totalElements}})</span></div>\n</div><div layout=\"row\"><div flex=\"20\"><md-card><md-list><md-subheader class=\"md-no-sticky\" \nstyle=\"border-bottom: 1px solid #D8D8D8\">\n{{\'company_applications.applications\' | translate}} ({{vm.applicationArray.length}})</md-subheader><md-list-item \nng-class=\"(r.application === vm.application) ? \'selected\' : \'\'\" \nng-click=\"vm.getParametersByApplication(r.application)\" ng-repeat=\"r in vm.applicationArray\" \nstyle=\"border-bottom: 1px solid #D8D8D8\"><p>{{r.application.name}}</p></md-list-item></md-list></md-card></div><div \nflex=\"80\"><md-card><div id=\"parametersGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"0\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><style>.selected {\n        background-color: lightblue;\n    }</style>");
$templateCache.put("app/main/apps/company/documents/documents.html","<div id=\"e-commerce-order\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button close-thread\" \naria-label=\"Back\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"COMPANY.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span translate=\"COMPANY.DOCUMENTS\">Documents</span></div><div \nclass=\"product-count secondary-text\" ng-if=\"vm.msgRequired\"><span class=\"h5\">\n{{vm.msgRequired}} {{\'COMPANY.REQUIRED_DOCUMENTS\'| translate}}</span></div></div></div></div><md-progress-linear \nmd-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div class=\"content-card\" layout=\"column\" block><div \nng-if=\"vm.textTipoError\" layout-align=\"center center\"><h2><center><span class=\"label md-orange-800-bg\">\n{{vm.textTipoError| translate }}</span></center></h2></div><md-content class=\"content\" block ms-scroll><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.DOCUMENT_TYPE\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'COMPANY.DOCUMENT\'| translate}}</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.DATE_OF_ISSUE\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'COMPANY.DUE_DATE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.FILE\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'COMPANY.OPTIONS\'| translate}}</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"doc in vm.company.documents | filter: {active: \'true\'}\"><td>\n{{doc.document.documentType.name}}</td><td>{{doc.document.number}}</td><td>\n{{!doc.document.dateOfIssue ? \'\' :(doc.document.dateOfIssue| flipdate : \'dd-MM-yyyy\')}}</td><td>\n{{!doc.document.dueDate ? \'\' : (doc.document.dueDate| flipdate : \'dd-MM-yyyy\')}}</td><td><div \nng-if=\"doc.document.files.length > 0\"><span ng-repeat=\"files in doc.document.files\"><a \nng-if=\"files.extension === \'.jpg\' || files.extension === \'.png\' || files.extension === \'.JPG\' || files.extension === \'.PNG\' || files.extension === \'.jpeg\' || files.extension === \'.JPEG\'\" \nng-href=\"{{vm.baseUrlSharedFiles}}{{files.parentPath}}{{files.name}}l{{files.extension}}\" \ntitle=\"{{doc.document.documentType.name}} - {{$index + 1}}\" data-gallery target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon></a><a \nng-if=\"files.extension !== \'.jpg\' && files.extension !== \'.png\' && files.extension !== \'.JPG\' && files.extension !== \'.PNG\' && files.extension !== \'.jpeg\' && files.extension !== \'.JPEG\'\" \nng-href=\"{{vm.baseUrlSharedFiles}}{{files.parentPath}}{{files.name}}{{files.extension}}\" \ntitle=\"{{doc.document.documentType.name}} - {{$index + 1}}\" data-gallery target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon></a></span></div></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.edit(doc)\" ng-disabled=\"!doc.document.documentType.canEditWhenIsProvider && vm.asProvider\" \naria-label=\"Product details\" translate translate-attr-aria-label=\"COMPANY.EDIT_DOCUMENT\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s16\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteDocument(doc)\" ng-if=\"!doc.documentType.required && vm.authorizedToEdit\" \nng-disabled=\"!doc.document.documentType.canEditWhenIsProvider && vm.asProvider\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANY.DELETE_DOCUMENT\"><md-icon md-font-icon=\"icon-delete\" class=\"s16 md-warn\"></md-icon>\n</md-button></td></tr></tbody></table></md-content></div><md-button class=\"md-fab md-fab-bottom-right button-position\" \naria-label=\"add\" ng-click=\"vm.addDocument()\" ng-disabled=\"!vm.canAddDocuments\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/content.html","<div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll expand-grid min=\"200\" other=\"235\"><div \nclass=\"search-list\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.searchCompanyInput\" placeholder=\"{{\'validate_provider.search_company\'| translate}}\" \nng-enter=\"vm.getAllCompanies()\"><md-button class=\"md-icon-button\" ng-click=\"vm.getAllCompanies()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nng-if=\"vm.companyArray.length > 0 && !vm.isShowLoaderCompanies\"><div class=\"item\" \nng-repeat=\"company in vm.companyArray\" ng-click=\"vm.viewCompany($event, company)\"><div layout=\"row\"><div layout=\"row\" \nflex layout-align=\"start center\"><div flex class=\"company-name\">\n{{company.name}} / {{company.businessName}}({{company.email}})</div></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.viewName === \'internalProviders\'\"><md-button class=\"md-icon-button\" \nng-click=\"vm.removeProvider($event, company)\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\" style=\"color: red\">\n</md-icon><md-tooltip md-direction=\"left\">{{\'validate_provider.delete\' | translate}}</md-tooltip></md-button></div>\n</div></div></div><div ng-if=\"vm.companyArray.length === 0 && !vm.isShowLoaderCompanies\" layout=\"column\" \nlayout-align=\"center center\" class=\"message-empty-list\"><div>{{\'validate_provider.no_providers\' | translate}}</div>\n</div><div layout=\"column\" layout-align=\"center center\" class=\"loader-content-list\" ng-if=\"vm.isShowLoaderCompanies\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\n{{\'validate_provider.loading_companies\'| translate}}...</div></div></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationCompanies.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationCompanies.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.paginationCompanies.getPage(page)\" \ntotal=\"vm.paginationCompanies.totalElements\"></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/validate-provider.html","<div id=\"validate-provider\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span ng-if=\"vm.viewName === \'validateProvider\'\">{{\'menu.validate_provider\'| translate}}</span> <span \nng-if=\"vm.viewName === \'myProviders\'\">{{\'menu.my_providers\'| translate}}</span> <span \nng-if=\"vm.viewName === \'internalProviders\'\">{{\'menu.internal_providers\'| translate}}</span></div></div><md-card \nclass=\"content-card\" id=\"company-list-container\" flex \nng-include=\"\'app/main/apps/company-providers/validate-provider/content.html\'\"></md-card></div><md-button \nng-if=\"vm.viewName === \'internalProviders\'\" class=\"md-fab md-fab-bottom-right\" ui-sref=\"app.CompanyProvider.private\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip>{{\'validate_provider.add\'| translate}}</md-tooltip></md-button>\n</div>");
$templateCache.put("app/main/apps/files/dialogPhoto/dialogPhoto.html","<md-dialog id=\"dialogPhoto\"><div layout=\"row\" layout-align=\"end center\" class=\"tools-dialog-photo\"><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.printElement(\'prevImage\')\"><md-icon \nmd-font-icon=\"icon-printer\" class=\"s16\"></md-icon></md-button><md-button ng-if=\"vm.fullUrl\" \nng-click=\"vm.downladFile()\" class=\"md-icon-button\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button>\n<md-button ng-if=\"!vm.fullUrl\" ng-href=\"{{vm.url}}\" class=\"md-icon-button\" download target=\"_blank\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div>\n<md-dialog-content><div id=\"prevImage\"><img alt=\"img\" ng-if=\"vm.isIMG\" ng-src=\"{{vm.url}}\"><iframe title=\"pdf\" \nng-if=\"vm.isPDF\" ng-src=\"{{vm.trustSrc(vm.url)}}\" style=\"min-height: 500px; min-width: 900px\" width=\"100%\" \nheight=\"100%\" name=\"plugin\" id=\"plugin\"></iframe></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\"><span translate=\"start_page.welcome\">\nBienvenido</span>, {{account.name}}!</span></div><div class=\"toolbar\"></div></div></div><div class=\"content\"></div>\n</div></div>");
$templateCache.put("app/main/apps/generalConfiguration/additionalFields/additionalFields.html","<div id=\"interfaz-configuration\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\'ADDITIONAL_FIELDS.ADDITIONAL_FIELDS\' | translate}}</span></div></div><div \nid=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" \nng-show=\"vm.showGrid\"></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" \nng-disabled=\"vm.configurationForm.$invalid\" ng-click=\"vm.createAdditionalFields(null);\"><md-tooltip \nmd-direction=\"left\">{{\'ADDITIONAL_FIELDS.add\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button>");
$templateCache.put("app/main/apps/generalConfiguration/gFace/gFace.html","<div id=\"interfaz-configuration\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\'MENU.gFace\' | translate}}</span></div></div><div layout=\"row\"><div flex=\"100\"><md-card><div \nid=\"masterGridCompanyGface\" ag-grid=\"vm.masterGridCompanyGface\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" \nng-click=\"vm.createGface(null);\"><md-tooltip md-direction=\"left\">{{\'DISCOUNTS.add\'| translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discounts.html","<div id=\"interfaz-configuration\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\'DISCOUNTS.DISCOUNTS\' | translate}}</span></div></div><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div></div>\n</div><md-button class=\"md-fab md-fab-bottom-right\" ng-click=\"vm.createDiscount(null);\"><md-tooltip \nmd-direction=\"left\">{{\'DISCOUNTS.add\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/interfaz/report/content.html","<div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" \nng-show=\"vm.showGrid\"></div>");
$templateCache.put("app/main/apps/interfaz/report/filter.html","<div id=\"h-filter\"><md-card><md-button class=\"md-primary button-filter\" target=\"_blank\" \nng-click=\"vm.isShowFilter = !vm.isShowFilter\">{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button><div ng-show=\"vm.isShowFilter\" class=\"animate-show\"><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\"><md-datepicker type=\"date\" ng-model=\"vm.filter.startDate\" \nmd-placeholder=\"Enter start date\" ng-change=\"vm.changeStartDate(true)\" name=\"startDate\" md-open-on-focus>\n</md-datepicker><md-datepicker type=\"date\" ng-model=\"vm.filter.endDate\" md-placeholder=\"Enter end date\" \nng-change=\"vm.changeStartDate(false)\" name=\"endDate\" md-min-date=\"vm.filter.startDate\" md-open-on-focus>\n</md-datepicker></div><div layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\" flex=\"90\"><label>{{\'REPORT.entity\' | translate}}</label><md-select \nng-model=\"vm.filter.entityCatalogIdList\" md-on-close=\"vm.clearSearchEntity()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingEntityArray\"><md-select-header><input id=\"searchEntityInput\" ng-model=\"vm.searchEntity\" \ntype=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup \nlabel=\"Departamentos\"><md-option ng-value=\"{{entity.id}}\" \nng-repeat=\"entity in vm.entityCatalogArray| filter:vm.searchEntity\">{{entity.entityName}} <span \nng-if=\"entity.entityDescripcion !== \'\' && entity.entityDescripcion !== null && entity.entityDescripcion !== undefined\">\n({{entity.entityDescripcion}})</span></md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingEntityArray\"></md-progress-linear></md-input-container></div><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"center center\"><md-input-container class=\"md-block\" flex=\"90\"><label>{{\'REPORT.entity_id\' | translate}}\n</label><input type=\"text\" ng-model=\"vm.filter.theId\"></md-input-container></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"vm.search()\">\n{{\'REPORT.SEARCH\'| translate}}</md-button></div></div></md-card></div>");
$templateCache.put("app/main/apps/interfaz/report/report.html","<div id=\"interfaz-report\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex>\n<div ng-include=\"\'app/main/apps/interfaz/report/filter.html\'\"></div><center><h2>\n{{\'REPORT.TITLE.report_of_transactions\'| translate}}</h2></center><md-card class=\"content-card\" layout=\"column\" flex \nng-include=\"\'app/main/apps/interfaz/report/content.html\'\" ms-scroll></md-card></div></div><md-button class=\"md-fab\" \nng-if=\"vm.exportXLS\" aria-label=\"Generar xls\" ng-show=\"vm.showGrid\" ng-click=\"vm.onExportXLS()\" \nstyle=\"position: fixed; bottom: 10px; right: 20px\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/notification/notification-type-schedule-list/notification-type-schedule-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><h2 \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">{{\'notificationTypeSchedule.title\'| translate}}</h2></div>\n</div><div style=\"padding-top: 5px\"><div id=\"h-filter\"><md-card><md-button class=\"md-primary button-filter\" \ntarget=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon \nng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"!vm.isShowFilter\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button><div ng-show=\"vm.isShowFilter\" class=\"animate-show\"><div \nlayout=\"row\"><md-input-container flex=\"50\"><label translate=\"menu.notification\">Notification</label><md-select \nng-model=\"vm.exchangeNotificationType.notificationType.id\" name=\"notificationtype\" \nmd-on-close=\"vm.clearSearchNotificationType()\"><md-select-header><input id=\"searchNotificationType\" \nng-model=\"vm.searchNotificationType\" type=\"search\" \nplaceholder=\"{{\'notificationTypeSchedule.parameters.parameterName\' | translate}}\"></md-select-header><md-optgroup \nlabel=\"notificationType\"><md-option ng-value=\"{{notificationType.id}}\" \nng-repeat=\"notificationType in vm.notificationTypes| filter:vm.searchNotificationType\" value=\"{{notificationType.id}}\">\n{{notificationType.notificationTypeDescription}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear></md-input-container></div><div layout=\"row\" \nlayout-xs=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"vm.search()\" \nng-disabled=\"!vm.exchangeNotificationType.notificationType\">{{\'REPORT.SEARCH\'| translate}}</md-button></div></div>\n</md-card></div><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"-10\" ng-show=\"vm.showGrid\"></div></div><md-button ng-if=\"vm.showGrid\" class=\"md-fab md-fab-bottom-right\" \naria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/notification/notificationReport/notificationReport.html","<div layout=\"column\" id=\"notiication-report\"><md-card><md-button class=\"md-primary button-filter\" target=\"_blank\" \nng-click=\"vm.expandFilter = !vm.expandFilter\">{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.expandFilter\" \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-icon ng-if=\"!vm.expandFilter\" md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button><div class=\"animate-show body-filter\" ms-scroll ng-if=\"vm.expandFilter\"><div layout=\"row\">\n<md-checkbox ng-model=\"vm.notification.filterEndDate\">{{\"publish.filterEndDate\"| translate}}</md-checkbox></div><div \nlayout-xs=\"column\" layout-sm=\"row\" layout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" \nlayout-align-sm=\"space-around center\" layout-align-md=\"space-around center\" layout-align-lg=\"space-around center\" \nlayout-align-xl=\"space-around center\" ng-class=\"vm.dateNew(vm.notification.startDate)\"><md-datepicker \ntitle=\"{{\'publish.startDate\'| translate}}\" type=\"date\" ng-model=\"vm.notification.startDate\" \nmd-placeholder=\"Enter start date\" name=\"startDate\" md-open-on-focus></md-datepicker><md-datepicker \ntitle=\"{{\'publish.endDate\'| translate}}\" type=\"date\" ng-model=\"vm.notification.endDate\" \nmd-placeholder=\"Enter end date\" name=\"endDate\" md-min-date=\"vm.notification.startDate\" \nmd-min-date=\"vm.notification.startDate\" md-open-on-focus></md-datepicker></div><div layout-xs=\"column\" layout-sm=\"row\" \nlayout-md=\"row\" layout-lg=\"row\" layout-xl=\"row\" layout-align-sm=\"space-between center\" \nlayout-align-md=\"space-between center\" layout-align-lg=\"space-between center\" layout-align-xl=\"space-between center\">\n<md-input-container flex><label>{{\'publish.application\'| translate}}</label><md-select \nng-model=\"vm.notification.applications\" md-on-close=\"vm.clearSearchApplication()\" multiple=\"multiple\" \nng-disabled=\"vm.loadingGroups\" aria-required=\"true\"><md-select-header><input ng-keydown=\"$event.stopPropagation()\" \nng-model=\"vm.searchApplication\" type=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header>\n<md-optgroup label=\"application\"><md-option ng-value=\"application.id\" \nng-repeat=\"application in vm.applicationByCompany | filter:vm.searchApplication\">{{application.name}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.query()\">{{\'publish.query\' | translate}}</md-button></div></div></md-card>\n<div layout=\"row\" layout-align=\"center center\" class=\"tickets-kpi-title\"><div class=\"h2\">\n{{\'menu.notificationReport\' | translate }}</div></div><div id=\"notification-configuration-grid\" \nag-grid=\"vm.gridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" \nng-show=\"vm.showGrid && vm.allNotification.length > 0\"></div></div>");
$templateCache.put("app/main/apps/notification/publishNotifications/publishNotifications.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">{{\'publish.publishNotifications\'| translate}}</span></div>\n</div><form name=\"vm.parameterConfigForm\" class=\"md-inline-form\" novalidate><md-input-container flex>\n</md-input-container><fieldset class=\"standard\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex=\"40\">\n<label>{{\'publish.startDate\'| translate}}</label><md-datepicker id=\"startDate\" type=\"date\" \nng-model=\"vm.notification.startDate\" name=\"startDate\" md-placeholder=\"dd-MM-yyyy\" required \nmd-min-date=\"vm.notification.startDate\"></md-datepicker></md-input-container><md-input-container flex=\"40\"><label>\n{{\'publish.endDate\'| translate}}</label><md-datepicker type=\"date\" ng-model=\"vm.notification.endDate\" name=\"endDate\" \nmd-open-on-focus md-min-date=\"vm.notification.startDate\" md-placeholder=\"dd-MM-yyyy\" required></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\n{{\'publish.message\'| translate}}</label><input type=\"text\" ng-model=\"vm.notification.message\" name=\"message\" required>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\n{{\'publish.application\'| translate}}</label><md-select ng-model=\"vm.notification.applicationId\" name=\"app\" required \nmd-on-close=\"vm.clearSearchApplication()\"><md-select-header><input id=\"searchApplication\" \nng-model=\"vm.searchApplication\" type=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header>\n<md-optgroup label=\"application\"><md-option value=\"{{data.application.id}}\" \nng-repeat=\"data in vm.applications| filter:vm.searchApplication\">{{data.application.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div></fieldset><md-button class=\"md-fab md-fab-bottom-right\" \nng-disabled=\"vm.parameterConfigForm.$invalid\" ng-if=\"!vm.showButton\" ng-click=\"vm.saveNotification()\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button></form>");
$templateCache.put("app/main/apps/product/account/product-account.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 70%; height: 90%\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'productAccount.cuentaContable\'| translate}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.newContact ? vm.flip() : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div><form ng-submit=\"vm.getAccounts(1)\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label translate=\"general.filter\">Filtro\n</label><input type=\"text\" ng-model=\"vm.filterAccount\" name=\"searchAccount\" ng-keyup=\"vm.changeFilter()\" \nid=\"searchAccount\"></md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"general.search\">\nSearch</span></md-button></div></form></div></div></div></md-toolbar><md-progress-linear type=\"indeterminate\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll style=\"padding: 0px\"><div \nlayout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"product in vm.accounts.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\'current-thread\':vm.selectedProduct.id === product.id}\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"title\">\n{{product.code ? product.code + \' - \' : \'\'}}{{product.description}} ({{product.levels}})</div><div class=\"notes\"></div>\n</div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectedProduct.id === product.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><center><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" \nhide-if-empty=\"true\" paging-action=\"vm.getAccounts(page)\" total=\"vm.accounts.totalElements\"></div></center></div><div \nclass=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular class=\"ajax-loader md-accent md-hue-2\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div></md-dialog-content></ms-widget-front><ms-widget-back \nid=\"perms\" class=\"white-bg\"><div ng-init=\"vm.flipping(flipWidget);\"></div><div class=\"page-layout carded fullwidth\" \nlayout=\"column\"><md-toolbar class=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.account.id ? \'general.edit\' : \'general.add\'| translate}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close\" translate translate-attr-aria-label=\"general.close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"center\" layout=\"column\" flex><div \nclass=\"md-dialog-content\"><ng-form name=\"vm.accountForm\" id=\"accountForm\"><div layout=\"row\"><md-input-container \nflex=\"80\"><span>{{\'accountingCatalog.code\'| translate}}*</span><br><span>\n{{vm.account.accountingCatalog.code}} - {{vm.account.accountingCatalog.description}}</span></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"vm.onEdit()\" flex=\"20\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\'general.edit\'| translate}}</md-tooltip></md-button></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>{{\'accountingCatalog.expenseType\'| translate}}</label><md-select \nng-model=\"vm.account.expenseType.id\" required><md-optgroup><md-option ng-value=\"r.id\" ng-repeat=\"r in vm.expenseType\">\n{{r.description}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-input-container\n flex=\"100\"><label>{{\'accountingCatalog.accountType\'| translate}}</label><md-select \nng-model=\"vm.account.accountType.id\" md-on-close=\"vm.clearSearchAccountType()\" required><md-select-header><input \nid=\"searchAccountType\" ng-model=\"vm.searchAccountType\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\">\n</md-select-header><md-optgroup><md-option ng-value=\"at.id\" \nng-repeat=\"at in vm.accountType| filter:vm.searchAccountType\">{{at.acTypeDescription}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\"><md-checkbox ng-disabled=\"!vm.account.id\" \nng-model=\"vm.account.active\">{{\'general.active\'| translate}}</md-checkbox></div><div layout=\"row\"><span flex></span>\n<md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" \nng-disabled=\"vm.accountForm.$invalid\">{{\'general.save\'| translate}}</md-button></div></ng-form></div></div></div>\n</ms-widget-back></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/product/category-feature/category-feature.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"30\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'category_feature.categories\' | translate}}</span></div></div><div id=\"tree\"></div>");
$templateCache.put("app/main/apps/product/account-list/product-account-list.html","<div id=\"e-commerce-product\" class=\"page-layout simple fullwidth\" layout=\"column\"><div layout=\"row\" \nclass=\"custom-header\" layout-align=\"none center\"><div flex=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">{{\"productAccount.cuentasContablesProductos\"| translate}}\n</span></div></div><div class=\"content\"><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-around none\"><div \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div><form \nng-submit=\"vm.getProducts(1)\" name=\"vm.searchForm\"><div class=\"md-toolbar-tools\"><md-input-container flex \nstyle=\"margin-top: 60px\"><label translate=\"general.filter\">Filtro</label><input type=\"text\" \nng-model=\"vm.filterProduct\" name=\"searchText\" ng-keyup=\"vm.changeFilter()\" id=\"searchField\"></md-input-container>\n<md-button type=\"submit\" aria-label=\"Search\"><span translate=\"general.search\">Search</span></md-button></div></form>\n</div><div class=\"content thread-list\" ms-scroll><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"product in vm.productos.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\'current-thread\':vm.selectedProduct.id === product.id}\"><div layout=\"row\" layout-align=\"start center\"><div>\n<div class=\"notes\" layout=\"column\"><span>{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}\n</span> <span ng-if=\"product.brand\"><strong>Marca: </strong>{{product.brand.name}}</span> <span \nng-if=\"product.measurementUnit\"><strong>Unidad de Medida: </strong>{{product.measurementUnit.name}}</span></div></div>\n</div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectedProduct.id === product.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><center><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" \nhide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" total=\"vm.productos.totalElements\"></div></center></div><div \nclass=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular class=\"ajax-loader md-accent md-hue-2\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div><div class=\"p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nclass=\"order-detail-form-container customer md-background-bg md-whiteframe-1dp\"><h2 style=\"padding-left: 8px\">\n{{vm.selectedProduct.name}}</h2></div><div ng-repeat=\"row in vm.productAccount\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" \nstyle=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\"><strong>\n{{\"productAccount.code\"| translate}}</strong></span></div><div flex=\"60\"><span>{{row.accountingCatalog.code}}</span>\n</div><div flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.edit(row)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.edit\"| translate}}</md-tooltip>\n</md-button></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label \ntranslate=\"productAccount.description\">Descripción:</label></strong></div><div flex=\"70\"><span>\n{{row.accountingCatalog.description}}</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\">\n<div flex=\"30\"><strong><label translate=\"productAccount.expenseType\">Tipo de Gasto:</label></strong></div><div \nflex=\"70\"><span>{{row.expenseType.description}}</span></div></div><div layout=\"row\" layout-xs=\"column\" \nstyle=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"productAccount.transactionType\">Tipo de Transacción:\n</label></strong></div><div flex=\"70\"><span>{{row.transactionType}}</span></div></div><div layout=\"row\" \nlayout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong>Activo</strong></div><div flex=\"70\"><md-checkbox \nng-model=\"row.active\" ng-change=\"vm.onDelete(row)\" aria-label=\"chk\" ng-if=\"row.active\"></md-checkbox><md-icon \nmd-font-icon=\"icon-close\" ng-if=\"!row.active\"></md-icon></div></div></ms-widget-front></ms-widget></div></div></div>\n</div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-show=\"vm.selectedProduct && vm.canAdd\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/product/consultProducts/consultProducts.html","<div id=\"consultProducts\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex>\n<div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\"menu.parameters_product\"| translate}}</span></div><div layout=\"row\" flex=\"80\" \nlayout-align=\"start center\" class=\"search-container\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"searchField\" \nng-click=\"vm.showAdvancedFilter = false;vm.generateFilter();\" flex ng-keyup=\"vm.changeFilter()\" \nng-enter=\"vm.getProducts(1)\" ng-model=\"vm.filterProduct\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\">\n<md-button ng-click=\"vm.getProducts(1)\">{{\'general.search\'| translate}}</md-button><md-button \ntitle=\"{{\'notifications.show_search_options\'| translate}}\" ng-click=\"vm.showAdvancedFilter = !vm.showAdvancedFilter;\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s18\"></md-icon></md-button></div><div \nng-if=\"vm.showAdvancedFilter\" id=\"advanced-filter\" layout=\"column\" \nng-include=\"\'app/main/apps/product/consultProducts/content/filter/filter.html\'\"></div></div></div><md-card \nclass=\"content-card\" layout=\"column\" flex ng-include=\"\'app/main/apps/product/consultProducts/content/content.html\'\">\n</md-card></div></div>");
$templateCache.put("app/main/apps/product/fields-value/fields-value.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 500px\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.fieldValueModel.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<ng-form name=\"vm.fieldValueForm\" id=\"fieldValueForm\"><div layout=\"row\" ng-if=\"vm.fieldValueModel.id == 0\">\n<md-input-container flex=\"100\"><label>{{\'additional-field-value.additional-field\'| translate}}</label><md-select \nng-model=\"vm.fieldValueModel.companyAdditionalFields.id\" md-on-open=\"vm.onOpenSelect(\'#searchAdditionalField\')\" \nmd-on-close=\"vm.clearSearchAdditionalField()\" required><md-select-header><input id=\"searchAdditionalField\" \nng-model=\"vm.searchAdditionalField\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\"></md-select-header>\n<md-optgroup><md-option ng-value=\"at.id\" ng-repeat=\"at in vm.additionalFields| filter:vm.searchAdditionalField\">\n{{at.additionalFieldName}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingAdditionalFields\"></md-progress-linear></md-input-container></div><div layout=\"row\" \nng-if=\"vm.fieldValueModel.id != 0\"><md-input-container flex=\"100\"><label>\n{{\'additional-field-value.additional-field\' | translate}}</label><input type=\"text\" \nng-model=\"vm.fieldValueModel.companyAdditionalFields.additionalFieldName\" name=\"fieldValue\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'additional-field-value.value\' | translate}}</label><input type=\"text\" \nng-model=\"vm.fieldValueModel.additionalFieldValue\" name=\"fieldValue\" required><div \nng-messages=\"vm.fieldValueForm.fieldValue.$error\"><div ng-message=\"required\">{{\'general.field_required\' | translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-checkbox ng-disabled=\"!vm.fieldValueModel.id\" \nng-model=\"vm.fieldValueModel.active\">{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"vm.fieldValueForm.$invalid || vm.isShowProgressLinear\" ng-click=\"vm.save()\">{{\'general.save\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/parameters/parameters.html","<div id=\"productParamenters\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\" layout=\"column\"><span>{{\"menu.parameters_product\"| translate}}</span></div><div layout=\"row\" flex=\"80\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input #searchfield id=\"searchField\" flex \nng-keyup=\"vm.changeFilter($event)\" ng-enter=\"vm.getProducts(1)\" ng-model=\"vm.filterProduct\" type=\"search\" \nplaceholder=\"{{vm.textSearch| translate}}\"><md-button ng-if=\"vm.textButtonSearch === \'product_parameters.clear\'\" \nng-click=\"vm.clearTextSearch()\">{{\'product_parameters.clear\' | translate}}</md-button><md-button \nng-click=\"vm.getProducts(1)\">{{\'general.search\' | translate}}</md-button></div></div></div><md-card \nclass=\"content-card\" layout=\"column\" flex ng-include=\"\'app/main/apps/product/parameters/content/content.html\'\">\n</md-card></div></div>");
$templateCache.put("app/main/apps/product/product-group/product-group-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'productGroup.productGroups\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'productGroup.search_productGroup\' | translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\">\n<md-button ng-click=\"vm.search()\">{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div \nflex=\"100\"><md-card><div id=\"productGroupsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/product/product-list/product-list.html","<div id=\"productList\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div\n class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span translate=\"menu.my_products\">Mis productos</span></div><div layout=\"row\" flex=\"80\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-enter=\"vm.search()\" flex ng-model=\"vm.searchInput\" \ntype=\"search\" placeholder=\"{{\'general.search\'| translate}}\"><md-button ng-click=\"vm.search()\">\n{{\'general.search\'| translate}}</md-button></div></div></div><md-card class=\"content-card\" layout=\"column\" flex \nng-include=\"\'app/main/apps/product/product-list/content/content.html\'\"></md-card></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" ng-click=\"vm.add(null, $event);\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/pre-negotiated-prices.html","<div id=\"prenegociatedPrice\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\"menu.pre_negotiated_price\"| translate}}</span></div><div layout=\"row\" flex=\"80\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"searchField\" flex ng-keyup=\"vm.changeFilter()\" \nng-enter=\"vm.getProducts(1)\" ng-model=\"vm.filterProduct\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\">\n<md-button ng-click=\"vm.getProducts(1)\">{{\'general.search\'| translate}}</md-button><md-button \ntitle=\"{{\'notifications.show_search_options\' | translate}}\" ng-click=\"vm.showAdvancedFilter = !vm.showAdvancedFilter;\" \nclass=\"md-icon-button\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s18\"></md-icon></md-button></div><div \nng-if=\"vm.showAdvancedFilter\" id=\"advanced-filter\" layout=\"column\" \nng-include=\"\'app/main/apps/product/pre-negotiated-price/filter/filter.html\'\" \nng-controller=\"PreNegociatedPriceFilterController as filterCtrl\"></div></div></div><md-card class=\"content-card\" \nlayout=\"column\" flex ng-include=\"\'app/main/apps/product/pre-negotiated-price/content/content.html\'\"></md-card></div>\n<md-button class=\"md-fab md-fab-bottom-right md-fa\" aria-label=\"add\" style=\"margin-right: 68px\" \nng-show=\"vm.productos && vm.productos.content.length>0 && vm.canUpdateAll\" ng-click=\"vm.massiveUpdate()\"><md-icon \nmd-font-icon=\"icon-sync\"></md-icon><md-tooltip md-direction=\"left\">{{\"pre-negotiated_price.massive_update\"| translate}}\n</md-tooltip></md-button><md-button class=\"md-fab md-fab-bottom-right md-fa\" aria-label=\"add\" style=\"position: fixed\" \nng-show=\"vm.selectedProduct && vm.canAdd\" ng-disabled=\"vm.loading2\" ng-click=\"vm.add()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button><md-button ng-if=\"vm.showEditCostCenter\" class=\"md-fab md-fab-bottom-right md-fa\" \naria-label=\"editCostCenter\" style=\"margin-bottom: 68px; position: fixed\" ng-show=\"vm.selectedProduct && vm.canAdd\" \nng-disabled=\"vm.loading2\" ng-click=\"vm.editCostCenter()\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\"pre-negotiated_price.bycostcenter\"| translate}}</md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/product/productType/productType.html","<div id=\"prenegociatedPrice\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><md-icon class=\"\" md-font-icon=\"icon-drawing-box\" class=\"icon s24\"></md-icon><span>\n{{\"menu.productType\"| translate}}</span></div><div layout=\"row\" flex=\"80\" layout-align=\"start center\"><div \nclass=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon><input id=\"searchField\" flex ng-keyup=\"vm.changeFilter()\" ng-enter=\"vm.getProducts(1)\" \nng-model=\"vm.filterProduct\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\"><md-button \nng-click=\"vm.changeFilter()\">{{\'general.search\'| translate}}</md-button></div></div></div><div id=\"sidenav-product\" \nms-scroll><div ng-if=\"vm.categorySelected.id !== 0\"><a style=\"cursor: pointer\" ng-click=\"vm.returnToAll();\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon><span class=\"sub-title\">{{\'PRODUCT.ALL_CATEGORY\'|translate}}</span>\n</a><br><br></div><span class=\"h4\"><strong>{{vm.categorySelected.name| translate}}</strong></span><div id=\"tree\"></div>\n</div></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" ng-click=\"vm.addProductType()\">\n<md-icon md-font-icon=\"icon-plus\"><md-tooltip md-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip></md-icon>\n</md-button>");
$templateCache.put("app/main/apps/product/tags/tags.html","<div id=\"prenegociatedPrice\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><md-icon class=\"\" md-font-icon=\"icon-tag\" class=\"icon s24\"></md-icon><span>{{\"menu.tags\"| translate}}\n</span></div><div layout=\"row\" flex=\"80\" layout-align=\"start center\"><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"searchField\" \nflex ng-keyup=\"vm.changeFilter()\" ng-enter=\"vm.getProducts(1)\" ng-model=\"vm.filterProduct\" type=\"search\" \nplaceholder=\"{{\'general.search\'| translate}}\"><md-button ng-click=\"vm.getProducts(1)\">{{\'general.search\'| translate}}\n</md-button></div></div></div><md-card class=\"content-card\" layout=\"column\" flex \nng-include=\"\'app/main/apps/product/tags/content/content.html\'\"></md-card></div></div>");
$templateCache.put("app/main/apps/providers/detail/detail.html","<div id=\"providers\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-button class=\"goto-orders-button md-icon-button\" \naria-label=\"Go to orders\" ng-click=\"vm.backTo()\" translate translate-attr-aria-label=\"CONTRACT.GO_TO_ORDERS\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">{{\'general.back\'| translate}}</md-tooltip>\n</md-button><md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span translate=\"PROVIDER.PROVIDER_FAVORITE\">Offers\n</span></div><div class=\"product-count secondary-text\"><span translate=\"PROVIDER.TOTAL_PROVIDER\">Total providers</span>\n <span>{{vm.membersList.totalElements}}</span></div></div></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><form name=\"vm.frmGroupN\" flex><div layout=\"row\" \nlayout-align=\"center center\" class=\"white-text\" flex><div layout=\"column\" class=\"black-text\" \nng-if=\"vm.allGroupType.length > 0\"><md-input-container style=\"margin-top: 15px\"><label translate=\"PROVIDER.GROUPTYPE\">\nTipo de grupos</label><md-select required ng-model=\"vm.stateId\"><md-option ng-repeat=\"state in vm.allGroupType\" \nng-value=\"{{state.id}}\">{{state.description}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nclass=\"black-text\"><md-input-container><label translate=\"PROVIDER.NAMEGROUP\"></label><input type=\"text\" \nng-model=\"vm.group.name\" required name=\"name\"></md-input-container></div><div layout=\"column\" class=\"black-text\">\n<md-button class=\"md-icon-button md-primary\" ng-click=\"vm.saveHeader()\" \nng-disabled=\"!vm.frmGroupN.$dirty || vm.frmGroupN.$invalid || !vm.group.name\"><ng-md-icon icon=\"save\"></ng-md-icon>\n<md-tooltip><span translate=\"PROVIDER.SAVE\">GUARDAR</span></md-tooltip></md-button></div></div></form></div><div \nng-if=\"vm.group.id\" class=\"content\" layout-sm=\"row\" layout-gt-lg=\"row\" layout-gt-md=\"row\" layout-xl=\"row\" \nlayout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" \nlayout-align-md=\"space-around center\"><div layout=\"column\" flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\" flex><div \nclass=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"text\" translate translate-attr-placeholder=\"PROVIDER.DETAIL.FILTER\" \nng-enter=\"vm.loadCompaniesAvailable(1, vm.searchAllCompany)\" ng-model=\"vm.searchAllCompany\" name=\"searchFieldAll\" \nid=\"searchField\" ng-keydown=\"vm.loadCompaniesAvailable(1, vm.searchAllCompany)\"><md-button type=\"submit\" \naria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nng-click=\"vm.toggle(item, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(item)}\" \nng-repeat=\"item in vm.allCompany.content\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(item)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(item)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{ item.name}} <span>\n({{ item.email}})</span><br><small>{{ item.description}}</small></div></div></div></div><div layout=\"row\"><div paging \nclass=\"pageable-div\" page=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" \npaging-action=\"vm.loadCompaniesAvailable(page)\" total=\"vm.allCompany.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div layout=\"column\" flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll><div class=\"search\" layout=\"row\" layout-align=\"start center\">\n<input flex type=\"search\" translate translate-attr-placeholder=\"PROVIDER.DETAIL.FILTER\" \nng-enter=\"vm.loadMembersList(1, vm.searchMemCompany)\" type=\"text\" ng-model=\"vm.searchMemCompany\" name=\"searchFieldMem\" \nid=\"searchField\" ng-keydown=\"vm.loadMembersList(1, vm.searchMemCompany)\"><md-button class=\"md-icon-button\" \ntype=\"submit\" aria-label=\"Search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nng-click=\"vm.toggleAssociated(item, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelectedAssociated(item)}\" \nng-repeat=\"item in vm.membersList.content\" ng-click=\"vm.toggleAssociated($event, item)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociated(item)\" md-font-icon=\"icon-checkbox-marked\">\n</md-icon><md-icon ng-if=\"!vm.isSelectedAssociated(item)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div \nflex class=\"product-name\">{{item.name}} ({{item.email}})</div></div></div></div><div layout=\"row\"><div paging \nclass=\"pageable-div\" page=\"vm.pageM\" ul-class=\"pagination\" page-size=\"vm.pageSizeM\" hide-if-empty=\"true\" \npaging-action=\"vm.loadMembersList(page)\" total=\"vm.membersList.totalElements\"></div></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/apps/usr/apps-user/reportAppsByUser.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><div id=\"h-filter\"><md-card>\n</md-card></div><center><h1>{{\'menu.reportAppsByUser\'| translate}}</h1></center><div id=\"masterGridOptionsAppByUser\" \nag-grid=\"vm.masterGridOptionsAppByUser\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div>\n</div><md-button class=\"md-fab\" aria-label=\"Generar xls\" ng-show=\"vm.showGrid\" ng-click=\"vm.exportXLS()\" \nstyle=\"position: fixed; bottom: 10px; right: 20px\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/usr/associate-role-jobhr/associateRolJobHr.html","<div id=\"associateRoleJob\"><md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" \nclass=\"md-accent\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"80\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'menu.associateRoleJobHR\' | translate}}</span></div></div><div id=\"h-filter\"><md-card><md-button \nclass=\"md-primary button-filter\" target=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">\n{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nng-show=\"vm.isShowFilter\" class=\"animate-show\"><form name=\"vm.associateRoleJobForm\" class=\"md-inline-form\" novalidate>\n<div class=\"animate-show\"><div layout=\"row\"><md-input-container flex=\"100\"><label \ntranslate=\"associateRoleJobHR.application\">Application</label><md-select ng-change=\"vm.getRol(vm.appId)\" \nng-model=\"vm.appId\" name=\"app\" md-on-close=\"vm.clearSearchErpInput()\"><md-select-header><input \nid=\"searchApplicationInput\" ng-model=\"vm.searchApplicationInput\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-option \nng-repeat=\"role in vm.roleApplications|filter:vm.searchApplicationInput\" ng-value=\"role.application.id\">\n{{role.application.name}}</md-option></md-select></md-input-container><md-input-container flex=\"100\"><label \ntranslate=\"associateRoleJobHR.role\">Rol</label><md-select ng-model=\"vm.roleId\" name=\"rol\" \nmd-on-close=\"vm.clearSearchGroup()\"><md-select-header><input id=\"clearSearchRolInput\" ng-model=\"vm.searchRolInput\" \ntype=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header><md-option \nng-repeat=\"role in vm.role|filter:vm.searchRolInput\" ng-value=\"role\">{{role.description}}</md-option></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingRoleApplication\"></md-progress-linear>\n</md-input-container></div><md-input-container class=\"md-block\" flex=\"100\" flex-sm=\"50\" flex-xs=\"100\"><label>\n{{\'associateRoleJobHR.jobCode\'| translate}}</label><input type=\"number\" ng-model=\"vm.jobHrId\" name=\"jobId\">\n</md-input-container><div layout=\"row\" layout-xs=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised md-hue-1\" ng-disabled=\"vm.jobHrId <= 0 && !vm.appId\" ng-if=\"!vm.showButton\" \nng-click=\"vm.search()\">{{\'REPORT.SEARCH\'| translate}}</md-button></div></div></form></div></md-card></div><div \nlayout=\"row\"><div flex=\"100\"><md-card><div id=\"contactsGrid\" ag-grid=\"vm.roleJobGrid\" class=\"ag-fresh\" expand-grid \nmin=\"100\" other=\"0\" ng-show=\"vm.showGrid\"></div></md-card></div></div><md-button id=\"buttonAlignEndFix\" \nclass=\"md-fab md-fab-bottom-right\" n g-show=\"vm.showGrid\" layout-align=\"end end\" a ria-label=\"add\" ng-click=\"vm.add()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/usr/user-roles/user-roles.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div style=\"padding-top: 5px\"><div id=\"h-filter\"><md-card>\n<md-button class=\"md-primary button-filter\" target=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">\n{{\'REPORT.CLICK_FILTRO\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon>\n<md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-right\"></md-icon></md-button><div \nng-show=\"vm.isShowFilter\" class=\"animate-show\"><div layout=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"guest.application\">Application</label><md-select ng-model=\"vm.appId\" name=\"app\" \nmd-on-close=\"vm.clearSearchGroup()\"><md-select-header><input id=\"searchGroupInput\" ng-model=\"vm.searchGroupInput\" \ntype=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header><md-option \nng-repeat=\"app in vm.applications| filter:vm.searchGroupInput\" value=\"{{app.application.id}}\">{{app.application.name}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"row\" layout-align=\"center center\">\n<md-button class=\"md-accent md-raised md-hue-1\" ng-click=\"vm.search()\">{{\'REPORT.SEARCH\'| translate}}</md-button></div>\n</div></md-card></div><center><h2>{{\'reporUsersRoles.title\'| translate}}</h2></center><div id=\"masterGridOptions\" \nag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div></div>\n<md-button class=\"md-fab\" aria-label=\"Generar xls\" ng-show=\"vm.showGrid\" ng-click=\"vm.onExportXLS()\" \nstyle=\"position: fixed; bottom: 10px; right: 20px\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/usr/user-guest/user-guest.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"30\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\"guest.title\"| translate}} ({{vm.pagination.totalElements}})</span></div></div><div layout=\"row\"><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"guest.invitados\">Guests</span>\n</md-tab-label><md-tab-body><md-content class=\"guest-tab\"><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div></md-content></md-tab-body></md-tab>\n<md-tab><md-tab-label><span translate=\"guest.invitar\">Invite</span></md-tab-label><md-tab-body><md-content \nclass=\"invite-tab\" ng-include=\"\'app/main/apps/usr/user-guest/tabs/invite/invite.html\'\"></md-content></md-tab-body>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/public/auth/forgot-password/forgot-password.html","<div id=\"forgot-password-container\" layout=\"row\" layout-align=\"center center\"><md-card flex-xl=\"20\" flex-lg=\"25\" \nflex-md=\"25\" flex-sm=\"60\" flex-xs=\"75\"><form id=\"forgotPasswordForm\" name=\"forgotPasswordForm\" \nng-submit=\"forgotPasswordCtrl.send()\" novalidate><div layout=\"row\" layout-align=\"center center\"><h2>\n{{\'FORGOTPASSWORD.TITLE\' | translate}}</h2></div><div layout=\"row\" layout-align=\"center center\"><md-input-container \nflex=\"90\" class=\"md-block\" md-no-float><input type=\"text\" name=\"email\" autocomplete=\"off\" \nng-model=\"forgotPasswordCtrl.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" required><div ng-messages=\"forgotPasswordForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\">\n<md-button flex=\"90\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></div><div \nclass=\"got-start-page\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"public.content.index\">\n{{\'FORGOTPASSWORD.GO_BACK\' | translate}}</a></div></form></md-card></div>");
$templateCache.put("app/main/public/auth/register/readAccept.html","<md-dialog class=\"md-dialog-fullscreen\" ng-cloak><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"close\" ng-click=\"termsCtrl.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-dialog-content style=\"padding: 15px\"><p style=\"text-align: justify\">\n{{\'REGISTER_V2.TERMS_COND\' | translate}}</p></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"termsCtrl.accept()\" md-autofocus>{{\'REGISTER_V2.ACCEPT\' | translate}}\n</md-button><md-button ng-click=\"termsCtrl.close()\">{{\'REGISTER_V2.CANCEL\' | translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/public/auth/register/register.html","<div id=\"register-container\" layout=\"row\" layout-align=\"center center\"><md-card flex-xl=\"20\" flex-lg=\"30\" flex-md=\"30\" \nflex-sm=\"80\" flex-xs=\"90\"><form id=\"registerForm\" name=\"registerForm\" ng-submit=\"registerCtrl.add()\" novalidate><div \nlayout=\"row\" layout-align=\"center center\"><h2>{{\'REGISTER_V2.TITLE\' | translate}}</h2></div><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex=\"90\" class=\"md-block\" md-no-float><input name=\"username\" \nng-model=\"registerCtrl.UserInfo.name\" placeholder=\"Name\" translate translate-attr-placeholder=\"REGISTER_V2.NAME\" \nrequired><div ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.FIELD_REQUIRED\"></span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex=\"90\" class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"registerCtrl.UserInfo.preferredUsername.userName\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex=\"90\" class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" id=\"password\" ng-model=\"registerCtrl.UserInfo.preferredUsername.password\" placeholder=\"Password\" \ntranslate translate-attr-placeholder=\"REGISTER_V2.PASSWORD\"><div my-password-strength \npassword=\"registerCtrl.UserInfo.preferredUsername.password\"></div><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\"></span></div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container style=\"margin: 0px\" \nflex=\"90\" class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"registerCtrl.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" pw-check=\"password\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\"></span></div><div ng-message=\"pwmatch\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_NOT_EQUALS\"></span></div></div></md-input-container></div><div \nlayout=\"row\" layout-align=\"center center\"><md-checkbox class=\"terms\" name=\"terms\" \nng-model=\"registerCtrl.isAcceptTermsAndConditions\" aria-label=\"I read and accept\" required><span \ntranslate=\"REGISTER_V2.READ_ACCEPT\"></span> <a href=\"\" ng-click=\"registerCtrl.accepTermsAndConditions()\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\"></a></md-checkbox></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button flex=\"90\" type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"CREATE MY ACCOUNT\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" \ntranslate=\"REGISTER_V2.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\"></md-button></div><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\"></span>\n <a class=\"link\" ng-click=\"registerCtrl.login()\" translate=\"REGISTER_V2.LOGIN\"></a></div></form></md-card></div>");
$templateCache.put("app/main/general/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>PS</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">\nRecover your password</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<input type=\"text\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" required><div ng-messages=\"forgotPasswordForm.email.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">\nEmail field is required</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \nng-click=\"vm.send()\" translate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"auth.login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/general/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password\n</div><form name=\"resetPasswordForm\" novalidate ng-submit=\"vm.changePwd()\"><div \nng-if=\"vm.user.snCambioPwd !== null && !vm.user.snCambioPwd\"><div class=\"subtitle\" translate=\"RESETPASSWORD.CHANGEPWD\">\nReset your password</div><md-input-container class=\"md-block\" md-no-float><input id=\"password\" type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" pw-validate required><div id=\"txtPwdInfo\"><ul \nng-show=\"!vm.form.password || vm.form.password === \'\'\"><li id=\"pwd1-letter\" class=\"er invalido\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icon invalido\"></md-icon><span translate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">\nrequerido</span></li></ul><ul ng-show=\"!(!vm.form.password || vm.form.password === \'\')\"><li id=\"pwd1-letter\" \nclass=\"er\" ng-class=\"!resetPasswordForm.password.$error.pwletter ? \'valido\' : \'invalido\'\"><md-icon \nng-class=\"!resetPasswordForm.password.$error.pwletter ? \'valido\' : \'invalido\'\" \nmd-font-icon=\"{{!basicForm.password.$error.pwletter ? \'icon-check\' : \'icon-close\'}}\" class=\"icon\"></md-icon>\n{{\'general.txt_al_menos\'| translate}} <strong>{{\'general.txt_una_letra\'| translate}}</strong></li><li \nid=\"pwd1-capital\" class=\"er\" ng-class=\"!resetPasswordForm.password.$error.pwcapital ? \'valido\' : \'invalido\'\"><md-icon \nng-class=\"!resetPasswordForm.password.$error.pwcapital ? \'valido\' : \'invalido\'\" \nmd-font-icon=\"{{!basicForm.password.$error.pwcapital ? \'icon-check\' : \'icon-close\'}}\" class=\"icon\"></md-icon>\n{{\'general.txt_al_menos\'| translate}} <strong>{{\'general.txt_una_letra_mayuscula\'| translate}}</strong></li><li \nid=\"pwd1-number\" class=\"er\" ng-class=\"!resetPasswordForm.password.$error.pwnum ? \'valido\' : \'invalido\'\"><md-icon \nng-class=\"!resetPasswordForm.password.$error.pwnum ? \'valido\' : \'invalido\'\" \nmd-font-icon=\"{{!basicForm.password.$error.pwnum ? \'icon-check\' : \'icon-close\'}}\" class=\"icon\"></md-icon>\n{{\'general.txt_al_menos\'| translate}} <strong>{{\'general.txt_un_numero\'| translate}}</strong></li><li id=\"pwd1-length\" \nclass=\"er\" ng-class=\"!resetPasswordForm.password.$error.pwlen ? \'valido\' : \'invalido\'\"><md-icon \nng-class=\"!resetPasswordForm.password.$error.pwlen ? \'valido\' : \'invalido\'\" \nmd-font-icon=\"{{!basicForm.password.$error.pwlen ? \'icon-check\' : \'icon-close\'}}\" class=\"icon\"></md-icon>\n{{\'general.txt_tener_por_lo_menos\'| translate}} <strong>8 {{\'general.txt_caracteres\'| translate}}</strong></li></ul>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input id=\"passwordConfirm\" \ntype=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \npw-check=\"password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nid=\"txtPwdInfo\"><ul ng-show=\"resetPasswordForm.passwordConfirm.$invalid\"><li id=\"pwd1-length\" class=\"er\" \nng-class=\"\'invalido\'\"><md-icon ng-class=\"\'invalido\'\" md-font-icon=\"icon-close\" class=\"icon\"></md-icon>\n{{\'RESETPASSWORD.ERRORS.NOMATCH\'| translate}}</li></ul></div></md-input-container></div><div \nng-if=\"vm.user.snCambioPwd2 !== null && !vm.user.snCambioPwd2\"><div class=\"subtitle\" \ntranslate=\"RESETPASSWORD.CHANGEPWD2\">Reset your password</div><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"password2\" id=\"password2\" ng-model=\"vm.form.password2\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD2\" maxlength=\"4\" minlength=\"4\" required><div \nng-messages=\"registerForm.password2.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div><div ng-message=\"maxlength\">\n<span translate=\"RESETPASSWORD.ERRORS.LENGTH4\">Debe ser de 4 digitos</span></div><div ng-message=\"minlength\"><span \ntranslate=\"RESETPASSWORD.ERRORS.LENGTH4\">Debe ser de 4 digitos</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm2\" \nng-model=\"vm.form.passwordConfirm2\" placeholder=\"Password (Confirm)\" pw-check=\"password2\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM2\" required><div id=\"txtPwdInfo\"><ul \nng-show=\"resetPasswordForm.passwordConfirm2.$invalid\"><li id=\"pwd1-length\" class=\"er\" ng-class=\"\'invalido\'\"><md-icon \nng-class=\"\'invalido\'\" md-font-icon=\"icon-close\" class=\"icon\"></md-icon>{{\'RESETPASSWORD.ERRORS.NOMATCH\'| translate}}\n</li></ul></div></md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">UPDATE MY PASSWORD\n</md-button></form></div></div></div>");
$templateCache.put("app/main/general/auth/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div \nclass=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\"></div></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div class=\"logo\" hide-gt-sm><span><img \nng-src=\"{{vm.urlIcons}}\" alt=\"image\"></span></div><div layout=\"column\" layout-align=\"start center\"><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\"></div></div><br><div layout=\"column\" layout-align=\"start center\"><md-button \naria-label=\"Login\" class=\"md-raised google\" ng-click=\"vm.authenticate(\'OIDC\')\" translate=\"LOGIN_V2.WITH_OIDC\">\n</md-button><a class=\"link\" ng-click=\"vm.forgetPassword();\">Olvide mi contraseña</a></div><div class=\"register\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN_V2.DONT_HAVE_ACCOUNT\">\n</span> <a class=\"link\" ng-click=\"vm.register();\" translate=\"LOGIN_V2.CREATE_ACCOUNT\"></a></div></div></div></div>");
$templateCache.put("app/main/general/auth/register/readAccept.html","<md-dialog class=\"md-dialog-fullscreen\" ng-cloak><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"close\" ng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-dialog-content style=\"padding: 15px\"><p style=\"text-align: justify\">\nAcepto los términos y condiciones</p></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.accept()\" md-autofocus>{{\'REGISTER_V2.ACCEPT\' | translate}}</md-button><md-button \nng-click=\"vm.close()\">{{\'REGISTER_V2.CANCEL\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/general/auth/register/register.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>PS</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\"></div><div \nclass=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\"></div></div><div id=\"register-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex ms-scroll><div id=\"register-v2-form\"><div \nclass=\"logo md-accent-bg\" hide-gt-sm><span>PS</span></div><div class=\"title\" translate=\"REGISTER_V2.TITLE\"></div><form \nname=\"registerForm\" ng-submit=\"vm.add()\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nname=\"username\" ng-model=\"vm.UserInfo.name\" placeholder=\"Name\" translate translate-attr-placeholder=\"REGISTER_V2.NAME\" \nrequired><div ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.FIELD_REQUIRED\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.UserInfo.preferredUsername.userName\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" id=\"password\" \nng-model=\"vm.UserInfo.preferredUsername.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD\"><div my-password-strength \npassword=\"vm.UserInfo.preferredUsername.password\"></div><div ng-messages=\"registerForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\"></span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" pw-check=\"password\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\"></span></div><div ng-message=\"pwmatch\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_NOT_EQUALS\"></span></div></div></md-input-container><div class=\"terms\" \nlayout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"vm.isAcceptTermsAndConditions\" \naria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\">\n<span translate=\"REGISTER_V2.READ_ACCEPT\"></span> <a href=\"\" ng-click=\"vm.accepTermsAndConditions()\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\"></a></div></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\"></md-button></form><div class=\"login\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\"></span> <a \nclass=\"link\" ui-sref=\"auth.login\" translate=\"REGISTER_V2.LOGIN\"></a></div></div></div></div>");
$templateCache.put("app/main/general/errors/404/error-404.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll ng-cloak><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><h1>\n{{\'ERRORS.405.MESSAGE\'| translate}}</h1><div class=\"logo\"><img ng-src=\"{{vm.iconApp}}\" alt=\"image\"></div><div \nclass=\"subtitle\">{{\'ERRORS.405.CODE\'| translate}}</div><div><a class=\"back-link md-accent-color\" href=\"/\" \nui-sref=\"app.dashboards_project\" translate=\"ERRORS.405.GO_BACK\">Go back to dashboard</a></div></div></div></div>");
$templateCache.put("app/main/general/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" src=\"{{userAccount.person.image}}\" alt=\"image\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\"></div><div class=\"subtitle\" \ntranslate=\"LOCK.SUBTITLE\"></div></div></div><form name=\"lockForm\" novalidate><md-button \nclass=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" ng-click=\"vm.authenticate(\'OIDC\')\" \ntranslate=\"LOCK.UNLOCK\" translate-attr-aria-label=\"LOCK.UNLOCK\"></md-button></form><div class=\"message\"><a \nui-sref=\"public.content.index\" class=\"md-accent-color\"><span translate=\"LOCK.ARE_YOU_NOT\"></span><span>\n {{account.name}}?</span></a></div></div></div></div>");
$templateCache.put("app/main/general/errors/unauthorized/unauthorized.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll ng-cloak><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><h1>\n{{\'ERRORS.noAutorizado.no_acceso_app\'| translate}}</h1><div class=\"logo\"><img ng-src=\"{{vm.iconApp}}\" alt=\"image\">\n</div><div class=\"subtitle\">{{\'ERRORS.noAutorizado.comuniquese_con_admin\'| translate}}</div><div><md-button \nclass=\"md-primary\" ng-click=\"vm.goToConfigureCompany()\">{{\'ERRORS.noAutorizado.configurarEmpresa\'| translate}}\n</md-button></div></div></div></div>");
$templateCache.put("app/main/general/notifications/my-notifications/my-notifications.html","<div id=\"my-notifications-view\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\'notifications.my_notifications\' | translate}}</span></div><div layout=\"column\" flex=\"80\" \nclass=\"search-container\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-enter=\"vm.search()\" \nng-click=\"vm.showAdvancedFilter = false;\" ng-model=\"vm.searchInput\" type=\"search\" \nplaceholder=\"{{\'general.search\'| translate}}\"><md-button title=\"{{\'notifications.show_search_options\' | translate}}\" \nng-click=\"vm.showAdvancedFilter = !vm.showAdvancedFilter;\" class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s18\"></md-icon></md-button></div><div ng-if=\"vm.showAdvancedFilter\" \nid=\"advanced-filter\" layout=\"column\" ng-include=\"\'app/main/general/notifications/my-notifications/filter/filter.html\'\" \nng-controller=\"MyNotificationsFilterController as filterCtrl\"></div></div></div><md-card class=\"content-card\" flex \nlayout=\"column\" ng-include=\"\'app/main/general/notifications/my-notifications/content/content.html\'\"></md-card></div>\n</div>");
$templateCache.put("app/main/general/notifications/configuration/configuration.html","<div id=\"notification-configuration-view\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div class=\"title\" flex=\"20\" \nflex-xs=\"100\"><span>{{\'notifications.setup_notifications\'| translate}}</span></div><div flex=\"20\" \nclass=\"applications-select\" layout=\"column\"><span>{{\'notifications.filter_by_application\' | translate}}:</span>\n<md-select aria-label=\"filter by application\" ng-model=\"vm.applicationsSelected\" \nng-change=\"vm.filterConfigByAppName()\"><md-option ng-value=\"application.id\" \nng-repeat=\"application in vm.applicationsArray\">{{application.name}}</md-option></md-select></div></div><div \nclass=\"content-card\" ms-scroll flex layout=\"column\" \nng-include=\"\'app/main/general/notifications/configuration/content/content.html\'\"></div></div></div>");
$templateCache.put("app/main/general/profile/profileEditor/profileEditor.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" ui-sref=\"app.profile\" \nstyle=\"cursor: pointer\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\" style=\"cursor: pointer\" ui-sref=\"app.profile\">\n{{vm.userInfo.name}} {{vm.userInfo.familyName}}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\" translate=\"PROFILE.EDIT.TITLE\">Edit</span></div><div class=\"title\"><span \ntranslate=\"PROFILE.EDIT.TITLE\">Edit</span> {{vm.userInfo.name}} {{vm.userInfo.familyName}}</div></div><div \nclass=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-warn\" style=\"height: 56px\" \naria-label=\"Edit\" ui-sref=\"app.profile\"><md-icon md-svg-icon=\"close\"></md-icon></md-button></div></div>\n<md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div class=\"content\" \nlayout=\"column\"><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><em class=\"icon-check s16\"></em> </span>\n<span class=\"ms-form-wizard-step-text\" translate=\"PROFILE.GENERAL_INFORMATION\">Personal Information</span></span>\n</md-tab-label><md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\">CHANFLE <input \ntype=\"text\" name=\"firstname\" ng-model=\"vm.userInfo.name\" placeholder=\"{{\'PROFILE.EDIT.NAME\'| translate}}\" required><div\n ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.NAME\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}.</span></div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\"><input type=\"text\" name=\"middlename\" \nng-model=\"vm.userInfo.middleName\" placeholder=\"{{\'PROFILE.EDIT.SNAME\'| translate}}\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"50\"><input type=\"text\" name=\"familyName\" \nng-model=\"vm.userInfo.familyName\" placeholder=\"{{\'PROFILE.EDIT.LASTNAME\'| translate}}\"></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"50\"><input type=\"text\" name=\"givenName\" \nng-model=\"vm.userInfo.givenName\" placeholder=\"{{\'PROFILE.EDIT.TNAME\'| translate}}\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"20\"><input type=\"text\" \nname=\"nickname\" ng-model=\"vm.userInfo.nickname\" placeholder=\"{{\'PROFILE.EDIT.NICKNAME\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"80\"><input type=\"email\" name=\"email\" \nng-model=\"vm.userInfo.email\" placeholder=\"{{\'PROFILE.EDIT.EMAIL\'| translate}}\" ng-pattern=\"/^.+@.+\\..+$/\" required><div\n ng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.EMAIL\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}.</span></div><div ng-message=\"pattern\">\n<span>{{\'PROFILE.EDIT.EMAIL\'| translate}} {{\'PROFILE.EDIT.EINVALID\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<label>{{\'PROFILE.EDIT.GENDER\'| translate}}</label><md-select ng-model=\"vm.userInfo.gender\"><md-option \nng-repeat=\"gender in vm.genders\" value=\"{{gender}}\">{{\'SEXO.\' + gender| translate}}</md-option></md-select>\n</md-input-container><div flex=\"100\" flex-gt-xs=\"50\"><md-datepicker class=\"md-block\" ng-model=\"vm.userInfo.birthdate\" \nmd-placeholder=\"Enter date\"></md-datepicker></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" \nng-model=\"vm.userInfo.preferredUsername.password\" placeholder=\"{{\'PROFILE.EDIT.PASSWORD\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" \nplaceholder=\"{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}})\" \nng-model=\"vm.userInfo.validatePassword\" ng-pattern=\"{{vm.userInfo.preferredUsername.password}}\" \nng-required=\"vm.userInfo.preferredUsername.password\"><div ng-messages=\"wizardStep1.passwordConfirm.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.REQUIRED\'| translate}}.\n</span></div><div ng-message=\"pattern\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.MATCH\'| translate}}.\n</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\">\n<em class=\"icon-check s16\"></em> </span><span class=\"ms-form-wizard-step-text\" translate=\"PROFILE.PROFILE\">Profile\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate><md-input-container \nclass=\"md-block\"><label>{{\'PROFILE.ABOUT_ME\'| translate}}</label><textarea rows=\"3\" name=\"profile\" md-maxlength=\"150\" \nmax-rows=\"5\" ng-model=\"vm.userInfo.profile\"></textarea></md-input-container><md-input-container class=\"md-block\">\n<label>{{\'PROFILE.PICTURE\'| translate}}</label><input type=\"file\" name=\"picture\" ng-model=\"vm.userInfo.picture\" \nplaceholder=\"Picture\"> <button ng-click=\"uploadFileGenerico(person.id)\" class=\"btn btn-sm\">Cargar</button>\n</md-input-container></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\">\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep3.$invalid\">3</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\">\n<em class=\"icon-check s16\"></em> </span><span class=\"ms-form-wizard-step-text\" translate=\"PROFILE.CONTACT\">Contact\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" ms-form-wizard-form novalidate><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex=\"100\" flex-gt-xs=\"80\"><label>{{\'PROFILE.EDIT.ADDRESS\'| translate}}</label>\n<textarea rows=\"1\" name=\"address\" md-maxlength=\"150\" max-rows=\"3\" ng-model=\"vm.userInfo.locale\"></textarea>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\"><label>{{\'PROFILE.EDIT.POSTAL\'| translate}}</label>\n<input name=\"postalcode\" ng-model=\"vm.userInfo.zoneinfo\" placeholder=\"12345\" ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep3.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><input type=\"tel\" name=\"phone\" ng-model=\"vm.userInfo.phoneNumber\" \nplaceholder=\"{{\'PROFILE.EDIT.PHONE\'| translate}}\"></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"url\" name=\"website\" ng-model=\"vm.userInfo.website\" placeholder=\"{{\'PROFILE.EDIT.WEBSITE\'| translate}}\">\n</md-input-container></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep()\"><span translate=\"PROFILE.EDIT.PREVIOUS\">Previous</span></md-button><div \nclass=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\n                                          \'selected md-accent-bg\':msWizard.selectedIndex === $index}\">\n</span></div><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\"><span translate=\"PROFILE.EDIT.NEXT\">Next</span></md-button><md-button \nclass=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\"><span translate=\"PROFILE.EDIT.SAVE\">Send</span></md-button></div>\n</ms-form-wizard></div></div></div>");
$templateCache.put("app/quick-panel/tabs/my-notifications/view-notification/view-notification.html","<md-dialog aria-label=\"view notification\" id=\"view-my-notification\"><div class=\"notification-toolbar\" layout=\"row\"><div\n flex layout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"notification\"><div layout=\"column\" flex><div class=\"notification-info\" layout=\"column\"><div layout=\"row\"><div \nclass=\"applicationFrom\" flex>{{\'notifications.application\'| translate}}: {{vm.notification.applicationName}}</div><div \nlayout=\"row\" layout-align=\"end center\" class=\"notification-date\"><span>\n{{vm.notification.createdAt| apiDate: \'dd-MM-yyyy HH:mm\'}}</span></div></div><div layout=\"row\"><div flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"userFrom\" ng-if=\"vm.notification.userFromId\">\n{{\'notifications.from\'| translate}}: {{vm.notification.userFromName}} ({{vm.notification.userFromAccount}})</div></div>\n<div layout=\"row\" layout-align=\"end center\" class=\"icon-alert-type\" \nng-class=\"{\'warning-type\': vm.notification.notificationType.alertType === \'WARNING\',\n                         \'error-type\': vm.notification.notificationType.alertType === \'ERROR\',\n                         \'success-type\': vm.notification.notificationType.alertType === \'SUCCESS\',\n                         \'message-type\': vm.notification.notificationType.alertType === \'MESSAGE\'}\">\n<md-icon md-font-icon=\"icon-pin\" class=\"s20\" ng-if=\"!vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-message-text\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'MESSAGE\' && vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-check\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'SUCCESS\' && vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-alert\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'WARNING\' && vm.notification.isUserNotification\"></md-icon><md-icon \nmd-font-icon=\"icon-cancel\" class=\"s20\" \nng-if=\"vm.notification.alertType === \'ERROR\' && vm.notification.isUserNotification\"></md-icon></div></div><div \nclass=\"origin-type-info\" layout=\"row\" layout-align=\"estart center\" \nng-if=\"vm.notification.originTypeId !== null && vm.notification.originTypeId !== undefined\">\n{{vm.notification.originTypeName}}: {{vm.notification.referenceNumber}}</div></div><div class=\"notification-message\" \nng-bind-html=\"vm.notification.message\"></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-primary\" ng-click=\"vm.closeDialog()\">{{\'general.close\'| translate}}</md-button></div></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">{{MsStepper.backDescriptionButton}}</md-button><div class=\"ms-stepper-dots\">\n<span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">\n{{MsStepper.nextDescriptionButton}}</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">\n{{MsStepper.submitDescriptionButton}}</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/main/apps/account/account-type/account-type/account-type.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 50%\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.accounttype.id ? \'general.edit\' : \'general.add\'| translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><ng-form name=\"vm.accounttypeForm\" id=\"accounttypeForm\">\n<div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'accounttype.acTypeCode\' | translate}}</label><input \ntype=\"text\" ng-model=\"vm.accounttype.acTypeCode\" name=\"acTypeCode\" required><div \nng-messages=\"vm.accounttypeForm.acTypeCode.$error\"><div ng-message=\"required\">{{\'general.field_required\' | translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'accounttype.acTypeDescription\' | translate}}</label><input type=\"text\" ng-model=\"vm.accounttype.acTypeDescription\" \nname=\"acTypeDescription\" required><div ng-messages=\"vm.accounttypeForm.acTypeDescription.$error\"><div \nng-message=\"required\">{{\'general.field_required\' | translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-checkbox ng-disabled=\"!vm.accounttype.id\" ng-model=\"vm.accounttype.active\">{{\'general.active\' | translate}}\n</md-checkbox></div></ng-form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">\n{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/accounting-catalog/accounting-catalog/accounting-catalog.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 90%\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.account.id ? \'general.edit\' : \'general.add\'| translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-if=\"!vm.confirmDeactivate\"><ng-form \nname=\"vm.accountForm\" id=\"accountForm\"><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'accountingCatalog.code\'| translate}}</label><input type=\"text\" ng-model=\"vm.account.code\" name=\"code\" required><div \nng-messages=\"vm.accountForm.code.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'accountingCatalog.description\'| translate}}</label><input type=\"text\" ng-model=\"vm.account.description\" \nname=\"description\" required><div ng-messages=\"vm.accountForm.description.$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nflex=\"100\"><label>{{\'accountingCatalog.expenseType\'| translate}}</label><md-select \nng-model=\"vm.account.expenseType.id\" required><md-optgroup><md-option ng-value=\"r.id\" ng-repeat=\"r in vm.expenseType\">\n{{r.description}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.account.id\" ng-model=\"vm.account.active\">{{\'general.active\'| translate}}</md-checkbox></div></ng-form>\n</div><div class=\"md-dialog-content\" ng-if=\"vm.confirmDeactivate\"><h1><span class=\"md-warn\">\n{{\'accountingCatalog.confirmaDesactivar1\'| translate}}</span></h1><h2><span>\n{{\'accountingCatalog.confirmaDesactivar2\'| translate}}</span></h2></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{vm.confirmDeactivate ? \'general.no\' : \'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">\n{{vm.confirmDeactivate ? \'general.si\' : \'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/accounting-catalog/accounting-catalog-list/accounting-catalog-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"100\"><span style=\"font-size: 25px; color: white; padding-left: 10px\" \nng-show=\"vm.account\">{{\"accountingCatalog.cuentasContablesDe\"| translate}}: {{vm.account.description}}</span> <span \nng-show=\"vm.companyParameterAccountLevel <= 0\" style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\"accountingCatalog.configureNivel\"| translate}}</span></div></div><div class=\"page-layout simple left-sidenav\" \nlayout=\"row\" style=\"min-height: 85%;height: 85%\"><md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><md-list><md-subheader class=\"md-no-sticky\" \nstyle=\"border-bottom: 1px solid #D8D8D8; padding: 1px\">{{\"accountingCatalog.level\"| translate}} 1<md-button \nclass=\"md-accent md-primary md-hue-1\" aria-label=\"add\" ng-show=\"vm.companyParameterAccountLevel > 0\" \nng-click=\"vm.add()\">{{\"accountingCatalog.agregarNuevo\"| translate}}</md-button></md-subheader><md-list-item \nng-class=\"(account === vm.account) ? \'selected\' : \'\'\" ng-click=\"vm.getAccountByLevel(account)\" \nng-repeat=\"account in vm.accountLevel1\" style=\"border-bottom: 1px solid #D8D8D8\"><p>{{account.description}}</p><md-icon\n ng-show=\"account.active\" md-font-icon=\"icon-check\"></md-icon><md-icon ng-show=\"!account.active\" \nmd-font-icon=\"icon-close\"></md-icon><md-button class=\"md-icon-button\" ng-click=\"vm.edit(account)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.edit\"| translate}}</md-tooltip>\n</md-button></md-list-item></md-list></md-sidenav><div class=\"center\" flex ms-scroll><md-card><md-progress-linear \nstyle=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear><div id=\"accountGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"0\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-show=\"vm.account && vm.companyParameterAccountLevel > 1\" ng-disabled=\"!vm.account.active\" \nng-click=\"vm.addChildren(vm.account, true)\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"accountingCatalog.agregarCuentaHija\"| translate}} ({{vm.account.description}})</md-tooltip>\n</md-button><style>.selected {\n        background-color: lightblue;\n    }</style>");
$templateCache.put("app/main/apps/account/accounting-entry/account-entry-edit/account-entry-edit.html","<md-dialog id=\"dialog-edit-account\" aria-label=\"Crear-Editar\" ng-style=\"vm.dinamicStyle\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.accountEntry.id ? \'general.edit\' : \'general.add\'| translate}} {{\'accountingEntry.accountingEntry\' | translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><ng-form name=\"vm.accountEntryForm\" \nid=\"accountEntryForm\"><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'accounttype.acTypeDescription\' | translate}}</label><input type=\"text\" ng-model=\"vm.accountEntry.seriesNameErp\" \nname=\"seriesNameErp\"><div ng-messages=\"vm.accountEntryForm.seriesNameErp.$error\"><div ng-message=\"required\">\n{{\'general.field_required\' | translate}}</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nflex=\"100\"><label>{{\'accountingEntry.accountingEntryType\' | translate}}</label><md-select \nng-model=\"vm.accountEntry.accountingEntryType.id\" required><md-optgroup><md-option ng-value=\"r.id\" \nng-repeat=\"r in vm.accountingEntryTypes\">{{r.accEntryTypeCode}} - {{r.accEntryTypeName}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\"><md-checkbox ng-disabled=\"!vm.accountEntry.id\" \nng-model=\"vm.accountEntry.active\">{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/accounting-entry/accounting-entry-config-detail/accounting-entry-config-detail.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><md-button class=\"md-icon-button\" ng-click=\"vm.back()\">\n<md-icon style=\"color: white\" class=\"s25\" md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{vm.accountingEntryConfig.seriesNameErp}} {{vm.accountingEntryConfig.accountingEntryType.accEntryTypeName}} ({{vm.pagination.totalElements}})\n</span></div><div flex=\"30\" flex-xs=\"100\" ng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input \nflex=\"85\" type=\"search\" placeholder=\"{{\'accountingEntry.search_accountingEntryDetail\' | translate}}\" \nng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\"><md-button ng-click=\"vm.search()\">{{\'general.search\' | translate}}\n</md-button></div></div></div><div layout=\"row\"><div flex=\"100\"><md-card><div id=\"departmentsGrid\" ag-grid=\"vm.grid\" \nclass=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" ng-show=\"vm.showGrid\"></div></md-card></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.edit()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/account/accounting-entry/accounting-entry-config-list/accounting-entry-config-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'accountingEntry.accountingEntryConfig\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" \nflex-xs=\"100\" ng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'accountingEntry.search_accountingEntry\' | translate}}\" ng-model=\"vm.inputSearch\" \nng-enter=\"vm.search()\"><md-button ng-click=\"vm.search()\">{{\'general.search\' | translate}}</md-button></div></div></div>\n<div layout=\"row\"><div flex=\"100\"><md-card><div id=\"departmentsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid \nmin=\"100\" other=\"-30\" ng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" \naria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/account/accounting-item-report/accounting-item-report-list/accounting-itemReport-list.html","<md-card><md-button class=\"md-primary button-filter\" target=\"_blank\" ng-click=\"vm.isShowFilter = !vm.isShowFilter\">\n{{\'accountingItemReport.clickSearch\'| translate}}<md-icon ng-if=\"vm.isShowFilter\" md-font-icon=\"icon-chevron-up\">\n</md-icon><md-icon ng-if=\"!vm.isShowFilter\" md-font-icon=\"icon-chevron-down\"></md-icon></md-button><div \nng-show=\"vm.isShowFilter\" class=\"animate-show\"><fieldset><form name=\"vm.searchForm\" id=\"searchForm\" \nng-submit=\"vm.search()\"><div layout=\"row\" layout-xs=\"row\" layout-align=\"space-around center\"><md-input-container block>\n<label>{{\'accountingItemReport.startDate\'| translate}}</label><md-datepicker type=\"date\" ng-messages=\"s\" \nng-model=\"vm.filterDTO.startDate\" name=\"startDate\" md-open-on-focus id=\"startDate\" md-placeholder=\"dd-MM-yyyy\" \nng-required=\"!vm.filterDTO.erpReference\" ng-change=\"vm.endDateRecet(vm.filterDTO.startDate)\"></md-datepicker>\n</md-input-container><md-input-container block><label>{{\'accountingItemReport.endDate\'| translate}}</label>\n<md-datepicker type=\"date\" ng-model=\"vm.filterDTO.endDate\" name=\"endDate\" md-open-on-focus id=\"endDate\" \nmd-placeholder=\"dd-MM-yyyy\" md-min-date=\"vm.filterDTO.startDate\" ng-required=\"!vm.filterDTO.erpReference\">\n</md-datepicker></md-input-container></div><div layout=\"row\" layout-xs=\"row\" layout-align=\"space-around center\">\n<md-input-container flex><span>{{\'accountingItemReport.erpReference\' | translate}}</span> <input type=\"text\" \nng-model=\"vm.filterDTO.erpReference\" name=\"erpReference\"></md-input-container><md-input-container flex><span>\n{{\'accountingItemReport.journalEntryType\' | translate}}</span><md-select ng-model=\"vm.filterDTO.journalEntryType\" \nrequired md-on-close=\"vm.clearSearchJournalEntryType()\" name=\"journalEntryType\" ng-disabled=\"vm.loadingSucursal\" \naria-required=\"true\"><md-select-header><input ng-keydown=\"$event.stopPropagation()\" \nng-model=\"vm.searchJournalEntryType\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"type\"><md-option value=\"{{type.value}}\" \nng-repeat=\"type in vm.journalEntryTypeList | filter:vm.searchJournalEntryType\">{{type.translate | translate}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-xs=\"row\" \nlayout-align=\"space-around center\"><md-input-container flex><span>{{\'accountingItemReport.company\'| translate}}</span>\n<md-select ng-model=\"vm.filterDTO.company\" md-on-close=\"vm.clearSearchCompany()\" ng ng-disabled=\"vm.loadingSucursal\" \naria-required=\"true\" ng-change=\"vm.estabishmentListByCompany(vm.filterDTO.company)\"><md-select-header><input \nng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchCompany\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"company\"><md-option \nng-value=\"company.id\" ng-repeat=\"company in vm.companyList | filter:vm.searchCompany\">{{company.name}}</md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex><span>\n{{\'accountingItemReport.establishment\'| translate}}</span><md-select ng-model=\"vm.filterDTO.establishment\" \nmd-on-close=\"vm.clearSearchEstablishment()\" ng-disabled=\"vm.loadingEstablishment\" aria-required=\"true\">\n<md-select-header><input ng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchEstablishment\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"establishment\"><md-option \nng-value=\"establishment.id\" ng-repeat=\"establishment in vm.establishmentList | filter:vm.searchEstablishment\">\n{{establishment.comercialName}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" \nlayout-xs=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" type=\"submit\" \nng-click=\"vm.query()\" ng-disabled=\"vm.searchForm.$invalid\">{{\'accountingItemReport.search\'| translate}}</md-button>\n</div></form></fieldset></div></md-card><div layout=\"row\" layout-align=\"center center\" class=\"tickets-kpi-title\"><div \nclass=\"h2\">{{\'accountingItemReport.accountingItemReport\' | translate }}</div></div><div id=\"pendigUPdateReport-grid\" \nag-grid=\"vm.gridOptions\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\" ng-show=\"vm.showGrid\"></div>");
$templateCache.put("app/main/apps/account/accounting-item-report/dialogDetailAccountingItem/dialogDetailAccountingItem.html","<md-dialog class=\"\" aria-label=\"create or edit product\" style=\"width: 60%; height: 60%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'accountingItemReport.accountingItemReportDetail\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div><div \nid=\"gridFields\" ag-grid=\"vm.gridFields\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"400\"></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/account/cost-center/cost-center-list/cost-center-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'costcenter.costcenters\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'costcenter.search_cost_center\' | translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\">\n<md-button ng-click=\"vm.search()\">{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div \nflex=\"100\"><md-card><div id=\"costCentersGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/account/cost-center/cost-center/cost-center.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 90%\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.costcenter.id ? \'general.edit\' : \'general.add\'| translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><ng-form name=\"vm.costcenterForm\" id=\"costcenterForm\">\n<div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'costcenter.code\' | translate}}</label><input type=\"text\" \nng-model=\"vm.costcenter.code\" name=\"code\" required><div ng-messages=\"vm.costcenterForm.code.$error\"><div \nng-message=\"required\">{{\'general.field_required\' | translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>{{\'costcenter.description\' | translate}}</label><input type=\"text\" \nng-model=\"vm.costcenter.description\" name=\"description\" required><div \nng-messages=\"vm.costcenterForm.description.$error\"><div ng-message=\"required\">{{\'general.field_required\' | translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-checkbox ng-disabled=\"!vm.costcenter.id\" \nng-model=\"vm.costcenter.active\">{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/department/department/department.html","<md-dialog class=\"department\" aria-label=\"Crear-Editar\" ng-style=\"vm.dinamicStyle\"><ms-widget flippable=\"true\" \nlayout=\"row\" style=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'department.padre\'| translate}}</span><md-button\n class=\"md-icon-button\" ng-click=\"vm.newContact ? vm.flip() : vm.cancel()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div><form ng-submit=\"vm.getDepartments(1)\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label translate=\"general.filter\">Filtro\n</label><input type=\"search\" ng-model=\"vm.filter\" name=\"searchFather\" ng-enter=\"vm.changeFilter()\" id=\"searchFather\">\n</md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"general.search\">Search</span>\n</md-button></div></form></div></div></div></md-toolbar><md-progress-linear type=\"indeterminate\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll style=\"padding: 0px\"><div \nng-style=\"vm.dinamicHeight\" layout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"depto in vm.departments.content\" ng-click=\"vm.selectFather(depto)\" \nng-class=\"{\'background: #E3F2FD; \' : vm.department.departmentParent.id === depto.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex><div class=\"title\">\n{{depto.code ? depto.code + \' - \' : \'\'}}{{depto.description}}</div><div class=\"notes\"></div></div></div><div \nlayout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" ng-if=\"vm.selectedFather.id === depto.id\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div></div></div><center><div paging class=\"pageable-div center\" \npage=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" \npaging-action=\"vm.getDepartments(page)\" total=\"vm.departments.totalElements\"></div></center></div><div \nclass=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular class=\"ajax-loader md-accent md-hue-2\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div></md-dialog-content></ms-widget-front><ms-widget-back \nid=\"perms\" class=\"white-bg\"><div ng-init=\"vm.flipping(flipWidget);\"></div><div class=\"page-layout carded fullwidth\" \nlayout=\"column\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.department.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><div class=\"center\" layout=\"column\" flex><div \nclass=\"md-dialog-content\"><ng-form name=\"vm.departmentForm\" id=\"departmentForm\"><div layout=\"row\"><md-input-container \nflex=\"80\"><span>{{\'department.padre\'| translate}}</span><br><span>\n{{vm.department.departmentParent.code}} - {{vm.department.departmentParent.description}}</span></md-input-container>\n<md-input-container flex=\"10\" ng-if=\"vm.department.departmentParent\"><md-button class=\"md-icon-button\" \nng-click=\"vm.department.departmentParent = null\"><md-icon md-font-icon=\"icon-broom\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\"general.delete\"| translate}}</md-tooltip></md-button></md-input-container><md-input-container \nflex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.onEdit()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\'general.edit\'| translate}}</md-tooltip></md-button></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>{{\'costcenter.code\'| translate}}</label><input type=\"text\" \nng-model=\"vm.department.code\" name=\"code\" required><div ng-messages=\"vm.departmentForm.code.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>{{\'costcenter.description\'| translate}}</label><input type=\"text\" \nng-model=\"vm.department.description\" name=\"description\" required><div \nng-messages=\"vm.departmentForm.description.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-checkbox ng-disabled=\"!vm.department.id\" \nng-model=\"vm.department.active\">{{\'general.active\'| translate}}</md-checkbox></div><div layout=\"row\" \nng-show=\"vm.appTicketsActive\"><md-checkbox ng-model=\"vm.department.canReceiveTickets\">\n{{\'department.canReceiveTickets\'| translate}}</md-checkbox></div><div layout=\"row\" \nng-show=\"vm.appTicketsActive && vm.department.canReceiveTickets\"><md-checkbox \nng-model=\"vm.department.closeTicketOnReceivePurchase\">{{\'department.closeTicketOnReceivePurchase\'| translate}}\n</md-checkbox></div><div layout=\"row\"><md-checkbox ng-model=\"vm.department.useNameToBudgetErp\">\n{{\'department.useNameToBudgetErp\'| translate}}</md-checkbox></div></ng-form></div><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-click=\"vm.save()\">{{\'general.save\'| translate}}</md-button></md-dialog-actions></div></div></ms-widget-back>\n</ms-widget></md-dialog>");
$templateCache.put("app/main/apps/account/department/department-list/department-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'department.departments\' | translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'department.search_departments\' | translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\">\n<md-button ng-click=\"vm.search()\">{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div \nflex=\"100\"><md-card><div id=\"departmentsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/account/dimensions/dimension-company-detail-list/dimension-company-detail-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><md-button class=\"md-icon-button\" ng-click=\"vm.back()\">\n<md-icon style=\"color: white\" class=\"s25\" md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">{{\'dimensions.detail\'| translate}} - {{vm.dimensionName}}\n</span></div></div><div layout=\"row\"><div flex=\"100\"><md-card><div id=\"departmentsGrid\" ag-grid=\"vm.grid\" \nclass=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" ng-show=\"vm.showGrid\"></div></md-card></div></div><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.edit()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/account/dimensions/dimensions-company-list/dimensions-company-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">{{\'menu.dimensions\'| translate}}</span></div></div><div \nlayout=\"row\"><div flex=\"100\"><md-card><div id=\"departmentsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid \nmin=\"100\" other=\"-30\" ng-show=\"vm.showGrid\"></div></md-card></div></div>");
$templateCache.put("app/main/apps/account/expense-type/expense-type/expense-type.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 40%\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.expensetype.id ? \'general.edit\' : \'general.add\'| translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><ng-form name=\"vm.expensetypeForm\" id=\"expensetypeForm\">\n<div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'costcenter.description\' | translate}}</label><input \ntype=\"text\" ng-model=\"vm.expensetype.description\" name=\"description\" required><div \nng-messages=\"vm.expensetypeForm.description.$error\"><div ng-message=\"required\">{{\'general.field_required\' | translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-checkbox ng-disabled=\"!vm.expensetype.id\" \nng-model=\"vm.expensetype.active\">{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/account-type/account-type-list/account-type-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'accounttype.accounttypes\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'accounttype.search_accountType\' | translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\">\n<md-button ng-click=\"vm.search()\">{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div \nflex=\"100\"><md-card><div id=\"departmentsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/account/expense-type/expense-type-list/expense-type-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'expensetype.expensetypes\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'expensetype.search_expenseType\' | translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\">\n<md-button ng-click=\"vm.search()\">{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div \nflex=\"100\"><md-card><div id=\"departmentsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/account/posting-period/posting-period-list/posting-period-list.html","<md-progress-linear md-mode=\"query\" class=\"md-accent progress-style\" ng-show=\"vm.isShowProgressLinearGrid\">\n</md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-xs=\"column\" class=\"custom-header\" \nlayout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" layout-align-xs=\"center none\"><div \nflex=\"30\" flex-xs=\"100\"><span class=\"title-style\">\n{{\'postingPeriod.postingPeriods\'| translate}} ({{vm.postingPeriods.length}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.postingPeriods.length > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'postingPeriod.searchPostingPeriod\' | translate}}\" ng-model=\"vm.inputSearch\"><md-button ng-click=\"\">\n{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div flex=\"100\"><md-card><div \nid=\"postingPeriodsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" ng-show=\"vm.showGrid\">\n</div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right button-style\" aria-label=\"add\" \nng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/account/posting-period/posting-period/posting-period.html","<md-dialog aria-label=\"Crear-Editar\" class=\"dialog-style\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1>{{vm.postingPeriod.id ? \'general.edit\' : \'general.add\'| translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent progress-bar-style\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><div \nclass=\"mat-dialog-without-padding\"><ng-form name=\"vm.postingPeriodForm\" id=\"postingPeriodForm\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"50\"><label>{{\'postingPeriod.code\'| translate}}</label>\n<input type=\"text\" ng-model=\"vm.postingPeriod.periodCode\" name=\"periodCode\" required \nng-disabled=\"vm.isShowProgressLinear\"><div ng-messages=\"vm.postingPeriodForm.periodCode.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container><md-input-container \nflex=\"50\"><label>{{\'postingPeriod.name\'| translate}}</label><input type=\"text\" ng-model=\"vm.postingPeriod.periodName\" \nname=\"periodName\" ng-disabled=\"vm.isShowProgressLinear\" required><div \nng-messages=\"vm.postingPeriodForm.periodName.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}\n</div></div></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\"><md-input-container \nflex=\"50\"><label translate=\"postingPeriod.startDate\">Fecha de inicio</label><md-datepicker type=\"date\" \nng-model=\"vm.postingPeriod.periodStartDate\" name=\"periodStartDate\" md-open-on-focus \nmd-max-date=\"vm.postingPeriod.periodEndDate\" md-placeholder=\"dd-MM-yyyy\" required \nng-disabled=\"vm.isShowProgressLinear\"></md-datepicker><div ng-messages=\"vm.postingPeriodForm.periodStartDate.$error\">\n<div ng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div \nng-message=\"required\"><span>{{\'postingPeriod.startDate\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div>\n<div ng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div></md-input-container>\n<md-input-container flex=\"50\"><label translate=\"postingPeriod.endDate\">Fecha fin</label><md-datepicker type=\"date\" \nng-model=\"vm.postingPeriod.periodEndDate\" name=\"periodEndDate\" md-open-on-focus \nmd-min-date=\"vm.postingPeriod.periodStartDate\" md-placeholder=\"dd-MM-yyyy\" required \nng-disabled=\"vm.isShowProgressLinear\"></md-datepicker><div ng-messages=\"vm.postingPeriodForm.periodEndDate.$error\"><div\n ng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\">\n<span>{{\'postingPeriod.endDate\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div \nng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div></md-input-container></div><div \nlayout=\"row\"><md-checkbox ng-model=\"vm.postingPeriod.locked\" ng-disabled=\"vm.isShowProgressLinear\">\n{{\'postingPeriod.locked\' | translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.postingPeriod.id || vm.isShowProgressLinear\" ng-model=\"vm.postingPeriod.active\">\n{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between\" class=\"dialog-actions-style\"><md-button ng-click=\"vm.cancel()\" \nng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" \nng-disabled=\"vm.postingPeriodForm.$invalid  || vm.isShowProgressLinear\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/projects/projects-list/projects-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">{{\'projects.title\'| translate}} ({{vm.totalRow}})</span>\n</div><div flex=\"30\" flex-xs=\"100\" ng-if=\"vm.totalRow > 0 || vm.showSearch\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input \nflex=\"85\" type=\"search\" placeholder=\"{{\'projects.search_projects\' | translate}}\" ng-model=\"vm.search\"><md-button \nng-click=\"\">{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div flex=\"100\"><md-card>\n<div id=\"costCentersGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" ng-show=\"vm.showGrid\">\n</div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/account/projects/projects/projects.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 70%\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.project.id ? \'general.edit\' : \'general.add\'| translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><ng-form name=\"vm.projectForm\" id=\"projectForm\"><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>{{\'projects.prjCode\'| translate}}</label><input type=\"text\" \nng-model=\"vm.project.code\" name=\"code\" required><div ng-messages=\"vm.projectForm.code.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>{{\'projects.prjName\'| translate}}</label><input type=\"text\" \nng-model=\"vm.project.name\" name=\"description\" required><div ng-messages=\"vm.projectForm.description.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container><label translate=\"company_establishment.start_date\">Fecha de inicio</label><md-datepicker \ntype=\"date\" ng-model=\"vm.project.startDate\" name=\"startDate\" md-open-on-focus md-max-date=\"vm.project.endDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.projectForm.startDate.$error\"><div \nng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\">\n<span>{{\'project.startDate\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div ng-message=\"mindate\" \ntranslate=\"error.invalid_date\">Date is too early!</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container><label translate=\"company_establishment.end_date\">Fecha fin</label><md-datepicker type=\"date\" \nng-model=\"vm.project.endDate\" name=\"endDate\" md-open-on-focus md-min-date=\"vm.project.startDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.projectForm.endDate.$error\"><div \nng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\">\n<span>{{\'projects.endDate\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div ng-message=\"mindate\" \ntranslate=\"error.invalid_date\">Date is too early!</div></div></md-input-container></div></ng-form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" ng-disabled=\"!vm.projectForm.$dirty\">\n{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/rol-dimension-default/dimension-default/dimension-default.html","<div id=\"e-commerce-order\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"h2\"><span class=\"title-style\">{{\'dimensionDefault.roleDimensionDefault\'| translate}}</span></div></div></div>\n</div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear><div \nid=\"dimension-content\" class=\"content-card\" layout=\"column\" flex><ng-form name=\"vm.dimensionDefault\"><div layout=\"row\" \nclass=\"order-detail-form-container\" layout-align=\"space-around center\"><md-input-container class=\"md-block\" flex>\n<label>{{\'dimensionDefault.role\'| translate}}</label><md-select ng-model=\"vm.default.roleApplicationId\" \nname=\"roleApplication\" required md-on-close=\"vm.clearSearchRoleInput()\" \nng-disabled=\"vm.loadingRoleApplication || vm.loading\" ng-change=\"vm.getDimensionsDefault()\"><md-select-header><input \nid=\"searchRoleInput\" ng-model=\"vm.searchRoleInput\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"RoleApplication option list\"><md-option ng-value=\"role.roleApplicationId\" \nng-repeat=\"role in vm.roleApplications|filter:vm.searchRoleInput\">{{role.applicationName}} - {{role.roleDescription}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingRoleApplication\">\n</md-progress-linear><div ng-messages=\"vm.dimensionDefault.roleApplication.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'general.field_required\'| translate}}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>{{\'dimensionDefault.dimension\'| translate}}</label><md-select \nng-model=\"vm.default.dimensionNumber\" name=\"dimension\" required md-on-close=\"vm.clearSearchDimensionInput()\" \nng-disabled=\"vm.loadingDimensions || vm.loading\" ng-change=\"vm.getDimensionsDefault()\"><md-select-header><input \nid=\"searchDimensionInput\" ng-model=\"vm.searchDimensionInput\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Dimension option list\"><md-option \nng-value=\"dimension\" ng-repeat=\"dimension in vm.dimensions|filter:vm.searchDimensionInput\">{{dimension.value}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDimensions\">\n</md-progress-linear><div ng-messages=\"vm.dimensionDefault.dimension.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\'general.field_required\'| translate}}</span></div></div></md-input-container></div></ng-form><div \nclass=\"content\" layout=\"row\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" \nlayout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div flex-xl=\"45\" flex-lg=\"45\" \nflex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.searchDimension\" translate translate-attr-placeholder=\"dimensionDefault.searchDimensions\" \nng-enter=\"vm.searchDimensions()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchDimensions()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><md-subheader class=\"md-no-sticky\">\n{{\'dimensionDefault.dimensions\'| translate}} ({{vm.pagination.totalElements}})</md-subheader><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.noDimensionsDefault.length > 0\" \nng-model=\"vm.allNoDimensions\" ng-change=\"vm.selectAllNoDimensions()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.partialArray\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"!row.associated\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.code}} {{row.description ? row.description : row.name}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div \npaging class=\"pageable-div center\" ul-class=\"pagination\" hide-if-empty=\"false\" page=\"vm.pagination.pageNumber\" \npage-size=\"vm.pagination.pageSize\" paging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\">\n</div></div></div></div><div layout=\"column\"><md-button aria-label=\"Button disassociate cost center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray.length === 0 || vm.loading\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}</md-tooltip></md-button><md-button \naria-label=\"Button associate cost center\" class=\"md-primary md-raised\" ng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray.length === 0 || vm.loading\"><md-icon md-font-icon=\"icon-arrow-right\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip></md-button></div><div flex-xl=\"45\" \nflex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.searchDefault\" translate translate-attr-placeholder=\"dimensionDefault.searchRoleDimensions\" \nng-enter=\"vm.searchDefaults()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchDefaults()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><md-subheader class=\"md-no-sticky\">\n{{\'dimensionDefault.dimensions\'| translate}} ({{vm.paginationDefaults.totalElements}})</md-subheader><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.dimensionsDefault.length > 0\" \nng-model=\"vm.allDimensions\" ng-change=\"vm.selectAllDimensionsDefault()\">{{\'user.all\'| translate}}</md-checkbox></div>\n<div ng-click=\"vm.toggleDefaults(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelectedAssociated(row)}\" \nng-repeat=\"row in vm.partialDefaultArray\" ng-click=\"vm.toggleDefaults($event, row)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-marked\">\n</md-icon><md-icon ng-if=\"!vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div \nflex class=\"product-name\">{{row.code}} {{row.description}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div \npaging class=\"pageable-div center\" page=\"vm.paginationDefaults.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationDefaults.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.paginationDefaults.getPage(page)\" \ntotal=\"vm.paginationDefaults.totalElements\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/company/admin-series/establishment-cashier-list/establishment-cashier-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'menu.adminSeries\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'company_establishment.search\'| translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\"><md-button\n ng-click=\"vm.search()\">{{\'general.search\'| translate}}</md-button></div></div></div><div class=\"serie-desactivate\" \nng-show=\"vm.showGrid\"><md-switch aria-label=\"filter no validated products\" ng-model=\"vm.validateSwitch\" \nng-change=\"vm.serieDesactivate(vm.validateSwitch)\"><span translate=\"SERIES.filterCashierInvoiceSerieDesactivate\">\nFiltrar series inactivas</span></md-switch></div><div layout=\"row\"><div flex=\"100\"><md-card><div id=\"seriesGrid\" \nag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" ng-show=\"vm.showGrid\"></div></md-card></div>\n<md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-show=\"!vm.validateSwitch\" \nng-click=\"vm.addInvoiceSerieDialog()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\'general.add\'| translate}}</md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/company/company-establishments/establishment/establishment.html","<div id=\"e-commerce-order\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button close-thread\" \naria-label=\"Back\" ng-click=\"vm.goToEstablishments()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div\n layout=\"column\" layout-align=\"start start\"><div class=\"h2\"><md-icon md-font-icon=\"icon-image-filter-none\"></md-icon>\n<span translate=\"menu.establishments\" ng-if=\"!vm.establishment.id\">Establisments</span> <span \ntranslate=\"company_warehouse.establishment\" ng-if=\"vm.establishment.id\">Establisment</span>\n {{vm.establishment.establishmentName}}</div></div></div></div><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading\"></md-progress-linear><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\"><div \nlayout=\"row\"><md-tabs md-selected=\"vm.currentTab\" flex><md-tab id=\"tab1\" aria-controls=\"tab1-content\"><span \ntranslate=\"COMPANY.ABOUT\">Requisition Details</span></md-tab><md-tab \nng-disabled=\"!vm.establishment.id && (vm.establishmentForm.$invalid || vm.establishmentForm.$dirty)\" id=\"tab2\" \naria-controls=\"tab2-content\"><span translate=\"COMPANY.INVOICE_SERIE.INVOICE_SERIE\">Series</span></md-tab><md-tab \nid=\"tab3\" aria-controls=\"tab3-content\" \nng-disabled=\"!vm.establishment.id && (vm.establishmentForm.$invalid || vm.establishmentForm.$dirty)\"><span \ntranslate=\"menu.parameters\">Parametros</span></md-tab><md-tab id=\"tab4\" aria-controls=\"tab4-content\" \nng-disabled=\"!vm.establishment.id && (vm.establishmentForm.$invalid || vm.establishmentForm.$dirty)\"><span \ntranslate=\"company_establishment.user_permission\">UserPermission</span></md-tab></md-tabs></div></div><md-content \nclass=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"vm.currentTab\" class=\"tab-in-content\"><md-tab \naria-controls=\"tab1-content\"><md-tab-body><form name=\"vm.establishmentForm\" id=\"establishmentForm\" \nng-submit=\"vm.save()\"><div class=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\"><div \nclass=\"customer\"><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\" \nng-if=\"!vm.establishment.id\"><md-input-container flex-gt-xs><label translate=\"company_establishment.select_template\">\nselect_template</label><md-select ng-model=\"vm.establishment.templateReference.id\" name=\"templateReference\" \nmd-on-close=\"vm.clearSearchTemplateReference()\"><md-select-header><input id=\"searchTemplateReference\" \nng-model=\"vm.searchTemplateReference\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"templateReferences\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.templateReferences| filter:vm.searchTemplateReference\">{{data.establishmentName}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingTemplateReferences\">\n</md-progress-linear></md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start center\" \nlayout-align=\"start center\"><md-input-container flex-gt-xs><label translate=\"company_establishment.name\">Name</label>\n<input type=\"text\" name=\"name\" ng-model=\"vm.establishment.establishmentName\" required><div \nng-messages=\"vm.establishmentForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_establishment.name\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex-gt-xs><label translate=\"company_establishment.comercial_name\">\ncomercialName</label><input type=\"text\" name=\"comercialName\" ng-model=\"vm.establishment.comercialName\" required><div \nng-messages=\"vm.establishmentForm.comercialName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_establishment.comercial_name\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\">\n<md-input-container flex-gt-xs><label translate=\"company_establishment.department\">Department</label><md-select \nng-model=\"vm.establishment.department.id\" name=\"department\" required md-on-close=\"vm.clearSearchDepartment()\">\n<md-select-header><input id=\"searchDepartment\" ng-model=\"vm.searchDepartment\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{depto.id}}\" ng-repeat=\"depto in vm.departments| filter:vm.searchDepartment\">{{depto.description}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\">\n</md-progress-linear><div ng-messages=\"vm.establishmentForm.department.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\'company_establishment.department\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex-gt-xs><label translate=\"company_establishment.cost_center\">Cost Center\n</label><md-select ng-model=\"vm.establishment.costCenter.id\" name=\"costCenter\" \nmd-on-close=\"vm.clearSearchCostCenter()\" required><md-select-header><input id=\"searchCostCenter\" \nng-model=\"vm.searchCostCenter\" type=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header>\n<md-optgroup><md-option value=\"{{cc.id}}\" ng-repeat=\"cc in vm.costCenters| filter:vm.searchCostCenter\">\n{{cc.description}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingCostCenter\"></md-progress-linear><div ng-messages=\"vm.establishmentForm.costCenter.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_establishment.cost_center\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\">\n<md-input-container flex-gt-xs><label translate=\"company_establishment.currency\">Moneda</label><md-select \nng-model=\"vm.establishment.currency.id\" name=\"currency\" md-on-close=\"vm.clearSearchCurrencies()\" required>\n<md-select-header><input id=\"searchCurrency\" ng-model=\"vm.searchCurrency\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup><md-option value=\"{{cu.id}}\" \nng-repeat=\"cu in vm.currencies| filter:vm.searchCurrency\">{{cu.description}}</md-option></md-optgroup></md-select>\n<md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCurrencies\"></md-progress-linear><div \nng-messages=\"vm.establishmentForm.currency.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_establishment.currency\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex-gt-xs><label translate=\"company_establishment.address\">address</label>\n<div layout-gt-xs=\"row\"><div flex=\"100\"><input type=\"text\" name=\"address\" \nng-model=\"vm.establishment.address.addressDescription\" disabled=\"disabled\" ng-if=\"vm.establishment.address\"></div>\n<md-button class=\"md-icon-button\" ng-click=\"vm.addAddress()\"><md-icon \nmd-font-icon=\"{{vm.establishment.address?\'icon-border-color\':\'icon-plus\'}}\"></md-icon><md-tooltip md-direction=\"left\">\n{{vm.establishment.address ? \"general.edit\" : \"general.add\"| translate}}</md-tooltip></md-button></div>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\">\n<md-input-container flex-gt-xs><label translate=\"company_establishment.internal_code\">internalCode</label><input \ntype=\"text\" name=\"internalCode\" ng-model=\"vm.establishment.internalCode\" required><div \nng-messages=\"vm.establishmentForm.internalCode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_establishment.internal_code\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex-gt-xs><label translate=\"general.number\">establishmentNumber</label><input\n ng-model=\"vm.establishment.establishmentNumber\" type=\"number\" name=\"number\" required min=\"0\" \nmax=\"vm.establishment.establishmentNumber+1\" style=\"text-align: right\"><div \nng-messages=\"vm.establishmentForm.currency.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'general.number\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container></div><div\n layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs flex=\"50\">\n<label translate=\"company_establishment.erpAlmacenCode\">erpAlmacenCode</label><input type=\"text\" name=\"erpAlmacenCode\" \nng-model=\"vm.establishment.erpAlmacenCode\"></md-input-container><md-input-container flex-gt-xs><label \ntranslate=\"COMPANY.TEL\">phone</label><input ng-model=\"vm.establishment.phone\" name=\"phone\" maxlength=\"20\">\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\">\n<md-input-container flex-gt-xs><label translate=\"COMPANY.EMAILS\">email</label><input type=\"email\" \nng-model=\"vm.establishment.email\" name=\"email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\"><div \nng-messages=\"vm.establishmentForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container><md-input-container flex-gt-xs>\n<label translate=\"COMPANY.ADDRESSHEADQUARTER\">addressHeadquarter</label><input \nng-model=\"vm.establishment.addressHeadquarter\" name=\"addressHeadquarter\"></md-input-container></div><div \nlayout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"company_establishment.sizeInMeters\">sizeInMeters</label><input ng-model=\"vm.establishment.sizeInMeters\" \ntype=\"number\" name=\"sizeInMeters\" required step=\"0.01\" placeholder=\"0.00\" style=\"text-align: right\"><div \nng-messages=\"vm.establishmentForm.sizeInMeters.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_establishment.sizeInMeters\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex=\"30\" ng-if=\"vm.establishment.id\"><md-checkbox \nng-model=\"vm.establishment.active\">{{\'general.active\'| translate}}</md-checkbox></md-input-container>\n<md-input-container flex=\"30\" ng-if=\"!vm.establishment.templateReference\"><md-checkbox \nng-model=\"vm.establishment.template\">{{\'company_establishment.isTemplate\'| translate}}</md-checkbox>\n</md-input-container><md-input-container flex=\"30\" ng-if=\"!vm.establishment.template\"><md-checkbox \nng-model=\"vm.establishment.enabledJournal\">{{\'company_establishment.enabledJournal\'| translate}}</md-checkbox>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\">\n<md-input-container flex-gt-xs ng-if=\"vm.dimensionCompanyDetail3\"><label>{{vm.dimensionCompanyDetail3.description}}\n</label><md-select ng-model=\"vm.establishment.dimensionCompanyDetail3.id\" name=\"dimensionCompanyDetail3\" \nmd-on-close=\"vm.searchDimensionCompanyDetail3=\'\'\" ng-required=\"vm.dimensionCompanyDetail3.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail3\" ng-model=\"vm.searchDimensionCompanyDetail3\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" aria-label=\"search-dimension-company\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail3\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail3List| \n                                                            filter:vm.searchDimensionCompanyDetail3\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail3List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail4\"><label>{{vm.dimensionCompanyDetail4.description}}</label><md-select \nng-model=\"vm.establishment.dimensionCompanyDetail4.id\" name=\"dimensionCompanyDetail4\" \nmd-on-close=\"vm.searchDimensionCompanyDetail4=\'\'\" ng-required=\"vm.dimensionCompanyDetail4.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail4\" aria-label=\"search-dimension-company\" \nng-model=\"vm.searchDimensionCompanyDetail4\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail4\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail4List| \n                                                            filter:vm.searchDimensionCompanyDetail4\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail4List\"></md-progress-linear></md-input-container><md-input-container flex-gt-xs \nng-if=\"vm.dimensionCompanyDetail5\"><label>{{vm.dimensionCompanyDetail5.description}}</label><md-select \nng-model=\"vm.establishment.dimensionCompanyDetail5.id\" name=\"dimensionCompanyDetail5\" \nmd-on-close=\"vm.searchDimensionCompanyDetail5=\'\'\" ng-required=\"vm.dimensionCompanyDetail5.required\"><md-select-header>\n<input id=\"searchDimensionCompanyDetail5\" aria-label=\"search-dimension-company\" \nng-model=\"vm.searchDimensionCompanyDetail5\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup label=\"dimensionCompanyDetail5\"><md-option \nvalue=\"{{data.id}}\" \nng-repeat=\"data in vm.dimensionCompanyDetail5List| \n                                                            filter:vm.searchDimensionCompanyDetail5\">\n{{data.code}} - {{data.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingdimensionCompanyDetail5List\"></md-progress-linear></md-input-container></div><div layout-gt-xs=\"row\" \nlayout-align=\"start center\" layout-align=\"start center\"><md-input-container flex=\"{{vm.establishment.id?\'25\':\'50\'}}\">\n<label translate=\"company_establishment.start_date\">Fecha de inicio</label><md-datepicker type=\"date\" \nng-model=\"vm.establishment.startDate\" name=\"startDate\" md-open-on-focus md-max-date=\"vm.establishment.endDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.establishmentForm.startDate.$error\"><div \nng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\">\n<span>{{\'company_establishment.start_date\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div \nng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div></md-input-container>\n<md-input-container flex=\"{{vm.establishment.id?\'25\':\'50\'}}\"><label translate=\"company_establishment.end_date\">\nFecha fin</label><md-datepicker type=\"date\" ng-model=\"vm.establishment.endDate\" name=\"endDate\" md-open-on-focus \nmd-min-date=\"vm.establishment.startDate && vm.establishment.startDate > vm.minDate? vm.establishment.startDate:vm.minDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.establishmentForm.endDate.$error\"><div \nng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\">\n<span>{{\'company_establishment.end_date\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div \nng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div></md-input-container></div></div>\n</div></form></md-tab-body></md-tab><md-tab aria-controls=\"tab2-content\"><md-tab-body><div id=\"seriesGrid\" \nag-grid=\"vm.gridSeries\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"30\" ng-show=\"vm.showGridSeries\"></div>\n</md-tab-body></md-tab><md-tab aria-controls=\"tab3-content\"><md-tab-body><div layout=\"row\" flex><md-input-container \nflex><label translate=\"company_applications.applications\">applications</label><md-select ng-model=\"vm.application.id\" \nname=\"application\" required md-on-close=\"vm.clearSearchApplication()\" ng-change=\"vm.getParametersByApplication()\" \naria-label=\"select\"><md-select-header><input id=\"searchApplication\" ng-model=\"vm.searchApplication\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Applicacion\"><md-option \nvalue=\"{{r.application.id}}\" ng-repeat=\"r in vm.applicationArray| filter:vm.searchApplication\">{{r.application.name}}\n</md-option></md-optgroup></md-select></md-input-container></div><div \nng-repeat=\"(key, value) in vm.content | groupBy: \'applicationParameter.applicationParameterGroup.description\'\"><div \nstyle=\"padding-top: 10px; background: #fff0ff\"><strong>\n{{\'COMPANY.SECTION\' | translate | uppercase}} {{\'COMPANY.\'+(key === \'undefined\' ? \'CENTRAL\' : key) | translate | uppercase}}\n</strong></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsParameters\"><thead><tr>\n<th style=\"padding-top: 10px; padding-bottom: 10px; width: 50%\"><span translate=\"company_parameters.description\">\n</span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 40%\"><span translate=\"company_parameters.value\">\n</span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\">Opciones</th></tr></thead><tbody><tr \nng-repeat=\"player in value\"><td style=\"padding:0; width: 50%\">{{player.applicationParameter.parameterDescription}}</td>\n<td style=\"padding:0; width: 40%\"><div ng-if=\"player.applicationParameter.dataType===\'TEXT\'\"><input \nid=\"documentNumber\" autocomplete=\"off\" ng-model=\"player.parameterValue\" style=\"text-align: left; width: 100%\"></div>\n<div ng-if=\"player.applicationParameter.dataType===\'NUMBER\'\"><input id=\"documentNumber\" numbers-only=\"numbers-only\" \nautocomplete=\"off\" ng-model=\"player.parameterValue\" style=\"text-align: right\"></div><div \nng-if=\"player.applicationParameter.dataType===\'DECIMAL\'\"><input ng-model=\"player.parameterValue\" type=\"number\" \nname=\"rate\" required min=\"0.01\" max=\"vm.promotion.rate+1\" style=\"text-align: right\"></div><div \nng-if=\"player.applicationParameter.dataType===\'COLOR\'\"><div md-color-picker random=\"true\" open-on-input=\"true\" \nng-model=\"player.parameterValue\" default=\"#f00\" md-color-generic-palette=\"false\" md-color-history=\"false\">\n{{player.parameterValue}}</div></div><div ng-if=\"player.applicationParameter.dataType===\'BOOLEAN\'\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox ng-model=\"player.parameterValue\" aria-label=\"chk\"></md-checkbox></div></td>\n<td style=\"padding:0; width: 10%\"><div><md-button class=\"md-icon-button\" ng-click=\"vm.updateParameterValue(player)\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div></td></tr></tbody></table></div></md-tab-body>\n</md-tab><md-tab aria-controls=\"tab4-content\"><md-tab-body><div id=\"usersGrid\" ag-grid=\"vm.gridUser\" class=\"ag-fresh\" \nexpand-grid min=\"100\" other=\"-30\" ng-show=\"vm.showGrid\"></div></md-tab-body></md-tab></md-tabs></md-content></div>\n<md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" type=\"submit\" \nform=\"establishmentForm\" ng-if=\"vm.currentTab === 0\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip \nmd-direction=\"left\">{{(vm.establishment.id ? \'general.update\' : \'general.save\') | translate}}</md-tooltip></md-button>\n<md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.addInvoiceSerieDialog()\" ng-if=\"vm.currentTab === 1\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\'general.add\'| translate}}</md-tooltip></md-button><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.addNewUser()\" \nng-if=\"vm.currentTab === 3\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\'general.add\'| translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/establishment-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'menu.establishments\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'company_establishment.search\'| translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\"><md-button\n ng-click=\"vm.search()\">{{\'general.search\'| translate}}</md-button></div></div></div><div layout=\"row\"><div flex=\"100\">\n<md-card><div id=\"establishmentsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/company/company-establishments/paymentTypes/paymentTypes.html","<div id=\"productParamenters\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><md-button \nclass=\"goto-orders-button md-icon-button\" aria-label=\"Go to orders\" ng-click=\"vm.gotoBack()\" translate \ntranslate-attr-aria-label=\"REQUISITION.GO_TO_ORDERS\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div\n class=\"title\" flex=\"20\" flex-xs=\"100\"><span>\n{{\"PAYMENT_TYPE.PAYMENT_TYPES\"| translate}} {{vm.companyEstablishment.establishmentName}}</span></div></div><div \nclass=\"department-product\"><div><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.load\">\n<md-subheader class=\"md-no-sticky\">{{\'PAYMENT_TYPE.NOT_ASOCIATED\'| translate}} ({{vm.paymentTypesNotCompany.length}})\n</md-subheader><div ng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.paymentTypesNotCompany\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.paymentTypeName}} ({{row.paymentTypeCode}})</div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div \npaging class=\"pageable-div center\" page=\"vm.paginationRole.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationRole.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.paginationRole.getPage(page)\" \ntotal=\"vm.paginationRole.totalElements\"></div></div></div></div><div layout=\"column\"><md-button \naria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.loadAssociated\"><md-subheader class=\"md-no-sticky\">\n{{\'PAYMENT_TYPE.ASOCIATED\'| translate}} ({{vm.paymentTypesCompany.length}})</md-subheader><div \nng-click=\"vm.toggleAssociated(itemUsr, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelectedAssociated(itemUsr)}\" \nng-repeat=\"itemUsr in vm.paymentTypesCompany\" ng-click=\"vm.toggleAssociated($event, itemUsr)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociated(itemUsr)\" md-font-icon=\"icon-checkbox-marked\">\n</md-icon><md-icon ng-if=\"!vm.isSelectedAssociated(itemUsr)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div \nflex class=\"product-name\">{{itemUsr.paymentTypeName}} - ({{itemUsr.paymentTypeCode}})</div><md-icon \nmd-font-icon=\"icon-pencil\" ng-click=\"vm.associate(itemUsr)\"><md-tooltip md-direction=\"left\">\n{{\"general.edit\"| translate}}</md-tooltip></md-icon></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'department.charging_products_allowed\'| translate}}...</span></div>\n<div layout=\"row\"><div paging class=\"pageable-div center\" page=\"vm.paginationUserRole.pageNumber\" \nul-class=\"pagination\" page-size=\"vm.paginationUserRole.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationUserRole.getPage(page)\" total=\"vm.paginationUserRole.totalElements\"></div></div></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/apps/company/company-exchangeRate/ExchangeRate/exchangeRate.html","<div layout=\"column\" style=\"height: 100%; width: 100%\"><md-progress-linear \nstyle=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-xs=\"column\" class=\"custom-header\" \nlayout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" layout-align-xs=\"center none\"><div \nflex=\"30\" flex-xs=\"100\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'menu.exchangeRate\'| translate}} ({{vm.allExchangeRates.length}})</span></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-switch style=\"margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 10px\" \nng-change=\"vm.onChangeSwitch()\" ng-model=\"vm.isByEstablishment\" aria-label=\"Exchange rate by establishment\">\nTasa de cambio por sucursal</md-switch></div><div flex layout=\"row\" ng-if=\"!vm.isByEstablishment\" \nng-include=\"vm.currentContentTemplateUrl\"></div><div flex layout=\"row\" \nng-controller=\"EstablishmentExchangeRateController as secondCtrl\" ng-if=\"vm.isByEstablishment\" \nng-include=\"vm.currentContentTemplateUrl\"></div></div>");
$templateCache.put("app/main/apps/company/company-exchangeRate/by-establishment/by-establishment.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"30\"><form name=\"secondCtrl.basicForm\" class=\"md-inline-form\" \nnovalidate layout=\"column\"><md-input-container class=\"md-block\"><label>Sucursal</label><md-select \nng-model=\"secondCtrl.establishment\" name=\"Establishment\" required md-on-close=\"secondCtrl.searchEstablishment = \'\'\" \nng-change=\"secondCtrl.onChangeEstablishment()\"><md-select-header><input ng-keydown=\"$event.stopPropagation()\" \nng-model=\"secondCtrl.searchEstablishment\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"Discounts\"><md-option ng-value=\"establishment\" \nng-repeat=\"establishment in secondCtrl.establishments| filter:secondCtrl.searchEstablishment\">\n{{establishment.establishmentName}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex>\n<label translate=\"EXCHANGERATE.RATESTARTDATE\">Enter date</label><md-datepicker flex=\"100\" flex-gt-xs=\"50\" \nmd-placeholder=\"dd-MM-yyyy\" name=\"startDate\" ng-change=\"secondCtrl.changeFinalDate()\" \nng-disabled=\"secondCtrl.model.id\" ng-model=\"secondCtrl.startDatePicker\" ng-required=\"true\" type=\"date\"></md-datepicker>\n<div ng-messages=\"vm.basicForm.startDate.$error\"><div ng-message=\"required\" \ntranslate=\"EXCHANGERATE.RATESTARTDATE_IS_REQUIRED\">This date is required!</div><div ng-message=\"mindate\">\nDate is too early!</div></div></md-input-container><md-input-container flex><label \ntranslate=\"EXCHANGERATE.RATEDUEDATE\">Enter date</label><md-datepicker flex=\"100\" flex-gt-xs=\"50\" \nmd-min-date=\"secondCtrl.startDatePicker\" md-placeholder=\"dd-MM-yyyy\" name=\"dueDate\" ng-disabled=\"secondCtrl.model.id\" \nng-model=\"secondCtrl.dueDatePicker\" ng-required=\"true\" type=\"date\"></md-datepicker><div \nng-messages=\"vm.basicForm.dueDate.$error\"><div ng-message=\"required\" translate=\"EXCHANGERATE.RATEDUEDATE_IS_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\">Date is too early!</div></div></md-input-container>\n<md-input-container flex><label translate=\"EXCHANGERATE.SOURCECURRENCY\">Currency</label><md-select \nng-model=\"secondCtrl.model.sourceCurrency.id\" name=\"sourcecurrency\" required><md-option ng-value=\"sourceCurrency.id\" \nng-repeat=\"sourceCurrency in  vm.sourcecurrencies\" value=\"{{sourceCurrency.code}}\">\n{{sourceCurrency.description}} ({{sourceCurrency.symbol}})</md-option></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"secondCtrl.basicForm.currency.$error\"><div ng-message=\"required\" translate=\"BUDGET.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container><md-input-container flex><label \ntranslate=\"EXCHANGERATE.TARGETCURRENCY\">Currency</label><md-select ng-model=\"secondCtrl.model.targetCurrency.id\" \nname=\"targetCurrency\" required><md-option ng-value=\"targetCurrency.id\" \nng-repeat=\"targetCurrency in vm.targetCurrencies\" value=\"{{targetCurrency.code}}\">\n{{targetCurrency.description}} ({{targetCurrency.symbol}})</md-option></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"secondCtrl.basicForm.currency.$error\"><div ng-message=\"required\" translate=\"BUDGET.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container><md-input-container><label class=\"title\" \ntranslate=\"EXCHANGERATE.RATE \">amount</label><input type=\"number\" name=\"amount\" style=\"text-align: right\" \nng-model=\"secondCtrl.model.exchangeRate\" min=\"0.01\" required><div \nng-messages=\"secondCtrl.basicForm.exchangeRate.$error\" role=\"alert\"><div ng-message=\"required\"><div \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT_IS_REQUIRED\">This date is required!</div></div></div>\n</md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"save\" ng-disabled=\"secondCtrl.basicForm.$invalid\" \ntranslate=\"EXCHANGERATE.SAVE\" translate-attr-aria-label=\"EXCHANGERATE.SAVE\" aria-label=\"save\" \nng-click=\"secondCtrl.saveModel()\"></md-button></div></form></div><div \nclass=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"70\"><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><div id=\"masterGridOptions2\" ag-grid=\"secondCtrl.gridOptions\" class=\"ag-fresh\" expand-grid \nmin=\"260\" other=\"-10\"></div></div></div>");
$templateCache.put("app/main/apps/company/company-exchangeRate/by-company/by-company.html","<div class=\"form-wrapper md-whiteframe-1dp\" flex=\"30\"><form name=\"vm.basicForm\" class=\"md-inline-form\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"EXCHANGERATE.RATESTARTDATE\">Enter date\n</label><md-datepicker type=\"date\" flex=\"100\" flex-gt-xs=\"50\" ng-model=\"vm.exchangeRate.rateStartDate\" \nname=\"startDate\" md-placeholder=\"dd-MM-yyyy\" ng-disabled=\"vm.exchangeRate.id\"></md-datepicker><div \nng-messages=\"vm.basicForm.startDate.$error\"><div ng-message=\"required\" \ntranslate=\"EXCHANGERATE.RATESTARTDATE_IS_REQUIRED\">This date is required!</div><div ng-message=\"mindate\">\nDate is too early!</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"EXCHANGERATE.RATEDUEDATE\">Enter date</label><md-datepicker type=\"date\" flex=\"100\" \nflex-gt-xs=\"50\" ng-model=\"vm.exchangeRate.rateDueDate\" name=\"dueDate\" md-placeholder=\"dd-MM-yyyy\" \nmd-min-date=\"vm.exchangeRate.rateStartDate\" ng-disabled=\"vm.exchangeRate.id\"></md-datepicker><div \nng-messages=\"vm.basicForm.dueDate.$error\"><div ng-message=\"required\" translate=\"EXCHANGERATE.RATEDUEDATE_IS_REQUIRED\">\nThis date is required!</div><div ng-message=\"mindate\">Date is too early!</div></div></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label translate=\"EXCHANGERATE.SOURCECURRENCY\">Currency\n</label><md-select ng-model=\"vm.exchangeRate.sourceCurrency.id\" name=\"sourcecurrency\" required><md-option \nng-value=\"{{sourceCurrency.id}}\" ng-repeat=\"sourceCurrency in  vm.sourcecurrencies\" value=\"{{sourceCurrency.code}}\">\n{{sourceCurrency.description}} ({{sourceCurrency.symbol}})</md-option></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"vm.basicForm.currency.$error\"><div ng-message=\"required\" translate=\"BUDGET.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container><md-input-container flex><label \ntranslate=\"EXCHANGERATE.TARGETCURRENCY\">Currency</label><md-select ng-model=\"vm.exchangeRate.targetCurrency.id\" \nname=\"targetCurrency\" required><md-option ng-value=\"{{targetCurrency.id}}\" \nng-repeat=\"targetCurrency in vm.targetCurrencies\" value=\"{{targetCurrency.code}}\">\n{{targetCurrency.description}} ({{targetCurrency.symbol}})</md-option></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"vm.basicForm.currency.$error\"><div ng-message=\"required\" translate=\"BUDGET.ERROR.FIELD_REQUIRED\">\nThis date is required!</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container><label class=\"title\" translate=\"EXCHANGERATE.RATE \">amount</label><input type=\"number\" \nname=\"amount\" style=\"text-align: right\" ng-model=\"vm.exchangeRate.rate\" min=\"0.01\" required><div \nng-messages=\"vm.basicForm.rate.$error\" role=\"alert\"><div ng-message=\"required\"><div \ntranslate=\"EXPENSE_SETTLEMENTS.PETTY_CASH.AMOUNT_IS_REQUIRED\">This date is required!</div></div></div>\n</md-input-container></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-click=\"vm.allExchangeRate()\"><label class=\"title\" translate=\"EXCHANGERATE.CONSULT\">Consultar</label></md-button>\n<md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"save\" ng-disabled=\"vm.basicForm.$invalid\" \ntranslate=\"EXCHANGERATE.SAVE\" translate-attr-aria-label=\"EXCHANGERATE.SAVE\" aria-label=\"save\" \nng-click=\"vm.saveModel()\"></md-button></form></div><div class=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" \nflex=\"70\"><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"260\" other=\"-10\"></div></div></div>");
$templateCache.put("app/main/apps/company/company-fiscalPeriods/fiscalPeriod/fiscalPeriod.html","<md-dialog class=\"compose-dialog\" aria-label=\"Crear-Editar\" ng-style=\"vm.autoResizeDialog()\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.fiscalPeriod.id ? \'general.edit\' : \'general.add\'| translate}} {{\'company_fiscal_period.fiscal_period\'| translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\" style=\"z-index: 2; height: 5px; position: fixed; top: 50px\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><form name=\"vm.fiscalPeriodForm\" id=\"fiscalPeriodForm\" \nng-submit=\"vm.save()\"><div layout=\"row\"><md-input-container flex><label>\n{{\'company_fiscal_period.start_date\'| translate}}</label><md-datepicker type=\"date\" \nng-model=\"vm.fiscalPeriod.startDate\" name=\"startDate\" md-open-on-focus md-placeholder=\"dd-MM-yyyy\" required>\n</md-datepicker><div ng-messages=\"vm.fiscalPeriodForm.startDate.$error\"><div ng-message=\"valid\" \ntranslate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\"><span>\n{{\'company_fiscal_period.start_date\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div \nng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>{{\'company_fiscal_period.final_date\'| translate}}</label><md-datepicker \ntype=\"date\" ng-model=\"vm.fiscalPeriod.finalDate\" name=\"finalDate\" md-open-on-focus \nmd-min-date=\"vm.fiscalPeriod.startDate\" md-placeholder=\"dd-MM-yyyy\" required \nng-change=\"vm.changeFinalDate(vm.fiscalPeriod.finalDate)\"></md-datepicker><div \nng-messages=\"vm.fiscalPeriodForm.finalDate.$error\"><div ng-message=\"valid\" translate=\"error.invalid_date\">\nThe entered value is not a date!</div><div ng-message=\"required\"><span>\n{{\'company_fiscal_period.end_date\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div \nng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>{{\'company_fiscal_period.extended_date\'| translate}}</label><md-datepicker\n type=\"date\" ng-model=\"vm.fiscalPeriod.extendedDate\" name=\"extendedDate\" md-open-on-focus md-min-date=\"vm.minDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.fiscalPeriodForm.extendedDate.$error\"><div \nng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\">\n<span>{{\'company_fiscal_period.extended_date\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div \nng-message=\"vm.fiscalPeriod.extendedDate\" translate=\"error.invalid_date\">Date is too early!</div></div>\n</md-input-container></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"start end\">\n<md-button ng-disabled=\"vm.isShowProgressLinear\" ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button>\n<md-button ng-disabled=\"vm.isShowProgressLinear\" type=\"submit\" form=\"fiscalPeriodForm\">{{\'general.save\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/company-fiscalPeriods/fiscalPeriod-list/fiscalPeriod-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'menu.fiscalPeriod\'| translate}} ({{vm.pagination.totalElements}})</span></div></div><div layout=\"row\"><div \nflex=\"100\"><md-card><div id=\"fiscalPeriodsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/company/company-warehouses/warehouse-list/warehouse-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'menu.warehouses\'| translate}} ({{vm.pagination.totalElements}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'company_warehouse.search\'| translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\"><md-button \nng-click=\"vm.search()\">{{\'general.search\'| translate}}</md-button></div></div></div><div layout=\"row\"><div flex=\"100\">\n<md-card><div id=\"warehousesGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/company/company-warehouses/warehouse/warehouse.html","<md-dialog class=\"compose-dialog\" aria-label=\"Crear-Editar\" style=\"width: 30%; height: 60%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.warehouse.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<form name=\"vm.warehouseForm\" id=\"warehouseForm\" ng-submit=\"vm.save()\"><div layout=\"row\"><md-input-container \nflex=\"100\"><label>{{\'company_warehouse.code\'| translate}}</label><input type=\"text\" ng-model=\"vm.warehouse.whsCode\" \nname=\"code\" required><div ng-messages=\"vm.warehouseForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_warehouse.code\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'company_warehouse.name\'| translate}}</label><input \ntype=\"text\" ng-model=\"vm.warehouse.whsName\" name=\"name\" required><div ng-messages=\"vm.warehouseForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_warehouse.name\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"company_warehouse.establishment\">Establishment\n</label><md-select ng-model=\"vm.warehouse.companyEstablishment.id\" name=\"establishment\" \nmd-on-close=\"vm.clearSearchEstablishment()\"><md-select-header><input id=\"searchEstablishment\" \nng-model=\"vm.searchEstablishment\" type=\"search\" placeholder=\"Buscar sucursal\" clear-icon></md-select-header>\n<md-optgroup label=\"Departamentos\"><md-option value=\"{{row.id}}\" \nng-repeat=\"row in vm.establishments| filter:vm.searchEstablishment | orderBy: \'internalCode\'\">\n{{row.internalCode + \' - \' + row.establishmentName}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingEstablishments\"></md-progress-linear></md-input-container><md-input-container \nflex=\"10\" ng-if=\"vm.warehouse.companyEstablishment && vm.warehouse.companyEstablishment.id\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.warehouse.companyEstablishment = null\"><md-icon md-font-icon=\"icon-broom\">\n</md-icon><md-tooltip md-direction=\"top\">{{\"general.delete\"| translate}}</md-tooltip></md-button></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'company_warehouse.companyWarehouseType\'| translate}}\n</label><md-select ng-model=\"vm.warehouse.companyWarehouseType\" name=\"companyWarehouseType\"><md-option value=\"STORE\">\nBodega de Tienda</md-option><md-option value=\"SALE\">Bodega de Venta</md-option><md-option value=\"PRODUCT\">\nBodega de Producto</md-option><md-option value=\"CENTRAL\">Bodega Central</md-option><md-option value=\"POUND\">\nBodega de Libras</md-option></md-select></md-input-container></div><div layout=\"column\" class=\"pt-20\"><div \nlayout=\"row\"><md-checkbox ng-if=\"vm.warehouse.id\" ng-model=\"vm.warehouse.active\">{{\'general.active\'| translate}}\n</md-checkbox></div><div layout=\"row\"><md-checkbox ng-model=\"vm.warehouse.default\">{{\'general.default\'| translate}}\n</md-checkbox></div><div layout=\"row\"><md-checkbox ng-model=\"vm.warehouse.useInTms\">{{\'general.useInTms\' | translate}}\n</md-checkbox></div></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"start end\">\n<md-button ng-disabled=\"vm.isShowProgressLinear\" ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button>\n<md-button ng-disabled=\"vm.isShowProgressLinear\" type=\"submit\" form=\"warehouseForm\">{{\'general.save\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/documents/files/files.html","<md-content ng-controller=\"FilesController as fl\" class=\"p-16 mv-16\"><div class=\"md-background-bg md-whiteframe-1dp\">\n<div id=\"attach-uploader\" flow-init=\"fl.ngFlowOptions\" flow-name=\"fl.ngFlow.flow\" flow-files-submitted=\"fl.upload()\" \nflow-file-added=\"fl.fileAdded($file)\" flow-file-success=\"fl.fileSuccess($file, $message)\" \nflow-complete=\"fl.uploadComplete()\" flow-drop flow-drag-enter=\"fl.dropping=true\" flow-drag-leave=\"fl.dropping=false\" \nng-class=\"{\'dropping\':fl.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"files.DROP\">Drop to upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\" ng-show=\"!fl.loadingFiles\"><md-button class=\"md-accent md-raised\" flow-btn \naria-label=\"upload\" id=\"btnUpload\">{{\'files.UPLOAD\'| translate}}</md-button><span class=\"secondary-text mt-8\" \ntranslate=\"files.DROP\"></span></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"file in vm.filesToUpload\" ng-switch=\"file.type\"><md-content><div class=\"product-image\" \nng-class=\"fl.loadingFiles ? \'uploading\' : \'\'\" ng-switch-when=\"image\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"overlay\" layout=\"column\" layout-align=\"center center\"><md-progress-linear md-mode=\"indeterminate\">\n</md-progress-linear></div><div layout=\"column\"><img class=\"media\" ng-src=\"{{file.image ? file.image : file.url}}\" \nng-click=\"fl.updateZoomOptions(file.url)\" alt=\"image\"><p>{{file.file.name}}</p></div><md-button \nclass=\"md-fab-bottom-right md-fab md-mini\" ng-click=\"fl.fileRemove(file);\" ng-show=\"!fl.loadingFiles\" \naria-label=\"remove\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-content></div></div></div>\n</div></md-content>");
$templateCache.put("app/main/apps/company/tabs/bank-account/bank-account-list.html","<md-progress-linear md-mode=\"query\" class=\"md-accent progress-style\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear><div layout=\"row\"><div flex=\"100\"><md-card><div id=\"bankAccountGrid\" ag-grid=\"vm.bankAccountGrid\" \nclass=\"ag-fresh\" expand-grid min=\"100\" other=\"0\"></div></md-card></div></div><md-button ng-disabled=\"vm.readonly\" \naria-label=\"add\" class=\"md-fab md-fab-bottom-right button-position\" ng-click=\"vm.addBankAccount()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/company/tabs/company-contact/contact-list.html","<md-progress-linear md-mode=\"query\" class=\"md-accent progress-style-contact\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear><div layout=\"row\"><div flex=\"100\"><md-card><div id=\"contactsGrid\" ag-grid=\"vm.contactsGrid\" \nclass=\"ag-fresh\" expand-grid min=\"100\" other=\"0\"></div></md-card></div></div><md-button ng-disabled=\"vm.readonly\" \nclass=\"md-fab md-fab-bottom-right button-position-contact\" aria-label=\"add\" ng-click=\"vm.addContact()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/company/tabs/invite/invite.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"invite\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\" ng-if=\"!vm.readonly\"><div>\n<h2>{{\'guest.ENTER_EMAIL_INVITE_USERS\'| translate}} {{\'guest.PRESS_ENTER_TO_VARIOUS_EMAILS\'| translate}}:</h2><div \nlayout=\"row\"><md-input-container flex=\"50\"><label translate=\"guest.application\">Application</label><md-select \nng-model=\"vm.appId\" name=\"app\" ng-disabled=\"true\"><md-option ng-repeat=\"app in vm.applications\" \nvalue=\"{{app.application.id}}\">{{app.application.name}}</md-option></md-select></md-input-container><md-input-container\n flex=\"50\"><md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinearRoles\"></md-progress-linear><label translate=\"guest.role\">Role</label><md-select \nng-model=\"vm.rolId\" name=\"rol\" required ng-disabled=\"true\"><md-option ng-repeat=\"role in vm.roles\" value=\"{{role.id}}\">\n{{role.description}} ({{role.name}})</md-option></md-select></md-input-container></div><div layout=\"row\"><md-chips \nflex=\"100\" md-add-on-blur=\"true\" ng-model=\"vm.invitationContacts\" md-separator-keys=\"vm.customKeys\" \nplaceholder=\"{{\'guest.CORREOS\'| translate}}\" md-transform-chip=\"vm.validateEmailChip($chip)\"></md-chips></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warn\" \nng-disabled=\"vm.invitationContacts.length === 0\" ng-click=\"vm.sendInvitation()\">{{\'guest.SEND_INVITATION\'| translate}}\n<md-icon md-svg-icon=\"send\"></md-icon></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/company/tabs/operaciones2-warehouse/operaciones2-warehouse.html","<div id=\"operations2-warehouses\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.operaciones2Warehouses.length === 0\"><h2>\n{{\'OPERACIONES2.WAREHOUSE.NO_WAREHOUSES\'| translate}}</h2></div><div class=\"loading-threads\" layout=\"column\" \nlayout-align=\"center center\" ng-if=\"vm.operaciones2Warehouses.length > 0 && !vm.company.warehouseOperacionesId\"><h2>\n{{\'OPERACIONES2.WAREHOUSE.SELECT_WAREHOUSE\'| translate}}</h2></div><md-list><md-list-item ng-disabled=\"vm.loading\" \nng-class=\"(warehouse.id === vm.company.warehouseOperacionesId) ? \'selected\' : \'\'\" \nng-repeat=\"warehouse in vm.operaciones2Warehouses\" class=\"list-item\" \nng-click=\"vm.selectOperaciones2Warehouse(warehouse.id)\"><p>{{warehouse.name}}</p><md-icon md-font-icon=\"icon-check\" \nng-if=\"warehouse.id === vm.company.warehouseOperacionesId\"></md-icon></md-list-item></md-list></div></div></div>");
$templateCache.put("app/main/apps/company/tabs/warehouses/warehouse-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\"><div flex=\"100\"><md-card><div \nid=\"warehousesGrid\" ag-grid=\"vm.warehousesGrid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"0\"></div></md-card></div>\n</div><md-button ng-disabled=\"vm.readonly\" class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.addWarehouse()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/company/tabs/invoiceSerie/invoiceSerie.html","<div id=\"e-commerce-order\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button class=\"md-icon-button close-thread\" \naria-label=\"Back\" ng-click=\"vm.closeThread()\" translate translate-attr-aria-label=\"COMPANY.BACK\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n<md-icon md-font-icon=\"icon-receipt\"></md-icon><span translate=\"COMPANY.INVOICE_SERIE.INVOICE_SERIE\">Documents</span>\n</div></div></div></div><div class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsInvoiceSerie\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.SERIE\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.INITIAL_NUMBER\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.LAST_NUMBER\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.RESOLUTION\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.DOCUMENT_TYPE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.INVOICE_TYPE\'| translate}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.DUE_DATE\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.VALIDATED\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.ACTIVE\'| translate}}</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">{{\'COMPANY.FILE\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'COMPANY.OPTIONS\'| translate}}</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"invoiceSerie in vm.invoiceSeries\"><td>{{invoiceSerie.serie}}</td><td \nstyle=\"text-align: right\">{{invoiceSerie.initialNumber}}</td><td style=\"text-align: right\">{{invoiceSerie.lastNumber}}\n</td><td>{{invoiceSerie.resolution}}</td><td><span>{{invoiceSerie.invoiceSerieDocumentTypeName}}</span></td><td>\n{{invoiceSerie.invoiceSerieType.invoiceSerieTypeName}}</td><td>\n{{invoiceSerie.authorizationDate| flipdate : \'dd-MM-yyyy\'}}</td><td \nng-if=\"invoiceSerie.electronicInvoice && (!invoiceSerie.invoiceSerieType.endDateByInvoiceElectronic || invoiceSerie.invoiceSerieType.endDateByInvoiceElectronic == null) \">\n</td><td ng-if=\"!invoiceSerie.electronicInvoice || invoiceSerie.invoiceSerieType.endDateByInvoiceElectronic\">\n{{invoiceSerie.dueDate| flipdate : \'dd-MM-yyyy\'}}</td><td><em ng-if=\"invoiceSerie.validated\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></em> <em ng-if=\"!invoiceSerie.validated\" \nclass=\"icon-cancel red-500-fg\"></em></td><td><em ng-if=\"invoiceSerie.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></em> <em ng-if=\"!invoiceSerie.active\" class=\"icon-cancel red-500-fg\">\n</em></td><td><a \nng-href=\"{{vm.baseUrlSharedFiles}}{{invoiceSerie.fileStorage.parentPath}}{{invoiceSerie.fileStorage.name}}{{\'l\'}}{{invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{invoiceSerie.fileStorage.originalName + invoiceSerie.fileStorage.extension}}\" data-gallery target=\"_blank\" \nng-if=\"invoiceSerie.fileStorage.extension === \'.jpg\' || invoiceSerie.fileStorage.extension === \'.png\' || invoiceSerie.fileStorage.extension === \'.JPG\' || invoiceSerie.fileStorage.extension === \'.PNG\' || invoiceSerie.fileStorage.extension === \'.jpeg\' || invoiceSerie.fileStorage.extension === \'.JPEG\'\">\n<img \nng-src=\"{{vm.baseUrlSharedFiles}}{{invoiceSerie.fileStorage.parentPath}}{{invoiceSerie.fileStorage.name}}{{\'i\'}}{{invoiceSerie.fileStorage.extension}}\" \nclass=\"img-rounded border12\" alt=\"photo\" height=\"20\" onerror=\"this.src=\'assets/images/logos/angular.png\'\"> </a><a \nng-href=\"{{vm.baseUrlSharedFiles + invoiceSerie.fileStorage.parentPath + invoiceSerie.fileStorage.name + invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{invoiceSerie.fileStorage.originalName + invoiceSerie.fileStorage.extension}}\" data-gallery target=\"_blank\" \nng-if=\"invoiceSerie.fileStorage.extension !== \'.jpg\' && invoiceSerie.fileStorage.extension !== \'.png\' && invoiceSerie.fileStorage.extension !== \'.JPG\' && invoiceSerie.fileStorage.extension !== \'.PNG\' && invoiceSerie.fileStorage.extension !== \'.jpeg\' && invoiceSerie.fileStorage.extension !== \'.JPEG\'\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon></a></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.editInvoiceSerie(invoiceSerie, $index)\" aria-label=\"Product details\" translate \ntranslate-attr-aria-label=\"COMPANY.EDIT\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon><md-tooltip \nmd-direction=\"bottom\">{{\"general.edit\"| translate}}</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteInvoiceSerie(invoiceSerie, $index)\" ng-if=\"invoiceSerie.active\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANY.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"s16 md-warn\"></md-icon>\n<md-tooltip md-direction=\"bottom\">{{\"general.deactive\"| translate}}</md-tooltip></md-button></td></tr></tbody></table>\n</md-content></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.addInvoiceSerieDialog()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button></div>");
$templateCache.put("app/main/apps/company/tabs/withholdingFileDialog/withholdingFile.html","<md-dialog class=\"compose-dialog\" aria-label=\"Document\" style=\"max-width: 500px; width: 500px\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"COMPANY.UPLOAD\">\nNuevo Documento</label></h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"COMPANY.UPLOAD\"></label><div \nng-include=\"\'app/main/apps/files/files.html\'\"></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"center start\" layout-wrap ng-show=\"vm.companyWithholding.withholdingFile\"><md-content><div \nlayout=\"column\" ng-click=\"vm.viewIMG(vm.file)\" \nng-if=\"vm.file.extension == \'.jpg\' || vm.file.extension == \'.png\' || vm.file.extension == \'.JPG\' || vm.file.extension == \'.PNG\'\">\n<a href=\"\"><img height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.baseUrlFiles + vm.file.parentPath + vm.file.name + vm.file.extension}}\" alt=\"image\"><p>\n{{vm.file.originalName + vm.file.extension}}</p></a></div><div layout=\"column\" \nng-if=\"vm.file.extension != \'.jpg\' && vm.file.extension != \'.png\' && vm.file.extension != \'.JPG\' && vm.file.extension != \'.PNG\'\">\n<a target=\"_blank\" href=\"{{vm.baseUrlFiles + vm.file.parentPath + vm.file.name + vm.file.extension}}\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><p>{{vm.file.originalName + vm.file.extension}}</p></a></div></md-content>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-disabled=\"vm.filesToUpload.length<=0\" ng-click=\"vm.save()\">\n{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/tabs/about/about.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div ng-if=\"vm.isNew\" layout-align=\"center center\"><h1><div layout=\"row\" layout-align=\"center center\">\n{{\'COMPANY.COMPLETE_INFO\'| translate }}!!!</div></h1></div><div ng-if=\"vm.textTipoError\" layout-align=\"center center\">\n<h2><div layout=\"row\" layout-align=\"center center\"><span class=\"label md-orange-800-bg\">\n{{vm.textTipoError| translate }} <span></span></span></div></h2></div><form name=\"vm.wizardStep1\"><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div ng-class=\"vm.editMode ? \'\' : \'info-line\'\">\n<br><md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.NAME\">Full Name</label><input \ntype=\"text\" name=\"name\" ng-disabled=\"!vm.editMode\" ng-model=\"vm.company.name\" required><div \nng-messages=\"vm.wizardStep1.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'COMPANY.NAME\' | translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.BUSINESSNAME\">Business Name</label><input \ntype=\"text\" name=\"bussines\" ng-model=\"vm.company.businessName\" ng-disabled=\"!vm.editMode || vm.asProvider\" required>\n<div ng-messages=\"vm.wizardStep1.bussines.$error\" r role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.BUSINESSNAME\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.RESPRESENTATIVE\">Legal Representative\n</label><input type=\"text\" name=\"representant\" ng-model=\"vm.company.legalRepresentative\" ng-disabled=\"!vm.editMode\" \nrequired><div ng-messages=\"vm.wizardStep1.representant.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.RESPRESENTATIVE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.LINE_OF_BUSINESS\">Line of business</label>\n<input type=\"text\" name=\"description\" ng-model=\"vm.company.description\" ng-disabled=\"!vm.editMode\">\n</md-input-container><md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.COUNTRY\">Country\n</label><md-select ng-model=\"vm.company.country.id\" md-on-close=\"vm.clearSearchCountry()\" name=\"country\" \nng-disabled=\"!vm.editMode || vm.isPrivated\" required ng-change=\"vm.onChangeCountry()\"><md-select-header><input \nid=\"country\" ng-model=\"vm.searchCountry\" type=\"search\" placeholder=\"{{\'COMPANY.SELECT\'| translate}}\">\n</md-select-header><md-optgroup label=\"country\"><md-option ng-value=\"{{country.id}}\" \nng-repeat=\"country in vm.countries| filter:vm.searchCountry | orderBy:\'name\'\">{{country.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCountry\"></md-progress-linear>\n<div ng-messages=\"vm.wizardStep1.country.$error\"><div ng-message=\"required\" translate=\"COMPANY.IS_REQUIRED\">\nThis date is required!</div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"title\" \ntranslate=\"COMPANY.TYPE_TAXPAYER\">Type of Taxpayer</label><md-select ng-model=\"vm.company.companyTypeId\" \nmd-on-close=\"vm.searchCompanyType = \'\'\" name=\"country\" ng-disabled=\"!vm.editMode || vm.asProvider\" required>\n<md-select-header><input id=\"companyType\" ng-model=\"vm.searchCompanyType\" type=\"search\" \nplaceholder=\"{{\'COMPANY.SELECT\'| translate}}\"></md-select-header><md-optgroup label=\"country\"><md-option \nng-value=\"{{row.id}}\" \nng-repeat=\"row in vm.companyTypeList|\n                                           filter:vm.searchCompanyType | orderBy:\'name\'\">\n{{row.code}} - {{row.description}}</md-option></md-optgroup></md-select></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex class=\"md-block\"><label \nclass=\"title\" translate=\"COMPANY.TAXPAYER_CATEGORY\">Taxpayer Category</label><md-select \nng-model=\"vm.company.companyCategoryId\" md-on-close=\"vm.searchCompanyCategory = \'\'\" name=\"taxpayerCategory\" \nng-disabled=\"!vm.editMode || vm.asProvider\" \nng-required=\"!vm.asProvider || (vm.asProvider && vm.company.companyCategoryId)\"><md-select-header><input \nid=\"searchCompanyCategory\" ng-model=\"vm.searchCompanyCategory\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"category\"><md-option \nng-value=\"{{row.id}}\" ng-repeat=\"row in vm.companyCategoryList| filter:vm.searchCompanyCategory\">\n{{row.code}} - {{row.description}}</md-option></md-optgroup></md-select></md-input-container></div><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"COMPANY.CURRENCY\">Currency</label><md-select \nng-model=\"vm.company.currency.id\" md-on-close=\"vm.clearSearchCurrency()\" name=\"currency\" ng-disabled=\"!vm.editMode\" \nrequired><md-select-header><input id=\"currency\" ng-model=\"vm.searchCurrency\" type=\"search\" \nplaceholder=\"{{\'COMPANY.SELECT_CURRENCY\'| translate}}\"></md-select-header><md-optgroup label=\"currency\"><md-option \nng-value=\"{{currency.id}}\" ng-repeat=\"currency in vm.currencies| filter:vm.searchCurrency\">\n{{currency.description}} ({{currency.code}})</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"vm.wizardStep1.currency.$error\"><div ng-message=\"required\" translate=\"COMPANY.IS_REQUIRED\">\nThis date is required!</div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"title\" \ntranslate=\"COMPANY.FOREIGN_CURRENCY\">Currency</label><md-select ng-model=\"vm.company.foreignCurrency.id\" \nmd-on-close=\"vm.clearSearchForeignCurrency()\" name=\"foreignCurrency\" ng-disabled=\"!vm.editMode\" required>\n<md-select-header><input id=\"foreignCurrency\" ng-model=\"vm.searchForeignCurrency\" type=\"search\" \nplaceholder=\"{{\'COMPANY.SELECT_FOREIGN_CURRENCY\'| translate}}\"></md-select-header><md-optgroup label=\"foreignCurrency\">\n<md-option ng-value=\"{{currency.id}}\" ng-repeat=\"currency in vm.currencies| filter:vm.searchForeignCurrency\">\n{{currency.description}} ({{currency.code}})</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingCurrency\"></md-progress-linear><div \nng-messages=\"vm.wizardStep1.foreignCurrency.$error\"><div ng-message=\"required\" translate=\"COMPANY.IS_REQUIRED\">\nThis date is required!</div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex \nclass=\"layout-gt-xs-row layout-column flex\" ng-if=\"!vm.isMyCompany\"><md-input-container flex class=\"md-block\">\n<md-checkbox ng-disabled=\"!vm.editMode\" ng-model=\"vm.haveCredit\" aria-label=\"chk\">{{\"COMPANY.HAVECREDIT\"| translate}}\n</md-checkbox></md-input-container><md-input-container flex class=\"md-block\" ng-if=\"vm.haveCredit && !vm.isMyCompany\">\n<label class=\"title\" translate=\"COMPANY.DAYSCREDIT\">Days Credit</label><input type=\"number\" name=\"daysCredit\" \nng-model=\"vm.daysCredit\" ng-disabled=\"!vm.editMode\" ng-required=\"vm.haveCredit && !vm.isMyCompany\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex class=\"layout-gt-xs-row layout-column flex\">\n<md-input-container flex class=\"md-block\" ng-if=\"!vm.isMyCompany\"><label class=\"title\" \ntranslate=\"COMPANY.CODE_PROVIDER\">codeProvider</label><input type=\"text\" name=\"companyProviderCode\" \nng-model=\"vm.companyProviderCode\" ng-disabled=\"!vm.editMode\"></md-input-container></div></div></div><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div ng-class=\"vm.editMode ? \'\' : \'info-line\'\">\n<header class=\"md-accent-bg\"><div class=\"title\" translate=\"COMPANY.CONTACT\">Contact</div></header><br>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.ADDRESS\">Address</label><input \ntype=\"text\" name=\"address\" maxlength=\"200\" ng-model=\"vm.company.address\" ng-disabled=\"!vm.editMode\">\n</md-input-container><md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.TEL\">Phone</label>\n<input type=\"text\" name=\"phone\" ng-model=\"vm.company.phone\" required ng-disabled=\"!vm.editMode\"><div \nng-messages=\"vm.wizardStep1.phone.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{ \'COMPANY.TEL\' | translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.TEL2\">Phone</label><input type=\"text\" \nname=\"phone\" ng-model=\"vm.company.phone2\" ng-disabled=\"!vm.editMode\"></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"COMPANY.PHONE_MOBILE\">Phone</label><input type=\"text\" name=\"phone\" \nng-model=\"vm.company.phoneMobile\" ng-disabled=\"!vm.editMode\"></md-input-container><md-input-container class=\"md-block\">\n<label class=\"title\" translate=\"COMPANY.WEBPAGE\">Web Page</label><input type=\"text\" name=\"web\" \nng-model=\"vm.company.webPage\" ng-disabled=\"!vm.editMode\"></md-input-container><md-input-container class=\"md-block\">\n<label class=\"title\" translate=\"COMPANY.EMAILS\">Emails</label><input type=\"email\" name=\"email\" \nng-model=\"vm.company.email\" ng-pattern=\"/^[a-zA-Z0-9._-]+@+[a-zA-Z0-9]+(?:\\.[a-zA-Z0-9-]+)*$/\" required \nng-disabled=\"!vm.editMode\"><div ng-messages=\"vm.wizardStep1.email.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\'COMPANY.EMAILS\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div><div ng-message=\"pattern\"><span\n translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container></div></div><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div ng-class=\"vm.editMode ? \'\' : \'info-line\'\">\n<header class=\"md-accent-bg\"><div class=\"title\" translate=\"CONTACTS.CONTACT_PERSON\">Contact</div></header><br>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"CONTACTS.NAME\">Name</label><input type=\"text\" \nname=\"name\" ng-model=\"vm.companyContact.name\" ng-disabled=\"!vm.editMode\" required></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"CONTACTS.PHONE\">Phone</label><input type=\"text\" \nname=\"phone\" ng-model=\"vm.companyContact.phone\" ng-disabled=\"!vm.editMode\" required></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"CONTACTS.PHONE2\">Phone2</label><input type=\"text\" \nname=\"phone2\" ng-model=\"vm.companyContact.phone2\" ng-disabled=\"!vm.editMode\"></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"CONTACTS.PHONEMOBILE\">PhoneMobile</label><input type=\"text\" \nname=\"phoneMobile\" ng-model=\"vm.companyContact.phoneMobile\" ng-disabled=\"!vm.editMode\"></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"CONTACTS.EMAIL\">Email</label><input type=\"email\" \nname=\"email\" ng-model=\"vm.companyContact.email\" ng-disabled=\"!vm.editMode\" \nng-pattern=\"/^[a-zA-Z0-9._-]+@+[a-zA-Z0-9]+(?:\\.[a-zA-Z0-9-]+)*$/\"></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"CONTACTS.ADDRESS\">Address</label><input type=\"text\" name=\"address\" \nmaxlength=\"100\" ng-model=\"vm.companyContact.address\" ng-disabled=\"!vm.editMode\" required></md-input-container></div>\n</div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div \nng-class=\"vm.editMode ? \'\' : \'info-line\'\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"BANKACCOUNT.BANK_ACCOUNT\">Bank Account</div></header><br><md-input-container class=\"md-block\"><label \nclass=\"title\" translate=\"BANKACCOUNT.BANK\">Bank</label><md-select ng-model=\"vm.bankAccount.bank.id\" \nmd-on-close=\"vm.clearSearchBank()\" name=\"bank\" ng-disabled=\"!vm.editMode\" required><md-select-header><input id=\"bank\" \nng-model=\"vm.searchBank\" type=\"search\" placeholder=\"{{\'COMPANY.SELECT_BANK\'| translate}}\"></md-select-header>\n<md-optgroup label=\"bank\"><md-option ng-value=\"{{bank.id}}\" ng-repeat=\"bank in vm.banks| filter:vm.searchBank\">\n{{bank.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingBank\">\n</md-progress-linear><div ng-messages=\"vm.wizardStep1.bank.$error\"><div ng-message=\"required\" \ntranslate=\"COMPANY.IS_REQUIRED\">This date is required!</div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"BANKACCOUNT.ACCOUNTTYPE\"></label><md-select \nng-model=\"vm.bankAccount.bankAccountType.id\" name=\"bankAccountType\" required \nmd-on-close=\"vm.clearSearchBankAccountType()\" ng-disabled=\"!vm.editMode\"><md-select-header><input \nid=\"searchBankAccountType\" ng-model=\"vm.searchBankAccountType\" type=\"search\" translate \ntranslate-attr-placeholder=\"BANK.BANK_ACCOUNT_TYPE\"></md-select-header><md-optgroup label=\"bankAccountTypes\"><md-option\n ng-value=\"{{data.id}}\" ng-repeat=\"data in vm.bankAccountTypes| filter:vm.searchBankAccountType\">\n{{data.bankAccountTypeDescription}}</md-option></md-optgroup></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"BANKACCOUNT.ACCOUNTNUMBER\">AccountNumber</label><input type=\"text\" \nname=\"accountNumber\" ng-model=\"vm.bankAccount.accountNumber\" ng-disabled=\"!vm.editMode\" required></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"BANKACCOUNT.NAME\">AccountName</label><input \ntype=\"text\" name=\"accountName\" ng-model=\"vm.bankAccount.accountName\" ng-disabled=\"!vm.editMode\" required>\n</md-input-container></div></div></form></div></div></div>");
$templateCache.put("app/main/apps/company/tabs/about/documents.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"navigation\" flex layout=\"row\" layout-align=\"end center\" ng-if=\"vm.company.id\"><span \nng-if=\"vm.msgRequired\" class=\"h5\">{{vm.msgRequired}} {{\'COMPANY.REQUIRED_DOCUMENTS\'| translate}}</span><md-button \nng-if=\"!vm.readonly\" class=\"md-raised md-warn\" ng-click=\"vm.goDocuments()\" ng-disabled=\"!vm.authorizedToEdit\" \naria-label=\"Save Change\">{{\'COMPANY.EDIT\'| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon></md-button></div>\n<div class=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" \nng-if=\"vm.company.documents.length > 0\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'COMPANY.DOCUMENT_TYPE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.DOCUMENT\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'COMPANY.DATE_OF_ISSUE\'| translate}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.DUE_DATE\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'COMPANY.FILE\'| translate}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"doc in vm.company.documents| filter: {active: \'true\'}\"><td>{{doc.document.documentType.name}}</td><td>\n{{doc.document.number}}</td><td>{{!doc.document.dateOfIssue ? \'\' :(doc.document.dateOfIssue| flipdate : \'dd-MM-yyyy\')}}\n</td><td>{{!doc.document.dueDate ? \'\' : (doc.document.dueDate| flipdate : \'dd-MM-yyyy\')}}</td><td><div \nng-if=\"doc.document.files.length > 0\"><spam ng-repeat=\"files in doc.document.files\"><a \nng-if=\"files.extension === \'.jpg\' || files.extension === \'.png\' || files.extension === \'.JPG\' || files.extension === \'.PNG\' || files.extension === \'.jpeg\' || files.extension === \'.JPEG\'\" \nng-href=\"{{vm.baseUrlSharedFiles}}{{files.parentPath}}{{files.name}}l{{files.extension}}\" \ntitle=\"{{doc.document.documentType.name}} - {{$index + 1}}\" data-gallery target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon></a><a \nng-if=\"files.extension !== \'.jpg\' && files.extension !== \'.png\' && files.extension !== \'.JPG\' && files.extension !== \'.PNG\' && files.extension !== \'.jpeg\' && files.extension !== \'.JPEG\'\" \nng-href=\"{{vm.baseUrlSharedFiles}}{{files.parentPath}}{{files.name}}{{files.extension}}\" \ntitle=\"{{doc.document.documentType.name}} - {{$index + 1}}\" data-gallery target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon></a></spam></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/company/tabs/about/invoiceSerie.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"navigation\" flex layout=\"row\" layout-align=\"end center\" ng-if=\"vm.company.id\"><md-button \nng-if=\"!vm.readonly\" class=\"md-raised md-warn\" ng-click=\"vm.goInvoiceSeries()\" ng-disabled=\"!vm.authorizedToEdit\" \naria-label=\"Save Change\">{{\'COMPANY.EDIT\'| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon></md-button></div>\n<div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.company.invoiceSeries.length === 0\"><h2>{{\'COMPANY.INVOICE_SERIE.NO_SERIES\'| translate}}</h2></div><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" \nng-if=\"vm.company.invoiceSeries.length > 0\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsInvoice\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'COMPANY.INVOICE_SERIE.SERIE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.INITIAL_NUMBER\'| translate}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.LAST_NUMBER\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.RESOLUTION\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.DOCUMENT_TYPE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.INVOICE_TYPE\'| translate}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.DUE_DATE\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.VALIDATED\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'COMPANY.FILE\'| translate}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"invoiceSerie in vm.company.invoiceSeries\"><td>{{invoiceSerie.serie}}</td><td>{{invoiceSerie.initialNumber}}\n</td><td>{{invoiceSerie.lastNumber}}</td><td>{{invoiceSerie.resolution}}</td><td><span>\n{{invoiceSerie.invoiceSerieDocumentTypeName}}</span></td><td>{{invoiceSerie.invoiceSerieType.invoiceSerieTypeName}}\n</td><td>{{invoiceSerie.authorizationDate| flipdate : \'dd-MM-yyyy\'}}</td><td>\n{{invoiceSerie.dueDate| flipdate : \'dd-MM-yyyy\'}}</td><td>{{invoiceSerie.validated}}</td><td><a \nng-href=\"{{vm.baseUrlSharedFiles}}{{invoiceSerie.fileStorage.parentPath}}{{invoiceSerie.fileStorage.name}}{{\'l\'}}{{invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{invoiceSerie.fileStorage.originalName + invoiceSerie.fileStorage.extension}}\" data-gallery target=\"_blank\" \nng-if=\"invoiceSerie.fileStorage.extension === \'.jpg\' || invoiceSerie.fileStorage.extension === \'.png\' || invoiceSerie.fileStorage.extension === \'.JPG\' || invoiceSerie.fileStorage.extension === \'.PNG\' || invoiceSerie.fileStorage.extension === \'.jpeg\' || invoiceSerie.fileStorage.extension === \'.JPEG\'\">\n<img \nng-src=\"{{vm.baseUrlSharedFiles}}{{invoiceSerie.fileStorage.parentPath}}{{invoiceSerie.fileStorage.name}}{{\'i\'}}{{invoiceSerie.fileStorage.extension}}\" \nclass=\"img-rounded border12\" alt=\"photo\" height=\"20\" onerror=\"this.src=\'assets/images/logos/angular.png\'\"> </a><a \nng-href=\"{{vm.baseUrlSharedFiles + invoiceSerie.fileStorage.parentPath + invoiceSerie.fileStorage.name + invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{invoiceSerie.fileStorage.originalName + invoiceSerie.fileStorage.extension}}\" data-gallery target=\"_blank\" \nng-if=\"invoiceSerie.fileStorage.extension !== \'.jpg\' && invoiceSerie.fileStorage.extension !== \'.png\' && invoiceSerie.fileStorage.extension !== \'.JPG\' && invoiceSerie.fileStorage.extension !== \'.PNG\' && invoiceSerie.fileStorage.extension !== \'.jpeg\' && invoiceSerie.fileStorage.extension !== \'.JPEG\'\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon></a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/company/tabs/about/logo.html","<div class=\"md-inline-form\" ng-if=\"vm.setLogo == true\"><md-content><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div id=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\n                             \'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" \nlayout-align=\"center center\"><span translate=\"files.DROP\">Drop to upload</span></div><div ngi class=\"upload-button\" \nlayout=\"column\" layout-align=\"center center\" ng-show=\"!vm.loading\"><div layout=\"row\"><md-button \nclass=\"md-accent md-raised\" flow-btn>{{\'files.UPLOADIMG\'| translate}}</md-button></div><span \nclass=\"secondary-text mt-8\">{{\'COMPANY.MSG.ADD_LOGO\'| translate}} {{\'COMPANY.MSG.ONLY_FORMAT\'| translate}}</span></div>\n<div layout=\"row\" layout-align=\"center center\" layout-wrap><div ng-repeat=\"image in vm.images\" ng-switch=\"image.type\">\n<md-content><div class=\"product-image\" ng-class=\"vm.loading ? \'uploading\' : \'\'\" ng-switch-when=\"image\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"overlay\" layout=\"column\" layout-align=\"center center\"><md-progress-linear \nmd-mode=\"indeterminate\"></md-progress-linear></div><img class=\"media\" ng-src=\"{{image.url}}\" \nng-click=\"vm.updateImageZoomOptions(image.url)\" alt=\"image\"><md-button class=\"md-fab-bottom-right md-fab md-mini\" \nng-click=\"vm.fileRemove(image);\" ng-show=\"!vm.loading\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-content></div></div></div></div><md-button class=\"md-fab md-fab-bottom-right\" ng-click=\"vm.uploadFiles();\" \nng-if=\"!vm.loading && vm.images.length > 0\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>\n{{\'general.save\'| translate}}</md-tooltip></md-button></md-content><center><md-button class=\"md-primary md-raised\" \nng-if=\"vm.company.logo\" ng-click=\"vm.setLogo = false; vm.images = [];\">{{\'general.cancel\'| translate}}</md-button>\n</center></div><div id=\"product-image\" ng-if=\"vm.setLogo !== true\"><div layout=\"row\" layout-align=\"center center\"><div \nclass=\"image-zoom-area\"><img wip-image-zoom=\"vm.imageZoomOptions\" ng-fallback=\"assets/images/etc/thumbPhoto.jpg\" \nalt=\"image\"></div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap flex=\"100\"><div \nclass=\"product-image\" layout-align=\"center center\"><img class=\"media\" \nng-src=\"{{vm.logo.url + \'s\' + vm.logo.extension}}\" ng-fallback=\"assets/images/etc/thumbPhoto.jpg\" \nng-click=\"vm.updateImageZoomOptions(vm.logo)\" alt=\"image\"><div><md-button \nclass=\"md-fab-bottom-left left-align md-fab md-mini\" ng-click=\"vm.setLogo = true;\" ng-show=\"!vm.loading\"><md-icon \nmd-font-icon=\"icon-image-area\"></md-icon><md-tooltip>{{\'COMPANY.CHANGE\'| translate}}</md-tooltip></md-button><md-button\n class=\"md-fab-bottom-right right-align md-warn md-fab md-mini\" ng-click=\"vm.deleteLogo();\" ng-show=\"!vm.loading\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>{{\'COMPANY.DELETE\'| translate}}</md-tooltip></md-button></div>\n</div></div></div>");
$templateCache.put("app/main/apps/company/tabs/about/regime.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.company.regimes.length === 0\"><h2>{{\'COMPANY.NO_REGIMES\'| translate}}</h2></div><md-list><md-list-item \nng-class=\"(account === vm.account) ? \'selected\' : \'\'\" ng-repeat=\"account in vm.regimes\" \nstyle=\"border-bottom: 1px solid #D8D8D8\"><p>{{account.name}}</p><div ng-show=\"account.enabled\" \nclass=\"label md-orange-800-bg\">Habilitado</div><md-button ng-if=\"!vm.readonly\" class=\"md-icon-button\" \nng-show=\"account.enabled\" ng-click=\"vm.deleteRegime(account)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANY.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"md-warn\"></md-icon></md-button>\n<md-button ng-if=\"!vm.readonly\" class=\"md-icon-button\" ng-disabled=\"vm.loading\" ng-show=\"!account.enabled\" \nng-click=\"vm.addRegime(account)\" aria-label=\"Add\" translate translate-attr-aria-label=\"COMPANY.ADD\"><md-icon \nmd-font-icon=\"icon-check\"><md-tooltip md-direction=\"left\">Seleccionar</md-tooltip></md-icon></md-button></md-list-item>\n</md-list></div></div></div><div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div \nclass=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><md-list><md-list-item \nng-class=\"(row === vm.withholding) ? \'selected\' : \'\'\" ng-repeat=\"row in vm.withholdings\" \nstyle=\"border-bottom: 1px solid #D8D8D8\"><p>{{row.withholding.withholdingDescription}}</p><div \nng-if=\"row.withholdingFile\"><div layout=\"column\" ng-click=\"vm.viewIMG(row.withholdingFile)\" \nng-if=\"row.withholdingFile.extension === \'.jpg\' || row.withholdingFile.extension === \'.png\' || row.withholdingFile.extension === \'.JPG\' || row.withholdingFile.extension === \'.PNG\'\">\n<a href=\"\"><img height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.baseUrlFiles + row.withholdingFile.parentPath + row.withholdingFile.name + row.withholdingFile.extension}}\" \nalt=\"image\"><p>{{row.withholdingFile.originalName + row.withholdingFile.extension}}</p></a></div><div layout=\"column\" \nng-if=\"row.withholdingFile.extension !== \'.jpg\' && row.withholdingFile.extension !== \'.png\' && row.withholdingFile.extension !== \'.JPG\' && row.withholdingFile.extension !== \'.PNG\'\">\n<a target=\"_blank\" \nhref=\"{{vm.baseUrlFiles + row.withholdingFile.parentPath + row.withholdingFile.name + row.withholdingFile.extension}}\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon><p>\n{{row.withholdingFile.originalName + row.withholdingFile.extension}}</p></a></div></div><div ng-show=\"row.id != 0\" \nclass=\"label md-orange-800-bg\">Habilitado</div><md-button ng-if=\"!vm.readonly\" class=\"md-icon-button\" \nng-show=\"row.id != 0\" ng-click=\"vm.deleteWithholding(row)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANY.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"md-warn\"></md-icon></md-button>\n<md-button ng-if=\"!vm.readonly\" class=\"md-icon-button\" ng-show=\"row.id == 0\" ng-click=\"vm.addWithholding(row)\" \naria-label=\"Add\" translate translate-attr-aria-label=\"COMPANY.ADD\"><md-icon md-font-icon=\"icon-check\"><md-tooltip \nmd-direction=\"left\">Seleccionar</md-tooltip></md-icon></md-button></md-list-item></md-list></div></div></div><style>\n.selected {\n        background-color: lightblue;\n    }</style>");
$templateCache.put("app/main/apps/company-providers/provider-group/provider-group-list/provider-group-list.html","<md-progress-linear md-mode=\"query\" class=\"md-accent progress-style-provider-group\" \nng-show=\"vm.isShowProgressLinearGrid\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span class=\"title-style-provider-group\">\n{{\'providerGroup.providerGroups\'| translate}} ({{vm.providerGroups.length}})</span></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.providerGroups.length > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'providerGroup.searchProviderGroup\' | translate}}\" ng-model=\"vm.inputSearch\"><md-button ng-click=\"\">\n{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div flex=\"100\"><md-card><div \nclass=\"ag-fresh\" id=\"providerGroups\" ag-grid=\"vm.gridProviderGroups\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button aria-label=\"add\" \nclass=\"md-fab md-fab-bottom-right button-style-provider-group\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/company-providers/provider-group/provider-group/provider-group.html","<md-dialog aria-label=\"Crear-Editar\" class=\"dialog-style-provider-group\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.providerGroup.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent progress-bar-style-provider-group\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><div \nclass=\"mat-dialog-without-padding\"><ng-form name=\"vm.providerGroupForm\" id=\"postingPeriodForm\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"100\"><label>{{\'providerGroup.groupCode\'| translate}}\n</label><input type=\"text\" ng-model=\"vm.providerGroup.groupCode\" name=\"groupCode\" \nng-disabled=\"vm.isShowProgressLinear\" required><div ng-messages=\"vm.providerGroupForm.groupCode.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"50\"><label>{{\'providerGroup.groupName\'| translate}}\n</label><input type=\"text\" ng-model=\"vm.providerGroup.groupName\" name=\"groupName\" \nng-disabled=\"vm.isShowProgressLinear\" required><div ng-messages=\"vm.providerGroupForm.groupName.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container><md-input-container \nflex=\"50\"><label>{{\'providerGroup.code\'| translate}}</label><input type=\"text\" ng-model=\"vm.providerGroup.erpCode\" \nname=\"erpCode\" required ng-disabled=\"vm.isShowProgressLinear\"><div ng-messages=\"vm.providerGroupForm.erpCode.$error\">\n<div ng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div \nlayout=\"row\"><md-checkbox ng-disabled=\"!vm.providerGroup.id || vm.isShowProgressLinear\" \nng-model=\"vm.providerGroup.active\">{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between\" \nclass=\"dialog-actions-style-provider-group\"><md-button ng-click=\"vm.cancel()\" ng-disabled=\"vm.isShowProgressLinear\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" \nng-disabled=\"vm.providerGroupForm.$invalid  || vm.isShowProgressLinear\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/provider-information.html","<div id=\"provider-information\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><div flex=\"80\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.back()\"><md-icon style=\"color: white\" \nclass=\"s25\" md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div class=\"title\" flex flex-xs=\"100\"><span>\n{{vm.provider.name}}</span></div></div><div flex=\"20\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-warn\" aria-label=\"Save Change\" ng-if=\"vm.tabIndex === 0 && vm.saveButton && !vm.disableEditButton\" \nng-disabled=\"vm.wizardStep1.$invalid\" ng-click=\"vm.editMode ? vm.sendForm() : (vm.editMode = true)\">\n{{(vm.editMode ? \'COMPANY.SEND\' : \'COMPANY.EDIT\')| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon>\n</md-button><md-button ng-if=\"vm.viewParentName === \'internalProviders\'\" class=\"md-raised md-warn\" \nng-click=\"vm.removeProvider($event)\">{{\'validate_provider.delete\'| translate}}</md-button><md-button \nng-if=\"vm.viewParentName === \'validateProvider\'\" class=\"md-raised md-primary\" ng-click=\"vm.validate($event)\">\n{{\'validate_provider.validate\'| translate}}</md-button><md-button ng-if=\"vm.viewParentName === \'validateProvider\'\" \nclass=\"md-raised md-warn\" ng-click=\"vm.noValidate($event)\">{{\'validate_provider.not_validate\'| translate}}</md-button>\n</div></div><md-card class=\"content-card\" flex \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/content.html\'\" ms-scroll>\n</md-card></div></div>");
$templateCache.put("app/main/apps/generalConfiguration/additionalFields/dialogAdditionalFieldApp/dialogAdditionalFieldApp.html","<md-dialog class=\"\" aria-label=\"create or edit product\" style=\"width: 60%; height: 60%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'ADDITIONAL_FIELDS.appsFields\'| translate}} {{vm.data.additionalFieldName}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div \nng-show=\"vm.currentTab === 1\"><div id=\"gridFields\" ag-grid=\"vm.gridFields\" class=\"ag-fresh\" expand-grid min=\"260\" \nother=\"400\"></div></div><div class=\"form-inline\" ng-show=\"vm.currentTab === 2\"><ng-form name=\"vm.objForm\"><div \nlayout=\"row\"><md-input-container flex class=\"md-block\"><label translate=\"guest.application\">Aplicación</label>\n<md-select ng-disabled=\"vm.selectedCompanyApplicationAdditionalField.id>0\" \nng-model=\"vm.selectedCompanyApplicationAdditionalField.application.id\" name=\"app\" ng-change=\"vm.getInfoByApp(app);\" \nng-required=\"vm.selectedCompanyApplicationAdditionalField.id===0\"><md-option ng-repeat=\"app in vm.applications\" \nvalue=\"{{app.application.id}}\">{{app.application.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\"><md-input-container flex class=\"md-block\"><label>{{\"menu.establishments\"|translate}}</label><md-select \nng-disabled=\"vm.selectedCompanyApplicationAdditionalField.id>0\" \nng-model=\"vm.selectedCompanyApplicationAdditionalField.companyEstablishment.id\" name=\"department\" \nmd-on-close=\"vm.clearSearchCompanyEstablishment()\" ng-change=\"vm.getParametersByApplication(vm.application)\">\n<md-select-header><input id=\"searchCompanyEstablishment\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"vm.searchCompanyEstablishment\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"groups\"><md-option ng-value=\"{{data.id}}\" \nng-repeat=\"data in vm.companyestablishments| filter:vm.searchCompanyEstablishment\">{{data.establishmentName}}\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label>{{\"ADDITIONAL_FIELDS.type\"|translate}}</label><md-select \nng-model=\"vm.selectedCompanyApplicationAdditionalField.typeAdditional\"><md-option ng-value=\"null\"></md-option>\n<md-option value=\"INVENTORY\">Inventario</md-option><md-option value=\"INVENTORYDETAIL\">Inventario Detalle</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"ADDITIONAL_FIELDS.orders\"></label><input type=\"number\" \nng-model=\"vm.selectedCompanyApplicationAdditionalField.orders\" name=\"authorizedAmount\" step=\"any\" required=\"true\">\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container flex class=\"md-block\">\n<label translate=\"ADDITIONAL_FIELDS.fieldDetailOrder\"></label><input type=\"number\" \nng-model=\"vm.selectedCompanyApplicationAdditionalField.fieldDetailOrder\" name=\"fieldDetailOrder\" ng-step=\"1\" \nng-min=\"1\" ng-max=\"3\"><div ng-messages=\"vm.objForm.fieldDetailOrder.$error\"><div ng-message=\"min\" \ntranslate=\"ADDITIONAL_FIELDS.MSG.only_values_1_to_3\">The field is required!</div><div ng-message=\"max\" \ntranslate=\"ADDITIONAL_FIELDS.MSG.only_values_1_to_3\">The field is required!</div></div></md-input-container><md-button \nclass=\"md-icon-button\" ng-click=\"vm.selectedCompanyApplicationAdditionalField.fieldDetailOrder = null\"><md-icon \nmd-font-icon=\"icon-broom\" class=\"md-warn\"></md-icon><md-tooltip md-direction=\"top\">{{\"general.delete\"| translate}}\n</md-tooltip></md-button></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><md-checkbox \nng-model=\"vm.selectedCompanyApplicationAdditionalField.required\">{{\'ADDITIONAL_FIELDS.required\'| translate}}\n</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><md-checkbox \nng-model=\"vm.selectedCompanyApplicationAdditionalField.visibleReport\">{{\'ADDITIONAL_FIELDS.visibleReport\'| translate}}\n</md-checkbox></md-input-container></div></ng-form></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div flex layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.newCompanyApplicationAdditionalFields()\" class=\"md md-fab send-button md-accent md-raised\" \naria-label=\"Crear\" ng-if=\"vm.currentTab===1\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nng-click=\"vm.saveCompanyApplicationAdditionalField()\" class=\"md md-fab send-button md-accent md-raised\" \naria-label=\"Crear\" ng-if=\"vm.currentTab===2\" ng-disabled=\"vm.objForm.$invalid\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/additionalFields/additionalFieldsEdit/additionalFieldsEdit.html","<md-dialog id=\"dialogsEdit\" class=\"\" aria-label=\"create or edit product\" \nstyle=\"width: {{vm.width}};height: {{vm.height}}; overflow: hidden\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>\n{{!vm.additionalField.id ? \'general.add\' : \'general.edit\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><form \nname=\"vm.additionalFieldForm\"><div layout=\"column\"><md-input-container flex><label \ntranslate=\"ADDITIONAL_FIELDS.additionalFieldName\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.additionalField.additionalFieldName\" required><div ng-messages=\"vm.additionalFieldForm.name.$error\" \nng-show=\"vm.additionalFieldForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"general.field_required\"></span></div></div></md-input-container><md-input-container flex><label \ntranslate=\"ADDITIONAL_FIELDS.dataType\"></label><md-select ng-disabled=\"vm.loadingMeasures\" \nng-model=\"vm.additionalField.dataType\" name=\"measure\" required md-on-close=\"vm.clearDataType()\"><md-select-header>\n<input id=\"searchDataType\" ng-model=\"vm.searchDataType\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"dataTypes\"><md-option \nvalue=\"{{data.value}}\" ng-repeat=\"data in vm.dataTypes| filter:vm.searchDataType | orderBy:\'text\'\">{{data.text}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingMeasures\">\n</md-progress-linear><div ng-messages=\"vm.additionalFieldForm.measure.$error\" \nng-show=\"vm.additionalFieldForm.measure.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"general.field_required\"></span></div></div></md-input-container><md-input-container flex><md-checkbox \nng-model=\"vm.additionalField.useInOpeningCycle\" name=\"useInOpeningCycle\">\n{{\'ADDITIONAL_FIELDS.useInOpeningCycle\'| translate}}</md-checkbox></md-input-container></div></form>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div flex layout=\"row\" \nlayout-align=\"end center\"><md-button ng-disabled=\"vm.additionalFieldForm.$invalid\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Crear\">{{\'general.save\'|translate}}</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/additionalFields/additionalFieldsEdit/aditionalFieldDetail.html","<md-dialog class=\"\" aria-label=\"create or edit product\" style=\"width:40% ;height: {{vm.height}}; overflow: hidden\">\n<md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'ADDITIONAL_FIELDS.detailList\'| translate}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear \nmd-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div flex-xl=\"100\" \nflex-lg=\"100\" ng-show=\"vm.indexView === 0\"><md-list-item style=\"border-top: 1px solid #D8D8D8\" ng-style=\"data.style\" \nng-repeat=\"data in vm.arrValueList\"><span>{{data.fieldCode ? data.fieldCode + \'-\' : \'\'}}{{data.fieldValue}}</span>\n<md-button ng-click=\"vm.editValueList($event, data, $index)\" class=\"md-secondary md-icon-button\"><md-icon \nstyle=\"color: rgb(3,155,229)\" md-font-icon=\"icon-border-color\"></md-icon><md-tooltip md-direction=\"left\">\n{{\'general.edit\'| translate}}</md-tooltip></md-button><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.removeValueList($event, data, $index)\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\" style=\"color: red\">\n</md-icon><md-tooltip md-direction=\"left\">{{\'general.delete\'| translate}}</md-tooltip></md-button></md-list-item></div>\n<form name=\"vm.additionalFieldForm\"><div layout=\"column\" ng-show=\"vm.indexView === 1\"><div layout=\"row\" flex>\n<md-input-container flex><label translate=\"ADDITIONAL_FIELDS.valueNewCode\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.valueNewList.fieldCode\" required><div ng-messages=\"vm.additionalFieldForm.valueNewList.$error\" \nng-show=\"vm.additionalFieldForm.valueNewList.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"general.field_required\"></span></div></div></md-input-container></div><div layout=\"row\" flex>\n<md-input-container flex><label translate=\"ADDITIONAL_FIELDS.valueNewList\"></label><input type=\"text\" name=\"name\" \nng-model=\"vm.valueNewList.fieldValue\" required><div ng-messages=\"vm.additionalFieldForm.valueNewList.$error\" \nng-show=\"vm.additionalFieldForm.valueNewList.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"general.field_required\"></span></div></div></md-input-container></div><md-input-container flex><label \ntranslate=\"ADDITIONAL_FIELDS.fieldOrder\"></label><input numbers-only=\"numbers-only\" autocomplete=\"off\" \nname=\"fieldOrder\" ng-model=\"vm.valueNewList.fieldOrder\"></md-input-container><div layout=\"row\" flex><div \nlabel=\"{{\'ADDITIONAL_FIELDS.valueColor\'| translate}}\" md-color-picker=\"vm.colorPickerOptions\" \nng-model=\"vm.valueNewList.fieldColor\" md-color-generic-palette=\"false\" md-color-history=\"false\">\n{{vm.valueNewList.fieldColor}}</div></div><div layout=\"row\" flex><div \nlabel=\"{{\'ADDITIONAL_FIELDS.valueFontColor\'| translate}}\" md-color-picker=\"vm.colorPickerOptions\" \nng-model=\"vm.valueNewList.fieldColorFont\" md-color-generic-palette=\"false\" md-color-history=\"false\">\n{{vm.valueNewList.fieldColorFont}}</div></div></div></form></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><div flex layout=\"row\" layout-align=\"end center\"><md-button ng-show=\"vm.indexView === 0\" \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.add()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\'general.add\'| translate}}</md-tooltip>\n</md-button><md-button ng-if=\"vm.valueNewList && vm.indexView !== 0\" class=\"md-fab md-fab-bottom-right\" \nng-disabled=\"vm.additionalFieldForm.$invalid || vm.additionalFieldForm.$pristine\" aria-label=\"save\" \nstyle=\"position: fixed\" ng-click=\"vm.addValueList(vm.valueNewList)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip md-direction=\"left\">{{\'general.save\'| translate}}</md-tooltip></md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/gFace/gFaceEdit/gFaceEdit.html","<md-dialog class=\"\" aria-label=\"create or edit product\" style=\"width: 60%; max-height: 95%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>{{\'GFACE.gFaceByCompany\'| translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"form-inline\"><ng-form name=\"vm.companyGfaceForm\"><div \nlayout=\"row\"><md-input-container flex class=\"md-block\"><label>{{\'GFACE.gFaceName\'| translate}}</label><md-select \nng-model=\"vm.companyGface.gface.id\" name=\"app\" md-on-close=\"vm.clearSearchCompanyGface()\" \nng-disabled=\"vm.gFaceDisabled\"><md-select-header><input id=\"searchCompanyGface\" ng-model=\"vm.searchCompanyGface\" \ntype=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"gFaces\">\n<md-option value=\"{{data.id}}\" ng-repeat=\"data in vm.gFaces| filter:vm.searchCompanyGface\" \nng-click=\"vm.searchGetCompanyGface(data.id)\">{{data.gfaceName}}</md-option></md-optgroup></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label>{{\'GFACE.orderPriority\'| translate}}\n</label><input type=\"number\" ng-model=\"vm.companyGface.orderPriority\" name=\"orderPriority\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex><label>{{\'GFACE.userToSignDocuments\'| translate}}</label><input type=\"text\" \nng-model=\"vm.companyGface.userToSignDocuments\" name=\"userToSignDocuments\"></md-input-container><md-input-container \nflex><label>{{\'GFACE.keyToSignDocuments\'| translate}}</label><input type=\"text\" \nng-model=\"vm.companyGface.keyToSignDocuments\" name=\"keyToSignDocuments\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label>{{\'GFACE.aliasPfx\'| translate}}</label><input type=\"text\" \nng-model=\"vm.companyGface.aliasPfx\" name=\"aliasPfx\"></md-input-container><md-input-container flex><label>\n{{\'GFACE.keyPfx\'| translate}}</label><input type=\"text\" ng-model=\"vm.companyGface.keyPfx\" name=\"keyPfx\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"GFACE.expirationDate\">\nexpirationDate</label><md-datepicker type=\"date\" ng-model=\"vm.companyGface.expirationDate\" name=\"expirationDate\" \nmd-open-on-focus md-placeholder=\"dd-MM-yyyy\" required ng-disabled=\"vm.isShowProgressLinear\"></md-datepicker><div \nng-messages=\"vm.companyGfaceForm.expirationDate.$error\"><div ng-message=\"required\"><span>\n{{\'GFACE.expirationDate\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n</div></ng-form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div flex \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.saveGfaceByCompany()\" \nclass=\"md md-fab send-button md-accent md-raised\" aria-label=\"Crear\" ng-disabled=\"vm.companyGfaceForm.$invalid\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/discountsConfigureDetail.html","<div id=\"discount-settings\" layout=\"column\"><div layout=\"row\" class=\"custom-header\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.back()\"><md-icon style=\"color: white\" class=\"s25\" \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div flex=\"70\" class=\"title\" \nstyle=\"padding-left: 20px; color: white\"><h1><strong>\n{{\"DISCOUNTS.DISCOUNTS_CONFIGURE\" | translate}} {{\"DISCOUNTS.OF\" | translate}} {{vm.establishment.establishmentName}}\n</strong></h1></div></div><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loading\"></md-progress-linear>\n<md-card class=\"center\" flex layout=\"column\"><md-tabs md-dynamic-height md-selected=\"vm.tabIndex\" \nstyle=\"margin-bottom: 10px\"><md-tab md-on-select=\"vm.viewIndex = 0\"><md-tab-label><span \ntranslate=\"DISCOUNTS.discountCompanyEstablishmentPriority\">discountCompanyEstablishmentPriority</span></md-tab-label>\n</md-tab><md-tab md-on-select=\"vm.viewIndex = 1\" ng-if=\"!vm.isNew\"><md-tab-label><span \ntranslate=\"DISCOUNTS.DISCOUNTS_BY_PRODUCTTYPE\">Descuentos por Tipo de Producto</span></md-tab-label></md-tab><md-tab \nmd-on-select=\"vm.viewIndex = 2\" ng-if=\"!vm.isNew\"><md-tab-label><span translate=\"DISCOUNTS.discountDates\">discountDates\n</span></md-tab-label></md-tab><md-tab md-on-select=\"vm.viewIndex = 3\" ng-if=\"!vm.isNew\"><md-tab-label><span>\nAgregar nueva fecha de descuentos</span></md-tab-label></md-tab></md-tabs><div \nng-show=\"vm.tabIndex === 0 && vm.viewIndex === 0\" flex><div id=\"discountGrid\" ag-grid=\"vm.discountGrid\" \nclass=\"ag-fresh\" style=\"height: 100%; width: 100%\"></div><md-button ng-click=\"vm.addDiscountPriority()\" class=\"md-fab\" \naria-label=\"add discount date\" style=\"bottom: 20px; right: 20px; position: fixed\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div><div id=\"discountsProductType\" ng-show=\"vm.tabIndex === 1 && vm.viewIndex === 1\" \nlayout=\"column\" flex ng-controller=\"DiscountEstablishmentProductTypeController as dptCtrl\"><div \nclass=\"content-wrapper\" layout=\"row\" flex><div id=\"productTypesList\" class=\"content\" \nng-include=\"\'app/main/apps/generalConfiguration/discounts/discountsConfigure/discountEstablishmentProductType/producttype-list.html\'\" \nms-scroll flex=\"50\"></div><div class=\"content\" \nng-include=\"\'app/main/apps/generalConfiguration/discounts/discountsConfigure/discountEstablishmentProductType/discounts.html\'\" \nms-scroll flex=\"50\"></div></div></div><div ng-show=\"vm.tabIndex === 2 && vm.viewIndex === 2\" flex><div \nid=\"discountDatesGrid\" ag-grid=\"vm.discountDatesGrid\" class=\"ag-fresh\" style=\"height: 100%; width: 100%\"></div>\n<md-button ng-click=\"vm.tabIndex = 3;\" class=\"md-fab\" aria-label=\"add discount date\" \nstyle=\"bottom: 20px; right: 20px; position: fixed\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nng-show=\"vm.tabIndex === 3 && vm.viewIndex === 3\" flex ms-scroll class=\"add-discount-date\"><div layout=\"row\" \nlayout-align-xs=\"start center\" layout-align-sm=\"start center\" layout-align-md=\"center center\" \nlayout-align-lg=\"center center\"><form name=\"vm.dataForm2\" layout=\"column\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"100\" \nflex-lg=\"70\"><div><fieldset style=\"height: 100%\"><legend>{{\'DISCOUNTS.dates_and_discount_value\' | translate}}:</legend>\n<div layout=\"column\"><div layout=\"row\"><div flex><md-input-container flex class=\"md-block\"><label \ntranslate=\"DISCOUNTS.discountStartDate\"></label><md-datepicker flex type=\"date\" \nng-model=\"vm.discountDate.discountStartDate\" name=\"discountStartDate\" md-open-on-focus \nmd-max-date=\"vm.discountDate.discountEndDate\" md-placeholder=\"dd-MM-yyyy\" required></md-datepicker>\n</md-input-container></div><div flex><md-input-container flex class=\"md-block\"><label \ntranslate=\"DISCOUNTS.discountEndDate\"></label><md-datepicker flex type=\"date\" \nng-model=\"vm.discountDate.discountEndDate\" name=\"discountEndDate\" md-open-on-focus \nmd-min-date=\"vm.discountDate.discountStartDate\" md-placeholder=\"dd-MM-yyyy\" required></md-datepicker>\n</md-input-container></div></div><div layout=\"row\"><md-input-container flex class=\"md-block\" \nstyle=\"margin-top: 15px; margin-bottom: 0px\"><label translate=\"DISCOUNTS.discountCompanyEstablishment\"></label>\n<md-select ng-model=\"vm.discountDate.discountCompanyEstablishment.id\" name=\"discountCompanyEstablishment\" required \nmd-on-close=\"vm.searchDiscountCompanyEstablishment = \'\'\" ng-change=\"vm.filterDisocuntPriorityByDiscountMethod();\">\n<md-select-header><input ng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchDiscountCompanyEstablishment\" \ntype=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Discounts\">\n<md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.companyEstablishmentDiscounts| filter:vm.searchDiscountCompanyEstablishment\">\n{{data.discountCompany.discountName}}</md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"start center\" layout-align-xs=\"start start\"><md-input-container \nclass=\"md-block\" style=\"margin-top: 15px; margin-bottom: 0px; margin-right: 5px\"><md-switch \nng-model=\"vm.discountDate.applyAll\" aria-label=\"Apply all\">{{\"DISCOUNTS.APPLY_ALL\"| translate}}</md-switch>\n</md-input-container><md-input-container class=\"md-block\" style=\"margin-top: 15px; margin-bottom: 0px\"><md-switch \nng-model=\"vm.discountDate.applyToAllInvoices\" aria-label=\"Apply to all invoices\">\n{{\"DISCOUNTS.APPLY_TO_ALL_INVOICES\"| translate}}</md-switch></md-input-container></div></div></fieldset></div><div>\n<fieldset style=\"height: 100%\"><legend>{{\'DISCOUNTS.DISCOUNT_TYPE\' | translate}}:</legend><div layout=\"column\"><div \nlayout=\"row\"><md-input-container flex class=\"md-block\"><label translate=\"DISCOUNTS.DISCOUNT_TYPE\"></label><md-select \nng-model=\"vm.discountDate.discountType\" required name=\"discount\" md-on-close=\"vm.searchDiscount = \'\'\">\n<md-select-header><input ng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchDiscount\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Discounts\"><md-option \nvalue=\"{{data.discountType}}\" ng-repeat=\"data in vm.discountCompanyPriority| filter:vm.searchDiscount\">{{data.value}} \n<span ng-if=\"data.isPercentage\">%</span></md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.discountDate.discountType!==\'INVOICE_SALE\'\"><md-input-container \nflex class=\"md-block\" style=\"margin-top: 15px; margin-bottom: 0px\"><label>\n{{\'DISCOUNTS.click_on_plus_to_add_reference\' | translate}}</label><input ng-model=\"vm.discountDate.referenceId\" \nreadonly=\"readonly\" required></md-input-container><md-button class=\"md-icon-button\" aria-label=\"addDetail\" \nng-disabled=\"!vm.discountDate.discountType\" ng-click=\"vm.addReference($event)\"><md-icon md-font-icon=\"icon-plus\">\n<md-tooltip md-direction=\"top\">{{\'DISCOUNTS.add_reference\'| translate}}</md-tooltip></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.discountDate.discountType===\'PRODUCT_TYPE_ADD_FIELD\'\">\n<md-input-container flex class=\"md-block\" style=\"margin-top: 15px; margin-bottom: 0px\"><label>\n{{\'DISCOUNTS.click_on_plus_to_add_additional_field\' | translate}}</label><input \nng-model=\"vm.discountDate.additionalFieldValue\" readonly=\"readonly\" required></md-input-container><md-button \nclass=\"md-icon-button\" aria-label=\"addAdditionalField\" ng-disabled=\"!vm.discountDate.discountType\" \nng-click=\"vm.addAdditionalField($event)\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip md-direction=\"top\">\n{{\'DISCOUNTS.add_additional_field\' | translate}}</md-tooltip></md-icon></md-button></div></div></fieldset></div><div>\n<fieldset style=\"height: 100%\"><legend>{{\'DISCOUNTS.message\' | translate}}:</legend><md-input-container flex \nclass=\"md-block\"><label translate=\"DISCOUNTS.message\"></label><textarea ng-model=\"vm.discountDate.message\" \nautocomplete=\"off\"></textarea></md-input-container></fieldset></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-primary\" ng-disabled=\"vm.dataForm2.$invalid\" ng-click=\"vm.saveDiscountDates($event)\">\n{{\'general.save\' | translate}}</md-button></div></form></div></div><div ng-show=\"vm.viewIndex === 4\" \nstyle=\"position: relative\"><div layout=\"row\" layout-align=\"center start\" flex \nng-controller=\"DiscountDateFiltersController as ddfCtrl\" class=\"discount-dates-filters\" ms-scroll><fieldset flex=\"50\">\n<legend>Configuracion de filtros especiales por descuento:</legend><form name=\"ddfCtrl.dataForm\" layout=\"column\"><div \nlayout=\"row\"><md-input-container flex class=\"md-block\"><label>Aplicar descuento sobre:</label><md-select \nng-disabled=\"ddfCtrl.discountDatesFilter.id !== null && ddfCtrl.discountDatesFilter.id !== undefined\" \nng-model=\"ddfCtrl.discountEntity\" name=\"discountEntity\" \nng-change=\"ddfCtrl.filterDiscountFieldByEntityName(); ddfCtrl.clearValues();\"><md-option ng-value=\"entity.name\" \nng-repeat=\"entity in ddfCtrl.entitiesToApplyDiscounts\">{{entity.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"DISCOUNTS.DISCOUNT_FIELD\"></label><md-select \nng-disabled=\"ddfCtrl.discountDatesFilter.id !== null && ddfCtrl.discountDatesFilter.id !== undefined\" \nng-model=\"ddfCtrl.discountDatesFilter.discountField.id\" name=\"discountField\" ng-change=\"ddfCtrl.clearValues()\" \nrequired md-on-close=\"ddfCtrl.searchDiscountField = \'\'\"><md-select-header><input \nng-keydown=\"$event.stopPropagation();\" ng-model=\"ddfCtrl.searchDiscountField\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"DiscountsField\"><md-option \nng-value=\"data.id\" ng-repeat=\"data in ddfCtrl.discountFields| filter:ddfCtrl.searchDiscountField\">\n{{data.discountFieldDescription}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex class=\"md-block\"><label translate=\"DISCOUNTS.DISCOUNT_CONDITION\">\n</label><md-select \nng-disabled=\"ddfCtrl.discountDatesFilter.id !== null && ddfCtrl.discountDatesFilter.id !== undefined\" \nng-model=\"ddfCtrl.discountDatesFilter.discountCondition\" name=\"discountCondition\" required \nmd-on-close=\"ddfCtrl.searchDiscountCondition =  \'\'\"><md-select-header><input ng-keydown=\"$event.stopPropagation()\" \nng-model=\"ddfCtrl.searchDiscountCondition\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"DiscountsCondition\"><md-option value=\"{{data.value}}\" \nng-repeat=\"data in ddfCtrl.discountConditions| filter:ddfCtrl.searchDiscountCondition\">{{data.translate | translate}} \n<strong>{{data.symbol}}</strong></md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-switch ng-model=\"ddfCtrl.discountDatesFilter.hasListValue\" \nng-change=\"ddfCtrl.clearValues()\" \nng-disabled=\"ddfCtrl.dataForm.discountCondition.$invalid || (ddfCtrl.discountDatesFilter.id !== null && ddfCtrl.discountDatesFilter.id !== undefined)\">\nEs una lista de valores</md-switch><md-button ng-disabled=\"ddfCtrl.dataForm.discountField.$invalid\" \nng-if=\"ddfCtrl.discountDatesFilter.hasListValue\" class=\"md-raised md-primary\" aria-label=\"addValuesToList\" \nng-click=\"ddfCtrl.addValue()\">Agregar valores</md-button></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"!ddfCtrl.discountDatesFilter.hasListValue\"><md-button ng-disabled=\"ddfCtrl.dataForm.discountField.$invalid\" \nclass=\"md-raised md-primary\" aria-label=\"addValuesToList\" ng-click=\"ddfCtrl.addValue()\">Agregar valor</md-button>\n<md-input-container flex class=\"md-block\"><label translate=\"DISCOUNTS.FILTER_VALUE\"></label><input \nng-model=\"ddfCtrl.discountDatesFilter.filterValue\" disabled=\"disabled\" required></md-input-container></div><md-chips \nng-if=\"ddfCtrl.discountDatesFilter.hasListValue\" class=\"discount-date-filter-values\" \nng-model=\"ddfCtrl.discountDateFilterValues\" readonly=\"true\" md-removable=\"true\" \nmd-on-remove=\"ddfCtrl.removeFilterValue($chip, $index, $event)\"><md-chip-template><span><em>{{$chip.filterIdValue}}\n</em></span></md-chip-template><button md-chip-remove class=\"md-primary remove-value\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></button></md-chips><div layout=\"row\" layout-align=\"center center\"><md-button \nng-if=\"ddfCtrl.discountDatesFilter.hasListValue\" class=\"md-raised md-primary\" aria-label=\"addDetail\" \nng-disabled=\"!ddfCtrl.discountDatesFilter.hasListValue || ddfCtrl.discountDateFilterValues.length === 0\" \nng-click=\"ddfCtrl.save($event)\">{{\"general.save\"| translate}}</md-button><md-button class=\"md-raised md-primary\" \nng-if=\"!ddfCtrl.discountDatesFilter.hasListValue\" aria-label=\"addDetail\" \nng-disabled=\"ddfCtrl.dataForm.$invalid || ddfCtrl.discountDatesFilter.hasListValue\" ng-click=\"ddfCtrl.save($event)\">\n{{\"general.save\"| translate}}</md-button><md-button class=\"md-raised md-warn\" ng-click=\"ddfCtrl.cancel($event)\">\n{{\"general.cancel\"| translate}}</md-button></div></form></fieldset></div><md-button title=\"Cerrar\" \nng-click=\"vm.tabIndex = 2; vm.viewIndex = vm.previousViewIndex;\" class=\"md-icon-button\" aria-label=\"close tab\" \nstyle=\"top: -50px; right: 5px; position: absolute\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nng-show=\"vm.viewIndex === 5\" flex ng-controller=\"DiscountDateFiltersListController as ddflCtrl\" \nstyle=\"position: relative\"><div ag-grid=\"ddflCtrl.discountDatesFilterGrid\" class=\"ag-fresh\" \nstyle=\"width: 100%; height: 100%\"></div><md-button title=\"Cerrar lista de filtros\" \nng-click=\"vm.tabIndex = 2; vm.viewIndex = 2;\" class=\"md-icon-button\" aria-label=\"close tab\" \nstyle=\"top: -50px; right: 5px; position: absolute\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-card></div>");
$templateCache.put("app/main/apps/generalConfiguration/payment-condition/payment/payment.html","<md-dialog aria-label=\"Crear-Editar\" class=\"dialog-style-payment\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.paymentCondition.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent progress-bar-style-payment\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear></md-toolbar><md-dialog-content><div class=\"mat-dialog-without-padding\"><ng-form \nname=\"vm.paymentConditionForm\" id=\"postingPeriodForm\"><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"50\"><label>{{\'paymentCondition.name\'| translate}}</label><input type=\"text\" \nng-model=\"vm.paymentCondition.name\" name=\"name\" ng-disabled=\"vm.isShowProgressLinear\" required><div \nng-messages=\"vm.paymentConditionForm.name.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}\n</div></div></md-input-container><md-input-container flex=\"50\"><label>{{\'paymentCondition.code\'| translate}}</label>\n<input type=\"text\" ng-model=\"vm.paymentCondition.erpCode\" name=\"erpCode\" required \nng-disabled=\"vm.isShowProgressLinear\"><div ng-messages=\"vm.paymentConditionForm.erpCode.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-checkbox ng-disabled=\"!vm.paymentCondition.id || vm.isShowProgressLinear\" ng-model=\"vm.paymentCondition.active\">\n{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between\" class=\"dialog-actions-style-payment\"><md-button ng-click=\"vm.cancel()\" \nng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" \nng-disabled=\"vm.paymentConditionForm.$invalid  || vm.isShowProgressLinear\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/payment-condition/payment-list/payment-list.html","<md-progress-linear md-mode=\"query\" class=\"md-accent progress-style-payment\" ng-show=\"vm.isShowProgressLinearGrid\">\n</md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-xs=\"column\" class=\"custom-header\" \nlayout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" layout-align-xs=\"center none\"><div \nflex=\"30\" flex-xs=\"100\"><span class=\"title-style-payment\">\n{{\'paymentCondition.paymentConditions\'| translate}} ({{vm.paymentConditions.length}})</span></div><div flex=\"30\" \nflex-xs=\"100\" ng-if=\"vm.paymentConditions.length > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'paymentCondition.searchPaymentCondition\' | translate}}\" ng-model=\"vm.inputSearch\"><md-button \nng-click=\"\">{{\'general.search\' | translate}}</md-button></div></div></div><div layout=\"row\"><div flex=\"100\"><md-card>\n<div class=\"ag-fresh\" id=\"paymentConditions\" ag-grid=\"vm.gridPayment\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div></md-card></div></div><md-button aria-label=\"add\" \nclass=\"md-fab md-fab-bottom-right button-style-payment\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/dialogDiscounts/dialogDiscounts.html","<md-dialog class=\"\" aria-label=\"create or edit product\" style=\"width: 60%; max-height: 80%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'DISCOUNTS.DISCOUNTS\'| translate}} {{vm.data.additionalFieldName}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"form-inline\"><ng-form name=\"vm.objForm\"><div layout=\"row\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"DISCOUNTS.name\">name</label><input ng-model=\"vm.discount.discountName\" type=\"text\" required=\"true\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"DISCOUNTS.value\"></label><input type=\"number\" ng-model=\"vm.discount.discountValue\" name=\"authorizedAmount\" \nstep=\"any\" required=\"true\"></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\">\n<label translate=\"DISCOUNTS.applicationMethod\"></label><md-select ng-model=\"vm.discount.discountMethod\" \nname=\"discountMethod\" required md-on-close=\"vm.searchDiscountMethod = \'\'\"><md-select-header><input \nng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchDiscountMethod\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"DiscountMethods\"><md-option \nvalue=\"{{data.key}}\" ng-repeat=\"data in vm.discountMethods| filter:vm.searchDiscountMethod\">{{data.value}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div class=\"operator-info-text\" \nng-if=\"vm.discount.discountMethod === vm.discountMethodFinalPriceCode\"><strong>\n{{ \'DISCOUNTS.operatorInfo\' | translate }}</strong>{{ \'DISCOUNTS.operatorInfoVariables\' | translate }}</div><div \nlayout=\"row\" ng-if=\"vm.discount.discountMethod === vm.discountMethodFinalPriceCode\"><md-input-container flex \nclass=\"md-block\"><label translate=\"DISCOUNTS.operator\"></label><input type=\"text\" ng-model=\"vm.discount.operator\" \nname=\"operator\"></md-input-container></div><div layout=\"row\"><md-input-container flex class=\"md-block\"><md-checkbox \nng-model=\"vm.discount.isUnique\">{{\'DISCOUNTS.isUnique\'| translate}}</md-checkbox></md-input-container></div></ng-form>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><div flex layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.saveCompanyApplicationAdditionalField()\" \nclass=\"md md-fab send-button md-accent md-raised\" aria-label=\"Crear\" ng-disabled=\"vm.objForm.$invalid\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/notification/dialogs/dialog-notification-type-schedule/dialog-notification-type-schedule.html","<md-dialog id=\"dialog-notification-type-schedule-config\" class=\"compose-dialog\" aria-label=\"Crear-Editar\"><md-toolbar>\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.notificationTypeSchedule.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" ng-show=\"vm.isShowProgressLinear\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 50px\"></md-progress-linear></md-toolbar><md-dialog-content \nstyle=\"height: 100%\"><div class=\"md-dialog-content\"><form name=\"vm.notificationTypeScheduleForm\" \nid=\"notificationTypeScheduleForm\" ng-submit=\"vm.save()\"><div layout=\"row\"><md-checkbox ng-model=\"vm.showSpecificDate\" \nng-change=\"vm.changeSpecificDate()\">{{\'notificationTypeSchedule.inSpecificDate\' | translate}}</md-checkbox><md-checkbox\n ng-model=\"vm.removeDayOfWeek\" ng-if=\"vm.showSpecificDate\" ng-change=\"vm.changeDayOfWeek()\">\n{{\'notificationTypeSchedule.removeDayOfWeek\' | translate}}</md-checkbox></div><div layout=\"row\" \nng-if=\"!vm.removeDayOfWeek\"><md-input-container flex><label>{{\'notificationTypeSchedule.dayOfWeek\'| translate}}</label>\n<md-select ng-model=\"vm.notificationTypeSchedule.dayOfWeek\" name=\"dayOfWeek\" required><md-option ng-value=\"1\">\n{{\'daysOfWeek.Sunday\'| translate}}</md-option><md-option ng-value=\"2\">{{\'daysOfWeek.Monday\'| translate}}</md-option>\n<md-option ng-value=\"3\">{{\'daysOfWeek.Tuesday\'| translate}}</md-option><md-option ng-value=\"4\">\n{{\'daysOfWeek.Wednesday\'| translate}}</md-option><md-option ng-value=\"5\">{{\'daysOfWeek.Thursday\'| translate}}\n</md-option><md-option ng-value=\"6\">{{\'daysOfWeek.Friday\'| translate}}</md-option><md-option ng-value=\"7\">\n{{\'daysOfWeek.Saturday\'| translate}}</md-option></md-select><div \nng-messages=\"vm.notificationTypeScheduleForm.dayOfWeek.$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.showSpecificDate\"><md-input-container flex=\"50\"><label translate=\"notificationTypeSchedule.startDate\">\nFecha de inicio</label><md-datepicker type=\"date\" ng-model=\"vm.notificationTypeSchedule.startDate\" name=\"startDate\" \nmd-open-on-focus md-max-date=\"vm.notificationTypeSchedule.endDate\" md-min-date=\"vm.currentDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div \nng-messages=\"vm.notificationTypeScheduleForm.startDate.$error\"><div ng-message=\"valid\" translate=\"error.invalid_date\">\nThe entered value is not a date!</div><div ng-message=\"required\"><span>\n{{\'notificationTypeSchedule.startDate\'| translate }} {{\'notificationTypeSchedule.isRequired\'| translate}}</span></div>\n<div ng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.showSpecificDate\"><md-input-container flex=\"50\"><label \ntranslate=\"notificationTypeSchedule.endDate\">Fecha fin</label><md-datepicker \nng-model=\"vm.notificationTypeSchedule.endDate\" md-min-date=\"vm.notificationTypeSchedule.startDate\" \nmd-placeholder=\"dd-MM-yyyy\"></md-datepicker></md-input-container><md-button class=\"md-icon-button\" \nng-click=\"vm.notificationTypeSchedule.endDate=null;\" style=\"padding-left: 5px\"><md-icon md-font-icon=\"icon-broom\" \nclass=\"md-warn\"></md-icon><md-tooltip md-direction=\"left\">{{\"notificationTypeSchedule.clearEndDate\"| translate}}\n</md-tooltip></md-button></div><div layout=\"row\"><md-input-container flex><label>\n{{\'notificationTypeSchedule.hourOfDay\'| translate}}</label><input type=\"number\" step=\"1\" min=\"1\" max=\"24\" \nng-model=\"vm.notificationTypeSchedule.hourOfDay\" name=\"hourOfDay\" required><div \nng-messages=\"vm.notificationTypeScheduleForm.hourOfDay.$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}</div><div ng-message=\"min\">{{\'general.can_not_be_less_than\'| translate}} 0\n</div><div ng-message=\"max\">{{\'general.can_not_be_greater_than\'| translate}} 24</div></div></md-input-container></div>\n<div layout=\"row\"><md-checkbox ng-disabled=\"!vm.notificationTypeSchedule.id\" \nng-model=\"vm.notificationTypeSchedule.active\">{{\'general.active\' | translate}}</md-checkbox></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"start end\"><md-button \nng-disabled=\"vm.isShowProgressLinear\" ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"vm.isShowProgressLinear || vm.notificationTypeScheduleForm.$invalid\" type=\"submit\" \nform=\"notificationTypeScheduleForm\">{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/notification/dialogs/dialog-scheduleParameter/dialog-scheduleParameter.html","<md-dialog class=\"compose-dialog\" aria-label=\"Document\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1><label>{{\"notificationTypeSchedule.parameters\" | translate}}</label></h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"animate-show\"><div layout=\"row\" layout-xs=\"column\">\n<md-input-container class=\"inputfilter\" flex><label>{{\'notificationTypeSchedule.parameters.parameterName\'| translate}}\n</label><md-select ng-model=\"vm.notificationTypeScheduleParameter.notificationTypeParameter\" \nmd-on-close=\"vm.clearSearchNotificationTypeScheduleParameter()\" ng-disabled=\"vm.loadingAdditionalFields\">\n<md-select-header><input id=\"searchParameter\" ng-model=\"vm.searchParameter\" type=\"search\" \nplaceholder=\"{{\'notificationTypeSchedule.parameters.parameterName\' | translate}}\"></md-select-header><md-optgroup \nlabel=\"notificationTypeParameter\"><md-option ng-value=\"dat\" \nng-repeat=\"dat in vm.notificationTypeParameters | filter:vm.searchParameter\">{{dat.parameterName}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingAdditionalFields\">\n</md-progress-linear></md-input-container><md-input-container class=\"inputfilter\" flex><label>\n{{\'notificationTypeSchedule.parameters.parameterValue\'| translate}}</label><input \nng-model=\"vm.notificationTypeScheduleParameter.parameterValue\"><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingAdditionalFieldValue\"></md-progress-linear></md-input-container><md-button \nclass=\"md-mini md-fab md-primary md-raised\" aria-label=\"addDetail\" ng-click=\"vm.addNotificationTypeParameter()\" \nng-disabled=\"!vm.notificationTypeScheduleParameter.notificationTypeParameter || !vm.notificationTypeScheduleParameter.parameterValue\">\n<md-icon md-font-icon=\"icon-content-save\"><md-tooltip md-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip>\n</md-icon></md-button></div></div><div class=\"animate-show\"><div id=\"gridAdditionalFields\" \nag-grid=\"vm.gridAdditionalFields\" class=\"ag-fresh\" expand-grid min=\"260\" other=\"280\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeDialog()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">{{\'notificationTypeSchedule.OK\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/category-feature/associate-category-feature/associate-category-feature.html","<md-dialog aria-label=\"Crear-Editar\" class=\"custom-md-dialog-height\" style=\"width: 1200px; height: 935px\"><md-toolbar>\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'category_feature.features\' | translate}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear \nmd-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content \nstyle=\"padding: 5px 24px 24px 24px\"><div layout-xl=\"row\" layout-lg=\"row\" layout-align-lg=\"space-around center\" \nlayout-md=\"row\" layout-align-md=\"space-around center\"><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div layout=\"column\">\n<div flex=\"100\"><md-list \nstyle=\"border-top: 1px solid #D8D8D8; border-bottom: 1px solid #D8D8D8; border-right: 1px solid #D8D8D8; border-left: 1px solid #D8D8D8\">\n<md-subheader class=\"md-no-sticky\">\n{{\'category_feature.features\' | translate}} ({{vm.featureArray.length}} {{\'user.of\'| translate}} {{vm.pagination.totalElements}})\n</md-subheader><div id=\"listFeatureContainer\"><md-list-item style=\"border-top: 1px solid #D8D8D8\" \nng-show=\"vm.featureArray.length > 0\"><md-checkbox ng-model=\"vm.isCheckAllFeature\" ng-change=\"vm.selectAllFeature()\">\n</md-checkbox><p>{{\'user.all\'| translate}}</p></md-list-item><md-list-item style=\"border-top: 1px solid #D8D8D8\" \nng-repeat=\"feature in vm.featureArray\"><md-checkbox ng-model=\"feature.isCheck\" \nng-change=\"vm.validateSelectAllFeature()\"></md-checkbox><p>{{feature.name}}</p></md-list-item></div></md-list></div>\n<div flex=\"100\"><div layout=\"row\" layout-align=\"center center\"><md-button aria-label=\"first page\" \nclass=\"md-icon-button\" ng-click=\"vm.pagination.firstPage()\" ng-disabled=\"vm.pagination.pageNumber === 1\"><md-tooltip \nmd-direction=\"left\">{{\'user.first_page\'|translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-double-left\">\n</md-icon></md-button><md-button aria-label=\"before page\" class=\"md-icon-button\" ng-click=\"vm.pagination.beforePage()\" \nng-disabled=\"vm.pagination.pageNumber === 1\"><md-tooltip md-direction=\"left\">{{\'user.before_page\'| translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button aria-label=\"next page\" \nclass=\"md-icon-button\" ng-click=\"vm.pagination.nextPage()\" \nng-disabled=\"vm.pagination.totalPages === 0 || vm.pagination.pageNumber === vm.pagination.totalPages\"><md-tooltip \nmd-direction=\"left\">{{\'user.next_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button><md-button aria-label=\"last page\" class=\"md-icon-button\" ng-click=\"vm.pagination.lastPage()\" \nng-disabled=\"vm.pagination.totalPages === 0 || vm.pagination.pageNumber === vm.pagination.totalPages\"><md-tooltip \nmd-direction=\"left\">{{\'user.last_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-double-right\">\n</md-icon></md-button></div></div></div></div><div flex-xl=\"10\" flex-lg=\"10\" flex-md=\"10\"><div layout=\"column\">\n<md-button aria-label=\"button disassociate departments\" flex=\"100\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" ng-disabled=\"vm.countCategoryFeatureSelected === 0\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button aria-label=\"Button associate departments\" flex=\"100\" \nclass=\"md-primary md-raised\" ng-click=\"vm.associate()\" ng-disabled=\"vm.countFeatureSelected === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button></div></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div \nlayout=\"column\"><div flex=\"100\"><md-list \nstyle=\"border-top: 1px solid #D8D8D8; border-bottom: 1px solid #D8D8D8; border-right: 1px solid #D8D8D8; border-left: 1px solid #D8D8D8\">\n<md-subheader class=\"md-no-sticky\">\n{{\'category_feature.feature_associates\' | translate}} ({{vm.categoryFeatureArray.length}} {{\'user.of\'| translate}} {{vm.paginationCategoryFeature.totalElements}})\n</md-subheader><div id=\"listCategoryFeatureContainer\"><md-list-item style=\"border-top: 1px solid #D8D8D8\" \nng-show=\"vm.categoryFeatureArray.length > 0\"><md-checkbox ng-model=\"vm.isCheckAllCategoryFeature\" \nng-change=\"vm.selectAllCategoryFeature()\"></md-checkbox><p>{{\'user.all\'| translate}}</p></md-list-item><md-list-item \nstyle=\"border-top: 1px solid #D8D8D8\" ng-repeat=\"categoryFeature in vm.categoryFeatureArray\"><md-checkbox \nng-model=\"categoryFeature.isCheck\" ng-change=\"vm.validateSelectAllCategoryFeature()\"></md-checkbox><p>\n{{categoryFeature.feature.name}}</p></md-list-item></div></md-list></div><div flex=\"100\"><div layout=\"row\" \nlayout-align=\"center center\"><md-button aria-label=\"first page\" class=\"md-icon-button\" \nng-click=\"vm.paginationCategoryFeature.firstPage()\" ng-disabled=\"vm.paginationCategoryFeature.pageNumber === 1\">\n<md-tooltip md-direction=\"left\">{{\'user.first_page\'| translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-chevron-double-left\"></md-icon></md-button><md-button aria-label=\"before page\" \nclass=\"md-icon-button\" ng-click=\"vm.paginationCategoryFeature.beforePage()\" \nng-disabled=\"vm.paginationCategoryFeature.pageNumber === 1\"><md-tooltip md-direction=\"left\">\n{{\'user.before_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button aria-label=\"next page\" class=\"md-icon-button\" ng-click=\"vm.paginationCategoryFeature.nextPage()\" \nng-disabled=\"vm.paginationCategoryFeature.totalPages === 0 || vm.paginationCategoryFeature.pageNumber === vm.paginationCategoryFeature.totalPages\">\n<md-tooltip md-direction=\"left\">{{\'user.next_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button><md-button aria-label=\"last page\" class=\"md-icon-button\" \nng-click=\"vm.paginationCategoryFeature.lastPage()\" \nng-disabled=\"vm.paginationCategoryFeature.totalPages === 0 || vm.paginationCategoryFeature.pageNumber === vm.paginationCategoryFeature.totalPages\">\n<md-tooltip md-direction=\"left\">{{\'user.last_page\'| translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-chevron-double-right\"></md-icon></md-button></div></div></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/product/feature/feature-list/feature-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"30\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\nCaracteristicas ({{vm.pagination.totalElements}})</span></div></div><div layout=\"row\"><div flex=\"100\"><md-card><div \nid=\"caracteristicasGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"0\" ng-show=\"vm.showGrid\">\n</div></md-card></div></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" \nng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button>");
$templateCache.put("app/main/apps/product/feature/feature/feature.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 100%\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.feature.id ? \'general.edit\' : \'general.add\'| translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div style=\"padding: 5px\"><ng-form name=\"vm.featureForm\" id=\"featureForm\"><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>{{\'feature.name\'| translate}}</label><input type=\"text\" \nng-model=\"vm.feature.name\" name=\"name\" required><div ng-messages=\"vm.featureForm.name.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>{{\'feature.value_data_type\'| translate}}</label><md-select \nng-model=\"vm.feature.dataType\"><md-option value=\"{{dataType.name}}\" ng-repeat=\"dataType in vm.dataTypeArray\">\n{{dataType.translate | translate}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>{{\'feature.value_length\'| translate}}</label><input type=\"text\" \nng-model=\"vm.feature.valueLength\" name=\"valueLength\" required><div ng-messages=\"vm.featureForm.valueLength.$error\"><div\n ng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label>{{\'feature.measurement_unit\' | translate}}</label><md-select \nng-model=\"vm.feature.measurementUnit.id\"><md-option ng-value=\"measurementUnit.id\" \nng-repeat=\"measurementUnit in vm.measurementUnitArray\">{{measurementUnit.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"space-between center\"><md-checkbox \nng-model=\"vm.feature.canAddValues\">{{\'feature.can_add_values\'| translate}}</md-checkbox><md-checkbox \nng-model=\"vm.feature.required\">{{\'feature.required\'| translate}}</md-checkbox><md-checkbox \nng-disabled=\"!vm.feature.id\" ng-model=\"vm.feature.active\">{{\'general.active\'| translate}}</md-checkbox></div></ng-form>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/feature/feature-measurement-unit/feature-measurement-unit.html","<md-dialog aria-label=\"Crear-Editar\" class=\"custom-md-dialog-height\" style=\"width: 1200px; height: 935px\"><md-toolbar>\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'feature.measurement_units\' | translate}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear \nmd-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content \nstyle=\"padding: 5px 24px 24px 24px\"><div layout-xl=\"row\" layout-lg=\"row\" layout-align-lg=\"space-around center\" \nlayout-md=\"row\" layout-align-md=\"space-around center\"><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div layout=\"column\">\n<div flex=\"100\"><md-list \nstyle=\"border-top: 1px solid #D8D8D8; border-bottom: 1px solid #D8D8D8; border-right: 1px solid #D8D8D8; border-left: 1px solid #D8D8D8\">\n<md-subheader class=\"md-no-sticky\">\n{{\'feature.measurement_units\' | translate}} ({{vm.measurementUnitArray.length}} {{\'user.of\'| translate}} {{vm.pagination.totalElements}})\n</md-subheader><div id=\"listMeasurementUnitContainer\"><md-list-item style=\"border-top: 1px solid #D8D8D8\" \nng-show=\"vm.measurementUnitArray.length > 0\"><md-checkbox ng-model=\"vm.isCheckAllMeasurementUnit\" \nng-change=\"vm.selectAllMeasurementUnit()\"></md-checkbox><p>{{\'user.all\'| translate}}</p></md-list-item><md-list-item \nstyle=\"border-top: 1px solid #D8D8D8\" ng-repeat=\"measurementUnit in vm.measurementUnitArray\"><md-checkbox \nng-model=\"measurementUnit.isCheck\" ng-change=\"vm.validateSelectAllMeasurementUnit()\"></md-checkbox><p>\n{{measurementUnit.name}} ({{measurementUnit.code}})</p></md-list-item></div></md-list></div><div flex=\"100\"><div \nlayout=\"row\" layout-align=\"center center\"><md-button aria-label=\"first page\" class=\"md-icon-button\" \nng-click=\"vm.pagination.firstPage()\" ng-disabled=\"vm.pagination.pageNumber === 1\"><md-tooltip md-direction=\"left\">\n{{\'user.first_page\'|translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-double-left\"></md-icon></md-button>\n<md-button aria-label=\"before page\" class=\"md-icon-button\" ng-click=\"vm.pagination.beforePage()\" \nng-disabled=\"vm.pagination.pageNumber === 1\"><md-tooltip md-direction=\"left\">{{\'user.before_page\'| translate}}\n</md-tooltip><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button aria-label=\"next page\" \nclass=\"md-icon-button\" ng-click=\"vm.pagination.nextPage()\" \nng-disabled=\"vm.pagination.totalPages === 0 || vm.pagination.pageNumber === vm.pagination.totalPages\"><md-tooltip \nmd-direction=\"left\">{{\'user.next_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button><md-button aria-label=\"last page\" class=\"md-icon-button\" ng-click=\"vm.pagination.lastPage()\" \nng-disabled=\"vm.pagination.totalPages === 0 || vm.pagination.pageNumber === vm.pagination.totalPages\"><md-tooltip \nmd-direction=\"left\">{{\'user.last_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-double-right\">\n</md-icon></md-button></div></div></div></div><div flex-xl=\"10\" flex-lg=\"10\" flex-md=\"10\"><div layout=\"column\">\n<md-button aria-label=\"button disassociate departments\" flex=\"100\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" ng-disabled=\"vm.countFeatureMeasurementUnitSelected === 0\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button aria-label=\"Button associate departments\" flex=\"100\" \nclass=\"md-primary md-raised\" ng-click=\"vm.associate()\" ng-disabled=\"vm.countMeasurementUnitSelected === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon></md-button></div></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div \nlayout=\"column\"><div flex=\"100\"><md-list \nstyle=\"border-top: 1px solid #D8D8D8; border-bottom: 1px solid #D8D8D8; border-right: 1px solid #D8D8D8; border-left: 1px solid #D8D8D8\">\n<md-subheader class=\"md-no-sticky\">\n{{\'feature.measurement_units_associated\' | translate}} ({{vm.featureMeasurementUnitArray.length}} {{\'user.of\'| translate}} {{vm.paginationFeatureMeasurementUnit.totalElements}})\n</md-subheader><div id=\"listFeatureMeasurementUnitContainer\"><md-list-item style=\"border-top: 1px solid #D8D8D8\" \nng-show=\"vm.featureMeasurementUnitArray.length > 0\"><md-checkbox ng-model=\"vm.isCheckAllFeatureMeasurementUnit\" \nng-change=\"vm.selectAllFeatureMeasurementUnit()\"></md-checkbox><span>{{\'user.all\'| translate}}</span></md-list-item>\n<md-list-item style=\"border-top: 1px solid #D8D8D8\" \nng-repeat=\"featureMeasurementUnit in vm.featureMeasurementUnitArray\"><md-checkbox \nng-disabled=\"featureMeasurementUnit.isPredeterminated\" ng-hide=\"featureMeasurementUnit.isPredeterminated\" \nng-model=\"featureMeasurementUnit.isCheck\" ng-change=\"vm.validateSelectAllFeatureMeasurementUnit()\"></md-checkbox><span \nng-style=\"featureMeasurementUnit.isPredeterminated ? {\'font-weight\': \'bold\'} : {}\">\n{{featureMeasurementUnit.measurementUnit.name}} ({{featureMeasurementUnit.measurementUnit.code}}) {{featureMeasurementUnit.isPredeterminated ? \'feature.predeterminated\' : \'\' | translate}}\n</span></md-list-item></div></md-list></div><div flex=\"100\"><div layout=\"row\" layout-align=\"center center\"><md-button \naria-label=\"first page\" class=\"md-icon-button\" ng-click=\"vm.paginationFeatureMeasurementUnit.firstPage()\" \nng-disabled=\"vm.paginationFeatureMeasurementUnit.pageNumber === 1\"><md-tooltip md-direction=\"left\">\n{{\'user.first_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-double-left\"></md-icon></md-button>\n<md-button aria-label=\"before page\" class=\"md-icon-button\" ng-click=\"vm.paginationFeatureMeasurementUnit.beforePage()\" \nng-disabled=\"vm.paginationFeatureMeasurementUnit.pageNumber === 1\"><md-tooltip md-direction=\"left\">\n{{\'user.before_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button aria-label=\"next page\" class=\"md-icon-button\" ng-click=\"vm.paginationFeatureMeasurementUnit.nextPage()\" \nng-disabled=\"vm.paginationFeatureMeasurementUnit.totalPages === 0 || vm.paginationUserRole.pageNumber === vm.paginationUserRole.totalPages\">\n<md-tooltip md-direction=\"left\">{{\'user.next_page\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button><md-button aria-label=\"last page\" class=\"md-icon-button\" \nng-click=\"vm.paginationFeatureMeasurementUnit.lastPage()\" \nng-disabled=\"vm.paginationFeatureMeasurementUnit.totalPages === 0 || vm.paginationUserRole.pageNumber === vm.paginationUserRole.totalPages\">\n<md-tooltip md-direction=\"left\">{{\'user.last_page\'| translate}}</md-tooltip><md-icon \nmd-font-icon=\"icon-chevron-double-right\"></md-icon></md-button></div></div></div></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/product/feature/feature-values/feature-values.html","<md-dialog aria-label=\"Crear-Editar\" class=\"custom-md-dialog-height\" style=\"width: 40%; height: 95%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>{{\'feature.values\' | translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content style=\"padding: 5px 24px 24px 24px\"><div layout-xl=\"row\" layout-lg=\"row\" \nlayout-align-lg=\"space-around center\" layout-md=\"row\" layout-align-md=\"space-around center\"><div flex-xl=\"100\" \nflex-lg=\"100\" ng-show=\"vm.indexView === 0\"><md-list \nstyle=\"border-top: 1px solid #D8D8D8; border-bottom: 1px solid #D8D8D8; border-right: 1px solid #D8D8D8; border-left: 1px solid #D8D8D8\">\n<md-subheader class=\"md-no-sticky\">{{\'feature.values\' | translate}} ({{vm.featureValuesArray.length}})</md-subheader>\n<md-list-item style=\"border-top: 1px solid #D8D8D8\" ng-repeat=\"featureValue in vm.featureValuesArray\"><span>\n{{featureValue.featureValue}}</span><md-checkbox ng-if=\"featureValue.active\" class=\"md-secondary\" \nng-model=\"featureValue.active\" ng-change=\"vm.changeActive(featureValue)\"></md-checkbox><md-icon \nng-if=\"!featureValue.active\" class=\"md-secondary\" md-font-icon=\"icon-close\"></md-icon><md-button \nng-click=\"vm.edit(featureValue)\" class=\"md-secondary md-icon-button\"><md-icon style=\"color: rgb(3,155,229)\" \nmd-font-icon=\"icon-border-color\"></md-icon></md-button></md-list-item></md-list></div><div flex-xl=\"60\" flex-lg=\"60\" \nng-show=\"vm.indexView === 1\"><ng-form name=\"vm.featureValueForm\"><div layout=\"row\"><md-input-container flex=\"100\">\n<label>{{\'feature.value\' | translate}}</label><input type=\"text\" ng-model=\"vm.featureValue.featureValue\" \nname=\"featureValue\" required><div ng-messages=\"vm.featureValueForm.featureValue.$error\"><div ng-message=\"required\">\n{{\'general.field_required\' | translate}}</div></div></md-input-container></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.featureValue.id\" ng-model=\"vm.featureValue.active\">{{\'general.active\' | translate}}</md-checkbox>\n</div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" ng-click=\"vm.save()\">\n{{\'general.save\' | translate}}</md-button></div></ng-form></div></div><md-button ng-show=\"vm.indexView === 0\" \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.add()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/product/consultProducts/content/content.html","<div class=\"content-wrapper\" layout=\"row\" flex><div id=\"parametersProductList\" class=\"content\" \nng-include=\"\'app/main/apps/product/consultProducts/content/product-list.html\'\" ms-scroll flex=\"50\"></div><div \nclass=\"content\" ng-include=\"\'app/main/apps/product/consultProducts/content/product-parameter.html\'\" ms-scroll \nflex=\"50\"></div></div>");
$templateCache.put("app/main/apps/product/consultProducts/content/product-list.html","<div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.selectProduct(product)\" class=\"item\" \nng-class=\"{\'selected\': vm.selectedProduct.id === product.id}\" ng-repeat=\"product in vm.productos.content\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div><div class=\"notes\" layout=\"column\"><span>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}} ({{\'CREATE.TYPES.\' + product.type| translate}})\n</span> <span ng-if=\"product.brand\"><strong>{{\'CREATE.BRAND\'| translate}}: </strong>{{product.brand.name}}</span> <span\n ng-if=\"product.measurementUnit\"><strong>{{\'CREATE.MEASURE\'| translate}}: </strong>{{product.measurementUnit.name}}\n</span></div></div></div><div ng-if=\"vm.selectedProduct.id === product.id\" class=\"label md-green-300-bg\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loading\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span class=\"loading-data\">{{\'department.charging_products\'| translate}}...</span></div><div \nlayout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" total=\"vm.productos.totalElements\">\n</div></div>");
$templateCache.put("app/main/apps/product/consultProducts/content/product-parameter.html","<div ng-style=\"vm.dinamicHeight\" ng-show=\"vm.loadingParameters\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"loading-data\">\n{{vm.messageOnLoadParameter}}...</span></div><md-card style=\"margin-top: 0px\" \nng-show=\"!vm.loadingParameters && vm.selectedProduct\" id=\"productParameter\" \nclass=\"card-content productParameterDetail\" layout=\"column\" ng-show=\"vm.selectedProduct\"><div \nclass=\"parameters-header\" layout=\"row\" layout-align=\"start center\" layout-xs=\"column\"><div flex=\"80\" layout=\"row\" \nlayout-align=\"start center\"><h4>{{vm.selectedProduct.name}}</h4><div layout=\"row\" layout-align=\"center center\" \nng-class=\"{\'label-validated-product\': vm.productCompanyAddons.validated, \'label-no-validated-product\': !vm.productCompanyAddons.validated}\">\n<span>\n{{vm.productCompanyAddons.validated ? \'product_parameters.product_validated\' : \'product_parameters.product_no_validated\'| translate}}\n</span></div></div></div><div class=\"parameters-content\" layout=\"column\"><md-tabs ng-style=\"vm.dinamicMinHeight\" \nclass=\"md-accent\" md-selected=\"data.selectedIndex\" md-align-tabs=\"{{\'bottom\'}}\"><md-tab id=\"tab1\"><md-tab-label>\n<md-icon md-font-icon=\"icon-drag-horizontal\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'menu.parameters_product\'| translate}}</md-tooltip></md-tab-label><md-tab-body><ng-form name=\"vm.parameterForm\"><div \nlayout=\"row\" layout-xs=\"column\"><md-checkbox ng-disabled=\"true\" ng-model=\"vm.productCompanyAddons.isConsignment\">\n{{\'product_parameters.is_consignment\'| translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-disabled=\"true\" ng-model=\"vm.productCompanyAddons.generateReposition\">\n{{\'product_parameters.generateReposition\'| translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-disabled=\"true\" ng-model=\"vm.productCompanyAddons.onlyReceivePOS\">\n{{\'product_parameters.only_receive_pos\'| translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-disabled=\"true\" ng-model=\"vm.productCompanyAddons.canReQuote\">{{\'product_parameters.can_requote\'| translate}}\n</md-checkbox></div><fieldset class=\"standard\"><legend>{{\'product_parameters.productGroup\'| translate}}</legend><div \nflex layout-wrap layout-gt-sm=\"row\"><md-input-container flex-gt-xs><label translate=\"product_parameters.productGroup\">\nGrupo de Producto</label><md-select ng-model=\"vm.productCompanyAddons.productCompanyGroup.id\" name=\"productGroup\" \nng-disabled=\"true\"><md-optgroup label=\"pgroups\"><md-option value=\"{{pgroup.id}}\" \nng-repeat=\"pgroup in vm.productCompanyGroup\">{{pgroup.groupCode}} - {{pgroup.groupName}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProductCompanyGroups\"></md-progress-linear>\n</md-input-container></div></fieldset><fieldset class=\"standard\"><legend>\n{{\'product_parameters.fixed_asset\'| translate}}</legend><div layout-wrap layout-gt-sm=\"row\"><div layout=\"row\">\n<md-checkbox ng-disabled=\"true\" ng-model=\"vm.productCompanyAddons.fixedAsset\">\n{{\"product_parameters.fixed_asset\"| translate}}</md-checkbox></div></div><div layout=\"row\" \nng-if=\"vm.productCompanyAddons.fixedAsset\"><md-input-container flex=\"100\" ng-disabled=\"true\"><label \ntranslate=\"product_parameters.group_fixed_asset\"></label><md-autocomplete ng-disabled=\"true\" md-input-name=\"group\" \nng-required=\"true\" md-no-cache=\"true\" md-require-match md-min-length=\"0\" \nplaceholder=\"{{\'product_parameters.select_group\'| translate}}\" md-selected-item=\"vm.group\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.fixedAssetGroupName\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.fixedAssetGroupName}}</span></md-item-template><md-not-found><span \ntranslate=\"product_parameter.no_results\">No se enconraron coincidencias para </span>\"{{vm.searchText}}\".</md-not-found>\n</md-autocomplete><div ng-messages=\"vm.parameterForm.group.$error\"><div ng-message=\"required\" \ntranslate=\"error.field_required\">The field is required!</div></div></md-input-container></div></fieldset><fieldset \nclass=\"standard\"><legend>{{\'product_parameters.taxes\'| translate}}</legend><div layout-wrap layout-gt-sm=\"row\"><div \nflex-gt-sm=\"50\"><md-checkbox ng-disabled=\"true\" ng-model=\"vm.productCompanyAddons.isExento\">\n{{\'product_parameters.isExento\'| translate}}</md-checkbox></div></div><div flex layout-wrap layout-gt-sm=\"row\" \nng-show=\"!vm.productCompanyAddons.isExento\"><md-input-container flex-gt-xs><label \ntranslate=\"product_parameters.taxesGroup\">Grupo de Impuestos</label><md-select ng-disabled=\"true\" \nng-model=\"vm.productCompanyAddons.productGroupForTaxes.id\" name=\"department\" \nmd-on-close=\"vm.clearSearchProductGroup()\"><md-select-header><input id=\"searchProductGroup\" \nng-model=\"vm.searchProductGroup\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\"></md-select-header>\n<md-optgroup label=\"groups\"><md-option value=\"{{depto.id}}\" \nng-repeat=\"depto in vm.taxesGroup| filter:vm.searchProductGroup\">{{depto.productGroupName}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-show=\"vm.loadingProductGroups\"></md-progress-linear>\n</md-input-container></div></fieldset><fieldset class=\"standard\"><legend>\n{{\'product_parameters.erpParameters\'| translate}}</legend><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"md-icon-float md-block\"><label>{{\'product_parameters.productCodeERP\'| translate}}</label><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"name\" \nng-click=\"vm.customText.show.productcodeerp = !vm.customText.show.productcodeerp\"><md-tooltip md-direction=\"top\">\n{{vm.customText.productcodeerp}}</md-tooltip></md-icon><input ng-disabled=\"true\" type=\"text\" \nng-model=\"vm.productCompanyAddons.productCodeERP\"></md-input-container><md-input-container flex=\"50\"><label \nclass=\"label-help\" ng-show=\"vm.customText.show.productcodeerp\">{{vm.customText.productcodeerp}}</label>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" class=\"md-icon-float md-block\"><label>\n{{\'product_parameters.erp_code2\'| translate}}</label><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \nng-click=\"vm.customText.show.productcodeerp2 = !vm.customText.show.productcodeerp2\"><md-tooltip md-direction=\"top\">\n{{vm.customText.productcodeerp2}}</md-tooltip></md-icon><input ng-disabled=\"true\" type=\"text\" \nng-model=\"vm.productCompanyAddons.productCodeERP2\"></md-input-container><md-input-container flex=\"50\"><label \nclass=\"label-help\" ng-show=\"vm.customText.show.productcodeerp2\">{{vm.customText.productcodeerp2}}</label>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" class=\"md-icon-float md-block\"><label>\n{{\'product_parameters.erp_code3\'| translate}}</label><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \nng-click=\"vm.customText.show.productcodeerp3 = !vm.customText.show.productcodeerp3\"><md-tooltip md-direction=\"top\">\n{{vm.customText.productcodeerp3}}</md-tooltip></md-icon><input ng-disabled=\"true\" type=\"text\" \nng-model=\"vm.productCompanyAddons.productCodeERP3\"></md-input-container><md-input-container flex=\"50\"><label \nclass=\"label-help\" ng-show=\"vm.customText.show.productcodeerp3\">{{vm.customText.productcodeerp3}}</label>\n</md-input-container></div></fieldset><fieldset class=\"standard\"><legend>\n{{\'product_parameters.accountingType\'| translate}}</legend><div layout=\"row\"><md-input-container flex \nng-disabled=\"true\"><label>{{\'product_parameters.accountingType\'| translate}}</label><md-select ng-disabled=\"true\" \nng-model=\"vm.productCompanyAddons.accountingType\" name=\"accountingtype\"><md-option value=\"NA\">\n{{\'product_parameters.accountingType.NA\'| translate}}</md-option><md-option value=\"PRODUCT\">\n{{\'product_parameters.accountingType.PRODUCT\'| translate}}</md-option><md-option value=\"GROUP\">\n{{\'product_parameters.accountingType.GROUP\'| translate}}</md-option></md-select></md-input-container></div></fieldset>\n</ng-form></md-tab-body></md-tab><md-tab id=\"tab2\"><md-tab-label><md-icon md-font-icon=\"icon-archive\"></md-icon>\n<md-tooltip md-direction=\"top\">{{\'productAccount.title\'| translate}}</md-tooltip></md-tab-label><md-tab-body><ms-widget\n flippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div id=\"groupsGrid\" ag-grid=\"vm.grid\" \nclass=\"ag-fresh\" ng-style=\"vm.gridDinamicHeight\"></div></ms-widget-front></ms-widget></md-tab-body></md-tab><md-tab \nid=\"tab3\"><md-tab-label><md-icon md-font-icon=\"icon-currency-usd\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'menu.pre_negotiated_price\'| translate}}</md-tooltip></md-tab-label><md-tab-body><ng-form \nname=\"vm.consultProductForm\"><fieldset class=\"standard\"><legend>{{\'menu.pre_negotiated_price\'| translate}}</legend>\n<md-card style=\"margin-top: 0px\" ng-show=\"!vm.loadingPreNegociatedPrice && vm.selectedProduct\" \nid=\"productPreNegociatedPrice\" class=\"card-content productPreNegociatedPriceDetail\" layout=\"column\" \nng-show=\"vm.selectedProduct\"><div class=\"prenegociated-content\" layout=\"column\"><ng-form \nname=\"vm.preNegociatedPriceForm\"><div ng-repeat=\"row in vm.productCompanyBuys\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" \nstyle=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span class=\"title grey-50-bg\"><strong>\n{{\"company.provider\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{row.productSale.company.name + (row.productSale.company.businessName ? \" (\" + row.productSale.company.businessName + \")\" : \"\")}}\n</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label \ntranslate=\"pre-negotiated_price.start_date\">FechaInicio:</label></strong></div><div flex=\"70\"><span>\n{{row.startDate| date: \'dd-MM-yyyy\'}}</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\">\n<div flex=\"30\"><strong><label translate=\"pre-negotiated_price.end_date\">FechaFin:</label></strong></div><div flex=\"70\">\n<span>{{row.endDate| date: \'dd-MM-yyyy\'}}</span></div></div><div layout=\"row\" layout-xs=\"column\" \nstyle=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.days\">Días para entrega:\n</label></strong></div><div flex=\"70\"><span>{{row.daysForDelivery}}</span></div></div><div layout=\"row\" \nlayout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.currency\">\nMoneda:</label></strong></div><div flex=\"70\"><span>{{row.currency.description}}</span></div></div><div layout=\"row\" \nlayout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.price\">\nPrecio:</label></strong></div><div flex=\"50\"><span>\n{{row.currency.symbol + \". \" + row.price + \" (\" + (row.taxesIncluded === true ? \"pre-negotiated_price.with_taxes\" : \"pre-negotiated_price.without_taxes\" | translate) + \")\"}}\n</span></div></div></ms-widget-front></ms-widget></div></ng-form></div></md-card></fieldset></ng-form></md-tab-body>\n</md-tab><md-tab id=\"tab4\"><md-tab-label><md-icon md-font-icon=\"icon-blur-linear\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\'menu.detailsProducts\'| translate}}</md-tooltip></md-tab-label><md-tab-body><ng-form \nname=\"vm.consultProductForm\"><fieldset class=\"standard\"><legend>{{\'product_parameters.productCompanySale\'| translate}}\n</legend><div class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptions\" ag-grid=\"vm.masterGridOptions\" \nclass=\"ag-fresh\" expand-grid min=\"160\" other=\"200\"></div></div></fieldset></ng-form></md-tab-body></md-tab><md-tab \nid=\"tab5\"><md-tab-label><md-icon md-font-icon=\"icon-document\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'department.departments\'| translate}}</md-tooltip></md-tab-label><md-tab-body><ng-form \nname=\"vm.consultDepartmentForm\"><fieldset class=\"standard\"><legend>{{\'department.departments\'| translate}}</legend><div\n class=\"content fullpage-datatable\" layout=\"column\" flex><md-progress-linear md-mode=\"indeterminate\" \nng-show=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div id=\"masterGridOptionsDepartments\" \nag-grid=\"vm.masterGridOptionsDepartments\" class=\"ag-fresh\" expand-grid min=\"160\" other=\"200\"></div></div></fieldset>\n</ng-form></md-tab-body></md-tab><md-tab id=\"tab6\"><md-tab-label><md-icon md-font-icon=\"icon-tag\"></md-icon><md-tooltip\n md-direction=\"top\">{{\'menu.tags\'| translate}}</md-tooltip></md-tab-label><md-tab-body><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: 20px; display: block; position: relative\"><div \nlayout-align=\"start-center\" class=\"badge white-fg ng-binding ng-scope\" \nstyle=\"background: silver; float: left; margin: 3px; margin-top: 3px\" ng-repeat=\"row in vm.productCompanyAddonsTags\">\n<span style=\"font-size: 20px\">{{row.productCompanyTags.productTagValue}}</span></div></div></md-tab-body></md-tab>\n</md-tabs></div></md-card>");
$templateCache.put("app/main/apps/product/parameters/content/content.html","<div class=\"content-wrapper\" layout=\"row\" flex><div id=\"parametersProductList\" class=\"content\" \nng-include=\"\'app/main/apps/product/parameters/content/product-list.html\'\" ms-scroll flex=\"50\"></div><div \nclass=\"content\" ng-include=\"\'app/main/apps/product/parameters/content/product-parameter.html\'\" ms-scroll flex=\"50\">\n</div></div>");
$templateCache.put("app/main/apps/product/parameters/content/product-list.html","<div class=\"only-not-validated\" layout-align=\"space-between center\" layout-md=\"column\" layout-sm=\"column\" \nlayout-xs=\"column\" layout=\"row\" flex><div layout-sm=\"column\" layout-xs=\"column\" layout=\"row\" flex><md-switch \naria-label=\"filter no validated products\" ng-model=\"vm.onlyNotValidated\" ng-change=\"vm.getProducts(1)\"><span \ntranslate=\"product_parameters.filter_no_validated\">Filtrar productos no validados</span></md-switch><md-switch \naria-label=\"filter no validated products\" ng-model=\"vm.batchUpdate\" ng-change=\"vm.changeBatch()\"><span \ntranslate=\"product_parameters.batch_update\">Actualización Masiva</span></md-switch></div><span \nng-if=\"vm.batchUpdate && vm.productos.totalElements\"><b>Total: {{vm.productos.totalElements}}</b></span></div><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.selectProduct(product)\" class=\"item\" \nng-class=\"{\'selected\': vm.selectedProduct.id === product.id}\" ng-repeat=\"product in vm.productos.content\"><div flex \nlayout=\"row\" layout-align=\"start center\" ng-class=\"{\'repeted-product\': product.repeated}\"><div><div class=\"notes\" \nlayout=\"column\"><span>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}} ({{\'CREATE.TYPES.\' + product.type| translate}})\n</span> <span ng-if=\"product.brand\"><b>{{\'CREATE.BRAND\'| translate}}: </b>{{product.brand.name}}</span> <span \nng-if=\"product.measurementUnit\"><b>{{\'CREATE.MEASURE\'| translate}}: </b>{{product.measurementUnit.name}}</span></div>\n</div></div><div ng-if=\"vm.selectedProduct.id === product.id\" class=\"label md-green-300-bg\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loading\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span class=\"loading-data\">{{\'department.charging_products\'| translate}}...</span></div><center>\n<div ng-if=\"!vm.batchUpdate\" paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" total=\"vm.productos.totalElements\">\n</div></center>");
$templateCache.put("app/main/apps/product/parameters/content/product-parameter.html","<div style=\"height: 40px\"></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadingParameters\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span class=\"loading-data\">{{vm.messageOnLoadParameter}}...</span></div><md-card style=\"margin-top: 0px\" \nng-if=\"!vm.loadingParameters && vm.selectedProduct\" id=\"productParameter\" class=\"card-content productParameterDetail\" \nlayout=\"column\" ng-if=\"vm.selectedProduct\"><div class=\"parameters-header\" layout=\"row\" layout-align=\"start center\" \nlayout-xs=\"column\"><div flex=\"50\" layout=\"row\" layout-align=\"start center\"><h4>{{vm.selectedProduct.name}}</h4><div \nlayout=\"row\" layout-align=\"center center\" \nng-class=\"{\'label-validated-product\': vm.productCompanyAddons.validated, \'label-no-validated-product\': !vm.productCompanyAddons.validated}\">\n<span>\n{{vm.productCompanyAddons.validated ? \'product_parameters.product_validated\' : \'product_parameters.product_no_validated\'| translate}}\n</span></div></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-switch ng-if=\"vm.batchUpdate\" \nng-model=\"vm.saveInBatch\" aria-label=\"Validated product\"><span translate=\"product_parameters.saveInBatch\">\nActualizar todos</span></md-switch><md-switch ng-change=\"vm.save()\" ng-model=\"vm.productCompanyAddons.validated\" \nng-disabled=\"vm.parameterForm.$invalid\" aria-label=\"Validated product\"><span translate=\"product_parameters.validado\">\nValidado</span></md-switch></div></div><div class=\"parameters-content\" layout=\"column\"><md-tabs \nng-style=\"vm.dinamicMinHeight\" class=\"md-accent\" md-selected=\"data.selectedIndex\" md-align-tabs=\"{{\'bottom\'}}\"><md-tab \nid=\"tab1\"><md-tab-label><md-icon md-font-icon=\"icon-drag-horizontal\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'menu.parameters_product\'| translate}}</md-tooltip></md-tab-label><md-tab-body><ng-form name=\"vm.parameterForm\"><div \nlayout=\"row\" layout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.isConsignment\" \nng-change=\"vm.validateChecksIsActive(\'isConsignment\')\">{{\'product_parameters.is_consignment\'| translate}}</md-checkbox>\n</div><div layout=\"row\" layout-align=\"start center\"><md-checkbox ng-change=\"vm.addRepositionDays()\" \nng-model=\"vm.productCompanyAddons.generateReposition\">{{\'product_parameters.generateReposition\'| translate}}\n</md-checkbox><md-button class=\"md-icon-button mb-5\" ng-click=\"vm.addRepositionDays()\" \nng-if=\"vm.productCompanyAddons.generateReposition\"><md-icon class=\"s16\" md-font-icon=\"icon-border-color\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\"general.edit\"| translate}}</md-tooltip></md-button></div><div layout=\"row\" \nlayout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.onlyReceivePOS\">\n{{\'product_parameters.only_receive_pos\'| translate}}</md-checkbox></div><div layout=\"row\" layout-xs=\"column\">\n<md-checkbox ng-model=\"vm.productCompanyAddons.canReQuote\">{{\'product_parameters.can_requote\'| translate}}\n</md-checkbox></div><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"40\" \nclass=\"md-icon-float md-block\"><label>{{\'product_parameters.min\'| translate}}</label><input type=\"number\" \nng-model=\"vm.productCompanyAddons.min\" min=\"0\" autocomplete=\"off\"></md-input-container><md-input-container flex=\"40\" \nclass=\"md-icon-float md-block\"><label>{{\'product_parameters.max\'| translate}}</label><input type=\"number\" \nng-model=\"vm.productCompanyAddons.max\" min=\"0\" autocomplete=\"off\"></md-input-container></div><fieldset \nclass=\"standard\"><legend>{{\'product_parameters.productGroup\'| translate}}</legend><div flex layout-wrap \nlayout-gt-sm=\"row\"><md-input-container flex-gt-xs><label translate=\"product_parameters.productGroup\">Grupo de Producto\n</label><md-select ng-model=\"vm.productCompanyAddons.productCompanyGroup.groupCode\" name=\"productGroup\" \nmd-on-close=\"vm.clearSearchProductCompanyGroup()\"><md-select-header><input id=\"searchProductCompanyGroup\" \nng-model=\"vm.searchProductCompanyGroup\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\"></md-select-header>\n<md-optgroup label=\"pgroups\"><md-option value=\"{{pgroup.groupCode}}\" \nng-repeat=\"pgroup in vm.productCompanyGroup| filter:vm.searchProductCompanyGroup\">\n{{pgroup.groupCode}} - {{pgroup.groupName}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingProductCompanyGroups\"></md-progress-linear></md-input-container>\n<md-input-container flex=\"10\" ng-if=\"vm.productCompanyAddons.productCompanyGroup\"><md-button class=\"md-icon-button\" \nng-click=\"vm.productCompanyAddons.productCompanyGroup = null\"><md-icon md-font-icon=\"icon-broom\" class=\"md-warn\">\n</md-icon><md-tooltip md-direction=\"top\">{{\"general.delete\"| translate}}</md-tooltip></md-button></md-input-container>\n</div></fieldset><fieldset class=\"standard\"><legend>{{\'product_parameters.fixed_asset\'| translate}}</legend><div \nlayout-wrap layout-gt-sm=\"row\"><div layout=\"row\"><md-checkbox ng-model=\"vm.productCompanyAddons.fixedAsset\">\n{{\"product_parameters.fixed_asset\"| translate}}</md-checkbox></div></div><div layout=\"row\" \nng-if=\"vm.productCompanyAddons.fixedAsset\"><md-input-container flex=\"100\"><label \ntranslate=\"product_parameters.group_fixed_asset\"></label><md-autocomplete md-input-name=\"group\" ng-required=\"true\" \nmd-no-cache=\"true\" md-require-match md-min-length=\"0\" placeholder=\"{{\'product_parameters.select_group\'| translate}}\" \nmd-selected-item=\"vm.group\" md-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" \nmd-item-text=\"item.fixedAssetGroupName\"><md-item-template><span md-highlight-text=\"vm.searchText\" \nmd-highlight-flags=\"^i\">{{item.fixedAssetGroupName}}</span></md-item-template><md-not-found><span \ntranslate=\"product_parameter.no_results\">No se enconraron coincidencias para </span>\"{{vm.searchText}}\".</md-not-found>\n</md-autocomplete><div ng-messages=\"vm.parameterForm.group.$error\"><div ng-message=\"required\" \ntranslate=\"error.field_required\">The field is required!</div></div></md-input-container></div></fieldset><fieldset \nclass=\"standard\"><legend>{{\'product_parameters.taxes\'| translate}}</legend><div layout-wrap layout-gt-sm=\"row\"><div \nflex-gt-sm=\"50\"><md-checkbox ng-model=\"vm.productCompanyAddons.isExento\">{{\'product_parameters.isExento\'| translate}}\n</md-checkbox></div></div><div flex layout-wrap layout-gt-sm=\"row\" ng-if=\"!vm.productCompanyAddons.isExento\">\n<md-input-container flex-gt-xs><label translate=\"product_parameters.taxesGroup\">Grupo de Impuestos</label><md-select \nng-model=\"vm.productCompanyAddons.productGroupForTaxes.id\" name=\"department\" \nmd-on-close=\"vm.clearSearchProductGroup()\"><md-select-header><input id=\"searchProductGroup\" \nng-model=\"vm.searchProductGroup\" type=\"search\" placeholder=\"{{\'general.search\'| translate}}\"></md-select-header>\n<md-optgroup label=\"groups\"><md-option value=\"{{depto.id}}\" \nng-repeat=\"depto in vm.taxesGroup| filter:vm.searchProductGroup\">{{depto.productGroupName}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProductGroups\"></md-progress-linear>\n</md-input-container><md-input-container flex=\"10\" ng-if=\"vm.productCompanyAddons.productGroupForTaxes\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.productCompanyAddons.productGroupForTaxes = null\"><md-icon \nmd-font-icon=\"icon-broom\" class=\"md-warn\"></md-icon><md-tooltip md-direction=\"top\">{{\"general.delete\"| translate}}\n</md-tooltip></md-button></md-input-container></div></fieldset><fieldset class=\"standard\"><legend>\n{{\'product_parameters.erpParameters\'| translate}}</legend><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"md-icon-float md-block\"><label>{{\'product_parameters.productCodeERP\'| translate}}</label><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"name\" \nng-click=\"vm.customText.show.productcodeerp = !vm.customText.show.productcodeerp\"><md-tooltip md-direction=\"top\">\n{{vm.customText.productcodeerp}}</md-tooltip></md-icon><input type=\"text\" \nng-model=\"vm.productCompanyAddons.productCodeERP\" ng-disabled=\"vm.batchUpdate\"></md-input-container><md-input-container\n flex=\"50\"><label class=\"label-help\" ng-if=\"vm.customText.show.productcodeerp\">{{vm.customText.productcodeerp}}</label>\n</md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" class=\"md-icon-float md-block\"><label>\n{{\'product_parameters.erp_code2\'| translate}}</label><md-icon md-font-icon=\"icon-help-circle\" class=\"name\" \nng-click=\"vm.customText.show.productcodeerp2 = !vm.customText.show.productcodeerp2\"><md-tooltip md-direction=\"top\">\n{{vm.customText.productcodeerp2}}</md-tooltip></md-icon><input type=\"text\" \nng-model=\"vm.productCompanyAddons.productCodeERP2\" ng-disabled=\"vm.batchUpdate\"></md-input-container>\n<md-input-container flex=\"50\"><label class=\"label-help\" ng-if=\"vm.customText.show.productcodeerp2\">\n{{vm.customText.productcodeerp2}}</label></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"md-icon-float md-block\"><label>{{\'product_parameters.erp_code3\'| translate}}</label><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"name\" \nng-click=\"vm.customText.show.productcodeerp3 = !vm.customText.show.productcodeerp3\"><md-tooltip md-direction=\"top\">\n{{vm.customText.productcodeerp3}}</md-tooltip></md-icon><input type=\"text\" \nng-model=\"vm.productCompanyAddons.productCodeERP3\" ng-disabled=\"vm.batchUpdate\"></md-input-container>\n<md-input-container flex=\"50\"><label class=\"label-help\" ng-if=\"vm.customText.show.productcodeerp3\">\n{{vm.customText.productcodeerp3}}</label></md-input-container></div></fieldset><fieldset class=\"standard\"><legend>\n{{\'product_parameters.accountingType\'| translate}}</legend><div layout=\"row\"><md-input-container flex><label>\n{{\'product_parameters.accountingType\'| translate}}</label><md-select ng-model=\"vm.productCompanyAddons.accountingType\" \nname=\"accountingtype\" required><md-option value=\"NA\">{{\'product_parameters.accountingType.NA\'| translate}}</md-option>\n<md-option value=\"PRODUCT\">{{\'product_parameters.accountingType.PRODUCT\'| translate}}</md-option><md-option \nvalue=\"GROUP\">{{\'product_parameters.accountingType.GROUP\'| translate}}</md-option></md-select></md-input-container>\n</div></fieldset><fieldset class=\"standard\"><legend>{{\'product_parameters.product_objective\'| translate}}</legend><div \nlayout=\"row\" layout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.isForSale\">\n{{\'product_parameters.for_sale\'| translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.productCompanyAddons.isForBuy\">{{\'product_parameters.for_buy\'| translate}}</md-checkbox></div></fieldset>\n<fieldset class=\"standard\"><legend>{{\'product_parameters.hide_product\'| translate}}</legend><div layout=\"row\" \nlayout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.isHideInPurchaseRequisition\">\n{{\'product_parameters.hide_in_purchase_requisition\'| translate}}</md-checkbox></div><div layout=\"row\" \nlayout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.hideInBudget\">\n{{\'product_parameters.hide_in_budget\'| translate}}</md-checkbox></div></fieldset><fieldset class=\"standard\"><legend>\n{{\'product_parameters.provider_invoice_before\'| translate}}</legend><div layout=\"row\" layout-xs=\"column\"><md-checkbox \nng-model=\"vm.productCompanyAddons.providerCanInvoiceBeforeReceive\" \nng-change=\"vm.validateChecksIsActive(\'providerCanInvoiceBeforeReceive\')\">\n{{\'product_parameters.provider_invoice_before_receive\'| translate}}</md-checkbox></div></fieldset><fieldset \nclass=\"standard\"><legend>{{\'product_parameters.compras_config\'| translate}}</legend><div layout=\"row\" \nlayout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.loadInventoryCompras\">\n{{\'product_parameters.load_inventory_compras\'| translate}}</md-checkbox></div><div layout=\"row\" layout-xs=\"column\">\n<md-checkbox ng-model=\"vm.productCompanyAddons.loadInventorySingleProduct\">\n{{\'product_parameters.load_inventory_compras_single_product\'| translate}}</md-checkbox></div><div layout=\"row\" \nlayout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.cancelOnReceivePos\">\n{{\'product_parameters.cancel_on_receive_pos\'| translate}}</md-checkbox></div><div flex layout-wrap layout-gt-sm=\"row\" \nng-if=\"vm.productCompanyAddons.loadInventorySingleProduct\"><md-input-container flex-gt-xs><label>\n{{\'product_parameters.inventory_product\'| translate}}</label><input type=\"number\" disabled=\"true\" \nng-model=\"vm.productCompanyAddons.inventoryProduct.id\" autocomplete=\"off\"></md-input-container><md-input-container \nflex=\"20\"><md-button class=\"md-icon-button\" \nng-click=\"vm.selectInventoryProduct($event, vm.productCompanyAddons.inventoryProduct)\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"md-accent\"></md-icon><md-tooltip md-direction=\"top\">\n{{\"product_parameters.select_inventory_product\"| translate}}</md-tooltip></md-button></md-input-container></div>\n</fieldset><div layout=\"row\" layout-align=\"center center\"><md-button ng-disabled=\"vm.parameterForm.$invalid\" \nng-click=\"vm.save(false)\" class=\"md-raised md-primary\">{{\'general.save\'| translate}}</md-button></div></ng-form>\n</md-tab-body></md-tab><md-tab id=\"tab2\" md-on-select=\"createCategoryTree(vm.categorySelected.id);\"><md-tab-label>\n<md-icon md-font-icon=\"icon-drawing-box\"></md-icon><md-tooltip md-direction=\"top\">{{\'menu.productType\'| translate}}\n</md-tooltip></md-tab-label><md-tab-body><fieldset class=\"standard\"><legend>{{\'menu.productType\'| translate}}</legend>\n<h3>\n{{(vm.productCompanyAddons.productType?vm.productCompanyAddons.productType.productTypeCode + \'-\' + vm.productCompanyAddons.productType.description:\'\')}}\n</h3><div layout=\"row\"><div id=\"sidenav-product\"><div ng-if=\"vm.categorySelected.id !== 0\"><a style=\"cursor: pointer\" \nng-click=\"vm.returnToAll();\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon><span class=\"sub-title\">\n{{\'PRODUCT.ALL_CATEGORY\'|translate}}</span></a><br><br></div><span class=\"h4\"><strong>\n{{vm.categorySelected.name| translate}}</strong></span><div id=\"tree\"></div></div></div></fieldset><div layout=\"row\" \nlayout-align=\"center center\"><md-button ng-disabled=\"vm.disableButtonSave\" ng-click=\"vm.saveProductType(false)\" \nclass=\"md-raised md-primary\">{{\'general.save\'| translate}}</md-button></div></md-tab-body></md-tab><md-tab id=\"tab3\">\n<md-tab-label><md-icon md-font-icon=\"icon-archive\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'productAccount.title\'| translate}}</md-tooltip></md-tab-label><md-tab-body><div id=\"groupsGrid\" ag-grid=\"vm.grid\" \nclass=\"ag-fresh\" ng-style=\"vm.gridDinamicHeight\"></div><md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"add\" \nstyle=\"position: fixed\" ng-show=\"vm.selectedProduct\" ng-click=\"vm.addAccount()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip></md-button></md-tab-body></md-tab>\n<md-tab id=\"tab4\"><md-tab-label><md-icon md-font-icon=\"icon-table-column-plus-after\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\'additional-field-value.title\'| translate}}</md-tooltip></md-tab-label><md-tab-body><div \nid=\"groupsGrid\" ag-grid=\"vm.gridFields\" class=\"ag-fresh\" ng-style=\"vm.gridDinamicHeight\"></div><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-show=\"vm.selectedProduct\" \nng-click=\"vm.addFieldValue()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.add\"| translate}}</md-tooltip></md-button></md-tab-body></md-tab></md-tabs></div></md-card>");
$templateCache.put("app/main/apps/product/product-group/product-group/product-group.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 30%; height: 70%\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.productCompanyGroup.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<ng-form name=\"vm.productCompanyGroupForm\" id=\"productCompanyGroupForm\"><div layout=\"row\"><md-input-container \nflex=\"100\"><label>{{\'productGroup.groupCode\' | translate}}</label><input type=\"text\" \nng-model=\"vm.productCompanyGroup.groupCode\" name=\"groupCode\" required><div \nng-messages=\"vm.productGroupForm.groupCode.$error\"><div ng-message=\"required\">{{\'general.field_required\' | translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'productGroup.groupName\' | translate}}</label><input type=\"text\" ng-model=\"vm.productCompanyGroup.groupName\" \nname=\"groupName\" required><div ng-messages=\"vm.productGroupForm.groupName.$error\"><div ng-message=\"required\">\n{{\'general.field_required\' | translate}}</div></div></md-input-container></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.productCompanyGroup.id\" ng-model=\"vm.productCompanyGroup.active\">{{\'general.active\' | translate}}\n</md-checkbox></div></ng-form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" \nng-disabled=\"vm.productCompanyGroupForm.$invalid\">{{\'general.save\'| translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/apps/product/product-group/product-group-accounting-catalog/product-group-accounting-catalog.html","<md-dialog id=\"dialogGroup\" aria-label=\"Crear-Editar\" class=\"custom-md-dialog-height\" style=\"width: 80%; height: 70%\">\n<ms-widget flippable=\"true\" layout=\"row\" style=\"padding: 12px; height: 100%\"><ms-widget-front class=\"white-bg\" \nms-scroll><md-toolbar class=\"md-primary md-tall md-toolbar-more\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.productGroupAccountingCatalog.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button \nclass=\"md-icon-button\" ng-click=\"vm.newAccount ? vm.flip() : vm.cancel()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><form ng-submit=\"vm.getAccounts(1)\" name=\"searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label style=\"color: white\">\n{{\'general.filter\'| translate}}</label><input style=\"color: white\" type=\"text\" ng-model=\"vm.filterAccount\" \nname=\"searchAccount\" ng-keyup=\"vm.changeFilter()\" id=\"searchAccount\"></md-input-container><md-button type=\"submit\" \naria-label=\"Search\"><span translate=\"general.search\">Search</span></md-button></div></form></div></div></md-toolbar>\n<md-progress-linear type=\"indeterminate\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content \nms-scroll style=\"padding: 0px\"><div layout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll style=\"max-height: 375px\"><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"account in vm.accounts.content\" ng-click=\"vm.selectAccount(account)\" \nng-class=\"{\'current-thread\':vm.selectedAccount.id === account.id}\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"title\">\n{{account.code ? account.code + \' - \' : \'\'}}{{account.description}} ({{account.levels}})</div><div class=\"notes\"></div>\n</div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectAccount.id === account.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" \nul-class=\"pagination\" hide-if-empty=\"true\" page-size=\"vm.pageSize\" paging-action=\"vm.getAccounts(page)\" \ntotal=\"vm.accounts.totalElements\"></div></div></div><div class=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular \nclass=\"ajax-loader md-accent md-hue-2\" md-mode=\"indeterminate\"></md-progress-circular></div></div></div>\n</md-dialog-content></ms-widget-front><ms-widget-back id=\"perms\" class=\"white-bg\"><div \nng-init=\"vm.flipping(flipWidget);\"></div><div class=\"page-layout carded fullwidth\" layout=\"column\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1 ng-show=\"vm.indexView === 1\">\n{{vm.productGroupAccountingCatalog.id ? \'general.edit\' : \'general.add\'| translate}}</h1><h1 \nng-show=\"vm.indexView === 0\">{{\'productGroup.accountingCatalog\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content \nstyle=\"padding: 5px 24px 24px 24px\"><div layout-xl=\"row\" layout-lg=\"row\" layout-align-lg=\"space-around center\" \nlayout-md=\"row\" layout-align-md=\"space-around center\"><div flex-xl=\"100\" flex-lg=\"100\" ng-show=\"vm.indexView === 0\">\n<div id=\"groupsGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" ng-style=\"vm.dinamicHeight\" ng-show=\"vm.showGrid\"></div></div>\n<div flex-xl=\"60\" flex-lg=\"60\" ng-show=\"vm.indexView === 1\"><ng-form name=\"vm.departmentGroupForm\"><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex><span>{{\'accountingCatalog.code\'| translate}}*</span><br><span>\n{{vm.productGroupAccountingCatalog.accountingCatalog.code}} - {{vm.productGroupAccountingCatalog.accountingCatalog.description}}\n</span></md-input-container><md-button class=\"md-icon-button\" ng-click=\"vm.onAccountingCatalog()\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon><md-tooltip md-direction=\"left\">{{\'general.edit\'| translate}}</md-tooltip>\n</md-button></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'accountingCatalog.accountType\'| translate}}</label><md-select \nng-model=\"vm.productGroupAccountingCatalog.accountType.id\" md-on-close=\"vm.clearSearchAccountType()\" required>\n<md-select-header><input id=\"searchAccountType\" ng-model=\"vm.searchAccountType\" type=\"search\" \nplaceholder=\"{{\'general.search\'| translate}}\"></md-select-header><md-optgroup><md-option ng-value=\"at.id\" \nng-repeat=\"at in vm.accountType| filter:vm.searchAccountType\">{{at.acTypeDescription}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.productGroupAccountingCatalog.id\" ng-model=\"vm.productGroupAccountingCatalog.active\">\n{{\'general.active\'| translate}}</md-checkbox></div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.onSave()\">{{\'general.save\'| translate}}</md-button></div></ng-form></div>\n</div></md-dialog-content><md-dialog-actions class=\"md-tall\"><md-button ng-show=\"vm.indexView === 0\" \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.onAdd()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button></md-dialog-actions></div></ms-widget-back></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/product/product-list/content/content.html","<div id=\"productGrid\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\" \nng-show=\"vm.showGrid\"></div>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/default-cost-center/default-cost-center.html","<md-dialog class=\"compose-dialog default-costcenter\" aria-label=\"Crear-Editar\" \nstyle=\"width: 40%; height: 90%; overflow: hidden\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'pre-negotiated_price.bycostcenter\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear type=\"indeterminate\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container flex=\"50\" \nng-disabled=\"true\"><label>{{\'pre-negotiated_price.costcenter\'| translate}}</label><md-select \nng-model=\"vm.costCenterSelected\" ng-change=\"vm.loadProductBuysCC(vm.costCenterSelected)\" required name=\"cc\">\n<md-optgroup><md-option ng-value=\"c.id\" ng-repeat=\"c in vm.costCenters\">{{c.description}}</md-option></md-optgroup>\n</md-select></md-input-container><div class=\"custom-list\" ng-if=\"!vm.loadingCostCenter\"><div \nng-style=\"vm.dinamicHeight\" ms-scroll><div class=\"item\" ng-repeat=\"row in vm.productCompanyBuysCC\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\"><ms-widget-front \nclass=\"white-bg\"><div layout=\"column\" style=\"padding-left: 8px\" ng-class=\"{\'md-green-100-bg\': row.isDefaultCC}\"><div \nng-if=\"row.isDefaultCC\" class=\"label\"><md-icon md-font-icon=\"icon-check-all\" class=\"icon-esp\"></md-icon></div><div \nlayout=\"row\" layout-xs=\"column\" class=\"p-6\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span \nclass=\"title\"><strong>{{\"company.provider\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{row.productSale.company.name + (row.productSale.company.businessName ? \" (\" + row.productSale.company.businessName + \")\" : \"\")}}\n</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label \ntranslate=\"pre-negotiated_price.start_date\">FechaInicio:</label></strong></div><div flex=\"70\"><span>\n{{row.startDate| date: \'dd-MM-yyyy\'}}</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\">\n<div flex=\"30\"><strong><label translate=\"pre-negotiated_price.end_date\">FechaFin:</label></strong></div><div flex=\"70\">\n<span>{{row.endDate| date: \'dd-MM-yyyy\'}}</span></div></div><div layout=\"row\" layout-xs=\"column\" \nstyle=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.days\">Días para entrega:\n</label></strong></div><div flex=\"70\"><span>{{row.daysForDelivery}}</span></div></div><div layout=\"row\" \nlayout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.currency\">\nMoneda:</label></strong></div><div flex=\"70\"><span>{{row.currency.description}}</span></div></div><div layout=\"row\" \nlayout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.price\">\nPrecio:</label></strong></div><div flex=\"70\"><span>\n{{row.currency.symbol + \". \" + row.price + \" (\" + (row.taxesIncluded === true ? \"pre-negotiated_price.with_taxes\" : \"pre-negotiated_price.without_taxes\" | translate) + \")\"}}\n</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\" layout-align=\"end center\"><div \nflex=\"10\" ng-if=\"!row.isDefaultCC\"><md-button class=\"md-icon-button\" ng-click=\"vm.changeDefault(row, $index)\"><md-icon \nmd-font-icon=\"icon-check-all\" class=\"icon-esp\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"pre-negotiated_price.makedefault\"| translate}}</md-tooltip></md-button></div></div></div></ms-widget-front>\n</ms-widget></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadingCostCenter\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n</div></div></div></md-dialog>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/editor/pre-negotiated-price.html","<md-dialog class=\"compose-dialog\" aria-label=\"Crear-Editar\" style=\"width: 60%; height: 90%\"><ms-widget \nflippable=\"true\" layout=\"row\" style=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.addProductSale === true ? (\'pre-negotiated_price.add_provider_to_product\' | translate) : (\'pre-negotiated_price.product_providers\' | translate) + vm.productCompanyBuy.productSale.product.name}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.newContact ? vm.flip() : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.visibleCompanies\"><div layout=\"column\" layout-align=\"center center\"><div><form \nng-submit=\"vm.addProductSale === true?vm.getAllCompanies(1):vm.getProductSales(1)\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label class=\"md-primary\" \ntranslate=\"general.filter\">Filtro</label><input type=\"text\" ng-model=\"vm.filterProvider\" name=\"search\" \nng-keyup=\"vm.changeFilter()\" id=\"searchFilter\"></md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span \ntranslate=\"general.search\">Search</span></md-button></div></form></div></div></div></md-toolbar><md-progress-linear \ntype=\"indeterminate\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll \nstyle=\"padding: 0px\"><div layout=\"column\" class=\"p-16\" style=\"padding: 0px\" ng-if=\"vm.visibleCompanies\"><div \nid=\"e-commerce-product\" class=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\" \nng-if=\"vm.addProductSale\"><div class=\"content thread-list\" ms-scroll><div class=\"thread\" md-ink-ripple \nng-if=\"!vm.loading\" ng-repeat=\"company in vm.companies.content\" ng-click=\"vm.selectItem(company)\" \nng-class=\"{\n                                             \'current-thread\':vm.selectedCompany.id === company.id}\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"title\">\n{{company.name + (company.businessName?\" (\" + company.businessName + \")\":\"\")}}</div><div class=\"notes\"></div></div>\n</div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectedCompany.id === company.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><center><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" \nhide-if-empty=\"true\" paging-action=\"vm.getAllCompanies(page)\" total=\"vm.companies.totalElements\"></div></center></div>\n<div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\" \nng-if=\"!vm.addProductSale\"><div class=\"content thread-list\" ms-scroll><div class=\"thread\" md-ink-ripple \nng-if=\"!vm.loading\" ng-repeat=\"productSale in vm.productSales.content\" ng-click=\"vm.selectItem(productSale)\" \nng-class=\"{\n                                             \'current-thread\':vm.selectedProductSale.company.id === productSale.id}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"title\">\n{{productSale.name + (productSale.businessName?\" (\" + productSale.businessName + \")\":\"\")}}</div><div class=\"notes\">\n</div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectedProductSale.company.id === productSale.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div>\n</div></div></div></div><center><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProductSales(page)\" \ntotal=\"vm.productSales.totalElements\"></div></center></div><center \nng-if=\"vm.addProductSale === true?!vm.companies.content.length > 0 && !vm.loading : !vm.productSales.content.length > 0 && !vm.loading\">\n<span class=\"title\">{{\'pre-negotiated_price.not_found_search\'| translate}} \"{{vm.filterProvider}}\"</span><br><a \nng-click=\"vm.selectProviderToAdd(!vm.addProductSale)\" ng-if=\"!vm.addProductSale\">\n{{\'pre-negotiated_price.search_all_providers\'| translate}}</a></center><center><div class=\"div-loader\" \nng-show=\"vm.loading\"><md-progress-circular class=\"ajax-loader md-accent md-hue-2\" md-mode=\"indeterminate\">\n</md-progress-circular></div></center></div></div></md-dialog-content></ms-widget-front><ms-widget-back id=\"perms\" \nclass=\"white-bg\" ms-scroll><div ng-init=\"vm.flipping(flipWidget);\"></div><div class=\"page-layout carded fullwidth\" \nlayout=\"column\"><md-toolbar class=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.productCompanyBuy.id ? \'general.edit\' : \'general.add\'| translate}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Close\" translate translate-attr-aria-label=\"general.close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"center\" layout=\"column\" flex><div \nclass=\"md-dialog-content\" ms-scroll><form name=\"vm.productBuyForm\" id=\"productBuyForm\" ng-submit=\"vm.save()\"><div \nlayout=\"row\"><div flex=\"30\"><strong><label translate=\"company.provider\">Proveedor:</label></strong></div><div \nflex=\"70\"><span required>\n{{vm.productCompanyBuy.productSale.company.name + (vm.productCompanyBuy.productSale.company.businessName?\" (\" + vm.productCompanyBuy.productSale.company.businessName + \")\":\"\")}}\n</span></div><md-button class=\"md-icon-button\" ng-click=\"vm.onEdit()\" ng-disabled=\"vm.productCompanyBuy.id\"><md-icon \nmd-font-icon=\"{{vm.productCompanyBuy.productSale && vm.productCompanyBuy.productSale.company?\'icon-border-color\':\'icon-plus\'}}\">\n</md-icon><md-tooltip md-direction=\"left\">\n{{vm.productCompanyBuy.productSale && vm.productCompanyBuy.productSale.company?\"general.edit\":\"general.add\"| translate}}\n</md-tooltip></md-button></div><div layout=\"row\"><md-input-container flex=\"50\" ng-disabled=\"true\"><label>\n{{\'pre-negotiated_price.currency\'| translate}}</label><md-select ng-model=\"vm.productCompanyBuy.currency.id\" required \nname=\"currency\" ng-disabled=\"true\"><md-optgroup><md-option ng-value=\"c.id\" ng-repeat=\"c in vm.currencies\">\n{{c.description}}</md-option></md-optgroup></md-select><div ng-messages=\"vm.productBuyForm.currency.$error\"><div \nng-message=\"required\" translate=\"error.field_required\">This field is required!</div></div></md-input-container>\n<md-input-container flex=\"25\"><label translate=\"pre-negotiated_price.price\">Price</label><input \nng-model=\"vm.productCompanyBuy.price\" type=\"number\" name=\"price\" required min=\"0.1\" max=\"vm.productCompanyBuy.price+1\" \nstyle=\"text-align: right\"><div ng-messages=\"vm.productBuyForm.price.$error\"><div ng-message=\"required\" \ntranslate=\"error.field_required\">The field is required!</div></div></md-input-container><md-input-container flex=\"25\" \nstyle=\"text-align: center\"><md-checkbox ng-model=\"vm.productCompanyBuy.taxesIncluded\" aria-label=\"Checkbox 1\" \nstyle=\"max-width: 100px\">{{\'pre-negotiated_price.taxes_included\'| translate}}</md-checkbox></md-input-container></div>\n<div layout=\"row\"><md-input-container flex=\"40\"><label translate=\"pre-negotiated_price.start_date\">Fecha de inicio\n</label><md-datepicker type=\"date\" ng-model=\"vm.productCompanyBuy.startDate\" name=\"startDate\" md-open-on-focus \nmd-max-date=\"vm.productCompanyBuy.endDate\" md-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div \nng-messages=\"vm.productBuyForm.startDate.$error\"><div ng-message=\"valid\" translate=\"error.invalid_date\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"error.field_required\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div>\n</md-input-container><md-input-container flex=\"40\"><label translate=\"pre-negotiated_price.end_date\">Fecha fin</label>\n<md-datepicker type=\"date\" ng-model=\"vm.productCompanyBuy.endDate\" name=\"endDate\" md-open-on-focus \nmd-min-date=\"vm.productCompanyBuy.startDate && vm.productCompanyBuy.startDate > vm.minDate? vm.productCompanyBuy.startDate:vm.minDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.productBuyForm.endDate.$error\"><div \nng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"error.field_required\">This date is required!</div><div ng-message=\"mindate\" translate=\"error.invalid_date\">\nDate is too early!</div></div></md-input-container><md-input-container flex=\"20\"><label \ntranslate=\"pre-negotiated_price.days\">Price</label><input ng-model=\"vm.productCompanyBuy.daysForDelivery\" \ntype=\"number\" name=\"days\" required min=\"1\" max=\"vm.productCompanyBuy.price+1\" style=\"text-align: right\"><md-tooltip \nmd-direction=\"top\">{{\"pre-negotiated_price.days\"| translate}}</md-tooltip><div \nng-messages=\"vm.productBuyForm.days.$error\"><div ng-message=\"required\" translate=\"error.field_required\">\nThe field is required!</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"25\" \nstyle=\"text-align: center\"><md-checkbox ng-model=\"vm.productCompanyBuy.isByCostCenter\" aria-label=\"Checkbox 1\" \nstyle=\"max-width: 100px\">{{\'pre-negotiated_price.is_by_cost_center\'| translate}}</md-checkbox></md-input-container>\n</div></form></div></div></div></ms-widget-back></ms-widget><md-dialog-actions layout=\"row\" layout-align=\"start end\">\n<md-button ng-click=\"vm.cancel()\" ng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button>\n<md-button type=\"submit\" form=\"productBuyForm\" ng-disabled=\"vm.isShowProgressLinear\">{{\'general.save\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/content/content.html","<div class=\"content-wrapper\" layout=\"row\" flex><div id=\"prenegociatedPriceProductList\" class=\"content\" \nng-include=\"\'app/main/apps/product/pre-negotiated-price/content/product-list.html\'\" ms-scroll flex=\"50\"></div><div \nclass=\"content\" ng-include=\"\'app/main/apps/product/pre-negotiated-price/content/pre-negociated-price.html\'\" ms-scroll \nflex=\"50\"></div></div>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/content/pre-negociated-price.html","<div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadingPreNegociatedPrice\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"loading-data\">\n{{vm.messageOnLoadPrenegociated}}...</span></div><md-card style=\"margin-top: 0px\" \nng-if=\"!vm.loadingPreNegociatedPrice && vm.selectedProduct\" id=\"productPreNegociatedPrice\" \nclass=\"card-content productPreNegociatedPriceDetail\" layout=\"column\" ng-if=\"vm.selectedProduct\"><div \nclass=\"prenegociated-header\" layout=\"row\" layout-align=\"start center\"><div flex=\"80\" layout=\"row\" \nlayout-align=\"start center\"><h4>{{vm.selectedProduct.name}}</h4></div></div><div class=\"prenegociated-content\" \nlayout=\"column\"><ng-form name=\"vm.preNegociatedPriceForm\"><div ng-repeat=\"row in vm.productCompanyBuys\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\" ng-class=\"{\'md-green-100-bg\': row.isDefault}\"><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\" ng-class=\"{\'selected\': row.isDefault}\">\n<div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\"><div ng-if=\"row.isDefault\" \nclass=\"label md-green-300-bg\"><md-icon md-font-icon=\"icon-check-all\" class=\"icon-esp\"></md-icon></div></div><div \nlayout=\"row\" layout-xs=\"column\" class=\"p-6 grey-50-bg\" style=\"padding-left: 8px; padding-top: 5px\"><div flex=\"30\"><span\n class=\"title grey-50-bg\"><strong>{{\"company.provider\"| translate}}</strong></span></div><div flex=\"70\"><span>\n{{row.productSale.company.name + (row.productSale.company.businessName ? \" (\" + row.productSale.company.businessName + \")\" : \"\")}}\n</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label \ntranslate=\"pre-negotiated_price.start_date\">FechaInicio:</label></strong></div><div flex=\"70\"><span>\n{{row.startDate| date: \'dd-MM-yyyy\'}}</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\">\n<div flex=\"30\"><strong><label translate=\"pre-negotiated_price.end_date\">FechaFin:</label></strong></div><div flex=\"70\">\n<span>{{row.endDate| date: \'dd-MM-yyyy\'}}</span></div></div><div layout=\"row\" layout-xs=\"column\" \nstyle=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.days\">Días para entrega:\n</label></strong></div><div flex=\"70\"><span>{{row.daysForDelivery}}</span></div></div><div layout=\"row\" \nlayout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.currency\">\nMoneda:</label></strong></div><div flex=\"70\"><span>{{row.currency.description}}</span></div></div><div layout=\"row\" \nlayout-xs=\"column\" style=\"padding-left: 8px\"><div flex=\"30\"><strong><label translate=\"pre-negotiated_price.price\">\nPrecio:</label></strong></div><div flex=\"70\"><span>\n{{row.currency.symbol + \". \" + row.price + \" (\" + (row.taxesIncluded === true ? \"pre-negotiated_price.with_taxes\" : \"pre-negotiated_price.without_taxes\" | translate) + \")\"}}\n</span></div></div><div layout=\"row\" layout-xs=\"column\" style=\"padding-left: 8px\" layout-align=\"end center\"><div \nflex=\"10\" ng-if=\"!row.isDefault\"><md-button ng-disabled=\"vm.loading2\" class=\"md-icon-button\" \nng-click=\"vm.changeDefaultPrice(row)\"><md-icon md-font-icon=\"icon-check-all\" class=\"icon-esp\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"pre-negotiated_price.makedefault\"| translate}}</md-tooltip></md-button></div><div flex=\"10\" \nng-if=\"row.isByCostCenter\"><md-button ng-disabled=\"vm.loading2\" class=\"md-icon-button\" \nng-click=\"vm.editByCostCenter(row, $index)\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon-esp\">\n</md-icon><md-tooltip md-direction=\"left\">{{\"pre-negotiated_price.byCostCenter\"| translate}}</md-tooltip></md-button>\n</div><div flex=\"10\" ng-if=\"vm.canChangePriceOnDocuments\"><md-button ng-disabled=\"vm.loading2\" class=\"md-icon-button\" \nng-click=\"vm.updateQuotations()\"><md-icon md-font-icon=\"icon-view-module\" class=\"icon-esp\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"pre-negotiated_price.updateQuotations\"| translate}}</md-tooltip></md-button></div><div \nflex=\"10\" ng-if=\"vm.canChangePriceOnDocuments\"><md-button ng-disabled=\"vm.loading2\" class=\"md-icon-button\" \nng-click=\"vm.updatePurchaseOrders()\"><md-icon md-font-icon=\"icon-image-filter-none\" class=\"icon-esp\"></md-icon>\n<md-tooltip md-direction=\"left\">{{\"pre-negotiated_price.updatePurchaseOrders\"| translate}}</md-tooltip></md-button>\n</div><div flex=\"10\"><md-button class=\"md-icon-button\" ng-click=\"vm.edit(row, $index)\" ng-disabled=\"vm.loading2\">\n<md-icon md-font-icon=\"icon-border-color\" class=\"icon-esp\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"general.edit\"| translate}}</md-tooltip></md-button></div><div flex=\"10\"><md-button class=\"md-icon-button md-warn\" \nng-click=\"vm.onDelete(row, $index)\" ng-disabled=\"vm.loading2\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\"general.delete\"| translate}}</md-tooltip></md-button></div></div></ms-widget-front></ms-widget>\n</div></ng-form></div></md-card><br><br><br>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/content/product-list.html","<div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.selectProduct(product)\" class=\"item\" \nng-class=\"{\'selected\': vm.selectedProduct.id === product.id}\" ng-repeat=\"product in vm.productos.content\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div><div class=\"notes\" layout=\"column\"><span>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}} ({{\'CREATE.TYPES.\' + product.type | translate}})\n</span> <span ng-if=\"product.brand\"><strong>{{\'CREATE.BRAND\'| translate}}: </strong>{{product.brand.name}}</span> <span\n ng-if=\"product.measurementUnit\"><strong>{{\'CREATE.MEASURE\'| translate}}: </strong>{{product.measurementUnit.name}}\n</span></div></div></div><div ng-if=\"vm.selectedProduct.id === product.id\" class=\"label md-green-300-bg\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loading\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span class=\"loading-data\">{{\'department.charging_products\'| translate}}...</span></div><center>\n<div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" \nhide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" total=\"vm.productos.totalElements\"></div></center>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/filter/filter.html","<div layout=\"row\" layout-align=\"end center\" class=\"toolbar-advanced-search\"><md-button class=\"md-icon-button\" \ntitle=\"{{\'notifications.clear_filters\' | translate}}\" ng-click=\"filterCtrl.clearFilters()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18 md-warn\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntitle=\"{{\'general.close\' | translate}}\" ng-click=\"vm.showAdvancedFilter = false\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s18\"></md-icon></md-button></div><div layout=\"row\"><md-input-container flex><md-checkbox \nng-model=\"vm.filter.productWithPrice\">{{\'pre-negotiated_price.filter_by_price\' | translate}}</md-checkbox>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label>\n{{\'pre-negotiated_price.filter_by_provider\' | translate}}</label><md-select ng-model=\"vm.filter.providersId\" \nmultiple=\"multiple\" md-on-close=\"filterCtrl.searchProvider=\'\'\"><md-select-header><input id=\"searchProviderInput\" \nng-model=\"filterCtrl.searchProvider\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \nng-keydown=\"$event.stopPropagation();\"></md-select-header><md-optgroup label=\"providers\"><md-option ng-value=\"row.id\" \nng-repeat=\"row in vm.companyArray | filter : filterCtrl.searchProvider\">{{row.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\n{{\'pre-negotiated_price.filter_by_product_type\' | translate}}</label><input type=\"text\" \nng-model=\"vm.productType.description\"></md-input-container><md-button ng-if=\"!vm.productType.description\" \nclass=\"md-fab md-mini md-button md-primary\" ng-click=\"filterCtrl.selectProductType()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button ng-if=\"vm.productType.description\" \nclass=\"md-fab md-mini md-button md-warn\" ng-click=\"vm.productType={}\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div layout=\"row\"><md-switch ng-model=\"vm.filter.filterByDates\" aria-label=\"filter by dates\">\n{{\'notifications.filter_by_dates\' | translate}}</md-switch></div><fieldset ng-if=\"vm.filter.filterByDates\"><legend>\n{{\'pre-negotiated_price.end_date_negotiation\' | translate}}</legend><div layout=\"row\"><div flex layout=\"row\" \nlayout-align=\"center center\"><md-datepicker ng-model=\"vm.filter.endDateNegotiation\" \nmd-placeholder=\"{{\'pre-negotiated_price.end_date_negotiation\' | translate}}\"></md-datepicker></div></div></fieldset>\n<div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-click=\"filterCtrl.search($event)\">{{\'general.search\' | translate}}</md-button></div>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/massive-update-dialog/massive-update-dialog.html","<md-dialog aria-label=\"Crear-Editar\"><md-toolbar><div layout=\"row\" class=\"headerToolbar\"><span \nstyle=\"padding-top: 20px; padding-left: 10px\">{{\"pre-negotiated_price.massive_update\"| translate}}</span> <span flex>\n</span><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"width: 370px; height: 350px\"><div layout=\"column\"><div layout=\"row\"><div flex layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex><label>{{\'pre-negotiated_price.start_date\' | translate}}</label>\n<md-datepicker ng-model=\"vm.productCompanyBuy.startDate\" \nmd-placeholder=\"{{\'pre-negotiated_price.start_date\' | translate}}\" md-min-date=\"vm.today\"></md-datepicker>\n</md-input-container></div></div><div layout=\"row\"><div flex layout=\"row\" layout-align=\"center center\">\n<md-input-container flex><label>{{\'pre-negotiated_price.end_date\' | translate}}</label><md-datepicker \nng-model=\"vm.productCompanyBuy.endDate\" md-placeholder=\"{{\'pre-negotiated_price.end_date\' | translate}}\" \nmd-min-date=\"vm.today\"></md-datepicker></md-input-container></div></div><div layout=\"row\"><div flex layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex><label>{{\'pre-negotiated_price.days\' | translate}}</label><input \nng-model=\"vm.productCompanyBuy.daysForDelivery\" type=\"number\" name=\"days\" required min=\"1\" \nmax=\"vm.productCompanyBuy.price+1\" style=\"text-align: right\"></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">\n{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" ng-disabled=\"vm.loadingSave\">\n{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/by-cost-center/by-cost-center.html","<md-dialog class=\"compose-dialog by-costcenter\" aria-label=\"Crear-Editar\" \nstyle=\"width: 40%; height: 90%; overflow: hidden\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.cost_center\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear type=\"indeterminate\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear><div class=\"md-dialog-content\"><form name=\"vm.productBuyForm\" id=\"productBuyForm\" \nng-submit=\"vm.save()\"><div layout=\"column\"><md-input-container flex=\"50\" ng-disabled=\"true\"><label>\n{{\'pre-negotiated_price.company\'| translate}}</label><md-select ng-model=\"vm.companySelected\" \nng-change=\"vm.loadCostCenter(vm.companySelected)\" required name=\"company\"><md-optgroup><md-option ng-value=\"c.id\" \nng-repeat=\"c in vm.companies\">{{c.name}}</md-option></md-optgroup></md-select></md-input-container><div \nclass=\"custom-list\" ng-if=\"!vm.loadingCostCenter\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input \nid=\"searchEntityInput\" ng-model=\"vm.searchEntity\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.costCenters.length > 0\" ng-model=\"vm.isCheckAllCostCenter\" ng-change=\"vm.selectAllCostCenter()\">\n{{\'pre-negotiated_price.all\'| translate}}</md-checkbox></div><div ng-style=\"vm.dinamicHeight\" ms-scroll><div \nng-click=\"vm.toggle(entity, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(entity)}\" \nng-repeat=\"entity in vm.costCenters| filter:vm.searchEntity\" ng-click=\"vm.toggle($event, entity)\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(entity)\" md-font-icon=\"icon-checkbox-marked\"></md-icon>\n<md-icon ng-if=\"!vm.isSelected(entity)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{entity.description}}</div></div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.loadingCostCenter\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div></div></form></div><md-dialog-actions \nlayout=\"row\" layout-align=\"start end\"><md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button>\n<md-button type=\"submit\" form=\"productBuyForm\" ng-disabled=\"vm.selectedArray.length <= 0\">{{\'general.save\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/productType/productType-dialog/productType-dialog.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 90%; height: 90%\" id=\"productTypedialog\"><md-toolbar><div \nlayout=\"row\" class=\"headerToolbar\"><md-tabs md-selected=\"data.selectedIndex\" flex><md-tab id=\"tab1\" \nng-click=\"vm.viewButtons = true; vm.updateChildProduct = false;\">{{\'menu.productType\'| translate}}</md-tab><md-tab \nid=\"tab2\" ng-if=\"vm.productType.id\" \nng-click=\"vm.viewButtons = false; vm.updateChildProduct = false; vm.getApplications();\">\n{{\'menu.configuracionadicional\'| translate}}</md-tab></md-tabs><span flex></span><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content style=\"padding: 5px 24px\">\n<md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height md-selected=\"data.selectedIndex\" \nclass=\"tab-in-content\"><md-tab><md-tab-body><div class=\"form-inline\"><ng-form name=\"vm.productTypeForm\">\n<md-input-container flex class=\"md-block\"><label>{{\"productType.description\"|translate}}</label><input type=\"text\" \nname=\"description\" ng-model=\"vm.productType.description\" required></md-input-container><md-input-container flex \nclass=\"md-block\"><label>{{\"productType.productTypeCode\"|translate}}</label><input type=\"text\" name=\"productTypeCode\" \nng-model=\"vm.productType.productTypeCode\" required></md-input-container><md-input-container flex class=\"md-block\" \nng-if=\"vm.productType.id\"><label>{{\"productType.productTypeLevel\"|translate}}</label><input type=\"text\" \nname=\"productTypeLevel\" ng-model=\"vm.productType.productTypeLevel\" ng-disabled=\"true\"></md-input-container>\n<md-input-container flex class=\"md-block\" ng-disabled=\"true\" ng-if=\"vm.productType.productTypeParent.id\"><label>\n{{\"productType.productTypeParent\"|translate}}</label><input ng-disabled=\"true\" type=\"text\" name=\"productTypeParent\" \nng-model=\"vm.productType.productTypeParent.description\" ng-if=\"vm.productType.productTypeParent\"></md-input-container>\n<div layout=\"row\" layout-align=\"left center\"><md-input-container class=\"md-block\" flex><label \ntranslate=\"productType.productCondition\">Product Condition</label><md-select required \nng-model=\"vm.productType.productCondition.id\" name=\"productCondition\" md-on-close=\"vm.clearSearchProductCondition()\">\n<md-select-header><input id=\"searchProductCondition\" ng-model=\"vm.searchProductCondition\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup>\n<md-option value=\"{{data.id}}\" ng-repeat=\"data in vm.productConditionArray| filter:vm.searchProductCondition\">\n{{data.conditionCode}} - {{data.conditionName}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingProductCondition\"></md-progress-linear><div \nng-messages=\"vm.productTypeForm.productCondition.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'productType.productCondition\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-checkbox ng-model=\"vm.productType.canOrder\" aria-label=\"can order\"><strong>\n{{\'productType.canOrder\'| translate}}</strong></md-checkbox></div><div layout=\"row\" layout-align=\"left center\">\n<md-input-container flex class=\"md-block\" ng-disabled=\"true\"><label>\n{{\"productType.productSaleValidationType\"|translate}}</label><md-select \nng-model=\"vm.productType.productSaleValidationType\" name=\"productSaleValidationType\" \nmd-on-close=\"vm.clearSearchProductSaleValidationType()\" required><md-select-header><input \nid=\"searchProductSaleValidationType\" ng-model=\"vm.searchProductSaleValidationType\" type=\"search\" \nplaceholder=\"{{\'general.search\'| translate}}\" ng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup \nlabel=\"groups\"><md-option value=\"{{data.value}}\" \nng-repeat=\"data in vm.productSaleValidationType| filter:vm.searchProductSaleValidationType\">\n{{\"productType.\"+data.value | translate}}</md-option></md-optgroup></md-select></md-input-container><md-checkbox \nng-model=\"vm.updateChildProduct\" aria-label=\"chk\" ng-if=\"vm.productType.id\"><strong>\n{{\'product_parameters.update_children\'| translate}}</strong></md-checkbox></div><div layout=\"row\" \nlayout-align=\"left center\"><md-input-container class=\"md-block\" flex><label translate=\"productType.gender\">\nProduct Gender</label><md-select required ng-model=\"vm.productType.productGender.id\" name=\"productGender\" \nmd-on-close=\"vm.clearSearchProductGender()\"><md-select-header><input id=\"searchProductGender\" \nng-model=\"vm.searchProductGender\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \nng-keydown=\"$event.stopPropagation()\"></md-select-header><md-optgroup><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.productGenders| filter:vm.searchProductGender\">{{data.value}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingProductGender\"></md-progress-linear><div \nng-messages=\"vm.productTypeForm.productGender.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'productType.gender\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container></div>\n<md-input-container flex class=\"md-block\"><label>{{\"productType.classifiedServiceCode\"|translate}}</label><input \ntype=\"text\" name=\"classifiedServiceCode\" ng-model=\"vm.productType.classifiedServiceCode\" required></md-input-container>\n<md-input-container flex class=\"md-block\"><md-checkbox ng-disabled=\"!vm.productType.id\" \nng-model=\"vm.productType.active\" ng-change=\"vm.onDelete()\">{{\'general.active\'| translate}}</md-checkbox>\n</md-input-container></ng-form></div></md-tab-body></md-tab><md-tab><md-tab-body><div layout=\"row\"><md-input-container \nflex><label translate=\"company_applications.applications\">applications</label><md-select ng-model=\"vm.application\" \nname=\"application\" required md-on-close=\"vm.clearSearchApplication()\" ng-change=\"vm.viewEstablishment=true\" \naria-label=\"select\"><md-select-header><input id=\"searchApplication\" ng-model=\"vm.searchApplication\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Applicacion\"><md-option \nng-value=\"{{r.application.id}}\" ng-repeat=\"r in vm.applicationArray| filter:vm.searchApplication\">\n{{r.application.name}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex \nclass=\"md-block\" ng-if=\"vm.viewEstablishment\"><label>{{\"menu.establishments\"|translate}}</label><md-select \nng-model=\"vm.companyEstablishment.id\" name=\"department\" md-on-close=\"vm.clearSearchCompanyEstablishment()\" \nng-change=\"vm.getParametersByApplication(vm.application)\"><md-select-header><input id=\"searchCompanyEstablishment\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchCompanyEstablishment\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"groups\"><md-option \nng-value=\"{{data.id}}\" ng-repeat=\"data in vm.companyestablishments| filter:vm.searchCompanyEstablishment\">\n{{data.establishmentName}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" \nng-show=\"vm.content\"><md-content class=\"content\" flex ms-scroll><md-tabs md-dynamic-height \nmd-selected=\"data.selectedIndexInner\" class=\"tab-in-content-inner\"><md-tab id=\"tab1In\"><md-tab-label>\n{{\'menu.parameters\'| translate}}</md-tab-label><md-tab-body><div layout=\"row\" layout-align=\"center center\"><span flex>\n</span><md-checkbox ng-model=\"vm.updateChildProduct\" aria-label=\"chk\"><strong>\n{{\'product_parameters.update_children\'| translate}}</strong></md-checkbox></div><div flex layout=\"column\"><div \nng-repeat=\"(key, value) in vm.content | groupBy: \'applicationParameter.applicationParameterGroup.description\'\"><div \nstyle=\"padding-top: 10px; background: #fff0ff\"><strong>\n{{\'COMPANY.SECTION\' | translate | uppercase}} {{\'COMPANY.\'+key | translate | uppercase}}</strong></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsParameters\"><thead><tr><th \nstyle=\"padding-top: 10px; padding-bottom: 10px; width: 50%\"><span translate=\"company_parameters.description\"></span>\n</th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 40%\"><span translate=\"company_parameters.value\"></span>\n</th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\">Opciones</th></tr></thead><tbody><tr \nng-repeat=\"player in value\"><td style=\"padding:0; width: 50%\">{{player.applicationParameter.parameterDescription}}</td>\n<td style=\"padding:0; width: 40%\"><div ng-if=\"player.applicationParameter.dataType===\'TEXT\'\"><input \nid=\"documentNumber\" autocomplete=\"off\" class=\"input-inner\" ng-model=\"player.parameterValue\" \nstyle=\"text-align: left; width: 100%\"></div><div ng-if=\"player.applicationParameter.dataType===\'NUMBER\'\"><input \nid=\"documentNumber\" numbers-only=\"numbers-only\" autocomplete=\"off\" ng-model=\"player.parameterValue\" \nclass=\"input-inner\" style=\"text-align: right\"></div><div ng-if=\"player.applicationParameter.dataType===\'DECIMAL\'\">\n<input ng-model=\"player.parameterValue\" name=\"rate\" required min=\"0.01\" max=\"vm.promotion.rate+1\" class=\"input-inner\" \nstyle=\"text-align: right\"></div><div ng-if=\"player.applicationParameter.dataType===\'COLOR\'\"><div md-color-picker \nrandom=\"true\" open-on-input=\"true\" ng-model=\"player.parameterValue\" default=\"#f00\" md-color-generic-palette=\"false\" \nmd-color-history=\"false\">{{player.parameterValue}}</div></div><div \nng-if=\"player.applicationParameter.dataType===\'BOOLEAN\'\" layout=\"row\" layout-align=\"center center\"><md-checkbox \nng-model=\"player.parameterValue\" aria-label=\"chk\"></md-checkbox></div></td><td style=\"padding:0; width: 10%\"><div>\n<md-button class=\"md-icon-button\" ng-click=\"vm.updateParameterValue(player)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon></md-button></div></td></tr></tbody></table></div></div></md-tab-body></md-tab><md-tab id=\"tab2In\">\n<md-tab-label>{{\'menu.addonsfields\'| translate}}</md-tab-label><md-tab-body><div flex layout=\"column\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsParameters2\"><thead><tr><th \nstyle=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"><span translate=\"parameters_field.activated\"></span></th>\n<th style=\"padding-top: 10px; padding-bottom: 10px; width: 30%\"><span translate=\"parameters_field.field\"></span></th>\n<th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"><span translate=\"parameters_field.addonsfieldgroup\">\n</span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"><span \ntranslate=\"parameters_field.isunique\"></span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"><span\n translate=\"parameters_field.ispksale\"></span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\">\n<span translate=\"parameters_field.printinvoice\"></span></th><th \nstyle=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"><span translate=\"parameters_field.printorder\"></span></th>\n<th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"><span translate=\"parameters_field.lengthmin\"></span>\n</th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"><span translate=\"parameters_field.lengthmax\">\n</span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\">Opciones</th></tr></thead><tbody><tr \nng-repeat=\"additional in vm.padditionals\" \nng-style=\"additional.active ? {\'background-color\':\'#e5fbc7\'} : {\'background-color\':\'#fbd3c7\'}\"><td \nstyle=\"padding:0; width: 10%\"><div layout=\"row\" layout-align=\"center center\"><md-checkbox ng-model=\"additional.active\" \naria-label=\"chk\"></md-checkbox></div></td><td style=\"padding:0; width: 30%\">\n{{additional.companyApplicationAdditionalFields.additionalField.additionalFieldName}}</td><td \nstyle=\"padding:0; width: 20%\"><div layout=\"row\"><md-input-container flex ng-if=\"!additional.newGroup\" \nng-disabled=\"!additional.active\"><label></label><md-select ng-model=\"additional.productAddonFieldGroup.name\"><md-option\n value=\"{{group.name}}\" ng-repeat=\"group in vm.groups|  orderBy:\'name\'\">{{group.name}}</md-option></md-select>\n</md-input-container><input id=\"documentNumber\" autocomplete=\"off\" class=\"input-inner\" \nng-disabled=\"!additional.active\" ng-if=\"additional.newGroup\" ng-model=\"additional.productAddonFieldGroup.name\" \nstyle=\"text-align: left; width: 100%\"><md-button class=\"md-icon-button\" ng-click=\"vm.changeGrouporCreate(additional);\" \nng-disabled=\"!additional.active\" aria-label=\"brand\" style=\"padding-top: 20px\"><div ng-if=\"!additional.newGroup\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></div><div ng-if=\"additional.newGroup\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></div></md-button></div></td><td style=\"padding:0; width: 10%\"><div layout=\"row\" \nlayout-align=\"center center\"><md-checkbox ng-model=\"additional.isunique\" ng-disabled=\"!additional.active\" \naria-label=\"chk\"></md-checkbox></div></td><td style=\"padding:0; width: 10%\"><div layout=\"row\" \nlayout-align=\"center center\"><md-checkbox ng-model=\"additional.pkSale\" ng-disabled=\"!additional.active\" \naria-label=\"chk\"></md-checkbox></div></td><td style=\"padding:0; width: 10%\"><div layout=\"row\" \nlayout-align=\"center center\"><md-checkbox ng-model=\"additional.printInvoice\" ng-disabled=\"!additional.active\" \naria-label=\"chk\"></md-checkbox></div></td><td style=\"padding:0; width: 10%\"><input id=\"documentNumber\" \nnumbers-only=\"numbers-only\" autocomplete=\"off\" ng-model=\"additional.printOrder\" ng-disabled=\"!additional.active\" \nclass=\"input-inner\" style=\"text-align: right\"></td><td style=\"padding:0; width: 10%\"><input id=\"documentNumber\" \nnumbers-only=\"numbers-only\" autocomplete=\"off\" ng-model=\"additional.lenghtMin\" ng-disabled=\"!additional.active\" \nclass=\"input-inner\" style=\"text-align: right\"></td><td style=\"padding:0; width: 10%\"><input id=\"documentNumber\" \nnumbers-only=\"numbers-only\" autocomplete=\"off\" ng-model=\"additional.lenghtMax\" ng-disabled=\"!additional.active\" \nclass=\"input-inner\" style=\"text-align: right\"></td><td style=\"padding:0; width: 10%\"><div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.updateAdditionalField(additional);\" ng-disabled=\"!additional.active\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button></div></td></tr></tbody></table></div></md-tab-body></md-tab>\n</md-tabs></md-content></div></md-tab-body></md-tab></md-tabs></md-content></md-dialog-content><md-dialog-actions><div \nng-if=\"vm.viewButtons\"><md-button class=\"md-fab md-fab-bottom-left\" aria-label=\"addDetail\" \nng-disabled=\"!vm.productType.id\" ng-click=\"vm.addChildren()\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip \nmd-direction=\"top\">{{\"productType.addChildren\"| translate}}</md-tooltip></md-icon></md-button><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"addDetail\" ng-disabled=\"vm.productTypeForm.$invalid\" \nng-click=\"vm.saveProductType($event)\"><md-icon md-font-icon=\"icon-content-save\"><md-tooltip md-direction=\"top\">\n{{\"general.save\"| translate}}</md-tooltip></md-icon></md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/update-price-dialog/update-price-dialog.html","<md-dialog aria-label=\"Update price\"><md-toolbar><div layout=\"row\" class=\"headerToolbar\"><span \nstyle=\"padding-top: 20px; padding-left: 10px\">{{vm.title | translate}}</span> <span flex></span><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content style=\"width: 450px; height: 270px\"><div class=\"center\" \nlayout=\"column\" flex><div class=\"md-dialog-content\" ms-scroll><form name=\"vm.updatePriceForm\" id=\"updatePriceForm\" \nng-submit=\"vm.save()\"><div flex layout=\"row\"><md-input-container flex><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.response.allCompanies\" required><md-radio-button ng-value=\"false\">\n{{\'pre-negotiated_price.currentCompany\' | translate}}</md-radio-button><md-radio-button ng-value=\"true\">\n{{\'pre-negotiated_price.allCompanies\' | translate}}</md-radio-button></md-radio-group></md-input-container></div><div \nflex layout=\"row\"><md-input-container flex><label>{{\'pre-negotiated_price.newPrice\' | translate}}</label><input \nng-model=\"vm.response.newPrice\" type=\"number\" name=\"price\" required min=\"0\" style=\"text-align: right\">\n</md-input-container></div></form></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-click=\"vm.save()\" ng-disabled=\"vm.loading || vm.updatePriceForm.$invalid\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/tags/editor/pre-negotiated-price.html","<md-dialog class=\"compose-dialog\" aria-label=\"Crear-Editar\" style=\"width: 60%; height: 90%\"><ms-widget \nflippable=\"true\" layout=\"row\" style=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.addProductSale === true ? (\'pre-negotiated_price.add_provider_to_product\' | translate) : (\'pre-negotiated_price.product_providers\' | translate) + vm.productCompanyBuy.productSale.product.name}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.newContact ? vm.flip() : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.visibleCompanies\"><div layout=\"column\" layout-align=\"center center\"><div><form \nng-submit=\"vm.addProductSale === true?vm.getAllCompanies(1):vm.getProductSales(1)\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label class=\"md-primary\" \ntranslate=\"general.filter\">Filtro</label><input type=\"text\" ng-model=\"vm.filterProvider\" name=\"search\" \nng-keyup=\"vm.changeFilter()\" id=\"searchFilter\"></md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span \ntranslate=\"general.search\">Search</span></md-button></div></form></div></div></div></md-toolbar><md-progress-linear \ntype=\"indeterminate\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content ms-scroll \nstyle=\"padding: 0px\"><div layout=\"column\" class=\"p-16\" style=\"padding: 0px\" ng-if=\"vm.visibleCompanies\"><div \nid=\"e-commerce-product\" class=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\" \nng-if=\"vm.addProductSale\"><div class=\"content thread-list\" ms-scroll><div class=\"thread\" md-ink-ripple \nng-if=\"!vm.loading\" ng-repeat=\"company in vm.companies.content\" ng-click=\"vm.selectItem(company)\" \nng-class=\"{\n                                             \'current-thread\':vm.selectedCompany.id === company.id}\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"title\">\n{{company.name + (company.businessName?\" (\" + company.businessName + \")\":\"\")}}</div><div class=\"notes\"></div></div>\n</div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectedCompany.id === company.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" \nul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getAllCompanies(page)\" \ntotal=\"vm.companies.totalElements\"></div></div></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\" \nng-if=\"!vm.addProductSale\"><div class=\"content thread-list\" ms-scroll><div class=\"thread\" md-ink-ripple \nng-if=\"!vm.loading\" ng-repeat=\"productSale in vm.productSales.content\" ng-click=\"vm.selectItem(productSale)\" \nng-class=\"{\n                                             \'current-thread\':vm.selectedProductSale.company.id === productSale.id}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><div class=\"title\">\n{{productSale.name + (productSale.businessName?\" (\" + productSale.businessName + \")\":\"\")}}</div><div class=\"notes\">\n</div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectedProductSale.company.id === productSale.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div>\n</div></div></div></div><div layout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" \npage=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" \npaging-action=\"vm.getProductSales(page)\" total=\"vm.productSales.totalElements\"></div></div></div><div layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"vm.addProductSale === true?!vm.companies.content.length > 0 && !vm.loading : !vm.productSales.content.length > 0 && !vm.loading\">\n<span class=\"title\">{{\'pre-negotiated_price.not_found_search\'| translate}} \"{{vm.filterProvider}}\"</span><br><a \nng-click=\"vm.selectProviderToAdd(!vm.addProductSale)\" ng-if=\"!vm.addProductSale\">\n{{\'pre-negotiated_price.search_all_providers\'| translate}}</a></div><div layout=\"row\" layout-align=\"center center\"><div\n class=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular class=\"ajax-loader md-accent md-hue-2\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></div></div></div></md-dialog-content></ms-widget-front>\n<ms-widget-back id=\"perms\" class=\"white-bg\" ms-scroll><div ng-init=\"vm.flipping(flipWidget);\"></div><div \nclass=\"page-layout carded fullwidth\" layout=\"column\"><md-toolbar class=\"md-accent md-tall md-toolbar-more\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.productCompanyBuy.id ? \'general.edit\' : \'general.add\'| translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close\" translate translate-attr-aria-label=\"general.close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"center\" layout=\"column\" flex>\n<div class=\"md-dialog-content\" ms-scroll><form name=\"vm.productBuyForm\" id=\"productBuyForm\" ng-submit=\"vm.save()\"><div \nlayout=\"row\"><div flex=\"30\"><strong><label translate=\"company.provider\">Proveedor:</label></strong></div><div \nflex=\"70\"><span required>\n{{vm.productCompanyBuy.productSale.company.name + (vm.productCompanyBuy.productSale.company.businessName?\" (\" + vm.productCompanyBuy.productSale.company.businessName + \")\":\"\")}}\n</span></div><md-button class=\"md-icon-button\" ng-click=\"vm.onEdit()\"><md-icon \nmd-font-icon=\"{{vm.productCompanyBuy.productSale && vm.productCompanyBuy.productSale.company?\'icon-border-color\':\'icon-plus\'}}\">\n</md-icon><md-tooltip md-direction=\"left\">\n{{vm.productCompanyBuy.productSale && vm.productCompanyBuy.productSale.company?\"general.edit\":\"general.add\"| translate}}\n</md-tooltip></md-button></div><div layout=\"row\"><md-input-container flex=\"50\" ng-disabled=\"true\"><label>\n{{\'pre-negotiated_price.currency\'| translate}}</label><md-select ng-model=\"vm.productCompanyBuy.currency.id\" required \nname=\"currency\" ng-disabled=\"true\"><md-optgroup><md-option ng-value=\"c.id\" ng-repeat=\"c in vm.currencies\">\n{{c.description}}</md-option></md-optgroup></md-select><div ng-messages=\"vm.productBuyForm.currency.$error\"><div \nng-message=\"required\" translate=\"error.field_required\">This field is required!</div></div></md-input-container>\n<md-input-container flex=\"25\"><label translate=\"pre-negotiated_price.price\">Price</label><input \nng-model=\"vm.productCompanyBuy.price\" type=\"number\" name=\"price\" required min=\"0.1\" max=\"vm.productCompanyBuy.price+1\" \nstyle=\"text-align: right\"><div ng-messages=\"vm.productBuyForm.price.$error\"><div ng-message=\"required\" \ntranslate=\"error.field_required\">The field is required!</div></div></md-input-container><md-input-container flex=\"25\" \nstyle=\"text-align: center\"><md-checkbox ng-model=\"vm.productCompanyBuy.taxesIncluded\" aria-label=\"Checkbox 1\" \nstyle=\"max-width: 100px\">{{\'pre-negotiated_price.taxes_included\'| translate}}</md-checkbox></md-input-container></div>\n<div layout=\"row\"><md-input-container flex=\"40\"><label translate=\"pre-negotiated_price.start_date\">Fecha de inicio\n</label><md-datepicker type=\"date\" ng-model=\"vm.productCompanyBuy.startDate\" name=\"startDate\" md-open-on-focus \nmd-max-date=\"vm.productCompanyBuy.endDate\" md-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div \nng-messages=\"vm.productBuyForm.startDate.$error\"><div ng-message=\"valid\" translate=\"error.invalid_date\">\nThe entered value is not a date!</div><div ng-message=\"required\" translate=\"error.field_required\">\nThis date is required!</div><div ng-message=\"mindate\" translate=\"error.invalid_date\">Date is too early!</div></div>\n</md-input-container><md-input-container flex=\"40\"><label translate=\"pre-negotiated_price.end_date\">Fecha fin</label>\n<md-datepicker type=\"date\" ng-model=\"vm.productCompanyBuy.endDate\" name=\"endDate\" md-open-on-focus \nmd-min-date=\"vm.productCompanyBuy.startDate && vm.productCompanyBuy.startDate > vm.minDate? vm.productCompanyBuy.startDate:vm.minDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.productBuyForm.endDate.$error\"><div \nng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div><div ng-message=\"required\" \ntranslate=\"error.field_required\">This date is required!</div><div ng-message=\"mindate\" translate=\"error.invalid_date\">\nDate is too early!</div></div></md-input-container><md-input-container flex=\"20\"><label \ntranslate=\"pre-negotiated_price.days\">Price</label><input ng-model=\"vm.productCompanyBuy.daysForDelivery\" \ntype=\"number\" name=\"days\" required min=\"1\" max=\"vm.productCompanyBuy.price+1\" style=\"text-align: right\"><md-tooltip \nmd-direction=\"top\">{{\"pre-negotiated_price.days\"| translate}}</md-tooltip><div \nng-messages=\"vm.productBuyForm.days.$error\"><div ng-message=\"required\" translate=\"error.field_required\">\nThe field is required!</div></div></md-input-container></div></form></div></div></div></ms-widget-back></ms-widget>\n<md-dialog-actions layout=\"row\" layout-align=\"start end\"><md-button ng-click=\"vm.cancel()\" \nng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button><md-button type=\"submit\" \nform=\"productBuyForm\" ng-disabled=\"vm.isShowProgressLinear\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/tags/content/content.html","<div class=\"content-wrapper\" layout=\"row\" flex><div id=\"prenegociatedPriceProductList\" class=\"content\" \nng-include=\"\'app/main/apps/product/tags/content/product-list.html\'\" ms-scroll flex=\"50\"></div><div class=\"content\" \nng-include=\"\'app/main/apps/product/tags/content/tags.html\'\" ms-scroll flex=\"50\"></div></div>");
$templateCache.put("app/main/apps/product/tags/content/product-list.html","<div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.selectProduct(product)\" class=\"item\" \nng-class=\"{\'selected\': vm.selectedProduct.id === product.id}\" ng-repeat=\"product in vm.productos.content\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div><div class=\"notes\" layout=\"column\"><span>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}} ({{\'CREATE.TYPES.\' + product.type | translate}})\n</span> <span ng-if=\"product.brand\"><strong>{{\'CREATE.BRAND\'| translate}}: </strong>{{product.brand.name}}</span> <span\n ng-if=\"product.measurementUnit\"><strong>{{\'CREATE.MEASURE\'| translate}}: </strong>{{product.measurementUnit.name}}\n</span></div></div></div><div ng-if=\"vm.selectedProduct.id === product.id\" class=\"label md-green-300-bg\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loading\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span class=\"loading-data\">{{\'department.charging_products\'| translate}}...</span></div><div \nlayout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" ul-class=\"pagination\" \npage-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" total=\"vm.productos.totalElements\">\n</div></div>");
$templateCache.put("app/main/apps/product/tags/content/tags.html","<div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadingTags\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"loading-data\">\n{{vm.messageOnLoadTags}}...</span></div><md-card style=\"margin-top: 0px\" ng-if=\"!vm.loadingTags && vm.selectedProduct\" \nid=\"productPreNegociatedPrice\" class=\"card-content productPreNegociatedPriceDetail\" layout=\"column\" \nng-if=\"vm.selectedProduct\"><div class=\"prenegociated-header\" layout=\"row\" layout-align=\"start center\"><div flex=\"80\" \nlayout=\"row\" layout-align=\"start center\"><h4>{{vm.selectedProduct.name}}</h4></div></div><div \nclass=\"prenegociated-content\" layout=\"column\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-tag\" class=\"icon s24\"></md-icon><input flex type=\"search\" \nplaceholder=\"{{\'TAGS.ADD_TAG\'| translate}}\" ng-enter=\"vm.saveTag()\" ng-model=\"vm.newTag\"> <button \nng-disabled=\"!vm.newTag\" class=\"md-fab md-mini md-button md-primary\" ng-click=\"vm.saveTag()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-top: 20px; display: block; position: relative\"><div layout-align=\"start-center\" \nclass=\"badge white-fg ng-binding ng-scope\" style=\"background: silver; float: left; margin: 3px; margin-top: 3px\" \nng-repeat=\"row in vm.productCompanyAddonsTags\"><span style=\"font-size: 20px\">\n{{row.productCompanyTags.productTagValue}} <a ng-click=\"vm.deleteTag(row)\"><md-icon class=\"md-warn\" \nmd-font-icon=\"s20 icon-trash\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.delete\"| translate}}</md-tooltip>\n</a></span></div></div></div></md-card><br><br><br>");
$templateCache.put("app/main/apps/providers/detail/list/list.html","<div class=\"no-threads\" ng-if=\"!vm.details || vm.details.length === 0\" translate=\"TENDER.DETAIL.NOT_DETAIL\">\nThere are no details!</div><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"!vm.details && vm.loadingDetails\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"64\"></md-progress-circular><div><span translate=\"TENDER.DETAIL.LOADING\">Loading your details...</span>\n</div></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><spam class=\"column-title\">{{\'TENDER.CREAR.PRODUCTOS\'| translate}}\n</spam></div></th><th class=\"secondary-text\"><div class=\"table-header\"><spam class=\"column-title\">Producto/Servicio\n</spam></div></th><th class=\"secondary-text\"><div class=\"table-header\"><spam class=\"column-title\">Cantidad</spam></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><spam class=\"column-title\">Fotos</spam></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><spam class=\"column-title\">Opciones</spam></div></th></tr></thead>\n<tbody><tr class=\"thread {{detail.status}}\" ng-repeat=\"detail in vm.details\" ng-if=\"!vm.loadingDetails\" \nng-class=\"{\'current-thread\': vm.currentDetail === detail}\" nd-ink-ripple><td>{{$index + 1}}</td><td>\n{{detail.product.name}}</td><td>{{detail.quantity}}</td><td><div><span ng-repeat=\"photo in detail.photos\"><a \nng-href=\"{{ vm.baseUrlSharedFiles}}{{photo.parentPath}}{{photo.name}}{{\'l\'}}{{photo.extension}}\" data-gallery \ntarget=\"_blank\"><img ng-src=\"{{ vm.baseUrlSharedFiles}}{{photo.parentPath}}{{photo.name}}{{\'i\'}}{{photo.extension}}\" \nclass=\"img-rounded border12\" alt=\"photo\" height=\"20\" onerror=\"this.src=\'assets/images/logos/angular.png\'\"></a></span>\n</div></td><td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.editDetail($event, detail)\" \nng-disabled=\"!vm.canModifyTenderAndDetail || !vm.canModifyDetail\" aria-label=\"Product details\" translate \ntranslate-attr-aria-label=\"COMPANY.EDIT_DOCUMENT\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.deleteDetail($event, detail)\" \nng-disabled=\"!vm.canModifyTenderAndDetail || !vm.canModifyDetail\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANY.DELETE_DOCUMENT\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\"></md-icon>\n</md-button></td></tr></tbody></table>");
$templateCache.put("app/main/apps/usr/associate-equivalence-role/associate-equivalence-role-list/associate-equivalence-role-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout=\"row\" class=\"custom-header\" \nlayout-align=\"none center\"><div flex=\"80\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'menu.associateEquivalenceRole\' | translate}} | {{vm.application.name}}</span></div></div><div \nclass=\"page-layout simple left-sidenav\" layout=\"row\" style=\"min-height: 85%;height: 85%\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><md-list><md-subheader \nclass=\"md-no-sticky\" style=\"border-bottom: 1px solid #D8D8D8\">\n{{\'associateEquivalenceRole.applications\' | translate}} ({{vm.applicationArray.length}})</md-subheader><md-list-item \nng-class=\"(r.application === vm.application) ? \'selected\' : \'\'\" \nng-click=\"vm.getEquivalencesByApplication(r.application)\" ng-repeat=\"r in vm.applicationArray\" \nstyle=\"border-bottom: 1px solid #D8D8D8\"><p>{{r.application.name}}</p></md-list-item></md-list></md-sidenav><div \nclass=\"center\" flex ms-scroll><md-card ng-disabled=\"true\"><md-progress-linear ng-if=\"vm.isShowProgressLinearGrid\" \nstyle=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\"></md-progress-linear><div \nid=\"parametersGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"0\" ng-show=\"vm.showGrid\"></div>\n</md-card></div></div><style>.selected {\n        background-color: lightblue;\n    }</style>");
$templateCache.put("app/main/apps/usr/associate-role-jobhr/associate-role-jobhr-dialog/associateRolJobHrDialog.html","<md-dialog aria-label=\"Crear-Editar\" class=\"dialog-style\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1>{{vm.jobHrId ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent progress-bar-style\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><md-progress-linear \ntype=\"indeterminate\" ng-show=\"vm.loadingProgress\"></md-progress-linear><div class=\"mat-dialog-without-padding\"><form \nname=\"myForm\"><div layout=\"row\" ng-show=\"vm.companyRoleJobNewData.applicationId <= 0\" layout-align=\"center center\">\n<md-input-container flex=\"50\" layout-align=\"center center\"><div ng-messages=\"vm.myForm.code.$error\"><div \nng-message-default layout-align=\"center center\">{{\'associateRoleJobHR.field_required\' | translate}}</div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label \ntranslate=\"associateRoleJobHR.application\">Application</label><md-select \nng-change=\"vm.getRol(vm.companyRoleJobNewData.applicationId)\" ng-model=\"vm.companyRoleJobNewData.applicationId\" \nname=\"app\" md-on-close=\"vm.clearSearchErpInput()\" ng-disabled=\"vm.companyRoleJobNewData.disabledData\">\n<md-select-header><input id=\"searchApplicationInput\" ng-model=\"vm.searchApplicationInput\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-option \nng-repeat=\"app in vm.companyRoleJobNewData.applicationData |filter:vm.searchApplicationInput\" \nng-value=\"app.application.id\">{{app.application.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\"><label translate=\"associateRoleJobHR.role\">Rol</label><md-select \nng-model=\"vm.companyRoleJobNewData.rolApplicationId\" name=\"rol\" md-on-close=\"vm.clearSearchGroup()\" \nng-disabled=\"vm.companyRoleJobNewData.disabledData\"><md-select-header><input id=\"clearSearchRolInput\" \nng-model=\"vm.searchRolInput\" type=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header>\n<md-option ng-repeat=\"role in vm.companyRoleJobNewData.roles|filter:vm.searchRolInput\" ng-value=\"role.id\">\n{{role.description}}</md-option></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingRoleApplication\"></md-progress-linear></md-input-container></div><div layout=\"row\"><md-input-container\n flex=\"100\"><label>{{\'associateRoleJobHR.jobCode\'| translate}}</label><input type=\"number\" \nng-model=\"vm.companyRoleJobNewData.jobHrId\" name=\"jobHrId\" ng-disabled=\"vm.companyRoleJobNewData.applicationId <= 0\" \nrequired></md-input-container></div></form></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between\" class=\"dialog-actions-style\"><md-button ng-click=\"vm.cancel()\" \nng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.saveRolJob()\" \nng-disabled=\"!vm.companyRoleJobNewData.jobHrId\">{{\'general.save\'| translate}}</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/apps/usr/user/country/country.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.countries\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input \nflex type=\"search\" ng-model=\"vm.inputSearchCountry\" translate translate-attr-placeholder=\"user.search_country\" \nng-enter=\"vm.searchCountry()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchCountry()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.countryArray.length > 0\" ng-model=\"vm.isCheckAllCountry\" \nng-change=\"vm.selectAllCountry()\">{{\'user.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggle(row, $event)\" \nclass=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" ng-repeat=\"row in vm.countryArray\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelected(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.name}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate countries\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate countries\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchUserCountry\" translate \ntranslate-attr-placeholder=\"user.search_associates_countries\" ng-enter=\"vm.searchUserCountry()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchUserCountry()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userCountryArray.length > 0\" ng-model=\"vm.isCheckAllUserCountry\" ng-change=\"vm.selectAllUserCountry()\">\n{{\'user.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggleAssociated(userCountry, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(departmentProduct)}\" ng-repeat=\"userCountry in vm.userCountryArray\" \nng-click=\"vm.toggleAssociated($event, userCountry)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(userCountry)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userCountry)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{userCountry.name}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'department.charging_products_allowed\'| translate}}...</span></div>\n<div layout=\"row\"><div paging class=\"pageable-div center\" page=\"vm.paginationUserCountry.pageNumber\" \nul-class=\"pagination\" page-size=\"vm.paginationUserCountry.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationUserCountry.getPage(page)\" total=\"vm.paginationUserCountry.totalElements\"></div></div>\n</div></div></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/department/department.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.departments\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input \nflex type=\"search\" ng-model=\"vm.inputSearchDepartment\" translate translate-attr-placeholder=\"user.search_departments\" \nng-enter=\"vm.searchDepartment()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchDepartment()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.departmentArray.length > 0\" ng-model=\"vm.isCheckAllDepartments\" \nng-change=\"vm.selectAllDepartments()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.departmentArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.code}} {{row.description}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchUserDepartment\" translate \ntranslate-attr-placeholder=\"user.search_associates_departments\" ng-enter=\"vm.searchUserDepartment()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchUserDepartment()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userDepartmentArray.length > 0\" ng-model=\"vm.isCheckAllUserDepartment\" \nng-change=\"vm.selectAllUserDepartments()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggleAssociated(userDepartment, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(departmentProduct)}\" \nng-repeat=\"userDepartment in vm.userDepartmentArray\" ng-click=\"vm.toggleAssociated($event, userDepartment)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociated(userDepartment)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelectedAssociated(userDepartment)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{userDepartment.department.code}} {{userDepartment.department.description}}</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationUserDepartment.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUserDepartment.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationUserDepartment.getPage(page)\" total=\"vm.paginationUserDepartment.totalElements\"></div>\n</div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/dialog-establishment-role-user/dialog-establishment-role-user.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'establishmentRoleUser.establishmentRoleUser\'| translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content style=\"padding: 5px 24px 24px 24px\"><fieldset><legend>\n{{\'establishmentRoleUser.associate_employee\' | translate}}</legend><div id=\"associate\" ng-if=\"!vm.employee\"><div \nlayout=\"row\" flex ng-if=\"vm.canAssociateWithoutEmployeeCode\"><md-switch ng-model=\"vm.withoutEmployeeCode\">\n{{\'establishmentRoleUser.withoutEmployeeCode\'| translate}}</md-switch></div><div layout=\"row\" flex \nng-if=\"!vm.withoutEmployeeCode\"><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\" flex>\n<div flex><div class=\"md-inline-form\" flex><md-card class=\"content-card\" flex><div layout-align=\"center center\"><div \nclass=\"search-list\" layout=\"row\" layout-align=\"start center\"><input style=\"padding: 10px\" flex type=\"search\" \nng-model=\"vm.inputSearchEmployeeCode\" placeholder=\"{{\'company_establishment.search_employee_code\'| translate}}\" \nng-enter=\"vm.getAllEmployeeByCompanyCode()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.getAllEmployeeByCompanyCode()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nstyle=\"height: 60px\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"item\" ng-class=\"{\'selected\': vm.employee.employeeId === employee.employeeId}\" \nng-repeat=\"employee in vm.employeeArray\"><div flex layout=\"row\" layout-align=\"start center\"><div><div class=\"notes\" \nlayout=\"column\"><span>{{employee.employeeId ? employee.employeeId + \' - \' : \'\'}}{{employee.fullName}}</span></div>\n</div></div></div></div></div></md-card></div><div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent md-button\" ng-click=\"vm.associateEmployeeToUser()\" \nng-disabled=\"vm.employeeArray.length===0 || vm.employeeArray.length>1 || vm.disableAssociateButton\"><span>\n{{\'company_establishment.associate_employee\'| translate}}</span><md-tooltip md-direction=\"left\">\n{{\'company_establishment.associate_employee\'| translate}}</md-tooltip></md-button></div></div></div></div></div></div>\n<div id=\"employee\" ng-if=\"vm.employee\" layout-align=\"center center\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"center center\"><h3>{{vm.employee.employeeCompanyCode}} - {{vm.employee.fullName}}</h3></div></div>\n</fieldset><fieldset><legend>{{\'establishmentRoleUser.associate_role\' | translate}}</legend><div layout=\"row\" \nflex=\"100\" ng-show=\"!vm.roleApplicationId\"><h3><label translate=\"establishmentRoleUser.selectRole\">Select Role:</label>\n</h3></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"establishmentRoleUser.role\">Role</label>\n<md-select ng-model=\"vm.roleApplicationId\" name=\"roleApplication\" ng-change=\"vm.loadEstablishmentRoleUser()\" \nng-disabled=\"(!vm.employee && !vm.withoutEmployeeCode)\"><md-option ng-repeat=\"row in vm.roles\" ng-value=\"{{row.id}}\">\n{{row.description}}</md-option></md-select></md-input-container></div><div class=\"content\" layout-xl=\"row\" \nlayout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" \nlayout-align-md=\"space-around center\" ng-show=\"vm.roleApplicationId\" style=\"padding-top: 15px\"><div flex-xl=\"45\" \nflex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.load\"><md-subheader class=\"md-no-sticky\">\n{{\'establishmentRoleUser.establishments\'| translate}} ({{vm.paginationEstablishment.totalElements}})</md-subheader><div\n class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.inputSearchCompanyEstablishment\" translate \ntranslate-attr-placeholder=\"establishmentRoleUser.searchCompanyEstablishment\" ng-enter=\"vm.getEstablishment()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.getEstablishment()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.establishmentArray.length > 0\" ng-model=\"vm.isCheckAllEstablishment\" ng-change=\"vm.selectAllEstablishment()\">\n{{\'establishmentRoleUser.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggle(row, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelected(row)}\" ng-repeat=\"row in vm.establishmentArray\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelected(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.internalCode}} ({{row.establishmentName}})</div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div \npaging class=\"pageable-div center\" page=\"vm.paginationEstablishment.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationEstablishment.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationEstablishment.getPage(page)\" total=\"vm.paginationEstablishment.totalElements\"></div></div>\n</div></div><div layout=\"column\"><md-button aria-label=\"Button disassociate establishment role user\" \nclass=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"establishmentRoleUser.disassociate\"| translate}}</md-tooltip></md-button><md-button \naria-label=\"Button associate establishment role user\" class=\"md-primary md-raised\" ng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"establishmentRoleUser.associate\"| translate}}</md-tooltip></md-button></div><div flex-xl=\"45\" flex-lg=\"45\" \nflex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.loadAssociated\"><md-subheader class=\"md-no-sticky\">\n{{\'establishmentRoleUser.associatedEstablishments\'| translate}} ({{vm.paginationEstablishmentRoleUser.totalElements}})\n</md-subheader><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.inputSearchCompanyEstablishmentRoleUser\" translate \ntranslate-attr-placeholder=\"establishmentRoleUser.searchAssociatedCompanyEstablishment\" \nng-enter=\"vm.getEstablishmentRoleUser()\"><md-button class=\"md-icon-button\" ng-click=\"vm.getEstablishmentRoleUser()\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.establishmentRoleUserArray.length > 0\" \nng-model=\"vm.isCheckAllEstablishmentRoleUser\" ng-change=\"vm.selectAllEstablishmentRoleUser()\">\n{{\'establishmentRoleUser.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggleAssociated(row2, $event)\" \nclass=\"item\" ng-class=\"{\'selected\': vm.isSelectedAssociated(row2)}\" ng-repeat=\"row2 in vm.establishmentRoleUserArray\" \nng-click=\"vm.toggleAssociated($event, row2)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(row2)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(row2)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{row2.internalCode}} ({{row2.establishmentName}})</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationEstablishmentRoleUser.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationEstablishmentRoleUser.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationEstablishmentRoleUser.getPage(page)\" \ntotal=\"vm.paginationEstablishmentRoleUser.totalElements\"></div></div></div></div></div></fieldset></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/usr/user/dialog-product-type-user/dialog-product-type-user.html","<md-dialog id=\"productType\" class=\"department-product\" aria-label=\"product type\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.productType\' | translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear></md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input \nflex type=\"search\" ng-model=\"vm.inputSearchProductType\" translate translate-attr-placeholder=\"user.searchProductType\">\n<md-button class=\"md-icon-button\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" layout-padding=\"10\"><md-checkbox ng-if=\"vm.productTypeArray.length > 0\" \nng-model=\"vm.isCheckAllProductType\" ng-change=\"vm.selectAllProductType()\">{{\'user.all\' | translate}}</md-checkbox>\n</div><div ng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.productTypeArray | filter:vm.inputSearchProductType\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelected(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.productTypeCode}} {{row.description}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span>{{\'user.cargando\' | translate}}...</span></div></div></div><div layout=\"column\"><md-button\n aria-label=\"Button disassociate\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null\n                 || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\" | translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null\n                 || vm.selectedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\" | translate}}\n</md-tooltip></md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchUserProductType\" translate \ntranslate-attr-placeholder=\"user.searchProductType\"><md-button class=\"md-icon-button\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nlayout-padding=\"10\"><md-checkbox ng-if=\"vm.userProductTypeArray.length > 0\" ng-model=\"vm.isCheckAllUserProductType\" \nng-change=\"vm.selectAllUserProductType()\">{{\'user.all\' | translate}}</md-checkbox></div><div \nng-click=\"vm.toggleAssociated(userProductType, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(userProductType)}\" \nng-repeat=\"userProductType in vm.userProductTypeArray | filter:vm.inputSearchUserProductType\" \nng-click=\"vm.toggleAssociated($event, userProductType)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(userProductType)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userProductType)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{userProductType.productType.productTypeCode}} {{userProductType.productType.description}}</div>\n</div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'user.cargando\' | translate}}...</span></div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/dialog-user-notification/dialog-user-notification.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.notifications\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.inputSearchNotAssociated\" translate translate-attr-placeholder=\"user.search_notification\" \nng-enter=\"vm.searchNotAssociated()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchNotAssociated()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.notAssociatedUserNotificationArray.length > 0\" \nng-model=\"vm.isCheckAllNotAssociated\" ng-change=\"vm.selectAllNotAssociated()\">{{\'user.all\'| translate}}</md-checkbox>\n</div><div ng-click=\"vm.toggleNotAssociated(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.notAssociatedUserNotificationArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.notificationTypeCode}} - {{row.notificationTypeDescription}}</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div>\n<div layout=\"row\" style=\"height: 77px\"><div paging class=\"pageable-div center\" \npage=\"vm.paginationNotAssociated.pageNumber\" ul-class=\"pagination\" page-size=\"vm.paginationNotAssociated.pageSize\" \nhide-if-empty=\"false\" paging-action=\"vm.paginationNotAssociated.getPage(page)\" \ntotal=\"vm.paginationNotAssociated.totalElements\"></div></div></div></div><div layout=\"column\"><md-button \naria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate user notification\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedNotAssociatedArray === undefiled || vm.selectedNotAssociatedArray === null || vm.selectedNotAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}\n</md-tooltip></md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll><div class=\"search\" layout=\"row\" layout-align=\"start center\">\n<input flex type=\"search\" ng-model=\"vm.inputSearchAssociated\" translate \ntranslate-attr-placeholder=\"user.search_associates_notification\" ng-enter=\"vm.searchAssociated()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchAssociated()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.associatedUserNotificationArray.length > 0\" ng-model=\"vm.isCheckAllAssociated\" \nng-change=\"vm.selectAllAssociated()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggleAssociated(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelectedAssociated(row)}\" \nng-repeat=\"row in vm.associatedUserNotificationArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">\n{{row.notificationType.notificationTypeCode}} - {{row.notificationType.notificationTypeDescription}}</div></div></div>\n</div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_allowed\'| translate}}...</span></div><div layout=\"row\" style=\"height: 77px\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationAssociated.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationAssociated.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationAssociated.getPage(page)\" total=\"vm.paginationAssociated.totalElements\"></div></div></div>\n</div></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/dimension-company/dimension-company.html","<md-dialog class=\"department-product\" aria-label=\"dimension settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.dimensionCompany\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div layout=\"row\" layout-align=\"center center\"><md-input-container flex=\"95\"><label \ntranslate=\"dimensions.select_dimension_company\">Dimensions</label><md-select ng-model=\"vm.dimensionCompanyId\" \nname=\"app\" ng-change=\"vm.getDimensionCompany();\"><md-option ng-repeat=\"row in vm.dimensionCompanyList\" \nng-value=\"row.id\">{{row.description}}</md-option></md-select></md-input-container></div><div class=\"content\" \nlayout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" \nlayout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div flex-xl=\"45\" flex-lg=\"45\" \nflex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.inputSearchDimensionCompany\" translate translate-attr-placeholder=\"dimensions.search_dimensionCompany\">\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.dimensionCompanyArray.length > 0\" ng-model=\"vm.isCheckAllDimensionCompany\" \nng-change=\"vm.selectAllDimensionCompany()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.dimensionCompanyArray | filter: vm.inputSearchDimensionCompany\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelected(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.code}} {{row.name}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'dimensions.loading\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchUserDimensionCompany\" translate \ntranslate-attr-placeholder=\"dimensions.search_associates_dimensionCompany\"></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.userDimensionCompanyArray.length > 0\" \nng-model=\"vm.isCheckAllUserDimensionCompany\" ng-change=\"vm.selectAllUserDimensionCompany()\">{{\'user.all\'| translate}}\n</md-checkbox></div><div ng-click=\"vm.toggleAssociated(userDimensionCompany, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(dimensionCompanyUser)}\" \nng-repeat=\"userDimensionCompany in vm.userDimensionCompanyArray\n               | filter: vm.inputSearchUserDimensionCompany\" \nng-click=\"vm.toggleAssociated($event, userDimensionCompanyProd)\"><div layout=\"row\" layout-align=\"start center\"><md-icon\n ng-if=\"vm.isSelectedAssociated(userDimensionCompany)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userDimensionCompany)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{userDimensionCompany.code}} {{userDimensionCompany.name}}</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'dimensions.loading\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.paginationUserDimensionCompany.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUserDimensionCompany.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationUserDimensionCompany.getPage(page)\" \ntotal=\"vm.paginationUserDimensionCompany.totalElements\"></div></div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/operaciones-warehouses/operaciones-warehouses.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.wareHousesByUser\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input \nflex type=\"search\" ng-model=\"vm.inputSearchWarehouses\" translate \ntranslate-attr-placeholder=\"warehouse.search_warehouse\" ng-enter=\"vm.searchWarehouses()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchWarehouses()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.warehousesArray.length > 0\" ng-model=\"vm.isCheckAllWarehouses\" ng-change=\"vm.selectAllWarehouses()\">\n{{\'user.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggle(row, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelected(row)}\" ng-repeat=\"row in vm.warehousesArray\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelected(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.code}} {{row.name}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'user.cargando\'| translate}}...</span></div></div></div><div layout=\"column\"><md-button \naria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedDataArray === undefined ||\n                vm.selectedAssociatedDataArray === null ||\n                vm.selectedAssociatedDataArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedDataArray === undefiled ||\n                vm.selectedDataArray === null\n                || vm.selectedDataArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}\n</md-tooltip></md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchUserWarehouses\" translate \ntranslate-attr-placeholder=\"warehouse.search_associates_warehouse\" ng-enter=\"vm.searchUserWarehouses()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchUserWarehouses()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userWarehousesArray.length > 0\" ng-model=\"vm.isCheckAllUserWarehouses\" \nng-change=\"vm.selectAllUserWarehouses()\">{{\'user.all\'| translate}}</md-checkbox></div><div class=\"item\" \nng-repeat=\"userWarehouses in vm.userWarehousesArray\" layout=\"row\"><div flex \nng-click=\"vm.toggleAssociated(userWarehouses, $event)\" layout-align=\"start center\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(departmentProduct)}\" layout=\"row\"><md-icon \nng-if=\"vm.isSelectedAssociated(userWarehouses)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userWarehouses)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{userWarehouses.code}} {{userWarehouses.name}}</div></div><md-input-container flex><label>\n{{\"user.role\"|translate}}</label><md-select ng-model=\"userWarehouses.roleApplicationId\" name=\"roleId\" \nmd-on-close=\"vm.searchRoleAplication = \'\'\" ng-change=\"vm.updateRole(userWarehouses)\" \nng-disabled=\"vm.updatingUserWarehouse\"><md-select-header><input id=\"searchRoleAplication\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchRoleAplication\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"groups\"><md-option \nng-value=\"{{data.id}}\" ng-repeat=\"data in vm.roleApplications| filter:vm.searchRoleAplication\">{{data.description}}\n</md-option></md-optgroup></md-select></md-input-container></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'userWarehouses.charging_warehouse_allowed\'| translate}}...</span>\n</div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/parameter/parameter.html","<md-dialog class=\"department-product\" aria-label=\"department settings\" \nstyle=\"width: 60%; height: 70%; min-height: 450px\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1><label translate=\"user.parameters\">Parameters</label></h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><div ng-repeat=\"(key, value) in vm.content | groupBy: \'user.id\'\"><div \nstyle=\"padding-top: 20px; background: #fff0ff\"></div><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-options=\"vm.dtOptionsParameters\"><thead><tr><th style=\"padding-top: 10px; padding-bottom: 10px; width: 50%\"><span \ntranslate=\"company_parameters.description\"></span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 40%\">\n<span translate=\"company_parameters.value\"></span></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\">\nOpciones</th></tr></thead><tbody><tr ng-repeat=\"player in value\"><td style=\"padding:0; width: 50%\">\n{{player.applicationParameter.parameterDescription}}</td><td style=\"padding:0; width: 40%\"><div \nng-if=\"player.applicationParameter.dataType===\'TEXT\'\"><input id=\"documentNumber\" autocomplete=\"off\" \nng-model=\"player.userParameterValue\" style=\"text-align: left; width: 100%\"></div><div \nng-if=\"player.applicationParameter.dataType===\'NUMBER\'\"><input id=\"documentNumber\" numbers-only=\"numbers-only\" \nautocomplete=\"off\" ng-model=\"player.userParameterValue\" style=\"text-align: right\"></div><div \nng-if=\"player.applicationParameter.dataType===\'DECIMAL\'\"><input ng-model=\"player.userParameterValue\" type=\"number\" \nname=\"rate\" required min=\"0.01\" max=\"vm.promotion.rate+1\" style=\"text-align: right\"></div><div \nng-if=\"player.applicationParameter.dataType===\'COLOR\'\"><div md-color-picker random=\"true\" open-on-input=\"true\" \nng-model=\"player.userParameterValue\" default=\"#f00\" md-color-generic-palette=\"false\" md-color-history=\"false\">\n{{player.userParameterValue}}</div></div><div ng-if=\"player.applicationParameter.dataType===\'BOOLEAN\'\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox ng-model=\"player.userParameterValue\" aria-label=\"chk\"></md-checkbox></div>\n</td><td style=\"padding:0; width: 10%\"><div><md-button class=\"md-icon-button\" \nng-click=\"vm.updateParameterValue(player)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon></md-button></div></td>\n</tr></tbody></table></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/roles/roles.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.roles\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content style=\"padding: 5px 24px 24px 24px\"><div layout=\"row\" flex=\"100\" ng-show=\"!vm.appId\">\n<h3><label translate=\"guest.selectApp\">Seleccione una Aplicación:</label></h3></div><div layout=\"row\">\n<md-input-container flex=\"100\"><label translate=\"guest.application\">Aplicación</label><md-select ng-model=\"vm.appId\" \nname=\"app\" ng-change=\"vm.getInfoByApp(app);\"><md-option ng-repeat=\"app in vm.applications\" \nvalue=\"{{app.application.id}}\">{{app.application.name}}</md-option></md-select></md-input-container></div><div \nclass=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" \nlayout-align-lg=\"space-around center\" layout-align-md=\"space-around center\" ng-show=\"vm.appId\"><div flex-xl=\"45\" \nflex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.load\"><md-subheader class=\"md-no-sticky\">{{\'user.roles\'| translate}} ({{vm.pagination.totalElements}})\n</md-subheader><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.roleArray.length > 0\" ng-model=\"vm.isCheckAllRole\" ng-change=\"vm.selectAllRoles()\">{{\'user.all\'| translate}}\n</md-checkbox></div><div ng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.roleArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.description}} ({{row.name}})\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><md-subheader \nclass=\"md-no-sticky\">{{\'user.associated_roles\'| translate}} ({{vm.paginationUserRole.totalElements}})</md-subheader>\n<div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userRoleArray.length > 0\" ng-model=\"vm.isCheckAllUserRole\" ng-change=\"vm.selectAllUserRoles()\">\n{{\'user.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggleAssociated(userRole, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(userRole)}\" ng-repeat=\"userRole in vm.userRoleArray\" \nng-click=\"vm.toggleAssociated($event, userRole)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(userRole)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userRole)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{userRole.businessCircle.role.description}} ({{userRole.businessCircle.role.name}})</div></div>\n</div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationUserRole.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUserRole.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.paginationUserRole.getPage(page)\" \ntotal=\"vm.paginationUserRole.totalElements\"></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/usr/user/tickets-group/tickets-group.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'ticketsGroup.title\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content style=\"padding: 5px 24px 24px 24px\"><div layout=\"row\" flex=\"100\" \nng-show=\"!vm.departmentId\"><h3><label translate=\"ticketsGroup.selectDepartment\">Seleccione un Departamento:</label>\n</h3></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"ticketsGroup.department\">Departamento\n</label><md-select ng-model=\"vm.departmentId\" name=\"department\" ng-change=\"vm.getInfoByDepartment(department);\">\n<md-option ng-repeat=\"department in vm.deparments\" value=\"{{department.id}}\">{{department.description}}</md-option>\n</md-select></md-input-container></div><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\" \nng-show=\"vm.departmentId\"><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><md-subheader class=\"md-no-sticky\">\n{{\'ticketsGroup.groups\'| translate}} ({{vm.pagination.totalElements}})</md-subheader><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.groupArray.length > 0\" \nng-model=\"vm.isCheckAll\" ng-change=\"vm.selectAll()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.groupArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.groupName}}</div></div></div>\n</div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><md-subheader \nclass=\"md-no-sticky\">{{\'ticketsGroup.associated_groups\'| translate}} ({{vm.paginationUserGroup.totalElements}})\n</md-subheader><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userGroupArray.length > 0\" ng-model=\"vm.isCheckAllUserRole\" ng-change=\"vm.selectAllUserRoles()\">\n{{\'user.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggleAssociated(userRole, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(userRole)}\" ng-repeat=\"userRole in vm.userGroupArray\" \nng-click=\"vm.toggleAssociated($event, userRole)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(userRole)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userRole)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{userRole.ticketDepartmentGroup.groupName}}</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationUserGroup.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUserGroup.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.paginationUserGroup.getPage(page)\" \ntotal=\"vm.paginationUserGroup.totalElements\"></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/usr/user/user-list/user-list.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"ul.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><div flex=\"30\" flex-xs=\"100\"><span \nstyle=\"font-size: 25px; color: white; padding-left: 10px\">{{\'user.users\'| translate}} ({{ul.pagination.totalElements}})\n</span></div><div flex=\"30\" flex-xs=\"100\" ng-if=\"ul.pagination.totalElements > 0 || ul.showSearch\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input \nflex=\"85\" type=\"search\" placeholder=\"{{\'user.search_users\' | translate}}\" ng-model=\"ul.inputSearch\" \nng-enter=\"ul.search()\"><md-button ng-click=\"ul.search()\">{{\'general.search\' | translate}}</md-button></div></div></div>\n<div layout=\"row\"><div flex=\"100\"><md-card><div id=\"usersGrid\" ag-grid=\"ul.grid\" class=\"ag-fresh\" expand-grid \nmin=\"100\" other=\"-30\" ng-show=\"ul.showGrid\"></div></md-card></div></div>");
$templateCache.put("app/main/general/auth/directives/strengthPassword/strengthPassword.tpl.html","<div class=\"password-strength\"><div class=\"password-strength-label\">\n{{strengthLabel || \'js.passwordStrength\' | translate}}</div><div class=\"bar-container\"><div \nclass=\"bar {{strengthLevel}}\" style=\"width: {{lengthLevel}}%\"></div></div></div>");
$templateCache.put("app/main/apps/usr/user/company-establishment/company-establishment.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.companyEstablishment\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input \nflex type=\"search\" ng-model=\"vm.inputSearchCompanyEstablishment\" translate \ntranslate-attr-placeholder=\"user.search_company_establishment\" ng-enter=\"vm.searchCompanyEstablishment()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchCompanyEstablishment()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.companyEstablishmentArray.length > 0\" ng-model=\"vm.isCheckAllCompanyEstablishment\" \nng-change=\"vm.selectAllCompanyEstablishment()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.companyEstablishmentArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.internalCode}} - {{row.establishmentName}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div \npaging class=\"pageable-div center\" page=\"vm.pagination.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.pagination.getPage(page)\" \ntotal=\"vm.pagination.totalElements\"></div></div></div></div><div layout=\"column\"><md-button \naria-label=\"Button disassociate company establishment\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate company establishment\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchUserCompanyEstablishment\" translate \ntranslate-attr-placeholder=\"user.search_associates_company_establishment\" \nng-enter=\"vm.searchUserCompanyEstablishment()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.searchUserCompanyEstablishment()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userCompanyEstablishmentArray.length > 0\" ng-model=\"vm.isCheckAllUserCompanyEstablishment\" \nng-change=\"vm.selectAllUserCompanyEstablishment()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggleAssociated(userCompanyEstablishment, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(departmentProduct)}\" \nng-repeat=\"userCompanyEstablishment in vm.userCompanyEstablishmentArray\" \nng-click=\"vm.toggleAssociated($event, userCompanyEstablishment)\"><div layout=\"row\" layout-align=\"start center\"><md-icon\n ng-if=\"vm.isSelectedAssociated(userCompanyEstablishment)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userCompanyEstablishment)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div \nflex class=\"product-name\">{{userCompanyEstablishment.internalCode}} - {{userCompanyEstablishment.establishmentName}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationUserCompanyEstablishment.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUserCompanyEstablishment.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationUserCompanyEstablishment.getPage(page)\" \ntotal=\"vm.paginationUserCompanyEstablishment.totalElements\"></div></div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/usr/user/cost-center/cost-center.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'user.cost_center\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input \nflex type=\"search\" ng-model=\"vm.inputSearchCostCenter\" translate translate-attr-placeholder=\"user.search_cost_center\" \nng-enter=\"vm.searchCostCenter()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchCostCenter()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.costCenterArray.length > 0\" ng-model=\"vm.isCheckAllCostCenter\" \nng-change=\"vm.selectAllCostCenter()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.costCenterArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.code}} {{row.description}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchUserCostCenter\" translate \ntranslate-attr-placeholder=\"user.search_associates_cost_center\" ng-enter=\"vm.searchUserCostCenter()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchUserCostCenter()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userCostCenterArray.length > 0\" ng-model=\"vm.isCheckAllUserCostCenter\" \nng-change=\"vm.selectAllUserCostCenter()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggleAssociated(userCostCenter, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(departmentProduct)}\" \nng-repeat=\"userCostCenter in vm.userCostCenterArray\" ng-click=\"vm.toggleAssociated($event, userCostCenter)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociated(userCostCenter)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelectedAssociated(userCostCenter)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{userCostCenter.costCenter.code}} {{userCostCenter.costCenter.description}}</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationUserCostCenter.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUserCostCenter.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationUserCostCenter.getPage(page)\" total=\"vm.paginationUserCostCenter.totalElements\"></div>\n</div></div></div></div></md-dialog>");
$templateCache.put("app/main/general/notifications/my-notifications/filter/filter.html","<div layout=\"row\" layout-align=\"end center\" class=\"toolbar-advanced-search\"><md-button class=\"md-icon-button\" \ntitle=\"{{\'notifications.clear_filters\' | translate}}\" ng-click=\"filterCtrl.clearFilters()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18 md-warn\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntitle=\"{{\'general.close\' | translate}}\" ng-click=\"vm.showAdvancedFilter = false\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s18\"></md-icon></md-button></div><div layout=\"row\"><md-input-container flex><label>\n{{\'notifications.company\' | translate}}</label><md-select ng-model=\"vm.filter.companies\" multiple=\"multiple\" \nmd-on-close=\"filterCtrl.clearSearchCompany()\"><md-select-header><input id=\"searchCompanyInput\" \nng-model=\"filterCtrl.searchCompany\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"Companies\"><md-option ng-value=\"company.id\" \nng-repeat=\"company in filterCtrl.companyArray | filter : filterCtrl.searchCompany\">{{company.name}}</md-option>\n</md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"filterCtrl.loadingCompanies\">\n</md-progress-linear></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\n{{\'notifications.application\' | translate}}</label><md-select ng-model=\"vm.filter.applications\" multiple=\"multiple\" \nmd-on-close=\"filterCtrl.clearSearchApplication()\"><md-select-header><input id=\"searchApplicationInput\" \nng-model=\"filterCtrl.searchApplication\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"Applications\"><md-option ng-value=\"application.id\" \nng-repeat=\"application in $root.myApps | filter : filterCtrl.searchApplication\">{{application.name}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"row\"><md-switch ng-model=\"vm.filter.filterByDates\" \naria-label=\"filter by dates\">{{\'notifications.filter_by_dates\' | translate}}</md-switch></div><fieldset \nng-if=\"vm.filter.filterByDates\"><legend>{{\'notifications.dates_range\' | translate}}</legend><div layout=\"row\"><div \nflex layout=\"row\" layout-align=\"center center\"><md-datepicker ng-model=\"vm.filter.startDate\" \nng-change=\"filterCtrl.changeStartDate(true)\" md-placeholder=\"{{\'notifications.start_date\' | translate}}\">\n</md-datepicker></div><div flex layout=\"row\" layout-align=\"center center\"><md-datepicker ng-model=\"vm.filter.endDate\" \nng-change=\"filterCtrl.changeStartDate(true)\" md-placeholder=\"{{\'notifications.end_date\' | translate}}\"></md-datepicker>\n</div></div></fieldset><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-click=\"filterCtrl.search($event)\">{{\'general.search\' | translate}}</md-button></div>");
$templateCache.put("app/main/general/notifications/my-notifications/content/content.html","<div class=\"notifications-header\" layout=\"row\"><div flex layout=\"row\" layout-align=\"start center\"><md-checkbox \naria-label=\"select all notifications\" ng-model=\"vm.selectAllNotifications\" \nng-checked=\"vm.selectedNotifications.length > 0\" ng-click=\"vm.toggleSelectNotifications()\" \ntitle=\"{{\'notifications.select_all_notifications\'| translate}}\"></md-checkbox><md-button title=\"Marcar como leído\" \nclass=\"md-icon-button\" ng-if=\"vm.selectedNotifications.length > 0\" aria-label=\"mark as read\" \nng-click=\"vm.markAsRead(vm.selectedNotifications)\"><md-icon style=\"color: green\" md-font-icon=\"icon-check\"></md-icon>\n</md-button><md-button title=\"Marcar todas las notificaciones como leídas\" class=\"md-icon-button\" \nng-if=\"vm.myNotificationsArray.length > 0 && $root.totalNumberOfNotifications > 0\" aria-label=\"mark all as read\" \nng-click=\"vm.markAllAsRead()\"><md-icon style=\"color: green\" md-font-icon=\"icon-check-all\"></md-icon></md-button></div>\n<div flex layout=\"row\" layout-align=\"end center\"><md-switch md-invert ng-model=\"vm.filter.onlyUnread\" \nng-change=\"vm.getMyNotifications()\" aria-label=\"show only unread notifications\" \ntitle=\"{{\'notifications.filter_by_unread\'| translate}}\">{{\'notifications.filter_by_unread\'| translate}}</md-switch>\n<span class=\"page-info\" hide-sm>\n{{ (vm.pagination.pageNumber * vm.pagination.pageSize) - (vm.pagination.pageSize - 1)}} - {{ (vm.pagination.totalElements > vm.pagination.pageSize) ? (vm.pagination.pageSize * vm.pagination.pageNumber) : vm.pagination.numberOfElements}} {{\'general.of\' | translate}} {{vm.pagination.totalElements}}\n</span><md-button title=\"{{\'notifications.before_page\'| translate}}\" class=\"md-icon-button arrow\" \naria-label=\"Previous\" ng-click=\"vm.pagination.beforePage()\" ng-disabled=\"vm.pagination.pageNumber === 1\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button title=\"{{\'notifications.next_page\'| translate}}\" \nclass=\"md-icon-button arrow\" aria-label=\"Next\" ng-click=\"vm.pagination.nextPage()\" \nng-disabled=\"vm.pagination.pageNumber === vm.pagination.totalPages || vm.pagination.totalPages === 0\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><div class=\"notifications-list\" ms-scroll flex><div\n class=\"notifications-content\"><div class=\"notification\" ng-class=\"{\'unread\': !notification.markedAsRead}\" \nng-repeat=\"notification in vm.myNotificationsArray| filter:vm.searchInput\" layout=\"row\" layout-align=\"start center\" \nng-click=\"vm.showNotification($event, notification)\"><div layout=\"column\" flex><div class=\"notification-info\" \nlayout=\"row\" layout-align=\"start center\"><md-checkbox ng-checked=\"vm.isSelectedNotification(notification)\" \nng-click=\"vm.toggleSelectNotification(notification, $event)\" \naria-label=\"{{vm.isSelectedNotification(notification) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div flex \nlayout=\"column\"><div class=\"applicationFrom\">\n{{\'notifications.application\'| translate}}: {{notification.application.name}}</div><div class=\"userFrom\" \nng-if=\"notification.userFrom\">\n{{\'notifications.from\'| translate}}: {{notification.userFrom.name}}({{notification.userFrom.account}})</div><div \nng-if=\"notification.originType !== null && notification.originType !== undefined\">\n{{notification.originType.originTypeName}}: {{notification.referenceNumber}}</div></div><div flex layout=\"column\"><div \nlayout=\"row\" layout-align=\"end center\"><div class=\"notification-date\">\n{{notification.createdAt| apiDate: \'dd-MM-yyyy HH:mm\'}}</div></div><div class=\"icon-alert-type\" \nng-class=\"{\'warning-type\': notification.notificationType.alertType === \'WARNING\', \'error-type\': notification.notificationType.alertType === \'ERROR\', \'success-type\': notification.notificationType.alertType === \'SUCCESS\', \'message-type\': notification.notificationType.alertType === \'MESSAGE\'}\" \nlayout=\"row\" layout-align=\"end center\"><md-icon md-font-icon=\"icon-message-text\" class=\"s20\" \nng-if=\"notification.notificationType.alertType === \'MESSAGE\'\"></md-icon><md-icon md-font-icon=\"icon-check\" class=\"s20\" \nng-if=\"notification.notificationType.alertType === \'SUCCESS\'\"></md-icon><md-icon md-font-icon=\"icon-alert\" class=\"s20\" \nng-if=\"notification.notificationType.alertType === \'WARNING\'\"></md-icon><md-icon md-font-icon=\"icon-cancel\" \nclass=\"s20\" ng-if=\"notification.notificationType.alertType === \'ERROR\'\"></md-icon></div></div></div><div \nclass=\"notification-message-preview\" ng-if=\"vm.currentNotification.id !== notification.id\">\n{{notification.message| topCharactersHtml: 100}}...</div><div class=\"notification-message\" \nng-if=\"vm.currentNotification.id === notification.id\" ng-bind-html=\"notification.message\"></div></div></div></div>\n</div>");
$templateCache.put("app/main/general/notifications/configuration/content/content.html","<div id=\"notification-configuration-grid\" ag-grid=\"vm.gridOptions\" class=\"ag-fresh\" ng-show=\"vm.showGrid\" \nstyle=\"width: 100%; height: 100%\"></div>");
$templateCache.put("app/main/general/profile/tabs/password/password.html","<div layout=\"row\" layout-wrap layout-align=\"center center\"><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><form \nname=\"changePasswordForm\" class=\"md-inline-form\" novalidate><div class=\"about\" layout=\"column\" flex=\"200\" \nflex-gt-sm=\"100\" flex-gt-md=\"130\"><div class=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\"><div layout=\"row\"><div class=\"title\" translate=\"PROFILE.CHANGE_PASSWORD\">Change Password</div>\n<span flex></span><md-button type=\"submit\" class=\"md-raised md-warn\" \nng-disabled=\"changePasswordForm.$invalid || changePasswordForm.$pristine\" ng-click=\"vm.sendFormChangePassword();\"><span\n translate=\"PROFILE.EDIT.CHANGE\">Change</span></md-button></div></header><div class=\"content\" layout=\"column\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" name=\"password\" id=\"password\" \nng-model=\"vm.pass.newPassword\" placeholder=\"{{\'PROFILE.EDIT.NEW_PASSWORD\'| translate}}\" ng-required=\"true\">\n</md-input-container><div my-password-strength password=\"vm.pass.newPassword\"></div><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"password\" name=\"passwordConfirm\" \nplaceholder=\"{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}})\" \nng-model=\"vm.pass.validatePassword\" pw-check=\"password\" ng-required=\"true\"><div \nng-messages=\"wizardStep12.passwordConfirm.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.REQUIRED\'| translate}}.\n</span></div><div ng-message=\"pattern\"><span>\n{{\'PROFILE.EDIT.PASSWORD\'| translate}} ({{\'PROFILE.EDIT.CONFIRM\'| translate}}) {{\'PROFILE.EDIT.MATCH\'| translate}}.\n</span></div></div></md-input-container></div></div></div></form></div></div>");
$templateCache.put("app/main/general/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\" alt=\"image\"><div class=\"title\">{{media.title}}</div></div></div>\n</div></div>");
$templateCache.put("app/main/general/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\" alt=\"image\"><div layout=\"column\"><div class=\"title\"><span \nclass=\"username md-accent-color\">{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" \ntranslate=\"PROFILE.TYPE_POST\">posted on your timeline</span> <span ng-if=\"post.type == \'something\'\" \ntranslate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> <span ng-if=\"post.type == \'video\'\" \ntranslate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span ng-if=\"post.type == \'article\'\" \ntranslate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div class=\"time\">{{post.time}}</div></div>\n</div><md-button class=\"md-icon-button\" aria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div class=\"content\"><div ng-if=\"post.message\" \nclass=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\"><img ng-if=\"post.media.type === \'image\'\" \nng-src=\"{{post.media.preview}}\" alt=\"image\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\" alt=\"image\"></div><div class=\"title\">{{post.article.title}}\n</div><div class=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div>\n<div layout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span \ntranslate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>({{post.like}})</span></div></md-button><md-button \nclass=\"share-button\"><div layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-share\" class=\"s16\">\n</md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>({{post.share}})</span></div></md-button></div></div>\n<footer class=\"\" layout=\"column\" layout-align=\"start start\"><div ng-if=\"post.comments\" class=\"comment-count\">\n{{post.comments.length}} comments<md-icon md-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" \nlayout=\"row\" layout-fill ng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\" \nalt=\"image\"><div flex layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><span class=\"username\">\n{{comment.user.name}}</span> <span class=\"time\">{{comment.time}}</span></div><div class=\"message\">{{comment.message}}\n</div><div class=\"actions\" layout=\"row\" layout-align=\"space-between center\"><a href=\"#\" \nclass=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply</a><md-icon flex md-font-icon=\"icon-flag\" \nclass=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" layout=\"row\" layout-fill><img \nsrc=\"assets/images/avatars/profile.jpg\" class=\"avatar\" alt=\"image\"><form flex><textarea placeholder=\"Add a comment...\" \ntranslate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button ng-click=\"\" \nclass=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/general/profile/tabs/userGroups/userGroups.html","<div layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"content fullpage-datatable\" layout=\"column\" \nflex><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loading\" class=\"md-accent\"></md-progress-linear><div \nid=\"groupsGrid\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"-30\"></div></div></div>\n<md-button class=\"md-fab md-fab-bottom-right\" aria-label=\"addBudget\" style=\"position: fixed\" \nng-click=\"vm.addNewGroup()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/general/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><form name=\"wizardStep1\" \nclass=\"md-inline-form\" novalidate><div class=\"about\" layout=\"column\" flex=\"200\" flex-gt-sm=\"100\" flex-gt-md=\"130\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div \nng-class=\"vm.editMode ? \'\' : \'info-line\'\"><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.FULLNAME\">\nFullname</div><div class=\"info\">\n{{vm.userInfo.name}} {{vm.userInfo.middleName}} {{vm.userInfo.familyName}} {{vm.userInfo.givenName}}</div></div><div \nlayout=\"row\" layout-sm=\"column\"><md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.userInfo.name\" placeholder=\"{{\'PROFILE.EDIT.NAME\'| translate}}\" \nng-disabled=\"!vm.editMode\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'PROFILE.EDIT.NAME\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}.</span></div>\n</div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"50\"><input type=\"text\" \nname=\"middlename\" ng-model=\"vm.userInfo.middleName\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.SNAME\'| translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\">\n<md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"50\"><input type=\"text\" name=\"familyName\" \nng-model=\"vm.userInfo.familyName\" ng-disabled=\"!vm.editMode\" placeholder=\"{{\'PROFILE.EDIT.LASTNAME\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"50\"><input type=\"text\" \nname=\"givenName\" ng-model=\"vm.userInfo.givenName\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.TNAME\'| translate}}\"></md-input-container></div><div layout=\"row\" layout-sm=\"column\">\n<md-input-container flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"50\"><input type=\"text\" name=\"nickname\" \nng-model=\"vm.userInfo.nickname\" ng-disabled=\"!vm.editMode\" placeholder=\"{{\'PROFILE.EDIT.NICKNAME\'| translate}}\">\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label>{{\'PROFILE.EDIT.GENDER\'| translate}}</label>\n<md-select ng-model=\"vm.userInfo.gender\" ng-disabled=\"!vm.editMode\"><md-option ng-repeat=\"gender in vm.genders\" \nvalue=\"{{gender}}\">{{\'SEXO.\' + gender| translate}}</md-option></md-select></md-input-container></div>\n<md-input-container class=\"md-block\"><label translate=\"PROFILE.BIRTHDAY\">birthdate</label><md-datepicker \nng-model=\"vm.userInfo.birthdate\" name=\"birthday\" md-open-on-focus ng-disabled=\"!vm.editMode\"></md-datepicker><div \nng-messages=\"vm.wizardStep1.birthday.$error\"><div ng-message=\"valid\" translate=\"PROFILE.INVALID_DATE\">\nThe entered value is not a date!</div><div ng-message=\"required\">\n{{\'PROFILE.BIRTHDAY\'| translate}} {{\'PROFILE.EDIT.REQUIRED\'| translate}}</div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>{{\'PROFILE.ABOUT_ME\'| translate}}</label><textarea rows=\"3\" name=\"profile\" \nmd-maxlength=\"150\" max-rows=\"5\" ng-disabled=\"!vm.editMode\" ng-model=\"vm.userInfo.profile\">\n                                </textarea></md-input-container><md-input-container class=\"md-block\" ng-if=\"true\">\n<input id=\"fileInput\" type=\"file\" class=\"ng-hide\" name=\"photo\" aria-label=\"fileInput\" ng-disabled=\"!vm.editMode\" \nfile-model=\"vm.filesToUpload\" accept=\"image/jpeg, image/jpg\"><md-button class=\"md-raised md-button\" \nng-click=\"uploadf3()\" ng-disabled=\"!vm.editMode\" ng-show=\"vm.editMode\" translate=\"PROFILE.SELECT_PICTURE\"><md-icon \nmd-svg-icon=\"border-color\"></md-icon><label>AwesomeButtonName</label></md-button></md-input-container></div></div>\n</div><div class=\"profile-box company md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.EMPRESAS\">Empresas</div></header><div \nclass=\"content-wrapper\" layout=\"column\" flex><div class=\"content thread-list\" ms-scroll flex><div class=\"thread\" \nmd-ink-ripple style=\"cursor: pointer\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex><ul><li \nng-repeat=\"c in vm.company\"><strong><span>{{c.name}}</span> </strong>({{c.email}})</li></ul></div></div></div></div>\n</div></div></div></form></div><div flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"50\"><form name=\"wizardStep2\" \nclass=\"md-inline-form\" novalidate><div class=\"about\" layout=\"column\" flex=\"200\" flex-gt-sm=\"100\" flex-gt-md=\"130\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div layout=\"row\">\n<div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\">{{vm.userInfo.email}}</div></div><div \nlayout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"70\" flex-gt-md=\"70\"><label>\n{{\'PROFILE.EDIT.ADDRESS\'| translate}}</label><textarea rows=\"1\" name=\"address\" md-maxlength=\"150\" max-rows=\"3\" \nng-disabled=\"!vm.editMode\" ng-model=\"vm.userInfo.locale\">\n                                </textarea>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><label>\n{{\'PROFILE.EDIT.POSTAL\'| translate}}</label><input name=\"postalcode\" ng-model=\"vm.userInfo.zoneinfo\" \nplaceholder=\"12345\" ng-disabled=\"!vm.editMode\" ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"wizardStep1.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><input type=\"tel\" name=\"phone\" ng-model=\"vm.userInfo.phoneNumber\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.PHONE\'| translate}}\"></md-input-container><md-input-container class=\"md-block\"><input \ntype=\"url\" name=\"website\" ng-model=\"vm.userInfo.website\" ng-disabled=\"!vm.editMode\" \nplaceholder=\"{{\'PROFILE.EDIT.WEBSITE\'| translate}}\"></md-input-container></div></div></div></form></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item {{\'stepButton\' + stepInfo.stepNumber}}\" aria-label=\"clic\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">\n{{MsStepper.backDescriptionButton}}</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">\n{{MsStepper.nextDescriptionButton}}</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\">\n{{MsStepper.submitDescriptionButton}}</md-button></div>");
$templateCache.put("app/main/apps/account/accounting-entry/accounting-entry-config-detail/dialog-detail/dialog-detail.html","<md-dialog aria-label=\"Crear-Editar\" ng-style=\"vm.dinamicStyle\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1>\n{{vm.accountEntry.id ? \'general.edit\' : \'general.add\'| translate}} {{\'accountingEntry.accountingEntryConfigDetail\' | translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><ng-form name=\"vm.accountEntryForm\" \nid=\"accountEntryForm\"><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'accountingEntry.accountType\' | translate}}</label><md-select \nng-model=\"vm.accountingEntryConfigDetail.accountType.id\" required ng-change=\"vm.validateTemplateIds()\">\n<md-select-header><input id=\"searchAccountType\" ng-model=\"vm.searchAccountType\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" ng-keydown=\"$event.stopPropagation();\"></md-select-header><md-optgroup>\n<md-option ng-value=\"r.id\" ng-repeat=\"r in vm.accountTypes | filter:vm.searchAccountType\">\n{{r.acTypeCode}} - {{r.acTypeDescription}}</md-option></md-optgroup></md-select></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"100\"><label>{{\'accountingEntry.accountingEntryTypeTemplate\' | translate}}\n</label><md-select ng-model=\"vm.accountingEntryConfigDetail.accountingEntryTypeTemplate.id\" required><md-select-header>\n<input id=\"searchAccountingEntryTypeTemplates\" ng-model=\"vm.searchAccountingEntryTypeTemplates\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\" ng-keydown=\"$event.stopPropagation();\"></md-select-header>\n<md-optgroup><md-option ng-value=\"r.id\" \nng-repeat=\"r in vm.accountingEntryTypeTemplates | filter: vm.searchAccountingEntryTypeTemplates\">\n{{r.actTemplateCode}} - {{r.actTemplateName}}</md-option></md-optgroup></md-select></md-input-container></div>\n</ng-form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\">\n{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/department/department/products/department-product.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'department.products_allowed\'| translate}}</h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.loadProducts\"><div class=\"search\" layout=\"row\" layout-align=\"start center\">\n<input flex type=\"search\" ng-model=\"vm.searchProductInput\" translate translate-attr-placeholder=\"general.search\" \nng-enter=\"vm.searchProduct()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchProduct()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div ng-click=\"vm.toggleProduct(product, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedProduct(product)}\" ng-repeat=\"product in vm.productArray\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedProduct(product)\" md-font-icon=\"icon-checkbox-marked\">\n</md-icon><md-icon ng-if=\"!vm.isSelectedProduct(product)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div \nflex class=\"product-name\">\n{{product.name}} {{product.brand ? \'-\' + product.brand.name : \'\'}} {{product.measurementUnit ? \'-\' + product.measurementUnit.name : \'\'}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadProducts\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'department.charging_products\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.productPagination.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.productPagination.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.productPagination.getPage(page)\" \ntotal=\"vm.productPagination.totalElements\"></div></div></div></div><div layout=\"column\"><md-button \naria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.productAssociatedSelectedArray === undefined || vm.productAssociatedSelectedArray === null || vm.productAssociatedSelectedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button aria-label=\"Button associate cost center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.associate()\" \nng-disabled=\"vm.productSelectedArray === undefiled || vm.productSelectedArray === null || vm.productSelectedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div \nclass=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.loadAssociatedProducts\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex \ntype=\"search\" ng-model=\"vm.searchAssociatedProductInput\" translate translate-attr-placeholder=\"general.search\" \nng-enter=\"vm.searchAssociatedProduct()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchAssociatedProduct()\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\"><md-input-container flex><label>\n{{\'accountingCatalog.purchaseUrgent\'| translate}}</label><md-select ng-model=\"vm.productType.value\" \nng-change=\"vm.getAssociatedProductToDepartment()\"><md-option ng-value=\"r.value\" ng-repeat=\"r in vm.productTypes\">\n{{r.description}}</md-option></md-select></md-input-container></div><div \nng-click=\"vm.toggleAssociatedProduct(departmentProduct, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociatedProduct(departmentProduct)}\" \nng-repeat=\"departmentProduct in vm.associatedProductArray\" ng-click=\"vm.toggleAssociatedProduct($event, product)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociatedProduct(departmentProduct)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelectedAssociatedProduct(departmentProduct)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{departmentProduct.product.name}} {{departmentProduct.product.brand ? \'-\' + departmentProduct.product.brand.name : \'\'}} {{departmentProduct.product.measurementUnit ? \'-\' + departmentProduct.product.measurementUnit.name : \'\'}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociatedProducts\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.associatedProductPagination.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.associatedProductPagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.associatedProductPagination.getPage(page)\" total=\"vm.associatedProductPagination.totalElements\">\n</div></div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/account/department/department-list/department-related/department-related.html","<md-dialog id=\"department-related\" aria-label=\"Crear-Editar\" ng-style=\"vm.dinamicHeightDialog\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'department.related_department\'| translate}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear \nmd-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><fieldset><legend>\n{{\'department.select_company_of_corporate\' | translate}}</legend><div layout=\"row\"><md-input-container flex=\"100\">\n<label>{{\'department.select_company\' | translate}}</label><md-select required ng-model=\"vm.companySelected\" \nng-change=\"vm.getDepartmentsByCompany()\"><md-select-header><input id=\"searchCompany\" ng-model=\"vm.searchCompany\" \ntype=\"search\" translate translate-attr-placeholder=\"general.search\" ng-keydown=\"$event.stopPropagation();\">\n</md-select-header><md-optgroup><md-option ng-value=\"r\" ng-repeat=\"r in vm.companyArray | filter:vm.searchCompany\">\n{{r.name}} - {{r.account}}</md-option></md-optgroup></md-select></md-input-container></div></fieldset><fieldset \nng-show=\"vm.companySelected.id\"><legend>{{\'department.related_department\' | translate}}</legend><div class=\"content\" \nlayout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" \nlayout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div flex-xl=\"45\" flex-lg=\"45\" \nflex-md=\"40\" ms-scroll><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" \nng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.inputSearchDepartment\" translate translate-attr-placeholder=\"user.search_departments\" \nng-enter=\"vm.searchDepartment()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchDepartment()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.departmentArray.length > 0\" ng-model=\"vm.isCheckAllDepartments\" \nng-change=\"vm.selectAllDepartments()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.departmentArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.code}} {{row.description}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\" ms-scroll><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchRelatedDepartment\" translate \ntranslate-attr-placeholder=\"department.search_associates_departments\" ng-enter=\"vm.searchRelatedDepartment()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.searchRelatedDepartment()\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.departmentsRelatedArray.length > 0\" ng-model=\"vm.isCheckAllRelatedDepartment\" \nng-change=\"vm.selectAllRelatedDepartments()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggleAssociated(rowAssigned, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(departmentProduct)}\" \nng-repeat=\"rowAssigned in vm.departmentsRelatedArray\" ng-click=\"vm.toggleAssociated($event, rowAssigned)\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociated(rowAssigned)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelectedAssociated(rowAssigned)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{rowAssigned.code}} {{rowAssigned.description}}</div></div></div></div><div ng-style=\"vm.dinamicHeight\" \nng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div \npaging class=\"pageable-div center\" page=\"vm.paginationRelatedDepartment.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationRelatedDepartment.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationRelatedDepartment.getPage(page)\" total=\"vm.paginationRelatedDepartment.totalElements\">\n</div></div></div></div></div></fieldset></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/account/dimensions/dimension-company-detail-list/dialog-detail/dialog-detail.html","<md-dialog aria-label=\"Crear-Editar\" ng-style=\"vm.dinamicStyle\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1>\n{{vm.dimensionDetail.id ? \'general.edit\' : \'general.add\'| translate}} {{\'dimensions.detail\' | translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content style=\"padding: 0px\"><div class=\"md-dialog-content\" style=\"padding: 10px\"><ng-form \nname=\"vm.dimensionDetailForm\" id=\"dimensionDetailForm\"><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'dimensions.code\'| translate}}</label><input type=\"text\" ng-model=\"vm.dimensionDetail.code\" name=\"code\" required><div\n ng-messages=\"vm.dimensionDetailForm.code.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\"><label>\n{{\'dimensions.name\'| translate}}</label><input type=\"text\" ng-model=\"vm.dimensionDetail.name\" name=\"name\" required><div\n ng-messages=\"vm.dimensionDetailForm.name.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}\n</div></div></md-input-container></div></ng-form></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between\" style=\"padding: 0px\"><md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}\n</md-button><md-button ng-click=\"vm.save()\">{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/account/department/department/settings/settings.html","<md-dialog class=\"department-settings\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>Configuración</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div flex=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"vm.department.settings.requiresGroupToCreateTicket\">\n{{\'department.requires_group_to_create_ticket\' | translate}}</md-checkbox></div><div flex=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"vm.department.settings.showAverageResponseTimeToCreateTicket\">\n{{\'department.show_average_response_time_to_create_ticket\' | translate}}</md-checkbox></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" aria-label=\"save\">{{\'general.save\'| translate}}\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/admin-series/establishment-cashier-list/dialogSeries/invoiceSerieDialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"invoiceSerie\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1><label ng-if=\"!vm.invoiceSerie.id\" translate=\"SERIES.NEW_SERIE\">Nueva Serie\n</label><label ng-if=\"vm.invoiceSerie.id\" translate=\"COMPANY.INVOICE_SERIE.SERIE\">Serie</label><label \nng-if=\"vm.invoiceSerie.id\">({{vm.invoiceSerie.serie}})</label></h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content-card\" layout=\"column\" flex><md-content class=\"content\" flex ms-scroll><form name=\"vm.theForm\" \nid=\"theForm\" ng-submit=\"vm.save()\"><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"SERIES.ESTABLISHMENT\"></label><md-select ng-required=\"true\" ng-model=\"vm.establishment.id\" \nname=\"establishment\" ng-model-options=\"{trackBy: \'$value\'}\" ng-change=\"vm.loadEstablishmentCashiers()\" \nmd-on-close=\"vm.searchEstablishment=\'\'\" ng-disabled=\"vm.invoiceSerie.id\"><md-select-header><input \nid=\"searchTemplateReference\" ng-model=\"vm.searchEstablishment\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" ng-keydown=\"$event.stopPropagation();\"></md-select-header><md-optgroup \nlabel=\"establishments\"><md-option ng-repeat=\"establishment in vm.establishmentList | filter: vm.searchEstablishment\" \nng-value=\"establishment.id\">{{establishment.establishmentName}}</md-option></md-optgroup></md-select>\n</md-input-container><md-input-container flex ng-if=\"vm.establishment.id\"><label translate=\"SERIES.NAME_COMPUTER\">\n</label><md-select ng-required=\"true\" ng-model=\"vm.establishmentCashier.id\" ng-disabled=\"vm.invoiceSerie.id\" \nname=\"establishmentCashier\" ng-model-options=\"{trackBy: \'$value\'}\" md-on-close=\"vm.searchEstablishmentCashier=\'\'\">\n<md-select-header><input ng-model=\"vm.searchEstablishmentCashier\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\" ng-keydown=\"$event.stopPropagation();\"></md-select-header><md-optgroup \nlabel=\"establishmentCashiers\"><md-option \nng-repeat=\"establishmentCashier in vm.establishmentCashierList | filter: vm.searchEstablishmentCashier\" \nng-value=\"establishmentCashier.id\">{{establishmentCashier.number}} - {{establishmentCashier.nameComputer}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label translate=\"COMPANY.INVOICE_SERIE.RESOLUTION\"></label><input ng-required=\"true\" \nng-model=\"vm.invoiceSerie.resolution\" type=\"text\" name=\"resolution\"><div ng-messages=\"vm.theForm.resolution.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.RESOLUTION\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.SERIE\"></label><input \nng-required=\"true\" ng-model=\"vm.invoiceSerie.serie\" type=\"text\" name=\"serie\"><div \nng-messages=\"vm.theForm.serie.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.SERIE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"COMPANY.INVOICE_SERIE.INITIAL_NUMBER\"></label><input ng-required=\"true\" \nng-model=\"vm.invoiceSerie.initialNumber\" type=\"number\" min=\"1\" style=\"text-align: right\" name=\"initialNumber\" \nng-blur=\"vm.validateCorrelativeRange(true)\"><div ng-messages=\"vm.theForm.initialNumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'COMPANY.INVOICE_SERIE.INITIAL_NUMBER\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}\n</span></div></div></md-input-container><md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.LAST_NUMBER\">\n</label><input ng-required=\"true\" ng-model=\"vm.invoiceSerie.lastNumber\" type=\"number\" min=\"1\" \nstyle=\"text-align: right\" name=\"lastNumber\" ng-blur=\"vm.validateCorrelativeRange(false)\"><div \nng-messages=\"vm.theForm.lastNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.LAST_NUMBER\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"COMPANY.INVOICE_SERIE.DOCUMENT_TYPE\"></label><md-select ng-required=\"true\" \nng-model=\"vm.invoiceSerie.invoiceSerieDocumentType\" name=\"documentType\" ng-model-options=\"{trackBy: \'$value\'}\">\n<md-option ng-repeat=\"documentType in vm.invoiceSerieDocumentTypes\" \nng-value=\"documentType.invoiceSeriesDocumentTypeId\">{{documentType.invoiceSeriesDocumentTypeDescription}}</md-option>\n</md-select><div ng-messages=\"vm.theForm.serieTye.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.INVOICE_TYPE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.INVOICE_TYPE\"></label><md-select \nng-required=\"true\" ng-model=\"vm.invoiceSerie.invoiceSerieType\" name=\"serieType\" ng-change=\"vm.getGfaces()\"><md-option \nng-repeat=\"invoiceType in vm.invoiceSerieTypes\" ng-value=\"invoiceType\">{{invoiceType.invoiceSerieTypeName}}</md-option>\n</md-select><div ng-messages=\"vm.theForm.serieTye.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.DOCUMENT_TYPE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nng-if=\"vm.invoiceSerie.invoiceSerieType.isElectronic\"><label translate=\"COMPANY.GFACE_PROVIDER\"></label><md-select \nng-required=\"vm.invoiceSerie.invoiceSerieType.isElectronic\" ng-model=\"vm.invoiceSerie.gFace\" name=\"gFace\"><md-option \nng-repeat=\"data in vm.gFaces\" ng-value=\"data\">{{data.gfaceName}}</md-option></md-select><div \nng-messages=\"vm.theForm.gFace.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.GFACE_PROVIDER\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE\"></label><md-datepicker \ntype=\"date\" ng-model=\"vm.invoiceSerie.authorizationDate\" name=\"authorizationDate\" md-open-on-focus \nmd-max-date=\"vm.invoiceSerie.dueDate\" md-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div \nng-messages=\"vm.theForm.authorizationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex \nng-if=\"((!vm.invoiceSerie.invoiceSerieType.isElectronic) || (vm.invoiceSerie.invoiceSerieType.isElectronic && vm.invoiceSerie.invoiceSerieType.endDateByInvoiceElectronic))\">\n<label translate=\"COMPANY.DUE_DATE\"></label><md-datepicker type=\"date\" ng-model=\"vm.invoiceSerie.dueDate\" \nname=\"dueDate\" md-open-on-focus \nmd-min-date=\"vm.invoiceSerie.authorizationDate && vm.invoiceSerie.authorizationDate > vm.minDate? vm.invoiceSerie.authorizationDate:vm.minDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.theForm.dueDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'COMPANY.INVOICE_SERIE.DUE_DATE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\">\n<md-checkbox ng-model=\"vm.invoiceSerie.printDocument\">{{\'COMPANY.INVOICE_SERIE.PRINT_DOCUMENT\' | translate}}\n</md-checkbox></md-input-container><md-input-container flex=\"50\"><label>\n{{\'COMPANY.INVOICE_SERIE.PRINT_FORMAT_DOCUMENT\' | translate}}</label><input type=\"text\" \nng-model=\"vm.invoiceSerie.printFormatDocument\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"50\"><md-checkbox ng-model=\"vm.invoiceSerie.onlyCancelInMonth\">\n{{\'COMPANY.INVOICE_SERIE.ONLY_CANCEL_IN_MONTH\' | translate}}</md-checkbox></md-input-container><md-input-container \nflex=\"50\"><md-checkbox ng-model=\"vm.invoiceSerie.creditNotePartial\">\n{{\'COMPANY.INVOICE_SERIE.CREDIT_NOTE_PARTIAL\' | translate}}</md-checkbox></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\"><label \ntranslate=\"COMPANY.INVOICE_SERIE.AMOUNT_BASE_TO_REQUEST_COSTUMER_IDENTIFER\"></label><input type=\"number\" step=\"0.01\" \nname=\"amountBaseToRequestCustomerIdentifier\" ng-model=\"vm.invoiceSerie.amountBaseToRequestCustomerIdentifier\">\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"COMPANY.INVOICE_SERIE.DAYS_TO_CANCEL\"></label><input type=\"number\" ng-model=\"vm.invoiceSerie.daysToCancel\">\n</md-input-container><md-input-container flex=\"50\"><label>{{\'COMPANY.INVOICE_SERIE.DOCUMENT_TYPE_CANCEL\' | translate}}\n</label><md-select ng-model=\"vm.invoiceSerie.invoiceSerieDocumentTypeCancel\" name=\"documentType\" \nng-model-options=\"{trackBy: \'$value\'}\"><md-option ng-repeat=\"documentType in vm.invoiceSerieDocumentTypesCancel\" \nng-value=\"documentType\">{{\'COMPANY.INVOICE_SERIE.\' + documentType| translate}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-xs><md-checkbox \nng-if=\"vm.cashierInvoiceSerie.id\" ng-model=\"vm.cashierInvoiceSerie.active\">\n{{\"COMPANY.INVOICE_SERIE.ACTIVE\"| translate}}</md-checkbox></md-input-container><md-input-container flex-gt-xs \nng-if=\"!vm.setFile\"><div id=\"product-image\" ng-if=\"vm.setLogo !== true\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.invoiceSerie.fileStorage.extension === \'.jpg\' || vm.invoiceSerie.fileStorage.extension === \'.png\' || vm.invoiceSerie.fileStorage.extension === \'.JPG\' || vm.invoiceSerie.fileStorage.extension === \'.PNG\' || vm.invoiceSerie.fileStorage.extension === \'.jpeg\' || vm.invoiceSerie.fileStorage.extension === \'.JPEG\'\">\n<a target=\"_blank\" href=\"{{vm.image.url + \'l\' + vm.image.extension}}\"><div class=\"image-zoom-area\"><img \nwip-image-zoom=\"vm.imageZoomOptions\" ng-fallback=\"assets/images/etc/thumbPhoto.jpg\" alt=\"image\"></div></a></div><div \nlayout=\"row\" layout-align=\"center center\" layout-wrap flex=\"100\"><div class=\"product-image\" \nlayout-align=\"center center\"><img class=\"media\" ng-src=\"{{vm.image.url + \'s\' + vm.image.extension}}\" \nng-fallback=\"assets/images/etc/thumbPhoto.jpg\" ng-click=\"vm.updateImageZoomOptions(vm.image)\" \ntitle=\"{{vm.invoiceSerie.fileStorage.originalName + vm.invoiceSerie.fileStorage.extension}}\" \nng-if=\"vm.invoiceSerie.fileStorage.extension === \'.jpg\' || vm.invoiceSerie.fileStorage.extension === \'.png\' || vm.invoiceSerie.fileStorage.extension === \'.JPG\' || vm.invoiceSerie.fileStorage.extension === \'.PNG\' || vm.invoiceSerie.fileStorage.extension === \'.jpeg\' || vm.invoiceSerie.fileStorage.extension === \'.JPEG\'\" \nalt=\"image\"> <a target=\"_blank\" \nhref=\"{{vm.baseUrlFiles + vm.invoiceSerie.fileStorage.parentPath + vm.invoiceSerie.fileStorage.name + vm.invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{vm.invoiceSerie.fileStorage.originalName + vm.invoiceSerie.fileStorage.extension}}\" \nng-if=\"vm.invoiceSerie.fileStorage.extension !== \'.jpg\' && vm.invoiceSerie.fileStorage.extension !== \'.png\' && vm.invoiceSerie.fileStorage.extension !== \'.JPG\' && vm.invoiceSerie.fileStorage.extension !== \'.PNG\' && vm.invoiceSerie.fileStorage.extension !== \'.jpeg\' && vm.invoiceSerie.fileStorage.extension !== \'.JPEG\'\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon><p>\n{{vm.invoiceSerie.fileStorage.originalName + vm.invoiceSerie.fileStorage.extension}}</p></a><div><md-button \nclass=\"md-fab-bottom-right right-align md-fab md-mini\" ng-click=\"vm.setFile = true;\" ng-show=\"!vm.loading\"><md-icon \nmd-font-icon=\"icon-image-area\"></md-icon><md-tooltip>{{\'COMPANY.CHANGE\'| translate}}</md-tooltip></md-button></div>\n</div></div></div></md-input-container></div><div layout=\"column\" flex=\"100\" ng-if=\"vm.setFile\"><div flex=\"100\" \nng-include=\"\'app/main/apps/company/documents/files/files.html\'\"></div><center><md-button class=\"md-primary md-raised\" \nng-if=\"vm.invoiceSerie.fileStorage\" ng-click=\"vm.setFile = false; vm.filesToUpload = [];\">\n{{\'general.cancel\'| translate}}</md-button></center></div></form></md-content></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"start end\"><md-button ng-disabled=\"vm.isShowProgressLinear\" \nng-click=\"vm.closeDialog()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"vm.isShowProgressLinear || vm.theForm.$invalid\" type=\"submit\" form=\"theForm\">{{\'general.save\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment/dialogs/address.html","<md-dialog class=\"compose-dialog\" aria-label=\"Document\" style=\"max-width: 500px; width: 500px\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"COMPANY.ADDRESS\">\nNuevo Documento</label></h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"vm.theForm\" id=\"theForm\"><div layout=\"row\"><md-input-container flex-gt-xs><label translate=\"address.state\">\nDepartment</label><md-select ng-model=\"vm.state.id\" name=\"state\" required md-on-close=\"vm.clearSearchStates()\" \nng-change=\"vm.loadCities()\"><md-select-header><input id=\"searchState\" ng-model=\"vm.searchState\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Departamentos\"><md-option \nvalue=\"{{state.id}}\" ng-repeat=\"state in vm.states| filter:vm.searchState\">{{state.name}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingDepartments\"></md-progress-linear><div \nng-messages=\"vm.theForm.state.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'address.state\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.state\"><md-input-container flex-gt-xs><label translate=\"address.city\">Department</label>\n<md-select ng-model=\"vm.address.city.id\" name=\"city\" required md-on-close=\"vm.searchCity=\'\';\"><md-select-header><input \nid=\"searchCity\" ng-model=\"vm.searchCity\" type=\"search\" translate translate-attr-placeholder=\"general.search\" \nng-keydown=\"$event.stopPropagation();\"></md-select-header><md-optgroup label=\"Municipios\"><md-option \nvalue=\"{{city.id}}\" ng-repeat=\"city in vm.cities| filter:vm.searchCity\">{{city.name}}</md-option></md-optgroup>\n</md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingCities\"></md-progress-linear><div \nng-messages=\"vm.theForm.city.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'address.city\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label translate=\"address.description\">direccionCompleta</label><input \ntype=\"text\" name=\"description\" ng-model=\"vm.address.addressDescription\" required><div \nng-messages=\"vm.theForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'address.description\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex><label translate=\"address.street\">street</label><input type=\"text\" \nname=\"street\" ng-model=\"vm.address.street\" required><div ng-messages=\"vm.theForm.street.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'address.street\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex-gt-xs><label translate=\"address.zone\">zone</label><input \nng-model=\"vm.address.zoneNumber\" type=\"text\" name=\"zone\" required style=\"text-align: right\"><div \nng-messages=\"vm.theForm.zone.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'address.zone\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label translate=\"address.residential\">residential</label><input type=\"text\" \nname=\"residential\" ng-model=\"vm.address.residential\"><div ng-messages=\"vm.theForm.residential.$error\" role=\"alert\"><div\n ng-message=\"required\"><span>{{\'address.residential\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div>\n</div></md-input-container><md-input-container flex><label translate=\"general.number\">number</label><input type=\"text\" \nname=\"number\" ng-model=\"vm.address.number\"><div ng-messages=\"vm.theForm.number.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'general.number\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label translate=\"address.postalCode\">PostalCode\n</label><input type=\"text\" name=\"postalCode\" ng-model=\"vm.address.postalCode\" autocomplete=\"false\">\n</md-input-container></div></form></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button ng-click=\"vm.closeDialog()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"vm.theForm.$invalid\" ng-click=\"vm.sendAddress()\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment/dialogs/dialog-addUser.html","<md-dialog class=\"department-product\" aria-label=\"department settings\" style=\"width: 70%; height: 80%\"><md-toolbar><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1><label \ntranslate=\"company_establishment.user_permission\">User Permission</label>\n{{vm.selectedUser ? vm.selectedUser.account : \'\'}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div ng-if=\"vm.currentTab === 1\"><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"85\" flex-lg=\"85\" flex-md=\"60\"><div class=\"md-inline-form\"><md-card class=\"content-card\" flex><div \nlayout-align=\"center center\"><div class=\"search-list\" layout=\"row\" layout-align=\"start center\"><input flex \ntype=\"search\" ng-model=\"vm.inputSearch\" placeholder=\"{{\'company_establishment.search_user\'| translate}}\" \nng-enter=\"vm.getAllUser()\"><md-button class=\"md-icon-button\" ng-click=\"vm.getAllUser()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.loading\"><div layout=\"row\" layout-align=\"start center\" ng-click=\"vm.selectUser(data)\" class=\"item\" \nng-class=\"{\'selected\': vm.selectedUser.id === data.id}\" ng-repeat=\"data in vm.userArray.content\"><div flex \nlayout=\"row\" layout-align=\"start center\"><div><div class=\"notes\" layout=\"column\"><span>\n{{data.account ? data.account + \' - \' : \'\'}}{{data.account}}</span></div></div></div><div \nng-if=\"vm.selectedUser.id === data.id\" class=\"label md-green-300-bg\"><md-icon md-font-icon=\"icon-check-all\"></md-icon>\n</div></div></div><div paging class=\"pageable-div center\" page=\"vm.pagination.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.pagination.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.pagination.getPage(page)\" \ntotal=\"vm.pagination.totalElements\"></div></div></md-card></div></div></div></div><div ng-if=\"vm.currentTab === 2\">\n<button ng-hide=\"vm.hideButton\" class=\"md-icon-button close-thread md-button md-default-theme md-ink-ripple\" \ntype=\"button\" aria-label=\"Back\" ng-click=\"vm.currentTab = 1\"><md-icon \nclass=\"ng-scope md-default-theme md-font material-icons icon-arrow-left\" md-font-icon=\"icon-arrow-left-bold\">\n<md-tooltip md-direction=\"bottom\">{{\"general.back\"| translate}}</md-tooltip></md-icon></button><fieldset><legend>\n{{\'company_establishment.associate_user\' | translate}}:</legend><div layout=\"row\" flex \nng-if=\"vm.canAssociateWithoutEmployeeCode && !vm.selectedEmployee\"><md-switch ng-model=\"vm.withoutEmployeeCode\" \nng-click=\"vm.appId=0\">{{\'establishmentRoleUser.withoutEmployeeCode\'| translate}}</md-switch></div><div layout=\"row\" \nflex ng-if=\"!vm.selectedUser.employeeCompanyCode && !vm.withoutEmployeeCode\"><div class=\"content\" layout-xl=\"row\" \nlayout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" \nlayout-align-md=\"space-around center\" flex><div flex><div class=\"md-inline-form\" flex><md-card class=\"content-card\" \nflex><div layout-align=\"center center\"><div class=\"search-list\" layout=\"row\" layout-align=\"start center\"><input \nstyle=\"padding: 10px\" flex type=\"search\" ng-model=\"vm.inputSearchEmployeeCode\" \nplaceholder=\"{{\'company_establishment.search_employee_code\'| translate}}\" ng-enter=\"vm.getAllEmployeeByCompanyCode()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.getAllEmployeeByCompanyCode()\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button></div><div style=\"height: 60px\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"item\" ng-class=\"{\'selected\': vm.selectedEmployee.id === employee.id}\" \nng-repeat=\"employee in vm.employeeArray\"><div flex layout=\"row\" layout-align=\"start center\"><div><div class=\"notes\" \nlayout=\"column\"><span>{{employee.employeeId ? employee.employeeId + \' - \' : \'\'}}{{employee.fullName}}</span></div>\n</div></div></div></div></div></md-card></div><div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent md-button\" ng-click=\"vm.associateEmployeeToUser()\" \nng-disabled=\"vm.employeeArray.length===0 || vm.employeeArray.length>1 || vm.disableAssociateButton\"><span>\n{{\'company_establishment.associate_employee\'| translate}}</span><md-tooltip md-direction=\"left\">\n{{\'company_establishment.associate_employee\'| translate}}</md-tooltip></md-button></div></div></div></div></div><div \nid=\"employee\" ng-if=\"vm.selectedEmployee\" layout-align=\"center center\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"center center\"><h3>{{vm.selectedEmployee.employeeCompanyCode}} - {{vm.selectedEmployee.fullName}}</h3>\n</div></div></fieldset><fieldset><legend>{{\'company_establishment.add_role\' | translate}}:</legend><div><div \nlayout=\"row\" flex=\"100\" ng-show=\"!vm.appId\"><h3><label translate=\"guest.selectApp\">Seleccione una Aplicación:</label>\n</h3></div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"guest.application\">Aplicación</label>\n<md-select ng-disabled=\"!vm.selectedEmployee && !vm.withoutEmployeeCode\" ng-model=\"vm.appId\" name=\"app\" \nng-change=\"vm.getInfoByApp(app);\"><md-option ng-repeat=\"app in vm.applications\" value=\"{{app.application.id}}\">\n{{app.application.name}}</md-option></md-select></md-input-container></div><div class=\"content md-wi\" layout-xl=\"row\" \nlayout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around\" layout-align-lg=\"space-around center\" \nlayout-align-md=\"space-around center\" ng-show=\"vm.appId\"><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div \nclass=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><md-subheader \nclass=\"md-no-sticky\">{{\'user.roles\'| translate}} ({{vm.pagination.totalElements}})</md-subheader><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.roleArray.length > 0\" \nng-model=\"vm.isCheckAllRole\" ng-change=\"vm.selectAllRoles()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.roleArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.description}} ({{row.name}})\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.paginationRole.pageNumber\" ul-class=\"pagination\" page-size=\"vm.paginationRole.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationRole.getPage(page)\" total=\"vm.paginationRole.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><md-subheader \nclass=\"md-no-sticky\">{{\'user.associated_roles\'| translate}} ({{vm.paginationUserRole.totalElements}})</md-subheader>\n<div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userRoleArray.length > 0\" ng-model=\"vm.isCheckAllUserRole\" ng-change=\"vm.selectAllUserRoles()\">\n{{\'user.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggleAssociated(userRole, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(userRole)}\" ng-repeat=\"userRole in vm.userRoleArray\" \nng-click=\"vm.toggleAssociated($event, userRole)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(userRole)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(userRole)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{userRole.description}} ({{userRole.name}})</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationUserRole.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUserRole.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.paginationUserRole.getPage(page)\" \ntotal=\"vm.paginationUserRole.totalElements\"></div></div></div></div></div></div></fieldset></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment/dialogs/dialog-change-code-employee.html","<md-dialog class=\"department-product\" aria-label=\"department settings\" style=\"width: 70%; height: 55%\"><md-toolbar><div\n class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1><label \ntranslate=\"company_establishment.associate_employee\">Associate Employee</label>\n{{vm.selectedUser ? vm.selectedUser.account : \'\'}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><fieldset><legend>{{\'company_establishment.associate_user\' | translate}}:</legend><div layout=\"row\" flex><div\n class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" \nlayout-align-lg=\"space-around center\" layout-align-md=\"space-around center\" flex><div flex><div class=\"md-inline-form\" \nflex><md-card class=\"content-card\" flex><div layout-align=\"center center\"><div class=\"search-list\" layout=\"row\" \nlayout-align=\"start center\"><input style=\"padding: 10px\" flex type=\"search\" ng-model=\"vm.inputSearchEmployeeCode\" \nplaceholder=\"{{\'company_establishment.search_employee_code\'| translate}}\" ng-enter=\"vm.getAllEmployeeByCompanyCode()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.getAllEmployeeByCompanyCode()\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button></div><div style=\"height: 60px\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"item\" ng-class=\"{\'selected\': vm.selectedEmployee.id === employee.id}\" \nng-repeat=\"employee in vm.employeeArray\"><div flex layout=\"row\" layout-align=\"start center\"><div><div class=\"notes\" \nlayout=\"column\"><span>{{employee.employeeId ? employee.employeeId + \' - \' : \'\'}}{{employee.fullName}}</span></div>\n</div></div></div></div></div></md-card></div><div><div layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent md-button\" ng-click=\"vm.associateEmployeeToUser()\" \nng-disabled=\"vm.employeeArray.length===0 || vm.employeeArray.length>1 || vm.disableAssociateButton\"><span>\n{{\'company_establishment.update_associate_employee\'| translate}}</span><md-tooltip md-direction=\"left\">\n{{\'company_establishment.update_associate_employee\'| translate}}</md-tooltip></md-button></div></div></div></div></div>\n</fieldset></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/codeBagCollectionQueue/codeBagCollectionQueue.html","<md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><div layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-xs=\"column\" class=\"custom-header\" layout-align-xl=\"space-between center\" layout-align-lg=\"space-between center\" \nlayout-align-xs=\"center none\"><md-button class=\"md-icon-button close-thread white-fg\" aria-label=\"Back\" \nng-click=\"vm.backTo()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div flex=\"30\" flex-xs=\"100\"><div \nlayout=\"row\"><span style=\"font-size: 25px; color: white; padding-left: 10px\">\n{{\'company_establishment.CODE_CHARGE_QUEUE\'| translate}} [{{vm.name}}]</span></div><div layout=\"row\" class=\"white-fg\">\nTotal: {{vm.pagination.totalElements}}</div></div><div flex=\"30\" flex-xs=\"100\" \nng-if=\"vm.pagination.totalElements > 0 || vm.showSearch\"><div layout=\"row\" layout-align=\"center center\" \nclass=\"custom-crud-search\"><md-icon flex=\"5\" md-font-icon=\"icon-magnify\"></md-icon><input flex=\"85\" type=\"search\" \nplaceholder=\"{{\'company_establishment.search_code\'| translate}}\" ng-model=\"vm.inputSearch\" ng-enter=\"vm.search()\">\n<md-button ng-click=\"vm.search()\">{{\'general.search\'| translate}}</md-button></div></div></div><div layout=\"row\"><div \nflex=\"100\"><md-card><div id=\"codeBagCollectionQueueGrid\" ag-grid=\"vm.grid\" class=\"ag-fresh\" expand-grid min=\"100\" \nother=\"-30\" ng-show=\"vm.showGrid\"></div></md-card></div></div><div layout=\"row\" layout-align=\"end center\" \nstyle=\"padding: 8px\"></div><md-button class=\"md-fab\" aria-label=\"Generar xls\" \nng-show=\"vm.showGrid && vm.content.length > 0\" ng-click=\"vm.exportXLS()\" \nstyle=\"position: fixed; bottom: 20px; right: 90px\"><md-icon md-font-icon=\"icon-file-excel\"></md-icon><md-tooltip \nmd-direction=\"left\">{{\'REPORT.EXPORTXLS\'| translate}}</md-tooltip></md-button><md-button \nclass=\"md-fab md-fab-bottom-right\" aria-label=\"add\" style=\"position: fixed\" ng-click=\"vm.addNewCode()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.add\"| translate}}</md-tooltip>\n</md-button>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/dialogBank/dialog-Bank.html","<md-dialog class=\"compose-dialog\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"company_establishment.bank\">bank</label>\n{{vm.selectedUser ? vm.selectedUser.account : \'\'}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"toolbar\"><form name=\"vm.dataForm\"><div layout=\"row\" layout-align=\"center center\">\n<md-input-container flex class=\"md-block\"><label translate=\"BANK.BANK\"></label><md-select \nng-model=\"vm.bankAccount.bank.id\" name=\"department\" required md-on-close=\"vm.clearSearchBank()\"><md-select-header>\n<input id=\"searchBank\" ng-model=\"vm.searchBank\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"Banks\"><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.banks| filter:vm.searchBank\">{{data.name}}</md-option></md-optgroup></md-select>\n</md-input-container><md-checkbox ng-model=\"vm.bankAccount.isDefaultBank\" ng-disabled=\"vm.dataForm.$invalid\">\n{{\"BANK.ISDEFAULT\"| translate}}</md-checkbox><md-button class=\"md-fab md-mini\" aria-label=\"addDetail\" \nng-disabled=\"vm.dataForm.$invalid\" ng-click=\"vm.saveBank($event)\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip \nmd-direction=\"top\">{{\"general.save\"| translate}}</md-tooltip></md-icon></md-button></div></form></div><div \nid=\"bankGrid\" ag-grid=\"vm.gridBank\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"300\"></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/dialogClassifications/dialog-classifications.html","<md-dialog class=\"compose-dialog\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label \ntranslate=\"company_establishment.classification.classifications\">classifications</label></h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div class=\"toolbar\"><form name=\"vm.dataForm\"><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"company_establishment.classification.type\"></label><md-select ng-model=\"vm.classificationTypeId\" \nname=\"type\" required md-on-close=\"vm.clearSearchType()\" ng-change=\"vm.getClassficationValues();\"><md-select-header>\n<input id=\"searchType\" ng-model=\"vm.searchType\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup><md-option value=\"{{data.id}}\" ng-repeat=\"data in vm.classTypes| filter:vm.searchType\">\n{{data.classTypeName}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex \nclass=\"md-block\"><label translate=\"company_establishment.classification.value\"></label><md-select \nng-model=\"vm.establishmentClassType.corporateClassificationTypeValues.id\" name=\"value\" required \nmd-on-close=\"vm.clearSearchValue()\"><md-select-header><input id=\"searchValue\" ng-model=\"vm.searchValue\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.classTypeValues| filter:vm.searchValue\">{{data.typeValue}}</md-option></md-optgroup></md-select>\n</md-input-container><md-button class=\"md-fab md-mini\" aria-label=\"establishmentClassTypes\" \nng-disabled=\"vm.dataForm.$invalid\" ng-click=\"vm.save($event)\"><md-icon \nmd-font-icon=\"{{vm.establishmentClassType.id ? \'icon-content-save\' : \'icon-plus\'}}\"><md-tooltip md-direction=\"top\">\n{{vm.establishmentClassType.id ? \'general.save\' : \'general.edit\'| translate}}</md-tooltip></md-icon></md-button>\n<md-button ng-if=\"vm.establishmentClassType.id\" class=\"md-fab md-mini md-warn\" \naria-label=\"cancelEditEstablishmentClassTypes\" ng-click=\"vm.cancelEdit()\"><md-icon class=\"md-warn\" \nmd-font-icon=\"icon-cancel\"><md-tooltip md-direction=\"top\">{{\"general.cancel\"| translate}}</md-tooltip></md-icon>\n</md-button></div></form></div><div id=\"classTypesGrid\" ag-grid=\"vm.classTypesGrid\" class=\"ag-fresh\" expand-grid \nmin=\"100\" other=\"300\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/dialogAccountingAccount/dialog-accounting-account.html","<md-dialog class=\"accounting-account-dialog\" aria-label=\"department settings\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>{{vm.establishment.establishmentName}} /\n<label translate=\"company_establishment.accountingAccount.accountingAccount\">accountingAccount</label></h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" ng-show=\"vm.isShowProgressLinear\">\n</md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div class=\"toolbar\"><form name=\"vm.dataForm\"><div \nlayout=\"row\" layout-align=\"center center\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"company_establishment.accountingAccount.accountType\"></label><md-select \nng-model=\"vm.companyAccount.accountTypeId\" name=\"accountType\" required ng-disabled=\"vm.isShowProgressLinear\" \nmd-on-open=\"vm.onOpenSelect(\'#searchAccountType\')\" md-on-close=\"vm.clearSearchAccountType()\"><md-select-header><input \nid=\"searchAccountType\" ng-model=\"vm.searchAccountType\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.accountTypes| filter:vm.searchAccountType\">{{data.acTypeDescription}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex class=\"md-block\"><label \ntranslate=\"company_establishment.accountingAccount.catalog\"></label><md-select \nng-model=\"vm.companyAccount.accountingCatalogId\" name=\"accountingCatalog\" required \nng-disabled=\"vm.isShowProgressLinear\" md-on-open=\"vm.onOpenSelect(\'#searchAccountingCatalog\')\" \nmd-on-close=\"vm.clearSearchAccountingCatalog()\"><md-select-header><input id=\"searchAccountingCatalog\" \nng-model=\"vm.searchAccountingCatalog\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup><md-option value=\"{{data.id}}\" \nng-repeat=\"data in vm.accountingCatalogs| filter:vm.searchAccountingCatalog\">{{data.description}}</md-option>\n</md-optgroup></md-select></md-input-container><md-button class=\"md-fab md-mini\" \naria-label=\"establishmentAccountingAccounts\" ng-disabled=\"vm.dataForm.$invalid || vm.isShowProgressLinear\" \nng-click=\"vm.save($event)\"><md-icon md-font-icon=\"{{vm.companyAccount.id ? \'icon-content-save\' : \'icon-plus\'}}\">\n<md-tooltip md-direction=\"top\">{{vm.companyAccount.id ? \'general.save\' : \'general.add\'| translate}}</md-tooltip>\n</md-icon></md-button><md-button ng-if=\"vm.companyAccount.id\" class=\"md-fab md-mini md-warn\" aria-label=\"cancelEdit\" \nng-disabled=\"vm.isShowProgressLinear\" ng-click=\"vm.cancelEdit()\"><md-icon class=\"md-warn\" md-font-icon=\"icon-cancel\">\n<md-tooltip md-direction=\"top\">{{\"general.cancel\"| translate}}</md-tooltip></md-icon></md-button></div></form></div>\n<div id=\"accountingAccountGrid\" ag-grid=\"vm.accountingAccountGrid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"200\">\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/dialogCompanyWarehouse/dialog-CompanyWarehouse.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'menu.warehouses\'| translate}} {{vm.establishment.establishmentName}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><div class=\"content\" layout-xl=\"row\" \nlayout-lg=\"row\" layout-md=\"row\" layout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" \nlayout-align-md=\"space-around center\"><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchCompanyWarehouse\" translate \ntranslate-attr-placeholder=\"company_warehouse.search\" ng-enter=\"vm.searchCompanyWarehouse()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.searchCompanyWarehouse()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.companyWarehouseArray.length > 0\" ng-model=\"vm.isCheckAllCompanyWarehouse\" \nng-change=\"vm.selectAllCompanyWarehouse()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.companyWarehouseArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelected(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{row.whsCode}} - {{row.whsName}} ( {{row.companyEstablishment.establishmentName}} )</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>{{\'user.cargando\'| translate}}...</span></div>\n<div layout=\"row\" style=\"height: 77px\"><div paging class=\"pageable-div center\" \npage=\"vm.paginationCompanyWarehouse.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationCompanyWarehouse.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationCompanyWarehouse.getPage(page)\" total=\"vm.paginationCompanyWarehouse.totalElements\"></div>\n</div></div></div><div layout=\"column\"><md-button aria-label=\"Button disassociate company warehouse\" \nclass=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate company warehouse\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchEstablishmentCompanyWarehouse\" translate \ntranslate-attr-placeholder=\"company_warehouse.search_associates\" ng-enter=\"vm.searchEstablishmentCompanyWarehouse()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.searchEstablishmentCompanyWarehouse()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.establishmentCompanyWarehouseArray.length > 0\" \nng-model=\"vm.isCheckAllEstablishmentCompanyWarehouse\" ng-change=\"vm.selectAllEstablishmentCompanyWarehouse()\">\n{{\'user.all\'| translate}}</md-checkbox></div><div ng-click=\"vm.toggleAssociated(row, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(row)}\" ng-repeat=\"row in vm.establishmentCompanyWarehouseArray\" \nng-click=\"vm.toggleAssociated($event, row)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{row.whsCode}} - {{row.whsName}} ( {{row.companyEstablishment.establishmentName}} )</div></div>\n</div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\" style=\"height: 77px\"><div \npaging class=\"pageable-div center\" page=\"vm.paginationEstablishmentCompanyWarehouse.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationEstablishmentCompanyWarehouse.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.paginationEstablishmentCompanyWarehouse.getPage(page)\" \ntotal=\"vm.paginationEstablishmentCompanyWarehouse.totalElements\"></div></div></div></div></div></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/dialogDiscounts/dialog-Discounts.html","<md-dialog class=\"compose-dialog\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"DISCOUNTS.DISCOUNTS\">DISCOUNTS</label>\n{{vm.selectedUser ? vm.selectedUser.account : \'\'}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"toolbar\"><form name=\"vm.dataForm\"><div layout=\"row\" layout-align=\"center center\">\n<md-input-container flex class=\"md-block\"><label translate=\"DISCOUNTS.DISCOUNTS\"></label><md-select \nng-model=\"vm.discountEstablishment.discountCompany.id\" name=\"discount\" required md-on-close=\"vm.clearSearchDiscount()\">\n<md-select-header><input id=\"searchDiscount\" ng-model=\"vm.searchDiscount\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Discounts\"><md-option \nvalue=\"{{data.id}}\" ng-repeat=\"data in vm.discounts| filter:vm.searchDiscount\">\n{{data.discountName}} - {{data.discountValue}} <span ng-if=\"data.discountMethod === \'PERCENTAGE\'\">%</span></md-option>\n</md-optgroup></md-select></md-input-container><md-button class=\"md-fab md-mini\" aria-label=\"addDetail\" \nng-disabled=\"vm.dataForm.$invalid\" ng-click=\"vm.save($event)\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip \nmd-direction=\"top\">{{\"general.save\"| translate}}</md-tooltip></md-icon></md-button></div></form></div><div \nid=\"discountGrid\" ag-grid=\"vm.discountGrid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"300\"></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/dialogCoin/dialog-Coin.html","<md-dialog class=\"compose-dialog\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"company_establishment.currency\">bank</label>\n{{vm.selectedUser ? vm.selectedUser.account : \'\'}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"toolbar\"><form name=\"vm.dataForm\"><div layout=\"row\" layout-align=\"center center\">\n<md-input-container flex class=\"md-block\" style=\"height:58px\"><label translate=\"CURRENCY.CURRENCY\"></label><md-select \nng-model=\"vm.currencyAccount.currency.id\" name=\"currency\" required md-on-close=\"vm.clearSearchCurrency()\">\n<md-select-header><input id=\"searchCurrency\" ng-model=\"vm.searchCurrency\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Currencies\"><md-option \nvalue=\"{{data.id}}\" ng-repeat=\"data in vm.currencies| filter:vm.searchCurrency\">{{data.description}} - <small>\n{{data.symbol}}</small></md-option></md-optgroup></md-select></md-input-container><md-input-container flex \nclass=\"md-block\"><label translate=\"CURRENCY.BASE_AMOUNT\"></label><input type=\"number\" \nng-model=\"vm.currencyAccount.baseAmount\" name=\"baseAmount\" required value=\"0\" step=\"0.01\"></md-input-container>\n<md-input-container flex class=\"md-block\"><label translate=\"CURRENCY.CASH_DEPOSIT_AMOUNT\"></label><input type=\"number\" \nng-model=\"vm.currencyAccount.cashDepositAmount\" name=\"cashDepositAmount\" required value=\"0\" step=\"0.01\">\n</md-input-container><md-checkbox ng-model=\"vm.currencyAccount.isDefaultCurrency\" ng-disabled=\"vm.dataForm.$invalid\">\n{{\"CURRENCY.ISDEFAULT\"| translate}}</md-checkbox><md-button class=\"md-fab md-mini\" aria-label=\"addDetail\" \nng-disabled=\"vm.dataForm.$invalid\" ng-click=\"vm.saveCurrency($event)\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip \nmd-direction=\"top\">{{\"general.save\"| translate}}</md-tooltip></md-icon></md-button></div></form></div><div \nid=\"coinGrid\" ag-grid=\"vm.gridCoin\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"300\"></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/dialogRoleSpecialAction/dialog-RoleSpecialAction.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><span>\n{{\"company_establishment.special_actions\" | translate}} {{vm.establishment.establishmentName}}</span></h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"><md-input-container flex=\"100\"><label \ntranslate=\"guest.application\">Aplicación</label><md-select ng-model=\"vm.appId\" name=\"app\" \nng-change=\"vm.getInfoByApp(app);\"><md-option ng-repeat=\"app in vm.applications\" value=\"{{app.application.id}}\">\n{{app.application.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" ng-show=\"vm.appId\">\n<md-input-container flex=\"100\"><label translate=\"COMPANY.role_application\">RoleApplication</label><md-select \nng-model=\"vm.roleApplicationId\" name=\"roleApp\" ng-change=\"vm.getInfoByApp2(roleApp);\"><md-option \nng-repeat=\"roleApp in vm.roleApplications\" value=\"{{roleApp.id}}\">{{roleApp.description}}</md-option></md-select>\n</md-input-container></div><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"center\" layout-align-lg=\"center\" layout-align-md=\"center\" ng-show=\"vm.roleApplicationId\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll ng-if=\"!vm.load\"><md-subheader class=\"md-no-sticky\">\n{{\'company_establishment.special_actions\'| translate}} ({{vm.roleArray.length}})</md-subheader><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.roleArray.length > 0\" \nng-model=\"vm.isCheckAll\" ng-change=\"vm.selectAll()\">{{\'user.all\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.roleArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.actionName}}</div></div>\n</div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'user.cargando\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.pagination.pageNumber\" ul-class=\"pagination\" page-size=\"vm.pagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.pagination.getPage(page)\" total=\"vm.pagination.totalElements\"></div></div></div></div><div \nlayout=\"column\"><md-button aria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.disassociate()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.disassociate\"| translate}}\n</md-tooltip></md-button><md-button aria-label=\"Button associate cost center\" class=\"md-primary md-raised\" \nng-click=\"vm.associate()\" \nng-disabled=\"vm.selectedArray === undefiled || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"user.associate\"| translate}}</md-tooltip>\n</md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><md-subheader \nclass=\"md-no-sticky\">{{\'company_establishment.special_actions_associated\'| translate}} ({{vm.userArray.length}})\n</md-subheader><div layout=\"row\" layout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox \nng-if=\"vm.userArray.length > 0\" ng-model=\"vm.isCheckAllUser\" ng-change=\"vm.selectAllUsers()\">{{\'user.all\'| translate}}\n</md-checkbox></div><div ng-click=\"vm.toggleAssociated(user, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(user)}\" ng-repeat=\"user in vm.userArray\" \nng-click=\"vm.toggleAssociated($event, user)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(user)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(user)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{user.actionName}} {{user.roleApplication.id}}</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.paginationUser.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.paginationUser.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.paginationUser.getPage(page)\" \ntotal=\"vm.paginationUser.totalElements\"></div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/parameters/parameters.html","<div id=\"productParamenters\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" \nflex><div class=\"header\" layout-xl=\"row\" layout-align-xl=\"space-between center\" layout-lg=\"row\" \nlayout-align-lg=\"space-between center\" layout-xs=\"column\" layout-align-xs=\"none center\"><md-button \nclass=\"md-icon-button close-thread white-fg\" aria-label=\"Back\" ng-click=\"vm.backTo()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div class=\"title\" flex=\"20\" flex-xs=\"100\"><span>\n{{\"menu.parameters_product\"| translate}}</span> <span>{{vm.establishment.establishmentName}}</span></div><div \nlayout=\"row\" flex=\"80\" layout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input id=\"searchField\" flex \nng-keyup=\"vm.changeFilter($event)\" ng-enter=\"vm.getProducts(1)\" ng-model=\"vm.filterProduct\" type=\"search\" \nplaceholder=\"{{vm.textSearch| translate}}\"><md-button ng-if=\"vm.textButtonSearch === \'product_parameters.clear\'\" \nng-click=\"vm.clearTextSearch()\">{{\'product_parameters.clear\' | translate}}</md-button><md-button \nng-click=\"vm.getProducts(1)\">{{\'general.search\' | translate}}</md-button></div></div></div><md-card \nclass=\"content-card\" layout=\"column\" flex \nng-include=\"\'app/main/apps/company/company-establishments/establishment-list/parameters/content/content.html\'\">\n</md-card></div></div>");
$templateCache.put("app/main/apps/company/company-establishments/paymentTypes/dialogPaymentTypes/dialogPaymentTypes.html","<md-dialog class=\"compose-dialog\" aria-label=\"department settings\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-primary md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.bankAccount.id ? \'general.edit\' : \'general.add\' | translate}}\n</h1><md-button class=\"md-icon-button\" ng-click=\"vm.newAccount ? vm.flip() : vm.cancel()\" aria-label=\"Close\" translate \ntranslate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><form ng-submit=\"vm.getAccounts(1)\" name=\"searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label class=\"fontColor\">\n{{\'general.filter\' | translate}}</label><input class=\"fontColor\" type=\"text\" ng-model=\"vm.filterAccount\" \nname=\"searchAccount\" ng-keyup=\"vm.changeFilter()\" id=\"searchAccount\"></md-input-container><md-button type=\"submit\" \naria-label=\"Search\"><span translate=\"general.search\">Search</span></md-button></div></form></div></div></md-toolbar>\n<md-progress-linear type=\"indeterminate\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content \nms-scroll style=\"padding: 0px\"><div layout=\"column\" class=\"p-16\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\" flex-gt-sm=\"50\" flex=\"100\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\" ng-show=\"!vm.loading\"><div \nclass=\"content thread-list\" ms-scroll style=\"max-height: 375px\"><div class=\"thread\" md-ink-ripple ng-if=\"!vm.loading\" \nng-repeat=\"account in vm.accounts.content\" ng-click=\"vm.selectAccount(account)\" \nng-class=\"{\'current-thread\':vm.selectedAccount.id === account.id}\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"title\">\n{{account.code ? account.code + \' - \' : \'\'}}{{account.description}} ({{account.levels}})</div><div class=\"notes\"></div>\n</div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.selectAccount.id === account.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div>\n</div><div layout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" \nul-class=\"pagination\" hide-if-empty=\"true\" page-size=\"vm.pageSize\" paging-action=\"vm.getAccounts(page)\" \ntotal=\"vm.accounts.totalElements\"></div></div></div><div class=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular \nclass=\"ajax-loader md-accent md-hue-2\" md-mode=\"indeterminate\"></md-progress-circular></div></div></div>\n</md-dialog-content></ms-widget-front><ms-widget-back id=\"perms\" class=\"white-bg\"><div \nng-init=\"vm.flipping(flipWidget);\"></div><div class=\"page-layout carded fullwidth\" layout=\"column\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1><label \ntranslate=\"PAYMENT_TYPE.ADD_PAYMENT_TYPE\">ADD_PAYMENT_TYPE</label></h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"form-inline\"><ng-form name=\"vm.objForm\"><div layout=\"row\">\n<md-input-container flex class=\"md-block\"><label translate=\"PAYMENT_TYPE.authorizedAmount\"></label><input \ntype=\"number\" ng-model=\"vm.obj.authorizedAmount\" name=\"authorizedAmount\" step=\"any\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex class=\"md-block\"><label translate=\"PAYMENT_TYPE.commissionPercentage\"></label>\n<input type=\"number\" ng-model=\"vm.obj.commissionPercentage\" name=\"authorizedAmount\" step=\"any\"></md-input-container>\n</div><div layout=\"row\"><md-input-container flex class=\"md-block\"><label translate=\"PAYMENT_TYPE.maxAmount\"></label>\n<input type=\"number\" ng-model=\"vm.obj.maxAmount\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label translate=\"PAYMENT_TYPE.percentageInvoice\"></label><input type=\"number\" \nng-model=\"vm.obj.percentageInvoice\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label translate=\"PAYMENT_TYPE.paymentTypeAutomaticInvoice\"></label><input type=\"number\" \nng-model=\"vm.obj.paymentTypeAutomaticInvoice\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label translate=\"PAYMENT_TYPE.invoiceAutomaticCustomerName\"></label><input type=\"text\" \nng-model=\"vm.obj.invoiceAutomaticCustomerName\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label translate=\"PAYMENT_TYPE.invoiceAutomaticCustomerTax\"></label><input type=\"text\" \nng-model=\"vm.obj.invoiceAutomaticCustomerTax\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label translate=\"PAYMENT_TYPE.invoiceAutomaticCustomerAddress\"></label><input type=\"text\" \nng-model=\"vm.obj.invoiceAutomaticCustomerAddress\"></md-input-container></div><div layout=\"row\"><md-input-container \nflex class=\"md-block\"><label translate=\"PAYMENT_TYPE.invoiceAutomaticProductCode\"></label><input type=\"text\" \nng-model=\"vm.obj.invoiceAutomaticProductCode\"></md-input-container></div><div layout=\"row\"><md-input-container flex \nclass=\"md-block\"><label translate=\"BANK.PRODUCT_FOR_CREDIT_DOCUMENT\"></label><input type=\"text\" \nng-model=\"vm.obj.productForCreditDocument\" name=\"productForCreditDocument\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"80\"><span>{{\'BANK.ACCOUNTING_CATALOG\' | translate}}</span><br><span>\n{{vm.obj.accountingCatalog.code}} - {{vm.obj.accountingCatalog.description}}</span></md-input-container><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"vm.onAccountingCatalog(1)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"left\">{{\'general.edit\' | translate}}\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.obj.accountingCatalog = null\" \nng-if=\"vm.obj.accountingCatalog\"><md-icon md-font-icon=\"icon-broom\" class=\"md-warn\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\"general.delete\" | translate}}</md-tooltip></md-button></div></div><div layout=\"row\">\n<md-input-container flex=\"80\"><span>{{\'BANK.ACCOUNT_FOR_CREDIT_DOCUMENT\' | translate}}</span><br><span>\n{{vm.obj.accountForCreditDocument.code}} - {{vm.obj.accountForCreditDocument.description}}</span></md-input-container>\n<div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"vm.onAccountingCatalog(2)\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.edit\" | translate}}\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.obj.accountForCreditDocument = null\" \nng-if=\"vm.obj.accountForCreditDocument\"><md-icon md-font-icon=\"icon-broom\" class=\"md-warn\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\"general.delete\" | translate}}</md-tooltip></md-button></div></div><div layout=\"column\"><div \nlayout=\"row\" flex><md-input-container flex class=\"md-block\"><md-checkbox ng-model=\"vm.obj.usePosIntegrated\">\n{{\'PAYMENT_TYPE.usePosIntegrated\' | translate}}</md-checkbox></md-input-container><md-input-container flex \nclass=\"md-block\"><md-checkbox ng-model=\"vm.obj.usePosIntegratedIgnoreCut\">\n{{\'PAYMENT_TYPE.usePosIntegratedIgnoreCut\' | translate}}</md-checkbox></md-input-container></div></div><div \nlayout=\"column\"><div layout=\"row\" flex><md-input-container flex class=\"md-block\"><md-checkbox \nng-model=\"vm.obj.requestAuthorization\">{{\'PAYMENT_TYPE.requestAuthorization\' | translate}}</md-checkbox>\n</md-input-container><md-input-container flex class=\"md-block\"><md-checkbox ng-model=\"vm.obj.canInvoiceStayPending\">\n{{\'PAYMENT_TYPE.pendingPayment\' | translate}}</md-checkbox></md-input-container></div></div><div layout=\"column\" \nclass=\"md-block\"><div layout=\"row\" flex><md-input-container flex class=\"md-block\"><md-checkbox \nng-model=\"vm.obj.canEnterCustomerEmailOnInvoice\">{{\'PAYMENT_TYPE.enterCustomerEmailOnInvoice\' | translate}}\n</md-checkbox></md-input-container><md-input-container flex class=\"md-block\"><md-checkbox \nng-model=\"vm.obj.requireCustomerEmailOnInvoice\">{{\'PAYMENT_TYPE.customerEmailsIsRequired\' | translate}}</md-checkbox>\n</md-input-container></div></div><div layout=\"column\" class=\"md-block\"><div layout=\"row\" flex><md-input-container flex \nclass=\"md-block\"><md-checkbox ng-model=\"vm.obj.generateAutomaticInvoice\">\n{{\'PAYMENT_TYPE.generateAutomaticInvoice\' | translate}}</md-checkbox></md-input-container><md-input-container flex \nclass=\"md-block\"><md-checkbox ng-model=\"vm.obj.extractPercentageFromTotal\">\n{{\'PAYMENT_TYPE.extractPercentageFromTotal\' | translate}}</md-checkbox></md-input-container></div></div>\n<md-input-container flex class=\"md-block\" ng-show=\"vm.obj.usePosIntegrated\"><label \ntranslate=\"PAYMENT_TYPE.providerIntegration\"></label><md-select ng-model=\"vm.obj.typeProviderIntegration\" \nname=\"integrationMethod\"><md-optgroup label=\"{{\'PAYMENT_TYPE.providerIntegration.integrationMethod\'| translate}}\">\n<md-option value=\"{{data.id}}\" ng-repeat=\"data in vm.paymentIntegrated\">{{data.name}}</md-option></md-optgroup>\n</md-select><div layout=\"row\" class=\"mt-10\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"PAYMENT_TYPE.amountForSignature\"></label><input type=\"number\" ng-model=\"vm.obj.amountForSignature\" \nname=\"amountForSignature\" step=\"any\" min=\"0\"></md-input-container></div></md-input-container></ng-form></div>\n</md-dialog-content><md-dialog-actions><md-button class=\"md-primary md-raised\" ng-click=\"vm.cancel()\" \naria-label=\"cancel\"><span translate=\"general.close\"></span></md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.save()\" aria-label=\"save\"><span translate=\"general.save\"></span></md-button></md-dialog-actions></div>\n</ms-widget-back></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/company/documents/dialogs/document/document.html","<md-dialog class=\"compose-dialog\" aria-label=\"Document\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1><label ng-if=\"!vm.document.id\" translate=\"COMPANY.DOCUMENT_NEW\">Nuevo Documento\n</label><label ng-if=\"vm.document.id\" translate=\"COMPANY.DOCUMENT\">Documento</label><label ng-if=\"vm.document.id\">\n({{vm.document.document.number}})</label></h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear \nmd-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><ng-form \nname=\"vm.theForm\" id=\"theForm\"><div layout=\"row\"><md-input-container flex><label translate=\"COMPANY.DOCUMENT_TYPE\">\n</label><md-select ng-required=\"true\" ng-model=\"vm.document.document.documentType\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"theDocumentType\" ng-disabled=\"vm.document.id\"><md-option \nng-value=\"row\" ng-repeat=\"row in vm.documentTypes\">{{row.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label translate=\"COMPANY.DOCUMENT_NUMBER\"></label><input name=\"documentType\" \nng-required=\"true\" ng-model=\"vm.document.document.number\" type=\"text\" \nng-pattern=\"vm.document.document.documentType.documentTypeFormat\"><div ng-messages=\"vm.theForm.documentType.$error\">\n<div ng-message=\"pattern\" translate=\"company_document.incorrect_format\">The format of the value is not correct!</div>\n<div ng-message=\"required\" translate=\"general.field_required\">This field is required!</div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"50\" ng-if=\"vm.document.document.documentType.requiredDateOfIssue\">\n<label translate=\"COMPANY.DATE_OF_ISSUE\">Enter date of issue</label><md-datepicker ng-required=\"true\" flex=\"100\" \nflex-gt-xs=\"50\" ng-model=\"vm.document.document.dateOfIssue\" name=\"startDate\"></md-datepicker><div \nng-messages=\"vm.theForm.startDate.$error\"><div ng-message=\"valid\">The entered value is not a date!</div><div \nng-message=\"required\">This date is required!</div></div></md-input-container><md-input-container flex=\"50\" \nng-if=\"vm.document.document.documentType.requiredDueDate\"><label translate=\"COMPANY.DUE_DATE\">Enter due date</label>\n<md-datepicker ng-required=\"true\" flex=\"100\" flex-gt-xs=\"50\" ng-model=\"vm.document.document.dueDate\" name=\"endDate\" \nmd-min-date=\"vm.minDate\"></md-datepicker><div ng-messages=\"vm.theForm.endDate.$error\"><div ng-message=\"valid\">\nThe entered value is not a date!</div><div ng-message=\"required\">This date is required!</div><div ng-message=\"mindate\">\nDate is too early!</div></div></md-input-container></div></ng-form><div layout=\"row\" flex=\"100\"><div flex=\"100\" \nng-include=\"\'app/main/apps/company/documents/files/files.html\'\"></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button>\n<md-button ng-disabled=\"vm.theForm.$invalid\" ng-click=\"vm.save()\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/tabs/bank-account/bank/bank.html","<md-dialog aria-label=\"Crear-Editar\" class=\"bank-account-dialog-style\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.bankAccount.id ? \'general.edit\' : \'general.add\'| translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" \nclass=\"md-accent bank-account-progress-bar-style\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar>\n<md-dialog-content><div class=\"mat-dialog-without-padding\"><ng-form name=\"vm.bankAccountForm\" id=\"bankAccountForm\"><div\n layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"50\"><label translate=\"BANKACCOUNT.BANK\">\n</label><md-select ng-model=\"vm.bankAccount.bank.id\" name=\"bank\" required md-on-close=\"vm.clearSearchBank()\" \nng-disabled=\"vm.isShowProgressLinear\"><md-select-header><input id=\"searchBank\" ng-model=\"vm.searchBank\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Banks\"><md-option \nng-value=\"{{data.id}}\" ng-repeat=\"data in vm.banks| filter:vm.searchBank\">{{data.name}}</md-option></md-optgroup>\n</md-select></md-input-container><md-input-container flex=\"50\"><label translate=\"BANKACCOUNT.ACCOUNTTYPE\"></label>\n<md-select ng-model=\"vm.bankAccount.bankAccountType.id\" name=\"bankAccountType\" required \nmd-on-close=\"vm.clearSearchBankAccountType()\" ng-disabled=\"vm.isShowProgressLinear\"><md-select-header><input \nid=\"searchBankAccountType\" ng-model=\"vm.searchBankAccountType\" type=\"search\" translate \ntranslate-attr-placeholder=\"BANK.BANK_ACCOUNT_TYPE\"></md-select-header><md-optgroup label=\"bankAccountTypes\"><md-option\n ng-value=\"{{data.id}}\" ng-repeat=\"data in vm.bankAccountTypes| filter:vm.searchBankAccountType\">\n{{data.bankAccountTypeDescription}}</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"50\"><label>{{\'BANKACCOUNT.ACCOUNTNUMBER\'| translate}}\n</label><input type=\"text\" ng-model=\"vm.bankAccount.accountNumber\" name=\"accountNumber\" required \nng-disabled=\"vm.isShowProgressLinear\"><div ng-messages=\"vm.bankAccountForm.accountNumber.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container><md-input-container \nflex=\"50\"><label>{{\'BANKACCOUNT.NAME\'| translate}}</label><input type=\"text\" ng-model=\"vm.bankAccount.accountName\" \nname=\"accountName\" ng-disabled=\"vm.isShowProgressLinear\" required><div \nng-messages=\"vm.bankAccountForm.accountName.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}\n</div></div></md-input-container></div><div layout=\"row\"><md-checkbox ng-model=\"vm.bankAccount.isDefault\" \nng-disabled=\"vm.isShowProgressLinear \n                        || (!vm.bankAccount.active && vm.bankAccount.id) || vm.firstBankAccount\">\n{{\'BANKACCOUNT.ISDEFAULT\' | translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-disabled=\"!vm.bankAccount.id || vm.isShowProgressLinear\" ng-model=\"vm.bankAccount.active\" \nng-change=\"vm.onChangeActive()\">{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between\" class=\"dialog-actions-style\">\n<md-button ng-click=\"vm.cancel()\" ng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button>\n<md-button ng-click=\"vm.save()\" ng-disabled=\"vm.bankAccountForm.$invalid  || vm.isShowProgressLinear\">\n{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/tabs/company-contact/contact/contact.html","<md-dialog aria-label=\"Crear-Editar\" class=\"contact-dialog-style\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{vm.contact.id ? \'general.edit\' : \'general.add\'| translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent contact-progress-bar-style\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><div \nclass=\"mat-dialog-without-padding\"><ng-form name=\"vm.contactForm\" id=\"contactForm\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"50\"><label>{{\'CONTACTS.NAME\'| translate}}</label><input \ntype=\"text\" ng-model=\"vm.contact.name\" name=\"name\" required ng-disabled=\"vm.isShowProgressLinear\"><div \nng-messages=\"vm.contactForm.name.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}</div></div>\n</md-input-container><md-input-container flex=\"50\"><label>{{\'CONTACTS.PHONE\'| translate}}</label><input type=\"text\" \nng-model=\"vm.contact.phone\" name=\"phone\" ng-disabled=\"vm.isShowProgressLinear\" required><div \nng-messages=\"vm.contactForm.phone.$error\"><div ng-message=\"required\">{{\'general.field_required\'| translate}}</div>\n</div></md-input-container></div><div layout=\"row\" layout-align=\"space-between center\"><md-input-container flex=\"50\">\n<label>{{\'CONTACTS.PHONE2\'| translate}}</label><input type=\"text\" ng-model=\"vm.contact.phone2\" name=\"phone2\" \nng-disabled=\"vm.isShowProgressLinear\"><div ng-messages=\"vm.contactForm.phone2.$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}</div></div></md-input-container><md-input-container flex=\"50\"><label>\n{{\'CONTACTS.PHONEMOBILE\'| translate}}</label><input type=\"text\" ng-model=\"vm.contact.phoneMobile\" name=\"phoneMobile\" \nng-disabled=\"vm.isShowProgressLinear\"><div ng-messages=\"vm.contactForm.phoneMobile.$error\"><div ng-message=\"required\">\n{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"50\"><label>{{\'CONTACTS.EMAIL\'| translate}}</label><input \ntype=\"email\" ng-model=\"vm.contact.email\" name=\"email\" ng-disabled=\"vm.isShowProgressLinear\" \nng-pattern=\"/^[a-zA-Z0-9._-]+@+[a-zA-Z0-9]+(?:\\.[a-zA-Z0-9-]+)*$/\"><div ng-messages=\"vm.contactForm.email.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container><md-input-container \nflex=\"50\"><label>{{\'CONTACTS.ADDRESS\'| translate}}</label><input type=\"text\" ng-model=\"vm.contact.address\" \nname=\"address\" ng-disabled=\"vm.isShowProgressLinear\" required><div ng-messages=\"vm.contactForm.address.$error\"><div \nng-message=\"required\">{{\'general.field_required\'| translate}}</div></div></md-input-container></div><div layout=\"row\">\n<md-checkbox ng-disabled=\"!vm.contact.id || vm.isShowProgressLinear\" ng-model=\"vm.contact.active\">\n{{\'general.active\' | translate}}</md-checkbox></div></ng-form></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between\" class=\"dialog-actions-style\"><md-button ng-click=\"vm.cancel()\" \nng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button><md-button ng-click=\"vm.save()\" \nng-disabled=\"vm.contactForm.$invalid  || vm.isShowProgressLinear\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/tabs/warehouses/warehouse/warehouse.html","<md-dialog class=\"compose-dialog\" aria-label=\"Crear-Editar\" style=\"width: 30%; height: 60%\"><md-toolbar><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.warehouse.id ? \'general.edit\' : \'general.add\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<form name=\"vm.warehouseForm\" id=\"warehouseForm\" ng-submit=\"vm.save()\"><div layout=\"row\"><md-input-container \nflex=\"100\"><label>{{\'company_warehouse.code\'| translate}}</label><input type=\"text\" ng-model=\"vm.warehouse.whsCode\" \nname=\"code\" required><div ng-messages=\"vm.warehouseForm.code.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_warehouse.code\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'company_warehouse.name\'| translate}}</label><input \ntype=\"text\" ng-model=\"vm.warehouse.whsName\" name=\"name\" required><div ng-messages=\"vm.warehouseForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>\n{{\'company_warehouse.name\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label translate=\"company_warehouse.establishment\">Establishment\n</label><md-select ng-model=\"vm.warehouse.companyEstablishment.id\" name=\"establishment\" \nmd-on-close=\"vm.clearSearchEstablishment()\"><md-select-header><input id=\"searchEstablishment\" \nng-model=\"vm.searchEstablishment\" type=\"search\" placeholder=\"Buscar sucursal\" clear-icon></md-select-header>\n<md-optgroup label=\"Departamentos\"><md-option value=\"{{row.id}}\" \nng-repeat=\"row in vm.establishments| filter:vm.searchEstablishment | orderBy: \'internalCode\'\">\n{{row.internalCode + \' - \' + row.establishmentName}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loadingEstablishments\"></md-progress-linear></md-input-container><md-input-container \nflex=\"10\" ng-if=\"vm.warehouse.companyEstablishment && vm.warehouse.companyEstablishment.id\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.warehouse.companyEstablishment = null\"><md-icon md-font-icon=\"icon-broom\">\n</md-icon><md-tooltip md-direction=\"top\">{{\"general.delete\"| translate}}</md-tooltip></md-button></md-input-container>\n</div><div layout=\"row\"><md-input-container flex=\"100\"><label>{{\'company_warehouse.companyWarehouseType\'| translate}}\n</label><md-select ng-model=\"vm.warehouse.companyWarehouseType\" name=\"companyWarehouseType\"><md-option value=\"STORE\">\nBodega de Tienda</md-option><md-option value=\"SALE\">Bodega de Venta</md-option><md-option value=\"PRODUCT\">\nBodega de Producto</md-option><md-option value=\"CENTRAL\">Bodega Central</md-option><md-option value=\"POUND\">\nBodega de Libras</md-option></md-select></md-input-container></div><div layout=\"row\"><md-checkbox \nng-if=\"vm.warehouse.id\" ng-model=\"vm.warehouse.active\">{{\'general.active\'| translate}}</md-checkbox></div></form></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"start end\"><md-button \nng-disabled=\"vm.isShowProgressLinear\" ng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"vm.isShowProgressLinear\" type=\"submit\" form=\"warehouseForm\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/tabs/invoiceSerie/dialog/invoiceSerieDialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"invoiceSerie\"><md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><h1><label ng-if=\"!vm.invoiceSerie.id\" \ntranslate=\"COMPANY.INVOICE_SERIE.INVOICE_SERIE\">Nueva Serie</label><label ng-if=\"vm.invoiceSerie.id\" \ntranslate=\"COMPANY.INVOICE_SERIE.SERIE\">Serie</label><label ng-if=\"vm.invoiceSerie.id\">({{vm.invoiceSerie.serie}})\n</label></h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"content-card\" layout=\"column\" flex><md-content class=\"content\" \nflex ms-scroll><form name=\"vm.theForm\" id=\"theForm\" ng-submit=\"vm.save()\"><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.RESOLUTION\"></label><input ng-required=\"true\" \nng-model=\"vm.invoiceSerie.resolution\" type=\"text\" name=\"resolution\"><div ng-messages=\"vm.theForm.resolution.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.RESOLUTION\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.SERIE\"></label><input \nng-required=\"true\" ng-model=\"vm.invoiceSerie.serie\" type=\"text\" name=\"serie\"><div \nng-messages=\"vm.theForm.serie.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.SERIE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"COMPANY.INVOICE_SERIE.INITIAL_NUMBER\"></label><input ng-required=\"true\" \nng-model=\"vm.invoiceSerie.initialNumber\" type=\"number\" min=\"1\" style=\"text-align: right\" name=\"initialNumber\" \nng-blur=\"vm.validateCorrelativeRange(true)\"><div ng-messages=\"vm.theForm.initialNumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'COMPANY.INVOICE_SERIE.INITIAL_NUMBER\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}\n</span></div></div></md-input-container><md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.LAST_NUMBER\">\n</label><input ng-required=\"true\" ng-model=\"vm.invoiceSerie.lastNumber\" type=\"number\" min=\"1\" \nstyle=\"text-align: right\" name=\"lastNumber\" ng-blur=\"vm.validateCorrelativeRange(false)\"><div \nng-messages=\"vm.theForm.lastNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.LAST_NUMBER\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"COMPANY.INVOICE_SERIE.DOCUMENT_TYPE\"></label><md-select ng-required=\"true\" \nng-model=\"vm.invoiceSerie.invoiceSerieDocumentType\" name=\"documentType\" ng-model-options=\"{trackBy: \'$value\'}\">\n<md-option ng-repeat=\"documentType in vm.invoiceSerieDocumentTypes\" \nng-value=\"documentType.invoiceSeriesDocumentTypeId\">{{documentType.invoiceSeriesDocumentTypeDescription}}</md-option>\n</md-select><div ng-messages=\"vm.theForm.serieTye.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.INVOICE_TYPE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.INVOICE_TYPE\"></label><md-select \nng-required=\"true\" ng-model=\"vm.invoiceSerie.invoiceSerieType\" name=\"serieType\" ng-change=\"vm.getGfaces()\"><md-option \nng-repeat=\"invoiceType in vm.invoiceSerieTypes\" ng-value=\"invoiceType\">{{invoiceType.invoiceSerieTypeName}}</md-option>\n</md-select><div ng-messages=\"vm.theForm.serieTye.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.DOCUMENT_TYPE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex \nng-if=\"vm.invoiceSerie.invoiceSerieType.isElectronic\"><label translate=\"COMPANY.GFACE_PROVIDER\"></label><md-select \nng-required=\"vm.invoiceSerie.invoiceSerieType.isElectronic\" ng-model=\"vm.invoiceSerie.gFace\" name=\"gFace\"><md-option \nng-repeat=\"data in vm.gFaces\" ng-value=\"data\">{{data.gfaceName}}</md-option></md-select><div \nng-messages=\"vm.theForm.gFace.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.GFACE_PROVIDER\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div></md-input-container>\n<md-input-container flex><label translate=\"COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE\"></label><md-datepicker \ntype=\"date\" ng-model=\"vm.invoiceSerie.authorizationDate\" name=\"authorizationDate\" md-open-on-focus \nmd-max-date=\"vm.invoiceSerie.dueDate\" md-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div \nng-messages=\"vm.theForm.authorizationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\'COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}</span></div></div>\n</md-input-container><md-input-container flex \nng-if=\"((!vm.invoiceSerie.invoiceSerieType.isElectronic) || (vm.invoiceSerie.invoiceSerieType.isElectronic && vm.invoiceSerie.invoiceSerieType.endDateByInvoiceElectronic))\">\n<label translate=\"COMPANY.DUE_DATE\"></label><md-datepicker type=\"date\" ng-model=\"vm.invoiceSerie.dueDate\" \nname=\"dueDate\" md-open-on-focus \nmd-min-date=\"vm.invoiceSerie.authorizationDate && vm.invoiceSerie.authorizationDate > vm.minDate? vm.invoiceSerie.authorizationDate:vm.minDate\" \nmd-placeholder=\"dd-MM-yyyy\" required></md-datepicker><div ng-messages=\"vm.theForm.dueDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\'COMPANY.INVOICE_SERIE.DUE_DATE\'| translate }} {{\'COMPANY.IS_REQUIRED\'| translate}}\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"40\">\n<md-checkbox ng-model=\"vm.invoiceSerie.printDocument\">{{\'COMPANY.INVOICE_SERIE.PRINT_DOCUMENT\' | translate }}\n</md-checkbox></md-input-container><md-input-container flex=\"60\"><label \ntranslate=\"COMPANY.INVOICE_SERIE.PRINT_FORMAT_DOCUMENT\"></label><input type=\"text\" \nng-model=\"vm.invoiceSerie.printFormatDocument\"></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"50\"><md-checkbox ng-model=\"vm.invoiceSerie.onlyCancelInMonth\">\n{{\'COMPANY.INVOICE_SERIE.ONLY_CANCEL_IN_MONTH\' | translate }}</md-checkbox></md-input-container><md-input-container \nflex=\"50\"><md-checkbox ng-model=\"vm.invoiceSerie.creditNotePartial\">\n{{\'COMPANY.INVOICE_SERIE.CREDIT_NOTE_PARTIAL\' | translate }}</md-checkbox></md-input-container></div>\n<md-input-container flex=\"100\" layout=\"column\" layout-gt-xs=\"row\"><label>\n{{\'COMPANY.INVOICE_SERIE.AMOUNT_BASE_TO_REQUEST_COSTUMER_IDENTIFER\' | translate}}</label><input type=\"number\" \nstep=\"0.01\" ng-model=\"vm.invoiceSerie.amountBaseToRequestCustomerIdentifier\" class=\"input-number-type\">\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\"><label>\n{{\'COMPANY.INVOICE_SERIE.DAYS_TO_CANCEL\' | translate}}</label><input type=\"number\" \nng-model=\"vm.invoiceSerie.daysToCancel\" class=\"input-number-type\"></md-input-container><md-input-container flex=\"50\">\n<label translate=\"COMPANY.INVOICE_SERIE.DOCUMENT_TYPE_CANCEL\"></label><md-select \nng-model=\"vm.invoiceSerie.invoiceSerieDocumentTypeCancel\" name=\"documentType\" ng-model-options=\"{trackBy: \'$value\'}\">\n<md-option ng-repeat=\"documentType in vm.invoiceSerieDocumentTypesCancel\" ng-value=\"documentType\">\n{{\'COMPANY.INVOICE_SERIE.\' + documentType| translate}}</md-option></md-select></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"50\"><label \ntranslate=\"COMPANY.INVOICE_SERIE.PREFIX_CORRELATIVE\"></label><input type=\"text\" \nng-model=\"vm.invoiceSerie.prefixCorrelative\"></md-input-container><md-input-container flex=\"50\"><label \ntranslate=\"COMPANY.INVOICE_SERIE.QUANTITY_CORRELATIVE_DIGITS\"></label><input type=\"number\" \nng-model=\"vm.invoiceSerie.quantityCorrelativeDigits\" min=\"0\" class=\"input-number-type\"></md-input-container></div><div \nlayout=\"column\" layout-gt-xs=\"row\"><md-input-container flex-xs><md-checkbox ng-if=\"vm.invoiceSerie.id\" \nng-model=\"vm.invoiceSerie.active\">{{\"COMPANY.INVOICE_SERIE.ACTIVE\"| translate}}</md-checkbox></md-input-container>\n<md-input-container flex-gt-xs ng-if=\"!vm.setFile\"><div id=\"product-image\" ng-if=\"vm.setLogo !== true\"><div \nlayout=\"row\" layout-align=\"center center\" \nng-if=\"vm.invoiceSerie.fileStorage.extension === \'.jpg\' || vm.invoiceSerie.fileStorage.extension === \'.png\' || vm.invoiceSerie.fileStorage.extension === \'.JPG\' || vm.invoiceSerie.fileStorage.extension === \'.PNG\' || vm.invoiceSerie.fileStorage.extension === \'.jpeg\' || vm.invoiceSerie.fileStorage.extension === \'.JPEG\'\">\n<a target=\"_blank\" href=\"{{vm.image.url + \'l\' + vm.image.extension}}\"><div class=\"image-zoom-area\"><img \nwip-image-zoom=\"vm.imageZoomOptions\" ng-fallback=\"assets/images/etc/thumbPhoto.jpg\" alt=\"image\"></div></a></div><div \nlayout=\"row\" layout-align=\"center center\" layout-wrap flex=\"100\"><div class=\"product-image\" \nlayout-align=\"center center\"><img class=\"media\" ng-src=\"{{vm.image.url + \'s\' + vm.image.extension}}\" \nng-fallback=\"assets/images/etc/thumbPhoto.jpg\" ng-click=\"vm.updateImageZoomOptions(vm.image)\" \ntitle=\"{{vm.invoiceSerie.fileStorage.originalName + vm.invoiceSerie.fileStorage.extension}}\" \nng-if=\"vm.invoiceSerie.fileStorage.extension === \'.jpg\' || vm.invoiceSerie.fileStorage.extension === \'.png\' || vm.invoiceSerie.fileStorage.extension === \'.JPG\' || vm.invoiceSerie.fileStorage.extension === \'.PNG\' || vm.invoiceSerie.fileStorage.extension === \'.jpeg\' || vm.invoiceSerie.fileStorage.extension === \'.JPEG\'\" \nalt=\"image\"> <a target=\"_blank\" \nhref=\"{{vm.baseUrlFiles + vm.invoiceSerie.fileStorage.parentPath + vm.invoiceSerie.fileStorage.name + vm.invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{vm.invoiceSerie.fileStorage.originalName + vm.invoiceSerie.fileStorage.extension}}\" \nng-if=\"vm.invoiceSerie.fileStorage.extension !== \'.jpg\' && vm.invoiceSerie.fileStorage.extension !== \'.png\' && vm.invoiceSerie.fileStorage.extension !== \'.JPG\' && vm.invoiceSerie.fileStorage.extension !== \'.PNG\' && vm.invoiceSerie.fileStorage.extension !== \'.jpeg\' && vm.invoiceSerie.fileStorage.extension !== \'.JPEG\'\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon><p>\n{{vm.invoiceSerie.fileStorage.originalName + vm.invoiceSerie.fileStorage.extension}}</p></a><div><md-button \nclass=\"md-fab-bottom-right right-align md-fab md-mini\" ng-click=\"vm.setFile = true;\" ng-show=\"!vm.loading\"><md-icon \nmd-font-icon=\"icon-image-area\"></md-icon><md-tooltip>{{\'COMPANY.CHANGE\'| translate}}</md-tooltip></md-button></div>\n</div></div></div></md-input-container></div><div layout=\"column\" flex=\"100\" ng-if=\"vm.setFile\"><div flex=\"100\" \nng-include=\"\'app/main/apps/company/documents/files/files.html\'\"></div><center><md-button class=\"md-primary md-raised\" \nng-if=\"vm.invoiceSerie.fileStorage\" ng-click=\"vm.setFile = false; vm.filesToUpload = [];\">\n{{\'general.cancel\'| translate}}</md-button></center></div></form></md-content></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"start end\"><md-button ng-disabled=\"vm.isShowProgressLinear\" \nng-click=\"vm.closeDialog()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"vm.isShowProgressLinear || vm.theForm.$invalid\" type=\"submit\" form=\"theForm\">{{\'general.save\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/no-validate-dialog/no-validate-provider.html","<md-dialog class=\"no-validate-provider\" aria-label=\"No validate provider\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>{{\'validate_provider.send_notification_to_provider\'| translate}}\n</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content ms-scroll><trix-editor ng-disabled=\"vm.isShowProgressLinear\" id=\"responseEditor\" \nangular-trix flex ng-model=\"vm.noValidateProvider.observations\" trix-change=\"vm.trixChange(e, editor);\" \ntrix-initialize=\"vm.trixInitialize(e, editor);\"></trix-editor><div class=\"character-count\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"count\">\n{{\'validate_provider.characters\'| translate}}: {{vm.countCharacters}} ({{\'validate_provider.maximun\'| translate}} {{vm.numberOfCharactersAllowed}} {{\'validate_provider.characters\'| translate}})\n</span> <span ng-if=\"vm.countCharacters === vm.numberOfCharactersAllowed\" class=\"error\">\n{{\'validate_provider.can_not_enter_more_than\'| translate}} {{vm.numberOfCharactersAllowed}} {{\'validate_provider.characters\'| translate}}\n</span></div></md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"end center\"><md-button\n \nng-disabled=\"vm.noValidateProvider.observations === null || vm.noValidateProvider.observations === undefined || vm.countCharacters <= 1\" \nng-click=\"vm.send()\" class=\"send-button md-accent md-raised\" aria-label=\"Crear\">{{\'validate_provider.send\'| translate}}\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/about.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div class=\"info-line\"><br>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.NAME\">Full Name</label><input type=\"text\" \nname=\"name\" ng-disabled=\"true\" ng-model=\"vm.provider.name\"></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"100\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container class=\"md-block\" \nflex=\"80\"><label class=\"title\" translate=\"COMPANY.BUSINESSNAME\">Business Name</label><input type=\"text\" \nname=\"bussines\" ng-model=\"vm.provider.businessName\" ng-disabled=\"!vm.editBusinessName\"></md-input-container><div \nlayout=\"row\" flex=\"20\" ng-if=\"vm.canEditProvider\"><md-button class=\"md-fab md-mini\" aria-label=\"add\" \nng-click=\"vm.editBusinessName ? vm.saveBusinessName() : vm.editBusinessNameF()\"><md-icon md-svg-icon=\"border-color\" \nng-if=\"!vm.editBusinessName\"></md-icon><md-icon md-font-icon=\"icon-content-save\" ng-if=\"vm.editBusinessName\"></md-icon>\n<md-tooltip md-direction=\"top\">{{(vm.editBusinessName ? \"general.save\" : \"general.edit\")| translate}}</md-tooltip>\n</md-button><md-button class=\"md-fab md-mini md-warn\" aria-label=\"add\" ng-click=\"vm.cancelEditBusinessName()\" \nng-if=\"vm.editBusinessName\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip md-direction=\"top\">\n{{\"general.cancel\"| translate}}</md-tooltip></md-button></div></div><md-input-container class=\"md-block\"><label \nclass=\"title\" translate=\"COMPANY.RESPRESENTATIVE\">Legal Representative</label><input type=\"text\" name=\"representant\" \nng-model=\"vm.provider.legalRepresentative\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"COMPANY.LINE_OF_BUSINESS\">Line of business</label><input type=\"text\" \nname=\"description\" ng-model=\"vm.provider.description\" ng-disabled=\"true\"></md-input-container><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"100\" class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"80\" \nclass=\"md-block\"><label class=\"title\" translate=\"COMPANY.TYPE_TAXPAYER\">Type of Taxpayer</label><md-select \nng-model=\"vm.provider.companyTypeId\" name=\"taxpayerType\" ng-disabled=\"true\" required><md-optgroup label=\"type\">\n<md-option ng-value=\"{{row.id}}\" ng-repeat=\"row in vm.companyTypeList\">{{row.code}} - {{row.description}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"100\" \nclass=\"layout-gt-xs-row layout-column flex\"><md-input-container flex=\"80\" class=\"md-block\"><label class=\"title\" \ntranslate=\"COMPANY.TAXPAYER_CATEGORY\">Taxpayer Category</label><md-select ng-model=\"vm.provider.companyCategoryId\" \nmd-on-close=\"vm.searchCompanyCategory = \'\'\" name=\"taxpayerCategory\" ng-disabled=\"!vm.editCompanyCategory\" required>\n<md-select-header><input id=\"searchCompanyCategory\" ng-model=\"vm.searchCompanyCategory\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"category\"><md-option \nng-value=\"{{row.id}}\" \nng-repeat=\"row in vm.companyCategoryList|\n                                            filter:vm.searchCompanyCategory\">\n{{row.code}} - {{row.description}}</md-option></md-optgroup></md-select></md-input-container><div layout=\"row\" \nflex=\"20\" ng-if=\"vm.canEditProvider\"><md-button class=\"md-fab md-mini\" aria-label=\"add\" \nng-click=\"vm.editCompanyCategory ? vm.saveCompanyCategory() : vm.editCompanyCategoryF()\"><md-icon \nmd-svg-icon=\"border-color\" ng-if=\"!vm.editCompanyCategory\"></md-icon><md-icon md-font-icon=\"icon-content-save\" \nng-if=\"vm.editCompanyCategory\"></md-icon><md-tooltip md-direction=\"top\">\n{{(vm.editCompanyCategory ? \"general.save\" : \"general.edit\")| translate}}</md-tooltip></md-button><md-button \nclass=\"md-fab md-mini md-warn\" aria-label=\"add\" ng-click=\"vm.cancelEditCompanyCategory()\" \nng-if=\"vm.editCompanyCategory\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip md-direction=\"top\">\n{{\"general.cancel\"| translate}}</md-tooltip></md-button></div></div><md-input-container class=\"md-block\"><label \nclass=\"title\" translate=\"COMPANY.COUNTRY\">Country</label><input type=\"text\" ng-model=\"vm.provider.country.name\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\"><label class=\"title\" \ntranslate=\"COMPANY.CURRENCY\">Country</label><input type=\"text\" ng-model=\"vm.provider.currency.description\" \nng-disabled=\"true\"></md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex \nclass=\"layout-gt-xs-row layout-column flex\"><md-input-container flex class=\"md-block\"><md-checkbox \nng-disabled=\"!vm.editMode\" ng-model=\"vm.haveCredit\" aria-label=\"chk\">{{\"COMPANY.HAVECREDIT\"| translate}}</md-checkbox>\n</md-input-container><md-input-container flex class=\"md-block\" ng-if=\"vm.haveCredit\"><label class=\"title\" \ntranslate=\"COMPANY.DAYSCREDIT\">Days Credit</label><input type=\"number\" name=\"daysCredit\" ng-model=\"vm.daysCredit\" \nng-disabled=\"!vm.editMode\" ng-required=\"vm.haveCredit\"></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex class=\"layout-gt-xs-row layout-column flex\"><md-input-container flex class=\"md-block\"><label \nclass=\"title\" translate=\"COMPANY.CODE_PROVIDER\">codeProvider</label><input type=\"text\" name=\"companyProviderCode\" \nng-model=\"vm.companyProviderCode\" ng-disabled=\"!vm.editMode\"></md-input-container></div></div></div><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div class=\"info-line\"><header \nclass=\"md-accent-bg\"><div class=\"title\" translate=\"COMPANY.CONTACT\">Contact</div></header><br><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"COMPANY.ADDRESS\">Address</label><input type=\"text\" name=\"address\" \nng-model=\"vm.provider.address\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\"><label \nclass=\"title\" translate=\"COMPANY.TEL\">Phone</label><input type=\"text\" name=\"phone\" ng-model=\"vm.provider.phone\" \nng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\"><label class=\"title\" \ntranslate=\"COMPANY.TEL2\">Phone</label><input type=\"text\" name=\"phone\" ng-model=\"vm.company.phone2\" ng-disabled=\"true\">\n</md-input-container><md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.PHONE_MOBILE\">Phone\n</label><input type=\"text\" name=\"phone\" ng-model=\"vm.company.phoneMobile\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"COMPANY.WEBPAGE\">Web Page</label><input \ntype=\"text\" name=\"web\" ng-model=\"vm.provider.webPage\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"COMPANY.EMAILS\">Emails</label><input type=\"email\" name=\"email\" \nng-model=\"vm.provider.email\" ng-pattern=\"/^[a-zA-Z0-9._-]+@+[a-zA-Z0-9]+(?:\\.[a-zA-Z0-9-]+)*$/\" ng-disabled=\"true\">\n</md-input-container></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div \nclass=\"info-line\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"CONTACTS.CONTACT_PERSON\">Contact</div>\n</header><br><md-input-container class=\"md-block\"><label class=\"title\" translate=\"CONTACTS.NAME\">Name</label><input \ntype=\"text\" name=\"address\" ng-model=\"vm.companyContact.name\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"CONTACTS.PHONE\">Phone</label><input type=\"text\" \nname=\"address\" ng-model=\"vm.companyContact.phone\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"CONTACTS.PHONE2\">Phone2</label><input type=\"text\" name=\"address\" \nng-model=\"vm.companyContact.phone2\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\"><label\n class=\"title\" translate=\"CONTACTS.PHONEMOBILE\">PhoneMobile</label><input type=\"text\" name=\"address\" \nng-model=\"vm.companyContact.phoneMobile\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\">\n<label class=\"title\" translate=\"CONTACTS.EMAIL\">Email</label><input type=\"email\" name=\"address\" \nng-model=\"vm.companyContact.email\" ng-disabled=\"true\" \nng-pattern=\"/^[a-zA-Z0-9._-]+@+[a-zA-Z0-9]+(?:\\.[a-zA-Z0-9-]+)*$/\"></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"title\" translate=\"CONTACTS.ADDRESS\">Address</label><input type=\"text\" name=\"address\" \nng-model=\"vm.companyContact.address\" ng-disabled=\"true\"></md-input-container></div></div><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div ng-class=\"vm.editMode ? \'\' : \'info-line\'\">\n<header class=\"md-accent-bg\"><div class=\"title\" translate=\"BANKACCOUNT.BANK_ACCOUNT\">Bank Account</div></header><br>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"BANKACCOUNT.BANK\">Bank</label><input type=\"text\" \nname=\"address\" ng-model=\"vm.bankAccount.bank.name\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"BANKACCOUNT.ACCOUNTTYPE\"></label><input type=\"text\" name=\"address\" \nng-model=\"vm.bankAccount.bankAccountType.bankAccountTypeDescription\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"BANKACCOUNT.ACCOUNTNUMBER\">Phone</label><input \ntype=\"text\" name=\"address\" ng-model=\"vm.bankAccount.accountNumber\" ng-disabled=\"true\"></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"title\" translate=\"BANKACCOUNT.NAME\">Phone2</label><input \ntype=\"text\" name=\"address\" ng-model=\"vm.bankAccount.accountName\" ng-disabled=\"true\"></md-input-container></div></div>\n</div></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/accountingCatalog.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"navigation\" flex layout=\"row\" layout-align=\"end center\" ng-if=\"vm.canEditProvider\">\n<md-button class=\"md-raised md-warn\" ng-click=\"vm.showValidateDialog($event, true)\" aria-label=\"Save Changes\">\n{{\'COMPANY.EDIT\'| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon></md-button></div><div class=\"info-line\">\n<md-input-container class=\"md-block\"><label translate=\"productAccount.cuentaContable\"></label><input type=\"text\" \nname=\"address\" ng-model=\"vm.accountingCatalog.description\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"validate_provider.paymentCondition\"></label><input type=\"text\" name=\"address\" \nng-model=\"vm.paymentCondition.name\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\"><label\n translate=\"providerGroup.providerGroup\"></label><input type=\"text\" name=\"address\" \nng-model=\"vm.providerGroup.groupName\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"validate_provider.erpError\"></label><input type=\"text\" name=\"address\" \nng-model=\"vm.companyProvider.erpError\" ng-disabled=\"true\"></md-input-container><md-input-container class=\"md-block\">\n<label translate=\"validate_provider.erpReference\"></label><input type=\"text\" name=\"address\" \nng-model=\"vm.companyProvider.erpReference\" ng-disabled=\"true\"></md-input-container></div></div></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/companyConfiguration.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\" style=\"padding: 15px\"><div class=\"about\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsConfiguration\"><thead><tr><th \nstyle=\"padding-top: 10px; padding-bottom: 10px; width: 50%\"><span translate=\"company_parameters.description\"></span>\n</th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 40%\"><div layout=\"row\" layout-align=\"center center\">\n<span translate=\"company_parameters.value\"></span></div></th><th \nstyle=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"></th></tr></thead><tbody><tr \nng-repeat=\"player in vm.valueConfiguration\"><td style=\"padding:0; width: 50%\">{{player.description}}</td><td \nstyle=\"padding:0; width: 40%\"><div ng-if=\"player.dataType===\'TEXT\'\"><input id=\"documentNumber\" autocomplete=\"off\" \nng-model=\"player.value\" style=\"text-align: left; width: 100%\"></div><div ng-if=\"player.dataType===\'NUMBER\'\"><input \nid=\"documentNumber\" numbers-only=\"numbers-only\" autocomplete=\"off\" ng-model=\"player.value\" style=\"text-align: right\">\n</div><div ng-if=\"player.dataType===\'DECIMAL\'\"><input ng-model=\"player.value\" type=\"number\" name=\"rate\" required \nmin=\"0.01\" max=\"vm.promotion.rate+1\" style=\"text-align: right\"></div><div ng-if=\"player.dataType===\'COLOR\'\"><div \nmd-color-picker random=\"true\" open-on-input=\"true\" ng-model=\"player.value\" default=\"#f00\" \nmd-color-generic-palette=\"false\" md-color-history=\"false\">{{player.value}}</div></div><div \nng-if=\"player.dataType===\'BOOLEAN\'\" layout=\"row\" layout-align=\"center center\"><md-checkbox ng-model=\"player.value\" \naria-label=\"chk\" ng-click=\"vm.disableSaveConfigButton=false\" ng-disabled=\"!vm.canEditProvider\"></md-checkbox></div>\n</td><td style=\"padding:0; width: 10%\"></td></tr></tbody></table><md-button class=\"md-fab md-fab-bottom-right\" \nng-click=\"vm.updateFieldsConfiguration()\" ng-disabled=\"vm.disableSaveConfigButton\" ng-if=\"vm.canEditProvider\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>{{\'validate_provider.save\'| translate}}</md-tooltip></md-button>\n</div></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderFiles.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\" style=\"padding: 15px\"><div class=\"about\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-options=\"vm.dtOptionsFiles\"><thead><tr><th \nstyle=\"padding-top: 10px; padding-bottom: 10px; width: 50%\"><span translate=\"company_files.name\"></span></th><th \nstyle=\"padding-top: 10px; padding-bottom: 10px; width: 40%\"><div layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"company_files.photo\"></span></div></th><th style=\"padding-top: 10px; padding-bottom: 10px; width: 10%\"></th>\n</tr></thead><tbody><tr ng-repeat=\"player in vm.companyProviderFiles\"><td style=\"padding:10px; width: 50%\"><div>\n{{player.fileStorage.originalName}}{{player.fileStorage.extension}}</div></td><td style=\"padding:0; width: 40%\"><div \nlayout=\"column\" \nng-if=\"player.fileStorage.extension===\'.jpg\' || player.fileStorage.extension===\'.png\'\n                 || player.fileStorage.extension === \'.JPG\' || player.fileStorage.extension === \'.PNG\'\" \nlayout-align=\"center center\" ng-click=\"vm.viewIMG(player.fileStorage)\"><img width=\"50\" height=\"50\" id=\"fullUrl\" \nng-src=\"{{player.fileStorage.fileUrl}}\" style=\"text-align: left; width: 50px; height: 50px\"></div><div layout=\"column\" \nng-if=\"player.fileStorage.extension!==\'.jpg\' && player.fileStorage.extension!==\'.png\'\n                 && player.fileStorage.extension !== \'.JPG\' && player.fileStorage.extension !== \'.PNG\'\" \nlayout-align=\"center center\"><a title=\"{{player.fileStorage.originalName + player.fileStorage.extension}}\" \ndata-gallery ng-href=\"{{player.fileStorage.fileUrl}}\" \ndownload=\"{{player.fileStorage.originalName + player.fileStorage.extension}}\" target=\"_blank\" \nng-if=\"player.fileStorage !== null && player.fileStorage !== undefined\n                 && player.fileStorage.extension !== \'.jpg\' && player.fileStorage.extension !== \'.png\'\n                 && player.fileStorage.extension !== \'.JPG\' && player.fileStorage.extension !== \'.PNG\'\n                 && player.fileStorage.extension !== \'.jpeg\' && player.fileStorage.extension !== \'.JPEG\'\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon></a></div></td><td style=\"padding:0; width: 10%\"></td></tr>\n</tbody></table></div></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderProduct.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"contentProduct\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\" ng-if=\"vm.canEditProvider\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadProducts\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.searchProductInput\" translate \ntranslate-attr-placeholder=\"general.search\" ng-enter=\"vm.getNotAssociatedProductToProvider()\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.getNotAssociatedProductToProvider()\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button></div><div ng-click=\"vm.toggleProduct(product, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedProduct(product)}\" ng-repeat=\"product in vm.productArray\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedProduct(product)\" md-font-icon=\"icon-checkbox-marked\">\n</md-icon><md-icon ng-if=\"!vm.isSelectedProduct(product)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div \nflex class=\"product-name\">\n{{product.name}} {{product.brand ? \'-\' + product.brand.name : \'\'}} {{product.measurementUnit ? \'-\' + product.measurementUnit.name : \'\'}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadProducts\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'department.charging_products\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.productPagination.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.productPagination.pageSize\" hide-if-empty=\"false\" paging-action=\"vm.productPagination.getPage(page)\" \ntotal=\"vm.productPagination.totalElements\"></div></div></div></div><div layout=\"column\" ng-if=\"vm.canEditProvider\">\n<md-button aria-label=\"Button disassociate cost center\" class=\"md-primary md-raised\" ng-click=\"vm.disassociate()\" \nng-disabled=\"vm.productAssociatedSelectedArray === undefined || vm.productAssociatedSelectedArray === null || vm.productAssociatedSelectedArray.length === 0 || !vm.saveButton\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><md-button aria-label=\"Button associate cost center\" \nclass=\"md-primary md-raised\" ng-click=\"vm.associate()\" \nng-disabled=\"vm.productSelectedArray === undefiled || vm.productSelectedArray === null || vm.productSelectedArray.length === 0 || !vm.saveButton\">\n<md-icon md-font-icon=\"icon-arrow-right\"></md-icon></md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div \nclass=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll \nng-if=\"!vm.loadAssociatedProducts\"><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex \ntype=\"search\" ng-model=\"vm.searchAssociatedProductInput\" translate translate-attr-placeholder=\"general.search\" \nng-enter=\"vm.getCompanyProviderProducts()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.getCompanyProviderProducts()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div \nng-click=\"vm.toggleAssociatedProduct(companyProviderProduct, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociatedProduct(companyProviderProduct)}\" \nng-repeat=\"companyProviderProduct in vm.associatedProductArray\" ng-click=\"vm.toggleAssociatedProduct($event, product)\">\n<div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelectedAssociatedProduct(companyProviderProduct)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelectedAssociatedProduct(companyProviderProduct)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">\n{{companyProviderProduct.product.name}} {{companyProviderProduct.product.brand ? \'-\' + companyProviderProduct.product.brand.name : \'\'}} {{companyProviderProduct.product.measurementUnit ? \'-\' + companyProviderProduct.product.measurementUnit.name : \'\'}}\n</div></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociatedProducts\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span>{{\'department.charging_products_allowed\'| translate}}...</span></div><div layout=\"row\"><div paging \nclass=\"pageable-div center\" page=\"vm.associatedProductPagination.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.associatedProductPagination.pageSize\" hide-if-empty=\"false\" \npaging-action=\"vm.associatedProductPagination.getPage(page)\" total=\"vm.associatedProductPagination.totalElements\">\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderTags.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\" ng-if=\"vm.saveButton\"><md-icon \nmd-font-icon=\"icon-tag\" class=\"icon s24\"></md-icon><input flex type=\"search\" id=\"companyTagValue\" \nname=\"companyTagValue\" placeholder=\"{{\'TAGS.ADD_TAG\'| translate}}\" ng-enter=\"vm.saveTag()\" \nng-model=\"vm.companyProviderTag.companyTags.companyTagValue\"> <button \nng-disabled=\"!vm.companyProviderTag.companyTags.companyTagValue\" class=\"md-fab md-mini md-button md-primary\" \nng-click=\"vm.saveTag()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></button></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: 20px; display: block; position: relative\"><div \nlayout-align=\"start-center\" class=\"badge white-fg ng-binding ng-scope\" \nstyle=\"background: silver; float: left; margin: 3px; margin-top: 3px; border-radius: 5px\" \nng-repeat=\"row in vm.companyProviderTag.companyProvider.tagsDTO.companyTags\"><span style=\"font-size: 20px\">\n{{row.companyTagValue}} <a ng-click=\"vm.deleteTag(row)\" ng-if=\"vm.saveButton\"><md-icon class=\"md-warn\" \nmd-font-icon=\"s20 icon-trash\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.delete\"| translate}}</md-tooltip>\n</a></span></div></div></div></div></div><style>.selected {\n        background-color: lightblue;\n    }</style>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/content.html","<div class=\"content\" flex><md-tabs md-dynamic-height><md-tab md-on-select=\"vm.tabIndex = 0\"><md-tab-label><span \ntranslate=\"COMPANY.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/about.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 1\" ng-if=\"!vm.isNew\"><md-tab-label><span \ntranslate=\"COMPANY.DOCUMENTS\">Documents</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/documents.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 2\" ng-if=\"!vm.isNew\"><md-tab-label><span \ntranslate=\"COMPANY.REGIME\">Regimen</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/regime.html\'\"></md-content>\n</md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 3\" ng-if=\"!vm.isNew\"><md-tab-label><span \ntranslate=\"COMPANY.INVOICE_SERIE.INVOICE_SERIE\">Invoice series</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/invoiceSerie.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 4\" \nng-if=\"!vm.isNew && vm.showAccountingCatalog\"><md-tab-label><span translate=\"accountingCatalog.accountingInformation\">\nAccounting Information</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/accountingCatalog.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 5\" ng-if=\"!vm.isNew\" ng-click=\"vm.focusTag()\">\n<md-tab-label><span translate=\"accountingCatalog.companyProviderTags\">companyProviderTags</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderTags.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 6\" ng-if=\"!vm.isNew && (vm.myProviders)\" \nng-click=\"vm.getProductsListAssociate()\"><md-tab-label><span translate=\"accountingCatalog.companyProviderProduct\">\ncompanyProviderProduct</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderProduct.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 7\" ng-if=\"!vm.isNew && (vm.myProviders)\">\n<md-tab-label><span translate=\"validate_provider.companyConfiguration\">companyConfiguration</span></md-tab-label>\n<md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/companyConfiguration.html\'\">\n</md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.tabIndex = 8\" \nng-if=\"!vm.isNew && (vm.myProviders) && vm.companyProviderFiles.length>0\"><md-tab-label><span \ntranslate=\"validate_provider.companyProviderFiles\">companyProviderFiles</span></md-tab-label><md-tab-body><md-content \nclass=\"about-tab\" \nng-include=\"\'app/main/apps/company-providers/validate-provider/provider-information/content/companyProviderFiles.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/documents.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.documentArray.length === 0\"><h2 translate=\"validate_provider.no_documents\">\nNo existen documentos asociados a esta empresa</h2></div><div class=\"navigation\" flex layout=\"row\" \nlayout-align=\"end center\" ng-if=\"vm.canEditProvider\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.goDocuments()\" \naria-label=\"Save Changes\">{{\'COMPANY.EDIT\'| translate}}<md-icon md-svg-icon=\"border-color\"></md-icon></md-button></div>\n<div class=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" \nng-if=\"vm.documentArray.length > 0\"><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'COMPANY.DOCUMENT_TYPE\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.DOCUMENT\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'COMPANY.DATE_OF_ISSUE\'| translate}}\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.DUE_DATE\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">{{\'COMPANY.FILE\'| translate}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"doc in vm.documentArray| filter: {active: \'true\'}\"><td>{{doc.document.documentType.name}}</td><td>\n{{doc.document.number}}</td><td>{{!doc.document.dateOfIssue ? \'\' :(doc.document.dateOfIssue| flipdate : \'dd-MM-yyyy\')}}\n</td><td>{{!doc.document.dueDate ? \'\' : (doc.document.dueDate| flipdate : \'dd-MM-yyyy\')}}</td><td><div \nng-if=\"doc.document.files.length > 0\"><spam ng-repeat=\"files in doc.document.files\"><a \nng-if=\"files.extension === \'.jpg\' || files.extension === \'.png\' || files.extension === \'.JPG\' || files.extension === \'.PNG\' || files.extension === \'.jpeg\' || files.extension === \'.JPEG\'\" \nng-href=\"{{vm.baseUrlSharedFiles}}{{files.parentPath}}{{files.name}}l{{files.extension}}\" \ntitle=\"{{doc.document.documentType.name}} - {{$index + 1}}\" data-gallery target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon></a><a \nng-if=\"files.extension !== \'.jpg\' && files.extension !== \'.png\' && files.extension !== \'.JPG\' && files.extension !== \'.PNG\' && files.extension !== \'.jpeg\' && files.extension !== \'.JPEG\'\" \nng-href=\"{{vm.baseUrlSharedFiles}}{{files.parentPath}}{{files.name}}{{files.extension}}\" \ntitle=\"{{doc.document.documentType.name}} - {{$index + 1}}\" data-gallery target=\"_blank\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon></a></spam></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/invoiceSerie.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.serieArray.length === 0\"><h2 translate=\"validate_provider.no_series\">\nNo existen series asociadas a esta empresa</h2></div><div \nclass=\"order-detail-form-container products md-background-bg md-whiteframe-1dp\" ng-if=\"vm.serieArray.length > 0\"><table\n class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptionsInvoice\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.SERIE\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.INITIAL_NUMBER\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.LAST_NUMBER\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.INVOICE_TYPE\'| translate}}</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.RESOLUTION\'| translate}}</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.AUTHORIZATION_DATE\'| translate}}</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">\n{{\'COMPANY.INVOICE_SERIE.DUE_DATE\'| translate}}</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">{{\'COMPANY.INVOICE_SERIE.VALIDATED\'| translate}}</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">{{\'COMPANY.FILE\'| translate}}</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"invoiceSerie in vm.serieArray\"><td>{{invoiceSerie.serie}}</td><td>\n{{invoiceSerie.initialNumber}}</td><td>{{invoiceSerie.lastNumber}}</td><td>\n{{invoiceSerie.electronicInvoice === false ? \'Manual\' : \'Electronica\'}}</td><td>{{invoiceSerie.resolution}}</td><td>\n{{invoiceSerie.authorizationDate| flipdate : \'dd-MM-yyyy\'}}</td><td>{{invoiceSerie.dueDate| flipdate : \'dd-MM-yyyy\'}}\n</td><td>{{invoiceSerie.validated}}</td><td><a \nng-href=\"{{vm.baseUrlSharedFiles}}{{invoiceSerie.fileStorage.parentPath}}{{invoiceSerie.fileStorage.name}}{{\'l\'}}{{invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{invoiceSerie.fileStorage.originalName + invoiceSerie.fileStorage.extension}}\" data-gallery target=\"_blank\" \nng-if=\"invoiceSerie.fileStorage !== null && invoiceSerie.fileStorage !== undefined && (invoiceSerie.fileStorage.extension === \'.jpg\' || invoiceSerie.fileStorage.extension === \'.png\' || invoiceSerie.fileStorage.extension === \'.JPG\' || invoiceSerie.fileStorage.extension === \'.PNG\' || invoiceSerie.fileStorage.extension === \'.jpeg\' || invoiceSerie.fileStorage.extension === \'.JPEG\')\">\n<img \nng-src=\"{{vm.baseUrlSharedFiles}}{{invoiceSerie.fileStorage.parentPath}}{{invoiceSerie.fileStorage.name}}{{\'i\'}}{{invoiceSerie.fileStorage.extension}}\" \nclass=\"img-rounded border12\" alt=\"photo\" height=\"20\" onerror=\"this.src=\'assets/images/logos/angular.png\'\"> </a><a \nng-href=\"{{vm.baseUrlSharedFiles + invoiceSerie.fileStorage.parentPath + invoiceSerie.fileStorage.name + invoiceSerie.fileStorage.extension}}\" \ntitle=\"{{invoiceSerie.fileStorage.originalName + invoiceSerie.fileStorage.extension}}\" data-gallery target=\"_blank\" \nng-if=\"invoiceSerie.fileStorage !== null && invoiceSerie.fileStorage !== undefined && invoiceSerie.fileStorage.extension !== \'.jpg\' && invoiceSerie.fileStorage.extension !== \'.png\' && invoiceSerie.fileStorage.extension !== \'.JPG\' && invoiceSerie.fileStorage.extension !== \'.PNG\' && invoiceSerie.fileStorage.extension !== \'.jpeg\' && invoiceSerie.fileStorage.extension !== \'.JPEG\'\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon></a></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/content/regime.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"about\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.regimeArray.length === 0\"><h2 translate=\"validate_provider.no_regime\">No hay régimen asociado esta empresa\n</h2></div><md-list><md-list-item ng-class=\"(account === vm.account) ? \'selected\' : \'\'\" \nng-repeat=\"account in vm.regimeArray\" style=\"border-bottom: 1px solid #D8D8D8\"><p>{{account.name}}</p><div \nng-show=\"account.enabled\" class=\"label md-orange-800-bg\">Habilitado</div><md-button class=\"md-icon-button\" \nng-show=\"account.enabled\" ng-click=\"vm.deleteRegime(account)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANY.DELETE\"><md-icon md-font-icon=\"icon-delete\" class=\"md-warn\"></md-icon></md-button>\n</md-list-item></md-list></div></div></div><div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" \nlayout=\"column\"><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><md-list><md-list-item \nng-class=\"(row === vm.withholding) ? \'selected\' : \'\'\" ng-repeat=\"row in vm.withholdings\" \nstyle=\"border-bottom: 1px solid #D8D8D8\"><p>{{row.withholding.withholdingDescription}}</p><div \nng-if=\"row.withholdingFile\"><div layout=\"column\" ng-click=\"vm.viewIMG(row.withholdingFile)\" \nng-if=\"row.withholdingFile.extension === \'.jpg\' || row.withholdingFile.extension === \'.png\' || row.withholdingFile.extension === \'.JPG\' || row.withholdingFile.extension === \'.PNG\'\">\n<a href=\"\"><img height=\"100px\" width=\"100px\" class=\"media\" \nng-src=\"{{vm.baseUrlFiles + row.withholdingFile.parentPath + row.withholdingFile.name + row.withholdingFile.extension}}\" \nalt=\"image\"><p>{{row.withholdingFile.originalName + row.withholdingFile.extension}}</p></a></div><div layout=\"column\" \nng-if=\"row.withholdingFile.extension !== \'.jpg\' && row.withholdingFile.extension !== \'.png\' && row.withholdingFile.extension !== \'.JPG\' && row.withholdingFile.extension !== \'.PNG\'\">\n<a target=\"_blank\" \nhref=\"{{vm.baseUrlFiles + row.withholdingFile.parentPath + row.withholdingFile.name + row.withholdingFile.extension}}\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon><p>\n{{row.withholdingFile.originalName + row.withholdingFile.extension}}</p></a></div></div></md-list-item></md-list></div>\n</div></div><style>.selected {\n        background-color: lightblue;\n    }</style>");
$templateCache.put("app/main/apps/company-providers/validate-provider/provider-information/validate-dialog/validate-dialog.html","<md-dialog class=\"dialog-account\" aria-label=\"Validar Proveedor\"><ms-widget flippable=\"true\" layout=\"row\" \nclass=\"widget-account\"><ms-widget-front class=\"white-bg\" ms-scroll><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{\'productAccount.cuentaContable\'| translate}}\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.newContact ? vm.flip() : vm.cancel()\" aria-label=\"Close\" \ntranslate translate-attr-aria-label=\"general.close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div><form ng-submit=\"vm.getAccounts(1)\" name=\"vm.searchForm\"><div \nclass=\"md-toolbar-tools\"><md-input-container flex style=\"margin-top: 60px\"><label translate=\"general.filter\">Filtro\n</label><input type=\"text\" ng-model=\"vm.filterAccount\" name=\"searchAccount\" ng-keyup=\"vm.changeFilter()\" \nid=\"searchAccount\"></md-input-container><md-button type=\"submit\" aria-label=\"Search\"><span translate=\"general.search\">\nSearch</span></md-button></div></form></div></div></div></md-toolbar><md-progress-linear type=\"indeterminate\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear><md-dialog-content style=\"padding: 0px\"><div layout=\"column\" \nclass=\"p-16 widget-front-content-account\" style=\"padding: 0px\"><div id=\"e-commerce-product\" \nclass=\"md-dialog-list-content center p-16\"><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"content thread-list\" ms-scroll>\n<div class=\"thread\" md-ink-ripple ng-repeat=\"product in vm.accounts.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\'current-thread\':vm.account.id === product.id}\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"info\" flex><div class=\"title\">\n{{product.code ? product.code + \' - \' : \'\'}}{{product.description}} ({{product.levels}})</div><div class=\"notes\"></div>\n</div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" \nng-if=\"vm.account.id === product.id\"><md-icon md-font-icon=\"icon-check-all\"></md-icon></div></div></div></div></div>\n<div layout=\"row\" layout-align=\"center center\"><div paging class=\"pageable-div center\" page=\"vm.page\" \nul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getAccounts(page)\" \ntotal=\"vm.accounts.totalElements\"></div></div></div><div class=\"div-loader\" ng-show=\"vm.loading\"><md-progress-circular \nclass=\"ajax-loader md-accent md-hue-2\" md-mode=\"indeterminate\"></md-progress-circular></div></div></div>\n</md-dialog-content></ms-widget-front><ms-widget-back class=\"white-bg\" ms-scroll><div \nng-init=\"vm.flipping(flipWidget);\"></div><div class=\"page-layout carded fullwidth\" layout=\"column\"><md-toolbar \nclass=\"md-accent md-tall md-toolbar-more\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title| translate}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close\" translate translate-attr-aria-label=\"general.close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"center\" layout=\"column\" flex>\n<div class=\"md-dialog-content\" ms-scroll><form name=\"vm.accountProviderForm\" id=\"accountProviderForm\" \nng-submit=\"vm.save()\"><div layout=\"row\"><div flex=\"30\"><strong><label translate=\"productAccount.cuentaContable\">\nCuenta contable:</label></strong></div><div flex=\"70\"><span required>\n{{vm.account.code ? vm.account.code + \" - \" + vm.account.description : \"\"}}</span></div><md-button \nclass=\"md-icon-button\" ng-click=\"vm.onEdit()\"><md-icon \nmd-font-icon=\"{{vm.account.accountingCatalog \n                                            && vm.account.accountingCatalog.id ? \'icon-border-color\' : \'icon-plus\'}}\">\n</md-icon><md-tooltip md-direction=\"left\">{{vm.account && vm.account.id?\"general.edit\":\"general.add\"| translate}}\n</md-tooltip></md-button></div><div layout=\"row\"><md-input-container flex=\"100\" class=\"md-block\"><label \ntranslate=\"validate_provider.paymentCondition\"></label><md-select ng-model=\"vm.paymentCondition.id\" \nname=\"paymentCondition\" required md-on-close=\"vm.clearSearchPaymentCondition()\"><md-select-header><input \nid=\"searchPaymentCondition\" ng-model=\"vm.searchPaymentCondition\" type=\"search\" translate \ntranslate-attr-placeholder=\"validate_provider.paymentCondition\"></md-select-header><md-optgroup \nlabel=\"paymentConditions\"><md-option ng-value=\"{{data.id}}\" \nng-repeat=\"data in vm.paymentConditions | filter:vm.searchPaymentCondition\">{{data.name}}</md-option></md-optgroup>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"100\" class=\"md-block\"><label \ntranslate=\"providerGroup.providerGroup\"></label><md-select ng-model=\"vm.providerGroup.id\" name=\"providerGroup\" \nrequired md-on-close=\"vm.clearSearchProviderGroup()\"><md-select-header><input id=\"searchProviderGroup\" \nng-model=\"vm.searchProviderGroup\" type=\"search\" translate translate-attr-placeholder=\"providerGroup.providerGroup\">\n</md-select-header><md-optgroup label=\"providerGroups\"><md-option ng-value=\"{{data.id}}\" \nng-repeat=\"data in vm.providerGroups | filter:vm.searchProviderGroup\">{{data.groupCode}} - {{data.groupName}}\n</md-option></md-optgroup></md-select></md-input-container></div></form></div></div></div></ms-widget-back></ms-widget>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between\" class=\"dialog-actions-account\"><md-button \nng-click=\"vm.cancel()\" ng-disabled=\"vm.isShowProgressLinear\">{{\'general.cancel\'| translate}}</md-button><md-button \ntype=\"submit\" form=\"accountProviderForm\" \nng-disabled=\"vm.accountProviderForm.$invalid \n            || vm.account === undefined \n            || vm.account === null \n            || vm.isShowProgressLinear\">\n{{\'general.save\'| translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/AdditionalFieldValuesDialog/AdditionalFieldValuesDialog.html","<md-dialog id=\"additional-field-values\" class=\"compose-dialog\" style=\"height: 80%\" \naria-label=\"Additional field dialog\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label>{{vm.dialogTitle}}</label></h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.showLoadingProgress\"></md-progress-linear>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"column\"><div class=\"field-values-search\" layout=\"row\" \nlayout-align=\"start center\"><input flex flex type=\"search\" ng-model=\"vm.searchInput\" \nplaceholder=\"{{\'DISCOUNTS.search\'| translate}}\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></div><div \nclass=\"field-value\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"additionalFieldValue in vm.additionalFieldValueList | filter:vm.searchInput\" \nng-click=\"vm.selectValue(additionalFieldValue)\"><span>{{additionalFieldValue.fieldValue}}</span></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/dialogMoreFilters/dialogMoreFilters.html","<md-dialog style=\"width: 80%; height: 90%\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"DISCOUNTS.addFilters\">addFilters</label><label \ntranslate=\"DISCOUNTS.for\">for</label>{{vm.data ? \'DISCOUNTS.types.\'+vm.data.discountType : \'\' |translate}}</h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><ms-widget \nflippable=\"true\" layout=\"row\" style=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><div \nclass=\"toolbar\"><form name=\"vm.dataFormList\"><div layout=\"row\" layout-align=\"center center\"><md-input-container flex \nclass=\"md-block\"><label translate=\"DISCOUNTS.FILTER_VALUE\"></label><input ng-model=\"vm.discountDatesFilterValue\">\n</md-input-container><md-button class=\"md-fab md-mini\" aria-label=\"addDetail\" ng-disabled=\"vm.dataForm.$invalid\" \nng-click=\"vm.addFieldValue($event)\"><md-icon md-font-icon=\"icon-plus\"><md-tooltip md-direction=\"top\">\n{{\"general.save\"| translate}}</md-tooltip></md-icon></md-button></div></form></div><div id=\"discountFieldValueGrid\" \nag-grid=\"vm.discountFieldValueGrid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"300\"></div></ms-widget-front>\n<ms-widget-back id=\"perms\" class=\"white-bg\" ms-scroll><div ng-init=\"vm.flipping(flipWidget);\"></div><div \nclass=\"page-layout carded fullwidth\" layout=\"column\"><div class=\"toolbar\"><form name=\"vm.dataForm\"><div layout=\"row\" \nlayout-align=\"center center\"><md-input-container flex class=\"md-block\"><label>Aplicar descuento sobre:</label>\n<md-select ng-model=\"vm.discountEntity\" name=\"discountEntity\" ng-change=\"vm.filterByEntityName()\"><md-option \nng-value=\"entity.name\" ng-repeat=\"entity in vm.entitiesToApplyDiscounts\">{{entity.description}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-input-container flex class=\"md-block\">\n<label translate=\"DISCOUNTS.DISCOUNT_FIELD\"></label><md-select ng-model=\"vm.discountDatesFilter.discountField.id\" \nname=\"discountField\" required md-on-close=\"vm.clearSearchDiscountField()\"><md-select-header><input \nid=\"searchDiscountField\" ng-model=\"vm.searchDiscountField\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"DiscountsField\"><md-option \nvalue=\"{{data.id}}\" ng-repeat=\"data in vm.discountFields| filter:vm.searchDiscountField\">\n{{data.discountFieldDescription}}</md-option></md-optgroup></md-select></md-input-container><md-input-container flex \nclass=\"md-block\"><label translate=\"DISCOUNTS.DISCOUNT_CONDITION\"></label><md-select \nng-model=\"vm.discountDatesFilter.discountCondition\" name=\"discountCondition\" required \nmd-on-close=\"vm.clearSearchDiscountCondition()\"><md-select-header><input id=\"searchDiscountCondition\" \nng-model=\"vm.searchDiscountCondition\" type=\"search\" translate translate-attr-placeholder=\"general.search\">\n</md-select-header><md-optgroup label=\"DiscountsCondition\"><md-option value=\"{{data.value}}\" \nng-repeat=\"data in vm.discountConditions| filter:vm.searchDiscountCondition\">{{data.translate | translate}} <strong>\n{{data.symbol}}</strong></md-option></md-optgroup></md-select></md-input-container><md-checkbox \nng-model=\"vm.discountDatesFilter.hasListValue\" ng-click=\"vm.createList(!vm.tabCurrent)\" \nng-disabled=\"vm.dataForm.$invalid || vm.discountDatesFilter.filterValue\">{{\"DISCOUNTS.HAS_LIST_VALUE\"| translate}}\n</md-checkbox><md-input-container flex class=\"md-block\" ng-if=\"!vm.discountDatesFilter.hasListValue\" \nstyle=\"margin-top: 40px; margin-left: 20px\"><label translate=\"DISCOUNTS.FILTER_VALUE\"></label><input \nng-model=\"vm.discountDatesFilter.filterValue\"></md-input-container><md-button class=\"md-fab md-mini\" \naria-label=\"addDetail\" ng-disabled=\"vm.dataForm.$invalid || vm.discountDatesFilter.hasListValue\" \nng-click=\"vm.saveFilter($event)\"><md-icon md-font-icon=\"icon-content-save\"><md-tooltip md-direction=\"top\">\n{{\"general.save\"| translate}}</md-tooltip></md-icon></md-button></div></form></div><div id=\"discountDatesFilterGrid\" \nag-grid=\"vm.discountDatesFilterGrid\" class=\"ag-fresh\" expand-grid min=\"100\" other=\"300\"></div></div></ms-widget-back>\n</ms-widget></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" \nstyle=\"position: relative; justify-content: space-between\"><md-button \nng-click=\"!vm.tabCurrent?vm.closeDialog():vm.flip();\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"vm.fieldValueList.length<=0\" ng-click=\"vm.save()\">{{\'DISCOUNTS.OK\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/dialogReference/dialogReference.html","<md-dialog class=\"compose-dialog\" aria-label=\"Document\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1><label>\n{{(\"DISCOUNTS.types.\" + vm.type) | translate}}</label></h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><md-progress-linear \nmd-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><div \nid=\"productParamenters\" layout=\"row\"><div class=\"center\" layout=\"column\" flex><md-card class=\"content-card\" \nlayout=\"column\" flex><div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll expand-grid min=\"200\" other=\"235\">\n<div class=\"search-list\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.searchInput\" \nplaceholder=\"{{\'DISCOUNTS.search\'| translate}} {{(\'DISCOUNTS.types.\' + vm.type) | translate}}\" ng-enter=\"vm.getAll()\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.getAll()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-if=\"vm.arrayCompanySelected.length > 0\" \nng-click=\"vm.arrayCompanySelected = []; vm.arraySelected()\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon></md-button></div><div ng-if=\"vm.objectArray.length > 0 && !vm.isShowLoader\"><div class=\"item\" \nng-repeat=\"obj in vm.objectArray\" ng-click=\"vm.selectdObject(obj)\" style=\"height: 50px\"><div layout=\"row\"><div \nlayout=\"row\" flex layout-align=\"start center\"><div class=\"obj-name\" ng-if=\"vm.type===\'INVENTORY\'\"><strong>{{obj.id}}\n</strong>\n {{obj.batchNumber}} / {{obj.productType.productTypeCode}} {{obj.productType.description}}({{obj.companyWarehouse.whsName}} \n<small>{{obj.provider.name}}</small>)</div><div class=\"obj-name\" ng-if=\"vm.type===\'PRODUCT\'\"><strong>{{obj.id}}\n</strong> {{obj.name}} / {{obj.brand}} {{obj.measurementUnit.name}}({{obj.company}} <small>{{obj.salePrice}}</small>)\n</div><div class=\"obj-name\" ng-if=\"vm.type===\'PRODUCT_TYPE\'\"><strong>{{obj.id}}</strong>\n {{obj.description}} / {{obj.productTypeCode}}</div><div class=\"obj-name\" ng-if=\"vm.type===\'PRODUCT_TYPE_ADD_FIELD\'\">\n<strong>{{obj.id}}</strong> {{obj.additionalFieldName}} / {{obj.dataType}}</div><div class=\"obj-name\" \nng-if=\"vm.type===\'PAYMENT_TYPE\'\"><strong>{{obj.id}} - </strong>{{obj.paymentTypeName}} / {{obj.paymentTypeCode}}</div>\n</div><md-icon md-font-icon=\"icon-check\" ng-if=\"vm.existSelectedObject(obj.id)\"></md-icon></div></div></div><div \nng-if=\"vm.objectArray.length === 0 && !vm.isShowLoader\" layout=\"column\" layout-align=\"center center\" \nclass=\"message-empty-list\"><div>{{\'DISCOUNTS.NO\'| translate}} {{(\"DISCOUNTS.types.\" + vm.type) | translate}}s</div>\n</div><div layout=\"column\" layout-align=\"center center\" class=\"loader-content-list\" ng-if=\"vm.isShowLoader\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\n{{\'DISCOUNTS.loading\'| translate}} {{(\"DISCOUNTS.types.\" + vm.type) | translate}}s...</div></div></div><div \nlayout=\"row\"><div paging class=\"pageable-div center\" page=\"vm.pagination.pageNumber\" ul-class=\"pagination\" \npage-size=\"vm.pagination.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.pagination.getPage(page)\" \ntotal=\"vm.pagination.totalElements\"></div></div></md-card></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.closeDialog()\">{{\'general.cancel\'| translate}}\n</md-button><md-button ng-disabled=\"!vm.objectsSelected.length > 0\" ng-click=\"vm.save()\">{{\'DISCOUNTS.OK\'| translate}}\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/addDiscountPriorityDialog/AddDiscountPriorityDialog.html","<md-dialog id=\"add-discount-priority-dialog\" class=\"compose-dialog\" style=\"height: 80%\" \naria-label=\"Add discount priority\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label>Configurar orden de descuentos</label></h1><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.showLoadingProgress\"></md-progress-linear>\n</md-toolbar><md-dialog-content ms-scroll><form name=\"vm.dataForm\" layout=\"column\"><div layout=\"row\">\n<md-input-container flex class=\"md-block\"><label translate=\"DISCOUNTS.DISCOUNT_TYPE\"></label><md-select \nng-model=\"vm.discountEstablishmentPriority.discountType\" name=\"discount\" required md-on-close=\"vm.searchDiscount = \'\'\">\n<md-select-header><input ng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchDiscount\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Discounts\"><md-option \nvalue=\"{{data.keyDiscountType}}\" ng-repeat=\"data in vm.discountTypes| filter:vm.searchDiscount\">{{data.value}} <span \nng-if=\"data.isPercentage\">%</span></md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container flex class=\"md-block\" style=\"margin-top: 40px\"><label translate=\"DISCOUNTS.PRIORITY_ORDER\"></label>\n<input type=\"number\" ng-model=\"vm.discountEstablishmentPriority.priorityOrder\" required></md-input-container></div><div\n layout=\"row\"><md-input-container flex class=\"md-block\"><label translate=\"DISCOUNTS.SECOND_DISCOUNT_TYPE\"></label>\n<md-select ng-model=\"vm.discountEstablishmentPriority.secondDiscountType\" name=\"discount\" \nmd-on-close=\"vm.searchDiscount = \'\'\"><md-select-header><input ng-keydown=\"$event.stopPropagation()\" \nng-model=\"vm.searchDiscount\" type=\"search\" translate translate-attr-placeholder=\"general.search\"></md-select-header>\n<md-optgroup label=\"Discounts\"><md-option value=\"{{data.keyDiscountType}}\" \nng-repeat=\"data in vm.discountTypes| filter:vm.searchDiscount\">{{data.value}} <span ng-if=\"data.isPercentage\">%</span>\n</md-option></md-optgroup></md-select></md-input-container></div><div layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-primary\" ng-disabled=\"vm.dataForm.$invalid\" ng-click=\"vm.save($event)\">\n{{\"general.save\"| translate}}</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/discountEstablishmentProductType/discounts.html","<div ng-style=\"dptCtrl.dinamicHeight\" ng-if=\"dptCtrl.loadingDiscounts\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"loading-data\">\n{{dptCtrl.messageOnLoadDiscounts}}...</span></div><md-card ng-if=\"dptCtrl.selectedProducttype.id\"><div \nng-style=\"dptCtrl.dinamicHeight\" class=\"custom-list\" ms-scroll><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"item\" ng-repeat=\"discount in dptCtrl.establishmentDiscounts\"><div flex layout=\"row\" layout-align=\"start center\">\n<div><div class=\"notes\" layout=\"column\"><span>{{discount.discountCompany.discountName}}</span></div></div></div><div \nlayout=\"row\" layout-align=\"center center\" style=\"width: 44px\"><md-switch ng-hide=\"discount.loading\" class=\"md-accent\" \nmd-no-ink aria-label=\"Switch No Ink\" ng-model=\"discount.selected\" ng-change=\"dptCtrl.onChangeDiscount(discount)\">\n</md-switch><md-progress-circular md-diameter=\"20px\" md-mode=\"indeterminate\" ng-hide=\"!discount.loading\" \nclass=\"md-accent\"></md-progress-circular></div></div></div></md-card>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/discountEstablishmentProductType/producttype-list.html","<md-card><div ng-style=\"dptCtrl.dinamicHeight\" class=\"custom-list\" ms-scroll><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"dptCtrl.selectProductType(producttype)\" class=\"item\" \nng-class=\"{\'selected\': dptCtrl.selectedProducttype.id === producttype.id}\" \nng-repeat=\"producttype in dptCtrl.producttypes\"><div flex layout=\"row\" layout-align=\"start center\"><div><div \nclass=\"notes\" layout=\"column\"><span>\n{{producttype.productTypeCode ? producttype.productTypeCode + \' - \' : \'\'}}{{producttype.description}}</span></div>\n</div></div><div ng-if=\"dptCtrl.selectedProducttype.id === producttype.id\" class=\"label md-green-300-bg\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div></md-card><div ng-style=\"dptCtrl.dinamicHeight\" \nng-if=\"dptCtrl.loadingPt\" layout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" \nclass=\"md-accent\"></md-progress-circular><span class=\"loading-data\">{{\'DISCOUNTS.loading\'| translate}}...</span></div>");
$templateCache.put("app/main/apps/generalConfiguration/discounts/discountsConfigure/discountDatesMessageDialog/discountDatesMessageDialog.html","<md-dialog id=\"discount-dates-message-dialog\" class=\"discount-dates-message-dialog\" \naria-label=\"Discount dates message\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label>\n{{\"general.edit\"| translate}} {{\"DISCOUNTS.message\"| translate}}</label></h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent custom-progress\" ng-show=\"vm.showLoadingProgress\">\n</md-progress-linear></md-toolbar><md-dialog-content ms-scroll class=\"custom-dialog-content\"><form name=\"vm.dataForm\" \nlayout=\"column\"><div layout=\"row\" class=\"message-content\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"DISCOUNTS.message\"></label><textarea ng-model=\"vm.discountDate.message\" autocomplete=\"off\"></textarea>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary\" \nng-disabled=\"vm.dataForm.$invalid\" ng-click=\"vm.save($event)\">{{\"general.save\"| translate}}</md-button></div></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/interfaz/report/dialogs/detail/detail.html","<md-dialog class=\"transaction-detail\" aria-label=\"detail of transaction\"><div layout=\"row\" class=\"tools-dialog\"><div \nflex=\"50\" layout=\"row\" layout-align=\"start center\"><h2 translate=\"REPORT.transaction_detail\">Detalle de transacción\n</h2></div><div flex=\"50\" layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div></div><div id=\"transactionDetailMasterGridOptions\" ag-grid=\"vm.masterGridOptions\" class=\"ag-fresh\">\n</div></md-dialog>");
$templateCache.put("app/main/apps/product/consultProducts/content/filter/filter.html","<div layout=\"row\" layout-align=\"end center\" class=\"toolbar-advanced-search\"><md-button class=\"md-icon-button\" \ntitle=\"{{\'notifications.clear_filters\'| translate}}\" ng-click=\"vm.generateFilter()\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18 md-warn\"></md-icon></md-button><md-button class=\"md-icon-button\" \ntitle=\"{{\'general.close\'| translate}}\" ng-click=\"vm.showAdvancedFilter = false; vm.generateFilter()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div><div layout=\"row\"><div flex \nng-if=\"vm.filtrar.fixedAsset!==null\"><md-switch aria-label=\"filter fixed Asset\" ng-model=\"vm.filtrar.fixedAsset\"><span \ntranslate=\"product_parameters.fixedAsset\">Filtrar productos Activos Fijos</span> <span \nng-click=\"vm.filtrar.fixedAsset=null\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\'product_parameters.delete_filter\'| translate}}</md-tooltip></span></md-switch></div><div flex \nng-if=\"vm.filtrar.fixedAsset===null\"><span translate=\"product_parameters.fixedAsset\">Filtrar productos Activos Fijos\n</span> <span ng-click=\"vm.filtrar.fixedAsset=true\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon><md-tooltip\n md-direction=\"top\">{{\'product_parameters.add_filter\'| translate}}</md-tooltip></span></div><div flex \nng-if=\"vm.filtrar.isConsignment!==null\"><md-switch aria-label=\"filter is Consignment\" \nng-model=\"vm.filtrar.isConsignment\"><span translate=\"product_parameters.isConsignment\">\nFiltrar productos En Consignacion</span> <span ng-click=\"vm.filtrar.isConsignment=null\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'product_parameters.delete_filter\'| translate}}</md-tooltip></span></md-switch></div><div flex \nng-if=\"vm.filtrar.isConsignment===null\"><span translate=\"product_parameters.isConsignment\">\nFiltrar productos En Consignacion</span> <span ng-click=\"vm.filtrar.isConsignment=true\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'product_parameters.add_filter\'| translate}}</md-tooltip></span></div></div><div layout=\"row\"><div flex \nng-if=\"vm.filtrar.isExento!==null\"><md-switch aria-label=\"filter is Exento\" ng-model=\"vm.filtrar.isExento\"><span \ntranslate=\"product_parameters.filterIsExento\">Filtrar productos Exentos</span> <span \nng-click=\"vm.filtrar.isExento=null\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\'product_parameters.delete_filter\'| translate}}</md-tooltip></span></md-switch></div><div flex \nng-if=\"vm.filtrar.isExento===null\"><span translate=\"product_parameters.filterIsExento\">Filtrar productos Exentos</span>\n <span ng-click=\"vm.filtrar.isExento=true\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon><md-tooltip \nmd-direction=\"top\">{{\'product_parameters.add_filter\'| translate}}</md-tooltip></span></div><div flex \nng-if=\"vm.filtrar.generateReposition!==null\"><md-switch aria-label=\"filter generate Reposition\" \nng-model=\"vm.filtrar.generateReposition\"><span translate=\"product_parameters.generateReposition\">\nFiltrar productos generaron reposicion</span> <span ng-click=\"vm.filtrar.generateReposition=null\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'product_parameters.delete_filter\'| translate}}</md-tooltip></span></md-switch></div><div flex \nng-if=\"vm.filtrar.generateReposition===null\"><span translate=\"product_parameters.generateReposition\">\nFiltrar productos generaron reposicion</span> <span ng-click=\"vm.filtrar.generateReposition=true\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon><md-tooltip md-direction=\"top\">\n{{\'product_parameters.add_filter\'| translate}}</md-tooltip></span></div></div><div layout=\"row\"><div flex \nng-if=\"vm.filtrar.validated!==null\"><md-switch aria-label=\"filter no validated products\" \nng-model=\"vm.filtrar.validated\"><span translate=\"product_parameters.filter_no_validated\">Filtrar productos no validados\n</span> <span ng-click=\"vm.filtrar.validated=null\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon><md-tooltip\n md-direction=\"top\">{{\'product_parameters.delete_filter\'| translate}}</md-tooltip></span></md-switch></div><div flex \nng-if=\"vm.filtrar.validated===null\"><span translate=\"product_parameters.filter_no_validated\">\nFiltrar productos no validados</span> <span ng-click=\"vm.filtrar.validated=true\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s18\"></md-icon><md-tooltip md-direction=\"top\">{{\'product_parameters.add_filter\'| translate}}</md-tooltip></span>\n</div></div><div layout=\"row\"><md-input-container flex><label>{{\'product_parameters.productCodeERP\'| translate}}\n</label><input ng-model=\"vm.filtrar.productCodeERP\" type=\"text\" \nclass=\"ng-valid md-input ng-not-empty ng-dirty ng-valid-parse ng-touched\" id=\"input_37\" aria-invalid=\"false\" style=\"\" \nname=\"city\"></md-input-container></div><div layout=\"row\"><md-input-container flex><label>\n{{\'product_parameters.productCodeERP\'| translate}}</label><input ng-model=\"vm.filtrar.productCodeERP2\" type=\"text\">\n</md-input-container></div><div layout=\"row\"><md-input-container flex><label>\n{{\'product_parameters.productCodeERP\'| translate}}</label><input ng-model=\"vm.filtrar.productCodeERP3\" type=\"text\">\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.getProducts(1, true)\">{{\'general.search\'| translate}}</md-button></div>");
$templateCache.put("app/main/apps/product/parameters/dialogs/product-list-batch-dialog/product-list-batch-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nstyle=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'product_parameters.productupdated\'| translate}}\"></md-tab></md-tabs></div><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill class=\"md-dialog-list-content\"><div class=\"content thread-list\"><div \nclass=\"thread\" md-ink-ripple ng-repeat=\"product in vm.productos.content\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"info\" flex layout=\"row\"><div class=\"title h3\"><strong>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</strong></div><span flex></span><div \nclass=\"div-loader\" ng-show=\"!product.loading\"><span class=\"red\" ng-if=\"product.isError\">\n{{\'product_parameters.have_error\'| translate}}</span> <span class=\"green\" ng-if=\"!product.isError\">\n{{\'product_parameters.saved_success\'| translate}}</span></div><div class=\"div-loader\" ng-show=\"product.loading\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-accent md-hue-2\" md-mode=\"indeterminate\"></md-progress-circular>\n</div></div></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/product/parameters/dialogs/product-list-dialog/product-list-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\" ng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div\n style=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'product_parameters.product\'| translate}}\"></md-tab></md-tabs></div><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.activeSearch()\" aria-label=\"Close dialog\" tranlate \nng-if=\"vm.selectedTab === 0\" translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-toolbar class=\"md-accent md-hue-2\" ng-show=\"vm.searchMode\"><form ng-submit=\"vm.getProducts(1)\" \nname=\"vm.searchForm\"><div class=\"md-toolbar-tools\"><md-button type=\"button\" class=\"md-icon-button\" \nng-click=\"vm.searchMode = !vm.searchMode; vm.getProducts(1)\" aria-label=\"Back\"><ng-md-icon icon=\"arrow_back\">\n</ng-md-icon></md-button><md-input-container flex style=\"margin-top: 60px\"><label translate=\"general.filter\">Filtro\n</label><input type=\"text\" ng-model=\"vm.filterProduct\" name=\"searchText\" id=\"searchField\" \nng-model-options=\"{\'debounce\': 500}\"><div ng-messages=\"vm.searchForm.searchText.$error\"><div ng-message=\"required\" \ntranslate=\"error.field_required\">This date is required!</div></div></md-input-container><md-button type=\"submit\" \naria-label=\"Search\"><span translate=\"general.filter\">Search</span></md-button></div></form></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill ng-class=\"vm.selectedTab === 0 ? \'md-dialog-list-content\' : \'\'\"><div \nng-if=\"vm.selectedTab === 0\"><div class=\"content thread-list\" ng-show=\"!vm.creatingProduct\"><div class=\"thread\" \nmd-ink-ripple ng-if=\"!vm.loading\" ng-repeat=\"product in vm.productos.content\" ng-click=\"vm.selectProduct(product)\" \nng-class=\"{\n                                 \'current-thread\': vm.product.id === product.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"row\"><div><div class=\"title h3\"><strong>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</strong></div><div class=\"notes\" \nlayout=\"column\"><span ng-if=\"product.brand\"><strong>Marca: </strong>{{product.brand}}</span> <span \nng-if=\"product.company\"><strong>Empresa: </strong>{{product.company}}</span> <span ng-if=\"product.measurementUnit\">\n<strong>Unidad de Medida: </strong>{{product.measurementUnit.name}}</span></div></div><span flex></span><div \nng-if=\"product.salePrice || product.buyPrice\"><h1 ng-if=\"product.buyPrice && product.buyPrice > 0\">\n{{product.currencyBuy.symbol}} {{product.buyPrice| number: 2}}</h1><h1 \nng-if=\"!product.buyPrice && product.salePrice && product.salePrice > 0\">\n{{product.currencySale.symbol}} {{product.salePrice| number: 2}}</h1></div></div></div><div layout=\"column\" \nlayout-align=\"space-between end\"><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\" ng-if=\"vm.product.id === product.id\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div></div></div><div class=\"div-loader\" ng-show=\"vm.loading\">\n<md-progress-circular class=\"ajax-loader md-accent md-hue-2\" md-mode=\"indeterminate\"></md-progress-circular></div>\n</div></md-dialog-content><md-dialog-actions style=\"justify-content: center\" class=\"actionsSpace\" \nng-if=\"vm.selectedTab === 0 && !vm.creatingProduct\"><div paging class=\"pageable-div\" page=\"vm.page\" \nul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" \ntotal=\"vm.productos.totalElements\"></div><md-button ng-click=\"vm.sendDetail()\" \nclass=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" ng-if=\"vm.canSave\" ng-disabled=\"vm.loading\" \ntranslate-attr-aria-label=\"product_parameters.select_product\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/parameters/dialogs/reposition-days-dialog/reposition-days-dialog.html","<md-dialog aria-label=\"add-reposition-days\" class=\"reposition-days-dialog\" id=\"add-reposition-days\" ms-scroll \nstyle=\"width: 80%\"><md-toolbar class=\"md-accent md-hue-2\" layout=\"row\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"min-width: 400px\"><span>\n{{\'product_parameters.repositionDaysProduct\'| translate}}</span></div><span flex></span><md-button \naria-label=\"Close dialog\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content flex layout-fill ms-scroll><form name=\"vm.dataForm\"><div layout-align=\"start center\" \nlayout-gt-xs=\"row\"><md-input-container flex-gt-xs><label translate=\"product_parameters.daysOfWeek\">DAYS_OF_WEEK</label>\n<md-select name=\"dayOfWeek\" ng-disabled=\"vm.loading\" ng-model=\"vm.salePurchaseRepositionDays.dayOfWeek\" \nng-required=\"true\"><md-optgroup><md-option ng-repeat=\"data in vm.copyArrayDaysOfWeek\" value=\"{{data.id}}\">\n{{\"product_parameters.\" + data.value | translate}}</md-option></md-optgroup></md-select><md-progress-linear \nmd-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-linear><div ng-messages=\"vm.dataForm.dayOfWeek.$error\"><div \nng-message=\"required\" translate=\"error.field_required\">This is required!</div></div></md-input-container><md-button \naria-label=\"addDayOfWeek\" class=\"md-fab md-mini\" ng-click=\"vm.save()\" ng-disabled=\"vm.dataForm.$invalid || vm.loading\">\n<md-icon md-font-icon=\"icon-plus\"><md-tooltip md-direction=\"top\">{{\"general.add\"| translate}}</md-tooltip></md-icon>\n</md-button></div></form><div class=\"content fullpage-datatable\" flex layout=\"column\"><md-progress-linear \nclass=\"md-accent\" md-mode=\"indeterminate\" ng-if=\"vm.loading\"></md-progress-linear><div ag-grid=\"vm.gridOptions\" \nclass=\"ag-fresh\" expand-grid id=\"gridOptions\" min=\"100\" ng-show=\"vm.showGrid\" other=\"100\"></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/product/product-list/dialogs/create/create-product.html","<md-dialog class=\"create-product-dialog\" aria-label=\"create or edit product\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1>\n{{vm.product.id === null ? \'general.add\' : \'general.edit\'| translate}}</h1><md-button aria-label=\"button close\" \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<md-progress-linear md-mode=\"query\" class=\"md-accent\" style=\"z-index: 2; height: 5px; position: fixed; top: 64px\" \nng-show=\"vm.isShowProgressLinear\"></md-progress-linear></md-toolbar><md-dialog-content ms-scroll><form \nname=\"vm.createProduct\"><div layout=\"column\"><md-input-container flex><label translate=\"CREATE.CODE\"></label><input \ntype=\"text\" name=\"name\" ng-model=\"vm.product.productCode\"></md-input-container><md-input-container flex><label \ntranslate=\"CREATE.NAME\"></label><input type=\"text\" name=\"name\" ng-model=\"vm.product.name\" required><div \nng-messages=\"vm.createProduct.name.$error\" ng-show=\"vm.createProduct.name.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"general.field_required\"></span></div></div></md-input-container>\n<md-input-container flex><label translate=\"CREATE.MEASURE\"></label><md-select ng-disabled=\"vm.loadingMeasures\" \nng-model=\"vm.product.measurementUnit.name\" name=\"measure\" required md-on-close=\"vm.clearSearchMeasure()\">\n<md-select-header><input id=\"searchMeasureses\" ng-model=\"vm.searchMeasures\" type=\"search\" translate \ntranslate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Measures\"><md-option \nvalue=\"{{measure.name}}\" ng-repeat=\"measure in vm.measures| filter: vm.searchMeasures |  orderBy:\'name\'\">\n{{measure.name}}</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingMeasures\"></md-progress-linear><div ng-messages=\"vm.createProduct.measure.$error\" \nng-show=\"vm.createProduct.measure.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"general.field_required\"></span></div></div></md-input-container><div layout=\"row\" flex \nlayout-align=\"center center\"><md-input-container flex ng-if=\"!vm.noExistBrand\"><label translate=\"CREATE.BRAND\"></label>\n<md-select ng-disabled=\"vm.loadingBrands\" ng-model=\"vm.product.brand.name\" name=\"brand\" required \nmd-on-close=\"vm.clearSearchBrand()\"><md-select-header><input id=\"searchBrand\" ng-model=\"vm.searchBrand\" type=\"search\" \ntranslate translate-attr-placeholder=\"general.search\"></md-select-header><md-optgroup label=\"Brands\"><md-option \nvalue=\"{{brand.name}}\" ng-repeat=\"brand in vm.brands| filter:vm.searchBrand |  orderBy:\'name\'\">{{brand.name}}\n</md-option></md-optgroup></md-select><md-progress-linear md-mode=\"indeterminate\" ng-if=\"vm.loadingBrands\">\n</md-progress-linear><div ng-messages=\"vm.createProduct.brand.$error\"><div ng-message=\"required\"><span \ntranslate=\"general.field_required\"></span></div></div></md-input-container><md-input-container flex \nng-if=\"vm.noExistBrand\"><label translate=\"CREATE.BRANDNEW\"></label><input type=\"text\" id=\"ipBrand\" name=\"brand\" \nng-model=\"vm.product.brand.name\" required autofocus><div ng-messages=\"vm.createProduct.brand.$error\" \nng-show=\"vm.createProduct.brand.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"general.field_required\"></span></div></div></md-input-container><md-button class=\"md-icon-button\" \nng-click=\"vm.changeBrand()\" aria-label=\"brand\"><div ng-if=\"!vm.noExistBrand\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip>{{\'CREATE.BRANDADD\'| translate}}</md-tooltip></div><div ng-if=\"vm.noExistBrand\"><md-tooltip>\n{{\'CREATE.BRANDSEARCH\'| translate}}</md-tooltip><md-icon md-font-icon=\"icon-magnify\"></md-icon></div></md-button></div>\n<md-input-container flex><label translate=\"CREATE.TYPE\"></label><md-select ng-model=\"vm.product.type\" name=\"type\" \nrequired><md-option value=\"P\">{{\'CREATE.TYPES.P\'|translate}}</md-option><md-option value=\"S\">\n{{\'CREATE.TYPES.S\'|translate}}</md-option></md-select></md-input-container><md-input-container flex><label \ntranslate=\"CREATE.DESCRIPTION_1\"></label><input type=\"text\" id=\"description1\" ng-model=\"vm.product.description1\">\n</md-input-container><md-input-container flex><label translate=\"CREATE.DESCRIPTION_2\"></label><input type=\"text\" \nid=\"description2\" ng-model=\"vm.product.description2\"></md-input-container><md-input-container flex><label \ntranslate=\"CREATE.BARCODE\"></label><input type=\"text\" id=\"barCode\" ng-model=\"vm.product.barCode\"></md-input-container>\n<md-input-container flex><label translate=\"CREATE.EAN_CODE\"></label><input type=\"text\" id=\"ean\" \nng-model=\"vm.product.ean\"></md-input-container><md-input-container flex><label translate=\"CREATE.GOOGLE_CATEGORY\">\n</label><input type=\"text\" id=\"googleCategory\" ng-model=\"vm.product.googleCategory\"></md-input-container>\n<md-input-container flex><label translate=\"CREATE.ISBN\"></label><input type=\"text\" id=\"isbn\" \nng-model=\"vm.product.isbn\"></md-input-container><md-input-container flex><label translate=\"CREATE.UPC\"></label><input \ntype=\"text\" id=\"upc\" ng-model=\"vm.product.upc\"></md-input-container><md-input-container flex><label \ntranslate=\"CREATE.URL_REFERENCE\"></label><input type=\"text\" id=\"urlReference\" ng-model=\"vm.product.urlReference\">\n</md-input-container><md-input-container flex><label translate=\"CREATE.MX_PRODUCT_CODE\"></label><input type=\"text\" \nid=\"mxProductCode\" ng-model=\"vm.product.mxProductCode\"></md-input-container><md-input-container flex><label \ntranslate=\"CREATE.PROVIDER_CODE\"></label><input type=\"text\" id=\"providerCode\" ng-model=\"vm.product.providerCode\">\n</md-input-container><div layout=\"row\" flex layout-align=\"space-between center\"><md-input-container flex><label \ntranslate=\"CREATE.HIGH\"></label><input type=\"text\" id=\"high\" ng-model=\"vm.product.high\"></md-input-container>\n<md-input-container flex><label translate=\"CREATE.WIDTH\"></label><input type=\"number\" id=\"width\" \nng-model=\"vm.product.width\"></md-input-container></div><div layout=\"row\" flex layout-align=\"space-between center\">\n<md-input-container flex><label translate=\"CREATE.DEPTH\"></label><input type=\"number\" id=\"depth\" \nng-model=\"vm.product.depth\"></md-input-container><md-input-container flex><label \ntranslate=\"CREATE.DAYS_INVENTORY_DURATION\"></label><input type=\"number\" id=\"daysInventoryDuration\" \nng-model=\"vm.product.daysInventoryDuration\"></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"space-between center\"><md-input-container flex><label translate=\"CREATE.MASTER_BOX_UNITS\"></label><input \ntype=\"number\" id=\"masterBoxUnits\" ng-model=\"vm.product.masterBoxUnits\"></md-input-container><md-input-container flex>\n<label translate=\"CREATE.MASTER_BOX_CODE\"></label><input type=\"text\" id=\"masterBoxCode\" \nng-model=\"vm.product.masterBoxCode\"></md-input-container></div><div layout=\"row\" flex \nlayout-align=\"space-between center\"><md-input-container flex><label translate=\"CREATE.EXPIRATION_DATE\">\nFecha de expiración</label><md-datepicker type=\"date\" ng-model=\"vm.product.expirationDate\" name=\"expirationDate\" \nmd-open-on-focus md-placeholder=\"dd-MM-yyyy\"></md-datepicker><div ng-messages=\"vm.createProduct.expirationDate.$error\">\n<div ng-message=\"valid\" translate=\"error.invalid_date\">The entered value is not a date!</div></div>\n</md-input-container><md-checkbox flex ng-model=\"vm.product.isPhoneService\">{{\'general.isPhoneService\'| translate}}\n</md-checkbox></div></div></form><fieldset class=\"standard\" ng-if=\"vm.product.productPhotos.length > 0\"><legend>\n{{\'CREATE.PHOTOS\' | translate}}</legend><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"file in vm.product.productPhotos| filter: {active: \'true\'}\"><md-content><div layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"space-between center\"><img class=\"media product-image\" \nng-src=\"{{vm.baseUrlSharedFiles}}{{file.photo.parentPath}}{{file.photo.name}}{{\'t\'}}{{file.photo.extension}}\" \nalt=\"image\" width=\"auto\" height=\"auto\" style=\"width: 120px; height: 120px\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button class=\"md-icon-button\" ng-click=\"vm.viewImage(file)\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s16\"></md-icon><md-tooltip md-direction=\"left\">{{\"CREATE.VIEW\"| translate}}</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.fileRemove(file)\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s16 md-warn\"></md-icon><md-tooltip md-direction=\"left\">{{\"general.delete\"| translate}}</md-tooltip></md-button>\n</div></div></div></md-content></div></div></fieldset><div layout=\"row\" flex=\"100\"><div flex=\"100\" \nng-include=\"\'app/main/apps/company/documents/files/files.html\'\"></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><div flex layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"vm.createProduct.$invalid || vm.loading\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \naria-label=\"Crear\">{{\'general.save\'|translate}}</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/product/pre-negotiated-price/filter/dialogProductType/dialogProductType.html","<md-dialog aria-label=\"Crear-Editar\" style=\"width: 90%; height: 90%\"><md-toolbar><div layout=\"row\" \nclass=\"headerToolbar\"><span style=\"padding-top: 20px; padding-left: 10px\">{{\'menu.productType\'| translate}}</span> \n<span flex></span><div class=\"search\" flex layout=\"row\" layout-align=\"start center\" style=\"padding-top: 10px\"><input \nid=\"searchField\" flex ng-keyup=\"vm.changeFilter()\" ng-enter=\"vm.getProducts(1)\" ng-model=\"vm.filterProduct\" \ntype=\"search\" style=\"height: 40px\" placeholder=\"  {{\'general.search\'| translate}}\"></div><md-button \naria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><md-dialog-content><div id=\"sidenav-product\" ms-scroll><div ng-if=\"vm.categorySelected.id !== 0\"><a \nstyle=\"cursor: pointer\" ng-click=\"vm.returnToAll();\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon><span \nclass=\"sub-title\">{{\'PRODUCT.ALL_CATEGORY\'|translate}}</span></a><br><br></div><span class=\"h4\"><strong>\n{{vm.categorySelected.name| translate}}</strong></span><div style=\"height: 40px\" ng-if=\"vm.loading\" layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular>\n<span class=\"loading-data\">{{\'department.charging_products\'| translate}}...</span></div><div id=\"tree\"></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.loading\"><md-button \nng-click=\"vm.cancel()\">{{\'general.cancel\'| translate}}</md-button><md-button \nng-disabled=\"!vm.productsToFilter.length>0\" ng-click=\"vm.selectProductType()\">{{\'general.save\'| translate}}</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/usr/user-guest/tabs/invite/invite.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"invite\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><div><h2>\n{{\'guest.ENTER_EMAIL_INVITE_USERS\'| translate}} {{\'guest.PRESS_ENTER_TO_VARIOUS_EMAILS\'| translate}}:</h2><div \nlayout=\"row\"><md-input-container flex=\"50\"><label translate=\"guest.application\">Application</label><md-select \nng-model=\"vm.appId\" name=\"app\" ng-change=\"vm.getRoles(app);\"><md-option ng-repeat=\"app in vm.applications\" \nvalue=\"{{app.application.id}}\">{{app.application.name}}</md-option></md-select></md-input-container><md-input-container\n flex=\"50\"><md-progress-linear style=\"position: fixed; height: 5px; z-index: 10\" md-mode=\"query\" class=\"md-accent\" \nng-show=\"vm.isShowProgressLinearRoles\"></md-progress-linear><label translate=\"guest.role\">Role</label><md-select \nng-model=\"vm.rolId\" name=\"rol\" required><md-option ng-repeat=\"role in vm.roles\" value=\"{{role.id}}\">\n{{role.description}} ({{role.name}})</md-option></md-select></md-input-container></div><div layout=\"row\"><md-chips \nflex=\"100\" md-add-on-blur=\"true\" ng-model=\"vm.invitationContacts\" md-separator-keys=\"vm.customKeys\" \nplaceholder=\"{{\'guest.CORREOS\'| translate}}\" md-transform-chip=\"vm.validateEmailChip($chip)\"></md-chips></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warn\" \nng-disabled=\"vm.invitationContacts.length === 0\" ng-click=\"vm.sendInvitation()\">{{\'guest.SEND_INVITATION\'| translate}}\n<md-icon md-svg-icon=\"send\"></md-icon></md-button></div></div></div></div></div></div>");
$templateCache.put("app/main/general/profile/tabs/userGroups/newGroup/newGroup.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\" ng-if=\"!vm.searchMode\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div\n style=\"min-width: 350px\"><label translate=\"{{\'GROUP.NEW_GROUP\'| translate}}\"></label></div><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill><div><form name=\"vm.groupForm\" ng-submit=\"vm.saveGroup()\"><div \nclass=\"order-detail-form-container status md-background-bg md-whiteframe-1dp\"><div layout-gt-xs=\"row\" \nlayout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label translate=\"GROUP.NAME\">\nGroup name</label><input required name=\"groupName\" ng-model=\"vm.group.groupName\" \nclass=\"ng-pristine md-input ng-empty ng-valid-email ng-invalid ng-invalid-required ng-valid-pattern ng-touched\" \naria-label=\"groupName\" id=\"groupName\" aria-invalid=\"true\"><div ng-messages=\"vm.groupForm.groupName.$error\"><div \nng-message=\"required\" translate=\"CORPORATION.ERROR.FIELD_REQUIRED\">is required!</div></div></md-input-container></div>\n<div layout-gt-xs=\"row\" layout-align=\"start center\" layout-align=\"start center\"><md-input-container flex-gt-xs><label \ntranslate=\"GROUP.DESCRIPTION\">Group description</label><input required name=\"groupDescription\" \nng-model=\"vm.group.groupDescription\" \nclass=\"ng-pristine md-input ng-empty ng-valid-email ng-invalid ng-invalid-required ng-valid-pattern ng-touched\" \naria-label=\"groupDescription\" id=\"groupDescription\" aria-invalid=\"true\"><md-progress-linear md-mode=\"indeterminate\" \nng-if=\"vm.loadingDepartments\"></md-progress-linear><div ng-messages=\"vm.groupForm.groupDescription.$error\"><div \nng-message=\"required\" translate=\"CORPORATION.ERROR.FIELD_REQUIRED\">is required!</div></div></md-input-container></div>\n<div layout-gt-xs=\"row\" style=\"margin-left: 150px\" layout-align=\"start center\" layout-align=\"start center\"></div>\n<md-input-container flex-gt-xs><md-checkbox ng-model=\"vm.group.searchDefault\" ng-change=\"vm.onChangeDefault()\">\n{{\'GROUP.SEARCH_DEFAULT\'|translate}}</md-checkbox></md-input-container></div></form></div><md-button \nng-click=\"vm.saveGroup()\" class=\"send-button md-accent md-fab md-fab-bottom-right\" aria-label=\"Send\" \nng-disabled=\"vm.groupForm.$invalid\" ng-disabled=\"vm.loading\" translate-attr-aria-label=\"PROFILE.SAVE\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon></md-button></md-dialog-content></md-dialog>");
$templateCache.put("app/main/general/profile/tabs/userGroups/members/members.html","<md-dialog class=\"department-product\" aria-label=\"department settings\"><ms-widget flippable=\"true\" layout=\"row\" \nstyle=\"padding: 0; height: 100%\"><ms-widget-front class=\"white-bg\" ms-scroll><div \nng-include=\"\'app/main/general/profile/tabs/userGroups/members/widget-content/widget-content.html\'\"></div>\n</ms-widget-front></ms-widget></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/codeBagCollectionQueue/dialog/dialogDetailCodeBag.html","<md-dialog class=\"compose-dialog\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"company_establishment.code\">code</label></h1>\n<md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form name=\"vm.dataForm\"><div layout=\"row\">\n<md-input-container flex class=\"md-block\"><label translate=\"company_establishment.code\"></label><input \nng-model=\"vm.bag.code\" required readonly=\"readonly\"></md-input-container></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.bag.used\" ng-disabled=\"vm.dataForm.$invalid\">{{\"company_establishment.used\"| translate}}</md-checkbox>\n</div><div layout=\"row\"><md-checkbox ng-model=\"vm.bag.isClosed\" ng-disabled=\"vm.dataForm.$invalid\">\n{{\"company_establishment.isClosed\"| translate}}</md-checkbox></div></form></md-dialog-content><md-dialog-actions>\n<md-button aria-label=\"btn\" ng-click=\"vm.cancel()\" class=\"md-primary\"><span translate=\"general.close\"></span>\n</md-button><md-button aria-label=\"btn\" ng-click=\"vm.saveBag()\" class=\"md-primary\"><span translate=\"general.save\">\n</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/parameters/content/content.html","<div class=\"content-wrapper\" layout=\"row\" flex><div id=\"parametersProductList\" class=\"content\" \nng-include=\"\'app/main/apps/company/company-establishments/establishment-list/parameters/content/product-list.html\'\" \nms-scroll flex=\"50\"></div><div class=\"content\" \nng-include=\"\'app/main/apps/company/company-establishments/establishment-list/parameters/content/product-parameter.html\'\" \nms-scroll flex=\"50\"></div></div>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/parameters/content/product-list.html","<div class=\"only-not-validated\" layout-align=\"space-between center\" layout-md=\"column\" layout-sm=\"column\" \nlayout-xs=\"column\" layout=\"row\" flex><md-switch aria-label=\"filter no validated products\" ng-model=\"vm.batchUpdate\" \nng-change=\"vm.changeBatch()\"><span translate=\"product_parameters.batch_update\">Actualización Masiva</span></md-switch>\n<span ng-if=\"vm.batchUpdate && vm.productos.totalElements\"><b>Total: {{vm.productos.totalElements}}</b></span></div>\n<div ng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loading\"><div layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.selectProduct(product)\" class=\"item\" \nng-class=\"{\'selected\': vm.selectedProduct.id === product.id}\" ng-repeat=\"product in vm.productos.content\"><div flex \nlayout=\"row\" layout-align=\"start center\" ng-class=\"{\'repeted-product\': product.repeated}\"><div><div class=\"notes\" \nlayout=\"column\"><span>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}} ({{\'CREATE.TYPES.\' + product.type| translate}})\n</span> <span ng-if=\"product.brand\"><b>{{\'CREATE.BRAND\'| translate}}: </b>{{product.brand.name}}</span> <span \nng-if=\"product.measurementUnit\"><b>{{\'CREATE.MEASURE\'| translate}}: </b>{{product.measurementUnit.name}}</span></div>\n</div></div><div ng-if=\"vm.selectedProduct.id === product.id\" class=\"label md-green-300-bg\"><md-icon \nmd-font-icon=\"icon-check-all\"></md-icon></div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loading\" \nlayout=\"column\" layout-align=\"center center\"><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\">\n</md-progress-circular><span class=\"loading-data\">{{\'department.charging_products\'| translate}}...</span></div><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"!vm.batchUpdate\" paging class=\"pageable-div center\" \npage=\"vm.page\" ul-class=\"pagination\" page-size=\"vm.pageSize\" hide-if-empty=\"true\" paging-action=\"vm.getProducts(page)\" \ntotal=\"vm.productos.totalElements\"></div></div>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/parameters/content/product-parameter.html","<div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadingParameters\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span class=\"loading-data\">\n{{vm.messageOnLoadParameter}}...</span></div><md-card style=\"margin-top: 0px\" \nng-if=\"!vm.loadingParameters && vm.selectedProduct\" id=\"productParameter\" class=\"card-content productParameterDetail\" \nlayout=\"column\" ng-if=\"vm.selectedProduct\"><div class=\"parameters-header\" layout=\"row\" layout-align=\"start center\" \nlayout-xs=\"column\"><div flex=\"85\" layout=\"row\" layout-align=\"start center\"><h4>{{vm.selectedProduct.name}}</h4></div>\n<div layout=\"row\"><md-switch ng-if=\"vm.batchUpdate\" ng-model=\"vm.saveInBatch\" aria-label=\"Validated product\"><span \ntranslate=\"product_parameters.saveInBatch\">Actualizar todos</span></md-switch><md-checkbox style=\"margin-top: 10px\" \nng-model=\"vm.productCompanyAddons.active\" ng-change=\"vm.save()\">{{\'product_parameters.ENABLE\'| translate}}\n</md-checkbox></div></div><div class=\"parameters-content\" layout=\"column\"><md-tabs ng-style=\"vm.dinamicMinHeight\" \nclass=\"md-accent\" md-selected=\"data.selectedIndex\" md-align-tabs=\"{{\'bottom\'}}\"><md-tab id=\"tab1\"><md-tab-label>\n<md-tooltip md-direction=\"top\">{{\'menu.parameters_product\'| translate}}</md-tooltip></md-tab-label><md-tab-body>\n<ng-form name=\"vm.parameterForm\"><fieldset class=\"standard\"><legend>{{\'product_parameters.pos_fields\'| translate}}\n</legend><div layout=\"row\" layout-xs=\"column\"><md-checkbox ng-model=\"vm.productCompanyAddons.posCanChangePrice\">\n{{\'product_parameters.CHANGEPRICE\'| translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.productCompanyAddons.posCanAddComments\">{{\'product_parameters.ADDCOMMENTS\'| translate}}</md-checkbox>\n</div><div layout=\"row\"><md-checkbox ng-model=\"vm.productCompanyAddons.posCanChangeQuantity\">\n{{\'product_parameters.CHANGEQUANTITY\'| translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.productCompanyAddons.isFreeOfTaxes\">{{\'product_parameters.is_free_of_taxes\' | translate}}</md-checkbox>\n</div><div layout=\"row\"><md-checkbox ng-model=\"vm.productCompanyAddons.inventoryBalancedEnabled\">\n{{\'product_parameters.inventory_balanced_enable\' | translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.productCompanyAddons.excludeInPosReports\">{{\'product_parameters.exclude_in_posreports\' | translate}}\n</md-checkbox></div><div layout=\"row\"><md-checkbox ng-model=\"vm.productCompanyAddons.excludeTaxWhenIsFree\">\n{{\'product_parameters.excludeTaxWhenIsFree\' | translate}}</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-model=\"vm.productCompanyAddons.blockDeleteInInvoice\">{{\'product_parameters.blockDeleteInInvoice\' | translate}}\n</md-checkbox></div><div layout=\"row\"><md-input-container flex><label>Impuesto de venta</label><md-select \nng-model=\"vm.productCompanyAddons.saleTax.id\"><md-option ng-value=\"0\"><em>Ninguno</em></md-option><md-option \nng-repeat=\"countryTax in vm.salesTaxArray\" ng-value=\"countryTax.id\">{{countryTax.description}} ({{countryTax.rate}}%)\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"80\" \nclass=\"md-icon-float md-block\"><label>{{\'product_parameters.PRICE\'| translate}}</label><input type=\"number\" \nng-model=\"vm.productCompanyAddons.salePrice\" min=\"0\"></md-input-container></div><div layout=\"row\"><fieldset \nclass=\"standard\" style=\"width:100%\"><legend>{{\'product_parameters.max_min\'| translate}}</legend><div flex layout-wrap \nlayout-gt-sm=\"row\"><md-checkbox flex=\"100\" ng-model=\"vm.updateMaxMin\">\n{{\'product_parameters.update_max_min\' | translate}}</md-checkbox></div><div flex layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"50\" class=\"md-icon-float md-block\"><label>\n{{\'product_parameters.min\'| translate}}</label><input type=\"number\" ng-model=\"vm.productCompanyAddons.min\" min=\"0\" \nautocomplete=\"off\"></md-input-container><md-input-container flex=\"50\" class=\"md-icon-float md-block\"><label>\n{{\'product_parameters.max\'| translate}}</label><input type=\"number\" ng-model=\"vm.productCompanyAddons.max\" min=\"0\" \nautocomplete=\"off\"></md-input-container></div></fieldset></div><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"40\" class=\"md-icon-float md-block\"><label>\n{{\'product_parameters.daysInventoryRotation\'| translate}}</label><input type=\"number\" \nng-model=\"vm.productCompanyAddons.daysInventoryRotation\" min=\"0\" step=\"1\"></md-input-container><md-input-container \nflex=\"40\" class=\"md-icon-float md-block\" ng-if=\"vm.productCompanyAddons.id\"><label>\n{{\'product_parameters.lastSaleDate\'| translate}}</label><input type=\"text\" ng-model=\"vm.lastSaleDate\" \ndisabled=\"disabled\"></md-input-container></div></fieldset><div layout=\"row\" layout-align=\"center center\"><md-button \nng-disabled=\"vm.parameterForm.$invalid\" ng-click=\"vm.save(false)\" class=\"md-raised md-primary\">\n{{\'general.save\'| translate}}</md-button></div></ng-form></md-tab-body></md-tab></md-tabs></div></md-card>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/codeBagCollectionQueue/dialogGenerate/dialogGenerateCodeBag.html","<md-dialog class=\"compose-dialog\" aria-label=\"department settings\"><md-toolbar><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><h1><label translate=\"company_establishment.generate_code\">code\n</label></h1><md-button aria-label=\"button close\" class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"vm.dataForm\"><div layout=\"row\"><md-input-container flex class=\"md-block\"><label \ntranslate=\"company_establishment.quantity_code_bag\"></label><input ng-model=\"vm.quantity\" required type=\"number\" \nmin=\"1\"></md-input-container></div></form></md-dialog-content><md-dialog-actions><md-button aria-label=\"btn\" \nng-click=\"vm.cancel()\" class=\"md-primary\"><span translate=\"general.close\"></span></md-button><md-button \naria-label=\"btn\" ng-click=\"vm.saveBag()\" class=\"md-primary\"><span translate=\"general.save\"></span></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/general/profile/tabs/userGroups/members/widget-content/widget-content.html","<md-toolbar><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h1>\n{{\'GROUP.ESTABLISHMENTS\'| translate}}</h1><md-button aria-label=\"button close\" class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip md-direction=\"down\">\n{{\"general.close\"| translate}}</md-tooltip></md-button></div><md-progress-linear md-mode=\"query\" class=\"md-accent\" \nstyle=\"z-index: 2; height: 5px; position: fixed; top: 64px\" ng-show=\"vm.isShowProgressLinear\"></md-progress-linear>\n</md-toolbar><div class=\"content\" layout-xl=\"row\" layout-lg=\"row\" layout-md=\"row\" \nlayout-align-xl=\"space-around center\" layout-align-lg=\"space-around center\" layout-align-md=\"space-around center\"><div \nflex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div ng-style=\"vm.dinamicHeight\" \nclass=\"custom-list\" ms-scroll><div class=\"search\" layout=\"row\" layout-align=\"start center\"><input flex type=\"search\" \nng-model=\"vm.inputSearchEstablishment\" translate translate-attr-placeholder=\"GROUP.MEMBER.TO_ADD\" \nng-enter=\"vm.searchNoMember()\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchNoMember()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.noMembersArray.length > 0\" ng-model=\"vm.isCheckAllNoMembers\" \nng-change=\"vm.selectAllNoMembers()\">{{\'GROUP.MEMBER.FULL\'| translate}}</md-checkbox></div><div \nng-click=\"vm.toggle(row, $event)\" class=\"item\" ng-class=\"{\'selected\': vm.isSelected(row)}\" \nng-repeat=\"row in vm.noMembersArray\"><div layout=\"row\" layout-align=\"start center\"><md-icon ng-if=\"vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon ng-if=\"!vm.isSelected(row)\" \nmd-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex class=\"product-name\">{{row.establishmentName}}</div>\n</div></div></div><div ng-style=\"vm.dinamicHeight\" ng-if=\"vm.load\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'general.loadingOoo\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.paginationNotMembers.pageNumber\" ul-class=\"pagination\" page-size=\"vm.paginationNotMembers.pageSize\" \nhide-if-empty=\"false\" paging-action=\"vm.paginationNotMembers.getPage(page)\" \ntotal=\"vm.paginationNotMembers.totalElements\"></div></div></div></div><div layout=\"column\"><md-button \naria-label=\"Button disassociate\" class=\"md-primary md-raised\" ng-click=\"vm.disassociateEstablishment()\" \nng-disabled=\"vm.selectedAssociatedArray === undefined || vm.selectedAssociatedArray === null\n                                   || vm.selectedAssociatedArray.length === 0\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"left\">\n{{\"GROUP.MEMBER.DISASSOCIATE\"| translate}}</md-tooltip></md-button><md-button aria-label=\"Button associate\" \nclass=\"md-primary md-raised\" ng-click=\"vm.associateEstablishment()\" \nng-disabled=\"vm.selectedArray === undefined || vm.selectedArray === null || vm.selectedArray.length === 0\"><md-icon \nmd-font-icon=\"icon-arrow-right\"></md-icon><md-tooltip md-direction=\"left\">{{\"GROUP.MEMBER.ASSOCIATE\"| translate}}\n</md-tooltip></md-button></div><div flex-xl=\"45\" flex-lg=\"45\" flex-md=\"40\"><div class=\"md-inline-form\"><div \nng-style=\"vm.dinamicHeight\" class=\"custom-list\" ms-scroll ng-if=\"!vm.loadAssociated\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\"><input flex type=\"search\" ng-model=\"vm.inputSearchMember\" translate \ntranslate-attr-placeholder=\"GROUP.MEMBER.ADDED\" ng-enter=\"vm.searchMember()\"><md-button class=\"md-icon-button\" \nng-click=\"vm.searchMember()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" style=\"padding-left: 10px\"><md-checkbox ng-if=\"vm.membersArray.length > 0\" \nng-model=\"vm.isCheckAllMembers\" ng-change=\"vm.selectAllMembers()\">{{\'GROUP.MEMBER.FULL\'| translate}}</md-checkbox>\n</div><div ng-click=\"vm.toggleAssociated(row, $event)\" class=\"item\" \nng-class=\"{\'selected\': vm.isSelectedAssociated(departmentProduct)}\" ng-repeat=\"row in vm.membersArray\" \nng-click=\"vm.toggleAssociated($event, row)\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nng-if=\"vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-marked\"></md-icon><md-icon \nng-if=\"!vm.isSelectedAssociated(row)\" md-font-icon=\"icon-checkbox-blank-outline\"></md-icon><div flex \nclass=\"product-name\">{{row.companyEstablishment.establishmentName}}</div></div></div></div><div \nng-style=\"vm.dinamicHeight\" ng-if=\"vm.loadAssociated\" layout=\"column\" layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular><span>\n{{\'general.loadingOoo\'| translate}}...</span></div><div layout=\"row\"><div paging class=\"pageable-div center\" \npage=\"vm.paginationMembers.pageNumber\" ul-class=\"pagination\" page-size=\"vm.paginationMembers.pageSize\" \nhide-if-empty=\"false\" paging-action=\"vm.paginationMembers.getPage(page)\" total=\"vm.paginationMembers.totalElements\">\n</div></div></div></div></div>");
$templateCache.put("app/main/apps/company/company-establishments/establishment-list/parameters/dialog/product-list-batch-dialog/product-list-batch-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\" ms-scroll><md-toolbar class=\"md-accent md-hue-2\" \nlayout=\"row\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div \nstyle=\"min-width: 400px\"><md-tabs md-selected=\"vm.selectedTab\" class=\"title\"><md-tab id=\"tab12\" \naria-controls=\"tab12-content\" label=\"{{\'product_parameters.productupdated\'| translate}}\"></md-tab></md-tabs></div><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate \ntranslate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll flex layout-fill class=\"md-dialog-list-content\"><div class=\"content thread-list\"><div \nclass=\"thread\" md-ink-ripple ng-repeat=\"product in vm.productos.content\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"info\" flex layout=\"row\"><div class=\"title h3\"><strong>\n{{product.productCode ? product.productCode + \' - \' : \'\'}}{{product.name}}</strong></div><span flex></span><div \nclass=\"div-loader\" ng-show=\"product.loading === false\"><span class=\"red\" ng-if=\"product.isError\">\n{{\'product_parameters.have_error\'| translate}}</span> <span class=\"green\" ng-if=\"!product.isError\">\n{{\'product_parameters.saved_success\'| translate}}</span></div><div class=\"div-loader\" \nng-show=\"product.loading === true\"><md-progress-circular md-diameter=\"20px\" class=\"md-accent md-hue-2\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"div-loader\" ng-show=\"product.loading === undefined\">\n<span class=\"red\">...</span></div></div></div></div></div></md-dialog-content></md-dialog>");}]);